!function(e){function r(e,r,o){return 4===arguments.length?t.apply(this,arguments):void n(e,{declarative:!0,deps:r,declare:o})}function t(e,r,t,o){n(e,{declarative:!1,deps:r,executingRequire:t,execute:o})}function n(e,r){r.name=e,e in v||(v[e]=r),r.normalizedDeps=r.deps}function o(e,r){if(r[e.groupIndex]=r[e.groupIndex]||[],-1==g.call(r[e.groupIndex],e)){r[e.groupIndex].push(e);for(var t=0,n=e.normalizedDeps.length;n>t;t++){var a=e.normalizedDeps[t],u=v[a];if(u&&!u.evaluated){var d=e.groupIndex+(u.declarative!=e.declarative);if(void 0===u.groupIndex||u.groupIndex<d){if(void 0!==u.groupIndex&&(r[u.groupIndex].splice(g.call(r[u.groupIndex],u),1),0==r[u.groupIndex].length))throw new TypeError("Mixed dependency cycle detected");u.groupIndex=d}o(u,r)}}}}function a(e){var r=v[e];r.groupIndex=0;var t=[];o(r,t);for(var n=!!r.declarative==t.length%2,a=t.length-1;a>=0;a--){for(var u=t[a],i=0;i<u.length;i++){var s=u[i];n?d(s):l(s)}n=!n}}function u(e){return y[e]||(y[e]={name:e,dependencies:[],exports:{},importers:[]})}function d(r){if(!r.module){var t=r.module=u(r.name),n=r.module.exports,o=r.declare.call(e,function(e,r){if(t.locked=!0,"object"==typeof e)for(var o in e)n[o]=e[o];else n[e]=r;for(var a=0,u=t.importers.length;u>a;a++){var d=t.importers[a];if(!d.locked)for(var i=0;i<d.dependencies.length;++i)d.dependencies[i]===t&&d.setters[i](n)}return t.locked=!1,r},r.name);t.setters=o.setters,t.execute=o.execute;for(var a=0,i=r.normalizedDeps.length;i>a;a++){var l,s=r.normalizedDeps[a],c=v[s],f=y[s];f?l=f.exports:c&&!c.declarative?l=c.esModule:c?(d(c),f=c.module,l=f.exports):l=p(s),f&&f.importers?(f.importers.push(t),t.dependencies.push(f)):t.dependencies.push(null),t.setters[a]&&t.setters[a](l)}}}function i(e){var r,t=v[e];if(t)t.declarative?f(e,[]):t.evaluated||l(t),r=t.module.exports;else if(r=p(e),!r)throw new Error("Unable to load dependency "+e+".");return(!t||t.declarative)&&r&&r.__useDefault?r["default"]:r}function l(r){if(!r.module){var t={},n=r.module={exports:t,id:r.name};if(!r.executingRequire)for(var o=0,a=r.normalizedDeps.length;a>o;o++){var u=r.normalizedDeps[o],d=v[u];d&&l(d)}r.evaluated=!0;var c=r.execute.call(e,function(e){for(var t=0,n=r.deps.length;n>t;t++)if(r.deps[t]==e)return i(r.normalizedDeps[t]);throw new TypeError("Module "+e+" not declared as a dependency.")},t,n);c&&(n.exports=c),t=n.exports,t&&t.__esModule?r.esModule=t:r.esModule=s(t)}}function s(r){var t={};if(("object"==typeof r||"function"==typeof r)&&r!==e)if(m)for(var n in r)"default"!==n&&c(t,r,n);else{var o=r&&r.hasOwnProperty;for(var n in r)"default"===n||o&&!r.hasOwnProperty(n)||(t[n]=r[n])}return t["default"]=r,x(t,"__useDefault",{value:!0}),t}function c(e,r,t){try{var n;(n=Object.getOwnPropertyDescriptor(r,t))&&x(e,t,n)}catch(o){return e[t]=r[t],!1}}function f(r,t){var n=v[r];if(n&&!n.evaluated&&n.declarative){t.push(r);for(var o=0,a=n.normalizedDeps.length;a>o;o++){var u=n.normalizedDeps[o];-1==g.call(t,u)&&(v[u]?f(u,t):p(u))}n.evaluated||(n.evaluated=!0,n.module.execute.call(e))}}function p(e){if(I[e])return I[e];if("@node/"==e.substr(0,6))return D(e.substr(6));var r=v[e];if(!r)throw"Module "+e+" not present.";return a(e),f(e,[]),v[e]=void 0,r.declarative&&x(r.module.exports,"__esModule",{value:!0}),I[e]=r.declarative?r.module.exports:r.esModule}var v={},g=Array.prototype.indexOf||function(e){for(var r=0,t=this.length;t>r;r++)if(this[r]===e)return r;return-1},m=!0;try{Object.getOwnPropertyDescriptor({a:0},"a")}catch(h){m=!1}var x;!function(){try{Object.defineProperty({},"a",{})&&(x=Object.defineProperty)}catch(e){x=function(e,r,t){try{e[r]=t.value||t.get.call(e)}catch(n){}}}}();var y={},D="undefined"!=typeof System&&System._nodeRequire||"undefined"!=typeof require&&require.resolve&&"undefined"!=typeof process&&require,I={"@empty":{}};return function(e,n,o,a){return function(u){u(function(u){for(var d={_nodeRequire:D,register:r,registerDynamic:t,get:p,set:function(e,r){I[e]=r},newModule:function(e){return e}},i=0;i<n.length;i++)(function(e,r){r&&r.__esModule?I[e]=r:I[e]=s(r)})(n[i],arguments[i]);a(d);var l=p(e[0]);if(e.length>1)for(var i=1;i<e.length;i++)p(e[i]);return o?l["default"]:l})}}}("undefined"!=typeof self?self:global)

(["1","2"], [], false, function($__System) {
var require = this.require, exports = this.exports, module = this.module;
!function(e){function r(e,r){for(var n=e.split(".");n.length;)r=r[n.shift()];return r}function n(n){if("string"==typeof n)return r(n,e);if(!(n instanceof Array))throw new Error("Global exports must be a string or array.");for(var t={},o=!0,f=0;f<n.length;f++){var i=r(n[f],e);o&&(t["default"]=i,o=!1),t[n[f].split(".").pop()]=i}return t}function t(r){if(Object.keys)Object.keys(e).forEach(r);else for(var n in e)a.call(e,n)&&r(n)}function o(r){t(function(n){if(-1==l.call(s,n)){try{var t=e[n]}catch(o){s.push(n)}r(n,t)}})}var f,i=$__System,a=Object.prototype.hasOwnProperty,l=Array.prototype.indexOf||function(e){for(var r=0,n=this.length;n>r;r++)if(this[r]===e)return r;return-1},s=["_g","sessionStorage","localStorage","clipboardData","frames","frameElement","external","mozAnimationStartTime","webkitStorageInfo","webkitIndexedDB","mozInnerScreenY","mozInnerScreenX"];i.set("@@global-helpers",i.newModule({prepareGlobal:function(r,t,i){var a=e.define;e.define=void 0;var l;if(i){l={};for(var s in i)l[s]=e[s],e[s]=i[s]}return t||(f={},o(function(e,r){f[e]=r})),function(){var r;if(t)r=n(t);else{r={};var i,s;o(function(e,n){f[e]!==n&&"undefined"!=typeof n&&(r[e]=n,"undefined"!=typeof i?s||i===n||(s=!0):i=n)}),r=s?r:i}if(l)for(var u in l)e[u]=l[u];return e.define=a,r}}}))}("undefined"!=typeof self?self:global);
!function(e){function n(e,n){e=e.replace(l,"");var r=e.match(u),t=(r[1].split(",")[n]||"require").replace(s,""),i=p[t]||(p[t]=new RegExp(a+t+f,"g"));i.lastIndex=0;for(var o,c=[];o=i.exec(e);)c.push(o[2]||o[3]);return c}function r(e,n,t,o){if("object"==typeof e&&!(e instanceof Array))return r.apply(null,Array.prototype.splice.call(arguments,1,arguments.length-1));if("string"==typeof e&&"function"==typeof n&&(e=[e]),!(e instanceof Array)){if("string"==typeof e){var l=i.get(e);return l.__useDefault?l["default"]:l}throw new TypeError("Invalid require")}for(var a=[],f=0;f<e.length;f++)a.push(i["import"](e[f],o));Promise.all(a).then(function(e){n&&n.apply(null,e)},t)}function t(t,l,a){"string"!=typeof t&&(a=l,l=t,t=null),l instanceof Array||(a=l,l=["require","exports","module"].splice(0,a.length)),"function"!=typeof a&&(a=function(e){return function(){return e}}(a)),void 0===l[l.length-1]&&l.pop();var f,u,s;-1!=(f=o.call(l,"require"))&&(l.splice(f,1),t||(l=l.concat(n(a.toString(),f)))),-1!=(u=o.call(l,"exports"))&&l.splice(u,1),-1!=(s=o.call(l,"module"))&&l.splice(s,1);var p={name:t,deps:l,execute:function(n,t,o){for(var p=[],c=0;c<l.length;c++)p.push(n(l[c]));o.uri=o.id,o.config=function(){},-1!=s&&p.splice(s,0,o),-1!=u&&p.splice(u,0,t),-1!=f&&p.splice(f,0,function(e,t,l){return"string"==typeof e&&"function"!=typeof t?n(e):r.call(i,e,t,l,o.id)});var d=a.apply(-1==u?e:t,p);return"undefined"==typeof d&&o&&(d=o.exports),"undefined"!=typeof d?d:void 0}};if(t)c.anonDefine||c.isBundle?c.anonDefine&&c.anonDefine.name&&(c.anonDefine=null):c.anonDefine=p,c.isBundle=!0,i.registerDynamic(p.name,p.deps,!1,p.execute);else{if(c.anonDefine&&!c.anonDefine.name)throw new Error("Multiple anonymous defines in module "+t);c.anonDefine=p}}var i=$__System,o=Array.prototype.indexOf||function(e){for(var n=0,r=this.length;r>n;n++)if(this[n]===e)return n;return-1},l=/(\/\*([\s\S]*?)\*\/|([^:]|^)\/\/(.*)$)/gm,a="(?:^|[^$_a-zA-Z\\xA0-\\uFFFF.])",f="\\s*\\(\\s*(\"([^\"]+)\"|'([^']+)')\\s*\\)",u=/\(([^\)]*)\)/,s=/^\s+|\s+$/g,p={};t.amd={};var c={isBundle:!1,anonDefine:null};i.amdDefine=t,i.amdRequire=r}("undefined"!=typeof self?self:global);
$__System.registerDynamic("2", ["3"], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  var angular = $__require('3');
  angular.module('app').run(['$templateCache', function($templateCache) {
    $templateCache.put('views/about.html', '<main ng-controller="AboutController as aboutController" ng-init="aboutController.init()">\n    <header>\n        <div class="col-xs-6 pl-0">\n            <a ui-sref="musicmap.homepage" class="logo"></a>\n        </div>\n        <div class="main_nav col-xs-6">\n            <nav role="navigation">\n                <div id="menuToggle">\n                    <input type="checkbox">\n                    <span></span>\n                    <span></span>\n                    <span></span>\n\n                    <ul id="menu">\n                        <li><a ui-sref="page.about">About</a></li>\n                        <li><a ui-sref="page.artists">Artists</a></li>\n                        <li><a ui-sref="page.services">Services</a></li>\n                        <li><a ui-sref="page.contact">Contact</a></li>\n                    </ul>\n                </div>\n            </nav>\n        </div>\n    </header>\n    <section id="about">\n        <div class="container text-containers">\n            <div class="row">\n                <div class="col-sm-12">\n                    <h2 class="float-left">About</h2>\n                    <p>MusicMap is a local music discovery service on a global scale. Our aim is to unearth the world\u2019s\n                        most exciting underground talent and showcase the music scenes and communities that are\n                        flourishing on every continent. </p>\n                    <p>Simply choose a continent or country on the map to explore the most cutting-edge sounds currently\n                        emerging from that area, including exclusive mixes by local experts and interviews with the\n                        artists, DJs and labels on the ground making it happen. </p>\n                    <p>MusicMap is powered by <a class="underline" href="https://record-play.net/" target="_blank">Record-Play</a>,\n                        an international consultancy that offers music supervision, audio branding and strategic\n                        guidance to fashion labels, video game producers, tech companies, airlines and many more. </p>\n                    <p>To find out how MusicMap and <a href="https://record-play.net/" target="_blank">Record-Play</a>\n                        can help provide the perfect soundtrack for your project, wherever you are in the world, please\n                        contact us using the form below. </p>\n                    <p><strong>You can also follow MusicMap on <a class="underline" href="https://www.facebook.com/MusicMapGlobal/" target="_blank">Facebook</a>, <a class="underline" href="https://twitter.com/musicmapglobal?lang=en" target="_blank">Twitter</a>,\n                        <a class="underline" href="https://www.instagram.com/musicmapglobal/" target="_blank">Instagram</a> and <a class="underline" href="https://open.spotify.com/user/musicmap.global?si=WHcmWUsWTVustvLJNd-3Zg" target="_blank">Spotify</a></strong></p>\n                </div>\n            </div>\n        </div>\n    </section>\n    <section id="contact" class="pb-50">\n        <div class="container text-containers">\n            <div class="row">\n                <div class="wrapper mauto col-sm-6 col-xs-12">\n                    <h2>\n                        Contact\n                    </h2>\n\n                    <form ng-if="!contactSuccess" name="contactForm" ng-submit="doContact();">\n                        <div class="fields">\n                            <input class="text-field" type="text" ng-class="{\'error\': contactError.name}" placeholder="Name" name="contactName" ng-model="contact.name">\n\n                            <input class="text-field" type="text" ng-class="{\'error\': contactError.company}" placeholder="Company" name="contactCompany" ng-model="contact.company">\n\n                            <input class="text-field" type="email" ng-class="{\'error\': contactError.email}" placeholder="Email" name="contactEmail" ng-model="contact.email">\n\n                            <textarea class="text-field" type="text" ng-class="{\'error\': contactError.message}" placeholder="Message" name="contactMessage" ng-model="contact.message"></textarea>\n\n                            <div class="terms-holder" ng-class="{\'error\': contactError.gdpr}">\n                                <label class="check-container white">I consent to having MusicMap and its parent\n                                    company, Record-Play, store my submitted information so they can respond to my\n                                    enquiry.\n                                    <input type="checkbox" ng-model="contact.gdpr" value="1">\n                                    <span class="checkmark"></span>\n                                </label>\n                            </div>\n\n                        </div>\n\n                        <script src="https://www.google.com/recaptcha/api.js"></script>\n                        <div vc-recaptcha key="\'6LclOI8UAAAAAD7lixtupG5eEksjuITBO1lrkb9D\'"></div>\n                        <button type="submit" class="btn btn-block btn-main">Contact</button>\n                    </form>\n                    <div ng-if="contactSuccess">\n                        <h4>Sent!</h4>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </section>\n</main>\n');
    $templateCache.put('views/article.html', '<main ng-controller="ArticleController as articleController" ng-init="articleController.init()">\n    <section id="article">\n        <div class="half big-background" ng-style="{\'background-image\': \'url(\' + article.images.background + \')\'}" ng-class="{\'scale\': article.images.scale}">\n            <header>\n                <h1><a ui-sref="musicmap.homepage"><i class="fa fa-angle-left"></i> World</a></h1>\n                <h2 ng-repeat="country in article.countries">\n                    <a href ui-sref="musicmap.country({ alpha2: country.alpha2 })">{{ country.name }}</a></h2>\n            </header>\n        </div>\n        <div class="half">\n            <div class="articles-holder">\n                <a class="go-back" ng-click="closeArticle()" href><i class="fa fa-close"></i></a>\n                <div class="article-content">\n                    <h2>\n                        {{ article.title }}\n                    </h2>\n                    <div class="article-options">\n                        <a href ng-click="toggleFavorite(article.id);" class="heart">\n                            <i ng-class="{\'fa-heart\': isFavorite(article.id), \'fa-heart-o\': !isFavorite(article.id)}" class="fa"></i>\n                        </a>\n                        <button class="share-icon" type="button" ng-click="shareOptions = !shareOptions">\n                            <i class="fa fa-share-alt"></i>\n                        </button>\n                        <div class="social-share" ng-class="{\'share-open\': shareOptions}">\n                            <a href ng-click="socialShare(\'facebook\');">\n                                <i class="fa fa-facebook"></i>\n                            </a>\n                            <a href ng-click="socialShare(\'twitter\');">\n                                <i class="fa fa-twitter"></i>\n                            </a>\n                        </div>\n                    </div>\n\n                    <div class="article-description" ng-bind-html="article.longDescription | unsafe"></div>\n\n                    <a href ng-click="subscribeOpened = true" class="btn-light pull-right">Subscribe to MusicMap</a>\n                </div>\n            </div>\n            <div class="articles-wrapper related-articles" ng-if="related">\n                <span class="title">Related articles</span>\n\n                <slick settings="slickConfig" ng-if="relatedArticlesLoaded">\n                    <div ng-repeat="relatedArticle in related" class="internal article-item">\n                        <a href ui-sref="musicmap.article({ path: relatedArticle.path, id: relatedArticle.id })" class="image-holder" ng-style="{\'background-image\': \'url(\' + relatedArticle.images.thb + \')\'}"></a>\n\n                        <a href ui-sref="musicmap.article({ path: relatedArticle.path, id: relatedArticle.id })" class="info-holder">\n                            <span class="related-title">{{ relatedArticle.title }}</span>\n                            <div class="medium-text">{{ relatedArticle.shortDescription }}</div>\n                        </a>\n\n                        <a href ng-click="toggleFavorite(relatedArticle.id);" class="heart">\n                            <i ng-class="{\'fa-heart\': isFavorite(relatedArticle.id), \'fa-heart-o\': !isFavorite(relatedArticle.id)}" class="fa"></i>\n                        </a>\n                    </div>\n                </slick>\n            </div>\n        </div>\n    </section>\n\n    <section id="subscribe-popup" class="popup" ng-class="{\'opened\': subscribeOpened}">\n        <div class="wrapper">\n            <h2>\n                Subscription\n                <a href ng-click="subscribeOpened = false"><i class="fa fa-times"></i></a>\n            </h2>\n\n            <form ng-if="!subscribeSuccess" name="subscribeForm" ng-submit="doSubscribe();">\n                <div class="fields">\n                    <input class="text-field" type="email" ng-class="{\'error\': subscriberError.email}" placeholder="Email" name="subscriberEmail" ng-model="subscriber.email">\n                    <input class="text-field" type="text" ng-class="{\'error\': subscriberError.firstname}" placeholder="First Name" name="subscriberFirstname" ng-model="subscriber.firstname">\n                    <input class="text-field" type="text" ng-class="{\'error\': subscriberError.lastname}" placeholder="Last Name" name="subscriberLastname" ng-model="subscriber.lastname">\n                    <div class="terms-holder" ng-class="{\'error\': subscriberError.terms}">\n                        <label class="check-container">I accept the <a href ui-sref="page.privacy()" target="_blank">privacy policy</a>\n                            <input type="checkbox" ng-model="subscriber.terms" value="1">\n                            <span class="checkmark"></span>\n                        </label>\n                    </div>\n                </div>\n\n                <button type="submit" class="btn btn-block btn-main">Subscribe to MusicMap</button>\n            </form>\n\n            <div ng-if="subscribeSuccess">\n                <h4>Thank you!</h4>\n            </div>\n        </div>\n    </section>\n</main>\n');
    $templateCache.put('views/artists.html', '<main ng-controller="ArtistController as artistController" ng-init="artistController.init()">\n    <header>\n        <div class="col-xs-6 pl-0">\n            <a ui-sref="musicmap.homepage" class="logo"></a>\n        </div>\n        <div class="main_nav col-xs-6">\n            <nav role="navigation">\n                <div id="menuToggle">\n                    <input type="checkbox">\n                    <span></span>\n                    <span></span>\n                    <span></span>\n                    <ul id="menu">\n                        <li><a ui-sref="page.about">About</a></li>\n                        <li><a ui-sref="page.artists">Artists</a></li>\n                        <li><a ui-sref="page.services">Services</a></li>\n                        <li><a ui-sref="page.contact">Contact</a></li>\n                    </ul>\n                </div>\n            </nav>\n        </div>\n    </header>\n    <section id="artists">\n        <div class="container text-containers">\n            <div class="row">\n                <div class="col-sm-12">\n                    <h2 class="float-left">Artists</h2>\n                    <p>MusicMap is constantly on the lookout for exciting and original music that we can share with the\n                        world. As a division of the independent music consultancy Record-Play, we also try to find sync\n                        and licensing opportunities for the musicians who make it. </p>\n                    <p>If you\u2019re an independent artist who\u2019d like to have your music featured on MusicMap, please\n                        complete the form below. Musicians from outside the English-speaking world\n                        are particularly encouraged to get in touch. If your music is suitable for the site, we\u2019ll get\n                        back to you.\n                    </p>\n                    <p><i>Please be aware that due to time constraints we may not be able to respond to every\n                        submission. </i>\n                    </p>\n                </div>\n            </div>\n        </div>\n    </section>\n\n    <section id="contact" class="pb-50">\n        <div class="container text-containers">\n            <div class="row">\n                <div class="wrapper mauto col-sm-6 col-xs-12">\n                    <h2>\n                        Contact\n                    </h2>\n                    <form ng-if="!contactSuccess" name="contactForm" ng-submit="doContact();">\n                        <div class="fields">\n                            <input class="text-field" type="text" ng-class="{\'error\': contactError.name}" placeholder="Name" name="contactName" ng-model="contact.name">\n\n                            <input class="text-field" type="email" ng-class="{\'error\': contactError.email}" placeholder="Email" name="contactEmail" ng-model="contact.email">\n\n                            <input class="text-field" type="text" ng-class="{\'error\': contactError.artist_name}" placeholder="Artist\'s name" name="contactArtist_name" ng-model="contact.artist_name">\n\n                            <input class="text-field" type="text" ng-class="{\'error\': contactError.country}" placeholder="Country" name="contactCountry" ng-model="contact.country">\n\n                            <textarea class="text-field" type="text" ng-class="{\'error\': contactError.description}" placeholder="Description" name="contactDescription" ng-model="contact.description"></textarea>\n\n                            <input class="text-field" type="text" ng-class="{\'error\': contactError.link}" placeholder="Link" name="contactLink" ng-model="contact.link">\n\n                            <div class="terms-holder" ng-class="{\'error\': contactError.gdpr}">\n                                <label class="check-container white">I consent to having MusicMap and its parent\n                                    company, Record-Play, store my submitted information so they can respond to my\n                                    enquiry.\n                                    <input type="checkbox" ng-model="contact.gdpr" value="1">\n                                    <span class="checkmark"></span>\n                                </label>\n                            </div>\n                            <script src="https://www.google.com/recaptcha/api.js"></script>\n                            <div vc-recaptcha key="\'6LclOI8UAAAAAD7lixtupG5eEksjuITBO1lrkb9D\'"></div>\n\n                        </div>\n                        <button type="submit" class="btn btn-block btn-main">Contact</button>\n                    </form>\n                    <div ng-if="contactSuccess">\n                        <h4>Sent!</h4>\n                    </div>\n\n                </div>\n            </div>\n        </div>\n    </section>\n</main>\n');
    $templateCache.put('views/contact.html', '<main ng-controller="ContactController as contactController" ng-init="contactController.init()">\n    <header>\n        <div class="col-xs-6 pl-0">\n            <a ui-sref="musicmap.homepage" class="logo"></a>\n        </div>\n        <div class="main_nav col-xs-6">\n            <nav role="navigation">\n                <div id="menuToggle">\n                    <input type="checkbox">\n                    <span></span>\n                    <span></span>\n                    <span></span>\n\n                    <ul id="menu">\n                        <li><a ui-sref="page.about">About</a></li>\n                        <li><a ui-sref="page.artists">Artists</a></li>\n                        <li><a ui-sref="page.services">Services</a></li>\n                        <li><a ui-sref="page.contact">Contact</a></li>\n                    </ul>\n                </div>\n            </nav>\n        </div>\n    </header>\n    <section id="contact" class="pb-50">\n        <div class="container text-containers">\n            <div class="row">\n                <div class="wrapper mauto col-sm-6 col-xs-12">\n                    <h2>\n                        Contact\n                    </h2>\n                    <form ng-if="!contactSuccess" name="contactForm" ng-submit="doContact();">\n                        <div class="fields">\n                            <input class="text-field" type="text" ng-class="{\'error\': contactError.name}" placeholder="Name" name="contactName" ng-model="contact.name">\n\n                            <input class="text-field" type="email" ng-class="{\'error\': contactError.email}" placeholder="Email" name="contactEmail" ng-model="contact.email">\n\n                            <textarea class="text-field" type="text" ng-class="{\'error\': contactError.message}" placeholder="Message" name="contactMessage" ng-model="contact.message"></textarea>\n\n                            <div class="terms-holder" ng-class="{\'error\': contactError.gdpr}">\n                                <label class="check-container white">I consent to having MusicMap and its parent\n                                    company, Record-Play, store my submitted information so they can respond to my\n                                    enquiry.\n                                    <input type="checkbox" ng-model="contact.gdpr" value="1">\n                                    <span class="checkmark"></span>\n                                </label>\n                            </div>\n\n                        </div>\n                        <script src="https://www.google.com/recaptcha/api.js"></script>\n                        <div vc-recaptcha key="\'6LclOI8UAAAAAD7lixtupG5eEksjuITBO1lrkb9D\'"></div>\n\n                        <button type="submit" class="btn btn-block btn-main">Contact</button>\n                    </form>\n                    <div ng-if="contactSuccess">\n                        <h4>Sent!</h4>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </section>\n</main>\n');
    $templateCache.put('views/continent.html', '<main ng-controller="ContinentController as continentController" ng-init="continentController.init()">\n    <section id="continent">\n        <div class="half left">\n            <header>\n                <h1>\n                    <a ui-sref="musicmap.homepage"><i class="fa fa-angle-left"></i>World</a>\n                </h1>\n                <div class="col-sm-4 col-md-4 continent-search hidden-xs">\n                    <div class="search-country visible-xl">\n                        <div class="input-group">\n                            <input class="form-control" ng-focus="focusCountry = true" ng-blur="focusCountry = false" ng-model="searchCountry" placeholder="Find country" type="text" tabindex="0">\n                            <span class="input-group-addon"><i class="fa fa-search"></i></span>\n                        </div>\n                    </div>\n                    <ul class="list" ng-show="searchCountry || focusCountry">\n                        <li ng-repeat="country in countries | filter:searchCountry">\n                            <a href ng-mousedown="$root.jumpToCountry(country)" ng-bind-html="country.name | trusted"></a>\n                        </li>\n                    </ul>\n                </div>\n                <h2 class="inner">{{ continent.name }}</h2>\n                 <div class="main_nav">\n                    <nav role="navigation">\n                      <div id="menuToggle">\n                        <input type="checkbox">\n                        <span></span>\n                        <span></span>\n                        <span></span>\n                         <ul id="menu">\n                            <li><a ui-sref="page.about">About</a></li>\n                            <li><a ui-sref="page.artists">Artists</a></li>\n                            <li><a ui-sref="page.services">Services</a></li>\n                            <li><a ui-sref="page.contact">Contact</a></li>\n                        </ul>\n                      </div>\n                    </nav>\n                </div>\n            </header>\n\n            <div class="countries-list">\n                <div class="hidden-xs" id="map"></div>\n                <div class="search-country visible-xs">\n                    <div class="input-group">\n                        <input class="form-control" ng-model="searchCountry" placeholder="Search" type="text">\n                        <span class="input-group-addon"><i class="fa fa-search"></i></span>\n                    </div>\n                </div>\n\n                <ul class="visible-xs list">\n                    <li ng-repeat="country in countries | filter:searchCountry">\n                        <a href ui-sref="musicmap.country({ alpha2: country.alpha2 })" ng-bind-html="country.name | trusted"></a>\n                    </li>\n                </ul>\n            </div>\n        </div>\n\n        <div class="half hidden-xs">\n            <div class="articles-holder" ng-if="!fullPlaylist && !history.enabled">\n                <div ng-repeat="(categoryType, category) in categories" ng-show="category.articles.length" class="half-height">\n                    <h2>\n                        {{ continent.name }} {{ categoryType }}\n                        <a href ng-click="openArticlesHistory(categoryType)" class="pull-right"> See All </a>\n                    </h2>\n\n                    <div class="articles-wrapper">\n                        <slick settings="slickConfig" ng-if="articlesLoaded">\n                            <div class="article-item" ng-repeat="article in category.articles">\n                                <a href ui-sref="musicmap.article({ path: article.path, id: article.id })" class="image-holder" ng-style="{\'background-image\': \'url(\' + article.images.thb + \')\'}"></a>\n\n                                <a href ui-sref="musicmap.article({ path: article.path, id: article.id })" class="info-holder">\n                                    <strong>{{ article.title }}</strong>\n                                    <div class="medium-text">{{ article.shortDescription }}</div>\n                                </a>\n\n                                <a href ng-click="toggleFavorite(article.id);" class="heart">\n                                    <i ng-class="{\'fa-heart\': isFavorite(article.id), \'fa-heart-o\': !isFavorite(article.id)}" class="fa"></i>\n                                </a>\n                            </div>\n                        </slick>\n                    </div>\n                </div>\n            </div>\n\n            <div class="articles-history" ng-if="history.enabled">\n                <a href ng-click="closeArticlesHistory()" class="go-back"><i class="fa fa-close"></i></a>\n\n                <header>\n                    <h2> {{ continent.name }} {{ history.categoryType }}</h2>\n                </header>\n\n                <div class="articles-wrapper">\n                    <div>\n                        <div class="article-item" ng-repeat="article in history.articles">\n                            <a href ui-sref="musicmap.article({ path: article.path, id: article.id })" class="image-holder" ng-style="{\'background-image\': \'url(\' + article.images.thb + \')\'}"></a>\n\n                            <a href ui-sref="musicmap.article({ path: article.path, id: article.id })" class="info-holder">\n                                <strong>{{ article.title }}</strong>\n                                <div class="medium-text">{{ article.shortDescription }}</div>\n                            </a>\n\n                            <a href ng-click="toggleFavorite(article.id);" class="heart">\n                                <i ng-class="{\'fa-heart\': isFavorite(article.id), \'fa-heart-o\': !isFavorite(article.id)}" class="fa"></i>\n                            </a>\n                        </div>\n                    </div>\n\n                    <a href class="btn btn-block btn-load-more" ng-if="history.pagination.more" ng-click="getArticlesHistory(history.pagination.page + 1)">LOAD MORE</a>\n                </div>\n            </div>\n\n            <div class="mixes-holder" ng-if="!fullPlaylist && !history.enabled">\n                 <div class="playlist-tracks">\n                     <h2 class="playlist-title">\n                         <a href ng-click="openEmbedPopup();" class="btn-embed"><i class="fa fa-share-alt"></i></a>\n                        {{ continent.name }} Playlist\n                        <a href ng-click="toggleFullPlaylist()" class="pull-right"><i class="fa fa-plus"></i></a>\n                    </h2>\n\n                    <div class="playlist-row vcenter" ng-repeat="(trackIndex, track) in playlist" ng-click="$root.startPlaylist(playlist, trackIndex, \'continent\')">\n                        <div class="col-xs-2 pl-0">\n                            <div class="image-holder" ng-style="{\'background-image\': \'url(\' + track.cover + \')\'}"></div>\n                        </div>\n                        <div class="col-xs-7">\n                            {{ track.nameTrack }} by {{ track.nameArtist }}\n                        </div>\n                        <div class="col-xs-2 text-center">{{ track.duration }}</div>\n                        <div class="col-xs-1 text-center play-pause pr-0">\n                            <a href><i class="fa" ng-class="$root.trackPlayingClass(trackIndex)"></i></a>\n                        </div>\n                    </div>\n                </div>\n            </div>\n\n            <div class="playlist-tracks" ng-if="fullPlaylist">\n                <h2>\n                    <a href ng-click="openEmbedPopup();" class="btn-embed"><i class="fa fa-share-alt"></i></a>\n                    {{ continent.name }} Playlist\n                    <a href ng-click="toggleFullPlaylist()" class="pull-right"><i class="fa fa-angle-down"></i></a>\n                </h2>\n\n                <div class="playlist-row vcenter" ng-repeat="(trackIndex, track) in playlist" ng-click="$root.startPlaylist(playlist, trackIndex, \'continent\')">\n                    <div class="col-xs-2">\n                        <div class="image-holder" ng-style="{\'background-image\': \'url(\' + track.cover + \')\'}"></div>\n                    </div>\n                    <div class="col-xs-7">\n                        {{ track.nameTrack }} by {{ track.nameArtist }}\n                    </div>\n                    <div class="col-xs-2 text-center">{{ track.duration }}</div>\n                    <div class="col-xs-1 text-center play-pause">\n                        <a href><i class="fa" ng-class="$root.trackPlayingClass(trackIndex)"></i></a>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </section>\n\n    <section id="embed-popup" class="popup" ng-class="{\'opened\': embedOpened}">\n        <div class="wrapper">\n            <h2>\n                Share playlist\n                <a href ng-click="embedOpened = !embedOpened"><i class="fa fa-times"></i></a>\n            </h2>\n\n            <div class="embed-content">\n                Copy the HTML code below and paste it into your website.\n                <textarea readonly="readonly" spellcheck="false"><iframe width="300" height="380" src="{{ embedUrl }}" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe></textarea>\n            </div>\n        </div>\n    </section>\n</main>\n');
    $templateCache.put('views/country.html', '<main ng-controller="CountryController as countryController" ng-init="countryController.init()">\n    <section id="country">\n        <div class="half big-background" ng-style="{\'background-image\': \'url(\' + country.background + \')\'}">\n            <header>\n                <h1>\n                    <a ui-sref="musicmap.continent({ name: country.continent_slug })"><i class="fa fa-angle-left"></i>\n                    Back to {{ country.continent_name }}</a>\n                </h1>\n                <h2 class="hidden-xs inner">{{ country.name }}</h2>\n                <div class="main_nav">\n                    <nav role="navigation">\n                      <div id="menuToggle">\n                        <input type="checkbox">\n                        <span></span>\n                        <span></span>\n                        <span></span>\n                         <ul id="menu">\n                            <li><a ui-sref="page.about">About</a></li>\n                            <li><a ui-sref="page.artists">Artists</a></li>\n                            <li><a ui-sref="page.services">Services</a></li>\n                            <li><a ui-sref="page.contact">Contact</a></li>\n                        </ul>\n                      </div>\n                    </nav>\n                </div>\n            </header>\n        </div>\n        <div class="half second-half">\n            <div class="articles-holder" ng-if="!fullPlaylist && !history.enabled">\n                <div ng-repeat="(categoryType, category) in categories" ng-show="category.articles.length" class="half-height">\n                    <h2>\n                        {{ country.name }} {{ categoryType }}\n                        <a href ng-click="openArticlesHistory(categoryType)" class="pull-right"> See All</a>\n                    </h2>\n                    <div class="articles-wrapper">\n                        <slick settings="slickConfig" ng-if="articlesLoaded">\n                            <div class="article-item" ng-repeat="article in category.articles">\n                                <a href ui-sref="musicmap.article({ path: article.path, id: article.id })" class="image-holder" ng-style="{\'background-image\': \'url(\' + article.images.thb + \')\'}"></a>\n\n                                <a href ui-sref="musicmap.article({ path: article.path, id: article.id })" class="info-holder">\n                                    <strong>{{ article.title }}</strong>\n                                    <div class="medium-text">{{ article.shortDescription }}</div>\n                                </a>\n\n                                <a href ng-click="toggleFavorite(article.id);" class="heart">\n                                    <i ng-class="{\'fa-heart\': isFavorite(article.id), \'fa-heart-o\': !isFavorite(article.id)}" class="fa"></i>\n                                </a>\n                            </div>\n                        </slick>\n                    </div>\n                </div>\n            </div>\n\n            <div class="articles-history" ng-if="history.enabled">\n                <a href ng-click="closeArticlesHistory()" class="go-back"><i class="fa fa-close"></i></a>\n\n                <header>\n                    <h2>{{ country.name }} {{ history.categoryType }}</h2>\n                </header>\n\n                <div class="articles-wrapper">\n                    <div>\n                        <div class="article-item" ng-repeat="article in history.articles">\n                            <a href ui-sref="musicmap.article({ path: article.path, id: article.id })" class="image-holder" ng-style="{\'background-image\': \'url(\' + article.images.thb + \')\'}"></a>\n\n                            <a href ui-sref="musicmap.article({ path: article.path, id: article.id })" class="info-holder">\n                                <strong>{{ article.title }}</strong>\n                                <div class="medium-text">{{ article.shortDescription }}</div>\n                            </a>\n\n                            <a href ng-click="toggleFavorite(article.id);" class="heart">\n                                <i ng-class="{\'fa-heart\': isFavorite(article.id), \'fa-heart-o\': !isFavorite(article.id)}" class="fa"></i>\n                            </a>\n                        </div>\n                    </div>\n\n                    <a href class="btn btn-block btn-load-more" ng-if="history.pagination.more" ng-click="getArticlesHistory(history.pagination.page + 1)">LOAD MORE</a>\n                </div>\n            </div>\n\n            <div class="mixes-holder" ng-if="!fullPlaylist && !history.enabled">\n                 <div class="playlist-tracks">\n                     <h2 class="playlist-title">\n                         <a href ng-click="openEmbedPopup();" class="btn-embed"><i class="fa fa-share-alt"></i></a>\n                        {{ country.name }} Playlist\n                        <a href ng-click="toggleFullPlaylist()" class="pull-right"><i class="fa fa-plus"></i></a>\n                    </h2>\n\n                    <div class="playlist-row vcenter" ng-repeat="(trackIndex, track) in playlist" ng-click="$root.startPlaylist(playlist, trackIndex, \'country\')">\n                        <div class="col-xs-2 pl-0">\n                            <div class="image-holder" ng-style="{\'background-image\': \'url(\' + track.cover + \')\'}"></div>\n                        </div>\n                        <div class="col-xs-7">\n                            {{ track.nameTrack }} by {{ track.nameArtist }}\n                        </div>\n                        <div class="col-xs-2 text-center">{{ track.duration }}</div>\n                        <div class="col-xs-1 text-center play-pause pr-0">\n                            <a href><i class="fa" ng-class="$root.trackPlayingClass(trackIndex)"></i></a>\n                        </div>\n                    </div>\n                </div>\n            </div>\n\n            <div class="playlist-tracks" ng-if="fullPlaylist">\n                <h2>\n                    <a href ng-click="openEmbedPopup();" class="btn-embed"><i class="fa fa-share-alt"></i></a>\n                    {{ country.name }} Playlist\n                    <a href ng-click="toggleFullPlaylist()" class="pull-right"><i class="fa fa-angle-down"></i></a>\n                </h2>\n\n                <div class="playlist-row vcenter" ng-repeat="(trackIndex, track) in playlist" ng-click="$root.startPlaylist(playlist, trackIndex, \'country\')">\n                    <div class="col-xs-2">\n                        <div class="image-holder" ng-style="{\'background-image\': \'url(\' + track.cover + \')\'}"></div>\n                    </div>\n                    <div class="col-xs-7">\n                        {{ track.nameTrack }} by {{ track.nameArtist }}\n                    </div>\n                    <div class="col-xs-2 text-center">{{ track.duration }}</div>\n                    <div class="col-xs-1 text-center play-pause">\n                        <a href><i class="fa" ng-class="$root.trackPlayingClass(trackIndex)"></i></a>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </section>\n\n    <section id="embed-popup" class="popup" ng-class="{\'opened\': embedOpened}">\n        <div class="wrapper">\n            <h2>\n                Share playlist\n                <a href ng-click="embedOpened = !embedOpened"><i class="fa fa-times"></i></a>\n            </h2>\n\n            <div class="embed-content">\n                Copy the HTML code below and paste it into your website.\n                <textarea readonly="readonly" spellcheck="false"><iframe width="300" height="380" src="{{ embedUrl }}" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe></textarea>\n            </div>\n        </div>\n    </section>\n</main>\n');
    $templateCache.put('views/embed.html', '<div id="embed-player" ng-controller="PlayerController as playerController" ng-init="playerController.init()" ng-class="{\'is-collapsed\': $root.playerCollapsed}">\n    <div class="now-playing">\n        <div class="cover" ng-style="{\'background-image\': \'url(\' + currentTrack().cover + \')\'}">\n            <a href ng-if="!$root.playing" ng-click="play()"><i class="fa fa-play"></i></a>\n            <a href ng-if="$root.playing" ng-click="pause()"><i class="fa fa-pause"></i></a>\n        </div>\n        <div class="track-holder">\n            <div class="track-info">\n                <a class="mini-logo" target="_blank" href="{{ $root.embedEntity.site }}"><img src="/images/logos/logo-dark.png" alt="Musicmap"></a>\n                <a target="_blank" href="{{ $root.embedEntity.url }}">{{ $root.embedEntity.name }}</a>\n                <strong>{{ currentTrack().nameTrack }}</strong>\n                <span>{{ currentTrack().nameArtist }}</span>\n            </div>\n            <div class="slidecontainer">\n                <span class="current">{{ $root.player.currentTime | trackTime }}</span>\n                <input type="range" min="0" max="1" step="0.001" class="slider" ng-model="audioProgressControl.value">\n                <span class="total">{{ $root.player.duration | trackTime }}</span>\n            </div>\n        </div>\n    </div>\n\n    <div class="playlist">\n        <div class="playlist-row vcenter" ng-repeat="(trackIndex, track) in $root.tracks" ng-click="$root.startPlaylist($root.tracks, trackIndex, \'embed\')">\n            <div class="col-index text-center">\n                {{ trackIndex + 1 }}\n            </div>\n            <div class="col-track">\n                {{ track.nameTrack }} by {{ track.nameArtist }}\n            </div>\n            <div class="col-duration text-center">{{ track.duration }}</div>\n        </div>\n    </div>\n</div>\n');
    $templateCache.put('views/homepage.html', '<main ng-controller="HomepageController as homepageController" ng-init="homepageController.init()" class="homePage">\n    <header>\n        <div class="col-xs-6 pl-0">\n            <a ui-sref="musicmap.homepage" class="logo"></a>\n         </div>\n        <h2 style="display: none"><a href ng-click="aboutOpened = !aboutOpened">About</a></h2>\n        \n        <div class="main_nav col-sm-6">\n            <div class="hp countries-list hidden-xs">\n                <div class="search-country visible-xl">\n                    <div class="input-group find">\n                        <input class="form-control" ng-model="searchCountry" ng-focus="focusCountry = true" ng-blur="focusCountry = false" placeholder="Find country" type="text">\n                        <span class="input-group-addon"><i class="fa fa-search"></i></span>\n                    </div>\n                </div>\n                <ul class="list" ng-show="searchCountry || focusCountry">\n                    <li ng-repeat="country in countries | filter:searchCountry">\n                        <a href ng-mousedown="$root.jumpToCountry(country)" ng-bind-html="country.name | trusted"></a>\n                    </li>\n                </ul>\n            </div> \n            <nav role="navigation">\n              <div id="menuToggle">\n                <input type="checkbox">\n                <span></span>\n                <span></span>\n                <span></span>\n            \n                <ul id="menu">\n                    <li><a ui-sref="page.about">About</a></li>\n                    <li><a ui-sref="page.artists">Artists</a></li>\n                    <li><a ui-sref="page.services">Services</a></li>\n                    <li><a ui-sref="page.contact">Contact</a></li>\n                </ul>\n              </div>\n            </nav>\n        </div>\n    </header>\n    <section id="homepage">\n        <div class="continents-list">\n            <div class="hidden-xs" id="map"></div>\n            <slick dots="true" infinite="false" arrows="false" class="mobile-continents visible-xs">\n                <div ng-repeat="(continentCode, continentName) in continents">\n                    <a href ui-sref="musicmap.continent({ name: (continentName | slug) })">\n                        <img ng-src="/images/continents/{{ continentCode}}.png" alt="{{ continentName }}">\n                    </a>\n                </div>\n            </slick>\n             \n        </div>\n         <div class="d-flex title_container">\n            <h2 class="left hp-title col-xs-12 col-sm-6 col-md-4">MusicMap is a music discovery platform dedicated to independent artists all over the planet. Click anywhere on the map to get started and discover the world one track at a time!\n            </h2>\n        </div>\n        <div class="social-media">\n            <a href="https://www.facebook.com/MusicMapGlobal/" target="_blank">\n                <i class="facebook"></i>\n            </a>\n            <a href="https://twitter.com/musicmapglobal?lang=en" target="_blank">\n                <i class="twitter"></i>\n            </a>\n            <a href="https://www.instagram.com/musicmapglobal/" target="_blank">\n                <i class="instagram"></i>\n            </a>\n             <a href="https://open.spotify.com/user/musicmap.global?si=WHcmWUsWTVustvLJNd-3Zg" target="_blank">\n                <i class="spotify"></i>\n            </a>\n        </div>\n       \n        <div class="featured">\n            <a href ng-click="toggleHomepageArticles()" class="big-heart tooltips">\n                <i class="fa" ng-class="{\'fa-heart\': $root.homepageArticlesMode == \'featured\', \'fa-star\': $root.homepageArticlesMode == \'favorites\'}"></i>\n\n            </a>\n            <div class="articles-wrapper">\n                <slick settings="homepageSlickConfig" ng-if="featuredArticlesLoaded && $root.homepageArticlesMode == \'featured\'">\n                    <div class="item" ng-repeat="article in featuredArticles">\n                        <a href ng-click="toggleFavorite(article.id);" class="heart">\n                            <i ng-class="{\'fa-heart\': isFavorite(article.id), \'fa-heart-o\': !isFavorite(article.id)}" class="fa"></i>\n                        </a>\n\n                        <a href ui-sref="musicmap.article({ path: article.path, id: article.id })" class="image-holder" ng-style="{\'background-image\': \'url(\' + article.images.thb + \')\'}"></a>\n\n                        <a href ui-sref="musicmap.article({ path: article.path, id: article.id })" class="info-holder">\n                            <strong>{{ article.title }}</strong>\n                            <div ng-bind-html="article.shortDescription | removeHTMLTags | maxLength: 75 | unsafe"></div>\n                        </a>\n                    </div>\n                </slick>\n\n                <slick settings="homepageSlickConfig" ng-if="$root.favoriteArticlesLoaded && $root.homepageArticlesMode == \'favorites\'">\n                    <div class="item" ng-repeat="article in favoriteArticles">\n                        <a href ng-click="toggleFavorite(article.id);" class="heart">\n                            <i class="fa fa-heart"></i>\n                        </a>\n\n                        <a href ui-sref="musicmap.article({ path: article.path, id: article.id })" class="image-holder" ng-style="{\'background-image\': \'url(\' + article.images.thb + \')\'}"></a>\n\n                        <a href ui-sref="musicmap.article({ path: article.path, id: article.id })" class="info-holder">\n                            <strong>{{ article.title }}</strong>\n                            <div ng-bind-html="article.shortDescription | removeHTMLTags | maxLength: 75 | unsafe"></div>\n                        </a>\n                    </div>\n                </slick>\n            </div>\n        </div>\n    </section>\n   \n    <section id="about-popup" class="popup" ng-class="{\'opened\': aboutOpened}">\n        <div class="wrapper">\n            <h2>\n                About\n                <a href ng-click="aboutOpened = !aboutOpened"><i class="fa fa-times"></i></a>\n            </h2>\n\n            <div class="about-content" ng-bind-html="aboutContent.about | unsafe"></div>\n\n            <a ng-href="mailto: {{ aboutContent.email }}" target="_blank" class="btn btn-block btn-main">Contact Us</a>\n        </div>\n    </section>\n</main>\n');
    $templateCache.put('views/player.html', '<div id="player" ng-controller="PlayerController as playerController" ng-init="playerController.init()" ng-class="{\'is-collapsed\': $root.playerCollapsed}">\n    <div class="player-bar">\n        <a href class="visible-xs toggle-player" ng-click="$root.playerCollapsed = !$root.playerCollapsed" id="player-click">\n            <i ng-if="$root.playerCollapsed" class="fa fa-angle-up"></i>\n            <i ng-if="!$root.playerCollapsed" class="fa fa-angle-down"></i>\n        </a>\n        <div class="col-md-3 now-playing" ng-click="linkTrackToCountry(currentTrack());" ng-class="{\'pointer\': trackHasCountry(currentTrack())}">\n            <div class="image-holder">\n                <img ng-src="{{ currentTrack().cover }}">\n            </div>\n            <div class="track-holder">\n                <div class="hidden-xs">\n                    <span class="xs-font-size">Now playing</span>\n                    <strong class="display-inline-md">{{ currentTrack().nameTrack }}</strong>\n                    <span class="xs-font-size visible-sm">by</span>\n                    <span class="display-inline-md">{{ currentTrack().nameArtist }}</span>\n                    <span class="xs-font-size">{{ currentTrack().countries | implodeCountries }}</span>\n                </div>\n                <div class="track-summary visible-xs">\n                    {{ currentTrack().nameTrack }} by {{ currentTrack().nameArtist }}\n                </div>\n            </div>\n        </div>\n        <div class="col-md-6 play-controls">\n            <div class="controls">\n                <div class="buttons">\n                    <a href ng-click="playerController.getPlaylist(true);" ng-show="$root.playerSection != \'homepage\'"><i class="fa fa-globe"></i></a>\n\n                    <a href ng-class="{\'disabled\': !previousTrack()}" ng-click="previous()"><i class="fa fa-step-backward"></i></a>\n                    <a href ng-if="!$root.playing" ng-click="play()"><i class="fa fa-play"></i></a>\n                    <a href ng-if="$root.playing" ng-click="pause()"><i class="fa fa-pause"></i></a>\n                    <a href ng-class="{\'disabled\': !nextTrack()}" ng-click="next()"><i class="fa fa-step-forward"></i></a>\n                </div>\n                <div class="slidecontainer">\n                    <span class="current">{{ $root.player.currentTime | trackTime }}</span>\n                    <input type="range" min="0" max="1" step="0.001" class="slider" ng-model="audioProgressControl.value">\n                    <span class="total">{{ $root.player.duration | trackTime }}</span>\n                </div>\n            </div>\n        </div>\n        <div class="col-md-3 next-in-queue" ng-if="nextTrack()" ng-click="linkTrackToCountry(nextTrack());" ng-class="{\'pointer\': trackHasCountry(nextTrack())}">\n            <div class="image-holder">\n                <img ng-src="{{ nextTrack().cover }}">\n            </div>\n            <div class="track-holder">\n                <span class="xs-font-size">Next track</span>\n                <strong class="display-inline-md">{{ nextTrack().nameTrack }}</strong>\n                <span class="xs-font-size visible-sm">by</span>\n                <span class="display-inline-md">{{ nextTrack().nameArtist }}</span>\n                <span class="xs-font-size">{{ nextTrack().countries | implodeCountries }}</span>\n            </div>\n        </div>\n    </div>\n</div>\n');
    $templateCache.put('views/privacy-policy.html', '<main ng-controller="PageController as pageController" ng-init="pageController.init()" class="page-content">\n\n    <h2>Privacy Policy</h2>\n\n    <div class="about-content">\n        <p>\n            MusicMap is operated by Record-Play Ltd, a privately owned company\n            registered in Spain and the United Kingdom. Record-Play takes privacy\n            seriously and promises to protect and respect any personal data you share\n            with us, or that we get from other organisations. By visiting MusicMap you\n            are accepting the policies outlined in this Privacy Policy, which explains\n            the type of data we use and how we use it.\n        </p>\n\n        <h3>How we collect personal information:</h3>\n        <p>\n            <strong>1. When you give it to us directly</strong>\n            , by signing up to our email newsletter or entering a competition. By\n            providing your e-mail address you agree to: Receive correspondence from\n            MusicMap regarding, but not limited to, content, competitions,\n            announcements and service updates. You agree to receive such correspondence\n            indefinitely, unless you unsubscribe via the unsubscribe option available\n            on every correspondence. Record-Play agrees to not share your data with any\n            third parties.\n        </p>\n        <p>\n            <strong>2. When you use our website. </strong>\n            Like most websites, we use cookies to help us make our site \u2013 and the way\n            you use it \u2013 better. Cookies are small text files stored on your device\n            that allow us to recognise your device so that we can tailor certain\n            content to you automatically.\n        </p>\n        <p>\n            We use cookies to enhance the online experience of our visitors; for\n            example, by letting visitors save their favourite posts using the heart\n            icon. We also use cookies for visitor analytics; however, as we are an\n            ad-free platform this is for internal purposes only, in order to inform any\n            design or content changes we make to the site.\n        </p>\n        <p>\n            You have the right to choose whether you want to accept these cookies. By\n            default, your browser will accept cookies \u2013 this can be changed by amending\n            the controls on your browser to reflect your cookie preferences. Please\n            note, disabling cookies may prevent you from using the full range of\n            services available on this website.\n        </p>\n        <p>\n            Our website uses tracking software to monitor our visitors to understand\n            how they use it. We use software provided by Google Analytics, which uses\n            cookies to track visitor usage. This software will save a cookie to your\n            computer\u2019s hard drive to track and monitor your engagement and use of the\n            website, and to help identify you on future visits. It will not store, save\n            or collect personal information.\n        </p>\n\n        <h3>The MusicMap Native Player: for visitors</h3>\n        <p>\n            The MusicMap Native Player is a streaming only service offered by MusicMap.\n            MusicMap does not host advertising, nor generate any revenue from music\n            streaming. It is designed to support new music and help develop global\n            music scenes.\n        </p>\n        <p>\n            The Native Player only hosts tracks that have been cleared with each\n            track\u2019s rightsholder(s). Material on Native Player is owned explicitly by\n            the rights holder(s) and they retain sole rights to grant any and all\n            licenses for commercial and other use. The rightsholder(s) take full\n            responsibility for the clearance of any samples in any of the hosted\n            tracks. Copyright infringement notices will be complied with and the\n            relevant rights holder(s) notified. Neither MusicMap nor its users have the\n            right to claim or hold any rights for any of the material on the Native\n            Player or the site.\n        </p>\n        <p>\n            Users are not granted any permissions more than being able to stream only\n            content featured on the Native Player. Users are explicitly forbidden to\n            rip, record or otherwise pirate any of the material hosted on the Native\n            Player.\n        </p>\n        <p>\n            Content on the Native Player may change. MusicMap and rights holder(s)\n            reserve the right to remove and add content at any time.\n        </p>\n\n        <h3>The MusicMap Native Player: for rightsholders</h3>\n        <p>\n            We have designed the Native Player to allow the music-loving public to\n            discover the world\u2019s newest and most exciting music. We make it easy for\n            listeners to share non-downloadable streaming links through which users are\n            able to play tracks only within the context of the MusicMap Native Player.\n            We complement uploads with in-depth editorial content, and promote the site\n            and the player through our extensive business-to-consumer network, as well\n            as our brand and music licensing network.\n            <br>\n            <br>\n            MusicMap is operated by Record-Play Ltd. We are based in the UK and as such\n            pay an online blanket fee to PRS/PPL in order to operate as a digital music\n            streaming service. This means that if your music is registered with a\n            collection society you should be earning broadcast royalties from them.\n            MusicMap does not pay rightsholders directly for music streaming. We\n            strongly advise that you register your works with your local Performance\n            Rights Organization (\n            <a href="https://en.wikipedia.org/wiki/Performance_rights_organisation">\n                https://en.wikipedia.org/wiki/Performance_rights_organisation\n            </a>\n            ).\n            <br>\n            <br>\n            Tracks can only be uploaded by artists who either\n            <br>\n            1) retain copyright controls on the track, or\n            <br>\n            2) by organisations who have the right to distribute the track to digital\n            music platforms.\n            <br>\n            <br>\n            In the event that the editorial board is granted the right to upload a\n            track, either of the above two criteria must be applicable to whoever is\n            granting the editorial board the right to upload.\n            <br>\n            <br>\n            The artist(s)/rightsholder(s) retain all rights to the track - uploading a\n            track to the MusicMap Native Player does not give Record-Play any rights to\n            the track other than to make it available for streaming via the MusicMap\n            Native Player only.\n            <br>\n            <br>\n            The Native Player exists on the site <a href="http://www.musicmap.global/"> www.musicmap.global</a> and\n            also,\n            via its API, can be shared via social networks and embedded on third party\n            sites.\n            <br>\n            <br>\n            The artist(s)/rightsholder(s) reserve the right to remove a track at any\n            time. They can either do this themselves (see instructions provided\n            separately) or by request to the editorial team.\n            <br>\n            <br>\n            Copyright infringement notices will be recognised by Record-Play and works\n            uploaded to the Native Player will be removed if flagged for violating\n            copyright law. Artist(s)/rightsholder(s) will be informed if this takes\n            place.\n        </p>\n        <p>\n            MusicMap does not host advertising, nor generate any revenue from music\n            streaming. It is designed to support new music and help develop global\n            music scenes. For any questions please contact kier@record-play.net.\n        </p>\n    </div>\n</main>\n');
    $templateCache.put('views/services.html', '<main ng-controller="ServicesController as servicesController" ng-init="servicesController.init()">\n    <header>\n        <div class="col-xs-6 pl-0">\n            <a ui-sref="musicmap.homepage" class="logo"></a>\n        </div>\n        <div class="main_nav col-xs-6">\n            <nav role="navigation">\n                <div id="menuToggle">\n                    <input type="checkbox">\n                    <span></span>\n                    <span></span>\n                    <span></span>\n                    <ul id="menu">\n                        <li><a ui-sref="page.about">About</a></li>\n                        <li><a ui-sref="page.artists">Artists</a></li>\n                        <li><a ui-sref="page.services">Services</a></li>\n                        <li><a ui-sref="page.contact">Contact</a></li>\n                    </ul>\n                </div>\n            </nav>\n        </div>\n    </header>\n    <section id="services">\n        <div class="container text-containers">\n            <div class="row">\n                <div class="col-sm-12">\n                    <h2 class="float-left">Services</h2>\n                    <p>Looking for an up-and-coming artist from a specific country to appear in a film or ad\n                        campaign? </p>\n                    <p>Want to add local flavours to your in-store playlists or inflight entertainment system? </p>\n                    <p>Feel you need a more diverse soundtrack for your film, TV show or computer game?\n                    </p><p>\n                    </p><p>Or do you just want to gain a better understanding of local music scenes? </p>\n                    <p>If so, MusicMap can help. </p>\n                    <p>We are able to offer strategic audio branding and geo-targeted music supervision to benefit any\n                        project. We help create distinct sonic identities for our clients by specialising in: </p>\n                    <div class="col-sm-14">\n                        <p>\n                        </p><ul style="list-style-type:disc;">\n                            <li>Music trend-spotting</li>\n                            <li>Geo-targeted campaigns</li>\n                            <li>Territorial music insights</li>\n                            <li>Influencer marketing</li>\n                            <li>Localised music content</li>\n                            <li>Sonic branding</li>\n                            <li>Playlist curation</li>\n                            <li>Music-related concepts and strategies</li>\n                        </ul>\n                        If you think your project or campaign could benefit from MusicMap\u2019s specialist knowledge give us\n                        a shout via the following form: <p></p>\n                        <div>\n                        </div>\n                    </div>\n                </div>\n\n    </div></div></section>\n    <section id="contact" class="pb-50">\n        <div class="container text-containers">\n            <div class="row">\n                <div class="wrapper mauto col-sm-6 col-xs-12">\n                    <h2>\n                        Contact\n                    </h2>\n\n                    <form ng-if="!contactSuccess" name="contactForm" ng-submit="doContact();">\n                        <div class="fields">\n                            <input class="text-field" type="text" ng-class="{\'error\': contactError.name}" placeholder="Name" name="contactName" ng-model="contact.name">\n\n                            <input class="text-field" type="text" ng-class="{\'error\': contactError.company}" placeholder="Company" name="contactCompany" ng-model="contact.company">\n\n                            <input class="text-field" type="email" ng-class="{\'error\': contactError.email}" placeholder="Email" name="contactEmail" ng-model="contact.email">\n\n                            <textarea class="text-field" type="text" ng-class="{\'error\': contactError.message}" placeholder="Message" name="contactMessage" ng-model="contact.message"></textarea>\n\n                            <div class="terms-holder" ng-class="{\'error\': contactError.gdpr}">\n                                <label class="check-container white">I consent to having MusicMap and its parent\n                                    company, Record-Play, store my submitted information so they can respond to my\n                                    enquiry.\n                                    <input type="checkbox" ng-model="contact.gdpr" value="1">\n                                    <span class="checkmark"></span>\n                                </label>\n                            </div>\n\n                        </div>\n                        <script src="https://www.google.com/recaptcha/api.js"></script>\n                        <div vc-recaptcha key="\'6LclOI8UAAAAAD7lixtupG5eEksjuITBO1lrkb9D\'"></div>\n                        <button type="submit" class="btn btn-block btn-main">Contact</button>\n                    </form>\n                    <div ng-if="contactSuccess">\n                        <h4>Sent!</h4>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </section>\n</main>');
  }]);
  return module.exports;
});

(function() {
var define = $__System.amdDefine;
(function(global, factory) {
  "use strict";
  if (typeof module === "object" && typeof module.exports === "object") {
    module.exports = global.document ? factory(global, true) : function(w) {
      if (!w.document) {
        throw new Error("jQuery requires a window with a document");
      }
      return factory(w);
    };
  } else {
    factory(global);
  }
})(typeof window !== "undefined" ? window : this, function(window, noGlobal) {
  "use strict";
  var arr = [];
  var document = window.document;
  var getProto = Object.getPrototypeOf;
  var slice = arr.slice;
  var concat = arr.concat;
  var push = arr.push;
  var indexOf = arr.indexOf;
  var class2type = {};
  var toString = class2type.toString;
  var hasOwn = class2type.hasOwnProperty;
  var fnToString = hasOwn.toString;
  var ObjectFunctionString = fnToString.call(Object);
  var support = {};
  var isFunction = function isFunction(obj) {
    return typeof obj === "function" && typeof obj.nodeType !== "number";
  };
  var isWindow = function isWindow(obj) {
    return obj != null && obj === obj.window;
  };
  var preservedScriptAttributes = {
    type: true,
    src: true,
    noModule: true
  };
  function DOMEval(code, doc, node) {
    doc = doc || document;
    var i,
        script = doc.createElement("script");
    script.text = code;
    if (node) {
      for (i in preservedScriptAttributes) {
        if (node[i]) {
          script[i] = node[i];
        }
      }
    }
    doc.head.appendChild(script).parentNode.removeChild(script);
  }
  function toType(obj) {
    if (obj == null) {
      return obj + "";
    }
    return typeof obj === "object" || typeof obj === "function" ? class2type[toString.call(obj)] || "object" : typeof obj;
  }
  var version = "3.3.1",
      jQuery = function(selector, context) {
        return new jQuery.fn.init(selector, context);
      },
      rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
  jQuery.fn = jQuery.prototype = {
    jquery: version,
    constructor: jQuery,
    length: 0,
    toArray: function() {
      return slice.call(this);
    },
    get: function(num) {
      if (num == null) {
        return slice.call(this);
      }
      return num < 0 ? this[num + this.length] : this[num];
    },
    pushStack: function(elems) {
      var ret = jQuery.merge(this.constructor(), elems);
      ret.prevObject = this;
      return ret;
    },
    each: function(callback) {
      return jQuery.each(this, callback);
    },
    map: function(callback) {
      return this.pushStack(jQuery.map(this, function(elem, i) {
        return callback.call(elem, i, elem);
      }));
    },
    slice: function() {
      return this.pushStack(slice.apply(this, arguments));
    },
    first: function() {
      return this.eq(0);
    },
    last: function() {
      return this.eq(-1);
    },
    eq: function(i) {
      var len = this.length,
          j = +i + (i < 0 ? len : 0);
      return this.pushStack(j >= 0 && j < len ? [this[j]] : []);
    },
    end: function() {
      return this.prevObject || this.constructor();
    },
    push: push,
    sort: arr.sort,
    splice: arr.splice
  };
  jQuery.extend = jQuery.fn.extend = function() {
    var options,
        name,
        src,
        copy,
        copyIsArray,
        clone,
        target = arguments[0] || {},
        i = 1,
        length = arguments.length,
        deep = false;
    if (typeof target === "boolean") {
      deep = target;
      target = arguments[i] || {};
      i++;
    }
    if (typeof target !== "object" && !isFunction(target)) {
      target = {};
    }
    if (i === length) {
      target = this;
      i--;
    }
    for (; i < length; i++) {
      if ((options = arguments[i]) != null) {
        for (name in options) {
          src = target[name];
          copy = options[name];
          if (target === copy) {
            continue;
          }
          if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
            if (copyIsArray) {
              copyIsArray = false;
              clone = src && Array.isArray(src) ? src : [];
            } else {
              clone = src && jQuery.isPlainObject(src) ? src : {};
            }
            target[name] = jQuery.extend(deep, clone, copy);
          } else if (copy !== undefined) {
            target[name] = copy;
          }
        }
      }
    }
    return target;
  };
  jQuery.extend({
    expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),
    isReady: true,
    error: function(msg) {
      throw new Error(msg);
    },
    noop: function() {},
    isPlainObject: function(obj) {
      var proto,
          Ctor;
      if (!obj || toString.call(obj) !== "[object Object]") {
        return false;
      }
      proto = getProto(obj);
      if (!proto) {
        return true;
      }
      Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
      return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
    },
    isEmptyObject: function(obj) {
      var name;
      for (name in obj) {
        return false;
      }
      return true;
    },
    globalEval: function(code) {
      DOMEval(code);
    },
    each: function(obj, callback) {
      var length,
          i = 0;
      if (isArrayLike(obj)) {
        length = obj.length;
        for (; i < length; i++) {
          if (callback.call(obj[i], i, obj[i]) === false) {
            break;
          }
        }
      } else {
        for (i in obj) {
          if (callback.call(obj[i], i, obj[i]) === false) {
            break;
          }
        }
      }
      return obj;
    },
    trim: function(text) {
      return text == null ? "" : (text + "").replace(rtrim, "");
    },
    makeArray: function(arr, results) {
      var ret = results || [];
      if (arr != null) {
        if (isArrayLike(Object(arr))) {
          jQuery.merge(ret, typeof arr === "string" ? [arr] : arr);
        } else {
          push.call(ret, arr);
        }
      }
      return ret;
    },
    inArray: function(elem, arr, i) {
      return arr == null ? -1 : indexOf.call(arr, elem, i);
    },
    merge: function(first, second) {
      var len = +second.length,
          j = 0,
          i = first.length;
      for (; j < len; j++) {
        first[i++] = second[j];
      }
      first.length = i;
      return first;
    },
    grep: function(elems, callback, invert) {
      var callbackInverse,
          matches = [],
          i = 0,
          length = elems.length,
          callbackExpect = !invert;
      for (; i < length; i++) {
        callbackInverse = !callback(elems[i], i);
        if (callbackInverse !== callbackExpect) {
          matches.push(elems[i]);
        }
      }
      return matches;
    },
    map: function(elems, callback, arg) {
      var length,
          value,
          i = 0,
          ret = [];
      if (isArrayLike(elems)) {
        length = elems.length;
        for (; i < length; i++) {
          value = callback(elems[i], i, arg);
          if (value != null) {
            ret.push(value);
          }
        }
      } else {
        for (i in elems) {
          value = callback(elems[i], i, arg);
          if (value != null) {
            ret.push(value);
          }
        }
      }
      return concat.apply([], ret);
    },
    guid: 1,
    support: support
  });
  if (typeof Symbol === "function") {
    jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
  }
  jQuery.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(i, name) {
    class2type["[object " + name + "]"] = name.toLowerCase();
  });
  function isArrayLike(obj) {
    var length = !!obj && "length" in obj && obj.length,
        type = toType(obj);
    if (isFunction(obj) || isWindow(obj)) {
      return false;
    }
    return type === "array" || length === 0 || typeof length === "number" && length > 0 && (length - 1) in obj;
  }
  var Sizzle = (function(window) {
    var i,
        support,
        Expr,
        getText,
        isXML,
        tokenize,
        compile,
        select,
        outermostContext,
        sortInput,
        hasDuplicate,
        setDocument,
        document,
        docElem,
        documentIsHTML,
        rbuggyQSA,
        rbuggyMatches,
        matches,
        contains,
        expando = "sizzle" + 1 * new Date(),
        preferredDoc = window.document,
        dirruns = 0,
        done = 0,
        classCache = createCache(),
        tokenCache = createCache(),
        compilerCache = createCache(),
        sortOrder = function(a, b) {
          if (a === b) {
            hasDuplicate = true;
          }
          return 0;
        },
        hasOwn = ({}).hasOwnProperty,
        arr = [],
        pop = arr.pop,
        push_native = arr.push,
        push = arr.push,
        slice = arr.slice,
        indexOf = function(list, elem) {
          var i = 0,
              len = list.length;
          for (; i < len; i++) {
            if (list[i] === elem) {
              return i;
            }
          }
          return -1;
        },
        booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
        whitespace = "[\\x20\\t\\r\\n\\f]",
        identifier = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",
        attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace + "*([*^$|!~]?=)" + whitespace + "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace + "*\\]",
        pseudos = ":(" + identifier + ")(?:\\((" + "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" + "((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" + ".*" + ")\\)|)",
        rwhitespace = new RegExp(whitespace + "+", "g"),
        rtrim = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g"),
        rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"),
        rcombinators = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"),
        rattributeQuotes = new RegExp("=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g"),
        rpseudo = new RegExp(pseudos),
        ridentifier = new RegExp("^" + identifier + "$"),
        matchExpr = {
          "ID": new RegExp("^#(" + identifier + ")"),
          "CLASS": new RegExp("^\\.(" + identifier + ")"),
          "TAG": new RegExp("^(" + identifier + "|[*])"),
          "ATTR": new RegExp("^" + attributes),
          "PSEUDO": new RegExp("^" + pseudos),
          "CHILD": new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i"),
          "bool": new RegExp("^(?:" + booleans + ")$", "i"),
          "needsContext": new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
        },
        rinputs = /^(?:input|select|textarea|button)$/i,
        rheader = /^h\d$/i,
        rnative = /^[^{]+\{\s*\[native \w/,
        rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
        rsibling = /[+~]/,
        runescape = new RegExp("\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig"),
        funescape = function(_, escaped, escapedWhitespace) {
          var high = "0x" + escaped - 0x10000;
          return high !== high || escapedWhitespace ? escaped : high < 0 ? String.fromCharCode(high + 0x10000) : String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00);
        },
        rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
        fcssescape = function(ch, asCodePoint) {
          if (asCodePoint) {
            if (ch === "\0") {
              return "\uFFFD";
            }
            return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ";
          }
          return "\\" + ch;
        },
        unloadHandler = function() {
          setDocument();
        },
        disabledAncestor = addCombinator(function(elem) {
          return elem.disabled === true && ("form" in elem || "label" in elem);
        }, {
          dir: "parentNode",
          next: "legend"
        });
    try {
      push.apply((arr = slice.call(preferredDoc.childNodes)), preferredDoc.childNodes);
      arr[preferredDoc.childNodes.length].nodeType;
    } catch (e) {
      push = {apply: arr.length ? function(target, els) {
          push_native.apply(target, slice.call(els));
        } : function(target, els) {
          var j = target.length,
              i = 0;
          while ((target[j++] = els[i++])) {}
          target.length = j - 1;
        }};
    }
    function Sizzle(selector, context, results, seed) {
      var m,
          i,
          elem,
          nid,
          match,
          groups,
          newSelector,
          newContext = context && context.ownerDocument,
          nodeType = context ? context.nodeType : 9;
      results = results || [];
      if (typeof selector !== "string" || !selector || nodeType !== 1 && nodeType !== 9 && nodeType !== 11) {
        return results;
      }
      if (!seed) {
        if ((context ? context.ownerDocument || context : preferredDoc) !== document) {
          setDocument(context);
        }
        context = context || document;
        if (documentIsHTML) {
          if (nodeType !== 11 && (match = rquickExpr.exec(selector))) {
            if ((m = match[1])) {
              if (nodeType === 9) {
                if ((elem = context.getElementById(m))) {
                  if (elem.id === m) {
                    results.push(elem);
                    return results;
                  }
                } else {
                  return results;
                }
              } else {
                if (newContext && (elem = newContext.getElementById(m)) && contains(context, elem) && elem.id === m) {
                  results.push(elem);
                  return results;
                }
              }
            } else if (match[2]) {
              push.apply(results, context.getElementsByTagName(selector));
              return results;
            } else if ((m = match[3]) && support.getElementsByClassName && context.getElementsByClassName) {
              push.apply(results, context.getElementsByClassName(m));
              return results;
            }
          }
          if (support.qsa && !compilerCache[selector + " "] && (!rbuggyQSA || !rbuggyQSA.test(selector))) {
            if (nodeType !== 1) {
              newContext = context;
              newSelector = selector;
            } else if (context.nodeName.toLowerCase() !== "object") {
              if ((nid = context.getAttribute("id"))) {
                nid = nid.replace(rcssescape, fcssescape);
              } else {
                context.setAttribute("id", (nid = expando));
              }
              groups = tokenize(selector);
              i = groups.length;
              while (i--) {
                groups[i] = "#" + nid + " " + toSelector(groups[i]);
              }
              newSelector = groups.join(",");
              newContext = rsibling.test(selector) && testContext(context.parentNode) || context;
            }
            if (newSelector) {
              try {
                push.apply(results, newContext.querySelectorAll(newSelector));
                return results;
              } catch (qsaError) {} finally {
                if (nid === expando) {
                  context.removeAttribute("id");
                }
              }
            }
          }
        }
      }
      return select(selector.replace(rtrim, "$1"), context, results, seed);
    }
    function createCache() {
      var keys = [];
      function cache(key, value) {
        if (keys.push(key + " ") > Expr.cacheLength) {
          delete cache[keys.shift()];
        }
        return (cache[key + " "] = value);
      }
      return cache;
    }
    function markFunction(fn) {
      fn[expando] = true;
      return fn;
    }
    function assert(fn) {
      var el = document.createElement("fieldset");
      try {
        return !!fn(el);
      } catch (e) {
        return false;
      } finally {
        if (el.parentNode) {
          el.parentNode.removeChild(el);
        }
        el = null;
      }
    }
    function addHandle(attrs, handler) {
      var arr = attrs.split("|"),
          i = arr.length;
      while (i--) {
        Expr.attrHandle[arr[i]] = handler;
      }
    }
    function siblingCheck(a, b) {
      var cur = b && a,
          diff = cur && a.nodeType === 1 && b.nodeType === 1 && a.sourceIndex - b.sourceIndex;
      if (diff) {
        return diff;
      }
      if (cur) {
        while ((cur = cur.nextSibling)) {
          if (cur === b) {
            return -1;
          }
        }
      }
      return a ? 1 : -1;
    }
    function createInputPseudo(type) {
      return function(elem) {
        var name = elem.nodeName.toLowerCase();
        return name === "input" && elem.type === type;
      };
    }
    function createButtonPseudo(type) {
      return function(elem) {
        var name = elem.nodeName.toLowerCase();
        return (name === "input" || name === "button") && elem.type === type;
      };
    }
    function createDisabledPseudo(disabled) {
      return function(elem) {
        if ("form" in elem) {
          if (elem.parentNode && elem.disabled === false) {
            if ("label" in elem) {
              if ("label" in elem.parentNode) {
                return elem.parentNode.disabled === disabled;
              } else {
                return elem.disabled === disabled;
              }
            }
            return elem.isDisabled === disabled || elem.isDisabled !== !disabled && disabledAncestor(elem) === disabled;
          }
          return elem.disabled === disabled;
        } else if ("label" in elem) {
          return elem.disabled === disabled;
        }
        return false;
      };
    }
    function createPositionalPseudo(fn) {
      return markFunction(function(argument) {
        argument = +argument;
        return markFunction(function(seed, matches) {
          var j,
              matchIndexes = fn([], seed.length, argument),
              i = matchIndexes.length;
          while (i--) {
            if (seed[(j = matchIndexes[i])]) {
              seed[j] = !(matches[j] = seed[j]);
            }
          }
        });
      });
    }
    function testContext(context) {
      return context && typeof context.getElementsByTagName !== "undefined" && context;
    }
    support = Sizzle.support = {};
    isXML = Sizzle.isXML = function(elem) {
      var documentElement = elem && (elem.ownerDocument || elem).documentElement;
      return documentElement ? documentElement.nodeName !== "HTML" : false;
    };
    setDocument = Sizzle.setDocument = function(node) {
      var hasCompare,
          subWindow,
          doc = node ? node.ownerDocument || node : preferredDoc;
      if (doc === document || doc.nodeType !== 9 || !doc.documentElement) {
        return document;
      }
      document = doc;
      docElem = document.documentElement;
      documentIsHTML = !isXML(document);
      if (preferredDoc !== document && (subWindow = document.defaultView) && subWindow.top !== subWindow) {
        if (subWindow.addEventListener) {
          subWindow.addEventListener("unload", unloadHandler, false);
        } else if (subWindow.attachEvent) {
          subWindow.attachEvent("onunload", unloadHandler);
        }
      }
      support.attributes = assert(function(el) {
        el.className = "i";
        return !el.getAttribute("className");
      });
      support.getElementsByTagName = assert(function(el) {
        el.appendChild(document.createComment(""));
        return !el.getElementsByTagName("*").length;
      });
      support.getElementsByClassName = rnative.test(document.getElementsByClassName);
      support.getById = assert(function(el) {
        docElem.appendChild(el).id = expando;
        return !document.getElementsByName || !document.getElementsByName(expando).length;
      });
      if (support.getById) {
        Expr.filter["ID"] = function(id) {
          var attrId = id.replace(runescape, funescape);
          return function(elem) {
            return elem.getAttribute("id") === attrId;
          };
        };
        Expr.find["ID"] = function(id, context) {
          if (typeof context.getElementById !== "undefined" && documentIsHTML) {
            var elem = context.getElementById(id);
            return elem ? [elem] : [];
          }
        };
      } else {
        Expr.filter["ID"] = function(id) {
          var attrId = id.replace(runescape, funescape);
          return function(elem) {
            var node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
            return node && node.value === attrId;
          };
        };
        Expr.find["ID"] = function(id, context) {
          if (typeof context.getElementById !== "undefined" && documentIsHTML) {
            var node,
                i,
                elems,
                elem = context.getElementById(id);
            if (elem) {
              node = elem.getAttributeNode("id");
              if (node && node.value === id) {
                return [elem];
              }
              elems = context.getElementsByName(id);
              i = 0;
              while ((elem = elems[i++])) {
                node = elem.getAttributeNode("id");
                if (node && node.value === id) {
                  return [elem];
                }
              }
            }
            return [];
          }
        };
      }
      Expr.find["TAG"] = support.getElementsByTagName ? function(tag, context) {
        if (typeof context.getElementsByTagName !== "undefined") {
          return context.getElementsByTagName(tag);
        } else if (support.qsa) {
          return context.querySelectorAll(tag);
        }
      } : function(tag, context) {
        var elem,
            tmp = [],
            i = 0,
            results = context.getElementsByTagName(tag);
        if (tag === "*") {
          while ((elem = results[i++])) {
            if (elem.nodeType === 1) {
              tmp.push(elem);
            }
          }
          return tmp;
        }
        return results;
      };
      Expr.find["CLASS"] = support.getElementsByClassName && function(className, context) {
        if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) {
          return context.getElementsByClassName(className);
        }
      };
      rbuggyMatches = [];
      rbuggyQSA = [];
      if ((support.qsa = rnative.test(document.querySelectorAll))) {
        assert(function(el) {
          docElem.appendChild(el).innerHTML = "<a id='" + expando + "'></a>" + "<select id='" + expando + "-\r\\' msallowcapture=''>" + "<option selected=''></option></select>";
          if (el.querySelectorAll("[msallowcapture^='']").length) {
            rbuggyQSA.push("[*^$]=" + whitespace + "*(?:''|\"\")");
          }
          if (!el.querySelectorAll("[selected]").length) {
            rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")");
          }
          if (!el.querySelectorAll("[id~=" + expando + "-]").length) {
            rbuggyQSA.push("~=");
          }
          if (!el.querySelectorAll(":checked").length) {
            rbuggyQSA.push(":checked");
          }
          if (!el.querySelectorAll("a#" + expando + "+*").length) {
            rbuggyQSA.push(".#.+[+~]");
          }
        });
        assert(function(el) {
          el.innerHTML = "<a href='' disabled='disabled'></a>" + "<select disabled='disabled'><option/></select>";
          var input = document.createElement("input");
          input.setAttribute("type", "hidden");
          el.appendChild(input).setAttribute("name", "D");
          if (el.querySelectorAll("[name=d]").length) {
            rbuggyQSA.push("name" + whitespace + "*[*^$|!~]?=");
          }
          if (el.querySelectorAll(":enabled").length !== 2) {
            rbuggyQSA.push(":enabled", ":disabled");
          }
          docElem.appendChild(el).disabled = true;
          if (el.querySelectorAll(":disabled").length !== 2) {
            rbuggyQSA.push(":enabled", ":disabled");
          }
          el.querySelectorAll("*,:x");
          rbuggyQSA.push(",.*:");
        });
      }
      if ((support.matchesSelector = rnative.test((matches = docElem.matches || docElem.webkitMatchesSelector || docElem.mozMatchesSelector || docElem.oMatchesSelector || docElem.msMatchesSelector)))) {
        assert(function(el) {
          support.disconnectedMatch = matches.call(el, "*");
          matches.call(el, "[s!='']:x");
          rbuggyMatches.push("!=", pseudos);
        });
      }
      rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));
      rbuggyMatches = rbuggyMatches.length && new RegExp(rbuggyMatches.join("|"));
      hasCompare = rnative.test(docElem.compareDocumentPosition);
      contains = hasCompare || rnative.test(docElem.contains) ? function(a, b) {
        var adown = a.nodeType === 9 ? a.documentElement : a,
            bup = b && b.parentNode;
        return a === bup || !!(bup && bup.nodeType === 1 && (adown.contains ? adown.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
      } : function(a, b) {
        if (b) {
          while ((b = b.parentNode)) {
            if (b === a) {
              return true;
            }
          }
        }
        return false;
      };
      sortOrder = hasCompare ? function(a, b) {
        if (a === b) {
          hasDuplicate = true;
          return 0;
        }
        var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
        if (compare) {
          return compare;
        }
        compare = (a.ownerDocument || a) === (b.ownerDocument || b) ? a.compareDocumentPosition(b) : 1;
        if (compare & 1 || (!support.sortDetached && b.compareDocumentPosition(a) === compare)) {
          if (a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a)) {
            return -1;
          }
          if (b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b)) {
            return 1;
          }
          return sortInput ? (indexOf(sortInput, a) - indexOf(sortInput, b)) : 0;
        }
        return compare & 4 ? -1 : 1;
      } : function(a, b) {
        if (a === b) {
          hasDuplicate = true;
          return 0;
        }
        var cur,
            i = 0,
            aup = a.parentNode,
            bup = b.parentNode,
            ap = [a],
            bp = [b];
        if (!aup || !bup) {
          return a === document ? -1 : b === document ? 1 : aup ? -1 : bup ? 1 : sortInput ? (indexOf(sortInput, a) - indexOf(sortInput, b)) : 0;
        } else if (aup === bup) {
          return siblingCheck(a, b);
        }
        cur = a;
        while ((cur = cur.parentNode)) {
          ap.unshift(cur);
        }
        cur = b;
        while ((cur = cur.parentNode)) {
          bp.unshift(cur);
        }
        while (ap[i] === bp[i]) {
          i++;
        }
        return i ? siblingCheck(ap[i], bp[i]) : ap[i] === preferredDoc ? -1 : bp[i] === preferredDoc ? 1 : 0;
      };
      return document;
    };
    Sizzle.matches = function(expr, elements) {
      return Sizzle(expr, null, null, elements);
    };
    Sizzle.matchesSelector = function(elem, expr) {
      if ((elem.ownerDocument || elem) !== document) {
        setDocument(elem);
      }
      expr = expr.replace(rattributeQuotes, "='$1']");
      if (support.matchesSelector && documentIsHTML && !compilerCache[expr + " "] && (!rbuggyMatches || !rbuggyMatches.test(expr)) && (!rbuggyQSA || !rbuggyQSA.test(expr))) {
        try {
          var ret = matches.call(elem, expr);
          if (ret || support.disconnectedMatch || elem.document && elem.document.nodeType !== 11) {
            return ret;
          }
        } catch (e) {}
      }
      return Sizzle(expr, document, null, [elem]).length > 0;
    };
    Sizzle.contains = function(context, elem) {
      if ((context.ownerDocument || context) !== document) {
        setDocument(context);
      }
      return contains(context, elem);
    };
    Sizzle.attr = function(elem, name) {
      if ((elem.ownerDocument || elem) !== document) {
        setDocument(elem);
      }
      var fn = Expr.attrHandle[name.toLowerCase()],
          val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : undefined;
      return val !== undefined ? val : support.attributes || !documentIsHTML ? elem.getAttribute(name) : (val = elem.getAttributeNode(name)) && val.specified ? val.value : null;
    };
    Sizzle.escape = function(sel) {
      return (sel + "").replace(rcssescape, fcssescape);
    };
    Sizzle.error = function(msg) {
      throw new Error("Syntax error, unrecognized expression: " + msg);
    };
    Sizzle.uniqueSort = function(results) {
      var elem,
          duplicates = [],
          j = 0,
          i = 0;
      hasDuplicate = !support.detectDuplicates;
      sortInput = !support.sortStable && results.slice(0);
      results.sort(sortOrder);
      if (hasDuplicate) {
        while ((elem = results[i++])) {
          if (elem === results[i]) {
            j = duplicates.push(i);
          }
        }
        while (j--) {
          results.splice(duplicates[j], 1);
        }
      }
      sortInput = null;
      return results;
    };
    getText = Sizzle.getText = function(elem) {
      var node,
          ret = "",
          i = 0,
          nodeType = elem.nodeType;
      if (!nodeType) {
        while ((node = elem[i++])) {
          ret += getText(node);
        }
      } else if (nodeType === 1 || nodeType === 9 || nodeType === 11) {
        if (typeof elem.textContent === "string") {
          return elem.textContent;
        } else {
          for (elem = elem.firstChild; elem; elem = elem.nextSibling) {
            ret += getText(elem);
          }
        }
      } else if (nodeType === 3 || nodeType === 4) {
        return elem.nodeValue;
      }
      return ret;
    };
    Expr = Sizzle.selectors = {
      cacheLength: 50,
      createPseudo: markFunction,
      match: matchExpr,
      attrHandle: {},
      find: {},
      relative: {
        ">": {
          dir: "parentNode",
          first: true
        },
        " ": {dir: "parentNode"},
        "+": {
          dir: "previousSibling",
          first: true
        },
        "~": {dir: "previousSibling"}
      },
      preFilter: {
        "ATTR": function(match) {
          match[1] = match[1].replace(runescape, funescape);
          match[3] = (match[3] || match[4] || match[5] || "").replace(runescape, funescape);
          if (match[2] === "~=") {
            match[3] = " " + match[3] + " ";
          }
          return match.slice(0, 4);
        },
        "CHILD": function(match) {
          match[1] = match[1].toLowerCase();
          if (match[1].slice(0, 3) === "nth") {
            if (!match[3]) {
              Sizzle.error(match[0]);
            }
            match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
            match[5] = +((match[7] + match[8]) || match[3] === "odd");
          } else if (match[3]) {
            Sizzle.error(match[0]);
          }
          return match;
        },
        "PSEUDO": function(match) {
          var excess,
              unquoted = !match[6] && match[2];
          if (matchExpr["CHILD"].test(match[0])) {
            return null;
          }
          if (match[3]) {
            match[2] = match[4] || match[5] || "";
          } else if (unquoted && rpseudo.test(unquoted) && (excess = tokenize(unquoted, true)) && (excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {
            match[0] = match[0].slice(0, excess);
            match[2] = unquoted.slice(0, excess);
          }
          return match.slice(0, 3);
        }
      },
      filter: {
        "TAG": function(nodeNameSelector) {
          var nodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
          return nodeNameSelector === "*" ? function() {
            return true;
          } : function(elem) {
            return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
          };
        },
        "CLASS": function(className) {
          var pattern = classCache[className + " "];
          return pattern || (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)")) && classCache(className, function(elem) {
            return pattern.test(typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "");
          });
        },
        "ATTR": function(name, operator, check) {
          return function(elem) {
            var result = Sizzle.attr(elem, name);
            if (result == null) {
              return operator === "!=";
            }
            if (!operator) {
              return true;
            }
            result += "";
            return operator === "=" ? result === check : operator === "!=" ? result !== check : operator === "^=" ? check && result.indexOf(check) === 0 : operator === "*=" ? check && result.indexOf(check) > -1 : operator === "$=" ? check && result.slice(-check.length) === check : operator === "~=" ? (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1 : operator === "|=" ? result === check || result.slice(0, check.length + 1) === check + "-" : false;
          };
        },
        "CHILD": function(type, what, argument, first, last) {
          var simple = type.slice(0, 3) !== "nth",
              forward = type.slice(-4) !== "last",
              ofType = what === "of-type";
          return first === 1 && last === 0 ? function(elem) {
            return !!elem.parentNode;
          } : function(elem, context, xml) {
            var cache,
                uniqueCache,
                outerCache,
                node,
                nodeIndex,
                start,
                dir = simple !== forward ? "nextSibling" : "previousSibling",
                parent = elem.parentNode,
                name = ofType && elem.nodeName.toLowerCase(),
                useCache = !xml && !ofType,
                diff = false;
            if (parent) {
              if (simple) {
                while (dir) {
                  node = elem;
                  while ((node = node[dir])) {
                    if (ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1) {
                      return false;
                    }
                  }
                  start = dir = type === "only" && !start && "nextSibling";
                }
                return true;
              }
              start = [forward ? parent.firstChild : parent.lastChild];
              if (forward && useCache) {
                node = parent;
                outerCache = node[expando] || (node[expando] = {});
                uniqueCache = outerCache[node.uniqueID] || (outerCache[node.uniqueID] = {});
                cache = uniqueCache[type] || [];
                nodeIndex = cache[0] === dirruns && cache[1];
                diff = nodeIndex && cache[2];
                node = nodeIndex && parent.childNodes[nodeIndex];
                while ((node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop())) {
                  if (node.nodeType === 1 && ++diff && node === elem) {
                    uniqueCache[type] = [dirruns, nodeIndex, diff];
                    break;
                  }
                }
              } else {
                if (useCache) {
                  node = elem;
                  outerCache = node[expando] || (node[expando] = {});
                  uniqueCache = outerCache[node.uniqueID] || (outerCache[node.uniqueID] = {});
                  cache = uniqueCache[type] || [];
                  nodeIndex = cache[0] === dirruns && cache[1];
                  diff = nodeIndex;
                }
                if (diff === false) {
                  while ((node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop())) {
                    if ((ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1) && ++diff) {
                      if (useCache) {
                        outerCache = node[expando] || (node[expando] = {});
                        uniqueCache = outerCache[node.uniqueID] || (outerCache[node.uniqueID] = {});
                        uniqueCache[type] = [dirruns, diff];
                      }
                      if (node === elem) {
                        break;
                      }
                    }
                  }
                }
              }
              diff -= last;
              return diff === first || (diff % first === 0 && diff / first >= 0);
            }
          };
        },
        "PSEUDO": function(pseudo, argument) {
          var args,
              fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || Sizzle.error("unsupported pseudo: " + pseudo);
          if (fn[expando]) {
            return fn(argument);
          }
          if (fn.length > 1) {
            args = [pseudo, pseudo, "", argument];
            return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? markFunction(function(seed, matches) {
              var idx,
                  matched = fn(seed, argument),
                  i = matched.length;
              while (i--) {
                idx = indexOf(seed, matched[i]);
                seed[idx] = !(matches[idx] = matched[i]);
              }
            }) : function(elem) {
              return fn(elem, 0, args);
            };
          }
          return fn;
        }
      },
      pseudos: {
        "not": markFunction(function(selector) {
          var input = [],
              results = [],
              matcher = compile(selector.replace(rtrim, "$1"));
          return matcher[expando] ? markFunction(function(seed, matches, context, xml) {
            var elem,
                unmatched = matcher(seed, null, xml, []),
                i = seed.length;
            while (i--) {
              if ((elem = unmatched[i])) {
                seed[i] = !(matches[i] = elem);
              }
            }
          }) : function(elem, context, xml) {
            input[0] = elem;
            matcher(input, null, xml, results);
            input[0] = null;
            return !results.pop();
          };
        }),
        "has": markFunction(function(selector) {
          return function(elem) {
            return Sizzle(selector, elem).length > 0;
          };
        }),
        "contains": markFunction(function(text) {
          text = text.replace(runescape, funescape);
          return function(elem) {
            return (elem.textContent || elem.innerText || getText(elem)).indexOf(text) > -1;
          };
        }),
        "lang": markFunction(function(lang) {
          if (!ridentifier.test(lang || "")) {
            Sizzle.error("unsupported lang: " + lang);
          }
          lang = lang.replace(runescape, funescape).toLowerCase();
          return function(elem) {
            var elemLang;
            do {
              if ((elemLang = documentIsHTML ? elem.lang : elem.getAttribute("xml:lang") || elem.getAttribute("lang"))) {
                elemLang = elemLang.toLowerCase();
                return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
              }
            } while ((elem = elem.parentNode) && elem.nodeType === 1);
            return false;
          };
        }),
        "target": function(elem) {
          var hash = window.location && window.location.hash;
          return hash && hash.slice(1) === elem.id;
        },
        "root": function(elem) {
          return elem === docElem;
        },
        "focus": function(elem) {
          return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
        },
        "enabled": createDisabledPseudo(false),
        "disabled": createDisabledPseudo(true),
        "checked": function(elem) {
          var nodeName = elem.nodeName.toLowerCase();
          return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
        },
        "selected": function(elem) {
          if (elem.parentNode) {
            elem.parentNode.selectedIndex;
          }
          return elem.selected === true;
        },
        "empty": function(elem) {
          for (elem = elem.firstChild; elem; elem = elem.nextSibling) {
            if (elem.nodeType < 6) {
              return false;
            }
          }
          return true;
        },
        "parent": function(elem) {
          return !Expr.pseudos["empty"](elem);
        },
        "header": function(elem) {
          return rheader.test(elem.nodeName);
        },
        "input": function(elem) {
          return rinputs.test(elem.nodeName);
        },
        "button": function(elem) {
          var name = elem.nodeName.toLowerCase();
          return name === "input" && elem.type === "button" || name === "button";
        },
        "text": function(elem) {
          var attr;
          return elem.nodeName.toLowerCase() === "input" && elem.type === "text" && ((attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text");
        },
        "first": createPositionalPseudo(function() {
          return [0];
        }),
        "last": createPositionalPseudo(function(matchIndexes, length) {
          return [length - 1];
        }),
        "eq": createPositionalPseudo(function(matchIndexes, length, argument) {
          return [argument < 0 ? argument + length : argument];
        }),
        "even": createPositionalPseudo(function(matchIndexes, length) {
          var i = 0;
          for (; i < length; i += 2) {
            matchIndexes.push(i);
          }
          return matchIndexes;
        }),
        "odd": createPositionalPseudo(function(matchIndexes, length) {
          var i = 1;
          for (; i < length; i += 2) {
            matchIndexes.push(i);
          }
          return matchIndexes;
        }),
        "lt": createPositionalPseudo(function(matchIndexes, length, argument) {
          var i = argument < 0 ? argument + length : argument;
          for (; --i >= 0; ) {
            matchIndexes.push(i);
          }
          return matchIndexes;
        }),
        "gt": createPositionalPseudo(function(matchIndexes, length, argument) {
          var i = argument < 0 ? argument + length : argument;
          for (; ++i < length; ) {
            matchIndexes.push(i);
          }
          return matchIndexes;
        })
      }
    };
    Expr.pseudos["nth"] = Expr.pseudos["eq"];
    for (i in {
      radio: true,
      checkbox: true,
      file: true,
      password: true,
      image: true
    }) {
      Expr.pseudos[i] = createInputPseudo(i);
    }
    for (i in {
      submit: true,
      reset: true
    }) {
      Expr.pseudos[i] = createButtonPseudo(i);
    }
    function setFilters() {}
    setFilters.prototype = Expr.filters = Expr.pseudos;
    Expr.setFilters = new setFilters();
    tokenize = Sizzle.tokenize = function(selector, parseOnly) {
      var matched,
          match,
          tokens,
          type,
          soFar,
          groups,
          preFilters,
          cached = tokenCache[selector + " "];
      if (cached) {
        return parseOnly ? 0 : cached.slice(0);
      }
      soFar = selector;
      groups = [];
      preFilters = Expr.preFilter;
      while (soFar) {
        if (!matched || (match = rcomma.exec(soFar))) {
          if (match) {
            soFar = soFar.slice(match[0].length) || soFar;
          }
          groups.push((tokens = []));
        }
        matched = false;
        if ((match = rcombinators.exec(soFar))) {
          matched = match.shift();
          tokens.push({
            value: matched,
            type: match[0].replace(rtrim, " ")
          });
          soFar = soFar.slice(matched.length);
        }
        for (type in Expr.filter) {
          if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
            matched = match.shift();
            tokens.push({
              value: matched,
              type: type,
              matches: match
            });
            soFar = soFar.slice(matched.length);
          }
        }
        if (!matched) {
          break;
        }
      }
      return parseOnly ? soFar.length : soFar ? Sizzle.error(selector) : tokenCache(selector, groups).slice(0);
    };
    function toSelector(tokens) {
      var i = 0,
          len = tokens.length,
          selector = "";
      for (; i < len; i++) {
        selector += tokens[i].value;
      }
      return selector;
    }
    function addCombinator(matcher, combinator, base) {
      var dir = combinator.dir,
          skip = combinator.next,
          key = skip || dir,
          checkNonElements = base && key === "parentNode",
          doneName = done++;
      return combinator.first ? function(elem, context, xml) {
        while ((elem = elem[dir])) {
          if (elem.nodeType === 1 || checkNonElements) {
            return matcher(elem, context, xml);
          }
        }
        return false;
      } : function(elem, context, xml) {
        var oldCache,
            uniqueCache,
            outerCache,
            newCache = [dirruns, doneName];
        if (xml) {
          while ((elem = elem[dir])) {
            if (elem.nodeType === 1 || checkNonElements) {
              if (matcher(elem, context, xml)) {
                return true;
              }
            }
          }
        } else {
          while ((elem = elem[dir])) {
            if (elem.nodeType === 1 || checkNonElements) {
              outerCache = elem[expando] || (elem[expando] = {});
              uniqueCache = outerCache[elem.uniqueID] || (outerCache[elem.uniqueID] = {});
              if (skip && skip === elem.nodeName.toLowerCase()) {
                elem = elem[dir] || elem;
              } else if ((oldCache = uniqueCache[key]) && oldCache[0] === dirruns && oldCache[1] === doneName) {
                return (newCache[2] = oldCache[2]);
              } else {
                uniqueCache[key] = newCache;
                if ((newCache[2] = matcher(elem, context, xml))) {
                  return true;
                }
              }
            }
          }
        }
        return false;
      };
    }
    function elementMatcher(matchers) {
      return matchers.length > 1 ? function(elem, context, xml) {
        var i = matchers.length;
        while (i--) {
          if (!matchers[i](elem, context, xml)) {
            return false;
          }
        }
        return true;
      } : matchers[0];
    }
    function multipleContexts(selector, contexts, results) {
      var i = 0,
          len = contexts.length;
      for (; i < len; i++) {
        Sizzle(selector, contexts[i], results);
      }
      return results;
    }
    function condense(unmatched, map, filter, context, xml) {
      var elem,
          newUnmatched = [],
          i = 0,
          len = unmatched.length,
          mapped = map != null;
      for (; i < len; i++) {
        if ((elem = unmatched[i])) {
          if (!filter || filter(elem, context, xml)) {
            newUnmatched.push(elem);
            if (mapped) {
              map.push(i);
            }
          }
        }
      }
      return newUnmatched;
    }
    function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
      if (postFilter && !postFilter[expando]) {
        postFilter = setMatcher(postFilter);
      }
      if (postFinder && !postFinder[expando]) {
        postFinder = setMatcher(postFinder, postSelector);
      }
      return markFunction(function(seed, results, context, xml) {
        var temp,
            i,
            elem,
            preMap = [],
            postMap = [],
            preexisting = results.length,
            elems = seed || multipleContexts(selector || "*", context.nodeType ? [context] : context, []),
            matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems,
            matcherOut = matcher ? postFinder || (seed ? preFilter : preexisting || postFilter) ? [] : results : matcherIn;
        if (matcher) {
          matcher(matcherIn, matcherOut, context, xml);
        }
        if (postFilter) {
          temp = condense(matcherOut, postMap);
          postFilter(temp, [], context, xml);
          i = temp.length;
          while (i--) {
            if ((elem = temp[i])) {
              matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
            }
          }
        }
        if (seed) {
          if (postFinder || preFilter) {
            if (postFinder) {
              temp = [];
              i = matcherOut.length;
              while (i--) {
                if ((elem = matcherOut[i])) {
                  temp.push((matcherIn[i] = elem));
                }
              }
              postFinder(null, (matcherOut = []), temp, xml);
            }
            i = matcherOut.length;
            while (i--) {
              if ((elem = matcherOut[i]) && (temp = postFinder ? indexOf(seed, elem) : preMap[i]) > -1) {
                seed[temp] = !(results[temp] = elem);
              }
            }
          }
        } else {
          matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut);
          if (postFinder) {
            postFinder(null, results, matcherOut, xml);
          } else {
            push.apply(results, matcherOut);
          }
        }
      });
    }
    function matcherFromTokens(tokens) {
      var checkContext,
          matcher,
          j,
          len = tokens.length,
          leadingRelative = Expr.relative[tokens[0].type],
          implicitRelative = leadingRelative || Expr.relative[" "],
          i = leadingRelative ? 1 : 0,
          matchContext = addCombinator(function(elem) {
            return elem === checkContext;
          }, implicitRelative, true),
          matchAnyContext = addCombinator(function(elem) {
            return indexOf(checkContext, elem) > -1;
          }, implicitRelative, true),
          matchers = [function(elem, context, xml) {
            var ret = (!leadingRelative && (xml || context !== outermostContext)) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));
            checkContext = null;
            return ret;
          }];
      for (; i < len; i++) {
        if ((matcher = Expr.relative[tokens[i].type])) {
          matchers = [addCombinator(elementMatcher(matchers), matcher)];
        } else {
          matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches);
          if (matcher[expando]) {
            j = ++i;
            for (; j < len; j++) {
              if (Expr.relative[tokens[j].type]) {
                break;
              }
            }
            return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector(tokens.slice(0, i - 1).concat({value: tokens[i - 2].type === " " ? "*" : ""})).replace(rtrim, "$1"), matcher, i < j && matcherFromTokens(tokens.slice(i, j)), j < len && matcherFromTokens((tokens = tokens.slice(j))), j < len && toSelector(tokens));
          }
          matchers.push(matcher);
        }
      }
      return elementMatcher(matchers);
    }
    function matcherFromGroupMatchers(elementMatchers, setMatchers) {
      var bySet = setMatchers.length > 0,
          byElement = elementMatchers.length > 0,
          superMatcher = function(seed, context, xml, results, outermost) {
            var elem,
                j,
                matcher,
                matchedCount = 0,
                i = "0",
                unmatched = seed && [],
                setMatched = [],
                contextBackup = outermostContext,
                elems = seed || byElement && Expr.find["TAG"]("*", outermost),
                dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
                len = elems.length;
            if (outermost) {
              outermostContext = context === document || context || outermost;
            }
            for (; i !== len && (elem = elems[i]) != null; i++) {
              if (byElement && elem) {
                j = 0;
                if (!context && elem.ownerDocument !== document) {
                  setDocument(elem);
                  xml = !documentIsHTML;
                }
                while ((matcher = elementMatchers[j++])) {
                  if (matcher(elem, context || document, xml)) {
                    results.push(elem);
                    break;
                  }
                }
                if (outermost) {
                  dirruns = dirrunsUnique;
                }
              }
              if (bySet) {
                if ((elem = !matcher && elem)) {
                  matchedCount--;
                }
                if (seed) {
                  unmatched.push(elem);
                }
              }
            }
            matchedCount += i;
            if (bySet && i !== matchedCount) {
              j = 0;
              while ((matcher = setMatchers[j++])) {
                matcher(unmatched, setMatched, context, xml);
              }
              if (seed) {
                if (matchedCount > 0) {
                  while (i--) {
                    if (!(unmatched[i] || setMatched[i])) {
                      setMatched[i] = pop.call(results);
                    }
                  }
                }
                setMatched = condense(setMatched);
              }
              push.apply(results, setMatched);
              if (outermost && !seed && setMatched.length > 0 && (matchedCount + setMatchers.length) > 1) {
                Sizzle.uniqueSort(results);
              }
            }
            if (outermost) {
              dirruns = dirrunsUnique;
              outermostContext = contextBackup;
            }
            return unmatched;
          };
      return bySet ? markFunction(superMatcher) : superMatcher;
    }
    compile = Sizzle.compile = function(selector, match) {
      var i,
          setMatchers = [],
          elementMatchers = [],
          cached = compilerCache[selector + " "];
      if (!cached) {
        if (!match) {
          match = tokenize(selector);
        }
        i = match.length;
        while (i--) {
          cached = matcherFromTokens(match[i]);
          if (cached[expando]) {
            setMatchers.push(cached);
          } else {
            elementMatchers.push(cached);
          }
        }
        cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));
        cached.selector = selector;
      }
      return cached;
    };
    select = Sizzle.select = function(selector, context, results, seed) {
      var i,
          tokens,
          token,
          type,
          find,
          compiled = typeof selector === "function" && selector,
          match = !seed && tokenize((selector = compiled.selector || selector));
      results = results || [];
      if (match.length === 1) {
        tokens = match[0] = match[0].slice(0);
        if (tokens.length > 2 && (token = tokens[0]).type === "ID" && context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {
          context = (Expr.find["ID"](token.matches[0].replace(runescape, funescape), context) || [])[0];
          if (!context) {
            return results;
          } else if (compiled) {
            context = context.parentNode;
          }
          selector = selector.slice(tokens.shift().value.length);
        }
        i = matchExpr["needsContext"].test(selector) ? 0 : tokens.length;
        while (i--) {
          token = tokens[i];
          if (Expr.relative[(type = token.type)]) {
            break;
          }
          if ((find = Expr.find[type])) {
            if ((seed = find(token.matches[0].replace(runescape, funescape), rsibling.test(tokens[0].type) && testContext(context.parentNode) || context))) {
              tokens.splice(i, 1);
              selector = seed.length && toSelector(tokens);
              if (!selector) {
                push.apply(results, seed);
                return results;
              }
              break;
            }
          }
        }
      }
      (compiled || compile(selector, match))(seed, context, !documentIsHTML, results, !context || rsibling.test(selector) && testContext(context.parentNode) || context);
      return results;
    };
    support.sortStable = expando.split("").sort(sortOrder).join("") === expando;
    support.detectDuplicates = !!hasDuplicate;
    setDocument();
    support.sortDetached = assert(function(el) {
      return el.compareDocumentPosition(document.createElement("fieldset")) & 1;
    });
    if (!assert(function(el) {
      el.innerHTML = "<a href='#'></a>";
      return el.firstChild.getAttribute("href") === "#";
    })) {
      addHandle("type|href|height|width", function(elem, name, isXML) {
        if (!isXML) {
          return elem.getAttribute(name, name.toLowerCase() === "type" ? 1 : 2);
        }
      });
    }
    if (!support.attributes || !assert(function(el) {
      el.innerHTML = "<input/>";
      el.firstChild.setAttribute("value", "");
      return el.firstChild.getAttribute("value") === "";
    })) {
      addHandle("value", function(elem, name, isXML) {
        if (!isXML && elem.nodeName.toLowerCase() === "input") {
          return elem.defaultValue;
        }
      });
    }
    if (!assert(function(el) {
      return el.getAttribute("disabled") == null;
    })) {
      addHandle(booleans, function(elem, name, isXML) {
        var val;
        if (!isXML) {
          return elem[name] === true ? name.toLowerCase() : (val = elem.getAttributeNode(name)) && val.specified ? val.value : null;
        }
      });
    }
    return Sizzle;
  })(window);
  jQuery.find = Sizzle;
  jQuery.expr = Sizzle.selectors;
  jQuery.expr[":"] = jQuery.expr.pseudos;
  jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
  jQuery.text = Sizzle.getText;
  jQuery.isXMLDoc = Sizzle.isXML;
  jQuery.contains = Sizzle.contains;
  jQuery.escapeSelector = Sizzle.escape;
  var dir = function(elem, dir, until) {
    var matched = [],
        truncate = until !== undefined;
    while ((elem = elem[dir]) && elem.nodeType !== 9) {
      if (elem.nodeType === 1) {
        if (truncate && jQuery(elem).is(until)) {
          break;
        }
        matched.push(elem);
      }
    }
    return matched;
  };
  var siblings = function(n, elem) {
    var matched = [];
    for (; n; n = n.nextSibling) {
      if (n.nodeType === 1 && n !== elem) {
        matched.push(n);
      }
    }
    return matched;
  };
  var rneedsContext = jQuery.expr.match.needsContext;
  function nodeName(elem, name) {
    return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
  }
  ;
  var rsingleTag = (/^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i);
  function winnow(elements, qualifier, not) {
    if (isFunction(qualifier)) {
      return jQuery.grep(elements, function(elem, i) {
        return !!qualifier.call(elem, i, elem) !== not;
      });
    }
    if (qualifier.nodeType) {
      return jQuery.grep(elements, function(elem) {
        return (elem === qualifier) !== not;
      });
    }
    if (typeof qualifier !== "string") {
      return jQuery.grep(elements, function(elem) {
        return (indexOf.call(qualifier, elem) > -1) !== not;
      });
    }
    return jQuery.filter(qualifier, elements, not);
  }
  jQuery.filter = function(expr, elems, not) {
    var elem = elems[0];
    if (not) {
      expr = ":not(" + expr + ")";
    }
    if (elems.length === 1 && elem.nodeType === 1) {
      return jQuery.find.matchesSelector(elem, expr) ? [elem] : [];
    }
    return jQuery.find.matches(expr, jQuery.grep(elems, function(elem) {
      return elem.nodeType === 1;
    }));
  };
  jQuery.fn.extend({
    find: function(selector) {
      var i,
          ret,
          len = this.length,
          self = this;
      if (typeof selector !== "string") {
        return this.pushStack(jQuery(selector).filter(function() {
          for (i = 0; i < len; i++) {
            if (jQuery.contains(self[i], this)) {
              return true;
            }
          }
        }));
      }
      ret = this.pushStack([]);
      for (i = 0; i < len; i++) {
        jQuery.find(selector, self[i], ret);
      }
      return len > 1 ? jQuery.uniqueSort(ret) : ret;
    },
    filter: function(selector) {
      return this.pushStack(winnow(this, selector || [], false));
    },
    not: function(selector) {
      return this.pushStack(winnow(this, selector || [], true));
    },
    is: function(selector) {
      return !!winnow(this, typeof selector === "string" && rneedsContext.test(selector) ? jQuery(selector) : selector || [], false).length;
    }
  });
  var rootjQuery,
      rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,
      init = jQuery.fn.init = function(selector, context, root) {
        var match,
            elem;
        if (!selector) {
          return this;
        }
        root = root || rootjQuery;
        if (typeof selector === "string") {
          if (selector[0] === "<" && selector[selector.length - 1] === ">" && selector.length >= 3) {
            match = [null, selector, null];
          } else {
            match = rquickExpr.exec(selector);
          }
          if (match && (match[1] || !context)) {
            if (match[1]) {
              context = context instanceof jQuery ? context[0] : context;
              jQuery.merge(this, jQuery.parseHTML(match[1], context && context.nodeType ? context.ownerDocument || context : document, true));
              if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
                for (match in context) {
                  if (isFunction(this[match])) {
                    this[match](context[match]);
                  } else {
                    this.attr(match, context[match]);
                  }
                }
              }
              return this;
            } else {
              elem = document.getElementById(match[2]);
              if (elem) {
                this[0] = elem;
                this.length = 1;
              }
              return this;
            }
          } else if (!context || context.jquery) {
            return (context || root).find(selector);
          } else {
            return this.constructor(context).find(selector);
          }
        } else if (selector.nodeType) {
          this[0] = selector;
          this.length = 1;
          return this;
        } else if (isFunction(selector)) {
          return root.ready !== undefined ? root.ready(selector) : selector(jQuery);
        }
        return jQuery.makeArray(selector, this);
      };
  init.prototype = jQuery.fn;
  rootjQuery = jQuery(document);
  var rparentsprev = /^(?:parents|prev(?:Until|All))/,
      guaranteedUnique = {
        children: true,
        contents: true,
        next: true,
        prev: true
      };
  jQuery.fn.extend({
    has: function(target) {
      var targets = jQuery(target, this),
          l = targets.length;
      return this.filter(function() {
        var i = 0;
        for (; i < l; i++) {
          if (jQuery.contains(this, targets[i])) {
            return true;
          }
        }
      });
    },
    closest: function(selectors, context) {
      var cur,
          i = 0,
          l = this.length,
          matched = [],
          targets = typeof selectors !== "string" && jQuery(selectors);
      if (!rneedsContext.test(selectors)) {
        for (; i < l; i++) {
          for (cur = this[i]; cur && cur !== context; cur = cur.parentNode) {
            if (cur.nodeType < 11 && (targets ? targets.index(cur) > -1 : cur.nodeType === 1 && jQuery.find.matchesSelector(cur, selectors))) {
              matched.push(cur);
              break;
            }
          }
        }
      }
      return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched);
    },
    index: function(elem) {
      if (!elem) {
        return (this[0] && this[0].parentNode) ? this.first().prevAll().length : -1;
      }
      if (typeof elem === "string") {
        return indexOf.call(jQuery(elem), this[0]);
      }
      return indexOf.call(this, elem.jquery ? elem[0] : elem);
    },
    add: function(selector, context) {
      return this.pushStack(jQuery.uniqueSort(jQuery.merge(this.get(), jQuery(selector, context))));
    },
    addBack: function(selector) {
      return this.add(selector == null ? this.prevObject : this.prevObject.filter(selector));
    }
  });
  function sibling(cur, dir) {
    while ((cur = cur[dir]) && cur.nodeType !== 1) {}
    return cur;
  }
  jQuery.each({
    parent: function(elem) {
      var parent = elem.parentNode;
      return parent && parent.nodeType !== 11 ? parent : null;
    },
    parents: function(elem) {
      return dir(elem, "parentNode");
    },
    parentsUntil: function(elem, i, until) {
      return dir(elem, "parentNode", until);
    },
    next: function(elem) {
      return sibling(elem, "nextSibling");
    },
    prev: function(elem) {
      return sibling(elem, "previousSibling");
    },
    nextAll: function(elem) {
      return dir(elem, "nextSibling");
    },
    prevAll: function(elem) {
      return dir(elem, "previousSibling");
    },
    nextUntil: function(elem, i, until) {
      return dir(elem, "nextSibling", until);
    },
    prevUntil: function(elem, i, until) {
      return dir(elem, "previousSibling", until);
    },
    siblings: function(elem) {
      return siblings((elem.parentNode || {}).firstChild, elem);
    },
    children: function(elem) {
      return siblings(elem.firstChild);
    },
    contents: function(elem) {
      if (nodeName(elem, "iframe")) {
        return elem.contentDocument;
      }
      if (nodeName(elem, "template")) {
        elem = elem.content || elem;
      }
      return jQuery.merge([], elem.childNodes);
    }
  }, function(name, fn) {
    jQuery.fn[name] = function(until, selector) {
      var matched = jQuery.map(this, fn, until);
      if (name.slice(-5) !== "Until") {
        selector = until;
      }
      if (selector && typeof selector === "string") {
        matched = jQuery.filter(selector, matched);
      }
      if (this.length > 1) {
        if (!guaranteedUnique[name]) {
          jQuery.uniqueSort(matched);
        }
        if (rparentsprev.test(name)) {
          matched.reverse();
        }
      }
      return this.pushStack(matched);
    };
  });
  var rnothtmlwhite = (/[^\x20\t\r\n\f]+/g);
  function createOptions(options) {
    var object = {};
    jQuery.each(options.match(rnothtmlwhite) || [], function(_, flag) {
      object[flag] = true;
    });
    return object;
  }
  jQuery.Callbacks = function(options) {
    options = typeof options === "string" ? createOptions(options) : jQuery.extend({}, options);
    var firing,
        memory,
        fired,
        locked,
        list = [],
        queue = [],
        firingIndex = -1,
        fire = function() {
          locked = locked || options.once;
          fired = firing = true;
          for (; queue.length; firingIndex = -1) {
            memory = queue.shift();
            while (++firingIndex < list.length) {
              if (list[firingIndex].apply(memory[0], memory[1]) === false && options.stopOnFalse) {
                firingIndex = list.length;
                memory = false;
              }
            }
          }
          if (!options.memory) {
            memory = false;
          }
          firing = false;
          if (locked) {
            if (memory) {
              list = [];
            } else {
              list = "";
            }
          }
        },
        self = {
          add: function() {
            if (list) {
              if (memory && !firing) {
                firingIndex = list.length - 1;
                queue.push(memory);
              }
              (function add(args) {
                jQuery.each(args, function(_, arg) {
                  if (isFunction(arg)) {
                    if (!options.unique || !self.has(arg)) {
                      list.push(arg);
                    }
                  } else if (arg && arg.length && toType(arg) !== "string") {
                    add(arg);
                  }
                });
              })(arguments);
              if (memory && !firing) {
                fire();
              }
            }
            return this;
          },
          remove: function() {
            jQuery.each(arguments, function(_, arg) {
              var index;
              while ((index = jQuery.inArray(arg, list, index)) > -1) {
                list.splice(index, 1);
                if (index <= firingIndex) {
                  firingIndex--;
                }
              }
            });
            return this;
          },
          has: function(fn) {
            return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0;
          },
          empty: function() {
            if (list) {
              list = [];
            }
            return this;
          },
          disable: function() {
            locked = queue = [];
            list = memory = "";
            return this;
          },
          disabled: function() {
            return !list;
          },
          lock: function() {
            locked = queue = [];
            if (!memory && !firing) {
              list = memory = "";
            }
            return this;
          },
          locked: function() {
            return !!locked;
          },
          fireWith: function(context, args) {
            if (!locked) {
              args = args || [];
              args = [context, args.slice ? args.slice() : args];
              queue.push(args);
              if (!firing) {
                fire();
              }
            }
            return this;
          },
          fire: function() {
            self.fireWith(this, arguments);
            return this;
          },
          fired: function() {
            return !!fired;
          }
        };
    return self;
  };
  function Identity(v) {
    return v;
  }
  function Thrower(ex) {
    throw ex;
  }
  function adoptValue(value, resolve, reject, noValue) {
    var method;
    try {
      if (value && isFunction((method = value.promise))) {
        method.call(value).done(resolve).fail(reject);
      } else if (value && isFunction((method = value.then))) {
        method.call(value, resolve, reject);
      } else {
        resolve.apply(undefined, [value].slice(noValue));
      }
    } catch (value) {
      reject.apply(undefined, [value]);
    }
  }
  jQuery.extend({
    Deferred: function(func) {
      var tuples = [["notify", "progress", jQuery.Callbacks("memory"), jQuery.Callbacks("memory"), 2], ["resolve", "done", jQuery.Callbacks("once memory"), jQuery.Callbacks("once memory"), 0, "resolved"], ["reject", "fail", jQuery.Callbacks("once memory"), jQuery.Callbacks("once memory"), 1, "rejected"]],
          state = "pending",
          promise = {
            state: function() {
              return state;
            },
            always: function() {
              deferred.done(arguments).fail(arguments);
              return this;
            },
            "catch": function(fn) {
              return promise.then(null, fn);
            },
            pipe: function() {
              var fns = arguments;
              return jQuery.Deferred(function(newDefer) {
                jQuery.each(tuples, function(i, tuple) {
                  var fn = isFunction(fns[tuple[4]]) && fns[tuple[4]];
                  deferred[tuple[1]](function() {
                    var returned = fn && fn.apply(this, arguments);
                    if (returned && isFunction(returned.promise)) {
                      returned.promise().progress(newDefer.notify).done(newDefer.resolve).fail(newDefer.reject);
                    } else {
                      newDefer[tuple[0] + "With"](this, fn ? [returned] : arguments);
                    }
                  });
                });
                fns = null;
              }).promise();
            },
            then: function(onFulfilled, onRejected, onProgress) {
              var maxDepth = 0;
              function resolve(depth, deferred, handler, special) {
                return function() {
                  var that = this,
                      args = arguments,
                      mightThrow = function() {
                        var returned,
                            then;
                        if (depth < maxDepth) {
                          return;
                        }
                        returned = handler.apply(that, args);
                        if (returned === deferred.promise()) {
                          throw new TypeError("Thenable self-resolution");
                        }
                        then = returned && (typeof returned === "object" || typeof returned === "function") && returned.then;
                        if (isFunction(then)) {
                          if (special) {
                            then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special));
                          } else {
                            maxDepth++;
                            then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special), resolve(maxDepth, deferred, Identity, deferred.notifyWith));
                          }
                        } else {
                          if (handler !== Identity) {
                            that = undefined;
                            args = [returned];
                          }
                          (special || deferred.resolveWith)(that, args);
                        }
                      },
                      process = special ? mightThrow : function() {
                        try {
                          mightThrow();
                        } catch (e) {
                          if (jQuery.Deferred.exceptionHook) {
                            jQuery.Deferred.exceptionHook(e, process.stackTrace);
                          }
                          if (depth + 1 >= maxDepth) {
                            if (handler !== Thrower) {
                              that = undefined;
                              args = [e];
                            }
                            deferred.rejectWith(that, args);
                          }
                        }
                      };
                  if (depth) {
                    process();
                  } else {
                    if (jQuery.Deferred.getStackHook) {
                      process.stackTrace = jQuery.Deferred.getStackHook();
                    }
                    window.setTimeout(process);
                  }
                };
              }
              return jQuery.Deferred(function(newDefer) {
                tuples[0][3].add(resolve(0, newDefer, isFunction(onProgress) ? onProgress : Identity, newDefer.notifyWith));
                tuples[1][3].add(resolve(0, newDefer, isFunction(onFulfilled) ? onFulfilled : Identity));
                tuples[2][3].add(resolve(0, newDefer, isFunction(onRejected) ? onRejected : Thrower));
              }).promise();
            },
            promise: function(obj) {
              return obj != null ? jQuery.extend(obj, promise) : promise;
            }
          },
          deferred = {};
      jQuery.each(tuples, function(i, tuple) {
        var list = tuple[2],
            stateString = tuple[5];
        promise[tuple[1]] = list.add;
        if (stateString) {
          list.add(function() {
            state = stateString;
          }, tuples[3 - i][2].disable, tuples[3 - i][3].disable, tuples[0][2].lock, tuples[0][3].lock);
        }
        list.add(tuple[3].fire);
        deferred[tuple[0]] = function() {
          deferred[tuple[0] + "With"](this === deferred ? undefined : this, arguments);
          return this;
        };
        deferred[tuple[0] + "With"] = list.fireWith;
      });
      promise.promise(deferred);
      if (func) {
        func.call(deferred, deferred);
      }
      return deferred;
    },
    when: function(singleValue) {
      var remaining = arguments.length,
          i = remaining,
          resolveContexts = Array(i),
          resolveValues = slice.call(arguments),
          master = jQuery.Deferred(),
          updateFunc = function(i) {
            return function(value) {
              resolveContexts[i] = this;
              resolveValues[i] = arguments.length > 1 ? slice.call(arguments) : value;
              if (!(--remaining)) {
                master.resolveWith(resolveContexts, resolveValues);
              }
            };
          };
      if (remaining <= 1) {
        adoptValue(singleValue, master.done(updateFunc(i)).resolve, master.reject, !remaining);
        if (master.state() === "pending" || isFunction(resolveValues[i] && resolveValues[i].then)) {
          return master.then();
        }
      }
      while (i--) {
        adoptValue(resolveValues[i], updateFunc(i), master.reject);
      }
      return master.promise();
    }
  });
  var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
  jQuery.Deferred.exceptionHook = function(error, stack) {
    if (window.console && window.console.warn && error && rerrorNames.test(error.name)) {
      window.console.warn("jQuery.Deferred exception: " + error.message, error.stack, stack);
    }
  };
  jQuery.readyException = function(error) {
    window.setTimeout(function() {
      throw error;
    });
  };
  var readyList = jQuery.Deferred();
  jQuery.fn.ready = function(fn) {
    readyList.then(fn).catch(function(error) {
      jQuery.readyException(error);
    });
    return this;
  };
  jQuery.extend({
    isReady: false,
    readyWait: 1,
    ready: function(wait) {
      if (wait === true ? --jQuery.readyWait : jQuery.isReady) {
        return;
      }
      jQuery.isReady = true;
      if (wait !== true && --jQuery.readyWait > 0) {
        return;
      }
      readyList.resolveWith(document, [jQuery]);
    }
  });
  jQuery.ready.then = readyList.then;
  function completed() {
    document.removeEventListener("DOMContentLoaded", completed);
    window.removeEventListener("load", completed);
    jQuery.ready();
  }
  if (document.readyState === "complete" || (document.readyState !== "loading" && !document.documentElement.doScroll)) {
    window.setTimeout(jQuery.ready);
  } else {
    document.addEventListener("DOMContentLoaded", completed);
    window.addEventListener("load", completed);
  }
  var access = function(elems, fn, key, value, chainable, emptyGet, raw) {
    var i = 0,
        len = elems.length,
        bulk = key == null;
    if (toType(key) === "object") {
      chainable = true;
      for (i in key) {
        access(elems, fn, i, key[i], true, emptyGet, raw);
      }
    } else if (value !== undefined) {
      chainable = true;
      if (!isFunction(value)) {
        raw = true;
      }
      if (bulk) {
        if (raw) {
          fn.call(elems, value);
          fn = null;
        } else {
          bulk = fn;
          fn = function(elem, key, value) {
            return bulk.call(jQuery(elem), value);
          };
        }
      }
      if (fn) {
        for (; i < len; i++) {
          fn(elems[i], key, raw ? value : value.call(elems[i], i, fn(elems[i], key)));
        }
      }
    }
    if (chainable) {
      return elems;
    }
    if (bulk) {
      return fn.call(elems);
    }
    return len ? fn(elems[0], key) : emptyGet;
  };
  var rmsPrefix = /^-ms-/,
      rdashAlpha = /-([a-z])/g;
  function fcamelCase(all, letter) {
    return letter.toUpperCase();
  }
  function camelCase(string) {
    return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase);
  }
  var acceptData = function(owner) {
    return owner.nodeType === 1 || owner.nodeType === 9 || !(+owner.nodeType);
  };
  function Data() {
    this.expando = jQuery.expando + Data.uid++;
  }
  Data.uid = 1;
  Data.prototype = {
    cache: function(owner) {
      var value = owner[this.expando];
      if (!value) {
        value = {};
        if (acceptData(owner)) {
          if (owner.nodeType) {
            owner[this.expando] = value;
          } else {
            Object.defineProperty(owner, this.expando, {
              value: value,
              configurable: true
            });
          }
        }
      }
      return value;
    },
    set: function(owner, data, value) {
      var prop,
          cache = this.cache(owner);
      if (typeof data === "string") {
        cache[camelCase(data)] = value;
      } else {
        for (prop in data) {
          cache[camelCase(prop)] = data[prop];
        }
      }
      return cache;
    },
    get: function(owner, key) {
      return key === undefined ? this.cache(owner) : owner[this.expando] && owner[this.expando][camelCase(key)];
    },
    access: function(owner, key, value) {
      if (key === undefined || ((key && typeof key === "string") && value === undefined)) {
        return this.get(owner, key);
      }
      this.set(owner, key, value);
      return value !== undefined ? value : key;
    },
    remove: function(owner, key) {
      var i,
          cache = owner[this.expando];
      if (cache === undefined) {
        return;
      }
      if (key !== undefined) {
        if (Array.isArray(key)) {
          key = key.map(camelCase);
        } else {
          key = camelCase(key);
          key = key in cache ? [key] : (key.match(rnothtmlwhite) || []);
        }
        i = key.length;
        while (i--) {
          delete cache[key[i]];
        }
      }
      if (key === undefined || jQuery.isEmptyObject(cache)) {
        if (owner.nodeType) {
          owner[this.expando] = undefined;
        } else {
          delete owner[this.expando];
        }
      }
    },
    hasData: function(owner) {
      var cache = owner[this.expando];
      return cache !== undefined && !jQuery.isEmptyObject(cache);
    }
  };
  var dataPriv = new Data();
  var dataUser = new Data();
  var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
      rmultiDash = /[A-Z]/g;
  function getData(data) {
    if (data === "true") {
      return true;
    }
    if (data === "false") {
      return false;
    }
    if (data === "null") {
      return null;
    }
    if (data === +data + "") {
      return +data;
    }
    if (rbrace.test(data)) {
      return JSON.parse(data);
    }
    return data;
  }
  function dataAttr(elem, key, data) {
    var name;
    if (data === undefined && elem.nodeType === 1) {
      name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
      data = elem.getAttribute(name);
      if (typeof data === "string") {
        try {
          data = getData(data);
        } catch (e) {}
        dataUser.set(elem, key, data);
      } else {
        data = undefined;
      }
    }
    return data;
  }
  jQuery.extend({
    hasData: function(elem) {
      return dataUser.hasData(elem) || dataPriv.hasData(elem);
    },
    data: function(elem, name, data) {
      return dataUser.access(elem, name, data);
    },
    removeData: function(elem, name) {
      dataUser.remove(elem, name);
    },
    _data: function(elem, name, data) {
      return dataPriv.access(elem, name, data);
    },
    _removeData: function(elem, name) {
      dataPriv.remove(elem, name);
    }
  });
  jQuery.fn.extend({
    data: function(key, value) {
      var i,
          name,
          data,
          elem = this[0],
          attrs = elem && elem.attributes;
      if (key === undefined) {
        if (this.length) {
          data = dataUser.get(elem);
          if (elem.nodeType === 1 && !dataPriv.get(elem, "hasDataAttrs")) {
            i = attrs.length;
            while (i--) {
              if (attrs[i]) {
                name = attrs[i].name;
                if (name.indexOf("data-") === 0) {
                  name = camelCase(name.slice(5));
                  dataAttr(elem, name, data[name]);
                }
              }
            }
            dataPriv.set(elem, "hasDataAttrs", true);
          }
        }
        return data;
      }
      if (typeof key === "object") {
        return this.each(function() {
          dataUser.set(this, key);
        });
      }
      return access(this, function(value) {
        var data;
        if (elem && value === undefined) {
          data = dataUser.get(elem, key);
          if (data !== undefined) {
            return data;
          }
          data = dataAttr(elem, key);
          if (data !== undefined) {
            return data;
          }
          return;
        }
        this.each(function() {
          dataUser.set(this, key, value);
        });
      }, null, value, arguments.length > 1, null, true);
    },
    removeData: function(key) {
      return this.each(function() {
        dataUser.remove(this, key);
      });
    }
  });
  jQuery.extend({
    queue: function(elem, type, data) {
      var queue;
      if (elem) {
        type = (type || "fx") + "queue";
        queue = dataPriv.get(elem, type);
        if (data) {
          if (!queue || Array.isArray(data)) {
            queue = dataPriv.access(elem, type, jQuery.makeArray(data));
          } else {
            queue.push(data);
          }
        }
        return queue || [];
      }
    },
    dequeue: function(elem, type) {
      type = type || "fx";
      var queue = jQuery.queue(elem, type),
          startLength = queue.length,
          fn = queue.shift(),
          hooks = jQuery._queueHooks(elem, type),
          next = function() {
            jQuery.dequeue(elem, type);
          };
      if (fn === "inprogress") {
        fn = queue.shift();
        startLength--;
      }
      if (fn) {
        if (type === "fx") {
          queue.unshift("inprogress");
        }
        delete hooks.stop;
        fn.call(elem, next, hooks);
      }
      if (!startLength && hooks) {
        hooks.empty.fire();
      }
    },
    _queueHooks: function(elem, type) {
      var key = type + "queueHooks";
      return dataPriv.get(elem, key) || dataPriv.access(elem, key, {empty: jQuery.Callbacks("once memory").add(function() {
          dataPriv.remove(elem, [type + "queue", key]);
        })});
    }
  });
  jQuery.fn.extend({
    queue: function(type, data) {
      var setter = 2;
      if (typeof type !== "string") {
        data = type;
        type = "fx";
        setter--;
      }
      if (arguments.length < setter) {
        return jQuery.queue(this[0], type);
      }
      return data === undefined ? this : this.each(function() {
        var queue = jQuery.queue(this, type, data);
        jQuery._queueHooks(this, type);
        if (type === "fx" && queue[0] !== "inprogress") {
          jQuery.dequeue(this, type);
        }
      });
    },
    dequeue: function(type) {
      return this.each(function() {
        jQuery.dequeue(this, type);
      });
    },
    clearQueue: function(type) {
      return this.queue(type || "fx", []);
    },
    promise: function(type, obj) {
      var tmp,
          count = 1,
          defer = jQuery.Deferred(),
          elements = this,
          i = this.length,
          resolve = function() {
            if (!(--count)) {
              defer.resolveWith(elements, [elements]);
            }
          };
      if (typeof type !== "string") {
        obj = type;
        type = undefined;
      }
      type = type || "fx";
      while (i--) {
        tmp = dataPriv.get(elements[i], type + "queueHooks");
        if (tmp && tmp.empty) {
          count++;
          tmp.empty.add(resolve);
        }
      }
      resolve();
      return defer.promise(obj);
    }
  });
  var pnum = (/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/).source;
  var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");
  var cssExpand = ["Top", "Right", "Bottom", "Left"];
  var isHiddenWithinTree = function(elem, el) {
    elem = el || elem;
    return elem.style.display === "none" || elem.style.display === "" && jQuery.contains(elem.ownerDocument, elem) && jQuery.css(elem, "display") === "none";
  };
  var swap = function(elem, options, callback, args) {
    var ret,
        name,
        old = {};
    for (name in options) {
      old[name] = elem.style[name];
      elem.style[name] = options[name];
    }
    ret = callback.apply(elem, args || []);
    for (name in options) {
      elem.style[name] = old[name];
    }
    return ret;
  };
  function adjustCSS(elem, prop, valueParts, tween) {
    var adjusted,
        scale,
        maxIterations = 20,
        currentValue = tween ? function() {
          return tween.cur();
        } : function() {
          return jQuery.css(elem, prop, "");
        },
        initial = currentValue(),
        unit = valueParts && valueParts[3] || (jQuery.cssNumber[prop] ? "" : "px"),
        initialInUnit = (jQuery.cssNumber[prop] || unit !== "px" && +initial) && rcssNum.exec(jQuery.css(elem, prop));
    if (initialInUnit && initialInUnit[3] !== unit) {
      initial = initial / 2;
      unit = unit || initialInUnit[3];
      initialInUnit = +initial || 1;
      while (maxIterations--) {
        jQuery.style(elem, prop, initialInUnit + unit);
        if ((1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <= 0) {
          maxIterations = 0;
        }
        initialInUnit = initialInUnit / scale;
      }
      initialInUnit = initialInUnit * 2;
      jQuery.style(elem, prop, initialInUnit + unit);
      valueParts = valueParts || [];
    }
    if (valueParts) {
      initialInUnit = +initialInUnit || +initial || 0;
      adjusted = valueParts[1] ? initialInUnit + (valueParts[1] + 1) * valueParts[2] : +valueParts[2];
      if (tween) {
        tween.unit = unit;
        tween.start = initialInUnit;
        tween.end = adjusted;
      }
    }
    return adjusted;
  }
  var defaultDisplayMap = {};
  function getDefaultDisplay(elem) {
    var temp,
        doc = elem.ownerDocument,
        nodeName = elem.nodeName,
        display = defaultDisplayMap[nodeName];
    if (display) {
      return display;
    }
    temp = doc.body.appendChild(doc.createElement(nodeName));
    display = jQuery.css(temp, "display");
    temp.parentNode.removeChild(temp);
    if (display === "none") {
      display = "block";
    }
    defaultDisplayMap[nodeName] = display;
    return display;
  }
  function showHide(elements, show) {
    var display,
        elem,
        values = [],
        index = 0,
        length = elements.length;
    for (; index < length; index++) {
      elem = elements[index];
      if (!elem.style) {
        continue;
      }
      display = elem.style.display;
      if (show) {
        if (display === "none") {
          values[index] = dataPriv.get(elem, "display") || null;
          if (!values[index]) {
            elem.style.display = "";
          }
        }
        if (elem.style.display === "" && isHiddenWithinTree(elem)) {
          values[index] = getDefaultDisplay(elem);
        }
      } else {
        if (display !== "none") {
          values[index] = "none";
          dataPriv.set(elem, "display", display);
        }
      }
    }
    for (index = 0; index < length; index++) {
      if (values[index] != null) {
        elements[index].style.display = values[index];
      }
    }
    return elements;
  }
  jQuery.fn.extend({
    show: function() {
      return showHide(this, true);
    },
    hide: function() {
      return showHide(this);
    },
    toggle: function(state) {
      if (typeof state === "boolean") {
        return state ? this.show() : this.hide();
      }
      return this.each(function() {
        if (isHiddenWithinTree(this)) {
          jQuery(this).show();
        } else {
          jQuery(this).hide();
        }
      });
    }
  });
  var rcheckableType = (/^(?:checkbox|radio)$/i);
  var rtagName = (/<([a-z][^\/\0>\x20\t\r\n\f]+)/i);
  var rscriptType = (/^$|^module$|\/(?:java|ecma)script/i);
  var wrapMap = {
    option: [1, "<select multiple='multiple'>", "</select>"],
    thead: [1, "<table>", "</table>"],
    col: [2, "<table><colgroup>", "</colgroup></table>"],
    tr: [2, "<table><tbody>", "</tbody></table>"],
    td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
    _default: [0, "", ""]
  };
  wrapMap.optgroup = wrapMap.option;
  wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
  wrapMap.th = wrapMap.td;
  function getAll(context, tag) {
    var ret;
    if (typeof context.getElementsByTagName !== "undefined") {
      ret = context.getElementsByTagName(tag || "*");
    } else if (typeof context.querySelectorAll !== "undefined") {
      ret = context.querySelectorAll(tag || "*");
    } else {
      ret = [];
    }
    if (tag === undefined || tag && nodeName(context, tag)) {
      return jQuery.merge([context], ret);
    }
    return ret;
  }
  function setGlobalEval(elems, refElements) {
    var i = 0,
        l = elems.length;
    for (; i < l; i++) {
      dataPriv.set(elems[i], "globalEval", !refElements || dataPriv.get(refElements[i], "globalEval"));
    }
  }
  var rhtml = /<|&#?\w+;/;
  function buildFragment(elems, context, scripts, selection, ignored) {
    var elem,
        tmp,
        tag,
        wrap,
        contains,
        j,
        fragment = context.createDocumentFragment(),
        nodes = [],
        i = 0,
        l = elems.length;
    for (; i < l; i++) {
      elem = elems[i];
      if (elem || elem === 0) {
        if (toType(elem) === "object") {
          jQuery.merge(nodes, elem.nodeType ? [elem] : elem);
        } else if (!rhtml.test(elem)) {
          nodes.push(context.createTextNode(elem));
        } else {
          tmp = tmp || fragment.appendChild(context.createElement("div"));
          tag = (rtagName.exec(elem) || ["", ""])[1].toLowerCase();
          wrap = wrapMap[tag] || wrapMap._default;
          tmp.innerHTML = wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2];
          j = wrap[0];
          while (j--) {
            tmp = tmp.lastChild;
          }
          jQuery.merge(nodes, tmp.childNodes);
          tmp = fragment.firstChild;
          tmp.textContent = "";
        }
      }
    }
    fragment.textContent = "";
    i = 0;
    while ((elem = nodes[i++])) {
      if (selection && jQuery.inArray(elem, selection) > -1) {
        if (ignored) {
          ignored.push(elem);
        }
        continue;
      }
      contains = jQuery.contains(elem.ownerDocument, elem);
      tmp = getAll(fragment.appendChild(elem), "script");
      if (contains) {
        setGlobalEval(tmp);
      }
      if (scripts) {
        j = 0;
        while ((elem = tmp[j++])) {
          if (rscriptType.test(elem.type || "")) {
            scripts.push(elem);
          }
        }
      }
    }
    return fragment;
  }
  (function() {
    var fragment = document.createDocumentFragment(),
        div = fragment.appendChild(document.createElement("div")),
        input = document.createElement("input");
    input.setAttribute("type", "radio");
    input.setAttribute("checked", "checked");
    input.setAttribute("name", "t");
    div.appendChild(input);
    support.checkClone = div.cloneNode(true).cloneNode(true).lastChild.checked;
    div.innerHTML = "<textarea>x</textarea>";
    support.noCloneChecked = !!div.cloneNode(true).lastChild.defaultValue;
  })();
  var documentElement = document.documentElement;
  var rkeyEvent = /^key/,
      rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
      rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
  function returnTrue() {
    return true;
  }
  function returnFalse() {
    return false;
  }
  function safeActiveElement() {
    try {
      return document.activeElement;
    } catch (err) {}
  }
  function on(elem, types, selector, data, fn, one) {
    var origFn,
        type;
    if (typeof types === "object") {
      if (typeof selector !== "string") {
        data = data || selector;
        selector = undefined;
      }
      for (type in types) {
        on(elem, type, selector, data, types[type], one);
      }
      return elem;
    }
    if (data == null && fn == null) {
      fn = selector;
      data = selector = undefined;
    } else if (fn == null) {
      if (typeof selector === "string") {
        fn = data;
        data = undefined;
      } else {
        fn = data;
        data = selector;
        selector = undefined;
      }
    }
    if (fn === false) {
      fn = returnFalse;
    } else if (!fn) {
      return elem;
    }
    if (one === 1) {
      origFn = fn;
      fn = function(event) {
        jQuery().off(event);
        return origFn.apply(this, arguments);
      };
      fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
    }
    return elem.each(function() {
      jQuery.event.add(this, types, fn, data, selector);
    });
  }
  jQuery.event = {
    global: {},
    add: function(elem, types, handler, data, selector) {
      var handleObjIn,
          eventHandle,
          tmp,
          events,
          t,
          handleObj,
          special,
          handlers,
          type,
          namespaces,
          origType,
          elemData = dataPriv.get(elem);
      if (!elemData) {
        return;
      }
      if (handler.handler) {
        handleObjIn = handler;
        handler = handleObjIn.handler;
        selector = handleObjIn.selector;
      }
      if (selector) {
        jQuery.find.matchesSelector(documentElement, selector);
      }
      if (!handler.guid) {
        handler.guid = jQuery.guid++;
      }
      if (!(events = elemData.events)) {
        events = elemData.events = {};
      }
      if (!(eventHandle = elemData.handle)) {
        eventHandle = elemData.handle = function(e) {
          return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ? jQuery.event.dispatch.apply(elem, arguments) : undefined;
        };
      }
      types = (types || "").match(rnothtmlwhite) || [""];
      t = types.length;
      while (t--) {
        tmp = rtypenamespace.exec(types[t]) || [];
        type = origType = tmp[1];
        namespaces = (tmp[2] || "").split(".").sort();
        if (!type) {
          continue;
        }
        special = jQuery.event.special[type] || {};
        type = (selector ? special.delegateType : special.bindType) || type;
        special = jQuery.event.special[type] || {};
        handleObj = jQuery.extend({
          type: type,
          origType: origType,
          data: data,
          handler: handler,
          guid: handler.guid,
          selector: selector,
          needsContext: selector && jQuery.expr.match.needsContext.test(selector),
          namespace: namespaces.join(".")
        }, handleObjIn);
        if (!(handlers = events[type])) {
          handlers = events[type] = [];
          handlers.delegateCount = 0;
          if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === false) {
            if (elem.addEventListener) {
              elem.addEventListener(type, eventHandle);
            }
          }
        }
        if (special.add) {
          special.add.call(elem, handleObj);
          if (!handleObj.handler.guid) {
            handleObj.handler.guid = handler.guid;
          }
        }
        if (selector) {
          handlers.splice(handlers.delegateCount++, 0, handleObj);
        } else {
          handlers.push(handleObj);
        }
        jQuery.event.global[type] = true;
      }
    },
    remove: function(elem, types, handler, selector, mappedTypes) {
      var j,
          origCount,
          tmp,
          events,
          t,
          handleObj,
          special,
          handlers,
          type,
          namespaces,
          origType,
          elemData = dataPriv.hasData(elem) && dataPriv.get(elem);
      if (!elemData || !(events = elemData.events)) {
        return;
      }
      types = (types || "").match(rnothtmlwhite) || [""];
      t = types.length;
      while (t--) {
        tmp = rtypenamespace.exec(types[t]) || [];
        type = origType = tmp[1];
        namespaces = (tmp[2] || "").split(".").sort();
        if (!type) {
          for (type in events) {
            jQuery.event.remove(elem, type + types[t], handler, selector, true);
          }
          continue;
        }
        special = jQuery.event.special[type] || {};
        type = (selector ? special.delegateType : special.bindType) || type;
        handlers = events[type] || [];
        tmp = tmp[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");
        origCount = j = handlers.length;
        while (j--) {
          handleObj = handlers[j];
          if ((mappedTypes || origType === handleObj.origType) && (!handler || handler.guid === handleObj.guid) && (!tmp || tmp.test(handleObj.namespace)) && (!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
            handlers.splice(j, 1);
            if (handleObj.selector) {
              handlers.delegateCount--;
            }
            if (special.remove) {
              special.remove.call(elem, handleObj);
            }
          }
        }
        if (origCount && !handlers.length) {
          if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === false) {
            jQuery.removeEvent(elem, type, elemData.handle);
          }
          delete events[type];
        }
      }
      if (jQuery.isEmptyObject(events)) {
        dataPriv.remove(elem, "handle events");
      }
    },
    dispatch: function(nativeEvent) {
      var event = jQuery.event.fix(nativeEvent);
      var i,
          j,
          ret,
          matched,
          handleObj,
          handlerQueue,
          args = new Array(arguments.length),
          handlers = (dataPriv.get(this, "events") || {})[event.type] || [],
          special = jQuery.event.special[event.type] || {};
      args[0] = event;
      for (i = 1; i < arguments.length; i++) {
        args[i] = arguments[i];
      }
      event.delegateTarget = this;
      if (special.preDispatch && special.preDispatch.call(this, event) === false) {
        return;
      }
      handlerQueue = jQuery.event.handlers.call(this, event, handlers);
      i = 0;
      while ((matched = handlerQueue[i++]) && !event.isPropagationStopped()) {
        event.currentTarget = matched.elem;
        j = 0;
        while ((handleObj = matched.handlers[j++]) && !event.isImmediatePropagationStopped()) {
          if (!event.rnamespace || event.rnamespace.test(handleObj.namespace)) {
            event.handleObj = handleObj;
            event.data = handleObj.data;
            ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args);
            if (ret !== undefined) {
              if ((event.result = ret) === false) {
                event.preventDefault();
                event.stopPropagation();
              }
            }
          }
        }
      }
      if (special.postDispatch) {
        special.postDispatch.call(this, event);
      }
      return event.result;
    },
    handlers: function(event, handlers) {
      var i,
          handleObj,
          sel,
          matchedHandlers,
          matchedSelectors,
          handlerQueue = [],
          delegateCount = handlers.delegateCount,
          cur = event.target;
      if (delegateCount && cur.nodeType && !(event.type === "click" && event.button >= 1)) {
        for (; cur !== this; cur = cur.parentNode || this) {
          if (cur.nodeType === 1 && !(event.type === "click" && cur.disabled === true)) {
            matchedHandlers = [];
            matchedSelectors = {};
            for (i = 0; i < delegateCount; i++) {
              handleObj = handlers[i];
              sel = handleObj.selector + " ";
              if (matchedSelectors[sel] === undefined) {
                matchedSelectors[sel] = handleObj.needsContext ? jQuery(sel, this).index(cur) > -1 : jQuery.find(sel, this, null, [cur]).length;
              }
              if (matchedSelectors[sel]) {
                matchedHandlers.push(handleObj);
              }
            }
            if (matchedHandlers.length) {
              handlerQueue.push({
                elem: cur,
                handlers: matchedHandlers
              });
            }
          }
        }
      }
      cur = this;
      if (delegateCount < handlers.length) {
        handlerQueue.push({
          elem: cur,
          handlers: handlers.slice(delegateCount)
        });
      }
      return handlerQueue;
    },
    addProp: function(name, hook) {
      Object.defineProperty(jQuery.Event.prototype, name, {
        enumerable: true,
        configurable: true,
        get: isFunction(hook) ? function() {
          if (this.originalEvent) {
            return hook(this.originalEvent);
          }
        } : function() {
          if (this.originalEvent) {
            return this.originalEvent[name];
          }
        },
        set: function(value) {
          Object.defineProperty(this, name, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: value
          });
        }
      });
    },
    fix: function(originalEvent) {
      return originalEvent[jQuery.expando] ? originalEvent : new jQuery.Event(originalEvent);
    },
    special: {
      load: {noBubble: true},
      focus: {
        trigger: function() {
          if (this !== safeActiveElement() && this.focus) {
            this.focus();
            return false;
          }
        },
        delegateType: "focusin"
      },
      blur: {
        trigger: function() {
          if (this === safeActiveElement() && this.blur) {
            this.blur();
            return false;
          }
        },
        delegateType: "focusout"
      },
      click: {
        trigger: function() {
          if (this.type === "checkbox" && this.click && nodeName(this, "input")) {
            this.click();
            return false;
          }
        },
        _default: function(event) {
          return nodeName(event.target, "a");
        }
      },
      beforeunload: {postDispatch: function(event) {
          if (event.result !== undefined && event.originalEvent) {
            event.originalEvent.returnValue = event.result;
          }
        }}
    }
  };
  jQuery.removeEvent = function(elem, type, handle) {
    if (elem.removeEventListener) {
      elem.removeEventListener(type, handle);
    }
  };
  jQuery.Event = function(src, props) {
    if (!(this instanceof jQuery.Event)) {
      return new jQuery.Event(src, props);
    }
    if (src && src.type) {
      this.originalEvent = src;
      this.type = src.type;
      this.isDefaultPrevented = src.defaultPrevented || src.defaultPrevented === undefined && src.returnValue === false ? returnTrue : returnFalse;
      this.target = (src.target && src.target.nodeType === 3) ? src.target.parentNode : src.target;
      this.currentTarget = src.currentTarget;
      this.relatedTarget = src.relatedTarget;
    } else {
      this.type = src;
    }
    if (props) {
      jQuery.extend(this, props);
    }
    this.timeStamp = src && src.timeStamp || Date.now();
    this[jQuery.expando] = true;
  };
  jQuery.Event.prototype = {
    constructor: jQuery.Event,
    isDefaultPrevented: returnFalse,
    isPropagationStopped: returnFalse,
    isImmediatePropagationStopped: returnFalse,
    isSimulated: false,
    preventDefault: function() {
      var e = this.originalEvent;
      this.isDefaultPrevented = returnTrue;
      if (e && !this.isSimulated) {
        e.preventDefault();
      }
    },
    stopPropagation: function() {
      var e = this.originalEvent;
      this.isPropagationStopped = returnTrue;
      if (e && !this.isSimulated) {
        e.stopPropagation();
      }
    },
    stopImmediatePropagation: function() {
      var e = this.originalEvent;
      this.isImmediatePropagationStopped = returnTrue;
      if (e && !this.isSimulated) {
        e.stopImmediatePropagation();
      }
      this.stopPropagation();
    }
  };
  jQuery.each({
    altKey: true,
    bubbles: true,
    cancelable: true,
    changedTouches: true,
    ctrlKey: true,
    detail: true,
    eventPhase: true,
    metaKey: true,
    pageX: true,
    pageY: true,
    shiftKey: true,
    view: true,
    "char": true,
    charCode: true,
    key: true,
    keyCode: true,
    button: true,
    buttons: true,
    clientX: true,
    clientY: true,
    offsetX: true,
    offsetY: true,
    pointerId: true,
    pointerType: true,
    screenX: true,
    screenY: true,
    targetTouches: true,
    toElement: true,
    touches: true,
    which: function(event) {
      var button = event.button;
      if (event.which == null && rkeyEvent.test(event.type)) {
        return event.charCode != null ? event.charCode : event.keyCode;
      }
      if (!event.which && button !== undefined && rmouseEvent.test(event.type)) {
        if (button & 1) {
          return 1;
        }
        if (button & 2) {
          return 3;
        }
        if (button & 4) {
          return 2;
        }
        return 0;
      }
      return event.which;
    }
  }, jQuery.event.addProp);
  jQuery.each({
    mouseenter: "mouseover",
    mouseleave: "mouseout",
    pointerenter: "pointerover",
    pointerleave: "pointerout"
  }, function(orig, fix) {
    jQuery.event.special[orig] = {
      delegateType: fix,
      bindType: fix,
      handle: function(event) {
        var ret,
            target = this,
            related = event.relatedTarget,
            handleObj = event.handleObj;
        if (!related || (related !== target && !jQuery.contains(target, related))) {
          event.type = handleObj.origType;
          ret = handleObj.handler.apply(this, arguments);
          event.type = fix;
        }
        return ret;
      }
    };
  });
  jQuery.fn.extend({
    on: function(types, selector, data, fn) {
      return on(this, types, selector, data, fn);
    },
    one: function(types, selector, data, fn) {
      return on(this, types, selector, data, fn, 1);
    },
    off: function(types, selector, fn) {
      var handleObj,
          type;
      if (types && types.preventDefault && types.handleObj) {
        handleObj = types.handleObj;
        jQuery(types.delegateTarget).off(handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType, handleObj.selector, handleObj.handler);
        return this;
      }
      if (typeof types === "object") {
        for (type in types) {
          this.off(type, selector, types[type]);
        }
        return this;
      }
      if (selector === false || typeof selector === "function") {
        fn = selector;
        selector = undefined;
      }
      if (fn === false) {
        fn = returnFalse;
      }
      return this.each(function() {
        jQuery.event.remove(this, types, fn, selector);
      });
    }
  });
  var rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,
      rnoInnerhtml = /<script|<style|<link/i,
      rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
      rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
  function manipulationTarget(elem, content) {
    if (nodeName(elem, "table") && nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr")) {
      return jQuery(elem).children("tbody")[0] || elem;
    }
    return elem;
  }
  function disableScript(elem) {
    elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
    return elem;
  }
  function restoreScript(elem) {
    if ((elem.type || "").slice(0, 5) === "true/") {
      elem.type = elem.type.slice(5);
    } else {
      elem.removeAttribute("type");
    }
    return elem;
  }
  function cloneCopyEvent(src, dest) {
    var i,
        l,
        type,
        pdataOld,
        pdataCur,
        udataOld,
        udataCur,
        events;
    if (dest.nodeType !== 1) {
      return;
    }
    if (dataPriv.hasData(src)) {
      pdataOld = dataPriv.access(src);
      pdataCur = dataPriv.set(dest, pdataOld);
      events = pdataOld.events;
      if (events) {
        delete pdataCur.handle;
        pdataCur.events = {};
        for (type in events) {
          for (i = 0, l = events[type].length; i < l; i++) {
            jQuery.event.add(dest, type, events[type][i]);
          }
        }
      }
    }
    if (dataUser.hasData(src)) {
      udataOld = dataUser.access(src);
      udataCur = jQuery.extend({}, udataOld);
      dataUser.set(dest, udataCur);
    }
  }
  function fixInput(src, dest) {
    var nodeName = dest.nodeName.toLowerCase();
    if (nodeName === "input" && rcheckableType.test(src.type)) {
      dest.checked = src.checked;
    } else if (nodeName === "input" || nodeName === "textarea") {
      dest.defaultValue = src.defaultValue;
    }
  }
  function domManip(collection, args, callback, ignored) {
    args = concat.apply([], args);
    var fragment,
        first,
        scripts,
        hasScripts,
        node,
        doc,
        i = 0,
        l = collection.length,
        iNoClone = l - 1,
        value = args[0],
        valueIsFunction = isFunction(value);
    if (valueIsFunction || (l > 1 && typeof value === "string" && !support.checkClone && rchecked.test(value))) {
      return collection.each(function(index) {
        var self = collection.eq(index);
        if (valueIsFunction) {
          args[0] = value.call(this, index, self.html());
        }
        domManip(self, args, callback, ignored);
      });
    }
    if (l) {
      fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
      first = fragment.firstChild;
      if (fragment.childNodes.length === 1) {
        fragment = first;
      }
      if (first || ignored) {
        scripts = jQuery.map(getAll(fragment, "script"), disableScript);
        hasScripts = scripts.length;
        for (; i < l; i++) {
          node = fragment;
          if (i !== iNoClone) {
            node = jQuery.clone(node, true, true);
            if (hasScripts) {
              jQuery.merge(scripts, getAll(node, "script"));
            }
          }
          callback.call(collection[i], node, i);
        }
        if (hasScripts) {
          doc = scripts[scripts.length - 1].ownerDocument;
          jQuery.map(scripts, restoreScript);
          for (i = 0; i < hasScripts; i++) {
            node = scripts[i];
            if (rscriptType.test(node.type || "") && !dataPriv.access(node, "globalEval") && jQuery.contains(doc, node)) {
              if (node.src && (node.type || "").toLowerCase() !== "module") {
                if (jQuery._evalUrl) {
                  jQuery._evalUrl(node.src);
                }
              } else {
                DOMEval(node.textContent.replace(rcleanScript, ""), doc, node);
              }
            }
          }
        }
      }
    }
    return collection;
  }
  function remove(elem, selector, keepData) {
    var node,
        nodes = selector ? jQuery.filter(selector, elem) : elem,
        i = 0;
    for (; (node = nodes[i]) != null; i++) {
      if (!keepData && node.nodeType === 1) {
        jQuery.cleanData(getAll(node));
      }
      if (node.parentNode) {
        if (keepData && jQuery.contains(node.ownerDocument, node)) {
          setGlobalEval(getAll(node, "script"));
        }
        node.parentNode.removeChild(node);
      }
    }
    return elem;
  }
  jQuery.extend({
    htmlPrefilter: function(html) {
      return html.replace(rxhtmlTag, "<$1></$2>");
    },
    clone: function(elem, dataAndEvents, deepDataAndEvents) {
      var i,
          l,
          srcElements,
          destElements,
          clone = elem.cloneNode(true),
          inPage = jQuery.contains(elem.ownerDocument, elem);
      if (!support.noCloneChecked && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem)) {
        destElements = getAll(clone);
        srcElements = getAll(elem);
        for (i = 0, l = srcElements.length; i < l; i++) {
          fixInput(srcElements[i], destElements[i]);
        }
      }
      if (dataAndEvents) {
        if (deepDataAndEvents) {
          srcElements = srcElements || getAll(elem);
          destElements = destElements || getAll(clone);
          for (i = 0, l = srcElements.length; i < l; i++) {
            cloneCopyEvent(srcElements[i], destElements[i]);
          }
        } else {
          cloneCopyEvent(elem, clone);
        }
      }
      destElements = getAll(clone, "script");
      if (destElements.length > 0) {
        setGlobalEval(destElements, !inPage && getAll(elem, "script"));
      }
      return clone;
    },
    cleanData: function(elems) {
      var data,
          elem,
          type,
          special = jQuery.event.special,
          i = 0;
      for (; (elem = elems[i]) !== undefined; i++) {
        if (acceptData(elem)) {
          if ((data = elem[dataPriv.expando])) {
            if (data.events) {
              for (type in data.events) {
                if (special[type]) {
                  jQuery.event.remove(elem, type);
                } else {
                  jQuery.removeEvent(elem, type, data.handle);
                }
              }
            }
            elem[dataPriv.expando] = undefined;
          }
          if (elem[dataUser.expando]) {
            elem[dataUser.expando] = undefined;
          }
        }
      }
    }
  });
  jQuery.fn.extend({
    detach: function(selector) {
      return remove(this, selector, true);
    },
    remove: function(selector) {
      return remove(this, selector);
    },
    text: function(value) {
      return access(this, function(value) {
        return value === undefined ? jQuery.text(this) : this.empty().each(function() {
          if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
            this.textContent = value;
          }
        });
      }, null, value, arguments.length);
    },
    append: function() {
      return domManip(this, arguments, function(elem) {
        if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
          var target = manipulationTarget(this, elem);
          target.appendChild(elem);
        }
      });
    },
    prepend: function() {
      return domManip(this, arguments, function(elem) {
        if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
          var target = manipulationTarget(this, elem);
          target.insertBefore(elem, target.firstChild);
        }
      });
    },
    before: function() {
      return domManip(this, arguments, function(elem) {
        if (this.parentNode) {
          this.parentNode.insertBefore(elem, this);
        }
      });
    },
    after: function() {
      return domManip(this, arguments, function(elem) {
        if (this.parentNode) {
          this.parentNode.insertBefore(elem, this.nextSibling);
        }
      });
    },
    empty: function() {
      var elem,
          i = 0;
      for (; (elem = this[i]) != null; i++) {
        if (elem.nodeType === 1) {
          jQuery.cleanData(getAll(elem, false));
          elem.textContent = "";
        }
      }
      return this;
    },
    clone: function(dataAndEvents, deepDataAndEvents) {
      dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
      deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
      return this.map(function() {
        return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
      });
    },
    html: function(value) {
      return access(this, function(value) {
        var elem = this[0] || {},
            i = 0,
            l = this.length;
        if (value === undefined && elem.nodeType === 1) {
          return elem.innerHTML;
        }
        if (typeof value === "string" && !rnoInnerhtml.test(value) && !wrapMap[(rtagName.exec(value) || ["", ""])[1].toLowerCase()]) {
          value = jQuery.htmlPrefilter(value);
          try {
            for (; i < l; i++) {
              elem = this[i] || {};
              if (elem.nodeType === 1) {
                jQuery.cleanData(getAll(elem, false));
                elem.innerHTML = value;
              }
            }
            elem = 0;
          } catch (e) {}
        }
        if (elem) {
          this.empty().append(value);
        }
      }, null, value, arguments.length);
    },
    replaceWith: function() {
      var ignored = [];
      return domManip(this, arguments, function(elem) {
        var parent = this.parentNode;
        if (jQuery.inArray(this, ignored) < 0) {
          jQuery.cleanData(getAll(this));
          if (parent) {
            parent.replaceChild(elem, this);
          }
        }
      }, ignored);
    }
  });
  jQuery.each({
    appendTo: "append",
    prependTo: "prepend",
    insertBefore: "before",
    insertAfter: "after",
    replaceAll: "replaceWith"
  }, function(name, original) {
    jQuery.fn[name] = function(selector) {
      var elems,
          ret = [],
          insert = jQuery(selector),
          last = insert.length - 1,
          i = 0;
      for (; i <= last; i++) {
        elems = i === last ? this : this.clone(true);
        jQuery(insert[i])[original](elems);
        push.apply(ret, elems.get());
      }
      return this.pushStack(ret);
    };
  });
  var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");
  var getStyles = function(elem) {
    var view = elem.ownerDocument.defaultView;
    if (!view || !view.opener) {
      view = window;
    }
    return view.getComputedStyle(elem);
  };
  var rboxStyle = new RegExp(cssExpand.join("|"), "i");
  (function() {
    function computeStyleTests() {
      if (!div) {
        return;
      }
      container.style.cssText = "position:absolute;left:-11111px;width:60px;" + "margin-top:1px;padding:0;border:0";
      div.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;" + "margin:auto;border:1px;padding:1px;" + "width:60%;top:1%";
      documentElement.appendChild(container).appendChild(div);
      var divStyle = window.getComputedStyle(div);
      pixelPositionVal = divStyle.top !== "1%";
      reliableMarginLeftVal = roundPixelMeasures(divStyle.marginLeft) === 12;
      div.style.right = "60%";
      pixelBoxStylesVal = roundPixelMeasures(divStyle.right) === 36;
      boxSizingReliableVal = roundPixelMeasures(divStyle.width) === 36;
      div.style.position = "absolute";
      scrollboxSizeVal = div.offsetWidth === 36 || "absolute";
      documentElement.removeChild(container);
      div = null;
    }
    function roundPixelMeasures(measure) {
      return Math.round(parseFloat(measure));
    }
    var pixelPositionVal,
        boxSizingReliableVal,
        scrollboxSizeVal,
        pixelBoxStylesVal,
        reliableMarginLeftVal,
        container = document.createElement("div"),
        div = document.createElement("div");
    if (!div.style) {
      return;
    }
    div.style.backgroundClip = "content-box";
    div.cloneNode(true).style.backgroundClip = "";
    support.clearCloneStyle = div.style.backgroundClip === "content-box";
    jQuery.extend(support, {
      boxSizingReliable: function() {
        computeStyleTests();
        return boxSizingReliableVal;
      },
      pixelBoxStyles: function() {
        computeStyleTests();
        return pixelBoxStylesVal;
      },
      pixelPosition: function() {
        computeStyleTests();
        return pixelPositionVal;
      },
      reliableMarginLeft: function() {
        computeStyleTests();
        return reliableMarginLeftVal;
      },
      scrollboxSize: function() {
        computeStyleTests();
        return scrollboxSizeVal;
      }
    });
  })();
  function curCSS(elem, name, computed) {
    var width,
        minWidth,
        maxWidth,
        ret,
        style = elem.style;
    computed = computed || getStyles(elem);
    if (computed) {
      ret = computed.getPropertyValue(name) || computed[name];
      if (ret === "" && !jQuery.contains(elem.ownerDocument, elem)) {
        ret = jQuery.style(elem, name);
      }
      if (!support.pixelBoxStyles() && rnumnonpx.test(ret) && rboxStyle.test(name)) {
        width = style.width;
        minWidth = style.minWidth;
        maxWidth = style.maxWidth;
        style.minWidth = style.maxWidth = style.width = ret;
        ret = computed.width;
        style.width = width;
        style.minWidth = minWidth;
        style.maxWidth = maxWidth;
      }
    }
    return ret !== undefined ? ret + "" : ret;
  }
  function addGetHookIf(conditionFn, hookFn) {
    return {get: function() {
        if (conditionFn()) {
          delete this.get;
          return;
        }
        return (this.get = hookFn).apply(this, arguments);
      }};
  }
  var rdisplayswap = /^(none|table(?!-c[ea]).+)/,
      rcustomProp = /^--/,
      cssShow = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
      },
      cssNormalTransform = {
        letterSpacing: "0",
        fontWeight: "400"
      },
      cssPrefixes = ["Webkit", "Moz", "ms"],
      emptyStyle = document.createElement("div").style;
  function vendorPropName(name) {
    if (name in emptyStyle) {
      return name;
    }
    var capName = name[0].toUpperCase() + name.slice(1),
        i = cssPrefixes.length;
    while (i--) {
      name = cssPrefixes[i] + capName;
      if (name in emptyStyle) {
        return name;
      }
    }
  }
  function finalPropName(name) {
    var ret = jQuery.cssProps[name];
    if (!ret) {
      ret = jQuery.cssProps[name] = vendorPropName(name) || name;
    }
    return ret;
  }
  function setPositiveNumber(elem, value, subtract) {
    var matches = rcssNum.exec(value);
    return matches ? Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px") : value;
  }
  function boxModelAdjustment(elem, dimension, box, isBorderBox, styles, computedVal) {
    var i = dimension === "width" ? 1 : 0,
        extra = 0,
        delta = 0;
    if (box === (isBorderBox ? "border" : "content")) {
      return 0;
    }
    for (; i < 4; i += 2) {
      if (box === "margin") {
        delta += jQuery.css(elem, box + cssExpand[i], true, styles);
      }
      if (!isBorderBox) {
        delta += jQuery.css(elem, "padding" + cssExpand[i], true, styles);
        if (box !== "padding") {
          delta += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
        } else {
          extra += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
        }
      } else {
        if (box === "content") {
          delta -= jQuery.css(elem, "padding" + cssExpand[i], true, styles);
        }
        if (box !== "margin") {
          delta -= jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
        }
      }
    }
    if (!isBorderBox && computedVal >= 0) {
      delta += Math.max(0, Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - computedVal - delta - extra - 0.5));
    }
    return delta;
  }
  function getWidthOrHeight(elem, dimension, extra) {
    var styles = getStyles(elem),
        val = curCSS(elem, dimension, styles),
        isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box",
        valueIsBorderBox = isBorderBox;
    if (rnumnonpx.test(val)) {
      if (!extra) {
        return val;
      }
      val = "auto";
    }
    valueIsBorderBox = valueIsBorderBox && (support.boxSizingReliable() || val === elem.style[dimension]);
    if (val === "auto" || !parseFloat(val) && jQuery.css(elem, "display", false, styles) === "inline") {
      val = elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)];
      valueIsBorderBox = true;
    }
    val = parseFloat(val) || 0;
    return (val + boxModelAdjustment(elem, dimension, extra || (isBorderBox ? "border" : "content"), valueIsBorderBox, styles, val)) + "px";
  }
  jQuery.extend({
    cssHooks: {opacity: {get: function(elem, computed) {
          if (computed) {
            var ret = curCSS(elem, "opacity");
            return ret === "" ? "1" : ret;
          }
        }}},
    cssNumber: {
      "animationIterationCount": true,
      "columnCount": true,
      "fillOpacity": true,
      "flexGrow": true,
      "flexShrink": true,
      "fontWeight": true,
      "lineHeight": true,
      "opacity": true,
      "order": true,
      "orphans": true,
      "widows": true,
      "zIndex": true,
      "zoom": true
    },
    cssProps: {},
    style: function(elem, name, value, extra) {
      if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) {
        return;
      }
      var ret,
          type,
          hooks,
          origName = camelCase(name),
          isCustomProp = rcustomProp.test(name),
          style = elem.style;
      if (!isCustomProp) {
        name = finalPropName(origName);
      }
      hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
      if (value !== undefined) {
        type = typeof value;
        if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
          value = adjustCSS(elem, name, ret);
          type = "number";
        }
        if (value == null || value !== value) {
          return;
        }
        if (type === "number") {
          value += ret && ret[3] || (jQuery.cssNumber[origName] ? "" : "px");
        }
        if (!support.clearCloneStyle && value === "" && name.indexOf("background") === 0) {
          style[name] = "inherit";
        }
        if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value, extra)) !== undefined) {
          if (isCustomProp) {
            style.setProperty(name, value);
          } else {
            style[name] = value;
          }
        }
      } else {
        if (hooks && "get" in hooks && (ret = hooks.get(elem, false, extra)) !== undefined) {
          return ret;
        }
        return style[name];
      }
    },
    css: function(elem, name, extra, styles) {
      var val,
          num,
          hooks,
          origName = camelCase(name),
          isCustomProp = rcustomProp.test(name);
      if (!isCustomProp) {
        name = finalPropName(origName);
      }
      hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
      if (hooks && "get" in hooks) {
        val = hooks.get(elem, true, extra);
      }
      if (val === undefined) {
        val = curCSS(elem, name, styles);
      }
      if (val === "normal" && name in cssNormalTransform) {
        val = cssNormalTransform[name];
      }
      if (extra === "" || extra) {
        num = parseFloat(val);
        return extra === true || isFinite(num) ? num || 0 : val;
      }
      return val;
    }
  });
  jQuery.each(["height", "width"], function(i, dimension) {
    jQuery.cssHooks[dimension] = {
      get: function(elem, computed, extra) {
        if (computed) {
          return rdisplayswap.test(jQuery.css(elem, "display")) && (!elem.getClientRects().length || !elem.getBoundingClientRect().width) ? swap(elem, cssShow, function() {
            return getWidthOrHeight(elem, dimension, extra);
          }) : getWidthOrHeight(elem, dimension, extra);
        }
      },
      set: function(elem, value, extra) {
        var matches,
            styles = getStyles(elem),
            isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box",
            subtract = extra && boxModelAdjustment(elem, dimension, extra, isBorderBox, styles);
        if (isBorderBox && support.scrollboxSize() === styles.position) {
          subtract -= Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - parseFloat(styles[dimension]) - boxModelAdjustment(elem, dimension, "border", false, styles) - 0.5);
        }
        if (subtract && (matches = rcssNum.exec(value)) && (matches[3] || "px") !== "px") {
          elem.style[dimension] = value;
          value = jQuery.css(elem, dimension);
        }
        return setPositiveNumber(elem, value, subtract);
      }
    };
  });
  jQuery.cssHooks.marginLeft = addGetHookIf(support.reliableMarginLeft, function(elem, computed) {
    if (computed) {
      return (parseFloat(curCSS(elem, "marginLeft")) || elem.getBoundingClientRect().left - swap(elem, {marginLeft: 0}, function() {
        return elem.getBoundingClientRect().left;
      })) + "px";
    }
  });
  jQuery.each({
    margin: "",
    padding: "",
    border: "Width"
  }, function(prefix, suffix) {
    jQuery.cssHooks[prefix + suffix] = {expand: function(value) {
        var i = 0,
            expanded = {},
            parts = typeof value === "string" ? value.split(" ") : [value];
        for (; i < 4; i++) {
          expanded[prefix + cssExpand[i] + suffix] = parts[i] || parts[i - 2] || parts[0];
        }
        return expanded;
      }};
    if (prefix !== "margin") {
      jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
    }
  });
  jQuery.fn.extend({css: function(name, value) {
      return access(this, function(elem, name, value) {
        var styles,
            len,
            map = {},
            i = 0;
        if (Array.isArray(name)) {
          styles = getStyles(elem);
          len = name.length;
          for (; i < len; i++) {
            map[name[i]] = jQuery.css(elem, name[i], false, styles);
          }
          return map;
        }
        return value !== undefined ? jQuery.style(elem, name, value) : jQuery.css(elem, name);
      }, name, value, arguments.length > 1);
    }});
  function Tween(elem, options, prop, end, easing) {
    return new Tween.prototype.init(elem, options, prop, end, easing);
  }
  jQuery.Tween = Tween;
  Tween.prototype = {
    constructor: Tween,
    init: function(elem, options, prop, end, easing, unit) {
      this.elem = elem;
      this.prop = prop;
      this.easing = easing || jQuery.easing._default;
      this.options = options;
      this.start = this.now = this.cur();
      this.end = end;
      this.unit = unit || (jQuery.cssNumber[prop] ? "" : "px");
    },
    cur: function() {
      var hooks = Tween.propHooks[this.prop];
      return hooks && hooks.get ? hooks.get(this) : Tween.propHooks._default.get(this);
    },
    run: function(percent) {
      var eased,
          hooks = Tween.propHooks[this.prop];
      if (this.options.duration) {
        this.pos = eased = jQuery.easing[this.easing](percent, this.options.duration * percent, 0, 1, this.options.duration);
      } else {
        this.pos = eased = percent;
      }
      this.now = (this.end - this.start) * eased + this.start;
      if (this.options.step) {
        this.options.step.call(this.elem, this.now, this);
      }
      if (hooks && hooks.set) {
        hooks.set(this);
      } else {
        Tween.propHooks._default.set(this);
      }
      return this;
    }
  };
  Tween.prototype.init.prototype = Tween.prototype;
  Tween.propHooks = {_default: {
      get: function(tween) {
        var result;
        if (tween.elem.nodeType !== 1 || tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null) {
          return tween.elem[tween.prop];
        }
        result = jQuery.css(tween.elem, tween.prop, "");
        return !result || result === "auto" ? 0 : result;
      },
      set: function(tween) {
        if (jQuery.fx.step[tween.prop]) {
          jQuery.fx.step[tween.prop](tween);
        } else if (tween.elem.nodeType === 1 && (tween.elem.style[jQuery.cssProps[tween.prop]] != null || jQuery.cssHooks[tween.prop])) {
          jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
        } else {
          tween.elem[tween.prop] = tween.now;
        }
      }
    }};
  Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {set: function(tween) {
      if (tween.elem.nodeType && tween.elem.parentNode) {
        tween.elem[tween.prop] = tween.now;
      }
    }};
  jQuery.easing = {
    linear: function(p) {
      return p;
    },
    swing: function(p) {
      return 0.5 - Math.cos(p * Math.PI) / 2;
    },
    _default: "swing"
  };
  jQuery.fx = Tween.prototype.init;
  jQuery.fx.step = {};
  var fxNow,
      inProgress,
      rfxtypes = /^(?:toggle|show|hide)$/,
      rrun = /queueHooks$/;
  function schedule() {
    if (inProgress) {
      if (document.hidden === false && window.requestAnimationFrame) {
        window.requestAnimationFrame(schedule);
      } else {
        window.setTimeout(schedule, jQuery.fx.interval);
      }
      jQuery.fx.tick();
    }
  }
  function createFxNow() {
    window.setTimeout(function() {
      fxNow = undefined;
    });
    return (fxNow = Date.now());
  }
  function genFx(type, includeWidth) {
    var which,
        i = 0,
        attrs = {height: type};
    includeWidth = includeWidth ? 1 : 0;
    for (; i < 4; i += 2 - includeWidth) {
      which = cssExpand[i];
      attrs["margin" + which] = attrs["padding" + which] = type;
    }
    if (includeWidth) {
      attrs.opacity = attrs.width = type;
    }
    return attrs;
  }
  function createTween(value, prop, animation) {
    var tween,
        collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners["*"]),
        index = 0,
        length = collection.length;
    for (; index < length; index++) {
      if ((tween = collection[index].call(animation, prop, value))) {
        return tween;
      }
    }
  }
  function defaultPrefilter(elem, props, opts) {
    var prop,
        value,
        toggle,
        hooks,
        oldfire,
        propTween,
        restoreDisplay,
        display,
        isBox = "width" in props || "height" in props,
        anim = this,
        orig = {},
        style = elem.style,
        hidden = elem.nodeType && isHiddenWithinTree(elem),
        dataShow = dataPriv.get(elem, "fxshow");
    if (!opts.queue) {
      hooks = jQuery._queueHooks(elem, "fx");
      if (hooks.unqueued == null) {
        hooks.unqueued = 0;
        oldfire = hooks.empty.fire;
        hooks.empty.fire = function() {
          if (!hooks.unqueued) {
            oldfire();
          }
        };
      }
      hooks.unqueued++;
      anim.always(function() {
        anim.always(function() {
          hooks.unqueued--;
          if (!jQuery.queue(elem, "fx").length) {
            hooks.empty.fire();
          }
        });
      });
    }
    for (prop in props) {
      value = props[prop];
      if (rfxtypes.test(value)) {
        delete props[prop];
        toggle = toggle || value === "toggle";
        if (value === (hidden ? "hide" : "show")) {
          if (value === "show" && dataShow && dataShow[prop] !== undefined) {
            hidden = true;
          } else {
            continue;
          }
        }
        orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop);
      }
    }
    propTween = !jQuery.isEmptyObject(props);
    if (!propTween && jQuery.isEmptyObject(orig)) {
      return;
    }
    if (isBox && elem.nodeType === 1) {
      opts.overflow = [style.overflow, style.overflowX, style.overflowY];
      restoreDisplay = dataShow && dataShow.display;
      if (restoreDisplay == null) {
        restoreDisplay = dataPriv.get(elem, "display");
      }
      display = jQuery.css(elem, "display");
      if (display === "none") {
        if (restoreDisplay) {
          display = restoreDisplay;
        } else {
          showHide([elem], true);
          restoreDisplay = elem.style.display || restoreDisplay;
          display = jQuery.css(elem, "display");
          showHide([elem]);
        }
      }
      if (display === "inline" || display === "inline-block" && restoreDisplay != null) {
        if (jQuery.css(elem, "float") === "none") {
          if (!propTween) {
            anim.done(function() {
              style.display = restoreDisplay;
            });
            if (restoreDisplay == null) {
              display = style.display;
              restoreDisplay = display === "none" ? "" : display;
            }
          }
          style.display = "inline-block";
        }
      }
    }
    if (opts.overflow) {
      style.overflow = "hidden";
      anim.always(function() {
        style.overflow = opts.overflow[0];
        style.overflowX = opts.overflow[1];
        style.overflowY = opts.overflow[2];
      });
    }
    propTween = false;
    for (prop in orig) {
      if (!propTween) {
        if (dataShow) {
          if ("hidden" in dataShow) {
            hidden = dataShow.hidden;
          }
        } else {
          dataShow = dataPriv.access(elem, "fxshow", {display: restoreDisplay});
        }
        if (toggle) {
          dataShow.hidden = !hidden;
        }
        if (hidden) {
          showHide([elem], true);
        }
        anim.done(function() {
          if (!hidden) {
            showHide([elem]);
          }
          dataPriv.remove(elem, "fxshow");
          for (prop in orig) {
            jQuery.style(elem, prop, orig[prop]);
          }
        });
      }
      propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
      if (!(prop in dataShow)) {
        dataShow[prop] = propTween.start;
        if (hidden) {
          propTween.end = propTween.start;
          propTween.start = 0;
        }
      }
    }
  }
  function propFilter(props, specialEasing) {
    var index,
        name,
        easing,
        value,
        hooks;
    for (index in props) {
      name = camelCase(index);
      easing = specialEasing[name];
      value = props[index];
      if (Array.isArray(value)) {
        easing = value[1];
        value = props[index] = value[0];
      }
      if (index !== name) {
        props[name] = value;
        delete props[index];
      }
      hooks = jQuery.cssHooks[name];
      if (hooks && "expand" in hooks) {
        value = hooks.expand(value);
        delete props[name];
        for (index in value) {
          if (!(index in props)) {
            props[index] = value[index];
            specialEasing[index] = easing;
          }
        }
      } else {
        specialEasing[name] = easing;
      }
    }
  }
  function Animation(elem, properties, options) {
    var result,
        stopped,
        index = 0,
        length = Animation.prefilters.length,
        deferred = jQuery.Deferred().always(function() {
          delete tick.elem;
        }),
        tick = function() {
          if (stopped) {
            return false;
          }
          var currentTime = fxNow || createFxNow(),
              remaining = Math.max(0, animation.startTime + animation.duration - currentTime),
              temp = remaining / animation.duration || 0,
              percent = 1 - temp,
              index = 0,
              length = animation.tweens.length;
          for (; index < length; index++) {
            animation.tweens[index].run(percent);
          }
          deferred.notifyWith(elem, [animation, percent, remaining]);
          if (percent < 1 && length) {
            return remaining;
          }
          if (!length) {
            deferred.notifyWith(elem, [animation, 1, 0]);
          }
          deferred.resolveWith(elem, [animation]);
          return false;
        },
        animation = deferred.promise({
          elem: elem,
          props: jQuery.extend({}, properties),
          opts: jQuery.extend(true, {
            specialEasing: {},
            easing: jQuery.easing._default
          }, options),
          originalProperties: properties,
          originalOptions: options,
          startTime: fxNow || createFxNow(),
          duration: options.duration,
          tweens: [],
          createTween: function(prop, end) {
            var tween = jQuery.Tween(elem, animation.opts, prop, end, animation.opts.specialEasing[prop] || animation.opts.easing);
            animation.tweens.push(tween);
            return tween;
          },
          stop: function(gotoEnd) {
            var index = 0,
                length = gotoEnd ? animation.tweens.length : 0;
            if (stopped) {
              return this;
            }
            stopped = true;
            for (; index < length; index++) {
              animation.tweens[index].run(1);
            }
            if (gotoEnd) {
              deferred.notifyWith(elem, [animation, 1, 0]);
              deferred.resolveWith(elem, [animation, gotoEnd]);
            } else {
              deferred.rejectWith(elem, [animation, gotoEnd]);
            }
            return this;
          }
        }),
        props = animation.props;
    propFilter(props, animation.opts.specialEasing);
    for (; index < length; index++) {
      result = Animation.prefilters[index].call(animation, elem, props, animation.opts);
      if (result) {
        if (isFunction(result.stop)) {
          jQuery._queueHooks(animation.elem, animation.opts.queue).stop = result.stop.bind(result);
        }
        return result;
      }
    }
    jQuery.map(props, createTween, animation);
    if (isFunction(animation.opts.start)) {
      animation.opts.start.call(elem, animation);
    }
    animation.progress(animation.opts.progress).done(animation.opts.done, animation.opts.complete).fail(animation.opts.fail).always(animation.opts.always);
    jQuery.fx.timer(jQuery.extend(tick, {
      elem: elem,
      anim: animation,
      queue: animation.opts.queue
    }));
    return animation;
  }
  jQuery.Animation = jQuery.extend(Animation, {
    tweeners: {"*": [function(prop, value) {
        var tween = this.createTween(prop, value);
        adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
        return tween;
      }]},
    tweener: function(props, callback) {
      if (isFunction(props)) {
        callback = props;
        props = ["*"];
      } else {
        props = props.match(rnothtmlwhite);
      }
      var prop,
          index = 0,
          length = props.length;
      for (; index < length; index++) {
        prop = props[index];
        Animation.tweeners[prop] = Animation.tweeners[prop] || [];
        Animation.tweeners[prop].unshift(callback);
      }
    },
    prefilters: [defaultPrefilter],
    prefilter: function(callback, prepend) {
      if (prepend) {
        Animation.prefilters.unshift(callback);
      } else {
        Animation.prefilters.push(callback);
      }
    }
  });
  jQuery.speed = function(speed, easing, fn) {
    var opt = speed && typeof speed === "object" ? jQuery.extend({}, speed) : {
      complete: fn || !fn && easing || isFunction(speed) && speed,
      duration: speed,
      easing: fn && easing || easing && !isFunction(easing) && easing
    };
    if (jQuery.fx.off) {
      opt.duration = 0;
    } else {
      if (typeof opt.duration !== "number") {
        if (opt.duration in jQuery.fx.speeds) {
          opt.duration = jQuery.fx.speeds[opt.duration];
        } else {
          opt.duration = jQuery.fx.speeds._default;
        }
      }
    }
    if (opt.queue == null || opt.queue === true) {
      opt.queue = "fx";
    }
    opt.old = opt.complete;
    opt.complete = function() {
      if (isFunction(opt.old)) {
        opt.old.call(this);
      }
      if (opt.queue) {
        jQuery.dequeue(this, opt.queue);
      }
    };
    return opt;
  };
  jQuery.fn.extend({
    fadeTo: function(speed, to, easing, callback) {
      return this.filter(isHiddenWithinTree).css("opacity", 0).show().end().animate({opacity: to}, speed, easing, callback);
    },
    animate: function(prop, speed, easing, callback) {
      var empty = jQuery.isEmptyObject(prop),
          optall = jQuery.speed(speed, easing, callback),
          doAnimation = function() {
            var anim = Animation(this, jQuery.extend({}, prop), optall);
            if (empty || dataPriv.get(this, "finish")) {
              anim.stop(true);
            }
          };
      doAnimation.finish = doAnimation;
      return empty || optall.queue === false ? this.each(doAnimation) : this.queue(optall.queue, doAnimation);
    },
    stop: function(type, clearQueue, gotoEnd) {
      var stopQueue = function(hooks) {
        var stop = hooks.stop;
        delete hooks.stop;
        stop(gotoEnd);
      };
      if (typeof type !== "string") {
        gotoEnd = clearQueue;
        clearQueue = type;
        type = undefined;
      }
      if (clearQueue && type !== false) {
        this.queue(type || "fx", []);
      }
      return this.each(function() {
        var dequeue = true,
            index = type != null && type + "queueHooks",
            timers = jQuery.timers,
            data = dataPriv.get(this);
        if (index) {
          if (data[index] && data[index].stop) {
            stopQueue(data[index]);
          }
        } else {
          for (index in data) {
            if (data[index] && data[index].stop && rrun.test(index)) {
              stopQueue(data[index]);
            }
          }
        }
        for (index = timers.length; index--; ) {
          if (timers[index].elem === this && (type == null || timers[index].queue === type)) {
            timers[index].anim.stop(gotoEnd);
            dequeue = false;
            timers.splice(index, 1);
          }
        }
        if (dequeue || !gotoEnd) {
          jQuery.dequeue(this, type);
        }
      });
    },
    finish: function(type) {
      if (type !== false) {
        type = type || "fx";
      }
      return this.each(function() {
        var index,
            data = dataPriv.get(this),
            queue = data[type + "queue"],
            hooks = data[type + "queueHooks"],
            timers = jQuery.timers,
            length = queue ? queue.length : 0;
        data.finish = true;
        jQuery.queue(this, type, []);
        if (hooks && hooks.stop) {
          hooks.stop.call(this, true);
        }
        for (index = timers.length; index--; ) {
          if (timers[index].elem === this && timers[index].queue === type) {
            timers[index].anim.stop(true);
            timers.splice(index, 1);
          }
        }
        for (index = 0; index < length; index++) {
          if (queue[index] && queue[index].finish) {
            queue[index].finish.call(this);
          }
        }
        delete data.finish;
      });
    }
  });
  jQuery.each(["toggle", "show", "hide"], function(i, name) {
    var cssFn = jQuery.fn[name];
    jQuery.fn[name] = function(speed, easing, callback) {
      return speed == null || typeof speed === "boolean" ? cssFn.apply(this, arguments) : this.animate(genFx(name, true), speed, easing, callback);
    };
  });
  jQuery.each({
    slideDown: genFx("show"),
    slideUp: genFx("hide"),
    slideToggle: genFx("toggle"),
    fadeIn: {opacity: "show"},
    fadeOut: {opacity: "hide"},
    fadeToggle: {opacity: "toggle"}
  }, function(name, props) {
    jQuery.fn[name] = function(speed, easing, callback) {
      return this.animate(props, speed, easing, callback);
    };
  });
  jQuery.timers = [];
  jQuery.fx.tick = function() {
    var timer,
        i = 0,
        timers = jQuery.timers;
    fxNow = Date.now();
    for (; i < timers.length; i++) {
      timer = timers[i];
      if (!timer() && timers[i] === timer) {
        timers.splice(i--, 1);
      }
    }
    if (!timers.length) {
      jQuery.fx.stop();
    }
    fxNow = undefined;
  };
  jQuery.fx.timer = function(timer) {
    jQuery.timers.push(timer);
    jQuery.fx.start();
  };
  jQuery.fx.interval = 13;
  jQuery.fx.start = function() {
    if (inProgress) {
      return;
    }
    inProgress = true;
    schedule();
  };
  jQuery.fx.stop = function() {
    inProgress = null;
  };
  jQuery.fx.speeds = {
    slow: 600,
    fast: 200,
    _default: 400
  };
  jQuery.fn.delay = function(time, type) {
    time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
    type = type || "fx";
    return this.queue(type, function(next, hooks) {
      var timeout = window.setTimeout(next, time);
      hooks.stop = function() {
        window.clearTimeout(timeout);
      };
    });
  };
  (function() {
    var input = document.createElement("input"),
        select = document.createElement("select"),
        opt = select.appendChild(document.createElement("option"));
    input.type = "checkbox";
    support.checkOn = input.value !== "";
    support.optSelected = opt.selected;
    input = document.createElement("input");
    input.value = "t";
    input.type = "radio";
    support.radioValue = input.value === "t";
  })();
  var boolHook,
      attrHandle = jQuery.expr.attrHandle;
  jQuery.fn.extend({
    attr: function(name, value) {
      return access(this, jQuery.attr, name, value, arguments.length > 1);
    },
    removeAttr: function(name) {
      return this.each(function() {
        jQuery.removeAttr(this, name);
      });
    }
  });
  jQuery.extend({
    attr: function(elem, name, value) {
      var ret,
          hooks,
          nType = elem.nodeType;
      if (nType === 3 || nType === 8 || nType === 2) {
        return;
      }
      if (typeof elem.getAttribute === "undefined") {
        return jQuery.prop(elem, name, value);
      }
      if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
        hooks = jQuery.attrHooks[name.toLowerCase()] || (jQuery.expr.match.bool.test(name) ? boolHook : undefined);
      }
      if (value !== undefined) {
        if (value === null) {
          jQuery.removeAttr(elem, name);
          return;
        }
        if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) {
          return ret;
        }
        elem.setAttribute(name, value + "");
        return value;
      }
      if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) {
        return ret;
      }
      ret = jQuery.find.attr(elem, name);
      return ret == null ? undefined : ret;
    },
    attrHooks: {type: {set: function(elem, value) {
          if (!support.radioValue && value === "radio" && nodeName(elem, "input")) {
            var val = elem.value;
            elem.setAttribute("type", value);
            if (val) {
              elem.value = val;
            }
            return value;
          }
        }}},
    removeAttr: function(elem, value) {
      var name,
          i = 0,
          attrNames = value && value.match(rnothtmlwhite);
      if (attrNames && elem.nodeType === 1) {
        while ((name = attrNames[i++])) {
          elem.removeAttribute(name);
        }
      }
    }
  });
  boolHook = {set: function(elem, value, name) {
      if (value === false) {
        jQuery.removeAttr(elem, name);
      } else {
        elem.setAttribute(name, name);
      }
      return name;
    }};
  jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g), function(i, name) {
    var getter = attrHandle[name] || jQuery.find.attr;
    attrHandle[name] = function(elem, name, isXML) {
      var ret,
          handle,
          lowercaseName = name.toLowerCase();
      if (!isXML) {
        handle = attrHandle[lowercaseName];
        attrHandle[lowercaseName] = ret;
        ret = getter(elem, name, isXML) != null ? lowercaseName : null;
        attrHandle[lowercaseName] = handle;
      }
      return ret;
    };
  });
  var rfocusable = /^(?:input|select|textarea|button)$/i,
      rclickable = /^(?:a|area)$/i;
  jQuery.fn.extend({
    prop: function(name, value) {
      return access(this, jQuery.prop, name, value, arguments.length > 1);
    },
    removeProp: function(name) {
      return this.each(function() {
        delete this[jQuery.propFix[name] || name];
      });
    }
  });
  jQuery.extend({
    prop: function(elem, name, value) {
      var ret,
          hooks,
          nType = elem.nodeType;
      if (nType === 3 || nType === 8 || nType === 2) {
        return;
      }
      if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
        name = jQuery.propFix[name] || name;
        hooks = jQuery.propHooks[name];
      }
      if (value !== undefined) {
        if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) {
          return ret;
        }
        return (elem[name] = value);
      }
      if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) {
        return ret;
      }
      return elem[name];
    },
    propHooks: {tabIndex: {get: function(elem) {
          var tabindex = jQuery.find.attr(elem, "tabindex");
          if (tabindex) {
            return parseInt(tabindex, 10);
          }
          if (rfocusable.test(elem.nodeName) || rclickable.test(elem.nodeName) && elem.href) {
            return 0;
          }
          return -1;
        }}},
    propFix: {
      "for": "htmlFor",
      "class": "className"
    }
  });
  if (!support.optSelected) {
    jQuery.propHooks.selected = {
      get: function(elem) {
        var parent = elem.parentNode;
        if (parent && parent.parentNode) {
          parent.parentNode.selectedIndex;
        }
        return null;
      },
      set: function(elem) {
        var parent = elem.parentNode;
        if (parent) {
          parent.selectedIndex;
          if (parent.parentNode) {
            parent.parentNode.selectedIndex;
          }
        }
      }
    };
  }
  jQuery.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function() {
    jQuery.propFix[this.toLowerCase()] = this;
  });
  function stripAndCollapse(value) {
    var tokens = value.match(rnothtmlwhite) || [];
    return tokens.join(" ");
  }
  function getClass(elem) {
    return elem.getAttribute && elem.getAttribute("class") || "";
  }
  function classesToArray(value) {
    if (Array.isArray(value)) {
      return value;
    }
    if (typeof value === "string") {
      return value.match(rnothtmlwhite) || [];
    }
    return [];
  }
  jQuery.fn.extend({
    addClass: function(value) {
      var classes,
          elem,
          cur,
          curValue,
          clazz,
          j,
          finalValue,
          i = 0;
      if (isFunction(value)) {
        return this.each(function(j) {
          jQuery(this).addClass(value.call(this, j, getClass(this)));
        });
      }
      classes = classesToArray(value);
      if (classes.length) {
        while ((elem = this[i++])) {
          curValue = getClass(elem);
          cur = elem.nodeType === 1 && (" " + stripAndCollapse(curValue) + " ");
          if (cur) {
            j = 0;
            while ((clazz = classes[j++])) {
              if (cur.indexOf(" " + clazz + " ") < 0) {
                cur += clazz + " ";
              }
            }
            finalValue = stripAndCollapse(cur);
            if (curValue !== finalValue) {
              elem.setAttribute("class", finalValue);
            }
          }
        }
      }
      return this;
    },
    removeClass: function(value) {
      var classes,
          elem,
          cur,
          curValue,
          clazz,
          j,
          finalValue,
          i = 0;
      if (isFunction(value)) {
        return this.each(function(j) {
          jQuery(this).removeClass(value.call(this, j, getClass(this)));
        });
      }
      if (!arguments.length) {
        return this.attr("class", "");
      }
      classes = classesToArray(value);
      if (classes.length) {
        while ((elem = this[i++])) {
          curValue = getClass(elem);
          cur = elem.nodeType === 1 && (" " + stripAndCollapse(curValue) + " ");
          if (cur) {
            j = 0;
            while ((clazz = classes[j++])) {
              while (cur.indexOf(" " + clazz + " ") > -1) {
                cur = cur.replace(" " + clazz + " ", " ");
              }
            }
            finalValue = stripAndCollapse(cur);
            if (curValue !== finalValue) {
              elem.setAttribute("class", finalValue);
            }
          }
        }
      }
      return this;
    },
    toggleClass: function(value, stateVal) {
      var type = typeof value,
          isValidValue = type === "string" || Array.isArray(value);
      if (typeof stateVal === "boolean" && isValidValue) {
        return stateVal ? this.addClass(value) : this.removeClass(value);
      }
      if (isFunction(value)) {
        return this.each(function(i) {
          jQuery(this).toggleClass(value.call(this, i, getClass(this), stateVal), stateVal);
        });
      }
      return this.each(function() {
        var className,
            i,
            self,
            classNames;
        if (isValidValue) {
          i = 0;
          self = jQuery(this);
          classNames = classesToArray(value);
          while ((className = classNames[i++])) {
            if (self.hasClass(className)) {
              self.removeClass(className);
            } else {
              self.addClass(className);
            }
          }
        } else if (value === undefined || type === "boolean") {
          className = getClass(this);
          if (className) {
            dataPriv.set(this, "__className__", className);
          }
          if (this.setAttribute) {
            this.setAttribute("class", className || value === false ? "" : dataPriv.get(this, "__className__") || "");
          }
        }
      });
    },
    hasClass: function(selector) {
      var className,
          elem,
          i = 0;
      className = " " + selector + " ";
      while ((elem = this[i++])) {
        if (elem.nodeType === 1 && (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(className) > -1) {
          return true;
        }
      }
      return false;
    }
  });
  var rreturn = /\r/g;
  jQuery.fn.extend({val: function(value) {
      var hooks,
          ret,
          valueIsFunction,
          elem = this[0];
      if (!arguments.length) {
        if (elem) {
          hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()];
          if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== undefined) {
            return ret;
          }
          ret = elem.value;
          if (typeof ret === "string") {
            return ret.replace(rreturn, "");
          }
          return ret == null ? "" : ret;
        }
        return;
      }
      valueIsFunction = isFunction(value);
      return this.each(function(i) {
        var val;
        if (this.nodeType !== 1) {
          return;
        }
        if (valueIsFunction) {
          val = value.call(this, i, jQuery(this).val());
        } else {
          val = value;
        }
        if (val == null) {
          val = "";
        } else if (typeof val === "number") {
          val += "";
        } else if (Array.isArray(val)) {
          val = jQuery.map(val, function(value) {
            return value == null ? "" : value + "";
          });
        }
        hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];
        if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === undefined) {
          this.value = val;
        }
      });
    }});
  jQuery.extend({valHooks: {
      option: {get: function(elem) {
          var val = jQuery.find.attr(elem, "value");
          return val != null ? val : stripAndCollapse(jQuery.text(elem));
        }},
      select: {
        get: function(elem) {
          var value,
              option,
              i,
              options = elem.options,
              index = elem.selectedIndex,
              one = elem.type === "select-one",
              values = one ? null : [],
              max = one ? index + 1 : options.length;
          if (index < 0) {
            i = max;
          } else {
            i = one ? index : 0;
          }
          for (; i < max; i++) {
            option = options[i];
            if ((option.selected || i === index) && !option.disabled && (!option.parentNode.disabled || !nodeName(option.parentNode, "optgroup"))) {
              value = jQuery(option).val();
              if (one) {
                return value;
              }
              values.push(value);
            }
          }
          return values;
        },
        set: function(elem, value) {
          var optionSet,
              option,
              options = elem.options,
              values = jQuery.makeArray(value),
              i = options.length;
          while (i--) {
            option = options[i];
            if (option.selected = jQuery.inArray(jQuery.valHooks.option.get(option), values) > -1) {
              optionSet = true;
            }
          }
          if (!optionSet) {
            elem.selectedIndex = -1;
          }
          return values;
        }
      }
    }});
  jQuery.each(["radio", "checkbox"], function() {
    jQuery.valHooks[this] = {set: function(elem, value) {
        if (Array.isArray(value)) {
          return (elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1);
        }
      }};
    if (!support.checkOn) {
      jQuery.valHooks[this].get = function(elem) {
        return elem.getAttribute("value") === null ? "on" : elem.value;
      };
    }
  });
  support.focusin = "onfocusin" in window;
  var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
      stopPropagationCallback = function(e) {
        e.stopPropagation();
      };
  jQuery.extend(jQuery.event, {
    trigger: function(event, data, elem, onlyHandlers) {
      var i,
          cur,
          tmp,
          bubbleType,
          ontype,
          handle,
          special,
          lastElement,
          eventPath = [elem || document],
          type = hasOwn.call(event, "type") ? event.type : event,
          namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];
      cur = lastElement = tmp = elem = elem || document;
      if (elem.nodeType === 3 || elem.nodeType === 8) {
        return;
      }
      if (rfocusMorph.test(type + jQuery.event.triggered)) {
        return;
      }
      if (type.indexOf(".") > -1) {
        namespaces = type.split(".");
        type = namespaces.shift();
        namespaces.sort();
      }
      ontype = type.indexOf(":") < 0 && "on" + type;
      event = event[jQuery.expando] ? event : new jQuery.Event(type, typeof event === "object" && event);
      event.isTrigger = onlyHandlers ? 2 : 3;
      event.namespace = namespaces.join(".");
      event.rnamespace = event.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null;
      event.result = undefined;
      if (!event.target) {
        event.target = elem;
      }
      data = data == null ? [event] : jQuery.makeArray(data, [event]);
      special = jQuery.event.special[type] || {};
      if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) {
        return;
      }
      if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {
        bubbleType = special.delegateType || type;
        if (!rfocusMorph.test(bubbleType + type)) {
          cur = cur.parentNode;
        }
        for (; cur; cur = cur.parentNode) {
          eventPath.push(cur);
          tmp = cur;
        }
        if (tmp === (elem.ownerDocument || document)) {
          eventPath.push(tmp.defaultView || tmp.parentWindow || window);
        }
      }
      i = 0;
      while ((cur = eventPath[i++]) && !event.isPropagationStopped()) {
        lastElement = cur;
        event.type = i > 1 ? bubbleType : special.bindType || type;
        handle = (dataPriv.get(cur, "events") || {})[event.type] && dataPriv.get(cur, "handle");
        if (handle) {
          handle.apply(cur, data);
        }
        handle = ontype && cur[ontype];
        if (handle && handle.apply && acceptData(cur)) {
          event.result = handle.apply(cur, data);
          if (event.result === false) {
            event.preventDefault();
          }
        }
      }
      event.type = type;
      if (!onlyHandlers && !event.isDefaultPrevented()) {
        if ((!special._default || special._default.apply(eventPath.pop(), data) === false) && acceptData(elem)) {
          if (ontype && isFunction(elem[type]) && !isWindow(elem)) {
            tmp = elem[ontype];
            if (tmp) {
              elem[ontype] = null;
            }
            jQuery.event.triggered = type;
            if (event.isPropagationStopped()) {
              lastElement.addEventListener(type, stopPropagationCallback);
            }
            elem[type]();
            if (event.isPropagationStopped()) {
              lastElement.removeEventListener(type, stopPropagationCallback);
            }
            jQuery.event.triggered = undefined;
            if (tmp) {
              elem[ontype] = tmp;
            }
          }
        }
      }
      return event.result;
    },
    simulate: function(type, elem, event) {
      var e = jQuery.extend(new jQuery.Event(), event, {
        type: type,
        isSimulated: true
      });
      jQuery.event.trigger(e, null, elem);
    }
  });
  jQuery.fn.extend({
    trigger: function(type, data) {
      return this.each(function() {
        jQuery.event.trigger(type, data, this);
      });
    },
    triggerHandler: function(type, data) {
      var elem = this[0];
      if (elem) {
        return jQuery.event.trigger(type, data, elem, true);
      }
    }
  });
  if (!support.focusin) {
    jQuery.each({
      focus: "focusin",
      blur: "focusout"
    }, function(orig, fix) {
      var handler = function(event) {
        jQuery.event.simulate(fix, event.target, jQuery.event.fix(event));
      };
      jQuery.event.special[fix] = {
        setup: function() {
          var doc = this.ownerDocument || this,
              attaches = dataPriv.access(doc, fix);
          if (!attaches) {
            doc.addEventListener(orig, handler, true);
          }
          dataPriv.access(doc, fix, (attaches || 0) + 1);
        },
        teardown: function() {
          var doc = this.ownerDocument || this,
              attaches = dataPriv.access(doc, fix) - 1;
          if (!attaches) {
            doc.removeEventListener(orig, handler, true);
            dataPriv.remove(doc, fix);
          } else {
            dataPriv.access(doc, fix, attaches);
          }
        }
      };
    });
  }
  var location = window.location;
  var nonce = Date.now();
  var rquery = (/\?/);
  jQuery.parseXML = function(data) {
    var xml;
    if (!data || typeof data !== "string") {
      return null;
    }
    try {
      xml = (new window.DOMParser()).parseFromString(data, "text/xml");
    } catch (e) {
      xml = undefined;
    }
    if (!xml || xml.getElementsByTagName("parsererror").length) {
      jQuery.error("Invalid XML: " + data);
    }
    return xml;
  };
  var rbracket = /\[\]$/,
      rCRLF = /\r?\n/g,
      rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
      rsubmittable = /^(?:input|select|textarea|keygen)/i;
  function buildParams(prefix, obj, traditional, add) {
    var name;
    if (Array.isArray(obj)) {
      jQuery.each(obj, function(i, v) {
        if (traditional || rbracket.test(prefix)) {
          add(prefix, v);
        } else {
          buildParams(prefix + "[" + (typeof v === "object" && v != null ? i : "") + "]", v, traditional, add);
        }
      });
    } else if (!traditional && toType(obj) === "object") {
      for (name in obj) {
        buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
      }
    } else {
      add(prefix, obj);
    }
  }
  jQuery.param = function(a, traditional) {
    var prefix,
        s = [],
        add = function(key, valueOrFunction) {
          var value = isFunction(valueOrFunction) ? valueOrFunction() : valueOrFunction;
          s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value == null ? "" : value);
        };
    if (Array.isArray(a) || (a.jquery && !jQuery.isPlainObject(a))) {
      jQuery.each(a, function() {
        add(this.name, this.value);
      });
    } else {
      for (prefix in a) {
        buildParams(prefix, a[prefix], traditional, add);
      }
    }
    return s.join("&");
  };
  jQuery.fn.extend({
    serialize: function() {
      return jQuery.param(this.serializeArray());
    },
    serializeArray: function() {
      return this.map(function() {
        var elements = jQuery.prop(this, "elements");
        return elements ? jQuery.makeArray(elements) : this;
      }).filter(function() {
        var type = this.type;
        return this.name && !jQuery(this).is(":disabled") && rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && (this.checked || !rcheckableType.test(type));
      }).map(function(i, elem) {
        var val = jQuery(this).val();
        if (val == null) {
          return null;
        }
        if (Array.isArray(val)) {
          return jQuery.map(val, function(val) {
            return {
              name: elem.name,
              value: val.replace(rCRLF, "\r\n")
            };
          });
        }
        return {
          name: elem.name,
          value: val.replace(rCRLF, "\r\n")
        };
      }).get();
    }
  });
  var r20 = /%20/g,
      rhash = /#.*$/,
      rantiCache = /([?&])_=[^&]*/,
      rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,
      rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
      rnoContent = /^(?:GET|HEAD)$/,
      rprotocol = /^\/\//,
      prefilters = {},
      transports = {},
      allTypes = "*/".concat("*"),
      originAnchor = document.createElement("a");
  originAnchor.href = location.href;
  function addToPrefiltersOrTransports(structure) {
    return function(dataTypeExpression, func) {
      if (typeof dataTypeExpression !== "string") {
        func = dataTypeExpression;
        dataTypeExpression = "*";
      }
      var dataType,
          i = 0,
          dataTypes = dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];
      if (isFunction(func)) {
        while ((dataType = dataTypes[i++])) {
          if (dataType[0] === "+") {
            dataType = dataType.slice(1) || "*";
            (structure[dataType] = structure[dataType] || []).unshift(func);
          } else {
            (structure[dataType] = structure[dataType] || []).push(func);
          }
        }
      }
    };
  }
  function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {
    var inspected = {},
        seekingTransport = (structure === transports);
    function inspect(dataType) {
      var selected;
      inspected[dataType] = true;
      jQuery.each(structure[dataType] || [], function(_, prefilterOrFactory) {
        var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
        if (typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[dataTypeOrTransport]) {
          options.dataTypes.unshift(dataTypeOrTransport);
          inspect(dataTypeOrTransport);
          return false;
        } else if (seekingTransport) {
          return !(selected = dataTypeOrTransport);
        }
      });
      return selected;
    }
    return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*");
  }
  function ajaxExtend(target, src) {
    var key,
        deep,
        flatOptions = jQuery.ajaxSettings.flatOptions || {};
    for (key in src) {
      if (src[key] !== undefined) {
        (flatOptions[key] ? target : (deep || (deep = {})))[key] = src[key];
      }
    }
    if (deep) {
      jQuery.extend(true, target, deep);
    }
    return target;
  }
  function ajaxHandleResponses(s, jqXHR, responses) {
    var ct,
        type,
        finalDataType,
        firstDataType,
        contents = s.contents,
        dataTypes = s.dataTypes;
    while (dataTypes[0] === "*") {
      dataTypes.shift();
      if (ct === undefined) {
        ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
      }
    }
    if (ct) {
      for (type in contents) {
        if (contents[type] && contents[type].test(ct)) {
          dataTypes.unshift(type);
          break;
        }
      }
    }
    if (dataTypes[0] in responses) {
      finalDataType = dataTypes[0];
    } else {
      for (type in responses) {
        if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
          finalDataType = type;
          break;
        }
        if (!firstDataType) {
          firstDataType = type;
        }
      }
      finalDataType = finalDataType || firstDataType;
    }
    if (finalDataType) {
      if (finalDataType !== dataTypes[0]) {
        dataTypes.unshift(finalDataType);
      }
      return responses[finalDataType];
    }
  }
  function ajaxConvert(s, response, jqXHR, isSuccess) {
    var conv2,
        current,
        conv,
        tmp,
        prev,
        converters = {},
        dataTypes = s.dataTypes.slice();
    if (dataTypes[1]) {
      for (conv in s.converters) {
        converters[conv.toLowerCase()] = s.converters[conv];
      }
    }
    current = dataTypes.shift();
    while (current) {
      if (s.responseFields[current]) {
        jqXHR[s.responseFields[current]] = response;
      }
      if (!prev && isSuccess && s.dataFilter) {
        response = s.dataFilter(response, s.dataType);
      }
      prev = current;
      current = dataTypes.shift();
      if (current) {
        if (current === "*") {
          current = prev;
        } else if (prev !== "*" && prev !== current) {
          conv = converters[prev + " " + current] || converters["* " + current];
          if (!conv) {
            for (conv2 in converters) {
              tmp = conv2.split(" ");
              if (tmp[1] === current) {
                conv = converters[prev + " " + tmp[0]] || converters["* " + tmp[0]];
                if (conv) {
                  if (conv === true) {
                    conv = converters[conv2];
                  } else if (converters[conv2] !== true) {
                    current = tmp[0];
                    dataTypes.unshift(tmp[1]);
                  }
                  break;
                }
              }
            }
          }
          if (conv !== true) {
            if (conv && s.throws) {
              response = conv(response);
            } else {
              try {
                response = conv(response);
              } catch (e) {
                return {
                  state: "parsererror",
                  error: conv ? e : "No conversion from " + prev + " to " + current
                };
              }
            }
          }
        }
      }
    }
    return {
      state: "success",
      data: response
    };
  }
  jQuery.extend({
    active: 0,
    lastModified: {},
    etag: {},
    ajaxSettings: {
      url: location.href,
      type: "GET",
      isLocal: rlocalProtocol.test(location.protocol),
      global: true,
      processData: true,
      async: true,
      contentType: "application/x-www-form-urlencoded; charset=UTF-8",
      accepts: {
        "*": allTypes,
        text: "text/plain",
        html: "text/html",
        xml: "application/xml, text/xml",
        json: "application/json, text/javascript"
      },
      contents: {
        xml: /\bxml\b/,
        html: /\bhtml/,
        json: /\bjson\b/
      },
      responseFields: {
        xml: "responseXML",
        text: "responseText",
        json: "responseJSON"
      },
      converters: {
        "* text": String,
        "text html": true,
        "text json": JSON.parse,
        "text xml": jQuery.parseXML
      },
      flatOptions: {
        url: true,
        context: true
      }
    },
    ajaxSetup: function(target, settings) {
      return settings ? ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings) : ajaxExtend(jQuery.ajaxSettings, target);
    },
    ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
    ajaxTransport: addToPrefiltersOrTransports(transports),
    ajax: function(url, options) {
      if (typeof url === "object") {
        options = url;
        url = undefined;
      }
      options = options || {};
      var transport,
          cacheURL,
          responseHeadersString,
          responseHeaders,
          timeoutTimer,
          urlAnchor,
          completed,
          fireGlobals,
          i,
          uncached,
          s = jQuery.ajaxSetup({}, options),
          callbackContext = s.context || s,
          globalEventContext = s.context && (callbackContext.nodeType || callbackContext.jquery) ? jQuery(callbackContext) : jQuery.event,
          deferred = jQuery.Deferred(),
          completeDeferred = jQuery.Callbacks("once memory"),
          statusCode = s.statusCode || {},
          requestHeaders = {},
          requestHeadersNames = {},
          strAbort = "canceled",
          jqXHR = {
            readyState: 0,
            getResponseHeader: function(key) {
              var match;
              if (completed) {
                if (!responseHeaders) {
                  responseHeaders = {};
                  while ((match = rheaders.exec(responseHeadersString))) {
                    responseHeaders[match[1].toLowerCase()] = match[2];
                  }
                }
                match = responseHeaders[key.toLowerCase()];
              }
              return match == null ? null : match;
            },
            getAllResponseHeaders: function() {
              return completed ? responseHeadersString : null;
            },
            setRequestHeader: function(name, value) {
              if (completed == null) {
                name = requestHeadersNames[name.toLowerCase()] = requestHeadersNames[name.toLowerCase()] || name;
                requestHeaders[name] = value;
              }
              return this;
            },
            overrideMimeType: function(type) {
              if (completed == null) {
                s.mimeType = type;
              }
              return this;
            },
            statusCode: function(map) {
              var code;
              if (map) {
                if (completed) {
                  jqXHR.always(map[jqXHR.status]);
                } else {
                  for (code in map) {
                    statusCode[code] = [statusCode[code], map[code]];
                  }
                }
              }
              return this;
            },
            abort: function(statusText) {
              var finalText = statusText || strAbort;
              if (transport) {
                transport.abort(finalText);
              }
              done(0, finalText);
              return this;
            }
          };
      deferred.promise(jqXHR);
      s.url = ((url || s.url || location.href) + "").replace(rprotocol, location.protocol + "//");
      s.type = options.method || options.type || s.method || s.type;
      s.dataTypes = (s.dataType || "*").toLowerCase().match(rnothtmlwhite) || [""];
      if (s.crossDomain == null) {
        urlAnchor = document.createElement("a");
        try {
          urlAnchor.href = s.url;
          urlAnchor.href = urlAnchor.href;
          s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !== urlAnchor.protocol + "//" + urlAnchor.host;
        } catch (e) {
          s.crossDomain = true;
        }
      }
      if (s.data && s.processData && typeof s.data !== "string") {
        s.data = jQuery.param(s.data, s.traditional);
      }
      inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);
      if (completed) {
        return jqXHR;
      }
      fireGlobals = jQuery.event && s.global;
      if (fireGlobals && jQuery.active++ === 0) {
        jQuery.event.trigger("ajaxStart");
      }
      s.type = s.type.toUpperCase();
      s.hasContent = !rnoContent.test(s.type);
      cacheURL = s.url.replace(rhash, "");
      if (!s.hasContent) {
        uncached = s.url.slice(cacheURL.length);
        if (s.data && (s.processData || typeof s.data === "string")) {
          cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s.data;
          delete s.data;
        }
        if (s.cache === false) {
          cacheURL = cacheURL.replace(rantiCache, "$1");
          uncached = (rquery.test(cacheURL) ? "&" : "?") + "_=" + (nonce++) + uncached;
        }
        s.url = cacheURL + uncached;
      } else if (s.data && s.processData && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0) {
        s.data = s.data.replace(r20, "+");
      }
      if (s.ifModified) {
        if (jQuery.lastModified[cacheURL]) {
          jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL]);
        }
        if (jQuery.etag[cacheURL]) {
          jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL]);
        }
      }
      if (s.data && s.hasContent && s.contentType !== false || options.contentType) {
        jqXHR.setRequestHeader("Content-Type", s.contentType);
      }
      jqXHR.setRequestHeader("Accept", s.dataTypes[0] && s.accepts[s.dataTypes[0]] ? s.accepts[s.dataTypes[0]] + (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") : s.accepts["*"]);
      for (i in s.headers) {
        jqXHR.setRequestHeader(i, s.headers[i]);
      }
      if (s.beforeSend && (s.beforeSend.call(callbackContext, jqXHR, s) === false || completed)) {
        return jqXHR.abort();
      }
      strAbort = "abort";
      completeDeferred.add(s.complete);
      jqXHR.done(s.success);
      jqXHR.fail(s.error);
      transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR);
      if (!transport) {
        done(-1, "No Transport");
      } else {
        jqXHR.readyState = 1;
        if (fireGlobals) {
          globalEventContext.trigger("ajaxSend", [jqXHR, s]);
        }
        if (completed) {
          return jqXHR;
        }
        if (s.async && s.timeout > 0) {
          timeoutTimer = window.setTimeout(function() {
            jqXHR.abort("timeout");
          }, s.timeout);
        }
        try {
          completed = false;
          transport.send(requestHeaders, done);
        } catch (e) {
          if (completed) {
            throw e;
          }
          done(-1, e);
        }
      }
      function done(status, nativeStatusText, responses, headers) {
        var isSuccess,
            success,
            error,
            response,
            modified,
            statusText = nativeStatusText;
        if (completed) {
          return;
        }
        completed = true;
        if (timeoutTimer) {
          window.clearTimeout(timeoutTimer);
        }
        transport = undefined;
        responseHeadersString = headers || "";
        jqXHR.readyState = status > 0 ? 4 : 0;
        isSuccess = status >= 200 && status < 300 || status === 304;
        if (responses) {
          response = ajaxHandleResponses(s, jqXHR, responses);
        }
        response = ajaxConvert(s, response, jqXHR, isSuccess);
        if (isSuccess) {
          if (s.ifModified) {
            modified = jqXHR.getResponseHeader("Last-Modified");
            if (modified) {
              jQuery.lastModified[cacheURL] = modified;
            }
            modified = jqXHR.getResponseHeader("etag");
            if (modified) {
              jQuery.etag[cacheURL] = modified;
            }
          }
          if (status === 204 || s.type === "HEAD") {
            statusText = "nocontent";
          } else if (status === 304) {
            statusText = "notmodified";
          } else {
            statusText = response.state;
            success = response.data;
            error = response.error;
            isSuccess = !error;
          }
        } else {
          error = statusText;
          if (status || !statusText) {
            statusText = "error";
            if (status < 0) {
              status = 0;
            }
          }
        }
        jqXHR.status = status;
        jqXHR.statusText = (nativeStatusText || statusText) + "";
        if (isSuccess) {
          deferred.resolveWith(callbackContext, [success, statusText, jqXHR]);
        } else {
          deferred.rejectWith(callbackContext, [jqXHR, statusText, error]);
        }
        jqXHR.statusCode(statusCode);
        statusCode = undefined;
        if (fireGlobals) {
          globalEventContext.trigger(isSuccess ? "ajaxSuccess" : "ajaxError", [jqXHR, s, isSuccess ? success : error]);
        }
        completeDeferred.fireWith(callbackContext, [jqXHR, statusText]);
        if (fireGlobals) {
          globalEventContext.trigger("ajaxComplete", [jqXHR, s]);
          if (!(--jQuery.active)) {
            jQuery.event.trigger("ajaxStop");
          }
        }
      }
      return jqXHR;
    },
    getJSON: function(url, data, callback) {
      return jQuery.get(url, data, callback, "json");
    },
    getScript: function(url, callback) {
      return jQuery.get(url, undefined, callback, "script");
    }
  });
  jQuery.each(["get", "post"], function(i, method) {
    jQuery[method] = function(url, data, callback, type) {
      if (isFunction(data)) {
        type = type || callback;
        callback = data;
        data = undefined;
      }
      return jQuery.ajax(jQuery.extend({
        url: url,
        type: method,
        dataType: type,
        data: data,
        success: callback
      }, jQuery.isPlainObject(url) && url));
    };
  });
  jQuery._evalUrl = function(url) {
    return jQuery.ajax({
      url: url,
      type: "GET",
      dataType: "script",
      cache: true,
      async: false,
      global: false,
      "throws": true
    });
  };
  jQuery.fn.extend({
    wrapAll: function(html) {
      var wrap;
      if (this[0]) {
        if (isFunction(html)) {
          html = html.call(this[0]);
        }
        wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);
        if (this[0].parentNode) {
          wrap.insertBefore(this[0]);
        }
        wrap.map(function() {
          var elem = this;
          while (elem.firstElementChild) {
            elem = elem.firstElementChild;
          }
          return elem;
        }).append(this);
      }
      return this;
    },
    wrapInner: function(html) {
      if (isFunction(html)) {
        return this.each(function(i) {
          jQuery(this).wrapInner(html.call(this, i));
        });
      }
      return this.each(function() {
        var self = jQuery(this),
            contents = self.contents();
        if (contents.length) {
          contents.wrapAll(html);
        } else {
          self.append(html);
        }
      });
    },
    wrap: function(html) {
      var htmlIsFunction = isFunction(html);
      return this.each(function(i) {
        jQuery(this).wrapAll(htmlIsFunction ? html.call(this, i) : html);
      });
    },
    unwrap: function(selector) {
      this.parent(selector).not("body").each(function() {
        jQuery(this).replaceWith(this.childNodes);
      });
      return this;
    }
  });
  jQuery.expr.pseudos.hidden = function(elem) {
    return !jQuery.expr.pseudos.visible(elem);
  };
  jQuery.expr.pseudos.visible = function(elem) {
    return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
  };
  jQuery.ajaxSettings.xhr = function() {
    try {
      return new window.XMLHttpRequest();
    } catch (e) {}
  };
  var xhrSuccessStatus = {
    0: 200,
    1223: 204
  },
      xhrSupported = jQuery.ajaxSettings.xhr();
  support.cors = !!xhrSupported && ("withCredentials" in xhrSupported);
  support.ajax = xhrSupported = !!xhrSupported;
  jQuery.ajaxTransport(function(options) {
    var callback,
        errorCallback;
    if (support.cors || xhrSupported && !options.crossDomain) {
      return {
        send: function(headers, complete) {
          var i,
              xhr = options.xhr();
          xhr.open(options.type, options.url, options.async, options.username, options.password);
          if (options.xhrFields) {
            for (i in options.xhrFields) {
              xhr[i] = options.xhrFields[i];
            }
          }
          if (options.mimeType && xhr.overrideMimeType) {
            xhr.overrideMimeType(options.mimeType);
          }
          if (!options.crossDomain && !headers["X-Requested-With"]) {
            headers["X-Requested-With"] = "XMLHttpRequest";
          }
          for (i in headers) {
            xhr.setRequestHeader(i, headers[i]);
          }
          callback = function(type) {
            return function() {
              if (callback) {
                callback = errorCallback = xhr.onload = xhr.onerror = xhr.onabort = xhr.ontimeout = xhr.onreadystatechange = null;
                if (type === "abort") {
                  xhr.abort();
                } else if (type === "error") {
                  if (typeof xhr.status !== "number") {
                    complete(0, "error");
                  } else {
                    complete(xhr.status, xhr.statusText);
                  }
                } else {
                  complete(xhrSuccessStatus[xhr.status] || xhr.status, xhr.statusText, (xhr.responseType || "text") !== "text" || typeof xhr.responseText !== "string" ? {binary: xhr.response} : {text: xhr.responseText}, xhr.getAllResponseHeaders());
                }
              }
            };
          };
          xhr.onload = callback();
          errorCallback = xhr.onerror = xhr.ontimeout = callback("error");
          if (xhr.onabort !== undefined) {
            xhr.onabort = errorCallback;
          } else {
            xhr.onreadystatechange = function() {
              if (xhr.readyState === 4) {
                window.setTimeout(function() {
                  if (callback) {
                    errorCallback();
                  }
                });
              }
            };
          }
          callback = callback("abort");
          try {
            xhr.send(options.hasContent && options.data || null);
          } catch (e) {
            if (callback) {
              throw e;
            }
          }
        },
        abort: function() {
          if (callback) {
            callback();
          }
        }
      };
    }
  });
  jQuery.ajaxPrefilter(function(s) {
    if (s.crossDomain) {
      s.contents.script = false;
    }
  });
  jQuery.ajaxSetup({
    accepts: {script: "text/javascript, application/javascript, " + "application/ecmascript, application/x-ecmascript"},
    contents: {script: /\b(?:java|ecma)script\b/},
    converters: {"text script": function(text) {
        jQuery.globalEval(text);
        return text;
      }}
  });
  jQuery.ajaxPrefilter("script", function(s) {
    if (s.cache === undefined) {
      s.cache = false;
    }
    if (s.crossDomain) {
      s.type = "GET";
    }
  });
  jQuery.ajaxTransport("script", function(s) {
    if (s.crossDomain) {
      var script,
          callback;
      return {
        send: function(_, complete) {
          script = jQuery("<script>").prop({
            charset: s.scriptCharset,
            src: s.url
          }).on("load error", callback = function(evt) {
            script.remove();
            callback = null;
            if (evt) {
              complete(evt.type === "error" ? 404 : 200, evt.type);
            }
          });
          document.head.appendChild(script[0]);
        },
        abort: function() {
          if (callback) {
            callback();
          }
        }
      };
    }
  });
  var oldCallbacks = [],
      rjsonp = /(=)\?(?=&|$)|\?\?/;
  jQuery.ajaxSetup({
    jsonp: "callback",
    jsonpCallback: function() {
      var callback = oldCallbacks.pop() || (jQuery.expando + "_" + (nonce++));
      this[callback] = true;
      return callback;
    }
  });
  jQuery.ajaxPrefilter("json jsonp", function(s, originalSettings, jqXHR) {
    var callbackName,
        overwritten,
        responseContainer,
        jsonProp = s.jsonp !== false && (rjsonp.test(s.url) ? "url" : typeof s.data === "string" && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && rjsonp.test(s.data) && "data");
    if (jsonProp || s.dataTypes[0] === "jsonp") {
      callbackName = s.jsonpCallback = isFunction(s.jsonpCallback) ? s.jsonpCallback() : s.jsonpCallback;
      if (jsonProp) {
        s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName);
      } else if (s.jsonp !== false) {
        s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName;
      }
      s.converters["script json"] = function() {
        if (!responseContainer) {
          jQuery.error(callbackName + " was not called");
        }
        return responseContainer[0];
      };
      s.dataTypes[0] = "json";
      overwritten = window[callbackName];
      window[callbackName] = function() {
        responseContainer = arguments;
      };
      jqXHR.always(function() {
        if (overwritten === undefined) {
          jQuery(window).removeProp(callbackName);
        } else {
          window[callbackName] = overwritten;
        }
        if (s[callbackName]) {
          s.jsonpCallback = originalSettings.jsonpCallback;
          oldCallbacks.push(callbackName);
        }
        if (responseContainer && isFunction(overwritten)) {
          overwritten(responseContainer[0]);
        }
        responseContainer = overwritten = undefined;
      });
      return "script";
    }
  });
  support.createHTMLDocument = (function() {
    var body = document.implementation.createHTMLDocument("").body;
    body.innerHTML = "<form></form><form></form>";
    return body.childNodes.length === 2;
  })();
  jQuery.parseHTML = function(data, context, keepScripts) {
    if (typeof data !== "string") {
      return [];
    }
    if (typeof context === "boolean") {
      keepScripts = context;
      context = false;
    }
    var base,
        parsed,
        scripts;
    if (!context) {
      if (support.createHTMLDocument) {
        context = document.implementation.createHTMLDocument("");
        base = context.createElement("base");
        base.href = document.location.href;
        context.head.appendChild(base);
      } else {
        context = document;
      }
    }
    parsed = rsingleTag.exec(data);
    scripts = !keepScripts && [];
    if (parsed) {
      return [context.createElement(parsed[1])];
    }
    parsed = buildFragment([data], context, scripts);
    if (scripts && scripts.length) {
      jQuery(scripts).remove();
    }
    return jQuery.merge([], parsed.childNodes);
  };
  jQuery.fn.load = function(url, params, callback) {
    var selector,
        type,
        response,
        self = this,
        off = url.indexOf(" ");
    if (off > -1) {
      selector = stripAndCollapse(url.slice(off));
      url = url.slice(0, off);
    }
    if (isFunction(params)) {
      callback = params;
      params = undefined;
    } else if (params && typeof params === "object") {
      type = "POST";
    }
    if (self.length > 0) {
      jQuery.ajax({
        url: url,
        type: type || "GET",
        dataType: "html",
        data: params
      }).done(function(responseText) {
        response = arguments;
        self.html(selector ? jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector) : responseText);
      }).always(callback && function(jqXHR, status) {
        self.each(function() {
          callback.apply(this, response || [jqXHR.responseText, status, jqXHR]);
        });
      });
    }
    return this;
  };
  jQuery.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function(i, type) {
    jQuery.fn[type] = function(fn) {
      return this.on(type, fn);
    };
  });
  jQuery.expr.pseudos.animated = function(elem) {
    return jQuery.grep(jQuery.timers, function(fn) {
      return elem === fn.elem;
    }).length;
  };
  jQuery.offset = {setOffset: function(elem, options, i) {
      var curPosition,
          curLeft,
          curCSSTop,
          curTop,
          curOffset,
          curCSSLeft,
          calculatePosition,
          position = jQuery.css(elem, "position"),
          curElem = jQuery(elem),
          props = {};
      if (position === "static") {
        elem.style.position = "relative";
      }
      curOffset = curElem.offset();
      curCSSTop = jQuery.css(elem, "top");
      curCSSLeft = jQuery.css(elem, "left");
      calculatePosition = (position === "absolute" || position === "fixed") && (curCSSTop + curCSSLeft).indexOf("auto") > -1;
      if (calculatePosition) {
        curPosition = curElem.position();
        curTop = curPosition.top;
        curLeft = curPosition.left;
      } else {
        curTop = parseFloat(curCSSTop) || 0;
        curLeft = parseFloat(curCSSLeft) || 0;
      }
      if (isFunction(options)) {
        options = options.call(elem, i, jQuery.extend({}, curOffset));
      }
      if (options.top != null) {
        props.top = (options.top - curOffset.top) + curTop;
      }
      if (options.left != null) {
        props.left = (options.left - curOffset.left) + curLeft;
      }
      if ("using" in options) {
        options.using.call(elem, props);
      } else {
        curElem.css(props);
      }
    }};
  jQuery.fn.extend({
    offset: function(options) {
      if (arguments.length) {
        return options === undefined ? this : this.each(function(i) {
          jQuery.offset.setOffset(this, options, i);
        });
      }
      var rect,
          win,
          elem = this[0];
      if (!elem) {
        return;
      }
      if (!elem.getClientRects().length) {
        return {
          top: 0,
          left: 0
        };
      }
      rect = elem.getBoundingClientRect();
      win = elem.ownerDocument.defaultView;
      return {
        top: rect.top + win.pageYOffset,
        left: rect.left + win.pageXOffset
      };
    },
    position: function() {
      if (!this[0]) {
        return;
      }
      var offsetParent,
          offset,
          doc,
          elem = this[0],
          parentOffset = {
            top: 0,
            left: 0
          };
      if (jQuery.css(elem, "position") === "fixed") {
        offset = elem.getBoundingClientRect();
      } else {
        offset = this.offset();
        doc = elem.ownerDocument;
        offsetParent = elem.offsetParent || doc.documentElement;
        while (offsetParent && (offsetParent === doc.body || offsetParent === doc.documentElement) && jQuery.css(offsetParent, "position") === "static") {
          offsetParent = offsetParent.parentNode;
        }
        if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1) {
          parentOffset = jQuery(offsetParent).offset();
          parentOffset.top += jQuery.css(offsetParent, "borderTopWidth", true);
          parentOffset.left += jQuery.css(offsetParent, "borderLeftWidth", true);
        }
      }
      return {
        top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true),
        left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true)
      };
    },
    offsetParent: function() {
      return this.map(function() {
        var offsetParent = this.offsetParent;
        while (offsetParent && jQuery.css(offsetParent, "position") === "static") {
          offsetParent = offsetParent.offsetParent;
        }
        return offsetParent || documentElement;
      });
    }
  });
  jQuery.each({
    scrollLeft: "pageXOffset",
    scrollTop: "pageYOffset"
  }, function(method, prop) {
    var top = "pageYOffset" === prop;
    jQuery.fn[method] = function(val) {
      return access(this, function(elem, method, val) {
        var win;
        if (isWindow(elem)) {
          win = elem;
        } else if (elem.nodeType === 9) {
          win = elem.defaultView;
        }
        if (val === undefined) {
          return win ? win[prop] : elem[method];
        }
        if (win) {
          win.scrollTo(!top ? val : win.pageXOffset, top ? val : win.pageYOffset);
        } else {
          elem[method] = val;
        }
      }, method, val, arguments.length);
    };
  });
  jQuery.each(["top", "left"], function(i, prop) {
    jQuery.cssHooks[prop] = addGetHookIf(support.pixelPosition, function(elem, computed) {
      if (computed) {
        computed = curCSS(elem, prop);
        return rnumnonpx.test(computed) ? jQuery(elem).position()[prop] + "px" : computed;
      }
    });
  });
  jQuery.each({
    Height: "height",
    Width: "width"
  }, function(name, type) {
    jQuery.each({
      padding: "inner" + name,
      content: type,
      "": "outer" + name
    }, function(defaultExtra, funcName) {
      jQuery.fn[funcName] = function(margin, value) {
        var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"),
            extra = defaultExtra || (margin === true || value === true ? "margin" : "border");
        return access(this, function(elem, type, value) {
          var doc;
          if (isWindow(elem)) {
            return funcName.indexOf("outer") === 0 ? elem["inner" + name] : elem.document.documentElement["client" + name];
          }
          if (elem.nodeType === 9) {
            doc = elem.documentElement;
            return Math.max(elem.body["scroll" + name], doc["scroll" + name], elem.body["offset" + name], doc["offset" + name], doc["client" + name]);
          }
          return value === undefined ? jQuery.css(elem, type, extra) : jQuery.style(elem, type, value, extra);
        }, type, chainable ? margin : undefined, chainable);
      };
    });
  });
  jQuery.each(("blur focus focusin focusout resize scroll click dblclick " + "mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " + "change select submit keydown keypress keyup contextmenu").split(" "), function(i, name) {
    jQuery.fn[name] = function(data, fn) {
      return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name);
    };
  });
  jQuery.fn.extend({hover: function(fnOver, fnOut) {
      return this.mouseenter(fnOver).mouseleave(fnOut || fnOver);
    }});
  jQuery.fn.extend({
    bind: function(types, data, fn) {
      return this.on(types, null, data, fn);
    },
    unbind: function(types, fn) {
      return this.off(types, null, fn);
    },
    delegate: function(selector, types, data, fn) {
      return this.on(types, selector, data, fn);
    },
    undelegate: function(selector, types, fn) {
      return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn);
    }
  });
  jQuery.proxy = function(fn, context) {
    var tmp,
        args,
        proxy;
    if (typeof context === "string") {
      tmp = fn[context];
      context = fn;
      fn = tmp;
    }
    if (!isFunction(fn)) {
      return undefined;
    }
    args = slice.call(arguments, 2);
    proxy = function() {
      return fn.apply(context || this, args.concat(slice.call(arguments)));
    };
    proxy.guid = fn.guid = fn.guid || jQuery.guid++;
    return proxy;
  };
  jQuery.holdReady = function(hold) {
    if (hold) {
      jQuery.readyWait++;
    } else {
      jQuery.ready(true);
    }
  };
  jQuery.isArray = Array.isArray;
  jQuery.parseJSON = JSON.parse;
  jQuery.nodeName = nodeName;
  jQuery.isFunction = isFunction;
  jQuery.isWindow = isWindow;
  jQuery.camelCase = camelCase;
  jQuery.type = toType;
  jQuery.now = Date.now;
  jQuery.isNumeric = function(obj) {
    var type = jQuery.type(obj);
    return (type === "number" || type === "string") && !isNaN(obj - parseFloat(obj));
  };
  if (typeof define === "function" && define.amd) {
    define("4", [], function() {
      return jQuery;
    }) && define("jquery", ["4"], function(m) {
      return m;
    });
  }
  var _jQuery = window.jQuery,
      _$ = window.$;
  jQuery.noConflict = function(deep) {
    if (window.$ === jQuery) {
      window.$ = _$;
    }
    if (deep && window.jQuery === jQuery) {
      window.jQuery = _jQuery;
    }
    return jQuery;
  };
  if (!noGlobal) {
    window.jQuery = window.$ = jQuery;
  }
  return jQuery;
});

})();
(function() {
var define = $__System.amdDefine;
;
(function(factory) {
  'use strict';
  if (typeof define === 'function' && define.amd) {
    define("5", ["4"], factory);
  } else if (typeof exports !== 'undefined') {
    module.exports = factory(require('jquery'));
  } else {
    factory(jQuery);
  }
}(function($) {
  'use strict';
  var Slick = window.Slick || {};
  Slick = (function() {
    var instanceUid = 0;
    function Slick(element, settings) {
      var _ = this,
          dataSettings;
      _.defaults = {
        accessibility: true,
        adaptiveHeight: false,
        appendArrows: $(element),
        appendDots: $(element),
        arrows: true,
        asNavFor: null,
        prevArrow: '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
        nextArrow: '<button class="slick-next" aria-label="Next" type="button">Next</button>',
        autoplay: false,
        autoplaySpeed: 3000,
        centerMode: false,
        centerPadding: '50px',
        cssEase: 'ease',
        customPaging: function(slider, i) {
          return $('<button type="button" />').text(i + 1);
        },
        dots: false,
        dotsClass: 'slick-dots',
        draggable: true,
        easing: 'linear',
        edgeFriction: 0.35,
        fade: false,
        focusOnSelect: false,
        focusOnChange: false,
        infinite: true,
        initialSlide: 0,
        lazyLoad: 'ondemand',
        mobileFirst: false,
        pauseOnHover: true,
        pauseOnFocus: true,
        pauseOnDotsHover: false,
        respondTo: 'window',
        responsive: null,
        rows: 1,
        rtl: false,
        slide: '',
        slidesPerRow: 1,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 500,
        swipe: true,
        swipeToSlide: false,
        touchMove: true,
        touchThreshold: 5,
        useCSS: true,
        useTransform: true,
        variableWidth: false,
        vertical: false,
        verticalSwiping: false,
        waitForAnimate: true,
        zIndex: 1000
      };
      _.initials = {
        animating: false,
        dragging: false,
        autoPlayTimer: null,
        currentDirection: 0,
        currentLeft: null,
        currentSlide: 0,
        direction: 1,
        $dots: null,
        listWidth: null,
        listHeight: null,
        loadIndex: 0,
        $nextArrow: null,
        $prevArrow: null,
        scrolling: false,
        slideCount: null,
        slideWidth: null,
        $slideTrack: null,
        $slides: null,
        sliding: false,
        slideOffset: 0,
        swipeLeft: null,
        swiping: false,
        $list: null,
        touchObject: {},
        transformsEnabled: false,
        unslicked: false
      };
      $.extend(_, _.initials);
      _.activeBreakpoint = null;
      _.animType = null;
      _.animProp = null;
      _.breakpoints = [];
      _.breakpointSettings = [];
      _.cssTransitions = false;
      _.focussed = false;
      _.interrupted = false;
      _.hidden = 'hidden';
      _.paused = true;
      _.positionProp = null;
      _.respondTo = null;
      _.rowCount = 1;
      _.shouldClick = true;
      _.$slider = $(element);
      _.$slidesCache = null;
      _.transformType = null;
      _.transitionType = null;
      _.visibilityChange = 'visibilitychange';
      _.windowWidth = 0;
      _.windowTimer = null;
      dataSettings = $(element).data('slick') || {};
      _.options = $.extend({}, _.defaults, settings, dataSettings);
      _.currentSlide = _.options.initialSlide;
      _.originalSettings = _.options;
      if (typeof document.mozHidden !== 'undefined') {
        _.hidden = 'mozHidden';
        _.visibilityChange = 'mozvisibilitychange';
      } else if (typeof document.webkitHidden !== 'undefined') {
        _.hidden = 'webkitHidden';
        _.visibilityChange = 'webkitvisibilitychange';
      }
      _.autoPlay = $.proxy(_.autoPlay, _);
      _.autoPlayClear = $.proxy(_.autoPlayClear, _);
      _.autoPlayIterator = $.proxy(_.autoPlayIterator, _);
      _.changeSlide = $.proxy(_.changeSlide, _);
      _.clickHandler = $.proxy(_.clickHandler, _);
      _.selectHandler = $.proxy(_.selectHandler, _);
      _.setPosition = $.proxy(_.setPosition, _);
      _.swipeHandler = $.proxy(_.swipeHandler, _);
      _.dragHandler = $.proxy(_.dragHandler, _);
      _.keyHandler = $.proxy(_.keyHandler, _);
      _.instanceUid = instanceUid++;
      _.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/;
      _.registerBreakpoints();
      _.init(true);
    }
    return Slick;
  }());
  Slick.prototype.activateADA = function() {
    var _ = this;
    _.$slideTrack.find('.slick-active').attr({'aria-hidden': 'false'}).find('a, input, button, select').attr({'tabindex': '0'});
  };
  Slick.prototype.addSlide = Slick.prototype.slickAdd = function(markup, index, addBefore) {
    var _ = this;
    if (typeof(index) === 'boolean') {
      addBefore = index;
      index = null;
    } else if (index < 0 || (index >= _.slideCount)) {
      return false;
    }
    _.unload();
    if (typeof(index) === 'number') {
      if (index === 0 && _.$slides.length === 0) {
        $(markup).appendTo(_.$slideTrack);
      } else if (addBefore) {
        $(markup).insertBefore(_.$slides.eq(index));
      } else {
        $(markup).insertAfter(_.$slides.eq(index));
      }
    } else {
      if (addBefore === true) {
        $(markup).prependTo(_.$slideTrack);
      } else {
        $(markup).appendTo(_.$slideTrack);
      }
    }
    _.$slides = _.$slideTrack.children(this.options.slide);
    _.$slideTrack.children(this.options.slide).detach();
    _.$slideTrack.append(_.$slides);
    _.$slides.each(function(index, element) {
      $(element).attr('data-slick-index', index);
    });
    _.$slidesCache = _.$slides;
    _.reinit();
  };
  Slick.prototype.animateHeight = function() {
    var _ = this;
    if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
      var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
      _.$list.animate({height: targetHeight}, _.options.speed);
    }
  };
  Slick.prototype.animateSlide = function(targetLeft, callback) {
    var animProps = {},
        _ = this;
    _.animateHeight();
    if (_.options.rtl === true && _.options.vertical === false) {
      targetLeft = -targetLeft;
    }
    if (_.transformsEnabled === false) {
      if (_.options.vertical === false) {
        _.$slideTrack.animate({left: targetLeft}, _.options.speed, _.options.easing, callback);
      } else {
        _.$slideTrack.animate({top: targetLeft}, _.options.speed, _.options.easing, callback);
      }
    } else {
      if (_.cssTransitions === false) {
        if (_.options.rtl === true) {
          _.currentLeft = -(_.currentLeft);
        }
        $({animStart: _.currentLeft}).animate({animStart: targetLeft}, {
          duration: _.options.speed,
          easing: _.options.easing,
          step: function(now) {
            now = Math.ceil(now);
            if (_.options.vertical === false) {
              animProps[_.animType] = 'translate(' + now + 'px, 0px)';
              _.$slideTrack.css(animProps);
            } else {
              animProps[_.animType] = 'translate(0px,' + now + 'px)';
              _.$slideTrack.css(animProps);
            }
          },
          complete: function() {
            if (callback) {
              callback.call();
            }
          }
        });
      } else {
        _.applyTransition();
        targetLeft = Math.ceil(targetLeft);
        if (_.options.vertical === false) {
          animProps[_.animType] = 'translate3d(' + targetLeft + 'px, 0px, 0px)';
        } else {
          animProps[_.animType] = 'translate3d(0px,' + targetLeft + 'px, 0px)';
        }
        _.$slideTrack.css(animProps);
        if (callback) {
          setTimeout(function() {
            _.disableTransition();
            callback.call();
          }, _.options.speed);
        }
      }
    }
  };
  Slick.prototype.getNavTarget = function() {
    var _ = this,
        asNavFor = _.options.asNavFor;
    if (asNavFor && asNavFor !== null) {
      asNavFor = $(asNavFor).not(_.$slider);
    }
    return asNavFor;
  };
  Slick.prototype.asNavFor = function(index) {
    var _ = this,
        asNavFor = _.getNavTarget();
    if (asNavFor !== null && typeof asNavFor === 'object') {
      asNavFor.each(function() {
        var target = $(this).slick('getSlick');
        if (!target.unslicked) {
          target.slideHandler(index, true);
        }
      });
    }
  };
  Slick.prototype.applyTransition = function(slide) {
    var _ = this,
        transition = {};
    if (_.options.fade === false) {
      transition[_.transitionType] = _.transformType + ' ' + _.options.speed + 'ms ' + _.options.cssEase;
    } else {
      transition[_.transitionType] = 'opacity ' + _.options.speed + 'ms ' + _.options.cssEase;
    }
    if (_.options.fade === false) {
      _.$slideTrack.css(transition);
    } else {
      _.$slides.eq(slide).css(transition);
    }
  };
  Slick.prototype.autoPlay = function() {
    var _ = this;
    _.autoPlayClear();
    if (_.slideCount > _.options.slidesToShow) {
      _.autoPlayTimer = setInterval(_.autoPlayIterator, _.options.autoplaySpeed);
    }
  };
  Slick.prototype.autoPlayClear = function() {
    var _ = this;
    if (_.autoPlayTimer) {
      clearInterval(_.autoPlayTimer);
    }
  };
  Slick.prototype.autoPlayIterator = function() {
    var _ = this,
        slideTo = _.currentSlide + _.options.slidesToScroll;
    if (!_.paused && !_.interrupted && !_.focussed) {
      if (_.options.infinite === false) {
        if (_.direction === 1 && (_.currentSlide + 1) === (_.slideCount - 1)) {
          _.direction = 0;
        } else if (_.direction === 0) {
          slideTo = _.currentSlide - _.options.slidesToScroll;
          if (_.currentSlide - 1 === 0) {
            _.direction = 1;
          }
        }
      }
      _.slideHandler(slideTo);
    }
  };
  Slick.prototype.buildArrows = function() {
    var _ = this;
    if (_.options.arrows === true) {
      _.$prevArrow = $(_.options.prevArrow).addClass('slick-arrow');
      _.$nextArrow = $(_.options.nextArrow).addClass('slick-arrow');
      if (_.slideCount > _.options.slidesToShow) {
        _.$prevArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');
        _.$nextArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');
        if (_.htmlExpr.test(_.options.prevArrow)) {
          _.$prevArrow.prependTo(_.options.appendArrows);
        }
        if (_.htmlExpr.test(_.options.nextArrow)) {
          _.$nextArrow.appendTo(_.options.appendArrows);
        }
        if (_.options.infinite !== true) {
          _.$prevArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
        }
      } else {
        _.$prevArrow.add(_.$nextArrow).addClass('slick-hidden').attr({
          'aria-disabled': 'true',
          'tabindex': '-1'
        });
      }
    }
  };
  Slick.prototype.buildDots = function() {
    var _ = this,
        i,
        dot;
    if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
      _.$slider.addClass('slick-dotted');
      dot = $('<ul />').addClass(_.options.dotsClass);
      for (i = 0; i <= _.getDotCount(); i += 1) {
        dot.append($('<li />').append(_.options.customPaging.call(this, _, i)));
      }
      _.$dots = dot.appendTo(_.options.appendDots);
      _.$dots.find('li').first().addClass('slick-active');
    }
  };
  Slick.prototype.buildOut = function() {
    var _ = this;
    _.$slides = _.$slider.children(_.options.slide + ':not(.slick-cloned)').addClass('slick-slide');
    _.slideCount = _.$slides.length;
    _.$slides.each(function(index, element) {
      $(element).attr('data-slick-index', index).data('originalStyling', $(element).attr('style') || '');
    });
    _.$slider.addClass('slick-slider');
    _.$slideTrack = (_.slideCount === 0) ? $('<div class="slick-track"/>').appendTo(_.$slider) : _.$slides.wrapAll('<div class="slick-track"/>').parent();
    _.$list = _.$slideTrack.wrap('<div class="slick-list"/>').parent();
    _.$slideTrack.css('opacity', 0);
    if (_.options.centerMode === true || _.options.swipeToSlide === true) {
      _.options.slidesToScroll = 1;
    }
    $('img[data-lazy]', _.$slider).not('[src]').addClass('slick-loading');
    _.setupInfinite();
    _.buildArrows();
    _.buildDots();
    _.updateDots();
    _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);
    if (_.options.draggable === true) {
      _.$list.addClass('draggable');
    }
  };
  Slick.prototype.buildRows = function() {
    var _ = this,
        a,
        b,
        c,
        newSlides,
        numOfSlides,
        originalSlides,
        slidesPerSection;
    newSlides = document.createDocumentFragment();
    originalSlides = _.$slider.children();
    if (_.options.rows > 0) {
      slidesPerSection = _.options.slidesPerRow * _.options.rows;
      numOfSlides = Math.ceil(originalSlides.length / slidesPerSection);
      for (a = 0; a < numOfSlides; a++) {
        var slide = document.createElement('div');
        for (b = 0; b < _.options.rows; b++) {
          var row = document.createElement('div');
          for (c = 0; c < _.options.slidesPerRow; c++) {
            var target = (a * slidesPerSection + ((b * _.options.slidesPerRow) + c));
            if (originalSlides.get(target)) {
              row.appendChild(originalSlides.get(target));
            }
          }
          slide.appendChild(row);
        }
        newSlides.appendChild(slide);
      }
      _.$slider.empty().append(newSlides);
      _.$slider.children().children().children().css({
        'width': (100 / _.options.slidesPerRow) + '%',
        'display': 'inline-block'
      });
    }
  };
  Slick.prototype.checkResponsive = function(initial, forceUpdate) {
    var _ = this,
        breakpoint,
        targetBreakpoint,
        respondToWidth,
        triggerBreakpoint = false;
    var sliderWidth = _.$slider.width();
    var windowWidth = window.innerWidth || $(window).width();
    if (_.respondTo === 'window') {
      respondToWidth = windowWidth;
    } else if (_.respondTo === 'slider') {
      respondToWidth = sliderWidth;
    } else if (_.respondTo === 'min') {
      respondToWidth = Math.min(windowWidth, sliderWidth);
    }
    if (_.options.responsive && _.options.responsive.length && _.options.responsive !== null) {
      targetBreakpoint = null;
      for (breakpoint in _.breakpoints) {
        if (_.breakpoints.hasOwnProperty(breakpoint)) {
          if (_.originalSettings.mobileFirst === false) {
            if (respondToWidth < _.breakpoints[breakpoint]) {
              targetBreakpoint = _.breakpoints[breakpoint];
            }
          } else {
            if (respondToWidth > _.breakpoints[breakpoint]) {
              targetBreakpoint = _.breakpoints[breakpoint];
            }
          }
        }
      }
      if (targetBreakpoint !== null) {
        if (_.activeBreakpoint !== null) {
          if (targetBreakpoint !== _.activeBreakpoint || forceUpdate) {
            _.activeBreakpoint = targetBreakpoint;
            if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
              _.unslick(targetBreakpoint);
            } else {
              _.options = $.extend({}, _.originalSettings, _.breakpointSettings[targetBreakpoint]);
              if (initial === true) {
                _.currentSlide = _.options.initialSlide;
              }
              _.refresh(initial);
            }
            triggerBreakpoint = targetBreakpoint;
          }
        } else {
          _.activeBreakpoint = targetBreakpoint;
          if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
            _.unslick(targetBreakpoint);
          } else {
            _.options = $.extend({}, _.originalSettings, _.breakpointSettings[targetBreakpoint]);
            if (initial === true) {
              _.currentSlide = _.options.initialSlide;
            }
            _.refresh(initial);
          }
          triggerBreakpoint = targetBreakpoint;
        }
      } else {
        if (_.activeBreakpoint !== null) {
          _.activeBreakpoint = null;
          _.options = _.originalSettings;
          if (initial === true) {
            _.currentSlide = _.options.initialSlide;
          }
          _.refresh(initial);
          triggerBreakpoint = targetBreakpoint;
        }
      }
      if (!initial && triggerBreakpoint !== false) {
        _.$slider.trigger('breakpoint', [_, triggerBreakpoint]);
      }
    }
  };
  Slick.prototype.changeSlide = function(event, dontAnimate) {
    var _ = this,
        $target = $(event.currentTarget),
        indexOffset,
        slideOffset,
        unevenOffset;
    if ($target.is('a')) {
      event.preventDefault();
    }
    if (!$target.is('li')) {
      $target = $target.closest('li');
    }
    unevenOffset = (_.slideCount % _.options.slidesToScroll !== 0);
    indexOffset = unevenOffset ? 0 : (_.slideCount - _.currentSlide) % _.options.slidesToScroll;
    switch (event.data.message) {
      case 'previous':
        slideOffset = indexOffset === 0 ? _.options.slidesToScroll : _.options.slidesToShow - indexOffset;
        if (_.slideCount > _.options.slidesToShow) {
          _.slideHandler(_.currentSlide - slideOffset, false, dontAnimate);
        }
        break;
      case 'next':
        slideOffset = indexOffset === 0 ? _.options.slidesToScroll : indexOffset;
        if (_.slideCount > _.options.slidesToShow) {
          _.slideHandler(_.currentSlide + slideOffset, false, dontAnimate);
        }
        break;
      case 'index':
        var index = event.data.index === 0 ? 0 : event.data.index || $target.index() * _.options.slidesToScroll;
        _.slideHandler(_.checkNavigable(index), false, dontAnimate);
        $target.children().trigger('focus');
        break;
      default:
        return;
    }
  };
  Slick.prototype.checkNavigable = function(index) {
    var _ = this,
        navigables,
        prevNavigable;
    navigables = _.getNavigableIndexes();
    prevNavigable = 0;
    if (index > navigables[navigables.length - 1]) {
      index = navigables[navigables.length - 1];
    } else {
      for (var n in navigables) {
        if (index < navigables[n]) {
          index = prevNavigable;
          break;
        }
        prevNavigable = navigables[n];
      }
    }
    return index;
  };
  Slick.prototype.cleanUpEvents = function() {
    var _ = this;
    if (_.options.dots && _.$dots !== null) {
      $('li', _.$dots).off('click.slick', _.changeSlide).off('mouseenter.slick', $.proxy(_.interrupt, _, true)).off('mouseleave.slick', $.proxy(_.interrupt, _, false));
      if (_.options.accessibility === true) {
        _.$dots.off('keydown.slick', _.keyHandler);
      }
    }
    _.$slider.off('focus.slick blur.slick');
    if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
      _.$prevArrow && _.$prevArrow.off('click.slick', _.changeSlide);
      _.$nextArrow && _.$nextArrow.off('click.slick', _.changeSlide);
      if (_.options.accessibility === true) {
        _.$prevArrow && _.$prevArrow.off('keydown.slick', _.keyHandler);
        _.$nextArrow && _.$nextArrow.off('keydown.slick', _.keyHandler);
      }
    }
    _.$list.off('touchstart.slick mousedown.slick', _.swipeHandler);
    _.$list.off('touchmove.slick mousemove.slick', _.swipeHandler);
    _.$list.off('touchend.slick mouseup.slick', _.swipeHandler);
    _.$list.off('touchcancel.slick mouseleave.slick', _.swipeHandler);
    _.$list.off('click.slick', _.clickHandler);
    $(document).off(_.visibilityChange, _.visibility);
    _.cleanUpSlideEvents();
    if (_.options.accessibility === true) {
      _.$list.off('keydown.slick', _.keyHandler);
    }
    if (_.options.focusOnSelect === true) {
      $(_.$slideTrack).children().off('click.slick', _.selectHandler);
    }
    $(window).off('orientationchange.slick.slick-' + _.instanceUid, _.orientationChange);
    $(window).off('resize.slick.slick-' + _.instanceUid, _.resize);
    $('[draggable!=true]', _.$slideTrack).off('dragstart', _.preventDefault);
    $(window).off('load.slick.slick-' + _.instanceUid, _.setPosition);
  };
  Slick.prototype.cleanUpSlideEvents = function() {
    var _ = this;
    _.$list.off('mouseenter.slick', $.proxy(_.interrupt, _, true));
    _.$list.off('mouseleave.slick', $.proxy(_.interrupt, _, false));
  };
  Slick.prototype.cleanUpRows = function() {
    var _ = this,
        originalSlides;
    if (_.options.rows > 0) {
      originalSlides = _.$slides.children().children();
      originalSlides.removeAttr('style');
      _.$slider.empty().append(originalSlides);
    }
  };
  Slick.prototype.clickHandler = function(event) {
    var _ = this;
    if (_.shouldClick === false) {
      event.stopImmediatePropagation();
      event.stopPropagation();
      event.preventDefault();
    }
  };
  Slick.prototype.destroy = function(refresh) {
    var _ = this;
    _.autoPlayClear();
    _.touchObject = {};
    _.cleanUpEvents();
    $('.slick-cloned', _.$slider).detach();
    if (_.$dots) {
      _.$dots.remove();
    }
    if (_.$prevArrow && _.$prevArrow.length) {
      _.$prevArrow.removeClass('slick-disabled slick-arrow slick-hidden').removeAttr('aria-hidden aria-disabled tabindex').css('display', '');
      if (_.htmlExpr.test(_.options.prevArrow)) {
        _.$prevArrow.remove();
      }
    }
    if (_.$nextArrow && _.$nextArrow.length) {
      _.$nextArrow.removeClass('slick-disabled slick-arrow slick-hidden').removeAttr('aria-hidden aria-disabled tabindex').css('display', '');
      if (_.htmlExpr.test(_.options.nextArrow)) {
        _.$nextArrow.remove();
      }
    }
    if (_.$slides) {
      _.$slides.removeClass('slick-slide slick-active slick-center slick-visible slick-current').removeAttr('aria-hidden').removeAttr('data-slick-index').each(function() {
        $(this).attr('style', $(this).data('originalStyling'));
      });
      _.$slideTrack.children(this.options.slide).detach();
      _.$slideTrack.detach();
      _.$list.detach();
      _.$slider.append(_.$slides);
    }
    _.cleanUpRows();
    _.$slider.removeClass('slick-slider');
    _.$slider.removeClass('slick-initialized');
    _.$slider.removeClass('slick-dotted');
    _.unslicked = true;
    if (!refresh) {
      _.$slider.trigger('destroy', [_]);
    }
  };
  Slick.prototype.disableTransition = function(slide) {
    var _ = this,
        transition = {};
    transition[_.transitionType] = '';
    if (_.options.fade === false) {
      _.$slideTrack.css(transition);
    } else {
      _.$slides.eq(slide).css(transition);
    }
  };
  Slick.prototype.fadeSlide = function(slideIndex, callback) {
    var _ = this;
    if (_.cssTransitions === false) {
      _.$slides.eq(slideIndex).css({zIndex: _.options.zIndex});
      _.$slides.eq(slideIndex).animate({opacity: 1}, _.options.speed, _.options.easing, callback);
    } else {
      _.applyTransition(slideIndex);
      _.$slides.eq(slideIndex).css({
        opacity: 1,
        zIndex: _.options.zIndex
      });
      if (callback) {
        setTimeout(function() {
          _.disableTransition(slideIndex);
          callback.call();
        }, _.options.speed);
      }
    }
  };
  Slick.prototype.fadeSlideOut = function(slideIndex) {
    var _ = this;
    if (_.cssTransitions === false) {
      _.$slides.eq(slideIndex).animate({
        opacity: 0,
        zIndex: _.options.zIndex - 2
      }, _.options.speed, _.options.easing);
    } else {
      _.applyTransition(slideIndex);
      _.$slides.eq(slideIndex).css({
        opacity: 0,
        zIndex: _.options.zIndex - 2
      });
    }
  };
  Slick.prototype.filterSlides = Slick.prototype.slickFilter = function(filter) {
    var _ = this;
    if (filter !== null) {
      _.$slidesCache = _.$slides;
      _.unload();
      _.$slideTrack.children(this.options.slide).detach();
      _.$slidesCache.filter(filter).appendTo(_.$slideTrack);
      _.reinit();
    }
  };
  Slick.prototype.focusHandler = function() {
    var _ = this;
    _.$slider.off('focus.slick blur.slick').on('focus.slick blur.slick', '*', function(event) {
      event.stopImmediatePropagation();
      var $sf = $(this);
      setTimeout(function() {
        if (_.options.pauseOnFocus) {
          _.focussed = $sf.is(':focus');
          _.autoPlay();
        }
      }, 0);
    });
  };
  Slick.prototype.getCurrent = Slick.prototype.slickCurrentSlide = function() {
    var _ = this;
    return _.currentSlide;
  };
  Slick.prototype.getDotCount = function() {
    var _ = this;
    var breakPoint = 0;
    var counter = 0;
    var pagerQty = 0;
    if (_.options.infinite === true) {
      if (_.slideCount <= _.options.slidesToShow) {
        ++pagerQty;
      } else {
        while (breakPoint < _.slideCount) {
          ++pagerQty;
          breakPoint = counter + _.options.slidesToScroll;
          counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
        }
      }
    } else if (_.options.centerMode === true) {
      pagerQty = _.slideCount;
    } else if (!_.options.asNavFor) {
      pagerQty = 1 + Math.ceil((_.slideCount - _.options.slidesToShow) / _.options.slidesToScroll);
    } else {
      while (breakPoint < _.slideCount) {
        ++pagerQty;
        breakPoint = counter + _.options.slidesToScroll;
        counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
      }
    }
    return pagerQty - 1;
  };
  Slick.prototype.getLeft = function(slideIndex) {
    var _ = this,
        targetLeft,
        verticalHeight,
        verticalOffset = 0,
        targetSlide,
        coef;
    _.slideOffset = 0;
    verticalHeight = _.$slides.first().outerHeight(true);
    if (_.options.infinite === true) {
      if (_.slideCount > _.options.slidesToShow) {
        _.slideOffset = (_.slideWidth * _.options.slidesToShow) * -1;
        coef = -1;
        if (_.options.vertical === true && _.options.centerMode === true) {
          if (_.options.slidesToShow === 2) {
            coef = -1.5;
          } else if (_.options.slidesToShow === 1) {
            coef = -2;
          }
        }
        verticalOffset = (verticalHeight * _.options.slidesToShow) * coef;
      }
      if (_.slideCount % _.options.slidesToScroll !== 0) {
        if (slideIndex + _.options.slidesToScroll > _.slideCount && _.slideCount > _.options.slidesToShow) {
          if (slideIndex > _.slideCount) {
            _.slideOffset = ((_.options.slidesToShow - (slideIndex - _.slideCount)) * _.slideWidth) * -1;
            verticalOffset = ((_.options.slidesToShow - (slideIndex - _.slideCount)) * verticalHeight) * -1;
          } else {
            _.slideOffset = ((_.slideCount % _.options.slidesToScroll) * _.slideWidth) * -1;
            verticalOffset = ((_.slideCount % _.options.slidesToScroll) * verticalHeight) * -1;
          }
        }
      }
    } else {
      if (slideIndex + _.options.slidesToShow > _.slideCount) {
        _.slideOffset = ((slideIndex + _.options.slidesToShow) - _.slideCount) * _.slideWidth;
        verticalOffset = ((slideIndex + _.options.slidesToShow) - _.slideCount) * verticalHeight;
      }
    }
    if (_.slideCount <= _.options.slidesToShow) {
      _.slideOffset = 0;
      verticalOffset = 0;
    }
    if (_.options.centerMode === true && _.slideCount <= _.options.slidesToShow) {
      _.slideOffset = ((_.slideWidth * Math.floor(_.options.slidesToShow)) / 2) - ((_.slideWidth * _.slideCount) / 2);
    } else if (_.options.centerMode === true && _.options.infinite === true) {
      _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2) - _.slideWidth;
    } else if (_.options.centerMode === true) {
      _.slideOffset = 0;
      _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2);
    }
    if (_.options.vertical === false) {
      targetLeft = ((slideIndex * _.slideWidth) * -1) + _.slideOffset;
    } else {
      targetLeft = ((slideIndex * verticalHeight) * -1) + verticalOffset;
    }
    if (_.options.variableWidth === true) {
      if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
        targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
      } else {
        targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow);
      }
      if (_.options.rtl === true) {
        if (targetSlide[0]) {
          targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
        } else {
          targetLeft = 0;
        }
      } else {
        targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
      }
      if (_.options.centerMode === true) {
        if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
          targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
        } else {
          targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow + 1);
        }
        if (_.options.rtl === true) {
          if (targetSlide[0]) {
            targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
          } else {
            targetLeft = 0;
          }
        } else {
          targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
        }
        targetLeft += (_.$list.width() - targetSlide.outerWidth()) / 2;
      }
    }
    return targetLeft;
  };
  Slick.prototype.getOption = Slick.prototype.slickGetOption = function(option) {
    var _ = this;
    return _.options[option];
  };
  Slick.prototype.getNavigableIndexes = function() {
    var _ = this,
        breakPoint = 0,
        counter = 0,
        indexes = [],
        max;
    if (_.options.infinite === false) {
      max = _.slideCount;
    } else {
      breakPoint = _.options.slidesToScroll * -1;
      counter = _.options.slidesToScroll * -1;
      max = _.slideCount * 2;
    }
    while (breakPoint < max) {
      indexes.push(breakPoint);
      breakPoint = counter + _.options.slidesToScroll;
      counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
    }
    return indexes;
  };
  Slick.prototype.getSlick = function() {
    return this;
  };
  Slick.prototype.getSlideCount = function() {
    var _ = this,
        slidesTraversed,
        swipedSlide,
        centerOffset;
    centerOffset = _.options.centerMode === true ? _.slideWidth * Math.floor(_.options.slidesToShow / 2) : 0;
    if (_.options.swipeToSlide === true) {
      _.$slideTrack.find('.slick-slide').each(function(index, slide) {
        if (slide.offsetLeft - centerOffset + ($(slide).outerWidth() / 2) > (_.swipeLeft * -1)) {
          swipedSlide = slide;
          return false;
        }
      });
      slidesTraversed = Math.abs($(swipedSlide).attr('data-slick-index') - _.currentSlide) || 1;
      return slidesTraversed;
    } else {
      return _.options.slidesToScroll;
    }
  };
  Slick.prototype.goTo = Slick.prototype.slickGoTo = function(slide, dontAnimate) {
    var _ = this;
    _.changeSlide({data: {
        message: 'index',
        index: parseInt(slide)
      }}, dontAnimate);
  };
  Slick.prototype.init = function(creation) {
    var _ = this;
    if (!$(_.$slider).hasClass('slick-initialized')) {
      $(_.$slider).addClass('slick-initialized');
      _.buildRows();
      _.buildOut();
      _.setProps();
      _.startLoad();
      _.loadSlider();
      _.initializeEvents();
      _.updateArrows();
      _.updateDots();
      _.checkResponsive(true);
      _.focusHandler();
    }
    if (creation) {
      _.$slider.trigger('init', [_]);
    }
    if (_.options.accessibility === true) {
      _.initADA();
    }
    if (_.options.autoplay) {
      _.paused = false;
      _.autoPlay();
    }
  };
  Slick.prototype.initADA = function() {
    var _ = this,
        numDotGroups = Math.ceil(_.slideCount / _.options.slidesToShow),
        tabControlIndexes = _.getNavigableIndexes().filter(function(val) {
          return (val >= 0) && (val < _.slideCount);
        });
    _.$slides.add(_.$slideTrack.find('.slick-cloned')).attr({
      'aria-hidden': 'true',
      'tabindex': '-1'
    }).find('a, input, button, select').attr({'tabindex': '-1'});
    if (_.$dots !== null) {
      _.$slides.not(_.$slideTrack.find('.slick-cloned')).each(function(i) {
        var slideControlIndex = tabControlIndexes.indexOf(i);
        $(this).attr({
          'role': 'tabpanel',
          'id': 'slick-slide' + _.instanceUid + i,
          'tabindex': -1
        });
        if (slideControlIndex !== -1) {
          var ariaButtonControl = 'slick-slide-control' + _.instanceUid + slideControlIndex;
          if ($('#' + ariaButtonControl).length) {
            $(this).attr({'aria-describedby': ariaButtonControl});
          }
        }
      });
      _.$dots.attr('role', 'tablist').find('li').each(function(i) {
        var mappedSlideIndex = tabControlIndexes[i];
        $(this).attr({'role': 'presentation'});
        $(this).find('button').first().attr({
          'role': 'tab',
          'id': 'slick-slide-control' + _.instanceUid + i,
          'aria-controls': 'slick-slide' + _.instanceUid + mappedSlideIndex,
          'aria-label': (i + 1) + ' of ' + numDotGroups,
          'aria-selected': null,
          'tabindex': '-1'
        });
      }).eq(_.currentSlide).find('button').attr({
        'aria-selected': 'true',
        'tabindex': '0'
      }).end();
    }
    for (var i = _.currentSlide,
        max = i + _.options.slidesToShow; i < max; i++) {
      if (_.options.focusOnChange) {
        _.$slides.eq(i).attr({'tabindex': '0'});
      } else {
        _.$slides.eq(i).removeAttr('tabindex');
      }
    }
    _.activateADA();
  };
  Slick.prototype.initArrowEvents = function() {
    var _ = this;
    if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
      _.$prevArrow.off('click.slick').on('click.slick', {message: 'previous'}, _.changeSlide);
      _.$nextArrow.off('click.slick').on('click.slick', {message: 'next'}, _.changeSlide);
      if (_.options.accessibility === true) {
        _.$prevArrow.on('keydown.slick', _.keyHandler);
        _.$nextArrow.on('keydown.slick', _.keyHandler);
      }
    }
  };
  Slick.prototype.initDotEvents = function() {
    var _ = this;
    if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
      $('li', _.$dots).on('click.slick', {message: 'index'}, _.changeSlide);
      if (_.options.accessibility === true) {
        _.$dots.on('keydown.slick', _.keyHandler);
      }
    }
    if (_.options.dots === true && _.options.pauseOnDotsHover === true && _.slideCount > _.options.slidesToShow) {
      $('li', _.$dots).on('mouseenter.slick', $.proxy(_.interrupt, _, true)).on('mouseleave.slick', $.proxy(_.interrupt, _, false));
    }
  };
  Slick.prototype.initSlideEvents = function() {
    var _ = this;
    if (_.options.pauseOnHover) {
      _.$list.on('mouseenter.slick', $.proxy(_.interrupt, _, true));
      _.$list.on('mouseleave.slick', $.proxy(_.interrupt, _, false));
    }
  };
  Slick.prototype.initializeEvents = function() {
    var _ = this;
    _.initArrowEvents();
    _.initDotEvents();
    _.initSlideEvents();
    _.$list.on('touchstart.slick mousedown.slick', {action: 'start'}, _.swipeHandler);
    _.$list.on('touchmove.slick mousemove.slick', {action: 'move'}, _.swipeHandler);
    _.$list.on('touchend.slick mouseup.slick', {action: 'end'}, _.swipeHandler);
    _.$list.on('touchcancel.slick mouseleave.slick', {action: 'end'}, _.swipeHandler);
    _.$list.on('click.slick', _.clickHandler);
    $(document).on(_.visibilityChange, $.proxy(_.visibility, _));
    if (_.options.accessibility === true) {
      _.$list.on('keydown.slick', _.keyHandler);
    }
    if (_.options.focusOnSelect === true) {
      $(_.$slideTrack).children().on('click.slick', _.selectHandler);
    }
    $(window).on('orientationchange.slick.slick-' + _.instanceUid, $.proxy(_.orientationChange, _));
    $(window).on('resize.slick.slick-' + _.instanceUid, $.proxy(_.resize, _));
    $('[draggable!=true]', _.$slideTrack).on('dragstart', _.preventDefault);
    $(window).on('load.slick.slick-' + _.instanceUid, _.setPosition);
    $(_.setPosition);
  };
  Slick.prototype.initUI = function() {
    var _ = this;
    if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
      _.$prevArrow.show();
      _.$nextArrow.show();
    }
    if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
      _.$dots.show();
    }
  };
  Slick.prototype.keyHandler = function(event) {
    var _ = this;
    if (!event.target.tagName.match('TEXTAREA|INPUT|SELECT')) {
      if (event.keyCode === 37 && _.options.accessibility === true) {
        _.changeSlide({data: {message: _.options.rtl === true ? 'next' : 'previous'}});
      } else if (event.keyCode === 39 && _.options.accessibility === true) {
        _.changeSlide({data: {message: _.options.rtl === true ? 'previous' : 'next'}});
      }
    }
  };
  Slick.prototype.lazyLoad = function() {
    var _ = this,
        loadRange,
        cloneRange,
        rangeStart,
        rangeEnd;
    function loadImages(imagesScope) {
      $('img[data-lazy]', imagesScope).each(function() {
        var image = $(this),
            imageSource = $(this).attr('data-lazy'),
            imageSrcSet = $(this).attr('data-srcset'),
            imageSizes = $(this).attr('data-sizes') || _.$slider.attr('data-sizes'),
            imageToLoad = document.createElement('img');
        imageToLoad.onload = function() {
          image.animate({opacity: 0}, 100, function() {
            if (imageSrcSet) {
              image.attr('srcset', imageSrcSet);
              if (imageSizes) {
                image.attr('sizes', imageSizes);
              }
            }
            image.attr('src', imageSource).animate({opacity: 1}, 200, function() {
              image.removeAttr('data-lazy data-srcset data-sizes').removeClass('slick-loading');
            });
            _.$slider.trigger('lazyLoaded', [_, image, imageSource]);
          });
        };
        imageToLoad.onerror = function() {
          image.removeAttr('data-lazy').removeClass('slick-loading').addClass('slick-lazyload-error');
          _.$slider.trigger('lazyLoadError', [_, image, imageSource]);
        };
        imageToLoad.src = imageSource;
      });
    }
    if (_.options.centerMode === true) {
      if (_.options.infinite === true) {
        rangeStart = _.currentSlide + (_.options.slidesToShow / 2 + 1);
        rangeEnd = rangeStart + _.options.slidesToShow + 2;
      } else {
        rangeStart = Math.max(0, _.currentSlide - (_.options.slidesToShow / 2 + 1));
        rangeEnd = 2 + (_.options.slidesToShow / 2 + 1) + _.currentSlide;
      }
    } else {
      rangeStart = _.options.infinite ? _.options.slidesToShow + _.currentSlide : _.currentSlide;
      rangeEnd = Math.ceil(rangeStart + _.options.slidesToShow);
      if (_.options.fade === true) {
        if (rangeStart > 0)
          rangeStart--;
        if (rangeEnd <= _.slideCount)
          rangeEnd++;
      }
    }
    loadRange = _.$slider.find('.slick-slide').slice(rangeStart, rangeEnd);
    if (_.options.lazyLoad === 'anticipated') {
      var prevSlide = rangeStart - 1,
          nextSlide = rangeEnd,
          $slides = _.$slider.find('.slick-slide');
      for (var i = 0; i < _.options.slidesToScroll; i++) {
        if (prevSlide < 0)
          prevSlide = _.slideCount - 1;
        loadRange = loadRange.add($slides.eq(prevSlide));
        loadRange = loadRange.add($slides.eq(nextSlide));
        prevSlide--;
        nextSlide++;
      }
    }
    loadImages(loadRange);
    if (_.slideCount <= _.options.slidesToShow) {
      cloneRange = _.$slider.find('.slick-slide');
      loadImages(cloneRange);
    } else if (_.currentSlide >= _.slideCount - _.options.slidesToShow) {
      cloneRange = _.$slider.find('.slick-cloned').slice(0, _.options.slidesToShow);
      loadImages(cloneRange);
    } else if (_.currentSlide === 0) {
      cloneRange = _.$slider.find('.slick-cloned').slice(_.options.slidesToShow * -1);
      loadImages(cloneRange);
    }
  };
  Slick.prototype.loadSlider = function() {
    var _ = this;
    _.setPosition();
    _.$slideTrack.css({opacity: 1});
    _.$slider.removeClass('slick-loading');
    _.initUI();
    if (_.options.lazyLoad === 'progressive') {
      _.progressiveLazyLoad();
    }
  };
  Slick.prototype.next = Slick.prototype.slickNext = function() {
    var _ = this;
    _.changeSlide({data: {message: 'next'}});
  };
  Slick.prototype.orientationChange = function() {
    var _ = this;
    _.checkResponsive();
    _.setPosition();
  };
  Slick.prototype.pause = Slick.prototype.slickPause = function() {
    var _ = this;
    _.autoPlayClear();
    _.paused = true;
  };
  Slick.prototype.play = Slick.prototype.slickPlay = function() {
    var _ = this;
    _.autoPlay();
    _.options.autoplay = true;
    _.paused = false;
    _.focussed = false;
    _.interrupted = false;
  };
  Slick.prototype.postSlide = function(index) {
    var _ = this;
    if (!_.unslicked) {
      _.$slider.trigger('afterChange', [_, index]);
      _.animating = false;
      if (_.slideCount > _.options.slidesToShow) {
        _.setPosition();
      }
      _.swipeLeft = null;
      if (_.options.autoplay) {
        _.autoPlay();
      }
      if (_.options.accessibility === true) {
        _.initADA();
        if (_.options.focusOnChange) {
          var $currentSlide = $(_.$slides.get(_.currentSlide));
          $currentSlide.attr('tabindex', 0).focus();
        }
      }
    }
  };
  Slick.prototype.prev = Slick.prototype.slickPrev = function() {
    var _ = this;
    _.changeSlide({data: {message: 'previous'}});
  };
  Slick.prototype.preventDefault = function(event) {
    event.preventDefault();
  };
  Slick.prototype.progressiveLazyLoad = function(tryCount) {
    tryCount = tryCount || 1;
    var _ = this,
        $imgsToLoad = $('img[data-lazy]', _.$slider),
        image,
        imageSource,
        imageSrcSet,
        imageSizes,
        imageToLoad;
    if ($imgsToLoad.length) {
      image = $imgsToLoad.first();
      imageSource = image.attr('data-lazy');
      imageSrcSet = image.attr('data-srcset');
      imageSizes = image.attr('data-sizes') || _.$slider.attr('data-sizes');
      imageToLoad = document.createElement('img');
      imageToLoad.onload = function() {
        if (imageSrcSet) {
          image.attr('srcset', imageSrcSet);
          if (imageSizes) {
            image.attr('sizes', imageSizes);
          }
        }
        image.attr('src', imageSource).removeAttr('data-lazy data-srcset data-sizes').removeClass('slick-loading');
        if (_.options.adaptiveHeight === true) {
          _.setPosition();
        }
        _.$slider.trigger('lazyLoaded', [_, image, imageSource]);
        _.progressiveLazyLoad();
      };
      imageToLoad.onerror = function() {
        if (tryCount < 3) {
          setTimeout(function() {
            _.progressiveLazyLoad(tryCount + 1);
          }, 500);
        } else {
          image.removeAttr('data-lazy').removeClass('slick-loading').addClass('slick-lazyload-error');
          _.$slider.trigger('lazyLoadError', [_, image, imageSource]);
          _.progressiveLazyLoad();
        }
      };
      imageToLoad.src = imageSource;
    } else {
      _.$slider.trigger('allImagesLoaded', [_]);
    }
  };
  Slick.prototype.refresh = function(initializing) {
    var _ = this,
        currentSlide,
        lastVisibleIndex;
    lastVisibleIndex = _.slideCount - _.options.slidesToShow;
    if (!_.options.infinite && (_.currentSlide > lastVisibleIndex)) {
      _.currentSlide = lastVisibleIndex;
    }
    if (_.slideCount <= _.options.slidesToShow) {
      _.currentSlide = 0;
    }
    currentSlide = _.currentSlide;
    _.destroy(true);
    $.extend(_, _.initials, {currentSlide: currentSlide});
    _.init();
    if (!initializing) {
      _.changeSlide({data: {
          message: 'index',
          index: currentSlide
        }}, false);
    }
  };
  Slick.prototype.registerBreakpoints = function() {
    var _ = this,
        breakpoint,
        currentBreakpoint,
        l,
        responsiveSettings = _.options.responsive || null;
    if ($.type(responsiveSettings) === 'array' && responsiveSettings.length) {
      _.respondTo = _.options.respondTo || 'window';
      for (breakpoint in responsiveSettings) {
        l = _.breakpoints.length - 1;
        if (responsiveSettings.hasOwnProperty(breakpoint)) {
          currentBreakpoint = responsiveSettings[breakpoint].breakpoint;
          while (l >= 0) {
            if (_.breakpoints[l] && _.breakpoints[l] === currentBreakpoint) {
              _.breakpoints.splice(l, 1);
            }
            l--;
          }
          _.breakpoints.push(currentBreakpoint);
          _.breakpointSettings[currentBreakpoint] = responsiveSettings[breakpoint].settings;
        }
      }
      _.breakpoints.sort(function(a, b) {
        return (_.options.mobileFirst) ? a - b : b - a;
      });
    }
  };
  Slick.prototype.reinit = function() {
    var _ = this;
    _.$slides = _.$slideTrack.children(_.options.slide).addClass('slick-slide');
    _.slideCount = _.$slides.length;
    if (_.currentSlide >= _.slideCount && _.currentSlide !== 0) {
      _.currentSlide = _.currentSlide - _.options.slidesToScroll;
    }
    if (_.slideCount <= _.options.slidesToShow) {
      _.currentSlide = 0;
    }
    _.registerBreakpoints();
    _.setProps();
    _.setupInfinite();
    _.buildArrows();
    _.updateArrows();
    _.initArrowEvents();
    _.buildDots();
    _.updateDots();
    _.initDotEvents();
    _.cleanUpSlideEvents();
    _.initSlideEvents();
    _.checkResponsive(false, true);
    if (_.options.focusOnSelect === true) {
      $(_.$slideTrack).children().on('click.slick', _.selectHandler);
    }
    _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);
    _.setPosition();
    _.focusHandler();
    _.paused = !_.options.autoplay;
    _.autoPlay();
    _.$slider.trigger('reInit', [_]);
  };
  Slick.prototype.resize = function() {
    var _ = this;
    if ($(window).width() !== _.windowWidth) {
      clearTimeout(_.windowDelay);
      _.windowDelay = window.setTimeout(function() {
        _.windowWidth = $(window).width();
        _.checkResponsive();
        if (!_.unslicked) {
          _.setPosition();
        }
      }, 50);
    }
  };
  Slick.prototype.removeSlide = Slick.prototype.slickRemove = function(index, removeBefore, removeAll) {
    var _ = this;
    if (typeof(index) === 'boolean') {
      removeBefore = index;
      index = removeBefore === true ? 0 : _.slideCount - 1;
    } else {
      index = removeBefore === true ? --index : index;
    }
    if (_.slideCount < 1 || index < 0 || index > _.slideCount - 1) {
      return false;
    }
    _.unload();
    if (removeAll === true) {
      _.$slideTrack.children().remove();
    } else {
      _.$slideTrack.children(this.options.slide).eq(index).remove();
    }
    _.$slides = _.$slideTrack.children(this.options.slide);
    _.$slideTrack.children(this.options.slide).detach();
    _.$slideTrack.append(_.$slides);
    _.$slidesCache = _.$slides;
    _.reinit();
  };
  Slick.prototype.setCSS = function(position) {
    var _ = this,
        positionProps = {},
        x,
        y;
    if (_.options.rtl === true) {
      position = -position;
    }
    x = _.positionProp == 'left' ? Math.ceil(position) + 'px' : '0px';
    y = _.positionProp == 'top' ? Math.ceil(position) + 'px' : '0px';
    positionProps[_.positionProp] = position;
    if (_.transformsEnabled === false) {
      _.$slideTrack.css(positionProps);
    } else {
      positionProps = {};
      if (_.cssTransitions === false) {
        positionProps[_.animType] = 'translate(' + x + ', ' + y + ')';
        _.$slideTrack.css(positionProps);
      } else {
        positionProps[_.animType] = 'translate3d(' + x + ', ' + y + ', 0px)';
        _.$slideTrack.css(positionProps);
      }
    }
  };
  Slick.prototype.setDimensions = function() {
    var _ = this;
    if (_.options.vertical === false) {
      if (_.options.centerMode === true) {
        _.$list.css({padding: ('0px ' + _.options.centerPadding)});
      }
    } else {
      _.$list.height(_.$slides.first().outerHeight(true) * _.options.slidesToShow);
      if (_.options.centerMode === true) {
        _.$list.css({padding: (_.options.centerPadding + ' 0px')});
      }
    }
    _.listWidth = _.$list.width();
    _.listHeight = _.$list.height();
    if (_.options.vertical === false && _.options.variableWidth === false) {
      _.slideWidth = Math.ceil(_.listWidth / _.options.slidesToShow);
      _.$slideTrack.width(Math.ceil((_.slideWidth * _.$slideTrack.children('.slick-slide').length)));
    } else if (_.options.variableWidth === true) {
      _.$slideTrack.width(5000 * _.slideCount);
    } else {
      _.slideWidth = Math.ceil(_.listWidth);
      _.$slideTrack.height(Math.ceil((_.$slides.first().outerHeight(true) * _.$slideTrack.children('.slick-slide').length)));
    }
    var offset = _.$slides.first().outerWidth(true) - _.$slides.first().width();
    if (_.options.variableWidth === false)
      _.$slideTrack.children('.slick-slide').width(_.slideWidth - offset);
  };
  Slick.prototype.setFade = function() {
    var _ = this,
        targetLeft;
    _.$slides.each(function(index, element) {
      targetLeft = (_.slideWidth * index) * -1;
      if (_.options.rtl === true) {
        $(element).css({
          position: 'relative',
          right: targetLeft,
          top: 0,
          zIndex: _.options.zIndex - 2,
          opacity: 0
        });
      } else {
        $(element).css({
          position: 'relative',
          left: targetLeft,
          top: 0,
          zIndex: _.options.zIndex - 2,
          opacity: 0
        });
      }
    });
    _.$slides.eq(_.currentSlide).css({
      zIndex: _.options.zIndex - 1,
      opacity: 1
    });
  };
  Slick.prototype.setHeight = function() {
    var _ = this;
    if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
      var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
      _.$list.css('height', targetHeight);
    }
  };
  Slick.prototype.setOption = Slick.prototype.slickSetOption = function() {
    var _ = this,
        l,
        item,
        option,
        value,
        refresh = false,
        type;
    if ($.type(arguments[0]) === 'object') {
      option = arguments[0];
      refresh = arguments[1];
      type = 'multiple';
    } else if ($.type(arguments[0]) === 'string') {
      option = arguments[0];
      value = arguments[1];
      refresh = arguments[2];
      if (arguments[0] === 'responsive' && $.type(arguments[1]) === 'array') {
        type = 'responsive';
      } else if (typeof arguments[1] !== 'undefined') {
        type = 'single';
      }
    }
    if (type === 'single') {
      _.options[option] = value;
    } else if (type === 'multiple') {
      $.each(option, function(opt, val) {
        _.options[opt] = val;
      });
    } else if (type === 'responsive') {
      for (item in value) {
        if ($.type(_.options.responsive) !== 'array') {
          _.options.responsive = [value[item]];
        } else {
          l = _.options.responsive.length - 1;
          while (l >= 0) {
            if (_.options.responsive[l].breakpoint === value[item].breakpoint) {
              _.options.responsive.splice(l, 1);
            }
            l--;
          }
          _.options.responsive.push(value[item]);
        }
      }
    }
    if (refresh) {
      _.unload();
      _.reinit();
    }
  };
  Slick.prototype.setPosition = function() {
    var _ = this;
    _.setDimensions();
    _.setHeight();
    if (_.options.fade === false) {
      _.setCSS(_.getLeft(_.currentSlide));
    } else {
      _.setFade();
    }
    _.$slider.trigger('setPosition', [_]);
  };
  Slick.prototype.setProps = function() {
    var _ = this,
        bodyStyle = document.body.style;
    _.positionProp = _.options.vertical === true ? 'top' : 'left';
    if (_.positionProp === 'top') {
      _.$slider.addClass('slick-vertical');
    } else {
      _.$slider.removeClass('slick-vertical');
    }
    if (bodyStyle.WebkitTransition !== undefined || bodyStyle.MozTransition !== undefined || bodyStyle.msTransition !== undefined) {
      if (_.options.useCSS === true) {
        _.cssTransitions = true;
      }
    }
    if (_.options.fade) {
      if (typeof _.options.zIndex === 'number') {
        if (_.options.zIndex < 3) {
          _.options.zIndex = 3;
        }
      } else {
        _.options.zIndex = _.defaults.zIndex;
      }
    }
    if (bodyStyle.OTransform !== undefined) {
      _.animType = 'OTransform';
      _.transformType = '-o-transform';
      _.transitionType = 'OTransition';
      if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined)
        _.animType = false;
    }
    if (bodyStyle.MozTransform !== undefined) {
      _.animType = 'MozTransform';
      _.transformType = '-moz-transform';
      _.transitionType = 'MozTransition';
      if (bodyStyle.perspectiveProperty === undefined && bodyStyle.MozPerspective === undefined)
        _.animType = false;
    }
    if (bodyStyle.webkitTransform !== undefined) {
      _.animType = 'webkitTransform';
      _.transformType = '-webkit-transform';
      _.transitionType = 'webkitTransition';
      if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined)
        _.animType = false;
    }
    if (bodyStyle.msTransform !== undefined) {
      _.animType = 'msTransform';
      _.transformType = '-ms-transform';
      _.transitionType = 'msTransition';
      if (bodyStyle.msTransform === undefined)
        _.animType = false;
    }
    if (bodyStyle.transform !== undefined && _.animType !== false) {
      _.animType = 'transform';
      _.transformType = 'transform';
      _.transitionType = 'transition';
    }
    _.transformsEnabled = _.options.useTransform && (_.animType !== null && _.animType !== false);
  };
  Slick.prototype.setSlideClasses = function(index) {
    var _ = this,
        centerOffset,
        allSlides,
        indexOffset,
        remainder;
    allSlides = _.$slider.find('.slick-slide').removeClass('slick-active slick-center slick-current').attr('aria-hidden', 'true');
    _.$slides.eq(index).addClass('slick-current');
    if (_.options.centerMode === true) {
      var evenCoef = _.options.slidesToShow % 2 === 0 ? 1 : 0;
      centerOffset = Math.floor(_.options.slidesToShow / 2);
      if (_.options.infinite === true) {
        if (index >= centerOffset && index <= (_.slideCount - 1) - centerOffset) {
          _.$slides.slice(index - centerOffset + evenCoef, index + centerOffset + 1).addClass('slick-active').attr('aria-hidden', 'false');
        } else {
          indexOffset = _.options.slidesToShow + index;
          allSlides.slice(indexOffset - centerOffset + 1 + evenCoef, indexOffset + centerOffset + 2).addClass('slick-active').attr('aria-hidden', 'false');
        }
        if (index === 0) {
          allSlides.eq(allSlides.length - 1 - _.options.slidesToShow).addClass('slick-center');
        } else if (index === _.slideCount - 1) {
          allSlides.eq(_.options.slidesToShow).addClass('slick-center');
        }
      }
      _.$slides.eq(index).addClass('slick-center');
    } else {
      if (index >= 0 && index <= (_.slideCount - _.options.slidesToShow)) {
        _.$slides.slice(index, index + _.options.slidesToShow).addClass('slick-active').attr('aria-hidden', 'false');
      } else if (allSlides.length <= _.options.slidesToShow) {
        allSlides.addClass('slick-active').attr('aria-hidden', 'false');
      } else {
        remainder = _.slideCount % _.options.slidesToShow;
        indexOffset = _.options.infinite === true ? _.options.slidesToShow + index : index;
        if (_.options.slidesToShow == _.options.slidesToScroll && (_.slideCount - index) < _.options.slidesToShow) {
          allSlides.slice(indexOffset - (_.options.slidesToShow - remainder), indexOffset + remainder).addClass('slick-active').attr('aria-hidden', 'false');
        } else {
          allSlides.slice(indexOffset, indexOffset + _.options.slidesToShow).addClass('slick-active').attr('aria-hidden', 'false');
        }
      }
    }
    if (_.options.lazyLoad === 'ondemand' || _.options.lazyLoad === 'anticipated') {
      _.lazyLoad();
    }
  };
  Slick.prototype.setupInfinite = function() {
    var _ = this,
        i,
        slideIndex,
        infiniteCount;
    if (_.options.fade === true) {
      _.options.centerMode = false;
    }
    if (_.options.infinite === true && _.options.fade === false) {
      slideIndex = null;
      if (_.slideCount > _.options.slidesToShow) {
        if (_.options.centerMode === true) {
          infiniteCount = _.options.slidesToShow + 1;
        } else {
          infiniteCount = _.options.slidesToShow;
        }
        for (i = _.slideCount; i > (_.slideCount - infiniteCount); i -= 1) {
          slideIndex = i - 1;
          $(_.$slides[slideIndex]).clone(true).attr('id', '').attr('data-slick-index', slideIndex - _.slideCount).prependTo(_.$slideTrack).addClass('slick-cloned');
        }
        for (i = 0; i < infiniteCount + _.slideCount; i += 1) {
          slideIndex = i;
          $(_.$slides[slideIndex]).clone(true).attr('id', '').attr('data-slick-index', slideIndex + _.slideCount).appendTo(_.$slideTrack).addClass('slick-cloned');
        }
        _.$slideTrack.find('.slick-cloned').find('[id]').each(function() {
          $(this).attr('id', '');
        });
      }
    }
  };
  Slick.prototype.interrupt = function(toggle) {
    var _ = this;
    if (!toggle) {
      _.autoPlay();
    }
    _.interrupted = toggle;
  };
  Slick.prototype.selectHandler = function(event) {
    var _ = this;
    var targetElement = $(event.target).is('.slick-slide') ? $(event.target) : $(event.target).parents('.slick-slide');
    var index = parseInt(targetElement.attr('data-slick-index'));
    if (!index)
      index = 0;
    if (_.slideCount <= _.options.slidesToShow) {
      _.slideHandler(index, false, true);
      return;
    }
    _.slideHandler(index);
  };
  Slick.prototype.slideHandler = function(index, sync, dontAnimate) {
    var targetSlide,
        animSlide,
        oldSlide,
        slideLeft,
        targetLeft = null,
        _ = this,
        navTarget;
    sync = sync || false;
    if (_.animating === true && _.options.waitForAnimate === true) {
      return;
    }
    if (_.options.fade === true && _.currentSlide === index) {
      return;
    }
    if (sync === false) {
      _.asNavFor(index);
    }
    targetSlide = index;
    targetLeft = _.getLeft(targetSlide);
    slideLeft = _.getLeft(_.currentSlide);
    _.currentLeft = _.swipeLeft === null ? slideLeft : _.swipeLeft;
    if (_.options.infinite === false && _.options.centerMode === false && (index < 0 || index > _.getDotCount() * _.options.slidesToScroll)) {
      if (_.options.fade === false) {
        targetSlide = _.currentSlide;
        if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
          _.animateSlide(slideLeft, function() {
            _.postSlide(targetSlide);
          });
        } else {
          _.postSlide(targetSlide);
        }
      }
      return;
    } else if (_.options.infinite === false && _.options.centerMode === true && (index < 0 || index > (_.slideCount - _.options.slidesToScroll))) {
      if (_.options.fade === false) {
        targetSlide = _.currentSlide;
        if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
          _.animateSlide(slideLeft, function() {
            _.postSlide(targetSlide);
          });
        } else {
          _.postSlide(targetSlide);
        }
      }
      return;
    }
    if (_.options.autoplay) {
      clearInterval(_.autoPlayTimer);
    }
    if (targetSlide < 0) {
      if (_.slideCount % _.options.slidesToScroll !== 0) {
        animSlide = _.slideCount - (_.slideCount % _.options.slidesToScroll);
      } else {
        animSlide = _.slideCount + targetSlide;
      }
    } else if (targetSlide >= _.slideCount) {
      if (_.slideCount % _.options.slidesToScroll !== 0) {
        animSlide = 0;
      } else {
        animSlide = targetSlide - _.slideCount;
      }
    } else {
      animSlide = targetSlide;
    }
    _.animating = true;
    _.$slider.trigger('beforeChange', [_, _.currentSlide, animSlide]);
    oldSlide = _.currentSlide;
    _.currentSlide = animSlide;
    _.setSlideClasses(_.currentSlide);
    if (_.options.asNavFor) {
      navTarget = _.getNavTarget();
      navTarget = navTarget.slick('getSlick');
      if (navTarget.slideCount <= navTarget.options.slidesToShow) {
        navTarget.setSlideClasses(_.currentSlide);
      }
    }
    _.updateDots();
    _.updateArrows();
    if (_.options.fade === true) {
      if (dontAnimate !== true) {
        _.fadeSlideOut(oldSlide);
        _.fadeSlide(animSlide, function() {
          _.postSlide(animSlide);
        });
      } else {
        _.postSlide(animSlide);
      }
      _.animateHeight();
      return;
    }
    if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
      _.animateSlide(targetLeft, function() {
        _.postSlide(animSlide);
      });
    } else {
      _.postSlide(animSlide);
    }
  };
  Slick.prototype.startLoad = function() {
    var _ = this;
    if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
      _.$prevArrow.hide();
      _.$nextArrow.hide();
    }
    if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
      _.$dots.hide();
    }
    _.$slider.addClass('slick-loading');
  };
  Slick.prototype.swipeDirection = function() {
    var xDist,
        yDist,
        r,
        swipeAngle,
        _ = this;
    xDist = _.touchObject.startX - _.touchObject.curX;
    yDist = _.touchObject.startY - _.touchObject.curY;
    r = Math.atan2(yDist, xDist);
    swipeAngle = Math.round(r * 180 / Math.PI);
    if (swipeAngle < 0) {
      swipeAngle = 360 - Math.abs(swipeAngle);
    }
    if ((swipeAngle <= 45) && (swipeAngle >= 0)) {
      return (_.options.rtl === false ? 'left' : 'right');
    }
    if ((swipeAngle <= 360) && (swipeAngle >= 315)) {
      return (_.options.rtl === false ? 'left' : 'right');
    }
    if ((swipeAngle >= 135) && (swipeAngle <= 225)) {
      return (_.options.rtl === false ? 'right' : 'left');
    }
    if (_.options.verticalSwiping === true) {
      if ((swipeAngle >= 35) && (swipeAngle <= 135)) {
        return 'down';
      } else {
        return 'up';
      }
    }
    return 'vertical';
  };
  Slick.prototype.swipeEnd = function(event) {
    var _ = this,
        slideCount,
        direction;
    _.dragging = false;
    _.swiping = false;
    if (_.scrolling) {
      _.scrolling = false;
      return false;
    }
    _.interrupted = false;
    _.shouldClick = (_.touchObject.swipeLength > 10) ? false : true;
    if (_.touchObject.curX === undefined) {
      return false;
    }
    if (_.touchObject.edgeHit === true) {
      _.$slider.trigger('edge', [_, _.swipeDirection()]);
    }
    if (_.touchObject.swipeLength >= _.touchObject.minSwipe) {
      direction = _.swipeDirection();
      switch (direction) {
        case 'left':
        case 'down':
          slideCount = _.options.swipeToSlide ? _.checkNavigable(_.currentSlide + _.getSlideCount()) : _.currentSlide + _.getSlideCount();
          _.currentDirection = 0;
          break;
        case 'right':
        case 'up':
          slideCount = _.options.swipeToSlide ? _.checkNavigable(_.currentSlide - _.getSlideCount()) : _.currentSlide - _.getSlideCount();
          _.currentDirection = 1;
          break;
        default:
      }
      if (direction != 'vertical') {
        _.slideHandler(slideCount);
        _.touchObject = {};
        _.$slider.trigger('swipe', [_, direction]);
      }
    } else {
      if (_.touchObject.startX !== _.touchObject.curX) {
        _.slideHandler(_.currentSlide);
        _.touchObject = {};
      }
    }
  };
  Slick.prototype.swipeHandler = function(event) {
    var _ = this;
    if ((_.options.swipe === false) || ('ontouchend' in document && _.options.swipe === false)) {
      return;
    } else if (_.options.draggable === false && event.type.indexOf('mouse') !== -1) {
      return;
    }
    _.touchObject.fingerCount = event.originalEvent && event.originalEvent.touches !== undefined ? event.originalEvent.touches.length : 1;
    _.touchObject.minSwipe = _.listWidth / _.options.touchThreshold;
    if (_.options.verticalSwiping === true) {
      _.touchObject.minSwipe = _.listHeight / _.options.touchThreshold;
    }
    switch (event.data.action) {
      case 'start':
        _.swipeStart(event);
        break;
      case 'move':
        _.swipeMove(event);
        break;
      case 'end':
        _.swipeEnd(event);
        break;
    }
  };
  Slick.prototype.swipeMove = function(event) {
    var _ = this,
        edgeWasHit = false,
        curLeft,
        swipeDirection,
        swipeLength,
        positionOffset,
        touches,
        verticalSwipeLength;
    touches = event.originalEvent !== undefined ? event.originalEvent.touches : null;
    if (!_.dragging || _.scrolling || touches && touches.length !== 1) {
      return false;
    }
    curLeft = _.getLeft(_.currentSlide);
    _.touchObject.curX = touches !== undefined ? touches[0].pageX : event.clientX;
    _.touchObject.curY = touches !== undefined ? touches[0].pageY : event.clientY;
    _.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(_.touchObject.curX - _.touchObject.startX, 2)));
    verticalSwipeLength = Math.round(Math.sqrt(Math.pow(_.touchObject.curY - _.touchObject.startY, 2)));
    if (!_.options.verticalSwiping && !_.swiping && verticalSwipeLength > 4) {
      _.scrolling = true;
      return false;
    }
    if (_.options.verticalSwiping === true) {
      _.touchObject.swipeLength = verticalSwipeLength;
    }
    swipeDirection = _.swipeDirection();
    if (event.originalEvent !== undefined && _.touchObject.swipeLength > 4) {
      _.swiping = true;
      event.preventDefault();
    }
    positionOffset = (_.options.rtl === false ? 1 : -1) * (_.touchObject.curX > _.touchObject.startX ? 1 : -1);
    if (_.options.verticalSwiping === true) {
      positionOffset = _.touchObject.curY > _.touchObject.startY ? 1 : -1;
    }
    swipeLength = _.touchObject.swipeLength;
    _.touchObject.edgeHit = false;
    if (_.options.infinite === false) {
      if ((_.currentSlide === 0 && swipeDirection === 'right') || (_.currentSlide >= _.getDotCount() && swipeDirection === 'left')) {
        swipeLength = _.touchObject.swipeLength * _.options.edgeFriction;
        _.touchObject.edgeHit = true;
      }
    }
    if (_.options.vertical === false) {
      _.swipeLeft = curLeft + swipeLength * positionOffset;
    } else {
      _.swipeLeft = curLeft + (swipeLength * (_.$list.height() / _.listWidth)) * positionOffset;
    }
    if (_.options.verticalSwiping === true) {
      _.swipeLeft = curLeft + swipeLength * positionOffset;
    }
    if (_.options.fade === true || _.options.touchMove === false) {
      return false;
    }
    if (_.animating === true) {
      _.swipeLeft = null;
      return false;
    }
    _.setCSS(_.swipeLeft);
  };
  Slick.prototype.swipeStart = function(event) {
    var _ = this,
        touches;
    _.interrupted = true;
    if (_.touchObject.fingerCount !== 1 || _.slideCount <= _.options.slidesToShow) {
      _.touchObject = {};
      return false;
    }
    if (event.originalEvent !== undefined && event.originalEvent.touches !== undefined) {
      touches = event.originalEvent.touches[0];
    }
    _.touchObject.startX = _.touchObject.curX = touches !== undefined ? touches.pageX : event.clientX;
    _.touchObject.startY = _.touchObject.curY = touches !== undefined ? touches.pageY : event.clientY;
    _.dragging = true;
  };
  Slick.prototype.unfilterSlides = Slick.prototype.slickUnfilter = function() {
    var _ = this;
    if (_.$slidesCache !== null) {
      _.unload();
      _.$slideTrack.children(this.options.slide).detach();
      _.$slidesCache.appendTo(_.$slideTrack);
      _.reinit();
    }
  };
  Slick.prototype.unload = function() {
    var _ = this;
    $('.slick-cloned', _.$slider).remove();
    if (_.$dots) {
      _.$dots.remove();
    }
    if (_.$prevArrow && _.htmlExpr.test(_.options.prevArrow)) {
      _.$prevArrow.remove();
    }
    if (_.$nextArrow && _.htmlExpr.test(_.options.nextArrow)) {
      _.$nextArrow.remove();
    }
    _.$slides.removeClass('slick-slide slick-active slick-visible slick-current').attr('aria-hidden', 'true').css('width', '');
  };
  Slick.prototype.unslick = function(fromBreakpoint) {
    var _ = this;
    _.$slider.trigger('unslick', [_, fromBreakpoint]);
    _.destroy();
  };
  Slick.prototype.updateArrows = function() {
    var _ = this,
        centerOffset;
    centerOffset = Math.floor(_.options.slidesToShow / 2);
    if (_.options.arrows === true && _.slideCount > _.options.slidesToShow && !_.options.infinite) {
      _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
      _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
      if (_.currentSlide === 0) {
        _.$prevArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
        _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
      } else if (_.currentSlide >= _.slideCount - _.options.slidesToShow && _.options.centerMode === false) {
        _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
        _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
      } else if (_.currentSlide >= _.slideCount - 1 && _.options.centerMode === true) {
        _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
        _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
      }
    }
  };
  Slick.prototype.updateDots = function() {
    var _ = this;
    if (_.$dots !== null) {
      _.$dots.find('li').removeClass('slick-active').end();
      _.$dots.find('li').eq(Math.floor(_.currentSlide / _.options.slidesToScroll)).addClass('slick-active');
    }
  };
  Slick.prototype.visibility = function() {
    var _ = this;
    if (_.options.autoplay) {
      if (document[_.hidden]) {
        _.interrupted = true;
      } else {
        _.interrupted = false;
      }
    }
  };
  $.fn.slick = function() {
    var _ = this,
        opt = arguments[0],
        args = Array.prototype.slice.call(arguments, 1),
        l = _.length,
        i,
        ret;
    for (i = 0; i < l; i++) {
      if (typeof opt == 'object' || typeof opt == 'undefined')
        _[i].slick = new Slick(_[i], opt);
      else
        ret = _[i].slick[opt].apply(_[i].slick, args);
      if (typeof ret != 'undefined')
        return ret;
    }
    return _;
  };
}));

})();
$__System.registerDynamic("6", [], false, function($__require, $__exports, $__module) {
  var _retrieveGlobal = $__System.get("@@global-helpers").prepareGlobal($__module.id, null, null);
  (function() {
    (function() {
      var d;
      window.AmCharts ? d = window.AmCharts : (d = {}, window.AmCharts = d, d.themes = {}, d.maps = {}, d.inheriting = {}, d.charts = [], d.onReadyArray = [], d.useUTC = !1, d.updateRate = 60, d.uid = 0, d.lang = {}, d.translations = {}, d.mapTranslations = {}, d.windows = {}, d.initHandlers = [], d.amString = "am", d.pmString = "pm");
      d.Class = function(a) {
        var b = function() {
          arguments[0] !== d.inheriting && (this.events = {}, this.construct.apply(this, arguments));
        };
        a.inherits ? (b.prototype = new a.inherits(d.inheriting), b.base = a.inherits.prototype, delete a.inherits) : (b.prototype.createEvents = function() {
          for (var a = 0; a < arguments.length; a++)
            this.events[arguments[a]] = [];
        }, b.prototype.listenTo = function(a, b, c) {
          this.removeListener(a, b, c);
          a.events[b].push({
            handler: c,
            scope: this
          });
        }, b.prototype.addListener = function(a, b, c) {
          this.removeListener(this, a, b);
          a && this.events[a] && this.events[a].push({
            handler: b,
            scope: c
          });
        }, b.prototype.removeListener = function(a, b, c) {
          if (a && a.events && (a = a.events[b]))
            for (b = a.length - 1; 0 <= b; b--)
              a[b].handler === c && a.splice(b, 1);
        }, b.prototype.fire = function(a) {
          for (var b = this.events[a.type],
              c = 0; c < b.length; c++) {
            var d = b[c];
            d.handler.call(d.scope, a);
          }
        });
        for (var c in a)
          b.prototype[c] = a[c];
        return b;
      };
      d.addChart = function(a) {
        window.requestAnimationFrame ? d.animationRequested || (d.animationRequested = !0, window.requestAnimationFrame(d.update)) : d.updateInt || (d.updateInt = setInterval(function() {
          d.update();
        }, Math.round(1E3 / d.updateRate)));
        d.charts.push(a);
      };
      d.removeChart = function(a) {
        for (var b = d.charts,
            c = b.length - 1; 0 <= c; c--)
          b[c] == a && b.splice(c, 1);
        0 === b.length && (d.requestAnimation && (window.cancelAnimationFrame(d.requestAnimation), d.animationRequested = !1), d.updateInt && (clearInterval(d.updateInt), d.updateInt = NaN));
      };
      d.isModern = !0;
      d.getIEVersion = function() {
        var a = 0,
            b,
            c;
        "Microsoft Internet Explorer" == navigator.appName && (b = navigator.userAgent, c = /MSIE ([0-9]{1,}[.0-9]{0,})/, null !== c.exec(b) && (a = parseFloat(RegExp.$1)));
        return a;
      };
      d.applyLang = function(a, b) {
        var c = d.translations;
        b.dayNames = d.extend({}, d.dayNames);
        b.shortDayNames = d.extend({}, d.shortDayNames);
        b.monthNames = d.extend({}, d.monthNames);
        b.shortMonthNames = d.extend({}, d.shortMonthNames);
        b.amString = "am";
        b.pmString = "pm";
        c && (c = c[a]) && (d.lang = c, b.langObj = c, c.monthNames && (b.dayNames = d.extend({}, c.dayNames), b.shortDayNames = d.extend({}, c.shortDayNames), b.monthNames = d.extend({}, c.monthNames), b.shortMonthNames = d.extend({}, c.shortMonthNames)), c.am && (b.amString = c.am), c.pm && (b.pmString = c.pm));
        d.amString = b.amString;
        d.pmString = b.pmString;
      };
      d.IEversion = d.getIEVersion();
      9 > d.IEversion && 0 < d.IEversion && (d.isModern = !1, d.isIE = !0);
      d.dx = 0;
      d.dy = 0;
      if (document.addEventListener || window.opera)
        d.isNN = !0, d.isIE = !1, d.dx = .5, d.dy = .5;
      document.attachEvent && (d.isNN = !1, d.isIE = !0, d.isModern || (d.dx = 0, d.dy = 0));
      window.chrome && (d.chrome = !0);
      d.handleMouseUp = function(a) {
        for (var b = d.charts,
            c = 0; c < b.length; c++) {
          var e = b[c];
          e && e.handleReleaseOutside && e.handleReleaseOutside(a);
        }
      };
      d.handleMouseMove = function(a) {
        for (var b = d.charts,
            c = 0; c < b.length; c++) {
          var e = b[c];
          e && e.handleMouseMove && e.handleMouseMove(a);
        }
      };
      d.handleWheel = function(a) {
        for (var b = d.charts,
            c = 0; c < b.length; c++) {
          var e = b[c];
          if (e && e.mouseIsOver) {
            (e.mouseWheelScrollEnabled || e.mouseWheelZoomEnabled) && e.handleWheel && e.handleWheel(a);
            break;
          }
        }
      };
      d.resetMouseOver = function() {
        for (var a = d.charts,
            b = 0; b < a.length; b++) {
          var c = a[b];
          c && (c.mouseIsOver = !1);
        }
      };
      d.ready = function(a) {
        d.onReadyArray.push(a);
      };
      d.handleLoad = function() {
        d.isReady = !0;
        for (var a = d.onReadyArray,
            b = 0; b < a.length; b++) {
          var c = a[b];
          isNaN(d.processDelay) ? c() : setTimeout(c, d.processDelay * b);
        }
        d.onReadyArray = [];
      };
      d.addInitHandler = function(a, b) {
        d.initHandlers.push({
          method: a,
          types: b
        });
      };
      d.callInitHandler = function(a) {
        var b = d.initHandlers;
        if (d.initHandlers)
          for (var c = 0; c < b.length; c++) {
            var e = b[c];
            e.types ? d.isInArray(e.types, a.type) && e.method(a) : e.method(a);
          }
      };
      d.getUniqueId = function() {
        d.uid++;
        return "AmChartsEl-" + d.uid;
      };
      d.isNN && (document.addEventListener("mousemove", d.handleMouseMove), document.addEventListener("mouseup", d.handleMouseUp, !0), window.addEventListener("load", d.handleLoad, !0));
      d.isIE && (document.attachEvent("onmousemove", d.handleMouseMove), document.attachEvent("onmouseup", d.handleMouseUp), window.attachEvent("onload", d.handleLoad));
      d.addWheelListeners = function() {
        d.wheelIsListened || (d.isNN && (window.addEventListener("DOMMouseScroll", d.handleWheel, !0), document.addEventListener("mousewheel", d.handleWheel, !0)), d.isIE && document.attachEvent("onmousewheel", d.handleWheel));
        d.wheelIsListened = !0;
      };
      d.clear = function() {
        var a = d.charts;
        if (a)
          for (var b = a.length - 1; 0 <= b; b--)
            a[b].clear();
        d.updateInt && clearInterval(d.updateInt);
        d.requestAnimation && window.cancelAnimationFrame(d.requestAnimation);
        d.charts = [];
        d.isNN && (document.removeEventListener("mousemove", d.handleMouseMove, !0), document.removeEventListener("mouseup", d.handleMouseUp, !0), window.removeEventListener("load", d.handleLoad, !0), window.removeEventListener("DOMMouseScroll", d.handleWheel, !0), document.removeEventListener("mousewheel", d.handleWheel, !0));
        d.isIE && (document.detachEvent("onmousemove", d.handleMouseMove), document.detachEvent("onmouseup", d.handleMouseUp), window.detachEvent("onload", d.handleLoad));
      };
      d.makeChart = function(a, b, c) {
        var e = b.type,
            g = b.theme;
        d.isString(g) && (g = d.themes[g], b.theme = g);
        var f;
        switch (e) {
          case "serial":
            f = new d.AmSerialChart(g);
            break;
          case "xy":
            f = new d.AmXYChart(g);
            break;
          case "pie":
            f = new d.AmPieChart(g);
            break;
          case "radar":
            f = new d.AmRadarChart(g);
            break;
          case "gauge":
            f = new d.AmAngularGauge(g);
            break;
          case "funnel":
            f = new d.AmFunnelChart(g);
            break;
          case "map":
            f = new d.AmMap(g);
            break;
          case "stock":
            f = new d.AmStockChart(g);
            break;
          case "gantt":
            f = new d.AmGanttChart(g);
        }
        d.extend(f, b);
        d.isReady ? isNaN(c) ? f.write(a) : setTimeout(function() {
          d.realWrite(f, a);
        }, c) : d.ready(function() {
          isNaN(c) ? f.write(a) : setTimeout(function() {
            d.realWrite(f, a);
          }, c);
        });
        return f;
      };
      d.realWrite = function(a, b) {
        a.write(b);
      };
      d.updateCount = 0;
      d.validateAt = Math.round(d.updateRate / 10);
      d.update = function() {
        var a = d.charts;
        d.updateCount++;
        var b = !1;
        d.updateCount == d.validateAt && (b = !0, d.updateCount = 0);
        if (a)
          for (var c = a.length - 1; 0 <= c; c--)
            a[c].update && a[c].update(), b && (a[c].autoResize ? a[c].validateSize && a[c].validateSize() : a[c].premeasure && a[c].premeasure());
        window.requestAnimationFrame && (d.requestAnimation = window.requestAnimationFrame(d.update));
      };
      "complete" == document.readyState && d.handleLoad();
    })();
    (function() {
      var d = window.AmCharts;
      d.toBoolean = function(a, b) {
        if (void 0 === a)
          return b;
        switch (String(a).toLowerCase()) {
          case "true":
          case "yes":
          case "1":
            return !0;
          case "false":
          case "no":
          case "0":
          case null:
            return !1;
          default:
            return !!a;
        }
      };
      d.removeFromArray = function(a, b) {
        var c;
        if (void 0 !== b && void 0 !== a)
          for (c = a.length - 1; 0 <= c; c--)
            a[c] == b && a.splice(c, 1);
      };
      d.getPath = function() {
        var a = document.getElementsByTagName("script");
        if (a)
          for (var b = 0; b < a.length; b++) {
            var c = a[b].src;
            if (-1 !== c.search(/\/(amcharts|ammap)\.js/))
              return c.replace(/\/(amcharts|ammap)\.js.*/, "/");
          }
      };
      d.normalizeUrl = function(a) {
        return "" !== a && -1 === a.search(/\/$/) ? a + "/" : a;
      };
      d.isAbsolute = function(a) {
        return 0 === a.search(/^http[s]?:|^\//);
      };
      d.isInArray = function(a, b) {
        for (var c = 0; c < a.length; c++)
          if (a[c] == b)
            return !0;
        return !1;
      };
      d.getDecimals = function(a) {
        var b = 0;
        isNaN(a) || (a = String(a), -1 != a.indexOf("e-") ? b = Number(a.split("-")[1]) : -1 != a.indexOf(".") && (b = a.split(".")[1].length));
        return b;
      };
      d.wordwrap = function(a, b, c, e) {
        var g,
            f,
            h,
            k;
        a += "";
        if (1 > b)
          return a;
        g = -1;
        for (a = (k = a.split(/\r\n|\n|\r/)).length; ++g < a; k[g] += h) {
          h = k[g];
          for (k[g] = ""; h.length > b; k[g] += d.trim(h.slice(0, f)) + ((h = h.slice(f)).length ? c : ""))
            f = 2 == e || (f = h.slice(0, b + 1).match(/\S*(\s)?$/))[1] ? b : f.input.length - f[0].length || 1 == e && b || f.input.length + (f = h.slice(b).match(/^\S*/))[0].length;
          h = d.trim(h);
        }
        return k.join(c);
      };
      d.trim = function(a) {
        return a.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
      };
      d.wrappedText = function(a, b, c, e, g, f, h, k) {
        var l = d.text(a, b, c, e, g, f, h);
        if (l) {
          var m = l.getBBox();
          if (m.width > k) {
            var n = "\n";
            d.isModern || (n = "<br>");
            k = Math.floor(k / (m.width / b.length));
            2 < k && (k -= 2);
            b = d.wordwrap(b, k, n, !0);
            l.remove();
            l = d.text(a, b, c, e, g, f, h);
          }
        }
        return l;
      };
      d.getStyle = function(a, b) {
        var c = "";
        if (document.defaultView && document.defaultView.getComputedStyle)
          try {
            c = document.defaultView.getComputedStyle(a, "").getPropertyValue(b);
          } catch (e) {}
        else
          a.currentStyle && (b = b.replace(/\-(\w)/g, function(a, b) {
            return b.toUpperCase();
          }), c = a.currentStyle[b]);
        return c;
      };
      d.removePx = function(a) {
        if (void 0 !== a)
          return Number(a.substring(0, a.length - 2));
      };
      d.getURL = function(a, b) {
        if (a)
          if ("_self" != b && b)
            if ("_top" == b && window.top)
              window.top.location.href = a;
            else if ("_parent" == b && window.parent)
              window.parent.location.href = a;
            else if ("_blank" == b)
              window.open(a);
            else {
              var c = document.getElementsByName(b)[0];
              c ? c.src = a : (c = d.windows[b]) ? c.opener && !c.opener.closed ? c.location.href = a : d.windows[b] = window.open(a) : d.windows[b] = window.open(a);
            }
          else
            window.location.href = a;
      };
      d.ifArray = function(a) {
        return a && "object" == typeof a && 0 < a.length ? !0 : !1;
      };
      d.callMethod = function(a, b) {
        var c;
        for (c = 0; c < b.length; c++) {
          var e = b[c];
          if (e) {
            if (e[a])
              e[a]();
            var d = e.length;
            if (0 < d) {
              var f;
              for (f = 0; f < d; f++) {
                var h = e[f];
                if (h && h[a])
                  h[a]();
              }
            }
          }
        }
      };
      d.toNumber = function(a) {
        return "number" == typeof a ? a : Number(String(a).replace(/[^0-9\-.]+/g, ""));
      };
      d.toColor = function(a) {
        if ("" !== a && void 0 !== a)
          if (-1 != a.indexOf(",")) {
            a = a.split(",");
            var b;
            for (b = 0; b < a.length; b++) {
              var c = a[b].substring(a[b].length - 6, a[b].length);
              a[b] = "#" + c;
            }
          } else
            a = a.substring(a.length - 6, a.length), a = "#" + a;
        return a;
      };
      d.toCoordinate = function(a, b, c) {
        var e;
        void 0 !== a && (a = String(a), c && c < b && (b = c), e = Number(a), -1 != a.indexOf("!") && (e = b - Number(a.substr(1))), -1 != a.indexOf("%") && (e = b * Number(a.substr(0, a.length - 1)) / 100));
        return e;
      };
      d.fitToBounds = function(a, b, c) {
        a < b && (a = b);
        a > c && (a = c);
        return a;
      };
      d.isDefined = function(a) {
        return void 0 === a ? !1 : !0;
      };
      d.stripNumbers = function(a) {
        return a.replace(/[0-9]+/g, "");
      };
      d.roundTo = function(a, b) {
        if (0 > b)
          return a;
        var c = Math.pow(10, b);
        return Math.round(a * c) / c;
      };
      d.toFixed = function(a, b) {
        var c = !1;
        0 > a && (c = !0, a = Math.abs(a));
        var e = String(Math.round(a * Math.pow(10, b)));
        if (0 < b) {
          var d = e.length;
          if (d < b) {
            var f;
            for (f = 0; f < b - d; f++)
              e = "0" + e;
          }
          d = e.substring(0, e.length - b);
          "" === d && (d = 0);
          e = d + "." + e.substring(e.length - b, e.length);
          return c ? "-" + e : e;
        }
        return String(e);
      };
      d.formatDuration = function(a, b, c, e, g, f) {
        var h = d.intervals,
            k = f.decimalSeparator;
        if (a >= h[b].contains) {
          var l = a - Math.floor(a / h[b].contains) * h[b].contains;
          "ss" == b ? (l = d.formatNumber(l, f), 1 == l.split(k)[0].length && (l = "0" + l)) : l = d.roundTo(l, f.precision);
          ("mm" == b || "hh" == b) && 10 > l && (l = "0" + l);
          c = l + "" + e[b] + "" + c;
          a = Math.floor(a / h[b].contains);
          b = h[b].nextInterval;
          return d.formatDuration(a, b, c, e, g, f);
        }
        "ss" == b && (a = d.formatNumber(a, f), 1 == a.split(k)[0].length && (a = "0" + a));
        "mm" == b && (a = d.roundTo(a, f.precision));
        ("mm" == b || "hh" == b) && 10 > a && (a = "0" + a);
        c = a + "" + e[b] + "" + c;
        if (h[g].count > h[b].count)
          for (a = h[b].count; a < h[g].count; a++)
            b = h[b].nextInterval, "ss" == b || "mm" == b || "hh" == b ? c = "00" + e[b] + "" + c : "DD" == b && (c = "0" + e[b] + "" + c);
        ":" == c.charAt(c.length - 1) && (c = c.substring(0, c.length - 1));
        return c;
      };
      d.formatNumber = function(a, b, c, e, g) {
        a = d.roundTo(a, b.precision);
        isNaN(c) && (c = b.precision);
        var f = b.decimalSeparator;
        b = b.thousandsSeparator;
        void 0 == f && (f = ",");
        void 0 == b && (b = " ");
        var h;
        h = 0 > a ? "-" : "";
        a = Math.abs(a);
        var k = String(a),
            l = !1;
        -1 != k.indexOf("e") && (l = !0);
        0 <= c && !l && (k = d.toFixed(a, c));
        var m = "";
        if (l)
          m = k;
        else {
          var k = k.split("."),
              l = String(k[0]),
              n;
          for (n = l.length; 0 <= n; n -= 3)
            m = n != l.length ? 0 !== n ? l.substring(n - 3, n) + b + m : l.substring(n - 3, n) + m : l.substring(n - 3, n);
          void 0 !== k[1] && (m = m + f + k[1]);
          void 0 !== c && 0 < c && "0" != m && (m = d.addZeroes(m, f, c));
        }
        m = h + m;
        "" === h && !0 === e && 0 !== a && (m = "+" + m);
        !0 === g && (m += "%");
        return m;
      };
      d.addZeroes = function(a, b, c) {
        a = a.split(b);
        void 0 === a[1] && 0 < c && (a[1] = "0");
        return a[1].length < c ? (a[1] += "0", d.addZeroes(a[0] + b + a[1], b, c)) : void 0 !== a[1] ? a[0] + b + a[1] : a[0];
      };
      d.scientificToNormal = function(a) {
        var b;
        a = String(a).split("e");
        var c;
        if ("-" == a[1].substr(0, 1)) {
          b = "0.";
          for (c = 0; c < Math.abs(Number(a[1])) - 1; c++)
            b += "0";
          b += a[0].split(".").join("");
        } else {
          var e = 0;
          b = a[0].split(".");
          b[1] && (e = b[1].length);
          b = a[0].split(".").join("");
          for (c = 0; c < Math.abs(Number(a[1])) - e; c++)
            b += "0";
        }
        return b;
      };
      d.toScientific = function(a, b) {
        if (0 === a)
          return "0";
        var c = Math.floor(Math.log(Math.abs(a)) * Math.LOG10E),
            e = String(e).split(".").join(b);
        return String(e) + "e" + c;
      };
      d.randomColor = function() {
        return "#" + ("00000" + (16777216 * Math.random() << 0).toString(16)).substr(-6);
      };
      d.hitTest = function(a, b, c) {
        var e = !1,
            g = a.x,
            f = a.x + a.width,
            h = a.y,
            k = a.y + a.height,
            l = d.isInRectangle;
        e || (e = l(g, h, b));
        e || (e = l(g, k, b));
        e || (e = l(f, h, b));
        e || (e = l(f, k, b));
        e || !0 === c || (e = d.hitTest(b, a, !0));
        return e;
      };
      d.isInRectangle = function(a, b, c) {
        return a >= c.x - 5 && a <= c.x + c.width + 5 && b >= c.y - 5 && b <= c.y + c.height + 5 ? !0 : !1;
      };
      d.isPercents = function(a) {
        if (-1 != String(a).indexOf("%"))
          return !0;
      };
      d.formatValue = function(a, b, c, e, g, f, h, k) {
        if (b) {
          void 0 === g && (g = "");
          var l;
          for (l = 0; l < c.length; l++) {
            var m = c[l],
                n = b[m];
            void 0 !== n && (n = f ? d.addPrefix(n, k, h, e) : d.formatNumber(n, e), a = a.replace(new RegExp("\\[\\[" + g + "" + m + "\\]\\]", "g"), n));
          }
        }
        return a;
      };
      d.formatDataContextValue = function(a, b) {
        if (a) {
          var c = a.match(/\[\[.*?\]\]/g),
              e;
          for (e = 0; e < c.length; e++) {
            var d = c[e],
                d = d.substr(2, d.length - 4);
            void 0 !== b[d] && (a = a.replace(new RegExp("\\[\\[" + d + "\\]\\]", "g"), b[d]));
          }
        }
        return a;
      };
      d.massReplace = function(a, b) {
        for (var c in b)
          if (b.hasOwnProperty(c)) {
            var e = b[c];
            void 0 === e && (e = "");
            a = a.replace(c, e);
          }
        return a;
      };
      d.cleanFromEmpty = function(a) {
        return a.replace(/\[\[[^\]]*\]\]/g, "");
      };
      d.addPrefix = function(a, b, c, e, g) {
        var f = d.formatNumber(a, e),
            h = "",
            k,
            l,
            m;
        if (0 === a)
          return "0";
        0 > a && (h = "-");
        a = Math.abs(a);
        if (1 < a)
          for (k = b.length - 1; -1 < k; k--) {
            if (a >= b[k].number && (l = a / b[k].number, m = Number(e.precision), 1 > m && (m = 1), c = d.roundTo(l, m), m = d.formatNumber(c, {
              precision: -1,
              decimalSeparator: e.decimalSeparator,
              thousandsSeparator: e.thousandsSeparator
            }), !g || l == c)) {
              f = h + "" + m + "" + b[k].prefix;
              break;
            }
          }
        else
          for (k = 0; k < c.length; k++)
            if (a <= c[k].number) {
              l = a / c[k].number;
              m = Math.abs(Math.floor(Math.log(l) * Math.LOG10E));
              l = d.roundTo(l, m);
              f = h + "" + l + "" + c[k].prefix;
              break;
            }
        return f;
      };
      d.remove = function(a) {
        a && a.remove();
      };
      d.getEffect = function(a) {
        ">" == a && (a = "easeOutSine");
        "<" == a && (a = "easeInSine");
        "elastic" == a && (a = "easeOutElastic");
        return a;
      };
      d.getObjById = function(a, b) {
        var c,
            e;
        for (e = 0; e < a.length; e++) {
          var d = a[e];
          if (d.id == b) {
            c = d;
            break;
          }
        }
        return c;
      };
      d.applyTheme = function(a, b, c) {
        b || (b = d.theme);
        try {
          b = JSON.parse(JSON.stringify(b));
        } catch (e) {}
        b && b[c] && d.extend(a, b[c]);
      };
      d.isString = function(a) {
        return "string" == typeof a ? !0 : !1;
      };
      d.extend = function(a, b, c) {
        var e;
        a || (a = {});
        for (e in b)
          c ? a.hasOwnProperty(e) || (a[e] = b[e]) : a[e] = b[e];
        return a;
      };
      d.copyProperties = function(a, b) {
        for (var c in a)
          a.hasOwnProperty(c) && "events" != c && void 0 !== a[c] && "function" != typeof a[c] && "cname" != c && (b[c] = a[c]);
      };
      d.processObject = function(a, b, c, e) {
        if (!1 === a instanceof b && (a = e ? d.extend(new b(c), a) : d.extend(a, new b(c), !0), a.listeners))
          for (var g in a.listeners)
            b = a.listeners[g], a.addListener(b.event, b.method);
        return a;
      };
      d.fixNewLines = function(a) {
        var b = RegExp("\\n", "g");
        a && (a = a.replace(b, "<br />"));
        return a;
      };
      d.fixBrakes = function(a) {
        if (d.isModern) {
          var b = RegExp("<br>", "g");
          a && (a = a.replace(b, "\n"));
        } else
          a = d.fixNewLines(a);
        return a;
      };
      d.deleteObject = function(a, b) {
        if (a) {
          if (void 0 === b || null === b)
            b = 20;
          if (0 !== b)
            if ("[object Array]" === Object.prototype.toString.call(a))
              for (var c = 0; c < a.length; c++)
                d.deleteObject(a[c], b - 1), a[c] = null;
            else if (a && !a.tagName)
              try {
                for (c in a.theme = null, a)
                  a[c] && ("object" == typeof a[c] && d.deleteObject(a[c], b - 1), "function" != typeof a[c] && (a[c] = null));
              } catch (e) {}
        }
      };
      d.bounce = function(a, b, c, e, d) {
        return (b /= d) < 1 / 2.75 ? 7.5625 * e * b * b + c : b < 2 / 2.75 ? e * (7.5625 * (b -= 1.5 / 2.75) * b + .75) + c : b < 2.5 / 2.75 ? e * (7.5625 * (b -= 2.25 / 2.75) * b + .9375) + c : e * (7.5625 * (b -= 2.625 / 2.75) * b + .984375) + c;
      };
      d.easeInOutQuad = function(a, b, c, e, d) {
        b /= d / 2;
        if (1 > b)
          return e / 2 * b * b + c;
        b--;
        return -e / 2 * (b * (b - 2) - 1) + c;
      };
      d.easeInSine = function(a, b, c, e, d) {
        return -e * Math.cos(b / d * (Math.PI / 2)) + e + c;
      };
      d.easeOutSine = function(a, b, c, e, d) {
        return e * Math.sin(b / d * (Math.PI / 2)) + c;
      };
      d.easeOutElastic = function(a, b, c, e, d) {
        a = 1.70158;
        var f = 0,
            h = e;
        if (0 === b)
          return c;
        if (1 == (b /= d))
          return c + e;
        f || (f = .3 * d);
        h < Math.abs(e) ? (h = e, a = f / 4) : a = f / (2 * Math.PI) * Math.asin(e / h);
        return h * Math.pow(2, -10 * b) * Math.sin(2 * (b * d - a) * Math.PI / f) + e + c;
      };
      d.fixStepE = function(a) {
        a = a.toExponential(0).split("e");
        var b = Number(a[1]);
        9 == Number(a[0]) && b++;
        return d.generateNumber(1, b);
      };
      d.generateNumber = function(a, b) {
        var c = "",
            e;
        e = 0 > b ? Math.abs(b) - 1 : Math.abs(b);
        var d;
        for (d = 0; d < e; d++)
          c += "0";
        return 0 > b ? Number("0." + c + String(a)) : Number(String(a) + c);
      };
      d.setCN = function(a, b, c, e) {
        if (a.addClassNames && b && (b = b.node) && c) {
          var d = b.getAttribute("class");
          a = a.classNamePrefix + "-";
          e && (a = "");
          d ? b.setAttribute("class", d + " " + a + c) : b.setAttribute("class", a + c);
        }
      };
      d.removeCN = function(a, b, c) {
        b && (b = b.node) && c && (b = b.classList) && b.remove(a.classNamePrefix + "-" + c);
      };
      d.parseDefs = function(a, b) {
        for (var c in a) {
          var e = typeof a[c];
          if (0 < a[c].length && "object" == e)
            for (var g = 0; g < a[c].length; g++)
              e = document.createElementNS(d.SVG_NS, c), b.appendChild(e), d.parseDefs(a[c][g], e);
          else
            "object" == e ? (e = document.createElementNS(d.SVG_NS, c), b.appendChild(e), d.parseDefs(a[c], e)) : b.setAttribute(c, a[c]);
        }
      };
    })();
    (function() {
      var d = window.AmCharts;
      d.AmDraw = d.Class({
        construct: function(a, b, c, e) {
          d.SVG_NS = "http://www.w3.org/2000/svg";
          d.SVG_XLINK = "http://www.w3.org/1999/xlink";
          d.hasSVG = !!document.createElementNS && !!document.createElementNS(d.SVG_NS, "svg").createSVGRect;
          1 > b && (b = 10);
          1 > c && (c = 10);
          this.div = a;
          this.width = b;
          this.height = c;
          this.rBin = document.createElement("div");
          d.hasSVG ? (d.SVG = !0, b = this.createSvgElement("svg"), a.appendChild(b), this.container = b, this.addDefs(e), this.R = new d.SVGRenderer(this)) : d.isIE && d.VMLRenderer && (d.VML = !0, d.vmlStyleSheet || (document.namespaces.add("amvml", "urn:schemas-microsoft-com:vml"), 31 > document.styleSheets.length ? (b = document.createStyleSheet(), b.addRule(".amvml", "behavior:url(#default#VML); display:inline-block; antialias:true"), d.vmlStyleSheet = b) : document.styleSheets[0].addRule(".amvml", "behavior:url(#default#VML); display:inline-block; antialias:true")), this.container = a, this.R = new d.VMLRenderer(this, e), this.R.disableSelection(a));
        },
        createSvgElement: function(a) {
          return document.createElementNS(d.SVG_NS, a);
        },
        circle: function(a, b, c, e) {
          var g = new d.AmDObject("circle", this);
          g.attr({
            r: c,
            cx: a,
            cy: b
          });
          this.addToContainer(g.node, e);
          return g;
        },
        ellipse: function(a, b, c, e, g) {
          var f = new d.AmDObject("ellipse", this);
          f.attr({
            rx: c,
            ry: e,
            cx: a,
            cy: b
          });
          this.addToContainer(f.node, g);
          return f;
        },
        setSize: function(a, b) {
          0 < a && 0 < b && (this.container.style.width = a + "px", this.container.style.height = b + "px");
        },
        rect: function(a, b, c, e, g, f, h) {
          var k = new d.AmDObject("rect", this);
          d.VML && (g = Math.round(100 * g / Math.min(c, e)), c += 2 * f, e += 2 * f, k.bw = f, k.node.style.marginLeft = -f, k.node.style.marginTop = -f);
          1 > c && (c = 1);
          1 > e && (e = 1);
          k.attr({
            x: a,
            y: b,
            width: c,
            height: e,
            rx: g,
            ry: g,
            "stroke-width": f
          });
          this.addToContainer(k.node, h);
          return k;
        },
        image: function(a, b, c, e, g, f) {
          var h = new d.AmDObject("image", this);
          h.attr({
            x: b,
            y: c,
            width: e,
            height: g
          });
          this.R.path(h, a);
          this.addToContainer(h.node, f);
          return h;
        },
        addToContainer: function(a, b) {
          b || (b = this.container);
          b.appendChild(a);
        },
        text: function(a, b, c) {
          return this.R.text(a, b, c);
        },
        path: function(a, b, c, e) {
          var g = new d.AmDObject("path", this);
          e || (e = "100,100");
          g.attr({cs: e});
          c ? g.attr({dd: a}) : g.attr({d: a});
          this.addToContainer(g.node, b);
          return g;
        },
        set: function(a) {
          return this.R.set(a);
        },
        remove: function(a) {
          if (a) {
            var b = this.rBin;
            b.appendChild(a);
            b.innerHTML = "";
          }
        },
        renderFix: function() {
          var a = this.container,
              b = a.style;
          b.top = "0px";
          b.left = "0px";
          try {
            var c = a.getBoundingClientRect(),
                e = c.left - Math.round(c.left),
                d = c.top - Math.round(c.top);
            e && (b.left = e + "px");
            d && (b.top = d + "px");
          } catch (f) {}
        },
        update: function() {
          this.R.update();
        },
        addDefs: function(a) {
          if (d.hasSVG) {
            var b = this.createSvgElement("desc"),
                c = this.container;
            c.setAttribute("version", "1.1");
            c.style.position = "absolute";
            this.setSize(this.width, this.height);
            if (a.accessibleTitle) {
              var e = this.createSvgElement("text");
              c.appendChild(e);
              e.innerHTML = a.accessibleTitle;
              e.style.opacity = 0;
            }
            d.rtl && (c.setAttribute("direction", "rtl"), c.style.left = "auto", c.style.right = "0px");
            a && (a.addCodeCredits && b.appendChild(document.createTextNode("JavaScript chart by amCharts " + a.version)), a.accessibleDescription && (b.innerHTML = "", b.appendChild(document.createTextNode(a.accessibleDescription))), c.appendChild(b), a.defs && (b = this.createSvgElement("defs"), c.appendChild(b), d.parseDefs(a.defs, b), this.defs = b));
          }
        }
      });
    })();
    (function() {
      var d = window.AmCharts;
      d.AmDObject = d.Class({
        construct: function(a, b) {
          this.D = b;
          this.R = b.R;
          this.node = this.R.create(this, a);
          this.y = this.x = 0;
          this.scale = 1;
        },
        attr: function(a) {
          this.R.attr(this, a);
          return this;
        },
        getAttr: function(a) {
          return this.node.getAttribute(a);
        },
        setAttr: function(a, b) {
          this.R.setAttr(this, a, b);
          return this;
        },
        clipRect: function(a, b, c, e) {
          this.R.clipRect(this, a, b, c, e);
        },
        translate: function(a, b, c, e) {
          e || (a = Math.round(a), b = Math.round(b));
          this.R.move(this, a, b, c);
          this.x = a;
          this.y = b;
          this.scale = c;
          this.angle && this.rotate(this.angle);
        },
        rotate: function(a, b) {
          this.R.rotate(this, a, b);
          this.angle = a;
        },
        animate: function(a, b, c) {
          for (var e in a)
            if (a.hasOwnProperty(e)) {
              var g = e,
                  f = a[e];
              c = d.getEffect(c);
              this.R.animate(this, g, f, b, c);
            }
        },
        push: function(a) {
          if (a) {
            var b = this.node;
            b.appendChild(a.node);
            var c = a.clipPath;
            c && b.appendChild(c);
            (a = a.grad) && b.appendChild(a);
          }
        },
        text: function(a) {
          this.R.setText(this, a);
        },
        remove: function() {
          this.stop();
          this.R.remove(this);
        },
        clear: function() {
          var a = this.node;
          if (a.hasChildNodes())
            for (; 1 <= a.childNodes.length; )
              a.removeChild(a.firstChild);
        },
        hide: function() {
          this.setAttr("visibility", "hidden");
        },
        show: function() {
          this.setAttr("visibility", "visible");
        },
        getBBox: function() {
          return this.R.getBBox(this);
        },
        toFront: function() {
          var a = this.node;
          if (a) {
            this.prevNextNode = a.nextSibling;
            var b = a.parentNode;
            b && b.appendChild(a);
          }
        },
        toPrevious: function() {
          var a = this.node;
          a && this.prevNextNode && (a = a.parentNode) && a.insertBefore(this.prevNextNode, null);
        },
        toBack: function() {
          var a = this.node;
          if (a) {
            this.prevNextNode = a.nextSibling;
            var b = a.parentNode;
            if (b) {
              var c = b.firstChild;
              c && b.insertBefore(a, c);
            }
          }
        },
        mouseover: function(a) {
          this.R.addListener(this, "mouseover", a);
          return this;
        },
        mouseout: function(a) {
          this.R.addListener(this, "mouseout", a);
          return this;
        },
        click: function(a) {
          this.R.addListener(this, "click", a);
          return this;
        },
        dblclick: function(a) {
          this.R.addListener(this, "dblclick", a);
          return this;
        },
        mousedown: function(a) {
          this.R.addListener(this, "mousedown", a);
          return this;
        },
        mouseup: function(a) {
          this.R.addListener(this, "mouseup", a);
          return this;
        },
        touchmove: function(a) {
          this.R.addListener(this, "touchmove", a);
          return this;
        },
        touchstart: function(a) {
          this.R.addListener(this, "touchstart", a);
          return this;
        },
        touchend: function(a) {
          this.R.addListener(this, "touchend", a);
          return this;
        },
        keyup: function(a) {
          this.R.addListener(this, "keyup", a);
          return this;
        },
        focus: function(a) {
          this.R.addListener(this, "focus", a);
          return this;
        },
        blur: function(a) {
          this.R.addListener(this, "blur", a);
          return this;
        },
        contextmenu: function(a) {
          this.node.addEventListener ? this.node.addEventListener("contextmenu", a, !0) : this.R.addListener(this, "contextmenu", a);
          return this;
        },
        stop: function() {
          d.removeFromArray(this.R.animations, this.an_translate);
          d.removeFromArray(this.R.animations, this.an_y);
          d.removeFromArray(this.R.animations, this.an_x);
        },
        length: function() {
          return this.node.childNodes.length;
        },
        gradient: function(a, b, c) {
          this.R.gradient(this, a, b, c);
        },
        pattern: function(a, b, c) {
          a && this.R.pattern(this, a, b, c);
        }
      });
    })();
    (function() {
      var d = window.AmCharts;
      d.SVGRenderer = d.Class({
        construct: function(a) {
          this.D = a;
          this.animations = [];
        },
        create: function(a, b) {
          return document.createElementNS(d.SVG_NS, b);
        },
        attr: function(a, b) {
          for (var c in b)
            b.hasOwnProperty(c) && this.setAttr(a, c, b[c]);
        },
        setAttr: function(a, b, c) {
          void 0 !== c && a.node.setAttribute(b, c);
        },
        animate: function(a, b, c, e, g) {
          a.animationFinished = !1;
          var f = a.node;
          a["an_" + b] && d.removeFromArray(this.animations, a["an_" + b]);
          "translate" == b ? (f = (f = f.getAttribute("transform")) ? String(f).substring(10, f.length - 1) : "0,0", f = f.split(", ").join(" "), f = f.split(" ").join(","), 0 === f && (f = "0,0")) : f = Number(f.getAttribute(b));
          c = {
            obj: a,
            frame: 0,
            attribute: b,
            from: f,
            to: c,
            time: e,
            effect: g
          };
          this.animations.push(c);
          a["an_" + b] = c;
        },
        update: function() {
          var a,
              b = this.animations;
          for (a = b.length - 1; 0 <= a; a--) {
            var c = b[a],
                e = c.time * d.updateRate,
                g = c.frame + 1,
                f = c.obj,
                h = c.attribute,
                k,
                l,
                m;
            if (g <= e) {
              c.frame++;
              if ("translate" == h) {
                k = c.from.split(",");
                h = Number(k[0]);
                k = Number(k[1]);
                isNaN(k) && (k = 0);
                l = c.to.split(",");
                m = Number(l[0]);
                l = Number(l[1]);
                m = 0 === m - h ? m : Math.round(d[c.effect](0, g, h, m - h, e));
                c = 0 === l - k ? l : Math.round(d[c.effect](0, g, k, l - k, e));
                h = "transform";
                if (isNaN(m) || isNaN(c))
                  continue;
                c = "translate(" + m + "," + c + ")";
              } else
                l = Number(c.from), k = Number(c.to), m = k - l, c = d[c.effect](0, g, l, m, e), isNaN(c) && (c = k), 0 === m && this.animations.splice(a, 1);
              this.setAttr(f, h, c);
            } else
              "translate" == h ? (l = c.to.split(","), m = Number(l[0]), l = Number(l[1]), f.translate(m, l)) : (k = Number(c.to), this.setAttr(f, h, k)), f.animationFinished = !0, this.animations.splice(a, 1);
          }
        },
        getBBox: function(a) {
          if (a = a.node)
            try {
              return a.getBBox();
            } catch (b) {}
          return {
            width: 0,
            height: 0,
            x: 0,
            y: 0
          };
        },
        path: function(a, b) {
          a.node.setAttributeNS(d.SVG_XLINK, "xlink:href", b);
        },
        clipRect: function(a, b, c, e, g) {
          var f = a.node,
              h = a.clipPath;
          h && this.D.remove(h);
          var k = f.parentNode;
          k && (f = document.createElementNS(d.SVG_NS, "clipPath"), h = d.getUniqueId(), f.setAttribute("id", h), this.D.rect(b, c, e, g, 0, 0, f), k.appendChild(f), b = "#", d.baseHref && !d.isIE && (b = this.removeTarget(window.location.href) + b), this.setAttr(a, "clip-path", "url(" + b + h + ")"), this.clipPathC++, a.clipPath = f);
        },
        text: function(a, b, c) {
          var e = new d.AmDObject("text", this.D);
          a = String(a).split("\n");
          var g = d.removePx(b["font-size"]),
              f;
          for (f = 0; f < a.length; f++) {
            var h = this.create(null, "tspan");
            h.appendChild(document.createTextNode(a[f]));
            h.setAttribute("y", (g + 2) * f + Math.round(g / 2));
            h.setAttribute("x", 0);
            e.node.appendChild(h);
          }
          e.node.setAttribute("y", Math.round(g / 2));
          this.attr(e, b);
          this.D.addToContainer(e.node, c);
          return e;
        },
        setText: function(a, b) {
          var c = a.node;
          c && (c.removeChild(c.firstChild), c.appendChild(document.createTextNode(b)));
        },
        move: function(a, b, c, e) {
          isNaN(b) && (b = 0);
          isNaN(c) && (c = 0);
          b = "translate(" + b + "," + c + ")";
          e && (b = b + " scale(" + e + ")");
          this.setAttr(a, "transform", b);
        },
        rotate: function(a, b) {
          var c = a.node.getAttribute("transform"),
              e = "rotate(" + b + ")";
          c && (e = c + " " + e);
          this.setAttr(a, "transform", e);
        },
        set: function(a) {
          var b = new d.AmDObject("g", this.D);
          this.D.container.appendChild(b.node);
          if (a) {
            var c;
            for (c = 0; c < a.length; c++)
              b.push(a[c]);
          }
          return b;
        },
        addListener: function(a, b, c) {
          a.node["on" + b] = c;
        },
        gradient: function(a, b, c, e) {
          var g = a.node,
              f = a.grad;
          f && this.D.remove(f);
          b = document.createElementNS(d.SVG_NS, b);
          f = d.getUniqueId();
          b.setAttribute("id", f);
          if (!isNaN(e)) {
            var h = 0,
                k = 0,
                l = 0,
                m = 0;
            90 == e ? l = 100 : 270 == e ? m = 100 : 180 == e ? h = 100 : 0 === e && (k = 100);
            b.setAttribute("x1", h + "%");
            b.setAttribute("x2", k + "%");
            b.setAttribute("y1", l + "%");
            b.setAttribute("y2", m + "%");
          }
          for (e = 0; e < c.length; e++)
            h = document.createElementNS(d.SVG_NS, "stop"), k = 100 * e / (c.length - 1), 0 === e && (k = 0), h.setAttribute("offset", k + "%"), h.setAttribute("stop-color", c[e]), b.appendChild(h);
          g.parentNode.appendChild(b);
          c = "#";
          d.baseHref && !d.isIE && (c = this.removeTarget(window.location.href) + c);
          g.setAttribute("fill", "url(" + c + f + ")");
          a.grad = b;
        },
        removeTarget: function(a) {
          return a.split("#")[0];
        },
        pattern: function(a, b, c, e) {
          var g = a.node;
          isNaN(c) && (c = 1);
          var f = a.patternNode;
          f && this.D.remove(f);
          var f = document.createElementNS(d.SVG_NS, "pattern"),
              h = d.getUniqueId(),
              k = b;
          b.url && (k = b.url);
          d.isAbsolute(k) || -1 != k.indexOf("data:image") || (k = e + k);
          e = Number(b.width);
          isNaN(e) && (e = 4);
          var l = Number(b.height);
          isNaN(l) && (l = 4);
          e /= c;
          l /= c;
          c = b.x;
          isNaN(c) && (c = 0);
          var m = -Math.random() * Number(b.randomX);
          isNaN(m) || (c = m);
          m = b.y;
          isNaN(m) && (m = 0);
          var n = -Math.random() * Number(b.randomY);
          isNaN(n) || (m = n);
          f.setAttribute("id", h);
          f.setAttribute("width", e);
          f.setAttribute("height", l);
          f.setAttribute("patternUnits", "userSpaceOnUse");
          f.setAttribute("xlink:href", k);
          b.color && (n = document.createElementNS(d.SVG_NS, "rect"), n.setAttributeNS(null, "height", e), n.setAttributeNS(null, "width", l), n.setAttributeNS(null, "fill", b.color), f.appendChild(n));
          this.D.image(k, 0, 0, e, l, f).translate(c, m);
          k = "#";
          d.baseHref && !d.isIE && (k = this.removeTarget(window.location.href) + k);
          g.setAttribute("fill", "url(" + k + h + ")");
          a.patternNode = f;
          g.parentNode.appendChild(f);
        },
        remove: function(a) {
          a.clipPath && this.D.remove(a.clipPath);
          a.grad && this.D.remove(a.grad);
          a.patternNode && this.D.remove(a.patternNode);
          this.D.remove(a.node);
        }
      });
    })();
    (function() {
      var d = window.AmCharts;
      d.AmChart = d.Class({
        construct: function(a) {
          this.svgIcons = this.tapToActivate = !0;
          this.theme = a;
          this.classNamePrefix = "amcharts";
          this.addClassNames = !1;
          this.version = "3.21.12";
          d.addChart(this);
          this.createEvents("buildStarted", "dataUpdated", "init", "rendered", "drawn", "failed", "resized", "animationFinished");
          this.height = this.width = "100%";
          this.dataChanged = !0;
          this.chartCreated = !1;
          this.previousWidth = this.previousHeight = 0;
          this.backgroundColor = "#FFFFFF";
          this.borderAlpha = this.backgroundAlpha = 0;
          this.color = this.borderColor = "#000000";
          this.fontFamily = "Verdana";
          this.fontSize = 8;
          this.usePrefixes = !1;
          this.autoResize = !0;
          this.autoDisplay = !1;
          this.addCodeCredits = this.accessible = !0;
          this.touchStartTime = this.touchClickDuration = 0;
          this.precision = -1;
          this.percentPrecision = 2;
          this.decimalSeparator = ".";
          this.thousandsSeparator = ",";
          this.labels = [];
          this.allLabels = [];
          this.titles = [];
          this.marginRight = this.marginLeft = this.autoMarginOffset = 0;
          this.timeOuts = [];
          this.creditsPosition = "top-left";
          var b = document.createElement("div"),
              c = b.style;
          c.overflow = "hidden";
          c.position = "relative";
          c.textAlign = "left";
          this.chartDiv = b;
          b = document.createElement("div");
          c = b.style;
          c.overflow = "hidden";
          c.position = "relative";
          c.textAlign = "left";
          this.legendDiv = b;
          this.titleHeight = 0;
          this.hideBalloonTime = 150;
          this.handDrawScatter = 2;
          this.cssScale = this.handDrawThickness = 1;
          this.cssAngle = 0;
          this.prefixesOfBigNumbers = [{
            number: 1E3,
            prefix: "k"
          }, {
            number: 1E6,
            prefix: "M"
          }, {
            number: 1E9,
            prefix: "G"
          }, {
            number: 1E12,
            prefix: "T"
          }, {
            number: 1E15,
            prefix: "P"
          }, {
            number: 1E18,
            prefix: "E"
          }, {
            number: 1E21,
            prefix: "Z"
          }, {
            number: 1E24,
            prefix: "Y"
          }];
          this.prefixesOfSmallNumbers = [{
            number: 1E-24,
            prefix: "y"
          }, {
            number: 1E-21,
            prefix: "z"
          }, {
            number: 1E-18,
            prefix: "a"
          }, {
            number: 1E-15,
            prefix: "f"
          }, {
            number: 1E-12,
            prefix: "p"
          }, {
            number: 1E-9,
            prefix: "n"
          }, {
            number: 1E-6,
            prefix: "\u03bc"
          }, {
            number: .001,
            prefix: "m"
          }];
          this.panEventsEnabled = !0;
          this.product = "amcharts";
          this.animations = [];
          this.balloon = new d.AmBalloon(this.theme);
          this.balloon.chart = this;
          this.processTimeout = 0;
          this.processCount = 1E3;
          this.animatable = [];
          this.langObj = {};
          d.applyTheme(this, a, "AmChart");
        },
        drawChart: function() {
          0 < this.realWidth && 0 < this.realHeight && (this.drawBackground(), this.redrawLabels(), this.drawTitles(), this.brr(), this.renderFix(), this.chartDiv && (this.boundingRect = this.chartDiv.getBoundingClientRect()));
        },
        makeAccessible: function(a, b, c) {
          this.accessible && a && (c && a.setAttr("role", c), a.setAttr("aria-label", b));
        },
        drawBackground: function() {
          d.remove(this.background);
          var a = this.container,
              b = this.backgroundColor,
              c = this.backgroundAlpha,
              e = this.set;
          d.isModern || 0 !== c || (c = .001);
          var g = this.updateWidth();
          this.realWidth = g;
          var f = this.updateHeight();
          this.realHeight = f;
          b = d.polygon(a, [0, g - 1, g - 1, 0], [0, 0, f - 1, f - 1], b, c, 1, this.borderColor, this.borderAlpha);
          d.setCN(this, b, "bg");
          this.background = b;
          e.push(b);
          if (b = this.backgroundImage)
            a = a.image(b, 0, 0, g, f), d.setCN(this, b, "bg-image"), this.bgImg = a, e.push(a);
        },
        drawTitles: function(a) {
          var b = this.titles;
          this.titleHeight = 0;
          if (d.ifArray(b)) {
            var c = 20,
                e;
            for (e = 0; e < b.length; e++) {
              var g = b[e],
                  g = d.processObject(g, d.Title, this.theme);
              if (!1 !== g.enabled) {
                var f = g.color;
                void 0 === f && (f = this.color);
                var h = g.size;
                isNaN(h) && (h = this.fontSize + 2);
                isNaN(g.alpha);
                var k = this.marginLeft,
                    l = !0;
                void 0 !== g.bold && (l = g.bold);
                f = d.wrappedText(this.container, g.text, f, this.fontFamily, h, "middle", l, this.realWidth - 35 - this.marginRight - k);
                f.translate(k + (this.realWidth - this.marginRight - k) / 2, c);
                f.node.style.pointerEvents = "none";
                g.sprite = f;
                void 0 !== g.tabIndex && f.setAttr("tabindex", g.tabIndex);
                d.setCN(this, f, "title");
                g.id && d.setCN(this, f, "title-" + g.id);
                f.attr({opacity: g.alpha});
                c += f.getBBox().height + 5;
                a ? f.remove() : this.freeLabelsSet.push(f);
              }
            }
            this.titleHeight = c - 10;
          }
        },
        write: function(a) {
          var b = this;
          if (b.listeners)
            for (var c = 0; c < b.listeners.length; c++) {
              var e = b.listeners[c];
              b.addListener(e.event, e.method);
            }
          b.fire({
            type: "buildStarted",
            chart: b
          });
          b.afterWriteTO && clearTimeout(b.afterWriteTO);
          0 < b.processTimeout ? b.afterWriteTO = setTimeout(function() {
            b.afterWrite.call(b, a);
          }, b.processTimeout) : b.afterWrite(a);
        },
        afterWrite: function(a) {
          var b;
          if (b = "object" != typeof a ? document.getElementById(a) : a) {
            for (; b.firstChild; )
              b.removeChild(b.firstChild);
            this.div = b;
            b.style.overflow = "hidden";
            b.style.textAlign = "left";
            a = this.chartDiv;
            var c = this.legendDiv,
                e = this.legend,
                g = c.style,
                f = a.style;
            this.measure();
            this.previousHeight = this.divRealHeight;
            this.previousWidth = this.divRealWidth;
            var h,
                k = document.createElement("div");
            h = k.style;
            h.position = "relative";
            this.containerDiv = k;
            k.className = this.classNamePrefix + "-main-div";
            a.className = this.classNamePrefix + "-chart-div";
            b.appendChild(k);
            (b = this.exportConfig) && d.AmExport && !this.AmExport && (this.AmExport = new d.AmExport(this, b));
            this.amExport && d.AmExport && (this.AmExport = d.extend(this.amExport, new d.AmExport(this), !0));
            this.AmExport && this.AmExport.init && this.AmExport.init();
            if (e) {
              e = this.addLegend(e, e.divId);
              if (e.enabled)
                switch (g.left = null, g.top = null, g.right = null, f.left = null, f.right = null, f.top = null, g.position = "relative", f.position = "relative", h.width = "100%", h.height = "100%", e.position) {
                  case "bottom":
                    k.appendChild(a);
                    k.appendChild(c);
                    break;
                  case "top":
                    k.appendChild(c);
                    k.appendChild(a);
                    break;
                  case "absolute":
                    g.position = "absolute";
                    f.position = "absolute";
                    void 0 !== e.left && (g.left = e.left + "px");
                    void 0 !== e.right && (g.right = e.right + "px");
                    void 0 !== e.top && (g.top = e.top + "px");
                    void 0 !== e.bottom && (g.bottom = e.bottom + "px");
                    e.marginLeft = 0;
                    e.marginRight = 0;
                    k.appendChild(a);
                    k.appendChild(c);
                    break;
                  case "right":
                    g.position = "relative";
                    f.position = "absolute";
                    k.appendChild(a);
                    k.appendChild(c);
                    break;
                  case "left":
                    g.position = "absolute";
                    f.position = "relative";
                    k.appendChild(a);
                    k.appendChild(c);
                    break;
                  case "outside":
                    k.appendChild(a);
                }
              else
                k.appendChild(a);
              this.prevLegendPosition = e.position;
            } else
              k.appendChild(a);
            this.listenersAdded || (this.addListeners(), this.listenersAdded = !0);
            (this.mouseWheelScrollEnabled || this.mouseWheelZoomEnabled) && d.addWheelListeners();
            this.initChart();
          }
        },
        createLabelsSet: function() {
          d.remove(this.labelsSet);
          this.labelsSet = this.container.set();
          this.freeLabelsSet.push(this.labelsSet);
        },
        initChart: function() {
          this.balloon = d.processObject(this.balloon, d.AmBalloon, this.theme);
          window.AmCharts_path && (this.path = window.AmCharts_path);
          void 0 === this.path && (this.path = d.getPath());
          void 0 === this.path && (this.path = "amcharts/");
          this.path = d.normalizeUrl(this.path);
          void 0 === this.pathToImages && (this.pathToImages = this.path + "images/");
          this.initHC || (d.callInitHandler(this), this.initHC = !0);
          d.applyLang(this.language, this);
          var a = this.numberFormatter;
          a && (isNaN(a.precision) || (this.precision = a.precision), void 0 !== a.thousandsSeparator && (this.thousandsSeparator = a.thousandsSeparator), void 0 !== a.decimalSeparator && (this.decimalSeparator = a.decimalSeparator));
          (a = this.percentFormatter) && !isNaN(a.precision) && (this.percentPrecision = a.precision);
          this.nf = {
            precision: this.precision,
            thousandsSeparator: this.thousandsSeparator,
            decimalSeparator: this.decimalSeparator
          };
          this.pf = {
            precision: this.percentPrecision,
            thousandsSeparator: this.thousandsSeparator,
            decimalSeparator: this.decimalSeparator
          };
          this.destroy();
          (a = this.container) ? (a.container.innerHTML = "", a.width = this.realWidth, a.height = this.realHeight, a.addDefs(this), this.chartDiv.appendChild(a.container)) : a = new d.AmDraw(this.chartDiv, this.realWidth, this.realHeight, this);
          this.container = a;
          this.extension = ".png";
          this.svgIcons && d.SVG && (this.extension = ".svg");
          this.checkDisplay();
          this.checkTransform(this.div);
          a.chart = this;
          d.VML || d.SVG ? (a.handDrawn = this.handDrawn, a.handDrawScatter = this.handDrawScatter, a.handDrawThickness = this.handDrawThickness, d.remove(this.set), this.set = a.set(), d.remove(this.gridSet), this.gridSet = a.set(), d.remove(this.cursorLineSet), this.cursorLineSet = a.set(), d.remove(this.graphsBehindSet), this.graphsBehindSet = a.set(), d.remove(this.bulletBehindSet), this.bulletBehindSet = a.set(), d.remove(this.columnSet), this.columnSet = a.set(), d.remove(this.graphsSet), this.graphsSet = a.set(), d.remove(this.trendLinesSet), this.trendLinesSet = a.set(), d.remove(this.axesSet), this.axesSet = a.set(), d.remove(this.cursorSet), this.cursorSet = a.set(), d.remove(this.scrollbarsSet), this.scrollbarsSet = a.set(), d.remove(this.bulletSet), this.bulletSet = a.set(), d.remove(this.freeLabelsSet), this.freeLabelsSet = a.set(), d.remove(this.axesLabelsSet), this.axesLabelsSet = a.set(), d.remove(this.balloonsSet), this.balloonsSet = a.set(), d.remove(this.plotBalloonsSet), this.plotBalloonsSet = a.set(), d.remove(this.zoomButtonSet), this.zoomButtonSet = a.set(), d.remove(this.zbSet), this.zbSet = null, d.remove(this.linkSet), this.linkSet = a.set()) : this.fire({
            type: "failed",
            chart: this
          });
        },
        premeasure: function() {
          var a = this.div;
          if (a) {
            try {
              this.boundingRect = this.chartDiv.getBoundingClientRect();
            } catch (e) {}
            var b = a.offsetWidth,
                c = a.offsetHeight;
            a.clientHeight && (b = a.clientWidth, c = a.clientHeight);
            if (b != this.mw || c != this.mh)
              this.mw = b, this.mh = c, this.measure();
          }
        },
        measure: function() {
          var a = this.div;
          if (a) {
            var b = this.chartDiv,
                c = a.offsetWidth,
                e = a.offsetHeight,
                g = this.container;
            a.clientHeight && (c = a.clientWidth, e = a.clientHeight);
            var e = Math.round(e),
                c = Math.round(c),
                a = Math.round(d.toCoordinate(this.width, c)),
                f = Math.round(d.toCoordinate(this.height, e));
            (c != this.previousWidth || e != this.previousHeight) && 0 < a && 0 < f && (b.style.width = a + "px", b.style.height = f + "px", b.style.padding = 0, g && g.setSize(a, f), this.balloon = d.processObject(this.balloon, d.AmBalloon, this.theme));
            this.balloon && this.balloon.setBounds && this.balloon.setBounds(2, 2, a - 2, f);
            this.updateWidth();
            this.balloon.chart = this;
            this.realWidth = a;
            this.realHeight = f;
            this.divRealWidth = c;
            this.divRealHeight = e;
          }
        },
        checkDisplay: function() {
          if (this.autoDisplay && this.container) {
            var a = d.rect(this.container, 10, 10),
                b = a.getBBox();
            0 === b.width && 0 === b.height && (this.divRealHeight = this.divRealWidth = this.realHeight = this.realWidth = 0, this.previousWidth = this.previousHeight = NaN);
            a.remove();
          }
        },
        checkTransform: function(a) {
          if (this.autoTransform && window.getComputedStyle && a) {
            if (a.style) {
              var b = window.getComputedStyle(a, null);
              if (b && (b = b.getPropertyValue("-webkit-transform") || b.getPropertyValue("-moz-transform") || b.getPropertyValue("-ms-transform") || b.getPropertyValue("-o-transform") || b.getPropertyValue("transform")) && "none" !== b) {
                var c = b.split("(")[1].split(")")[0].split(","),
                    b = c[0],
                    c = c[1],
                    b = Math.sqrt(b * b + c * c);
                isNaN(b) || (this.cssScale *= b);
              }
            }
            a.parentNode && this.checkTransform(a.parentNode);
          }
        },
        destroy: function() {
          this.chartDiv.innerHTML = "";
          this.clearTimeOuts();
          this.legend && this.legend.destroy();
        },
        clearTimeOuts: function() {
          var a = this.timeOuts;
          if (a) {
            var b;
            for (b = 0; b < a.length; b++)
              clearTimeout(a[b]);
          }
          this.timeOuts = [];
        },
        clear: function(a) {
          try {
            document.removeEventListener("touchstart", this.docfn1, !0), document.removeEventListener("touchend", this.docfn2, !0);
          } catch (b) {}
          d.callMethod("clear", [this.chartScrollbar, this.scrollbarV, this.scrollbarH, this.chartCursor]);
          this.chartCursor = this.scrollbarH = this.scrollbarV = this.chartScrollbar = null;
          this.clearTimeOuts();
          this.container && (this.container.remove(this.chartDiv), this.container.remove(this.legendDiv));
          a || d.removeChart(this);
          if (a = this.div)
            for (; a.firstChild; )
              a.removeChild(a.firstChild);
          this.legend && this.legend.destroy();
          this.AmExport && this.AmExport.clear && this.AmExport.clear();
        },
        setMouseCursor: function(a) {
          "auto" == a && d.isNN && (a = "default");
          this.chartDiv.style.cursor = a;
          this.legendDiv.style.cursor = a;
        },
        redrawLabels: function() {
          this.labels = [];
          var a = this.allLabels;
          this.createLabelsSet();
          var b;
          for (b = 0; b < a.length; b++)
            this.drawLabel(a[b]);
        },
        drawLabel: function(a) {
          var b = this;
          if (b.container && !1 !== a.enabled) {
            a = d.processObject(a, d.Label, b.theme);
            var c = a.y,
                e = a.text,
                g = a.align,
                f = a.size,
                h = a.color,
                k = a.rotation,
                l = a.alpha,
                m = a.bold,
                n = d.toCoordinate(a.x, b.realWidth),
                c = d.toCoordinate(c, b.realHeight);
            n || (n = 0);
            c || (c = 0);
            void 0 === h && (h = b.color);
            isNaN(f) && (f = b.fontSize);
            g || (g = "start");
            "left" == g && (g = "start");
            "right" == g && (g = "end");
            "center" == g && (g = "middle", k ? c = b.realHeight - c + c / 2 : n = b.realWidth / 2 - n);
            void 0 === l && (l = 1);
            void 0 === k && (k = 0);
            c += f / 2;
            e = d.text(b.container, e, h, b.fontFamily, f, g, m, l);
            e.translate(n, c);
            void 0 !== a.tabIndex && e.setAttr("tabindex", a.tabIndex);
            d.setCN(b, e, "label");
            a.id && d.setCN(b, e, "label-" + a.id);
            0 !== k && e.rotate(k);
            a.url ? (e.setAttr("cursor", "pointer"), e.click(function() {
              d.getURL(a.url, b.urlTarget);
            })) : e.node.style.pointerEvents = "none";
            b.labelsSet.push(e);
            b.labels.push(e);
          }
        },
        addLabel: function(a, b, c, e, d, f, h, k, l, m) {
          a = {
            x: a,
            y: b,
            text: c,
            align: e,
            size: d,
            color: f,
            alpha: k,
            rotation: h,
            bold: l,
            url: m,
            enabled: !0
          };
          this.container && this.drawLabel(a);
          this.allLabels.push(a);
        },
        clearLabels: function() {
          var a = this.labels,
              b;
          for (b = a.length - 1; 0 <= b; b--)
            a[b].remove();
          this.labels = [];
          this.allLabels = [];
        },
        updateHeight: function() {
          var a = this.divRealHeight,
              b = this.legend;
          if (b) {
            var c = this.legendDiv.offsetHeight,
                b = b.position;
            if ("top" == b || "bottom" == b) {
              a -= c;
              if (0 > a || isNaN(a))
                a = 0;
              this.chartDiv.style.height = a + "px";
            }
          }
          return a;
        },
        updateWidth: function() {
          var a = this.divRealWidth,
              b = this.divRealHeight,
              c = this.legend;
          if (c) {
            var e = this.legendDiv,
                d = e.offsetWidth;
            isNaN(c.width) || (d = c.width);
            c.ieW && (d = c.ieW);
            var f = e.offsetHeight,
                e = e.style,
                h = this.chartDiv.style,
                k = c.position;
            if (("right" == k || "left" == k) && void 0 === c.divId) {
              a -= d;
              if (0 > a || isNaN(a))
                a = 0;
              h.width = a + "px";
              this.balloon && this.balloon.setBounds && this.balloon.setBounds(2, 2, a - 2, this.realHeight);
              "left" == k ? (h.left = d + "px", e.left = "0px") : (h.left = "0px", e.left = a + "px");
              b > f && (e.top = (b - f) / 2 + "px");
            }
          }
          return a;
        },
        getTitleHeight: function() {
          this.drawTitles(!0);
          return this.titleHeight;
        },
        addTitle: function(a, b, c, e, d) {
          isNaN(b) && (b = this.fontSize + 2);
          a = {
            text: a,
            size: b,
            color: c,
            alpha: e,
            bold: d,
            enabled: !0
          };
          this.titles.push(a);
          return a;
        },
        handleWheel: function(a) {
          var b = 0;
          a || (a = window.event);
          a.wheelDelta ? b = a.wheelDelta / 120 : a.detail && (b = -a.detail / 3);
          b && this.handleWheelReal(b, a.shiftKey);
          a.preventDefault && a.preventDefault();
        },
        handleWheelReal: function() {},
        handleDocTouchStart: function() {
          this.handleMouseMove();
          this.tmx = this.mouseX;
          this.tmy = this.mouseY;
          this.touchStartTime = (new Date).getTime();
        },
        handleDocTouchEnd: function() {
          -.5 < this.tmx && this.tmx < this.divRealWidth + 1 && 0 < this.tmy && this.tmy < this.divRealHeight ? (this.handleMouseMove(), 4 > Math.abs(this.mouseX - this.tmx) && 4 > Math.abs(this.mouseY - this.tmy) ? (this.tapped = !0, this.panRequired && this.panEventsEnabled && this.chartDiv && (this.chartDiv.style.msTouchAction = "none", this.chartDiv.style.touchAction = "none")) : this.mouseIsOver || this.resetTouchStyle()) : (this.tapped = !1, this.resetTouchStyle());
        },
        resetTouchStyle: function() {
          this.panEventsEnabled && this.chartDiv && (this.chartDiv.style.msTouchAction = "auto", this.chartDiv.style.touchAction = "auto");
        },
        checkTouchDuration: function(a) {
          var b = this,
              c = (new Date).getTime();
          if (a)
            if (a.touches)
              b.isTouchEvent = !0;
            else if (!b.isTouchEvent)
              return !0;
          if (c - b.touchStartTime > b.touchClickDuration)
            return !0;
          setTimeout(function() {
            b.resetTouchDuration();
          }, 300);
        },
        resetTouchDuration: function() {
          this.isTouchEvent = !1;
        },
        checkTouchMoved: function() {
          if (4 < Math.abs(this.mouseX - this.tmx) || 4 < Math.abs(this.mouseY - this.tmy))
            return !0;
        },
        addListeners: function() {
          var a = this,
              b = a.chartDiv;
          document.addEventListener ? ("ontouchstart" in document.documentElement && (b.addEventListener("touchstart", function(b) {
            a.handleTouchStart.call(a, b);
          }, !0), b.addEventListener("touchmove", function(b) {
            a.handleMouseMove.call(a, b);
          }, !0), b.addEventListener("touchend", function(b) {
            a.handleTouchEnd.call(a, b);
          }, !0), a.docfn1 = function(b) {
            a.handleDocTouchStart.call(a, b);
          }, a.docfn2 = function(b) {
            a.handleDocTouchEnd.call(a, b);
          }, document.addEventListener("touchstart", a.docfn1, !0), document.addEventListener("touchend", a.docfn2, !0)), b.addEventListener("mousedown", function(b) {
            a.mouseIsOver = !0;
            a.handleMouseMove.call(a, b);
            a.handleMouseDown.call(a, b);
            a.handleDocTouchStart.call(a, b);
          }, !0), b.addEventListener("mouseover", function(b) {
            a.handleMouseOver.call(a, b);
          }, !0), b.addEventListener("mouseout", function(b) {
            a.handleMouseOut.call(a, b);
          }, !0), b.addEventListener("mouseup", function(b) {
            a.handleDocTouchEnd.call(a, b);
          }, !0)) : (b.attachEvent("onmousedown", function(b) {
            a.handleMouseDown.call(a, b);
          }), b.attachEvent("onmouseover", function(b) {
            a.handleMouseOver.call(a, b);
          }), b.attachEvent("onmouseout", function(b) {
            a.handleMouseOut.call(a, b);
          }));
        },
        dispDUpd: function() {
          this.skipEvents || (this.dispatchDataUpdated && (this.dispatchDataUpdated = !1, this.fire({
            type: "dataUpdated",
            chart: this
          })), this.chartCreated || (this.chartCreated = !0, this.fire({
            type: "init",
            chart: this
          })), this.chartRendered || (this.fire({
            type: "rendered",
            chart: this
          }), this.chartRendered = !0), this.fire({
            type: "drawn",
            chart: this
          }));
          this.skipEvents = !1;
        },
        validateSize: function() {
          var a = this;
          a.premeasure();
          a.checkDisplay();
          a.cssScale = 1;
          a.cssAngle = 0;
          a.checkTransform(a.div);
          if (a.divRealWidth != a.previousWidth || a.divRealHeight != a.previousHeight) {
            var b = a.legend;
            if (0 < a.realWidth && 0 < a.realHeight) {
              a.sizeChanged = !0;
              if (b) {
                a.legendInitTO && clearTimeout(a.legendInitTO);
                var c = setTimeout(function() {
                  b.invalidateSize();
                }, 10);
                a.timeOuts.push(c);
                a.legendInitTO = c;
              }
              a.marginsUpdated = !1;
              clearTimeout(a.initTO);
              c = setTimeout(function() {
                a.initChart();
              }, 10);
              a.timeOuts.push(c);
              a.initTO = c;
            }
            a.renderFix();
            b && b.renderFix && b.renderFix();
            a.positionCred();
            clearTimeout(a.resizedTO);
            a.resizedTO = setTimeout(function() {
              a.fire({
                type: "resized",
                chart: a
              });
            }, 10);
            a.previousHeight = a.divRealHeight;
            a.previousWidth = a.divRealWidth;
          }
        },
        invalidateSize: function() {
          this.previousHeight = this.previousWidth = NaN;
          this.invalidateSizeReal();
        },
        invalidateSizeReal: function() {
          var a = this;
          a.marginsUpdated = !1;
          clearTimeout(a.validateTO);
          var b = setTimeout(function() {
            a.validateSize();
          }, 5);
          a.timeOuts.push(b);
          a.validateTO = b;
        },
        validateData: function(a) {
          this.chartCreated && (this.dataChanged = !0, this.marginsUpdated = !1, this.initChart(a));
        },
        validateNow: function(a, b) {
          this.initTO && clearTimeout(this.initTO);
          a && (this.dataChanged = !0, this.marginsUpdated = !1);
          this.skipEvents = b;
          this.chartRendered = !1;
          var c = this.legend;
          c && c.position != this.prevLegendPosition && (this.previousWidth = this.mw = 0, c.invalidateSize && (c.invalidateSize(), this.validateSize()));
          this.write(this.div);
        },
        showItem: function(a) {
          a.hidden = !1;
          this.initChart();
        },
        hideItem: function(a) {
          a.hidden = !0;
          this.initChart();
        },
        hideBalloon: function() {
          var a = this;
          clearTimeout(a.hoverInt);
          clearTimeout(a.balloonTO);
          a.hoverInt = setTimeout(function() {
            a.hideBalloonReal.call(a);
          }, a.hideBalloonTime);
        },
        cleanChart: function() {},
        hideBalloonReal: function() {
          var a = this.balloon;
          a && a.hide && a.hide();
        },
        showBalloon: function(a, b, c, e, d) {
          var f = this;
          clearTimeout(f.balloonTO);
          clearTimeout(f.hoverInt);
          f.balloonTO = setTimeout(function() {
            f.showBalloonReal.call(f, a, b, c, e, d);
          }, 1);
        },
        showBalloonReal: function(a, b, c, e, d) {
          this.handleMouseMove();
          var f = this.balloon;
          f.enabled && (f.followCursor(!1), f.changeColor(b), !c || f.fixedPosition ? (f.setPosition(e, d), isNaN(e) || isNaN(d) ? f.followCursor(!0) : f.followCursor(!1)) : f.followCursor(!0), a && f.showBalloon(a));
        },
        handleMouseOver: function() {
          this.outTO && clearTimeout(this.outTO);
          d.resetMouseOver();
          this.mouseIsOver = !0;
        },
        handleMouseOut: function() {
          var a = this;
          d.resetMouseOver();
          a.outTO && clearTimeout(a.outTO);
          a.outTO = setTimeout(function() {
            a.handleMouseOutReal();
          }, 10);
        },
        handleMouseOutReal: function() {
          this.mouseIsOver = !1;
        },
        handleMouseMove: function(a) {
          a || (a = window.event);
          this.mouse2Y = this.mouse2X = NaN;
          var b,
              c,
              e,
              d;
          if (a) {
            if (a.touches) {
              var f = a.touches.item(1);
              f && this.panEventsEnabled && this.boundingRect && (e = f.clientX - this.boundingRect.left, d = f.clientY - this.boundingRect.top);
              a = a.touches.item(0);
              if (!a)
                return;
            } else
              this.wasTouched = !1;
            this.boundingRect && a.clientX && (b = a.clientX - this.boundingRect.left, c = a.clientY - this.boundingRect.top);
            isNaN(e) ? this.mouseX = b : (this.mouseX = Math.min(b, e), this.mouse2X = Math.max(b, e));
            isNaN(d) ? this.mouseY = c : (this.mouseY = Math.min(c, d), this.mouse2Y = Math.max(c, d));
            this.autoTransform && (this.mouseX /= this.cssScale, this.mouseY /= this.cssScale);
          }
        },
        handleTouchStart: function(a) {
          this.hideBalloonReal();
          a && (a.touches && this.tapToActivate && !this.tapped || !this.panRequired) || (this.handleMouseMove(a), this.handleMouseDown(a));
        },
        handleTouchEnd: function(a) {
          this.wasTouched = !0;
          this.handleMouseMove(a);
          d.resetMouseOver();
          this.handleReleaseOutside(a);
        },
        handleReleaseOutside: function() {
          this.handleDocTouchEnd.call(this);
        },
        handleMouseDown: function(a) {
          d.resetMouseOver();
          this.mouseIsOver = !0;
          a && a.preventDefault && (this.panEventsEnabled ? a.preventDefault() : a.touches || a.preventDefault());
        },
        addLegend: function(a, b) {
          a = d.processObject(a, d.AmLegend, this.theme);
          a.divId = b;
          a.ieW = 0;
          var c;
          c = "object" != typeof b && b ? document.getElementById(b) : b;
          this.legend = a;
          a.chart = this;
          c ? (a.div = c, a.position = "outside", a.autoMargins = !1) : a.div = this.legendDiv;
          return a;
        },
        removeLegend: function() {
          this.legend = void 0;
          this.previousWidth = 0;
          this.legendDiv.innerHTML = "";
        },
        handleResize: function() {
          (d.isPercents(this.width) || d.isPercents(this.height)) && this.invalidateSizeReal();
          this.renderFix();
        },
        renderFix: function() {
          if (!d.VML) {
            var a = this.container;
            a && a.renderFix();
          }
        },
        getSVG: function() {
          if (d.hasSVG)
            return this.container;
        },
        animate: function(a, b, c, e, g, f, h) {
          a["an_" + b] && d.removeFromArray(this.animations, a["an_" + b]);
          c = {
            obj: a,
            frame: 0,
            attribute: b,
            from: c,
            to: e,
            time: g,
            effect: f,
            suffix: h
          };
          a["an_" + b] = c;
          this.animations.push(c);
          return c;
        },
        setLegendData: function(a) {
          var b = this.legend;
          b && b.setData(a);
        },
        stopAnim: function(a) {
          d.removeFromArray(this.animations, a);
        },
        updateAnimations: function() {
          var a;
          this.container && this.container.update();
          if (this.animations)
            for (a = this.animations.length - 1; 0 <= a; a--) {
              var b = this.animations[a],
                  c = d.updateRate * b.time,
                  e = b.frame + 1,
                  g = b.obj,
                  f = b.attribute;
              if (e <= c) {
                b.frame++;
                var h = Number(b.from),
                    k = Number(b.to) - h,
                    c = d[b.effect](0, e, h, k, c);
                0 === k ? (this.animations.splice(a, 1), g.node.style[f] = Number(b.to) + b.suffix) : g.node.style[f] = c + b.suffix;
              } else
                g.node.style[f] = Number(b.to) + b.suffix, g.animationFinished = !0, this.animations.splice(a, 1);
            }
        },
        update: function() {
          this.updateAnimations();
          var a = this.animatable;
          if (0 < a.length) {
            for (var b = !0,
                c = a.length - 1; 0 <= c; c--) {
              var e = a[c];
              e && (e.animationFinished ? a.splice(c, 1) : b = !1);
            }
            b && (this.fire({
              type: "animationFinished",
              chart: this
            }), this.animatable = []);
          }
        },
        inIframe: function() {
          try {
            return window.self !== window.top;
          } catch (a) {
            return !0;
          }
        },
        brr: function() {
          if (!this.hideCredits) {
            var a = "amcharts.com",
                b = window.location.hostname.split("."),
                c;
            2 <= b.length && (c = b[b.length - 2] + "." + b[b.length - 1]);
            this.amLink && (b = this.amLink.parentNode) && b.removeChild(this.amLink);
            if (c != a || !0 === this.inIframe()) {
              c = a = "http://www." + a;
              var b = "JavaScript charts",
                  e = "JS chart by amCharts";
              "ammap" == this.product && (c = a + "/javascript-maps/", b = "Interactive JavaScript maps", e = "JS map by amCharts");
              a = document.createElement("a");
              e = document.createTextNode(e);
              a.setAttribute("href", c);
              a.setAttribute("title", b);
              this.urlTarget && a.setAttribute("target", this.urlTarget);
              this.chartDiv.appendChild(a);
              this.amLink = a;
              a = a.style;
              a.position = "absolute";
              a.textDecoration = "none";
              a.color = this.color;
              a.fontFamily = this.fontFamily;
              a.fontSize = "11px";
              a.opacity = .7;
              a.display = "block";
              this.positionCred();
            }
          }
        },
        positionCred: function() {
          var a = this.amLink;
          if (a) {
            var b = this.creditsPosition,
                c = a.style,
                e = a.offsetWidth,
                a = a.offsetHeight,
                d = 0,
                f = 0,
                h = this.realWidth,
                k = this.realHeight,
                l = this.type;
            if ("serial" == l || "xy" == l || "gantt" == l)
              d = this.marginLeftReal, f = this.marginTopReal, h = d + this.plotAreaWidth, k = f + this.plotAreaHeight;
            var l = 5 + d,
                m = f + 5;
            "bottom-left" == b && (l = 5 + d, m = k - a - 3);
            "bottom-right" == b && (l = h - e - 5, m = k - a - 3);
            "top-right" == b && (l = h - e - 5, m = f + 5);
            c.left = l + "px";
            c.top = m + "px";
          }
        }
      });
      d.Slice = d.Class({construct: function() {}});
      d.SerialDataItem = d.Class({construct: function() {}});
      d.GraphDataItem = d.Class({construct: function() {}});
      d.Guide = d.Class({construct: function(a) {
          this.cname = "Guide";
          d.applyTheme(this, a, this.cname);
        }});
      d.Title = d.Class({construct: function(a) {
          this.cname = "Title";
          d.applyTheme(this, a, this.cname);
        }});
      d.Label = d.Class({construct: function(a) {
          this.cname = "Label";
          d.applyTheme(this, a, this.cname);
        }});
    })();
    (function() {
      var d = window.AmCharts;
      d.AmBalloon = d.Class({
        construct: function(a) {
          this.cname = "AmBalloon";
          this.enabled = !0;
          this.fillColor = "#FFFFFF";
          this.fillAlpha = 0;
          this.borderThickness = 0;
          this.borderColor = "#FFFFFF";
          this.borderAlpha = 0;
          this.cornerRadius = 0;
          this.maxWidth = 220;
          this.addClassNames = true;
          this.horizontalPadding = 8;
          this.verticalPadding = 4;
          this.pointerWidth = 0;
          this.pointerOrientation = "V";
          this.color = "#ffffff";
          this.adjustBorderColor = !0;
          this.show = this.follow = this.showBullet = !1;
          this.bulletSize = 5;
          this.shadowAlpha = 0;
          this.shadowColor = "#000000";
          this.fadeOutDuration = this.animationDuration = .3;
          this.fixedPosition = false;
          this.offsetY = -20;
          this.offsetX = 90;
          this.textAlign = "left";
          this.disableMouseEvents = !0;
          this.deltaSignX = this.deltaSignY = 1;
          d.isModern || (this.offsetY *= 1.5);
          this.sdy = this.sdx = 0;
          d.applyTheme(this, a, this.cname);
        },
        draw: function() {
          var a = this.pointToX,
              b = this.pointToY;
          d.isModern || (this.drop = !1);
          var c = this.chart;
          d.VML && (this.fadeOutDuration = 0);
          this.xAnim && c.stopAnim(this.xAnim);
          this.yAnim && c.stopAnim(this.yAnim);
          this.sdy = this.sdx = 0;
          if (!isNaN(a)) {
            var e = this.follow,
                g = c.container,
                f = this.set;
            d.remove(f);
            this.removeDiv();
            f = g.set();
            f.node.style.pointerEvents = "none";
            this.set = f;
            this.mainSet ? (this.mainSet.push(this.set), this.sdx = this.mainSet.x, this.sdy = this.mainSet.y) : c.balloonsSet.push(f);
            if (this.show) {
              var h = this.l,
                  k = this.t,
                  l = this.r,
                  m = this.b,
                  n = this.balloonColor,
                  p = this.fillColor,
                  r = this.borderColor,
                  t = p;
              void 0 != n && (this.adjustBorderColor ? t = r = n : p = n);
              var q = this.horizontalPadding,
                  y = this.verticalPadding,
                  B = this.pointerWidth,
                  u = this.pointerOrientation,
                  w = this.cornerRadius,
                  v = c.fontFamily,
                  A = this.fontSize;
              void 0 == A && (A = c.fontSize);
              var n = document.createElement("div"),
                  C = c.classNamePrefix;
              n.className = C + "-balloon-div";
              this.className && (n.className = n.className + " " + C + "-balloon-div-" + this.className);
              C = n.style;
              this.disableMouseEvents && (C.pointerEvents = "none");
              C.position = "absolute";
              var x = this.minWidth,
                  z = document.createElement("div");
              n.appendChild(z);
              var E = z.style;
              isNaN(x) || (E.minWidth = x - 2 * q + "px");
              E.textAlign = this.textAlign;
              E.maxWidth = this.maxWidth + "px";
              E.fontSize = A + "px";
              E.color = this.color;
              E.fontFamily = v;
              z.innerHTML = this.text;
              c.chartDiv.appendChild(n);
              this.textDiv = n;
              var E = n.offsetWidth,
                  F = n.offsetHeight;
              n.clientHeight && (E = n.clientWidth, F = n.clientHeight);
              v = F + 2 * y;
              z = E + 2 * q;
              !isNaN(x) && z < x && (z = x);
              window.opera && (v += 2);
              var H = !1,
                  A = this.offsetY;
              c.handDrawn && (A += c.handDrawScatter + 2);
              "H" != u ? (x = a - z / 2, b < k + v + 10 && "down" != u ? (H = !0, e && (b += A), A = b + B, this.deltaSignY = -1) : (e && (b -= A), A = b - v - B, this.deltaSignY = 1)) : (2 * B > v && (B = v / 2), A = b - v / 2, a < h + (l - h) / 2 ? (x = a + B, this.deltaSignX = -1) : (x = a - z - B, this.deltaSignX = 1));
              A + v >= m && (A = m - v);
              A < k && (A = k);
              x < h && (x = h);
              x + z > l && (x = l - z);
              var k = A + y,
                  m = x + q,
                  G = this.shadowAlpha,
                  D = this.shadowColor,
                  q = this.borderThickness,
                  L = this.bulletSize,
                  J,
                  y = this.fillAlpha,
                  M = this.borderAlpha;
              this.showBullet && (J = d.circle(g, L, t, y), f.push(J));
              this.drop ? (h = z / 1.6, l = 0, "V" == u && (u = "down"), "H" == u && (u = "left"), "down" == u && (x = a + 1, A = b - h - h / 3), "up" == u && (l = 180, x = a + 1, A = b + h + h / 3), "left" == u && (l = 270, x = a + h + h / 3 + 2, A = b), "right" == u && (l = 90, x = a - h - h / 3 + 2, A = b), k = A - F / 2 + 1, m = x - E / 2 - 1, p = d.drop(g, h, l, p, y, q, r, M)) : 0 < w || 0 === B ? (0 < G && (a = d.rect(g, z, v, p, 0, q + 1, D, G, w), d.isModern ? a.translate(1, 1) : a.translate(4, 4), f.push(a)), p = d.rect(g, z, v, p, y, q, r, M, w)) : (t = [], w = [], "H" != u ? (h = a - x, h > z - B && (h = z - B), h < B && (h = B), t = [0, h - B, a - x, h + B, z, z, 0, 0], w = H ? [0, 0, b - A, 0, 0, v, v, 0] : [v, v, b - A, v, v, 0, 0, v]) : (u = b - A, u > v - B && (u = v - B), u < B && (u = B), w = [0, u - B, b - A, u + B, v, v, 0, 0], t = a < h + (l - h) / 2 ? [0, 0, x < a ? 0 : a - x, 0, 0, z, z, 0] : [z, z, x + z > a ? z : a - x, z, z, 0, 0, z]), 0 < G && (a = d.polygon(g, t, w, p, 0, q, D, G), a.translate(1, 1), f.push(a)), p = d.polygon(g, t, w, p, y, q, r, M));
              this.bg = p;
              f.push(p);
              p.toFront();
              d.setCN(c, p, "balloon-bg");
              this.className && d.setCN(c, p, "balloon-bg-" + this.className);
              g = 1 * this.deltaSignX;
              m += this.sdx;
              k += this.sdy;
              C.left = m + "px";
              C.top = k + "px";
              f.translate(x - g, A, 1, !0);
              p = p.getBBox();
              this.bottom = A + v + 1;
              this.yPos = p.y + A;
              J && J.translate(this.pointToX - x + g, b - A);
              b = this.animationDuration;
              0 < this.animationDuration && !e && !isNaN(this.prevX) && (f.translate(this.prevX, this.prevY, NaN, !0), f.animate({translate: x - g + "," + A}, b, "easeOutSine"), n && (C.left = this.prevTX + "px", C.top = this.prevTY + "px", this.xAnim = c.animate({node: n}, "left", this.prevTX, m, b, "easeOutSine", "px"), this.yAnim = c.animate({node: n}, "top", this.prevTY, k, b, "easeOutSine", "px")));
              this.prevX = x - g;
              this.prevY = A;
              this.prevTX = m;
              this.prevTY = k;
            }
          }
        },
        fixPrevious: function() {
          this.rPrevX = this.prevX;
          this.rPrevY = this.prevY;
          this.rPrevTX = this.prevTX;
          this.rPrevTY = this.prevTY;
        },
        restorePrevious: function() {
          this.prevX = this.rPrevX;
          this.prevY = this.rPrevY;
          this.prevTX = this.rPrevTX;
          this.prevTY = this.rPrevTY;
        },
        followMouse: function() {
          if (this.follow && this.show) {
            var a = this.chart.mouseX - this.offsetX * this.deltaSignX - this.sdx,
                b = this.chart.mouseY - this.sdy;
            this.pointToX = a;
            this.pointToY = b;
            if (a != this.previousX || b != this.previousY)
              if (this.previousX = a, this.previousY = b, 0 === this.cornerRadius)
                this.draw();
              else {
                var c = this.set;
                if (c) {
                  var e = c.getBBox(),
                      a = a - e.width / 2,
                      d = b - e.height - 10;
                  a < this.l && (a = this.l);
                  a > this.r - e.width && (a = this.r - e.width);
                  d < this.t && (d = b + 10);
                  c.translate(a, d);
                  b = this.textDiv.style;
                  b.left = a + this.horizontalPadding + "px";
                  b.top = d + this.verticalPadding + "px";
                }
              }
          }
        },
        changeColor: function(a) {
          this.balloonColor = a;
        },
        setBounds: function(a, b, c, e) {
          this.l = a;
          this.t = b;
          this.r = c;
          this.b = e;
          this.destroyTO && clearTimeout(this.destroyTO);
        },
        showBalloon: function(a) {
          if (this.text != a || this.positionChanged)
            this.text = a, this.isHiding = !1, this.show = !0, this.destroyTO && clearTimeout(this.destroyTO), a = this.chart, this.fadeAnim1 && a.stopAnim(this.fadeAnim1), this.fadeAnim2 && a.stopAnim(this.fadeAnim2), this.draw(), this.positionChanged = !1;
        },
        hide: function(a) {
          var b = this;
          b.text = void 0;
          isNaN(a) && (a = b.fadeOutDuration);
          var c = b.chart;
          if (0 < a && !b.isHiding) {
            b.isHiding = !0;
            b.destroyTO && clearTimeout(b.destroyTO);
            b.destroyTO = setTimeout(function() {
              b.destroy.call(b);
            }, 1E3 * a);
            b.follow = !1;
            b.show = !1;
            var e = b.set;
            e && (e.setAttr("opacity", b.fillAlpha), b.fadeAnim1 = e.animate({opacity: 0}, a, "easeInSine"));
            b.textDiv && (b.fadeAnim2 = c.animate({node: b.textDiv}, "opacity", 1, 0, a, "easeInSine", ""));
          } else
            b.show = !1, b.follow = !1, b.destroy();
        },
        setPosition: function(a, b) {
          if (a != this.pointToX || b != this.pointToY)
            this.previousX = this.pointToX, this.previousY = this.pointToY, this.pointToX = a, this.pointToY = b, this.positionChanged = !0;
        },
        followCursor: function(a) {
          var b = this;
          b.follow = a;
          clearInterval(b.interval);
          var c = b.chart.mouseX - b.sdx,
              e = b.chart.mouseY - b.sdy;
          !isNaN(c) && a && (b.pointToX = c - b.offsetX * b.deltaSignX, b.pointToY = e, b.followMouse(), b.interval = setInterval(function() {
            b.followMouse.call(b);
          }, 40));
        },
        removeDiv: function() {
          if (this.textDiv) {
            var a = this.textDiv.parentNode;
            a && a.removeChild(this.textDiv);
          }
        },
        destroy: function() {
          clearInterval(this.interval);
          d.remove(this.set);
          this.removeDiv();
          this.set = null;
        }
      });
    })();
    (function() {
      var d = window.AmCharts;
      d.circle = function(a, b, c, e, g, f, h, k, l) {
        0 >= b && (b = .001);
        if (void 0 == g || 0 === g)
          g = .01;
        void 0 === f && (f = "#000000");
        void 0 === h && (h = 0);
        e = {
          fill: c,
          stroke: f,
          "fill-opacity": e,
          "stroke-width": g,
          "stroke-opacity": h
        };
        a = isNaN(l) ? a.circle(0, 0, b).attr(e) : a.ellipse(0, 0, b, l).attr(e);
        k && a.gradient("radialGradient", [c, d.adjustLuminosity(c, -.6)]);
        return a;
      };
      d.text = function(a, b, c, e, g, f, h, k) {
        f || (f = "middle");
        "right" == f && (f = "end");
        "left" == f && (f = "start");
        isNaN(k) && (k = 1);
        void 0 !== b && (b = String(b), d.isIE && !d.isModern && (b = b.replace("&amp;", "&"), b = b.replace("&", "&amp;")));
        c = {
          fill: c,
          "font-family": e,
          "font-size": g + "px",
          opacity: k
        };
        !0 === h && (c["font-weight"] = "bold");
        c["text-anchor"] = f;
        return a.text(b, c);
      };
      d.polygon = function(a, b, c, e, g, f, h, k, l, m, n) {
        isNaN(f) && (f = .01);
        isNaN(k) && (k = g);
        var p = e,
            r = !1;
        "object" == typeof p && 1 < p.length && (r = !0, p = p[0]);
        void 0 === h && (h = p);
        g = {
          fill: p,
          stroke: h,
          "fill-opacity": g,
          "stroke-width": f,
          "stroke-opacity": k
        };
        void 0 !== n && 0 < n && (g["stroke-dasharray"] = n);
        n = d.dx;
        f = d.dy;
        a.handDrawn && (c = d.makeHD(b, c, a.handDrawScatter), b = c[0], c = c[1]);
        h = Math.round;
        m && (h = Number);
        k = "M" + (h(b[0]) + n) + "," + (h(c[0]) + f);
        for (p = 1; p < b.length; p++)
          m && (b[p] = d.roundTo(b[p], 5), c[p] = d.roundTo(c[p], 5)), k += " L" + (h(b[p]) + n) + "," + (h(c[p]) + f);
        a = a.path(k + " Z").attr(g);
        r && a.gradient("linearGradient", e, l);
        return a;
      };
      d.rect = function(a, b, c, e, g, f, h, k, l, m, n) {
        if (isNaN(b) || isNaN(c))
          return a.set();
        isNaN(f) && (f = 0);
        void 0 === l && (l = 0);
        void 0 === m && (m = 270);
        isNaN(g) && (g = 0);
        var p = e,
            r = !1;
        "object" == typeof p && (p = p[0], r = !0);
        void 0 === h && (h = p);
        void 0 === k && (k = g);
        b = Math.round(b);
        c = Math.round(c);
        var t = 0,
            q = 0;
        0 > b && (b = Math.abs(b), t = -b);
        0 > c && (c = Math.abs(c), q = -c);
        t += d.dx;
        q += d.dy;
        g = {
          fill: p,
          stroke: h,
          "fill-opacity": g,
          "stroke-opacity": k
        };
        void 0 !== n && 0 < n && (g["stroke-dasharray"] = n);
        a = a.rect(t, q, b, c, l, f).attr(g);
        r && a.gradient("linearGradient", e, m);
        return a;
      };
      d.bullet = function(a, b, c, e, g, f, h, k, l, m, n, p, r) {
        var t;
        "circle" == b && (b = "round");
        switch (b) {
          case "round":
            t = d.circle(a, c / 2, e, g, f, h, k);
            break;
          case "square":
            t = d.polygon(a, [-c / 2, c / 2, c / 2, -c / 2], [c / 2, c / 2, -c / 2, -c / 2], e, g, f, h, k, m - 180, void 0, r);
            break;
          case "rectangle":
            t = d.polygon(a, [-c, c, c, -c], [c / 2, c / 2, -c / 2, -c / 2], e, g, f, h, k, m - 180, void 0, r);
            break;
          case "diamond":
            t = d.polygon(a, [-c / 2, 0, c / 2, 0], [0, -c / 2, 0, c / 2], e, g, f, h, k);
            break;
          case "triangleUp":
            t = d.triangle(a, c, 0, e, g, f, h, k);
            break;
          case "triangleDown":
            t = d.triangle(a, c, 180, e, g, f, h, k);
            break;
          case "triangleLeft":
            t = d.triangle(a, c, 270, e, g, f, h, k);
            break;
          case "triangleRight":
            t = d.triangle(a, c, 90, e, g, f, h, k);
            break;
          case "bubble":
            t = d.circle(a, c / 2, e, g, f, h, k, !0);
            break;
          case "line":
            t = d.line(a, [-c / 2, c / 2], [0, 0], e, g, f, h, k);
            break;
          case "yError":
            t = a.set();
            t.push(d.line(a, [0, 0], [-c / 2, c / 2], e, g, f));
            t.push(d.line(a, [-l, l], [-c / 2, -c / 2], e, g, f));
            t.push(d.line(a, [-l, l], [c / 2, c / 2], e, g, f));
            break;
          case "xError":
            t = a.set(), t.push(d.line(a, [-c / 2, c / 2], [0, 0], e, g, f)), t.push(d.line(a, [-c / 2, -c / 2], [-l, l], e, g, f)), t.push(d.line(a, [c / 2, c / 2], [-l, l], e, g, f));
        }
        t && t.pattern(n, NaN, p);
        return t;
      };
      d.triangle = function(a, b, c, e, d, f, h, k) {
        if (void 0 === f || 0 === f)
          f = 1;
        void 0 === h && (h = "#000");
        void 0 === k && (k = 0);
        e = {
          fill: e,
          stroke: h,
          "fill-opacity": d,
          "stroke-width": f,
          "stroke-opacity": k
        };
        b /= 2;
        var l;
        0 === c && (l = " M" + -b + "," + b + " L0," + -b + " L" + b + "," + b + " Z");
        180 == c && (l = " M" + -b + "," + -b + " L0," + b + " L" + b + "," + -b + " Z");
        90 == c && (l = " M" + -b + "," + -b + " L" + b + ",0 L" + -b + "," + b + " Z");
        270 == c && (l = " M" + -b + ",0 L" + b + "," + b + " L" + b + "," + -b + " Z");
        return a.path(l).attr(e);
      };
      d.line = function(a, b, c, e, g, f, h, k, l, m, n) {
        if (a.handDrawn && !n)
          return d.handDrawnLine(a, b, c, e, g, f, h, k, l, m, n);
        f = {
          fill: "none",
          "stroke-width": f
        };
        void 0 !== h && 0 < h && (f["stroke-dasharray"] = h);
        isNaN(g) || (f["stroke-opacity"] = g);
        e && (f.stroke = e);
        e = Math.round;
        m && (e = Number, b[0] = d.roundTo(b[0], 5), c[0] = d.roundTo(c[0], 5));
        m = d.dx;
        g = d.dy;
        h = "M" + (e(b[0]) + m) + "," + (e(c[0]) + g);
        for (k = 1; k < b.length; k++)
          b[k] = d.roundTo(b[k], 5), c[k] = d.roundTo(c[k], 5), h += " L" + (e(b[k]) + m) + "," + (e(c[k]) + g);
        if (d.VML)
          return a.path(h, void 0, !0).attr(f);
        l && (h += " M0,0 L0,0");
        return a.path(h).attr(f);
      };
      d.makeHD = function(a, b, c) {
        for (var e = [],
            d = [],
            f = 1; f < a.length; f++)
          for (var h = Number(a[f - 1]),
              k = Number(b[f - 1]),
              l = Number(a[f]),
              m = Number(b[f]),
              n = Math.round(Math.sqrt(Math.pow(l - h, 2) + Math.pow(m - k, 2)) / 50) + 1,
              l = (l - h) / n,
              m = (m - k) / n,
              p = 0; p <= n; p++) {
            var r = k + p * m + Math.random() * c;
            e.push(h + p * l + Math.random() * c);
            d.push(r);
          }
        return [e, d];
      };
      d.handDrawnLine = function(a, b, c, e, g, f, h, k, l, m) {
        var n,
            p = a.set();
        for (n = 1; n < b.length; n++)
          for (var r = [b[n - 1], b[n]],
              t = [c[n - 1], c[n]],
              t = d.makeHD(r, t, a.handDrawScatter),
              r = t[0],
              t = t[1],
              q = 1; q < r.length; q++)
            p.push(d.line(a, [r[q - 1], r[q]], [t[q - 1], t[q]], e, g, f + Math.random() * a.handDrawThickness - a.handDrawThickness / 2, h, k, l, m, !0));
        return p;
      };
      d.doNothing = function(a) {
        return a;
      };
      d.drop = function(a, b, c, e, d, f, h, k) {
        var l = 1 / 180 * Math.PI,
            m = c - 20,
            n = Math.sin(m * l) * b,
            p = Math.cos(m * l) * b,
            r = Math.sin((m + 40) * l) * b,
            t = Math.cos((m + 40) * l) * b,
            q = .8 * b,
            y = -b / 3,
            B = b / 3;
        0 === c && (y = -y, B = 0);
        180 == c && (B = 0);
        90 == c && (y = 0);
        270 == c && (y = 0, B = -B);
        c = {
          fill: e,
          stroke: h,
          "stroke-width": f,
          "stroke-opacity": k,
          "fill-opacity": d
        };
        b = "M" + n + "," + p + " A" + b + "," + b + ",0,1,1," + r + "," + t + (" A" + q + "," + q + ",0,0,0," + (Math.sin((m + 20) * l) * b + B) + "," + (Math.cos((m + 20) * l) * b + y));
        b += " A" + q + "," + q + ",0,0,0," + n + "," + p;
        return a.path(b, void 0, void 0, "1000,1000").attr(c);
      };
      d.wedge = function(a, b, c, e, g, f, h, k, l, m, n, p, r, t) {
        var q = Math.round;
        f = q(f);
        h = q(h);
        k = q(k);
        var y = q(h / f * k),
            B = d.VML,
            u = 359.5 + f / 100;
        359.94 < u && (u = 359.94);
        g >= u && (g = u);
        var w = 1 / 180 * Math.PI,
            u = b + Math.sin(e * w) * k,
            v = c - Math.cos(e * w) * y,
            A = b + Math.sin(e * w) * f,
            C = c - Math.cos(e * w) * h,
            x = b + Math.sin((e + g) * w) * f,
            z = c - Math.cos((e + g) * w) * h,
            E = b + Math.sin((e + g) * w) * k,
            w = c - Math.cos((e + g) * w) * y,
            F = {
              fill: d.adjustLuminosity(m.fill, -.2),
              "stroke-opacity": 0,
              "fill-opacity": m["fill-opacity"]
            },
            H = 0;
        180 < Math.abs(g) && (H = 1);
        e = a.set();
        var G;
        B && (u = q(10 * u), A = q(10 * A), x = q(10 * x), E = q(10 * E), v = q(10 * v), C = q(10 * C), z = q(10 * z), w = q(10 * w), b = q(10 * b), l = q(10 * l), c = q(10 * c), f *= 10, h *= 10, k *= 10, y *= 10, 1 > Math.abs(g) && 1 >= Math.abs(x - A) && 1 >= Math.abs(z - C) && (G = !0));
        g = "";
        var D;
        p && (F["fill-opacity"] = 0, F["stroke-opacity"] = m["stroke-opacity"] / 2, F.stroke = m.stroke);
        if (0 < l) {
          D = " M" + u + "," + (v + l) + " L" + A + "," + (C + l);
          B ? (G || (D += " A" + (b - f) + "," + (l + c - h) + "," + (b + f) + "," + (l + c + h) + "," + A + "," + (C + l) + "," + x + "," + (z + l)), D += " L" + E + "," + (w + l), 0 < k && (G || (D += " B" + (b - k) + "," + (l + c - y) + "," + (b + k) + "," + (l + c + y) + "," + E + "," + (l + w) + "," + u + "," + (l + v)))) : (D += " A" + f + "," + h + ",0," + H + ",1," + x + "," + (z + l) + " L" + E + "," + (w + l), 0 < k && (D += " A" + k + "," + y + ",0," + H + ",0," + u + "," + (v + l)));
          D += " Z";
          var L = l;
          B && (L /= 10);
          for (var J = 0; J < L; J += 10) {
            var M = a.path(D, void 0, void 0, "1000,1000").attr(F);
            e.push(M);
            M.translate(0, -J);
          }
          D = a.path(" M" + u + "," + v + " L" + u + "," + (v + l) + " L" + A + "," + (C + l) + " L" + A + "," + C + " L" + u + "," + v + " Z", void 0, void 0, "1000,1000").attr(F);
          l = a.path(" M" + x + "," + z + " L" + x + "," + (z + l) + " L" + E + "," + (w + l) + " L" + E + "," + w + " L" + x + "," + z + " Z", void 0, void 0, "1000,1000").attr(F);
          e.push(D);
          e.push(l);
        }
        B ? (G || (g = " A" + q(b - f) + "," + q(c - h) + "," + q(b + f) + "," + q(c + h) + "," + q(A) + "," + q(C) + "," + q(x) + "," + q(z)), h = " M" + q(u) + "," + q(v) + " L" + q(A) + "," + q(C) + g + " L" + q(E) + "," + q(w)) : h = " M" + u + "," + v + " L" + A + "," + C + (" A" + f + "," + h + ",0," + H + ",1," + x + "," + z) + " L" + E + "," + w;
        0 < k && (B ? G || (h += " B" + (b - k) + "," + (c - y) + "," + (b + k) + "," + (c + y) + "," + E + "," + w + "," + u + "," + v) : h += " A" + k + "," + y + ",0," + H + ",0," + u + "," + v);
        a.handDrawn && (k = d.line(a, [u, A], [v, C], m.stroke, m.thickness * Math.random() * a.handDrawThickness, m["stroke-opacity"]), e.push(k));
        a = a.path(h + " Z", void 0, void 0, "1000,1000").attr(m);
        if (n) {
          k = [];
          for (y = 0; y < n.length; y++)
            k.push(d.adjustLuminosity(m.fill, n[y]));
          "radial" != t || d.isModern || (k = []);
          0 < k.length && a.gradient(t + "Gradient", k);
        }
        d.isModern && "radial" == t && a.grad && (a.grad.setAttribute("gradientUnits", "userSpaceOnUse"), a.grad.setAttribute("r", f), a.grad.setAttribute("cx", b), a.grad.setAttribute("cy", c));
        a.pattern(p, NaN, r);
        e.wedge = a;
        e.push(a);
        return e;
      };
      d.rgb2hex = function(a) {
        return (a = a.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i)) && 4 === a.length ? "#" + ("0" + parseInt(a[1], 10).toString(16)).slice(-2) + ("0" + parseInt(a[2], 10).toString(16)).slice(-2) + ("0" + parseInt(a[3], 10).toString(16)).slice(-2) : "";
      };
      d.adjustLuminosity = function(a, b) {
        a && -1 != a.indexOf("rgb") && (a = d.rgb2hex(a));
        a = String(a).replace(/[^0-9a-f]/gi, "");
        6 > a.length && (a = String(a[0]) + String(a[0]) + String(a[1]) + String(a[1]) + String(a[2]) + String(a[2]));
        b = b || 0;
        var c = "#",
            e,
            g;
        for (g = 0; 3 > g; g++)
          e = parseInt(a.substr(2 * g, 2), 16), e = Math.round(Math.min(Math.max(0, e + e * b), 255)).toString(16), c += ("00" + e).substr(e.length);
        return c;
      };
    })();
    (function() {
      var d = window.AmCharts;
      d.AmLegend = d.Class({
        construct: function(a) {
          this.enabled = !0;
          this.cname = "AmLegend";
          this.createEvents("rollOverMarker", "rollOverItem", "rollOutMarker", "rollOutItem", "showItem", "hideItem", "clickMarker", "clickLabel");
          this.position = "bottom";
          this.borderColor = this.color = "#000000";
          this.borderAlpha = 0;
          this.markerLabelGap = 5;
          this.verticalGap = 10;
          this.align = "left";
          this.horizontalGap = 0;
          this.spacing = 10;
          this.markerDisabledColor = "#AAB3B3";
          this.markerType = "square";
          this.markerSize = 16;
          this.markerBorderThickness = this.markerBorderAlpha = 1;
          this.marginBottom = this.marginTop = 0;
          this.marginLeft = this.marginRight = 20;
          this.autoMargins = !0;
          this.valueWidth = 50;
          this.switchable = !0;
          this.switchType = "x";
          this.switchColor = "#FFFFFF";
          this.rollOverColor = "#CC0000";
          this.reversedOrder = !1;
          this.labelText = "[[title]]";
          this.valueText = "[[value]]";
          this.accessibleLabel = "[[title]]";
          this.useMarkerColorForLabels = !1;
          this.rollOverGraphAlpha = 1;
          this.textClickEnabled = !1;
          this.equalWidths = !0;
          this.backgroundColor = "#FFFFFF";
          this.backgroundAlpha = 0;
          this.useGraphSettings = !1;
          this.showEntries = !0;
          this.labelDx = 0;
          d.applyTheme(this, a, this.cname);
        },
        setData: function(a) {
          this.legendData = a;
          this.invalidateSize();
        },
        invalidateSize: function() {
          this.destroy();
          this.entries = [];
          this.valueLabels = [];
          var a = this.legendData;
          this.enabled && (d.ifArray(a) || d.ifArray(this.data)) && this.drawLegend();
        },
        drawLegend: function() {
          var a = this.chart,
              b = this.position,
              c = this.width,
              e = a.divRealWidth,
              g = a.divRealHeight,
              f = this.div,
              h = this.legendData;
          this.data && (h = this.combineLegend ? this.legendData.concat(this.data) : this.data);
          isNaN(this.fontSize) && (this.fontSize = a.fontSize);
          this.maxColumnsReal = this.maxColumns;
          if ("right" == b || "left" == b)
            this.maxColumnsReal = 1, this.autoMargins && (this.marginLeft = this.marginRight = 10);
          else if (this.autoMargins) {
            this.marginRight = a.marginRight;
            this.marginLeft = a.marginLeft;
            var k = a.autoMarginOffset;
            "bottom" == b ? (this.marginBottom = k, this.marginTop = 0) : (this.marginTop = k, this.marginBottom = 0);
          }
          c = void 0 !== c ? d.toCoordinate(c, e) : "right" != b && "left" != b ? a.realWidth : 0 < this.ieW ? this.ieW : a.realWidth;
          "outside" == b ? (c = f.offsetWidth, g = f.offsetHeight, f.clientHeight && (c = f.clientWidth, g = f.clientHeight)) : (isNaN(c) || (f.style.width = c + "px"), f.className = "amChartsLegend " + a.classNamePrefix + "-legend-div");
          this.divWidth = c;
          (b = this.container) ? (b.container.innerHTML = "", f.appendChild(b.container), b.width = c, b.height = g, b.setSize(c, g), b.addDefs(a)) : b = new d.AmDraw(f, c, g, a);
          this.container = b;
          this.lx = 0;
          this.ly = 8;
          g = this.markerSize;
          g > this.fontSize && (this.ly = g / 2 - 1);
          0 < g && (this.lx += g + this.markerLabelGap);
          this.titleWidth = 0;
          if (g = this.title)
            g = d.text(this.container, g, this.color, a.fontFamily, this.fontSize, "start", !0), d.setCN(a, g, "legend-title"), g.translate(this.marginLeft, this.marginTop + this.verticalGap + this.ly + 1), a = g.getBBox(), this.titleWidth = a.width + 15, this.titleHeight = a.height + 6;
          this.index = this.maxLabelWidth = 0;
          if (this.showEntries) {
            for (a = 0; a < h.length; a++)
              this.createEntry(h[a]);
            for (a = this.index = 0; a < h.length; a++)
              this.createValue(h[a]);
          }
          this.arrangeEntries();
          this.updateValues();
        },
        arrangeEntries: function() {
          var a = this.position,
              b = this.marginLeft + this.titleWidth,
              c = this.marginRight,
              e = this.marginTop,
              g = this.marginBottom,
              f = this.horizontalGap,
              h = this.div,
              k = this.divWidth,
              l = this.maxColumnsReal,
              m = this.verticalGap,
              n = this.spacing,
              p = k - c - b,
              r = 0,
              t = 0,
              q = this.container;
          this.set && this.set.remove();
          var y = q.set();
          this.set = y;
          var B = q.set();
          y.push(B);
          var u = this.entries,
              w,
              v;
          for (v = 0; v < u.length; v++) {
            w = u[v].getBBox();
            var A = w.width;
            A > r && (r = A);
            w = w.height;
            w > t && (t = w);
          }
          var A = t = 0,
              C = f,
              x = 0,
              z = 0;
          for (v = 0; v < u.length; v++) {
            var E = u[v];
            this.reversedOrder && (E = u[u.length - v - 1]);
            w = E.getBBox();
            var F;
            this.equalWidths ? F = A * (r + n + this.markerLabelGap) : (F = C, C = C + w.width + f + n);
            F + w.width > p && 0 < v && 0 !== A && (t++, F = A = 0, C = F + w.width + f + n, x = x + z + m, z = 0);
            w.height > z && (z = w.height);
            E.translate(F, x);
            A++;
            !isNaN(l) && A >= l && (A = 0, t++, x = x + z + m, C = f, z = 0);
            B.push(E);
          }
          w = B.getBBox();
          l = w.height + 2 * m - 1;
          "left" == a || "right" == a ? (n = w.width + 2 * f, k = n + b + c, h.style.width = k + "px", this.ieW = k) : n = k - b - c - 1;
          c = d.polygon(this.container, [0, n, n, 0], [0, 0, l, l], this.backgroundColor, this.backgroundAlpha, 1, this.borderColor, this.borderAlpha);
          d.setCN(this.chart, c, "legend-bg");
          y.push(c);
          y.translate(b, e);
          c.toBack();
          b = f;
          if ("top" == a || "bottom" == a || "absolute" == a || "outside" == a)
            "center" == this.align ? b = f + (n - w.width) / 2 : "right" == this.align && (b = f + n - w.width);
          B.translate(b, m + 1);
          this.titleHeight > l && (l = this.titleHeight);
          e = l + e + g + 1;
          0 > e && (e = 0);
          "absolute" != a && "outside" != a && e > this.chart.divRealHeight && (h.style.top = "0px");
          h.style.height = Math.round(e) + "px";
          q.setSize(this.divWidth, e);
        },
        createEntry: function(a) {
          if (!1 !== a.visibleInLegend && !a.hideFromLegend) {
            var b = this,
                c = b.chart,
                e = b.useGraphSettings,
                g = a.markerType;
            g && (e = !1);
            a.legendEntryWidth = b.markerSize;
            g || (g = b.markerType);
            var f = a.color,
                h = a.alpha;
            a.legendKeyColor && (f = a.legendKeyColor());
            a.legendKeyAlpha && (h = a.legendKeyAlpha());
            var k;
            !0 === a.hidden && (k = f = b.markerDisabledColor);
            var l = a.pattern,
                m,
                n = a.customMarker;
            n || (n = b.customMarker);
            var p = b.container,
                r = b.markerSize,
                t = 0,
                q = 0,
                y = r / 2;
            if (e) {
              e = a.type;
              b.switchType = void 0;
              if ("line" == e || "step" == e || "smoothedLine" == e || "ohlc" == e)
                m = p.set(), a.hidden || (f = a.lineColorR, k = a.bulletBorderColorR), t = d.line(p, [0, 2 * r], [r / 2, r / 2], f, a.lineAlpha, a.lineThickness, a.dashLength), d.setCN(c, t, "graph-stroke"), m.push(t), a.bullet && (a.hidden || (f = a.bulletColorR), t = d.bullet(p, a.bullet, a.bulletSize, f, a.bulletAlpha, a.bulletBorderThickness, k, a.bulletBorderAlpha)) && (d.setCN(c, t, "graph-bullet"), t.translate(r + 1, r / 2), m.push(t)), y = 0, t = r, q = r / 3;
              else {
                a.getGradRotation && (m = a.getGradRotation(), 0 === m && (m = 180));
                t = a.fillColorsR;
                !0 === a.hidden && (t = f);
                if (m = b.createMarker("rectangle", t, a.fillAlphas, a.lineThickness, f, a.lineAlpha, m, l, a.dashLength))
                  y = r, m.translate(y, r / 2);
                t = r;
              }
              d.setCN(c, m, "graph-" + e);
              d.setCN(c, m, "graph-" + a.id);
            } else if (n)
              m = p.image(n, 0, 0, r, r);
            else {
              var B;
              isNaN(b.gradientRotation) || (B = 180 + b.gradientRotation);
              (m = b.createMarker(g, f, h, void 0, void 0, void 0, B, l)) && m.translate(r / 2, r / 2);
            }
            d.setCN(c, m, "legend-marker");
            b.addListeners(m, a);
            p = p.set([m]);
            b.switchable && a.switchable && p.setAttr("cursor", "pointer");
            void 0 !== a.id && d.setCN(c, p, "legend-item-" + a.id);
            d.setCN(c, p, a.className, !0);
            k = b.switchType;
            var u;
            k && "none" != k && 0 < r && ("x" == k ? (u = b.createX(), u.translate(r / 2, r / 2)) : u = b.createV(), u.dItem = a, !0 !== a.hidden ? "x" == k ? u.hide() : u.show() : "x" != k && u.hide(), b.switchable || u.hide(), b.addListeners(u, a), a.legendSwitch = u, p.push(u), d.setCN(c, u, "legend-switch"));
            k = b.color;
            a.showBalloon && b.textClickEnabled && void 0 !== b.selectedColor && (k = b.selectedColor);
            b.useMarkerColorForLabels && !l && (k = f);
            !0 === a.hidden && (k = b.markerDisabledColor);
            f = d.massReplace(b.labelText, {"[[title]]": a.title});
            void 0 !== b.tabIndex && (p.setAttr("tabindex", b.tabIndex), p.setAttr("role", "menuitem"), p.keyup(function(c) {
              13 == c.keyCode && b.clickMarker(a, c);
            }));
            c.accessible && b.accessibleLabel && (l = d.massReplace(b.accessibleLabel, {"[[title]]": a.title}), c.makeAccessible(p, l));
            l = b.fontSize;
            m && (r <= l && (r = r / 2 + b.ly - l / 2 + (l + 2 - r) / 2 - q, m.translate(y, r), u && u.translate(u.x, r)), a.legendEntryWidth = m.getBBox().width);
            var w;
            f && (f = d.fixBrakes(f), a.legendTextReal = f, w = b.labelWidth, w = isNaN(w) ? d.text(b.container, f, k, c.fontFamily, l, "start") : d.wrappedText(b.container, f, k, c.fontFamily, l, "start", !1, w, 0), d.setCN(c, w, "legend-label"), w.translate(b.lx + t, b.ly), p.push(w), b.labelDx = t, c = w.getBBox().width, b.maxLabelWidth < c && (b.maxLabelWidth = c));
            b.entries[b.index] = p;
            a.legendEntry = b.entries[b.index];
            a.legendMarker = m;
            a.legendLabel = w;
            b.index++;
          }
        },
        addListeners: function(a, b) {
          var c = this;
          a && a.mouseover(function(a) {
            c.rollOverMarker(b, a);
          }).mouseout(function(a) {
            c.rollOutMarker(b, a);
          }).click(function(a) {
            c.clickMarker(b, a);
          });
        },
        rollOverMarker: function(a, b) {
          this.switchable && this.dispatch("rollOverMarker", a, b);
          this.dispatch("rollOverItem", a, b);
        },
        rollOutMarker: function(a, b) {
          this.switchable && this.dispatch("rollOutMarker", a, b);
          this.dispatch("rollOutItem", a, b);
        },
        clickMarker: function(a, b) {
          this.switchable && (!0 === a.hidden ? this.dispatch("showItem", a, b) : this.dispatch("hideItem", a, b));
          this.dispatch("clickMarker", a, b);
        },
        rollOverLabel: function(a, b) {
          a.hidden || this.textClickEnabled && a.legendLabel && a.legendLabel.attr({fill: this.rollOverColor});
          this.dispatch("rollOverItem", a, b);
        },
        rollOutLabel: function(a, b) {
          if (!a.hidden && this.textClickEnabled && a.legendLabel) {
            var c = this.color;
            void 0 !== this.selectedColor && a.showBalloon && (c = this.selectedColor);
            this.useMarkerColorForLabels && (c = a.lineColor, void 0 === c && (c = a.color));
            a.legendLabel.attr({fill: c});
          }
          this.dispatch("rollOutItem", a, b);
        },
        clickLabel: function(a, b) {
          this.textClickEnabled ? a.hidden || this.dispatch("clickLabel", a, b) : this.switchable && (!0 === a.hidden ? this.dispatch("showItem", a, b) : this.dispatch("hideItem", a, b));
        },
        dispatch: function(a, b, c) {
          a = {
            type: a,
            dataItem: b,
            target: this,
            event: c,
            chart: this.chart
          };
          this.chart && this.chart.handleLegendEvent(a);
          this.fire(a);
        },
        createValue: function(a) {
          var b = this,
              c = b.fontSize,
              e = b.chart;
          if (!1 !== a.visibleInLegend && !a.hideFromLegend) {
            var g = b.maxLabelWidth;
            b.forceWidth && (g = b.labelWidth);
            b.equalWidths || (b.valueAlign = "left");
            "left" == b.valueAlign && a.legendLabel && (g = a.legendLabel.getBBox().width);
            var f = g;
            if (b.valueText && 0 < b.valueWidth) {
              var h = b.color;
              b.useMarkerColorForValues && (h = a.color, a.legendKeyColor && (h = a.legendKeyColor()));
              !0 === a.hidden && (h = b.markerDisabledColor);
              var k = b.valueText,
                  g = g + b.lx + b.labelDx + b.markerLabelGap + b.valueWidth,
                  l = "end";
              "left" == b.valueAlign && (g -= b.valueWidth, l = "start");
              h = d.text(b.container, k, h, b.chart.fontFamily, c, l);
              d.setCN(e, h, "legend-value");
              h.translate(g, b.ly);
              b.entries[b.index].push(h);
              f += b.valueWidth + 2 * b.markerLabelGap;
              h.dItem = a;
              b.valueLabels.push(h);
            }
            b.index++;
            e = b.markerSize;
            e < c + 7 && (e = c + 7, d.VML && (e += 3));
            c = b.container.rect(a.legendEntryWidth, 0, f, e, 0, 0).attr({
              stroke: "none",
              fill: "#fff",
              "fill-opacity": .005
            });
            c.dItem = a;
            b.entries[b.index - 1].push(c);
            c.mouseover(function(c) {
              b.rollOverLabel(a, c);
            }).mouseout(function(c) {
              b.rollOutLabel(a, c);
            }).click(function(c) {
              b.clickLabel(a, c);
            });
          }
        },
        createV: function() {
          var a = this.markerSize;
          return d.polygon(this.container, [a / 5, a / 2, a - a / 5, a / 2], [a / 3, a - a / 5, a / 5, a / 1.7], this.switchColor);
        },
        createX: function() {
          var a = (this.markerSize - 4) / 2,
              b = {
                stroke: this.switchColor,
                "stroke-width": 3
              },
              c = this.container,
              e = d.line(c, [-a, a], [-a, a]).attr(b),
              a = d.line(c, [-a, a], [a, -a]).attr(b);
          return this.container.set([e, a]);
        },
        createMarker: function(a, b, c, e, g, f, h, k, l) {
          var m = this.markerSize,
              n = this.container;
          g || (g = this.markerBorderColor);
          g || (g = b);
          isNaN(e) && (e = this.markerBorderThickness);
          isNaN(f) && (f = this.markerBorderAlpha);
          return d.bullet(n, a, m, b, c, e, g, f, m, h, k, this.chart.path, l);
        },
        validateNow: function() {
          this.invalidateSize();
        },
        updateValues: function() {
          var a = this.valueLabels,
              b = this.chart,
              c,
              e = this.data;
          if (a)
            for (c = 0; c < a.length; c++) {
              var g = a[c],
                  f = g.dItem;
              f.periodDataItem = void 0;
              f.periodPercentDataItem = void 0;
              var h = " ";
              if (e)
                f.value ? g.text(f.value) : g.text("");
              else {
                var k = null;
                if (void 0 !== f.type) {
                  var k = f.currentDataItem,
                      l = this.periodValueText;
                  f.legendPeriodValueText && (l = f.legendPeriodValueText);
                  f.legendPeriodValueTextR && (l = f.legendPeriodValueTextR);
                  k ? (h = this.valueText, f.legendValueText && (h = f.legendValueText), f.legendValueTextR && (h = f.legendValueTextR), h = b.formatString(h, k)) : l && b.formatPeriodString && (l = d.massReplace(l, {"[[title]]": f.title}), h = b.formatPeriodString(l, f));
                } else
                  h = b.formatString(this.valueText, f);
                l = f;
                k && (l = k);
                var m = this.valueFunction;
                m && (h = m(l, h, b.periodDataItem));
                var n;
                this.useMarkerColorForLabels && !k && f.lastDataItem && (k = f.lastDataItem);
                k ? n = b.getBalloonColor(f, k) : f.legendKeyColor && (n = f.legendKeyColor());
                f.legendColorFunction && (n = f.legendColorFunction(l, h, f.periodDataItem, f.periodPercentDataItem));
                g.text(h);
                if (!f.pattern && (this.useMarkerColorForValues && g.setAttr("fill", n), this.useMarkerColorForLabels)) {
                  if (g = f.legendMarker)
                    g.setAttr("fill", n), g.setAttr("stroke", n);
                  (g = f.legendLabel) && (f.hidden ? g.setAttr("fill", this.markerDisabledColor) : g.setAttr("fill", n));
                }
              }
            }
        },
        renderFix: function() {
          if (!d.VML && this.enabled) {
            var a = this.container;
            a && a.renderFix();
          }
        },
        destroy: function() {
          this.div.innerHTML = "";
          d.remove(this.set);
        }
      });
    })();
    (function() {
      var d = window.AmCharts;
      d.AmMap = d.Class({
        inherits: d.AmChart,
        construct: function(a) {
          this.cname = "AmMap";
          this.type = "map";
          this.theme = a;
          this.svgNotSupported = "This browser doesn't support SVG. Use Chrome, Firefox, Internet Explorer 9 or later.";
          this.createEvents("rollOverMapObject", "rollOutMapObject", "clickMapObject", "mouseDownMapObject", "selectedObjectChanged", "homeButtonClicked", "zoomCompleted", "dragCompleted", "positionChanged", "writeDevInfo", "click", "descriptionClosed");
          this.zoomDuration = .6;
          this.zoomControl = new d.ZoomControl(a);
          this.fitMapToContainer = !0;
          this.mouseWheelZoomEnabled = this.backgroundZoomsToTop = !1;
          this.allowClickOnSelectedObject = this.useHandCursorOnClickableOjects = this.showBalloonOnSelectedObject = !0;
          this.showObjectsAfterZoom = this.wheelBusy = !1;
          this.zoomOnDoubleClick = this.useObjectColorForBalloon = !0;
          this.allowMultipleDescriptionWindows = !1;
          this.dragMap = this.centerMap = this.linesAboveImages = !0;
          this.colorSteps = 5;
          this.forceNormalize = !1;
          this.showAreasInList = !0;
          this.showLinesInList = this.showImagesInList = !1;
          this.areasProcessor = new d.AreasProcessor(this);
          this.areasSettings = new d.AreasSettings(a);
          this.imagesProcessor = new d.ImagesProcessor(this);
          this.imagesSettings = new d.ImagesSettings(a);
          this.linesProcessor = new d.LinesProcessor(this);
          this.linesSettings = new d.LinesSettings(a);
          this.initialTouchZoom = 1;
          this.showDescriptionOnHover = !1;
          d.AmMap.base.construct.call(this, a);
          this.creditsPosition = "bottom-left";
          this.product = "ammap";
          this.areasClasses = {};
          this.updatableImages = [];
          d.applyTheme(this, a, this.cname);
        },
        initChart: function() {
          this.zoomInstantly = !0;
          var a = this.container;
          this.panRequired = !0;
          if (this.sizeChanged && d.hasSVG && this.chartCreated) {
            this.updatableImages = [];
            this.freeLabelsSet && this.freeLabelsSet.remove();
            this.freeLabelsSet = a.set();
            this.container.setSize(this.realWidth, this.realHeight);
            this.resizeMap();
            this.drawBackground();
            this.redrawLabels();
            this.drawTitles();
            this.processObjects(!0);
            this.rescaleObjects();
            this.zoomControl.init(this, a);
            this.drawBg();
            var b = this.smallMap;
            b && b.init(this, a);
            (b = this.valueLegend) && b.init(this, a);
            this.sizeChanged = !1;
            this.zoomToLongLat(this.zLevelTemp, this.zLongTemp, this.zLatTemp, !0);
            this.previousWidth = this.realWidth;
            this.previousHeight = this.realHeight;
            this.updateSmallMap();
            this.linkSet.toFront();
            this.zoomControl.update && this.zoomControl.update();
          } else
            (d.AmMap.base.initChart.call(this), d.hasSVG) ? (this.dataChanged && (this.parseData(), this.dispatchDataUpdated = !0, this.dataChanged = !1, a = this.legend) && (a.position = "absolute", a.invalidateSize()), this.createDescriptionsDiv(), this.svgAreas = [], this.svgAreasById = {}, this.drawChart()) : (this.chartDiv.style.textAlign = "", this.chartDiv.setAttribute("class", "ammapAlert"), this.chartDiv.innerHTML = this.svgNotSupported, this.fire({
              type: "failed",
              chart: this
            }));
        },
        storeTemp: function() {
          if (d.hasSVG && 0 < this.realWidth && 0 < this.realHeight) {
            var a = this.mapContainer.getBBox();
            0 < a.width && 0 < a.height && (a = this.zoomLongitude(), isNaN(a) || (this.zLongTemp = a), a = this.zoomLatitude(), isNaN(a) || (this.zLatTemp = a), a = this.zoomLevel(), isNaN(a) || (this.zLevelTemp = a));
          }
        },
        invalidateSize: function() {
          this.storeTemp();
          d.AmMap.base.invalidateSize.call(this);
        },
        validateSize: function() {
          this.storeTemp();
          d.AmMap.base.validateSize.call(this);
        },
        handleWheelReal: function(a) {
          if (!this.wheelBusy) {
            this.stopAnimation();
            var b = this.zoomLevel(),
                c = this.zoomControl,
                e = c.zoomFactor;
            this.wheelBusy = !0;
            a = d.fitToBounds(0 < a ? b * e : b / e, c.minZoomLevel, c.maxZoomLevel);
            e = this.mouseX / this.mapWidth;
            c = this.mouseY / this.mapHeight;
            e = (this.zoomX() - e) * (a / b) + e;
            b = (this.zoomY() - c) * (a / b) + c;
            this.zoomTo(a, e, b);
          }
        },
        addLegend: function(a, b) {
          a.position = "absolute";
          a.autoMargins = !1;
          a.valueWidth = 0;
          a.switchable = !1;
          d.AmMap.base.addLegend.call(this, a, b);
          void 0 === a.enabled && (a.enabled = !0);
          return a;
        },
        handleLegendEvent: function() {},
        createDescriptionsDiv: function() {
          if (!this.descriptionsDiv) {
            var a = document.createElement("div"),
                b = a.style;
            b.position = "absolute";
            b.left = "0px";
            b.top = "0px";
            this.descriptionsDiv = a;
          }
          this.containerDiv.appendChild(this.descriptionsDiv);
        },
        drawChart: function() {
          d.AmMap.base.drawChart.call(this);
          var a = this.dataProvider;
          this.dataProvider = a = d.extend(a, new d.MapData, !0);
          this.areasSettings = d.processObject(this.areasSettings, d.AreasSettings, this.theme);
          this.imagesSettings = d.processObject(this.imagesSettings, d.ImagesSettings, this.theme);
          this.linesSettings = d.processObject(this.linesSettings, d.LinesSettings, this.theme);
          var b = this.container;
          this.mapContainer && this.mapContainer.remove();
          this.mapContainer = b.set();
          this.graphsSet.push(this.mapContainer);
          var c;
          a.map && (c = d.maps[a.map]);
          a.mapVar && (c = a.mapVar);
          c ? (this.svgData = c.svg, this.getBounds(), this.buildEverything()) : (a = a.mapURL) && this.loadXml(a);
          this.balloonsSet.toFront();
        },
        drawBg: function() {
          var a = this;
          a.background.click(function() {
            a.handleBackgroundClick();
          });
          a.background.mouseover(function() {
            a.rollOutMapObject(a.previouslyHovered);
          });
        },
        buildEverything: function() {
          if (0 < this.realWidth && 0 < this.realHeight) {
            var a = this.container,
                b = this.dataProvider;
            isNaN(b.zoomLevel) || (this.mapContainer.scale = b.zoomLevel);
            this.projection || (this.projection = b.projection, this.projection || (this.projection = "equirectangular"));
            this.updatableImages = [];
            var c = this.projection;
            c && (this.projectionFunction = d[c]);
            this.projectionFunction || (this.projectionFunction = d.equirectangular);
            this.dpProjectionFunction = d[b.projection];
            this.dpProjectionFunction || (this.dpProjectionFunction = d.equirectangular);
            this.zoomControl = d.processObject(this.zoomControl, d.ZoomControl, this.theme);
            this.zoomControl.init(this, a);
            this.drawBg();
            this.buildSVGMap();
            this.projectionFunction && c != b.projection || this.forceNormalize ? (this.normalizeMap(), this.changeProjection()) : this.fixMapPosition();
            if (c = this.smallMap)
              c = d.processObject(c, d.SmallMap, this.theme), c.init(this, a), this.smallMap = c;
            isNaN(b.zoomX) && isNaN(b.zoomY) && isNaN(b.zoomLatitude) && isNaN(b.zoomLongitude) && (this.centerMap ? (c = this.xyToCoordinates(this.mapWidth / 2, this.mapHeight / 2), b.zoomLongitudeC = c.longitude, b.zoomLatitudeC = c.latitude) : (b.zoomX = 0, b.zoomY = 0), this.zoomInstantly = !0);
            this.selectObject(this.dataProvider);
            this.processAreas();
            if (b = this.valueLegend)
              this.valueLegend = b = d.processObject(b, d.ValueLegend, this.theme), b.init(this, a);
            this.objectList && (a = this.objectList = d.processObject(this.objectList, d.ObjectList)) && (this.clearObjectList(), a.init(this));
            this.dispDUpd();
            this.updateSmallMap();
            this.linkSet.toFront();
          } else
            this.cleanChart();
        },
        hideGroup: function(a) {
          this.showHideGroup(a, !1);
        },
        showGroup: function(a) {
          this.showHideGroup(a, !0);
        },
        showHideGroup: function(a, b) {
          this.showHideReal(this.imagesProcessor.allObjects, a, b);
          this.showHideReal(this.areasProcessor.allObjects, a, b);
          this.showHideReal(this.linesProcessor.allObjects, a, b);
        },
        showHideReal: function(a, b, c) {
          var e;
          for (e = 0; e < a.length; e++) {
            var d = a[e];
            if (d.groupId == b) {
              var f = d.displayObject;
              f && (c ? (d.hidden = !1, f.show()) : (d.hidden = !0, f.hide()));
            }
          }
        },
        makeObjectAccessible: function(a) {
          if (a.accessibleLabel) {
            var b = this.formatString(a.accessibleLabel, a);
            a.displayObject && this.makeAccessible(a.displayObject, b, "menuitem");
          }
        },
        update: function() {
          if (d.hasSVG) {
            d.AmMap.base.update.call(this);
            this.zoomControl && this.zoomControl.update && this.zoomControl.update();
            for (var a = 0,
                b = this.updatableImages.length; a < b; a++)
              this.updatableImages[a].update();
          }
        },
        animateMap: function() {
          var a = this;
          a.totalFrames = a.zoomDuration * d.updateRate;
          a.totalFrames += 1;
          a.frame = 0;
          a.tweenPercent = 0;
          a.balloon.hide(0);
          setTimeout(function() {
            a.updateSize.call(a);
          }, 1E3 / d.updateRate);
        },
        updateSize: function() {
          var a = this,
              b = a.totalFrames;
          a.preventHover = !0;
          a.frame <= b ? (a.frame++, b = d.easeOutSine(0, a.frame, 0, 1, b), 1 <= b ? (b = 1, a.preventHover = !1, a.wheelBusy = !1) : window.requestAnimationFrame ? window.requestAnimationFrame(function() {
            a.updateSize.call(a);
          }) : setTimeout(function() {
            a.updateSize.call(a);
          }, 1E3 / d.updateRate), .8 < b && (a.preventHover = !1)) : (b = 1, a.preventHover = !1, a.wheelBusy = !1);
          a.tweenPercent = b;
          a.rescaleMapAndObjects();
        },
        rescaleMapAndObjects: function() {
          var a = this.initialScale,
              b = this.initialX,
              c = this.initialY,
              e = this.tweenPercent,
              a = a + (this.finalScale - a) * e;
          this.mapContainer.translate(b + (this.finalX - b) * e, c + (this.finalY - c) * e, a, !0);
          if (this.areasSettings.adjustOutlineThickness) {
            for (var b = this.svgAreas,
                d = 0; d < b.length; d++)
              (c = b[d]) && c.setAttr("stroke-width", this.areasSettings.outlineThickness / a / this.mapScale);
            if (b = this.dataProvider.areas)
              for (d = 0; d < b.length; d++) {
                var c = b[d],
                    f = c.displayObject;
                f && f.setAttr("stroke-width", c.outlineThicknessReal / a / this.mapScale);
              }
          }
          this.rescaleObjects();
          this.positionChanged();
          this.updateSmallMap();
          1 == e && this.fire({
            type: "zoomCompleted",
            chart: this
          });
        },
        updateSmallMap: function() {
          this.smallMap && this.smallMap.update();
        },
        rescaleObjects: function() {
          var a = this.mapContainer.scale,
              b = this.imagesProcessor.objectsToResize,
              c;
          for (c = 0; c < b.length; c++) {
            var e = b[c].image,
                d = b[c].scale,
                f = b[c].mapImage;
            isNaN(f.selectedScaleReal) || f != this.selectedObject || (f.tempScale = d, d *= f.selectedScaleReal);
            e.translate(e.x, e.y, d / a, !0);
          }
          b = this.imagesProcessor.labelsToReposition;
          for (c = 0; c < b.length; c++)
            e = b[c], e.imageLabel && this.imagesProcessor.positionLabel(e.imageLabel, e, e.labelPositionReal);
          b = this.linesProcessor;
          if (e = b.linesToResize)
            for (c = 0; c < e.length; c++)
              d = e[c], d.line.setAttr("stroke-width", d.thickness / a);
          b = b.objectsToResize;
          for (c = 0; c < b.length; c++)
            e = b[c], e.translate(e.x, e.y, 1 / a, !0);
        },
        handleTouchEnd: function(a) {
          this.initialDistance = NaN;
          this.mouseIsDown = this.isDragging = !1;
          d.AmMap.base.handleTouchEnd.call(this, a);
        },
        handleMouseDown: function(a) {
          d.resetMouseOver();
          this.mouseIsDown = this.mouseIsOver = !0;
          this.balloon.hide(0);
          a && this.mouseIsOver && a.preventDefault && this.panEventsEnabled && a.preventDefault();
          if (this.chartCreated && !this.preventHover && (this.initialTouchZoom = this.zoomLevel(), this.dragMap && (this.stopAnimation(), this.mapContainerClickX = this.mapContainer.x, this.mapContainerClickY = this.mapContainer.y), a || (a = window.event), a.shiftKey && !0 === this.developerMode && this.getDevInfo(), a && a.touches)) {
            var b = this.mouseX,
                c = this.mouseY,
                e = a.touches.item(1);
            e && this.panEventsEnabled && this.boundingRect && (a = e.clientX - this.boundingRect.left, e = e.clientY - this.boundingRect.top, this.middleXP = (b + (a - b) / 2) / this.realWidth, this.middleYP = (c + (e - c) / 2) / this.realHeight, this.initialDistance = Math.sqrt(Math.pow(a - b, 2) + Math.pow(e - c, 2)));
          }
        },
        stopDrag: function() {
          this.isDragging = !1;
        },
        handleReleaseOutside: function() {
          if (d.isModern) {
            var a = this;
            d.AmMap.base.handleReleaseOutside.call(a);
            a.mouseIsDown = !1;
            setTimeout(function() {
              a.resetPinch.call(a);
            }, 100);
            if (!a.preventHover) {
              a.stopDrag();
              var b = a.zoomControl;
              b && b.draggerUp && b.draggerUp();
              a.mapWasDragged = !1;
              var b = a.mapContainer,
                  c = a.mapContainerClickX,
                  e = a.mapContainerClickY;
              isNaN(c) || isNaN(e) || !(3 < Math.abs(b.x - c) || 3 < Math.abs(b.y - e)) || (a.mapWasDragged = !0, b = {
                type: "dragCompleted",
                zoomX: a.zoomX(),
                zoomY: a.zoomY(),
                zoomLevel: a.zoomLevel(),
                chart: a
              }, a.fire(b));
              (a.mouseIsOver && !a.mapWasDragged && !a.skipClick || a.wasTouched && 3 > Math.abs(a.mouseX - a.tmx) && 3 > Math.abs(a.mouseY - a.tmy)) && a.fire({
                type: "click",
                x: a.mouseX,
                y: a.mouseY,
                chart: a
              });
              a.mapContainerClickX = NaN;
              a.mapContainerClickY = NaN;
              a.objectWasClicked = !1;
              a.zoomOnDoubleClick && a.mouseIsOver && (b = (new Date).getTime(), 200 > b - a.previousClickTime && 40 < b - a.previousClickTime && a.doDoubleClickZoom(), a.previousClickTime = b);
            }
            a.wasTouched = !1;
          }
        },
        resetPinch: function() {
          this.mapWasPinched = !1;
        },
        handleMouseMove: function(a) {
          var b = this;
          d.AmMap.base.handleMouseMove.call(b, a);
          if (!a || !a.touches || !b.tapToActivate || b.tapped) {
            b.panEventsEnabled && b.mouseIsOver && a && a.preventDefault && a.preventDefault();
            var c = b.previuosMouseX,
                e = b.previuosMouseY,
                g = b.mouseX,
                f = b.mouseY,
                h = b.zoomControl;
            isNaN(c) && (c = g);
            isNaN(e) && (e = f);
            b.mouse2X = NaN;
            b.mouse2Y = NaN;
            a && a.touches && (a = a.touches.item(1)) && b.panEventsEnabled && b.boundingRect && (b.mouse2X = a.clientX - b.boundingRect.left, b.mouse2Y = a.clientY - b.boundingRect.top);
            if (a = b.mapContainer) {
              var k = b.mouse2X,
                  l = b.mouse2Y;
              b.pinchTO && clearTimeout(b.pinchTO);
              b.pinchTO = setTimeout(function() {
                b.resetPinch.call(b);
              }, 1E3);
              var m = b.realHeight,
                  n = b.realWidth,
                  p = b.mapWidth,
                  r = b.mapHeight;
              b.mouseIsDown && b.dragMap && (3 < Math.abs(b.previuosMouseX - b.mouseX) || 3 < Math.abs(b.previuosMouseY - b.mouseY)) && (b.isDragging = !0);
              if (!isNaN(k)) {
                b.stopDrag();
                var t = Math.sqrt(Math.pow(k - g, 2) + Math.pow(l - f, 2)),
                    q = b.initialDistance;
                isNaN(q) && (q = Math.sqrt(Math.pow(k - g, 2) + Math.pow(l - f, 2)));
                if (!isNaN(q)) {
                  var k = b.initialTouchZoom * t / q,
                      k = d.fitToBounds(k, h.minZoomLevel, h.maxZoomLevel),
                      h = b.zoomLevel(),
                      q = b.middleXP,
                      l = b.middleYP,
                      t = m / r,
                      y = n / p,
                      q = (b.zoomX() - q * y) * (k / h) + q * y,
                      l = (b.zoomY() - l * t) * (k / h) + l * t;
                  .1 < Math.abs(k - h) && (b.zoomTo(k, q, l, !0), b.mapWasPinched = !0, clearTimeout(b.pinchTO));
                }
              }
              k = a.scale;
              b.isDragging && (b.balloon.hide(0), b.positionChanged(), c = a.x + (g - c), e = a.y + (f - e), b.preventDragOut && (r = -r * k + m / 2 - b.diffY * b.mapScale * k, m = m / 2 - b.diffY * b.mapScale * k, c = d.fitToBounds(c, -p * k + n / 2, n / 2), e = d.fitToBounds(e, r, m)), isNaN(c) || isNaN(e) || (a.translate(c, e, k, !0), b.updateSmallMap()));
              b.previuosMouseX = g;
              b.previuosMouseY = f;
            }
          }
        },
        selectObject: function(a, b) {
          var c = this;
          a || (a = c.dataProvider);
          a.isOver = !1;
          var e = a.linkToObject;
          d.isString(e) && (e = c.getObjectById(e));
          a.useTargetsZoomValues && e && (a.zoomX = e.zoomX, a.zoomY = e.zoomY, a.zoomLatitude = e.zoomLatitude, a.zoomLongitude = e.zoomLongitude, a.zoomLevel = e.zoomLevel);
          var g = c.selectedObject;
          g && c.returnInitialColor(g);
          c.selectedObject = a;
          var f = !1,
              h,
              k;
          "MapArea" == a.objectType && (a.autoZoomReal && (f = !0), h = c.areasSettings.selectedOutlineColor, k = c.areasSettings.selectedOutlineThickness);
          if (e && !f && (d.isString(e) && (e = c.getObjectById(e)), isNaN(a.zoomLevel) && isNaN(a.zoomX) && isNaN(a.zoomY))) {
            if (c.extendMapData(e))
              return;
            c.selectObject(e);
            return;
          }
          c.allowMultipleDescriptionWindows || c.closeAllDescriptions();
          clearTimeout(c.selectedObjectTimeOut);
          clearTimeout(c.processObjectsTimeOut);
          e = c.zoomDuration;
          !f && isNaN(a.zoomLevel) && isNaN(a.zoomX) && isNaN(a.zoomY) ? (c.showDescriptionAndGetUrl(), b || c.processObjects()) : (c.selectedObjectTimeOut = setTimeout(function() {
            c.showDescriptionAndGetUrl.call(c);
          }, 1E3 * e + 200), c.showObjectsAfterZoom) ? b || (c.processObjectsTimeOut = setTimeout(function() {
            c.processObjects.call(c);
          }, 1E3 * e + 200)) : b || c.processObjects();
          e = a.displayObject;
          f = a.selectedColorReal;
          if ("MapImage" == a.objectType) {
            h = c.imagesSettings.selectedOutlineColor;
            k = c.imagesSettings.selectedOutlineThickness;
            var e = a.image,
                l = a.selectedScaleReal;
            if (!isNaN(l) && 1 != l) {
              var m = a.scale;
              isNaN(a.tempScale) || (m = a.tempScale);
              isNaN(m) && (m = 1);
              a.tempScale = m;
              var n = a.displayObject;
              n.translate(n.x, n.y, m * l, !0);
            }
          }
          if (e) {
            if (d.removeCN(c, e, "selected-object"), d.setCN(c, e, "selected-object"), a.bringForwardOnHover && a.displayObject.toFront(), c.outlinesToFront(), !a.preserveOriginalAttributes) {
              e.setAttr("stroke", a.outlineColorReal);
              void 0 !== f && e.setAttr("fill", f);
              void 0 !== h && e.setAttr("stroke", h);
              void 0 !== k && e.setAttr("stroke-width", k);
              "MapLine" == a.objectType && ((l = a.lineSvg) && l.setAttr("stroke", f), l = a.arrowSvg) && (l.setAttr("fill", f), l.setAttr("stroke", f));
              if (l = a.imageLabel)
                m = a.selectedLabelColorReal, void 0 !== m && l.setAttr("fill", m);
              a.selectable || (e.setAttr("cursor", "default"), l && l.setAttr("cursor", "default"));
            }
          } else
            c.returnInitialColorReal(a);
          if (e = a.groupId)
            for (l = a.groupArray, l || (l = c.getGroupById(e), a.groupArray = l), m = 0; m < l.length; m++)
              if (n = l[m], n.isOver = !1, e = n.displayObject, "MapImage" == n.objectType && (e = n.image), e) {
                var p = n.selectedColorReal;
                void 0 !== p && e.setAttr("fill", p);
                void 0 !== h && e.setAttr("stroke", h);
                void 0 !== k && e.setAttr("stroke-width", k);
                "MapLine" == n.objectType && ((e = n.lineSvg) && e.setAttr("stroke", f), e = n.arrowSvg) && (e.setAttr("fill", f), e.setAttr("stroke", f));
              }
          c.rescaleObjects();
          c.zoomToSelectedObject();
          g != a && c.fire({
            type: "selectedObjectChanged",
            chart: c
          });
        },
        returnInitialColor: function(a, b) {
          this.returnInitialColorReal(a);
          b && (a.isFirst = !1);
          if (this.selectedObject.bringForwardOnHover) {
            var c = this.selectedObject.displayObject;
            c && c.toFront();
          }
          if (c = a.groupId) {
            var c = this.getGroupById(c),
                d;
            for (d = 0; d < c.length; d++)
              this.returnInitialColorReal(c[d]), b && (c[d].isFirst = !1);
          }
          this.outlinesToFront();
        },
        outlinesToFront: function() {
          if (this.outlines)
            for (var a = 0; a < this.outlines.length; a++)
              this.outlines[a].toFront();
        },
        closeAllDescriptions: function() {
          this.descriptionsDiv.innerHTML = "";
        },
        fireClosed: function() {
          this.fire({
            type: "descriptionClosed",
            chart: this
          });
        },
        returnInitialColorReal: function(a) {
          a.isOver = !1;
          var b = a.displayObject;
          if (b) {
            d.removeCN(this, b, "selected-object");
            b.toPrevious();
            if ("MapImage" == a.objectType) {
              var c = a.tempScale;
              isNaN(c) || b.translate(b.x, b.y, c, !0);
              a.tempScale = NaN;
              b = a.image;
            }
            c = a.colorReal;
            if ("MapLine" == a.objectType) {
              var e = a.lineSvg;
              e && e.setAttr("stroke", c);
              if (e = a.arrowSvg) {
                var g = a.arrowColor;
                void 0 === g && (g = c);
                e.setAttr("fill", g);
                e.setAttr("stroke", g);
              }
            }
            var e = a.alphaReal,
                g = a.outlineAlphaReal,
                f = a.outlineThicknessReal,
                h = a.outlineColorReal;
            if (a.showAsSelected) {
              var c = a.selectedColorReal,
                  k,
                  l;
              "MapImage" == a.objectType && (k = this.imagesSettings.selectedOutlineColor, l = this.imagesSettings.selectedOutlineThickness);
              "MapArea" == a.objectType && (k = this.areasSettings.selectedOutlineColor, l = this.areasSettings.selectedOutlineThickness);
              void 0 !== k && (h = k);
              void 0 !== l && (f = l);
            }
            "bubble" == a.type && (c = void 0);
            void 0 !== c && b.setAttr("fill", c);
            if (k = a.image)
              k.setAttr("fill", c), k.setAttr("stroke", h), k.setAttr("stroke-width", f), k.setAttr("fill-opacity", e), k.setAttr("stroke-opacity", g);
            "MapArea" == a.objectType && (c = 1, this.areasSettings.adjustOutlineThickness && (c = this.zoomLevel() * this.mapScale), b.setAttr("stroke", h), b.setAttr("stroke-width", f / c), b.setAttr("fill-opacity", e), b.setAttr("stroke-opacity", g));
            (c = a.pattern) && b.pattern(c, this.mapScale, this.path);
            (b = a.imageLabel) && !a.labelInactive && (a.showAsSelected && void 0 !== a.selectedLabelColor ? b.setAttr("fill", a.selectedLabelColor) : b.setAttr("fill", a.labelColorReal));
          }
        },
        zoomToRectangle: function(a, b, c, e) {
          var g = this.realWidth,
              f = this.realHeight,
              h = this.mapSet.scale,
              k = this.zoomControl,
              g = d.fitToBounds(c / g > e / f ? .8 * g / (c * h) : .8 * f / (e * h), k.minZoomLevel, k.maxZoomLevel);
          this.zoomToMapXY(g, (a + c / 2) * h, (b + e / 2) * h);
        },
        zoomToLatLongRectangle: function(a, b, c, e) {
          var g = this.dataProvider,
              f = this.zoomControl,
              h = Math.abs(c - a),
              k = Math.abs(b - e),
              l = Math.abs(g.rightLongitude - g.leftLongitude),
              g = Math.abs(g.topLatitude - g.bottomLatitude),
              f = d.fitToBounds(h / l > k / g ? .8 * l / h : .8 * g / k, f.minZoomLevel, f.maxZoomLevel);
          this.zoomToLongLat(f, a + (c - a) / 2, e + (b - e) / 2);
        },
        getGroupById: function(a) {
          var b = [];
          this.getGroup(this.imagesProcessor.allObjects, a, b);
          this.getGroup(this.linesProcessor.allObjects, a, b);
          this.getGroup(this.areasProcessor.allObjects, a, b);
          return b;
        },
        zoomToGroup: function(a) {
          a = "object" == typeof a ? a : this.getGroupById(a);
          var b,
              c,
              d,
              g,
              f;
          for (f = 0; f < a.length; f++) {
            var h = a[f].displayObject;
            if (h) {
              var k = h.getBBox(),
                  h = k.y,
                  l = k.y + k.height,
                  m = k.x,
                  k = k.x + k.width;
              if (h < b || isNaN(b))
                b = h;
              if (l > g || isNaN(g))
                g = l;
              if (m < c || isNaN(c))
                c = m;
              if (k > d || isNaN(d))
                d = k;
            }
          }
          c += this.diffX;
          d += this.diffX;
          g += this.diffY;
          b += this.diffY;
          this.zoomToRectangle(c, b, d - c, g - b);
        },
        getGroup: function(a, b, c) {
          if (a) {
            var d;
            for (d = 0; d < a.length; d++) {
              var g = a[d];
              g.groupId == b && c.push(g);
            }
          }
        },
        zoomToStageXY: function(a, b, c, e) {
          if (!this.objectWasClicked) {
            var g = this.zoomControl;
            a = d.fitToBounds(a, g.minZoomLevel, g.maxZoomLevel);
            var g = this.zoomLevel(),
                f = this.mapSet.getBBox();
            b = this.xyToCoordinates((b - this.mapContainer.x) / g - f.x * this.mapScale, (c - this.mapContainer.y) / g - f.y * this.mapScale);
            this.zoomToLongLat(a, b.longitude, b.latitude, e);
          }
        },
        zoomToLongLat: function(a, b, c, d) {
          b = this.coordinatesToXY(b, c);
          this.zoomToMapXY(a, b.x, b.y, d);
        },
        zoomToMapXY: function(a, b, c, d) {
          var g = this.mapWidth,
              f = this.mapHeight;
          this.zoomTo(a, -(b / g) * a + this.realWidth / g / 2, -(c / f) * a + this.realHeight / f / 2, d);
        },
        zoomToObject: function(a) {
          if (a) {
            var b = a.zoomLatitude,
                c = a.zoomLongitude;
            isNaN(a.zoomLatitudeC) || (b = a.zoomLatitudeC);
            isNaN(a.zoomLongitudeC) || (c = a.zoomLongitudeC);
            var e = a.zoomLevel,
                g = this.zoomInstantly,
                f = a.zoomX,
                h = a.zoomY,
                k = this.realWidth,
                l = this.realHeight;
            isNaN(e) || (isNaN(b) || isNaN(c) ? this.zoomTo(e, f, h, g) : this.zoomToLongLat(e, c, b, g));
            this.zoomInstantly = !1;
            "MapImage" == a.objectType && isNaN(a.zoomX) && isNaN(a.zoomY) && isNaN(a.zoomLatitude) && isNaN(a.zoomLongitude) && !isNaN(a.latitude) && !isNaN(a.longitude) && this.zoomToLongLat(a.zoomLevel, a.longitude, a.latitude);
            "MapArea" == a.objectType && (g = a.displayObject.getBBox(), f = this.mapScale, b = (g.x + this.diffX) * f, c = (g.y + this.diffY) * f, e = g.width * f, g = g.height * f, k = a.autoZoomReal && isNaN(a.zoomLevel) ? e / k > g / l ? .8 * k / e : .8 * l / g : a.zoomLevel, l = this.zoomControl, k = d.fitToBounds(k, l.minZoomLevel, l.maxZoomLevel), isNaN(a.zoomX) && isNaN(a.zoomY) && isNaN(a.zoomLatitude) && isNaN(a.zoomLongitude) && this.zoomToMapXY(k, b + e / 2, c + g / 2));
            this.zoomControl.update();
          }
        },
        zoomToSelectedObject: function() {
          this.zoomToObject(this.selectedObject);
        },
        zoomTo: function(a, b, c, e) {
          var g = this.zoomControl;
          a = d.fitToBounds(a, g.minZoomLevel, g.maxZoomLevel);
          g = this.zoomLevel();
          isNaN(b) && (b = this.realWidth / this.mapWidth, b = (this.zoomX() - .5 * b) * (a / g) + .5 * b);
          isNaN(c) && (c = this.realHeight / this.mapHeight, c = (this.zoomY() - .5 * c) * (a / g) + .5 * c);
          this.stopAnimation();
          isNaN(a) || (g = this.mapContainer, this.initialX = g.x, this.initialY = g.y, this.initialScale = g.scale, this.finalX = this.mapWidth * b, this.finalY = this.mapHeight * c, this.finalScale = a, this.finalX != this.initialX || this.finalY != this.initialY || this.finalScale != this.initialScale ? e ? (this.tweenPercent = 1, this.rescaleMapAndObjects(), this.wheelBusy = !1) : this.animateMap() : this.wheelBusy = !1);
        },
        loadXml: function(a) {
          var b;
          window.XMLHttpRequest && (b = new XMLHttpRequest);
          b.overrideMimeType && b.overrideMimeType("text/xml");
          b.open("GET", a, !1);
          b.send();
          this.parseXMLObject(b.responseXML);
          this.svgData && this.buildEverything();
        },
        stopAnimation: function() {
          this.frame = this.totalFrames;
        },
        processObjects: function(a) {
          var b = this.selectedObject;
          if (0 < b.images.length || 0 < b.areas.length || 0 < b.lines.length || b == this.dataProvider || a) {
            a = this.container;
            var c = this.stageImagesContainer;
            c && c.remove();
            this.stageImagesContainer = c = a.set();
            this.trendLinesSet.push(c);
            var d = this.stageLinesContainer;
            d && d.remove();
            this.stageLinesContainer = d = a.set();
            this.trendLinesSet.push(d);
            var g = this.mapImagesContainer;
            g && g.remove();
            this.mapImagesContainer = g = a.set();
            this.mapContainer.push(g);
            var f = this.mapLinesContainer;
            f && f.remove();
            this.mapLinesContainer = f = a.set();
            this.mapContainer.push(f);
            this.linesAboveImages ? (g.toFront(), c.toFront(), f.toFront(), d.toFront()) : (f.toFront(), d.toFront(), g.toFront(), c.toFront());
            b && (this.imagesProcessor.reset(), this.linesProcessor.reset(), this.linesAboveImages ? (this.imagesProcessor.process(b), this.linesProcessor.process(b)) : (this.linesProcessor.process(b), this.imagesProcessor.process(b)));
            this.rescaleObjects();
          }
        },
        processAreas: function() {
          this.areasProcessor.process(this.dataProvider);
        },
        buildSVGMap: function() {
          d.remove(this.mapSet);
          var a = this.svgData.g.path,
              b = this.container,
              c = b.set();
          this.svgAreas = [];
          this.svgAreasById = {};
          void 0 === a.length && (a = [a]);
          var e;
          for (e = 0; e < a.length; e++) {
            var g = a[e],
                f = g.d,
                h = g.title;
            g.titleTr && (h = g.titleTr);
            var k = b.path(f);
            k.id = g.id;
            if (this.areasSettings.preserveOriginalAttributes) {
              k.customAttr = {};
              for (var l in g)
                "d" != l && "id" != l && "title" != l && (k.customAttr[l] = g[l]);
            }
            g.outline && (k.outline = !0);
            k.path = f;
            this.svgAreasById[g.id] = {
              area: k,
              title: h,
              className: g["class"]
            };
            this.svgAreas.push(k);
            c.push(k);
          }
          this.mapSet = c;
          this.mapContainer.push(c);
          this.resizeMap();
        },
        centerAlign: function() {},
        setProjection: function(a) {
          this.projection = a;
          this.chartCreated = !1;
          this.buildEverything();
        },
        addObjectEventListeners: function(a, b) {
          var c = this;
          a.mousedown(function(a) {
            c.mouseDownMapObject(b, a);
          }).mouseup(function(a) {
            c.clickMapObject(b, a);
          }).mouseover(function(a) {
            c.balloonX = NaN;
            c.rollOverMapObject(b, !0, a);
          }).mouseout(function(a) {
            c.balloonX = NaN;
            c.rollOutMapObject(b, a);
          }).touchend(function(a) {
            4 > Math.abs(c.mouseX - c.tmx) && 4 > Math.abs(c.mouseY - c.tmy) && (c.tapped = !0);
            c.tapToActivate && !c.tapped || c.mapWasDragged || c.mapWasPinched || (c.balloonX = NaN, c.rollOverMapObject(b, !0, a), c.clickMapObject(b, a));
          }).touchstart(function(a) {
            c.tmx = c.mouseX;
            c.tmy = c.mouseY;
            c.mouseDownMapObject(b, a);
          }).keyup(function(a) {
            13 == a.keyCode && c.clickMapObject(b, a);
          }).focus(function(a) {
            var d,
                f;
            "MapImage" != b.objectType || isNaN(b.longitude) || (d = b.longitude, f = b.latitude);
            "MapArea" == b.objectType && (d = c.getAreaCenterLongitude(b), f = c.getAreaCenterLatitude(b));
            d = c.coordinatesToStageXY(d, f);
            c.balloonX = d.x;
            c.balloonY = d.y;
            c.rollOverMapObject(b, !0, a);
          }).blur(function(a) {
            c.rollOutMapObject(b, a);
          });
        },
        checkIfSelected: function(a) {
          var b = this.selectedObject;
          if (b == a)
            return !0;
          if (b = b.groupId) {
            var b = this.getGroupById(b),
                c;
            for (c = 0; c < b.length; c++)
              if (b[c] == a)
                return !0;
          }
          return !1;
        },
        clearMap: function() {
          this.chartDiv.innerHTML = "";
          this.clearObjectList();
        },
        clearObjectList: function() {
          var a = this.objectList;
          a && a.div && (a.div.innerHTML = "");
        },
        checkIfLast: function(a) {
          if (a) {
            var b = a.parentNode;
            if (b && b.lastChild == a)
              return !0;
          }
          return !1;
        },
        showAsRolledOver: function(a) {
          var b = a.displayObject;
          if (!a.showAsSelected && b && !a.isOver) {
            b.node.onmouseout = function() {};
            b.node.onmouseover = function() {};
            b.node.onclick = function() {};
            !a.isFirst && a.bringForwardOnHover && (b.toFront(), a.isFirst = !0);
            var c = a.rollOverColorReal,
                e;
            a.preserveOriginalAttributes && (c = void 0);
            "bubble" == a.type && (c = void 0);
            void 0 == c && (isNaN(a.rollOverBrightnessReal) || (c = d.adjustLuminosity(a.colorReal, a.rollOverBrightnessReal / 100)));
            if (void 0 != c)
              if ("MapImage" == a.objectType)
                (e = a.image) && e.setAttr("fill", c);
              else if ("MapLine" == a.objectType) {
                if ((e = a.lineSvg) && e.setAttr("stroke", c), e = a.arrowSvg)
                  e.setAttr("fill", c), e.setAttr("stroke", c);
              } else
                b.setAttr("fill", c);
            (c = a.imageLabel) && !a.labelInactive && (e = a.labelRollOverColorReal, void 0 != e && c.setAttr("fill", e));
            c = a.rollOverOutlineColorReal;
            void 0 != c && ("MapImage" == a.objectType ? (e = a.image) && e.setAttr("stroke", c) : b.setAttr("stroke", c));
            "MapImage" == a.objectType ? (c = this.imagesSettings.rollOverOutlineThickness, (e = a.image) && (isNaN(c) || e.setAttr("stroke-width", c))) : (c = this.areasSettings.rollOverOutlineThickness, isNaN(c) || b.setAttr("stroke-width", c));
            if ("MapArea" == a.objectType) {
              c = this.areasSettings;
              e = a.rollOverAlphaReal;
              isNaN(e) || b.setAttr("fill-opacity", e);
              e = c.rollOverOutlineAlpha;
              isNaN(e) || b.setAttr("stroke-opacity", e);
              e = 1;
              this.areasSettings.adjustOutlineThickness && (e = this.zoomLevel() * this.mapScale);
              var g = c.rollOverOutlineThickness;
              isNaN(g) || b.setAttr("stroke-width", g / e);
              (c = c.rollOverPattern) && b.pattern(c, this.mapScale, this.path);
            }
            "MapImage" == a.objectType && (c = a.rollOverScaleReal, isNaN(c) || 1 == c || (e = b.scale, isNaN(e) && (e = 1), a.tempScale = e, b.translate(b.x, b.y, e * c, !0)));
            this.useHandCursorOnClickableOjects && this.checkIfClickable(a) && b.setAttr("cursor", "pointer");
            a.mouseEnabled && this.addObjectEventListeners(b, a);
            a.isOver = !0;
          }
          this.outlinesToFront();
        },
        rollOverMapObject: function(a, b, c) {
          if (this.chartCreated) {
            this.handleMouseMove();
            var d = this.previouslyHovered;
            d && d != a ? (!1 === this.checkIfSelected(d) && (this.returnInitialColor(d, !0), this.previouslyHovered = null), this.balloon.hide(0)) : clearTimeout(this.hoverInt);
            if (!this.preventHover) {
              if (!1 === this.checkIfSelected(a)) {
                if (d = a.groupId) {
                  var d = this.getGroupById(d),
                      g;
                  for (g = 0; g < d.length; g++)
                    d[g] != a && this.showAsRolledOver(d[g]);
                }
                this.showAsRolledOver(a);
              } else
                (d = a.displayObject) && (this.allowClickOnSelectedObject ? d.setAttr("cursor", "pointer") : d.setAttr("cursor", "default"));
              this.showDescriptionOnHover ? this.showDescription(a) : !this.showBalloonOnSelectedObject && this.checkIfSelected(a) || !1 === b || (g = this.balloon, this.balloon.fixedPosition = !1, b = a.colorReal, d = "", void 0 !== b && this.useObjectColorForBalloon || (b = g.fillColor), (g = a.balloonTextReal) && (d = this.formatString(g, a)), this.balloonLabelFunction && (d = this.balloonLabelFunction(a, this)), d && "" !== d && this.showBalloon(d, b, !1, this.balloonX, this.balloonY));
              this.fire({
                type: "rollOverMapObject",
                mapObject: a,
                chart: this,
                event: c
              });
              this.previouslyHovered = a;
            }
          }
        },
        longitudeToX: function(a) {
          return (this.longitudeToCoordinate(a) + this.diffX * this.mapScale) * this.zoomLevel() + this.mapContainer.x;
        },
        latitudeToY: function(a) {
          return (this.latitudeToCoordinate(a) + this.diffY * this.mapScale) * this.zoomLevel() + this.mapContainer.y;
        },
        latitudeToStageY: function(a) {
          return this.latitudeToCoordinate(a) * this.zoomLevel() + this.mapContainer.y + this.diffY * this.mapScale;
        },
        longitudeToStageX: function(a) {
          return this.longitudeToCoordinate(a) * this.zoomLevel() + this.mapContainer.x + this.diffX * this.mapScale;
        },
        stageXToLongitude: function(a) {
          a = (a - this.mapContainer.x) / this.zoomLevel();
          return this.coordinateToLongitude(a);
        },
        stageYToLatitude: function(a) {
          a = (a - this.mapContainer.y) / this.zoomLevel();
          return this.coordinateToLatitude(a);
        },
        rollOutMapObject: function(a, b) {
          this.hideBalloon();
          a && this.chartCreated && a.isOver && (this.checkIfSelected(a) || this.returnInitialColor(a), this.fire({
            type: "rollOutMapObject",
            mapObject: a,
            chart: this,
            event: b
          }));
        },
        formatString: function(a, b) {
          var c = this.nf,
              e = this.pf,
              g = b.title;
          b.titleTr && (g = b.titleTr);
          void 0 == g && (g = "");
          var f = b.value,
              f = isNaN(f) ? "" : d.formatNumber(f, c),
              c = b.percents,
              c = isNaN(c) ? "" : d.formatNumber(c, e),
              e = b.description;
          void 0 == e && (e = "");
          var h = b.customData;
          void 0 == h && (h = "");
          return a = d.massReplace(a, {
            "[[title]]": g,
            "[[value]]": f,
            "[[percent]]": c,
            "[[description]]": e,
            "[[customData]]": h
          });
        },
        mouseDownMapObject: function(a, b) {
          this.fire({
            type: "mouseDownMapObject",
            mapObject: a,
            chart: this,
            event: b
          });
        },
        clickMapObject: function(a, b) {
          var c = this;
          b && (b.touches || isNaN(a.zoomLevel) && isNaN(a.zoomX) && isNaN(a.zoomY) || c.hideBalloon());
          if (c.chartCreated && !c.preventHover && c.checkTouchDuration(b) && !c.mapWasDragged && c.checkIfClickable(a) && !c.mapWasPinched) {
            c.selectObject(a);
            var d = c.zoomLevel(),
                g = c.mapSet.getBBox(),
                d = c.xyToCoordinates((c.mouseX - c.mapContainer.x) / d - g.x * c.mapScale, (c.mouseY - c.mapContainer.y) / d - g.y * c.mapScale);
            c.clickLatitude = d.latitude;
            c.clickLongitude = d.longitude;
            b && b.touches && setTimeout(function() {
              c.showBalloonAfterZoom.call(c);
            }, 1E3 * c.zoomDuration);
            c.fire({
              type: "clickMapObject",
              mapObject: a,
              chart: c,
              event: b
            });
            c.objectWasClicked = !0;
          }
        },
        showBalloonAfterZoom: function() {
          var a = this.clickLongitude,
              b = this.clickLatitude,
              c = this.selectedObject;
          "MapImage" != c.objectType || isNaN(c.longitude) || (a = c.longitude, b = c.latitude);
          a = this.coordinatesToStageXY(a, b);
          this.balloonX = a.x;
          this.balloonY = a.y;
          this.rollOverMapObject(this.selectedObject, !0);
        },
        checkIfClickable: function(a) {
          var b = this.allowClickOnSelectedObject;
          return this.selectedObject == a && b ? !0 : this.selectedObject != a || b ? !0 === a.selectable || "MapArea" == a.objectType && a.autoZoomReal || a.url || a.linkToObject || 0 < a.images.length || 0 < a.lines.length || !isNaN(a.zoomLevel) || !isNaN(a.zoomX) || !isNaN(a.zoomY) || a.description ? !0 : !1 : !1;
        },
        resizeMap: function() {
          var a = this.mapSet;
          if (a) {
            var b = 1,
                c = a.getBBox(),
                d = this.realWidth,
                g = this.realHeight,
                f = c.width,
                c = c.height;
            0 < f && 0 < c && (this.fitMapToContainer && (b = f / d > c / g ? d / f : g / c), a.translate(0, 0, b, !0), this.mapScale = b, this.mapHeight = c * b, this.mapWidth = f * b);
          }
        },
        zoomIn: function() {
          var a = this.zoomLevel() * this.zoomControl.zoomFactor;
          this.zoomTo(a);
        },
        zoomOut: function() {
          var a = this.zoomLevel() / this.zoomControl.zoomFactor;
          this.zoomTo(a);
        },
        moveLeft: function() {
          var a = this.zoomX() + this.zoomControl.panStepSize;
          this.zoomTo(this.zoomLevel(), a, this.zoomY());
        },
        moveRight: function() {
          var a = this.zoomX() - this.zoomControl.panStepSize;
          this.zoomTo(this.zoomLevel(), a, this.zoomY());
        },
        moveUp: function() {
          var a = this.zoomY() + this.zoomControl.panStepSize;
          this.zoomTo(this.zoomLevel(), this.zoomX(), a);
        },
        moveDown: function() {
          var a = this.zoomY() - this.zoomControl.panStepSize;
          this.zoomTo(this.zoomLevel(), this.zoomX(), a);
        },
        zoomX: function() {
          return this.mapSet ? Math.round(1E4 * this.mapContainer.x / this.mapWidth) / 1E4 : NaN;
        },
        zoomY: function() {
          return this.mapSet ? Math.round(1E4 * this.mapContainer.y / this.mapHeight) / 1E4 : NaN;
        },
        goHome: function() {
          this.selectObject(this.dataProvider);
          this.fire({
            type: "homeButtonClicked",
            chart: this
          });
        },
        zoomLevel: function() {
          return Math.round(1E5 * this.mapContainer.scale) / 1E5;
        },
        showDescriptionAndGetUrl: function() {
          var a = this.selectedObject;
          if (a) {
            this.showDescription();
            var b = a.url;
            if (b)
              d.getURL(b, a.urlTarget);
            else if (b = a.linkToObject) {
              if (d.isString(b)) {
                var c = this.getObjectById(b);
                if (c) {
                  this.selectObject(c);
                  return;
                }
              }
              b && a.passZoomValuesToTarget && (b.zoomLatitude = this.zoomLatitude(), b.zoomLongitude = this.zoomLongitude(), b.zoomLevel = this.zoomLevel());
              this.extendMapData(b) || this.selectObject(b);
            }
          }
        },
        extendMapData: function(a) {
          var b = a.objectType;
          if ("MapImage" != b && "MapArea" != b && "MapLine" != b)
            return d.extend(a, new d.MapData, !0), this.dataProvider = a, this.zoomInstantly = !0, this.validateData(), !0;
        },
        showDescription: function(a) {
          a || (a = this.selectedObject);
          this.allowMultipleDescriptionWindows || this.closeAllDescriptions();
          if (a.description) {
            var b = a.descriptionWindow;
            b && b.close();
            b = new d.DescriptionWindow;
            a.descriptionWindow = b;
            var c = a.descriptionWindowWidth,
                e = a.descriptionWindowHeight,
                g = a.descriptionWindowLeft,
                f = a.descriptionWindowTop,
                h = a.descriptionWindowRight,
                k = a.descriptionWindowBottom;
            isNaN(h) || (g = this.realWidth - h);
            isNaN(k) || (f = this.realHeight - k);
            var l = a.descriptionWindowX;
            isNaN(l) || (g = l);
            l = a.descriptionWindowY;
            isNaN(l) || (f = l);
            isNaN(g) && (g = this.mouseX, g = g > this.realWidth / 2 ? g - c - 20 : g + 20);
            isNaN(f) && (f = this.mouseY);
            b.maxHeight = e;
            l = a.title;
            a.titleTr && (l = a.titleTr);
            b.show(this, this.descriptionsDiv, a.description, l);
            a = b.div.style;
            a.position = "absolute";
            a.width = c + "px";
            a.maxHeight = e + "px";
            isNaN(k) || (f -= b.div.offsetHeight);
            isNaN(h) || (g -= b.div.offsetWidth);
            a.left = g + "px";
            a.top = f + "px";
          }
        },
        parseXMLObject: function(a) {
          var b = {root: {}};
          this.parseXMLNode(b, "root", a);
          this.svgData = b.root.svg;
          this.getBounds();
        },
        getBounds: function() {
          var a = this.dataProvider;
          try {
            var b = this.svgData.defs["amcharts:ammap"];
            a.leftLongitude = Number(b.leftLongitude);
            a.rightLongitude = Number(b.rightLongitude);
            a.topLatitude = Number(b.topLatitude);
            a.bottomLatitude = Number(b.bottomLatitude);
            a.projection = b.projection;
            var c = b.wrappedLongitudes;
            c && (a.rightLongitude += 360);
            a.wrappedLongitudes = c;
          } catch (d) {}
        },
        recalcLongitude: function(a) {
          return this.dataProvider.wrappedLongitudes ? a < this.dataProvider.leftLongitude ? Number(a) + 360 : a : a;
        },
        latitudeToCoordinate: function(a) {
          var b,
              c = this.dataProvider;
          if (this.mapSet) {
            b = c.topLatitude;
            var d = c.bottomLatitude;
            "mercator" == c.projection && (a = this.mercatorLatitudeToCoordinate(a), b = this.mercatorLatitudeToCoordinate(b), d = this.mercatorLatitudeToCoordinate(d));
            b = (a - b) / (d - b) * this.mapHeight;
          }
          return b;
        },
        longitudeToCoordinate: function(a) {
          a = this.recalcLongitude(a);
          var b,
              c = this.dataProvider;
          this.mapSet && (b = c.leftLongitude, b = (a - b) / (c.rightLongitude - b) * this.mapWidth);
          return b;
        },
        mercatorLatitudeToCoordinate: function(a) {
          89.5 < a && (a = 89.5);
          -89.5 > a && (a = -89.5);
          a = d.degreesToRadians(a);
          return d.radiansToDegrees(.5 * Math.log((1 + Math.sin(a)) / (1 - Math.sin(a))) / 2);
        },
        zoomLatitude: function() {
          if (this.mapContainer) {
            var a = this.mapSet.getBBox(),
                b = (-this.mapContainer.x + this.previousWidth / 2) / this.zoomLevel() - a.x * this.mapScale,
                a = (-this.mapContainer.y + this.previousHeight / 2) / this.zoomLevel() - a.y * this.mapScale;
            return this.xyToCoordinates(b, a).latitude;
          }
        },
        zoomLongitude: function() {
          if (this.mapContainer) {
            var a = this.mapSet.getBBox(),
                b = (-this.mapContainer.x + this.previousWidth / 2) / this.zoomLevel() - a.x * this.mapScale,
                a = (-this.mapContainer.y + this.previousHeight / 2) / this.zoomLevel() - a.y * this.mapScale;
            return this.xyToCoordinates(b, a).longitude;
          }
        },
        getAreaCenterLatitude: function(a) {
          a = a.displayObject.getBBox();
          var b = this.mapScale,
              c = this.mapSet.getBBox();
          return this.xyToCoordinates((a.x + a.width / 2 + this.diffX) * b - c.x * b, (a.y + a.height / 2 + this.diffY) * b - c.y * b).latitude;
        },
        getAreaCenterLongitude: function(a) {
          a = a.displayObject.getBBox();
          var b = this.mapScale,
              c = this.mapSet.getBBox();
          return this.xyToCoordinates((a.x + a.width / 2 + this.diffX) * b - c.x * b, (a.y + a.height / 2 + this.diffY) * b - c.y * b).longitude;
        },
        milesToPixels: function(a) {
          var b = this.dataProvider;
          return this.mapWidth / (b.rightLongitude - b.leftLongitude) * a / 69.172;
        },
        kilometersToPixels: function(a) {
          var b = this.dataProvider;
          return this.mapWidth / (b.rightLongitude - b.leftLongitude) * a / 111.325;
        },
        handleBackgroundClick: function() {
          if (this.backgroundZoomsToTop && !this.mapWasDragged) {
            var a = this.dataProvider;
            if (this.checkIfClickable(a))
              this.clickMapObject(a);
            else {
              var b = a.zoomX,
                  c = a.zoomY,
                  d = a.zoomLongitude,
                  g = a.zoomLatitude,
                  a = a.zoomLevel;
              isNaN(b) || isNaN(c) || this.zoomTo(a, b, c);
              isNaN(d) || isNaN(g) || this.zoomToLongLat(a, d, g, !0);
            }
          }
        },
        parseXMLNode: function(a, b, c, d) {
          void 0 === d && (d = "");
          var g,
              f,
              h;
          if (c) {
            var k = c.childNodes.length;
            for (g = 0; g < k; g++) {
              f = c.childNodes[g];
              var l = f.nodeName,
                  m = f.nodeValue ? this.trim(f.nodeValue) : "",
                  n = !1;
              f.attributes && 0 < f.attributes.length && (n = !0);
              if (0 !== f.childNodes.length || "" !== m || !1 !== n)
                if (3 == f.nodeType || 4 == f.nodeType) {
                  if ("" !== m) {
                    f = 0;
                    for (h in a[b])
                      a[b].hasOwnProperty(h) && f++;
                    f ? a[b]["#text"] = m : a[b] = m;
                  }
                } else if (1 == f.nodeType) {
                  var p;
                  void 0 !== a[b][l] ? void 0 === a[b][l].length ? (p = a[b][l], a[b][l] = [], a[b][l].push(p), a[b][l].push({}), p = a[b][l][1]) : "object" == typeof a[b][l] && (a[b][l].push({}), p = a[b][l][a[b][l].length - 1]) : (a[b][l] = {}, p = a[b][l]);
                  if (f.attributes && f.attributes.length)
                    for (m = 0; m < f.attributes.length; m++)
                      p[f.attributes[m].name] = f.attributes[m].value;
                  void 0 !== a[b][l].length ? this.parseXMLNode(a[b][l], a[b][l].length - 1, f, d + "  ") : this.parseXMLNode(a[b], l, f, d + "  ");
                }
            }
            f = 0;
            c = "";
            for (h in a[b])
              "#text" == h ? c = a[b][h] : f++;
            0 === f && void 0 === a[b].length && (a[b] = c);
          }
        },
        doDoubleClickZoom: function() {
          if (!this.mapWasDragged) {
            var a = this.zoomLevel() * this.zoomControl.zoomFactor;
            this.zoomToStageXY(a, this.mouseX, this.mouseY);
          }
        },
        getDevInfo: function() {
          var a = this.zoomLevel(),
              b = this.mapSet.getBBox(),
              b = this.xyToCoordinates((this.mouseX - this.mapContainer.x) / a - b.x * this.mapScale, (this.mouseY - this.mapContainer.y) / a - b.y * this.mapScale),
              a = {
                chart: this,
                type: "writeDevInfo",
                zoomLevel: a,
                zoomX: this.zoomX(),
                zoomY: this.zoomY(),
                zoomLatitude: this.zoomLatitude(),
                zoomLongitude: this.zoomLongitude(),
                latitude: b.latitude,
                longitude: b.longitude,
                left: this.mouseX,
                top: this.mouseY,
                right: this.realWidth - this.mouseX,
                bottom: this.realHeight - this.mouseY,
                percentLeft: Math.round(this.mouseX / this.realWidth * 100) + "%",
                percentTop: Math.round(this.mouseY / this.realHeight * 100) + "%",
                percentRight: Math.round((this.realWidth - this.mouseX) / this.realWidth * 100) + "%",
                percentBottom: Math.round((this.realHeight - this.mouseY) / this.realHeight * 100) + "%"
              },
              b = "zoomLevel:" + a.zoomLevel + ", zoomLongitude:" + a.zoomLongitude + ", zoomLatitude:" + a.zoomLatitude + "\n",
              b = b + ("zoomX:" + a.zoomX + ", zoomY:" + a.zoomY + "\n"),
              b = b + ("latitude:" + a.latitude + ", longitude:" + a.longitude + "\n"),
              b = b + ("left:" + a.left + ", top:" + a.top + "\n"),
              b = b + ("right:" + a.right + ", bottom:" + a.bottom + "\n"),
              b = b + ("left:" + a.percentLeft + ", top:" + a.percentTop + "\n"),
              b = b + ("right:" + a.percentRight + ", bottom:" + a.percentBottom + "\n");
          a.str = b;
          this.fire(a);
          return a;
        },
        getXY: function(a, b, c) {
          void 0 !== a && (-1 != String(a).indexOf("%") ? (a = Number(a.split("%").join("")), c && (a = 100 - a), a = Number(a) * b / 100) : c && (a = b - a));
          return a;
        },
        getObjectById: function(a) {
          var b = this.dataProvider;
          if (b.areas) {
            var c = this.getObject(a, b.areas);
            if (c)
              return c;
          }
          if (c = this.getObject(a, b.images))
            return c;
          if (a = this.getObject(a, b.lines))
            return a;
        },
        getObject: function(a, b) {
          if (b) {
            var c;
            for (c = 0; c < b.length; c++) {
              var d = b[c];
              if (d.id == a)
                return d;
              if (d.areas) {
                var g = this.getObject(a, d.areas);
                if (g)
                  return g;
              }
              if (g = this.getObject(a, d.images))
                return g;
              if (d = this.getObject(a, d.lines))
                return d;
            }
          }
        },
        parseData: function() {
          var a = this.dataProvider;
          this.processObject(a.areas, a, "area");
          this.processObject(a.images, a, "image");
          this.processObject(a.lines, a, "line");
        },
        processObject: function(a, b, c) {
          if (a) {
            var e;
            for (e = 0; e < a.length; e++) {
              var g = a[e];
              g.parentObject = b;
              "area" == c && d.extend(g, new d.MapArea(this.theme), !0);
              "image" == c && (g = d.extend(g, new d.MapImage(this.theme), !0));
              "line" == c && (g = d.extend(g, new d.MapLine(this.theme), !0));
              a[e] = g;
              g.areas && this.processObject(g.areas, g, "area");
              g.images && this.processObject(g.images, g, "image");
              g.lines && this.processObject(g.lines, g, "line");
            }
          }
        },
        positionChanged: function() {
          var a = {
            type: "positionChanged",
            zoomX: this.zoomX(),
            zoomY: this.zoomY(),
            zoomLevel: this.zoomLevel(),
            chart: this
          };
          this.fire(a);
        },
        getX: function(a, b) {
          return this.getXY(a, this.realWidth, b);
        },
        getY: function(a, b) {
          return this.getXY(a, this.realHeight, b);
        },
        trim: function(a) {
          if (a) {
            var b;
            for (b = 0; b < a.length; b++)
              if (-1 === " \n\r\t\f\x0B\u00a0\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u200b\u2028\u2029\u3000".indexOf(a.charAt(b))) {
                a = a.substring(b);
                break;
              }
            for (b = a.length - 1; 0 <= b; b--)
              if (-1 === " \n\r\t\f\x0B\u00a0\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u200b\u2028\u2029\u3000".indexOf(a.charAt(b))) {
                a = a.substring(0, b + 1);
                break;
              }
            return -1 === " \n\r\t\f\x0B\u00a0\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u200b\u2028\u2029\u3000".indexOf(a.charAt(0)) ? a : "";
          }
        },
        destroy: function() {
          d.AmMap.base.destroy.call(this);
        },
        x2c: function(a) {
          var b = this.dataProvider.leftLongitude;
          return Math.round(this.unscaledMapWidth * (a - b) / (this.dataProvider.rightLongitude - b) * 100) / 100;
        },
        y2c: function(a) {
          var b = this.dataProvider.topLatitude;
          return Math.round(this.unscaledMapHeight * (a - b) / (this.dataProvider.bottomLatitude - b) * 100) / 100;
        },
        normalize: function(a) {
          if (!a.pathsArray) {
            var b;
            if (a.normalized)
              b = a.normalized;
            else {
              var c = d.normalizePath(a.node);
              b = a.node.getAttribute("d");
              a.normalized = b;
              c.maxX > this.maxMapX && (this.maxMapX = c.maxX);
              c.minX < this.minMapX && (this.minMapX = c.minX);
              c.maxY > this.maxMapY && (this.maxMapY = c.maxY);
              c.minY < this.minMapY && (this.minMapY = c.minY);
            }
            a.node.setAttribute("d", b);
          }
        },
        redraw: function(a) {
          var b = a.normalized,
              b = b.split(" Z").join(""),
              b = b.split("M");
          a.pathsArray = [];
          for (var c = 0; c < b.length; c++) {
            var d = b[c];
            if (d) {
              for (var d = d.split("L"),
                  g = [],
                  f = 0; f < d.length; f++)
                if (d[f]) {
                  var h = d[f].split(" "),
                      h = this.xyToCoordinates(Number(h[1]) - this.minMapX, Number(h[2]) - this.minMapY, this.dpProjectionFunction, this.sourceMapWidth, this.sourceMapHeight);
                  g.push([h.longitude, h.latitude]);
                }
              a.pathsArray.push(g);
            }
          }
          b = "";
          for (c = 0; c < a.pathsArray.length; c++)
            b += this.redrawArea(a.pathsArray[c]);
          a.node.setAttribute("d", b);
          a.path = b;
        },
        redrawArea: function(a) {
          for (var b = !1,
              c = "",
              e = 0; e < a.length; e++) {
            var g = a[e][0],
                f = a[e][1],
                h = d.degreesToRadians(a[e][0]),
                k = d.degreesToRadians(a[e][1]),
                k = this.projectionFunction(h, k),
                h = d.roundTo(this.x2c(d.radiansToDegrees(k[0])), 3),
                k = d.roundTo(this.y2c(d.radiansToDegrees(k[1])), 3);
            h < this.minMapXX && (this.minMapXX = h, this.leftLongLat = {
              longitude: g,
              latitude: f
            });
            h > this.maxMapXX && (this.maxMapXX = h, this.rightLongLat = {
              longitude: g,
              latitude: f
            });
            k < this.minMapYY && (this.minMapYY = k, this.topLongLat = {
              longitude: g,
              latitude: f
            });
            k > this.maxMapYY && (this.maxMapYY = k, this.bottomLongLat = {
              longitude: g,
              latitude: f
            });
            b ? c += " L " : (c += " M ", b = !0);
            c += h + " " + k;
          }
          return c + " Z ";
        },
        normalizeMap: function() {
          var a = d.degreesToRadians(this.dataProvider.leftLongitude),
              b = d.degreesToRadians(this.dataProvider.rightLongitude),
              c = d.degreesToRadians(this.dataProvider.topLatitude),
              e = d.degreesToRadians(this.dataProvider.bottomLatitude),
              g = a + (b - a) / 2,
              f = c + (e - c) / 2,
              h = this.dpProjectionFunction(g, c)[1],
              k = this.dpProjectionFunction(g, e)[1],
              l = this.dpProjectionFunction(a, f)[0],
              m = this.dpProjectionFunction(b, f)[0],
              c = d.equirectangular(g, c),
              e = d.equirectangular(g, e),
              h = (c[1] - e[1]) / (h - k),
              a = d.equirectangular(a, f),
              b = d.equirectangular(b, f),
              l = (a[0] - b[0]) / (l - m);
          this.minMapX = Infinity;
          this.maxMapX = -Infinity;
          this.minMapY = Infinity;
          this.maxMapY = -Infinity;
          for (m = 0; m < this.svgAreas.length; m++)
            this.normalize(this.svgAreas[m]);
          this.sourceMapHeight = Math.abs(this.maxMapY - this.minMapY);
          this.sourceMapWidth = Math.abs(this.maxMapX - this.minMapX);
          this.unscaledMapWidth = this.sourceMapWidth * l;
          this.unscaledMapHeight = this.sourceMapHeight * h;
          this.diffY = this.diffX = 0;
        },
        fixMapPosition: function() {
          var a = d.degreesToRadians(this.dataProvider.leftLongitude),
              b = d.degreesToRadians(this.dataProvider.rightLongitude),
              c = d.degreesToRadians(this.dataProvider.topLatitude),
              e = d.degreesToRadians(this.dataProvider.bottomLatitude),
              g = a + (b - a) / 2,
              f = c + (e - c) / 2,
              h = this.dpProjectionFunction(g, c)[1],
              k = this.dpProjectionFunction(g, e)[1],
              l = this.dpProjectionFunction(a, f)[0],
              m = this.dpProjectionFunction(b, f)[0];
          this.sourceMapHeight = this.mapHeight / this.mapScale;
          this.sourceMapWidth = this.mapWidth / this.mapScale;
          this.unscaledMapWidth = (a - b) / (l - m) * this.sourceMapWidth;
          this.unscaledMapHeight = (c - e) / (h - k) * this.sourceMapHeight;
          b = this.coordinatesToXY(d.radiansToDegrees(g), d.radiansToDegrees(c));
          a = this.coordinatesToXY(d.radiansToDegrees(a), d.radiansToDegrees(f));
          c = f = Infinity;
          for (e = 0; e < this.svgAreas.length; e++)
            g = this.svgAreas[e].getBBox(), g.y < f && (f = g.y), g.x < c && (c = g.x);
          this.diffY = b.y / this.mapScale - f;
          this.diffX = a.x / this.mapScale - c;
          for (e = 0; e < this.svgAreas.length; e++)
            this.svgAreas[e].translate(this.diffX, this.diffY);
        },
        changeProjection: function() {
          this.minMapXX = Infinity;
          this.maxMapXX = -Infinity;
          this.minMapYY = Infinity;
          this.maxMapYY = -Infinity;
          this.projectionChanged = !1;
          for (var a = 0; a < this.svgAreas.length; a++)
            this.redraw(this.svgAreas[a]);
          this.projectionChanged = !0;
          this.resizeMap();
        },
        coordinatesToXY: function(a, b) {
          var c,
              e;
          c = !1;
          this.dataProvider && (c = this.dataProvider.wrappedLongitudes) && (a = this.recalcLongitude(a));
          this.projectionFunction ? (e = this.projectionFunction(d.degreesToRadians(a), d.degreesToRadians(b)), c = this.mapScale * d.roundTo(this.x2c(d.radiansToDegrees(e[0])), 3), e = this.mapScale * d.roundTo(this.y2c(d.radiansToDegrees(e[1])), 3)) : (c = this.longitudeToCoordinate(a), e = this.latitudeToCoordinate(b));
          return {
            x: c,
            y: e
          };
        },
        coordinatesToStageXY: function(a, b) {
          var c = this.coordinatesToXY(a, b),
              d = c.x * this.zoomLevel() + this.mapContainer.x,
              c = c.y * this.zoomLevel() + this.mapContainer.y;
          return {
            x: d,
            y: c
          };
        },
        stageXYToCoordinates: function(a, b) {
          var c = this.mapSet.getBBox(),
              d = (a - this.mapContainer.x) / this.zoomLevel() - c.x * this.mapScale,
              c = (b - this.mapContainer.y) / this.zoomLevel() - c.y * this.mapScale;
          return this.xyToCoordinates(d, c);
        },
        xyToCoordinates: function(a, b, c, e, g) {
          var f;
          isNaN(e) && (e = this.mapWidth);
          isNaN(g) && (g = this.mapHeight);
          c || (c = this.projectionFunction);
          if (f = c.invert) {
            var h = this.dataProvider.leftLongitude,
                k = this.dataProvider.rightLongitude,
                l = this.dataProvider.topLatitude,
                m = this.dataProvider.bottomLatitude,
                n = h + (k - h) / 2,
                p = l + (m - l) / 2,
                l = d.radiansToDegrees(c(d.degreesToRadians(n), d.degreesToRadians(l))[1]),
                m = d.radiansToDegrees(c(d.degreesToRadians(n), d.degreesToRadians(m))[1]),
                h = d.radiansToDegrees(c(d.degreesToRadians(h), d.degreesToRadians(p))[0]),
                k = d.radiansToDegrees(c(d.degreesToRadians(k), d.degreesToRadians(p))[0]);
            this.projectionChanged && (l = d.radiansToDegrees(c(d.degreesToRadians(this.topLongLat.longitude), d.degreesToRadians(this.topLongLat.latitude))[1]), m = d.radiansToDegrees(c(d.degreesToRadians(this.bottomLongLat.longitude), d.degreesToRadians(this.bottomLongLat.latitude))[1]), h = d.radiansToDegrees(c(d.degreesToRadians(this.leftLongLat.longitude), d.degreesToRadians(this.leftLongLat.latitude))[0]), k = d.radiansToDegrees(c(d.degreesToRadians(this.rightLongLat.longitude), d.degreesToRadians(this.rightLongLat.latitude))[0]));
            a = d.degreesToRadians(a / e * (k - h) + h);
            b = d.degreesToRadians(b / g * (m - l) + l);
            b = f(a, b);
            f = d.radiansToDegrees(b[0]);
            b = d.radiansToDegrees(b[1]);
          } else
            f = this.coordinateToLongitude(a), b = this.coordinateToLatitude(b);
          return {
            longitude: d.roundTo(f, 4),
            latitude: d.roundTo(b, 4)
          };
        },
        coordinateToLatitude: function(a, b) {
          var c;
          void 0 === b && (b = this.mapHeight);
          if (this.mapSet) {
            var e = this.dataProvider,
                g = e.bottomLatitude;
            c = e.topLatitude;
            "mercator" == e.projection ? (e = this.mercatorLatitudeToCoordinate(g), c = this.mercatorLatitudeToCoordinate(c), c = 2 * d.degreesToRadians(a * (e - c) / b + c), c = d.radiansToDegrees(2 * Math.atan(Math.exp(c)) - .5 * Math.PI)) : c = a / b * (g - c) + c;
          }
          return Math.round(1E6 * c) / 1E6;
        },
        coordinateToLongitude: function(a, b) {
          var c,
              d = this.dataProvider;
          void 0 === b && (b = this.mapWidth);
          this.mapSet && (c = a / b * (d.rightLongitude - d.leftLongitude) + d.leftLongitude);
          return Math.round(1E6 * c) / 1E6;
        }
      });
    })();
    (function() {
      var d = window.AmCharts;
      d.ZoomControl = d.Class({
        construct: function(a) {
          this.cname = "ZoomControl";
          this.panStepSize = .1;
          this.zoomFactor = 2;
          this.maxZoomLevel = 64;
          this.minZoomLevel = 1;
          this.panControlEnabled = !1;
          this.zoomControlEnabled = !0;
          this.buttonRollOverColor = "#DADADA";
          this.buttonFillColor = "#FFFFFF";
          this.buttonFillAlpha = 1;
          this.buttonBorderColor = "#000000";
          this.buttonBorderAlpha = .1;
          this.buttonIconAlpha = this.buttonBorderThickness = 1;
          this.gridColor = this.buttonIconColor = "#000000";
          this.homeIconFile = "homeIcon.gif";
          this.gridBackgroundColor = "#000000";
          this.draggerAlpha = this.gridAlpha = this.gridBackgroundAlpha = 0;
          this.draggerSize = this.buttonSize = 31;
          this.iconSize = 11;
          this.homeButtonEnabled = !0;
          this.buttonCornerRadius = 2;
          this.gridHeight = 5;
          this.roundButtons = !0;
          this.top = this.left = 10;
          d.applyTheme(this, a, this.cname);
        },
        init: function(a, b) {
          var c = this;
          c.chart = a;
          d.remove(c.set);
          var e = b.set();
          d.setCN(a, e, "zoom-control");
          var g = c.buttonSize,
              f = c.zoomControlEnabled,
              h = c.panControlEnabled,
              k = c.buttonFillColor,
              l = c.buttonFillAlpha,
              m = c.buttonBorderThickness,
              n = c.buttonBorderColor,
              p = c.buttonBorderAlpha,
              r = c.buttonCornerRadius,
              t = c.buttonRollOverColor,
              q = c.gridHeight,
              y = c.zoomFactor,
              B = c.minZoomLevel,
              u = c.maxZoomLevel,
              w = c.buttonIconAlpha,
              v = c.buttonIconColor,
              A = c.roundButtons,
              C = a.svgIcons,
              x = a.getX(c.left),
              z = a.getY(c.top);
          isNaN(c.right) || (x = a.getX(c.right, !0), x = h ? x - 3 * g : x - g);
          isNaN(c.bottom) || (z = a.getY(c.bottom, !0), f && (z -= q + 3 * g), z = h ? z - 3 * g : c.homeButtonEnabled ? z - .5 * g : z + g);
          e.translate(x, z);
          c.previousDY = NaN;
          var E,
              x = g / 4 - 1;
          if (f) {
            E = b.set();
            d.setCN(a, E, "zoom-control-zoom");
            e.push(E);
            c.set = e;
            c.zoomSet = E;
            5 < q && (f = d.rect(b, g + 6, q + 2 * g + 6, c.gridBackgroundColor, c.gridBackgroundAlpha, 0, "#000000", 0, 4), d.setCN(a, f, "zoom-bg"), f.translate(-3, -3), f.mouseup(function() {
              c.handleBgUp();
            }).touchend(function() {
              c.handleBgUp();
            }), E.push(f));
            var F = g;
            A && (F = g / 1.5);
            c.draggerSize = F;
            var H = Math.log(u / B) / Math.log(y) + 1;
            1E3 < H && (H = 1E3);
            var f = q / H,
                G,
                D = b.set();
            D.translate((g - F) / 2 + 1, 1, NaN, !0);
            E.push(D);
            for (G = 1; G < H; G++)
              z = g + G * f, z = d.line(b, [1, F - 2], [z, z], c.gridColor, c.gridAlpha, 1), d.setCN(a, z, "zoom-grid"), D.push(z);
            z = new d.SimpleButton;
            z.setDownHandler(c.draggerDown, c);
            z.setClickHandler(c.draggerUp, c);
            z.init(b, F, f, k, l, m, n, p, r, t);
            d.setCN(a, z.set, "zoom-dragger");
            E.push(z.set);
            z.set.setAttr("opacity", c.draggerAlpha);
            c.dragger = z.set;
            c.previousY = NaN;
            z = new d.SimpleButton;
            C ? (F = b.set(), H = d.line(b, [-x, x], [0, 0], v, w, 1), G = d.line(b, [0, 0], [-x, x], v, w, 1), F.push(H), F.push(G), z.svgIcon = F) : z.setIcon(a.pathToImages + "plus.gif", c.iconSize);
            z.setClickHandler(a.zoomIn, a);
            z.init(b, g, g, k, l, m, n, p, r, t, w, v, A);
            d.setCN(a, z.set, "zoom-in");
            E.push(z.set);
            z = new d.SimpleButton;
            C ? z.svgIcon = d.line(b, [-x, x], [0, 0], v, w, 1) : z.setIcon(a.pathToImages + "minus.gif", c.iconSize);
            z.setClickHandler(a.zoomOut, a);
            z.init(b, g, g, k, l, m, n, p, r, t, w, v, A);
            z.set.translate(0, q + g);
            d.setCN(a, z.set, "zoom-out");
            E.push(z.set);
            q -= f;
            u = Math.log(u / 100) / Math.log(y);
            c.realStepSize = q / (u - Math.log(B / 100) / Math.log(y));
            c.realGridHeight = q;
            c.stepMax = u;
          }
          h && (h = b.set(), d.setCN(a, h, "zoom-control-pan"), e.push(h), E && E.translate(g, 4 * g), y = new d.SimpleButton, C ? y.svgIcon = d.line(b, [x / 5, -x + x / 5, x / 5], [-x, 0, x], v, w, 1) : y.setIcon(a.pathToImages + "panLeft.gif", c.iconSize), y.setClickHandler(a.moveLeft, a), y.init(b, g, g, k, l, m, n, p, r, t, w, v, A), y.set.translate(0, g), d.setCN(a, y.set, "pan-left"), h.push(y.set), y = new d.SimpleButton, C ? y.svgIcon = d.line(b, [-x / 5, x - x / 5, -x / 5], [-x, 0, x], v, w, 1) : y.setIcon(a.pathToImages + "panRight.gif", c.iconSize), y.setClickHandler(a.moveRight, a), y.init(b, g, g, k, l, m, n, p, r, t, w, v, A), y.set.translate(2 * g, g), d.setCN(a, y.set, "pan-right"), h.push(y.set), y = new d.SimpleButton, C ? y.svgIcon = d.line(b, [-x, 0, x], [x / 5, -x + x / 5, x / 5], v, w, 1) : y.setIcon(a.pathToImages + "panUp.gif", c.iconSize), y.setClickHandler(a.moveUp, a), y.init(b, g, g, k, l, m, n, p, r, t, w, v, A), y.set.translate(g, 0), d.setCN(a, y.set, "pan-up"), h.push(y.set), y = new d.SimpleButton, C ? y.svgIcon = d.line(b, [-x, 0, x], [-x / 5, x - x / 5, -x / 5], v, w, 1) : y.setIcon(a.pathToImages + "panDown.gif", c.iconSize), y.setClickHandler(a.moveDown, a), y.init(b, g, g, k, l, m, n, p, r, t, w, v, A), y.set.translate(g, 2 * g), d.setCN(a, y.set, "pan-down"), h.push(y.set), e.push(h));
          c.homeButtonEnabled && (h = new d.SimpleButton, C ? h.svgIcon = d.polygon(b, [-x, 0, x, x - 1, x - 1, 2, 2, -2, -2, -x + 1, -x + 1], [0, -x, 0, 0, x - 1, x - 1, 2, 2, x - 1, x - 1, 0], v, w, 1, v, w) : h.setIcon(a.pathToImages + c.homeIconFile, c.iconSize), h.setClickHandler(a.goHome, a), c.panControlEnabled && (p = l = 0), h.init(b, g, g, k, l, m, n, p, r, t, w, v, A), c.panControlEnabled ? h.set.translate(g, g) : E && E.translate(0, 1.5 * g), d.setCN(a, h.set, "pan-home"), e.push(h.set));
          c.update();
        },
        draggerDown: function() {
          this.chart.stopDrag();
          this.isDragging = !0;
        },
        draggerUp: function() {
          this.isDragging = !1;
        },
        handleBgUp: function() {
          var a = this.chart;
          a.zoomTo(100 * Math.pow(this.zoomFactor, this.stepMax - (a.mouseY - this.zoomSet.y - this.set.y - this.buttonSize - this.realStepSize / 2) / this.realStepSize));
        },
        update: function() {
          var a;
          a = this.zoomFactor;
          var b = this.realStepSize,
              c = this.stepMax,
              e = this.dragger,
              g = this.buttonSize,
              f,
              h = this.chart;
          h && (this.isDragging ? (h.stopDrag(), f = e.y + (h.mouseY - this.previousY), f = d.fitToBounds(f, g, this.realGridHeight + g), h.zoomTo(100 * Math.pow(a, c - (f - g) / b), NaN, NaN, !0)) : (a = Math.log(h.zoomLevel() / 100) / Math.log(a), f = (c - a) * b + g), this.previousY = h.mouseY, this.previousDY != f && e && (e.translate((this.buttonSize - this.draggerSize) / 2, f), this.previousDY = f));
        }
      });
    })();
    (function() {
      var d = window.AmCharts;
      d.SimpleButton = d.Class({
        construct: function() {},
        init: function(a, b, c, e, g, f, h, k, l, m, n, p, r) {
          var t = this;
          t.rollOverColor = m;
          t.color = e;
          t.container = a;
          m = a.set();
          t.set = m;
          r ? (b /= 2, e = d.circle(a, b, e, g, f, h, k), e.translate(b, b)) : e = d.rect(a, b, c, e, g, f, h, k, l);
          m.push(e);
          g = t.iconPath;
          var q;
          g && (q = t.iconSize, f = (b - q) / 2, r && (f = (2 * b - q) / 2), q = a.image(g, f, (c - q) / 2, q, q));
          t.svgIcon && (q = t.svgIcon, r ? q.translate(b, b) : q.translate(b / 2, b / 2));
          m.setAttr("cursor", "pointer");
          q && (m.push(q), q.setAttr("opacity", n), q.node.style.pointerEvents = "none");
          e.mousedown(function() {
            t.handleDown();
          }).touchstart(function() {
            t.handleDown();
          }).mouseup(function() {
            t.handleUp();
          }).touchend(function() {
            t.handleUp();
          }).mouseover(function() {
            t.handleOver();
          }).mouseout(function() {
            t.handleOut();
          });
          t.bg = e;
        },
        setIcon: function(a, b) {
          this.iconPath = a;
          this.iconSize = b;
        },
        setClickHandler: function(a, b) {
          this.clickHandler = a;
          this.scope = b;
        },
        setDownHandler: function(a, b) {
          this.downHandler = a;
          this.scope = b;
        },
        handleUp: function() {
          var a = this.clickHandler;
          a && a.call(this.scope);
        },
        handleDown: function() {
          var a = this.downHandler;
          a && a.call(this.scope);
        },
        handleOver: function() {
          this.container.chart.skipClick = !0;
          this.bg.setAttr("fill", this.rollOverColor);
        },
        handleOut: function() {
          this.container.chart.skipClick = !1;
          this.bg.setAttr("fill", this.color);
        }
      });
    })();
    (function() {
      var d = window.AmCharts;
      d.SmallMap = d.Class({
        construct: function(a) {
          this.cname = "SmallMap";
          this.mapColor = "#e6e6e6";
          this.rectangleColor = "#FFFFFF";
          this.top = this.right = 10;
          this.minimizeButtonWidth = 23;
          this.backgroundColor = "#9A9A9A";
          this.backgroundAlpha = 1;
          this.borderColor = "#FFFFFF";
          this.iconColor = "#000000";
          this.borderThickness = 3;
          this.borderAlpha = 1;
          this.size = .2;
          this.enabled = !0;
          d.applyTheme(this, a, this.cname);
        },
        init: function(a, b) {
          var c = this;
          if (c.enabled) {
            c.chart = a;
            c.container = b;
            c.width = a.realWidth * c.size;
            c.height = a.realHeight * c.size;
            d.remove(c.mapSet);
            d.remove(c.allSet);
            d.remove(c.set);
            var e = b.set();
            c.set = e;
            d.setCN(a, e, "small-map");
            var g = b.set();
            c.allSet = g;
            e.push(g);
            c.buildSVGMap();
            var f = c.borderThickness,
                h = c.borderColor,
                k = d.rect(b, c.width + f, c.height + f, c.backgroundColor, c.backgroundAlpha, f, h, c.borderAlpha);
            d.setCN(a, k, "small-map-bg");
            k.translate(-f / 2, -f / 2);
            g.push(k);
            k.toBack();
            var l,
                m,
                k = c.minimizeButtonWidth,
                n = new d.SimpleButton,
                p = k / 2;
            a.svgIcons ? n.svgIcon = d.line(b, [-p / 2, 0, p / 2], [-p / 4, p / 4, -p / 4], c.iconColor, 1, 1) : n.setIcon(a.pathToImages + "arrowDown.gif", k);
            n.setClickHandler(c.minimize, c);
            n.init(b, k, k, h, 1, 1, h, 1);
            d.setCN(a, n.set, "small-map-down");
            n = n.set;
            c.downButtonSet = n;
            e.push(n);
            var r = new d.SimpleButton;
            a.svgIcons ? r.svgIcon = d.line(b, [-p / 2, 0, p / 2], [p / 4, -p / 4, p / 4], c.iconColor, 1, 1) : r.setIcon(a.pathToImages + "arrowUp.gif", k);
            r.setClickHandler(c.maximize, c);
            r.init(b, k, k, h, 1, 1, h, 1);
            d.setCN(a, r.set, "small-map-up");
            h = r.set;
            c.upButtonSet = h;
            h.hide();
            e.push(h);
            var t,
                q;
            isNaN(c.top) || (l = a.getY(c.top) + f, q = 0);
            isNaN(c.bottom) || (l = a.getY(c.bottom, !0) - c.height - f, q = c.height - k + f / 2);
            isNaN(c.left) || (m = a.getX(c.left) + f, t = -f / 2);
            isNaN(c.right) || (m = a.getX(c.right, !0) - c.width - f, t = c.width - k + f / 2);
            f = b.set();
            f.clipRect(1, 1, c.width, c.height);
            g.push(f);
            c.rectangleC = f;
            e.translate(m, l);
            n.translate(t, q);
            h.translate(t, q);
            g.mouseup(function() {
              c.handleMouseUp();
            });
            c.drawRectangle();
          } else
            d.remove(c.allSet), d.remove(c.downButtonSet), d.remove(c.upButtonSet);
        },
        minimize: function() {
          this.downButtonSet.hide();
          this.upButtonSet.show();
          this.allSet.hide();
        },
        maximize: function() {
          this.downButtonSet.show();
          this.upButtonSet.hide();
          this.allSet.show();
        },
        buildSVGMap: function() {
          var a = this.chart,
              b = {
                fill: this.mapColor,
                stroke: this.mapColor,
                "stroke-opacity": 1
              },
              c = this.container,
              e = c.set();
          d.setCN(a, e, "small-map-image");
          var g;
          for (g = 0; g < a.svgAreas.length; g++) {
            var f = c.path(a.svgAreas[g].path).attr(b);
            e.push(f);
          }
          this.allSet.push(e);
          b = e.getBBox();
          c = this.size * a.mapScale;
          g = -b.x * c;
          var f = -b.y * c,
              h = 0,
              k = 0;
          a.centerMap && (h = (this.width - b.width * c) / 2, k = (this.height - b.height * c) / 2);
          this.mapWidth = b.width * c;
          this.mapHeight = b.height * c;
          g += h;
          f += k;
          this.dx = h;
          this.dy = k;
          e.translate(g, f, c);
          this.mapSet = e;
          this.mapX = g;
          this.mapY = f;
        },
        update: function() {
          var a = this.chart;
          if (a) {
            var b = a.zoomLevel(),
                c = this.width,
                d = this.height,
                g = c / (a.realWidth * b),
                f = a.mapContainer.getBBox(),
                c = c / b,
                d = d / b,
                h = this.rectangle;
            h.translate(-(a.mapContainer.x + f.x * b) * g + this.dx, -(a.mapContainer.y + f.y * b) * g + this.dy);
            0 < c && 0 < d && (h.setAttr("width", Math.ceil(c + 1)), h.setAttr("height", Math.ceil(d + 1)));
            this.rWidth = c;
            this.rHeight = d;
          }
        },
        drawRectangle: function() {
          var a = this.rectangle;
          d.remove(a);
          a = d.rect(this.container, 10, 10, "#000", 0, 1, this.rectangleColor, 1);
          d.setCN(this.chart, a, "small-map-rectangle");
          this.rectangleC.push(a);
          this.rectangle = a;
        },
        handleMouseUp: function() {
          var a = this.chart,
              b = a.zoomLevel();
          a.zoomToMapXY(b, (a.mouseX - this.set.x - this.mapX) / this.size + a.diffX * a.mapScale, (a.mouseY - this.set.y - this.mapY) / this.size + a.diffY * a.mapScale);
        }
      });
    })();
    (function() {
      var d = window.AmCharts;
      d.AreasProcessor = d.Class({
        construct: function(a) {
          this.chart = a;
        },
        process: function(a) {
          this.updateAllAreas();
          this.allObjects = [];
          a = a.areas;
          var b = this.chart;
          b.outlines = [];
          var c = a.length,
              d,
              g,
              f = 0,
              h = !1,
              k = !1,
              l = 0;
          for (d = 0; d < c; d++)
            if (g = a[d], g.value = Number(g.value), g = g.value, !isNaN(g)) {
              if (!1 === h || h < g)
                h = g;
              if (!1 === k || k > g)
                k = g;
              f += Math.abs(g);
              l++;
            }
          this.minValue = k;
          this.maxValue = h;
          isNaN(b.minValue) || (this.minValue = b.minValue);
          isNaN(b.maxValue) || (this.maxValue = b.maxValue);
          b.maxValueReal = h;
          b.minValueReal = k;
          for (d = 0; d < c; d++)
            g = a[d], isNaN(g.value) ? g.percents = void 0 : (g.percents = (g.value - k) / f * 100, k == h && (g.percents = 100));
          for (d = 0; d < c; d++)
            g = a[d], this.createArea(g);
          b.outlinesToFront();
        },
        updateAllAreas: function() {
          var a = this.chart,
              b = a.areasSettings,
              c = b.unlistedAreasColor,
              e = b.unlistedAreasAlpha,
              g = b.unlistedAreasOutlineColor,
              f = b.unlistedAreasOutlineAlpha,
              h = a.svgAreas,
              k = a.dataProvider,
              l = k.areas,
              m = {},
              n;
          for (n = 0; n < l.length; n++)
            m[l[n].id] = l[n];
          for (n = 0; n < h.length; n++) {
            l = h[n];
            if (b.preserveOriginalAttributes) {
              if (l.customAttr)
                for (var p in l.customAttr)
                  l.setAttr(p, l.customAttr[p]);
            } else {
              void 0 != c && l.setAttr("fill", c);
              isNaN(e) || l.setAttr("fill-opacity", e);
              void 0 != g && l.setAttr("stroke", g);
              isNaN(f) || l.setAttr("stroke-opacity", f);
              var r = b.outlineThickness;
              b.adjustOutlineThickness && (r = r / a.zoomLevel() / a.mapScale);
              l.setAttr("stroke-width", r);
            }
            d.setCN(a, l, "map-area-unlisted");
            k.getAreasFromMap && !m[l.id] && (r = new d.MapArea(a.theme), r.parentObject = k, r.id = l.id, r.outline = l.outline, k.areas.push(r));
          }
        },
        createArea: function(a) {
          var b = this.chart,
              c = b.svgAreasById[a.id],
              e = b.areasSettings;
          if (c && c.className) {
            var g = b.areasClasses[c.className];
            g && (e = d.processObject(g, d.AreasSettings, b.theme));
          }
          var f = e.color,
              h = e.alpha,
              k = e.outlineThickness,
              l = e.rollOverColor,
              m = e.selectedColor,
              n = e.rollOverAlpha,
              p = e.rollOverBrightness,
              r = e.outlineColor,
              t = e.outlineAlpha,
              q = e.balloonText,
              y = e.selectable,
              B = e.pattern,
              u = e.rollOverOutlineColor,
              w = e.bringForwardOnHover,
              v = e.preserveOriginalAttributes;
          this.allObjects.push(a);
          a.chart = b;
          a.baseSettings = e;
          a.autoZoomReal = void 0 == a.autoZoom ? e.autoZoom : a.autoZoom;
          g = a.color;
          void 0 == g && (g = f);
          var A = a.alpha;
          isNaN(A) && (A = h);
          h = a.rollOverAlpha;
          isNaN(h) && (h = n);
          isNaN(h) && (h = A);
          n = a.rollOverColor;
          void 0 == n && (n = l);
          l = a.pattern;
          void 0 == l && (l = B);
          B = a.selectedColor;
          void 0 == B && (B = m);
          m = a.balloonText;
          void 0 === m && (m = q);
          void 0 == e.colorSolid || isNaN(a.value) || (q = Math.floor((a.value - this.minValue) / ((this.maxValue - this.minValue) / b.colorSteps)), q == b.colorSteps && q--, q *= 1 / (b.colorSteps - 1), this.maxValue == this.minValue && (q = 1), a.colorReal = d.getColorFade(g, e.colorSolid, q));
          void 0 != a.color && (a.colorReal = a.color);
          void 0 == a.selectable && (a.selectable = y);
          void 0 == a.colorReal && (a.colorReal = f);
          f = a.outlineColor;
          void 0 == f && (f = r);
          r = a.outlineAlpha;
          isNaN(r) && (r = t);
          t = a.outlineThickness;
          isNaN(t) && (t = k);
          k = a.rollOverOutlineColor;
          void 0 == k && (k = u);
          u = a.rollOverBrightness;
          void 0 == u && (u = p);
          void 0 == a.bringForwardOnHover && (a.bringForwardOnHover = w);
          void 0 == a.preserveOriginalAttributes && (a.preserveOriginalAttributes = v);
          isNaN(e.selectedBrightness) || (B = d.adjustLuminosity(a.colorReal, e.selectedBrightness / 100));
          a.alphaReal = A;
          a.rollOverColorReal = n;
          a.rollOverAlphaReal = h;
          a.balloonTextReal = m;
          a.selectedColorReal = B;
          a.outlineColorReal = f;
          a.outlineAlphaReal = r;
          a.rollOverOutlineColorReal = k;
          a.outlineThicknessReal = t;
          a.patternReal = l;
          a.rollOverBrightnessReal = u;
          a.accessibleLabel || (a.accessibleLabel = e.accessibleLabel);
          d.processDescriptionWindow(e, a);
          if (c && (p = c.area, w = c.title, a.enTitle = c.title, w && !a.title && (a.title = w), (c = b.language) ? (w = d.mapTranslations) && (c = w[c]) && c[a.enTitle] && (a.titleTr = c[a.enTitle]) : a.titleTr = void 0, p)) {
            c = a.tabIndex;
            void 0 === c && (c = e.tabIndex);
            void 0 !== c && p.setAttr("tabindex", c);
            a.displayObject = p;
            a.outline && (A = 0, a.alphaReal = 0, a.rollOverAlphaReal = 0, a.mouseEnabled = !1, b.outlines.push(p), p.node.setAttribute("pointer-events", "none"));
            a.mouseEnabled && b.addObjectEventListeners(p, a);
            var C;
            void 0 != g && (C = g);
            void 0 != a.colorReal && (C = a.showAsSelected || b.selectedObject == a ? a.selectedColorReal : a.colorReal);
            p.node.setAttribute("class", "");
            d.setCN(b, p, "map-area");
            d.setCN(b, p, "map-area-" + p.id);
            e.adjustOutlineThickness && (t = t / b.zoomLevel() / b.mapScale);
            a.preserveOriginalAttributes || (p.setAttr("fill", C), p.setAttr("stroke", f), p.setAttr("stroke-opacity", r), p.setAttr("stroke-width", t), p.setAttr("fill-opacity", A));
            b.makeObjectAccessible(a);
            l && p.pattern(l, b.mapScale, b.path);
            a.hidden && p.hide();
          }
        }
      });
    })();
    (function() {
      var d = window.AmCharts;
      d.AreasSettings = d.Class({construct: function(a) {
          this.cname = "AreasSettings";
          this.alpha = 1;
          this.autoZoom = !1;
          this.balloonText = "[[title]]";
          this.color = "#FFCC00";
          this.colorSolid = "#990000";
          this.unlistedAreasAlpha = 1;
          this.unlistedAreasColor = "#cc0000";
          this.outlineColor = "#FFFFFF";
          this.outlineThickness = this.outlineAlpha = 1;
          this.selectedColor = this.rollOverOutlineColor = "#CC0000";
          this.unlistedAreasOutlineColor = "#FFFFFF";
          this.unlistedAreasOutlineAlpha = 1;
          this.descriptionWindowWidth = 250;
          this.bringForwardOnHover = this.adjustOutlineThickness = !0;
          this.accessibleLabel = "[[title]] [[value]] [[description]]";
          d.applyTheme(this, a, this.cname);
        }});
    })();
    (function() {
      var d = window.AmCharts;
      d.ImagesProcessor = d.Class({
        construct: function(a) {
          this.chart = a;
          this.reset();
        },
        process: function(a) {
          var b = a.images,
              c;
          for (c = b.length - 1; 0 <= c; c--) {
            var d = b[c];
            this.createImage(d, c);
            d.parentArray = b;
          }
          this.counter = c;
          a.parentObject && a.remainVisible && this.process(a.parentObject);
        },
        createImage: function(a, b) {
          a = d.processObject(a, d.MapImage);
          a.arrays = [];
          isNaN(b) && (this.counter++, b = this.counter);
          var c = this.chart,
              e = c.container,
              g = c.mapImagesContainer,
              f = c.stageImagesContainer,
              h = c.imagesSettings;
          a.remove && a.remove();
          var k = h.color,
              l = h.alpha,
              m = h.rollOverColor,
              n = h.rollOverOutlineColor,
              p = h.selectedColor,
              r = h.balloonText,
              t = h.outlineColor,
              q = h.outlineAlpha,
              y = h.outlineThickness,
              B = h.selectedScale,
              u = h.rollOverScale,
              w = h.selectable,
              v = h.labelPosition,
              A = h.labelColor,
              C = h.labelFontSize,
              x = h.bringForwardOnHover,
              z = h.labelRollOverColor,
              E = h.rollOverBrightness,
              F = h.selectedLabelColor;
          a.index = b;
          a.chart = c;
          a.baseSettings = c.imagesSettings;
          var H = e.set();
          a.displayObject = H;
          var G = a.color;
          void 0 == G && (G = k);
          k = a.alpha;
          isNaN(k) && (k = l);
          void 0 == a.bringForwardOnHover && (a.bringForwardOnHover = x);
          l = a.outlineAlpha;
          isNaN(l) && (l = q);
          q = a.rollOverColor;
          void 0 == q && (q = m);
          m = a.selectedColor;
          void 0 == m && (m = p);
          p = a.balloonText;
          void 0 === p && (p = r);
          r = a.outlineColor;
          void 0 == r && (r = t);
          a.outlineColorReal = r;
          t = a.outlineThickness;
          isNaN(t) && (t = y);
          (y = a.labelPosition) || (y = v);
          v = a.labelColor;
          void 0 == v && (v = A);
          A = a.labelRollOverColor;
          void 0 == A && (A = z);
          z = a.selectedLabelColor;
          void 0 == z && (z = F);
          F = a.labelFontSize;
          isNaN(F) && (F = C);
          C = a.selectedScale;
          isNaN(C) && (C = B);
          B = a.rollOverScale;
          isNaN(B) && (B = u);
          u = a.rollOverBrightness;
          void 0 == u && (u = E);
          void 0 == a.selectable && (a.selectable = w);
          a.colorReal = G;
          isNaN(h.selectedBrightness) || (m = d.adjustLuminosity(a.colorReal, h.selectedBrightness / 100));
          a.alphaReal = k;
          a.rollOverColorReal = q;
          a.balloonTextReal = p;
          a.selectedColorReal = m;
          a.labelColorReal = v;
          a.labelRollOverColorReal = A;
          a.selectedLabelColorReal = z;
          a.labelFontSizeReal = F;
          a.labelPositionReal = y;
          a.selectedScaleReal = C;
          a.rollOverScaleReal = B;
          a.rollOverOutlineColorReal = n;
          a.rollOverBrightnessReal = u;
          a.accessibleLabel || (a.accessibleLabel = h.accessibleLabel);
          d.processDescriptionWindow(h, a);
          a.centeredReal = void 0 == a.centered ? h.centered : a.centered;
          n = a.type;
          u = a.imageURL;
          B = a.svgPath;
          C = a.width;
          F = a.height;
          w = a.scale;
          isNaN(a.percentWidth) || (C = a.percentWidth / 100 * c.realWidth);
          isNaN(a.percentHeight) || (F = a.percentHeight / 100 * c.realHeight);
          var D;
          u || n || B || (n = "circle", C = 1, l = k = 0);
          q = E = 0;
          h = a.selectedColorReal;
          if (n) {
            isNaN(C) && (C = 10);
            isNaN(F) && (F = 10);
            "kilometers" == a.widthAndHeightUnits && (C = c.kilometersToPixels(a.width), F = c.kilometersToPixels(a.height));
            "miles" == a.widthAndHeightUnits && (C = c.milesToPixels(a.width), F = c.milesToPixels(a.height));
            if ("circle" == n || "bubble" == n)
              F = C;
            D = this.createPredefinedImage(G, r, t, n, C, F);
            q = E = 0;
            a.centeredReal ? (isNaN(a.right) || (E = C * w), isNaN(a.bottom) || (q = F * w)) : (E = C * w / 2, q = F * w / 2);
            D.translate(E, q, w, !0);
          } else
            u ? (isNaN(C) && (C = 10), isNaN(F) && (F = 10), D = e.image(u, 0, 0, C, F), D.node.setAttribute("preserveAspectRatio", "none"), D.setAttr("opacity", k), a.centeredReal && (E = isNaN(a.right) ? -C / 2 : C / 2, q = isNaN(a.bottom) ? -F / 2 : F / 2, D.translate(E, q, NaN, !0))) : B && (D = e.path(B), u = D.getBBox(), a.centeredReal ? (E = -u.x * w - u.width * w / 2, isNaN(a.right) || (E = -E), q = -u.y * w - u.height * w / 2, isNaN(a.bottom) || (q = -q)) : E = q = 0, D.translate(E, q, w, !0), D.x = E, D.y = q);
          D && (H.push(D), a.image = D, D.setAttr("stroke-opacity", l), D.setAttr("stroke-width", t), D.setAttr("stroke", r), D.setAttr("fill-opacity", k), "bubble" != n && D.setAttr("fill", G), d.setCN(c, D, "map-image"), void 0 != a.id && d.setCN(c, D, "map-image-" + a.id));
          G = a.labelColorReal;
          !a.showAsSelected && c.selectedObject != a || void 0 == h || (D && D.setAttr("fill", h), G = a.selectedLabelColorReal);
          D = null;
          void 0 !== a.label && (D = d.text(e, a.label, G, c.fontFamily, a.labelFontSizeReal, a.labelAlign), d.setCN(c, D, "map-image-label"), void 0 !== a.id && d.setCN(c, D, "map-image-label-" + a.id), G = a.labelBackgroundAlpha, (k = a.labelBackgroundColor) && 0 < G && (l = D.getBBox(), e = d.rect(e, l.width + 16, l.height + 10, k, G), d.setCN(c, e, "map-image-label-background"), void 0 != a.id && d.setCN(c, e, "map-image-label-background-" + a.id), H.push(e), a.labelBG = e), a.imageLabel = D, H.push(D), d.setCN(c, H, "map-image-container"), void 0 != a.id && d.setCN(c, H, "map-image-container-" + a.id), this.labelsToReposition.push(a), a.arrays.push({
            arr: this.labelsToReposition,
            el: a
          }));
          e = isNaN(a.latitude) || isNaN(a.longitude) ? !0 : !1;
          a.lineId && (D = this.chart.getObjectById(a.lineId)) && 0 < D.longitudes.length && (e = !1);
          e ? f.push(H) : g.push(H);
          H.toBack();
          H && (H.rotation = a.rotation, isNaN(a.rotation) || H.rotate(a.rotation), a.arrays.push({
            arr: this.allSvgObjects,
            el: H
          }), this.allSvgObjects.push(H));
          this.allObjects.push(a);
          c.makeObjectAccessible(a);
          g = a.tabIndex;
          void 0 === g && (g = c.imagesSettings.tabIndex);
          void 0 !== g && H.setAttr("tabindex", g);
          a.arrays.push({
            arr: this.allObjects,
            el: a
          });
          isNaN(a.longitude) || isNaN(a.latitude) || !a.fixedSize || (a.objToResize = {
            image: H,
            mapImage: a,
            scale: 1
          }, this.objectsToResize.push(a.objToResize), a.arrays.push({
            arr: this.objectsToResize,
            el: a.objToResize
          }));
          this.updateSizeAndPosition(a);
          a.mouseEnabled && c.addObjectEventListeners(H, a);
          a.hidden && H.hide();
          d.removeFromArray(c.updatableImages, a);
          a.animateAlongLine && (c.updatableImages.push(a), a.delayAnimateAlong());
          return a;
        },
        updateSizeAndPosition: function(a) {
          var b = this.chart,
              c = a.displayObject,
              e = b.getX(a.left),
              g = b.getY(a.top),
              f,
              h = a.image.getBBox();
          isNaN(a.right) || (e = b.getX(a.right, !0) - h.width * a.scale);
          isNaN(a.bottom) || (g = b.getY(a.bottom, !0) - h.height * a.scale);
          var k = a.longitude,
              l = a.latitude,
              m = a.positionOnLine,
              h = a.imageLabel,
              n = this.chart.zoomLevel(),
              p,
              r;
          a.lineId && (a.line = this.chart.getObjectById(a.lineId));
          if (a.line && a.line.getCoordinates) {
            a.line.chart = b;
            var t = a.line.getCoordinates(m, a.lineSegment);
            t && (k = b.coordinateToLongitude(t.x), l = b.coordinateToLatitude(t.y), p = t.x, r = t.y, a.animateAngle && (f = d.radiansToDegrees(t.angle)));
          }
          isNaN(f) || c.rotate(f + a.extraAngle);
          if (!isNaN(e) && !isNaN(g))
            c.translate(e, g, NaN, !0);
          else if (!isNaN(l) && !isNaN(k))
            if (g = b.coordinatesToXY(k, l), e = g.x, g = g.y, isNaN(p) || (e = p), isNaN(r) || (g = r), a.fixedSize) {
              p = a.positionScale;
              isNaN(p) ? p = 0 : (--p, p *= 1 - 2 * Math.abs(m - .5));
              if (m = a.objectToResize)
                m.scale = 1 + p;
              c.translate(e, g, 1 / n + p, !0);
            } else
              c.translate(e, g, NaN, !0);
          this.positionLabel(h, a, a.labelPositionReal);
        },
        positionLabel: function(a, b, c) {
          if (a) {
            var d = b.image,
                g = 0,
                f = 0,
                h = 0,
                k = 0;
            d && (k = d.getBBox(), f = d.y + k.y, g = d.x + k.x, h = k.width, k = k.height, b.svgPath && (h *= b.scale, k *= b.scale));
            var d = a.getBBox(),
                l = d.width,
                m = d.height;
            "right" == c && (g += h + l / 2 + 5, f += k / 2 - 2);
            "left" == c && (g += -l / 2 - 5, f += k / 2 - 2);
            "top" == c && (f -= m / 2 + 3, g += h / 2);
            "bottom" == c && (f += k + m / 2, g += h / 2);
            "middle" == c && (g += h / 2, f += k / 2);
            a.translate(g + b.labelShiftX, f + b.labelShiftY, NaN, !0);
            a = b.labelFontSizeReal;
            b.labelBG && b.labelBG.translate(g - d.width / 2 + b.labelShiftX - 9, f - a / 2 + b.labelShiftY - 4, NaN, !0);
          }
        },
        createPredefinedImage: function(a, b, c, e, g, f) {
          var h = this.chart.container,
              k;
          switch (e) {
            case "circle":
              k = d.circle(h, g / 2, a, 1, c, b, 1);
              break;
            case "rectangle":
              k = d.polygon(h, [-g / 2, g / 2, g / 2, -g / 2], [f / 2, f / 2, -f / 2, -f / 2], a, 1, c, b, 1, 0, !0);
              break;
            case "bubble":
              k = d.circle(h, g / 2, a, 1, c, b, 1, !0);
              break;
            case "hexagon":
              g /= Math.sqrt(3), k = d.polygon(h, [.866 * g, 0 * g, -.866 * g, -.866 * g, 0 * g, .866 * g], [.5 * g, 1 * g, .5 * g, -.5 * g, -1 * g, -.5 * g], a, 1, c, b, 1);
          }
          return k;
        },
        reset: function() {
          this.objectsToResize = [];
          this.allSvgObjects = [];
          this.allObjects = [];
          this.allLabels = [];
          this.labelsToReposition = [];
        }
      });
    })();
    (function() {
      var d = window.AmCharts;
      d.ImagesSettings = d.Class({construct: function(a) {
          this.cname = "ImagesSettings";
          this.balloonText = "[[title]]";
          this.alpha = 1;
          this.borderAlpha = 0;
          this.borderThickness = 1;
          this.labelPosition = "right";
          this.labelColor = "#000000";
          this.labelFontSize = 11;
          this.color = "#000000";
          this.labelRollOverColor = "#00CC00";
          this.centered = !0;
          this.rollOverScale = this.selectedScale = 1;
          this.descriptionWindowWidth = 250;
          this.bringForwardOnHover = !0;
          this.outlineColor = "transparent";
          this.adjustAnimationSpeed = !1;
          this.baseAnimationDistance = 500;
          this.pauseDuration = 0;
          this.easingFunction = d.easeInOutQuad;
          this.animationDuration = 3;
          this.positionScale = 1;
          this.accessibleLabel = "[[title]] [[description]]";
          d.applyTheme(this, a, this.cname);
        }});
    })();
    (function() {
      var d = window.AmCharts;
      d.LinesProcessor = d.Class({
        construct: function(a) {
          this.chart = a;
          this.reset();
        },
        process: function(a) {
          var b = a.lines,
              c;
          for (c = 0; c < b.length; c++) {
            var d = b[c];
            this.createLine(d, c);
            d.parentArray = b;
          }
          this.counter = c;
          a.parentObject && a.remainVisible && this.process(a.parentObject);
        },
        createLine: function(a, b) {
          a = d.processObject(a, d.MapLine);
          isNaN(b) && (this.counter++, b = this.counter);
          a.index = b;
          a.remove && a.remove();
          var c = this.chart,
              e = c.linesSettings,
              g = this.objectsToResize,
              f = c.mapLinesContainer,
              h = c.stageLinesContainer,
              k = e.thickness,
              l = e.dashLength,
              m = e.arrow,
              n = e.arrowSize,
              p = e.arrowColor,
              r = e.arrowAlpha,
              t = e.color,
              q = e.alpha,
              y = e.rollOverColor,
              B = e.selectedColor,
              u = e.rollOverAlpha,
              w = e.balloonText,
              v = e.bringForwardOnHover,
              A = e.arc,
              C = e.rollOverBrightness,
              x = c.container;
          a.chart = c;
          a.baseSettings = e;
          var z = x.set();
          a.displayObject = z;
          var E = a.tabIndex;
          void 0 === E && (E = e.tabIndex);
          void 0 !== E && z.setAttr("tabindex", E);
          this.allSvgObjects.push(z);
          a.arrays.push({
            arr: this.allSvgObjects,
            el: z
          });
          this.allObjects.push(a);
          a.arrays.push({
            arr: this.allObjects,
            el: a
          });
          a.mouseEnabled && c.addObjectEventListeners(z, a);
          if (a.remainVisible || c.selectedObject == a.parentObject) {
            E = a.thickness;
            isNaN(E) && (E = k);
            k = a.dashLength;
            isNaN(k) && (k = l);
            l = a.color;
            void 0 == l && (l = t);
            t = a.alpha;
            isNaN(t) && (t = q);
            q = a.rollOverAlpha;
            isNaN(q) && (q = u);
            isNaN(q) && (q = t);
            u = a.rollOverColor;
            void 0 == u && (u = y);
            y = a.selectedColor;
            void 0 == y && (y = B);
            B = a.balloonText;
            void 0 === B && (B = w);
            w = a.arc;
            isNaN(w) && (w = A);
            A = a.arrow;
            if (!A || "none" == A && "none" != m)
              A = m;
            m = a.arrowColor;
            void 0 == m && (m = p);
            void 0 == m && (m = l);
            p = a.arrowAlpha;
            isNaN(p) && (p = r);
            isNaN(p) && (p = t);
            r = a.arrowSize;
            isNaN(r) && (r = n);
            n = a.rollOverBrightness;
            void 0 == n && (n = C);
            a.colorReal = l;
            a.arrowColor = m;
            isNaN(e.selectedBrightness) || (y = d.adjustLuminosity(a.colorReal, e.selectedBrightness / 100));
            a.alphaReal = t;
            a.rollOverColorReal = u;
            a.rollOverAlphaReal = q;
            a.balloonTextReal = B;
            a.selectedColorReal = y;
            a.thicknessReal = E;
            a.rollOverBrightnessReal = n;
            a.accessibleLabel || (a.accessibleLabel = e.accessibleLabel);
            void 0 === a.shiftArrow && (a.shiftArrow = e.shiftArrow);
            void 0 == a.bringForwardOnHover && (a.bringForwardOnHover = v);
            d.processDescriptionWindow(e, a);
            v = this.processCoordinates(a.x, c.realWidth);
            C = this.processCoordinates(a.y, c.realHeight);
            n = a.longitudes;
            e = a.latitudes;
            q = n.length;
            if (0 < q)
              for (v = [], C = [], u = 0; u < q; u++)
                B = c.coordinatesToXY(n[u], e[u]), v.push(B.x), C.push(B.y);
            if (0 < v.length) {
              a.segments = v.length;
              d.dx = 0;
              d.dy = 0;
              var F,
                  H,
                  G,
                  q = 10 * (1 - Math.abs(w));
              10 <= q && (q = NaN);
              1 > q && (q = 1);
              a.arcRadius = [];
              a.distances = [];
              n = c.mapContainer.scale;
              if (isNaN(q)) {
                for (q = 0; q < v.length - 1; q++)
                  H = Math.sqrt(Math.pow(v[q + 1] - v[q], 2) + Math.pow(C[q + 1] - C[q], 2)), a.distances[q] = H;
                q = d.line(x, v, C, l, 1, E / n, k, !1, !1, !0);
                l = d.line(x, v, C, l, .001, 5 / n, k, !1, !1, !0);
                q.setAttr("stroke-linecap", "round");
              } else {
                u = 1;
                0 > w && (u = 0);
                B = {
                  fill: "none",
                  stroke: l,
                  "stroke-opacity": 1,
                  "stroke-width": E / n,
                  "fill-opacity": 0,
                  "stroke-linecap": "round"
                };
                void 0 !== k && 0 < k && (B["stroke-dasharray"] = k);
                for (var k = "",
                    D = 0; D < v.length - 1; D++) {
                  var L = v[D],
                      J = v[D + 1],
                      M = C[D],
                      O = C[D + 1];
                  H = Math.sqrt(Math.pow(J - L, 2) + Math.pow(O - M, 2));
                  G = H / 2 * q;
                  F = 270 + 180 * Math.acos(H / 2 / G) / Math.PI;
                  isNaN(F) && (F = 270);
                  L < J && (u = 1);
                  0 < w && (F = -F);
                  k += "M" + L + "," + M + "A" + G + "," + G + ",0,0," + u + "," + J + "," + O;
                  a.arcRadius[D] = G;
                  a.distances[D] = H;
                }
                q = x.path(k).attr(B);
                l = x.path(k).attr({
                  "fill-opacity": 0,
                  stroke: l,
                  "stroke-width": 5 / n,
                  "stroke-opacity": .001,
                  fill: "none"
                });
              }
              d.setCN(c, q, "map-line");
              void 0 != a.id && d.setCN(c, q, "map-line-" + a.id);
              d.dx = .5;
              d.dy = .5;
              z.push(q);
              z.push(l);
              q.setAttr("opacity", t);
              if ("none" != A) {
                var I,
                    K,
                    N;
                if ("end" == A || "both" == A)
                  u = v[v.length - 1], D = C[C.length - 1], 1 < v.length ? (B = v[v.length - 2], I = C[C.length - 2]) : (B = u, I = D), I = 180 * Math.atan((D - I) / (u - B)) / Math.PI, isNaN(F) || (I += F), K = u, N = D, I = 0 > u - B ? I - 90 : I + 90;
                t = [-r / 2 - .5, -.5, r / 2 - .5];
                k = [r, -.5, r];
                a.shiftArrow && "middle" != A && (k = [0, 1.2 * -r, 0]);
                "both" == A && (r = d.polygon(x, t, k, m, p, 1, m, p, void 0, !0), z.push(r), r.translate(K, N, 1 / n, !0), isNaN(I) || r.rotate(I), d.setCN(c, q, "map-line-arrow"), void 0 != a.id && d.setCN(c, q, "map-line-arrow-" + a.id), a.fixedSize && g.push(r));
                if ("start" == A || "both" == A)
                  r = v[0], N = C[0], 1 < v.length ? (u = v[1], K = C[1]) : (u = r, K = N), I = 180 * Math.atan((N - K) / (r - u)) / Math.PI, isNaN(F) || (I -= F), K = r, I = 0 > r - u ? I - 90 : I + 90;
                "middle" == A && (u = v[v.length - 1], D = C[C.length - 1], 1 < v.length ? (B = v[v.length - 2], I = C[C.length - 2]) : (B = u, I = D), K = B + (u - B) / 2, N = I + (D - I) / 2, I = 180 * Math.atan((D - I) / (u - B)) / Math.PI, isNaN(F) || (F = H / 2, G -= Math.sqrt(G * G - F * F), 0 > w && (G = -G), F = Math.sin(I / 180 * Math.PI), -1 == F && (F = 1), K -= F * G, N += Math.cos(I / 180 * Math.PI) * G), I = 0 > u - B ? I - 90 : I + 90);
                r = d.polygon(x, t, k, m, p, 1, m, p, void 0, !0);
                d.setCN(c, q, "map-line-arrow");
                void 0 != a.id && d.setCN(c, q, "map-line-arrow-" + a.id);
                z.push(r);
                r.translate(K, N, 1 / n, !0);
                isNaN(I) || r.rotate(I);
                a.fixedSize && (g.push(r), a.arrays.push({
                  arr: g,
                  el: r
                }));
                a.arrowSvg = r;
              }
              a.fixedSize && q && (g = {
                line: q,
                thickness: E
              }, this.linesToResize.push(g), a.arrays.push({
                arr: this.linesToResize,
                el: g
              }), g = {
                line: l,
                thickness: 5
              }, this.linesToResize.push(g), a.arrays.push({
                arr: this.linesToResize,
                el: g
              }));
              a.lineSvg = q;
              a.showAsSelected && !isNaN(y) && q.setAttr("stroke", y);
              0 < e.length ? f.push(z) : h.push(z);
              a.hidden && z.hide();
              c.makeObjectAccessible(a);
            }
          }
        },
        processCoordinates: function(a, b) {
          var c = [],
              d;
          for (d = 0; d < a.length; d++) {
            var g = a[d],
                f = Number(g);
            isNaN(f) && (f = Number(g.replace("%", "")) * b / 100);
            isNaN(f) || c.push(f);
          }
          return c;
        },
        reset: function() {
          this.objectsToResize = [];
          this.allSvgObjects = [];
          this.allObjects = [];
          this.linesToResize = [];
        }
      });
    })();
    (function() {
      var d = window.AmCharts;
      d.LinesSettings = d.Class({construct: function(a) {
          this.cname = "LinesSettings";
          this.balloonText = "[[title]]";
          this.thickness = 1;
          this.dashLength = 0;
          this.arrowSize = 10;
          this.arrowAlpha = 1;
          this.arrow = "none";
          this.color = "#990000";
          this.descriptionWindowWidth = 250;
          this.bringForwardOnHover = !0;
          d.applyTheme(this, a, this.cname);
        }});
    })();
    (function() {
      var d = window.AmCharts;
      d.MapObject = d.Class({
        construct: function(a) {
          this.fixedSize = this.mouseEnabled = !0;
          this.images = [];
          this.lines = [];
          this.areas = [];
          this.remainVisible = !0;
          this.passZoomValuesToTarget = !1;
          this.objectType = this.cname;
          d.applyTheme(this, a, "MapObject");
          this.arrays = [];
        },
        deleteObject: function() {
          this.remove();
          this.parentArray && d.removeFromArray(this.parentArray, this);
          if (this.arrays)
            for (var a = 0; a < this.arrays.length; a++)
              d.removeFromArray(this.arrays[a].arr, this.arrays[a].el);
          this.arrays = [];
        }
      });
    })();
    (function() {
      var d = window.AmCharts;
      d.MapArea = d.Class({
        inherits: d.MapObject,
        construct: function(a) {
          this.cname = "MapArea";
          d.MapArea.base.construct.call(this, a);
          d.applyTheme(this, a, this.cname);
        },
        validate: function() {
          this.chart.areasProcessor.createArea(this);
        }
      });
    })();
    (function() {
      var d = window.AmCharts;
      d.MapLine = d.Class({
        inherits: d.MapObject,
        construct: function(a) {
          this.cname = "MapLine";
          this.longitudes = [];
          this.latitudes = [];
          this.x = [];
          this.y = [];
          this.segments = 0;
          this.arrow = "none";
          d.MapLine.base.construct.call(this, a);
          d.applyTheme(this, a, this.cname);
        },
        validate: function() {
          this.chart.linesProcessor.createLine(this);
        },
        remove: function() {
          var a = this.displayObject;
          a && a.remove();
        },
        getCoordinates: function(a, b) {
          isNaN(b) && (b = 0);
          isNaN(this.arc) || this.isValid || (this.isValid = !0, this.validate());
          if (!isNaN(a)) {
            var c,
                e,
                g,
                f,
                h,
                k;
            if (1 < this.longitudes.length) {
              e = this.chart.coordinatesToXY(this.longitudes[b], this.latitudes[b]);
              var l = this.chart.coordinatesToXY(this.longitudes[b + 1], this.latitudes[b + 1]);
              c = e.x;
              g = l.x;
              e = e.y;
              f = l.y;
            } else
              1 < this.x.length && (c = this.x[b], g = this.x[b + 1], e = this.y[b], f = this.y[b + 1]);
            l = Math.sqrt(Math.pow(g - c, 2) + Math.pow(f - e, 2));
            c < g && !isNaN(this.arc) && 0 !== this.arc && (a = 1 - a);
            h = c + (g - c) * a;
            k = e + (f - e) * a;
            var m = Math.atan2(f - e, g - c);
            if (!isNaN(this.arc) && 0 !== this.arc && this.arcRadius) {
              var n = 0;
              c < g && (n = c, c = g, g = n, n = e, e = f, f = n, n = Math.PI);
              k = this.arcRadius[b];
              0 > this.arc && (l = -l);
              h = c + (g - c) / 2 + Math.sqrt(k * k - l / 2 * (l / 2)) * (e - f) / l;
              var p = e + (f - e) / 2 + Math.sqrt(k * k - l / 2 * (l / 2)) * (g - c) / l;
              c = 180 * Math.atan2(e - p, c - h) / Math.PI;
              g = 180 * Math.atan2(f - p, g - h) / Math.PI;
              180 < g - c && (g -= 360);
              m = d.degreesToRadians(c + (g - c) * a);
              h += k * Math.cos(m);
              k = p + k * Math.sin(m);
              m = 0 < this.arc ? m + Math.PI / 2 : m - Math.PI / 2;
              m += n;
            }
            this.distance = l;
            return {
              x: h,
              y: k,
              angle: m
            };
          }
        },
        fixToStage: function() {
          if (0 < this.latitudes.length) {
            this.y = [];
            for (var a = 0; a < this.latitudes.length; a++) {
              var b = this.chart.coordinatesToStageXY(this.longitudes[a], this.latitudes[a]);
              this.y.push(b.y);
              this.x.push(b.x);
            }
            this.latitudes = [];
            this.longitudes = [];
          }
          this.validate();
        },
        fixToMap: function() {
          if (0 < this.y.length) {
            this.latitudes = [];
            for (var a = 0; a < this.y.length; a++) {
              var b = this.chart.stageXYToCoordinates(this.x[a], this.y[a]);
              this.latitudes.push(b.latitude);
              this.longitudes.push(b.longitude);
            }
            this.y = [];
            this.x = [];
          }
          this.validate();
        }
      });
    })();
    (function() {
      var d = window.AmCharts;
      d.MapImage = d.Class({
        inherits: d.MapObject,
        construct: function(a) {
          this.cname = "MapImage";
          this.scale = 1;
          this.widthAndHeightUnits = "pixels";
          this.labelShiftY = this.labelShiftX = 0;
          this.positionOnLine = .5;
          this.direction = 1;
          this.lineSegment = this.extraAngle = 0;
          this.animateAngle = !0;
          this.createEvents("animationStart", "animationEnd");
          d.MapImage.base.construct.call(this, a);
          d.applyTheme(this, a, this.cname);
          this.delayCounter = 0;
        },
        validate: function() {
          this.chart.imagesProcessor.createImage(this);
        },
        updatePosition: function() {
          this.chart.imagesProcessor.updateSizeAndPosition(this);
        },
        remove: function() {
          var a = this.displayObject;
          a && a.remove();
          (a = this.imageLabel) && a.remove();
        },
        animateTo: function(a, b, c, d) {
          isNaN(c) || (this.animationDuration = c);
          d && (this.easingFunction = d);
          this.finalX = a;
          this.finalY = b;
          isNaN(this.longitude) || (this.initialX = this.longitude);
          isNaN(this.left) || (this.initialX = this.left);
          isNaN(this.right) || (this.initialX = this.right);
          isNaN(this.latitude) || (this.initialY = this.latitude);
          isNaN(this.top) || (this.initialY = this.top);
          isNaN(this.bottom) || (this.initialY = this.bottom);
          this.animatingAlong = !1;
          this.animate();
        },
        animateAlong: function(a, b, c) {
          1 == this.positionOnLine && this.flipDirection && (this.direction = -1, this.extraAngle = 180);
          isNaN(b) || (this.animationDuration = b);
          c && (this.easingFunction = c);
          a && (this.line = this.chart.getObjectById(a));
          this.animateAlongLine = this.line;
          this.animatingAlong = !0;
          this.animate();
        },
        animate: function() {
          var a = this.chart.imagesSettings,
              b = this.animationDuration;
          isNaN(b) && (b = a.animationDuration);
          this.totalFrames = b * d.updateRate;
          b = 1;
          this.line && a.adjustAnimationSpeed && (this.line.distances && (b = this.line.distances[this.lineSegment] * this.chart.zoomLevel(), b = Math.abs(b / a.baseAnimationDistance)), this.totalFrames = Math.round(b * this.totalFrames));
          this.frame = 0;
          this.fire({
            type: "animationStart",
            chart: this.chart,
            image: this,
            lineSegment: this.lineSegment,
            direction: this.direction
          });
        },
        update: function() {
          var a = this.totalFrames;
          this.frame++;
          this.delayCounter--;
          0 === this.delayCounter && this.animateAlong();
          if (!(0 < this.delayCounter))
            if (this.frame <= a) {
              this.updatePosition();
              var b = this.chart.imagesSettings,
                  c = this.easingFunction;
              c || (c = b.easingFunction);
              a = c(0, this.frame, 0, 1, a);
              -1 == this.direction && (a = 1 - a);
              this.animatingAlong ? this.positionOnLine = a : (b = this.initialX + (this.finalX - this.initialX) * a, isNaN(this.longitude) || (this.longitude = b), isNaN(this.left) || (this.left = b), isNaN(this.right) || (this.right = b), a = this.initialY + (this.finalY - this.initialY) * a, isNaN(this.latitude) || (this.latitude = a), isNaN(this.top) || (this.top = a), isNaN(this.bottom) || (this.bottom = a));
            } else
              this.frame == a + 1 && (this.fire({
                type: "animationEnd",
                chart: this.chart,
                image: this,
                lineSegment: this.lineSegment,
                direction: this.direction
              }), this.line && this.animatingAlong && (1 == this.direction ? this.lineSegment < this.line.segments - 2 ? (this.lineSegment++, this.delayAnimateAlong(), this.positionOnLine = 0) : this.flipDirection ? (this.direction = -1, this.extraAngle = 180, this.delayAnimateAlong()) : this.loop && (this.delayAnimateAlong(), this.lineSegment = 0) : 0 < this.lineSegment ? (this.lineSegment--, this.delayAnimateAlong(), this.positionOnLine = 0) : this.loop && this.flipDirection ? (this.direction = 1, this.extraAngle = 0, this.delayAnimateAlong()) : this.loop && this.delayAnimateAlong()));
        },
        delayAnimateAlong: function() {
          this.animateAlongLine && (this.delayCounter = this.chart.imagesSettings.pauseDuration * d.updateRate);
        },
        fixToStage: function() {
          if (!isNaN(this.longitude)) {
            var a = this.chart.coordinatesToStageXY(this.longitude, this.latitude);
            this.left = a.x;
            this.top = a.y;
            this.latitude = this.longitude = void 0;
          }
          this.validate();
        },
        fixToMap: function() {
          if (!isNaN(this.left)) {
            var a = this.chart.stageXYToCoordinates(this.left, this.top);
            this.longitude = a.longitude;
            this.latitude = a.latitude;
            this.top = this.left = void 0;
          }
          this.validate();
        }
      });
    })();
    (function() {
      var d = window.AmCharts;
      d.degreesToRadians = function(a) {
        return a / 180 * Math.PI;
      };
      d.radiansToDegrees = function(a) {
        return a / Math.PI * 180;
      };
      d.getColorFade = function(a, b, c) {
        var e = d.hex2RGB(b);
        b = e[0];
        var g = e[1],
            e = e[2],
            f = d.hex2RGB(a);
        a = f[0];
        var h = f[1],
            f = f[2];
        a += Math.round((b - a) * c);
        h += Math.round((g - h) * c);
        f += Math.round((e - f) * c);
        return "rgb(" + a + "," + h + "," + f + ")";
      };
      d.hex2RGB = function(a) {
        return [parseInt(a.substring(1, 3), 16), parseInt(a.substring(3, 5), 16), parseInt(a.substring(5, 7), 16)];
      };
      d.processDescriptionWindow = function(a, b) {
        isNaN(b.descriptionWindowX) && (b.descriptionWindowX = a.descriptionWindowX);
        isNaN(b.descriptionWindowY) && (b.descriptionWindowY = a.descriptionWindowY);
        isNaN(b.descriptionWindowLeft) && (b.descriptionWindowLeft = a.descriptionWindowLeft);
        isNaN(b.descriptionWindowRight) && (b.descriptionWindowRight = a.descriptionWindowRight);
        isNaN(b.descriptionWindowTop) && (b.descriptionWindowTop = a.descriptionWindowTop);
        isNaN(b.descriptionWindowBottom) && (b.descriptionWindowBottom = a.descriptionWindowBottom);
        isNaN(b.descriptionWindowWidth) && (b.descriptionWindowWidth = a.descriptionWindowWidth);
        isNaN(b.descriptionWindowHeight) && (b.descriptionWindowHeight = a.descriptionWindowHeight);
      };
      d.normalizePath = function(a) {
        for (var b = "",
            c = d.parsePath(a.getAttribute("d")),
            e,
            g,
            f = Infinity,
            h = -Infinity,
            k = Infinity,
            l = -Infinity,
            m = 0; m < c.length; m++) {
          var n = c[m],
              p = n.letter,
              r = n.x,
              n = n.y;
          "h" == p && (p = "L", r += e, n = g);
          "H" == p && (p = "L", n = g);
          "v" == p && (p = "L", r = e, n += g);
          "V" == p && (p = "L", r = e);
          if ("m" === p || "l" === p)
            p = p.toUpperCase(), r += e, n += g;
          r = d.roundTo(r, 3);
          n = d.roundTo(n, 3);
          e = r;
          g = n;
          r > h && (h = r);
          r < f && (f = r);
          n > l && (l = n);
          n < k && (k = n);
          b = "z" == p.toLowerCase() ? b + "Z " : b + (p + " " + r + " " + n + " ");
        }
        a.setAttribute("d", b);
        return {
          minX: f,
          maxX: h,
          minY: k,
          maxY: l
        };
      };
      d.mercatorLatitudeToRadians = function(a) {
        return Math.log(Math.tan(Math.PI / 4 + d.degreesToRadians(a) / 2));
      };
      d.parsePath = function(a) {
        a = a.match(/([MmLlHhVvZz]{1}[0-9.,\-\s]*)/g);
        for (var b = [],
            c = 0; c < a.length; c++) {
          var d = a[c].match(/([MmLlHhVvZz]{1})|([0-9.\-]+)/g),
              g = {letter: d[0]};
          switch (d[0]) {
            case "Z":
            case "Z":
            case "z":
              break;
            case "V":
            case "v":
              g.y = Number(d[1]);
              break;
            case "H":
            case "h":
              g.x = Number(d[1]);
              break;
            default:
              g.x = Number(d[1]), g.y = Number(d[2]);
          }
          b.push(g);
        }
        return b;
      };
      d.acos = function(a) {
        return 1 < a ? 0 : -1 > a ? Math.PI : Math.acos(a);
      };
      d.asin = function(a) {
        return 1 < a ? Math.PI / 2 : -1 > a ? -Math.PI / 2 : Math.asin(a);
      };
      d.sinci = function(a) {
        return a ? a / Math.sin(a) : 1;
      };
      d.asqrt = function(a) {
        return 0 < a ? Math.sqrt(a) : 0;
      };
      d.winkel3 = function(a, b) {
        var c = d.aitoff(a, b);
        return [(c[0] + a / Math.PI * 2) / 2, (c[1] + b) / 2];
      };
      d.winkel3.invert = function(a, b) {
        var c = a,
            e = b,
            g = 25,
            f = Math.PI / 2;
        do
          var h = Math.cos(e),
              k = Math.sin(e),
              l = Math.sin(2 * e),
              m = k * k,
              n = h * h,
              p = Math.sin(c),
              r = Math.cos(c / 2),
              t = Math.sin(c / 2),
              q = t * t,
              y = 1 - n * r * r,
              B = y ? d.acos(h * r) * Math.sqrt(u = 1 / y) : u = 0,
              u,
              y = .5 * (2 * B * h * t + c / f) - a,
              w = .5 * (B * k + e) - b,
              v = .5 * u * (n * q + B * h * r * m) + .5 / f,
              A = u * (p * l / 4 - B * k * t),
              k = .125 * u * (l * t - B * k * n * p),
              m = .5 * u * (m * r + B * q * h) + .5,
              h = A * k - m * v,
              A = (w * A - y * m) / h,
              y = (y * k - w * v) / h,
              c = c - A,
              e = e - y;
 while ((1E-6 < Math.abs(A) || 1E-6 < Math.abs(y)) && 0 < --g);
        return [c, e];
      };
      d.aitoff = function(a, b) {
        var c = Math.cos(b),
            e = d.sinci(d.acos(c * Math.cos(a /= 2)));
        return [2 * c * Math.sin(a) * e, Math.sin(b) * e];
      };
      d.orthographic = function(a, b) {
        return [Math.cos(b) * Math.sin(a), Math.sin(b)];
      };
      d.equirectangular = function(a, b) {
        return [a, b];
      };
      d.equirectangular.invert = function(a, b) {
        return [a, b];
      };
      d.eckert5 = function(a, b) {
        var c = Math.PI;
        return [a * (1 + Math.cos(b)) / Math.sqrt(2 + c), 2 * b / Math.sqrt(2 + c)];
      };
      d.eckert5.invert = function(a, b) {
        var c = Math.sqrt(2 + Math.PI),
            d = b * c / 2;
        return [c * a / (1 + Math.cos(d)), d];
      };
      d.eckert6 = function(a, b) {
        for (var c = Math.PI,
            d = (1 + c / 2) * Math.sin(b),
            g = 0,
            f = Infinity; 10 > g && 1E-5 < Math.abs(f); g++)
          b -= f = (b + Math.sin(b) - d) / (1 + Math.cos(b));
        d = Math.sqrt(2 + c);
        return [a * (1 + Math.cos(b)) / d, 2 * b / d];
      };
      d.eckert6.invert = function(a, b) {
        var c = 1 + Math.PI / 2,
            e = Math.sqrt(c / 2);
        return [2 * a * e / (1 + Math.cos(b *= e)), d.asin((b + Math.sin(b)) / c)];
      };
      d.mercator = function(a, b) {
        b >= Math.PI / 2 - .02 && (b = Math.PI / 2 - .02);
        b <= -Math.PI / 2 + .02 && (b = -Math.PI / 2 + .02);
        return [a, Math.log(Math.tan(Math.PI / 4 + b / 2))];
      };
      d.mercator.invert = function(a, b) {
        return [a, 2 * Math.atan(Math.exp(b)) - Math.PI / 2];
      };
      d.miller = function(a, b) {
        return [a, 1.25 * Math.log(Math.tan(Math.PI / 4 + .4 * b))];
      };
      d.miller.invert = function(a, b) {
        return [a, 2.5 * Math.atan(Math.exp(.8 * b)) - .625 * Math.PI];
      };
      d.eckert3 = function(a, b) {
        var c = Math.PI,
            d = Math.sqrt(c * (4 + c));
        return [2 / d * a * (1 + Math.sqrt(1 - 4 * b * b / (c * c))), 4 / d * b];
      };
      d.eckert3.invert = function(a, b) {
        var c = Math.PI,
            e = Math.sqrt(c * (4 + c)) / 2;
        return [a * e / (1 + d.asqrt(1 - b * b * (4 + c) / (4 * c))), b * e / 2];
      };
    })();
    (function() {
      var d = window.AmCharts;
      d.MapData = d.Class({
        inherits: d.MapObject,
        construct: function() {
          this.cname = "MapData";
          d.MapData.base.construct.call(this);
          this.projection = "mercator";
          this.topLatitude = 90;
          this.bottomLatitude = -90;
          this.leftLongitude = -180;
          this.rightLongitude = 180;
          this.zoomLevel = 1;
          this.getAreasFromMap = !1;
        }
      });
    })();
    (function() {
      var d = window.AmCharts;
      d.DescriptionWindow = d.Class({
        construct: function() {},
        show: function(a, b, c, d) {
          var g = this;
          g.chart = a;
          var f = document.createElement("div");
          f.style.position = "absolute";
          var h = a.classNamePrefix + "-description-";
          f.className = "ammapDescriptionWindow " + h + "div";
          g.div = f;
          b.appendChild(f);
          var k = ".gif";
          a.svgIcons && (k = ".svg");
          var l = document.createElement("img");
          l.className = "ammapDescriptionWindowCloseButton " + h + "close-img";
          l.src = a.pathToImages + "xIcon" + k;
          l.style.cssFloat = "right";
          l.style.cursor = "pointer";
          l.onclick = function() {
            g.close();
          };
          l.onmouseover = function() {
            l.src = a.pathToImages + "xIconH" + k;
          };
          l.onmouseout = function() {
            l.src = a.pathToImages + "xIcon" + k;
          };
          f.appendChild(l);
          b = document.createElement("div");
          b.className = "ammapDescriptionTitle " + h + "title-div";
          b.onmousedown = function() {
            g.div.style.zIndex = 1E3;
          };
          f.appendChild(b);
          b.innerHTML = d;
          d = b.offsetHeight;
          b = document.createElement("div");
          b.className = "ammapDescriptionText " + h + "text-div";
          b.style.maxHeight = g.maxHeight - d - 20 + "px";
          f.appendChild(b);
          b.innerHTML = c;
        },
        close: function() {
          try {
            this.div.parentNode.removeChild(this.div), this.chart.fireClosed();
          } catch (a) {}
        }
      });
    })();
    (function() {
      var d = window.AmCharts;
      d.ValueLegend = d.Class({
        construct: function(a) {
          this.cname = "ValueLegend";
          this.enabled = !0;
          this.showAsGradient = !1;
          this.minValue = 0;
          this.height = 12;
          this.width = 200;
          this.bottom = this.left = 10;
          this.borderColor = "#FFFFFF";
          this.borderAlpha = this.borderThickness = 1;
          this.color = "#000000";
          this.fontSize = 11;
          d.applyTheme(this, a, this.cname);
        },
        init: function(a, b) {
          if (this.enabled) {
            var c = a.areasSettings.color,
                e = a.areasSettings.colorSolid,
                g = a.colorSteps;
            d.remove(this.set);
            var f = b.set();
            this.set = f;
            d.setCN(a, f, "value-legend");
            var h = 0,
                k = this.minValue,
                l = this.fontSize,
                m = a.fontFamily,
                n = this.color,
                p = {
                  precision: a.precision,
                  decimalSeparator: a.decimalSeparator,
                  thousandsSeparator: a.thousandsSeparator
                };
            void 0 == k && (k = d.formatNumber(a.minValueReal, p));
            void 0 !== k && (h = d.text(b, k, n, m, l, "left"), h.translate(0, l / 2 - 1), d.setCN(a, h, "value-legend-min-label"), f.push(h), h = h.getBBox().height);
            k = this.maxValue;
            void 0 === k && (k = d.formatNumber(a.maxValueReal, p));
            void 0 !== k && (h = d.text(b, k, n, m, l, "right"), h.translate(this.width, l / 2 - 1), d.setCN(a, h, "value-legend-max-label"), f.push(h), h = h.getBBox().height);
            if (this.showAsGradient)
              c = d.rect(b, this.width, this.height, [c, e], 1, this.borderThickness, this.borderColor, 1, 0, 0), d.setCN(a, c, "value-legend-gradient"), c.translate(0, h), f.push(c);
            else
              for (l = this.width / g, m = 0; m < g; m++)
                n = d.getColorFade(c, e, 1 * m / (g - 1)), n = d.rect(b, l, this.height, n, 1, this.borderThickness, this.borderColor, 1), d.setCN(a, n, "value-legend-color"), d.setCN(a, n, "value-legend-color-" + m), n.translate(l * m, h), f.push(n);
            e = c = 0;
            g = f.getBBox();
            h = a.getY(this.bottom, !0);
            l = a.getY(this.top);
            m = a.getX(this.right, !0);
            n = a.getX(this.left);
            isNaN(l) || (c = l);
            isNaN(h) || (c = h - g.height);
            isNaN(n) || (e = n);
            isNaN(m) || (e = m - g.width);
            f.translate(e, c);
          } else
            d.remove(this.set);
        }
      });
    })();
    (function() {
      var d = window.AmCharts;
      d.ObjectList = d.Class({
        construct: function(a) {
          this.divId = a;
        },
        init: function(a) {
          this.chart = a;
          var b = this.divId;
          this.container && (b = this.container);
          this.div = "object" != typeof b ? document.getElementById(b) : b;
          b = document.createElement("div");
          b.className = "ammapObjectList " + a.classNamePrefix + "-object-list-div";
          this.div.appendChild(b);
          this.addObjects(a.dataProvider, b);
        },
        addObjects: function(a, b) {
          var c = this.chart,
              d = document.createElement("ul");
          d.className = c.classNamePrefix + "-object-list-ul";
          var g;
          if (a.areas)
            for (g = 0; g < a.areas.length; g++) {
              var f = a.areas[g];
              void 0 === f.showInList && (f.showInList = c.showAreasInList);
              this.addObject(f, d);
            }
          if (a.images)
            for (g = 0; g < a.images.length; g++)
              f = a.images[g], void 0 === f.showInList && (f.showInList = c.showImagesInList), this.addObject(f, d);
          if (a.lines)
            for (g = 0; g < a.lines.length; g++)
              f = a.lines[g], void 0 === f.showInList && (f.showInList = c.showLinesInList), this.addObject(f, d);
          0 < d.childNodes.length && b.appendChild(d);
        },
        addObject: function(a, b) {
          var c = this;
          if (a.showInList && void 0 !== a.title) {
            var d = c.chart,
                g = document.createElement("li");
            g.className = d.classNamePrefix + "-object-list-li";
            var f = a.titleTr;
            f || (f = a.title);
            var f = document.createTextNode(f),
                h = document.createElement("a");
            h.className = d.classNamePrefix + "-object-list-a";
            h.appendChild(f);
            g.appendChild(h);
            b.appendChild(g);
            this.addObjects(a, g);
            h.onmouseover = function() {
              c.chart.rollOverMapObject(a, !1);
            };
            h.onmouseout = function() {
              c.chart.rollOutMapObject(a);
            };
            h.onclick = function() {
              c.chart.clickMapObject(a);
            };
          }
        }
      });
    })();
  })();
  return _retrieveGlobal();
});

$__System.registerDynamic("7", [], false, function($__require, $__exports, $__module) {
  var _retrieveGlobal = $__System.get("@@global-helpers").prepareGlobal($__module.id, null, null);
  (function() {
    AmCharts.maps.worldLow = {"svg": {
        "defs": {"amcharts:ammap": {
            "projection": "mercator",
            "leftLongitude": "-169.6",
            "topLatitude": "83.68",
            "rightLongitude": "190.25",
            "bottomLatitude": "-55.55"
          }},
        "g": {"path": [{
            "id": "AE",
            "title": "United Arab Emirates",
            "d": "M619.87,393.72L620.37,393.57L620.48,394.41L622.67,393.93L624.99,394.01L626.68,394.1L628.6,392.03L630.7,390.05L632.47,388.15L633,389.2L633.38,391.64L631.95,391.65L631.72,393.65L632.22,394.07L630.95,394.67L630.94,395.92L630.12,397.18L630.05,398.39L629.48,399.03L621.06,397.51L619.98,394.43z"
          }, {
            "id": "AF",
            "title": "Afghanistan",
            "d": "M646.88,356.9L649.74,358.2L651.85,357.74L652.44,356.19L654.65,355.67L656.23,354.62L656.79,351.83L659.15,351.15L659.59,349.9L660.92,350.84L661.76,350.95L663.32,350.98L665.44,351.72L666.29,352.14L668.32,351.02L669.27,351.69L670.17,350.09L671.85,350.16L672.28,349.64L672.58,348.21L673.79,346.98L675.3,347.78L675,348.87L675.85,349.04L675.58,351.99L676.69,353.14L677.67,352.4L678.92,352.06L680.66,350.49L682.59,350.75L685.49,350.75L685.99,351.76L684.35,352.15L682.93,352.8L679.71,353.2L676.7,353.93L675.06,355.44L675.72,356.9L676.05,358.6L674.65,360.03L674.77,361.33L674,362.55L671.33,362.44L672.43,364.66L670.65,365.51L669.46,367.51L669.61,369.49L668.51,370.41L667.48,370.11L665.33,370.54L665.03,371.45L662.94,371.45L661.38,373.29L661.28,376.04L657.63,377.37L655.68,377.09L655.11,377.79L653.44,377.39L650.63,377.87L645.94,376.23L648.48,373.3L648.25,371.2L646.13,370.65L645.91,368.56L644.99,365.92L646.19,364.09L644.97,363.6L645.74,361.15z"
          }, {
            "id": "AL",
            "title": "Albania",
            "d": "M532.98,334.66L532.63,335.93L533.03,337.52L534.19,338.42L534.13,339.39L533.22,339.93L533.05,341.12L531.75,342.88L531.27,342.63L531.22,341.83L529.66,340.6L529.42,338.85L529.66,336.32L530.04,335.16L529.57,334.57L529.38,333.38L530.6,331.51L530.77,332.23L531.53,331.89L532.13,332.91L532.8,333.29z"
          }, {
            "id": "AM",
            "title": "Armenia",
            "d": "M597.45,337.5L601.35,336.92L601.93,337.9L603,338.54L602.43,339.46L603.93,340.72L603.14,341.88L604.33,342.87L605.59,343.46L605.65,345.96L604.63,346.06L603.49,343.98L603.5,343.43L602.26,343.44L601.43,342.46L600.85,342.56L599.74,341.5L597.66,340.59L597.93,338.8z"
          }, {
            "id": "AO",
            "title": "Angola",
            "d": "M521.03,479.78l0.69,2.09l0.8,1.68l0.64,0.91l1.07,1.47l1.85,-0.23l0.93,-0.4l1.55,0.4l0.42,-0.7l0.7,-1.64l1.74,-0.11l0.15,-0.49l1.43,-0.01l-0.24,1.01l3.4,-0.02l0.05,1.77l0.57,1.09l-0.41,1.7l0.21,1.74l0.94,1.05l-0.15,3.37l0.69,-0.26l1.22,0.07l1.74,-0.42l1.28,0.17l0.3,0.88l-0.32,1.38l0.49,1.34l-0.42,1.07l0.24,0.99l-5.84,-0.04l-0.13,9.16l1.89,2.38l1.83,1.82l-5.15,1.19l-6.79,-0.41l-1.94,-1.4l-11.37,0.13l-0.42,0.21l-1.67,-1.32l-1.82,-0.09l-1.68,0.5l-1.35,0.56l-0.26,-1.83l0.39,-2.55l0.97,-2.65l0.15,-1.24l0.91,-2.59l0.67,-1.17l1.61,-1.87l0.9,-1.27l0.29,-2.11l-0.15,-1.61l-0.84,-1.01l-0.75,-1.72l-0.69,-1.69l0.15,-0.59l0.86,-1.12l-0.85,-2.72l-0.57,-1.88l-1.4,-1.77l0.27,-0.54l1.16,-0.38l0.81,0.05l0.98,-0.34L521.03,479.78zM510.12,479.24l-0.71,0.3l-0.75,-2.1l1.13,-1.21l0.85,-0.47l1.05,0.96l-1.02,0.59l-0.46,0.72L510.12,479.24z"
          }, {
            "id": "AR",
            "title": "Argentina",
            "d": "M291.6,648.91l-2.66,0.25l-1.43,-1.73l-1.69,-0.13l-3,0l0,-10.57l1.08,2.15l1.4,3.53l3.65,2.87l3.93,1.21L291.6,648.91zM293.1,526.47l1.65,2.18l1.09,-2.43l3.2,0.12l0.45,0.64l5.15,4.94l2.29,0.46l3.43,2.26l2.89,1.2l0.4,1.36l-2.76,4.73l2.83,0.85l3.15,0.48l2.22,-0.5l2.54,-2.4l0.46,-2.74l1.39,-0.59l1.41,1.79l-0.06,2.49l-2.36,1.73l-1.88,1.28l-3.16,3.08l-3.74,4.37l-0.7,2.59l-0.75,3.37l0.03,3.3l-0.61,0.74l-0.22,2.17l-0.19,1.76l3.56,2.91l-0.38,2.37l1.75,1.51l-0.14,1.7l-2.69,4.52l-4.16,1.91l-5.62,0.75l-3.08,-0.36l0.59,2.15l-0.57,2.72l0.52,1.85l-1.68,1.3l-2.87,0.51l-2.7,-1.35l-1.08,0.97l0.39,3.71l1.89,1.14l1.54,-1.19l0.84,1.96l-2.58,1.18l-2.25,2.38l-0.41,3.91l-0.66,2.11l-2.65,0.01l-2.2,2.04l-0.8,3.01l2.76,2.98l2.68,0.83l-0.96,3.73l-3.31,2.38l-1.82,5.03l-2.56,1.72l-1.15,2.06l0.91,4.64l1.87,2.63l-1.18,-0.23l-2.6,-0.71l-6.78,-0.61l-1.16,-2.63l0.05,-3.33l-1.87,0.28l-0.99,-1.6l-0.25,-4.6l2.15,-1.88l0.89,-2.68l-0.33,-2.11l1.49,-3.52l1.02,-5.35l-0.3,-2.33l1.22,-0.75l-0.3,-1.48l-1.3,-0.78l0.92,-1.63l-1.27,-1.46l-0.65,-4.4l1.13,-0.77l-0.47,-4.54l0.66,-3.75l0.75,-3.22l1.68,-1.3l-0.85,-3.46l-0.01,-3.22l2.12,-2.26l-0.06,-2.87l1.6,-3.31l0.01,-3.09l-0.73,-0.61l-1.29,-5.69l1.73,-3.34l-0.27,-3.11l1,-2.9l1.84,-2.96l1.98,-1.95l-0.84,-1.23l0.59,-1l-0.09,-5.14l3.05,-1.51l0.96,-3.16l-0.34,-0.76l2.34,-2.72L293.1,526.47z"
          }, {
            "id": "AT",
            "title": "Austria",
            "d": "M522.86,309.85L522.65,311.56L521.07,311.57L521.61,312.46L520.68,315.11L520.15,315.8L517.7,315.9L516.28,316.82L513.96,316.51L509.95,315.46L509.33,314.03L506.56,314.75L506.23,315.52L504.53,314.94L503.1,314.83L501.83,314.09L502.26,313.08L502.15,312.34L503,312.12L504.42,313.26L504.82,312.17L507.29,312.35L509.3,311.61L510.64,311.73L511.51,312.58L511.78,311.88L511.38,309.16L512.39,308.62L513.37,306.67L515.46,308.04L517.03,306.3L518.02,305.98L520.2,307.28L521.51,307.06L522.81,307.86L522.58,308.4z"
          }, {
            "id": "AU",
            "title": "Australia",
            "d": "M882.93,588.16l2.71,1.28l1.53,-0.51l2.19,-0.71l1.68,0.25l0.2,4.43l-0.96,1.3l-0.29,3.06l-0.98,-1.05l-1.95,2.67l-0.58,-0.21l-1.72,-0.12l-1.73,-3.28l-0.38,-2.5l-1.62,-3.25l0.07,-1.7L882.93,588.16zM877.78,502.1l1.01,2.25l1.8,-1.08l0.93,1.22l1.35,1.13l-0.29,1.28l0.6,2.48l0.43,1.45l0.71,0.35l0.76,2.5l-0.27,1.52l0.91,1.99l3.04,1.54l1.98,1.41l1.88,1.29l-0.37,0.72l1.6,1.87l1.09,3.25l1.12,-0.66l1.14,1.31l0.69,-0.46l0.48,3.21l1.99,1.87l1.3,1.17l2.19,2.49l0.79,2.49l0.07,1.77l-0.19,1.94l1.34,2.68l-0.16,2.81l-0.49,1.48l-0.76,2.87l0.06,1.86l-0.55,2.34l-1.24,3l-2.08,1.63l-1.02,2.59l-0.94,1.67l-0.83,2.93l-1.08,1.71l-0.71,2.58l-0.36,2.4l0.14,1.11l-1.61,1.22l-3.14,0.13l-2.59,1.45l-1.29,1.38l-1.69,1.54l-2.32,-1.58l-1.72,-0.63l0.44,-1.85l-1.53,0.67l-2.46,2.58l-2.42,-0.97l-1.59,-0.56l-1.6,-0.25l-2.71,-1.03l-1.81,-2.18l-0.52,-2.66l-0.65,-1.75l-1.38,-1.4l-2.7,-0.41l0.92,-1.66l-0.68,-2.52l-1.37,2.35l-2.5,0.63l1.47,-1.88l0.42,-1.95l1.08,-1.65l-0.22,-2.47l-2.28,2.85l-1.75,1.15l-1.07,2.69l-2.19,-1.4l0.09,-1.79l-1.75,-2.43l-1.48,-1.25l0.53,-0.77l-3.6,-2l-1.97,-0.09l-2.7,-1.6l-5.02,0.31l-3.63,1.18l-3.19,1.1l-2.68,-0.22l-2.97,1.7l-2.43,0.77l-0.54,1.75l-1.04,1.36l-2.38,0.08l-1.76,0.3l-2.48,-0.61l-2.02,0.37l-1.92,0.15l-1.67,1.8l-0.82,-0.15l-1.41,0.96l-1.35,1.08l-2.05,-0.13l-1.88,0l-2.97,-2.17l-1.51,-0.64l0.06,-1.93l1.39,-0.46l0.48,-0.76l-0.1,-1.2l0.34,-2.3l-0.31,-1.95l-1.48,-3.29l-0.46,-1.85l0.12,-1.83l-1.12,-2.08l-0.07,-0.93l-1.24,-1.26l-0.35,-2.47l-1.6,-2.48l-0.39,-1.33l1.23,1.35l-0.95,-2.88l1.39,0.9l0.83,1.2l-0.05,-1.59l-1.39,-2.43l-0.27,-0.97l-0.65,-0.92l0.3,-1.77l0.57,-0.75l0.38,-1.52l-0.3,-1.77l1.16,-2.17l0.21,2.29l1.18,-2.07l2.28,-1l1.37,-1.28l2.14,-1.1l1.27,-0.23l0.77,0.37l2.21,-1.11l1.7,-0.33l0.42,-0.65l0.74,-0.27l1.55,0.07l2.95,-0.87l1.52,-1.31l0.72,-1.58l1.64,-1.49l0.13,-1.17l0.07,-1.59l1.96,-2.47l1.18,2.51l1.19,-0.58l-1,-1.38l0.88,-1.41l1.24,0.63l0.34,-2.21l1.53,-1.42l0.68,-1.14l1.41,-0.49l0.04,-0.8l1.23,0.34l0.05,-0.72l1.23,-0.41l1.36,-0.39l2.07,1.32l1.56,1.71l1.75,0.02l1.78,0.27l-0.59,-1.58l1.34,-2.3l1.26,-0.75l-0.44,-0.71l1.22,-1.63l1.7,-1.01l1.43,0.34l2.36,-0.54l-0.05,-1.45l-2.05,-0.94l1.49,-0.41l1.86,0.7l1.49,1.17l2.36,0.73l0.8,-0.29l1.74,0.88l1.64,-0.82l1.05,0.25l0.66,-0.55l1.29,1.41l-0.75,1.53l-1.06,1.16l-0.96,0.1l0.33,1.15l-0.82,1.43l-1,1.41l0.2,0.81l2.23,1.6l2.16,0.93l1.44,1l2.03,1.72l0.79,0l1.47,0.75l0.43,0.9l2.68,0.99l1.85,-1l0.55,-1.57l0.57,-1.29l0.35,-1.59l0.85,-2.3l-0.39,-1.39l0.2,-0.84l-0.32,-1.64l0.37,-2.16l0.54,-0.58l-0.44,-0.95l0.68,-1.51l0.53,-1.56l0.07,-0.81l1.04,-1.06l0.79,1.39l0.19,1.78l0.7,0.34l0.12,1.2l1.02,1.45l0.21,1.62L877.78,502.1z"
          }, {
            "id": "AZ",
            "title": "Azerbaijan",
            "d": "M601.43,342.46l0.83,0.97l1.24,-0.01l-0.01,0.56l1.14,2.08l-1.92,-0.48l-1.42,-1.66l-0.44,-1.37L601.43,342.46zM608.08,337.03l1.24,0.25l0.48,-0.95l1.67,-1.51l1.47,1.97l1.43,2.62l1.31,0.17l0.86,0.99l-2.31,0.29l-0.49,2.82l-0.48,1.26l-1.03,0.84l0.08,1.77l-0.7,0.18l-1.75,-1.87l0.97,-1.78l-0.83,-1.06l-1.05,0.27l-3.31,2.66l-0.06,-2.5l-1.26,-0.59l-1.19,-0.99l0.79,-1.16l-1.49,-1.26l0.56,-0.92l-1.07,-0.64l-0.58,-0.97l0.69,-0.61l2.09,1.07l1.51,0.22l0.38,-0.43l-1.38,-2.02l0.73,-0.52l0.79,0.13L608.08,337.03z"
          }, {
            "id": "BA",
            "title": "Bosnia and Herzegovina",
            "d": "M528.54,323.11L529.56,323.1L528.86,324.82L530.21,326.32L529.8,328.14L529.14,328.31L528.61,328.67L527.7,329.56L527.29,331.66L524.81,330.22L523.75,328.61L522.68,327.76L521.39,326.31L520.79,325.1L519.41,323.27L520,321.63L521.01,322.54L521.61,321.72L522.92,321.63L525.33,322.29L527.27,322.23z"
          }, {
            "id": "BD",
            "title": "Bangladesh",
            "d": "M735.09,400.41L735.04,402.56L734.06,402.1L734.24,404.51L733.44,402.95L733.28,401.43L732.74,399.98L731.57,398.22L728.99,398.1L729.25,399.35L728.37,401.02L727.17,400.41L726.76,400.96L725.97,400.63L724.89,400.36L724.45,397.88L723.48,395.6L723.95,393.76L722.23,392.94L722.85,391.82L724.6,390.67L722.58,389.04L723.57,386.93L725.79,388.27L727.13,388.43L727.38,390.58L730.04,391L732.65,390.95L734.26,391.48L732.97,394.07L731.71,394.25L730.85,395.98L732.38,397.56L732.84,395.62L733.62,395.61z"
          }, {
            "id": "BE",
            "title": "Belgium",
            "d": "M484.55,295.91L486.6,296.26L489.2,295.33L490.97,297.28L492.52,298.32L492.2,301.29L491.47,301.45L491.16,303.88L488.71,301.91L487.27,302.25L485.31,300.19L484.01,298.42L482.71,298.35L482.3,296.79z"
          }, {
            "id": "BF",
            "title": "Burkina Faso",
            "d": "M467.33,436.4L465.41,435.67L464.09,435.78L463.11,436.49L461.85,435.89L461.36,434.96L460.1,434.34L459.91,432.7L460.68,431.49L460.61,430.53L462.84,428.17L463.25,426.21L464.02,425.51L465.38,425.89L466.55,425.31L466.93,424.57L469.11,423.29L469.64,422.39L472.26,421.19L473.81,420.78L474.51,421.33L476.3,421.32L476.08,422.72L476.46,424.03L478.04,425.9L478.12,427.28L481.36,427.93L481.29,429.88L480.68,430.74L479.31,431L478.74,432.24L477.78,432.56L475.32,432.5L474.02,432.28L473.12,432.74L471.88,432.53L467.01,432.66L466.94,434.27z"
          }, {
            "id": "BG",
            "title": "Bulgaria",
            "d": "M538.78,325.56L539.59,327.16L540.67,326.87L542.83,327.48L546.95,327.68L548.34,326.69L551.64,325.79L553.68,327.2L555.33,327.61L553.87,329.2L552.85,331.93L553.75,334.09L551.34,333.58L548.48,334.76L548.45,336.62L545.9,336.97L543.93,335.67L541.68,336.7L539.61,336.59L539.41,334.12L538,332.91L538.47,332.37L538.16,331.92L538.63,330.71L539.7,329.52L538.34,327.86L538.09,326.44z"
          }, {
            "id": "BI",
            "title": "Burundi",
            "d": "M557.52,475.93L557.34,472.56L556.63,471.3L558.34,471.52L559.2,469.93L560.69,470.11L560.85,471.21L561.45,471.84L561.48,472.75L560.79,473.33L559.69,474.79L558.68,475.8z"
          }, {
            "id": "BJ",
            "title": "Benin",
            "d": "M482.8,445.92L480.48,446.25L479.79,444.31L479.92,437.85L479.35,437.27L479.25,435.88L478.27,434.89L477.42,434.06L477.78,432.56L478.74,432.24L479.31,431L480.68,430.74L481.29,429.88L482.23,429.05L483.24,429.04L485.38,430.68L485.27,431.63L485.9,433.31L485.35,434.45L485.64,435.21L484.28,436.96L483.42,437.83L482.89,439.6L482.96,441.39z"
          }, {
            "id": "BN",
            "title": "Brunei Darussalam",
            "d": "M795.46,450.77L796.57,449.72L798.96,448.19L798.83,449.57L798.67,451.35L797.33,451.26L796.74,452.21z"
          }, {
            "id": "BO",
            "title": "Bolivia",
            "d": "M299.04,526.35L295.84,526.22L294.75,528.65L293.1,526.47L289.43,525.74L287.1,528.46L285.07,528.87L283.97,524.72L282.47,521.38L283.35,518.51L281.88,517.26L281.51,515.14L280.13,513.14L281.9,510L280.69,507.56L281.34,506.59L280.83,505.52L281.93,504.08L281.99,501.64L282.12,499.62L282.73,498.66L280.3,494.08L282.39,494.32L283.83,494.25L284.46,493.4L286.91,492.25L288.38,491.19L292.05,490.71L291.76,492.83L292.1,493.92L291.87,495.82L294.92,498.37L298.06,498.84L299.16,499.91L301.06,500.48L302.22,501.31L303.98,501.28L305.61,502.13L305.73,503.79L306.28,504.63L306.32,505.88L305.5,505.92L306.58,509.29L311.95,509.41L311.54,511.09L311.84,512.24L313.37,513.06L314.04,514.88L313.54,517.2L312.77,518.49L313.04,520.18L312.16,520.79L312.12,519.88L309.5,518.37L306.9,518.32L302.01,519.18L300.67,521.8L300.6,523.4L299.49,526.99z"
          }, {
            "id": "BR",
            "title": "Brazil",
            "d": "M313.68,551.79L317.42,547.42L320.59,544.34L322.47,543.06L324.83,541.33L324.89,538.84L323.48,537.05L322.09,537.64L322.64,535.86L323.02,534.04L323.02,532.36L322.01,531.81L320.96,532.3L319.92,532.17L319.59,530.99L319.33,528.22L318.8,527.32L316.91,526.5L315.77,527.09L312.81,526.51L312.99,522.45L312.16,520.79L313.04,520.18L312.77,518.49L313.54,517.2L314.04,514.88L313.37,513.06L311.84,512.24L311.54,511.09L311.95,509.41L306.58,509.29L305.5,505.92L306.32,505.88L306.28,504.63L305.73,503.79L305.61,502.13L303.98,501.28L302.22,501.31L301.06,500.48L299.16,499.91L298.06,498.84L294.92,498.37L291.87,495.82L292.1,493.92L291.76,492.83L292.05,490.71L288.38,491.19L286.91,492.25L284.46,493.4L283.83,494.25L282.39,494.32L280.3,494.08L278.72,494.57L277.44,494.24L277.63,489.94L275.33,491.6L272.86,491.53L271.8,490.02L269.94,489.86L270.53,488.65L268.97,486.93L267.8,484.4L268.54,483.89L268.54,482.7L270.24,481.89L269.96,480.38L270.67,479.4L270.88,478.1L274.08,476.19L276.38,475.66L276.75,475.24L279.28,475.37L280.54,467.72L280.61,466.51L280.17,464.92L278.93,463.9L278.94,461.88L280.52,461.42L281.08,461.71L281.17,460.64L279.53,460.35L279.5,458.61L284.96,458.67L285.89,457.71L286.67,458.59L287.21,460.24L287.74,459.89L289.29,461.37L291.47,461.19L292.01,460.33L294.09,459.68L295.25,459.23L295.57,458.05L297.58,457.25L297.42,456.67L295.05,456.43L294.66,454.67L294.77,452.8L293.52,452.08L294.04,451.82L296.12,452.18L298.35,452.88L299.16,452.22L301.17,451.78L304.31,450.74L305.34,449.67L304.96,448.88L306.42,448.76L307.08,449.4L306.71,450.63L307.67,451.05L308.32,452.35L307.54,453.33L307.09,455.71L307.81,457.12L308.01,458.41L309.74,459.71L311.12,459.85L311.43,459.31L312.31,459.19L313.58,458.7L314.49,457.96L316.04,458.19L316.72,458.09L318.25,458.32L318.5,457.75L318.03,457.2L318.31,456.39L319.44,456.64L320.77,456.35L322.37,456.94L323.6,457.52L324.47,456.76L325.09,456.88L325.48,457.67L326.82,457.47L327.89,456.41L328.75,454.35L330.41,451.8L331.37,451.67L332.06,453.21L333.63,458.09L335.13,458.55L335.21,460.47L333.1,462.76L333.97,463.6L338.93,464.04L339.03,466.83L341.16,465L344.69,466.01L349.34,467.71L350.71,469.34L350.25,470.88L353.51,470.02L358.97,471.5L363.16,471.39L367.3,473.7L370.88,476.83L373.04,477.63L375.44,477.75L376.46,478.63L377.41,482.2L377.88,483.89L376.76,488.55L375.33,490.39L371.38,494.33L369.59,497.54L367.52,500.02L366.82,500.08L366.03,502.18L366.23,507.58L365.45,512.06L365.15,513.99L364.27,515.14L363.77,519.08L360.93,522.96L360.45,526.05L358.18,527.36L357.52,529.17L354.48,529.16L350.07,530.33L348.09,531.68L344.95,532.57L341.65,535.01L339.28,538.07L338.87,540.39L339.34,542.12L338.81,545.3L338.18,546.85L336.22,548.6L333.11,554.28L330.64,556.87L328.73,558.41L327.46,561.57L325.6,563.48L324.82,561.58L326.06,560.01L324.44,557.76L322.24,555.94L319.35,553.86L318.31,553.95L315.5,551.45z"
          }, {
            "id": "BS",
            "title": "Bahamas",
            "d": "M257.86,395.2l-0.69,0.15l-0.71,-1.76l-1.05,-0.89l0.61,-1.95l0.84,0.12l0.98,2.55L257.86,395.2zM257.06,386.51l-3.06,0.5l-0.2,-1.15l1.32,-0.25l1.85,0.09L257.06,386.51zM259.36,386.48l-0.48,2.21l-0.52,-0.4l0.05,-1.63l-1.26,-1.23l-0.01,-0.36L259.36,386.48z"
          }, {
            "id": "BT",
            "title": "Bhutan",
            "d": "M732.36,382.78L733.5,383.78L733.3,385.71L731.01,385.8L728.65,385.59L726.88,386.08L724.33,384.89L724.28,384.26L726.13,381.92L727.64,381.12L729.65,381.85L731.13,381.93z"
          }, {
            "id": "BW",
            "title": "Botswana",
            "d": "M547.17,515.95L547.73,516.47L548.62,518.18L551.79,521.43L552.99,521.75L553,522.8L553.82,524.7L555.99,525.16L557.78,526.52L553.81,528.74L551.29,531L550.36,533.03L549.52,534.18L547.99,534.43L547.5,535.9L547.21,536.86L545.42,537.58L543.14,537.43L541.8,536.57L540.62,536.19L539.25,536.91L538.56,538.39L537.23,539.32L535.83,540.71L533.82,541.03L533.2,539.94L533.46,538.04L531.79,535.11L531.04,534.65L531.04,525.79L533.8,525.68L533.88,515.11L535.97,515.02L540.29,513.99L541.37,515.2L543.15,514.05L544.01,514.04L545.59,513.38L546.09,513.6z"
          }, {
            "id": "BY",
            "title": "Belarus",
            "d": "M541.1,284.07L543.81,284.11L546.85,282.31L547.5,279.59L549.8,278.02L549.54,275.82L551.24,274.98L554.26,273.05L557.21,274.31L557.61,275.54L559.08,274.95L561.82,276.13L562.09,278.44L561.49,279.76L563.25,282.91L564.39,283.78L564.22,284.64L566.11,285.47L566.92,286.72L565.83,287.74L563.57,287.58L563.03,288.02L563.69,289.56L564.38,292.49L561.97,292.76L561.11,293.76L560.92,296.02L559.81,295.59L557.28,295.81L556.54,294.76L555.49,295.54L554.44,294.89L552.23,294.8L549.1,293.72L546.27,293.36L544.1,293.46L542.56,294.69L541.22,294.86L541.17,292.85L540.3,290.73L541.98,289.79L542,287.94L541.22,286.16z"
          }, {
            "id": "BZ",
            "title": "Belize",
            "d": "M225.31,412.96L225.29,412.53L225.63,412.39L226.14,412.74L227.14,410.97L227.67,410.93L227.68,411.36L228.21,411.37L228.17,412.17L227.71,413.44L227.96,413.89L227.67,414.94L227.84,415.21L227.52,416.68L226.97,417.46L226.46,417.55L225.9,418.55L225.07,418.55L225.29,415.27z"
          }, {
            "id": "CA",
            "title": "Canada",
            "d": "M198.93,96.23l-0.22,-5.9l3.63,0.58l1.63,0.96l3.35,4.92l-0.76,4.97l-4.15,2.77l-2.28,-3.12L198.93,96.23zM212.14,108.88l0.33,-1.49l-1.97,-2.45l-5.65,-0.19l0.75,3.68l5.25,0.83L212.14,108.88zM248.49,155.83l3.08,5.1l0.81,0.57l3.07,-1.27l3.02,0.2l2.98,0.28l-0.25,-2.64l-4.84,-5.38l-6.42,-1.08l-1.35,0.67L248.49,155.83zM183.06,93.13l-2.71,4.19l6.24,0.52l4.61,4.44l4.58,1.5l-1.09,-5.68l-2.14,-6.73l-7.58,-5.35l-5.5,-2.04l0.2,5.69L183.06,93.13zM208.96,82.89l5.13,-0.12l-2.22,4l-0.04,5.3l3.01,5.76l5.81,1.77l4.96,-0.99l5.18,-10.73l3.85,-4.45l-3.38,-4.97l-2.21,-10.65l-4.6,-3.19l-4.72,-3.68l-3.58,-9.56l-6.52,0.94l1.23,4.15l-2.87,1.25l-1.94,5.32l-1.94,7.46l1.78,7.26L208.96,82.89zM145.21,136.27l3.92,1.95l12.67,-1.3l-5.82,4.77l0.36,3.43l4.26,-0.24l7.07,-4.58l9.5,-1.67l1.71,-5.22l-0.49,-5.57l-2.94,-0.5l-2.5,1.93l-1.1,-4.13l-0.95,-5.7l-2.9,-1.42l-2.57,4.41l4.01,11.05l-4.9,-0.85l-4.98,-6.79l-7.89,-4l-2.64,3.32L145.21,136.27zM167.77,94.21l-3.65,-2.9l-1.5,-0.66l-2.88,4.28l-0.05,2l4.66,0.01L167.77,94.21zM166.31,106.56l0.93,-3.99l-3.95,-2.12l-4.09,1.39l-2.27,4.26l4.16,4.21L166.31,106.56zM195.4,139.8l4.62,-1.11l1.28,-8.25l-0.09,-5.95l-2.14,-5.56l-0.22,1.6l-3.94,-0.7l-4.22,4.09l-3.02,-0.37l0.18,8.92l4.6,-0.87l-0.06,6.47L195.4,139.8zM192.12,185.41l-5.06,-3.93l-4.71,-4.21l-0.87,-6.18l-1.76,-8.92l-3.14,-3.84l-2.79,-1.55l-2.47,1.42l1.99,9.59l-1.41,3.73l-2.29,-8.98l-2.56,-3.11l-3.17,4.81l-3.9,-4.76l-6.24,2.87l1.4,-4.46l-2.87,-1.87l-7.51,5.84l-1.95,3.71l-2.35,6.77l4.9,2.32l4.33,-0.12l-6.5,3.46l1.48,3.13l3.98,0.17l5.99,-0.67l5.42,1.96l-3.66,1.44l-3.95,-0.37l-4.33,1.41l-1.87,0.87l3.45,6.35l2.49,-0.88l3.83,2.15l1.52,3.65l4.99,-0.73l7.1,-1.16l5.26,-2.65l3.26,-0.48l4.82,2.12l5.07,1.22l0.94,-2.86l-1.79,-3.05l4.6,-0.64L192.12,185.41zM199.86,184.43l-1.96,3.54l-2.47,2.49l3.83,3.54l2.28,-0.85l3.78,2.36l1.74,-2.73l-1.71,-3.03l-0.84,-1.53l-1.68,-1.46L199.86,184.43zM182.25,154.98l-2.13,-2.17l-3.76,0.4l-0.95,1.38l4.37,6.75L182.25,154.98zM210.94,168.15l3.01,-6.93l3.34,-1.85l4.19,-8.74l-5.36,-2.47l-5.84,-0.36l-2.78,2.77l-1.47,4.23l-0.04,4.82l1.75,8.19L210.94,168.15zM228.09,145.15l5.76,-0.18l8.04,-1.61l3.59,1.28l4.18,-2.26l1.75,-2.84l-0.63,-4.52l-3,-4.23l-4.56,-0.8l-5.71,0.97l-4.46,2.44l-4.09,-0.94l-3.78,-0.5l-1.78,-2.7l-3.22,-2.61l0.64,-4.43l-2.42,-3.98l-5.52,0.03l-3.11,-3.99l-5.78,-0.8l-1.06,5.1l3.25,3.74l5.8,1.45l2.81,5.09l0.34,5.6l0.97,5.99l7.45,3.42L228.09,145.15zM139.07,126.88l5.21,-5.05l2.62,-0.59l2.16,-4.23l0.38,-9.77l-3.85,1.91l-4.3,-0.18l-5.76,8.19l-4.76,8.98l3.8,2.51L139.07,126.88zM211.25,143.05l1.53,-4.14l-1.02,-3.46l-2.45,-3.92l-4.03,3.02l-1.49,4.92l3.4,2.79L211.25,143.05zM202.94,154.49l-0.73,-2.88l-5,1.26l-3.34,-2.11l-3.32,4.8l3.09,6.28l-5.72,-1.17l-0.06,3.01l6.97,7.05l1.94,3.38l2.7,0.73l4.6,-3.41l0.5,-8.21l-4.24,-4.07L202.94,154.49zM128.95,308.23l-1.16,-2.34l-2.8,-1.77l-1.39,-2.05l-0.95,-1.5l-2.64,-0.46l-1.72,-0.67l-2.94,-0.96l-0.24,1.02l1.08,2.38l2.89,0.78l0.5,1.23l2.51,1.5l0.84,1.51l4.6,1.92L128.95,308.23zM250.65,230.6l-2,-2.11l-2.06,0.5l-0.25,-3.06l-3.21,-2.04l-3.07,-2.27l-1.63,-1.75l-1.43,1.03l-0.52,-2.96l-2.03,-0.55l-0.96,6.13l-0.36,5.11l-2.44,3.14l3.8,-0.6l0.96,3.65l3.99,-3.23l2.78,-3.38l1.57,2.86l4.36,1.51L250.65,230.6zM130.12,178.05l7.38,-4.18V170l3.48,-6.41l6.88,-6.69l3.52,-2.47l-3.01,-4.2l-2.72,-2.95l-7.16,-0.57l-4,-2.16l-9.48,1.63l2.74,6.23l-2.43,6.43l-1.94,6.87l-1.2,3.86l6.47,4.69L130.12,178.05zM264.36,205.36l0.32,-1.01l-0.03,-3.17l-2.19,-2.08l-2.57,1.05l-1.19,4.17l0.7,3.56l3.14,-0.36L264.36,205.36zM288.18,212.9l4.41,6.6l3.45,2.85l4.92,-7.87l0.87,-4.93l-4.41,-0.47l-4.03,-6.7l-4.45,-1.64l-6.6,-4.97l5.15,-3.63l-2.65,-7.54l-2.44,-3.35l-6.77,-3.35l-2.92,-5.55l-5.21,1.99l-0.36,-3.86l-3.86,-4.32l-6.22,-4.71l-2.65,3.71l-5.55,2.66l0.42,-6.06l-4.81,-10.05l-7.11,4.06l-2.59,7.7l-2.21,-5.92l2.06,-6.37l-7.24,2.65l-2.88,3.99l-2.15,8.42l0.89,9.05l3.98,0.04l-2.93,3.92l2.33,2.96l4.55,1.25l5.93,2.42l10.2,1.82l5.08,-1.04l1.5,-2.42l2.21,2.79l2.47,0.46l2.97,4.96l-1.8,1.98l5.68,2.63l4.29,3.68l1.08,2.55l0.77,3.24l-3.63,6.93l-0.98,3.44l0.94,2.42l-5.77,0.86l-5.27,0.12l-1.85,4.87l2.37,2.23l8.11,-1.03l-0.04,-1.89l4.08,3.15l4.18,3.28l-0.98,1.77l3.4,3.02l6.02,3.53l7.6,2.39l-0.46,-2.09l-2.92,-3.67l-3.96,-5.37l7.03,5l3.54,1.66l0.97,-4.44l-1.82,-6.3l-1.16,-1.73l-3.81,-3.03l-2.95,-3.91l0.35,-3.94L288.18,212.9zM222.35,51.34l2.34,7.29l4.96,5.88l9.81,-1.09l6.31,1.97l-4.38,6.05l-2.21,-1.78l-7.66,-0.71l1.19,8.31l3.96,6.04l-0.8,5.2l-4.97,3.46l-2.27,5.47l4.55,2.65l3.82,8.55l-7.5,-5.7l-1.71,0.94l1.38,9.38l-5.18,2.83l0.35,5.85l5.3,0.63l4.17,1.44l8.24,-1.84l7.33,3.27l7.49,-7.19l-0.06,-3.02l-4.79,0.48l-0.39,-2.84l3.92,-3.83l1.33,-5.15l4.33,-3.83l2.66,-4.76l-2.32,-7.1l1.94,-2.65l-3.86,-1.89l8.49,-1.63l1.79,-3.15l5.78,-2.6l4.8,-13.47l4.57,-4.94l6.62,-11.12l-6.1,0.1l2.54,-4.3l6.78,-3.99l6.84,-8.9l0.12,-5.73l-5.13,-6.04l-6.02,-2.93l-7.49,-1.82l-6.07,-1.49l-6.07,-1.5l-8.1,3.98l-1.49,-2.53l-8.57,0.98l-5.03,2.57l-3.7,3.65l-2.13,11.74L239,24.52l-3.48,-1.14l-4.12,7.97l-5.5,3.35l-3.27,0.66l-4.17,3.84l0.61,6.65L222.35,51.34zM296.75,316.34l-0.98,-1.98l-1.06,1.26l0.7,1.36l3.56,1.71l1.04,-0.26l1.38,-1.66l-2.6,0.11L296.75,316.34zM239.75,238.48l0.61,1.63l1.98,0.14l3.28,-3.34l0.06,-1.19l-3.85,-0.06L239.75,238.48zM301.88,304.92l-2.87,-1.8l-3.69,-1.09l-0.97,0.37l2.61,2.04l3.63,1.34l1.36,-0.08L301.88,304.92zM326.76,309.71l-0.36,-2.24l-1.96,0.72l0.87,-3.11l-2.8,-1.32l-1.29,1.05l-2.49,-1.18l0.98,-1.51l-1.88,-0.93l-1.83,1.47l1.86,-3.82l1.5,-2.8l0.54,-1.22l-1.3,-0.2l-2.43,1.55l-1.74,2.53l-2.9,6.92l-2.35,2.56l1.22,1.14l-1.75,1.47l0.43,1.23l5.44,0.13l3.01,-0.25l2.69,1.01l-1.98,1.93l1.67,0.14l3.25,-3.58l0.78,0.53l-0.61,3.37l1.84,0.77l1.27,-0.15l1.18,-3.61L326.76,309.71zM305.57,314.47l-2.81,4.56l-4.63,0.58l-3.64,-2.01l-0.92,-3.07l-0.89,-4.46l2.65,-2.83l-2.48,-2.09l-4.19,0.43l-5.88,3.53l-4.5,5.45l-2.38,0.67l3.23,-3.8l4.04,-5.57l3.57,-1.9l2.35,-3.11l2.9,-0.3l4.21,0.03l6,0.92l4.74,-0.71l3.53,-3.62l4.62,-1.59l2.01,-1.58l2.04,-1.71l-0.2,-5.19l-1.13,-1.77l-2.18,-0.63l-1.11,-4.05l-1.8,-1.55l-4.47,-1.26l-2.52,-2.82l-3.73,-2.83l1.13,-3.2l-3.1,-6.26l-3.65,-6.89l-2.18,-4.98l-1.86,2.61l-2.68,6.05l-4.06,2.97l-2.03,-3.16l-2.56,-0.85l-0.93,-6.99l0.08,-4.8l-5,-0.44l-0.85,-2.27l-3.45,-3.44l-2.61,-2.04l-2.32,1.58l-2.88,-0.58l-4.81,-1.65l-1.95,1.4l0.94,9.18l1.22,5.12l-3.31,5.75l3.41,4.02l1.9,4.44l0.23,3.42l-1.55,3.5l-3.18,3.46l-4.49,2.28l1.98,2.53l1.46,7.4l-1.52,4.68l-2.16,1.46l-4.17,-4.28l-2.03,-5.17l-0.87,-4.76l0.46,-4.19l-3.05,-0.47l-4.63,-0.28l-2.97,-2.08l-3.51,-1.37l-2.01,-2.38l-2.8,-1.94l-5.21,-2.23l-3.92,1.02l-1.31,-3.95l-1.26,-4.99l-4.12,-0.9l0.15,-6.41l1.09,-4.48l3.04,-6.6l3.43,-4.9l3.26,-0.77l0.19,-4.05l2.21,-2.68l4.01,-0.42l3.25,-4.39l0.82,-2.9l2.7,-5.73l0.84,-3.5l2.9,2.11l3.9,-1.08l5.49,-4.96l0.36,-3.54l-1.98,-3.98l2.09,-4.06l-0.17,-3.87l-3.76,-3.95l-4.14,-1.19l-3.98,-0.62l-0.15,8.71l-2.04,6.56l-2.93,5.3l-2.71,-4.95l0.84,-5.61l-3.35,-5.02l-3.75,6.09l0.01,-7.99l-5.21,-1.63l2.49,-4.01l-3.81,-9.59l-2.84,-3.91l-3.7,-1.44l-3.32,6.43l-0.22,9.34l3.27,3.29l3,4.91l-1.27,7.71l-2.26,-0.2l-1.78,5.88l0.02,-7l-4.34,-2.58l-2.49,1.33l0.32,4.67l-4.09,-0.18l-4.35,1.17l-4.95,-3.35l-3.13,0.6l-2.82,-4.11l-2.26,-1.84l-2.24,0.77l-3.41,0.35l-1.81,2.61l2.86,3.19l-3.05,3.72l-2.99,-4.42l-2.39,1.3l-7.57,0.87l-5.07,-1.59l3.94,-3.74l-3.78,-3.9l-2.75,0.5l-3.86,-1.32l-6.56,-2.89l-4.29,-3.37l-3.4,-0.47l-1.06,2.36l-3.44,1.31l-0.38,-6.15l-3.73,5.5l-4.74,-7.32l-1.94,-0.89l-0.63,3.91l-2.09,1.9l-1.93,-3.39l-4.59,2.05l-4.2,3.55l-4.17,-0.98l-3.4,2.5l-2.46,3.28l-2.92,-0.72l-4.41,-3.8l-5.23,-1.94l-0.02,27.65l-0.01,35.43l2.76,0.17l2.73,1.56l1.96,2.44l2.49,3.6l2.73,-3.05l2.81,-1.79l1.49,2.85l1.89,2.23l2.57,2.42l1.75,3.79l2.87,5.88l4.77,3.2l0.08,3.12l-1.56,2.35l0.06,2.48l3.39,3.45l0.49,3.76l3.59,1.96l-0.4,2.79l1.56,3.96l5.08,1.82l2,1.89l5.43,4.23l0.38,0.01h7.96h8.32h2.76h8.55h8.27h8.41l8.42,0l9.53,0l9.59,0l5.8,0l0.01,-1.64l0.95,-0.02l0.5,2.35l0.87,0.72l1.96,0.26l2.86,0.67l2.72,1.3l2.27,-0.55l3.45,1.09l1.14,-1.66l1.59,-0.66l0.62,-1.03l0.63,-0.55l2.61,0.86l1.93,0.1l0.67,0.57l0.94,2.38l3.15,0.63l-0.49,1.18l1.11,1.21l-0.48,1.56l1.18,0.51l-0.59,1.37l0.75,0.13l0.53,-0.6l0.55,0.9l2.1,0.5l2.13,0.04l2.27,0.41l2.51,0.78l0.91,1.26l1.82,3.04l-0.9,1.3l-2.28,-0.54l-1.42,-2.44l0.36,2.49l-1.34,2.17l0.15,1.84l-0.23,1.07l-1.81,1.27l-1.32,2.09l-0.62,1.32l1.54,0.24l2.08,-1.2l1.23,-1.06l0.83,-0.17l1.54,0.38l0.75,-0.59l1.37,-0.48l2.44,-0.47v0l0,0l-0.25,-1.15l-0.13,0.04l-0.86,0.2l-1.12,-0.36l0.84,-1.32l0.85,-0.46l1.98,-0.56l2.37,-0.53l1.24,0.73l0.78,-0.85l0.89,-0.54l0.6,0.29l0.03,0.06l2.87,-2.73l1.27,-0.73l4.26,-0.03l5.17,0l0.28,-0.98l0.9,-0.2l1.19,-0.62l1,-1.82l0.86,-3.15l2.14,-3.1l0.93,1.08l1.88,-0.7l1.25,1.19l0,5.52l1.83,2.25l3.12,-0.48l4.49,-0.13l-4.87,3.26l0.11,3.29l2.13,0.28l3.13,-2.79l2.78,-1.58l6.21,-2.35l3.47,-2.62l-1.81,-1.46L305.57,314.47zM251.91,243.37l1.1,-3.12l-0.71,-1.23l-1.15,-0.13l-1.08,1.8l-0.13,0.41l0.74,1.77L251.91,243.37zM109.25,279.8L109.25,279.8l1.56,-2.35L109.25,279.8zM105.85,283.09l-2.69,0.38l-1.32,-0.62l-0.17,1.52l0.52,2.07l1.42,1.46l1.04,2.13l1.69,2.1l1.12,0.01l-2.44,-3.7L105.85,283.09z"
          }, {
            "id": "CD",
            "title": "Democratic Republic of Congo",
            "d": "M561.71,453.61L561.54,456.87L562.66,457.24L561.76,458.23L560.68,458.97L559.61,460.43L559.02,461.72L558.86,463.96L558.21,465.02L558.19,467.12L557.38,467.9L557.28,469.56L556.89,469.77L556.63,471.3L557.34,472.56L557.52,475.93L558.02,478.5L557.74,479.96L558.3,481.58L559.93,483.15L561.44,486.7L560.34,486.41L556.57,486.89L555.82,487.22L555.02,489.02L555.65,490.27L555.15,493.62L554.8,496.47L555.56,496.98L557.52,498.08L558.29,497.57L558.53,500.65L556.38,500.62L555.23,499.05L554.2,497.83L552.05,497.43L551.42,495.94L549.7,496.84L547.46,496.44L546.52,495.15L544.74,494.89L543.43,494.96L543.27,494.08L542.3,494.01L541.02,493.84L539.29,494.26L538.07,494.19L537.37,494.45L537.52,491.08L536.59,490.03L536.38,488.3L536.79,486.6L536.23,485.51L536.18,483.75L532.77,483.77L533.02,482.76L531.59,482.77L531.44,483.26L529.7,483.37L528.99,485L528.57,485.71L527.02,485.31L526.1,485.71L524.24,485.93L523.17,484.46L522.53,483.55L521.72,481.87L521.03,479.78L512.76,479.75L511.77,480.08L510.96,480.03L509.8,480.41L509.41,479.54L510.12,479.24L510.21,478.02L510.67,477.3L511.69,476.72L512.43,477L513.39,475.93L514.91,475.96L515.09,476.75L516.14,477.25L517.79,475.49L519.42,474.13L520.13,473.24L520.04,470.94L521.26,468.23L522.54,466.8L524.39,465.46L524.71,464.57L524.78,463.55L525.24,462.58L525.09,461L525.44,458.53L525.99,456.79L526.83,455.3L526.99,453.62L527.24,451.67L528.34,450.25L529.84,449.35L532.15,450.3L533.93,451.33L535.98,451.61L538.07,452.15L538.91,450.47L539.3,450.25L540.57,450.53L543.7,449.14L544.8,449.73L545.71,449.65L546.13,448.97L547.17,448.73L549.28,449.02L551.08,449.08L552.01,448.79L553.7,451.1L554.96,451.43L555.71,450.96L557.01,451.15L558.57,450.56L559.24,451.75z"
          }, {
            "id": "CF",
            "title": "Central African Republic",
            "d": "M518.09,442.66L520.41,442.44L520.93,441.72L521.39,441.78L522.09,442.41L525.62,441.34L526.81,440.24L528.28,439.25L528,438.26L528.79,438L531.5,438.18L534.14,436.87L536.16,433.78L537.59,432.64L539.36,432.15L539.68,433.37L541.3,435.14L541.3,436.29L540.85,437.47L541.03,438.34L542,439.15L544.14,440.39L545.67,441.52L545.7,442.44L547.58,443.9L548.75,445.11L549.46,446.79L551.56,447.9L552.01,448.79L551.08,449.08L549.28,449.02L547.17,448.73L546.13,448.97L545.71,449.65L544.8,449.73L543.7,449.14L540.57,450.53L539.3,450.25L538.91,450.47L538.07,452.15L535.98,451.61L533.93,451.33L532.15,450.3L529.84,449.35L528.34,450.25L527.24,451.67L526.99,453.62L525.19,453.46L523.29,452.99L521.62,454.47L520.15,457.07L519.85,456.26L519.73,454.99L518.45,454.09L517.41,452.65L517.17,451.65L515.85,450.19L516.07,449.36L515.79,448.18L516.01,446.01L516.68,445.5z"
          }, {
            "id": "CG",
            "title": "Republic of Congo",
            "d": "M511.69,476.72L510.64,475.76L509.79,476.23L508.66,477.43L506.36,474.48L508.49,472.94L507.44,471.09L508.4,470.39L510.29,470.05L510.51,468.81L512.01,470.15L514.49,470.27L515.35,468.95L515.7,467.1L515.39,464.92L514.07,463.28L515.28,460.05L514.58,459.5L512.5,459.72L511.71,458.29L511.92,457.07L515.45,457.18L517.72,457.91L519.95,458.57L520.15,457.07L521.62,454.47L523.29,452.99L525.19,453.46L526.99,453.62L526.83,455.3L525.99,456.79L525.44,458.53L525.09,461L525.24,462.58L524.78,463.55L524.71,464.57L524.39,465.46L522.54,466.8L521.26,468.23L520.04,470.94L520.13,473.24L519.42,474.13L517.79,475.49L516.14,477.25L515.09,476.75L514.91,475.96L513.39,475.93L512.43,477z"
          }, {
            "id": "CH",
            "title": "Switzerland",
            "d": "M502.15,312.34L502.26,313.08L501.83,314.09L503.1,314.83L504.53,314.94L504.31,316.61L503.08,317.3L501,316.79L500.39,318.42L499.06,318.55L498.57,317.91L497,319.27L495.65,319.46L494.44,318.6L493.48,316.83L492.14,317.47L492.18,315.63L494.23,313.32L494.14,312.27L495.42,312.66L496.19,311.95L498.57,311.98L499.15,311.08z"
          }, {
            "id": "CI",
            "title": "Côte d'Ivoire",
            "d": "M467.24,449.46L465.97,449.49L464.01,448.94L462.22,448.97L458.89,449.46L456.95,450.27L454.17,451.29L453.63,451.22L453.84,448.92L454.11,448.57L454.03,447.46L452.84,446.29L451.95,446.1L451.13,445.33L451.74,444.09L451.46,442.73L451.59,441.91L452.04,441.91L452.2,440.68L451.98,440.14L452.25,439.75L453.29,439.41L452.6,437.15L451.95,435.99L452.18,435.02L452.74,434.81L453.1,434.55L453.88,434.97L456.04,435L456.56,434.17L457.04,434.23L457.85,433.91L458.29,435.12L458.94,434.76L460.1,434.34L461.36,434.96L461.85,435.89L463.11,436.49L464.09,435.78L465.41,435.67L467.33,436.4L468.07,440.41L466.89,442.77L466.16,445.94L467.37,448.35z"
          }, {
            "id": "CL",
            "title": "Chile",
            "d": "M282.81,636.73l0,10.57l3,0l1.69,0.13l-0.93,1.98l-2.4,1.53l-1.38,-0.16l-1.66,-0.4l-2.04,-1.48l-2.94,-0.71l-3.53,-2.71l-2.86,-2.57l-3.86,-5.25l2.31,0.97l3.94,3.13l3.72,1.7l1.45,-2.17l0.91,-3.2l2.58,-1.91L282.81,636.73zM283.97,524.72l1.1,4.15l2.02,-0.41l0.34,0.76l-0.96,3.16l-3.05,1.51l0.09,5.14l-0.59,1l0.84,1.23l-1.98,1.95l-1.84,2.96l-1,2.9l0.27,3.11l-1.73,3.34l1.29,5.69l0.73,0.61l-0.01,3.09l-1.6,3.31l0.06,2.87l-2.12,2.26l0.01,3.22l0.85,3.46l-1.68,1.3l-0.75,3.22l-0.66,3.75l0.47,4.54l-1.13,0.77l0.65,4.4l1.27,1.46l-0.92,1.63l1.3,0.78l0.3,1.48l-1.22,0.75l0.3,2.33l-1.02,5.35l-1.49,3.52l0.33,2.11l-0.89,2.68l-2.15,1.88l0.25,4.6l0.99,1.6l1.87,-0.28l-0.05,3.33l1.16,2.63l6.78,0.61l2.6,0.71l-2.49,-0.03l-1.35,1.13l-2.53,1.67l-0.45,4.38l-1.19,0.11l-3.16,-1.54l-3.21,-3.25l0,0l-3.49,-2.63l-0.88,-2.87l0.79,-2.62l-1.41,-2.94l-0.36,-7.34l1.19,-4.03l2.96,-3.19l-4.26,-1.19l2.67,-3.57l0.95,-6.56l3.12,1.37l1.46,-7.97l-1.88,-1l-0.88,4.75l-1.77,-0.54l0.88,-5.42l0.96,-6.84l1.29,-2.48l-0.81,-3.5l-0.23,-3.98l1.18,-0.11l1.72,-5.6l1.94,-5.43l1.19,-4.97l-0.65,-4.91l0.84,-2.67l-0.34,-3.96l1.64,-3.87l0.51,-6.04l0.9,-6.37l0.88,-6.75l-0.21,-4.87l-0.58,-4.15l1.44,-0.75l0.75,-1.5l1.37,1.99l0.37,2.12l1.47,1.25l-0.88,2.87L283.97,524.72z"
          }, {
            "id": "CM",
            "title": "Cameroon",
            "d": "M511.92,457.07L511.57,456.92L509.91,457.28L508.2,456.9L506.87,457.09L502.31,457.02L502.72,454.82L501.62,452.98L500.34,452.5L499.77,451.25L499.05,450.85L499.09,450.08L499.81,448.1L501.14,445.4L501.95,445.37L503.62,443.73L504.69,443.69L506.26,444.84L508.19,443.89L508.45,442.73L509.08,441.59L509.51,440.17L511.01,439.01L511.58,437.04L512.17,436.41L512.57,434.94L513.31,433.13L515.67,430.93L515.82,429.98L516.13,429.47L515.02,428.33L515.11,427.43L515.9,427.26L517.01,429.09L517.2,430.98L517.1,432.87L518.62,435.44L517.06,435.41L516.27,435.61L514.99,435.33L514.38,436.66L516.03,438.31L517.25,438.79L517.65,439.96L518.53,441.89L518.09,442.66L516.68,445.5L516.01,446.01L515.79,448.18L516.07,449.36L515.85,450.19L517.17,451.65L517.41,452.65L518.45,454.09L519.73,454.99L519.85,456.26L520.15,457.07L519.95,458.57L517.72,457.91L515.45,457.18z"
          }, {
            "id": "CN",
            "title": "China",
            "d": "M784.63,410.41l-2.42,1.41l-2.3,-0.91l-0.08,-2.53l1.38,-1.34l3.06,-0.83l1.61,0.07l0.63,1.13l-1.23,1.3L784.63,410.41zM833.19,302.89l4.88,1.38l3.32,3.03l1.13,3.95l4.26,0l2.43,-1.65l4.63,-1.24l-1.47,3.76l-1.09,1.51l-0.96,4.46l-1.89,3.89l-3.4,-0.7l-2.41,1.4l0.74,3.36l-0.4,4.55l-1.43,0.1l0.02,1.93l-1.81,-2.24l-1.11,2.13l-4.33,1.62l0.44,1.97l-2.42,-0.14l-1.33,-1.17l-1.93,2.64l-3.09,1.98l-2.28,2.35l-3.92,1.06l-2.06,1.69l-3.02,0.98l1.49,-1.67l-0.59,-1.41l2.22,-2.45l-1.48,-1.93l-2.44,1.3l-3.17,2.54l-1.73,2.34l-2.75,0.17l-1.43,1.68l1.48,2.41l2.29,0.58l0.09,1.58l2.22,1.02l3.14,-2.51l2.49,1.37l1.81,0.09l0.46,1.84l-3.97,0.97l-1.31,1.87l-2.73,1.73l-1.44,2.39l3.02,1.86l1.1,3.31l1.71,3.05l1.9,2.53l-0.05,2.43l-1.76,0.89l0.67,1.73l1.65,1l-0.43,2.61l-0.71,2.52l-1.57,0.28l-2.05,3.41l-2.27,4.09l-2.6,3.68l-3.86,2.82l-3.9,2.55l-3.16,0.35l-1.71,1.34l-0.97,-0.98l-1.59,1.5l-3.92,1.5l-2.97,0.46l-0.96,3.15l-1.55,0.17l-0.74,-2.16l0.66,-1.16l-3.76,-0.96l-1.33,0.49l-2.82,-0.78l-1.33,-1.22l0.44,-1.74l-2.56,-0.55l-1.35,-1.14l-2.39,1.62l-2.73,0.35l-2.24,-0.02l-1.5,0.74l-1.45,0.44l0.42,3.43l-1.5,-0.08l-0.25,-0.7l-0.08,-1.24l-2.06,0.87l-1.21,-0.55l-2.08,-1.13l0.82,-2.51l-1.78,-0.59l-0.67,-2.8l-2.96,0.51l0.34,-3.63l2.66,-2.58l0.11,-2.57l-0.08,-2.4l-1.22,-0.75l-0.94,-1.86l-1.64,0.24l-3.02,-0.47l0.95,-1.33l-1.31,-1.99l-2,1.35L740.4,378l-3.23,2.03l-2.55,2.36l-2.26,0.39l-1.23,-0.85l-1.48,-0.08l-2,-0.73l-1.51,0.8l-1.85,2.34l-0.24,-2.48l-1.71,0.66l-3.27,-0.31l-3.17,-0.73l-2.28,-1.39l-2.18,-0.63l-0.94,-1.53l-1.58,-0.46l-2.83,-2.09l-2.25,-0.99l-1.16,0.77l-3.9,-2.26l-2.75,-2.07l-0.79,-3.63l2.01,0.44l0.09,-1.69l-1.12,-1.71l0.28,-2.74l-3.01,-3.99l-4.61,-1.39l-0.83,-2.66l-2.07,-1.63l-0.5,-1.01l-0.42,-2.01l0.1,-1.38l-1.7,-0.81l-0.92,0.36l-0.71,-3.32l0.8,-0.83l-0.39,-0.85l2.68,-1.73l1.94,-0.72l2.97,0.49l1.06,-2.35l3.6,-0.44l1,-1.48l4.42,-2.03l0.39,-0.85l-0.22,-2.17l1.92,-1l-2.52,-6.75l5.55,-1.58l1.44,-0.89l2.02,-7.26l5.56,1.35l1.56,-1.86l0.13,-4.19l2.33,-0.39l2.13,-2.83l1.1,-0.35l0.74,2.97l2.36,2.23l4,1.57l1.93,3.32l-1.08,4.73l1.01,1.73l3.33,0.68l3.78,0.55l3.39,2.45l1.73,0.43l1.28,3.57l1.65,2.27l3.09,-0.09l5.79,0.85l3.73,-0.53l2.77,0.57l4.15,2.29l3.39,0l1.24,1.16l3.26,-2.01l4.53,-1.31l4.2,-0.14l3.28,-1.34l2.01,-2.05l1.96,-1.3l-0.45,-1.28l-0.9,-1.5l1.47,-2.54l1.58,0.36l2.88,0.8l2.79,-2.1l4.28,-1.55l2.05,-2.66l1.97,-1.16l4.07,-0.54l2.21,0.46l0.31,-1.45l-2.54,-2.89l-2.25,-1.33l-2.16,1.54l-2.77,-0.65l-1.59,0.53l-0.72,-1.71l1.98,-4.23l1.37,-3.25l3.37,1.63l3.95,-2.74l-0.03,-1.93l2.53,-4.73l1.56,-1.45l-0.04,-2.52l-1.54,-1.1l2.32,-2.31l3.48,-0.84l3.72,-0.13l4.2,1.39l2.46,1.71l1.73,4.61l1.05,1.94l0.98,2.73L833.19,302.89z"
          }, {
            "id": "CO",
            "title": "Colombia",
            "d": "M263.92,463.81L262.72,463.15L261.34,462.23L260.54,462.67L258.16,462.28L257.48,461.08L256.96,461.13L254.15,459.54L253.77,458.67L254.82,458.46L254.7,457.07L255.35,456.06L256.74,455.87L257.93,454.12L259,452.66L257.96,451.99L258.49,450.37L257.86,447.81L258.46,447.08L258.02,444.71L256.88,443.21L257.24,441.85L258.15,442.05L258.68,441.21L258.03,439.56L258.37,439.14L259.81,439.23L261.92,437.26L263.07,436.96L263.1,436.03L263.62,433.64L265.23,432.32L266.99,432.27L267.21,431.68L269.41,431.91L271.62,430.48L272.71,429.84L274.06,428.47L275.06,428.64L275.79,429.39L275.25,430.35L273.45,430.83L272.74,432.25L271.65,433.06L270.84,434.12L270.49,436.13L269.72,437.79L271.16,437.97L271.52,439.27L272.14,439.89L272.36,441.02L272.03,442.06L272.13,442.65L272.82,442.88L273.49,443.86L277.09,443.59L278.72,443.95L280.7,446.36L281.83,446.06L283.85,446.21L285.45,445.89L286.44,446.38L285.93,447.88L285.31,448.82L285.09,450.83L285.65,452.68L286.45,453.51L286.54,454.14L285.12,455.53L286.14,456.14L286.89,457.12L287.74,459.89L287.21,460.24L286.67,458.59L285.89,457.71L284.96,458.67L279.5,458.61L279.53,460.35L281.17,460.64L281.08,461.71L280.52,461.42L278.94,461.88L278.93,463.9L280.17,464.92L280.61,466.51L280.54,467.72L279.28,475.37L277.88,473.88L277.04,473.82L278.85,470.98L276.7,469.67L275.02,469.91L274.01,469.43L272.46,470.17L270.37,469.82L268.72,466.9L267.42,466.18L266.53,464.86L264.67,463.54z"
          }, {
            "id": "CR",
            "title": "Costa Rica",
            "d": "M242.63,440.4L241.11,439.77L240.54,439.18L240.86,438.69L240.76,438.07L239.98,437.39L238.88,436.84L237.91,436.48L237.73,435.65L236.99,435.14L237.17,435.97L236.61,436.64L235.97,435.86L235.07,435.58L234.69,435.01L234.71,434.15L235.08,433.25L234.29,432.85L234.93,432.31L235.35,431.94L237.2,432.69L237.84,432.32L238.73,432.56L239.2,433.14L240.02,433.33L240.69,432.73L241.41,434.27L242.49,435.41L243.81,436.62L242.72,436.87L242.74,438L243.32,438.42L242.9,438.76L243.01,439.27L242.78,439.84z"
          }, {
            "id": "CU",
            "title": "Cuba",
            "d": "M244.58,396.94L247.01,397.16L249.21,397.19L251.84,398.22L252.96,399.33L255.58,398.99L256.57,399.69L258.95,401.56L260.69,402.91L261.61,402.87L263.29,403.48L263.08,404.32L265.15,404.44L267.27,405.66L266.94,406.35L265.07,406.73L263.18,406.88L261.25,406.64L257.24,406.93L259.12,405.27L257.98,404.5L256.17,404.3L255.2,403.44L254.53,401.74L252.95,401.85L250.33,401.05L249.49,400.42L245.84,399.95L244.86,399.36L245.91,398.61L243.16,398.46L241.15,400.02L239.98,400.06L239.58,400.8L238.2,401.13L237,400.84L238.48,399.91L239.08,398.82L240.35,398.15L241.78,397.56L243.91,397.27z"
          }, {
            "id": "CY",
            "title": "Cyprus",
            "d": "M570.31,358.29L572.2,356.83L569.65,357.85L567.63,357.8L567.23,358.63L567.03,358.65L565.7,358.77L566.35,360.14L567.72,360.58L570.6,359.2L570.51,358.93z"
          }, {
            "id": "CZ",
            "title": "Czech Republic",
            "d": "M522.81,307.86L521.51,307.06L520.2,307.28L518.02,305.98L517.03,306.3L515.46,308.04L513.37,306.67L511.79,304.84L510.36,303.8L510.06,301.98L509.57,300.68L511.61,299.73L512.65,298.63L514.66,297.77L515.37,296.93L516.11,297.44L517.36,296.97L518.69,298.4L520.78,298.79L520.61,300L522.13,300.9L522.55,299.77L524.47,300.26L524.74,301.63L526.82,301.89L528.11,304.02L527.28,304.03L526.84,304.8L526.2,304.99L526.02,305.96L525.48,306.17L525.4,306.56L524.45,307L523.2,306.93z"
          }, {
            "id": "DE",
            "title": "Germany",
            "d": "M503.07,278.92L503.12,280.8L505.96,281.92L505.93,283.62L508.78,282.72L510.35,281.41L513.52,283.3L514.84,284.81L515.5,287.2L514.72,288.45L515.73,290.1L516.43,292.55L516.21,294.11L517.36,296.97L516.11,297.44L515.37,296.93L514.66,297.77L512.65,298.63L511.61,299.73L509.57,300.68L510.06,301.98L510.36,303.8L511.79,304.84L513.37,306.67L512.39,308.62L511.38,309.16L511.78,311.88L511.51,312.58L510.64,311.73L509.3,311.61L507.29,312.35L504.82,312.17L504.42,313.26L503,312.12L502.15,312.34L499.15,311.08L498.57,311.98L496.19,311.95L496.54,308.97L497.96,306.07L493.92,305.29L492.6,304.16L492.76,302.27L492.2,301.29L492.52,298.32L492.04,293.63L493.73,293.63L494.44,291.92L495.14,287.69L494.61,286.11L495.16,285.11L497.5,284.85L498.02,285.89L499.93,283.56L499.29,281.77L499.16,279.02L501.28,279.66z"
          }, {
            "id": "DJ",
            "title": "Djibouti",
            "d": "M596.05,427.72L596.71,428.6L596.62,429.79L595.02,430.47L596.23,431.24L595.19,432.76L594.57,432.26L593.9,432.46L592.33,432.41L592.28,431.55L592.07,430.76L593.01,429.43L594,428.17L595.2,428.42z"
          }, {
            "id": "DK",
            "title": "Denmark",
            "d": "M510.83,275.84l-1.68,3.97l-2.93,-2.76l-0.39,-2.05l4.11,-1.66L510.83,275.84zM505.85,271.59l-0.69,1.9l-0.83,-0.55l-2.02,3.59l0.76,2.39l-1.79,0.74l-2.12,-0.64l-1.14,-2.72l-0.08,-5.12l0.47,-1.38l0.8,-1.54l2.47,-0.32l0.98,-1.43l2.26,-1.47l-0.1,2.68l-0.83,1.68l0.34,1.43L505.85,271.59z"
          }, {
            "id": "DO",
            "title": "Dominican Republic",
            "d": "M274.18,407.35L274.53,406.84L276.72,406.86L278.38,407.62L279.12,407.54L279.63,408.59L281.16,408.53L281.07,409.41L282.32,409.52L283.7,410.6L282.66,411.8L281.32,411.16L280.04,411.28L279.12,411.14L278.61,411.68L277.53,411.86L277.11,411.14L276.18,411.57L275.06,413.57L274.34,413.11L274.19,412.27L274.25,411.47L273.53,410.59L274.21,410.09L274.43,408.96z"
          }, {
            "id": "DZ",
            "title": "Algeria",
            "d": "M508.9,396.08L499.29,401.83L491.17,407.68L487.22,409L484.11,409.29L484.08,407.41L482.78,406.93L481.03,406.08L480.37,404.69L470.91,398.14L461.45,391.49L450.9,383.96L450.96,383.35L450.96,383.14L450.93,379.39L455.46,377.03L458.26,376.54L460.55,375.68L461.63,374.06L464.91,372.77L465.03,370.36L466.65,370.07L467.92,368.86L471.59,368.3L472.1,367.02L471.36,366.31L470.39,362.78L470.23,360.73L469.17,358.55L471.86,356.68L474.9,356.08L476.67,354.65L479.37,353.6L484.12,352.98L488.76,352.69L490.17,353.21L492.81,351.84L495.81,351.81L496.95,352.62L498.86,352.41L498.29,354.2L498.74,357.48L498.08,360.3L496.35,362.18L496.6,364.71L498.89,366.69L498.92,367.5L500.64,368.83L501.84,374.69L502.75,377.53L502.9,379.01L502.41,381.6L502.61,383.04L502.25,384.76L502.5,386.73L501.38,388.02L503.04,390.28L503.15,391.6L504.14,393.31L505.45,392.75L507.67,394.17z"
          }, {
            "id": "EC",
            "title": "Ecuador",
            "d": "M250.1,472.87L251.59,470.79L250.98,469.57L249.91,470.87L248.23,469.64L248.8,468.86L248.33,466.33L249.31,465.91L249.83,464.18L250.89,462.38L250.69,461.25L252.23,460.65L254.15,459.54L256.96,461.13L257.48,461.08L258.16,462.28L260.54,462.67L261.34,462.23L262.72,463.15L263.92,463.81L264.31,465.92L263.44,467.73L260.38,470.65L257.01,471.75L255.29,474.18L254.76,476.06L253.17,477.21L252,475.8L250.86,475.5L249.7,475.72L249.63,474.7L250.43,474.04z"
          }, {
            "id": "EE",
            "title": "Estonia",
            "d": "M543.42,264.71L543.75,261.59L542.72,262.26L540.94,260.36L540.69,257.25L544.24,255.72L547.77,254.91L550.81,255.83L553.71,255.66L554.13,256.62L552.14,259.76L552.97,264.72L551.77,266.38L549.45,266.37L547.04,264.43L545.81,263.78z"
          }, {
            "id": "EG",
            "title": "Egypt",
            "d": "M573.17,377.28L572.38,378.57L571.78,380.97L571.02,382.61L570.36,383.17L569.43,382.15L568.16,380.73L566.16,376.16L565.88,376.45L567.04,379.82L568.76,383L570.88,387.88L571.91,389.56L572.81,391.3L575.33,394.7L574.77,395.23L574.86,397.2L578.13,399.91L578.62,400.53L567.5,400.53L556.62,400.53L545.35,400.53L545.35,389.3L545.35,378.12L544.51,375.54L545.23,373.54L544.8,372.15L545.81,370.58L549.54,370.53L552.24,371.39L555.02,372.36L556.32,372.86L558.48,371.83L559.63,370.9L562.11,370.63L564.1,371.04L564.87,372.66L565.52,371.59L567.76,372.36L569.95,372.55L571.33,371.73z"
          }, {
            "id": "EH",
            "title": "Western Sahara",
            "d": "M438.57,383.06L442.19,383.07L450.94,383.1L450.94,383.1L450.94,383.1L442.19,383.07L438.57,383.06L438.46,383.15L438.41,383.19L436.63,386.39L434.77,387.53L433.75,389.44L433.69,391.09L432.94,392.88L432,393.37L430.44,395.31L429.48,397.46L429.66,398.48L428.74,400.05L427.66,400.87L427.53,402.26L427.41,403.53L428.02,402.53L439,402.55L438.47,398.2L439.16,396.65L441.78,396.38L441.69,388.52L450.9,388.69L450.9,383.96L450.96,383.35L450.96,383.14z"
          }, {
            "id": "ER",
            "title": "Eritrea",
            "d": "M594,428.17L593.04,427.24L591.89,425.57L590.65,424.65L589.92,423.65L587.48,422.5L585.56,422.47L584.88,421.86L583.24,422.54L581.54,421.23L580.66,423.38L577.4,422.78L577.1,421.63L578.31,417.38L578.58,415.45L579.46,414.55L581.53,414.07L582.95,412.4L584.58,415.78L585.35,418.45L586.89,419.86L590.71,422.58L592.27,424.22L593.79,425.88L594.67,426.86L596.05,427.72L595.2,428.42z"
          }, {
            "id": "ES",
            "title": "Spain",
            "d": "M449.92,334.56L450.06,331.88L448.92,330.22L452.88,327.45L456.31,328.15L460.08,328.12L463.06,328.78L465.39,328.58L469.92,328.7L471.04,330.19L476.2,331.92L477.22,331.1L480.38,332.82L483.63,332.33L483.78,334.52L481.12,337.01L477.53,337.79L477.28,339.03L475.55,341.06L474.47,344.02L475.56,346.07L473.94,347.67L473.34,349.97L471.22,350.67L469.23,353.36L465.68,353.41L463,353.35L461.25,354.57L460.18,355.88L458.8,355.59L457.77,354.42L456.97,352.42L454.35,351.88L454.12,350.72L455.16,349.4L455.54,348.44L454.58,347.38L455.35,345.03L454.23,342.86L455.44,342.56L455.55,340.84L456.01,340.31L456.04,337.43L457.34,336.43L456.56,334.55L454.92,334.42L454.44,334.89L452.79,334.9L452.08,333.06L450.94,333.61z"
          }, {
            "id": "ET",
            "title": "Ethiopia",
            "d": "M581.54,421.23L583.24,422.54L584.88,421.86L585.56,422.47L587.48,422.5L589.92,423.65L590.65,424.65L591.89,425.57L593.04,427.24L594,428.17L593.01,429.43L592.07,430.76L592.28,431.55L592.33,432.41L593.9,432.46L594.57,432.26L595.19,432.76L594.58,433.77L595.62,435.33L596.65,436.69L597.72,437.7L606.89,441.04L609.25,441.02L601.32,449.44L597.67,449.56L595.17,451.53L593.38,451.58L592.61,452.46L590.69,452.46L589.56,451.52L587,452.69L586.17,453.85L584.3,453.63L583.68,453.31L583.02,453.38L582.14,453.36L578.59,450.98L576.64,450.98L575.68,450.07L575.68,448.5L574.22,448.03L572.57,444.98L571.29,444.33L570.79,443.21L569.37,441.84L567.65,441.64L568.61,440.03L570.09,439.96L570.51,439.1L570.48,436.57L571.31,433.61L572.63,432.81L572.92,431.65L574.12,429.48L575.81,428.06L576.95,425.25L577.4,422.78L580.66,423.38z"
          }, {
            "id": "FK",
            "title": "Falkland Islands",
            "d": "M303.66,633.13L307.02,630.44L309.41,631.56L311.09,629.77L313.33,631.78L312.49,633.36L308.7,634.72L307.44,633.13L305.06,635.18z"
          }, {
            "id": "FI",
            "title": "Finland",
            "d": "M555.42,193.1L555.01,198.5L559.31,203.49L556.72,208.97L559.98,216.93L558.09,222.69L560.62,227.55L559.47,231.69L563.62,235.95L562.56,239.05L559.96,242.5L553.96,249.91L548.87,250.36L543.94,252.43L539.38,253.61L537.75,250.54L535.04,248.67L535.66,242.95L534.3,237.54L535.64,233.96L538.18,230.02L544.59,223L546.47,221.61L546.17,218.77L542.27,215.55L541.33,212.85L541.25,201.73L536.88,196.58L533.14,192.77L534.82,190.69L537.94,194.84L541.6,194.45L544.61,196.32L547.28,192.88L548.66,187.03L553.01,184.25L556.61,187.51z"
          }, {
            "id": "FJ",
            "title": "Fiji",
            "d": "M980.53,508.61l-0.35,1.4l-0.23,0.16l-1.78,0.72l-1.79,0.61l-0.36,-1.09l1.4,-0.6l0.89,-0.16l1.64,-0.91L980.53,508.61zM974.69,512.92l-1.27,-0.36l-1.08,1l0.27,1.29l1.55,0.36l1.74,-0.4l0.46,-1.53l-0.96,-0.84L974.69,512.92z"
          }, {
            "id": "FR",
            "title": "France",
            "d": "M502.06,333.54l-0.93,2.89l-1.27,-0.76l-0.65,-2.53l0.57,-1.41l1.81,-1.45L502.06,333.54zM485.31,300.19l1.96,2.06l1.44,-0.34l2.45,1.97l0.63,0.37l0.81,-0.09l1.32,1.12l4.04,0.79l-1.42,2.9l-0.36,2.98l-0.77,0.71l-1.28,-0.38l0.09,1.05l-2.05,2.3l-0.04,1.84l1.34,-0.63l0.96,1.77l-0.12,1.13l0.83,1.5l-0.97,1.21l0.72,3.04l1.52,0.49l-0.32,1.68l-2.54,2.17l-5.53,-1.04l-4.08,1.24l-0.32,2.29l-3.25,0.49l-3.15,-1.72l-1.02,0.82l-5.16,-1.73l-1.12,-1.49l1.45,-2.32l0.53,-7.88l-2.89,-4.26l-2.07,-2.09l-4.29,-1.6l-0.28,-3.07l3.64,-0.92l4.71,1.09l-0.89,-4.84l2.65,1.85l6.53,-3.37l0.84,-3.61l2.45,-0.9l0.41,1.56l1.3,0.07L485.31,300.19z"
          }, {
            "id": "GA",
            "title": "Gabon",
            "d": "M506.36,474.48L503.48,471.66L501.62,469.36L499.92,466.48L500.01,465.56L500.62,464.66L501.3,462.64L501.87,460.57L502.82,460.41L506.89,460.44L506.87,457.09L508.2,456.9L509.91,457.28L511.57,456.92L511.92,457.07L511.71,458.29L512.5,459.72L514.58,459.5L515.28,460.05L514.07,463.28L515.39,464.92L515.7,467.1L515.35,468.95L514.49,470.27L512.01,470.15L510.51,468.81L510.29,470.05L508.4,470.39L507.44,471.09L508.49,472.94z"
          }, {
            "id": "GB",
            "title": "United Kingdom",
            "d": "M459.38,281l-1.5,3.29l-2.12,-0.98l-1.73,0.07l0.58,-2.57l-0.58,-2.6l2.35,-0.2L459.38,281zM466.83,260.24l-3,5.73l2.86,-0.72l3.07,0.03l-0.73,4.22l-2.52,4.53l2.9,0.32l0.22,0.52l2.5,5.79l1.92,0.77l1.73,5.41l0.8,1.84l3.4,0.88l-0.34,2.93l-1.43,1.33l1.12,2.33l-2.52,2.33l-3.75,-0.04l-4.77,1.21l-1.31,-0.87l-1.85,2.06l-2.59,-0.5l-1.97,1.67l-1.49,-0.87l4.11,-4.64l2.51,-0.97l-0.02,0l-4.38,-0.75l-0.79,-1.8l2.93,-1.41l-1.54,-2.48l0.53,-3.06l4.17,0.42l0,0l0.41,-2.74l-1.88,-2.95l-0.04,-0.07l-3.4,-0.85l-0.67,-1.32l1.02,-2.2l-0.92,-1.37l-1.51,2.34l-0.16,-4.8l-1.42,-2.59l1.02,-5.36l2.18,-4.31l2.24,0.42L466.83,260.24z"
          }, {
            "id": "GE",
            "title": "Georgia",
            "d": "M591.76,335.85L592.18,334.25L591.48,331.68L589.86,330.27L588.31,329.83L587.28,328.66L587.62,328.2L589.99,328.86L594.12,329.48L597.94,331.31L598.43,332.02L600.13,331.42L602.75,332.22L603.6,333.77L605.37,334.64L604.64,335.15L606.02,337.17L605.64,337.6L604.13,337.38L602.04,336.32L601.35,336.92L597.45,337.5L594.75,335.68z"
          }, {
            "id": "GF",
            "title": "French Guiana",
            "d": "M327.89,456.41l-1.07,1.06l-1.34,0.2l-0.38,-0.78l-0.63,-0.12l-0.87,0.76l-1.22,-0.57l0.71,-1.19l0.24,-1.27l0.48,-1.2l-1.09,-1.65l-0.22,-1.91l1.46,-2.41l0.95,0.31l2.06,0.66l2.97,2.36l0.46,1.14l-1.66,2.55L327.89,456.41z"
          }, {
            "id": "GH",
            "title": "Ghana",
            "d": "M478.23,446.84L473.83,448.48L472.27,449.44L469.74,450.25L467.24,449.46L467.37,448.35L466.16,445.94L466.89,442.77L468.07,440.41L467.33,436.4L466.94,434.27L467.01,432.66L471.88,432.53L473.12,432.74L474.02,432.28L475.32,432.5L475.11,433.39L476.28,434.85L476.28,436.9L476.55,439.12L477.25,440.15L476.63,442.68L476.85,444.08L477.6,445.86z"
          }, {
            "id": "GL",
            "title": "Greenland",
            "d": "M344.13,23.91L353.55,10.3L363.39,11.37L366.96,2.42L376.87,0L399.27,3.15L416.81,21.74L411.63,30.04L400.9,30.97L385.81,33L387.22,36.64L397.15,34.4L405.59,41.31L411.04,35.19L413.37,42.34L410.29,53.31L417.43,46.38L431.04,38.83L439.45,42.64L441.02,50.76L429.59,63.42L428.01,67.32L419.05,70.18L425.54,70.97L422.26,82.48L420,92.07L420.09,107.33L423.46,115.67L419.08,116.18L414.47,120.06L419.64,126.36L420.3,135.98L417.3,137L420.93,146.15L414.71,146.9L417.96,151.04L417.04,154.55L413.09,156.06L409.18,156.09L412.69,162.57L412.73,166.7L407.18,162.87L405.74,165.36L409.52,167.65L413.2,173.13L414.26,180.08L409.26,181.7L407.1,178.44L403.63,173.46L404.59,179.33L401.34,183.74L408.72,184.09L412.59,184.54L405.07,191.57L397.45,197.7L389.25,200.31L386.16,200.35L383.26,203.22L379.36,210.85L373.33,215.74L371.39,216.03L367.65,217.7L363.63,219.29L361.22,223.41L361.18,227.97L359.77,232.13L355.19,237.08L356.32,241.79L355.06,246.64L353.63,252.2L349.68,252.54L345.54,247.91L339.93,247.88L337.21,244.7L335.34,238.9L330.48,231.22L329.06,227.07L328.68,221.18L324.79,214.91L325.8,209.74L323.93,207.21L326.7,198.56L330.92,195.71L332.03,192.45L332.62,186.19L329.41,189.05L327.89,190.24L325.37,191.38L321.93,188.77L321.74,183.22L322.84,178.74L325.44,178.62L331.16,180.87L326.34,175.44L323.83,172.43L321.04,173.67L318.7,171.48L321.83,162.98L320.13,159.45L317.9,152.71L314.53,141.8L310.96,137.63L310.99,133L303.46,126.31L297.51,125.46L290.02,125.93L283.18,126.79L279.92,123.04L275.05,115.38L282.41,111.41L288.06,110.73L276.06,107.37L269.74,101.93L270.13,96.59L280.74,89.72L291.01,82.56L292.09,76.92L284.53,71.16L286.97,64.52L296.68,52.19L300.76,50.21L299.59,41.64L306.23,36.4L314.85,33.19L323.47,33.01L326.53,39.31L333.97,27.99L340.66,35.77L344.59,37.36L350.42,43.77L343.75,33z"
          }, {
            "id": "GM",
            "title": "Gambia",
            "d": "M428.03,426.43L428.39,425.16L431.44,425.07L432.08,424.4L432.97,424.35L434.07,425.06L434.94,425.07L435.87,424.59L436.43,425.41L435.22,426.06L434,426.01L432.8,425.4L431.76,426.06L431.26,426.09L430.58,426.49z"
          }, {
            "id": "GN",
            "title": "Guinea",
            "d": "M451.59,441.91L450.8,441.84L450.23,442.97L449.43,442.96L448.89,442.36L449.07,441.23L447.9,439.51L447.17,439.82L446.57,439.89L445.8,440.05L445.83,439.02L445.38,438.28L445.47,437.46L444.86,436.27L444.08,435.26L441.84,435.26L441.19,435.79L440.41,435.85L439.93,436.46L439.61,437.25L438.11,438.49L436.88,436.82L435.79,435.71L435.07,435.35L434.37,434.78L434.06,433.53L433.65,432.91L432.83,432.44L434.08,431.06L434.93,431.11L435.66,430.63L436.28,430.63L436.72,430.25L436.48,429.31L436.79,429.01L436.84,428.04L438.19,428.07L440.21,428.77L440.83,428.7L441.04,428.39L442.56,428.61L442.97,428.45L443.13,429.5L443.58,429.49L444.31,429.11L444.77,429.21L445.55,429.93L446.75,430.16L447.52,429.54L448.43,429.16L449.1,428.76L449.66,428.84L450.28,429.46L450.62,430.25L451.77,431.44L451.19,432.17L451.08,433.09L451.68,432.81L452.03,433.15L451.88,433.99L452.74,434.81L452.18,435.02L451.95,435.99L452.6,437.15L453.29,439.41L452.25,439.75L451.98,440.14L452.2,440.68L452.04,441.91z"
          }, {
            "id": "GQ",
            "title": "Equatorial Guinea",
            "d": "M501.87,460.57L501.34,460.15L502.31,457.02L506.87,457.09L506.89,460.44L502.82,460.41z"
          }, {
            "id": "GR",
            "title": "Greece",
            "d": "M541.7,356.71l1.53,1.16l2.18,-0.19l2.09,0.24l-0.07,0.6l1.53,-0.41l-0.35,1.01l-4.04,0.29l0.03,-0.56l-3.42,-0.67L541.7,356.71zM549.85,335.75l-0.87,2.33l-0.67,0.41l-1.71,-0.1l-1.46,-0.35l-3.4,0.96l1.94,2.06l-1.42,0.59l-1.56,0l-1.48,-1.88l-0.53,0.8l0.63,2.18l1.4,1.7l-1.06,0.79l1.56,1.65l1.39,1.03l0.04,2l-1.36,-1.15l-1.24,0.21l0.83,1.8l-0.92,0.19l-1,-0.69l1.2,3.95l-0.58,0l-0.45,-1.25l-0.57,-0.02l-0.26,1.32l-0.45,-0.3l0.1,-0.74l-0.56,-1.04h-0.64l0.12,0.84l-0.25,0.27l-0.62,-0.54l-0.38,-1.01l0.52,-0.57l-0.36,-0.74l-0.41,-0.38l-0.42,-0.09l-0.49,-0.94l0.58,-0.52l0.36,-0.48l0.56,0.1l0.25,-0.41l0.59,-0.16l0.68,0.46l0.55,0.17l0.39,-0.62l-0.94,-0.08l-0.56,-0.19l-1.25,0.28l-1.22,0.05l-1.09,-1.64l-0.18,-0.25l0.17,-0.64l-1.42,-1.15l-0.19,-1.03l1.3,-1.76l0.17,-1.19l0.91,-0.53l0.06,-0.97l1.83,-0.33l1.07,-0.81l1.52,0.07l0.46,-0.65l0.53,-0.12l2.07,0.11l2.25,-1.02l1.98,1.3l2.55,-0.35l0.03,-1.86L549.85,335.75z"
          }, {
            "id": "GT",
            "title": "Guatemala",
            "d": "M222.64,424.75L221.2,424.25L219.45,424.2L218.17,423.63L216.66,422.45L216.73,421.61L217.05,420.93L216.66,420.39L218.01,418.03L221.6,418.02L221.68,417.04L221.22,416.86L220.91,416.23L219.87,415.56L218.83,414.58L220.1,414.58L220.1,412.93L222.72,412.93L225.31,412.96L225.29,415.27L225.07,418.55L225.9,418.55L226.82,419.08L227.06,418.64L227.88,419.01L226.61,420.12L225.28,420.93L225.08,421.48L225.3,422.04L224.72,422.78L224.06,422.95L224.21,423.29L223.69,423.61L222.73,424.33z"
          }, {
            "id": "GW",
            "title": "Guinea-Bissau",
            "d": "M432.83,432.44L431.33,431.25L430.15,431.07L429.51,430.26L429.52,429.83L428.67,429.23L428.49,428.62L429.98,428.15L430.91,428.24L431.66,427.92L436.84,428.04L436.79,429.01L436.48,429.31L436.72,430.25L436.28,430.63L435.66,430.63L434.93,431.11L434.08,431.06z"
          }, {
            "id": "GY",
            "title": "Guyana",
            "d": "M307.7,440L309.54,441.03L311.28,442.86L311.35,444.31L312.41,444.38L313.91,445.74L315.02,446.72L314.57,449.24L312.87,449.97L313.02,450.62L312.5,452.07L313.75,454.09L314.64,454.1L315.01,455.67L316.72,458.09L316.04,458.19L314.49,457.96L313.58,458.7L312.31,459.19L311.43,459.31L311.12,459.85L309.74,459.71L308.01,458.41L307.81,457.12L307.09,455.71L307.54,453.33L308.32,452.35L307.67,451.05L306.71,450.63L307.08,449.4L306.42,448.76L304.96,448.88L303.07,446.76L303.83,445.99L303.77,444.69L305.5,444.24L306.19,443.72L305.23,442.68L305.48,441.65z"
          }, {
            "id": "HN",
            "title": "Honduras",
            "d": "M230.43,426.9L229.95,426.01L229.09,425.76L229.29,424.61L228.91,424.3L228.33,424.1L227.1,424.44L227,424.05L226.15,423.59L225.55,423.02L224.72,422.78L225.3,422.04L225.08,421.48L225.28,420.93L226.61,420.12L227.88,419.01L228.17,419.13L228.79,418.62L229.59,418.58L229.85,418.81L230.29,418.67L231.59,418.93L232.89,418.85L233.79,418.53L234.12,418.21L235.01,418.36L235.68,418.56L236.41,418.49L236.97,418.24L238.25,418.64L238.7,418.7L239.55,419.24L240.36,419.89L241.38,420.33L242.12,421.13L241.16,421.07L240.77,421.46L239.8,421.84L239.09,421.84L238.47,422.21L237.91,422.08L237.43,421.64L237.14,421.72L236.78,422.41L236.51,422.38L236.46,422.98L235.48,423.77L234.97,424.11L234.68,424.47L233.85,423.89L233.25,424.65L232.66,424.63L232,424.7L232.06,426.11L231.65,426.13L231.3,426.79z"
          }, {
            "id": "HR",
            "title": "Croatia",
            "d": "M528.05,318.93L528.73,320.48L529.62,321.62L528.54,323.11L527.27,322.23L525.33,322.29L522.92,321.63L521.61,321.72L521.01,322.54L520,321.63L519.41,323.27L520.79,325.1L521.39,326.31L522.68,327.76L523.75,328.61L524.81,330.22L527.29,331.66L526.98,332.3L524.35,330.9L522.72,329.52L520.16,328.38L517.8,325.53L518.37,325.23L517.09,323.59L517.03,322.25L515.23,321.63L514.37,323.34L513.54,322.01L513.61,320.63L513.71,320.57L515.66,320.71L516.18,320.03L517.13,320.68L518.23,320.76L518.22,319.64L519.19,319.23L519.47,317.61L521.7,316.53L522.59,317.03L524.69,318.76L527,319.53z"
          }, {
            "id": "HT",
            "title": "Haiti",
            "d": "M270.04,406.75L271.75,406.88L274.18,407.35L274.43,408.96L274.21,410.09L273.53,410.59L274.25,411.47L274.19,412.27L272.33,411.77L271.01,411.97L269.3,411.76L267.99,412.31L266.48,411.39L266.73,410.44L269.31,410.85L271.43,411.09L272.44,410.43L271.16,409.16L271.18,408.03L269.41,407.57z"
          }, {
            "id": "HU",
            "title": "Hungary",
            "d": "M520.68,315.11L521.61,312.46L521.07,311.57L522.65,311.56L522.86,309.85L524.29,310.92L525.32,311.38L527.68,310.87L527.9,310.03L529.02,309.9L530.38,309.25L530.68,309.52L532,309L532.66,308L533.58,307.75L536.58,309.03L537.18,308.6L538.73,309.74L538.93,310.86L537.22,311.73L535.89,314.53L534.2,317.29L531.95,318.05L530.2,317.88L528.05,318.93L527,319.53L524.69,318.76L522.59,317.03L521.7,316.53L521.15,315.16z"
          }, {
            "id": "ID",
            "title": "Indonesia",
            "d": "M813.72,492.06l-1.18,0.05l-3.72,-1.98l2.61,-0.56l1.47,0.86l0.98,0.86L813.72,492.06zM824.15,491.78l-2.4,0.62l-0.34,-0.34l0.25,-0.96l1.21,-1.72l2.77,-1.12l0.28,0.56l0.05,0.86L824.15,491.78zM805.83,486.01l1.01,0.75l1.73,-0.23l0.7,1.2l-3.24,0.57l-1.94,0.38l-1.51,-0.02l0.96,-1.62l1.54,-0.02L805.83,486.01zM819.86,486l-0.41,1.56l-4.21,0.8l-3.73,-0.35l-0.01,-1.03l2.23,-0.59l1.76,0.84l1.87,-0.21L819.86,486zM779.82,482.31l5.37,0.28l0.62,-1.16l5.2,1.35l1.02,1.82l4.21,0.51l3.44,1.67l-3.2,1.07l-3.08,-1.13l-2.54,0.08l-2.91,-0.21l-2.62,-0.51l-3.25,-1.07l-2.06,-0.28l-1.17,0.35l-5.11,-1.16l-0.49,-1.21l-2.57,-0.21l1.92,-2.68l3.4,0.17l2.26,1.09l1.16,0.21L779.82,482.31zM853,480.73l-1.44,1.91l-0.27,-2.11l0.5,-1.01l0.59,-0.95l0.64,0.82L853,480.73zM832.04,473.02l-1.05,0.93l-1.94,-0.51l-0.55,-1.2l2.84,-0.13L832.04,473.02zM841.08,472.01l1.02,2.13l-2.37,-1.15l-2.34,-0.23l-1.58,0.18l-1.94,-0.1l0.67,-1.53l3.46,-0.12L841.08,472.01zM851.37,466.59l0.78,4.51l2.9,1.67l2.34,-2.96l3.22,-1.68l2.49,0l2.4,0.97l2.08,1l3.01,0.53l0.05,9.1l0.05,9.16l-2.5,-2.31l-2.85,-0.57l-0.69,0.8l-3.55,0.09l1.19,-2.29l1.77,-0.78l-0.73,-3.05l-1.35,-2.35l-5.44,-2.37l-2.31,-0.23l-4.21,-2.58l-0.83,1.36l-1.08,0.25l-0.64,-1.02l-0.01,-1.21l-2.14,-1.37l3.02,-1l2,0.05l-0.24,-0.74l-4.1,-0.01l-1.11,-1.66l-2.5,-0.51l-1.19,-1.38l3.78,-0.67l1.44,-0.91l4.5,1.14L851.37,466.59zM826.41,459.43l-2.25,2.76l-2.11,0.54l-2.7,-0.54l-4.67,0.14l-2.45,0.4l-0.4,2.11l2.51,2.48l1.51,-1.26l5.23,-0.95l-0.23,1.28l-1.22,-0.4l-1.22,1.63l-2.47,1.08l2.65,3.57l-0.51,0.96l2.52,3.22l-0.02,1.84l-1.5,0.82l-1.1,-0.98l1.36,-2.29l-2.75,1.08l-0.7,-0.77l0.36,-1.08l-2.02,-1.64l0.21,-2.72l-1.87,0.85l0.24,3.25l0.11,4l-1.78,0.41l-1.2,-0.82l0.8,-2.57l-0.43,-2.69l-1.18,-0.02l-0.87,-1.91l1.16,-1.83l0.4,-2.21l1.41,-4.2l0.59,-1.15l2.38,-2.07l2.19,0.82l3.54,0.39l3.22,-0.12l2.77,-2.02L826.41,459.43zM836.08,460.23l-0.15,2.43l-1.45,-0.27l-0.43,1.69l1.16,1.47l-0.79,0.33l-1.13,-1.76l-0.83,-3.56l0.56,-2.23l0.93,-1.01l0.2,1.52l1.66,0.24L836.08,460.23zM805.76,458.29l3.14,2.58l-3.32,0.33l-0.94,1.9l0.12,2.52l-2.7,1.91L802,470.3l-1.08,4.27l-0.41,-0.99l-3.19,1.26l-1.11,-1.71l-2,-0.16l-1.4,-0.89l-3.33,1l-1.02,-1.35l-1.84,0.15l-2.31,-0.32l-0.43,-3.74l-1.4,-0.77l-1.35,-2.38l-0.39,-2.44l0.33,-2.58l1.67,-1.85l0.47,1.86l1.92,1.57l1.81,-0.57l1.79,0.2l1.63,-1.41l1.34,-0.24l2.65,0.78l2.29,-0.59l1.44,-3.88l1.08,-0.97l0.97,-3.17l3.22,0l2.43,0.47l-1.59,2.52l2.06,2.64L805.76,458.29zM771.95,479.71l-3.1,0.06l-2.36,-2.34l-3.6,-2.28l-1.2,-1.69l-2.12,-2.27l-1.39,-2.09l-2.13,-3.9l-2.46,-2.32l-0.82,-2.39l-1.03,-2.17l-2.53,-1.75l-1.47,-2.39l-2.11,-1.56l-2.92,-3.08l-0.25,-1.42l1.81,0.11l4.34,0.54l2.48,2.73l2.17,1.89l1.55,1.16l2.66,3l2.85,0.04l2.36,1.91l1.62,2.33l2.13,1.27l-1.12,2.27l1.61,0.97l1.01,0.07l0.48,1.94l0.98,1.56l2.06,0.25l1.36,1.76l-0.7,3.47L771.95,479.71z"
          }, {
            "id": "IE",
            "title": "Ireland",
            "d": "M457.88,284.29L458.34,287.65L456.22,291.77L451.25,294.45L447.28,293.77L449.55,288.99L448.09,284.22L451.9,280.47L454.02,278.2L454.6,280.8L454.02,283.37L455.76,283.31z"
          }, {
            "id": "IL",
            "title": "Israel",
            "d": "M575.41,366.82L574.92,367.87L573.9,367.41L573.32,369.61L574.02,369.97L573.31,370.43L573.18,371.29L574.5,370.84L574.57,372.11L573.17,377.28L571.33,371.73L572.14,370.65L571.95,370.46L572.69,368.93L573.26,366.43L573.66,365.59L573.74,365.56L574.68,365.56L574.94,364.98L575.69,364.93L575.73,366.3L575.35,366.8z"
          }, {
            "id": "IN",
            "title": "India",
            "d": "M693.5,357.44L696.51,361.43L696.23,364.17L697.34,365.88L697.25,367.57L695.24,367.13L696.03,370.76L698.78,372.82L702.68,375.09L700.9,376.55L699.81,379.54L702.53,380.74L705.17,382.29L708.83,384.06L712.67,384.47L714.29,386.06L716.45,386.35L719.83,387.08L722.16,387.03L722.48,385.79L722.11,383.8L722.33,382.45L724.04,381.78L724.28,384.26L724.33,384.89L726.88,386.08L728.65,385.59L731.01,385.8L733.3,385.71L733.5,383.78L732.36,382.78L734.62,382.38L737.17,380.03L740.4,378L742.75,378.78L744.75,377.44L746.07,379.42L745.12,380.76L748.14,381.23L748.36,382.43L747.37,383.01L747.6,384.94L745.6,384.37L741.97,386.53L742.05,388.31L740.51,390.91L740.36,392.41L739.11,394.93L736.92,394.23L736.81,397.38L736.18,398.41L736.48,399.69L735.09,400.41L733.62,395.61L732.84,395.62L732.38,397.56L730.85,395.98L731.71,394.25L732.97,394.07L734.26,391.48L732.65,390.95L730.04,391L727.38,390.58L727.13,388.43L725.79,388.27L723.57,386.93L722.58,389.04L724.6,390.67L722.85,391.82L722.23,392.94L723.95,393.76L723.48,395.6L724.45,397.88L724.89,400.36L724.48,401.46L722.58,401.42L719.12,402.04L719.28,404.29L717.78,406.05L713.75,408.05L710.61,411.51L708.5,413.36L705.71,415.27L705.71,416.61L704.31,417.33L701.78,418.36L700.47,418.52L699.63,420.72L700.21,424.47L700.36,426.84L699.18,429.55L699.16,434.38L697.71,434.52L696.44,436.67L697.29,437.6L694.73,438.4L693.79,440.32L692.66,441.13L690.01,438.5L688.71,434.54L687.63,431.68L686.65,430.34L685.16,427.6L684.47,424.02L683.98,422.22L681.43,418.25L680.27,412.61L679.43,408.84L679.44,405.26L678.9,402.46L674.82,404.25L672.84,403.89L669.18,400.26L670.53,399.17L669.7,397.99L666.41,395.41L668.28,393.37L674.45,393.38L673.89,390.74L672.32,389.18L672,386.79L670.16,385.39L673.25,382.09L676.51,382.33L679.44,379.01L681.2,375.75L683.92,372.51L683.88,370.18L686.27,368.27L684,366.64L683.03,364.39L682.04,361.44L683.41,359.98L687.67,360.81L690.79,360.3z"
          }, {
            "id": "IQ",
            "title": "Iraq",
            "d": "M602.61,355.77L604.44,356.81L604.66,358.81L603.24,359.98L602.59,362.62L604.54,365.8L607.97,367.62L609.42,370.12L608.96,372.49L609.85,372.49L609.88,374.22L611.43,375.91L609.77,375.76L607.88,375.49L605.82,378.57L600.61,378.31L592.71,371.82L588.53,369.53L585.15,368.64L584.02,364.6L590.23,361.1L591.29,356.98L591.02,354.46L592.56,353.6L594,351.42L595.2,350.87L598.46,351.33L599.45,352.22L600.79,351.63z"
          }, {
            "id": "IR",
            "title": "Iran",
            "d": "M626.44,351.53L628.91,350.85L630.9,348.83L632.77,348.93L634,348.27L636,348.6L639.1,350.39L641.34,350.78L644.54,353.87L646.63,353.99L646.88,356.9L645.74,361.15L644.97,363.6L646.19,364.09L644.99,365.92L645.91,368.56L646.13,370.65L648.25,371.2L648.48,373.3L645.94,376.23L647.32,377.91L648.45,379.84L651.13,381.24L651.21,384.01L652.55,384.52L652.78,385.96L648.74,387.57L647.68,391.17L642.41,390.24L639.35,389.53L636.19,389.12L634.99,385.31L633.65,384.75L631.49,385.31L628.67,386.82L625.24,385.79L622.41,383.38L619.71,382.48L617.84,379.47L615.77,375.2L614.26,375.72L612.48,374.65L611.43,375.91L609.88,374.22L609.85,372.49L608.96,372.49L609.42,370.12L607.97,367.62L604.54,365.8L602.59,362.62L603.24,359.98L604.66,358.81L604.44,356.81L602.61,355.77L600.79,351.63L599.26,348.8L599.8,347.71L598.93,343.59L600.85,342.56L601.29,343.93L602.71,345.59L604.63,346.06L605.65,345.96L608.96,343.3L610.01,343.03L610.83,344.1L609.87,345.88L611.62,347.74L612.31,347.57L613.2,350.18L615.86,350.91L617.81,352.67L621.79,353.27L626.17,352.35z"
          }, {
            "id": "IS",
            "title": "Iceland",
            "d": "M434.57,212.43L433.93,216.91L437.09,221.51L433.45,226.52L425.36,230.9L422.94,232.05L419.25,231.12L411.43,229.11L414.19,226.27L408.09,223.07L413.05,221.79L412.93,219.82L407.05,218.25L408.94,213.78L413.19,212.75L417.56,217.43L421.82,213.68L425.35,215.64L429.92,211.93z"
          }, {
            "id": "IT",
            "title": "Italy",
            "d": "M518.77,347.88l-1.01,2.78l0.42,1.09l-0.59,1.79l-2.14,-1.31l-1.43,-0.38l-3.91,-1.79l0.39,-1.82l3.28,0.32l2.86,-0.39L518.77,347.88zM501.08,337.06l1.68,2.62l-0.39,4.81l-1.27,-0.23l-1.14,1.2l-1.06,-0.95l-0.11,-4.38l-0.64,-2.1l1.54,0.19L501.08,337.06zM509.95,315.46l4.01,1.05l-0.3,1.99l0.67,1.71l-2.23,-0.58l-2.28,1.42l0.16,1.97l-0.34,1.12l0.92,1.99l2.63,1.95l1.41,3.17l3.12,3.05l2.2,-0.02l0.68,0.83l-0.79,0.74l2.51,1.35l2.06,1.12l2.4,1.92l0.29,0.68l-0.52,1.31l-1.56,-1.7l-2.44,-0.6l-1.18,2.36l2.03,1.34l-0.33,1.88l-1.17,0.21l-1.5,3.06l-1.17,0.27l0.01,-1.08l0.57,-1.91l0.61,-0.77l-1.09,-2.09l-0.86,-1.83l-1.16,-0.46l-0.83,-1.58l-1.8,-0.67l-1.21,-1.49l-2.07,-0.24l-2.19,-1.68l-2.56,-2.45l-1.91,-2.19l-0.87,-3.8l-1.4,-0.45l-2.28,-1.29l-1.29,0.53l-1.62,1.8l-1.17,0.28l0.32,-1.68l-1.52,-0.49l-0.72,-3.04l0.97,-1.21l-0.83,-1.5l0.12,-1.13l1.21,0.86l1.35,-0.19l1.57,-1.36l0.49,0.64l1.34,-0.13l0.61,-1.63l2.07,0.51l1.24,-0.68l0.22,-1.67l1.7,0.58l0.33,-0.78l2.77,-0.71L509.95,315.46z"
          }, {
            "id": "JM",
            "title": "Jamaica",
            "d": "M257.76,410.96L259.65,411.22L261.14,411.93L261.6,412.73L259.63,412.78L258.78,413.27L257.21,412.8L255.61,411.73L255.94,411.06L257.12,410.86z"
          }, {
            "id": "JO",
            "title": "Jordan",
            "d": "M574.92,367.87L575.41,366.82L578.53,368.14L584.02,364.6L585.15,368.64L584.62,369.13L579,370.78L581.8,374.04L580.87,374.58L580.41,375.67L578.27,376.11L577.6,377.27L576.38,378.25L573.26,377.74L573.17,377.28L574.57,372.11L574.5,370.84L574.92,369.88z"
          }, {
            "id": "JP",
            "title": "Japan",
            "d": "M852.76,362.01l0.36,1.15l-1.58,2.03l-1.15,-1.07l-1.44,0.78l-0.74,1.95l-1.83,-0.95l0.02,-1.58l1.55,-2l1.59,0.39l1.15,-1.42L852.76,362.01zM870.53,351.73l-1.06,2.78l0.49,1.73l-1.46,2.42l-3.58,1.6l-4.93,0.21l-4,3.84l-1.88,-1.29L854,360.5l-4.88,0.75l-3.32,1.59l-3.28,0.06l2.84,2.46l-1.87,5.61l-1.81,1.37l-1.36,-1.27l0.69,-2.96l-1.77,-0.96l-1.14,-2.28l2.65,-1.03l1.47,-2.11l2.82,-1.75l2.06,-2.33l5.58,-1.02l3,0.7l2.93,-6.17l1.87,1.67l4.11,-3.51l1.59,-1.38l1.76,-4.38l-0.48,-4.1l1.18,-2.33l2.98,-0.68l1.53,5.11l-0.08,2.94l-2.59,3.6L870.53,351.73zM878.76,325.8l1.97,0.83l1.98,-1.65l0.62,4.35l-4.16,1.05l-2.46,3.76l-4.41,-2.58l-1.53,4.12l-3.12,0.06l-0.39,-3.74l1.39,-2.94l3,-0.21l0.82,-5.38l0.83,-3.09l3.29,4.12L878.76,325.8z"
          }, {
            "id": "KE",
            "title": "Kenya",
            "d": "M590.19,465.78L591.85,468.07L589.89,469.19L589.2,470.35L588.14,470.55L587.75,472.52L586.85,473.64L586.3,475.5L585.17,476.42L581.15,473.63L580.95,472.01L570.79,466.34L570.31,466.03L570.29,463.08L571.09,461.95L572.47,460.11L573.49,458.08L572.26,454.88L571.93,453.48L570.6,451.54L572.32,449.87L574.22,448.03L575.68,448.5L575.68,450.07L576.64,450.98L578.59,450.98L582.14,453.36L583.02,453.38L583.68,453.31L584.3,453.63L586.17,453.85L587,452.69L589.56,451.52L590.69,452.46L592.61,452.46L590.16,455.63z"
          }, {
            "id": "KG",
            "title": "Kyrgyzstan",
            "d": "M674.22,333.11L674.85,331.45L676.69,330.91L681.31,332.22L681.74,329.98L683.33,329.18L687.33,330.79L688.35,330.37L693,330.47L697.16,330.87L698.56,332.24L700.29,332.79L699.9,333.65L695.48,335.68L694.48,337.16L690.88,337.6L689.82,339.95L686.85,339.46L684.92,340.18L682.24,341.9L682.63,342.75L681.83,343.58L676.53,344.13L673.06,342.96L670.02,343.24L670.29,341.14L673.34,341.75L674.37,340.62L676.5,340.98L680.09,338.34L676.77,336.38L674.77,337.31L672.7,335.91L675.05,333.48z"
          }, {
            "id": "KH",
            "title": "Cambodia",
            "d": "M765.44,433.6L764.3,432.12L762.89,429.18L762.22,425.73L764.02,423.35L767.64,422.8L770.27,423.21L772.58,424.34L773.85,422.35L776.34,423.41L776.99,425.33L776.64,428.75L771.93,430.94L773.16,432.67L770.22,432.87L767.79,434.01z"
          }, {
            "id": "KP",
            "title": "North Korea",
            "d": "M841.55,332.62L841.94,333.29L840.88,333.06L839.66,334.33L838.82,335.61L838.93,338.28L837.48,339.09L836.98,339.74L835.92,340.82L834.05,341.42L832.84,342.4L832.75,343.97L832.42,344.37L833.54,344.95L835.13,346.53L834.72,347.39L833.53,347.62L831.55,347.79L830.46,349.39L829.2,349.27L829.03,349.59L827.67,348.92L827.33,349.58L826.51,349.87L826.41,349.21L825.68,348.89L824.93,348.32L825.7,346.75L826.36,346.33L826.11,345.68L826.82,343.74L826.63,343.15L825,342.75L823.68,341.78L825.96,339.43L829.05,337.45L830.98,334.8L832.31,335.97L834.73,336.11L834.29,334.14L838.62,332.51L839.74,330.38z"
          }, {
            "id": "KR",
            "title": "South Korea",
            "d": "M835.13,346.53L837.55,350.71L838.24,352.98L838.26,356.96L837.21,358.84L834.67,359.5L832.43,360.91L829.9,361.2L829.59,359.35L830.11,356.78L828.87,353.18L830.95,352.59L829.03,349.59L829.2,349.27L830.46,349.39L831.55,347.79L833.53,347.62L834.72,347.39z"
          }, {
            "id": "XK",
            "title": "Kosovo",
            "d": "M533.47,333.92L533.34,334.69L532.98,334.66L532.8,333.29L532.13,332.91L531.53,331.89L532.05,331.04L532.72,330.76L533.11,329.5L533.61,329.28L534.01,329.82L534.54,330.06L534.9,330.67L535.36,330.85L535.91,331.55L536.31,331.53L535.99,332.46L535.66,332.91L535.75,333.19L535.12,333.33z"
          }, {
            "id": "KW",
            "title": "Kuwait",
            "d": "M609.77,375.76L610.35,377.17L610.1,377.9L611,380.31L609.02,380.39L608.32,378.88L605.82,378.57L607.88,375.49z"
          }, {
            "id": "KZ",
            "title": "Kazakhstan",
            "d": "M674.22,333.11L672.61,333.81L668.92,336.42L667.69,339.07L666.64,339.09L665.88,337.34L662.31,337.22L661.74,334.16L660.37,334.13L660.58,330.33L657.23,327.53L652.42,327.83L649.13,328.39L646.45,324.89L644.16,323.41L639.81,320.57L639.29,320.22L632.07,322.57L632.18,336.7L630.74,336.88L628.78,333.95L626.88,332.89L623.7,333.68L622.46,334.93L622.3,334.01L622.99,332.44L622.46,331.12L619.21,329.82L617.94,326.35L616.4,325.37L616.3,324.09L619.03,324.46L619.14,321.58L621.52,320.94L623.97,321.53L624.48,317.62L623.98,315.11L621.17,315.31L618.79,314.31L615.54,316.1L612.93,316.96L611.5,316.3L611.79,314.2L610,311.44L607.92,311.55L605.54,308.72L607.16,305.5L606.34,304.63L608.57,299.86L611.46,302.39L611.81,299.2L617.59,294.35L621.97,294.23L628.16,297.33L631.47,299.12L634.45,297.25L638.89,297.17L642.48,299.46L643.3,298.15L647.23,298.34L647.94,296.23L643.39,293.14L646.08,290.91L645.56,289.66L648.25,288.45L646.23,285.25L647.51,283.63L658,281.97L659.37,280.78L666.39,278.99L668.91,276.95L673.95,278.01L674.83,283.02L677.76,281.86L681.36,283.49L681.13,286.07L683.82,285.8L690.84,281.31L689.82,282.81L693.4,286.47L699.66,298.05L701.16,295.72L705.02,298.28L709.05,297.14L710.59,297.94L711.94,300.49L713.9,301.33L715.1,303.18L718.71,302.6L720.2,305.23L718.06,308.06L715.73,308.46L715.6,312.64L714.04,314.5L708.48,313.15L706.46,320.41L705.02,321.3L699.47,322.88L701.99,329.63L700.07,330.63L700.29,332.79L698.56,332.24L697.16,330.87L693,330.47L688.35,330.37L687.33,330.79L683.33,329.18L681.74,329.98L681.31,332.22L676.69,330.91L674.85,331.45z"
          }, {
            "id": "LA",
            "title": "Lao People's Democratic Republic",
            "d": "M770.27,423.21L771.18,421.91L771.31,419.47L769.04,416.94L768.86,414.07L766.73,411.69L764.61,411.49L764.05,412.51L762.4,412.59L761.56,412.08L758.61,413.82L758.54,411.2L759.23,408.09L757.34,407.96L757.18,406.18L755.96,405.26L756.56,404.16L758.95,402.22L759.2,402.92L760.69,403L760.27,399.57L761.72,399.13L763.36,401.5L764.62,404.22L768.07,404.25L769.16,406.84L767.37,407.61L766.56,408.68L769.92,410.44L772.25,413.9L774.02,416.47L776.14,418.49L776.85,420.53L776.34,423.41L773.85,422.35L772.58,424.34z"
          }, {
            "id": "LB",
            "title": "Lebanon",
            "d": "M575.69,364.93L574.94,364.98L574.68,365.56L573.74,365.56L574.74,362.83L576.13,360.45L576.19,360.33L577.45,360.51L577.91,361.83L576.38,363.1z"
          }, {
            "id": "LK",
            "title": "Sri Lanka",
            "d": "M704.57,442.37L704.15,445.29L702.98,446.09L700.54,446.73L699.2,444.5L698.71,440.47L699.98,435.89L701.91,437.46L703.22,439.44z"
          }, {
            "id": "LR",
            "title": "Liberia",
            "d": "M453.63,451.22L452.89,451.24L450,449.91L447.46,447.78L445.07,446.25L443.18,444.44L443.85,443.54L444,442.73L445.26,441.2L446.57,439.89L447.17,439.82L447.9,439.51L449.07,441.23L448.89,442.36L449.43,442.96L450.23,442.97L450.8,441.84L451.59,441.91L451.46,442.73L451.74,444.09L451.13,445.33L451.95,446.1L452.84,446.29L454.03,447.46L454.11,448.57L453.84,448.92z"
          }, {
            "id": "LS",
            "title": "Lesotho",
            "d": "M556.5,547.75L557.48,548.71L556.62,550.27L556.14,551.32L554.58,551.82L554.06,552.86L553.06,553.18L550.96,550.69L552.45,548.66L553.97,547.41L555.28,546.77z"
          }, {
            "id": "LT",
            "title": "Lithuania",
            "d": "M538.99,282.09L538.76,280.87L539.06,279.54L537.82,278.77L534.89,277.91L534.29,273.75L537.5,272.2L542.2,272.53L544.96,272.03L545.35,273.08L546.84,273.4L549.54,275.82L549.8,278.02L547.5,279.59L546.85,282.31L543.81,284.11L541.1,284.07L540.43,282.61z"
          }, {
            "id": "LU",
            "title": "Luxembourg",
            "d": "M492.2,301.29L492.76,302.27L492.6,304.16L491.79,304.26L491.16,303.88L491.47,301.45z"
          }, {
            "id": "LV",
            "title": "Latvia",
            "d": "M534.29,273.75L534.39,269.94L535.77,266.7L538.41,264.92L540.63,268.8L542.88,268.7L543.42,264.71L545.81,263.78L547.04,264.43L549.45,266.37L551.77,266.38L553.12,267.57L553.35,270.06L554.26,273.05L551.24,274.98L549.54,275.82L546.84,273.4L545.35,273.08L544.96,272.03L542.2,272.53L537.5,272.2z"
          }, {
            "id": "LY",
            "title": "Libya",
            "d": "M516.89,397.93L514.91,399.05L513.33,397.39L508.9,396.08L507.67,394.17L505.45,392.75L504.14,393.31L503.15,391.6L503.04,390.28L501.38,388.02L502.5,386.73L502.25,384.76L502.61,383.04L502.41,381.6L502.9,379.01L502.75,377.53L501.84,374.69L503.21,373.94L503.45,372.56L503.15,371.21L505.08,369.95L505.94,368.9L507.31,367.95L507.47,365.4L510.76,366.55L511.94,366.26L514.28,366.82L518,368.29L519.31,371.21L521.83,371.85L525.78,373.21L528.77,374.82L530.14,373.98L531.48,372.49L530.83,369.98L531.71,368.38L533.73,366.83L535.66,366.38L539.45,367.06L540.41,368.54L541.45,368.55L542.34,369.11L545.13,369.5L545.81,370.58L544.8,372.15L545.23,373.54L544.51,375.54L545.35,378.12L545.35,389.3L545.35,400.53L545.35,406.49L542.13,406.5L542.09,407.74L530.91,402.04L519.72,396.27z"
          }, {
            "id": "MA",
            "title": "Morocco",
            "d": "M450.96,383.14L450.93,379.39L455.46,377.03L458.26,376.54L460.55,375.68L461.63,374.06L464.91,372.77L465.03,370.36L466.65,370.07L467.92,368.86L471.59,368.3L472.1,367.02L471.36,366.31L470.39,362.78L470.23,360.73L469.17,358.55L467.95,358.51L465.05,357.76L462.38,358L460.69,356.54L458.63,356.52L457.74,358.63L455.87,362.14L453.79,363.53L450.98,365.06L449.18,367.3L448.8,369.04L447.73,371.86L448.43,375.89L446.09,378.57L444.69,379.42L442.48,381.59L439.87,381.94L438.57,383.06L442.19,383.07L450.94,383.1L450.94,383.1L450.94,383.1L442.19,383.07L438.57,383.06z"
          }, {
            "id": "MD",
            "title": "Moldova",
            "d": "M549.89,309.45L550.56,308.83L552.42,308.41L554.49,309.72L555.64,309.88L556.91,311L556.71,312.41L557.73,313.08L558.13,314.8L559.11,315.84L558.92,316.44L559.44,316.86L558.7,317.15L557.04,317.04L556.77,316.47L556.18,316.8L556.38,317.52L555.61,318.81L555.12,320.18L554.42,320.62L553.91,318.79L554.21,317.07L554.12,315.28L552.5,312.84L551.61,311.09L550.74,309.85z"
          }, {
            "id": "ME",
            "title": "Montenegro",
            "d": "M530.77,332.23L530.6,331.51L529.38,333.38L529.57,334.57L528.98,334.28L528.2,333.05L526.98,332.3L527.29,331.66L527.7,329.56L528.61,328.67L529.14,328.31L529.88,328.97L530.29,329.51L531.21,329.92L532.28,330.71L532.05,331.04L531.53,331.89z"
          }, {
            "id": "MG",
            "title": "Madagascar",
            "d": "M614.17,498.4L614.91,499.61L615.6,501.5L616.06,504.96L616.78,506.31L616.5,507.69L616.01,508.55L615.05,506.85L614.53,507.71L615.06,509.85L614.81,511.09L614.04,511.76L613.86,514.24L612.76,517.66L611.38,521.75L609.64,527.42L608.57,531.63L607.3,535.18L605.02,535.91L602.57,537.22L600.96,536.43L598.73,535.33L597.96,533.71L597.77,531L596.79,528.58L596.53,526.41L597.03,524.25L598.32,523.73L598.33,522.74L599.67,520.48L599.92,518.6L599.27,517.2L598.74,515.35L598.52,512.65L599.5,511.02L599.87,509.17L601.27,509.07L602.84,508.47L603.87,507.95L605.11,507.91L606.7,506.26L609.01,504.48L609.85,503.04L609.47,501.81L610.66,502.16L612.21,500.17L612.26,498.45L613.19,497.17z"
          }, {
            "id": "MK",
            "title": "Macedonia",
            "d": "M532.98,334.66L533.34,334.69L533.47,333.92L535.12,333.33L535.75,333.19L536.71,332.97L538,332.91L539.41,334.12L539.61,336.59L539.07,336.71L538.61,337.36L537.09,337.29L536.02,338.1L534.19,338.42L533.03,337.52L532.63,335.93z"
          }, {
            "id": "ML",
            "title": "Mali",
            "d": "M441.13,422.22L442.07,421.7L442.54,420L443.43,419.93L445.39,420.73L446.97,420.16L448.05,420.35L448.48,419.71L459.73,419.67L460.35,417.64L459.86,417.28L458.51,404.6L457.16,391.54L461.45,391.49L470.91,398.14L480.37,404.69L481.03,406.08L482.78,406.93L484.08,407.41L484.11,409.29L487.22,409L487.23,415.75L485.69,417.69L485.45,419.48L482.96,419.93L479.14,420.18L478.1,421.21L476.3,421.32L474.51,421.33L473.81,420.78L472.26,421.19L469.64,422.39L469.11,423.29L466.93,424.57L466.55,425.31L465.38,425.89L464.02,425.51L463.25,426.21L462.84,428.17L460.61,430.53L460.68,431.49L459.91,432.7L460.1,434.34L458.94,434.76L458.29,435.12L457.85,433.91L457.04,434.23L456.56,434.17L456.04,435L453.88,434.97L453.1,434.55L452.74,434.81L451.88,433.99L452.03,433.15L451.68,432.81L451.08,433.09L451.19,432.17L451.77,431.44L450.62,430.25L450.28,429.46L449.66,428.84L449.1,428.76L448.43,429.16L447.52,429.54L446.75,430.16L445.55,429.93L444.77,429.21L444.31,429.11L443.58,429.49L443.13,429.5L442.97,428.45L443.1,427.56L442.86,426.46L441.81,425.65L441.26,424.01z"
          }, {
            "id": "MM",
            "title": "Myanmar",
            "d": "M754.36,405.95L752.72,407.23L750.74,407.37L749.46,410.56L748.28,411.09L749.64,413.66L751.42,415.79L752.56,417.71L751.54,420.23L750.57,420.76L751.24,422.21L753.11,424.49L753.43,426.09L753.38,427.42L754.48,430.02L752.94,432.67L751.58,435.58L751.31,433.48L752.17,431.3L751.23,429.62L751.46,426.51L750.32,425.03L749.41,421.59L748.9,417.93L747.69,415.53L745.84,416.99L742.65,419.05L741.08,418.79L739.34,418.12L740.31,414.51L739.73,411.77L737.53,408.38L737.87,407.31L736.23,406.93L734.24,404.51L734.06,402.1L735.04,402.56L735.09,400.41L736.48,399.69L736.18,398.41L736.81,397.38L736.92,394.23L739.11,394.93L740.36,392.41L740.51,390.91L742.05,388.31L741.97,386.53L745.6,384.37L747.6,384.94L747.37,383.01L748.36,382.43L748.14,381.23L749.78,380.99L750.72,382.85L751.94,383.6L752.03,386L751.91,388.57L749.26,391.15L748.92,394.78L751.88,394.28L752.55,397.08L754.33,397.67L753.51,400.17L755.59,401.3L756.81,401.85L758.86,400.98L758.95,402.22L756.56,404.16L755.96,405.26z"
          }, {
            "id": "MN",
            "title": "Mongolia",
            "d": "M721.29,304.88L724.25,304.14L729.6,300.4L733.87,298.33L736.3,299.68L739.23,299.74L741.1,301.79L743.9,301.94L747.96,303.03L750.68,300L749.54,297.4L752.45,292.74L755.59,294.61L758.13,295.14L761.43,296.29L761.96,299.61L765.95,301.45L768.6,300.64L772.14,300.07L774.95,300.65L777.7,302.74L779.4,304.94L782,304.9L785.53,305.59L788.11,304.53L791.8,303.82L795.91,300.76L797.59,301.23L799.06,302.69L802.4,302.33L801.04,305.58L799.06,309.8L799.78,311.51L801.37,310.98L804.13,311.63L806.29,310.09L808.54,311.42L811.08,314.31L810.77,315.76L808.56,315.3L804.49,315.84L802.51,317L800.46,319.66L796.18,321.21L793.39,323.31L790.51,322.51L788.93,322.15L787.46,324.69L788.35,326.19L788.81,327.47L786.84,328.77L784.83,330.82L781.56,332.15L777.35,332.3L772.82,333.61L769.56,335.62L768.32,334.46L764.93,334.46L760.78,332.17L758.01,331.6L754.28,332.13L748.49,331.28L745.4,331.37L743.76,329.1L742.48,325.53L740.75,325.1L737.36,322.65L733.58,322.1L730.25,321.42L729.24,319.69L730.32,314.96L728.39,311.65L724.39,310.08L722.03,307.85z"
          }, {
            "id": "MR",
            "title": "Mauritania",
            "d": "M441.13,422.22L439.28,420.24L437.58,418.11L435.72,417.34L434.38,416.49L432.81,416.52L431.45,417.15L430.05,416.9L429.09,417.83L428.85,416.27L429.63,414.83L429.98,412.08L429.67,409.17L429.33,407.7L429.61,406.23L428.89,404.81L427.41,403.53L428.02,402.53L439,402.55L438.47,398.2L439.16,396.65L441.78,396.38L441.69,388.52L450.9,388.69L450.9,383.96L461.45,391.49L457.16,391.54L458.51,404.6L459.86,417.28L460.35,417.64L459.73,419.67L448.48,419.71L448.05,420.35L446.97,420.16L445.39,420.73L443.43,419.93L442.54,420L442.07,421.7z"
          }, {
            "id": "MW",
            "title": "Malawi",
            "d": "M572.15,495.69L571.37,497.85L572.15,501.57L573.13,501.53L574.14,502.45L575.31,504.53L575.55,508.25L574.34,508.86L573.48,510.87L571.65,509.08L571.45,507.04L572.04,505.69L571.87,504.54L570.77,503.81L569.99,504.07L568.38,502.69L566.91,501.95L567.76,499.29L568.64,498.3L568.1,495.94L568.66,493.64L569.14,492.87L568.43,490.47L567.11,489.21L569.85,489.73L570.42,490.51L571.37,491.83z"
          }, {
            "id": "MX",
            "title": "Mexico",
            "d": "M202.89,388.72L201.8,391.43L201.31,393.64L201.1,397.72L200.83,399.19L201.32,400.83L202.19,402.3L202.75,404.61L204.61,406.82L205.26,408.51L206.36,409.96L209.34,410.75L210.5,411.97L212.96,411.15L215.09,410.86L217.19,410.33L218.96,409.82L220.74,408.62L221.41,406.89L221.64,404.4L222.13,403.53L224.02,402.74L226.99,402.05L229.47,402.15L231.17,401.9L231.84,402.53L231.75,403.97L230.24,405.74L229.58,407.55L230.09,408.06L229.67,409.34L228.97,411.63L228.26,410.88L227.67,410.93L227.14,410.97L226.14,412.74L225.63,412.39L225.29,412.53L225.31,412.96L222.72,412.93L220.1,412.93L220.1,414.58L218.83,414.58L219.87,415.56L220.91,416.23L221.22,416.86L221.68,417.04L221.6,418.02L218.01,418.03L216.66,420.39L217.05,420.93L216.73,421.61L216.66,422.45L213.49,419.34L212.04,418.4L209.75,417.64L208.19,417.85L205.93,418.94L204.52,419.23L202.54,418.47L200.44,417.91L197.82,416.58L195.72,416.17L192.54,414.82L190.2,413.42L189.49,412.64L187.92,412.47L185.05,411.54L183.88,410.2L180.87,408.53L179.47,406.66L178.8,405.21L179.73,404.92L179.44,404.07L180.09,403.3L180.1,402.26L179.16,400.92L178.9,399.72L177.96,398.2L175.49,395.18L172.67,392.79L171.31,390.88L168.9,389.62L168.39,388.86L168.82,386.94L167.39,386.21L165.73,384.69L165.03,382.5L163.52,382.24L161.9,380.58L160.58,379.03L160.46,378.03L158.95,375.61L157.96,373.13L158,371.88L155.97,370.59L155.04,370.73L153.44,369.83L152.99,371.16L153.45,372.72L153.72,375.15L154.69,376.48L156.77,378.69L157.23,379.44L157.66,379.66L158.02,380.76L158.52,380.71L159.09,382.75L159.94,383.55L160.53,384.66L162.3,386.26L163.23,389.15L164.06,390.5L164.84,391.94L164.99,393.56L166.34,393.66L167.47,395.05L168.49,396.41L168.42,396.95L167.24,398.06L166.74,398.05L166,396.2L164.17,394.47L162.15,392.99L160.71,392.21L160.8,389.96L160.38,388.28L159.04,387.32L157.11,385.93L156.74,386.33L156.04,385.51L154.31,384.76L152.66,382.93L152.86,382.69L154.01,382.87L155.05,381.69L155.16,380.26L153,377.99L151.36,377.1L150.32,375.09L149.28,372.97L147.98,370.36L146.84,367.4L150.03,367.15L153.59,366.79L153.33,367.43L157.56,369.04L163.96,371.35L169.54,371.32L171.76,371.32L171.76,369.97L176.62,369.97L177.64,371.14L179.08,372.17L180.74,373.6L181.67,375.29L182.37,377.05L183.82,378.02L186.15,378.98L187.91,376.45L190.21,376.39L192.18,377.67L193.59,379.85L194.56,381.71L196.21,383.51L196.83,385.7L197.62,387.17L199.8,388.13L201.79,388.81z"
          }, {
            "id": "MY",
            "title": "Malaysia",
            "d": "M758.65,446.07l0.22,1.44l1.85,-0.33l0.92,-1.15l0.64,0.26l1.66,1.69l1.18,1.87l0.16,1.88l-0.3,1.27l0.27,0.96l0.21,1.65l0.99,0.77l1.1,2.46l-0.05,0.94l-1.99,0.19l-2.65,-2.06l-3.32,-2.21l-0.33,-1.42l-1.62,-1.87l-0.39,-2.31l-1.01,-1.52l0.31,-2.04l-0.62,-1.19l0.49,-0.5L758.65,446.07zM807.84,450.9l-2.06,0.95l-2.43,-0.47l-3.22,0l-0.97,3.17l-1.08,0.97l-1.44,3.88l-2.29,0.59l-2.65,-0.78l-1.34,0.24l-1.63,1.41l-1.79,-0.2l-1.81,0.57l-1.92,-1.57l-0.47,-1.86l2.05,0.96l2.17,-0.52l0.56,-2.36l1.2,-0.53l3.36,-0.6l2.01,-2.21l1.38,-1.77l1.28,1.45l0.59,-0.95l1.34,0.09l0.16,-1.78l0.13,-1.38l2.16,-1.95l1.41,-2.19l1.13,-0.01l1.44,1.42l0.13,1.22l1.85,0.78l2.34,0.84l-0.2,1.1l-1.88,0.14L807.84,450.9z"
          }, {
            "id": "MZ",
            "title": "Mozambique",
            "d": "M572.15,495.69L574.26,495.46L577.63,496.26L578.37,495.9L580.32,495.83L581.32,494.98L583,495.02L586.06,493.92L588.29,492.28L588.75,493.55L588.63,496.38L588.98,498.88L589.09,503.36L589.58,504.76L588.75,506.83L587.66,508.84L585.87,510.64L583.31,511.75L580.15,513.16L576.98,516.31L575.9,516.85L573.94,518.94L572.79,519.63L572.55,521.75L573.88,524L574.43,525.76L574.47,526.66L574.96,526.51L574.88,529.47L574.43,530.88L575.09,531.4L574.67,532.67L573.5,533.76L571.19,534.8L567.82,536.46L566.59,537.61L566.83,538.91L567.54,539.12L567.3,540.76L565.18,540.74L564.94,539.36L564.52,537.97L564.28,536.86L564.78,533.43L564.05,531.26L562.71,527L565.66,523.59L566.4,521.44L566.83,521.17L567.14,519.43L566.69,518.55L566.81,516.35L567.36,514.31L567.35,510.62L565.9,509.68L564.56,509.47L563.96,508.75L562.66,508.14L560.32,508.2L560.14,507.12L559.87,505.07L568.38,502.69L569.99,504.07L570.77,503.81L571.87,504.54L572.04,505.69L571.45,507.04L571.65,509.08L573.48,510.87L574.34,508.86L575.55,508.25L575.31,504.53L574.14,502.45L573.13,501.53L572.15,501.57L571.37,497.85z"
          }, {
            "id": "NA",
            "title": "Namibia",
            "d": "M521.08,546.54L519,544.15L517.9,541.85L517.28,538.82L516.59,536.57L515.65,531.85L515.59,528.22L515.23,526.58L514.14,525.34L512.69,522.87L511.22,519.3L510.61,517.45L508.32,514.58L508.15,512.33L509.5,511.78L511.18,511.28L513,511.37L514.67,512.69L515.09,512.48L526.46,512.36L528.4,513.76L535.19,514.17L540.34,512.98L542.64,512.31L544.46,512.48L545.56,513.14L545.59,513.38L544.01,514.04L543.15,514.05L541.37,515.2L540.29,513.99L535.97,515.02L533.88,515.11L533.8,525.68L531.04,525.79L531.04,534.65L531.03,546.17L528.53,547.8L527.03,548.03L525.26,547.43L524,547.2L523.53,545.84L522.42,544.97z"
          }, {
            "id": "NC",
            "title": "New Caledonia",
            "d": "M940.08,523.48L942.38,525.34L943.83,526.72L942.77,527.45L941.22,526.63L939.22,525.28L937.41,523.69L935.56,521.59L935.17,520.58L936.37,520.63L937.95,521.64L939.18,522.65z"
          }, {
            "id": "NE",
            "title": "Niger",
            "d": "M481.29,429.88L481.36,427.93L478.12,427.28L478.04,425.9L476.46,424.03L476.08,422.72L476.3,421.32L478.1,421.21L479.14,420.18L482.96,419.93L485.45,419.48L485.69,417.69L487.23,415.75L487.22,409L491.17,407.68L499.29,401.83L508.9,396.08L513.33,397.39L514.91,399.05L516.89,397.93L517.58,402.6L518.63,403.38L518.68,404.33L519.84,405.35L519.23,406.63L518.15,412.61L518.01,416.4L514.43,419.14L513.22,422.94L514.39,424L514.38,425.85L516.18,425.92L515.9,427.26L515.11,427.43L515.02,428.33L514.49,428.4L512.6,425.27L511.94,425.15L509.75,426.75L507.58,425.92L506.07,425.75L505.26,426.15L503.61,426.07L501.96,427.29L500.53,427.36L497.14,425.88L495.81,426.58L494.38,426.53L493.33,425.45L490.51,424.38L487.5,424.72L486.77,425.34L486.38,426.99L485.57,428.14L485.38,430.68L483.24,429.04L482.23,429.05z"
          }, {
            "id": "NG",
            "title": "Nigeria",
            "d": "M499.09,450.08L496.18,451.08L495.11,450.94L494.03,451.56L491.79,451.5L490.29,449.75L489.37,447.73L487.38,445.89L485.27,445.92L482.8,445.92L482.96,441.39L482.89,439.6L483.42,437.83L484.28,436.96L485.64,435.21L485.35,434.45L485.9,433.31L485.27,431.63L485.38,430.68L485.57,428.14L486.38,426.99L486.77,425.34L487.5,424.72L490.51,424.38L493.33,425.45L494.38,426.53L495.81,426.58L497.14,425.88L500.53,427.36L501.96,427.29L503.61,426.07L505.26,426.15L506.07,425.75L507.58,425.92L509.75,426.75L511.94,425.15L512.6,425.27L514.49,428.4L515.02,428.33L516.13,429.47L515.82,429.98L515.67,430.93L513.31,433.13L512.57,434.94L512.17,436.41L511.58,437.04L511.01,439.01L509.51,440.17L509.08,441.59L508.45,442.73L508.19,443.89L506.26,444.84L504.69,443.69L503.62,443.73L501.95,445.37L501.14,445.4L499.81,448.1z"
          }, {
            "id": "NI",
            "title": "Nicaragua",
            "d": "M234.93,432.31L233.96,431.41L232.65,430.26L232.03,429.3L230.85,428.41L229.44,427.12L229.75,426.68L230.22,427.11L230.43,426.9L231.3,426.79L231.65,426.13L232.06,426.11L232,424.7L232.66,424.63L233.25,424.65L233.85,423.89L234.68,424.47L234.97,424.11L235.48,423.77L236.46,422.98L236.51,422.38L236.78,422.41L237.14,421.72L237.43,421.64L237.91,422.08L238.47,422.21L239.09,421.84L239.8,421.84L240.77,421.46L241.16,421.07L242.12,421.13L241.88,421.41L241.74,422.05L242.02,423.1L241.38,424.08L241.08,425.23L240.98,426.5L241.14,427.23L241.21,428.52L240.78,428.8L240.52,430.02L240.71,430.77L240.13,431.5L240.27,432.26L240.69,432.73L240.02,433.33L239.2,433.14L238.73,432.56L237.84,432.32L237.2,432.69L235.35,431.94z"
          }, {
            "id": "NL",
            "title": "Netherlands",
            "d": "M492.28,285.98L494.61,286.11L495.14,287.69L494.44,291.92L493.73,293.63L492.04,293.63L492.52,298.32L490.97,297.28L489.2,295.33L486.6,296.26L484.55,295.91L485.99,294.67L488.45,287.93z"
          }, {
            "id": "NO",
            "title": "Norway",
            "d": "M554.23,175.61l8.77,6.24l-3.61,2.23l3.07,5.11l-4.77,3.19l-2.26,0.72l1.19,-5.59l-3.6,-3.25l-4.35,2.78l-1.38,5.85l-2.67,3.44l-3.01,-1.87l-3.66,0.38l-3.12,-4.15l-1.68,2.09l-1.74,0.32l-0.41,5.08l-5.28,-1.22l-0.74,4.22l-2.69,-0.03l-1.85,5.24l-2.8,7.87l-4.35,9.5l1.02,2.23l-0.98,2.55l-2.78,-0.11l-1.82,5.91l0.17,8.04l1.79,2.98l-0.93,6.73l-2.33,3.81l-1.24,3.15l-1.88,-3.35l-5.54,6.27l-3.74,1.24l-3.88,-2.71l-1,-5.86l-0.89,-13.26l2.58,-3.88l7.4,-5.18l5.54,-6.59l5.13,-9.3l6.74,-13.76l4.7,-5.67l7.71,-9.89l6.15,-3.59l4.61,0.44l4.27,-6.99l5.11,0.38L554.23,175.61z"
          }, {
            "id": "NP",
            "title": "Nepal",
            "d": "M722.33,382.45L722.11,383.8L722.48,385.79L722.16,387.03L719.83,387.08L716.45,386.35L714.29,386.06L712.67,384.47L708.83,384.06L705.17,382.29L702.53,380.74L699.81,379.54L700.9,376.55L702.68,375.09L703.84,374.31L706.09,375.31L708.92,377.4L710.49,377.86L711.43,379.39L713.61,380.02L715.89,381.41L719.06,382.14z"
          }, {
            "id": "NZ",
            "title": "New Zealand",
            "d": "M960.38,588.63l0.64,1.53l1.99,-1.5l0.81,1.57l0,1.57l-1.04,1.74l-1.83,2.8l-1.43,1.54l1.03,1.86l-2.16,0.05l-2.4,1.46l-0.75,2.57l-1.59,4.03l-2.2,1.8l-1.4,1.16l-2.58,-0.09l-1.82,-1.34l-3.05,-0.28l-0.47,-1.48l1.51,-2.96l3.53,-3.87l1.81,-0.73l2.01,-1.47l2.4,-2.01l1.68,-1.98l1.25,-2.81l1.06,-0.95l0.42,-2.07l1.97,-1.7L960.38,588.63zM964.84,571.61l2.03,3.67l0.06,-2.38l1.27,0.95l0.42,2.65l2.26,1.15l1.89,0.28l1.6,-1.35l1.42,0.41l-0.68,3.15l-0.85,2.09l-2.14,-0.07l-0.75,1.1l0.26,1.56l-0.41,0.68l-1.06,1.97l-1.39,2.53l-2.17,1.49l-0.48,-0.98l-1.17,-0.54l1.62,-3.04l-0.92,-2.01l-3.02,-1.45l0.08,-1.31l2.03,-1.25l0.47,-2.74l-0.13,-2.28l-1.14,-2.34l0.08,-0.61l-1.34,-1.43l-2.21,-3.04l-1.17,-2.41l1.04,-0.27l1.53,1.89l2.18,0.89L964.84,571.61z"
          }, {
            "id": "OM",
            "title": "Oman",
            "d": "M640.29,403.18l-1.05,2.04l-1.27,-0.16l-0.58,0.71l-0.45,1.5l0.34,1.98l-0.26,0.36l-1.29,-0.01l-1.75,1.1l-0.27,1.43l-0.64,0.62l-1.74,-0.02l-1.1,0.74l0.01,1.18l-1.36,0.81l-1.55,-0.27l-1.88,0.98l-1.3,0.16l-0.92,-2.04l-2.19,-4.84l8.41,-2.96l1.87,-5.97l-1.29,-2.14l0.07,-1.22l0.82,-1.26l0.01,-1.25l1.27,-0.6l-0.5,-0.42l0.23,-2l1.43,-0.01l1.26,2.09l1.57,1.11l2.06,0.4l1.66,0.55l1.27,1.74l0.76,1l1,0.38l-0.01,0.67l-1.02,1.79l-0.45,0.84L640.29,403.18zM633.37,388.64L633,389.2l-0.53,-1.06l0.82,-1.06l0.35,0.27L633.37,388.64z"
          }, {
            "id": "PA",
            "title": "Panama",
            "d": "M256.88,443.21L255.95,442.4L255.35,440.88L256.04,440.13L255.33,439.94L254.81,439.01L253.41,438.23L252.18,438.41L251.62,439.39L250.48,440.09L249.87,440.19L249.6,440.78L250.93,442.3L250.17,442.66L249.76,443.08L248.46,443.22L247.97,441.54L247.61,442.02L246.68,441.86L246.12,440.72L244.97,440.54L244.24,440.21L243.04,440.21L242.95,440.82L242.63,440.4L242.78,439.84L243.01,439.27L242.9,438.76L243.32,438.42L242.74,438L242.72,436.87L243.81,436.62L244.81,437.63L244.75,438.23L245.87,438.35L246.14,438.12L246.91,438.82L248.29,438.61L249.48,437.9L251.18,437.33L252.14,436.49L253.69,436.65L253.58,436.93L255.15,437.03L256.4,437.52L257.31,438.36L258.37,439.14L258.03,439.56L258.68,441.21L258.15,442.05L257.24,441.85z"
          }, {
            "id": "PE",
            "title": "Peru",
            "d": "M280.13,513.14L279.38,514.65L277.94,515.39L275.13,513.71L274.88,512.51L269.33,509.59L264.3,506.42L262.13,504.64L260.97,502.27L261.43,501.44L259.06,497.69L256.29,492.45L253.65,486.83L252.5,485.54L251.62,483.48L249.44,481.64L247.44,480.51L248.35,479.26L246.99,476.59L247.86,474.64L250.1,472.87L250.43,474.04L249.63,474.7L249.7,475.72L250.86,475.5L252,475.8L253.17,477.21L254.76,476.06L255.29,474.18L257.01,471.75L260.38,470.65L263.44,467.73L264.31,465.92L263.92,463.81L264.67,463.54L266.53,464.86L267.42,466.18L268.72,466.9L270.37,469.82L272.46,470.17L274.01,469.43L275.02,469.91L276.7,469.67L278.85,470.98L277.04,473.82L277.88,473.88L279.28,475.37L276.75,475.24L276.38,475.66L274.08,476.19L270.88,478.1L270.67,479.4L269.96,480.38L270.24,481.89L268.54,482.7L268.54,483.89L267.8,484.4L268.97,486.93L270.53,488.65L269.94,489.86L271.8,490.02L272.86,491.53L275.33,491.6L277.63,489.94L277.44,494.24L278.72,494.57L280.3,494.08L282.73,498.66L282.12,499.62L281.99,501.64L281.93,504.08L280.83,505.52L281.34,506.59L280.69,507.56L281.9,510z"
          }, {
            "id": "PG",
            "title": "Papua New Guinea",
            "d": "M912.32,482.42l-0.79,0.28l-1.21,-1.08l-1.23,-1.78l-0.6,-2.13l0.39,-0.27l0.3,0.83l0.85,0.63l1.36,1.77l1.32,0.95L912.32,482.42zM901.39,478.67l-1.47,0.23l-0.44,0.79l-1.53,0.68l-1.44,0.66l-1.49,0l-2.3,-0.81l-1.6,-0.78l0.23,-0.87l2.51,0.41l1.53,-0.22l0.42,-1.34l0.4,-0.07l0.27,1.49l1.6,-0.21l0.79,-0.96l1.57,-1l-0.31,-1.65l1.68,-0.05l0.57,0.46l-0.06,1.55L901.39,478.67zM887.96,484.02l2.5,1.84l1.82,2.99l1.61,-0.09l-0.11,1.25l2.17,0.48l-0.84,0.53l2.98,1.19l-0.31,0.82l-1.86,0.2l-0.69,-0.73l-2.41,-0.32l-2.83,-0.43l-2.18,-1.8l-1.59,-1.55l-1.46,-2.46l-3.66,-1.23l-2.38,0.8l-1.71,0.93l0.36,2.08l-2.2,0.97l-1.57,-0.47l-2.9,-0.12l-0.05,-9.16l-0.05,-9.1l4.87,1.92l5.18,1.6l1.93,1.43l1.56,1.41l0.43,1.65l4.67,1.73l0.68,1.49l-2.58,0.3L887.96,484.02zM904.63,475.93l-0.88,0.74l-0.53,-1.65l-0.65,-1.08l-1.27,-0.91l-1.6,-1.19l-2.02,-0.82l0.78,-0.67l1.51,0.78l0.95,0.61l1.18,0.67l1.12,1.17l1.07,0.89L904.63,475.93z"
          }, {
            "id": "PH",
            "title": "Philippines",
            "d": "M829.59,439.86l0.29,1.87l0.17,1.58l-0.96,2.57l-1.02,-2.86l-1.31,1.42l0.9,2.06l-0.8,1.31l-3.3,-1.63l-0.79,-2.03l0.86,-1.33l-1.78,-1.33l-0.88,1.17l-1.32,-0.11l-2.08,1.57l-0.46,-0.82l1.1,-2.37l1.77,-0.79l1.53,-1.06l0.99,1.27l2.13,-0.77l0.46,-1.26l1.98,-0.08l-0.17,-2.18l2.27,1.34l0.24,1.42L829.59,439.86zM822.88,434.6l-1.01,0.93l-0.88,1.79l-0.88,0.84l-1.73,-1.95l0.58,-0.76l0.7,-0.79l0.31,-1.76l1.55,-0.17l-0.45,1.91l2.08,-2.74L822.88,434.6zM807.52,437.32l-3.73,2.67l1.38,-1.97l2.03,-1.74l1.68,-1.96l1.47,-2.82l0.5,2.31l-1.85,1.56L807.52,437.32zM817,430.02l1.68,0.88l1.78,0l-0.05,1.19l-1.3,1.2l-1.78,0.85l-0.1,-1.32l0.2,-1.45L817,430.02zM827.14,429.25l0.79,3.18l-2.16,-0.75l0.06,0.95l0.69,1.75l-1.33,0.63l-0.12,-1.99l-0.84,-0.15l-0.44,-1.72l1.65,0.23l-0.04,-1.08l-1.71,-2.18l2.69,0.06L827.14,429.25zM816,426.66l-0.74,2.47l-1.2,-1.42l-1.43,-2.18l2.4,0.1L816,426.66zM815.42,410.92l1.73,0.84l0.86,-0.76l0.25,0.75l-0.46,1.22l0.96,2.09l-0.74,2.42l-1.65,0.96l-0.44,2.33l0.63,2.29l1.49,0.32l1.24,-0.34l3.5,1.59l-0.27,1.56l0.92,0.69l-0.29,1.32l-2.18,-1.4l-1.04,-1.5l-0.72,1.05l-1.79,-1.72l-2.55,0.42l-1.4,-0.63l0.14,-1.19l0.88,-0.73l-0.84,-0.67l-0.36,1.04l-1.38,-1.65l-0.42,-1.26l-0.1,-2.77l1.13,0.96l0.29,-4.55l0.91,-2.66L815.42,410.92z"
          }, {
            "id": "PL",
            "title": "Poland",
            "d": "M517.36,296.97L516.21,294.11L516.43,292.55L515.73,290.1L514.72,288.45L515.5,287.2L514.84,284.81L516.76,283.42L521.13,281.2L524.67,279.56L527.46,280.38L527.67,281.56L530.38,281.62L533.83,282.17L538.99,282.09L540.43,282.61L541.1,284.07L541.22,286.16L542,287.94L541.98,289.79L540.3,290.73L541.17,292.85L541.22,294.86L542.63,298.75L542.33,299.99L540.94,300.5L538.39,304.11L539.11,306.03L538.5,305.78L535.84,304.14L533.82,304.74L532.5,304.3L530.84,305.22L529.43,303.7L528.27,304.28L528.11,304.02L526.82,301.89L524.74,301.63L524.47,300.26L522.55,299.77L522.13,300.9L520.61,300L520.78,298.79L518.69,298.4z"
          }, {
            "id": "PK",
            "title": "Pakistan",
            "d": "M685.99,351.76L688.06,353.39L688.89,356.05L693.5,357.44L690.79,360.3L687.67,360.81L683.41,359.98L682.04,361.44L683.03,364.39L684,366.64L686.27,368.27L683.88,370.18L683.92,372.51L681.2,375.75L679.44,379.01L676.51,382.33L673.25,382.09L670.16,385.39L672,386.79L672.32,389.18L673.89,390.74L674.45,393.38L668.28,393.37L666.41,395.41L664.36,394.64L663.52,392.44L661.35,390.1L656.19,390.68L651.63,390.73L647.68,391.17L648.74,387.57L652.78,385.96L652.55,384.52L651.21,384.01L651.13,381.24L648.45,379.84L647.32,377.91L645.94,376.23L650.63,377.87L653.44,377.39L655.11,377.79L655.68,377.09L657.63,377.37L661.28,376.04L661.38,373.29L662.94,371.45L665.03,371.45L665.33,370.54L667.48,370.11L668.51,370.41L669.61,369.49L669.46,367.51L670.65,365.51L672.43,364.66L671.33,362.44L674,362.55L674.77,361.33L674.65,360.03L676.05,358.6L675.72,356.9L675.06,355.44L676.7,353.93L679.71,353.2L682.93,352.8L684.35,352.15z"
          }, {
            "id": "PR",
            "title": "Puerto Rico",
            "d": "M289.41,410.89L290.84,411.15L291.35,411.73L290.63,412.47L288.52,412.45L286.88,412.55L286.72,411.3L287.11,410.87z"
          }, {
            "id": "PS",
            "title": "Palestinian Territories",
            "d": "M574.92,367.87L574.92,369.88L574.5,370.84L573.18,371.29L573.31,370.43L574.02,369.97L573.32,369.61L573.9,367.41z"
          }, {
            "id": "PT",
            "title": "Portugal",
            "d": "M449.92,334.56L450.94,333.61L452.08,333.06L452.79,334.9L454.44,334.89L454.92,334.42L456.56,334.55L457.34,336.43L456.04,337.43L456.01,340.31L455.55,340.84L455.44,342.56L454.23,342.86L455.35,345.03L454.58,347.38L455.54,348.44L455.16,349.4L454.12,350.72L454.35,351.88L453.23,352.79L451.75,352.3L450.3,352.68L450.73,349.94L450.47,347.76L449.21,347.43L448.54,346.08L448.77,343.72L449.88,342.41L450.08,340.94L450.67,338.73L450.6,337.16L450.04,335.82z"
          }, {
            "id": "PY",
            "title": "Paraguay",
            "d": "M299.49,526.99L300.6,523.4L300.67,521.8L302.01,519.18L306.9,518.32L309.5,518.37L312.12,519.88L312.16,520.79L312.99,522.45L312.81,526.51L315.77,527.09L316.91,526.5L318.8,527.32L319.33,528.22L319.59,530.99L319.92,532.17L320.96,532.3L322.01,531.81L323.02,532.36L323.02,534.04L322.64,535.86L322.09,537.64L321.63,540.39L319.09,542.79L316.87,543.29L313.72,542.81L310.9,541.96L313.66,537.23L313.25,535.86L310.37,534.66L306.94,532.4L304.65,531.94z"
          }, {
            "id": "QA",
            "title": "Qatar",
            "d": "M617.72,392.16L617.53,389.92L618.29,388.3L619.05,387.96L619.9,388.93L619.95,390.74L619.34,392.55L618.56,392.77z"
          }, {
            "id": "RO",
            "title": "Romania",
            "d": "M538.93,310.86L540.14,309.97L541.88,310.43L543.67,310.45L544.97,311.46L545.93,310.82L548,310.42L548.71,309.44L549.89,309.45L550.74,309.85L551.61,311.09L552.5,312.84L554.12,315.28L554.21,317.07L553.91,318.79L554.42,320.62L555.67,321.35L556.98,320.71L558.26,321.39L558.32,322.42L556.96,323.26L556.11,322.9L555.33,327.61L553.68,327.2L551.64,325.79L548.34,326.69L546.95,327.68L542.83,327.48L540.67,326.87L539.59,327.16L538.78,325.56L538.27,324.88L538.92,324.22L538.22,323.73L537.34,324.61L535.71,323.47L535.49,321.84L533.78,320.9L533.47,319.63L531.95,318.05L534.2,317.29L535.89,314.53L537.22,311.73z"
          }, {
            "id": "RS",
            "title": "Serbia",
            "d": "M533.78,320.9L535.49,321.84L535.71,323.47L537.34,324.61L538.22,323.73L538.92,324.22L538.27,324.88L538.78,325.56L538.09,326.44L538.34,327.86L539.7,329.52L538.63,330.71L538.16,331.92L538.47,332.37L538,332.91L536.71,332.97L535.75,333.19L535.66,332.91L535.99,332.46L536.31,331.53L535.91,331.55L535.36,330.85L534.9,330.67L534.54,330.06L534.01,329.82L533.61,329.28L533.11,329.5L532.72,330.76L532.05,331.04L532.28,330.71L531.21,329.92L530.29,329.51L529.88,328.97L529.14,328.31L529.8,328.14L530.21,326.32L528.86,324.82L529.56,323.1L528.54,323.11L529.62,321.62L528.73,320.48L528.05,318.93L530.2,317.88L531.95,318.05L533.47,319.63z"
          }, {
            "id": "RU",
            "title": "Russia",
            "d": "M1008.27,215.75l-2.78,2.97l-4.6,0.7l-0.07,6.46l-1.12,1.35l-2.63,-0.19l-2.14,-2.26l-3.73,-1.92l-0.63,-2.89l-2.85,-1.1l-3.19,0.87l-1.52,-2.37l0.61,-2.55l-3.36,1.64l1.26,3.19l-1.59,2.83l-0.02,0.04l-3.6,2.89l-3.63,-0.48l2.53,3.44l1.67,5.2l1.29,1.67l0.33,2.53l-0.72,1.6l-5.23,-1.32l-7.84,4.51l-2.49,0.69l-4.29,4.1l-4.07,3.5l-1.03,2.55l-4.01,-3.9l-7.31,4.42l-1.28,-2.08l-2.7,2.39l-3.75,-0.76l-0.9,3.63l-3.36,5.22l0.1,2.14l3.19,1.17l-0.38,7.46l-2.6,0.19l-1.2,4.15l1.17,2.1l-4.9,2.47l-0.97,5.4l-4.18,1.14l-0.84,4.66l-4.04,4.18l-1.04,-3.08l-1.2,-6.69l-1.56,-10.65l1.35,-6.95l2.37,-3.07l0.15,-2.44l4.36,-1.18l5.01,-6.78l4.83,-5.73l5.04,-4.57l2.25,-8.37l-3.41,0.51l-1.68,4.92l-7.11,6.36l-2.3,-7.14l-7.24,2l-7.02,9.56l2.32,3.38l-6.26,1.42l-4.33,0.56l0.2,-3.95l-4.36,-0.84l-3.47,2.7l-8.57,-0.94l-9.22,1.62l-9.08,10.33l-10.75,11.78l4.42,0.61l1.38,3l2.72,1.05l1.79,-2.38l3.08,0.31l4.05,5.19l0.09,3.92l-2.19,4.51l-0.24,5.27l-1.26,6.85l-4.23,6.01l-0.94,2.82l-3.81,4.66l-3.78,4.53l-1.81,2.28l-3.74,2.25l-1.77,0.05l-1.76,-1.86l-3.76,2.79l-0.44,1.26l-0.39,-0.66l-0.02,-1.93l1.43,-0.1l0.4,-4.55l-0.74,-3.36l2.41,-1.4l3.4,0.7l1.89,-3.89l0.96,-4.46l1.09,-1.51l1.47,-3.76l-4.63,1.24l-2.43,1.65l-4.26,0l-1.13,-3.95l-3.32,-3.03l-4.88,-1.38l-1.04,-4.28l-0.98,-2.73l-1.05,-1.94l-1.73,-4.61l-2.46,-1.71l-4.2,-1.39l-3.72,0.13l-3.48,0.84l-2.32,2.31l1.54,1.1l0.04,2.52l-1.56,1.45l-2.53,4.72l0.03,1.93l-3.95,2.74l-3.37,-1.63l-3.35,0.36l-1.47,-1.46l-1.68,-0.47l-4.11,3.06l-3.69,0.71l-2.58,1.06l-3.53,-0.7l-2.6,0.04l-1.7,-2.2l-2.75,-2.09l-2.81,-0.58l-3.55,0.57l-2.65,0.81l-3.98,-1.84l-0.53,-3.32l-3.3,-1.15l-2.54,-0.53l-3.14,-1.87l-2.9,4.66l1.14,2.6l-2.73,3.03l-4.05,-1.09l-2.8,-0.16l-1.87,-2.04l-2.92,-0.06l-2.44,-1.35l-4.26,2.07l-5.35,3.74l-2.96,0.74l-1.1,0.35l-1.49,-2.63l-3.61,0.58l-1.19,-1.84l-1.96,-0.85l-1.35,-2.55l-1.55,-0.8l-4.03,1.14l-3.86,-2.57l-1.49,2.33l-6.27,-11.58l-3.58,-3.66l1.03,-1.5l-7.03,4.49l-2.69,0.27l0.23,-2.58l-3.6,-1.63l-2.93,1.17l-0.88,-5.01l-5.04,-1.06l-2.52,2.03l-7.02,1.79l-1.37,1.19l-10.49,1.66l-1.29,1.62l2.02,3.21l-2.69,1.2l0.53,1.25l-2.69,2.22l4.54,3.1l-0.7,2.11l-3.94,-0.19l-0.81,1.31l-3.59,-2.29l-4.45,0.09l-2.98,1.87l-3.32,-1.79l-6.18,-3.1l-4.38,0.12l-5.79,4.85l-0.35,3.19l-2.88,-2.53l-2.24,4.77l0.82,0.87l-1.62,3.21l2.38,2.84l2.08,-0.12l1.79,2.76l-0.28,2.1l1.42,0.66l-1.28,2.39l-2.72,0.66l-2.79,4.09l2.55,3.7l-0.28,2.59l3.06,4.46l-1.67,1.51l-0.48,0.95l-1.24,-0.25l-1.93,-2.27l-0.79,-0.13l-1.76,-0.87l-0.86,-1.55l-2.62,-0.79l-1.7,0.6l-0.49,-0.71l-3.82,-1.83l-4.13,-0.62l-2.37,-0.66l-0.34,0.45l-3.57,-3.27l-3.2,-1.48l-2.42,-2.32l2.04,-0.64l2.33,-3.35l-1.57,-1.6l4.13,-1.67l-0.07,-0.9l-2.52,0.66l0.09,-1.83l1.45,-1.16l2.71,-0.31l0.44,-1.4l-0.62,-2.33l1.14,-2.23l-0.03,-1.26l-4.13,-1.41l-1.64,0.05l-1.73,-2.04l-2.15,0.69l-3.56,-1.54l0.06,-0.87l-1,-1.93l-2.24,-0.22l-0.23,-1.39l0.7,-0.91l-1.79,-2.58l-2.91,0.44l-0.85,-0.23l-0.71,1.04l-1.05,-0.18l-0.69,-2.94l-0.66,-1.54l0.54,-0.44l2.26,0.16l1.09,-1.02l-0.81,-1.25l-1.89,-0.83l0.17,-0.86l-1.14,-0.87l-1.76,-3.15l0.6,-1.31l-0.27,-2.31l-2.74,-1.18l-1.47,0.59l-0.4,-1.24l-2.95,-1.26l-0.9,-2.99l-0.24,-2.49l-1.35,-1.19l1.2,-1.66l-0.83,-4.96l2,-3.13l-0.42,-0.96l3.19,-3.07l-2.94,-2.68l6,-7.41l2.6,-3.45l1.05,-3.1l-4.15,-4.26l1.15,-4.15l-2.52,-4.85l1.89,-5.76l-3.26,-7.96l2.59,-5.48l-4.29,-4.99l0.41,-5.4l2.26,-0.72l4.77,-3.19l2.89,-2.81l4.61,4.86l7.68,1.88l10.59,8.65l2.15,3.51l0.19,4.8l-3.11,3.69l-4.58,1.85l-12.52,-5.31l-2.06,0.9l4.57,5.1l0.18,3.15l0.18,6.75l3.61,1.97l2.19,1.66l0.36,-3.11l-1.69,-2.8l1.78,-2.51l6.78,4.1l2.36,-1.59l-1.89,-4.88l6.53,-6.74l2.59,0.4l2.62,2.43l1.63,-4.81l-2.34,-4.28l1.37,-4.41l-2.06,-4.69l7.84,2.44l1.6,4.18l-3.55,0.91l0.02,4.04l2.21,2.44l4.33,-1.54l0.69,-4.61l5.86,-3.52l9.79,-6.54l2.11,0.38l-2.76,4.64l3.48,0.78l2.01,-2.58l5.25,-0.21l4.16,-3.19l3.2,4.62l3.19,-5.09l-2.94,-4.58l1.46,-2.66l8.28,2.44l3.88,2.49l10.16,8.8l1.88,-3.97l-2.85,-4.11l-0.08,-1.68l-3.38,-0.78l0.92,-3.83l-1.5,-6.49l-0.08,-2.74l5.17,-7.99l1.84,-8.42l2.08,-1.88l7.42,2.51l0.58,5.18l-2.66,7.28l1.74,2.78l0.9,5.94l-0.64,11.07l3.09,4.73l-1.2,5.01l-5.49,10.2l3.21,1.02l1.12,-2.51l3.08,-1.82l0.74,-3.55l2.43,-3.49l-1.63,-4.26l1.31,-5.08l-3.07,-0.64l-0.67,-4.42l2.24,-8.28l-3.64,-7.03l5.02,-6.04l-0.65,-6.62l1.4,-0.22l1.47,5.19l-1.11,8.67l3,1.59l-1.28,-6.37l4.69,-3.58l5.82,-0.49l5.18,5.18l-2.49,-7.62l-0.28,-10.28l4.88,-2.02l6.74,0.44l6.08,-1.32l-2.28,-5.38l3.25,-7.02l3.22,-0.3l5.45,-5.51l7.4,-1.51l0.94,-3.15l7.36,-1.08l2.29,2.61l6.29,-6.24l5.15,0.2l0.77,-5.24l2.68,-5.33l6.62,-5.31l4.81,4.21l-3.82,3.13l6.35,1.92l0.76,6.03l2.56,-2.94l8.2,0.16l6.32,5.84l2.25,4.35l-0.7,5.85l-3.1,3.24l-7.37,5.92l-2.11,3.08l3.48,1.43l4.15,2.55l2.52,-1.91l1.43,6.39l1.23,-2.56l4.48,-1.57l9,1.65l0.68,4.58l11.72,1.43l0.16,-7.47l5.95,1.74l4.48,-0.05l4.53,5.14l1.29,6.04l-1.66,3.84l3.52,6.98l4.41,3.49l2.71,-9.18l4.5,4l4.78,-2.38l5.43,2.72l2.07,-2.47l4.59,1.24l-2.02,-8.4l3.7,-4.07l25.32,6.06l2.39,5.35l7.34,6.65l11.32,-1.62l5.58,1.41l2.33,3.5l-0.34,6.02l3.45,2.29l3.75,-1.64l4.97,-0.21l5.29,1.57l5.31,-0.89l4.88,6.99l3.47,-2.48l-2.27,-5.07l1.25,-3.62l8.95,2.29l5.83,-0.49l8.06,3.84l3.92,3.44l6.87,5.86l7.35,7.34l-0.24,4.44l1.89,1.74l-0.65,-5.15l7.61,1.07L1008.27,215.75zM880.84,306.25l-2.82,-7.68l-1.16,-4.51l0.07,-4.5l-0.97,-4.5l-0.73,-3.15l-1.25,0.67l1.11,2.21l-2.59,2.17l-0.25,6.3l1.64,4.41l-0.12,5.85l-0.65,3.24l0.32,4.54l-0.31,4.01l0.52,3.4l1.84,-3.13l2.13,2.44l0.08,-2.84l-2.73,-4.23l1.72,-6.11L880.84,306.25zM537.82,278.77l-2.94,-0.86l-3.87,1.58l-0.64,2.13l3.45,0.55l5.16,-0.07l-0.22,-1.23l0.3,-1.33L537.82,278.77zM979.95,178.65l3.66,-0.52l2.89,-2.06l0.24,-1.19l-4.06,-2.51l-2.38,-0.02l-0.36,0.37l-3.57,3.64l0.5,2.73L979.95,178.65zM870.07,151.56l-2.66,3.92l0.49,0.52l5.75,1.08l4.25,-0.07l-0.34,-2.57l-3.98,-3.81L870.07,151.56zM894.64,142.03l3.24,-4.25l-7.04,-2.88l-5.23,-1.68l-0.67,3.59l5.21,4.27L894.64,142.03zM869.51,140.34l10.33,0.3l2.21,-8.14l-10.13,-6.07l-7.4,-0.51l-3.7,2.18l-1.51,7.75l5.55,7.01L869.51,140.34zM622.39,166.28l-2.87,1.96l0.41,4.83l5.08,2.35l0.74,3.82l9.16,1.1l1.66,-0.74l-5.36,-7.11l-0.57,-7.52l4.39,-9.14l4.18,-9.82l8.71,-10.17l8.56,-5.34l9.93,-5.74l1.88,-3.71l-1.95,-4.83l-5.46,1.6l-4.8,4.49l-9.33,2.22l-9.26,7.41l-6.27,5.85l0.76,4.87l-6.71,9.03l2.58,1.22l-5.56,8.27L622.39,166.28zM769.87,98.34l0.83,-5.72l-7.11,-8.34l-2.11,-0.98l-2.3,1.7l-5.12,18.6L769.87,98.34zM605.64,69.03l3.04,3.88l3.28,-2.69l0.39,-2.72l2.52,-1.27l3.76,-2.23l1.08,-2.62l-4.16,-3.85l-2.64,2.9l-1.61,4.12l-0.57,-4.65l-4.26,0.21L601,63.25l6.24,0.52L605.64,69.03zM736.89,82.07l4.65,5.73l7.81,4.2l6.12,-1.8l0.69,-13.62l-6.46,-16.04l-5.45,-9.02l-6.07,4.11l-7.28,11.83l3.83,3.27L736.89,82.07z"
          }, {
            "id": "RW",
            "title": "Rwanda",
            "d": "M560.54,466.55L561.66,468.12L561.49,469.76L560.69,470.11L559.2,469.93L558.34,471.52L556.63,471.3L556.89,469.77L557.28,469.56L557.38,467.9L558.19,467.12L558.87,467.41z"
          }, {
            "id": "SA",
            "title": "Saudi Arabia",
            "d": "M595.2,417.22L594.84,415.98L593.99,415.1L593.77,413.93L592.33,412.89L590.83,410.43L590.04,408.02L588.1,405.98L586.85,405.5L584.99,402.65L584.67,400.57L584.79,398.78L583.18,395.42L581.87,394.23L580.35,393.6L579.43,391.84L579.58,391.15L578.8,389.55L577.98,388.86L576.89,386.54L575.18,384.02L573.75,381.86L572.36,381.87L572.79,380.13L572.92,379.02L573.26,377.74L576.38,378.25L577.6,377.27L578.27,376.11L580.41,375.67L580.87,374.58L581.8,374.04L579,370.78L584.62,369.13L585.15,368.64L588.53,369.53L592.71,371.82L600.61,378.31L605.82,378.57L608.32,378.88L609.02,380.39L611,380.31L612.1,383.04L613.48,383.75L613.96,384.86L615.87,386.17L616.04,387.46L615.76,388.49L616.12,389.53L616.92,390.4L617.3,391.41L617.72,392.16L618.56,392.77L619.34,392.55L619.87,393.72L619.98,394.43L621.06,397.51L629.48,399.03L630.05,398.39L631.33,400.53L629.46,406.5L621.05,409.46L612.97,410.59L610.35,411.91L608.34,414.98L607.03,415.46L606.33,414.49L605.26,414.64L602.55,414.35L602.03,414.05L598.8,414.12L598.04,414.39L596.89,413.63L596.14,415.06L596.43,416.29z"
          }, {
            "id": "SB",
            "title": "Solomon Islands",
            "d": "M929.81,492.75l0.78,0.97l-1.96,-0.02l-1.07,-1.74l1.67,0.69L929.81,492.75zM926.26,491.02l-1.09,0.06l-1.72,-0.29l-0.59,-0.44l0.18,-1.12l1.85,0.44l0.91,0.59L926.26,491.02zM928.58,490.25l-0.42,0.52l-2.08,-2.45l-0.58,-1.68h0.95l1.01,2.25L928.58,490.25zM923.52,486.69l0.12,0.57l-2.2,-1.19l-1.54,-1.01l-1.05,-0.94l0.42,-0.29l1.29,0.67l2.3,1.29L923.52,486.69zM916.97,483.91l-0.56,0.16l-1.23,-0.64l-1.15,-1.15l0.14,-0.47l1.67,1.18L916.97,483.91z"
          }, {
            "id": "SD",
            "title": "Sudan",
            "d": "M570.48,436.9L570.09,436.85L570.14,435.44L569.8,434.47L568.36,433.35L568.02,431.3L568.36,429.2L567.06,429.01L566.87,429.64L565.18,429.79L565.86,430.62L566.1,432.33L564.56,433.89L563.16,435.93L561.72,436.22L559.36,434.57L558.3,435.15L558.01,435.98L556.57,436.51L556.47,437.09L553.68,437.09L553.29,436.51L551.27,436.41L550.26,436.9L549.49,436.65L548.05,435L547.57,434.23L545.54,434.62L544.77,435.93L544.05,438.45L543.09,438.98L542.23,439.29L542,439.15L541.03,438.34L540.85,437.47L541.3,436.29L541.3,435.14L539.68,433.37L539.36,432.15L539.39,431.46L538.36,430.63L538.33,428.97L537.75,427.87L536.76,428.04L537.04,426.99L537.77,425.79L537.45,424.61L538.37,423.73L537.79,423.06L538.53,421.28L539.81,419.15L542.23,419.35L542.09,407.74L542.13,406.5L545.35,406.49L545.35,400.53L556.62,400.53L567.5,400.53L578.62,400.53L579.52,403.47L578.91,404.01L579.32,407.07L580.35,410.59L581.41,411.32L582.95,412.4L581.53,414.07L579.46,414.55L578.58,415.45L578.31,417.38L577.1,421.63L577.4,422.78L576.95,425.25L575.81,428.06L574.12,429.48L572.92,431.65L572.63,432.81L571.31,433.61L570.48,436.57z"
          }, {
            "id": "SE",
            "title": "Sweden",
            "d": "M537.45,217.49L534.73,222.18L535.17,226.2L530.71,231.33L525.3,236.67L523.25,245.08L525.25,249.15L527.93,252.29L525.36,258.52L522.44,259.78L521.37,268.62L519.78,273.38L516.38,272.89L514.79,276.84L511.54,277.07L510.65,272.36L508.3,266.55L506.17,259.05L507.41,255.9L509.74,252.09L510.67,245.36L508.88,242.38L508.7,234.34L510.53,228.43L513.31,228.54L514.28,225.99L513.26,223.76L517.61,214.26L520.42,206.39L522.27,201.15L524.96,201.17L525.71,196.96L530.99,198.18L531.4,193.1L533.14,192.77L536.88,196.58L541.25,201.73L541.33,212.85L542.27,215.55z"
          }, {
            "id": "SI",
            "title": "Slovenia",
            "d": "M513.96,316.51L516.28,316.82L517.7,315.9L520.15,315.8L520.68,315.11L521.15,315.16L521.7,316.53L519.47,317.61L519.19,319.23L518.22,319.64L518.23,320.76L517.13,320.68L516.18,320.03L515.66,320.71L513.71,320.57L514.33,320.21L513.66,318.5z"
          }, {
            "id": "SJ",
            "title": "Svalbard and Jan Mayen",
            "d": "M544.58,104.49l-6.26,5.36l-4.95,-3.02l1.94,-3.42l-1.69,-4.34l5.81,-2.78l1.11,5.18L544.58,104.49zM526.43,77.81l9.23,11.29l-7.06,5.66l-1.56,10.09l-2.46,2.49l-1.33,10.51l-3.38,0.48l-6.03,-7.64l2.54,-4.62l-4.2,-3.86l-5.46,-11.82l-2.18,-11.79l7.64,-5.69l1.54,5.56l3.99,-0.22l1.06,-5.43l4.12,-0.56L526.43,77.81zM546.6,66.35l5.5,5.8l-4.16,8.52l-8.13,1.81l-8.27,-2.56l-0.5,-4.32l-4.02,-0.28l-3.07,-7.48l8.66,-4.72l4.07,4.08l2.84,-5.09L546.6,66.35z"
          }, {
            "id": "SK",
            "title": "Slovakia",
            "d": "M528.11,304.02L528.27,304.28L529.43,303.7L530.84,305.22L532.5,304.3L533.82,304.74L535.84,304.14L538.5,305.78L537.73,306.89L537.18,308.6L536.58,309.03L533.58,307.75L532.66,308L532,309L530.68,309.52L530.38,309.25L529.02,309.9L527.9,310.03L527.68,310.87L525.32,311.38L524.29,310.92L522.86,309.85L522.58,308.4L522.81,307.86L523.2,306.93L524.45,307L525.4,306.56L525.48,306.17L526.02,305.96L526.2,304.99L526.84,304.8L527.28,304.03z"
          }, {
            "id": "SL",
            "title": "Sierra Leone",
            "d": "M443.18,444.44L442.42,444.23L440.41,443.1L438.95,441.6L438.46,440.57L438.11,438.49L439.61,437.25L439.93,436.46L440.41,435.85L441.19,435.79L441.84,435.26L444.08,435.26L444.86,436.27L445.47,437.46L445.38,438.28L445.83,439.02L445.8,440.05L446.57,439.89L445.26,441.2L444,442.73L443.85,443.54z"
          }, {
            "id": "SN",
            "title": "Senegal",
            "d": "M428.39,425.16L427.23,422.92L425.83,421.9L427.07,421.35L428.43,419.32L429.09,417.83L430.05,416.9L431.45,417.15L432.81,416.52L434.38,416.49L435.72,417.34L437.58,418.11L439.28,420.24L441.13,422.22L441.26,424.01L441.81,425.65L442.86,426.46L443.1,427.56L442.97,428.45L442.56,428.61L441.04,428.39L440.83,428.7L440.21,428.77L438.19,428.07L436.84,428.04L431.66,427.92L430.91,428.24L429.98,428.15L428.49,428.62L428.03,426.43L430.58,426.49L431.26,426.09L431.76,426.06L432.8,425.4L434,426.01L435.22,426.06L436.43,425.41L435.87,424.59L434.94,425.07L434.07,425.06L432.97,424.35L432.08,424.4L431.44,425.07z"
          }, {
            "id": "SO",
            "title": "Somalia",
            "d": "M618.63,430.43L618.56,429.64L617.5,429.65L616.17,430.63L614.68,430.91L613.39,431.33L612.5,431.39L610.9,431.49L609.9,432.01L608.51,432.2L606.04,433.08L602.99,433.41L600.34,434.14L598.95,434.13L597.69,432.94L597.14,431.77L596.23,431.24L595.19,432.76L594.58,433.77L595.62,435.33L596.65,436.69L597.72,437.7L606.89,441.04L609.25,441.02L601.32,449.44L597.67,449.56L595.17,451.53L593.38,451.58L592.61,452.46L590.16,455.63L590.19,465.78L591.85,468.07L592.48,467.41L593.13,465.95L596.2,462.57L598.81,460.45L603.01,457.69L605.81,455.43L609.11,451.62L611.5,448.49L613.91,444.39L615.64,440.8L616.99,437.65L617.78,434.6L618.38,433.58L618.37,432.08z"
          }, {
            "id": "SR",
            "title": "Suriname",
            "d": "M315.02,446.72L318.38,447.28L318.68,446.77L320.95,446.57L323.96,447.33L322.5,449.73L322.72,451.64L323.83,453.3L323.34,454.5L323.09,455.77L322.37,456.94L320.77,456.35L319.44,456.64L318.31,456.39L318.03,457.2L318.5,457.75L318.25,458.32L316.72,458.09L315.01,455.67L314.64,454.1L313.75,454.09L312.5,452.07L313.02,450.62L312.87,449.97L314.57,449.24z"
          }, {
            "id": "SS",
            "title": "South Sudan",
            "d": "M570.48,436.9L570.51,439.1L570.09,439.96L568.61,440.03L567.65,441.64L569.37,441.84L570.79,443.21L571.29,444.33L572.57,444.98L574.22,448.03L572.32,449.87L570.6,451.54L568.87,452.82L566.9,452.82L564.64,453.47L562.86,452.84L561.71,453.61L559.24,451.75L558.57,450.56L557.01,451.15L555.71,450.96L554.96,451.43L553.7,451.1L552.01,448.79L551.56,447.9L549.46,446.79L548.75,445.11L547.58,443.9L545.7,442.44L545.67,441.52L544.14,440.39L542.23,439.29L543.09,438.98L544.05,438.45L544.77,435.93L545.54,434.62L547.57,434.23L548.05,435L549.49,436.65L550.26,436.9L551.27,436.41L553.29,436.51L553.68,437.09L556.47,437.09L556.57,436.51L558.01,435.98L558.3,435.15L559.36,434.57L561.72,436.22L563.16,435.93L564.56,433.89L566.1,432.33L565.86,430.62L565.18,429.79L566.87,429.64L567.06,429.01L568.36,429.2L568.02,431.3L568.36,433.35L569.8,434.47L570.14,435.44L570.09,436.85z"
          }, {
            "id": "SV",
            "title": "El Salvador",
            "d": "M229.09,425.76L228.78,426.43L227.16,426.39L226.15,426.12L224.99,425.55L223.43,425.37L222.64,424.75L222.73,424.33L223.69,423.61L224.21,423.29L224.06,422.95L224.72,422.78L225.55,423.02L226.15,423.59L227,424.05L227.1,424.44L228.33,424.1L228.91,424.3L229.29,424.61z"
          }, {
            "id": "SY",
            "title": "Syria",
            "d": "M584.02,364.6L578.53,368.14L575.41,366.82L575.35,366.8L575.73,366.3L575.69,364.93L576.38,363.1L577.91,361.83L577.45,360.51L576.19,360.33L575.93,357.72L576.61,356.31L577.36,355.56L578.11,354.8L578.27,352.86L579.18,353.54L582.27,352.57L583.76,353.22L586.07,353.21L589.29,351.9L590.81,351.96L594,351.42L592.56,353.6L591.02,354.46L591.29,356.98L590.23,361.1z"
          }, {
            "id": "SZ",
            "title": "Swaziland",
            "d": "M565.18,540.74L564.61,542.13L562.97,542.46L561.29,540.77L561.27,539.69L562.03,538.52L562.3,537.62L563.11,537.4L564.52,537.97L564.94,539.36z"
          }, {
            "id": "TD",
            "title": "Chad",
            "d": "M515.9,427.26L516.18,425.92L514.38,425.85L514.39,424L513.22,422.94L514.43,419.14L518.01,416.4L518.15,412.61L519.23,406.63L519.84,405.35L518.68,404.33L518.63,403.38L517.58,402.6L516.89,397.93L519.72,396.27L530.91,402.04L542.09,407.74L542.23,419.35L539.81,419.15L538.53,421.28L537.79,423.06L538.37,423.73L537.45,424.61L537.77,425.79L537.04,426.99L536.76,428.04L537.75,427.87L538.33,428.97L538.36,430.63L539.39,431.46L539.36,432.15L537.59,432.64L536.16,433.78L534.14,436.87L531.5,438.18L528.79,438L528,438.26L528.28,439.25L526.81,440.24L525.62,441.34L522.09,442.41L521.39,441.78L520.93,441.72L520.41,442.44L518.09,442.66L518.53,441.89L517.65,439.96L517.25,438.79L516.03,438.31L514.38,436.66L514.99,435.33L516.27,435.61L517.06,435.41L518.62,435.44L517.1,432.87L517.2,430.98L517.01,429.09z"
          }, {
            "id": "TF",
            "title": "French Southern and Antarctic Lands",
            "d": "M668.54,619.03L670.34,620.36L672.99,620.9L673.09,621.71L672.31,623.67L668,623.95L667.93,621.66L668.35,619.9z"
          }, {
            "id": "TG",
            "title": "Togo",
            "d": "M480.48,446.25L478.23,446.84L477.6,445.86L476.85,444.08L476.63,442.68L477.25,440.15L476.55,439.12L476.28,436.9L476.28,434.85L475.11,433.39L475.32,432.5L477.78,432.56L477.42,434.06L478.27,434.89L479.25,435.88L479.35,437.27L479.92,437.85L479.79,444.31z"
          }, {
            "id": "TH",
            "title": "Thailand",
            "d": "M762.89,429.18L760.37,427.87L757.97,427.93L758.38,425.68L755.91,425.7L755.69,428.84L754.18,432.99L753.27,435.49L753.46,437.54L755.28,437.63L756.42,440.2L756.93,442.63L758.49,444.24L760.19,444.57L761.64,446.02L760.73,447.17L758.87,447.51L758.65,446.07L756.37,444.84L755.88,445.34L754.77,444.27L754.29,442.88L752.8,441.29L751.44,439.96L750.98,441.61L750.45,440.05L750.76,438.29L751.58,435.58L752.94,432.67L754.48,430.02L753.38,427.42L753.43,426.09L753.11,424.49L751.24,422.21L750.57,420.76L751.54,420.23L752.56,417.71L751.42,415.79L749.64,413.66L748.28,411.09L749.46,410.56L750.74,407.37L752.72,407.23L754.36,405.95L755.96,405.26L757.18,406.18L757.34,407.96L759.23,408.09L758.54,411.2L758.61,413.82L761.56,412.08L762.4,412.59L764.05,412.51L764.61,411.49L766.73,411.69L768.86,414.07L769.04,416.94L771.31,419.47L771.18,421.91L770.27,423.21L767.64,422.8L764.02,423.35L762.22,425.73z"
          }, {
            "id": "TJ",
            "title": "Tajikistan",
            "d": "M674.37,340.62L673.34,341.75L670.29,341.14L670.02,343.24L673.06,342.96L676.53,344.13L681.83,343.58L682.54,346.91L683.46,346.55L685.16,347.36L685.07,348.74L685.49,350.75L682.59,350.75L680.66,350.49L678.92,352.06L677.67,352.4L676.69,353.14L675.58,351.99L675.85,349.04L675,348.87L675.3,347.78L673.79,346.98L672.58,348.21L672.28,349.64L671.85,350.16L670.17,350.09L669.27,351.69L668.32,351.02L666.29,352.14L665.44,351.72L667.01,348.15L666.41,345.49L664.35,344.63L665.08,343.04L667.42,343.21L668.75,341.2L669.64,338.85L673.39,337.99L672.81,339.7L673.21,340.72z"
          }, {
            "id": "TL",
            "title": "Timor-Leste",
            "d": "M825.65,488.25L825.98,487.59L828.39,486.96L830.35,486.86L831.22,486.51L832.28,486.86L831.25,487.62L828.33,488.85L825.98,489.67L825.93,488.81z"
          }, {
            "id": "TM",
            "title": "Turkmenistan",
            "d": "M646.88,356.9L646.63,353.99L644.54,353.87L641.34,350.78L639.1,350.39L636,348.6L634,348.27L632.77,348.93L630.9,348.83L628.91,350.85L626.44,351.53L625.92,349.04L626.33,345.31L624.14,344.09L624.86,341.61L623,341.39L623.62,338.3L626.26,339.21L628.73,338.02L626.68,335.79L625.88,333.65L623.62,334.61L623.34,337.34L622.46,334.93L623.7,333.68L626.88,332.89L628.78,333.95L630.74,336.88L632.18,336.7L635.34,336.65L634.88,334.77L637.28,333.47L639.64,331.27L643.42,333.27L643.72,336.26L644.79,337.03L647.82,336.86L648.76,337.53L650.14,341.32L653.35,343.83L655.18,345.52L658.11,347.27L661.84,348.79L661.76,350.95L660.92,350.84L659.59,349.9L659.15,351.15L656.79,351.83L656.23,354.62L654.65,355.67L652.44,356.19L651.85,357.74L649.74,358.2z"
          }, {
            "id": "TN",
            "title": "Tunisia",
            "d": "M501.84,374.69L500.64,368.83L498.92,367.5L498.89,366.69L496.6,364.71L496.35,362.18L498.08,360.3L498.74,357.48L498.29,354.2L498.86,352.41L501.92,351L503.88,351.42L503.8,353.19L506.18,351.9L506.38,352.57L504.97,354.28L504.96,355.88L505.93,356.73L505.56,359.69L503.71,361.4L504.24,363.23L505.69,363.29L506.4,364.88L507.47,365.4L507.31,367.95L505.94,368.9L505.08,369.95L503.15,371.21L503.45,372.56L503.21,373.94z"
          }, {
            "id": "TR",
            "title": "Turkey",
            "d": "M578.75,336.6l4.02,1.43l3.27,-0.57l2.41,0.33l3.31,-1.94l2.99,-0.18l2.7,1.83l0.48,1.3l-0.27,1.79l2.08,0.91l1.1,1.06l-1.92,1.03l0.88,4.11l-0.55,1.1l1.53,2.82l-1.34,0.59l-0.98,-0.89l-3.26,-0.45l-1.2,0.55l-3.19,0.54l-1.51,-0.06l-3.23,1.31l-2.31,0.01l-1.49,-0.66l-3.09,0.97l-0.92,-0.68l-0.15,1.94l-0.75,0.76l-0.75,0.76l-1.03,-1.57l1.06,-1.3l-1.71,0.3l-2.35,-0.8l-1.93,2l-4.26,0.39l-2.27,-1.86l-3.02,-0.12l-0.65,1.44l-1.94,0.41l-2.71,-1.85l-3.06,0.06l-1.66,-3.48l-2.05,-1.96l1.36,-2.78l-1.78,-1.72l3.11,-3.48l4.32,-0.15l1.18,-2.81l5.34,0.49l3.37,-2.42l3.27,-1.06l4.64,-0.08L578.75,336.6zM551.5,338.99l-2.34,1.98l-0.88,-1.71l0.04,-0.76l0.67,-0.41l0.87,-2.33l-1.37,-0.99l2.86,-1.18l2.41,0.5l0.33,1.44l2.45,1.2l-0.51,0.91l-3.33,0.2L551.5,338.99z"
          }, {
            "id": "TT",
            "title": "Trinidad and Tobago",
            "d": "M302.31,433.24L303.92,432.87L304.51,432.97L304.4,435.08L302.06,435.39L301.55,435.14L302.37,434.36z"
          }, {
            "id": "TW",
            "title": "Taiwan",
            "d": "M816.7,393.27L815.01,398.14L813.81,400.62L812.33,398.07L812.01,395.82L813.66,392.82L815.91,390.5L817.19,391.41z"
          }, {
            "id": "TZ",
            "title": "Tanzania",
            "d": "M570.31,466.03L570.79,466.34L580.95,472.01L581.15,473.63L585.17,476.42L583.88,479.87L584.04,481.46L585.84,482.48L585.92,483.21L585.15,484.91L585.31,485.76L585.13,487.11L586.11,488.87L587.27,491.66L588.29,492.28L586.06,493.92L583,495.02L581.32,494.98L580.32,495.83L578.37,495.9L577.63,496.26L574.26,495.46L572.15,495.69L571.37,491.83L570.42,490.51L569.85,489.73L567.11,489.21L565.51,488.36L563.73,487.89L562.61,487.41L561.44,486.7L559.93,483.15L558.3,481.58L557.74,479.96L558.02,478.5L557.52,475.93L558.68,475.8L559.69,474.79L560.79,473.33L561.48,472.75L561.45,471.84L560.85,471.21L560.69,470.11L561.49,469.76L561.66,468.12L560.54,466.55L561.53,466.21L564.6,466.25z"
          }, {
            "id": "UA",
            "title": "Ukraine",
            "d": "M564.38,292.49L565.42,292.68L566.13,291.64L566.98,291.87L569.89,291.43L571.68,294L570.98,294.92L571.21,296.31L573.45,296.52L574.45,298.45L574.39,299.32L577.95,300.86L580.1,300.17L581.83,302.21L583.47,302.17L587.6,303.57L587.63,304.84L586.5,307.07L587.11,309.4L586.67,310.79L583.96,311.1L582.52,312.26L582.43,314.09L580.19,314.42L578.32,315.74L575.7,315.95L573.28,317.47L571.96,318.5L573.45,319.97L574.82,320.93L577.68,320.69L577.13,322.11L574.06,322.79L570.25,325.06L568.7,324.27L569.31,322.42L566.25,321.26L566.75,320.49L569.91,318.86L569.51,318.05L569.06,318.46L568.62,318.24L564.26,317.22L564.07,315.71L561.47,316.21L560.43,318.44L558.26,321.39L556.98,320.71L555.67,321.35L554.42,320.62L555.12,320.18L555.61,318.81L556.38,317.52L556.18,316.8L556.77,316.48L557.04,317.04L558.7,317.15L559.44,316.86L558.92,316.44L559.11,315.84L558.13,314.8L557.73,313.08L556.71,312.41L556.91,311L555.64,309.88L554.49,309.72L552.42,308.41L550.56,308.83L549.89,309.45L548.71,309.44L548,310.42L545.93,310.82L544.98,311.46L543.67,310.45L541.88,310.43L540.14,309.97L538.93,310.86L538.73,309.74L537.18,308.6L537.73,306.89L538.5,305.79L539.12,306.03L538.39,304.11L540.94,300.5L542.33,299.99L542.63,298.75L541.22,294.86L542.56,294.69L544.1,293.46L546.27,293.36L549.1,293.72L552.23,294.8L554.44,294.89L555.49,295.54L556.54,294.76L557.28,295.81L559.81,295.59L560.92,296.02L561.11,293.76L561.97,292.76z"
          }, {
            "id": "UG",
            "title": "Uganda",
            "d": "M564.6,466.25L561.53,466.21L560.54,466.55L558.87,467.41L558.19,467.12L558.21,465.02L558.86,463.96L559.02,461.72L559.61,460.43L560.68,458.97L561.76,458.23L562.66,457.24L561.54,456.87L561.71,453.61L562.86,452.84L564.64,453.47L566.9,452.82L568.87,452.82L570.6,451.54L571.93,453.48L572.26,454.88L573.49,458.08L572.47,460.11L571.09,461.95L570.29,463.08L570.31,466.03z"
          }, {
            "id": "US",
            "title": "United States",
            "d": "M109.25,279.8L109.25,279.8l-1.54,-1.83l-2.47,-1.57l-0.79,-4.36l-3.61,-4.13l-1.51,-4.94l-2.69,-0.34l-4.46,-0.13l-3.29,-1.54l-5.8,-5.64l-2.68,-1.05l-4.9,-1.99l-3.88,0.48l-5.51,-2.59l-3.33,-2.43l-3.11,1.21l0.58,3.93l-1.55,0.36l-3.24,1.16l-2.47,1.86l-3.11,1.16l-0.4,-3.24l1.26,-5.53l2.98,-1.77l-0.77,-1.46l-3.57,3.22l-1.91,3.77l-4.04,3.95l2.05,2.65l-2.65,3.85l-3.01,2.21l-2.81,1.59l-0.69,2.29l-4.38,2.63l-0.89,2.36l-3.28,2.13l-1.92,-0.38l-2.62,1.38l-2.85,1.67l-2.33,1.63l-4.81,1.38l-0.44,-0.81l3.07,-2.27l2.74,-1.51l2.99,-2.71l3.48,-0.56l1.38,-2.06l3.89,-3.05l0.63,-1.03l2.07,-1.83l0.48,-4l1.43,-3.17l-3.23,1.64l-0.9,-0.93l-1.52,1.95l-1.83,-2.73l-0.76,1.94l-1.05,-2.7l-2.8,2.17l-1.72,0l-0.24,-3.23l0.51,-2.02l-1.81,-1.98l-3.65,1.07l-2.37,-2.63l-1.92,-1.36l-0.01,-3.25l-2.16,-2.48l1.08,-3.41l2.29,-3.37l1,-3.15l2.27,-0.45l1.92,0.99l2.26,-3.01l2.04,0.54l2.14,-1.96l-0.52,-2.92l-1.57,-1.16l2.08,-2.52l-1.72,0.07l-2.98,1.43l-0.85,1.43l-2.21,-1.43l-3.97,0.73l-4.11,-1.56l-1.18,-2.65l-3.55,-3.91l3.94,-2.87l6.25,-3.41h2.31l-0.38,3.48l5.92,-0.27l-2.28,-4.34l-3.45,-2.72l-1.99,-3.64l-2.69,-3.17l-3.85,-2.38l1.57,-4.03l4.97,-0.25l3.54,-3.58l0.67,-3.92l2.86,-3.91l2.73,-0.95l5.31,-3.76l2.58,0.57l4.31,-4.61l4.24,1.83l2.03,3.87l1.25,-1.65l4.74,0.51l-0.17,1.95l4.29,1.43l2.86,-0.84l5.91,2.64l5.39,0.78l2.16,1.07l3.73,-1.34l4.25,2.46l3.05,1.13l-0.02,27.65l-0.01,35.43l2.76,0.17l2.73,1.56l1.96,2.44l2.49,3.6l2.73,-3.05l2.81,-1.79l1.49,2.85l1.89,2.23l2.57,2.42l1.75,3.79l2.87,5.88l4.77,3.2l0.08,3.12L109.25,279.8zM285.18,314.23l-1.25,-1.19l-1.88,0.7l-0.93,-1.08l-2.14,3.1l-0.86,3.15l-1,1.82l-1.19,0.62l-0.9,0.2l-0.28,0.98l-5.17,0l-4.26,0.03l-1.27,0.73l-2.87,2.73l0.29,0.54l0.17,1.51l-2.1,1.27l-2.3,-0.32l-2.2,-0.14l-1.33,0.44l0.25,1.15l0,0l0.05,0.37l-2.42,2.27l-2.11,1.09l-1.44,0.51l-1.66,1.03l-2.03,0.5l-1.4,-0.19l-1.73,-0.77l0.96,-1.45l0.62,-1.32l1.32,-2.09l-0.14,-1.57l-0.5,-2.24l-1.04,-0.39l-1.74,1.7l-0.56,-0.03l-0.14,-0.97l1.54,-1.56l0.26,-1.79l-0.23,-1.79l-2.08,-1.55l-2.38,-0.8l-0.39,1.52l-0.62,0.4l-0.5,1.95l-0.26,-1.33l-1.12,0.95l-0.7,1.32l-0.73,1.92l-0.14,1.64l0.93,2.38l-0.08,2.51l-1.14,1.84l-0.57,0.52l-0.76,0.41l-0.95,0.02l-0.26,-0.25l-0.76,-1.98l-0.02,-0.98l0.08,-0.94l-0.35,-1.87l0.53,-2.18l0.63,-2.71l1.46,-3.03l-0.42,0.01l-2.06,2.54l-0.38,-0.46l1.1,-1.42l1.67,-2.57l1.91,-0.36l2.19,-0.8l2.21,0.42l0.09,0.02l2.47,-0.36l-1.4,-1.61l-0.75,-0.13l-0.86,-0.16l-0.59,-1.14l-2.75,0.36l-2.49,0.9l-1.97,-1.55l-1.59,-0.52l0.9,-2.17l-2.48,1.37l-2.25,1.33l-2.16,1.04l-1.72,-1.4l-2.81,0.85l0.01,-0.6l1.9,-1.73l1.99,-1.65l2.86,-1.37l-3.45,-1.09l-2.27,0.55l-2.72,-1.3l-2.86,-0.67l-1.96,-0.26l-0.87,-0.72l-0.5,-2.35l-0.95,0.02l-0.01,1.64l-5.8,0l-9.59,0l-9.53,0l-8.42,0h-8.41h-8.27h-8.55h-2.76h-8.32h-7.96l0.95,3.47l0.45,3.41l-0.69,1.09l-1.49,-3.91l-4.05,-1.42l-0.34,0.82l0.82,1.94l0.89,3.53l0.51,5.42l-0.34,3.59l-0.34,3.54l-1.1,3.61l0.9,2.9l0.1,3.2l-0.61,3.05l1.49,1.99l0.39,2.95l2.17,2.99l1.24,1.17l-0.1,0.82l2.34,4.85l2.72,3.45l0.34,1.87l0.71,0.55l2.6,0.33l1,0.91l1.57,0.17l0.31,0.96l1.31,0.4l1.82,1.92l0.47,1.7l3.19,-0.25l3.56,-0.36l-0.26,0.65l4.23,1.6l6.4,2.31l5.58,-0.02l2.22,0l0.01,-1.35l4.86,0l1.02,1.16l1.43,1.03l1.67,1.43l0.93,1.69l0.7,1.77l1.45,0.97l2.33,0.96l1.77,-2.53l2.29,-0.06l1.98,1.28l1.41,2.18l0.97,1.86l1.65,1.8l0.62,2.19l0.79,1.47l2.19,0.96l1.99,0.68l1.09,-0.09l-0.53,-1.06l-0.14,-1.5l0.03,-2.16l0.65,-1.42l1.53,-1.51l2.79,-1.37l2.55,-2.37l2.36,-0.75l1.74,-0.23l2.04,0.74l2.45,-0.4l2.09,1.69l2.03,0.1l1.05,-0.61l1.04,0.47l0.53,-0.42l-0.6,-0.63l0.05,-1.3l-0.5,-0.86l1.16,-0.5l2.14,-0.22l2.49,0.36l3.17,-0.41l1.76,0.8l1.36,1.5l0.5,0.16l2.83,-1.46l1.09,0.49l2.19,2.68l0.79,1.75l-0.58,2.1l0.42,1.23l1.3,2.4l1.49,2.68l1.07,0.71l0.44,1.35l1.38,0.37l0.84,-0.39l0.7,-1.89l0.12,-1.21l0.09,-2.1l-1.33,-3.65l-0.02,-1.37l-1.25,-2.25l-0.94,-2.75l-0.5,-2.25l0.43,-2.31l1.32,-1.94l1.58,-1.57l3.08,-2.16l0.4,-1.12l1.42,-1.23l1.4,-0.22l1.84,-1.98l2.9,-1.01l1.78,-2.53l-0.39,-3.46l-0.29,-1.21l-0.8,-0.24l-0.12,-3.35l-1.93,-1.14l1.85,0.56l-0.6,-2.26l0.54,-1.55l0.33,2.97l1.43,1.36l-0.87,2.4l0.26,0.14l1.58,-2.81l0.9,-1.38l-0.04,-1.35l-0.7,-0.64l-0.58,-1.94l0.92,0.9l0.62,0.19l0.21,0.92l2.04,-2.78l0.61,-2.62l-0.83,-0.17l0.85,-1.02l-0.08,0.45l1.79,-0.01l3.93,-1.11l-0.83,-0.7l-4.12,0.7l2.34,-1.07l1.63,-0.18l1.22,-0.19l2.07,-0.65l1.35,0.07l1.89,-0.61l0.22,-1.07l-0.84,-0.84l0.29,1.37l-1.16,-0.09l-0.93,-1.99l0.03,-2.01l0.48,-0.86l1.48,-2.28l2.96,-1.15l2.88,-1.34l2.99,-1.9l-0.48,-1.29l-1.83,-2.25L285.18,314.23zM45.62,263.79l-1.5,0.8l-2.55,1.86l0.43,2.42l1.43,1.32l2.8,-1.95l2.43,-2.47l-1.19,-1.63L45.62,263.79zM0,235.22l2.04,-1.26l0.23,-0.68L0,232.61V235.22zM8.5,250.59l-2.77,0.97l1.7,1.52l1.84,1.04l1.72,-0.87l-0.27,-2.15L8.5,250.59zM105.85,283.09l-2.69,0.38l-1.32,-0.62l-0.17,1.52l0.52,2.07l1.42,1.46l1.04,2.13l1.69,2.1l1.12,0.01l-2.44,-3.7L105.85,283.09zM37.13,403.77l-1,-0.28l-0.27,0.26l0.02,0.19l0.32,0.24l0.48,0.63l0.94,-0.21l0.23,-0.36L37.13,403.77zM34.14,403.23l1.5,0.09l0.09,-0.32l-1.38,-0.13L34.14,403.23zM40.03,406.52l-0.5,-0.26l-1.07,-0.5l-0.21,-0.06l-0.16,0.28l0.19,0.58l-0.49,0.48l-0.14,0.33l0.46,1.08l-0.08,0.83l0.7,0.42l0.41,-0.49l0.9,-0.46l1.1,-0.63l0.07,-0.16l-0.71,-1.04L40.03,406.52zM32.17,401.38l-0.75,0.41l0.11,0.12l0.36,0.68l0.98,0.11l0.2,0.04l0.15,-0.17l-0.81,-0.99L32.17,401.38zM27.77,399.82l-0.43,0.3l-0.15,0.22l0.94,0.55l0.33,-0.3l-0.06,-0.7L27.77,399.82z"
          }, {
            "id": "UY",
            "title": "Uruguay",
            "d": "M313.68,551.79L315.5,551.45L318.31,553.95L319.35,553.86L322.24,555.94L324.44,557.76L326.06,560.01L324.82,561.58L325.6,563.48L324.39,565.6L321.22,567.48L319.15,566.8L317.63,567.17L315.04,565.71L313.14,565.82L311.43,563.95L311.65,561.79L312.26,561.05L312.23,557.75L312.98,554.38z"
          }, {
            "id": "UZ",
            "title": "Uzbekistan",
            "d": "M661.76,350.95L661.84,348.79L658.11,347.27L655.18,345.52L653.35,343.83L650.14,341.32L648.76,337.53L647.82,336.86L644.79,337.03L643.72,336.26L643.42,333.27L639.64,331.27L637.28,333.47L634.88,334.77L635.34,336.65L632.18,336.7L632.07,322.57L639.29,320.22L639.81,320.57L644.16,323.41L646.45,324.89L649.13,328.39L652.42,327.83L657.23,327.53L660.58,330.33L660.37,334.13L661.74,334.16L662.31,337.22L665.88,337.34L666.64,339.09L667.69,339.07L668.92,336.42L672.61,333.81L674.22,333.11L675.05,333.48L672.7,335.91L674.77,337.31L676.77,336.38L680.09,338.34L676.5,340.98L674.37,340.62L673.21,340.72L672.81,339.7L673.39,337.99L669.64,338.85L668.75,341.2L667.42,343.21L665.08,343.04L664.35,344.63L666.41,345.49L667.01,348.15L665.44,351.72L663.32,350.98z"
          }, {
            "id": "VE",
            "title": "Venezuela",
            "d": "M275.25,430.35L275.17,431.02L273.52,431.35L274.44,432.64L274.4,434.13L273.17,435.77L274.23,438.01L275.44,437.83L276.07,435.79L275.2,434.79L275.06,432.65L278.55,431.49L278.16,430.15L279.14,429.25L280.15,431.25L282.12,431.3L283.94,432.88L284.05,433.82L286.56,433.84L289.56,433.55L291.17,434.82L293.31,435.17L294.88,434.29L294.91,433.57L298.39,433.4L301.75,433.36L299.37,434.2L300.32,435.54L302.57,435.75L304.69,437.14L305.14,439.4L306.6,439.33L307.7,440L305.48,441.65L305.23,442.68L306.19,443.72L305.5,444.24L303.77,444.69L303.83,445.99L303.07,446.76L304.96,448.88L305.34,449.67L304.31,450.74L301.17,451.78L299.16,452.22L298.35,452.88L296.12,452.18L294.04,451.82L293.52,452.08L294.77,452.8L294.66,454.67L295.05,456.43L297.42,456.67L297.58,457.25L295.57,458.05L295.25,459.23L294.09,459.68L292.01,460.33L291.47,461.19L289.29,461.37L287.74,459.89L286.89,457.12L286.14,456.14L285.12,455.53L286.54,454.14L286.45,453.51L285.65,452.68L285.09,450.83L285.31,448.82L285.93,447.88L286.44,446.38L285.45,445.89L283.85,446.21L281.83,446.06L280.7,446.36L278.72,443.95L277.09,443.59L273.49,443.86L272.82,442.88L272.13,442.65L272.03,442.06L272.36,441.02L272.14,439.89L271.52,439.27L271.16,437.97L269.72,437.79L270.49,436.13L270.84,434.12L271.65,433.06L272.74,432.25L273.45,430.83z"
          }, {
            "id": "VN",
            "title": "Vietnam",
            "d": "M778.21,401.87L774.47,404.43L772.13,407.24L771.51,409.29L773.66,412.38L776.28,416.2L778.82,417.99L780.53,420.32L781.81,425.64L781.43,430.66L779.1,432.53L775.88,434.36L773.6,436.72L770.1,439.34L769.08,437.53L769.87,435.62L767.79,434.01L770.22,432.87L773.16,432.67L771.93,430.94L776.64,428.75L776.99,425.33L776.34,423.41L776.85,420.53L776.14,418.49L774.02,416.47L772.25,413.9L769.92,410.44L766.56,408.68L767.37,407.61L769.16,406.84L768.07,404.25L764.62,404.22L763.36,401.5L761.72,399.13L763.23,398.39L765.46,398.41L768.19,398.06L770.58,396.44L771.93,397.58L774.5,398.13L774.05,399.87L775.39,401.09z"
          }, {
            "id": "VU",
            "title": "Vanuatu",
            "d": "M945.87,509.9l-0.92,0.38l-0.94,-1.27l0.1,-0.78L945.87,509.9zM943.8,505.46l0.46,2.33l-0.75,-0.36l-0.58,0.16l-0.4,-0.8l-0.06,-2.21L943.8,505.46z"
          }, {
            "id": "YE",
            "title": "Yemen",
            "d": "M624.16,416.33L622.13,417.12L621.59,418.4L621.52,419.39L618.73,420.61L614.25,421.96L611.74,423.99L610.51,424.14L609.67,423.97L608.03,425.17L606.24,425.72L603.89,425.87L603.18,426.03L602.57,426.78L601.83,426.99L601.4,427.72L600.01,427.66L599.11,428.04L597.17,427.9L596.44,426.23L596.52,424.66L596.07,423.81L595.52,421.69L594.71,420.5L595.27,420.36L594.98,419.04L595.32,418.48L595.2,417.22L596.43,416.29L596.14,415.06L596.89,413.63L598.04,414.39L598.8,414.12L602.03,414.05L602.55,414.35L605.26,414.64L606.33,414.49L607.03,415.46L608.34,414.98L610.35,411.91L612.97,410.59L621.05,409.46L623.25,414.3z"
          }, {
            "id": "ZA",
            "title": "South Africa",
            "d": "M563.63,548.71l-0.55,0.46l-1.19,1.63l-0.78,1.66l-1.59,2.33l-3.17,3.38l-1.98,1.98l-2.12,1.51l-2.93,1.3l-1.43,0.17l-0.36,0.93l-1.7,-0.5l-1.39,0.64l-3.04,-0.65l-1.7,0.41l-1.16,-0.18l-2.89,1.33l-2.39,0.54l-1.73,1.28l-1.28,0.08l-1.19,-1.21l-0.95,-0.06l-1.21,-1.51l-0.13,0.47l-0.37,-0.91l0.02,-1.96l-0.91,-2.23l0.9,-0.6l-0.07,-2.53l-1.84,-3.05l-1.41,-2.74l0,-0.01l-2.01,-4.15l1.34,-1.57l1.11,0.87l0.47,1.36l1.26,0.23l1.76,0.6l1.51,-0.23l2.5,-1.63l0,-11.52l0.76,0.46l1.66,2.93l-0.26,1.89l0.63,1.1l2.01,-0.32l1.4,-1.39l1.33,-0.93l0.69,-1.48l1.37,-0.72l1.18,0.38l1.34,0.87l2.28,0.15l1.79,-0.72l0.28,-0.96l0.49,-1.47l1.53,-0.25l0.84,-1.15l0.93,-2.03l2.52,-2.26l3.97,-2.22l1.14,0.03l1.36,0.51l0.94,-0.36l1.49,0.3l1.34,4.26l0.73,2.17l-0.5,3.43l0.24,1.11l-1.42,-0.57l-0.81,0.22l-0.26,0.9l-0.77,1.17l0.03,1.08l1.67,1.7l1.64,-0.34l0.57,-1.39l2.13,0.03l-0.7,2.28l-0.33,2.62l-0.73,1.43L563.63,548.71zM556.5,547.75l-1.22,-0.98l-1.31,0.65l-1.52,1.25l-1.5,2.03l2.1,2.48l1,-0.32l0.52,-1.03l1.56,-0.5l0.48,-1.05l0.86,-1.56L556.5,547.75z"
          }, {
            "id": "ZM",
            "title": "Zambia",
            "d": "M567.11,489.21L568.43,490.47L569.14,492.87L568.66,493.64L568.1,495.94L568.64,498.3L567.76,499.29L566.91,501.95L568.38,502.69L559.87,505.07L560.14,507.12L558.01,507.52L556.42,508.67L556.08,509.68L555.07,509.9L552.63,512.3L551.08,514.19L550.13,514.26L549.22,513.92L546.09,513.6L545.59,513.38L545.56,513.14L544.46,512.48L542.64,512.31L540.34,512.98L538.51,511.16L536.62,508.78L536.75,499.62L542.59,499.66L542.35,498.67L542.77,497.6L542.28,496.27L542.6,494.89L542.3,494.01L543.27,494.08L543.43,494.96L544.74,494.89L546.52,495.15L547.46,496.44L549.7,496.84L551.42,495.94L552.05,497.43L554.2,497.83L555.23,499.05L556.38,500.62L558.53,500.65L558.29,497.57L557.52,498.08L555.56,496.98L554.8,496.47L555.15,493.62L555.65,490.27L555.02,489.02L555.82,487.22L556.57,486.89L560.34,486.41L561.44,486.7L562.61,487.41L563.73,487.89L565.51,488.36z"
          }, {
            "id": "ZW",
            "title": "Zimbabwe",
            "d": "M562.71,527L561.22,526.7L560.27,527.06L558.92,526.55L557.78,526.52L555.99,525.16L553.82,524.7L553,522.8L552.99,521.75L551.79,521.43L548.62,518.18L547.73,516.47L547.17,515.95L546.09,513.6L549.22,513.92L550.13,514.26L551.08,514.19L552.63,512.3L555.07,509.9L556.08,509.68L556.42,508.67L558.01,507.52L560.14,507.12L560.32,508.2L562.66,508.14L563.96,508.75L564.56,509.47L565.9,509.68L567.35,510.62L567.36,514.31L566.81,516.35L566.69,518.55L567.14,519.43L566.83,521.17L566.4,521.44L565.66,523.59z"
          }]}
      }};
  })();
  return _retrieveGlobal();
});

$__System.registerDynamic("8", [], false, function($__require, $__exports, $__module) {
  var _retrieveGlobal = $__System.get("@@global-helpers").prepareGlobal($__module.id, null, null);
  (function() {
    AmCharts.maps.continentsLow = {'svg': {
        'defs': {'amcharts:ammap': {
            'projection': 'mercator',
            'leftLongitude': '-169.6',
            'topLatitude': '83.68',
            'rightLongitude': '190.25',
            'bottomLatitude': '-55.55'
          }},
        'g': {'path': [{
            'id': 'south_america',
            'title': 'South America',
            'd': 'M302.37,434.36l-0.06,-1.12l1.61,-0.37l0.59,0.1l-0.11,2.11l-2.34,0.31l-0.5,-0.25L302.37,434.36zM309.41,631.56l-2.38,-1.12l-3.36,2.7l1.4,2.05l2.38,-2.05l1.26,1.59l3.79,-1.36l0.84,-1.58l-2.24,-2.01L309.41,631.56zM377.41,482.2l-0.95,-3.57l-1.02,-0.88l-2.4,-0.11l-2.16,-0.81l-3.58,-3.13l-4.15,-2.31l-4.19,0.11l-5.46,-1.47l-3.26,0.86l0.46,-1.54l-1.37,-1.63l-4.66,-1.7l-3.53,-1l-2.13,1.83l-0.1,-2.79l-4.96,-0.44l-0.87,-0.84l2.11,-2.29l-0.08,-1.92l-1.5,-0.46l-1.57,-4.88l-0.69,-1.54l-0.96,0.13l-0.46,-1.14l-2.97,-2.36l-2.06,-0.66l-0.95,-0.31l-3.01,-0.75l-2.27,0.2l-0.3,0.5l-3.36,-0.56l-1.11,-0.98l-1.5,-1.37l-1.06,-0.07l-0.08,-1.45l-1.73,-1.83L307.7,440l-1.1,-0.66l-1.46,0.06l-0.45,-2.26l-2.13,-1.39l-2.24,-0.21l-0.96,-1.34l2.38,-0.84l-3.36,0.04l-3.47,0.17l-0.03,0.71l-1.57,0.88l-2.14,-0.35l-1.61,-1.27l-3,0.29l-2.52,-0.02l-0.11,-0.94l-1.82,-1.58l-1.97,-0.05l-1.01,-2l-0.98,0.9l0.39,1.34l-3.49,1.15l0.14,2.15l0.87,1l-0.63,2.04l-1.21,0.18l-1.06,-2.24l1.24,-1.64l0.03,-1.48l-0.91,-1.29l1.65,-0.33l0.08,-0.67l0.54,-0.96l-0.74,-0.75l-0.99,-0.17l-1.36,1.37l-1.09,0.64l-2.21,1.44l-2.19,-0.24l-0.22,0.59l-1.77,0.05l-1.61,1.32l-0.52,2.39l-0.03,0.93l-1.15,0.3l-2.1,1.97l-1.45,-0.09l-0.34,0.41l0.65,1.66l-0.53,0.84l-0.9,-0.2l-0.36,1.37l1.14,1.5l0.44,2.37l-0.6,0.73l0.63,2.56l-0.53,1.62l1.03,0.66l-1.07,1.46l-1.18,1.75l-1.39,0.19l-0.66,1.01l0.12,1.4l-1.05,0.21l0.38,0.87l-1.93,1.11l-1.54,0.6l0.2,1.14l-1.06,1.79l-0.52,1.73l-0.98,0.42l0.47,2.53l-0.57,0.79l1.68,1.22l1.07,-1.29l0.61,1.22l-1.49,2.08l-2.24,1.76l-0.87,1.96l1.36,2.67l-0.91,1.25l2,1.13l2.18,1.83l0.88,2.07l1.15,1.28l2.65,5.62l2.76,5.24l2.37,3.75l-0.46,0.83l1.16,2.37l2.16,1.78l5.03,3.17l5.56,2.92l0.24,1.2l2.81,1.68l0.58,4.15l0.21,4.87l-0.88,6.75l-0.9,6.37l-0.51,6.04l-1.64,3.87l0.34,3.96l-0.84,2.67l0.65,4.91l-1.19,4.97l-1.94,5.43l-1.72,5.6l-1.18,0.11l0.23,3.98l0.81,3.5l-1.29,2.48l-0.96,6.84l-0.88,5.42l1.77,0.54l0.88,-4.75l1.88,1l-1.46,7.97l-3.12,-1.37l-0.95,6.56l-2.67,3.57l4.26,1.19l-2.96,3.19l-1.19,4.03l0.36,7.34l1.41,2.94l-0.79,2.62l0.88,2.87l3.49,2.63l3.21,3.25l3.16,1.54l1.19,-0.11l0.45,-4.38l2.53,-1.67l1.35,-1.13l2.49,0.03l1.18,0.23l-1.87,-2.63l-0.91,-4.64l1.15,-2.06l2.56,-1.72l1.82,-5.03l3.31,-2.38l0.96,-3.73l-2.68,-0.83l-2.76,-2.98l0.8,-3.01l2.2,-2.04l2.65,-0.01l0.66,-2.11l0.41,-3.91l2.25,-2.38l2.58,-1.18l-0.84,-1.96L294.9,594l-1.89,-1.14l-0.39,-3.71l1.08,-0.97l2.7,1.35l2.87,-0.51l1.68,-1.3l-0.52,-1.85l0.57,-2.72l-0.59,-2.15l3.08,0.36l5.62,-0.75l4.16,-1.91l2.69,-4.52l0.14,-1.7l-1.75,-1.51l0.38,-2.37l-3.56,-2.91l0.19,-1.76l1.71,1.87l1.9,-0.11l2.59,1.46l1.52,-0.36l2.07,0.68l3.17,-1.89l1.21,-2.12l1.85,-1.91l1.28,-3.15l1.91,-1.54l2.47,-2.59l3.11,-5.68l1.96,-1.75l0.64,-1.55l0.52,-3.18l-0.47,-1.73l0.41,-2.32l2.37,-3.06l3.3,-2.44l3.14,-0.89l1.97,-1.35l4.41,-1.17l3.05,0.01l0.66,-1.81l2.27,-1.3l0.48,-3.09l2.84,-3.88l0.5,-3.94l0.89,-1.16l0.3,-1.93l0.78,-4.48l-0.2,-5.4l0.78,-2.11l0.7,-0.06l2.08,-2.47l1.79,-3.22l3.95,-3.94l1.43,-1.84l1.12,-4.65L377.41,482.2zM285.29,642.4l-1.4,-3.53l-1.08,-2.15l-2,-0.54l-2.58,1.91l-0.91,3.2l-1.45,2.17l-3.72,-1.7l-3.94,-3.13l-2.31,-0.97l3.86,5.25l2.86,2.57l3.53,2.71l2.94,0.71l2.04,1.48l1.66,0.4l1.38,0.16l2.4,-1.53l0.93,-1.98l1.43,1.73l2.66,-0.25l1.26,-2.44l-3.93,-1.21L285.29,642.4z'
          }, {
            'id': 'north_america',
            'title': 'North America',
            'd': 'M281.07,409.41l0.09,-0.88l-1.53,0.06l-0.51,-1.05l-0.74,0.07l-1.66,-0.76l-2.19,-0.01l-0.35,0.5l-2.43,-0.47l-1.71,-0.13l-0.63,0.82l1.77,0.46l-0.02,1.13l1.28,1.28l-1.01,0.65l-2.12,-0.24l-2.58,-0.41l-0.25,0.95l1.5,0.91l1.31,-0.55l1.71,0.21l1.32,-0.2l1.86,0.5l0.14,0.84l0.72,0.46l1.12,-2.01l0.93,-0.42l0.43,0.71l1.08,-0.18l0.51,-0.54l0.92,0.14l1.29,-0.12l1.33,0.64l1.04,-1.2l-1.38,-1.08L281.07,409.41zM255.13,385.61l-1.32,0.25l0.2,1.15l3.05,-0.5l-0.08,-0.81L255.13,385.61zM256.02,390.76l-0.61,1.95l1.05,0.89l0.71,1.76l0.69,-0.15l-0.02,-1.77l-0.98,-2.55L256.02,390.76zM289.41,410.88l-2.29,-0.02l-0.4,0.43l0.16,1.26l1.64,-0.1l2.11,0.02l0.72,-0.74l-0.51,-0.59L289.41,410.88zM267.27,405.66l-2.12,-1.22l-2.07,-0.12l0.2,-0.84l-1.67,-0.61l-0.92,0.04l-1.75,-1.35l-2.37,-1.86l-0.99,-0.71l-2.62,0.34l-1.12,-1.11l-2.63,-1.03l-2.2,-0.03l-2.42,-0.22l-0.68,0.33l-2.12,0.29l-1.43,0.59l-1.27,0.67l-0.61,1.09l-1.48,0.93l1.2,0.28l1.39,-0.33l0.4,-0.73l1.16,-0.04l2.01,-1.57l2.75,0.15l-1.05,0.75l0.98,0.59l3.65,0.47l0.84,0.63l2.61,0.8l1.58,-0.12l0.66,1.7l0.97,0.86l1.81,0.2l1.14,0.77l-1.88,1.66l4.01,-0.29l1.93,0.23l1.89,-0.15l1.86,-0.38L267.27,405.66zM259.65,411.22l-1.89,-0.26l-0.64,-0.1l-1.18,0.21l-0.34,0.67l1.6,1.07l1.57,0.47l0.85,-0.49l1.97,-0.05l-0.46,-0.8L259.65,411.22zM258.87,388.7l0.48,-2.21l-2.22,-1.41l0.01,0.36l1.26,1.23l-0.05,1.63L258.87,388.7zM32.17,401.38l-0.75,0.41l0.11,0.12l0.36,0.68l0.98,0.11l0.2,0.04l0.15,-0.17l-0.81,-0.99L32.17,401.38zM27.77,399.82l-0.43,0.3l-0.15,0.22l0.94,0.55l0.33,-0.3l-0.06,-0.7L27.77,399.82zM34.14,403.23l1.5,0.09l0.09,-0.32l-1.38,-0.13L34.14,403.23zM37.14,403.76l-1,-0.28l-0.27,0.26l0.02,0.19l0.32,0.24l0.48,0.63l0.94,-0.21l0.23,-0.36L37.14,403.76zM8.5,250.59l-2.77,0.97l1.7,1.52l1.84,1.04l1.72,-0.87l-0.27,-2.15L8.5,250.59zM0,235.22l2.04,-1.26l0.23,-0.68L0,232.61V235.22zM139.07,126.88l5.21,-5.05l2.62,-0.59l2.16,-4.23l0.38,-9.77l-3.85,1.91l-4.3,-0.18l-5.76,8.19l-4.76,8.98l3.8,2.51L139.07,126.88zM145.21,136.27l3.92,1.95l12.67,-1.3l-5.82,4.77l0.36,3.43l4.26,-0.24l7.07,-4.58l9.5,-1.67l1.71,-5.22l-0.49,-5.57l-2.94,-0.5l-2.5,1.93l-1.1,-4.13l-0.95,-5.7l-2.9,-1.42l-2.57,4.41l4.01,11.05l-4.9,-0.85l-4.98,-6.79l-7.89,-4l-2.64,3.32L145.21,136.27zM130.12,178.05l7.38,-4.18V170l3.48,-6.41l6.88,-6.69l3.52,-2.47l-3.01,-4.2l-2.72,-2.95l-7.16,-0.57l-4,-2.16l-9.48,1.63l2.74,6.23l-2.43,6.43l-1.94,6.87l-1.2,3.86l6.47,4.69L130.12,178.05zM326.41,307.48l-1.96,0.72l0.87,-3.11l-2.8,-1.32l-1.29,1.05l-2.49,-1.18l0.98,-1.51l-1.88,-0.93l-1.83,1.47l1.86,-3.82l1.5,-2.8l0.54,-1.22l-1.3,-0.2l-2.43,1.55l-1.74,2.53l-2.9,6.92l-2.35,2.56l1.22,1.14l-1.75,1.47l0.43,1.23l5.44,0.13l3.01,-0.25l2.69,1.01l-1.98,1.93l1.67,0.14l3.25,-3.58l0.78,0.53l-0.61,3.37l1.84,0.77l1.27,-0.15l1.18,-3.61l-0.87,-2.59L326.41,307.48zM296.75,316.34l-0.98,-1.98l-1.06,1.26l0.7,1.36l3.56,1.71l1.04,-0.26l1.38,-1.66l-2.6,0.11L296.75,316.34zM40.03,406.52l-0.5,-0.26l-1.07,-0.5l-0.21,-0.06l-0.16,0.28l0.19,0.58l-0.49,0.48l-0.14,0.33l0.46,1.08l-0.08,0.83l0.7,0.42l0.41,-0.49l0.9,-0.46l1.1,-0.63l0.07,-0.16l-0.71,-1.04L40.03,406.52zM301.88,304.92l-2.87,-1.8l-3.69,-1.09l-0.97,0.37l2.61,2.04l3.63,1.34l1.36,-0.08L301.88,304.92zM439.45,42.64l-8.41,-3.81l-13.61,7.55l-7.14,6.92l3.08,-10.97l-2.33,-7.15l-5.44,6.12l-8.45,-6.91l-9.93,2.24L385.81,33l15.09,-2.03l10.73,-0.92l5.18,-8.31L399.27,3.15L376.87,0l-9.91,2.42l-3.58,8.95l-9.84,-1.07l-9.41,13.6l-0.38,9.1l6.67,10.77l-5.82,-6.41l-3.94,-1.59l-6.69,-7.78l-7.44,11.32L323.47,33l-8.62,0.18l-8.62,3.21l-6.64,5.24l1.17,8.57l-4.08,1.98l-9.71,12.33l-2.44,6.64l7.57,5.76l-1.08,5.64l-10.27,7.16l-10.62,6.87l-0.39,5.34l6.32,5.43l12,3.37l-5.64,0.68l-7.36,3.97l4.87,7.66l3.25,3.75l6.84,-0.86l7.49,-0.47l5.95,0.85l7.52,6.69l-0.03,4.63l3.57,4.18l3.38,10.91l2.23,6.74l1.71,3.52l-3.13,8.51l2.34,2.19l2.79,-1.24l2.51,3l4.82,5.43l-5.72,-2.25l-2.6,0.12l-1.1,4.48l0.19,5.55l3.44,2.6l2.52,-1.13l1.53,-1.19l3.2,-2.87l-0.59,6.26l-1.11,3.26l-4.22,2.85l-2.77,8.66l1.87,2.53l-1.01,5.17l3.88,6.27l0.38,5.89l1.42,4.16l4.86,7.67l1.87,5.8l2.72,3.18l5.61,0.03l4.14,4.63l3.95,-0.34l1.44,-5.57l1.26,-4.85l-1.13,-4.71l4.57,-4.95l1.42,-4.17l0.04,-4.56l2.4,-4.12l4.03,-1.58l3.73,-1.68l1.94,-0.28l6.03,-4.89l3.9,-7.63l2.9,-2.87l3.09,-0.03l8.21,-2.62l7.62,-6.13l7.52,-7.03l-3.87,-0.45l-7.39,-0.35l3.26,-4.41l-0.96,-5.87l3.47,4.98l2.16,3.26l5,-1.62l-1.06,-6.96l-3.67,-5.48l-3.79,-2.29l1.44,-2.49l5.55,3.83l-0.04,-4.13l-3.51,-6.48l3.91,-0.03l3.95,-1.52l0.92,-3.51l-3.25,-4.14l6.23,-0.74L417.3,137l3,-1.02l-0.66,-9.63l-5.17,-6.3l4.61,-3.88l4.38,-0.51l-3.37,-8.33L420,92.07l2.26,-9.6l3.28,-11.51l-6.49,-0.79l8.96,-2.87l1.58,-3.89l11.43,-12.67L439.45,42.64zM166.31,106.56l0.93,-3.99l-3.95,-2.12l-4.09,1.39l-2.27,4.26l4.16,4.21L166.31,106.56zM45.62,263.79l-1.5,0.8l-2.55,1.86l0.43,2.42l1.43,1.32l2.8,-1.95l2.43,-2.47l-1.19,-1.63L45.62,263.79zM105.85,283.09l-2.69,0.38l-1.32,-0.62l-0.17,1.52l0.52,2.07l1.42,1.46l1.04,2.13l1.69,2.1l1.12,0.01l-2.44,-3.7L105.85,283.09zM128.95,308.23l-1.16,-2.34l-2.8,-1.77l-1.39,-2.05l-0.95,-1.5l-2.64,-0.46l-1.72,-0.67l-2.94,-0.96l-0.24,1.02l1.08,2.38l2.89,0.78l0.5,1.23l2.51,1.5l0.84,1.51l4.6,1.92L128.95,308.23zM305.76,317.43l1.81,1.46l-3.47,2.62l-6.21,2.35l-2.78,1.58l-3.13,2.79l-2.13,-0.28l-0.11,-3.29l4.87,-3.26l-4.49,0.13l-3.12,0.48l0.48,1.29l-2.99,1.9l-2.88,1.34l-2.96,1.15l-1.48,2.28l-0.48,0.86l-0.03,2.01l0.93,1.99l1.16,0.09l-0.29,-1.37l0.84,0.84l-0.22,1.07l-1.89,0.61l-1.35,-0.07l-2.07,0.65l-1.22,0.19l-1.63,0.18l-2.34,1.07l4.12,-0.7l0.83,0.7l-3.93,1.11l-1.79,0.01l0.08,-0.45l-0.85,1.02l0.83,0.17l-0.61,2.62l-2.04,2.78l-0.21,-0.92l-0.62,-0.19l-0.92,-0.9l0.58,1.94l0.7,0.64l0.04,1.35l-0.9,1.38l-1.58,2.81l-0.26,-0.14l0.87,-2.4l-1.43,-1.36l-0.33,-2.97l-0.54,1.55l0.6,2.26l-1.85,-0.56l1.93,1.14l0.12,3.35l0.8,0.24l0.29,1.21l0.39,3.46l-1.78,2.53l-2.9,1.01l-1.84,1.98l-1.4,0.22l-1.42,1.23l-0.4,1.12l-3.08,2.16l-1.58,1.57l-1.3,1.94l-0.43,2.31l0.5,2.25l0.94,2.75l1.25,2.25l0.02,1.37l1.33,3.65l-0.09,2.1l-0.12,1.21l-0.7,1.89l-0.84,0.39l-1.38,-0.37l-0.44,-1.35l-1.07,-0.71l-1.49,-2.68l-1.3,-2.4l-0.42,-1.23l0.58,-2.1l-0.79,-1.75l-2.19,-2.68l-1.09,-0.49l-2.83,1.46l-0.5,-0.16l-1.36,-1.5l-1.76,-0.8l-3.17,0.41l-2.49,-0.36l-2.14,0.22l-1.16,0.5l0.5,0.86l-0.05,1.3l0.6,0.63l-0.53,0.42l-1.04,-0.47l-1.05,0.61l-2.03,-0.1l-2.09,-1.69l-2.45,0.4l-2.04,-0.74l-1.74,0.23l-2.36,0.75l-2.55,2.37l-2.79,1.37l-1.53,1.51l-0.65,1.42l-0.03,2.16l0.14,1.5l0.5,1.01l0.02,0l-0.01,0.02l0.02,0.03l-0.03,0l-1.07,2.66l-0.49,2.21l-0.21,4.08l-0.27,1.47l0.49,1.64l0.87,1.47l0.56,2.31l1.86,2.21l0.65,1.69l1.1,1.45l2.98,0.79l1.16,1.22l2.46,-0.82l2.13,-0.29l2.1,-0.53l1.77,-0.51l1.78,-1.2l0.67,-1.73l0.23,-2.49l0.49,-0.87l1.89,-0.79l2.97,-0.69l2.48,0.1l1.7,-0.25l0.67,0.63l-0.09,1.44l-1.51,1.77l-0.66,1.81l0.51,0.51l-0.42,1.28l-0.7,2.29l-0.71,-0.75l-0.59,0.05l0.01,0.43l0.53,0.01l-0.04,0.8l-0.46,1.27l0.25,0.45l-0.29,1.05l0.17,0.27l-0.32,1.47l-0.55,0.78l-0.51,0.09l-0.56,1l0.92,0.53l0.24,-0.44l0.82,0.37l0.29,0.12l0.62,-0.51l0.8,-0.04l0.26,0.23l0.44,-0.14l1.3,0.26l1.3,-0.08l0.9,-0.32l0.33,-0.32l0.89,0.15l0.67,0.2l0.73,-0.07l0.56,-0.25l1.28,0.4l0.45,0.06l0.85,0.54l0.81,0.65l1.02,0.44l0.74,0.8l-0.24,0.28l-0.14,0.64l0.28,1.05l-0.64,0.98l-0.3,1.15l-0.1,1.27l0.16,0.73l0.07,1.29l-0.43,0.28l-0.26,1.22l0.19,0.75l-0.58,0.73l0.14,0.76l0.42,0.47l0.72,1.54l1.08,1.14l1.32,1.21l1,1.01l-0.06,0.6l1.12,0.12l0.27,-0.23l0.77,0.7l1.38,-0.21l1.19,-0.71l1.7,-0.57l0.96,-0.84l1.55,0.16l-0.11,0.28l1.57,0.1l1.25,0.49l0.91,0.84l1.06,0.78l-0.34,0.42l0.65,1.65l-0.53,0.84l-0.91,-0.2l-0.36,1.36l-0.93,-0.81l-0.6,-1.52l0.69,-0.75l-0.71,-0.19l-0.52,-0.93l-1.4,-0.78l-1.23,0.18l-0.56,0.98l-1.14,0.7l-0.61,0.1l-0.27,0.59l1.33,1.52l-0.76,0.36l-0.41,0.42l-1.3,0.14l-0.49,-1.68l-0.36,0.48l-0.93,-0.16l-0.56,-1.14l-1.15,-0.18l-0.73,-0.33h-1.2l-0.09,0.61l-0.32,-0.42l-1.52,-0.63l-0.57,-0.59l0.32,-0.49l-0.1,-0.62l-0.78,-0.68l-1.1,-0.55l-0.97,-0.36l-0.18,-0.83l-0.74,-0.51l0.18,0.83l-0.56,0.67l-0.64,-0.78l-0.9,-0.28l-0.38,-0.57l0.02,-0.86l0.37,-0.9l-0.79,-0.4l0.64,-0.54l-0.97,-0.9l-1.31,-1.15l-0.62,-0.96l-1.18,-0.89l-1.41,-1.29l0.31,-0.44l0.47,0.43l0.21,-0.21l-0.48,-0.89l-0.86,-0.25l-0.31,0.67l-1.62,-0.04l-1.01,-0.27l-1.16,-0.57l-1.56,-0.18l-0.79,-0.62l-1.44,-0.5l-1.75,-0.05l-1.28,-0.57l-1.51,-1.18l-3.17,-3.11l-1.45,-0.94l-2.29,-0.76l-1.56,0.21l-2.26,1.09l-1.41,0.29l-1.98,-0.76l-2.1,-0.56l-2.62,-1.33l-2.1,-0.41l-3.18,-1.35l-2.34,-1.4l-0.71,-0.78l-1.57,-0.17l-2.87,-0.93l-1.17,-1.34l-3.01,-1.67l-1.4,-1.87l-0.67,-1.45l0.93,-0.29l-0.29,-0.85l0.65,-0.77l0.01,-1.04l-0.94,-1.34l-0.26,-1.2l-0.94,-1.52l-2.47,-3.02l-2.82,-2.39l-1.36,-1.91l-2.41,-1.26l-0.51,-0.76l0.43,-1.92l-1.43,-0.73l-1.66,-1.52l-0.7,-2.19l-1.51,-0.26l-1.62,-1.66l-1.32,-1.55l-0.12,-1l-1.51,-2.42l-0.99,-2.48l0.04,-1.25l-2.03,-1.29l-0.93,0.14l-1.6,-0.9l-0.45,1.33l0.46,1.56l0.27,2.43l0.97,1.33l2.08,2.21l0.46,0.75l0.43,0.22l0.36,1.1l0.5,-0.05l0.57,2.04l0.85,0.8l0.59,1.11l1.77,1.6l0.93,2.89l0.83,1.35l0.78,1.44l0.15,1.62l1.35,0.1l1.13,1.39l1.02,1.36l-0.07,0.54l-1.18,1.11l-0.5,-0.01L166,396.2l-1.83,-1.73l-2.02,-1.48l-1.44,-0.78l0.09,-2.25l-0.42,-1.68l-1.34,-0.96l-1.93,-1.39l-0.37,0.4l-0.7,-0.82l-1.73,-0.75l-1.65,-1.83l0.2,-0.24l1.15,0.18l1.04,-1.18l0.11,-1.43l-2.16,-2.27l-1.64,-0.89l-1.04,-2.01l-1.04,-2.12l-1.3,-2.61l-1.13,-2.92l-0.02,0l-0.47,-1.7l-1.82,-1.92l-1.31,-0.4l-0.31,-0.96l-1.57,-0.17l-1,-0.91l-2.6,-0.33l-0.71,-0.55l-0.34,-1.87l-2.72,-3.45l-2.34,-4.85l0.1,-0.82l-1.24,-1.17l-2.17,-2.99l-0.39,-2.95l-1.49,-1.99l0.61,-3.05l-0.1,-3.2l-0.9,-2.9l1.1,-3.61l0.34,-3.54l0.34,-3.59l-0.51,-5.42l-0.89,-3.53l-0.82,-1.94l0.34,-0.82l4.05,1.42l1.49,3.91l0.69,-1.09l-0.45,-3.41l-0.95,-3.47l-0.38,-0.01l-5.43,-4.23l-2,-1.89l-5.08,-1.82l-1.56,-3.96l0.4,-2.79l-3.59,-1.96l-0.49,-3.76l-3.39,-3.45l-0.06,-2.48l-1.54,-1.83l-2.47,-1.57l-0.79,-4.36l-3.61,-4.13l-1.51,-4.94l-2.69,-0.34l-4.46,-0.13l-3.29,-1.54l-5.8,-5.64l-2.68,-1.05l-4.9,-1.99l-3.88,0.48l-5.51,-2.59l-3.33,-2.43l-3.11,1.21l0.58,3.93l-1.55,0.36l-3.24,1.16l-2.47,1.86l-3.11,1.16l-0.4,-3.24l1.26,-5.53l2.98,-1.77l-0.77,-1.46l-3.57,3.22l-1.91,3.77l-4.04,3.95l2.05,2.65l-2.65,3.85l-3.01,2.21l-2.81,1.59l-0.69,2.29l-4.38,2.63l-0.89,2.36l-3.28,2.13l-1.92,-0.38l-2.62,1.38l-2.85,1.67l-2.33,1.63l-4.81,1.38l-0.44,-0.81l3.07,-2.27l2.74,-1.51l2.99,-2.71l3.48,-0.56l1.38,-2.06l3.89,-3.05l0.63,-1.03l2.07,-1.83l0.48,-4l1.43,-3.17l-3.23,1.64l-0.9,-0.93l-1.52,1.95l-1.83,-2.73l-0.76,1.94l-1.05,-2.7l-2.8,2.17h-1.72l-0.24,-3.23l0.51,-2.02l-1.81,-1.98l-3.65,1.07l-2.37,-2.63l-1.92,-1.36l-0.01,-3.25l-2.16,-2.48l1.08,-3.41l2.29,-3.37l1,-3.15l2.27,-0.45l1.92,0.99l2.26,-3.01l2.04,0.54l2.14,-1.96l-0.52,-2.92l-1.57,-1.16l2.08,-2.52l-1.72,0.07l-2.98,1.43l-0.85,1.43l-2.21,-1.43l-3.97,0.73l-4.11,-1.56l-1.18,-2.65l-3.55,-3.91l3.94,-2.87l6.25,-3.41h2.31l-0.38,3.48l5.92,-0.27l-2.28,-4.34l-3.45,-2.72l-1.99,-3.64l-2.69,-3.17l-3.85,-2.38l1.57,-4.03l4.97,-0.25l3.54,-3.58l0.67,-3.92l2.86,-3.91l2.73,-0.95l5.31,-3.76l2.58,0.57l4.31,-4.61l4.24,1.83l2.03,3.87l1.25,-1.65l4.74,0.51l-0.17,1.95l4.29,1.43l2.86,-0.84l5.91,2.64l5.39,0.78l2.16,1.07l3.73,-1.34l4.25,2.46l3.05,1.13l5.23,1.94l4.41,3.8l2.92,0.72l2.46,-3.28l3.4,-2.5l4.17,0.98l4.2,-3.55l4.59,-2.05l1.93,3.39l2.09,-1.9l0.63,-3.91l1.94,0.89l4.74,7.32l3.73,-5.5l0.38,6.15l3.44,-1.31l1.06,-2.36l3.4,0.47l4.29,3.37l6.56,2.89l3.86,1.32l2.75,-0.5l3.78,3.9l-3.94,3.74l5.07,1.59l7.57,-0.87l2.39,-1.3l2.99,4.42l3.05,-3.72l-2.86,-3.19l1.81,-2.61l3.41,-0.35l2.24,-0.77l2.26,1.84l2.82,4.11l3.13,-0.6l4.95,3.35l4.35,-1.17l4.09,0.18l-0.32,-4.67l2.49,-1.33l4.34,2.58l-0.02,7l1.78,-5.88l2.26,0.2l1.27,-7.71l-3,-4.91l-3.27,-3.29l0.22,-9.34l3.32,-6.43l3.7,1.44l2.84,3.91l3.81,9.59l-2.49,4.01l5.21,1.63l-0.01,7.99l3.75,-6.09l3.35,5.02l-0.84,5.61l2.71,4.95l2.93,-5.3l2.04,-6.56l0.15,-8.71l3.98,0.62l4.14,1.19l3.76,3.95l0.17,3.87l-2.09,4.06l1.98,3.98l-0.36,3.54l-5.49,4.96l-3.9,1.08l-2.9,-2.11l-0.84,3.5l-2.7,5.73l-0.82,2.9l-3.25,4.39l-4.01,0.42l-2.21,2.68l-0.19,4.05l-3.26,0.77l-3.43,4.9l-3.04,6.6l-1.09,4.48l-0.15,6.41l4.12,0.9l1.26,4.99l1.31,3.95l3.92,-1.02l5.21,2.23l2.8,1.94l2.01,2.38l3.51,1.37l2.97,2.08l4.63,0.28l3.05,0.47l-0.46,4.19l0.87,4.76l2.03,5.17l4.17,4.28l2.16,-1.46l1.52,-4.68l-1.46,-7.4l-1.98,-2.53l4.49,-2.28l3.18,-3.46l1.55,-3.5l-0.23,-3.42l-1.9,-4.44l-3.41,-4.02l3.31,-5.75l-1.22,-5.12l-0.94,-9.18l1.95,-1.4l4.81,1.65l2.88,0.58l2.32,-1.58l2.61,2.04l3.45,3.44l0.85,2.27l5,0.44l-0.08,4.8l0.93,6.99l2.56,0.85l2.03,3.16l4.06,-2.97l2.68,-6.05l1.86,-2.61l2.18,4.98l3.65,6.89l3.1,6.26l-1.13,3.2l3.73,2.83l2.52,2.82l4.47,1.26l1.8,1.55l1.11,4.05l2.18,0.63l1.13,1.77l0.2,5.19l-2.04,1.71l-2.01,1.58l-4.62,1.59l-3.53,3.62l-4.74,0.71l-6,-0.92l-4.21,-0.03l-2.9,0.3l-2.35,3.11l-3.57,1.9l-4.04,5.57l-3.23,3.8l2.38,-0.67l4.5,-5.45l5.88,-3.53l4.19,-0.43l2.48,2.09l-2.65,2.83l0.89,4.46l0.92,3.07l3.64,2.01l4.63,-0.58l2.81,-4.56L305.76,317.43zM199.86,184.43l-1.96,3.54l-2.47,2.49l3.83,3.54l2.28,-0.85l3.78,2.36l1.74,-2.73l-1.71,-3.03l-0.84,-1.53l-1.68,-1.46L199.86,184.43zM239.75,238.48l0.61,1.63l1.98,0.14l3.28,-3.34l0.06,-1.19l-3.85,-0.06L239.75,238.48zM251.91,243.37l1.1,-3.12l-0.71,-1.23l-1.15,-0.13l-1.08,1.8l-0.13,0.41l0.74,1.77L251.91,243.37zM202.94,154.49l-0.73,-2.88l-5,1.26l-3.34,-2.11l-3.32,4.8l3.09,6.28l-5.72,-1.17l-0.06,3.01l6.97,7.05l1.94,3.38l2.7,0.73l4.6,-3.41l0.5,-8.21l-4.24,-4.07L202.94,154.49zM192.12,185.41l-5.06,-3.93l-4.71,-4.21l-0.87,-6.18l-1.76,-8.92l-3.14,-3.84l-2.79,-1.55l-2.47,1.42l1.99,9.59l-1.41,3.73l-2.29,-8.98l-2.56,-3.11l-3.17,4.81l-3.9,-4.76l-6.24,2.87l1.4,-4.46l-2.87,-1.87l-7.51,5.84l-1.95,3.71l-2.35,6.77l4.9,2.32l4.33,-0.12l-6.5,3.46l1.48,3.13l3.98,0.17l5.99,-0.67l5.42,1.96l-3.66,1.44l-3.95,-0.37l-4.33,1.41l-1.87,0.87l3.45,6.35l2.49,-0.88l3.83,2.15l1.52,3.65l4.99,-0.73l7.1,-1.16l5.26,-2.65l3.26,-0.48l4.82,2.12l5.07,1.22l0.94,-2.86l-1.79,-3.05l4.6,-0.64L192.12,185.41zM250.65,230.6l-2,-2.11l-2.06,0.5l-0.25,-3.06l-3.21,-2.04l-3.07,-2.27l-1.63,-1.75L237,220.9l-0.52,-2.96l-2.03,-0.55l-0.96,6.13l-0.36,5.11l-2.44,3.14l3.8,-0.6l0.96,3.65l3.99,-3.23l2.78,-3.38l1.57,2.86l4.36,1.51L250.65,230.6zM222.35,51.34l2.34,7.29l4.96,5.88l9.81,-1.09l6.31,1.97l-4.38,6.05l-2.21,-1.78l-7.66,-0.71l1.19,8.31l3.96,6.04l-0.8,5.2l-4.97,3.46l-2.27,5.47l4.55,2.65l3.82,8.55l-7.5,-5.7l-1.71,0.94l1.38,9.38l-5.18,2.83l0.35,5.85l5.3,0.63l4.17,1.44l8.24,-1.84l7.33,3.27l7.49,-7.19l-0.06,-3.02l-4.79,0.48l-0.39,-2.84l3.92,-3.83l1.33,-5.15l4.33,-3.83l2.66,-4.76l-2.32,-7.1l1.94,-2.65l-3.86,-1.89l8.49,-1.63l1.79,-3.15l5.78,-2.6l4.8,-13.47l4.57,-4.94l6.62,-11.12l-6.1,0.1l2.54,-4.3l6.78,-3.99l6.84,-8.9l0.12,-5.73l-5.13,-6.04l-6.02,-2.93l-7.49,-1.82l-6.07,-1.49l-6.07,-1.5l-8.1,3.98l-1.49,-2.53l-8.57,0.98l-5.03,2.57l-3.7,3.65l-2.13,11.74L239,24.52l-3.48,-1.14l-4.12,7.97l-5.5,3.35l-3.27,0.66l-4.17,3.84l0.61,6.65L222.35,51.34zM167.77,94.21l-3.65,-2.9l-1.5,-0.66l-2.88,4.28l-0.05,2l4.66,0.01L167.77,94.21zM284.83,184.6l-2.44,-3.35l-6.77,-3.35l-2.92,-5.55l-5.21,1.99l-0.36,-3.86l-3.86,-4.32l-6.22,-4.71l-2.65,3.71l-5.55,2.66l0.42,-6.06l-4.81,-10.05l-7.11,4.06l-2.59,7.7l-2.21,-5.92l2.06,-6.37l-7.24,2.65l-2.88,3.99l-2.15,8.42l0.89,9.05l3.98,0.04l-2.93,3.92l2.33,2.96l4.55,1.25l5.93,2.42l10.2,1.82l5.08,-1.04l1.5,-2.42l2.21,2.79l2.47,0.46l2.97,4.96l-1.8,1.98l5.68,2.63l4.29,3.68l1.08,2.55l0.77,3.24l-3.63,6.93l-0.98,3.44l0.94,2.42l-5.77,0.86l-5.27,0.12l-1.85,4.87l2.37,2.23l8.11,-1.03l-0.04,-1.89l4.08,3.15l4.18,3.28l-0.98,1.77l3.4,3.02l6.02,3.53l7.6,2.39l-0.46,-2.09l-2.92,-3.67l-3.96,-5.37l7.03,5l3.54,1.66l0.97,-4.44l-1.82,-6.3l-1.16,-1.73l-3.81,-3.03l-2.95,-3.91l0.35,-3.94l3.63,-0.87l4.41,6.6l3.45,2.85l4.92,-7.87l0.87,-4.93l-4.41,-0.47l-4.03,-6.7l-4.45,-1.64l-6.6,-4.97l5.15,-3.63L284.83,184.6zM264.36,205.36l0.32,-1.01l-0.03,-3.17l-2.19,-2.08l-2.57,1.05l-1.19,4.17l0.7,3.56l3.14,-0.36L264.36,205.36zM182.25,154.98l-2.13,-2.17l-3.76,0.4l-0.95,1.38l4.37,6.75L182.25,154.98zM195.4,139.8l4.62,-1.11l1.28,-8.25l-0.09,-5.95l-2.14,-5.56l-0.22,1.6l-3.94,-0.7l-4.22,4.09l-3.02,-0.37l0.18,8.92l4.6,-0.87l-0.06,6.47L195.4,139.8zM248.49,155.83l3.08,5.1l0.81,0.57l3.07,-1.27l3.02,0.2l2.98,0.28l-0.25,-2.64l-4.84,-5.38l-6.42,-1.08l-1.35,0.67L248.49,155.83zM200.13,101.41l2.28,3.12l4.15,-2.77l0.76,-4.97l-3.35,-4.92l-1.63,-0.96l-3.63,-0.58l0.22,5.9L200.13,101.41zM183.06,93.13l-2.71,4.19l6.24,0.52l4.61,4.44l4.58,1.5l-1.09,-5.68l-2.14,-6.73l-7.58,-5.35l-5.5,-2.04l0.2,5.69L183.06,93.13zM208.96,82.89l5.13,-0.12l-2.22,4l-0.04,5.3l3.01,5.76l5.81,1.77l4.96,-0.99l5.18,-10.73l3.85,-4.45l-3.38,-4.97l-2.21,-10.65l-4.6,-3.19l-4.72,-3.68l-3.58,-9.56l-6.52,0.94l1.23,4.15l-2.87,1.25l-1.94,5.32l-1.94,7.46l1.78,7.26L208.96,82.89zM210.94,168.15l3.01,-6.93l3.34,-1.85l4.19,-8.74l-5.36,-2.47l-5.84,-0.36l-2.78,2.77l-1.47,4.23l-0.04,4.82l1.75,8.19L210.94,168.15zM212.14,108.88l0.33,-1.49l-1.97,-2.45l-5.65,-0.19l0.75,3.68l5.25,0.83L212.14,108.88zM211.25,143.05l1.53,-4.14l-1.02,-3.46l-2.45,-3.92l-4.03,3.02l-1.49,4.92l3.4,2.79L211.25,143.05zM228.09,145.15l5.76,-0.18l8.04,-1.61l3.59,1.28l4.18,-2.26l1.75,-2.84l-0.63,-4.52l-3,-4.23l-4.56,-0.8l-5.71,0.97l-4.46,2.44l-4.09,-0.94l-3.78,-0.5l-1.78,-2.7l-3.22,-2.61l0.64,-4.43l-2.42,-3.98l-5.52,0.03l-3.11,-3.99l-5.78,-0.8l-1.06,5.1l3.25,3.74l5.8,1.45l2.81,5.09l0.34,5.6l0.97,5.99l7.45,3.42L228.09,145.15z'
          }, {
            'id': 'asia',
            'title': 'Asia',
            'd': 'M835.21,465.56l-1.16,-1.47l0.43,-1.69l1.45,0.27l0.15,-2.43l-0.26,-1.14l-1.66,-0.24l-0.2,-1.52l-0.93,1.01l-0.56,2.23l0.83,3.56l1.13,1.76L835.21,465.56zM829.05,473.44l1.94,0.51l1.05,-0.93l-0.7,-0.92l-2.84,0.13L829.05,473.44zM819.98,432.89l-0.31,1.76l-0.7,0.79l-0.58,0.76l1.73,1.95l0.88,-0.84l0.88,-1.79l1.01,-0.93l0.27,-2.71l-2.08,2.74l0.45,-1.91L819.98,432.89zM817,430.02l0.43,1.35l-0.2,1.45l0.1,1.32l1.78,-0.85l1.3,-1.2l0.05,-1.19h-1.78L817,430.02zM814.05,427.7l1.2,1.42l0.74,-2.47l-0.97,-1.03l-2.4,-0.1L814.05,427.7zM830.35,486.86l-1.96,0.1l-2.41,0.63l-0.33,0.67l-2.77,1.12l-1.21,1.72l-0.25,0.96l0.34,0.34l2.4,-0.62l1.83,-2.11l2.35,-0.81l2.92,-1.23l1.03,-0.76l-1.06,-0.35L830.35,486.86zM815,398.14l1.69,-4.88l0.49,-1.85l-1.28,-0.92l-2.24,2.33l-1.65,3l0.32,2.25l1.48,2.55L815,398.14zM827.14,429.25l-0.77,-1.06l-2.69,-0.06l1.71,2.18l0.04,1.08l-1.65,-0.23l0.44,1.72l0.84,0.15l0.12,1.99l1.33,-0.63l-0.69,-1.75l-0.06,-0.95l2.16,0.75L827.14,429.25zM821.49,439.08l-1.53,1.06l-1.77,0.79l-1.1,2.37l0.46,0.82l2.08,-1.57l1.32,0.11l0.88,-1.17l1.78,1.33l-0.86,1.33l0.79,2.03l3.3,1.63l0.8,-1.31l-0.9,-2.06l1.31,-1.42l1.02,2.86l0.96,-2.57l-0.17,-1.58l-0.29,-1.87l-0.2,-1.04l-0.24,-1.42l-2.27,-1.34l0.17,2.18l-1.98,0.08l-0.46,1.26l-2.13,0.77L821.49,439.08zM868.65,337.12l-1.18,2.33l0.48,4.1l-1.76,4.38l-1.59,1.38l-4.11,3.51l-1.87,-1.67l-2.93,6.17l-3,-0.7l-5.58,1.02l-2.06,2.33l-2.82,1.75l-1.47,2.11l-2.65,1.03l1.14,2.28l1.77,0.96l-0.69,2.96l1.36,1.27l1.81,-1.37l1.87,-5.61l-2.84,-2.46l3.28,-0.06l3.32,-1.59l4.88,-0.75l0.12,2.52l1.88,1.29l4,-3.84l4.93,-0.21l3.58,-1.6l1.46,-2.42l-0.49,-1.73l1.06,-2.78l-0.05,-3.64l2.59,-3.6l0.08,-2.94l-1.53,-5.11L868.65,337.12zM872.26,293.25l1.64,4.41l-0.12,5.85l-0.65,3.24l0.32,4.54l-0.31,4.01l0.52,3.4l1.84,-3.13l2.13,2.44l0.08,-2.84l-2.73,-4.23l1.72,-6.11l4.15,1.41l-2.82,-7.68l-1.16,-4.51l0.07,-4.5l-0.97,-4.5l-0.73,-3.15l-1.25,0.67l1.11,2.21l-2.59,2.17L872.26,293.25zM837.99,471.19l-3.46,0.12l-0.67,1.53l1.94,0.1l1.58,-0.18l2.34,0.23l2.37,1.15l-1.02,-2.13L837.99,471.19zM647.68,391.17l-5.27,-0.93l-3.06,-0.71l-3.16,-0.41l-1.2,-3.81l-1.34,-0.56l-2.16,0.56l-2.82,1.51l-3.43,-1.03l-2.83,-2.41l-2.7,-0.9l-1.87,-3.01l-2.07,-4.27l-1.51,0.52l-1.78,-1.07l-1.05,1.26l-1.66,-0.15l0.58,1.41l-0.25,0.73l0.9,2.41l1.1,2.73l1.38,0.71l0.48,1.11l1.91,1.31l0.17,1.29l-0.28,1.03l0.36,1.04l0.8,0.87l0.38,1.01l0.42,0.75l-0.19,-2.24l0.76,-1.62l0.76,-0.34l0.85,0.97l0.05,1.81l-0.61,1.81l0.53,1.17l0.5,-0.15l0.11,0.84l2.19,-0.48l2.32,0.08l1.69,0.09l1.92,-2.07l2.1,-1.98l1.77,-1.9l0.81,-1.06l0.35,0.27l-0.26,1.28L633,389.2l0.38,2.44l1.26,2.09l1.56,1.11l2.06,0.4l1.66,0.55l1.27,1.74l0.75,1.01l1.01,0.38l-0.01,0.67l-1.02,1.8l-0.45,0.84l-1.18,0.95l-1.05,2.05l-1.27,-0.16l-0.58,0.71l-0.45,1.5l0.34,1.98l-0.26,0.36l-1.29,-0.01l-1.75,1.1l-0.27,1.43l-0.65,0.62l-1.74,-0.02l-1.1,0.73l0.02,1.18l-1.36,0.81l-1.55,-0.27l-1.87,0.98l-1.3,0.16l-2.03,0.79l-0.54,1.28l-0.07,0.99l-2.79,1.22l-4.48,1.35l-2.51,2.03l-1.23,0.15l-0.84,-0.17l-1.64,1.2l-1.79,0.55l-2.35,0.15l-0.71,0.16l-0.61,0.75l-0.74,0.21l-0.43,0.73l-1.39,-0.06l-0.9,0.38l-1.94,-0.14l-0.73,-1.67l0.08,-1.57l-0.45,-0.85l-0.55,-2.12l-0.81,-1.19l0.56,-0.14l-0.29,-1.32l0.34,-0.56l-0.12,-1.26l-0.36,-1.24l-0.85,-0.88l-0.22,-1.17l-1.44,-1.04l-1.5,-2.46l-0.79,-2.41l-1.94,-2.04l-1.25,-0.48l-1.86,-2.85l-0.32,-2.08l0.12,-1.79l-1.61,-3.36l-1.31,-1.19l-1.52,-0.63l-0.92,-1.76l0.15,-0.69l-0.78,-1.6l-0.82,-0.69l-1.09,-2.32l-1.71,-2.52l-1.43,-2.16l-1.39,0.01l0.43,-1.74l0.13,-1.11l0.34,-1.28l-0.09,-0.46l-1.84,-5.55l0.81,-1.08l-0.19,-0.19l0.74,-1.53l0.57,-2.5l0.4,-0.84l0.08,-0.03l1,-2.73l1.39,-2.38l0.06,-0.12l-0.26,-2.61l0.68,-1.41l0.75,-0.75l0.75,-0.76l0.16,-1.94l0.91,0.68l3.09,-0.97l1.49,0.65l2.31,-0.01l3.22,-1.31l1.52,0.06l3.19,-0.54l1.2,-0.55l3.26,0.46l0.99,0.89l1.34,-0.59l-1.53,-2.83l0.54,-1.09l-0.87,-4.12l1.92,-1.03l0.44,1.37l1.42,1.66l1.92,0.47l1.02,-0.1l3.31,-2.66l1.05,-0.27l0.82,1.07l-0.96,1.78l1.75,1.86l0.69,-0.17l0.89,2.61l2.66,0.73l1.95,1.76l3.98,0.6l4.38,-0.92l0.27,-0.82l0.08,-0.02l-0.52,-2.48l0.41,-3.73l-2.19,-1.22l0.72,-2.48l-1.86,-0.21l0.62,-3.09l2.64,0.91l2.46,-1.18l-2.04,-2.23l-0.8,-2.14l-2.26,0.96l-0.29,2.73l-0.88,-2.42l-0.16,-0.92l0.69,-1.57l-0.54,-1.32l-3.25,-1.3l-1.27,-3.46l-1.55,-0.99l-0.09,-1.28l2.73,0.37l0.11,-2.88l2.38,-0.65l2.45,0.59l0.5,-3.91l-0.5,-2.51l-2.81,0.2l-2.38,-1l-3.25,1.8l-2.62,0.85l-1.42,-0.66l0.28,-2.1l-1.79,-2.76l-2.08,0.12l-2.38,-2.84l1.62,-3.21l-0.82,-0.87l2.24,-4.77l2.88,2.53l0.35,-3.19l5.79,-4.85l4.38,-0.12l6.18,3.1l3.32,1.79l2.98,-1.87l4.44,-0.09l3.59,2.29l0.81,-1.31l3.94,0.19l0.7,-2.11l-4.54,-3.1l0.37,-0.3l-0.3,-0.11l-0.8,-1.88l-1.88,-0.67l-0.09,-2.65l1.13,-2.2l1.33,-1.39l-0.71,-1.75l-1.89,-1.07l-1.84,1.12l-1.9,1.5l-1.81,-2.32l-1.2,-1.83l-1.3,-2.44l3.08,-0.37l2.57,-0.64l1.66,-2.67l-0.31,-2.15l-2.11,-1.76l0.56,-2.42l2.17,-2.73l1.78,-3.54l1.77,-5l1.34,-8.84l1.89,-19.97l5.23,-4.07l4.82,-5.44l3.93,-3.13l3.76,-3.86l2.03,-4.04l-0.92,-7.34l1.6,1.39l1.88,-3.97l-2.85,-4.11l-0.08,-1.68l-3.38,-0.78l0.92,-3.83l-1.5,-6.49l-0.08,-2.74l5.17,-7.99l1.84,-8.42l2.08,-1.88l7.42,2.51l0.58,5.18l-2.66,7.28l1.74,2.78l0.9,5.94l-0.64,11.07l3.09,4.73l-1.2,5.01l-5.49,10.2l3.21,1.02l1.12,-2.51l3.08,-1.82l0.74,-3.55l2.43,-3.49l-1.63,-4.26l1.31,-5.08l-3.07,-0.64l-0.67,-4.42l2.24,-8.28l-3.64,-7.03l5.02,-6.04l-0.65,-6.62l1.4,-0.22l1.47,5.19l-1.11,8.67l3,1.59l-1.28,-6.37l4.69,-3.58l5.82,-0.49l5.18,5.18l-2.49,-7.62l-0.28,-10.28l4.88,-2.02l6.74,0.44l6.08,-1.32l-2.28,-5.38l3.25,-7.02l3.22,-0.3l5.45,-5.51l7.4,-1.51l0.94,-3.15l7.36,-1.08l2.29,2.61l6.29,-6.24l5.15,0.2l0.77,-5.24l2.68,-5.33l6.62,-5.31l4.81,4.21l-3.82,3.13l6.35,1.92l0.76,6.03l2.56,-2.94l8.2,0.16l6.32,5.84l2.25,4.35l-0.7,5.85l-3.1,3.24l-7.37,5.92l-2.11,3.08l3.48,1.43l4.15,2.55l2.52,-1.91l1.43,6.39l1.23,-2.56l4.48,-1.57l9,1.65l0.68,4.58l11.72,1.43l0.16,-7.47l5.95,1.74l4.48,-0.05l4.53,5.14l1.29,6.04l-1.66,3.84l3.52,6.98l4.41,3.49l2.71,-9.18l4.5,4l4.78,-2.38l5.43,2.72l2.07,-2.47l4.59,1.24l-2.02,-8.4l3.7,-4.07l25.32,6.06l2.39,5.35l7.34,6.65l11.32,-1.62l5.58,1.41l2.33,3.5l-0.34,6.02l3.45,2.29l3.75,-1.64l4.97,-0.21l5.29,1.57l5.31,-0.89l4.88,6.99l3.47,-2.48l-2.27,-5.07l1.25,-3.62l8.95,2.29l5.83,-0.49l8.06,3.84l3.92,3.44l6.87,5.86l7.35,7.34l-0.24,4.44l1.89,1.74l-0.65,-5.15l7.61,1.07l5.67,6.59l-2.78,2.97l-4.6,0.7l-0.07,6.46l-1.12,1.35l-2.63,-0.19l-2.14,-2.26l-3.73,-1.92l-0.63,-2.89l-2.85,-1.1l-3.19,0.87l-1.52,-2.37l0.61,-2.55l-3.36,1.64l1.26,3.19l-1.59,2.83l-0.02,0.04l-3.6,2.89l-3.63,-0.48l2.53,3.44l1.67,5.2l1.29,1.67l0.33,2.53l-0.72,1.6l-5.23,-1.32l-7.84,4.51l-2.49,0.69l-4.29,4.1l-4.07,3.5l-1.03,2.55l-4.01,-3.9l-7.31,4.42l-1.28,-2.08l-2.7,2.39l-3.75,-0.76l-0.9,3.63l-3.36,5.22l0.1,2.14l3.19,1.17l-0.38,7.46l-2.6,0.19l-1.2,4.15l1.17,2.1l-4.9,2.47l-0.97,5.4l-4.18,1.14l-0.84,4.66l-4.04,4.18l-1.04,-3.08l-1.2,-6.69l-1.56,-10.65l1.35,-6.95l2.37,-3.07l0.15,-2.44l4.36,-1.18l5.01,-6.78l4.83,-5.73l5.04,-4.57l2.25,-8.37l-3.41,0.51l-1.68,4.92l-7.11,6.36l-2.3,-7.14l-7.24,2l-7.02,9.56l2.32,3.38l-6.26,1.42l-4.33,0.56l0.2,-3.95l-4.36,-0.84l-3.47,2.7l-8.57,-0.94l-9.22,1.62l-9.08,10.33l-10.75,11.78l4.42,0.61l1.38,3l2.72,1.05l1.79,-2.38l3.08,0.31l4.05,5.19l0.09,3.92l-2.19,4.51l-0.24,5.27l-1.26,6.85l-4.23,6.01l-0.94,2.82l-3.81,4.66l-3.78,4.53l-1.81,2.28l-3.74,2.25l-1.77,0.05l-1.76,-1.86l-3.76,2.79l-0.44,1.26l-1.07,-0.23l-1.22,1.28l-0.84,1.27l0.11,2.67l-1.45,0.82l-0.5,0.65l-1.06,1.08l-1.87,0.6l-1.22,0.98l-0.09,1.57l-0.33,0.4l1.12,0.58l1.59,1.57l2.42,4.18l0.69,2.27l0.02,3.99l-1.06,1.88l-2.54,0.65l-2.24,1.41l-2.53,0.29l-0.31,-1.85l0.52,-2.57l-1.24,-3.6l2.08,-0.59l-1.92,-3l-1.36,-0.67l-0.34,0.66l-0.82,0.29l-0.1,-0.67l-0.73,-0.32l-0.75,-0.57l0.77,-1.57l0.66,-0.42l-0.25,-0.65l0.71,-1.94l-0.18,-0.59l-1.64,-0.39l-1.32,-0.98l-3.92,1.06l-2.06,1.69l-3.02,0.98l1.49,-1.67l-0.59,-1.41l2.22,-2.45l-1.48,-1.93l-2.44,1.3l-3.17,2.54l-1.73,2.34l-2.75,0.17l-1.43,1.68l1.48,2.41l2.29,0.58l0.09,1.58l2.22,1.02l3.14,-2.51l2.49,1.37l1.81,0.09l0.46,1.84l-3.97,0.97l-1.31,1.87l-2.73,1.73l-1.44,2.39l3.02,1.86l1.1,3.31l1.71,3.05l1.9,2.53l-0.05,2.43l-1.76,0.89l0.67,1.73l1.65,1l-0.43,2.61l-0.71,2.52l-1.57,0.28l-2.05,3.41l-2.27,4.09l-2.6,3.68l-3.86,2.82l-3.9,2.55l-3.16,0.35l-1.71,1.34l-0.97,-0.98l-1.59,1.5l-3.92,1.5l-2.97,0.46l-0.96,3.15l-1.55,0.17l-0.74,-2.16l0.66,-1.16l-3.76,-0.96l-1.33,0.49l-3.74,2.56l-2.34,2.81l-0.62,2.05l2.14,3.1l2.62,3.81l2.54,1.79l1.7,2.32l1.28,5.32l-0.38,5.02l-2.34,1.87l-3.21,1.83l-2.29,2.36l-3.5,2.63l-1.02,-1.81l0.79,-1.91l-2.08,-1.61l-2.35,-0.41l-1.14,-1.48l-1.42,-2.94l-2.52,-1.31l-2.4,0.05l0.41,-2.25l-2.47,0.02l-0.22,3.14l-1.51,4.15l-0.91,2.5l0.19,2.04l1.83,0.09l1.14,2.57l0.5,2.43l1.56,1.61l1.7,0.33l1.45,1.46l0.64,0.26l1.66,1.69l1.18,1.87l0.16,1.88l-0.3,1.27l0.27,0.96l0.21,1.65l0.99,0.77l1.1,2.46l-0.05,0.94l-1.99,0.19l-2.65,-2.06l-3.32,-2.21l-0.33,-1.42l-1.62,-1.87l-0.39,-2.31l-1.01,-1.52l0.31,-2.04l-0.62,-1.19l-1.11,-1.08l-0.48,-1.39l-1.49,-1.59l-1.36,-1.33l-0.46,1.65l-0.53,-1.56l0.31,-1.76l0.83,-2.71l-0.27,-2.1l0.86,-2.17l-0.94,-1.68l0.23,-3.11l-1.14,-1.48l-0.91,-3.44l-0.51,-3.65l-1.21,-2.41l-1.85,1.46l-3.19,2.07l-1.57,-0.26l-1.74,-0.68l0.97,-3.6l-0.58,-2.74l-2.2,-3.39l0.34,-1.07l-1.64,-0.38l-1.99,-2.42l-0.8,-1.56l-0.16,-1.53l-0.53,-1.45l-1.17,-1.76l-2.58,-0.12l0.25,1.25l-0.88,1.67l-1.19,-0.61l-0.41,0.55l-0.79,-0.33l-1.08,-0.27l-0.4,1.1l-1.91,-0.04l-3.46,0.62l0.16,2.25l-1.5,1.76l-4.04,1.99l-3.14,3.47l-2.11,1.85l-2.79,1.91v1.34l-1.4,0.72l-2.53,1.04l-1.31,0.15l-0.84,2.21l0.58,3.74l0.15,2.38l-1.19,2.71l-0.01,4.83l-1.45,0.14l-1.28,2.16l0.85,0.93l-2.56,0.8l-0.94,1.92l-1.13,0.81l-2.65,-2.63l-1.3,-3.96l-1.08,-2.86l-0.98,-1.35l-1.49,-2.74l-0.7,-3.58l-0.48,-1.8l-2.55,-3.97l-1.16,-5.65l-0.84,-3.76l0.01,-3.59l-0.54,-2.79l-4.08,1.79l-1.98,-0.36l-3.66,-3.63l1.35,-1.09l-0.83,-1.19l-3.29,-2.58l-2.05,-0.77l-0.84,-2.2l-2.17,-2.34l-5.17,0.58l-4.56,0.06l-3.95,0.43zM880.73,326.62l-1.97,-0.83l-2.15,-1.31l-3.29,-4.12l-0.83,3.09l-0.82,5.38l-3,0.21l-1.39,2.94l0.39,3.74l3.12,-0.06l1.53,-4.12l4.41,2.58l2.46,-3.76l4.16,-1.05l-0.62,-4.35L880.73,326.62zM870.6,470.63l-3.01,-0.53l-2.08,-1l-2.4,-0.97h-2.49l-3.22,1.68l-2.34,2.96l-2.9,-1.67l-0.78,-4.51l-0.44,-1.04l-4.5,-1.14l-1.44,0.91l-3.78,0.67l1.19,1.38l2.5,0.51l1.11,1.66l4.1,0.01l0.24,0.74l-2,-0.05l-3.02,1l2.14,1.37l0.01,1.21l0.64,1.02l1.08,-0.25l0.83,-1.36l4.21,2.58l2.31,0.23l5.44,2.37l1.35,2.35l0.73,3.05l-1.77,0.78l-1.19,2.29l3.55,-0.09l0.69,-0.8l2.85,0.57l2.5,2.31l-0.05,-9.16L870.6,470.63zM811.49,419.94l0.42,1.26l1.38,1.65l0.36,-1.04l0.84,0.67l-0.88,0.73l-0.14,1.19l1.4,0.63l2.55,-0.42l1.79,1.72l0.72,-1.05l1.04,1.5l2.18,1.4l0.29,-1.32l-0.92,-0.69l0.27,-1.56l-3.5,-1.59l-1.24,0.34l-1.49,-0.32l-0.63,-2.29l0.44,-2.33l1.65,-0.96l0.74,-2.42l-0.96,-2.09l0.46,-1.22l-0.25,-0.75l-0.86,0.76l-1.73,-0.84h-1.7l-0.91,2.66l-0.29,4.55l-1.13,-0.96L811.49,419.94zM848.95,364.89l1.44,-0.78l1.15,1.07l1.58,-2.03l-0.36,-1.15l-2.06,-0.73l-1.15,1.42l-1.59,-0.39l-1.55,2l-0.02,1.58l1.83,0.95L848.95,364.89zM851.78,479.52l-0.5,1.01l0.27,2.11l1.44,-1.91l0.01,-1.34l-0.64,-0.82L851.78,479.52zM769.87,98.34l0.83,-5.72l-7.11,-8.34l-2.11,-0.98l-2.3,1.7l-5.12,18.6L769.87,98.34zM736.89,82.07l4.65,5.73l7.81,4.2l6.12,-1.8l0.69,-13.62l-6.46,-16.04l-5.45,-9.02l-6.07,4.11l-7.28,11.83l3.83,3.27L736.89,82.07zM701.91,437.46l-1.94,-1.57l-1.27,4.58l0.5,4.04l1.33,2.23l2.44,-0.64l1.18,-0.8l0.42,-2.92l-1.36,-2.93L701.91,437.46zM870.07,151.56l-2.66,3.92l0.49,0.52l5.75,1.08l4.25,-0.07l-0.34,-2.57l-3.98,-3.81L870.07,151.56zM869.51,140.34l10.33,0.3l2.21,-8.14l-10.13,-6.07l-7.4,-0.51l-3.7,2.18l-1.51,7.75l5.55,7.01L869.51,140.34zM979.95,178.65l3.66,-0.52l2.89,-2.06l0.24,-1.19l-4.06,-2.51l-2.38,-0.02l-0.36,0.37l-3.57,3.64l0.5,2.73L979.95,178.65zM894.64,142.03l3.24,-4.25l-7.04,-2.88l-5.23,-1.68l-0.67,3.59l5.21,4.27L894.64,142.03zM772.06,475.39l0.7,-3.47l-1.36,-1.76l-2.06,-0.25l-0.98,-1.56l-0.48,-1.94l-1.01,-0.07l-1.61,-0.97l1.12,-2.27l-2.13,-1.27l-1.62,-2.33l-2.36,-1.91l-2.85,-0.04l-2.66,-3l-1.55,-1.16l-2.17,-1.89l-2.48,-2.73l-4.34,-0.54l-1.81,-0.11l0.25,1.42l2.92,3.08l2.11,1.56l1.47,2.39l2.53,1.75l1.03,2.17l0.82,2.39l2.46,2.32l2.13,3.9l1.39,2.09l2.12,2.27l1.2,1.69l3.6,2.28l2.36,2.34l3.1,-0.06L772.06,475.39zM808.57,486.53l-1.73,0.23l-1.01,-0.75l-0.75,1l-1.54,0.02l-0.96,1.62l1.51,0.02l1.94,-0.38l3.24,-0.57L808.57,486.53zM811.44,489.58l-2.61,0.56l3.72,1.98l1.18,-0.05l0.17,-0.76l-0.98,-0.86L811.44,489.58zM808.99,435.38l1.85,-1.56l-0.5,-2.31l-1.47,2.82l-1.68,1.96l-2.03,1.74l-1.38,1.97l3.73,-2.67L808.99,435.38zM814.34,467.31l-2.51,-2.48l0.4,-2.11l2.45,-0.4l4.67,-0.14l2.7,0.54l2.11,-0.54l2.25,-2.76l-0.49,-0.62l-2.77,2.02l-3.22,0.12l-3.54,-0.39l-2.19,-0.82l-2.38,2.07l-0.59,1.15l-1.41,4.2l-0.4,2.21l-1.16,1.83l0.87,1.91l1.18,0.02l0.43,2.69l-0.8,2.57l1.2,0.82l1.78,-0.41l-0.11,-4l-0.24,-3.25l1.87,-0.85l-0.21,2.72l2.02,1.64l-0.36,1.08l0.7,0.77l2.75,-1.08l-1.36,2.29l1.1,0.98l1.5,-0.82l0.02,-1.84l-2.52,-3.22l0.51,-0.96l-2.65,-3.57l2.47,-1.08l1.22,-1.63l1.22,0.4l0.23,-1.28l-5.23,0.95L814.34,467.31zM815.48,487.25l-1.76,-0.84l-2.23,0.59l0.01,1.03l3.73,0.35l4.21,-0.8l0.41,-1.56l-2.51,1.03L815.48,487.25zM804.64,463.1l0.94,-1.9l3.32,-0.33l-3.14,-2.58l0.48,-1.28l-2.06,-2.64l1.59,-2.52l2.06,-0.95l-0.5,-1.36l1.88,-0.14l0.2,-1.1l-2.34,-0.84l-1.85,-0.78l-0.13,-1.22l-1.44,-1.42l-1.13,0.01l-1.41,2.19l-2.16,1.95l-2.39,1.53l-1.11,1.05l-1.38,1.77l-2.01,2.21l-3.36,0.6l-1.2,0.53l-0.56,2.36l-2.17,0.52l-2.05,-0.96l-1.67,1.85l-0.33,2.58l0.39,2.44l1.35,2.38l1.4,0.77l0.43,3.74l2.31,0.32l1.84,-0.15l1.02,1.35l3.33,-1l1.4,0.89l2,0.16l1.11,1.71l3.19,-1.26l0.41,0.99l1.08,-4.27l0.07,-2.78l2.7,-1.91L804.64,463.1zM785.28,408.7l1.23,-1.3l-0.63,-1.13l-1.61,-0.07l-3.06,0.83l-1.38,1.34l0.08,2.53l2.3,0.91l2.42,-1.41L785.28,408.7zM792.03,484.6l-1.02,-1.82l-5.2,-1.35l-0.62,1.16l-5.37,-0.28l-0.38,-1l-1.16,-0.21l-2.26,-1.09l-3.4,-0.17l-1.92,2.68l2.57,0.21l0.49,1.21l5.11,1.16l1.17,-0.35l2.06,0.28l3.25,1.07l2.62,0.51l2.91,0.21l2.54,-0.08l3.08,1.13l3.2,-1.07l-3.44,-1.67L792.03,484.6z'
          }, {
            'id': 'europe',
            'title': 'Europe',
            'd': 'M533.37,106.83l1.94,-3.42l-1.69,-4.34l5.81,-2.78l1.11,5.18l4.05,3.03l-6.26,5.36L533.37,106.83zM531.04,75.59l0.5,4.32l8.27,2.56l8.13,-1.81l4.16,-8.52l-5.5,-5.8l-7.09,-4.26l-2.84,5.09l-4.07,-4.08l-8.66,4.72l3.07,7.48L531.04,75.59zM512.18,102.19l4.2,3.86l-2.54,4.62l6.03,7.64l3.38,-0.48l1.33,-10.51l2.46,-2.49l1.56,-10.09l7.06,-5.66l-9.23,-11.29l-3.54,-5.57l-4.12,0.56l-1.06,5.43l-3.99,0.22l-1.54,-5.56l-7.64,5.69l2.18,11.79L512.18,102.19zM434.57,212.43l-4.65,-0.5l-4.57,3.71l-3.53,-1.96l-4.26,3.75l-4.37,-4.68l-4.25,1.03l-1.89,4.47l5.88,1.57l0.12,1.96l-4.96,1.28l6.1,3.2l-2.76,2.84l7.82,2.01l3.69,0.93l2.42,-1.15l8.09,-4.38l3.65,-5.01l-3.17,-4.6L434.57,212.43zM459.59,277.32l1.51,-2.34l0.92,1.37l-1.02,2.2l0.67,1.32l3.4,0.85l0.04,0.07l1.88,2.95l-0.41,2.74l0,0l-4.17,-0.42l-0.53,3.06l1.54,2.48l-2.93,1.41l0.79,1.8l4.38,0.75h0.02l-2.51,0.97l-4.11,4.64l1.49,0.87l1.97,-1.67l2.59,0.5l1.85,-2.06l1.31,0.87l4.77,-1.21l3.75,0.04l2.52,-2.33l-1.12,-2.33l1.43,-1.33l0.34,-2.93l-3.4,-0.88l-0.8,-1.84l-1.73,-5.41l-1.92,-0.77l-2.5,-5.79l-0.22,-0.52l-2.9,-0.32l2.52,-4.53l0.73,-4.22l-3.07,-0.03l-2.86,0.72l3,-5.73l-3.38,0.45l-2.24,-0.42l-2.18,4.31l-1.02,5.36l1.42,2.59L459.59,277.32zM605.64,69.03l3.04,3.88l3.28,-2.69l0.39,-2.72l2.52,-1.27l3.76,-2.23l1.08,-2.62l-4.16,-3.85l-2.64,2.9l-1.61,4.12l-0.57,-4.65l-4.26,0.21L601,63.25l6.24,0.52L605.64,69.03zM622.39,166.28l-2.87,1.96l0.41,4.83l5.08,2.35l0.74,3.82l9.16,1.1l1.66,-0.74l-5.36,-7.11l-0.57,-7.52l4.39,-9.14l4.18,-9.82l8.71,-10.17l8.56,-5.34l9.93,-5.74l1.88,-3.71l-1.95,-4.83l-5.46,1.6l-4.8,4.49l-9.33,2.22l-9.26,7.41l-6.27,5.85l0.76,4.87l-6.71,9.03l2.58,1.22l-5.56,8.27L622.39,166.28zM516.64,348.19l-2.86,0.39l-3.28,-0.32l-0.39,1.82l3.91,1.79l1.43,0.38l2.14,1.31l0.59,-1.79l-0.42,-1.09l1.01,-2.78L516.64,348.19zM569.65,357.85l-2.02,-0.05l-0.41,0.82l-0.2,0.02l-1.33,0.13l0.66,1.37l1.37,0.44l2.87,-1.38l-0.09,-0.27l-0.2,-0.64l1.89,-1.46L569.65,357.85zM547.51,357.92l-2.09,-0.24l-2.18,0.2l-1.53,-1.16l-0.52,1.46l3.42,0.67l-0.03,0.56l4.04,-0.29l0.35,-1.01l-1.53,0.41L547.51,357.92zM451.25,294.45l4.97,-2.68l2.12,-4.12l-0.46,-3.36l1.5,-3.29l-3.01,-3.01l-2.35,0.2l-2.12,2.27l-3.81,3.75l1.46,4.77l-2.27,4.78L451.25,294.45zM657.19,191.76l-3.88,-2.49l-8.28,-2.44l-1.46,2.66l2.94,4.58l-3.19,5.09l-3.2,-4.62l-4.16,3.19l-5.25,0.21l-2.01,2.58l-3.48,-0.78l2.76,-4.64l-2.11,-0.38l-9.79,6.54l-5.86,3.52l-0.69,4.61l-4.33,1.54l-2.2,-2.43l-0.02,-4.04l3.55,-0.91l-1.6,-4.18l-7.84,-2.44l2.06,4.69l-1.37,4.41l2.34,4.28l-1.63,4.81l-2.62,-2.43l-2.59,-0.4l-6.53,6.74l1.89,4.88l-2.36,1.59l-6.78,-4.1l-1.78,2.51l1.69,2.8l-0.36,3.11l-2.19,-1.66l-3.61,-1.97l-0.18,-6.75l-0.18,-3.15l-4.57,-5.1l2.06,-0.9l12.52,5.31l4.58,-1.85l3.11,-3.69l-0.19,-4.8l-2.15,-3.51l-10.59,-8.65l-7.68,-1.88l-4.61,-4.86l-2.89,2.81l-3.07,-5.11l3.61,-2.23l-8.77,-6.24l-5.03,1.72l-5.11,-0.38l-4.27,6.99l-4.61,-0.44l-6.15,3.59l-7.71,9.89l-4.7,5.67l-6.74,13.76l-5.13,9.3l-5.54,6.59l-7.4,5.18l-2.58,3.88l0.89,13.26l1,5.86l3.88,2.71l3.74,-1.24l5.54,-6.27l1.88,3.35l2.13,7.5l2.35,5.81l0.89,4.71l3.25,-0.23l1.59,-3.95l3.4,0.49l1.59,-4.76l1.07,-8.84l2.92,-1.27l2.58,-6.23l-2.68,-3.14l-2,-4.07l2.04,-8.41l5.41,-5.34l4.46,-5.14l-0.44,-4.02l2.72,-4.69l4.82,-1.94l3.9,3.23l0.29,2.84l-1.87,1.39l-6.41,7.02l-2.54,3.94l-1.34,3.58l1.36,5.41l-0.62,5.73l2.72,1.87l1.62,3.07l4.56,-1.18l4.93,-2.07l5.09,-0.45l2.94,2.68l-3.19,3.07l-2.89,0.16l-3.04,-0.91l-3.53,0.8l-3.55,1.53l0.24,3.11l1.78,1.9l1.03,-0.67l-0.33,3.12l-0.54,3.99l-2.25,0.1l-2.23,-3.88l-2.64,1.78l-1.38,3.24l-0.1,3.81l0.6,4.16l-3.87,1.58l-0.64,2.13l-2.7,-0.06l-0.21,-1.18l-2.8,-0.82l-3.53,1.64l-4.38,2.22l-1.92,1.39l-1.32,-1.51l-3.17,-1.89l-1.58,1.31l-2.85,0.9l0.03,-1.7l-2.83,-1.12l-0.05,-1.88l-0.76,-2.39l2.02,-3.59l0.83,0.55l0.69,-1.9l-1.52,-0.77l-0.34,-1.43l0.83,-1.68l0.1,-2.68l-2.26,1.47l-0.98,1.43l-2.47,0.32l-0.8,1.54l-0.47,1.38l0.08,5.12l1.14,2.72l0.13,2.74l0.64,1.79l-1.9,2.33l-0.52,-1.04l-2.34,0.26l-0.55,1l-2.33,-0.13l-3.84,1.96l-2.46,6.74l-1.44,1.23l-2.25,0.88l-2.45,0.9l-0.84,3.61l-6.53,3.37l-2.65,-1.85l0.89,4.84l-4.71,-1.09l-3.64,0.92l0.28,3.07l4.29,1.6l2.07,2.09l2.89,4.26l-0.53,7.88l-1.45,2.32l-4.53,-0.13l-2.33,0.2l-2.98,-0.66l-3.76,0.02l-3.43,-0.7l-3.97,2.77l1.15,1.65l-0.14,2.69l0.12,1.26l0.56,1.34l0.06,1.57l-0.58,2.21l-0.2,1.47l-1.12,1.32l-0.22,2.35l0.67,1.35l1.25,0.33l0.26,2.18l-0.43,2.75l1.45,-0.38l1.48,0.49l1.13,-0.91l2.62,0.54l0.79,2l1.04,1.17l1.37,0.29l1.07,-1.31l1.76,-1.23l2.67,0.07l3.56,-0.05l1.99,-2.69l2.12,-0.7l0.61,-2.3l1.62,-1.59l-1.09,-2.05l1.08,-2.96l1.72,-2.03l0.25,-1.24l3.59,-0.78l2.66,-2.49l-0.15,-2.19l0.32,-2.29l4.08,-1.24l5.53,1.04l2.54,-2.17l1.17,-0.28l1.62,-1.8l1.29,-0.53l2.28,1.29l1.4,0.45l0.87,3.8l1.91,2.19l2.56,2.45l2.19,1.68l2.07,0.24l1.21,1.49l1.8,0.67l0.83,1.58l1.16,0.46l0.86,1.83l1.09,2.09l-0.61,0.77l-0.57,1.91l-0.01,1.08l1.17,-0.27l1.5,-3.06l1.17,-0.21l0.33,-1.88l-2.03,-1.34l1.18,-2.36l2.44,0.6l1.56,1.7l0.52,-1.31l-0.29,-0.68l-2.4,-1.92l-2.06,-1.12l-2.51,-1.35l0.79,-0.74l-0.68,-0.83l-2.2,0.02l-3.12,-3.05l-1.41,-3.17l-2.63,-1.95l-0.92,-1.99l0.34,-1.12l-0.16,-1.97l2.28,-1.42l2.23,0.58l-0.62,0.36l-0.1,0.06l-0.06,1.38l0.83,1.32l0.86,-1.71l1.8,0.63l0.05,1.33l1.28,1.65l-0.57,0.29l2.36,2.85l2.56,1.14l1.63,1.38l2.64,1.41l0,0l1.21,0.75l0.79,1.23l0.59,0.29l0.47,0.59l-0.38,1.16l-0.24,2.53l0.24,1.75l1.55,1.23l0.06,0.8l0.48,0.25l0.19,1.03l1.44,2.05l1.09,1.64l0.49,2.36l1.05,2.81l2.3,1.51l1.86,-0.04l-1.06,-3.08l1.78,-0.37l-0.83,-1.8l2.59,0.94l-0.04,-2l-1.39,-1.03l-1.56,-1.65l1.06,-0.79l-1.4,-1.7l-0.63,-2.18l0.53,-0.8l1.48,1.88h1.56l1.42,-0.59l-1.94,-2.06l3.4,-0.96l1.46,0.35l1.71,0.1l-0.04,0.76l0.88,1.71l2.34,-1.98l1.2,-1.14l3.33,-0.2l0.51,-0.91l-2.45,-1.2l-0.33,-1.44l-0.9,-2.15l1.02,-2.73l1.46,-1.6l0.78,-4.71l0.85,0.37l1.36,-0.85l-0.06,-1.02l2.17,-2.96l1.04,-2.23l2.6,-0.5l0.19,1.51l4.36,1.02l0.81,0.92l-2.68,1.33l-0.5,0.76l3.06,1.16l-0.62,1.85l1.56,0.8l3.81,-2.27l3.07,-0.69l0.55,-1.42l-2.86,0.24l-1.37,-0.96l-0.16,-2.5l2.42,-1.51l2.63,-0.21l1.87,-1.32l2.24,-0.33l2.52,-0.66l0.07,0.9l-4.13,1.67l1.57,1.6l-2.33,3.35l-2.04,0.64l2.42,2.32l3.2,1.48l3.57,3.27l1.03,1.18l1.55,0.44l1.62,1.4l0.7,2.58l-0.42,1.6l-3.31,1.94l-2.41,-0.33l-3.27,0.57l-4.02,-1.43l-4.89,-2.64l-4.64,0.08l-3.27,1.06l-3.37,2.42l-5.34,-0.49l-1.18,2.81l-4.32,0.15l-3.11,3.48l1.78,1.72l-1.36,2.78l2.05,1.96l1.66,3.48l3.06,-0.06l2.71,1.85l1.94,-0.41l0.65,-1.44l3.02,0.12l2.27,1.86l4.26,-0.39l1.93,-2l2.35,0.8l1.71,-0.3l-1.06,1.3l1.03,1.57l0.75,-0.76l0.75,-0.76l0.15,-1.94l0.92,0.68l3.09,-0.97l1.49,0.66l2.31,-0.01l3.23,-1.31l1.51,0.06l3.19,-0.54l1.2,-0.55l3.26,0.45l0.98,0.89l1.34,-0.59l-1.53,-2.82l0.55,-1.1l-0.88,-4.11l1.92,-1.03l0.44,1.37l1.42,1.66l1.92,0.48l1.02,-0.11l3.31,-2.66l1.05,-0.27l0.83,1.06l-0.97,1.78l1.75,1.87l0.7,-0.18l-0.08,-1.77l1.03,-0.84l0.48,-1.26l0.49,-2.82l2.31,-0.29l-0.86,-0.99l-1.31,-0.17l-1.43,-2.62l-1.47,-1.97l-3.06,-4.46l0.28,-2.59l-2.55,-3.7l2.79,-4.09l2.72,-0.66l1.28,-2.39l-1.42,-0.66l0.28,-2.1l-1.79,-2.76l-2.08,0.12l-2.38,-2.84l1.62,-3.21l-0.82,-0.87l2.24,-4.77l2.88,2.53l0.35,-3.19l5.79,-4.85l4.38,-0.12l6.18,3.1l3.32,1.79l2.98,-1.87l4.45,-0.09l3.59,2.29l0.81,-1.31l3.94,0.19l0.7,-2.11l-4.54,-3.1l0.37,-0.3l-0.3,-0.11l-0.8,-1.88l-1.88,-0.67l-0.09,-2.65l1.13,-2.2l1.33,-1.39l-0.71,-1.75l-1.89,-1.07l-1.84,1.12l-1.9,1.5l-1.81,-2.32l-1.2,-1.83l-1.3,-2.44l3.08,-0.37l2.57,-0.64l1.66,-2.67l-0.31,-2.15l-2.11,-1.76l0.56,-2.42l2.17,-2.73l1.78,-3.54l1.77,-5l1.34,-8.84l1.89,-19.97l5.23,-4.07l4.82,-5.44l3.93,-3.13l3.76,-3.86l2.03,-4.04l-0.92,-7.34L657.19,191.76zM499.67,338.21l-1.54,-0.19l0.64,2.1l0.11,4.38l1.06,0.95l1.14,-1.2l1.27,0.23l0.39,-4.81l-1.68,-2.62L499.67,338.21zM501.13,336.43l0.93,-2.89l-0.48,-3.25l-1.81,1.45l-0.57,1.41l0.65,2.53L501.13,336.43zM509.15,279.81l1.68,-3.97l-0.9,-2.5l-4.11,1.66l0.39,2.05L509.15,279.81z'
          }, {
            'id': 'australia',
            'title': 'Australia and Oceania',
            'd': 'M944.1,508.23l1.76,1.67l-0.92,0.38l-0.94,-1.27L944.1,508.23zM942.92,507.59l0.58,-0.16l0.75,0.36l-0.46,-2.33l-1.34,-0.89l0.06,2.21L942.92,507.59zM670.34,620.36l-1.81,-1.34l-0.19,0.87l-0.41,1.76l0.07,2.29l4.3,-0.28l0.79,-1.96l-0.1,-0.81L670.34,620.36zM924.89,489.69l-1.85,-0.44l-0.18,1.12l0.59,0.44l1.72,0.29l1.09,-0.06l-0.46,-0.74L924.89,489.69zM914.18,481.81l-0.14,0.47l1.15,1.15l1.23,0.64l0.56,-0.16l-1.12,-0.92L914.18,481.81zM923.52,486.69l-0.66,-0.89l-2.3,-1.29l-1.29,-0.67l-0.42,0.29l1.05,0.94l1.54,1.01l2.2,1.19L923.52,486.69zM929.25,492.65l-1.67,-0.69l1.07,1.74l1.96,0.02l-0.78,-0.97L929.25,492.65zM928.16,490.77l0.42,-0.52l-1.12,-1.35l-1.01,-2.25h-0.95l0.58,1.68L928.16,490.77zM870.69,488.89l2.9,0.12l1.57,0.47l2.2,-0.97l-0.36,-2.08l1.71,-0.93l2.38,-0.8l3.66,1.23l1.46,2.46l1.59,1.55l2.18,1.8l2.83,0.43l2.41,0.32l0.69,0.73l1.86,-0.2l0.31,-0.82l-2.98,-1.19l0.84,-0.53l-2.17,-0.48l0.11,-1.25l-1.61,0.09l-1.82,-2.99l-2.5,-1.84l-0.62,-1.87l2.58,-0.3l-0.68,-1.49l-4.67,-1.73l-0.43,-1.65l-1.56,-1.41l-1.93,-1.43l-5.18,-1.6l-4.87,-1.92l0.05,9.1L870.69,488.89zM895.02,481.01h1.49l1.44,-0.66l1.53,-0.68l0.44,-0.79l1.47,-0.23l0.94,-1.71l0.06,-1.55l-0.57,-0.46l-1.68,0.05l0.31,1.65l-1.57,1l-0.79,0.96l-1.6,0.21l-0.27,-1.49l-0.4,0.07l-0.42,1.34l-1.53,0.22l-2.51,-0.41l-0.23,0.87l1.6,0.78L895.02,481.01zM901.31,473.03l1.27,0.91l0.65,1.08l0.53,1.65l0.88,-0.74l-0.34,-1.45l-1.07,-0.89l-1.12,-1.17l-1.18,-0.67l-0.95,-0.61l-1.51,-0.78l-0.78,0.67l2.02,0.82L901.31,473.03zM910.03,478.91l-0.85,-0.63l-0.3,-0.83l-0.39,0.27l0.6,2.13l1.23,1.78l1.21,1.08l0.79,-0.28l0.39,-0.79l-1.32,-0.95L910.03,478.91zM963.01,588.66l-1.99,1.5l-0.64,-1.53l-0.62,-1.57l-1.97,1.7l-0.42,2.07l-1.06,0.95l-1.25,2.81l-1.68,1.98l-2.4,2.01l-2.01,1.47l-1.81,0.73l-3.53,3.87l-1.51,2.96l0.47,1.48l3.05,0.28l1.82,1.34l2.58,0.09l1.4,-1.16l2.2,-1.8l1.59,-4.03l0.75,-2.57l2.4,-1.46l2.16,-0.05l-1.03,-1.86l1.43,-1.54l1.83,-2.8l1.04,-1.74v-1.57L963.01,588.66zM972.77,577.93l-1.89,-0.28l-2.26,-1.15l-0.42,-2.65l-1.27,-0.95l-0.06,2.38l-2.03,-3.67l-0.79,-3.06l-2.18,-0.89l-1.53,-1.89l-1.04,0.27l1.17,2.41l2.21,3.04l1.34,1.43l-0.08,0.61l1.14,2.34l0.13,2.28l-0.47,2.74l-2.03,1.25l-0.08,1.31l3.02,1.45l0.92,2.01l-1.62,3.04l1.17,0.54l0.48,0.98l2.17,-1.49l1.39,-2.53l1.06,-1.97l0.41,-0.68l-0.26,-1.56l0.75,-1.1l2.14,0.07l0.85,-2.09l0.68,-3.15l-1.42,-0.41L972.77,577.93zM943.83,526.72l-1.46,-1.38l-2.3,-1.86l-0.9,-0.84l-1.23,-1.01l-1.57,-1.01l-1.21,-0.04l0.39,1.01l1.86,2.1l1.81,1.59l2.01,1.35l1.54,0.81L943.83,526.72zM979.95,508.74l-1.64,0.91l-0.89,0.16l-1.4,0.6l0.36,1.09l1.79,-0.61l1.78,-0.72l0.23,-0.16l0.35,-1.4L979.95,508.74zM974.69,512.92l-1.27,-0.36l-1.08,1l0.27,1.29l1.55,0.36l1.74,-0.4l0.46,-1.53l-0.96,-0.84L974.69,512.92zM889.35,588.22l-2.19,0.71l-1.53,0.51l-2.71,-1.28l-1.83,-0.33l-0.07,1.7l1.62,3.25l0.38,2.5l1.73,3.28l1.72,0.12l0.58,0.21l1.95,-2.67l0.98,1.05l0.29,-3.06l0.96,-1.3l-0.2,-4.43L889.35,588.22zM904.7,540.45l-0.07,-1.77l-0.79,-2.49l-2.19,-2.49l-1.3,-1.17l-1.99,-1.87l-0.48,-3.21l-0.69,0.46l-1.14,-1.31l-1.12,0.66l-1.09,-3.25l-1.6,-1.87l0.37,-0.72l-1.88,-1.29l-1.98,-1.41l-3.04,-1.54l-0.91,-1.99l0.27,-1.52l-0.76,-2.5l-0.71,-0.35l-0.43,-1.45l-0.6,-2.48l0.29,-1.28l-1.35,-1.13l-0.93,-1.22l-1.8,1.08l-1.01,-2.25l0.1,-1.04l-0.21,-1.62l-1.02,-1.45l-0.12,-1.2l-0.7,-0.34l-0.19,-1.78l-0.79,-1.39l-1.04,1.06l-0.07,0.81l-0.53,1.56l-0.68,1.51l0.44,0.95l-0.54,0.58l-0.37,2.16l0.32,1.64l-0.2,0.84l0.39,1.39l-0.85,2.3l-0.35,1.59l-0.57,1.29l-0.55,1.57l-1.85,1l-2.68,-0.99l-0.43,-0.9l-1.47,-0.75h-0.79l-2.03,-1.72l-1.44,-1l-2.16,-0.93l-2.23,-1.6l-0.2,-0.81l1,-1.41l0.82,-1.43l-0.33,-1.15l0.96,-0.1l1.06,-1.16l0.75,-1.53l-1.29,-1.41l-0.66,0.55l-1.05,-0.25l-1.64,0.82l-1.74,-0.88l-0.8,0.29l-2.36,-0.73l-1.49,-1.17l-1.86,-0.7l-1.49,0.41l2.05,0.94l0.05,1.45l-2.36,0.54l-1.43,-0.34l-1.7,1.01l-1.22,1.63l0.44,0.71l-1.26,0.75l-1.34,2.3l0.59,1.58l-1.78,-0.27l-1.75,-0.02l-1.56,-1.71l-2.07,-1.32l-1.36,0.39l-1.23,0.41l-0.05,0.72l-1.23,-0.34l-0.04,0.8l-1.41,0.49l-0.68,1.14l-1.53,1.42l-0.34,2.21l-1.24,-0.63l-0.88,1.41l1,1.38l-1.19,0.58l-1.18,-2.51l-1.96,2.47l-0.07,1.59l-0.13,1.17l-1.64,1.49l-0.72,1.58l-1.52,1.31l-2.95,0.87l-1.55,-0.07l-0.74,0.27l-0.42,0.65l-1.7,0.33l-2.21,1.11l-0.77,-0.37l-1.27,0.23l-2.14,1.1l-1.37,1.28l-2.28,1l-1.18,2.07l-0.21,-2.29l-1.16,2.17l0.3,1.77l-0.38,1.52l-0.57,0.75l-0.3,1.77l0.65,0.92l0.27,0.97l1.39,2.43l0.05,1.59l-0.83,-1.2l-1.39,-0.9l0.95,2.88l-1.23,-1.35l0.39,1.33l1.6,2.48l0.35,2.47l1.24,1.26l0.07,0.93l1.12,2.08l-0.12,1.83l0.46,1.85l1.48,3.29l0.31,1.95l-0.34,2.3l0.1,1.2l-0.48,0.76l-1.39,0.46l-0.06,1.93l1.51,0.64l2.97,2.17h1.88l2.05,0.13l1.35,-1.08l1.41,-0.96l0.82,0.15l1.67,-1.8l1.92,-0.15l2.02,-0.37l2.48,0.61l1.76,-0.3l2.38,-0.08l1.04,-1.36l0.54,-1.75l2.43,-0.77l2.97,-1.7l2.68,0.22l3.19,-1.1l3.63,-1.18l5.02,-0.31l2.7,1.6l1.97,0.09l3.6,2l-0.53,0.77l1.48,1.25l1.75,2.43l-0.09,1.79l2.19,1.4l1.07,-2.69l1.75,-1.15l2.28,-2.85l0.22,2.47l-1.08,1.65l-0.42,1.95l-1.47,1.88l2.5,-0.63l1.37,-2.35l0.68,2.52l-0.92,1.66l2.7,0.41l1.38,1.4l0.65,1.75l0.52,2.66l1.81,2.18l2.71,1.03l1.6,0.25l1.59,0.56l2.42,0.97l2.46,-2.58l1.53,-0.67l-0.44,1.85l1.72,0.63l2.32,1.58l1.69,-1.54l1.29,-1.38l2.59,-1.45l3.14,-0.13l1.61,-1.22l-0.14,-1.11l0.36,-2.4l0.71,-2.58l1.08,-1.71l0.83,-2.93l0.94,-1.67l1.02,-2.59l2.08,-1.63l1.24,-3l0.55,-2.34l-0.06,-1.86l0.76,-2.87l0.49,-1.48l0.16,-2.81l-1.34,-2.68L904.7,540.45z'
          }, {
            'id': 'africa',
            'title': 'Africa',
            'd': 'M618.63,430.43l-0.06,-0.79l-1.06,0.01l-1.33,0.97l-1.49,0.29l-1.29,0.42l-0.9,0.06l-1.6,0.1l-1,0.52l-1.39,0.19l-2.47,0.88l-3.05,0.34l-2.64,0.73l-1.39,-0.01l-1.26,-1.19l-0.55,-1.17l-0.91,-0.52l-1.2,-0.78l1.6,-0.68l0.09,-1.18l-0.66,-0.88l-1.38,-0.86l-0.88,-0.98l-1.52,-1.65l-1.56,-1.64l-3.83,-2.72l-1.54,-1.41l-0.77,-2.67l-1.63,-3.38l-1.53,-1.08l-1.07,-0.72l-1.03,-3.52l-0.41,-3.06l0.61,-0.54l-0.9,-2.94l-0.49,-0.62l-3.27,-2.71l-0.09,-1.97l0.56,-0.53l-2.52,-3.39l-0.9,-1.74l-1.04,-1.69l-2.12,-4.87l-1.72,-3.18l-1.16,-3.37l0.29,-0.29l2,4.58l1.27,1.41l0.93,1.02l0.65,-0.55l0.76,-1.65l0.6,-2.4l0.79,-1.29l-1.84,-5.56l-1.38,0.82l-2.19,-0.18l-2.25,-0.77l-0.65,1.06l-0.76,-1.62l-1.99,-0.41l-2.47,0.27l-1.15,0.94l-2.16,1.03l-1.3,-0.51l-2.78,-0.96l-2.7,-0.86l-3.73,0.05l-0.68,-1.08l-2.79,-0.39l-0.89,-0.56l-1.04,-0.01l-0.96,-1.48l-3.79,-0.68l-1.93,0.45l-2.02,1.55l-0.88,1.6l0.65,2.5l-1.34,1.49l-1.37,0.84l-2.99,-1.61l-3.95,-1.36l-2.52,-0.63l-1.31,-2.92l-3.72,-1.48l-2.34,-0.55l-1.18,0.29l-3.29,-1.15l-1.07,-0.52l-0.71,-1.59l-1.45,-0.06l-0.53,-1.84l1.85,-1.7l0.37,-2.96l-0.97,-0.86l0.02,-1.6l1.4,-1.71l-0.2,-0.67l-2.38,1.29l0.08,-1.77l-1.96,-0.42l-3.05,1.41l-1.92,0.21l-1.14,-0.81l-3,0.03l-2.64,1.38l-1.41,-0.52l-4.64,0.28l-4.75,0.62l-2.7,1.06l-1.77,1.43l-3.03,0.6l-2.7,1.87l-1.22,-0.04l-2.9,-0.75l-2.67,0.24l-1.69,-1.46l-2.06,-0.02l-0.88,2.1l-1.87,3.51l-2.08,1.39L451,365.1l-1.8,2.25l-0.38,1.74l-1.07,2.82l0.7,4.03l-2.34,2.68l-1.41,0.85l-2.21,2.17l-2.61,0.35l-1.41,1.21l-0.05,0.04l-1.78,3.2l-1.87,1.14l-1.01,1.92l-0.07,1.64l-0.74,1.79l-0.94,0.49l-1.56,1.94l-0.96,2.14l0.18,1.02l-0.92,1.57l-1.08,0.82l-0.13,1.39l-0.12,1.26l1.48,1.29l0.72,1.41l-0.28,1.48l0.34,1.47l0.31,2.91l-0.35,2.75l-0.78,1.44l0.24,1.57l-0.67,1.49l-1.36,2.03l-1.23,0.55l1.4,1.02l1.16,2.24l-0.36,1.27l0.46,2.19l0.18,0.61l0.85,0.6l-0.02,0.43l0.64,0.8l1.18,0.19l1.5,1.19l0.82,0.47l0.41,0.62l0.32,1.25l0.7,0.56l0.72,0.37l1.09,1.11l1.23,1.67l0.34,2.08l0.49,1.03l1.46,1.5l2.02,1.13l0.76,0.21l1.89,1.81l2.39,1.53l2.55,2.13l2.89,1.33l0.73,-0.02l0.54,0.07l2.78,-1.02l1.95,-0.81l3.32,-0.49l1.8,-0.03l1.96,0.55l1.28,-0.03l2.5,0.79l2.53,-0.81l1.56,-0.96l4.4,-1.64l2.26,-0.6l2.32,-0.33h2.47l2.11,-0.03l1.98,1.85l0.92,2.02l1.5,1.75l2.24,0.06l1.08,-0.63l1.06,0.15l2.91,-1.01l-0.03,0.77l0.72,0.4l0.57,1.25l1.28,0.47l1.1,1.84l-0.41,2.2l-0.96,3.13l0.52,0.42l-0.56,2.06l-0.68,2.03l-0.61,0.89l-0.09,0.93l1.7,2.88l1.85,2.3l2.88,2.82l2.3,2.96l0.75,2.1l0.39,0.87l-0.27,0.54l1.4,1.77l0.57,1.88l0.85,2.72l-0.86,1.12l-0.15,0.59l0.69,1.69l0.75,1.72l0.84,1.01l0.15,1.61l-0.29,2.11l-0.9,1.27l-1.61,1.87l-0.67,1.17l-0.91,2.59l-0.15,1.24l-0.97,2.65l-0.39,2.55l0.26,1.83l0.17,2.24l2.28,2.87l0.61,1.85l1.47,3.56l1.45,2.47l1.09,1.24l0.36,1.64l0.06,3.63l0.94,4.72l0.69,2.24l0.62,3.04l1.1,2.3l2.08,2.39l2.01,4.15v0.01l1.41,2.74l1.84,3.05l0.07,2.53l-0.9,0.6l0.91,2.23l-0.02,1.96l0.37,0.91l0.13,-0.47l1.21,1.51l0.95,0.06l1.19,1.21l1.28,-0.08l1.73,-1.28l2.39,-0.54l2.89,-1.33l1.16,0.18l1.7,-0.41l3.04,0.65l1.39,-0.64l1.7,0.5l0.36,-0.93l1.43,-0.17l2.93,-1.3l2.12,-1.51l1.98,-1.98l3.17,-3.38l1.59,-2.33l0.78,-1.66l1.19,-1.63l0.55,-0.46l1.91,-1.61l0.73,-1.43l0.33,-2.62l0.7,-2.28l0.24,-1.64l-0.72,-0.21l-0.24,-1.31l1.23,-1.14l3.37,-1.67l2.31,-1.04l1.17,-1.09l0.42,-1.27l-0.66,-0.52l0.45,-1.41l0.08,-2.96l-0.5,0.15l-0.04,-0.9l-0.55,-1.76l-1.33,-2.26l0.24,-2.12l1.16,-0.68l1.96,-2.1l1.08,-0.54l3.17,-3.15l3.16,-1.42l2.56,-1.11l1.79,-1.8l1.09,-2.01l0.84,-2.06l-0.49,-1.41l-0.11,-4.48l-0.35,-2.5l0.12,-2.83l-0.45,-1.27l-1.03,-0.62l-1.16,-2.79l-0.98,-1.77l0.18,-1.34l-0.16,-0.85l0.77,-1.7l-0.08,-0.73l-1.79,-1.02l-0.17,-1.59l1.29,-3.45l1.13,-0.92l0.55,-1.86l0.9,-1.13l0.4,-1.96l1.05,-0.2l0.69,-1.16l1.96,-1.11l0.63,-0.66l0.65,-1.47l3.07,-3.37l2.61,-2.12l4.19,-2.77l2.81,-2.26l3.3,-3.81l2.39,-3.13l2.41,-4.11l1.73,-3.59l1.35,-3.15l0.79,-3.06l0.59,-1.02l-0.01,-1.49L618.63,430.43zM616.06,504.96l0.73,1.35l-0.28,1.39l-0.5,0.85l-0.95,-1.7l-0.53,0.86l0.54,2.15l-0.25,1.23l-0.77,0.67l-0.18,2.48l-1.1,3.43l-1.38,4.08l-1.73,5.67l-1.07,4.21l-1.27,3.55l-2.28,0.73l-2.45,1.31l-1.61,-0.79l-2.23,-1.1l-0.77,-1.62l-0.19,-2.71l-0.99,-2.42l-0.26,-2.17l0.5,-2.16l1.29,-0.52l0.01,-0.99l1.34,-2.26l0.25,-1.89l-0.65,-1.4l-0.53,-1.85l-0.22,-2.7l0.98,-1.63l0.38,-1.84l1.4,-0.11l1.56,-0.59l1.04,-0.52l1.23,-0.04l1.6,-1.65l2.31,-1.78l0.84,-1.45l-0.38,-1.23l1.19,0.34l1.55,-1.99l0.05,-1.72l0.93,-1.28l0.98,1.22l0.74,1.21l0.69,1.89L616.06,504.96z'
          }]}
      }};
  })();
  return _retrieveGlobal();
});

$__System.registerDynamic("9", ["3"], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  (function webpackUniversalModuleDefinition(root, factory) {
    if (typeof exports === 'object' && typeof module === 'object')
      module.exports = factory($__require('3'));
    else if (typeof define === 'function' && define.amd)
      define("angular-ui-router", ["angular"], factory);
    else if (typeof exports === 'object')
      exports["angular-ui-router"] = factory($__require('3'));
    else
      root["angular-ui-router"] = factory(root["angular"]);
  })(this, function(__WEBPACK_EXTERNAL_MODULE_57__) {
    return (function(modules) {
      var installedModules = {};
      function __webpack_require__(moduleId) {
        if (installedModules[moduleId])
          return installedModules[moduleId].exports;
        var module = installedModules[moduleId] = {
          exports: {},
          id: moduleId,
          loaded: false
        };
        modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
        module.loaded = true;
        return module.exports;
      }
      __webpack_require__.m = modules;
      __webpack_require__.c = installedModules;
      __webpack_require__.p = "";
      return __webpack_require__(0);
    })([function(module, exports, __webpack_require__) {
      "use strict";
      function __export(m) {
        for (var p in m)
          if (!exports.hasOwnProperty(p))
            exports[p] = m[p];
      }
      __export(__webpack_require__(1));
      __export(__webpack_require__(53));
      __export(__webpack_require__(55));
      __export(__webpack_require__(58));
      __webpack_require__(60);
      __webpack_require__(61);
      __webpack_require__(62);
      __webpack_require__(63);
      Object.defineProperty(exports, "__esModule", {value: true});
      exports.default = "ui.router";
    }, function(module, exports, __webpack_require__) {
      "use strict";
      function __export(m) {
        for (var p in m)
          if (!exports.hasOwnProperty(p))
            exports[p] = m[p];
      }
      __export(__webpack_require__(2));
      __export(__webpack_require__(46));
      __export(__webpack_require__(47));
      __export(__webpack_require__(48));
      __export(__webpack_require__(49));
      __export(__webpack_require__(50));
      __export(__webpack_require__(51));
      __export(__webpack_require__(52));
      __export(__webpack_require__(44));
      var router_1 = __webpack_require__(25);
      exports.UIRouter = router_1.UIRouter;
    }, function(module, exports, __webpack_require__) {
      "use strict";
      function __export(m) {
        for (var p in m)
          if (!exports.hasOwnProperty(p))
            exports[p] = m[p];
      }
      __export(__webpack_require__(3));
      __export(__webpack_require__(6));
      __export(__webpack_require__(7));
      __export(__webpack_require__(5));
      __export(__webpack_require__(4));
      __export(__webpack_require__(8));
      __export(__webpack_require__(9));
      __export(__webpack_require__(12));
    }, function(module, exports, __webpack_require__) {
      "use strict";
      var predicates_1 = __webpack_require__(4);
      var hof_1 = __webpack_require__(5);
      var coreservices_1 = __webpack_require__(6);
      var w = typeof window === 'undefined' ? {} : window;
      var angular = w.angular || {};
      exports.fromJson = angular.fromJson || JSON.parse.bind(JSON);
      exports.toJson = angular.toJson || JSON.stringify.bind(JSON);
      exports.copy = angular.copy || _copy;
      exports.forEach = angular.forEach || _forEach;
      exports.extend = angular.extend || _extend;
      exports.equals = angular.equals || _equals;
      exports.identity = function(x) {
        return x;
      };
      exports.noop = function() {
        return undefined;
      };
      function bindFunctions(from, to, bindTo, fnNames) {
        if (fnNames === void 0) {
          fnNames = Object.keys(from);
        }
        return fnNames.filter(function(name) {
          return typeof from[name] === 'function';
        }).forEach(function(name) {
          return to[name] = from[name].bind(bindTo);
        });
      }
      exports.bindFunctions = bindFunctions;
      exports.inherit = function(parent, extra) {
        return exports.extend(new (exports.extend(function() {}, {prototype: parent}))(), extra);
      };
      var restArgs = function(args, idx) {
        if (idx === void 0) {
          idx = 0;
        }
        return Array.prototype.concat.apply(Array.prototype, Array.prototype.slice.call(args, idx));
      };
      exports.inArray = function(array, obj) {
        return array.indexOf(obj) !== -1;
      };
      exports.removeFrom = hof_1.curry(function(array, obj) {
        var idx = array.indexOf(obj);
        if (idx >= 0)
          array.splice(idx, 1);
        return array;
      });
      function defaults(opts) {
        if (opts === void 0) {
          opts = {};
        }
        var defaultsList = [];
        for (var _i = 1; _i < arguments.length; _i++) {
          defaultsList[_i - 1] = arguments[_i];
        }
        var defaults = merge.apply(null, [{}].concat(defaultsList));
        return exports.extend({}, defaults, pick(opts || {}, Object.keys(defaults)));
      }
      exports.defaults = defaults;
      function merge(dst) {
        var objs = [];
        for (var _i = 1; _i < arguments.length; _i++) {
          objs[_i - 1] = arguments[_i];
        }
        exports.forEach(objs, function(obj) {
          exports.forEach(obj, function(value, key) {
            if (!dst.hasOwnProperty(key))
              dst[key] = value;
          });
        });
        return dst;
      }
      exports.merge = merge;
      exports.mergeR = function(memo, item) {
        return exports.extend(memo, item);
      };
      function ancestors(first, second) {
        var path = [];
        for (var n in first.path) {
          if (first.path[n] !== second.path[n])
            break;
          path.push(first.path[n]);
        }
        return path;
      }
      exports.ancestors = ancestors;
      function equalForKeys(a, b, keys) {
        if (keys === void 0) {
          keys = Object.keys(a);
        }
        for (var i = 0; i < keys.length; i++) {
          var k = keys[i];
          if (a[k] != b[k])
            return false;
        }
        return true;
      }
      exports.equalForKeys = equalForKeys;
      function pickOmitImpl(predicate, obj) {
        var keys = [];
        for (var _i = 2; _i < arguments.length; _i++) {
          keys[_i - 2] = arguments[_i];
        }
        var objCopy = {};
        for (var key in obj) {
          if (predicate(keys, key))
            objCopy[key] = obj[key];
        }
        return objCopy;
      }
      function pick(obj) {
        return pickOmitImpl.apply(null, [exports.inArray].concat(restArgs(arguments)));
      }
      exports.pick = pick;
      function omit(obj) {
        var notInArray = function(array, item) {
          return !exports.inArray(array, item);
        };
        return pickOmitImpl.apply(null, [notInArray].concat(restArgs(arguments)));
      }
      exports.omit = omit;
      function pluck(collection, propName) {
        return map(collection, hof_1.prop(propName));
      }
      exports.pluck = pluck;
      function filter(collection, callback) {
        var arr = predicates_1.isArray(collection),
            result = arr ? [] : {};
        var accept = arr ? function(x) {
          return result.push(x);
        } : function(x, key) {
          return result[key] = x;
        };
        exports.forEach(collection, function(item, i) {
          if (callback(item, i))
            accept(item, i);
        });
        return result;
      }
      exports.filter = filter;
      function find(collection, callback) {
        var result;
        exports.forEach(collection, function(item, i) {
          if (result)
            return;
          if (callback(item, i))
            result = item;
        });
        return result;
      }
      exports.find = find;
      exports.mapObj = map;
      function map(collection, callback) {
        var result = predicates_1.isArray(collection) ? [] : {};
        exports.forEach(collection, function(item, i) {
          return result[i] = callback(item, i);
        });
        return result;
      }
      exports.map = map;
      exports.values = function(obj) {
        return Object.keys(obj).map(function(key) {
          return obj[key];
        });
      };
      exports.allTrueR = function(memo, elem) {
        return memo && elem;
      };
      exports.anyTrueR = function(memo, elem) {
        return memo || elem;
      };
      exports.unnestR = function(memo, elem) {
        return memo.concat(elem);
      };
      exports.flattenR = function(memo, elem) {
        return predicates_1.isArray(elem) ? memo.concat(elem.reduce(exports.flattenR, [])) : pushR(memo, elem);
      };
      function pushR(arr, obj) {
        arr.push(obj);
        return arr;
      }
      exports.pushR = pushR;
      exports.uniqR = function(acc, token) {
        return exports.inArray(acc, token) ? acc : pushR(acc, token);
      };
      exports.unnest = function(arr) {
        return arr.reduce(exports.unnestR, []);
      };
      exports.flatten = function(arr) {
        return arr.reduce(exports.flattenR, []);
      };
      function assertPredicate(predicate, errMsg) {
        if (errMsg === void 0) {
          errMsg = "assert failure";
        }
        return function(obj) {
          if (!predicate(obj)) {
            throw new Error(predicates_1.isFunction(errMsg) ? errMsg(obj) : errMsg);
          }
          return true;
        };
      }
      exports.assertPredicate = assertPredicate;
      exports.pairs = function(obj) {
        return Object.keys(obj).map(function(key) {
          return [key, obj[key]];
        });
      };
      function arrayTuples() {
        var arrayArgs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          arrayArgs[_i - 0] = arguments[_i];
        }
        if (arrayArgs.length === 0)
          return [];
        var length = arrayArgs.reduce(function(min, arr) {
          return Math.min(arr.length, min);
        }, 9007199254740991);
        return Array.apply(null, Array(length)).map(function(ignored, idx) {
          return arrayArgs.map(function(arr) {
            return arr[idx];
          });
        });
      }
      exports.arrayTuples = arrayTuples;
      function applyPairs(memo, keyValTuple) {
        var key,
            value;
        if (predicates_1.isArray(keyValTuple))
          key = keyValTuple[0], value = keyValTuple[1];
        if (!predicates_1.isString(key))
          throw new Error("invalid parameters to applyPairs");
        memo[key] = value;
        return memo;
      }
      exports.applyPairs = applyPairs;
      function tail(arr) {
        return arr.length && arr[arr.length - 1] || undefined;
      }
      exports.tail = tail;
      function _copy(src, dest) {
        if (dest)
          Object.keys(dest).forEach(function(key) {
            return delete dest[key];
          });
        if (!dest)
          dest = {};
        return exports.extend(dest, src);
      }
      function _forEach(obj, cb, _this) {
        if (predicates_1.isArray(obj))
          return obj.forEach(cb, _this);
        Object.keys(obj).forEach(function(key) {
          return cb(obj[key], key);
        });
      }
      function _copyProps(to, from) {
        Object.keys(from).forEach(function(key) {
          return to[key] = from[key];
        });
        return to;
      }
      function _extend(toObj) {
        return restArgs(arguments, 1).filter(exports.identity).reduce(_copyProps, toObj);
      }
      function _equals(o1, o2) {
        if (o1 === o2)
          return true;
        if (o1 === null || o2 === null)
          return false;
        if (o1 !== o1 && o2 !== o2)
          return true;
        var t1 = typeof o1,
            t2 = typeof o2;
        if (t1 !== t2 || t1 !== 'object')
          return false;
        var tup = [o1, o2];
        if (hof_1.all(predicates_1.isArray)(tup))
          return _arraysEq(o1, o2);
        if (hof_1.all(predicates_1.isDate)(tup))
          return o1.getTime() === o2.getTime();
        if (hof_1.all(predicates_1.isRegExp)(tup))
          return o1.toString() === o2.toString();
        if (hof_1.all(predicates_1.isFunction)(tup))
          return true;
        var predicates = [predicates_1.isFunction, predicates_1.isArray, predicates_1.isDate, predicates_1.isRegExp];
        if (predicates.map(hof_1.any).reduce(function(b, fn) {
          return b || !!fn(tup);
        }, false))
          return false;
        var key,
            keys = {};
        for (key in o1) {
          if (!_equals(o1[key], o2[key]))
            return false;
          keys[key] = true;
        }
        for (key in o2) {
          if (!keys[key])
            return false;
        }
        return true;
      }
      function _arraysEq(a1, a2) {
        if (a1.length !== a2.length)
          return false;
        return arrayTuples(a1, a2).reduce(function(b, t) {
          return b && _equals(t[0], t[1]);
        }, true);
      }
      exports.silenceUncaughtInPromise = function(promise) {
        return promise.catch(function(e) {
          return 0;
        }) && promise;
      };
      exports.silentRejection = function(error) {
        return exports.silenceUncaughtInPromise(coreservices_1.services.$q.reject(error));
      };
    }, function(module, exports, __webpack_require__) {
      "use strict";
      var hof_1 = __webpack_require__(5);
      var toStr = Object.prototype.toString;
      var tis = function(t) {
        return function(x) {
          return typeof(x) === t;
        };
      };
      exports.isUndefined = tis('undefined');
      exports.isDefined = hof_1.not(exports.isUndefined);
      exports.isNull = function(o) {
        return o === null;
      };
      exports.isFunction = tis('function');
      exports.isNumber = tis('number');
      exports.isString = tis('string');
      exports.isObject = function(x) {
        return x !== null && typeof x === 'object';
      };
      exports.isArray = Array.isArray;
      exports.isDate = (function(x) {
        return toStr.call(x) === '[object Date]';
      });
      exports.isRegExp = (function(x) {
        return toStr.call(x) === '[object RegExp]';
      });
      function isInjectable(val) {
        if (exports.isArray(val) && val.length) {
          var head = val.slice(0, -1),
              tail = val.slice(-1);
          return !(head.filter(hof_1.not(exports.isString)).length || tail.filter(hof_1.not(exports.isFunction)).length);
        }
        return exports.isFunction(val);
      }
      exports.isInjectable = isInjectable;
      exports.isPromise = hof_1.and(exports.isObject, hof_1.pipe(hof_1.prop('then'), exports.isFunction));
    }, function(module, exports) {
      "use strict";
      function curry(fn) {
        var initial_args = [].slice.apply(arguments, [1]);
        var func_args_length = fn.length;
        function curried(args) {
          if (args.length >= func_args_length)
            return fn.apply(null, args);
          return function() {
            return curried(args.concat([].slice.apply(arguments)));
          };
        }
        return curried(initial_args);
      }
      exports.curry = curry;
      function compose() {
        var args = arguments;
        var start = args.length - 1;
        return function() {
          var i = start,
              result = args[start].apply(this, arguments);
          while (i--)
            result = args[i].call(this, result);
          return result;
        };
      }
      exports.compose = compose;
      function pipe() {
        var funcs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          funcs[_i - 0] = arguments[_i];
        }
        return compose.apply(null, [].slice.call(arguments).reverse());
      }
      exports.pipe = pipe;
      exports.prop = function(name) {
        return function(obj) {
          return obj && obj[name];
        };
      };
      exports.propEq = curry(function(name, val, obj) {
        return obj && obj[name] === val;
      });
      exports.parse = function(name) {
        return pipe.apply(null, name.split(".").map(exports.prop));
      };
      exports.not = function(fn) {
        return function() {
          var args = [];
          for (var _i = 0; _i < arguments.length; _i++) {
            args[_i - 0] = arguments[_i];
          }
          return !fn.apply(null, args);
        };
      };
      function and(fn1, fn2) {
        return function() {
          var args = [];
          for (var _i = 0; _i < arguments.length; _i++) {
            args[_i - 0] = arguments[_i];
          }
          return fn1.apply(null, args) && fn2.apply(null, args);
        };
      }
      exports.and = and;
      function or(fn1, fn2) {
        return function() {
          var args = [];
          for (var _i = 0; _i < arguments.length; _i++) {
            args[_i - 0] = arguments[_i];
          }
          return fn1.apply(null, args) || fn2.apply(null, args);
        };
      }
      exports.or = or;
      exports.all = function(fn1) {
        return function(arr) {
          return arr.reduce(function(b, x) {
            return b && !!fn1(x);
          }, true);
        };
      };
      exports.any = function(fn1) {
        return function(arr) {
          return arr.reduce(function(b, x) {
            return b || !!fn1(x);
          }, false);
        };
      };
      exports.is = function(ctor) {
        return function(obj) {
          return (obj != null && obj.constructor === ctor || obj instanceof ctor);
        };
      };
      exports.eq = function(val) {
        return function(other) {
          return val === other;
        };
      };
      exports.val = function(v) {
        return function() {
          return v;
        };
      };
      function invoke(fnName, args) {
        return function(obj) {
          return obj[fnName].apply(obj, args);
        };
      }
      exports.invoke = invoke;
      function pattern(struct) {
        return function(x) {
          for (var i = 0; i < struct.length; i++) {
            if (struct[i][0](x))
              return struct[i][1](x);
          }
        };
      }
      exports.pattern = pattern;
    }, function(module, exports) {
      "use strict";
      var notImplemented = function(fnname) {
        return function() {
          throw new Error(fnname + "(): No coreservices implementation for UI-Router is loaded. You should include one of: ['angular1.js']");
        };
      };
      var services = {
        $q: undefined,
        $injector: undefined,
        location: {},
        locationConfig: {},
        template: {}
      };
      exports.services = services;
      ["setUrl", "path", "search", "hash", "onChange"].forEach(function(key) {
        return services.location[key] = notImplemented(key);
      });
      ["port", "protocol", "host", "baseHref", "html5Mode", "hashPrefix"].forEach(function(key) {
        return services.locationConfig[key] = notImplemented(key);
      });
    }, function(module, exports) {
      "use strict";
      var Glob = (function() {
        function Glob(text) {
          this.text = text;
          this.glob = text.split('.');
          var regexpString = this.text.split('.').map(function(seg) {
            if (seg === '**')
              return '(?:|(?:\\.[^.]*)*)';
            if (seg === '*')
              return '\\.[^.]*';
            return '\\.' + seg;
          }).join('');
          this.regexp = new RegExp("^" + regexpString + "$");
        }
        Glob.prototype.matches = function(name) {
          return this.regexp.test('.' + name);
        };
        Glob.is = function(text) {
          return text.indexOf('*') > -1;
        };
        Glob.fromString = function(text) {
          if (!this.is(text))
            return null;
          return new Glob(text);
        };
        return Glob;
      }());
      exports.Glob = Glob;
    }, function(module, exports) {
      "use strict";
      var Queue = (function() {
        function Queue(_items, _limit) {
          if (_items === void 0) {
            _items = [];
          }
          if (_limit === void 0) {
            _limit = null;
          }
          this._items = _items;
          this._limit = _limit;
        }
        Queue.prototype.enqueue = function(item) {
          var items = this._items;
          items.push(item);
          if (this._limit && items.length > this._limit)
            items.shift();
          return item;
        };
        Queue.prototype.dequeue = function() {
          if (this.size())
            return this._items.splice(0, 1)[0];
        };
        Queue.prototype.clear = function() {
          var current = this._items;
          this._items = [];
          return current;
        };
        Queue.prototype.size = function() {
          return this._items.length;
        };
        Queue.prototype.remove = function(item) {
          var idx = this._items.indexOf(item);
          return idx > -1 && this._items.splice(idx, 1)[0];
        };
        Queue.prototype.peekTail = function() {
          return this._items[this._items.length - 1];
        };
        Queue.prototype.peekHead = function() {
          if (this.size())
            return this._items[0];
        };
        return Queue;
      }());
      exports.Queue = Queue;
    }, function(module, exports, __webpack_require__) {
      "use strict";
      var predicates_1 = __webpack_require__(4);
      var rejectFactory_1 = __webpack_require__(10);
      var common_1 = __webpack_require__(3);
      var hof_1 = __webpack_require__(5);
      var transition_1 = __webpack_require__(11);
      var resolvable_1 = __webpack_require__(19);
      function maxLength(max, str) {
        if (str.length <= max)
          return str;
        return str.substr(0, max - 3) + "...";
      }
      exports.maxLength = maxLength;
      function padString(length, str) {
        while (str.length < length)
          str += " ";
        return str;
      }
      exports.padString = padString;
      function kebobString(camelCase) {
        return camelCase.replace(/^([A-Z])/, function($1) {
          return $1.toLowerCase();
        }).replace(/([A-Z])/g, function($1) {
          return "-" + $1.toLowerCase();
        });
      }
      exports.kebobString = kebobString;
      function _toJson(obj) {
        return JSON.stringify(obj);
      }
      function _fromJson(json) {
        return predicates_1.isString(json) ? JSON.parse(json) : json;
      }
      function promiseToString(p) {
        return "Promise(" + JSON.stringify(p) + ")";
      }
      function functionToString(fn) {
        var fnStr = fnToString(fn);
        var namedFunctionMatch = fnStr.match(/^(function [^ ]+\([^)]*\))/);
        var toStr = namedFunctionMatch ? namedFunctionMatch[1] : fnStr;
        var fnName = fn['name'] || "";
        if (fnName && toStr.match(/function \(/)) {
          return 'function ' + fnName + toStr.substr(9);
        }
        return toStr;
      }
      exports.functionToString = functionToString;
      function fnToString(fn) {
        var _fn = predicates_1.isArray(fn) ? fn.slice(-1)[0] : fn;
        return _fn && _fn.toString() || "undefined";
      }
      exports.fnToString = fnToString;
      var stringifyPatternFn = null;
      var stringifyPattern = function(value) {
        var isTransitionRejectionPromise = rejectFactory_1.Rejection.isTransitionRejectionPromise;
        stringifyPatternFn = stringifyPatternFn || hof_1.pattern([[hof_1.not(predicates_1.isDefined), hof_1.val("undefined")], [predicates_1.isNull, hof_1.val("null")], [predicates_1.isPromise, hof_1.val("[Promise]")], [isTransitionRejectionPromise, function(x) {
          return x._transitionRejection.toString();
        }], [hof_1.is(rejectFactory_1.Rejection), hof_1.invoke("toString")], [hof_1.is(transition_1.Transition), hof_1.invoke("toString")], [hof_1.is(resolvable_1.Resolvable), hof_1.invoke("toString")], [predicates_1.isInjectable, functionToString], [hof_1.val(true), common_1.identity]]);
        return stringifyPatternFn(value);
      };
      function stringify(o) {
        var seen = [];
        function format(val) {
          if (predicates_1.isObject(val)) {
            if (seen.indexOf(val) !== -1)
              return '[circular ref]';
            seen.push(val);
          }
          return stringifyPattern(val);
        }
        return JSON.stringify(o, function(key, val) {
          return format(val);
        }).replace(/\\"/g, '"');
      }
      exports.stringify = stringify;
      exports.beforeAfterSubstr = function(char) {
        return function(str) {
          if (!str)
            return ["", ""];
          var idx = str.indexOf(char);
          if (idx === -1)
            return [str, ""];
          return [str.substr(0, idx), str.substr(idx + 1)];
        };
      };
    }, function(module, exports, __webpack_require__) {
      "use strict";
      var common_1 = __webpack_require__(3);
      var strings_1 = __webpack_require__(9);
      (function(RejectType) {
        RejectType[RejectType["SUPERSEDED"] = 2] = "SUPERSEDED";
        RejectType[RejectType["ABORTED"] = 3] = "ABORTED";
        RejectType[RejectType["INVALID"] = 4] = "INVALID";
        RejectType[RejectType["IGNORED"] = 5] = "IGNORED";
        RejectType[RejectType["ERROR"] = 6] = "ERROR";
      })(exports.RejectType || (exports.RejectType = {}));
      var RejectType = exports.RejectType;
      var Rejection = (function() {
        function Rejection(type, message, detail) {
          this.type = type;
          this.message = message;
          this.detail = detail;
        }
        Rejection.prototype.toString = function() {
          var detailString = function(d) {
            return d && d.toString !== Object.prototype.toString ? d.toString() : strings_1.stringify(d);
          };
          var type = this.type,
              message = this.message,
              detail = detailString(this.detail);
          return "TransitionRejection(type: " + type + ", message: " + message + ", detail: " + detail + ")";
        };
        Rejection.prototype.toPromise = function() {
          return common_1.extend(common_1.silentRejection(this), {_transitionRejection: this});
        };
        Rejection.isTransitionRejectionPromise = function(obj) {
          return obj && (typeof obj.then === 'function') && obj._transitionRejection instanceof Rejection;
        };
        Rejection.superseded = function(detail, options) {
          var message = "The transition has been superseded by a different transition";
          var rejection = new Rejection(RejectType.SUPERSEDED, message, detail);
          if (options && options.redirected) {
            rejection.redirected = true;
          }
          return rejection;
        };
        Rejection.redirected = function(detail) {
          return Rejection.superseded(detail, {redirected: true});
        };
        Rejection.invalid = function(detail) {
          var message = "This transition is invalid";
          return new Rejection(RejectType.INVALID, message, detail);
        };
        Rejection.ignored = function(detail) {
          var message = "The transition was ignored";
          return new Rejection(RejectType.IGNORED, message, detail);
        };
        Rejection.aborted = function(detail) {
          var message = "The transition has been aborted";
          return new Rejection(RejectType.ABORTED, message, detail);
        };
        Rejection.errored = function(detail) {
          var message = "The transition errored";
          return new Rejection(RejectType.ERROR, message, detail);
        };
        return Rejection;
      }());
      exports.Rejection = Rejection;
    }, function(module, exports, __webpack_require__) {
      "use strict";
      var strings_1 = __webpack_require__(9);
      var trace_1 = __webpack_require__(12);
      var coreservices_1 = __webpack_require__(6);
      var common_1 = __webpack_require__(3);
      var predicates_1 = __webpack_require__(4);
      var hof_1 = __webpack_require__(5);
      var transitionHook_1 = __webpack_require__(13);
      var hookRegistry_1 = __webpack_require__(15);
      var hookBuilder_1 = __webpack_require__(16);
      var node_1 = __webpack_require__(21);
      var pathFactory_1 = __webpack_require__(20);
      var targetState_1 = __webpack_require__(14);
      var param_1 = __webpack_require__(22);
      var resolvable_1 = __webpack_require__(19);
      var rejectFactory_1 = __webpack_require__(10);
      var resolveContext_1 = __webpack_require__(17);
      var router_1 = __webpack_require__(25);
      var transitionCount = 0;
      var stateSelf = hof_1.prop("self");
      var Transition = (function() {
        function Transition(fromPath, targetState, router) {
          var _this = this;
          this._deferred = coreservices_1.services.$q.defer();
          this.promise = this._deferred.promise;
          this.treeChanges = function() {
            return _this._treeChanges;
          };
          this.isActive = function() {
            return _this === _this._options.current();
          };
          this.router = router;
          this._targetState = targetState;
          if (!targetState.valid()) {
            throw new Error(targetState.error());
          }
          hookRegistry_1.HookRegistry.mixin(new hookRegistry_1.HookRegistry(), this);
          this._options = common_1.extend({current: hof_1.val(this)}, targetState.options());
          this.$id = transitionCount++;
          var toPath = pathFactory_1.PathFactory.buildToPath(fromPath, targetState);
          this._treeChanges = pathFactory_1.PathFactory.treeChanges(fromPath, toPath, this._options.reloadState);
          var enteringStates = this._treeChanges.entering.map(function(node) {
            return node.state;
          });
          pathFactory_1.PathFactory.applyViewConfigs(router.transitionService.$view, this._treeChanges.to, enteringStates);
          var rootResolvables = [new resolvable_1.Resolvable(router_1.UIRouter, function() {
            return router;
          }, [], undefined, router), new resolvable_1.Resolvable(Transition, function() {
            return _this;
          }, [], undefined, this), new resolvable_1.Resolvable('$transition$', function() {
            return _this;
          }, [], undefined, this), new resolvable_1.Resolvable('$stateParams', function() {
            return _this.params();
          }, [], undefined, this.params())];
          var rootNode = this._treeChanges.to[0];
          var context = new resolveContext_1.ResolveContext(this._treeChanges.to);
          context.addResolvables(rootResolvables, rootNode.state);
        }
        Transition.prototype.onBefore = function(matchCriteria, callback, options) {
          throw "";
        };
        ;
        Transition.prototype.onStart = function(matchCriteria, callback, options) {
          throw "";
        };
        ;
        Transition.prototype.onExit = function(matchCriteria, callback, options) {
          throw "";
        };
        ;
        Transition.prototype.onRetain = function(matchCriteria, callback, options) {
          throw "";
        };
        ;
        Transition.prototype.onEnter = function(matchCriteria, callback, options) {
          throw "";
        };
        ;
        Transition.prototype.onFinish = function(matchCriteria, callback, options) {
          throw "";
        };
        ;
        Transition.prototype.onSuccess = function(matchCriteria, callback, options) {
          throw "";
        };
        ;
        Transition.prototype.onError = function(matchCriteria, callback, options) {
          throw "";
        };
        ;
        Transition.prototype.$from = function() {
          return common_1.tail(this._treeChanges.from).state;
        };
        Transition.prototype.$to = function() {
          return common_1.tail(this._treeChanges.to).state;
        };
        Transition.prototype.from = function() {
          return this.$from().self;
        };
        Transition.prototype.to = function() {
          return this.$to().self;
        };
        Transition.prototype.targetState = function() {
          return this._targetState;
        };
        Transition.prototype.is = function(compare) {
          if (compare instanceof Transition) {
            return this.is({
              to: compare.$to().name,
              from: compare.$from().name
            });
          }
          return !((compare.to && !hookRegistry_1.matchState(this.$to(), compare.to)) || (compare.from && !hookRegistry_1.matchState(this.$from(), compare.from)));
        };
        Transition.prototype.params = function(pathname) {
          if (pathname === void 0) {
            pathname = "to";
          }
          return this._treeChanges[pathname].map(hof_1.prop("paramValues")).reduce(common_1.mergeR, {});
        };
        Transition.prototype.injector = function(state) {
          var path = this.treeChanges().to;
          if (state)
            path = pathFactory_1.PathFactory.subPath(path, function(node) {
              return node.state === state || node.state.name === state;
            });
          return new resolveContext_1.ResolveContext(path).injector();
        };
        Transition.prototype.getResolveTokens = function() {
          return new resolveContext_1.ResolveContext(this._treeChanges.to).getTokens();
        };
        Transition.prototype.getResolveValue = function(token) {
          var resolveContext = new resolveContext_1.ResolveContext(this._treeChanges.to);
          var getData = function(token) {
            var resolvable = resolveContext.getResolvable(token);
            if (resolvable === undefined) {
              throw new Error("Dependency Injection token not found: " + strings_1.stringify(token));
            }
            return resolvable.data;
          };
          if (predicates_1.isArray(token)) {
            return token.map(getData);
          }
          return getData(token);
        };
        Transition.prototype.getResolvable = function(token) {
          return new resolveContext_1.ResolveContext(this._treeChanges.to).getResolvable(token);
        };
        Transition.prototype.addResolvable = function(resolvable, state) {
          if (state === void 0) {
            state = "";
          }
          var stateName = (typeof state === "string") ? state : state.name;
          var topath = this._treeChanges.to;
          var targetNode = common_1.find(topath, function(node) {
            return node.state.name === stateName;
          });
          var resolveContext = new resolveContext_1.ResolveContext(topath);
          resolveContext.addResolvables([resolvable], targetNode.state);
        };
        Transition.prototype.redirectedFrom = function() {
          return this._options.redirectedFrom || null;
        };
        Transition.prototype.options = function() {
          return this._options;
        };
        Transition.prototype.entering = function() {
          return common_1.map(this._treeChanges.entering, hof_1.prop('state')).map(stateSelf);
        };
        Transition.prototype.exiting = function() {
          return common_1.map(this._treeChanges.exiting, hof_1.prop('state')).map(stateSelf).reverse();
        };
        Transition.prototype.retained = function() {
          return common_1.map(this._treeChanges.retained, hof_1.prop('state')).map(stateSelf);
        };
        Transition.prototype.views = function(pathname, state) {
          if (pathname === void 0) {
            pathname = "entering";
          }
          var path = this._treeChanges[pathname];
          path = !state ? path : path.filter(hof_1.propEq('state', state));
          return path.map(hof_1.prop("views")).filter(common_1.identity).reduce(common_1.unnestR, []);
        };
        Transition.prototype.redirect = function(targetState) {
          var newOptions = common_1.extend({}, this.options(), targetState.options(), {
            redirectedFrom: this,
            source: "redirect"
          });
          targetState = new targetState_1.TargetState(targetState.identifier(), targetState.$state(), targetState.params(), newOptions);
          var newTransition = this.router.transitionService.create(this._treeChanges.from, targetState);
          var originalEnteringNodes = this.treeChanges().entering;
          var redirectEnteringNodes = newTransition.treeChanges().entering;
          var nodeIsReloading = function(reloadState) {
            return function(node) {
              return reloadState && node.state.includes[reloadState.name];
            };
          };
          var matchingEnteringNodes = node_1.PathNode.matching(redirectEnteringNodes, originalEnteringNodes).filter(hof_1.not(nodeIsReloading(targetState.options().reloadState)));
          matchingEnteringNodes.forEach(function(node, idx) {
            node.resolvables = originalEnteringNodes[idx].resolvables;
          });
          return newTransition;
        };
        Transition.prototype._changedParams = function() {
          var _a = this._treeChanges,
              to = _a.to,
              from = _a.from;
          if (this._options.reload || common_1.tail(to).state !== common_1.tail(from).state)
            return undefined;
          var nodeSchemas = to.map(function(node) {
            return node.paramSchema;
          });
          var _b = [to, from].map(function(path) {
            return path.map(function(x) {
              return x.paramValues;
            });
          }),
              toValues = _b[0],
              fromValues = _b[1];
          var tuples = common_1.arrayTuples(nodeSchemas, toValues, fromValues);
          return tuples.map(function(_a) {
            var schema = _a[0],
                toVals = _a[1],
                fromVals = _a[2];
            return param_1.Param.changed(schema, toVals, fromVals);
          }).reduce(common_1.unnestR, []);
        };
        Transition.prototype.dynamic = function() {
          var changes = this._changedParams();
          return !changes ? false : changes.map(function(x) {
            return x.dynamic;
          }).reduce(common_1.anyTrueR, false);
        };
        Transition.prototype.ignored = function() {
          var changes = this._changedParams();
          return !changes ? false : changes.length === 0;
        };
        Transition.prototype.hookBuilder = function() {
          return new hookBuilder_1.HookBuilder(this.router.transitionService, this, {
            transition: this,
            current: this._options.current
          });
        };
        Transition.prototype.run = function() {
          var _this = this;
          var runSynchronousHooks = transitionHook_1.TransitionHook.runSynchronousHooks;
          var hookBuilder = this.hookBuilder();
          var globals = this.router.globals;
          globals.transitionHistory.enqueue(this);
          var syncResult = runSynchronousHooks(hookBuilder.getOnBeforeHooks());
          if (rejectFactory_1.Rejection.isTransitionRejectionPromise(syncResult)) {
            syncResult.catch(function() {
              return 0;
            });
            var rejectReason = syncResult._transitionRejection;
            this._deferred.reject(rejectReason);
            return this.promise;
          }
          if (!this.valid()) {
            var error = new Error(this.error());
            this._deferred.reject(error);
            return this.promise;
          }
          if (this.ignored()) {
            trace_1.trace.traceTransitionIgnored(this);
            this._deferred.reject(rejectFactory_1.Rejection.ignored());
            return this.promise;
          }
          var transitionSuccess = function() {
            trace_1.trace.traceSuccess(_this.$to(), _this);
            _this.success = true;
            _this._deferred.resolve(_this.to());
            runSynchronousHooks(hookBuilder.getOnSuccessHooks(), true);
          };
          var transitionError = function(reason) {
            trace_1.trace.traceError(reason, _this);
            _this.success = false;
            _this._deferred.reject(reason);
            _this._error = reason;
            runSynchronousHooks(hookBuilder.getOnErrorHooks(), true);
          };
          trace_1.trace.traceTransitionStart(this);
          var appendHookToChain = function(prev, nextHook) {
            return prev.then(function() {
              return nextHook.invokeHook();
            });
          };
          hookBuilder.asyncHooks().reduce(appendHookToChain, syncResult).then(transitionSuccess, transitionError);
          return this.promise;
        };
        Transition.prototype.valid = function() {
          return !this.error() || this.success !== undefined;
        };
        Transition.prototype.error = function() {
          var state = this.$to();
          var redirects = 0,
              trans = this;
          while ((trans = trans.redirectedFrom()) != null) {
            if (++redirects > 20)
              return "Too many Transition redirects (20+)";
          }
          if (state.self.abstract)
            return "Cannot transition to abstract state '" + state.name + "'";
          if (!param_1.Param.validates(state.parameters(), this.params()))
            return "Param values not valid for state '" + state.name + "'";
          if (this.success === false)
            return this._error;
        };
        Transition.prototype.toString = function() {
          var fromStateOrName = this.from();
          var toStateOrName = this.to();
          var avoidEmptyHash = function(params) {
            return (params["#"] !== null && params["#"] !== undefined) ? params : common_1.omit(params, "#");
          };
          var id = this.$id,
              from = predicates_1.isObject(fromStateOrName) ? fromStateOrName.name : fromStateOrName,
              fromParams = common_1.toJson(avoidEmptyHash(this._treeChanges.from.map(hof_1.prop('paramValues')).reduce(common_1.mergeR, {}))),
              toValid = this.valid() ? "" : "(X) ",
              to = predicates_1.isObject(toStateOrName) ? toStateOrName.name : toStateOrName,
              toParams = common_1.toJson(avoidEmptyHash(this.params()));
          return "Transition#" + id + "( '" + from + "'" + fromParams + " -> " + toValid + "'" + to + "'" + toParams + " )";
        };
        Transition.diToken = Transition;
        return Transition;
      }());
      exports.Transition = Transition;
    }, function(module, exports, __webpack_require__) {
      "use strict";
      var hof_1 = __webpack_require__(5);
      var predicates_1 = __webpack_require__(4);
      var strings_1 = __webpack_require__(9);
      function uiViewString(viewData) {
        if (!viewData)
          return 'ui-view (defunct)';
        return ("[ui-view#" + viewData.id + " tag ") + ("in template from '" + (viewData.creationContext && viewData.creationContext.name || '(root)') + "' state]: ") + ("fqn: '" + viewData.fqn + "', ") + ("name: '" + viewData.name + "@" + viewData.creationContext + "')");
      }
      var viewConfigString = function(viewConfig) {
        return ("[ViewConfig#" + viewConfig.$id + " from '" + (viewConfig.viewDecl.$context.name || '(root)') + "' state]: target ui-view: '" + viewConfig.viewDecl.$uiViewName + "@" + viewConfig.viewDecl.$uiViewContextAnchor + "'");
      };
      function normalizedCat(input) {
        return predicates_1.isNumber(input) ? Category[input] : Category[Category[input]];
      }
      (function(Category) {
        Category[Category["RESOLVE"] = 0] = "RESOLVE";
        Category[Category["TRANSITION"] = 1] = "TRANSITION";
        Category[Category["HOOK"] = 2] = "HOOK";
        Category[Category["UIVIEW"] = 3] = "UIVIEW";
        Category[Category["VIEWCONFIG"] = 4] = "VIEWCONFIG";
      })(exports.Category || (exports.Category = {}));
      var Category = exports.Category;
      var Trace = (function() {
        function Trace() {
          this._enabled = {};
          this.approximateDigests = 0;
        }
        Trace.prototype._set = function(enabled, categories) {
          var _this = this;
          if (!categories.length) {
            categories = Object.keys(Category).map(function(k) {
              return parseInt(k, 10);
            }).filter(function(k) {
              return !isNaN(k);
            }).map(function(key) {
              return Category[key];
            });
          }
          categories.map(normalizedCat).forEach(function(category) {
            return _this._enabled[category] = enabled;
          });
        };
        Trace.prototype.enable = function() {
          var categories = [];
          for (var _i = 0; _i < arguments.length; _i++) {
            categories[_i - 0] = arguments[_i];
          }
          this._set(true, categories);
        };
        Trace.prototype.disable = function() {
          var categories = [];
          for (var _i = 0; _i < arguments.length; _i++) {
            categories[_i - 0] = arguments[_i];
          }
          this._set(false, categories);
        };
        Trace.prototype.enabled = function(category) {
          return !!this._enabled[normalizedCat(category)];
        };
        Trace.prototype.traceTransitionStart = function(transition) {
          if (!this.enabled(Category.TRANSITION))
            return;
          var tid = transition.$id,
              digest = this.approximateDigests,
              transitionStr = strings_1.stringify(transition);
          console.log("Transition #" + tid + " Digest #" + digest + ": Started  -> " + transitionStr);
        };
        Trace.prototype.traceTransitionIgnored = function(trans) {
          if (!this.enabled(Category.TRANSITION))
            return;
          var tid = trans && trans.$id,
              digest = this.approximateDigests,
              transitionStr = strings_1.stringify(trans);
          console.log("Transition #" + tid + " Digest #" + digest + ": Ignored  <> " + transitionStr);
        };
        Trace.prototype.traceHookInvocation = function(step, options) {
          if (!this.enabled(Category.HOOK))
            return;
          var tid = hof_1.parse("transition.$id")(options),
              digest = this.approximateDigests,
              event = hof_1.parse("traceData.hookType")(options) || "internal",
              context = hof_1.parse("traceData.context.state.name")(options) || hof_1.parse("traceData.context")(options) || "unknown",
              name = strings_1.functionToString(step.eventHook.callback);
          console.log("Transition #" + tid + " Digest #" + digest + ":   Hook -> " + event + " context: " + context + ", " + strings_1.maxLength(200, name));
        };
        Trace.prototype.traceHookResult = function(hookResult, transitionOptions) {
          if (!this.enabled(Category.HOOK))
            return;
          var tid = hof_1.parse("transition.$id")(transitionOptions),
              digest = this.approximateDigests,
              hookResultStr = strings_1.stringify(hookResult);
          console.log("Transition #" + tid + " Digest #" + digest + ":   <- Hook returned: " + strings_1.maxLength(200, hookResultStr));
        };
        Trace.prototype.traceResolvePath = function(path, when, trans) {
          if (!this.enabled(Category.RESOLVE))
            return;
          var tid = trans && trans.$id,
              digest = this.approximateDigests,
              pathStr = path && path.toString();
          console.log("Transition #" + tid + " Digest #" + digest + ":         Resolving " + pathStr + " (" + when + ")");
        };
        Trace.prototype.traceResolvableResolved = function(resolvable, trans) {
          if (!this.enabled(Category.RESOLVE))
            return;
          var tid = trans && trans.$id,
              digest = this.approximateDigests,
              resolvableStr = resolvable && resolvable.toString(),
              result = strings_1.stringify(resolvable.data);
          console.log("Transition #" + tid + " Digest #" + digest + ":               <- Resolved  " + resolvableStr + " to: " + strings_1.maxLength(200, result));
        };
        Trace.prototype.traceError = function(reason, trans) {
          if (!this.enabled(Category.TRANSITION))
            return;
          var tid = trans && trans.$id,
              digest = this.approximateDigests,
              transitionStr = strings_1.stringify(trans);
          console.log("Transition #" + tid + " Digest #" + digest + ": <- Rejected " + transitionStr + ", reason: " + reason);
        };
        Trace.prototype.traceSuccess = function(finalState, trans) {
          if (!this.enabled(Category.TRANSITION))
            return;
          var tid = trans && trans.$id,
              digest = this.approximateDigests,
              state = finalState.name,
              transitionStr = strings_1.stringify(trans);
          console.log("Transition #" + tid + " Digest #" + digest + ": <- Success  " + transitionStr + ", final state: " + state);
        };
        Trace.prototype.traceUIViewEvent = function(event, viewData, extra) {
          if (extra === void 0) {
            extra = "";
          }
          if (!this.enabled(Category.UIVIEW))
            return;
          console.log("ui-view: " + strings_1.padString(30, event) + " " + uiViewString(viewData) + extra);
        };
        Trace.prototype.traceUIViewConfigUpdated = function(viewData, context) {
          if (!this.enabled(Category.UIVIEW))
            return;
          this.traceUIViewEvent("Updating", viewData, " with ViewConfig from context='" + context + "'");
        };
        Trace.prototype.traceUIViewFill = function(viewData, html) {
          if (!this.enabled(Category.UIVIEW))
            return;
          this.traceUIViewEvent("Fill", viewData, " with: " + strings_1.maxLength(200, html));
        };
        Trace.prototype.traceViewServiceEvent = function(event, viewConfig) {
          if (!this.enabled(Category.VIEWCONFIG))
            return;
          console.log("VIEWCONFIG: " + event + " " + viewConfigString(viewConfig));
        };
        Trace.prototype.traceViewServiceUIViewEvent = function(event, viewData) {
          if (!this.enabled(Category.VIEWCONFIG))
            return;
          console.log("VIEWCONFIG: " + event + " " + uiViewString(viewData));
        };
        return Trace;
      }());
      exports.Trace = Trace;
      var trace = new Trace();
      exports.trace = trace;
    }, function(module, exports, __webpack_require__) {
      "use strict";
      var common_1 = __webpack_require__(3);
      var strings_1 = __webpack_require__(9);
      var predicates_1 = __webpack_require__(4);
      var hof_1 = __webpack_require__(5);
      var trace_1 = __webpack_require__(12);
      var coreservices_1 = __webpack_require__(6);
      var rejectFactory_1 = __webpack_require__(10);
      var targetState_1 = __webpack_require__(14);
      var defaultOptions = {
        async: true,
        rejectIfSuperseded: true,
        current: common_1.noop,
        transition: null,
        traceData: {},
        bind: null
      };
      var TransitionHook = (function() {
        function TransitionHook(transition, stateContext, eventHook, options) {
          var _this = this;
          this.transition = transition;
          this.stateContext = stateContext;
          this.eventHook = eventHook;
          this.options = options;
          this.isSuperseded = function() {
            return _this.options.current() !== _this.options.transition;
          };
          this.options = common_1.defaults(options, defaultOptions);
        }
        TransitionHook.prototype.invokeHook = function() {
          var _a = this,
              options = _a.options,
              eventHook = _a.eventHook;
          trace_1.trace.traceHookInvocation(this, options);
          if (options.rejectIfSuperseded && this.isSuperseded()) {
            return rejectFactory_1.Rejection.superseded(options.current()).toPromise();
          }
          var synchronousHookResult = !eventHook._deregistered ? eventHook.callback.call(options.bind, this.transition, this.stateContext) : undefined;
          return this.handleHookResult(synchronousHookResult);
        };
        TransitionHook.prototype.handleHookResult = function(result) {
          if (this.isSuperseded()) {
            return rejectFactory_1.Rejection.superseded(this.options.current()).toPromise();
          }
          if (predicates_1.isPromise(result)) {
            return result.then(this.handleHookResult.bind(this));
          }
          trace_1.trace.traceHookResult(result, this.options);
          if (result === false) {
            return rejectFactory_1.Rejection.aborted("Hook aborted transition").toPromise();
          }
          var isTargetState = hof_1.is(targetState_1.TargetState);
          if (isTargetState(result)) {
            return rejectFactory_1.Rejection.redirected(result).toPromise();
          }
        };
        TransitionHook.prototype.toString = function() {
          var _a = this,
              options = _a.options,
              eventHook = _a.eventHook;
          var event = hof_1.parse("traceData.hookType")(options) || "internal",
              context = hof_1.parse("traceData.context.state.name")(options) || hof_1.parse("traceData.context")(options) || "unknown",
              name = strings_1.fnToString(eventHook.callback);
          return event + " context: " + context + ", " + strings_1.maxLength(200, name);
        };
        TransitionHook.runSynchronousHooks = function(hooks, swallowExceptions) {
          if (swallowExceptions === void 0) {
            swallowExceptions = false;
          }
          var results = [];
          for (var i = 0; i < hooks.length; i++) {
            var hook = hooks[i];
            try {
              results.push(hook.invokeHook());
            } catch (exception) {
              if (!swallowExceptions) {
                return rejectFactory_1.Rejection.errored(exception).toPromise();
              }
              var errorHandler = hook.transition.router.stateService.defaultErrorHandler();
              errorHandler(exception);
            }
          }
          var rejections = results.filter(rejectFactory_1.Rejection.isTransitionRejectionPromise);
          if (rejections.length)
            return rejections[0];
          return results.filter(predicates_1.isPromise).reduce(function(chain, promise) {
            return chain.then(hof_1.val(promise));
          }, coreservices_1.services.$q.when());
        };
        return TransitionHook;
      }());
      exports.TransitionHook = TransitionHook;
    }, function(module, exports, __webpack_require__) {
      "use strict";
      var common_1 = __webpack_require__(3);
      var TargetState = (function() {
        function TargetState(_identifier, _definition, _params, _options) {
          if (_params === void 0) {
            _params = {};
          }
          if (_options === void 0) {
            _options = {};
          }
          this._identifier = _identifier;
          this._definition = _definition;
          this._options = _options;
          this._params = _params || {};
        }
        TargetState.prototype.name = function() {
          return this._definition && this._definition.name || this._identifier;
        };
        TargetState.prototype.identifier = function() {
          return this._identifier;
        };
        TargetState.prototype.params = function() {
          return this._params;
        };
        TargetState.prototype.$state = function() {
          return this._definition;
        };
        TargetState.prototype.state = function() {
          return this._definition && this._definition.self;
        };
        TargetState.prototype.options = function() {
          return this._options;
        };
        TargetState.prototype.exists = function() {
          return !!(this._definition && this._definition.self);
        };
        TargetState.prototype.valid = function() {
          return !this.error();
        };
        TargetState.prototype.error = function() {
          var base = this.options().relative;
          if (!this._definition && !!base) {
            var stateName = base.name ? base.name : base;
            return "Could not resolve '" + this.name() + "' from state '" + stateName + "'";
          }
          if (!this._definition)
            return "No such state '" + this.name() + "'";
          if (!this._definition.self)
            return "State '" + this.name() + "' has an invalid definition";
        };
        TargetState.prototype.toString = function() {
          return "'" + this.name() + "'" + common_1.toJson(this.params());
        };
        return TargetState;
      }());
      exports.TargetState = TargetState;
    }, function(module, exports, __webpack_require__) {
      "use strict";
      var common_1 = __webpack_require__(3);
      var predicates_1 = __webpack_require__(4);
      var glob_1 = __webpack_require__(7);
      function matchState(state, criterion) {
        var toMatch = predicates_1.isString(criterion) ? [criterion] : criterion;
        function matchGlobs(_state) {
          var globStrings = toMatch;
          for (var i = 0; i < globStrings.length; i++) {
            var glob = glob_1.Glob.fromString(globStrings[i]);
            if ((glob && glob.matches(_state.name)) || (!glob && globStrings[i] === _state.name)) {
              return true;
            }
          }
          return false;
        }
        var matchFn = (predicates_1.isFunction(toMatch) ? toMatch : matchGlobs);
        return !!matchFn(state);
      }
      exports.matchState = matchState;
      var EventHook = (function() {
        function EventHook(matchCriteria, callback, options) {
          if (options === void 0) {
            options = {};
          }
          this.callback = callback;
          this.matchCriteria = common_1.extend({
            to: true,
            from: true,
            exiting: true,
            retained: true,
            entering: true
          }, matchCriteria);
          this.priority = options.priority || 0;
          this.bind = options.bind || null;
          this._deregistered = false;
        }
        EventHook._matchingNodes = function(nodes, criterion) {
          if (criterion === true)
            return nodes;
          var matching = nodes.filter(function(node) {
            return matchState(node.state, criterion);
          });
          return matching.length ? matching : null;
        };
        EventHook.prototype.matches = function(treeChanges) {
          var mc = this.matchCriteria,
              _matchingNodes = EventHook._matchingNodes;
          var matches = {
            to: _matchingNodes([common_1.tail(treeChanges.to)], mc.to),
            from: _matchingNodes([common_1.tail(treeChanges.from)], mc.from),
            exiting: _matchingNodes(treeChanges.exiting, mc.exiting),
            retained: _matchingNodes(treeChanges.retained, mc.retained),
            entering: _matchingNodes(treeChanges.entering, mc.entering)
          };
          var allMatched = ["to", "from", "exiting", "retained", "entering"].map(function(prop) {
            return matches[prop];
          }).reduce(common_1.allTrueR, true);
          return allMatched ? matches : null;
        };
        return EventHook;
      }());
      exports.EventHook = EventHook;
      function makeHookRegistrationFn(hooks, name) {
        return function(matchObject, callback, options) {
          if (options === void 0) {
            options = {};
          }
          var eventHook = new EventHook(matchObject, callback, options);
          hooks[name].push(eventHook);
          return function deregisterEventHook() {
            eventHook._deregistered = true;
            common_1.removeFrom(hooks[name])(eventHook);
          };
        };
      }
      var HookRegistry = (function() {
        function HookRegistry() {
          var _this = this;
          this._transitionEvents = {
            onBefore: [],
            onStart: [],
            onEnter: [],
            onRetain: [],
            onExit: [],
            onFinish: [],
            onSuccess: [],
            onError: []
          };
          this.getHooks = function(name) {
            return _this._transitionEvents[name];
          };
          this.onBefore = makeHookRegistrationFn(this._transitionEvents, "onBefore");
          this.onStart = makeHookRegistrationFn(this._transitionEvents, "onStart");
          this.onEnter = makeHookRegistrationFn(this._transitionEvents, "onEnter");
          this.onRetain = makeHookRegistrationFn(this._transitionEvents, "onRetain");
          this.onExit = makeHookRegistrationFn(this._transitionEvents, "onExit");
          this.onFinish = makeHookRegistrationFn(this._transitionEvents, "onFinish");
          this.onSuccess = makeHookRegistrationFn(this._transitionEvents, "onSuccess");
          this.onError = makeHookRegistrationFn(this._transitionEvents, "onError");
        }
        HookRegistry.mixin = function(source, target) {
          Object.keys(source._transitionEvents).concat(["getHooks"]).forEach(function(key) {
            return target[key] = source[key];
          });
        };
        return HookRegistry;
      }());
      exports.HookRegistry = HookRegistry;
    }, function(module, exports, __webpack_require__) {
      "use strict";
      var common_1 = __webpack_require__(3);
      var predicates_1 = __webpack_require__(4);
      var transitionHook_1 = __webpack_require__(13);
      var resolveContext_1 = __webpack_require__(17);
      var HookBuilder = (function() {
        function HookBuilder($transitions, transition, baseHookOptions) {
          var _this = this;
          this.$transitions = $transitions;
          this.transition = transition;
          this.baseHookOptions = baseHookOptions;
          this.getOnBeforeHooks = function() {
            return _this._buildNodeHooks("onBefore", "to", tupleSort(), {async: false});
          };
          this.getOnStartHooks = function() {
            return _this._buildNodeHooks("onStart", "to", tupleSort());
          };
          this.getOnExitHooks = function() {
            return _this._buildNodeHooks("onExit", "exiting", tupleSort(true), {stateHook: true});
          };
          this.getOnRetainHooks = function() {
            return _this._buildNodeHooks("onRetain", "retained", tupleSort(false), {stateHook: true});
          };
          this.getOnEnterHooks = function() {
            return _this._buildNodeHooks("onEnter", "entering", tupleSort(false), {stateHook: true});
          };
          this.getOnFinishHooks = function() {
            return _this._buildNodeHooks("onFinish", "to", tupleSort());
          };
          this.getOnSuccessHooks = function() {
            return _this._buildNodeHooks("onSuccess", "to", tupleSort(), {
              async: false,
              rejectIfSuperseded: false
            });
          };
          this.getOnErrorHooks = function() {
            return _this._buildNodeHooks("onError", "to", tupleSort(), {
              async: false,
              rejectIfSuperseded: false
            });
          };
          this.treeChanges = transition.treeChanges();
          this.toState = common_1.tail(this.treeChanges.to).state;
          this.fromState = common_1.tail(this.treeChanges.from).state;
          this.transitionOptions = transition.options();
        }
        HookBuilder.prototype.asyncHooks = function() {
          var onStartHooks = this.getOnStartHooks();
          var onExitHooks = this.getOnExitHooks();
          var onRetainHooks = this.getOnRetainHooks();
          var onEnterHooks = this.getOnEnterHooks();
          var onFinishHooks = this.getOnFinishHooks();
          var asyncHooks = [onStartHooks, onExitHooks, onRetainHooks, onEnterHooks, onFinishHooks];
          return asyncHooks.reduce(common_1.unnestR, []).filter(common_1.identity);
        };
        HookBuilder.prototype._buildNodeHooks = function(hookType, matchingNodesProp, sortHooksFn, options) {
          var _this = this;
          var matchingHooks = this._matchingHooks(hookType, this.treeChanges);
          if (!matchingHooks)
            return [];
          var makeTransitionHooks = function(hook) {
            var matches = hook.matches(_this.treeChanges);
            var matchingNodes = matches[matchingNodesProp];
            var resolvePath = matchingNodesProp === 'exiting' ? _this.treeChanges.from : _this.treeChanges.to;
            var resolveContext = new resolveContext_1.ResolveContext(resolvePath);
            return matchingNodes.map(function(node) {
              var _options = common_1.extend({
                bind: hook.bind,
                traceData: {
                  hookType: hookType,
                  context: node
                }
              }, _this.baseHookOptions, options);
              var state = _options.stateHook ? node.state : null;
              var transitionHook = new transitionHook_1.TransitionHook(_this.transition, state, hook, _options);
              return {
                hook: hook,
                node: node,
                transitionHook: transitionHook
              };
            });
          };
          return matchingHooks.map(makeTransitionHooks).reduce(common_1.unnestR, []).sort(sortHooksFn).map(function(tuple) {
            return tuple.transitionHook;
          });
        };
        HookBuilder.prototype._matchingHooks = function(hookName, treeChanges) {
          return [this.transition, this.$transitions].map(function(reg) {
            return reg.getHooks(hookName);
          }).filter(common_1.assertPredicate(predicates_1.isArray, "broken event named: " + hookName)).reduce(common_1.unnestR, []).filter(function(hook) {
            return hook.matches(treeChanges);
          });
        };
        return HookBuilder;
      }());
      exports.HookBuilder = HookBuilder;
      function tupleSort(reverseDepthSort) {
        if (reverseDepthSort === void 0) {
          reverseDepthSort = false;
        }
        return function nodeDepthThenPriority(l, r) {
          var factor = reverseDepthSort ? -1 : 1;
          var depthDelta = (l.node.state.path.length - r.node.state.path.length) * factor;
          return depthDelta !== 0 ? depthDelta : r.hook.priority - l.hook.priority;
        };
      }
    }, function(module, exports, __webpack_require__) {
      "use strict";
      var common_1 = __webpack_require__(3);
      var hof_1 = __webpack_require__(5);
      var trace_1 = __webpack_require__(12);
      var coreservices_1 = __webpack_require__(6);
      var interface_1 = __webpack_require__(18);
      var resolvable_1 = __webpack_require__(19);
      var pathFactory_1 = __webpack_require__(20);
      var strings_1 = __webpack_require__(9);
      var when = interface_1.resolvePolicies.when;
      var ALL_WHENS = [when.EAGER, when.LAZY];
      var EAGER_WHENS = [when.EAGER];
      exports.NATIVE_INJECTOR_TOKEN = "Native Injector";
      var ResolveContext = (function() {
        function ResolveContext(_path) {
          this._path = _path;
        }
        ResolveContext.prototype.getTokens = function() {
          return this._path.reduce(function(acc, node) {
            return acc.concat(node.resolvables.map(function(r) {
              return r.token;
            }));
          }, []).reduce(common_1.uniqR, []);
        };
        ResolveContext.prototype.getResolvable = function(token) {
          var matching = this._path.map(function(node) {
            return node.resolvables;
          }).reduce(common_1.unnestR, []).filter(function(r) {
            return r.token === token;
          });
          return common_1.tail(matching);
        };
        ResolveContext.prototype.subContext = function(state) {
          return new ResolveContext(pathFactory_1.PathFactory.subPath(this._path, function(node) {
            return node.state === state;
          }));
        };
        ResolveContext.prototype.addResolvables = function(newResolvables, state) {
          var node = common_1.find(this._path, hof_1.propEq('state', state));
          var keys = newResolvables.map(function(r) {
            return r.token;
          });
          node.resolvables = node.resolvables.filter(function(r) {
            return keys.indexOf(r.token) === -1;
          }).concat(newResolvables);
        };
        ResolveContext.prototype.resolvePath = function(when, trans) {
          var _this = this;
          if (when === void 0) {
            when = "LAZY";
          }
          var whenOption = common_1.inArray(ALL_WHENS, when) ? when : "LAZY";
          var matchedWhens = whenOption === interface_1.resolvePolicies.when.EAGER ? EAGER_WHENS : ALL_WHENS;
          trace_1.trace.traceResolvePath(this._path, when, trans);
          var promises = this._path.reduce(function(acc, node) {
            var matchesRequestedPolicy = function(resolvable) {
              return common_1.inArray(matchedWhens, resolvable.getPolicy(node.state).when);
            };
            var nodeResolvables = node.resolvables.filter(matchesRequestedPolicy);
            var subContext = _this.subContext(node.state);
            var getResult = function(r) {
              return r.get(subContext, trans).then(function(value) {
                return ({
                  token: r.token,
                  value: value
                });
              });
            };
            return acc.concat(nodeResolvables.map(getResult));
          }, []);
          return coreservices_1.services.$q.all(promises);
        };
        ResolveContext.prototype.injector = function() {
          return this._injector || (this._injector = new UIInjectorImpl(this));
        };
        ResolveContext.prototype.findNode = function(resolvable) {
          return common_1.find(this._path, function(node) {
            return common_1.inArray(node.resolvables, resolvable);
          });
        };
        ResolveContext.prototype.getDependencies = function(resolvable) {
          var _this = this;
          var node = this.findNode(resolvable);
          var subPath = pathFactory_1.PathFactory.subPath(this._path, function(x) {
            return x === node;
          }) || this._path;
          var availableResolvables = subPath.reduce(function(acc, node) {
            return acc.concat(node.resolvables);
          }, []).filter(function(res) {
            return res !== resolvable;
          });
          var getDependency = function(token) {
            var matching = availableResolvables.filter(function(r) {
              return r.token === token;
            });
            if (matching.length)
              return common_1.tail(matching);
            var fromInjector = _this.injector().getNative(token);
            if (!fromInjector) {
              throw new Error("Could not find Dependency Injection token: " + strings_1.stringify(token));
            }
            return new resolvable_1.Resolvable(token, function() {
              return fromInjector;
            }, [], fromInjector);
          };
          return resolvable.deps.map(getDependency);
        };
        return ResolveContext;
      }());
      exports.ResolveContext = ResolveContext;
      var UIInjectorImpl = (function() {
        function UIInjectorImpl(context) {
          this.context = context;
          this.native = this.get(exports.NATIVE_INJECTOR_TOKEN) || coreservices_1.services.$injector;
        }
        UIInjectorImpl.prototype.get = function(token) {
          var resolvable = this.context.getResolvable(token);
          if (resolvable) {
            if (!resolvable.resolved) {
              throw new Error("Resolvable async .get() not complete:" + strings_1.stringify(resolvable.token));
            }
            return resolvable.data;
          }
          return this.native && this.native.get(token);
        };
        UIInjectorImpl.prototype.getAsync = function(token) {
          var resolvable = this.context.getResolvable(token);
          if (resolvable)
            return resolvable.get(this.context);
          return coreservices_1.services.$q.when(this.native.get(token));
        };
        UIInjectorImpl.prototype.getNative = function(token) {
          return this.native.get(token);
        };
        return UIInjectorImpl;
      }());
    }, function(module, exports) {
      "use strict";
      exports.resolvePolicies = {
        when: {
          LAZY: "LAZY",
          EAGER: "EAGER"
        },
        async: {
          WAIT: "WAIT",
          NOWAIT: "NOWAIT",
          RXWAIT: "RXWAIT"
        }
      };
    }, function(module, exports, __webpack_require__) {
      "use strict";
      var common_1 = __webpack_require__(3);
      var coreservices_1 = __webpack_require__(6);
      var trace_1 = __webpack_require__(12);
      var strings_1 = __webpack_require__(9);
      var predicates_1 = __webpack_require__(4);
      exports.defaultResolvePolicy = {
        when: "LAZY",
        async: "WAIT"
      };
      var Resolvable = (function() {
        function Resolvable(arg1, resolveFn, deps, policy, data) {
          this.resolved = false;
          this.promise = undefined;
          if (arg1 instanceof Resolvable) {
            common_1.extend(this, arg1);
          } else if (predicates_1.isFunction(resolveFn)) {
            if (arg1 == null || arg1 == undefined)
              throw new Error("new Resolvable(): token argument is required");
            if (!predicates_1.isFunction(resolveFn))
              throw new Error("new Resolvable(): resolveFn argument must be a function");
            this.token = arg1;
            this.policy = policy;
            this.resolveFn = resolveFn;
            this.deps = deps || [];
            this.data = data;
            this.resolved = data !== undefined;
            this.promise = this.resolved ? coreservices_1.services.$q.when(this.data) : undefined;
          } else if (predicates_1.isObject(arg1) && arg1.token && predicates_1.isFunction(arg1.resolveFn)) {
            var literal = arg1;
            return new Resolvable(literal.token, literal.resolveFn, literal.deps, literal.policy, literal.data);
          }
        }
        Resolvable.prototype.getPolicy = function(state) {
          var thisPolicy = this.policy || {};
          var statePolicy = state && state.resolvePolicy || {};
          return {
            when: thisPolicy.when || statePolicy.when || exports.defaultResolvePolicy.when,
            async: thisPolicy.async || statePolicy.async || exports.defaultResolvePolicy.async
          };
        };
        Resolvable.prototype.resolve = function(resolveContext, trans) {
          var _this = this;
          var $q = coreservices_1.services.$q;
          var getResolvableDependencies = function() {
            return $q.all(resolveContext.getDependencies(_this).map(function(r) {
              return r.get(resolveContext, trans);
            }));
          };
          var invokeResolveFn = function(resolvedDeps) {
            return _this.resolveFn.apply(null, resolvedDeps);
          };
          var waitForRx = function(observable$) {
            var cached = observable$.cache(1);
            return cached.take(1).toPromise().then(function() {
              return cached;
            });
          };
          var node = resolveContext.findNode(this);
          var state = node && node.state;
          var maybeWaitForRx = this.getPolicy(state).async === "RXWAIT" ? waitForRx : common_1.identity;
          var applyResolvedValue = function(resolvedValue) {
            _this.data = resolvedValue;
            _this.resolved = true;
            trace_1.trace.traceResolvableResolved(_this, trans);
            return _this.data;
          };
          return this.promise = $q.when().then(getResolvableDependencies).then(invokeResolveFn).then(maybeWaitForRx).then(applyResolvedValue);
        };
        Resolvable.prototype.get = function(resolveContext, trans) {
          return this.promise || this.resolve(resolveContext, trans);
        };
        Resolvable.prototype.toString = function() {
          return "Resolvable(token: " + strings_1.stringify(this.token) + ", requires: [" + this.deps.map(strings_1.stringify) + "])";
        };
        Resolvable.prototype.clone = function() {
          return new Resolvable(this);
        };
        Resolvable.fromData = function(token, data) {
          return new Resolvable(token, function() {
            return data;
          }, null, null, data);
        };
        return Resolvable;
      }());
      exports.Resolvable = Resolvable;
    }, function(module, exports, __webpack_require__) {
      "use strict";
      var common_1 = __webpack_require__(3);
      var hof_1 = __webpack_require__(5);
      var targetState_1 = __webpack_require__(14);
      var node_1 = __webpack_require__(21);
      var PathFactory = (function() {
        function PathFactory() {}
        PathFactory.makeTargetState = function(path) {
          var state = common_1.tail(path).state;
          return new targetState_1.TargetState(state, state, path.map(hof_1.prop("paramValues")).reduce(common_1.mergeR, {}));
        };
        PathFactory.buildPath = function(targetState) {
          var toParams = targetState.params();
          return targetState.$state().path.map(function(state) {
            return new node_1.PathNode(state).applyRawParams(toParams);
          });
        };
        PathFactory.buildToPath = function(fromPath, targetState) {
          var toPath = PathFactory.buildPath(targetState);
          if (targetState.options().inherit) {
            return PathFactory.inheritParams(fromPath, toPath, Object.keys(targetState.params()));
          }
          return toPath;
        };
        PathFactory.applyViewConfigs = function($view, path, states) {
          path.filter(function(node) {
            return common_1.inArray(states, node.state);
          }).forEach(function(node) {
            var viewDecls = common_1.values(node.state.views || {});
            var subPath = PathFactory.subPath(path, function(n) {
              return n === node;
            });
            var viewConfigs = viewDecls.map(function(view) {
              return $view.createViewConfig(subPath, view);
            });
            node.views = viewConfigs.reduce(common_1.unnestR, []);
          });
        };
        PathFactory.inheritParams = function(fromPath, toPath, toKeys) {
          if (toKeys === void 0) {
            toKeys = [];
          }
          function nodeParamVals(path, state) {
            var node = common_1.find(path, hof_1.propEq('state', state));
            return common_1.extend({}, node && node.paramValues);
          }
          function makeInheritedParamsNode(toNode) {
            var toParamVals = common_1.extend({}, toNode && toNode.paramValues);
            var incomingParamVals = common_1.pick(toParamVals, toKeys);
            toParamVals = common_1.omit(toParamVals, toKeys);
            var fromParamVals = nodeParamVals(fromPath, toNode.state) || {};
            var ownParamVals = common_1.extend(toParamVals, fromParamVals, incomingParamVals);
            return new node_1.PathNode(toNode.state).applyRawParams(ownParamVals);
          }
          return toPath.map(makeInheritedParamsNode);
        };
        PathFactory.treeChanges = function(fromPath, toPath, reloadState) {
          var keep = 0,
              max = Math.min(fromPath.length, toPath.length);
          var staticParams = function(state) {
            return state.parameters({inherit: false}).filter(hof_1.not(hof_1.prop('dynamic'))).map(hof_1.prop('id'));
          };
          var nodesMatch = function(node1, node2) {
            return node1.equals(node2, staticParams(node1.state));
          };
          while (keep < max && fromPath[keep].state !== reloadState && nodesMatch(fromPath[keep], toPath[keep])) {
            keep++;
          }
          function applyToParams(retainedNode, idx) {
            var cloned = node_1.PathNode.clone(retainedNode);
            cloned.paramValues = toPath[idx].paramValues;
            return cloned;
          }
          var from,
              retained,
              exiting,
              entering,
              to;
          from = fromPath;
          retained = from.slice(0, keep);
          exiting = from.slice(keep);
          var retainedWithToParams = retained.map(applyToParams);
          entering = toPath.slice(keep);
          to = (retainedWithToParams).concat(entering);
          return {
            from: from,
            to: to,
            retained: retained,
            exiting: exiting,
            entering: entering
          };
        };
        PathFactory.subPath = function(path, predicate) {
          var node = common_1.find(path, predicate);
          var elementIdx = path.indexOf(node);
          return elementIdx === -1 ? undefined : path.slice(0, elementIdx + 1);
        };
        PathFactory.paramValues = function(path) {
          return path.reduce(function(acc, node) {
            return common_1.extend(acc, node.paramValues);
          }, {});
        };
        return PathFactory;
      }());
      exports.PathFactory = PathFactory;
    }, function(module, exports, __webpack_require__) {
      "use strict";
      var common_1 = __webpack_require__(3);
      var hof_1 = __webpack_require__(5);
      var param_1 = __webpack_require__(22);
      var PathNode = (function() {
        function PathNode(stateOrPath) {
          if (stateOrPath instanceof PathNode) {
            var node = stateOrPath;
            this.state = node.state;
            this.paramSchema = node.paramSchema.slice();
            this.paramValues = common_1.extend({}, node.paramValues);
            this.resolvables = node.resolvables.slice();
            this.views = node.views && node.views.slice();
          } else {
            var state = stateOrPath;
            this.state = state;
            this.paramSchema = state.parameters({inherit: false});
            this.paramValues = {};
            this.resolvables = state.resolvables.map(function(res) {
              return res.clone();
            });
          }
        }
        PathNode.prototype.applyRawParams = function(params) {
          var getParamVal = function(paramDef) {
            return [paramDef.id, paramDef.value(params[paramDef.id])];
          };
          this.paramValues = this.paramSchema.reduce(function(memo, pDef) {
            return common_1.applyPairs(memo, getParamVal(pDef));
          }, {});
          return this;
        };
        PathNode.prototype.parameter = function(name) {
          return common_1.find(this.paramSchema, hof_1.propEq("id", name));
        };
        PathNode.prototype.equals = function(node, keys) {
          var _this = this;
          if (keys === void 0) {
            keys = this.paramSchema.map(function(p) {
              return p.id;
            });
          }
          var paramValsEq = function(key) {
            return _this.parameter(key).type.equals(_this.paramValues[key], node.paramValues[key]);
          };
          return this.state === node.state && keys.map(paramValsEq).reduce(common_1.allTrueR, true);
        };
        PathNode.clone = function(node) {
          return new PathNode(node);
        };
        PathNode.matching = function(pathA, pathB, ignoreDynamicParams) {
          if (ignoreDynamicParams === void 0) {
            ignoreDynamicParams = true;
          }
          var matching = [];
          for (var i = 0; i < pathA.length && i < pathB.length; i++) {
            var a = pathA[i],
                b = pathB[i];
            if (a.state !== b.state)
              break;
            var changedParams = param_1.Param.changed(a.paramSchema, a.paramValues, b.paramValues).filter(function(param) {
              return !(ignoreDynamicParams && param.dynamic);
            });
            if (changedParams.length)
              break;
            matching.push(a);
          }
          return matching;
        };
        return PathNode;
      }());
      exports.PathNode = PathNode;
    }, function(module, exports, __webpack_require__) {
      "use strict";
      var common_1 = __webpack_require__(3);
      var hof_1 = __webpack_require__(5);
      var predicates_1 = __webpack_require__(4);
      var coreservices_1 = __webpack_require__(6);
      var urlMatcherConfig_1 = __webpack_require__(23);
      var type_1 = __webpack_require__(24);
      var hasOwn = Object.prototype.hasOwnProperty;
      var isShorthand = function(cfg) {
        return ["value", "type", "squash", "array", "dynamic"].filter(hasOwn.bind(cfg || {})).length === 0;
      };
      (function(DefType) {
        DefType[DefType["PATH"] = 0] = "PATH";
        DefType[DefType["SEARCH"] = 1] = "SEARCH";
        DefType[DefType["CONFIG"] = 2] = "CONFIG";
      })(exports.DefType || (exports.DefType = {}));
      var DefType = exports.DefType;
      function unwrapShorthand(cfg) {
        cfg = isShorthand(cfg) && {value: cfg} || cfg;
        return common_1.extend(cfg, {$$fn: predicates_1.isInjectable(cfg.value) ? cfg.value : function() {
            return cfg.value;
          }});
      }
      function getType(cfg, urlType, location, id, paramTypes) {
        if (cfg.type && urlType && urlType.name !== 'string')
          throw new Error("Param '" + id + "' has two type configurations.");
        if (cfg.type && urlType && urlType.name === 'string' && paramTypes.type(cfg.type))
          return paramTypes.type(cfg.type);
        if (urlType)
          return urlType;
        if (!cfg.type)
          return (location === DefType.CONFIG ? paramTypes.type("any") : paramTypes.type("string"));
        return cfg.type instanceof type_1.ParamType ? cfg.type : paramTypes.type(cfg.type);
      }
      function getSquashPolicy(config, isOptional) {
        var squash = config.squash;
        if (!isOptional || squash === false)
          return false;
        if (!predicates_1.isDefined(squash) || squash == null)
          return urlMatcherConfig_1.matcherConfig.defaultSquashPolicy();
        if (squash === true || predicates_1.isString(squash))
          return squash;
        throw new Error("Invalid squash policy: '" + squash + "'. Valid policies: false, true, or arbitrary string");
      }
      function getReplace(config, arrayMode, isOptional, squash) {
        var replace,
            configuredKeys,
            defaultPolicy = [{
              from: "",
              to: (isOptional || arrayMode ? undefined : "")
            }, {
              from: null,
              to: (isOptional || arrayMode ? undefined : "")
            }];
        replace = predicates_1.isArray(config.replace) ? config.replace : [];
        if (predicates_1.isString(squash))
          replace.push({
            from: squash,
            to: undefined
          });
        configuredKeys = common_1.map(replace, hof_1.prop("from"));
        return common_1.filter(defaultPolicy, function(item) {
          return configuredKeys.indexOf(item.from) === -1;
        }).concat(replace);
      }
      var Param = (function() {
        function Param(id, type, config, location, paramTypes) {
          config = unwrapShorthand(config);
          type = getType(config, type, location, id, paramTypes);
          var arrayMode = getArrayMode();
          type = arrayMode ? type.$asArray(arrayMode, location === DefType.SEARCH) : type;
          var isOptional = config.value !== undefined;
          var dynamic = predicates_1.isDefined(config.dynamic) ? !!config.dynamic : !!type.dynamic;
          var squash = getSquashPolicy(config, isOptional);
          var replace = getReplace(config, arrayMode, isOptional, squash);
          function getArrayMode() {
            var arrayDefaults = {array: (location === DefType.SEARCH ? "auto" : false)};
            var arrayParamNomenclature = id.match(/\[\]$/) ? {array: true} : {};
            return common_1.extend(arrayDefaults, arrayParamNomenclature, config).array;
          }
          common_1.extend(this, {
            id: id,
            type: type,
            location: location,
            squash: squash,
            replace: replace,
            isOptional: isOptional,
            dynamic: dynamic,
            config: config,
            array: arrayMode
          });
        }
        Param.prototype.isDefaultValue = function(value) {
          return this.isOptional && this.type.equals(this.value(), value);
        };
        Param.prototype.value = function(value) {
          var _this = this;
          var $$getDefaultValue = function() {
            if (!coreservices_1.services.$injector)
              throw new Error("Injectable functions cannot be called at configuration time");
            var defaultValue = coreservices_1.services.$injector.invoke(_this.config.$$fn);
            if (defaultValue !== null && defaultValue !== undefined && !_this.type.is(defaultValue))
              throw new Error("Default value (" + defaultValue + ") for parameter '" + _this.id + "' is not an instance of ParamType (" + _this.type.name + ")");
            return defaultValue;
          };
          var $replace = function(val) {
            var replacement = common_1.map(common_1.filter(_this.replace, hof_1.propEq('from', val)), hof_1.prop("to"));
            return replacement.length ? replacement[0] : val;
          };
          value = $replace(value);
          return !predicates_1.isDefined(value) ? $$getDefaultValue() : this.type.$normalize(value);
        };
        Param.prototype.isSearch = function() {
          return this.location === DefType.SEARCH;
        };
        Param.prototype.validates = function(value) {
          if ((!predicates_1.isDefined(value) || value === null) && this.isOptional)
            return true;
          var normalized = this.type.$normalize(value);
          if (!this.type.is(normalized))
            return false;
          var encoded = this.type.encode(normalized);
          return !(predicates_1.isString(encoded) && !this.type.pattern.exec(encoded));
        };
        Param.prototype.toString = function() {
          return "{Param:" + this.id + " " + this.type + " squash: '" + this.squash + "' optional: " + this.isOptional + "}";
        };
        Param.fromConfig = function(id, type, config, paramTypes) {
          return new Param(id, type, config, DefType.CONFIG, paramTypes);
        };
        Param.fromPath = function(id, type, config, paramTypes) {
          return new Param(id, type, config, DefType.PATH, paramTypes);
        };
        Param.fromSearch = function(id, type, config, paramTypes) {
          return new Param(id, type, config, DefType.SEARCH, paramTypes);
        };
        Param.values = function(params, values) {
          if (values === void 0) {
            values = {};
          }
          return params.map(function(param) {
            return [param.id, param.value(values[param.id])];
          }).reduce(common_1.applyPairs, {});
        };
        Param.changed = function(params, values1, values2) {
          if (values1 === void 0) {
            values1 = {};
          }
          if (values2 === void 0) {
            values2 = {};
          }
          return params.filter(function(param) {
            return !param.type.equals(values1[param.id], values2[param.id]);
          });
        };
        Param.equals = function(params, values1, values2) {
          if (values1 === void 0) {
            values1 = {};
          }
          if (values2 === void 0) {
            values2 = {};
          }
          return Param.changed(params, values1, values2).length === 0;
        };
        Param.validates = function(params, values) {
          if (values === void 0) {
            values = {};
          }
          return params.map(function(param) {
            return param.validates(values[param.id]);
          }).reduce(common_1.allTrueR, true);
        };
        return Param;
      }());
      exports.Param = Param;
    }, function(module, exports, __webpack_require__) {
      "use strict";
      var predicates_1 = __webpack_require__(4);
      var MatcherConfig = (function() {
        function MatcherConfig() {
          this._isCaseInsensitive = false;
          this._isStrictMode = true;
          this._defaultSquashPolicy = false;
        }
        MatcherConfig.prototype.caseInsensitive = function(value) {
          return this._isCaseInsensitive = predicates_1.isDefined(value) ? value : this._isCaseInsensitive;
        };
        MatcherConfig.prototype.strictMode = function(value) {
          return this._isStrictMode = predicates_1.isDefined(value) ? value : this._isStrictMode;
        };
        MatcherConfig.prototype.defaultSquashPolicy = function(value) {
          if (predicates_1.isDefined(value) && value !== true && value !== false && !predicates_1.isString(value))
            throw new Error("Invalid squash policy: " + value + ". Valid policies: false, true, arbitrary-string");
          return this._defaultSquashPolicy = predicates_1.isDefined(value) ? value : this._defaultSquashPolicy;
        };
        return MatcherConfig;
      }());
      exports.MatcherConfig = MatcherConfig;
      exports.matcherConfig = new MatcherConfig();
    }, function(module, exports, __webpack_require__) {
      "use strict";
      var common_1 = __webpack_require__(3);
      var predicates_1 = __webpack_require__(4);
      function ArrayType(type, mode) {
        var _this = this;
        function arrayWrap(val) {
          return predicates_1.isArray(val) ? val : (predicates_1.isDefined(val) ? [val] : []);
        }
        function arrayUnwrap(val) {
          switch (val.length) {
            case 0:
              return undefined;
            case 1:
              return mode === "auto" ? val[0] : val;
            default:
              return val;
          }
        }
        function arrayHandler(callback, allTruthyMode) {
          return function handleArray(val) {
            if (predicates_1.isArray(val) && val.length === 0)
              return val;
            var arr = arrayWrap(val);
            var result = common_1.map(arr, callback);
            return (allTruthyMode === true) ? common_1.filter(result, function(x) {
              return !x;
            }).length === 0 : arrayUnwrap(result);
          };
        }
        function arrayEqualsHandler(callback) {
          return function handleArray(val1, val2) {
            var left = arrayWrap(val1),
                right = arrayWrap(val2);
            if (left.length !== right.length)
              return false;
            for (var i = 0; i < left.length; i++) {
              if (!callback(left[i], right[i]))
                return false;
            }
            return true;
          };
        }
        ['encode', 'decode', 'equals', '$normalize'].forEach(function(name) {
          var paramTypeFn = type[name].bind(type);
          var wrapperFn = name === 'equals' ? arrayEqualsHandler : arrayHandler;
          _this[name] = wrapperFn(paramTypeFn);
        });
        common_1.extend(this, {
          dynamic: type.dynamic,
          name: type.name,
          pattern: type.pattern,
          is: arrayHandler(type.is.bind(type), true),
          $arrayMode: mode
        });
      }
      var ParamType = (function() {
        function ParamType(def) {
          this.pattern = /.*/;
          common_1.extend(this, def);
        }
        ParamType.prototype.is = function(val, key) {
          return true;
        };
        ParamType.prototype.encode = function(val, key) {
          return val;
        };
        ParamType.prototype.decode = function(val, key) {
          return val;
        };
        ParamType.prototype.equals = function(a, b) {
          return a == b;
        };
        ParamType.prototype.$subPattern = function() {
          var sub = this.pattern.toString();
          return sub.substr(1, sub.length - 2);
        };
        ParamType.prototype.toString = function() {
          return "{ParamType:" + this.name + "}";
        };
        ParamType.prototype.$normalize = function(val) {
          return this.is(val) ? val : this.decode(val);
        };
        ParamType.prototype.$asArray = function(mode, isSearch) {
          if (!mode)
            return this;
          if (mode === "auto" && !isSearch)
            throw new Error("'auto' array mode is for query parameters only");
          return new ArrayType(this, mode);
        };
        return ParamType;
      }());
      exports.ParamType = ParamType;
    }, function(module, exports, __webpack_require__) {
      "use strict";
      var urlMatcherFactory_1 = __webpack_require__(26);
      var urlRouter_1 = __webpack_require__(29);
      var urlRouter_2 = __webpack_require__(29);
      var transitionService_1 = __webpack_require__(30);
      var view_1 = __webpack_require__(37);
      var stateRegistry_1 = __webpack_require__(38);
      var stateService_1 = __webpack_require__(43);
      var globals_1 = __webpack_require__(44);
      var UIRouter = (function() {
        function UIRouter() {
          this.viewService = new view_1.ViewService();
          this.transitionService = new transitionService_1.TransitionService(this);
          this.globals = new globals_1.Globals(this.transitionService);
          this.urlMatcherFactory = new urlMatcherFactory_1.UrlMatcherFactory();
          this.urlRouterProvider = new urlRouter_1.UrlRouterProvider(this.urlMatcherFactory, this.globals.params);
          this.urlRouter = new urlRouter_2.UrlRouter(this.urlRouterProvider);
          this.stateRegistry = new stateRegistry_1.StateRegistry(this.urlMatcherFactory, this.urlRouterProvider);
          this.stateService = new stateService_1.StateService(this);
          this.viewService.rootContext(this.stateRegistry.root());
          this.globals.$current = this.stateRegistry.root();
          this.globals.current = this.globals.$current.self;
        }
        return UIRouter;
      }());
      exports.UIRouter = UIRouter;
    }, function(module, exports, __webpack_require__) {
      "use strict";
      var common_1 = __webpack_require__(3);
      var predicates_1 = __webpack_require__(4);
      var urlMatcher_1 = __webpack_require__(27);
      var urlMatcherConfig_1 = __webpack_require__(23);
      var param_1 = __webpack_require__(22);
      var paramTypes_1 = __webpack_require__(28);
      function getDefaultConfig() {
        return {
          strict: urlMatcherConfig_1.matcherConfig.strictMode(),
          caseInsensitive: urlMatcherConfig_1.matcherConfig.caseInsensitive()
        };
      }
      var UrlMatcherFactory = (function() {
        function UrlMatcherFactory() {
          this.paramTypes = new paramTypes_1.ParamTypes();
          common_1.extend(this, {
            UrlMatcher: urlMatcher_1.UrlMatcher,
            Param: param_1.Param
          });
        }
        UrlMatcherFactory.prototype.caseInsensitive = function(value) {
          return urlMatcherConfig_1.matcherConfig.caseInsensitive(value);
        };
        UrlMatcherFactory.prototype.strictMode = function(value) {
          return urlMatcherConfig_1.matcherConfig.strictMode(value);
        };
        UrlMatcherFactory.prototype.defaultSquashPolicy = function(value) {
          return urlMatcherConfig_1.matcherConfig.defaultSquashPolicy(value);
        };
        UrlMatcherFactory.prototype.compile = function(pattern, config) {
          return new urlMatcher_1.UrlMatcher(pattern, this.paramTypes, common_1.extend(getDefaultConfig(), config));
        };
        UrlMatcherFactory.prototype.isMatcher = function(object) {
          if (!predicates_1.isObject(object))
            return false;
          var result = true;
          common_1.forEach(urlMatcher_1.UrlMatcher.prototype, function(val, name) {
            if (predicates_1.isFunction(val))
              result = result && (predicates_1.isDefined(object[name]) && predicates_1.isFunction(object[name]));
          });
          return result;
        };
        ;
        UrlMatcherFactory.prototype.type = function(name, definition, definitionFn) {
          var type = this.paramTypes.type(name, definition, definitionFn);
          return !predicates_1.isDefined(definition) ? type : this;
        };
        ;
        UrlMatcherFactory.prototype.$get = function() {
          this.paramTypes.enqueue = false;
          this.paramTypes._flushTypeQueue();
          return this;
        };
        ;
        return UrlMatcherFactory;
      }());
      exports.UrlMatcherFactory = UrlMatcherFactory;
    }, function(module, exports, __webpack_require__) {
      "use strict";
      var common_1 = __webpack_require__(3);
      var hof_1 = __webpack_require__(5);
      var predicates_1 = __webpack_require__(4);
      var param_1 = __webpack_require__(22);
      var predicates_2 = __webpack_require__(4);
      var param_2 = __webpack_require__(22);
      var common_2 = __webpack_require__(3);
      var common_3 = __webpack_require__(3);
      function quoteRegExp(string, param) {
        var surroundPattern = ['', ''],
            result = string.replace(/[\\\[\]\^$*+?.()|{}]/g, "\\$&");
        if (!param)
          return result;
        switch (param.squash) {
          case false:
            surroundPattern = ['(', ')' + (param.isOptional ? '?' : '')];
            break;
          case true:
            result = result.replace(/\/$/, '');
            surroundPattern = ['(?:\/(', ')|\/)?'];
            break;
          default:
            surroundPattern = [("(" + param.squash + "|"), ')?'];
            break;
        }
        return result + surroundPattern[0] + param.type.pattern.source + surroundPattern[1];
      }
      var memoizeTo = function(obj, prop, fn) {
        return obj[prop] = obj[prop] || fn();
      };
      var UrlMatcher = (function() {
        function UrlMatcher(pattern, paramTypes, config) {
          var _this = this;
          this.config = config;
          this._cache = {
            path: [],
            pattern: null
          };
          this._children = [];
          this._params = [];
          this._segments = [];
          this._compiled = [];
          this.pattern = pattern;
          this.config = common_1.defaults(this.config, {
            params: {},
            strict: true,
            caseInsensitive: false,
            paramMap: common_1.identity
          });
          var placeholder = /([:*])([\w\[\]]+)|\{([\w\[\]]+)(?:\:\s*((?:[^{}\\]+|\\.|\{(?:[^{}\\]+|\\.)*\})+))?\}/g,
              searchPlaceholder = /([:]?)([\w\[\].-]+)|\{([\w\[\].-]+)(?:\:\s*((?:[^{}\\]+|\\.|\{(?:[^{}\\]+|\\.)*\})+))?\}/g,
              last = 0,
              m,
              patterns = [];
          var checkParamErrors = function(id) {
            if (!UrlMatcher.nameValidator.test(id))
              throw new Error("Invalid parameter name '" + id + "' in pattern '" + pattern + "'");
            if (common_1.find(_this._params, hof_1.propEq('id', id)))
              throw new Error("Duplicate parameter name '" + id + "' in pattern '" + pattern + "'");
          };
          var matchDetails = function(m, isSearch) {
            var id = m[2] || m[3],
                regexp = isSearch ? m[4] : m[4] || (m[1] === '*' ? '.*' : null);
            return {
              id: id,
              regexp: regexp,
              cfg: _this.config.params[id],
              segment: pattern.substring(last, m.index),
              type: !regexp ? null : paramTypes.type(regexp || "string") || common_1.inherit(paramTypes.type("string"), {pattern: new RegExp(regexp, _this.config.caseInsensitive ? 'i' : undefined)})
            };
          };
          var p,
              segment;
          while ((m = placeholder.exec(pattern))) {
            p = matchDetails(m, false);
            if (p.segment.indexOf('?') >= 0)
              break;
            checkParamErrors(p.id);
            this._params.push(param_1.Param.fromPath(p.id, p.type, this.config.paramMap(p.cfg, false), paramTypes));
            this._segments.push(p.segment);
            patterns.push([p.segment, common_1.tail(this._params)]);
            last = placeholder.lastIndex;
          }
          segment = pattern.substring(last);
          var i = segment.indexOf('?');
          if (i >= 0) {
            var search = segment.substring(i);
            segment = segment.substring(0, i);
            if (search.length > 0) {
              last = 0;
              while ((m = searchPlaceholder.exec(search))) {
                p = matchDetails(m, true);
                checkParamErrors(p.id);
                this._params.push(param_1.Param.fromSearch(p.id, p.type, this.config.paramMap(p.cfg, true), paramTypes));
                last = placeholder.lastIndex;
              }
            }
          }
          this._segments.push(segment);
          common_1.extend(this, {
            _compiled: patterns.map(function(pattern) {
              return quoteRegExp.apply(null, pattern);
            }).concat(quoteRegExp(segment)),
            prefix: this._segments[0]
          });
          Object.freeze(this);
        }
        UrlMatcher.prototype.append = function(url) {
          this._children.push(url);
          common_1.forEach(url._cache, function(val, key) {
            return url._cache[key] = predicates_1.isArray(val) ? [] : null;
          });
          url._cache.path = this._cache.path.concat(this);
          return url;
        };
        UrlMatcher.prototype.isRoot = function() {
          return this._cache.path.length === 0;
        };
        UrlMatcher.prototype.toString = function() {
          return this.pattern;
        };
        UrlMatcher.prototype.exec = function(path, search, hash, options) {
          var _this = this;
          if (search === void 0) {
            search = {};
          }
          if (options === void 0) {
            options = {};
          }
          var match = memoizeTo(this._cache, 'pattern', function() {
            return new RegExp(['^', common_1.unnest(_this._cache.path.concat(_this).map(hof_1.prop('_compiled'))).join(''), _this.config.strict === false ? '\/?' : '', '$'].join(''), _this.config.caseInsensitive ? 'i' : undefined);
          }).exec(path);
          if (!match)
            return null;
          var allParams = this.parameters(),
              pathParams = allParams.filter(function(param) {
                return !param.isSearch();
              }),
              searchParams = allParams.filter(function(param) {
                return param.isSearch();
              }),
              nPathSegments = this._cache.path.concat(this).map(function(urlm) {
                return urlm._segments.length - 1;
              }).reduce(function(a, x) {
                return a + x;
              }),
              values = {};
          if (nPathSegments !== match.length - 1)
            throw new Error("Unbalanced capture group in route '" + this.pattern + "'");
          function decodePathArray(string) {
            var reverseString = function(str) {
              return str.split("").reverse().join("");
            };
            var unquoteDashes = function(str) {
              return str.replace(/\\-/g, "-");
            };
            var split = reverseString(string).split(/-(?!\\)/);
            var allReversed = common_1.map(split, reverseString);
            return common_1.map(allReversed, unquoteDashes).reverse();
          }
          for (var i = 0; i < nPathSegments; i++) {
            var param = pathParams[i];
            var value = match[i + 1];
            for (var j = 0; j < param.replace.length; j++) {
              if (param.replace[j].from === value)
                value = param.replace[j].to;
            }
            if (value && param.array === true)
              value = decodePathArray(value);
            if (predicates_2.isDefined(value))
              value = param.type.decode(value);
            values[param.id] = param.value(value);
          }
          searchParams.forEach(function(param) {
            var value = search[param.id];
            for (var j = 0; j < param.replace.length; j++) {
              if (param.replace[j].from === value)
                value = param.replace[j].to;
            }
            if (predicates_2.isDefined(value))
              value = param.type.decode(value);
            values[param.id] = param.value(value);
          });
          if (hash)
            values["#"] = hash;
          return values;
        };
        UrlMatcher.prototype.parameters = function(opts) {
          if (opts === void 0) {
            opts = {};
          }
          if (opts.inherit === false)
            return this._params;
          return common_1.unnest(this._cache.path.concat(this).map(hof_1.prop('_params')));
        };
        UrlMatcher.prototype.parameter = function(id, opts) {
          if (opts === void 0) {
            opts = {};
          }
          var parent = common_1.tail(this._cache.path);
          return (common_1.find(this._params, hof_1.propEq('id', id)) || (opts.inherit !== false && parent && parent.parameter(id)) || null);
        };
        UrlMatcher.prototype.validates = function(params) {
          var _this = this;
          var validParamVal = function(param, val) {
            return !param || param.validates(val);
          };
          return common_1.pairs(params || {}).map(function(_a) {
            var key = _a[0],
                val = _a[1];
            return validParamVal(_this.parameter(key), val);
          }).reduce(common_1.allTrueR, true);
        };
        UrlMatcher.prototype.format = function(values) {
          if (values === void 0) {
            values = {};
          }
          if (!this.validates(values))
            return null;
          var urlMatchers = this._cache.path.slice().concat(this);
          var pathSegmentsAndParams = urlMatchers.map(UrlMatcher.pathSegmentsAndParams).reduce(common_2.unnestR, []);
          var queryParams = urlMatchers.map(UrlMatcher.queryParams).reduce(common_2.unnestR, []);
          function getDetails(param) {
            var value = param.value(values[param.id]);
            var isDefaultValue = param.isDefaultValue(value);
            var squash = isDefaultValue ? param.squash : false;
            var encoded = param.type.encode(value);
            return {
              param: param,
              value: value,
              isDefaultValue: isDefaultValue,
              squash: squash,
              encoded: encoded
            };
          }
          var pathString = pathSegmentsAndParams.reduce(function(acc, x) {
            if (predicates_1.isString(x))
              return acc + x;
            var _a = getDetails(x),
                squash = _a.squash,
                encoded = _a.encoded,
                param = _a.param;
            if (squash === true)
              return (acc.match(/\/$/)) ? acc.slice(0, -1) : acc;
            if (predicates_1.isString(squash))
              return acc + squash;
            if (squash !== false)
              return acc;
            if (encoded == null)
              return acc;
            if (predicates_1.isArray(encoded))
              return acc + common_1.map(encoded, UrlMatcher.encodeDashes).join("-");
            if (param.type.raw)
              return acc + encoded;
            return acc + encodeURIComponent(encoded);
          }, "");
          var queryString = queryParams.map(function(param) {
            var _a = getDetails(param),
                squash = _a.squash,
                encoded = _a.encoded,
                isDefaultValue = _a.isDefaultValue;
            if (encoded == null || (isDefaultValue && squash !== false))
              return;
            if (!predicates_1.isArray(encoded))
              encoded = [encoded];
            if (encoded.length === 0)
              return;
            if (!param.type.raw)
              encoded = common_1.map(encoded, encodeURIComponent);
            return encoded.map(function(val) {
              return (param.id + "=" + val);
            });
          }).filter(common_1.identity).reduce(common_2.unnestR, []).join("&");
          return pathString + (queryString ? "?" + queryString : "") + (values["#"] ? "#" + values["#"] : "");
        };
        UrlMatcher.encodeDashes = function(str) {
          return encodeURIComponent(str).replace(/-/g, function(c) {
            return ("%5C%" + c.charCodeAt(0).toString(16).toUpperCase());
          });
        };
        UrlMatcher.pathSegmentsAndParams = function(matcher) {
          var staticSegments = matcher._segments;
          var pathParams = matcher._params.filter(function(p) {
            return p.location === param_2.DefType.PATH;
          });
          return common_3.arrayTuples(staticSegments, pathParams.concat(undefined)).reduce(common_2.unnestR, []).filter(function(x) {
            return x !== "" && predicates_2.isDefined(x);
          });
        };
        UrlMatcher.queryParams = function(matcher) {
          return matcher._params.filter(function(p) {
            return p.location === param_2.DefType.SEARCH;
          });
        };
        UrlMatcher.nameValidator = /^\w+([-.]+\w+)*(?:\[\])?$/;
        return UrlMatcher;
      }());
      exports.UrlMatcher = UrlMatcher;
    }, function(module, exports, __webpack_require__) {
      "use strict";
      var common_1 = __webpack_require__(3);
      var predicates_1 = __webpack_require__(4);
      var hof_1 = __webpack_require__(5);
      var coreservices_1 = __webpack_require__(6);
      var type_1 = __webpack_require__(24);
      function valToString(val) {
        return val != null ? val.toString().replace(/(~|\/)/g, function(m) {
          return ({
            '~': '~~',
            '/': '~2F'
          }[m]);
        }) : val;
      }
      function valFromString(val) {
        return val != null ? val.toString().replace(/(~~|~2F)/g, function(m) {
          return ({
            '~~': '~',
            '~2F': '/'
          }[m]);
        }) : val;
      }
      var ParamTypes = (function() {
        function ParamTypes() {
          this.enqueue = true;
          this.typeQueue = [];
          this.defaultTypes = {
            "hash": {
              encode: valToString,
              decode: valFromString,
              is: hof_1.is(String),
              pattern: /.*/,
              equals: function(a, b) {
                return a == b;
              }
            },
            "string": {
              encode: valToString,
              decode: valFromString,
              is: hof_1.is(String),
              pattern: /[^/]*/
            },
            "int": {
              encode: valToString,
              decode: function(val) {
                return parseInt(val, 10);
              },
              is: function(val) {
                return predicates_1.isDefined(val) && this.decode(val.toString()) === val;
              },
              pattern: /-?\d+/
            },
            "bool": {
              encode: function(val) {
                return val && 1 || 0;
              },
              decode: function(val) {
                return parseInt(val, 10) !== 0;
              },
              is: hof_1.is(Boolean),
              pattern: /0|1/
            },
            "date": {
              encode: function(val) {
                return !this.is(val) ? undefined : [val.getFullYear(), ('0' + (val.getMonth() + 1)).slice(-2), ('0' + val.getDate()).slice(-2)].join("-");
              },
              decode: function(val) {
                if (this.is(val))
                  return val;
                var match = this.capture.exec(val);
                return match ? new Date(match[1], match[2] - 1, match[3]) : undefined;
              },
              is: function(val) {
                return val instanceof Date && !isNaN(val.valueOf());
              },
              equals: function(l, r) {
                return ['getFullYear', 'getMonth', 'getDate'].reduce(function(acc, fn) {
                  return acc && l[fn]() === r[fn]();
                }, true);
              },
              pattern: /[0-9]{4}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[1-2][0-9]|3[0-1])/,
              capture: /([0-9]{4})-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])/
            },
            "json": {
              encode: common_1.toJson,
              decode: common_1.fromJson,
              is: hof_1.is(Object),
              equals: common_1.equals,
              pattern: /[^/]*/
            },
            "any": {
              encode: common_1.identity,
              decode: common_1.identity,
              equals: common_1.equals,
              pattern: /.*/
            }
          };
          var makeType = function(definition, name) {
            return new type_1.ParamType(common_1.extend({name: name}, definition));
          };
          this.types = common_1.inherit(common_1.map(this.defaultTypes, makeType), {});
        }
        ParamTypes.prototype.type = function(name, definition, definitionFn) {
          if (!predicates_1.isDefined(definition))
            return this.types[name];
          if (this.types.hasOwnProperty(name))
            throw new Error("A type named '" + name + "' has already been defined.");
          this.types[name] = new type_1.ParamType(common_1.extend({name: name}, definition));
          if (definitionFn) {
            this.typeQueue.push({
              name: name,
              def: definitionFn
            });
            if (!this.enqueue)
              this._flushTypeQueue();
          }
          return this;
        };
        ParamTypes.prototype._flushTypeQueue = function() {
          while (this.typeQueue.length) {
            var type = this.typeQueue.shift();
            if (type.pattern)
              throw new Error("You cannot override a type's .pattern at runtime.");
            common_1.extend(this.types[type.name], coreservices_1.services.$injector.invoke(type.def));
          }
        };
        return ParamTypes;
      }());
      exports.ParamTypes = ParamTypes;
    }, function(module, exports, __webpack_require__) {
      "use strict";
      var common_1 = __webpack_require__(3);
      var predicates_1 = __webpack_require__(4);
      var coreservices_1 = __webpack_require__(6);
      var $location = coreservices_1.services.location;
      function regExpPrefix(re) {
        var prefix = /^\^((?:\\[^a-zA-Z0-9]|[^\\\[\]\^$*+?.()|{}]+)*)/.exec(re.source);
        return (prefix != null) ? prefix[1].replace(/\\(.)/g, "$1") : '';
      }
      function interpolate(pattern, match) {
        return pattern.replace(/\$(\$|\d{1,2})/, function(m, what) {
          return match[what === '$' ? 0 : Number(what)];
        });
      }
      function handleIfMatch($injector, $stateParams, handler, match) {
        if (!match)
          return false;
        var result = $injector.invoke(handler, handler, {
          $match: match,
          $stateParams: $stateParams
        });
        return predicates_1.isDefined(result) ? result : true;
      }
      function appendBasePath(url, isHtml5, absolute) {
        var baseHref = coreservices_1.services.locationConfig.baseHref();
        if (baseHref === '/')
          return url;
        if (isHtml5)
          return baseHref.slice(0, -1) + url;
        if (absolute)
          return baseHref.slice(1) + url;
        return url;
      }
      function update(rules, otherwiseFn, evt) {
        if (evt && evt.defaultPrevented)
          return;
        function check(rule) {
          var handled = rule(coreservices_1.services.$injector, $location);
          if (!handled)
            return false;
          if (predicates_1.isString(handled)) {
            $location.setUrl(handled, true);
          }
          return true;
        }
        var n = rules.length;
        for (var i = 0; i < n; i++) {
          if (check(rules[i]))
            return;
        }
        if (otherwiseFn)
          check(otherwiseFn);
      }
      var UrlRouterProvider = (function() {
        function UrlRouterProvider($urlMatcherFactory, $stateParams) {
          this.rules = [];
          this.interceptDeferred = false;
          this.$urlMatcherFactory = $urlMatcherFactory;
          this.$stateParams = $stateParams;
        }
        UrlRouterProvider.prototype.rule = function(rule) {
          if (!predicates_1.isFunction(rule))
            throw new Error("'rule' must be a function");
          this.rules.push(rule);
          return this;
        };
        ;
        UrlRouterProvider.prototype.removeRule = function(rule) {
          return this.rules.length !== common_1.removeFrom(this.rules, rule).length;
        };
        UrlRouterProvider.prototype.otherwise = function(rule) {
          if (!predicates_1.isFunction(rule) && !predicates_1.isString(rule))
            throw new Error("'rule' must be a string or function");
          this.otherwiseFn = predicates_1.isString(rule) ? function() {
            return rule;
          } : rule;
          return this;
        };
        ;
        UrlRouterProvider.prototype.when = function(what, handler, ruleCallback) {
          if (ruleCallback === void 0) {
            ruleCallback = function(rule) {};
          }
          var _a = this,
              $urlMatcherFactory = _a.$urlMatcherFactory,
              $stateParams = _a.$stateParams;
          var redirect,
              handlerIsString = predicates_1.isString(handler);
          if (predicates_1.isString(what))
            what = $urlMatcherFactory.compile(what);
          if (!handlerIsString && !predicates_1.isFunction(handler) && !predicates_1.isArray(handler))
            throw new Error("invalid 'handler' in when()");
          var strategies = {
            matcher: function(_what, _handler) {
              if (handlerIsString) {
                redirect = $urlMatcherFactory.compile(_handler);
                _handler = ['$match', redirect.format.bind(redirect)];
              }
              return common_1.extend(function() {
                return handleIfMatch(coreservices_1.services.$injector, $stateParams, _handler, _what.exec($location.path(), $location.search(), $location.hash()));
              }, {prefix: predicates_1.isString(_what.prefix) ? _what.prefix : ''});
            },
            regex: function(_what, _handler) {
              if (_what.global || _what.sticky)
                throw new Error("when() RegExp must not be global or sticky");
              if (handlerIsString) {
                redirect = _handler;
                _handler = ['$match', function($match) {
                  return interpolate(redirect, $match);
                }];
              }
              return common_1.extend(function() {
                return handleIfMatch(coreservices_1.services.$injector, $stateParams, _handler, _what.exec($location.path()));
              }, {prefix: regExpPrefix(_what)});
            }
          };
          var check = {
            matcher: $urlMatcherFactory.isMatcher(what),
            regex: what instanceof RegExp
          };
          for (var n in check) {
            if (check[n]) {
              var rule = strategies[n](what, handler);
              ruleCallback(rule);
              return this.rule(rule);
            }
          }
          throw new Error("invalid 'what' in when()");
        };
        ;
        UrlRouterProvider.prototype.deferIntercept = function(defer) {
          if (defer === undefined)
            defer = true;
          this.interceptDeferred = defer;
        };
        ;
        return UrlRouterProvider;
      }());
      exports.UrlRouterProvider = UrlRouterProvider;
      var UrlRouter = (function() {
        function UrlRouter(urlRouterProvider) {
          this.urlRouterProvider = urlRouterProvider;
          common_1.bindFunctions(UrlRouter.prototype, this, this);
        }
        UrlRouter.prototype.sync = function() {
          update(this.urlRouterProvider.rules, this.urlRouterProvider.otherwiseFn);
        };
        UrlRouter.prototype.listen = function() {
          var _this = this;
          return this.listener = this.listener || $location.onChange(function(evt) {
            return update(_this.urlRouterProvider.rules, _this.urlRouterProvider.otherwiseFn, evt);
          });
        };
        UrlRouter.prototype.update = function(read) {
          if (read) {
            this.location = $location.path();
            return;
          }
          if ($location.path() === this.location)
            return;
          $location.setUrl(this.location, true);
        };
        UrlRouter.prototype.push = function(urlMatcher, params, options) {
          var replace = options && !!options.replace;
          $location.setUrl(urlMatcher.format(params || {}), replace);
        };
        UrlRouter.prototype.href = function(urlMatcher, params, options) {
          if (!urlMatcher.validates(params))
            return null;
          var url = urlMatcher.format(params);
          options = options || {absolute: false};
          var cfg = coreservices_1.services.locationConfig;
          var isHtml5 = cfg.html5Mode();
          if (!isHtml5 && url !== null) {
            url = "#" + cfg.hashPrefix() + url;
          }
          url = appendBasePath(url, isHtml5, options.absolute);
          if (!options.absolute || !url) {
            return url;
          }
          var slash = (!isHtml5 && url ? '/' : ''),
              port = cfg.port();
          port = (port === 80 || port === 443 ? '' : ':' + port);
          return [cfg.protocol(), '://', cfg.host(), port, slash, url].join('');
        };
        return UrlRouter;
      }());
      exports.UrlRouter = UrlRouter;
    }, function(module, exports, __webpack_require__) {
      "use strict";
      var transition_1 = __webpack_require__(11);
      var hookRegistry_1 = __webpack_require__(15);
      var resolve_1 = __webpack_require__(31);
      var views_1 = __webpack_require__(32);
      var url_1 = __webpack_require__(33);
      var redirectTo_1 = __webpack_require__(34);
      var onEnterExitRetain_1 = __webpack_require__(35);
      var lazyLoadStates_1 = __webpack_require__(36);
      exports.defaultTransOpts = {
        location: true,
        relative: null,
        inherit: false,
        notify: true,
        reload: false,
        custom: {},
        current: function() {
          return null;
        },
        source: "unknown"
      };
      var TransitionService = (function() {
        function TransitionService(_router) {
          this._router = _router;
          this.$view = _router.viewService;
          hookRegistry_1.HookRegistry.mixin(new hookRegistry_1.HookRegistry(), this);
          this._deregisterHookFns = {};
          this.registerTransitionHooks();
        }
        TransitionService.prototype.registerTransitionHooks = function() {
          var fns = this._deregisterHookFns;
          fns.redirectTo = redirectTo_1.registerRedirectToHook(this);
          fns.onExit = onEnterExitRetain_1.registerOnExitHook(this);
          fns.onRetain = onEnterExitRetain_1.registerOnRetainHook(this);
          fns.onEnter = onEnterExitRetain_1.registerOnEnterHook(this);
          fns.eagerResolve = resolve_1.registerEagerResolvePath(this);
          fns.lazyResolve = resolve_1.registerLazyResolveState(this);
          fns.loadViews = views_1.registerLoadEnteringViews(this);
          fns.activateViews = views_1.registerActivateViews(this);
          fns.updateUrl = url_1.registerUpdateUrl(this);
          fns.lazyLoad = lazyLoadStates_1.registerLazyLoadHook(this);
        };
        TransitionService.prototype.onBefore = function(matchCriteria, callback, options) {
          throw "";
        };
        ;
        TransitionService.prototype.onStart = function(matchCriteria, callback, options) {
          throw "";
        };
        ;
        TransitionService.prototype.onExit = function(matchCriteria, callback, options) {
          throw "";
        };
        ;
        TransitionService.prototype.onRetain = function(matchCriteria, callback, options) {
          throw "";
        };
        ;
        TransitionService.prototype.onEnter = function(matchCriteria, callback, options) {
          throw "";
        };
        ;
        TransitionService.prototype.onFinish = function(matchCriteria, callback, options) {
          throw "";
        };
        ;
        TransitionService.prototype.onSuccess = function(matchCriteria, callback, options) {
          throw "";
        };
        ;
        TransitionService.prototype.onError = function(matchCriteria, callback, options) {
          throw "";
        };
        ;
        TransitionService.prototype.create = function(fromPath, targetState) {
          return new transition_1.Transition(fromPath, targetState, this._router);
        };
        return TransitionService;
      }());
      exports.TransitionService = TransitionService;
    }, function(module, exports, __webpack_require__) {
      "use strict";
      var common_1 = __webpack_require__(3);
      var resolveContext_1 = __webpack_require__(17);
      var hof_1 = __webpack_require__(5);
      var eagerResolvePath = function(trans) {
        return new resolveContext_1.ResolveContext(trans.treeChanges().to).resolvePath("EAGER", trans).then(common_1.noop);
      };
      exports.registerEagerResolvePath = function(transitionService) {
        return transitionService.onStart({}, eagerResolvePath, {priority: 1000});
      };
      var lazyResolveState = function(trans, state) {
        return new resolveContext_1.ResolveContext(trans.treeChanges().to).subContext(state).resolvePath("LAZY", trans).then(common_1.noop);
      };
      exports.registerLazyResolveState = function(transitionService) {
        return transitionService.onEnter({entering: hof_1.val(true)}, lazyResolveState, {priority: 1000});
      };
    }, function(module, exports, __webpack_require__) {
      "use strict";
      var common_1 = __webpack_require__(3);
      var coreservices_1 = __webpack_require__(6);
      var loadEnteringViews = function(transition) {
        var enteringViews = transition.views("entering");
        if (!enteringViews.length)
          return;
        return coreservices_1.services.$q.all(enteringViews.map(function(view) {
          return view.load();
        })).then(common_1.noop);
      };
      exports.registerLoadEnteringViews = function(transitionService) {
        return transitionService.onStart({}, loadEnteringViews);
      };
      var activateViews = function(transition) {
        var enteringViews = transition.views("entering");
        var exitingViews = transition.views("exiting");
        if (!enteringViews.length && !exitingViews.length)
          return;
        var $view = transition.router.viewService;
        exitingViews.forEach(function(vc) {
          return $view.deactivateViewConfig(vc);
        });
        enteringViews.forEach(function(vc) {
          return $view.activateViewConfig(vc);
        });
        $view.sync();
      };
      exports.registerActivateViews = function(transitionService) {
        return transitionService.onSuccess({}, activateViews);
      };
    }, function(module, exports) {
      "use strict";
      var updateUrl = function(transition) {
        var options = transition.options();
        var $state = transition.router.stateService;
        var $urlRouter = transition.router.urlRouter;
        if (options.source !== 'url' && options.location && $state.$current.navigable) {
          var urlOptions = {replace: options.location === 'replace'};
          $urlRouter.push($state.$current.navigable.url, $state.params, urlOptions);
        }
        $urlRouter.update(true);
      };
      exports.registerUpdateUrl = function(transitionService) {
        return transitionService.onSuccess({}, updateUrl, {priority: 9999});
      };
    }, function(module, exports, __webpack_require__) {
      "use strict";
      var predicates_1 = __webpack_require__(4);
      var coreservices_1 = __webpack_require__(6);
      var targetState_1 = __webpack_require__(14);
      var redirectToHook = function(trans) {
        var redirect = trans.to().redirectTo;
        if (!redirect)
          return;
        function handleResult(result) {
          var $state = trans.router.stateService;
          if (result instanceof targetState_1.TargetState)
            return result;
          if (predicates_1.isString(result))
            return $state.target(result, trans.params(), trans.options());
          if (result['state'] || result['params'])
            return $state.target(result['state'] || trans.to(), result['params'] || trans.params(), trans.options());
        }
        if (predicates_1.isFunction(redirect)) {
          return coreservices_1.services.$q.when(redirect(trans)).then(handleResult);
        }
        return handleResult(redirect);
      };
      exports.registerRedirectToHook = function(transitionService) {
        return transitionService.onStart({to: function(state) {
            return !!state.redirectTo;
          }}, redirectToHook);
      };
    }, function(module, exports) {
      "use strict";
      function makeEnterExitRetainHook(hookName) {
        return function(transition, state) {
          var hookFn = state[hookName];
          return hookFn(transition, state);
        };
      }
      var onExitHook = makeEnterExitRetainHook('onExit');
      exports.registerOnExitHook = function(transitionService) {
        return transitionService.onExit({exiting: function(state) {
            return !!state.onExit;
          }}, onExitHook);
      };
      var onRetainHook = makeEnterExitRetainHook('onRetain');
      exports.registerOnRetainHook = function(transitionService) {
        return transitionService.onRetain({retained: function(state) {
            return !!state.onRetain;
          }}, onRetainHook);
      };
      var onEnterHook = makeEnterExitRetainHook('onEnter');
      exports.registerOnEnterHook = function(transitionService) {
        return transitionService.onEnter({entering: function(state) {
            return !!state.onEnter;
          }}, onEnterHook);
      };
    }, function(module, exports, __webpack_require__) {
      "use strict";
      var coreservices_1 = __webpack_require__(6);
      var lazyLoadHook = function(transition) {
        var toState = transition.to();
        var registry = transition.router.stateRegistry;
        function retryOriginalTransition() {
          if (transition.options().source === 'url') {
            var loc = coreservices_1.services.location,
                path_1 = loc.path(),
                search_1 = loc.search(),
                hash_1 = loc.hash();
            var matchState = function(state) {
              return [state, state.url && state.url.exec(path_1, search_1, hash_1)];
            };
            var matches = registry.get().map(function(s) {
              return s.$$state();
            }).map(matchState).filter(function(_a) {
              var state = _a[0],
                  params = _a[1];
              return !!params;
            });
            if (matches.length) {
              var _a = matches[0],
                  state = _a[0],
                  params = _a[1];
              return transition.router.stateService.target(state, params, transition.options());
            }
            transition.router.urlRouter.sync();
          }
          var orig = transition.targetState();
          return transition.router.stateService.target(orig.identifier(), orig.params(), orig.options());
        }
        function updateStateRegistry(result) {
          registry.deregister(transition.$to());
          if (result && Array.isArray(result.states)) {
            result.states.forEach(function(state) {
              return registry.register(state);
            });
          }
        }
        var hook = toState.lazyLoad;
        var promise = hook['_promise'];
        if (!promise) {
          promise = hook['_promise'] = hook(transition).then(updateStateRegistry);
          var cleanup = function() {
            return delete hook['_promise'];
          };
          promise.then(cleanup, cleanup);
        }
        return promise.then(retryOriginalTransition);
      };
      exports.registerLazyLoadHook = function(transitionService) {
        return transitionService.onBefore({to: function(state) {
            return !!state.lazyLoad;
          }}, lazyLoadHook);
      };
    }, function(module, exports, __webpack_require__) {
      "use strict";
      var common_1 = __webpack_require__(3);
      var hof_1 = __webpack_require__(5);
      var predicates_1 = __webpack_require__(4);
      var trace_1 = __webpack_require__(12);
      var ViewService = (function() {
        function ViewService() {
          var _this = this;
          this.uiViews = [];
          this.viewConfigs = [];
          this._viewConfigFactories = {};
          this.sync = function() {
            var uiViewsByFqn = _this.uiViews.map(function(uiv) {
              return [uiv.fqn, uiv];
            }).reduce(common_1.applyPairs, {});
            var matches = function(uiView) {
              return function(viewConfig) {
                if (uiView.$type !== viewConfig.viewDecl.$type)
                  return false;
                var vc = viewConfig.viewDecl;
                var vcSegments = vc.$uiViewName.split(".");
                var uivSegments = uiView.fqn.split(".");
                if (!common_1.equals(vcSegments, uivSegments.slice(0 - vcSegments.length)))
                  return false;
                var negOffset = (1 - vcSegments.length) || undefined;
                var fqnToFirstSegment = uivSegments.slice(0, negOffset).join(".");
                var uiViewContext = uiViewsByFqn[fqnToFirstSegment].creationContext;
                return vc.$uiViewContextAnchor === (uiViewContext && uiViewContext.name);
              };
            };
            function uiViewDepth(uiView) {
              return uiView.fqn.split(".").length;
            }
            function viewConfigDepth(config) {
              var context = config.viewDecl.$context,
                  count = 0;
              while (++count && context.parent)
                context = context.parent;
              return count;
            }
            var depthCompare = hof_1.curry(function(depthFn, posNeg, left, right) {
              return posNeg * (depthFn(left) - depthFn(right));
            });
            var matchingConfigPair = function(uiView) {
              var matchingConfigs = _this.viewConfigs.filter(matches(uiView));
              if (matchingConfigs.length > 1)
                matchingConfigs.sort(depthCompare(viewConfigDepth, -1));
              return [uiView, matchingConfigs[0]];
            };
            var configureUIView = function(_a) {
              var uiView = _a[0],
                  viewConfig = _a[1];
              if (_this.uiViews.indexOf(uiView) !== -1)
                uiView.configUpdated(viewConfig);
            };
            _this.uiViews.sort(depthCompare(uiViewDepth, 1)).map(matchingConfigPair).forEach(configureUIView);
          };
        }
        ViewService.prototype.rootContext = function(context) {
          return this._rootContext = context || this._rootContext;
        };
        ;
        ViewService.prototype.viewConfigFactory = function(viewType, factory) {
          this._viewConfigFactories[viewType] = factory;
        };
        ViewService.prototype.createViewConfig = function(path, decl) {
          var cfgFactory = this._viewConfigFactories[decl.$type];
          if (!cfgFactory)
            throw new Error("ViewService: No view config factory registered for type " + decl.$type);
          var cfgs = cfgFactory(path, decl);
          return predicates_1.isArray(cfgs) ? cfgs : [cfgs];
        };
        ViewService.prototype.deactivateViewConfig = function(viewConfig) {
          trace_1.trace.traceViewServiceEvent("<- Removing", viewConfig);
          common_1.removeFrom(this.viewConfigs, viewConfig);
        };
        ;
        ViewService.prototype.activateViewConfig = function(viewConfig) {
          trace_1.trace.traceViewServiceEvent("-> Registering", viewConfig);
          this.viewConfigs.push(viewConfig);
        };
        ;
        ViewService.prototype.registerUIView = function(uiView) {
          trace_1.trace.traceViewServiceUIViewEvent("-> Registering", uiView);
          var uiViews = this.uiViews;
          var fqnMatches = function(uiv) {
            return uiv.fqn === uiView.fqn;
          };
          if (uiViews.filter(fqnMatches).length)
            trace_1.trace.traceViewServiceUIViewEvent("!!!! duplicate uiView named:", uiView);
          uiViews.push(uiView);
          this.sync();
          return function() {
            var idx = uiViews.indexOf(uiView);
            if (idx === -1) {
              trace_1.trace.traceViewServiceUIViewEvent("Tried removing non-registered uiView", uiView);
              return;
            }
            trace_1.trace.traceViewServiceUIViewEvent("<- Deregistering", uiView);
            common_1.removeFrom(uiViews)(uiView);
          };
        };
        ;
        ViewService.prototype.available = function() {
          return this.uiViews.map(hof_1.prop("fqn"));
        };
        ViewService.prototype.active = function() {
          return this.uiViews.filter(hof_1.prop("$config")).map(hof_1.prop("name"));
        };
        ViewService.normalizeUIViewTarget = function(context, rawViewName) {
          if (rawViewName === void 0) {
            rawViewName = "";
          }
          var viewAtContext = rawViewName.split("@");
          var uiViewName = viewAtContext[0] || "$default";
          var uiViewContextAnchor = predicates_1.isString(viewAtContext[1]) ? viewAtContext[1] : "^";
          var relativeViewNameSugar = /^(\^(?:\.\^)*)\.(.*$)/.exec(uiViewName);
          if (relativeViewNameSugar) {
            uiViewContextAnchor = relativeViewNameSugar[1];
            uiViewName = relativeViewNameSugar[2];
          }
          if (uiViewName.charAt(0) === '!') {
            uiViewName = uiViewName.substr(1);
            uiViewContextAnchor = "";
          }
          var relativeMatch = /^(\^(?:\.\^)*)$/;
          if (relativeMatch.exec(uiViewContextAnchor)) {
            var anchor = uiViewContextAnchor.split(".").reduce((function(anchor, x) {
              return anchor.parent;
            }), context);
            uiViewContextAnchor = anchor.name;
          }
          return {
            uiViewName: uiViewName,
            uiViewContextAnchor: uiViewContextAnchor
          };
        };
        return ViewService;
      }());
      exports.ViewService = ViewService;
    }, function(module, exports, __webpack_require__) {
      "use strict";
      var stateMatcher_1 = __webpack_require__(39);
      var stateBuilder_1 = __webpack_require__(40);
      var stateQueueManager_1 = __webpack_require__(41);
      var common_1 = __webpack_require__(3);
      var StateRegistry = (function() {
        function StateRegistry(urlMatcherFactory, urlRouterProvider) {
          this.urlRouterProvider = urlRouterProvider;
          this.states = {};
          this.listeners = [];
          this.matcher = new stateMatcher_1.StateMatcher(this.states);
          this.builder = new stateBuilder_1.StateBuilder(this.matcher, urlMatcherFactory);
          this.stateQueue = new stateQueueManager_1.StateQueueManager(this.states, this.builder, urlRouterProvider, this.listeners);
          var rootStateDef = {
            name: '',
            url: '^',
            views: null,
            params: {'#': {
                value: null,
                type: 'hash',
                dynamic: true
              }},
            abstract: true
          };
          var _root = this._root = this.stateQueue.register(rootStateDef);
          _root.navigable = null;
        }
        StateRegistry.prototype.onStatesChanged = function(listener) {
          this.listeners.push(listener);
          return function deregisterListener() {
            common_1.removeFrom(this.listeners)(listener);
          }.bind(this);
        };
        StateRegistry.prototype.root = function() {
          return this._root;
        };
        StateRegistry.prototype.register = function(stateDefinition) {
          return this.stateQueue.register(stateDefinition);
        };
        StateRegistry.prototype._deregisterTree = function(state) {
          var _this = this;
          var all = this.get().map(function(s) {
            return s.$$state();
          });
          var getChildren = function(states) {
            var children = all.filter(function(s) {
              return states.indexOf(s.parent) !== -1;
            });
            return children.length === 0 ? children : children.concat(getChildren(children));
          };
          var children = getChildren([state]);
          var deregistered = [state].concat(children).reverse();
          deregistered.forEach(function(state) {
            _this.urlRouterProvider.removeRule(state._urlRule);
            delete _this.states[state.name];
          });
          return deregistered;
        };
        StateRegistry.prototype.deregister = function(stateOrName) {
          var _state = this.get(stateOrName);
          if (!_state)
            throw new Error("Can't deregister state; not found: " + stateOrName);
          var deregisteredStates = this._deregisterTree(_state.$$state());
          this.listeners.forEach(function(listener) {
            return listener("deregistered", deregisteredStates.map(function(s) {
              return s.self;
            }));
          });
          return deregisteredStates;
        };
        StateRegistry.prototype.get = function(stateOrName, base) {
          var _this = this;
          if (arguments.length === 0)
            return Object.keys(this.states).map(function(name) {
              return _this.states[name].self;
            });
          var found = this.matcher.find(stateOrName, base);
          return found && found.self || null;
        };
        StateRegistry.prototype.decorator = function(name, func) {
          return this.builder.builder(name, func);
        };
        return StateRegistry;
      }());
      exports.StateRegistry = StateRegistry;
    }, function(module, exports, __webpack_require__) {
      "use strict";
      var predicates_1 = __webpack_require__(4);
      var glob_1 = __webpack_require__(7);
      var common_1 = __webpack_require__(3);
      var StateMatcher = (function() {
        function StateMatcher(_states) {
          this._states = _states;
        }
        StateMatcher.prototype.isRelative = function(stateName) {
          stateName = stateName || "";
          return stateName.indexOf(".") === 0 || stateName.indexOf("^") === 0;
        };
        StateMatcher.prototype.find = function(stateOrName, base) {
          if (!stateOrName && stateOrName !== "")
            return undefined;
          var isStr = predicates_1.isString(stateOrName);
          var name = isStr ? stateOrName : stateOrName.name;
          if (this.isRelative(name))
            name = this.resolvePath(name, base);
          var state = this._states[name];
          if (state && (isStr || (!isStr && (state === stateOrName || state.self === stateOrName)))) {
            return state;
          } else if (isStr) {
            var matches = common_1.values(this._states).filter(function(state) {
              return new glob_1.Glob(state.name).matches(name);
            });
            if (matches.length > 1) {
              console.log("stateMatcher.find: Found multiple matches for " + name + " using glob: ", matches.map(function(match) {
                return match.name;
              }));
            }
            return matches[0];
          }
          return undefined;
        };
        StateMatcher.prototype.resolvePath = function(name, base) {
          if (!base)
            throw new Error("No reference point given for path '" + name + "'");
          var baseState = this.find(base);
          var splitName = name.split("."),
              i = 0,
              pathLength = splitName.length,
              current = baseState;
          for (; i < pathLength; i++) {
            if (splitName[i] === "" && i === 0) {
              current = baseState;
              continue;
            }
            if (splitName[i] === "^") {
              if (!current.parent)
                throw new Error("Path '" + name + "' not valid for state '" + baseState.name + "'");
              current = current.parent;
              continue;
            }
            break;
          }
          var relName = splitName.slice(i).join(".");
          return current.name + (current.name && relName ? "." : "") + relName;
        };
        return StateMatcher;
      }());
      exports.StateMatcher = StateMatcher;
    }, function(module, exports, __webpack_require__) {
      "use strict";
      var common_1 = __webpack_require__(3);
      var predicates_1 = __webpack_require__(4);
      var strings_1 = __webpack_require__(9);
      var hof_1 = __webpack_require__(5);
      var param_1 = __webpack_require__(22);
      var resolvable_1 = __webpack_require__(19);
      var coreservices_1 = __webpack_require__(6);
      var parseUrl = function(url) {
        if (!predicates_1.isString(url))
          return false;
        var root = url.charAt(0) === '^';
        return {
          val: root ? url.substring(1) : url,
          root: root
        };
      };
      function nameBuilder(state) {
        if (state.lazyLoad)
          state.name = state.self.name + ".**";
        return state.name;
      }
      function selfBuilder(state) {
        state.self.$$state = function() {
          return state;
        };
        return state.self;
      }
      function dataBuilder(state) {
        if (state.parent && state.parent.data) {
          state.data = state.self.data = common_1.inherit(state.parent.data, state.data);
        }
        return state.data;
      }
      var getUrlBuilder = function($urlMatcherFactoryProvider, root) {
        return function urlBuilder(state) {
          var stateDec = state;
          if (stateDec && stateDec.url && stateDec.lazyLoad) {
            stateDec.url += "{remainder:any}";
          }
          var parsed = parseUrl(stateDec.url),
              parent = state.parent;
          var url = !parsed ? stateDec.url : $urlMatcherFactoryProvider.compile(parsed.val, {
            params: state.params || {},
            paramMap: function(paramConfig, isSearch) {
              if (stateDec.reloadOnSearch === false && isSearch)
                paramConfig = common_1.extend(paramConfig || {}, {dynamic: true});
              return paramConfig;
            }
          });
          if (!url)
            return null;
          if (!$urlMatcherFactoryProvider.isMatcher(url))
            throw new Error("Invalid url '" + url + "' in state '" + state + "'");
          return (parsed && parsed.root) ? url : ((parent && parent.navigable) || root()).url.append(url);
        };
      };
      var getNavigableBuilder = function(isRoot) {
        return function navigableBuilder(state) {
          return !isRoot(state) && state.url ? state : (state.parent ? state.parent.navigable : null);
        };
      };
      var getParamsBuilder = function(paramTypes) {
        return function paramsBuilder(state) {
          var makeConfigParam = function(config, id) {
            return param_1.Param.fromConfig(id, null, config, paramTypes);
          };
          var urlParams = (state.url && state.url.parameters({inherit: false})) || [];
          var nonUrlParams = common_1.values(common_1.mapObj(common_1.omit(state.params || {}, urlParams.map(hof_1.prop('id'))), makeConfigParam));
          return urlParams.concat(nonUrlParams).map(function(p) {
            return [p.id, p];
          }).reduce(common_1.applyPairs, {});
        };
      };
      function pathBuilder(state) {
        return state.parent ? state.parent.path.concat(state) : [state];
      }
      function includesBuilder(state) {
        var includes = state.parent ? common_1.extend({}, state.parent.includes) : {};
        includes[state.name] = true;
        return includes;
      }
      function resolvablesBuilder(state) {
        var objects2Tuples = function(resolveObj, resolvePolicies) {
          return Object.keys(resolveObj || {}).map(function(token) {
            return ({
              token: token,
              val: resolveObj[token],
              deps: undefined,
              policy: resolvePolicies[token]
            });
          });
        };
        var annotate = function(fn) {
          return fn['$inject'] || coreservices_1.services.$injector.annotate(fn, coreservices_1.services.$injector.strictDi);
        };
        var isResolveLiteral = function(obj) {
          return !!(obj.token && obj.resolveFn);
        };
        var isLikeNg2Provider = function(obj) {
          return !!((obj.provide || obj.token) && (obj.useValue || obj.useFactory || obj.useExisting || obj.useClass));
        };
        var isTupleFromObj = function(obj) {
          return !!(obj && obj.val && (predicates_1.isString(obj.val) || predicates_1.isArray(obj.val) || predicates_1.isFunction(obj.val)));
        };
        var token = function(p) {
          return p.provide || p.token;
        };
        var literal2Resolvable = hof_1.pattern([[hof_1.prop('resolveFn'), function(p) {
          return new resolvable_1.Resolvable(token(p), p.resolveFn, p.deps, p.policy);
        }], [hof_1.prop('useFactory'), function(p) {
          return new resolvable_1.Resolvable(token(p), p.useFactory, (p.deps || p.dependencies), p.policy);
        }], [hof_1.prop('useClass'), function(p) {
          return new resolvable_1.Resolvable(token(p), function() {
            return new p.useClass();
          }, [], p.policy);
        }], [hof_1.prop('useValue'), function(p) {
          return new resolvable_1.Resolvable(token(p), function() {
            return p.useValue;
          }, [], p.policy, p.useValue);
        }], [hof_1.prop('useExisting'), function(p) {
          return new resolvable_1.Resolvable(token(p), common_1.identity, [p.useExisting], p.policy);
        }]]);
        var tuple2Resolvable = hof_1.pattern([[hof_1.pipe(hof_1.prop("val"), predicates_1.isString), function(tuple) {
          return new resolvable_1.Resolvable(tuple.token, common_1.identity, [tuple.val], tuple.policy);
        }], [hof_1.pipe(hof_1.prop("val"), predicates_1.isArray), function(tuple) {
          return new resolvable_1.Resolvable(tuple.token, common_1.tail(tuple.val), tuple.val.slice(0, -1), tuple.policy);
        }], [hof_1.pipe(hof_1.prop("val"), predicates_1.isFunction), function(tuple) {
          return new resolvable_1.Resolvable(tuple.token, tuple.val, annotate(tuple.val), tuple.policy);
        }]]);
        var item2Resolvable = hof_1.pattern([[hof_1.is(resolvable_1.Resolvable), function(r) {
          return r;
        }], [isResolveLiteral, literal2Resolvable], [isLikeNg2Provider, literal2Resolvable], [isTupleFromObj, tuple2Resolvable], [hof_1.val(true), function(obj) {
          throw new Error("Invalid resolve value: " + strings_1.stringify(obj));
        }]]);
        var decl = state.resolve;
        var items = predicates_1.isArray(decl) ? decl : objects2Tuples(decl, state.resolvePolicy || {});
        return items.map(item2Resolvable);
      }
      exports.resolvablesBuilder = resolvablesBuilder;
      var StateBuilder = (function() {
        function StateBuilder(matcher, $urlMatcherFactoryProvider) {
          this.matcher = matcher;
          var self = this;
          var root = function() {
            return matcher.find("");
          };
          var isRoot = function(state) {
            return state.name === "";
          };
          function parentBuilder(state) {
            if (isRoot(state))
              return null;
            return matcher.find(self.parentName(state)) || root();
          }
          this.builders = {
            name: [nameBuilder],
            self: [selfBuilder],
            parent: [parentBuilder],
            data: [dataBuilder],
            url: [getUrlBuilder($urlMatcherFactoryProvider, root)],
            navigable: [getNavigableBuilder(isRoot)],
            params: [getParamsBuilder($urlMatcherFactoryProvider.paramTypes)],
            views: [],
            path: [pathBuilder],
            includes: [includesBuilder],
            resolvables: [resolvablesBuilder]
          };
        }
        StateBuilder.prototype.builder = function(name, fn) {
          var builders = this.builders;
          var array = builders[name] || [];
          if (predicates_1.isString(name) && !predicates_1.isDefined(fn))
            return array.length > 1 ? array : array[0];
          if (!predicates_1.isString(name) || !predicates_1.isFunction(fn))
            return;
          builders[name] = array;
          builders[name].push(fn);
          return function() {
            return builders[name].splice(builders[name].indexOf(fn, 1)) && null;
          };
        };
        StateBuilder.prototype.build = function(state) {
          var _a = this,
              matcher = _a.matcher,
              builders = _a.builders;
          var parent = this.parentName(state);
          if (parent && !matcher.find(parent))
            return null;
          for (var key in builders) {
            if (!builders.hasOwnProperty(key))
              continue;
            var chain = builders[key].reduce(function(parentFn, step) {
              return function(_state) {
                return step(_state, parentFn);
              };
            }, common_1.noop);
            state[key] = chain(state);
          }
          return state;
        };
        StateBuilder.prototype.parentName = function(state) {
          var name = state.name || "";
          var segments = name.split('.');
          if (segments.length > 1) {
            if (state.parent) {
              throw new Error("States that specify the 'parent:' property should not have a '.' in their name (" + name + ")");
            }
            var lastSegment = segments.pop();
            if (lastSegment === '**')
              segments.pop();
            return segments.join(".");
          }
          if (!state.parent)
            return "";
          return predicates_1.isString(state.parent) ? state.parent : state.parent.name;
        };
        StateBuilder.prototype.name = function(state) {
          var name = state.name;
          if (name.indexOf('.') !== -1 || !state.parent)
            return name;
          var parentName = predicates_1.isString(state.parent) ? state.parent : state.parent.name;
          return parentName ? parentName + "." + name : name;
        };
        return StateBuilder;
      }());
      exports.StateBuilder = StateBuilder;
    }, function(module, exports, __webpack_require__) {
      "use strict";
      var common_1 = __webpack_require__(3);
      var predicates_1 = __webpack_require__(4);
      var stateObject_1 = __webpack_require__(42);
      var StateQueueManager = (function() {
        function StateQueueManager(states, builder, $urlRouterProvider, listeners) {
          this.states = states;
          this.builder = builder;
          this.$urlRouterProvider = $urlRouterProvider;
          this.listeners = listeners;
          this.queue = [];
        }
        StateQueueManager.prototype.register = function(config) {
          var _a = this,
              states = _a.states,
              queue = _a.queue,
              $state = _a.$state;
          var state = common_1.inherit(new stateObject_1.State(), common_1.extend({}, config, {
            self: config,
            resolve: config.resolve || [],
            toString: function() {
              return config.name;
            }
          }));
          if (!predicates_1.isString(state.name))
            throw new Error("State must have a valid name");
          if (states.hasOwnProperty(state.name) || common_1.pluck(queue, 'name').indexOf(state.name) !== -1)
            throw new Error("State '" + state.name + "' is already defined");
          queue.push(state);
          if (this.$state) {
            this.flush($state);
          }
          return state;
        };
        StateQueueManager.prototype.flush = function($state) {
          var _a = this,
              queue = _a.queue,
              states = _a.states,
              builder = _a.builder;
          var registered = [],
              orphans = [],
              previousQueueLength = {};
          while (queue.length > 0) {
            var state = queue.shift();
            var result = builder.build(state);
            var orphanIdx = orphans.indexOf(state);
            if (result) {
              if (states.hasOwnProperty(state.name))
                throw new Error("State '" + name + "' is already defined");
              states[state.name] = state;
              this.attachRoute($state, state);
              if (orphanIdx >= 0)
                orphans.splice(orphanIdx, 1);
              registered.push(state);
              continue;
            }
            var prev = previousQueueLength[state.name];
            previousQueueLength[state.name] = queue.length;
            if (orphanIdx >= 0 && prev === queue.length) {
              queue.push(state);
              return states;
            } else if (orphanIdx < 0) {
              orphans.push(state);
            }
            queue.push(state);
          }
          if (registered.length) {
            this.listeners.forEach(function(listener) {
              return listener("registered", registered.map(function(s) {
                return s.self;
              }));
            });
          }
          return states;
        };
        StateQueueManager.prototype.autoFlush = function($state) {
          this.$state = $state;
          this.flush($state);
        };
        StateQueueManager.prototype.attachRoute = function($state, state) {
          var $urlRouterProvider = this.$urlRouterProvider;
          if (state.abstract || !state.url)
            return;
          $urlRouterProvider.when(state.url, ['$match', '$stateParams', function($match, $stateParams) {
            if ($state.$current.navigable !== state || !common_1.equalForKeys($match, $stateParams)) {
              $state.transitionTo(state, $match, {
                inherit: true,
                source: "url"
              });
            }
          }], function(rule) {
            return state._urlRule = rule;
          });
        };
        return StateQueueManager;
      }());
      exports.StateQueueManager = StateQueueManager;
    }, function(module, exports, __webpack_require__) {
      "use strict";
      var common_1 = __webpack_require__(3);
      var hof_1 = __webpack_require__(5);
      var State = (function() {
        function State(config) {
          common_1.extend(this, config);
        }
        State.prototype.is = function(ref) {
          return this === ref || this.self === ref || this.fqn() === ref;
        };
        State.prototype.fqn = function() {
          if (!this.parent || !(this.parent instanceof this.constructor))
            return this.name;
          var name = this.parent.fqn();
          return name ? name + "." + this.name : this.name;
        };
        State.prototype.root = function() {
          return this.parent && this.parent.root() || this;
        };
        State.prototype.parameters = function(opts) {
          opts = common_1.defaults(opts, {inherit: true});
          var inherited = opts.inherit && this.parent && this.parent.parameters() || [];
          return inherited.concat(common_1.values(this.params));
        };
        State.prototype.parameter = function(id, opts) {
          if (opts === void 0) {
            opts = {};
          }
          return (this.url && this.url.parameter(id, opts) || common_1.find(common_1.values(this.params), hof_1.propEq('id', id)) || opts.inherit && this.parent && this.parent.parameter(id));
        };
        State.prototype.toString = function() {
          return this.fqn();
        };
        return State;
      }());
      exports.State = State;
    }, function(module, exports, __webpack_require__) {
      "use strict";
      var common_1 = __webpack_require__(3);
      var predicates_1 = __webpack_require__(4);
      var queue_1 = __webpack_require__(8);
      var coreservices_1 = __webpack_require__(6);
      var pathFactory_1 = __webpack_require__(20);
      var node_1 = __webpack_require__(21);
      var transitionService_1 = __webpack_require__(30);
      var rejectFactory_1 = __webpack_require__(10);
      var targetState_1 = __webpack_require__(14);
      var param_1 = __webpack_require__(22);
      var glob_1 = __webpack_require__(7);
      var common_2 = __webpack_require__(3);
      var common_3 = __webpack_require__(3);
      var resolveContext_1 = __webpack_require__(17);
      var StateService = (function() {
        function StateService(router) {
          this.router = router;
          this.invalidCallbacks = [];
          this._defaultErrorHandler = function $defaultErrorHandler($error$) {
            if ($error$ instanceof Error && $error$.stack) {
              console.error($error$);
              console.error($error$.stack);
            } else if ($error$ instanceof rejectFactory_1.Rejection) {
              console.error($error$.toString());
              if ($error$.detail && $error$.detail.stack)
                console.error($error$.detail.stack);
            } else {
              console.error($error$);
            }
          };
          var getters = ['current', '$current', 'params', 'transition'];
          var boundFns = Object.keys(StateService.prototype).filter(function(key) {
            return getters.indexOf(key) === -1;
          });
          common_3.bindFunctions(StateService.prototype, this, this, boundFns);
        }
        Object.defineProperty(StateService.prototype, "transition", {
          get: function() {
            return this.router.globals.transition;
          },
          enumerable: true,
          configurable: true
        });
        Object.defineProperty(StateService.prototype, "params", {
          get: function() {
            return this.router.globals.params;
          },
          enumerable: true,
          configurable: true
        });
        Object.defineProperty(StateService.prototype, "current", {
          get: function() {
            return this.router.globals.current;
          },
          enumerable: true,
          configurable: true
        });
        Object.defineProperty(StateService.prototype, "$current", {
          get: function() {
            return this.router.globals.$current;
          },
          enumerable: true,
          configurable: true
        });
        StateService.prototype._handleInvalidTargetState = function(fromPath, toState) {
          var _this = this;
          var fromState = pathFactory_1.PathFactory.makeTargetState(fromPath);
          var globals = this.router.globals;
          var latestThing = function() {
            return globals.transitionHistory.peekTail();
          };
          var latest = latestThing();
          var callbackQueue = new queue_1.Queue(this.invalidCallbacks.slice());
          var injector = new resolveContext_1.ResolveContext(fromPath).injector();
          var checkForRedirect = function(result) {
            if (!(result instanceof targetState_1.TargetState)) {
              return;
            }
            var target = result;
            target = _this.target(target.identifier(), target.params(), target.options());
            if (!target.valid())
              return rejectFactory_1.Rejection.invalid(target.error()).toPromise();
            if (latestThing() !== latest)
              return rejectFactory_1.Rejection.superseded().toPromise();
            return _this.transitionTo(target.identifier(), target.params(), target.options());
          };
          function invokeNextCallback() {
            var nextCallback = callbackQueue.dequeue();
            if (nextCallback === undefined)
              return rejectFactory_1.Rejection.invalid(toState.error()).toPromise();
            var callbackResult = coreservices_1.services.$q.when(nextCallback(toState, fromState, injector));
            return callbackResult.then(checkForRedirect).then(function(result) {
              return result || invokeNextCallback();
            });
          }
          return invokeNextCallback();
        };
        StateService.prototype.onInvalid = function(callback) {
          this.invalidCallbacks.push(callback);
          return function deregisterListener() {
            common_1.removeFrom(this.invalidCallbacks)(callback);
          }.bind(this);
        };
        StateService.prototype.reload = function(reloadState) {
          return this.transitionTo(this.current, this.params, {
            reload: predicates_1.isDefined(reloadState) ? reloadState : true,
            inherit: false,
            notify: false
          });
        };
        ;
        StateService.prototype.go = function(to, params, options) {
          var defautGoOpts = {
            relative: this.$current,
            inherit: true
          };
          var transOpts = common_1.defaults(options, defautGoOpts, transitionService_1.defaultTransOpts);
          return this.transitionTo(to, params, transOpts);
        };
        ;
        StateService.prototype.target = function(identifier, params, options) {
          if (options === void 0) {
            options = {};
          }
          if (predicates_1.isObject(options.reload) && !options.reload.name)
            throw new Error('Invalid reload state object');
          var reg = this.router.stateRegistry;
          options.reloadState = options.reload === true ? reg.root() : reg.matcher.find(options.reload, options.relative);
          if (options.reload && !options.reloadState)
            throw new Error("No such reload state '" + (predicates_1.isString(options.reload) ? options.reload : options.reload.name) + "'");
          var stateDefinition = reg.matcher.find(identifier, options.relative);
          return new targetState_1.TargetState(identifier, stateDefinition, params, options);
        };
        ;
        StateService.prototype.transitionTo = function(to, toParams, options) {
          var _this = this;
          if (toParams === void 0) {
            toParams = {};
          }
          if (options === void 0) {
            options = {};
          }
          var router = this.router;
          var globals = router.globals;
          var transHistory = globals.transitionHistory;
          options = common_1.defaults(options, transitionService_1.defaultTransOpts);
          options = common_1.extend(options, {current: transHistory.peekTail.bind(transHistory)});
          var ref = this.target(to, toParams, options);
          var latestSuccess = globals.successfulTransitions.peekTail();
          var rootPath = function() {
            return [new node_1.PathNode(_this.router.stateRegistry.root())];
          };
          var currentPath = latestSuccess ? latestSuccess.treeChanges().to : rootPath();
          if (!ref.exists())
            return this._handleInvalidTargetState(currentPath, ref);
          if (!ref.valid())
            return common_1.silentRejection(ref.error());
          var rejectedTransitionHandler = function(transition) {
            return function(error) {
              if (error instanceof rejectFactory_1.Rejection) {
                if (error.type === rejectFactory_1.RejectType.IGNORED) {
                  router.urlRouter.update();
                  return coreservices_1.services.$q.when(globals.current);
                }
                var detail = error.detail;
                if (error.type === rejectFactory_1.RejectType.SUPERSEDED && error.redirected && detail instanceof targetState_1.TargetState) {
                  var redirect = transition.redirect(detail);
                  return redirect.run().catch(rejectedTransitionHandler(redirect));
                }
                if (error.type === rejectFactory_1.RejectType.ABORTED) {
                  router.urlRouter.update();
                }
              }
              var errorHandler = _this.defaultErrorHandler();
              errorHandler(error);
              return coreservices_1.services.$q.reject(error);
            };
          };
          var transition = this.router.transitionService.create(currentPath, ref);
          var transitionToPromise = transition.run().catch(rejectedTransitionHandler(transition));
          common_1.silenceUncaughtInPromise(transitionToPromise);
          return common_1.extend(transitionToPromise, {transition: transition});
        };
        ;
        StateService.prototype.is = function(stateOrName, params, options) {
          options = common_1.defaults(options, {relative: this.$current});
          var state = this.router.stateRegistry.matcher.find(stateOrName, options.relative);
          if (!predicates_1.isDefined(state))
            return undefined;
          if (this.$current !== state)
            return false;
          return predicates_1.isDefined(params) && params !== null ? param_1.Param.equals(state.parameters(), this.params, params) : true;
        };
        ;
        StateService.prototype.includes = function(stateOrName, params, options) {
          options = common_1.defaults(options, {relative: this.$current});
          var glob = predicates_1.isString(stateOrName) && glob_1.Glob.fromString(stateOrName);
          if (glob) {
            if (!glob.matches(this.$current.name))
              return false;
            stateOrName = this.$current.name;
          }
          var state = this.router.stateRegistry.matcher.find(stateOrName, options.relative),
              include = this.$current.includes;
          if (!predicates_1.isDefined(state))
            return undefined;
          if (!predicates_1.isDefined(include[state.name]))
            return false;
          return params ? common_2.equalForKeys(param_1.Param.values(state.parameters(), params), this.params, Object.keys(params)) : true;
        };
        ;
        StateService.prototype.href = function(stateOrName, params, options) {
          var defaultHrefOpts = {
            lossy: true,
            inherit: true,
            absolute: false,
            relative: this.$current
          };
          options = common_1.defaults(options, defaultHrefOpts);
          params = params || {};
          var state = this.router.stateRegistry.matcher.find(stateOrName, options.relative);
          if (!predicates_1.isDefined(state))
            return null;
          if (options.inherit)
            params = this.params.$inherit(params, this.$current, state);
          var nav = (state && options.lossy) ? state.navigable : state;
          if (!nav || nav.url === undefined || nav.url === null) {
            return null;
          }
          return this.router.urlRouter.href(nav.url, param_1.Param.values(state.parameters(), params), {absolute: options.absolute});
        };
        ;
        StateService.prototype.defaultErrorHandler = function(handler) {
          return this._defaultErrorHandler = handler || this._defaultErrorHandler;
        };
        StateService.prototype.get = function(stateOrName, base) {
          var reg = this.router.stateRegistry;
          if (arguments.length === 0)
            return reg.get();
          return reg.get(stateOrName, base || this.$current);
        };
        return StateService;
      }());
      exports.StateService = StateService;
    }, function(module, exports, __webpack_require__) {
      "use strict";
      var stateParams_1 = __webpack_require__(45);
      var queue_1 = __webpack_require__(8);
      var common_1 = __webpack_require__(3);
      var Globals = (function() {
        function Globals(transitionService) {
          var _this = this;
          this.params = new stateParams_1.StateParams();
          this.transitionHistory = new queue_1.Queue([], 1);
          this.successfulTransitions = new queue_1.Queue([], 1);
          var beforeNewTransition = function($transition$) {
            _this.transition = $transition$;
            _this.transitionHistory.enqueue($transition$);
            var updateGlobalState = function() {
              _this.successfulTransitions.enqueue($transition$);
              _this.$current = $transition$.$to();
              _this.current = _this.$current.self;
              common_1.copy($transition$.params(), _this.params);
            };
            $transition$.onSuccess({}, updateGlobalState, {priority: 10000});
            var clearCurrentTransition = function() {
              if (_this.transition === $transition$)
                _this.transition = null;
            };
            $transition$.promise.then(clearCurrentTransition, clearCurrentTransition);
          };
          transitionService.onBefore({}, beforeNewTransition);
        }
        return Globals;
      }());
      exports.Globals = Globals;
    }, function(module, exports, __webpack_require__) {
      "use strict";
      var common_1 = __webpack_require__(3);
      var StateParams = (function() {
        function StateParams(params) {
          if (params === void 0) {
            params = {};
          }
          common_1.extend(this, params);
        }
        StateParams.prototype.$inherit = function(newParams, $current, $to) {
          var parents = common_1.ancestors($current, $to),
              parentParams,
              inherited = {},
              inheritList = [];
          for (var i in parents) {
            if (!parents[i] || !parents[i].params)
              continue;
            parentParams = Object.keys(parents[i].params);
            if (!parentParams.length)
              continue;
            for (var j in parentParams) {
              if (inheritList.indexOf(parentParams[j]) >= 0)
                continue;
              inheritList.push(parentParams[j]);
              inherited[parentParams[j]] = this[parentParams[j]];
            }
          }
          return common_1.extend({}, inherited, newParams);
        };
        ;
        return StateParams;
      }());
      exports.StateParams = StateParams;
    }, function(module, exports, __webpack_require__) {
      "use strict";
      function __export(m) {
        for (var p in m)
          if (!exports.hasOwnProperty(p))
            exports[p] = m[p];
      }
      __export(__webpack_require__(22));
      __export(__webpack_require__(28));
      __export(__webpack_require__(45));
      __export(__webpack_require__(24));
    }, function(module, exports, __webpack_require__) {
      "use strict";
      function __export(m) {
        for (var p in m)
          if (!exports.hasOwnProperty(p))
            exports[p] = m[p];
      }
      __export(__webpack_require__(21));
      __export(__webpack_require__(20));
    }, function(module, exports, __webpack_require__) {
      "use strict";
      function __export(m) {
        for (var p in m)
          if (!exports.hasOwnProperty(p))
            exports[p] = m[p];
      }
      __export(__webpack_require__(18));
      __export(__webpack_require__(19));
      __export(__webpack_require__(17));
    }, function(module, exports, __webpack_require__) {
      "use strict";
      function __export(m) {
        for (var p in m)
          if (!exports.hasOwnProperty(p))
            exports[p] = m[p];
      }
      __export(__webpack_require__(40));
      __export(__webpack_require__(42));
      __export(__webpack_require__(39));
      __export(__webpack_require__(41));
      __export(__webpack_require__(38));
      __export(__webpack_require__(43));
      __export(__webpack_require__(14));
    }, function(module, exports, __webpack_require__) {
      "use strict";
      function __export(m) {
        for (var p in m)
          if (!exports.hasOwnProperty(p))
            exports[p] = m[p];
      }
      __export(__webpack_require__(16));
      __export(__webpack_require__(15));
      __export(__webpack_require__(10));
      __export(__webpack_require__(11));
      __export(__webpack_require__(13));
      __export(__webpack_require__(30));
    }, function(module, exports, __webpack_require__) {
      "use strict";
      function __export(m) {
        for (var p in m)
          if (!exports.hasOwnProperty(p))
            exports[p] = m[p];
      }
      __export(__webpack_require__(27));
      __export(__webpack_require__(23));
      __export(__webpack_require__(26));
      __export(__webpack_require__(29));
    }, function(module, exports, __webpack_require__) {
      "use strict";
      function __export(m) {
        for (var p in m)
          if (!exports.hasOwnProperty(p))
            exports[p] = m[p];
      }
      __export(__webpack_require__(37));
    }, function(module, exports, __webpack_require__) {
      "use strict";
      var router_1 = __webpack_require__(25);
      var coreservices_1 = __webpack_require__(6);
      var common_1 = __webpack_require__(3);
      var hof_1 = __webpack_require__(5);
      var predicates_1 = __webpack_require__(4);
      var resolveService_1 = __webpack_require__(54);
      var trace_1 = __webpack_require__(12);
      var views_1 = __webpack_require__(55);
      var templateFactory_1 = __webpack_require__(56);
      var stateProvider_1 = __webpack_require__(58);
      var onEnterExitRetain_1 = __webpack_require__(59);
      var angular = __webpack_require__(57);
      var app = angular.module("ui.router.angular1", []);
      angular.module('ui.router.util', ['ng', 'ui.router.init']);
      angular.module('ui.router.router', ['ui.router.util']);
      angular.module('ui.router.state', ['ui.router.router', 'ui.router.util', 'ui.router.angular1']);
      angular.module('ui.router', ['ui.router.init', 'ui.router.state', 'ui.router.angular1']);
      angular.module('ui.router.compat', ['ui.router']);
      function annotateController(controllerExpression) {
        var $injector = coreservices_1.services.$injector;
        var $controller = $injector.get("$controller");
        var oldInstantiate = $injector.instantiate;
        try {
          var deps_1;
          $injector.instantiate = function fakeInstantiate(constructorFunction) {
            $injector.instantiate = oldInstantiate;
            deps_1 = $injector.annotate(constructorFunction);
          };
          $controller(controllerExpression, {$scope: {}});
          return deps_1;
        } finally {
          $injector.instantiate = oldInstantiate;
        }
      }
      exports.annotateController = annotateController;
      var router = null;
      $uiRouter.$inject = ['$locationProvider'];
      function $uiRouter($locationProvider) {
        router = new router_1.UIRouter();
        router.stateProvider = new stateProvider_1.StateProvider(router.stateRegistry, router.stateService);
        router.stateRegistry.decorator("views", views_1.ng1ViewsBuilder);
        router.stateRegistry.decorator("onExit", onEnterExitRetain_1.getStateHookBuilder("onExit"));
        router.stateRegistry.decorator("onRetain", onEnterExitRetain_1.getStateHookBuilder("onRetain"));
        router.stateRegistry.decorator("onEnter", onEnterExitRetain_1.getStateHookBuilder("onEnter"));
        router.viewService.viewConfigFactory('ng1', views_1.ng1ViewConfigFactory);
        common_1.bindFunctions($locationProvider, coreservices_1.services.locationConfig, $locationProvider, ['hashPrefix']);
        var urlListeners = [];
        coreservices_1.services.location.onChange = function(callback) {
          urlListeners.push(callback);
          return function() {
            return common_1.removeFrom(urlListeners)(callback);
          };
        };
        this.$get = $get;
        $get.$inject = ['$location', '$browser', '$sniffer', '$rootScope', '$http', '$templateCache'];
        function $get($location, $browser, $sniffer, $rootScope, $http, $templateCache) {
          $rootScope.$on("$locationChangeSuccess", function(evt) {
            return urlListeners.forEach(function(fn) {
              return fn(evt);
            });
          });
          coreservices_1.services.locationConfig.html5Mode = function() {
            var html5Mode = $locationProvider.html5Mode();
            html5Mode = predicates_1.isObject(html5Mode) ? html5Mode.enabled : html5Mode;
            return html5Mode && $sniffer.history;
          };
          coreservices_1.services.location.setUrl = function(newUrl, replace) {
            if (replace === void 0) {
              replace = false;
            }
            $location.url(newUrl);
            if (replace)
              $location.replace();
          };
          coreservices_1.services.template.get = function(url) {
            return $http.get(url, {
              cache: $templateCache,
              headers: {Accept: 'text/html'}
            }).then(hof_1.prop("data"));
          };
          common_1.bindFunctions($location, coreservices_1.services.location, $location, ["replace", "url", "path", "search", "hash"]);
          common_1.bindFunctions($location, coreservices_1.services.locationConfig, $location, ['port', 'protocol', 'host']);
          common_1.bindFunctions($browser, coreservices_1.services.locationConfig, $browser, ['baseHref']);
          return router;
        }
      }
      angular.module('ui.router.init', []).provider("$uiRouter", $uiRouter);
      runBlock.$inject = ['$injector', '$q'];
      function runBlock($injector, $q) {
        coreservices_1.services.$injector = $injector;
        coreservices_1.services.$q = $q;
      }
      angular.module('ui.router.init').run(runBlock);
      angular.module('ui.router.init').run(['$uiRouter', function($uiRouter) {}]);
      angular.module('ui.router.util').provider('$urlMatcherFactory', ['$uiRouterProvider', function() {
        return router.urlMatcherFactory;
      }]);
      angular.module('ui.router.util').run(['$urlMatcherFactory', function($urlMatcherFactory) {}]);
      function getUrlRouterProvider() {
        router.urlRouterProvider["$get"] = function() {
          router.urlRouter.update(true);
          if (!this.interceptDeferred)
            router.urlRouter.listen();
          return router.urlRouter;
        };
        return router.urlRouterProvider;
      }
      angular.module('ui.router.router').provider('$urlRouter', ['$uiRouterProvider', getUrlRouterProvider]);
      angular.module('ui.router.router').run(['$urlRouter', function($urlRouter) {}]);
      function getStateProvider() {
        router.stateProvider["$get"] = function() {
          router.stateRegistry.stateQueue.autoFlush(router.stateService);
          return router.stateService;
        };
        return router.stateProvider;
      }
      angular.module('ui.router.state').provider('$state', ['$uiRouterProvider', getStateProvider]);
      angular.module('ui.router.state').run(['$state', function($state) {}]);
      angular.module('ui.router.state').factory('$stateParams', ['$uiRouter', function($uiRouter) {
        return $uiRouter.globals.params;
      }]);
      function getTransitionsProvider() {
        router.transitionService["$get"] = function() {
          return router.transitionService;
        };
        return router.transitionService;
      }
      angular.module('ui.router.state').provider('$transitions', ['$uiRouterProvider', getTransitionsProvider]);
      angular.module('ui.router.util').factory('$templateFactory', ['$uiRouter', function() {
        return new templateFactory_1.TemplateFactory();
      }]);
      angular.module('ui.router').factory('$view', function() {
        return router.viewService;
      });
      angular.module('ui.router').factory('$resolve', resolveService_1.resolveFactory);
      angular.module("ui.router").service("$trace", function() {
        return trace_1.trace;
      });
      watchDigests.$inject = ['$rootScope'];
      function watchDigests($rootScope) {
        $rootScope.$watch(function() {
          trace_1.trace.approximateDigests++;
        });
      }
      exports.watchDigests = watchDigests;
      angular.module("ui.router").run(watchDigests);
      exports.getLocals = function(ctx) {
        var tokens = ctx.getTokens().filter(predicates_1.isString);
        var tuples = tokens.map(function(key) {
          return [key, ctx.getResolvable(key).data];
        });
        return tuples.reduce(common_1.applyPairs, {});
      };
      var $stateParams;
      var $transitions;
      var $transitionsProvider;
      var $state;
      var $stateProvider;
      var $urlRouterProvider;
      var $urlRouter;
      var $urlMatcherFactory;
      var $urlMatcherFactoryProvider;
    }, function(module, exports, __webpack_require__) {
      "use strict";
      var stateObject_1 = __webpack_require__(42);
      var node_1 = __webpack_require__(21);
      var resolveContext_1 = __webpack_require__(17);
      var common_1 = __webpack_require__(3);
      var stateBuilder_1 = __webpack_require__(40);
      var $resolve = {resolve: function(invocables, locals, parent) {
          if (locals === void 0) {
            locals = {};
          }
          var parentNode = new node_1.PathNode(new stateObject_1.State({
            params: {},
            resolvables: []
          }));
          var node = new node_1.PathNode(new stateObject_1.State({
            params: {},
            resolvables: []
          }));
          var context = new resolveContext_1.ResolveContext([parentNode, node]);
          context.addResolvables(stateBuilder_1.resolvablesBuilder({resolve: invocables}), node.state);
          var resolveData = function(parentLocals) {
            var rewrap = function(_locals) {
              return stateBuilder_1.resolvablesBuilder({resolve: common_1.mapObj(_locals, function(local) {
                  return function() {
                    return local;
                  };
                })});
            };
            context.addResolvables(rewrap(parentLocals), parentNode.state);
            context.addResolvables(rewrap(locals), node.state);
            var tuples2ObjR = function(acc, tuple) {
              acc[tuple.token] = tuple.value;
              return acc;
            };
            return context.resolvePath().then(function(results) {
              return results.reduce(tuples2ObjR, {});
            });
          };
          return parent ? parent.then(resolveData) : resolveData({});
        }};
      exports.resolveFactory = function() {
        return $resolve;
      };
    }, function(module, exports, __webpack_require__) {
      "use strict";
      var common_1 = __webpack_require__(3);
      var strings_1 = __webpack_require__(9);
      var view_1 = __webpack_require__(37);
      var predicates_1 = __webpack_require__(4);
      var coreservices_1 = __webpack_require__(6);
      var trace_1 = __webpack_require__(12);
      var templateFactory_1 = __webpack_require__(56);
      var resolveContext_1 = __webpack_require__(17);
      var resolvable_1 = __webpack_require__(19);
      var angular = __webpack_require__(57);
      exports.ng1ViewConfigFactory = function(path, view) {
        return [new Ng1ViewConfig(path, view)];
      };
      function ng1ViewsBuilder(state) {
        var tplKeys = ['templateProvider', 'templateUrl', 'template', 'notify', 'async'],
            ctrlKeys = ['controller', 'controllerProvider', 'controllerAs', 'resolveAs'],
            compKeys = ['component', 'bindings'],
            nonCompKeys = tplKeys.concat(ctrlKeys),
            allKeys = compKeys.concat(nonCompKeys);
        var views = {},
            viewsObject = state.views || {"$default": common_1.pick(state, allKeys)};
        common_1.forEach(viewsObject, function(config, name) {
          name = name || "$default";
          if (predicates_1.isString(config))
            config = {component: config};
          if (!Object.keys(config).length)
            return;
          if (config.component) {
            if (nonCompKeys.map(function(key) {
              return predicates_1.isDefined(config[key]);
            }).reduce(common_1.anyTrueR, false)) {
              throw new Error("Cannot combine: " + compKeys.join("|") + " with: " + nonCompKeys.join("|") + " in stateview: 'name@" + state.name + "'");
            }
            config.templateProvider = ['$injector', function($injector) {
              var resolveFor = function(key) {
                return config.bindings && config.bindings[key] || key;
              };
              var prefix = angular.version.minor >= 3 ? "::" : "";
              var attributeTpl = function(input) {
                var attrName = strings_1.kebobString(input.name);
                var resolveName = resolveFor(input.name);
                if (input.type === '@')
                  return attrName + "='{{" + prefix + "$resolve." + resolveName + "}}'";
                return attrName + "='" + prefix + "$resolve." + resolveName + "'";
              };
              var attrs = getComponentInputs($injector, config.component).map(attributeTpl).join(" ");
              var kebobName = strings_1.kebobString(config.component);
              return "<" + kebobName + " " + attrs + "></" + kebobName + ">";
            }];
          }
          config.resolveAs = config.resolveAs || '$resolve';
          config.$type = "ng1";
          config.$context = state;
          config.$name = name;
          var normalized = view_1.ViewService.normalizeUIViewTarget(config.$context, config.$name);
          config.$uiViewName = normalized.uiViewName;
          config.$uiViewContextAnchor = normalized.uiViewContextAnchor;
          views[name] = config;
        });
        return views;
      }
      exports.ng1ViewsBuilder = ng1ViewsBuilder;
      var scopeBindings = function(bindingsObj) {
        return Object.keys(bindingsObj || {}).map(function(key) {
          return [key, /^([=<@])[?]?(.*)/.exec(bindingsObj[key])];
        }).filter(function(tuple) {
          return predicates_1.isDefined(tuple) && predicates_1.isDefined(tuple[1]);
        }).map(function(tuple) {
          return ({
            name: tuple[1][2] || tuple[0],
            type: tuple[1][1]
          });
        });
      };
      var getBindings = function(def) {
        if (predicates_1.isObject(def.bindToController))
          return scopeBindings(def.bindToController);
        return scopeBindings(def.scope);
      };
      function getComponentInputs($injector, name) {
        var cmpDefs = $injector.get(name + "Directive");
        if (!cmpDefs || !cmpDefs.length)
          throw new Error("Unable to find component named '" + name + "'");
        return cmpDefs.map(getBindings).reduce(common_1.unnestR, []);
      }
      var id = 0;
      var Ng1ViewConfig = (function() {
        function Ng1ViewConfig(path, viewDecl) {
          this.path = path;
          this.viewDecl = viewDecl;
          this.$id = id++;
          this.loaded = false;
        }
        Ng1ViewConfig.prototype.load = function() {
          var _this = this;
          var $q = coreservices_1.services.$q;
          if (!this.hasTemplate())
            throw new Error("No template configuration specified for '" + this.viewDecl.$uiViewName + "@" + this.viewDecl.$uiViewContextAnchor + "'");
          var context = new resolveContext_1.ResolveContext(this.path);
          var params = this.path.reduce(function(acc, node) {
            return common_1.extend(acc, node.paramValues);
          }, {});
          var promises = {
            template: $q.when(this.getTemplate(params, new templateFactory_1.TemplateFactory(), context)),
            controller: $q.when(this.getController(context))
          };
          return $q.all(promises).then(function(results) {
            trace_1.trace.traceViewServiceEvent("Loaded", _this);
            _this.controller = results.controller;
            _this.template = results.template;
            return _this;
          });
        };
        Ng1ViewConfig.prototype.hasTemplate = function() {
          return !!(this.viewDecl.template || this.viewDecl.templateUrl || this.viewDecl.templateProvider);
        };
        Ng1ViewConfig.prototype.getTemplate = function(params, $factory, context) {
          return $factory.fromConfig(this.viewDecl, params, context);
        };
        Ng1ViewConfig.prototype.getController = function(context) {
          var provider = this.viewDecl.controllerProvider;
          if (!predicates_1.isInjectable(provider))
            return this.viewDecl.controller;
          var deps = coreservices_1.services.$injector.annotate(provider);
          var providerFn = predicates_1.isArray(provider) ? common_1.tail(provider) : provider;
          var resolvable = new resolvable_1.Resolvable("", providerFn, deps);
          return resolvable.get(context);
        };
        return Ng1ViewConfig;
      }());
      exports.Ng1ViewConfig = Ng1ViewConfig;
    }, function(module, exports, __webpack_require__) {
      "use strict";
      var predicates_1 = __webpack_require__(4);
      var coreservices_1 = __webpack_require__(6);
      var common_1 = __webpack_require__(3);
      var resolvable_1 = __webpack_require__(19);
      var TemplateFactory = (function() {
        function TemplateFactory() {}
        TemplateFactory.prototype.fromConfig = function(config, params, context) {
          return (predicates_1.isDefined(config.template) ? this.fromString(config.template, params) : predicates_1.isDefined(config.templateUrl) ? this.fromUrl(config.templateUrl, params) : predicates_1.isDefined(config.templateProvider) ? this.fromProvider(config.templateProvider, params, context) : null);
        };
        ;
        TemplateFactory.prototype.fromString = function(template, params) {
          return predicates_1.isFunction(template) ? template(params) : template;
        };
        ;
        TemplateFactory.prototype.fromUrl = function(url, params) {
          if (predicates_1.isFunction(url))
            url = url(params);
          if (url == null)
            return null;
          return coreservices_1.services.template.get(url);
        };
        ;
        TemplateFactory.prototype.fromProvider = function(provider, params, context) {
          var deps = coreservices_1.services.$injector.annotate(provider);
          var providerFn = predicates_1.isArray(provider) ? common_1.tail(provider) : provider;
          var resolvable = new resolvable_1.Resolvable("", providerFn, deps);
          return resolvable.get(context);
        };
        ;
        return TemplateFactory;
      }());
      exports.TemplateFactory = TemplateFactory;
    }, function(module, exports) {
      module.exports = __WEBPACK_EXTERNAL_MODULE_57__;
    }, function(module, exports, __webpack_require__) {
      "use strict";
      var predicates_1 = __webpack_require__(4);
      var common_1 = __webpack_require__(3);
      var StateProvider = (function() {
        function StateProvider(stateRegistry, stateService) {
          this.stateRegistry = stateRegistry;
          this.stateService = stateService;
          common_1.bindFunctions(StateProvider.prototype, this, this);
        }
        StateProvider.prototype.decorator = function(name, func) {
          return this.stateRegistry.decorator(name, func) || this;
        };
        StateProvider.prototype.state = function(name, definition) {
          if (predicates_1.isObject(name)) {
            definition = name;
          } else {
            definition.name = name;
          }
          this.stateRegistry.register(definition);
          return this;
        };
        StateProvider.prototype.onInvalid = function(callback) {
          return this.stateService.onInvalid(callback);
        };
        return StateProvider;
      }());
      exports.StateProvider = StateProvider;
    }, function(module, exports, __webpack_require__) {
      "use strict";
      var coreservices_1 = __webpack_require__(6);
      var services_1 = __webpack_require__(53);
      var resolveContext_1 = __webpack_require__(17);
      var common_1 = __webpack_require__(3);
      exports.getStateHookBuilder = function(hookName) {
        return function stateHookBuilder(state, parentFn) {
          var hook = state[hookName];
          function decoratedNg1Hook(trans, state) {
            var resolveContext = new resolveContext_1.ResolveContext(trans.treeChanges().to);
            return coreservices_1.services.$injector.invoke(hook, this, common_1.extend({$state$: state}, services_1.getLocals(resolveContext)));
          }
          return hook ? decoratedNg1Hook : undefined;
        };
      };
    }, function(module, exports, __webpack_require__) {
      "use strict";
      var angular = __webpack_require__(57);
      var common_1 = __webpack_require__(3);
      var predicates_1 = __webpack_require__(4);
      var hof_1 = __webpack_require__(5);
      function parseStateRef(ref, current) {
        var preparsed = ref.match(/^\s*({[^}]*})\s*$/),
            parsed;
        if (preparsed)
          ref = current + '(' + preparsed[1] + ')';
        parsed = ref.replace(/\n/g, " ").match(/^([^(]+?)\s*(\((.*)\))?$/);
        if (!parsed || parsed.length !== 4)
          throw new Error("Invalid state ref '" + ref + "'");
        return {
          state: parsed[1],
          paramExpr: parsed[3] || null
        };
      }
      function stateContext(el) {
        var $uiView = el.parent().inheritedData('$uiView');
        var path = hof_1.parse('$cfg.path')($uiView);
        return path ? common_1.tail(path).state.name : undefined;
      }
      function getTypeInfo(el) {
        var isSvg = Object.prototype.toString.call(el.prop('href')) === '[object SVGAnimatedString]';
        var isForm = el[0].nodeName === "FORM";
        return {
          attr: isForm ? "action" : (isSvg ? 'xlink:href' : 'href'),
          isAnchor: el.prop("tagName").toUpperCase() === "A",
          clickable: !isForm
        };
      }
      function clickHook(el, $state, $timeout, type, current) {
        return function(e) {
          var button = e.which || e.button,
              target = current();
          if (!(button > 1 || e.ctrlKey || e.metaKey || e.shiftKey || el.attr('target'))) {
            var transition = $timeout(function() {
              $state.go(target.state, target.params, target.options);
            });
            e.preventDefault();
            var ignorePreventDefaultCount = type.isAnchor && !target.href ? 1 : 0;
            e.preventDefault = function() {
              if (ignorePreventDefaultCount-- <= 0)
                $timeout.cancel(transition);
            };
          }
        };
      }
      function defaultOpts(el, $state) {
        return {
          relative: stateContext(el) || $state.$current,
          inherit: true,
          source: "sref"
        };
      }
      var uiSref = ['$state', '$timeout', function $StateRefDirective($state, $timeout) {
        return {
          restrict: 'A',
          require: ['?^uiSrefActive', '?^uiSrefActiveEq'],
          link: function(scope, element, attrs, uiSrefActive) {
            var ref = parseStateRef(attrs.uiSref, $state.current.name);
            var def = {
              state: ref.state,
              href: null,
              params: null,
              options: null
            };
            var type = getTypeInfo(element);
            var active = uiSrefActive[1] || uiSrefActive[0];
            var unlinkInfoFn = null;
            var hookFn;
            def.options = common_1.extend(defaultOpts(element, $state), attrs.uiSrefOpts ? scope.$eval(attrs.uiSrefOpts) : {});
            var update = function(val) {
              if (val)
                def.params = angular.copy(val);
              def.href = $state.href(ref.state, def.params, def.options);
              if (unlinkInfoFn)
                unlinkInfoFn();
              if (active)
                unlinkInfoFn = active.$$addStateInfo(ref.state, def.params);
              if (def.href !== null)
                attrs.$set(type.attr, def.href);
            };
            if (ref.paramExpr) {
              scope.$watch(ref.paramExpr, function(val) {
                if (val !== def.params)
                  update(val);
              }, true);
              def.params = angular.copy(scope.$eval(ref.paramExpr));
            }
            update();
            if (!type.clickable)
              return;
            hookFn = clickHook(element, $state, $timeout, type, function() {
              return def;
            });
            element.on("click", hookFn);
            scope.$on('$destroy', function() {
              element.off("click", hookFn);
            });
          }
        };
      }];
      var uiState = ['$state', '$timeout', function $StateRefDynamicDirective($state, $timeout) {
        return {
          restrict: 'A',
          require: ['?^uiSrefActive', '?^uiSrefActiveEq'],
          link: function(scope, element, attrs, uiSrefActive) {
            var type = getTypeInfo(element);
            var active = uiSrefActive[1] || uiSrefActive[0];
            var group = [attrs.uiState, attrs.uiStateParams || null, attrs.uiStateOpts || null];
            var watch = '[' + group.map(function(val) {
              return val || 'null';
            }).join(', ') + ']';
            var def = {
              state: null,
              params: null,
              options: null,
              href: null
            };
            var unlinkInfoFn = null;
            var hookFn;
            function runStateRefLink(group) {
              def.state = group[0];
              def.params = group[1];
              def.options = group[2];
              def.href = $state.href(def.state, def.params, def.options);
              if (unlinkInfoFn)
                unlinkInfoFn();
              if (active)
                unlinkInfoFn = active.$$addStateInfo(def.state, def.params);
              if (def.href)
                attrs.$set(type.attr, def.href);
            }
            scope.$watch(watch, runStateRefLink, true);
            runStateRefLink(scope.$eval(watch));
            if (!type.clickable)
              return;
            hookFn = clickHook(element, $state, $timeout, type, function() {
              return def;
            });
            element.on("click", hookFn);
            scope.$on('$destroy', function() {
              element.off("click", hookFn);
            });
          }
        };
      }];
      var uiSrefActive = ['$state', '$stateParams', '$interpolate', '$transitions', '$uiRouter', function $StateRefActiveDirective($state, $stateParams, $interpolate, $transitions, $uiRouter) {
        return {
          restrict: "A",
          controller: ['$scope', '$element', '$attrs', '$timeout', function($scope, $element, $attrs, $timeout) {
            var states = [],
                activeClasses = {},
                activeEqClass,
                uiSrefActive;
            activeEqClass = $interpolate($attrs.uiSrefActiveEq || '', false)($scope);
            try {
              uiSrefActive = $scope.$eval($attrs.uiSrefActive);
            } catch (e) {}
            uiSrefActive = uiSrefActive || $interpolate($attrs.uiSrefActive || '', false)($scope);
            if (predicates_1.isObject(uiSrefActive)) {
              common_1.forEach(uiSrefActive, function(stateOrName, activeClass) {
                if (predicates_1.isString(stateOrName)) {
                  var ref = parseStateRef(stateOrName, $state.current.name);
                  addState(ref.state, $scope.$eval(ref.paramExpr), activeClass);
                }
              });
            }
            this.$$addStateInfo = function(newState, newParams) {
              if (predicates_1.isObject(uiSrefActive) && states.length > 0) {
                return;
              }
              var deregister = addState(newState, newParams, uiSrefActive);
              update();
              return deregister;
            };
            function updateAfterTransition(trans) {
              trans.promise.then(update);
            }
            $scope.$on('$stateChangeSuccess', update);
            $scope.$on('$destroy', $transitions.onStart({}, updateAfterTransition));
            if ($uiRouter.globals.transition) {
              updateAfterTransition($uiRouter.globals.transition);
            }
            function addState(stateName, stateParams, activeClass) {
              var state = $state.get(stateName, stateContext($element));
              var stateHash = createStateHash(stateName, stateParams);
              var stateInfo = {
                state: state || {name: stateName},
                params: stateParams,
                hash: stateHash
              };
              states.push(stateInfo);
              activeClasses[stateHash] = activeClass;
              return function removeState() {
                var idx = states.indexOf(stateInfo);
                if (idx !== -1)
                  states.splice(idx, 1);
              };
            }
            function createStateHash(state, params) {
              if (!predicates_1.isString(state)) {
                throw new Error('state should be a string');
              }
              if (predicates_1.isObject(params)) {
                return state + common_1.toJson(params);
              }
              params = $scope.$eval(params);
              if (predicates_1.isObject(params)) {
                return state + common_1.toJson(params);
              }
              return state;
            }
            function update() {
              for (var i = 0; i < states.length; i++) {
                if (anyMatch(states[i].state, states[i].params)) {
                  addClass($element, activeClasses[states[i].hash]);
                } else {
                  removeClass($element, activeClasses[states[i].hash]);
                }
                if (exactMatch(states[i].state, states[i].params)) {
                  addClass($element, activeEqClass);
                } else {
                  removeClass($element, activeEqClass);
                }
              }
            }
            function addClass(el, className) {
              $timeout(function() {
                el.addClass(className);
              });
            }
            function removeClass(el, className) {
              el.removeClass(className);
            }
            function anyMatch(state, params) {
              return $state.includes(state.name, params);
            }
            function exactMatch(state, params) {
              return $state.is(state.name, params);
            }
            update();
          }]
        };
      }];
      angular.module('ui.router.state').directive('uiSref', uiSref).directive('uiSrefActive', uiSrefActive).directive('uiSrefActiveEq', uiSrefActive).directive('uiState', uiState);
    }, function(module, exports, __webpack_require__) {
      "use strict";
      var angular = __webpack_require__(57);
      $IsStateFilter.$inject = ['$state'];
      function $IsStateFilter($state) {
        var isFilter = function(state, params, options) {
          return $state.is(state, params, options);
        };
        isFilter.$stateful = true;
        return isFilter;
      }
      exports.$IsStateFilter = $IsStateFilter;
      $IncludedByStateFilter.$inject = ['$state'];
      function $IncludedByStateFilter($state) {
        var includesFilter = function(state, params, options) {
          return $state.includes(state, params, options);
        };
        includesFilter.$stateful = true;
        return includesFilter;
      }
      exports.$IncludedByStateFilter = $IncludedByStateFilter;
      angular.module('ui.router.state').filter('isState', $IsStateFilter).filter('includedByState', $IncludedByStateFilter);
    }, function(module, exports, __webpack_require__) {
      "use strict";
      var common_1 = __webpack_require__(3);
      var predicates_1 = __webpack_require__(4);
      var trace_1 = __webpack_require__(12);
      var views_1 = __webpack_require__(55);
      var hof_1 = __webpack_require__(5);
      var resolveContext_1 = __webpack_require__(17);
      var strings_1 = __webpack_require__(9);
      var services_1 = __webpack_require__(53);
      var angular = __webpack_require__(57);
      var uiView = ['$view', '$animate', '$uiViewScroll', '$interpolate', '$q', function $ViewDirective($view, $animate, $uiViewScroll, $interpolate, $q) {
        function getRenderer(attrs, scope) {
          return {
            enter: function(element, target, cb) {
              if (angular.version.minor > 2) {
                $animate.enter(element, null, target).then(cb);
              } else {
                $animate.enter(element, null, target, cb);
              }
            },
            leave: function(element, cb) {
              if (angular.version.minor > 2) {
                $animate.leave(element).then(cb);
              } else {
                $animate.leave(element, cb);
              }
            }
          };
        }
        function configsEqual(config1, config2) {
          return config1 === config2;
        }
        var rootData = {
          $cfg: {viewDecl: {$context: $view.rootContext()}},
          $uiView: {}
        };
        var directive = {
          count: 0,
          restrict: 'ECA',
          terminal: true,
          priority: 400,
          transclude: 'element',
          compile: function(tElement, tAttrs, $transclude) {
            return function(scope, $element, attrs) {
              var previousEl,
                  currentEl,
                  currentScope,
                  unregister,
                  onloadExp = attrs['onload'] || '',
                  autoScrollExp = attrs['autoscroll'],
                  renderer = getRenderer(attrs, scope),
                  viewConfig = undefined,
                  inherited = $element.inheritedData('$uiView') || rootData,
                  name = $interpolate(attrs['uiView'] || attrs['name'] || '')(scope) || '$default';
              var activeUIView = {
                $type: 'ng1',
                id: directive.count++,
                name: name,
                fqn: inherited.$uiView.fqn ? inherited.$uiView.fqn + "." + name : name,
                config: null,
                configUpdated: configUpdatedCallback,
                get creationContext() {
                  return hof_1.parse('$cfg.viewDecl.$context')(inherited);
                }
              };
              trace_1.trace.traceUIViewEvent("Linking", activeUIView);
              function configUpdatedCallback(config) {
                if (config && !(config instanceof views_1.Ng1ViewConfig))
                  return;
                if (configsEqual(viewConfig, config))
                  return;
                trace_1.trace.traceUIViewConfigUpdated(activeUIView, config && config.viewDecl && config.viewDecl.$context);
                viewConfig = config;
                updateView(config);
              }
              $element.data('$uiView', {$uiView: activeUIView});
              updateView();
              unregister = $view.registerUIView(activeUIView);
              scope.$on("$destroy", function() {
                trace_1.trace.traceUIViewEvent("Destroying/Unregistering", activeUIView);
                unregister();
              });
              function cleanupLastView() {
                if (previousEl) {
                  trace_1.trace.traceUIViewEvent("Removing (previous) el", previousEl.data('$uiView'));
                  previousEl.remove();
                  previousEl = null;
                }
                if (currentScope) {
                  trace_1.trace.traceUIViewEvent("Destroying scope", activeUIView);
                  currentScope.$destroy();
                  currentScope = null;
                }
                if (currentEl) {
                  var _viewData_1 = currentEl.data('$uiViewAnim');
                  trace_1.trace.traceUIViewEvent("Animate out", _viewData_1);
                  renderer.leave(currentEl, function() {
                    _viewData_1.$$animLeave.resolve();
                    previousEl = null;
                  });
                  previousEl = currentEl;
                  currentEl = null;
                }
              }
              function updateView(config) {
                var newScope = scope.$new();
                var animEnter = $q.defer(),
                    animLeave = $q.defer();
                var $uiViewData = {
                  $cfg: config,
                  $uiView: activeUIView
                };
                var $uiViewAnim = {
                  $animEnter: animEnter.promise,
                  $animLeave: animLeave.promise,
                  $$animLeave: animLeave
                };
                var cloned = $transclude(newScope, function(clone) {
                  clone.data('$uiViewAnim', $uiViewAnim);
                  clone.data('$uiView', $uiViewData);
                  renderer.enter(clone, $element, function onUIViewEnter() {
                    animEnter.resolve();
                    if (currentScope)
                      currentScope.$emit('$viewContentAnimationEnded');
                    if (predicates_1.isDefined(autoScrollExp) && !autoScrollExp || scope.$eval(autoScrollExp)) {
                      $uiViewScroll(clone);
                    }
                  });
                  cleanupLastView();
                });
                currentEl = cloned;
                currentScope = newScope;
                currentScope.$emit('$viewContentLoaded', config || viewConfig);
                currentScope.$eval(onloadExp);
              }
            };
          }
        };
        return directive;
      }];
      $ViewDirectiveFill.$inject = ['$compile', '$controller', '$transitions', '$view', '$timeout'];
      function $ViewDirectiveFill($compile, $controller, $transitions, $view, $timeout) {
        var getControllerAs = hof_1.parse('viewDecl.controllerAs');
        var getResolveAs = hof_1.parse('viewDecl.resolveAs');
        return {
          restrict: 'ECA',
          priority: -400,
          compile: function(tElement) {
            var initial = tElement.html();
            return function(scope, $element) {
              var data = $element.data('$uiView');
              if (!data)
                return;
              var cfg = data.$cfg || {viewDecl: {}};
              $element.html(cfg.template || initial);
              trace_1.trace.traceUIViewFill(data.$uiView, $element.html());
              var link = $compile($element.contents());
              var controller = cfg.controller;
              var controllerAs = getControllerAs(cfg);
              var resolveAs = getResolveAs(cfg);
              var resolveCtx = cfg.path && new resolveContext_1.ResolveContext(cfg.path);
              var locals = resolveCtx && services_1.getLocals(resolveCtx);
              scope[resolveAs] = locals;
              if (controller) {
                var controllerInstance = $controller(controller, common_1.extend({}, locals, {
                  $scope: scope,
                  $element: $element
                }));
                if (controllerAs) {
                  scope[controllerAs] = controllerInstance;
                  scope[controllerAs][resolveAs] = locals;
                }
                $element.data('$ngControllerController', controllerInstance);
                $element.children().data('$ngControllerController', controllerInstance);
                registerControllerCallbacks($transitions, controllerInstance, scope, cfg);
              }
              if (predicates_1.isString(cfg.viewDecl.component)) {
                var cmp_1 = cfg.viewDecl.component;
                var kebobName_1 = strings_1.kebobString(cmp_1);
                var getComponentController = function() {
                  var directiveEl = [].slice.call($element[0].children).filter(function(el) {
                    return el && el.tagName && el.tagName.toLowerCase() === kebobName_1;
                  });
                  return directiveEl && angular.element(directiveEl).data("$" + cmp_1 + "Controller");
                };
                var deregisterWatch_1 = scope.$watch(getComponentController, function(ctrlInstance) {
                  if (!ctrlInstance)
                    return;
                  registerControllerCallbacks($transitions, ctrlInstance, scope, cfg);
                  deregisterWatch_1();
                });
              }
              link(scope);
            };
          }
        };
      }
      var hasComponentImpl = typeof angular.module('ui.router')['component'] === 'function';
      function registerControllerCallbacks($transitions, controllerInstance, $scope, cfg) {
        if (predicates_1.isFunction(controllerInstance.$onInit) && !(cfg.viewDecl.component && hasComponentImpl))
          controllerInstance.$onInit();
        var viewState = common_1.tail(cfg.path).state.self;
        var hookOptions = {bind: controllerInstance};
        if (predicates_1.isFunction(controllerInstance.uiOnParamsChanged)) {
          var resolveContext = new resolveContext_1.ResolveContext(cfg.path);
          var viewCreationTrans_1 = resolveContext.getResolvable('$transition$').data;
          var paramsUpdated = function($transition$) {
            if ($transition$ === viewCreationTrans_1 || $transition$.exiting().indexOf(viewState) !== -1)
              return;
            var toParams = $transition$.params("to");
            var fromParams = $transition$.params("from");
            var toSchema = $transition$.treeChanges().to.map(function(node) {
              return node.paramSchema;
            }).reduce(common_1.unnestR, []);
            var fromSchema = $transition$.treeChanges().from.map(function(node) {
              return node.paramSchema;
            }).reduce(common_1.unnestR, []);
            var changedToParams = toSchema.filter(function(param) {
              var idx = fromSchema.indexOf(param);
              return idx === -1 || !fromSchema[idx].type.equals(toParams[param.id], fromParams[param.id]);
            });
            if (changedToParams.length) {
              var changedKeys_1 = changedToParams.map(function(x) {
                return x.id;
              });
              controllerInstance.uiOnParamsChanged(common_1.filter(toParams, function(val, key) {
                return changedKeys_1.indexOf(key) !== -1;
              }), $transition$);
            }
          };
          $scope.$on('$destroy', $transitions.onSuccess({}, paramsUpdated, hookOptions));
        }
        if (predicates_1.isFunction(controllerInstance.uiCanExit)) {
          var criteria = {exiting: viewState.name};
          $scope.$on('$destroy', $transitions.onBefore(criteria, controllerInstance.uiCanExit, hookOptions));
        }
      }
      angular.module('ui.router.state').directive('uiView', uiView);
      angular.module('ui.router.state').directive('uiView', $ViewDirectiveFill);
    }, function(module, exports, __webpack_require__) {
      "use strict";
      var angular = __webpack_require__(57);
      function $ViewScrollProvider() {
        var useAnchorScroll = false;
        this.useAnchorScroll = function() {
          useAnchorScroll = true;
        };
        this.$get = ['$anchorScroll', '$timeout', function($anchorScroll, $timeout) {
          if (useAnchorScroll) {
            return $anchorScroll;
          }
          return function($element) {
            return $timeout(function() {
              $element[0].scrollIntoView();
            }, 0, false);
          };
        }];
      }
      angular.module('ui.router.state').provider('$uiViewScroll', $ViewScrollProvider);
    }]);
  });
  ;
  return module.exports;
});

$__System.registerDynamic("a", ["3"], false, function($__require, $__exports, $__module) {
  var _retrieveGlobal = $__System.get("@@global-helpers").prepareGlobal($__module.id, null, null);
  (function() {
    (function(window, angular) {
      'use strict';
      var $resourceMinErr = angular.$$minErr('$resource');
      var MEMBER_NAME_REGEX = /^(\.[a-zA-Z_$@][0-9a-zA-Z_$@]*)+$/;
      function isValidDottedPath(path) {
        return (path != null && path !== '' && path !== 'hasOwnProperty' && MEMBER_NAME_REGEX.test('.' + path));
      }
      function lookupDottedPath(obj, path) {
        if (!isValidDottedPath(path)) {
          throw $resourceMinErr('badmember', 'Dotted member path "@{0}" is invalid.', path);
        }
        var keys = path.split('.');
        for (var i = 0,
            ii = keys.length; i < ii && angular.isDefined(obj); i++) {
          var key = keys[i];
          obj = (obj !== null) ? obj[key] : undefined;
        }
        return obj;
      }
      function shallowClearAndCopy(src, dst) {
        dst = dst || {};
        angular.forEach(dst, function(value, key) {
          delete dst[key];
        });
        for (var key in src) {
          if (src.hasOwnProperty(key) && !(key.charAt(0) === '$' && key.charAt(1) === '$')) {
            dst[key] = src[key];
          }
        }
        return dst;
      }
      angular.module('ngResource', ['ng']).info({angularVersion: '1.6.9'}).provider('$resource', function ResourceProvider() {
        var PROTOCOL_AND_IPV6_REGEX = /^https?:\/\/\[[^\]]*][^/]*/;
        var provider = this;
        this.defaults = {
          stripTrailingSlashes: true,
          cancellable: false,
          actions: {
            'get': {method: 'GET'},
            'save': {method: 'POST'},
            'query': {
              method: 'GET',
              isArray: true
            },
            'remove': {method: 'DELETE'},
            'delete': {method: 'DELETE'}
          }
        };
        this.$get = ['$http', '$log', '$q', '$timeout', function($http, $log, $q, $timeout) {
          var noop = angular.noop,
              forEach = angular.forEach,
              extend = angular.extend,
              copy = angular.copy,
              isArray = angular.isArray,
              isDefined = angular.isDefined,
              isFunction = angular.isFunction,
              isNumber = angular.isNumber,
              encodeUriQuery = angular.$$encodeUriQuery,
              encodeUriSegment = angular.$$encodeUriSegment;
          function Route(template, defaults) {
            this.template = template;
            this.defaults = extend({}, provider.defaults, defaults);
            this.urlParams = {};
          }
          Route.prototype = {setUrlParams: function(config, params, actionUrl) {
              var self = this,
                  url = actionUrl || self.template,
                  val,
                  encodedVal,
                  protocolAndIpv6 = '';
              var urlParams = self.urlParams = Object.create(null);
              forEach(url.split(/\W/), function(param) {
                if (param === 'hasOwnProperty') {
                  throw $resourceMinErr('badname', 'hasOwnProperty is not a valid parameter name.');
                }
                if (!(new RegExp('^\\d+$').test(param)) && param && (new RegExp('(^|[^\\\\]):' + param + '(\\W|$)').test(url))) {
                  urlParams[param] = {isQueryParamValue: (new RegExp('\\?.*=:' + param + '(?:\\W|$)')).test(url)};
                }
              });
              url = url.replace(/\\:/g, ':');
              url = url.replace(PROTOCOL_AND_IPV6_REGEX, function(match) {
                protocolAndIpv6 = match;
                return '';
              });
              params = params || {};
              forEach(self.urlParams, function(paramInfo, urlParam) {
                val = params.hasOwnProperty(urlParam) ? params[urlParam] : self.defaults[urlParam];
                if (isDefined(val) && val !== null) {
                  if (paramInfo.isQueryParamValue) {
                    encodedVal = encodeUriQuery(val, true);
                  } else {
                    encodedVal = encodeUriSegment(val);
                  }
                  url = url.replace(new RegExp(':' + urlParam + '(\\W|$)', 'g'), function(match, p1) {
                    return encodedVal + p1;
                  });
                } else {
                  url = url.replace(new RegExp('(/?):' + urlParam + '(\\W|$)', 'g'), function(match, leadingSlashes, tail) {
                    if (tail.charAt(0) === '/') {
                      return tail;
                    } else {
                      return leadingSlashes + tail;
                    }
                  });
                }
              });
              if (self.defaults.stripTrailingSlashes) {
                url = url.replace(/\/+$/, '') || '/';
              }
              url = url.replace(/\/\.(?=\w+($|\?))/, '.');
              config.url = protocolAndIpv6 + url.replace(/\/(\\|%5C)\./, '/.');
              forEach(params, function(value, key) {
                if (!self.urlParams[key]) {
                  config.params = config.params || {};
                  config.params[key] = value;
                }
              });
            }};
          function resourceFactory(url, paramDefaults, actions, options) {
            var route = new Route(url, options);
            actions = extend({}, provider.defaults.actions, actions);
            function extractParams(data, actionParams) {
              var ids = {};
              actionParams = extend({}, paramDefaults, actionParams);
              forEach(actionParams, function(value, key) {
                if (isFunction(value)) {
                  value = value(data);
                }
                ids[key] = value && value.charAt && value.charAt(0) === '@' ? lookupDottedPath(data, value.substr(1)) : value;
              });
              return ids;
            }
            function defaultResponseInterceptor(response) {
              return response.resource;
            }
            function Resource(value) {
              shallowClearAndCopy(value || {}, this);
            }
            Resource.prototype.toJSON = function() {
              var data = extend({}, this);
              delete data.$promise;
              delete data.$resolved;
              delete data.$cancelRequest;
              return data;
            };
            forEach(actions, function(action, name) {
              var hasBody = action.hasBody === true || (action.hasBody !== false && /^(POST|PUT|PATCH)$/i.test(action.method));
              var numericTimeout = action.timeout;
              var cancellable = isDefined(action.cancellable) ? action.cancellable : route.defaults.cancellable;
              if (numericTimeout && !isNumber(numericTimeout)) {
                $log.debug('ngResource:\n' + '  Only numeric values are allowed as `timeout`.\n' + '  Promises are not supported in $resource, because the same value would ' + 'be used for multiple requests. If you are looking for a way to cancel ' + 'requests, you should use the `cancellable` option.');
                delete action.timeout;
                numericTimeout = null;
              }
              Resource[name] = function(a1, a2, a3, a4) {
                var params = {},
                    data,
                    success,
                    error;
                switch (arguments.length) {
                  case 4:
                    error = a4;
                    success = a3;
                  case 3:
                  case 2:
                    if (isFunction(a2)) {
                      if (isFunction(a1)) {
                        success = a1;
                        error = a2;
                        break;
                      }
                      success = a2;
                      error = a3;
                    } else {
                      params = a1;
                      data = a2;
                      success = a3;
                      break;
                    }
                  case 1:
                    if (isFunction(a1))
                      success = a1;
                    else if (hasBody)
                      data = a1;
                    else
                      params = a1;
                    break;
                  case 0:
                    break;
                  default:
                    throw $resourceMinErr('badargs', 'Expected up to 4 arguments [params, data, success, error], got {0} arguments', arguments.length);
                }
                var isInstanceCall = this instanceof Resource;
                var value = isInstanceCall ? data : (action.isArray ? [] : new Resource(data));
                var httpConfig = {};
                var responseInterceptor = action.interceptor && action.interceptor.response || defaultResponseInterceptor;
                var responseErrorInterceptor = action.interceptor && action.interceptor.responseError || undefined;
                var hasError = !!error;
                var hasResponseErrorInterceptor = !!responseErrorInterceptor;
                var timeoutDeferred;
                var numericTimeoutPromise;
                forEach(action, function(value, key) {
                  switch (key) {
                    default:
                      httpConfig[key] = copy(value);
                      break;
                    case 'params':
                    case 'isArray':
                    case 'interceptor':
                    case 'cancellable':
                      break;
                  }
                });
                if (!isInstanceCall && cancellable) {
                  timeoutDeferred = $q.defer();
                  httpConfig.timeout = timeoutDeferred.promise;
                  if (numericTimeout) {
                    numericTimeoutPromise = $timeout(timeoutDeferred.resolve, numericTimeout);
                  }
                }
                if (hasBody)
                  httpConfig.data = data;
                route.setUrlParams(httpConfig, extend({}, extractParams(data, action.params || {}), params), action.url);
                var promise = $http(httpConfig).then(function(response) {
                  var data = response.data;
                  if (data) {
                    if (isArray(data) !== (!!action.isArray)) {
                      throw $resourceMinErr('badcfg', 'Error in resource configuration for action `{0}`. Expected response to ' + 'contain an {1} but got an {2} (Request: {3} {4})', name, action.isArray ? 'array' : 'object', isArray(data) ? 'array' : 'object', httpConfig.method, httpConfig.url);
                    }
                    if (action.isArray) {
                      value.length = 0;
                      forEach(data, function(item) {
                        if (typeof item === 'object') {
                          value.push(new Resource(item));
                        } else {
                          value.push(item);
                        }
                      });
                    } else {
                      var promise = value.$promise;
                      shallowClearAndCopy(data, value);
                      value.$promise = promise;
                    }
                  }
                  response.resource = value;
                  return response;
                }, function(response) {
                  response.resource = value;
                  return $q.reject(response);
                });
                promise = promise['finally'](function() {
                  value.$resolved = true;
                  if (!isInstanceCall && cancellable) {
                    value.$cancelRequest = noop;
                    $timeout.cancel(numericTimeoutPromise);
                    timeoutDeferred = numericTimeoutPromise = httpConfig.timeout = null;
                  }
                });
                promise = promise.then(function(response) {
                  var value = responseInterceptor(response);
                  (success || noop)(value, response.headers, response.status, response.statusText);
                  return value;
                }, (hasError || hasResponseErrorInterceptor) ? function(response) {
                  if (hasError && !hasResponseErrorInterceptor) {
                    promise.catch(noop);
                  }
                  if (hasError)
                    error(response);
                  return hasResponseErrorInterceptor ? responseErrorInterceptor(response) : $q.reject(response);
                } : undefined);
                if (!isInstanceCall) {
                  value.$promise = promise;
                  value.$resolved = false;
                  if (cancellable)
                    value.$cancelRequest = cancelRequest;
                  return value;
                }
                return promise;
                function cancelRequest(value) {
                  promise.catch(noop);
                  if (timeoutDeferred !== null) {
                    timeoutDeferred.resolve(value);
                  }
                }
              };
              Resource.prototype['$' + name] = function(params, success, error) {
                if (isFunction(params)) {
                  error = success;
                  success = params;
                  params = {};
                }
                var result = Resource[name].call(this, params, this, success, error);
                return result.$promise || result;
              };
            });
            return Resource;
          }
          return resourceFactory;
        }];
      });
    })(window, window.angular);
  })();
  return _retrieveGlobal();
});

$__System.registerDynamic("b", ["a"], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  $__require('a');
  module.exports = 'ngResource';
  return module.exports;
});

$__System.registerDynamic("c", ["3"], false, function($__require, $__exports, $__module) {
  var _retrieveGlobal = $__System.get("@@global-helpers").prepareGlobal($__module.id, null, null);
  (function() {
    (function(window, angular) {
      'use strict';
      angular.module('ngCookies', ['ng']).info({angularVersion: '1.6.9'}).provider('$cookies', [function $CookiesProvider() {
        var defaults = this.defaults = {};
        function calcOptions(options) {
          return options ? angular.extend({}, defaults, options) : defaults;
        }
        this.$get = ['$$cookieReader', '$$cookieWriter', function($$cookieReader, $$cookieWriter) {
          return {
            get: function(key) {
              return $$cookieReader()[key];
            },
            getObject: function(key) {
              var value = this.get(key);
              return value ? angular.fromJson(value) : value;
            },
            getAll: function() {
              return $$cookieReader();
            },
            put: function(key, value, options) {
              $$cookieWriter(key, value, calcOptions(options));
            },
            putObject: function(key, value, options) {
              this.put(key, angular.toJson(value), options);
            },
            remove: function(key, options) {
              $$cookieWriter(key, undefined, calcOptions(options));
            }
          };
        }];
      }]);
      angular.module('ngCookies').factory('$cookieStore', ['$cookies', function($cookies) {
        return {
          get: function(key) {
            return $cookies.getObject(key);
          },
          put: function(key, value) {
            $cookies.putObject(key, value);
          },
          remove: function(key) {
            $cookies.remove(key);
          }
        };
      }]);
      function $$CookieWriter($document, $log, $browser) {
        var cookiePath = $browser.baseHref();
        var rawDocument = $document[0];
        function buildCookieString(name, value, options) {
          var path,
              expires;
          options = options || {};
          expires = options.expires;
          path = angular.isDefined(options.path) ? options.path : cookiePath;
          if (angular.isUndefined(value)) {
            expires = 'Thu, 01 Jan 1970 00:00:00 GMT';
            value = '';
          }
          if (angular.isString(expires)) {
            expires = new Date(expires);
          }
          var str = encodeURIComponent(name) + '=' + encodeURIComponent(value);
          str += path ? ';path=' + path : '';
          str += options.domain ? ';domain=' + options.domain : '';
          str += expires ? ';expires=' + expires.toUTCString() : '';
          str += options.secure ? ';secure' : '';
          var cookieLength = str.length + 1;
          if (cookieLength > 4096) {
            $log.warn('Cookie \'' + name + '\' possibly not set or overflowed because it was too large (' + cookieLength + ' > 4096 bytes)!');
          }
          return str;
        }
        return function(name, value, options) {
          rawDocument.cookie = buildCookieString(name, value, options);
        };
      }
      $$CookieWriter.$inject = ['$document', '$log', '$browser'];
      angular.module('ngCookies').provider('$$cookieWriter', function $$CookieWriterProvider() {
        this.$get = $$CookieWriter;
      });
    })(window, window.angular);
  })();
  return _retrieveGlobal();
});

$__System.registerDynamic("d", ["c"], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  $__require('c');
  module.exports = 'ngCookies';
  return module.exports;
});

$__System.registerDynamic("e", [], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  (function(window, angular) {
    var isDefined = angular.isDefined,
        isUndefined = angular.isUndefined,
        isNumber = angular.isNumber,
        isObject = angular.isObject,
        isArray = angular.isArray,
        isString = angular.isString,
        extend = angular.extend,
        toJson = angular.toJson;
    angular.module('LocalStorageModule', []).provider('localStorageService', function() {
      this.prefix = 'ls';
      this.storageType = 'localStorage';
      this.cookie = {
        expiry: 30,
        path: '/',
        secure: false
      };
      this.defaultToCookie = true;
      this.notify = {
        setItem: true,
        removeItem: false
      };
      this.setPrefix = function(prefix) {
        this.prefix = prefix;
        return this;
      };
      this.setStorageType = function(storageType) {
        this.storageType = storageType;
        return this;
      };
      this.setDefaultToCookie = function(shouldDefault) {
        this.defaultToCookie = !!shouldDefault;
        return this;
      };
      this.setStorageCookie = function(exp, path, secure) {
        this.cookie.expiry = exp;
        this.cookie.path = path;
        this.cookie.secure = secure;
        return this;
      };
      this.setStorageCookieDomain = function(domain) {
        this.cookie.domain = domain;
        return this;
      };
      this.setNotify = function(itemSet, itemRemove) {
        this.notify = {
          setItem: itemSet,
          removeItem: itemRemove
        };
        return this;
      };
      this.$get = ['$rootScope', '$window', '$document', '$parse', '$timeout', function($rootScope, $window, $document, $parse, $timeout) {
        var self = this;
        var prefix = self.prefix;
        var cookie = self.cookie;
        var notify = self.notify;
        var storageType = self.storageType;
        var webStorage;
        if (!$document) {
          $document = document;
        } else if ($document[0]) {
          $document = $document[0];
        }
        if (prefix.substr(-1) !== '.') {
          prefix = !!prefix ? prefix + '.' : '';
        }
        var deriveQualifiedKey = function(key) {
          return prefix + key;
        };
        var underiveQualifiedKey = function(key) {
          return key.replace(new RegExp('^' + prefix, 'g'), '');
        };
        var isKeyPrefixOurs = function(key) {
          return key.indexOf(prefix) === 0;
        };
        var checkSupport = function() {
          try {
            var supported = (storageType in $window && $window[storageType] !== null);
            var key = deriveQualifiedKey('__' + Math.round(Math.random() * 1e7));
            if (supported) {
              webStorage = $window[storageType];
              webStorage.setItem(key, '');
              webStorage.removeItem(key);
            }
            return supported;
          } catch (e) {
            if (self.defaultToCookie)
              storageType = 'cookie';
            $rootScope.$broadcast('LocalStorageModule.notification.error', e.message);
            return false;
          }
        };
        var browserSupportsLocalStorage = checkSupport();
        var addToLocalStorage = function(key, value, type) {
          setStorageType(type);
          if (isUndefined(value)) {
            value = null;
          } else {
            value = toJson(value);
          }
          if (!browserSupportsLocalStorage && self.defaultToCookie || self.storageType === 'cookie') {
            if (!browserSupportsLocalStorage) {
              $rootScope.$broadcast('LocalStorageModule.notification.warning', 'LOCAL_STORAGE_NOT_SUPPORTED');
            }
            if (notify.setItem) {
              $rootScope.$broadcast('LocalStorageModule.notification.setitem', {
                key: key,
                newvalue: value,
                storageType: 'cookie'
              });
            }
            return addToCookies(key, value);
          }
          try {
            if (webStorage) {
              webStorage.setItem(deriveQualifiedKey(key), value);
            }
            if (notify.setItem) {
              $rootScope.$broadcast('LocalStorageModule.notification.setitem', {
                key: key,
                newvalue: value,
                storageType: self.storageType
              });
            }
          } catch (e) {
            $rootScope.$broadcast('LocalStorageModule.notification.error', e.message);
            return addToCookies(key, value);
          }
          return true;
        };
        var getFromLocalStorage = function(key, type) {
          setStorageType(type);
          if (!browserSupportsLocalStorage && self.defaultToCookie || self.storageType === 'cookie') {
            if (!browserSupportsLocalStorage) {
              $rootScope.$broadcast('LocalStorageModule.notification.warning', 'LOCAL_STORAGE_NOT_SUPPORTED');
            }
            return getFromCookies(key);
          }
          var item = webStorage ? webStorage.getItem(deriveQualifiedKey(key)) : null;
          if (!item || item === 'null') {
            return null;
          }
          try {
            return JSON.parse(item);
          } catch (e) {
            return item;
          }
        };
        var removeFromLocalStorage = function() {
          var consumed = 0;
          if (arguments.length >= 1 && (arguments[arguments.length - 1] === 'localStorage' || arguments[arguments.length - 1] === 'sessionStorage')) {
            consumed = 1;
            setStorageType(arguments[arguments.length - 1]);
          }
          var i,
              key;
          for (i = 0; i < arguments.length - consumed; i++) {
            key = arguments[i];
            if (!browserSupportsLocalStorage && self.defaultToCookie || self.storageType === 'cookie') {
              if (!browserSupportsLocalStorage) {
                $rootScope.$broadcast('LocalStorageModule.notification.warning', 'LOCAL_STORAGE_NOT_SUPPORTED');
              }
              if (notify.removeItem) {
                $rootScope.$broadcast('LocalStorageModule.notification.removeitem', {
                  key: key,
                  storageType: 'cookie'
                });
              }
              removeFromCookies(key);
            } else {
              try {
                webStorage.removeItem(deriveQualifiedKey(key));
                if (notify.removeItem) {
                  $rootScope.$broadcast('LocalStorageModule.notification.removeitem', {
                    key: key,
                    storageType: self.storageType
                  });
                }
              } catch (e) {
                $rootScope.$broadcast('LocalStorageModule.notification.error', e.message);
                removeFromCookies(key);
              }
            }
          }
        };
        var getKeysForLocalStorage = function(type) {
          setStorageType(type);
          if (!browserSupportsLocalStorage) {
            $rootScope.$broadcast('LocalStorageModule.notification.warning', 'LOCAL_STORAGE_NOT_SUPPORTED');
            return [];
          }
          var prefixLength = prefix.length;
          var keys = [];
          for (var key in webStorage) {
            if (key.substr(0, prefixLength) === prefix) {
              try {
                keys.push(key.substr(prefixLength));
              } catch (e) {
                $rootScope.$broadcast('LocalStorageModule.notification.error', e.Description);
                return [];
              }
            }
          }
          return keys;
        };
        var clearAllFromLocalStorage = function(regularExpression, type) {
          setStorageType(type);
          var prefixRegex = !!prefix ? new RegExp('^' + prefix) : new RegExp();
          var testRegex = !!regularExpression ? new RegExp(regularExpression) : new RegExp();
          if (!browserSupportsLocalStorage && self.defaultToCookie || self.storageType === 'cookie') {
            if (!browserSupportsLocalStorage) {
              $rootScope.$broadcast('LocalStorageModule.notification.warning', 'LOCAL_STORAGE_NOT_SUPPORTED');
            }
            return clearAllFromCookies();
          }
          if (!browserSupportsLocalStorage && !self.defaultToCookie)
            return false;
          var prefixLength = prefix.length;
          for (var key in webStorage) {
            if (prefixRegex.test(key) && testRegex.test(key.substr(prefixLength))) {
              try {
                removeFromLocalStorage(key.substr(prefixLength));
              } catch (e) {
                $rootScope.$broadcast('LocalStorageModule.notification.error', e.message);
                return clearAllFromCookies();
              }
            }
          }
          return true;
        };
        var browserSupportsCookies = (function() {
          try {
            return $window.navigator.cookieEnabled || ("cookie" in $document && ($document.cookie.length > 0 || ($document.cookie = "test").indexOf.call($document.cookie, "test") > -1));
          } catch (e) {
            $rootScope.$broadcast('LocalStorageModule.notification.error', e.message);
            return false;
          }
        }());
        var addToCookies = function(key, value, daysToExpiry, secure) {
          if (isUndefined(value)) {
            return false;
          } else if (isArray(value) || isObject(value)) {
            value = toJson(value);
          }
          if (!browserSupportsCookies) {
            $rootScope.$broadcast('LocalStorageModule.notification.error', 'COOKIES_NOT_SUPPORTED');
            return false;
          }
          try {
            var expiry = '',
                expiryDate = new Date(),
                cookieDomain = '';
            if (value === null) {
              expiryDate.setTime(expiryDate.getTime() + (-1 * 24 * 60 * 60 * 1000));
              expiry = "; expires=" + expiryDate.toGMTString();
              value = '';
            } else if (isNumber(daysToExpiry) && daysToExpiry !== 0) {
              expiryDate.setTime(expiryDate.getTime() + (daysToExpiry * 24 * 60 * 60 * 1000));
              expiry = "; expires=" + expiryDate.toGMTString();
            } else if (cookie.expiry !== 0) {
              expiryDate.setTime(expiryDate.getTime() + (cookie.expiry * 24 * 60 * 60 * 1000));
              expiry = "; expires=" + expiryDate.toGMTString();
            }
            if (!!key) {
              var cookiePath = "; path=" + cookie.path;
              if (cookie.domain) {
                cookieDomain = "; domain=" + cookie.domain;
              }
              if (typeof secure === 'boolean') {
                if (secure === true) {
                  cookieDomain += "; secure";
                }
              } else if (cookie.secure === true) {
                cookieDomain += "; secure";
              }
              $document.cookie = deriveQualifiedKey(key) + "=" + encodeURIComponent(value) + expiry + cookiePath + cookieDomain;
            }
          } catch (e) {
            $rootScope.$broadcast('LocalStorageModule.notification.error', e.message);
            return false;
          }
          return true;
        };
        var getFromCookies = function(key) {
          if (!browserSupportsCookies) {
            $rootScope.$broadcast('LocalStorageModule.notification.error', 'COOKIES_NOT_SUPPORTED');
            return false;
          }
          var cookies = $document.cookie && $document.cookie.split(';') || [];
          for (var i = 0; i < cookies.length; i++) {
            var thisCookie = cookies[i];
            while (thisCookie.charAt(0) === ' ') {
              thisCookie = thisCookie.substring(1, thisCookie.length);
            }
            if (thisCookie.indexOf(deriveQualifiedKey(key) + '=') === 0) {
              var storedValues = decodeURIComponent(thisCookie.substring(prefix.length + key.length + 1, thisCookie.length));
              try {
                var parsedValue = JSON.parse(storedValues);
                return typeof(parsedValue) === 'number' ? storedValues : parsedValue;
              } catch (e) {
                return storedValues;
              }
            }
          }
          return null;
        };
        var removeFromCookies = function(key) {
          addToCookies(key, null);
        };
        var clearAllFromCookies = function() {
          var thisCookie = null;
          var prefixLength = prefix.length;
          var cookies = $document.cookie.split(';');
          for (var i = 0; i < cookies.length; i++) {
            thisCookie = cookies[i];
            while (thisCookie.charAt(0) === ' ') {
              thisCookie = thisCookie.substring(1, thisCookie.length);
            }
            var key = thisCookie.substring(prefixLength, thisCookie.indexOf('='));
            removeFromCookies(key);
          }
        };
        var getStorageType = function() {
          return storageType;
        };
        var setStorageType = function(type) {
          if (type && storageType !== type) {
            storageType = type;
            browserSupportsLocalStorage = checkSupport();
          }
          return browserSupportsLocalStorage;
        };
        var bindToScope = function(scope, key, def, lsKey, type) {
          lsKey = lsKey || key;
          var value = getFromLocalStorage(lsKey, type);
          if (value === null && isDefined(def)) {
            value = def;
          } else if (isObject(value) && isObject(def)) {
            value = extend(value, def);
          }
          $parse(key).assign(scope, value);
          return scope.$watch(key, function(newVal) {
            addToLocalStorage(lsKey, newVal, type);
          }, isObject(scope[key]));
        };
        if (browserSupportsLocalStorage) {
          if ($window.addEventListener) {
            $window.addEventListener("storage", handleStorageChangeCallback, false);
            $rootScope.$on('$destroy', function() {
              $window.removeEventListener("storage", handleStorageChangeCallback);
            });
          } else if ($window.attachEvent) {
            $window.attachEvent("onstorage", handleStorageChangeCallback);
            $rootScope.$on('$destroy', function() {
              $window.detachEvent("onstorage", handleStorageChangeCallback);
            });
          }
        }
        function handleStorageChangeCallback(e) {
          if (!e) {
            e = $window.event;
          }
          if (notify.setItem) {
            if (isString(e.key) && isKeyPrefixOurs(e.key)) {
              var key = underiveQualifiedKey(e.key);
              $timeout(function() {
                $rootScope.$broadcast('LocalStorageModule.notification.changed', {
                  key: key,
                  newvalue: e.newValue,
                  storageType: self.storageType
                });
              });
            }
          }
        }
        var lengthOfLocalStorage = function(type) {
          setStorageType(type);
          var count = 0;
          var storage = $window[storageType];
          for (var i = 0; i < storage.length; i++) {
            if (storage.key(i).indexOf(prefix) === 0) {
              count++;
            }
          }
          return count;
        };
        return {
          isSupported: browserSupportsLocalStorage,
          getStorageType: getStorageType,
          setStorageType: setStorageType,
          set: addToLocalStorage,
          add: addToLocalStorage,
          get: getFromLocalStorage,
          keys: getKeysForLocalStorage,
          remove: removeFromLocalStorage,
          clearAll: clearAllFromLocalStorage,
          bind: bindToScope,
          deriveKey: deriveQualifiedKey,
          underiveKey: underiveQualifiedKey,
          length: lengthOfLocalStorage,
          defaultToCookie: this.defaultToCookie,
          cookie: {
            isSupported: browserSupportsCookies,
            set: addToCookies,
            add: addToCookies,
            get: getFromCookies,
            remove: removeFromCookies,
            clearAll: clearAllFromCookies
          }
        };
      }];
    });
  })(window, window.angular);
  return module.exports;
});

$__System.registerDynamic("f", ["e"], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  $__require('e');
  module.exports = 'LocalStorageModule';
  return module.exports;
});

$__System.registerDynamic("10", [], false, function($__require, $__exports, $__module) {
  var _retrieveGlobal = $__System.get("@@global-helpers").prepareGlobal($__module.id, null, null);
  (function() {
    'use strict';
    angular.module('slickCarousel', []).constant('slickCarouselConfig', {
      method: {},
      event: {}
    }).directive('slick', ['$timeout', 'slickCarouselConfig', function($timeout, slickCarouselConfig) {
      var slickMethodList,
          slickEventList;
      slickMethodList = ['slickGoTo', 'slickNext', 'slickPrev', 'slickPause', 'slickPlay', 'slickAdd', 'slickRemove', 'slickFilter', 'slickUnfilter', 'unslick'];
      slickEventList = ['afterChange', 'beforeChange', 'breakpoint', 'destroy', 'edge', 'init', 'reInit', 'setPosition', 'swipe', 'lazyLoaded', 'lazyLoadError'];
      return {
        scope: {
          settings: '=',
          enabled: '@',
          accessibility: '@',
          adaptiveHeight: '@',
          autoplay: '@',
          autoplaySpeed: '@',
          arrows: '@',
          asNavFor: '@',
          appendArrows: '@',
          prevArrow: '@',
          nextArrow: '@',
          centerMode: '@',
          centerPadding: '@',
          cssEase: '@',
          customPaging: '&',
          dots: '@',
          draggable: '@',
          fade: '@',
          focusOnSelect: '@',
          easing: '@',
          edgeFriction: '@',
          infinite: '@',
          initialSlide: '@',
          lazyLoad: '@',
          mobileFirst: '@',
          pauseOnHover: '@',
          pauseOnDotsHover: '@',
          respondTo: '@',
          responsive: '=?',
          rows: '@',
          slide: '@',
          slidesPerRow: '@',
          slidesToShow: '@',
          slidesToScroll: '@',
          speed: '@',
          swipe: '@',
          swipeToSlide: '@',
          touchMove: '@',
          touchThreshold: '@',
          useCSS: '@',
          variableWidth: '@',
          vertical: '@',
          verticalSwiping: '@',
          rtl: '@'
        },
        restrict: 'AE',
        link: function(scope, element, attr) {
          angular.element(element).css('display', 'none');
          var options,
              initOptions,
              destroy,
              init,
              destroyAndInit,
              currentIndex;
          initOptions = function() {
            options = angular.extend(angular.copy(slickCarouselConfig), {
              enabled: scope.enabled !== 'false',
              accessibility: scope.accessibility !== 'false',
              adaptiveHeight: scope.adaptiveHeight === 'true',
              autoplay: scope.autoplay === 'true',
              autoplaySpeed: scope.autoplaySpeed != null ? parseInt(scope.autoplaySpeed, 10) : 3000,
              arrows: scope.arrows !== 'false',
              asNavFor: scope.asNavFor ? scope.asNavFor : void 0,
              appendArrows: scope.appendArrows ? angular.element(scope.appendArrows) : angular.element(element),
              prevArrow: scope.prevArrow ? angular.element(scope.prevArrow) : void 0,
              nextArrow: scope.nextArrow ? angular.element(scope.nextArrow) : void 0,
              centerMode: scope.centerMode === 'true',
              centerPadding: scope.centerPadding || '50px',
              cssEase: scope.cssEase || 'ease',
              customPaging: attr.customPaging ? function(slick, index) {
                return scope.customPaging({
                  slick: slick,
                  index: index
                });
              } : void 0,
              dots: scope.dots === 'true',
              draggable: scope.draggable !== 'false',
              fade: scope.fade === 'true',
              focusOnSelect: scope.focusOnSelect === 'true',
              easing: scope.easing || 'linear',
              edgeFriction: scope.edgeFriction || 0.15,
              infinite: scope.infinite !== 'false',
              initialSlide: parseInt(scope.initialSlide) || 0,
              lazyLoad: scope.lazyLoad || 'ondemand',
              mobileFirst: scope.mobileFirst === 'true',
              pauseOnHover: scope.pauseOnHover !== 'false',
              pauseOnDotsHover: scope.pauseOnDotsHover === "true",
              respondTo: scope.respondTo != null ? scope.respondTo : 'window',
              responsive: scope.responsive || void 0,
              rows: scope.rows != null ? parseInt(scope.rows, 10) : 1,
              slide: scope.slide || '',
              slidesPerRow: scope.slidesPerRow != null ? parseInt(scope.slidesPerRow, 10) : 1,
              slidesToShow: scope.slidesToShow != null ? parseInt(scope.slidesToShow, 10) : 1,
              slidesToScroll: scope.slidesToScroll != null ? parseInt(scope.slidesToScroll, 10) : 1,
              speed: scope.speed != null ? parseInt(scope.speed, 10) : 300,
              swipe: scope.swipe !== 'false',
              swipeToSlide: scope.swipeToSlide === 'true',
              touchMove: scope.touchMove !== 'false',
              touchThreshold: scope.touchThreshold ? parseInt(scope.touchThreshold, 10) : 5,
              useCSS: scope.useCSS !== 'false',
              variableWidth: scope.variableWidth === 'true',
              vertical: scope.vertical === 'true',
              verticalSwiping: scope.verticalSwiping === 'true',
              rtl: scope.rtl === 'true'
            }, scope.settings);
          };
          destroy = function() {
            var slickness = angular.element(element);
            if (slickness.hasClass('slick-initialized')) {
              slickness.remove('slick-list');
              slickness.slick('unslick');
            }
            return slickness;
          };
          init = function() {
            initOptions();
            var slickness = angular.element(element);
            if (angular.element(element).hasClass('slick-initialized')) {
              if (options.enabled) {
                return slickness.slick('getSlick');
              } else {
                destroy();
              }
            } else {
              if (!options.enabled) {
                return;
              }
              slickness.on('init', function(event, slick) {
                if (typeof options.event.init !== 'undefined') {
                  options.event.init(event, slick);
                }
                if (typeof currentIndex !== 'undefined') {
                  return slick.slideHandler(currentIndex);
                }
              });
              $timeout(function() {
                angular.element(element).css('display', 'block');
                slickness.not('.slick-initialized').slick(options);
              });
            }
            scope.internalControl = options.method || {};
            slickMethodList.forEach(function(value) {
              scope.internalControl[value] = function() {
                var args;
                args = Array.prototype.slice.call(arguments);
                args.unshift(value);
                slickness.slick.apply(element, args);
              };
            });
            slickness.on('afterChange', function(event, slick, currentSlide) {
              currentIndex = currentSlide;
              if (typeof options.event.afterChange !== 'undefined') {
                $timeout(function() {
                  scope.$apply(function() {
                    options.event.afterChange(event, slick, currentSlide);
                  });
                });
              }
            });
            slickness.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
              if (typeof options.event.beforeChange !== 'undefined') {
                $timeout(function() {
                  $timeout(function() {
                    scope.$apply(function() {
                      options.event.beforeChange(event, slick, currentSlide, nextSlide);
                    });
                  });
                });
              }
            });
            slickness.on('reInit', function(event, slick) {
              if (typeof options.event.reInit !== 'undefined') {
                $timeout(function() {
                  scope.$apply(function() {
                    options.event.reInit(event, slick);
                  });
                });
              }
            });
            if (typeof options.event.breakpoint !== 'undefined') {
              slickness.on('breakpoint', function(event, slick, breakpoint) {
                $timeout(function() {
                  scope.$apply(function() {
                    options.event.breakpoint(event, slick, breakpoint);
                  });
                });
              });
            }
            if (typeof options.event.destroy !== 'undefined') {
              slickness.on('destroy', function(event, slick) {
                $timeout(function() {
                  scope.$apply(function() {
                    options.event.destroy(event, slick);
                  });
                });
              });
            }
            if (typeof options.event.edge !== 'undefined') {
              slickness.on('edge', function(event, slick, direction) {
                $timeout(function() {
                  scope.$apply(function() {
                    options.event.edge(event, slick, direction);
                  });
                });
              });
            }
            if (typeof options.event.setPosition !== 'undefined') {
              slickness.on('setPosition', function(event, slick) {
                $timeout(function() {
                  scope.$apply(function() {
                    options.event.setPosition(event, slick);
                  });
                });
              });
            }
            if (typeof options.event.swipe !== 'undefined') {
              slickness.on('swipe', function(event, slick, direction) {
                $timeout(function() {
                  scope.$apply(function() {
                    options.event.swipe(event, slick, direction);
                  });
                });
              });
            }
            if (typeof options.event.lazyLoaded !== 'undefined') {
              slickness.on('lazyLoaded', function(event, slick, image, imageSource) {
                $timeout(function() {
                  scope.$apply(function() {
                    options.event.lazyLoaded(event, slick, image, imageSource);
                  });
                });
              });
            }
            if (typeof options.event.lazyLoadError !== 'undefined') {
              slickness.on('lazyLoadError', function(event, slick, image, imageSource) {
                $timeout(function() {
                  scope.$apply(function() {
                    options.event.lazyLoadError(event, slick, image, imageSource);
                  });
                });
              });
            }
          };
          destroyAndInit = function() {
            destroy();
            init();
          };
          element.one('$destroy', function() {
            destroy();
          });
          return scope.$watch('settings', function(newVal, oldVal) {
            if (newVal !== null) {
              return destroyAndInit();
            }
          }, true);
        }
      };
    }]);
  })();
  return _retrieveGlobal();
});

$__System.registerDynamic("11", ["3"], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  (function(root, factory) {
    if (typeof define === 'function' && define.amd) {
      define(['angular'], factory);
    } else if (typeof exports === 'object') {
      module.exports = factory($__require('3'));
    } else {
      root.returnExports = factory(root.angular);
    }
  }(this, function(angular) {
    return angular.module('ngMeta', []).provider('ngMeta', function() {
      'use strict';
      var defaults = {};
      var config = {useTitleSuffix: false};
      function Meta($rootScope, $injector) {
        var setTitle = function(title, titleSuffix) {
          if (!$rootScope.ngMeta) {
            throw new Error('Cannot call setTitle when ngMeta is undefined. Did you forget to call ngMeta.init() in the run block? \nRefer: https://github.com/vinaygopinath/ngMeta#getting-started');
          }
          $rootScope.ngMeta.title = angular.isDefined(title) ? title : (defaults.title || '');
          if (config.useTitleSuffix) {
            $rootScope.ngMeta.title += angular.isDefined(titleSuffix) ? titleSuffix : (defaults.titleSuffix || '');
          }
          return this;
        };
        var setTag = function(tag, value) {
          if (!$rootScope.ngMeta) {
            throw new Error('Cannot call setTag when ngMeta is undefined. Did you forget to call ngMeta.init() in the run block? \nRefer: https://github.com/vinaygopinath/ngMeta#getting-started');
          }
          if (tag === 'title' || tag === 'titleSuffix') {
            throw new Error('Attempt to set \'' + tag + '\' through \'setTag\': \'title\' and \'titleSuffix\' are reserved tag names. Please use \'ngMeta.setTitle\' instead');
          }
          $rootScope.ngMeta[tag] = angular.isDefined(value) ? value : defaults[tag];
          return this;
        };
        var setDefaultTag = function(tag, value) {
          if (!$rootScope.ngMeta) {
            throw new Error('Cannot call setDefaultTag when ngMeta is undefined. Did you forget to call ngMeta.init() in the run block? \nRefer: https://github.com/vinaygopinath/ngMeta#getting-started');
          }
          defaults[tag] = value;
          if (tag === 'title' || tag === 'titleSuffix') {
            this.setTitle($rootScope.ngMeta.title, $rootScope.ngMeta.titleSuffix);
          } else {
            this.setTag(tag, $rootScope.ngMeta[tag]);
          }
          return this;
        };
        var readRouteMeta = function(meta) {
          meta = meta || {};
          if (meta.disableUpdate) {
            return false;
          }
          setTitle(meta.title, meta.titleSuffix);
          var def = angular.copy(defaults);
          delete meta.title;
          delete meta.titleSuffix;
          delete def.title;
          delete def.titleSuffix;
          var metaKeys = Object.keys(meta);
          for (var i = 0; i < metaKeys.length; i++) {
            if (def.hasOwnProperty(metaKeys[i])) {
              delete def[metaKeys[i]];
            }
            setTag(metaKeys[i], meta[metaKeys[i]]);
          }
          var defaultKeys = Object.keys(def);
          for (var j = 0; j < defaultKeys.length; j++) {
            setTag(defaultKeys[j], def[defaultKeys[j]]);
          }
        };
        var update = function(event, current) {
          readRouteMeta(angular.copy(current.meta || (current.data && current.data.meta)));
        };
        var init = function() {
          $rootScope.ngMeta = {};
          $rootScope.$on('$routeChangeSuccess', update);
          $rootScope.$on('$stateChangeSuccess', update);
          if ($injector.has('$transitions')) {
            var $transitions = $injector.get('$transitions');
            $transitions.onSuccess({}, function(transition) {
              update(null, transition.$to());
            });
          }
        };
        return {
          'init': init,
          'setTitle': setTitle,
          'setTag': setTag,
          'setDefaultTag': setDefaultTag
        };
      }
      this.setDefaultTitle = function(titleStr) {
        defaults.title = titleStr;
        return this;
      };
      this.setDefaultTitleSuffix = function(titleSuffix) {
        defaults.titleSuffix = titleSuffix;
        return this;
      };
      this.setDefaultTag = function(tag, value) {
        defaults[tag] = value;
        return this;
      };
      this.useTitleSuffix = function(bool) {
        config.useTitleSuffix = !!bool;
        return this;
      };
      this.mergeNestedStateData = function(state, parentDecoratorFn) {
        var originalData = parentDecoratorFn(state) || {};
        var parentMetaData = state.parent && state.parent.data && state.parent.data.meta;
        if (originalData.meta || parentMetaData) {
          var mergedMeta = angular.merge({}, parentMetaData, originalData.meta);
          originalData.meta = mergedMeta;
        }
        state.self.data = originalData;
        return originalData;
      };
      this.$get = ["$rootScope", "$injector", function($rootScope, $injector) {
        return new Meta($rootScope, $injector);
      }];
    });
  }));
  return module.exports;
});

$__System.register('12', [], function (_export, _context) {
  "use strict";

  var appRun;
  return {
    setters: [],
    execute: function () {
      appRun = function appRun(ngMeta) {
        ngMeta.init();
      };

      appRun.$inject = ['ngMeta'];

      _export('default', appRun);
    }
  };
});
$__System.register('13', [], function (_export, _context) {
  "use strict";

  var coreConfig;
  return {
    setters: [],
    execute: function () {
      coreConfig = function coreConfig($httpProvider, ngMetaProvider) {
        $httpProvider.interceptors.push(['$q', '$rootScope', function ($q) {
          return {
            responseError: function responseError(rejection) {
              if (rejection.status === 401) {
                console.log('401');
              }

              if (rejection.status === 403) {
                console.log('403');
              }

              return $q.reject(rejection);
            }
          };
        }]);

        //Add a suffix to all page titles
        ngMetaProvider.useTitleSuffix(true);
        ngMetaProvider.setDefaultTitle('MusicMap');
        ngMetaProvider.setDefaultTag('description', null);
        ngMetaProvider.setDefaultTag('og:image', null);
      };

      coreConfig.$inject = ['$httpProvider', 'ngMetaProvider'];

      _export('default', coreConfig);
    }
  };
});
$__System.register('14', [], function (_export, _context) {
  "use strict";

  var SettingsConstants;
  return {
    setters: [],
    execute: function () {
      SettingsConstants = {
        backendHost: 'https://app.musicmap.global/json'
      };

      _export('default', SettingsConstants);
    }
  };
});
$__System.register('15', ['3', '9', 'b', 'd', 'f', '10', '11', '12', '13', '14'], function (_export, _context) {
  "use strict";

  var angular, coreRun, coreConfig, SettingsConstants, coreModule;
  return {
    setters: [function (_) {
      angular = _.default;
    }, function (_2) {}, function (_b) {}, function (_d) {}, function (_f) {}, function (_3) {}, function (_4) {}, function (_5) {
      coreRun = _5.default;
    }, function (_6) {
      coreConfig = _6.default;
    }, function (_7) {
      SettingsConstants = _7.default;
    }],
    execute: function () {
      coreModule = angular.module('app.core', ['ui.router', 'ngResource', 'ngCookies', 'LocalStorageModule', 'slickCarousel', 'ngMeta'])
      /**
       * Body controller.
       */
      .controller('body', ['$scope', '$rootScope', '$state', '$http', '$cookies', '$window', '$location', '$httpParamSerializer', 'Settings', 'ngMeta', function ($scope, $rootScope, $state, $http, $cookies, $window, $location, $httpParamSerializer, Settings, ngMeta) {
        'use strict';

        /**
         * Initialize global variables.
         */

        $scope.categories = {};
        $scope.continents = {};

        /**
         * Article categories.
         */
        $scope.featuredCategoryId = 1;
        $scope.mixesCategoryId = 2;
        $scope.newsCategoryId = 3;

        $scope.cookieFavorites = [];
        $scope.favoriteArticles = [];

        /**
         * Default Slick carousel configuration.
         *
         * Cannot use `responsive` due to known issue at https://github.com/devmark/angular-slick-carousel/issues/55
         */
        var width = $window.innerWidth;
        var slickConfig = {
          slidesToShow: 1,
          arrows: true,
          infinite: false
        };

        if (width > 495) {
          slickConfig.slidesToShow = 2;
        }

        $scope.slickConfig = slickConfig;

        /**
         * Player collapsed flag.
         */
        $rootScope.playerCollapsed = false;

        /**
         * Cookie policy modal.
         */
        $rootScope.cookiesAgreed = !!$cookies.get('cookies');
        $rootScope.agreeCookies = function () {
          // Cookie helpers
          var now = new Date();
          var exp = new Date(now.getTime() + 1000 * 60 * 60 * 24 * 30); // 30 days

          $cookies.put('cookies', '1', {
            'path': '/',
            'expires': exp
          });
          $rootScope.cookiesAgreed = true;
        };

        /**
         * Default meta.
         */
        $rootScope.meta = {
          'title': 'MusicMap',
          'image': null,
          'description': 'MusicMap'
        };

        /**
         * Outline thickness of map points so the gaps are selectable.
         */
        $rootScope.mapPointOutlineThickness = 5;

        /**
         * Width under which the client is considered mobile.
         */
        $rootScope.mobileBreakdown = 767;

        /**
         * Map point size depending on screen width.
         */
        $rootScope.mapPointSize = function (continent) {
          if (typeof continent === 'undefined') {
            continent = false;
          }

          // Screen size
          var width = $window.innerWidth;
          var height = $window.innerHeight;

          // Default size (1204px +)
          var size = 4;

          // Big screens (more than fullHD)
          if (width > 1920) {
            size = 11;

            // Weird aspect ratio, such as 2560x1080px
            if (height < 1090) {
              size = 8.2;
            }
          }
          // larger screens (up to fullHD)
          else if (width > 1366) {
              size = 6;
            }

          // Reduce point size for continent views
          if (continent) {
            size = Math.round(size / 3 * 10) / 10;
          }

          return size;
        };

        /**
         * Track navigation history for article 'back' button.
         */
        $rootScope.history = [];
        $rootScope.$on('$locationChangeSuccess', function () {
          $rootScope.history.push($location.$$path);
        });

        /**
         * Jump to a country from quick search.
         */
        $rootScope.jumpToCountry = function (country) {
          $state.go('musicmap.country', { alpha2: country.alpha2 });
        };

        /**
         * Fetch article categories.
         */
        $scope.getCategories = function () {
          $http({
            url: Settings.backendHost + '/article_categories.php',
            method: 'GET'
          }).then(function (response) {
            $scope.categories = response.data;
          }, function (error) {
            console.log('Error while fetching categories');
          });
        };

        /**
         * Fetch continents.
         */
        $scope.getContinents = function () {
          $http({
            url: Settings.backendHost + '/continents.php',
            method: 'GET'
          }).then(function (response) {
            $scope.continents = response.data;
          }, function (error) {
            console.log('Error while fetching continents');
          });
        };

        /**
         * Get articles IDs which are favorites from cookies.
         */
        $scope.getFavoritesFromCookies = function () {
          var favorites = $cookies.getObject('favorites');

          // Initialize favorites if none set yet
          if (typeof favorites === 'undefined') {
            favorites = [];
          }

          $scope.cookieFavorites = favorites;
        };

        /**
         * Check if an article is in favorites.
         *
         * @param articleId
         */
        $scope.isFavorite = function (articleId) {
          articleId = parseInt(articleId);

          return $scope.cookieFavorites.indexOf(articleId) >= 0;
        };

        /**
         * Toggle an article to or from favorites.
         *
         * @param articleId
         */
        $scope.toggleFavorite = function (articleId) {
          articleId = parseInt(articleId);

          var index = $scope.cookieFavorites.indexOf(articleId);

          // Add to favorites
          if (index < 0) {
            $scope.cookieFavorites.push(articleId);
          }
          // or remove from favorites
          else {
              $scope.cookieFavorites.splice(index, 1);
            }

          $cookies.putObject('favorites', $scope.cookieFavorites);

          var refreshFavoritesCarousel = false;

          // If the last favorite is removed while on favorite view, switch back to featured
          if ($rootScope.homepageArticlesMode === 'favorites') {
            if (!$scope.cookieFavorites.length) {
              $rootScope.homepageArticlesMode = 'featured';
            }

            refreshFavoritesCarousel = true;
          }

          $scope.getFavoriteArticles(refreshFavoritesCarousel);
        };

        /**
         * Get favorite articles.
         */
        $scope.getFavoriteArticles = function (refreshFavoritesCarousel) {
          if (refreshFavoritesCarousel) {
            $rootScope.favoriteArticlesLoaded = false;
          }

          // No favorites :(
          if (!$scope.cookieFavorites.length) {
            $scope.favoriteArticles = [];
            $rootScope.favoriteArticlesLoaded = true;

            return;
          }

          $http({
            url: Settings.backendHost + '/articles.php?id=' + $scope.cookieFavorites.join(',') + '&per_page=1000',
            method: 'GET'
          }).then(function (response) {
            $scope.favoriteArticles = response.data.articles;

            var refreshTimeout = refreshFavoritesCarousel ? 100 : 1;

            setTimeout(function () {
              $rootScope.favoriteArticlesLoaded = true;
            }, refreshTimeout);
          }, function (error) {
            console.log('Error while fetching favorite articles');
          });
        };

        /**
         * Social share article to Facebook & Twitter
         * @param media
         */
        $scope.socialShare = function (media) {
          var url = $location.absUrl();
          url = encodeURIComponent(url);

          if (media === 'facebook') {
            url = 'https://www.facebook.com/sharer/sharer.php?u=' + url;
          } else {
            url = 'https://twitter.com/home?status=' + url;
          }

          $window.open(url, '_blank');
        };

        /**
         * Initialize project.
         */
        $scope.getFavoritesFromCookies();
        $scope.getFavoriteArticles(false);
        $scope.getCategories();
        $scope.getContinents();
      }]).filter('removeHTMLTags', function () {
        return function (text) {
          return text ? String(text).replace(/<[^>]+>/gm, '') : '';
        };
      }).filter('implodeCountries', function () {
        return function (countries) {
          var imploded = [];

          angular.forEach(countries, function (country) {
            imploded.push(country.name);
          });

          return imploded.length ? imploded.join(', ') : 'N/A';
        };
      }).filter('slug', function () {
        return function (text) {
          return text.toString().toLowerCase().replace(/\s+/g, '-') // Replace spaces with -
          .replace(/[^\w\-]+/g, '') // Remove all non-word chars
          .replace(/\-\-+/g, '-') // Replace multiple - with single -
          .replace(/^-+/, '') // Trim - from start of text
          .replace(/-+$/, ''); // Trim - from end of text;
        };
      }).filter('trusted', ['$sce', function ($sce) {
        return function (text) {
          return $sce.trustAsHtml(text);
        };
      }]).filter('unsafe', function ($sce) {
        return $sce.trustAsHtml;
      }).filter('maxLength', function () {
        return function (string, length) {
          if (string.length <= length) {
            return string;
          }

          return string.substring(0, length) + '...';
        };
      }).run(coreRun).config(coreConfig).constant('Settings', SettingsConstants);

      _export('default', coreModule);
    }
  };
});
$__System.register('16', [], function (_export, _context) {
  "use strict";

  /** @ngInject */
  function routesConfig($stateProvider, $urlRouterProvider, $locationProvider) {
    $locationProvider.html5Mode(true);
    $locationProvider.hashPrefix('');

    $urlRouterProvider.otherwise('/');

    $stateProvider
    // Website routes
    .state('musicmap', {
      views: {
        'player': {
          templateUrl: 'views/player.html'
        },
        'content': {
          template: '<div ui-view></div>'
        }
      }
    }).state('musicmap.homepage', {
      url: '/',
      templateUrl: 'views/homepage.html'
    }).state('musicmap.continent', {
      url: '/continent/:name',
      templateUrl: 'views/continent.html'
    }).state('musicmap.country', {
      url: '/country/:alpha2',
      templateUrl: 'views/country.html'
    }).state('musicmap.category', {
      url: '/category/:name/:id',
      templateUrl: 'views/category.html'
    }).state('musicmap.article', {
      url: '/article/:path',
      templateUrl: 'views/article.html'
    })

    // CMS pages
    .state('page', {
      views: {
        'content': {
          template: '<div ui-view></div>'
        }
      }
    }).state('page.privacy', {
      url: '/page/privacy-policy',
      templateUrl: 'views/privacy-policy.html'
    }).state('page.about', {
      url: '/page/about',
      templateUrl: 'views/about.html'
    }).state('page.artists', {
      url: '/page/artists',
      templateUrl: 'views/artists.html'
    }).state('page.services', {
      url: '/page/services',
      templateUrl: 'views/services.html'
    }).state('page.contact', {
      url: '/page/contact',
      templateUrl: 'views/contact.html'
    })

    // Embedded playlists
    .state('embed', {
      views: {
        'player': {
          templateUrl: 'views/embed.html'
        }
      }
    }).state('embed.continent', {
      url: '/embed/continent/:name'
    }).state('embed.country', {
      url: '/embed/country/:alpha2'
    });
  }

  return {
    setters: [],
    execute: function () {
      _export('default', routesConfig);

      routesConfig.$inject = ['$stateProvider', '$urlRouterProvider', '$locationProvider'];
    }
  };
});
$__System.register('17', ['3', '16'], function (_export, _context) {
  "use strict";

  var angular, routesConfig, routesModule;
  return {
    setters: [function (_) {
      angular = _.default;
    }, function (_2) {
      routesConfig = _2.default;
    }],
    execute: function () {
      routesModule = angular.module('app.routes', []).config(routesConfig);

      _export('default', routesModule);
    }
  };
});
$__System.register('18', [], function (_export, _context) {
  "use strict";

  var HomepageController;
  return {
    setters: [],
    execute: function () {
      HomepageController = function HomepageController($rootScope, $scope, $http, $state, $window, $cookies, Settings) {
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$http = $http;
        this.Settings = Settings;

        /**
         * Initialize variables.
         */
        $scope.countries = [];
        $scope.featuredArticles = [];
        $scope.homepageArticles = [];
        $rootScope.homepageArticlesMode = 'featured';
        $scope.featuredArticlesLoaded = false;
        $scope.aboutOpened = false;
        $scope.focusCountry = false;
        $scope.bubblesOpened = !$cookies.get('bubbles');

        /**
         * Slick carousel configuration.
         *
         * Cannot use `responsive` due to known issue at https://github.com/devmark/angular-slick-carousel/issues/55
         */
        var width = $window.innerWidth;
        var homepageSlickConfig = {
          slidesToShow: 1,
          arrows: true,
          infinite: false
        };

        if (width > 660) {
          homepageSlickConfig.slidesToShow = 2;
        }

        if (width > 1023) {
          homepageSlickConfig.slidesToShow = 3;
        }

        if (width > 1024) {
          homepageSlickConfig.slidesToShow = 4;
        }
        if (width > 1320) {
          homepageSlickConfig.slidesToShow = 5;
        }

        $scope.homepageSlickConfig = homepageSlickConfig;

        /**
         * Close buubbles.
         */
        $scope.closeBubbles = function () {
          $scope.bubblesOpened = false;

          // Cookie helpers
          var now = new Date();
          var exp = new Date(now.getTime() + 1000 * 60 * 60 * 24 * 30); // 30 days

          $cookies.put('bubbles', '1', {
            'path': '/',
            'expires': exp
          });
        };

        /**
         * Map.
         */
        $scope.map = null;

        /**
         * Continents.
         */
        $scope.continents = {
          'EU': 'Europe',
          'OC': 'Oceania',
          'AF': 'Africa',
          'NA': 'North America',
          'SA': 'South America',
          'AS': 'Asia'
        };

        /**
         * Default meta
         */
        $rootScope.meta = {
          'title': 'MusicMap',
          'image': null,
          'description': 'Discover The World One Track At A Time'
        };

        /**
         * Toggle homepage articles between favorites and featured.
         */
        $scope.toggleHomepageArticles = function () {
          // Switch to favorites
          if ($rootScope.homepageArticlesMode === 'featured' && $scope.cookieFavorites.length) {
            $rootScope.favoriteArticlesLoaded = false;
            $rootScope.homepageArticlesMode = 'favorites';

            setTimeout(function () {
              $rootScope.favoriteArticlesLoaded = true;
            }, 400);
          }
          // or switch to featured
          else if ($rootScope.homepageArticlesMode === 'favorites') {
              $scope.featuredArticlesLoaded = false;
              $rootScope.homepageArticlesMode = 'featured';

              setTimeout(function () {
                $scope.featuredArticlesLoaded = true;
              }, 400);
            }
        };

        /**
         * Handle map resize.
         */
        $(window).resize(function () {
          // Ignore for mobile
          if (!$scope.map) {
            return;
          }

          // Get map point size
          var pointSize = $rootScope.mapPointSize();

          // Update pixels size
          angular.forEach($scope.map.dataProvider.images, function (point, key) {
            $scope.map.dataProvider.images[key].width = pointSize;
            $scope.map.dataProvider.images[key].height = pointSize;
          });
        });

        /**
         * Initialize world map with continents.
         */
        $scope.initMap = function () {
          // Loading map animation
          $('#map').addClass('spinner');

          // Get map point size
          var pointSize = $rootScope.mapPointSize(false);

          $http({
            url: '/scripts/libraries/map/data/continents.json',
            method: 'GET'
          }).then(function (response) {
            var data = response.data;

            // Update pixels data
            angular.forEach(data.dataProvider.images, function (point, key) {
              data.dataProvider.images[key].width = pointSize;
              data.dataProvider.images[key].height = pointSize;
              data.dataProvider.images[key].selectable = true;
              data.dataProvider.images[key].title = $scope.continents[point.groupId];
              data.dataProvider.images[key].type = 'circle';
              data.dataProvider.images[key].color = 'rgb(130,130,130)';
              data.dataProvider.images[key].rollOverColor = 'rgb(255,255,255)';
              data.dataProvider.images[key].scale = 1;
              data.dataProvider.images[key].fixedSize = false;
              data.dataProvider.images[key].outlineThickness = $rootScope.mapPointOutlineThickness * 5;
            });

            // Set map listeners
            data.listeners = [
            // Click map country
            {
              event: 'clickMapObject',
              method: function method(e) {
                var continent = e.mapObject.title;

                continent = angular.lowercase(continent);
                continent = continent.replace(/ /g, '-');

                $state.go('musicmap.continent', { 'name': continent });
              }
            },
            // Map is rendered
            {
              event: 'rendered',
              method: function method() {
                // Hide loading animation
                $('#map').removeClass('spinner');
              }
            }];

            // Disable zoom on double click
            data.zoomOnDoubleClick = false;

            // Instantiate map
            $scope.map = AmCharts.makeChart('map', data);
          }, function (error) {
            console.log('error', error);
          });
        };

        // Init map for desktop
        if ($window.innerWidth > $rootScope.mobileBreakdown) {
          $scope.initMap();
        }
      };

      HomepageController.prototype = {
        /**
         * Initialize.
         */
        init: function init() {
          // Get featured articles
          this.getFeaturedArticles();

          // Get about data
          this.getAboutData();

          // Get countries
          this.getCountries();
        },

        /**
         * Get about popup data.
         */
        getAboutData: function getAboutData() {
          var that = this;

          this.$http({
            url: this.Settings.backendHost + '/about.php',
            method: 'GET'
          }).then(function (response) {
            that.$scope.aboutContent = response.data;
          }, function (error) {
            console.log('error', error);
          });
        },

        /**
         * Get featured articles.
         */
        getFeaturedArticles: function getFeaturedArticles() {
          var that = this;

          this.$http({
            url: this.Settings.backendHost + '/articles.php?highlighted=1',
            method: 'GET'
          }).then(function (response) {
            that.$scope.featuredArticles = response.data.articles;
            that.$scope.featuredArticlesLoaded = true;
          }, function (error) {
            console.log('Error while fetching featured articles');
          });
        },

        getCountries: function getCountries() {
          var that = this;

          this.$http({
            url: this.Settings.backendHost + '/countries.php?',
            method: 'GET'
          }).then(function (response) {
            that.$scope.countries = response.data;
          }, function (error) {
            console.log('error', error);
          });
        }

      };

      HomepageController.$inject = ['$rootScope', '$scope', '$http', '$state', '$window', '$cookies', 'Settings'];

      _export('default', HomepageController);
    }
  };
});
$__System.register('19', ['3', '18'], function (_export, _context) {
  "use strict";

  var angular, HomepageController, homepageModule;
  return {
    setters: [function (_) {
      angular = _.default;
    }, function (_2) {
      HomepageController = _2.default;
    }],
    execute: function () {
      homepageModule = angular.module('app.homepage', ['ngCookies', 'slickCarousel']).controller('HomepageController', HomepageController);

      _export('default', homepageModule);
    }
  };
});
$__System.register('1a', [], function (_export, _context) {
  "use strict";

  var CategoryController;
  return {
    setters: [],
    execute: function () {
      CategoryController = function CategoryController($rootScope, $scope, $cookies, $http, $window, $state) {};

      CategoryController.prototype = {
        init: function init() {}
      };

      CategoryController.$inject = ['$rootScope', '$scope', '$cookies', '$http', '$window', '$state'];

      _export('default', CategoryController);
    }
  };
});
$__System.register('1b', ['3', '1a'], function (_export, _context) {
  "use strict";

  var angular, CategoryController, categoryModule;
  return {
    setters: [function (_) {
      angular = _.default;
    }, function (_a) {
      CategoryController = _a.default;
    }],
    execute: function () {
      categoryModule = angular.module('app.category', ['ngCookies']).controller('CategoryController', CategoryController);

      _export('default', categoryModule);
    }
  };
});
$__System.register('1c', [], function (_export, _context) {
  "use strict";

  var ContinentController;
  return {
    setters: [],
    execute: function () {
      ContinentController = function ContinentController($rootScope, $scope, $http, $state, $stateParams, $window, Settings, ngMeta) {
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$http = $http;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$window = $window;
        this.Settings = Settings;
        this.ngMeta = ngMeta;

        /**
         * Map.
         */
        $scope.map = null;

        /**
         * Initialize variables.
         */
        $scope.countries = [];
        $scope.embedOpened = false;
        $scope.embedUrl = null;
        $scope.mapCountries = [['Country']];
        $scope.mixes = [];
        $scope.countriesWithoutArticles = [];
        $scope.focusCountry = false;

        /**
         * Open embed popup.
         */
        $scope.openEmbedPopup = function () {
          $scope.embedOpened = true;
        };

        /**
         * Load status of articles for carousel.
         */
        $scope.articlesLoaded = false;
        $scope.mixesLoaded = false;

        /**
         * Continents mapping.
         */
        $scope.continents = [];
        $scope.continents.europe = { code: 'EU', name: 'Europe' };
        $scope.continents.africa = { code: 'AF', name: 'Africa' };
        $scope.continents.antarctica = { code: 'AN', name: 'Antarctica' };
        $scope.continents.asia = { code: 'AS', name: 'Asia' };
        $scope.continents.oceania = { code: 'OC', name: 'Oceania' };
        $scope.continents['north-america'] = { code: 'NA', name: 'North America' };
        $scope.continents['south-america'] = { code: 'SA', name: 'South America' };

        /**
         * Toggle full playlist.
         */
        $scope.fullPlaylist = false;
        $scope.toggleFullPlaylist = function () {
          $scope.fullPlaylist = !$scope.fullPlaylist;
        };

        /**
         * Articles history variables.
         */
        $scope.articlesHistory = false;
        $scope.historyCategoryType = null;
        $scope.history = {
          'enabled': false,
          'categoryType': null,
          'articles': [],
          'pagination': {
            'total': 0,
            'per_page': 20,
            'page': 0,
            'pages': 0, // calculated when fetching
            'more': false
          }
        };

        /**
         * Open articles history for a category.
         */
        $scope.openArticlesHistory = function (type) {
          $scope.history.enabled = true;
          $scope.history.categoryType = type;

          // Get articles on first load or if category changed
          if (!$scope.history.articles.length || type !== $scope.history.categoryType) {
            $scope.getArticlesHistory(0);
          }
        };

        /**
         * Close articles history.
         */
        $scope.closeArticlesHistory = function () {
          $scope.history.enabled = false;
          $scope.history.categoryType = null;
          $scope.history.articles = [];
        };

        /**
         * Get articles history for current category and page.
         */
        $scope.getArticlesHistory = function (page) {
          if (typeof page === 'undefined') {
            page = 0;
          }

          var perPage = $scope.history.pagination.per_page;
          var categoryType = $scope.history.categoryType;

          $scope.historyCategoryName = $scope.categories[$scope.history.categoryType].name;

          $http({
            url: Settings.backendHost + '/articles.php?continent=' + $scope.continent.code + '&pagination=' + page,
            method: 'GET'
          }).then(function (response) {
            var data = response.data;

            var total = data['count__' + categoryType];
            var pages = Math.ceil(total / perPage) - 1;

            $scope.history.pagination.total = total;
            $scope.history.pagination.pages = pages;
            $scope.history.pagination.page = page;
            $scope.history.pagination.more = page < pages;

            // Grab all articles and push to history
            angular.forEach(data['articles__' + categoryType], function (article) {
              $scope.history.articles.push(article);
            });
          }, function (error) {
            console.log('Error while fetching articles history');
          });
        };

        /**
         * Continents centers and zoom.
         */
        $scope.continentCenters = {
          'EU': { 'zoom': 2.4, 'x': -0.9, 'y': 0.6 },
          'AS': { 'zoom': 3, 'x': -1.64, 'y': -0.25 },
          'AF': { 'zoom': 3.3, 'x': -1.2, 'y': -0.75 },
          'SA': { 'zoom': 3.5, 'x': -0.62, 'y': -1.38 },
          'NA': { 'zoom': 2.2, 'x': 0.01, 'y': 0.55 },
          'OC': { 'zoom': 4, 'x': -3, 'y': -1.76 }
        };

        /**
         * Prepare data and then init map.
         * Get countries without articles in order to disable them.
         */
        $scope.startMap = function () {
          // Loading map animation
          $('#map').addClass('spinner');

          $http({
            url: Settings.backendHost + '/countries.php?continent=' + $scope.continent.code + '&has_articles=0',
            method: 'GET'
          }).then(function (response) {
            angular.forEach(response.data, function (country) {
              $scope.countriesWithoutArticles.push(country.alpha2);
            });

            // Init map, yay!
            $scope.initMap();
          }, function (error) {
            console.log('error', error);
          });
        };

        /**
         * Handle map resize.
         */
        $(window).resize(function () {
          // Ignore for mobile
          if (!$scope.map) {
            return;
          }

          // Get map point size
          var pointSize = $rootScope.mapPointSize(true);

          // Update pixels size
          angular.forEach($scope.map.dataProvider.images, function (point, key) {
            $scope.map.dataProvider.images[key].width = pointSize;
            $scope.map.dataProvider.images[key].height = pointSize;
          });

          // Zoom and center map
          var continentCenter = $scope.continentCenters[$scope.continent.code];
          $scope.map.zoomTo(continentCenter.zoom, continentCenter.x, continentCenter.y, true);
        });

        /**
         * Initialize continent map with countries.
         */
        $scope.initMap = function () {
          // Get map point size
          var pointSize = $rootScope.mapPointSize(true);

          $http({
            url: '/scripts/libraries/map/data/continents/' + $scope.continent.code + '.json',
            method: 'GET'
          }).then(function (response) {
            var data = response.data;

            // Get API countries so we can make not selectable the ones missing, such as Greenland
            var apiCountries = [];
            angular.forEach($scope.countries, function (country) {
              apiCountries.push(country.alpha2);
            });

            // Update pixels data
            angular.forEach(data.dataProvider.images, function (point, key) {
              var selectable = true;

              // Country has no articles
              if ($scope.countriesWithoutArticles.indexOf(point.groupId) !== -1) {
                selectable = false;
              }

              // Country is missing from API
              if (apiCountries.indexOf(point.groupId) === -1) {
                selectable = false;
              }

              var color = 'rgb(130,130,130)';
              var rollOverColor = 'rgb(255,255,255)';

              if (!selectable) {
                color = 'rgb(48,48,48)';
                rollOverColor = 'rgb(48,48,48)';
                delete data.dataProvider.images[key].title;
              }

              data.dataProvider.images[key].width = pointSize;
              data.dataProvider.images[key].height = pointSize;
              data.dataProvider.images[key].selectable = selectable;
              data.dataProvider.images[key].type = 'circle';
              data.dataProvider.images[key].color = color;
              data.dataProvider.images[key].rollOverColor = rollOverColor;
              data.dataProvider.images[key].scale = 1;
              data.dataProvider.images[key].fixedSize = false;
              data.dataProvider.images[key].outlineThickness = $rootScope.mapPointOutlineThickness;
            });

            // Set listeners
            data.listeners = [
            // Click country
            {
              event: 'clickMapObject',
              method: function method(e) {
                $state.go('musicmap.country', { 'alpha2': e.mapObject.groupId });
              }
            },
            // Map is rendered
            {
              event: 'rendered',
              method: function method() {
                // Hide loading animation
                $('#map').removeClass('spinner');
              }
            }];

            // Disable zoom on double click
            data.zoomOnDoubleClick = false;

            // Instantiate map
            $scope.map = AmCharts.makeChart('map', data);

            // Zoom and center map to continent
            var continentCenter = $scope.continentCenters[$scope.continent.code];
            $scope.map.zoomTo(continentCenter.zoom, continentCenter.x, continentCenter.y, true);
          }, function (error) {
            console.log('error', error);
          });
        };
      };

      ContinentController.prototype = {
        /**
         * Initialize.
         */
        init: function init() {
          var that = this;

          // Get current continent
          that.$scope.continent = that.$scope.continents[that.$stateParams.name];
          if (typeof that.$scope.continent === 'undefined') {
            that.$state.go('musicmap.homepage');
          }

          // Embed URL
          that.$scope.embedUrl = that.$state.href('embed.continent', { name: that.$stateParams.name }, { absolute: true });

          // Set meta
          that.ngMeta.setTitle('MusicMap - ' + that.$scope.continent.name);

          // Get continent countries
          that.getCountries();

          // Get continent highlighted articles
          that.getHighlightedArticles();

          // Get continent playlist
          that.getPlaylist();
        },

        /**
         * Get countries of current continent.
         */
        getCountries: function getCountries() {
          var that = this;

          this.$http({
            url: this.Settings.backendHost + '/countries.php?continent=' + this.$scope.continent.code,
            method: 'GET'
          }).then(function (response) {
            that.$scope.countries = response.data;

            // Init map for desktop
            if (that.$window.innerWidth > that.$rootScope.mobileBreakdown) {
              that.$scope.startMap();
            }
          }, function (error) {
            console.log('error', error);
          });
        },

        /**
         * Get continent highlighted articles.
         */
        getHighlightedArticles: function getHighlightedArticles() {
          var that = this;

          this.$http({
            url: this.Settings.backendHost + '/articles.php?continent=' + this.$scope.continent.code,
            method: 'GET'
          }).then(function (response) {
            var data = response.data;
            var categories = {
              'features': { total: 0, articles: [] },
              'latest': { total: 0, articles: [] }
            };

            // Push features
            if (data.count__features > 0) {
              categories.features.total = data.count__features;
              categories.features.articles = data.articles__features;
            }

            // Push features
            if (data.count__latest > 0) {
              categories.latest.total = data.count__latest;
              categories.latest.articles = data.articles__latest;
            }

            that.$scope.categories = categories;
            that.$scope.articlesLoaded = true;
          }, function (error) {
            console.log('Error while fetching page articles');
          });
        },

        /**
         * Get playlist for continent.
         */
        getPlaylist: function getPlaylist() {
          var that = this;

          this.$http({
            url: this.Settings.backendHost + '/playlist.php?continent=' + this.$scope.continent.code,
            method: 'GET'
          }).then(function (response) {
            var tracks = [];

            if (response.data !== null) {
              tracks = response.data.tracks;
            }

            that.$scope.playlist = tracks;
          }, function (error) {
            console.log('error', error);
          });
        }
      };

      ContinentController.$inject = ['$rootScope', '$scope', '$http', '$state', '$stateParams', '$window', 'Settings', 'ngMeta'];

      _export('default', ContinentController);
    }
  };
});
$__System.register('1d', ['3', '1c'], function (_export, _context) {
  "use strict";

  var angular, ContinentController, continentModule;
  return {
    setters: [function (_) {
      angular = _.default;
    }, function (_c) {
      ContinentController = _c.default;
    }],
    execute: function () {
      continentModule = angular.module('app.continent', ['ngCookies', 'slickCarousel']).controller('ContinentController', ContinentController);

      _export('default', continentModule);
    }
  };
});
$__System.register('1e', [], function (_export, _context) {
  "use strict";

  var CountryController;
  return {
    setters: [],
    execute: function () {
      CountryController = function CountryController($rootScope, $scope, $http, $state, $stateParams, Settings, ngMeta) {
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$http = $http;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.Settings = Settings;
        this.ngMeta = ngMeta;

        /**
         * Initialize variables.
         */
        $scope.mixes = [];
        $scope.embedOpened = false;
        $scope.embedUrl = null;

        /**
         * Load status of articles for carousel.
         */
        $scope.articlesLoaded = false;
        $scope.mixesLoaded = false;

        /**
         * Toggle full playlist.
         */
        $scope.fullPlaylist = false;
        $scope.toggleFullPlaylist = function () {
          $scope.fullPlaylist = !$scope.fullPlaylist;
        };

        /**
         * Articles history variables.
         */
        $scope.articlesHistory = false;
        $scope.historyCategoryType = null;
        $scope.history = {
          'enabled': false,
          'categoryType': null,
          'articles': [],
          'pagination': {
            'total': 0,
            'per_page': 20,
            'page': 0,
            'pages': 0, // calculated when fetching
            'more': false
          }
        };

        /**
         * Open embed popup.
         */
        $scope.openEmbedPopup = function () {
          $scope.embedOpened = true;
        };

        /**
         * Open articles history for a category.
         */
        $scope.openArticlesHistory = function (type) {
          $scope.history.enabled = true;
          $scope.history.categoryType = type;

          // Get articles on first load or if category changed
          if (!$scope.history.articles.length || type !== $scope.history.categoryType) {
            $scope.getArticlesHistory(0);
          }
        };

        /**
         * Close articles history.
         */
        $scope.closeArticlesHistory = function () {
          $scope.history.enabled = false;
          $scope.history.categoryType = null;
          $scope.history.articles = [];
        };

        /**
         * Get articles history for current category and page.
         */
        $scope.getArticlesHistory = function (page) {
          if (typeof page === 'undefined') {
            page = 0;
          }

          var perPage = $scope.history.pagination.per_page;
          var categoryType = $scope.history.categoryType;

          $scope.historyCategoryName = $scope.categories[$scope.history.categoryType].name;

          $http({
            url: Settings.backendHost + '/articles.php?country_alpha2=' + $scope.country.alpha2 + '&pagination=' + page,
            method: 'GET'
          }).then(function (response) {
            var data = response.data;

            var total = data['count__' + categoryType];
            var pages = Math.ceil(total / perPage) - 1;

            $scope.history.pagination.total = total;
            $scope.history.pagination.pages = pages;
            $scope.history.pagination.page = page;
            $scope.history.pagination.more = page < pages;

            // Grab all articles and push to history
            angular.forEach(data['articles__' + categoryType], function (article) {
              $scope.history.articles.push(article);
            });
          }, function (error) {
            console.log('Error while fetching articles history');
          });
        };
      };

      CountryController.prototype = {
        /**
         * Initialize.
         */
        init: function init() {
          var that = this;

          this.$http({
            url: this.Settings.backendHost + '/countries.php?alpha2=' + this.$stateParams.alpha2,
            method: 'GET'
          }).then(function (response) {
            // Country is not valid
            if (response.data.length !== 1) {
              that.$state.go('musicmap.homepage');

              return;
            }

            // Embed URL
            that.$scope.embedUrl = that.$state.href('embed.country', { alpha2: that.$stateParams.alpha2 }, { absolute: true });

            // Set country
            that.$scope.country = response.data[0];

            // Set meta
            that.ngMeta.setTitle('MusicMap - ' + that.$scope.country.name);

            // Get country highlighted articles
            that.getHighlightedArticles();

            // Get continent playlist
            that.getPlaylist();
          }, function (error) {
            console.log('error', error);
          });
        },

        /**
         * Get country highlighted articles.
         */
        getHighlightedArticles: function getHighlightedArticles() {
          var that = this;

          this.$http({
            url: this.Settings.backendHost + '/articles.php?country_alpha2=' + this.$scope.country.alpha2,
            method: 'GET'
          }).then(function (response) {
            var data = response.data;
            var categories = {
              'features': { total: 0, articles: [] },
              'latest': { total: 0, articles: [] }
            };

            // Push features
            if (data.count__features > 0) {
              categories.features.total = data.count__features;
              categories.features.articles = data.articles__features;
            }

            // Push features
            if (data.count__latest > 0) {
              categories.latest.total = data.count__latest;
              categories.latest.articles = data.articles__latest;
            }

            that.$scope.categories = categories;
            that.$scope.articlesLoaded = true;
          }, function (error) {
            console.log('Error while fetching page articles');
          });
        },

        /**
         * Get playlist for country.
         */
        getPlaylist: function getPlaylist() {
          var that = this;

          this.$http({
            url: this.Settings.backendHost + '/playlist.php?country_alpha2=' + this.$scope.country.alpha2,
            method: 'GET'
          }).then(function (response) {
            var tracks = [];

            if (response.data !== null) {
              tracks = response.data.tracks;
            }

            that.$scope.playlist = tracks;
          }, function (error) {
            console.log('error', error);
          });
        }
      };

      CountryController.$inject = ['$rootScope', '$scope', '$http', '$state', '$stateParams', 'Settings', 'ngMeta'];

      _export('default', CountryController);
    }
  };
});
$__System.register('1f', ['3', '1e'], function (_export, _context) {
  "use strict";

  var angular, CountryController, countryModule;
  return {
    setters: [function (_) {
      angular = _.default;
    }, function (_e) {
      CountryController = _e.default;
    }],
    execute: function () {
      countryModule = angular.module('app.country', ['ngCookies', 'slickCarousel']).controller('CountryController', CountryController);

      _export('default', countryModule);
    }
  };
});
$__System.register('20', [], function (_export, _context) {
  "use strict";

  var ArticleController;
  return {
    setters: [],
    execute: function () {
      ArticleController = function ArticleController($rootScope, $scope, $document, $window, $http, $cookies, $state, $stateParams, Settings, ngMeta) {
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$http = $http;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.Settings = Settings;
        this.ngMeta = ngMeta;

        /**
         * Initialize variables.
         */
        $scope.shareOptions = false;
        $scope.subscribeOpened = false;
        $scope.subscribed = !!$cookies.get('subscribed');
        $scope.subscribeSuccess = false;
        $scope.subscriber = {
          email: '',
          firstname: '',
          lastname: ''
        };
        $scope.subscriberError = {
          email: '',
          firstname: '',
          lastname: ''
        };

        /**
         * Flags for carousels.
         */
        $scope.relatedArticlesLoaded = false;

        /**
         * Subscribe.
         */
        $scope.doSubscribe = function () {
          // Reset form validity
          var valid = true;

          // Reset errors
          $scope.subscriberError = {
            email: '',
            firstname: '',
            lastname: '',
            terms: ''
          };

          // Validate fields
          if ($scope.subscriber.email.length === 0) {
            valid = false;
            $scope.subscriberError.email = true;
          }

          if ($scope.subscriber.firstname.length === 0) {
            valid = false;
            $scope.subscriberError.firstname = true;
          }

          if ($scope.subscriber.lastname.length === 0) {
            valid = false;
            $scope.subscriberError.lastname = true;
          }

          if ($scope.subscriber.terms !== true) {
            valid = false;
            $scope.subscriberError.terms = true;
          }

          // All good, send next
          if (valid) {
            $http({
              url: Settings.backendHost + '/subscriptions.php?email=' + $scope.subscriber.email + '&firstname=' + $scope.subscriber.firstname + '&lastname=' + $scope.subscriber.lastname,
              method: 'GET'
            }).then(function (response) {
              $scope.subscribeSuccess = true;
              $scope.subscribed = true;

              // Cookie helpers
              var now = new Date();
              var exp = new Date(now.getTime() + 1000 * 60 * 60 * 24 * 30); // 30 days

              $cookies.put('subscribed', 1, {
                'path': '/',
                'expires': exp
              });
            }, function (error) {
              console.log('error', error);
            });
          }
        };

        /**
         * Close article.
         *
         * If there is history we go back with one.
         * Otherwise, on direct article URL load we fallback to first country.
         */
        $scope.closeArticle = function () {
          // No history, only self
          if ($rootScope.history.length < 2) {
            $state.go('musicmap.country', { alpha2: $scope.article.countries[0].alpha2 });
          }
          // go back one state
          else {
              $window.history.back();
            }
        };
      };

      ArticleController.prototype = {
        /**
         * Initialize.
         */
        init: function init() {
          var that = this;

          this.$http({
            url: this.Settings.backendHost + '/articles.php?path=' + this.$stateParams.path,
            method: 'GET'
          }).then(function (response) {
            // Article is not valid
            if (response.data.articles.length !== 1) {
              that.$state.go('musicmap.homepage');

              return;
            }

            // Set current article
            that.$scope.article = response.data.articles[0];

            // Get related articles
            that.getRelatedArticles();

            // Set meta
            that.ngMeta.setTitle('MusicMap - ' + that.$scope.article.title);
            that.ngMeta.setTag('og:image', that.$scope.article.images.thb);
            that.ngMeta.setTag('description', that.$scope.article.shortDescription.replace(/<\/?[^>]+(>|$)/g, ""));
          }, function (error) {
            console.log('error', error);
          });
        },

        /**
         * Get related articles
         */
        getRelatedArticles: function getRelatedArticles() {
          var that = this;

          // No related articles
          if (!that.$scope.article.related.length) {
            that.$scope.related = [];
          }

          this.$http({
            url: this.Settings.backendHost + '/articles.php?id=' + that.$scope.article.related.join(','),
            method: 'GET'
          }).then(function (response) {
            that.$scope.related = response.data.articles;
            that.$scope.relatedArticlesLoaded = true;
          }, function (error) {
            console.log('Error while fetching related articles');
          });
        }
      };

      ArticleController.$inject = ['$rootScope', '$scope', '$document', '$window', '$http', '$cookies', '$state', '$stateParams', 'Settings', 'ngMeta'];

      _export('default', ArticleController);
    }
  };
});
$__System.register('21', ['3', '20'], function (_export, _context) {
  "use strict";

  var angular, ArticleController, articleModule;
  return {
    setters: [function (_) {
      angular = _.default;
    }, function (_2) {
      ArticleController = _2.default;
    }],
    execute: function () {
      articleModule = angular.module('app.article', ['ngCookies', 'slickCarousel']).controller('ArticleController', ArticleController);

      _export('default', articleModule);
    }
  };
});
$__System.register('22', [], function (_export, _context) {
  "use strict";

  var ContactController;
  return {
    setters: [],
    execute: function () {
      ContactController = function ContactController($rootScope, $scope, $http, $state, $stateParams, Settings, ngMeta, vcRecaptchaService) {
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$http = $http;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.Settings = Settings;
        this.ngMeta = ngMeta;
        this.vcRecaptchaService = vcRecaptchaService;

        /**
         * Initialize variables.
         */

        $scope.contactSuccess = false;

        $scope.contact = false;
        $scope.contact = {
          name: '',
          email: '',
          message: ''
        };
        $scope.contactError = {
          name: '',
          email: '',
          message: '',
          gdpr: ''
        };

        /**
         * Contact.
         */
        $scope.doContact = function () {
          // Reset form validity
          var valid = true;

          // Reset errors
          $scope.contactError = {
            name: '',
            email: '',
            message: '',
            gdpr: ''
          };

          // Validate fields
          if ($scope.contact.name.length === 0) {
            valid = false;
            $scope.contactError.name = true;
          }

          if ($scope.contact.email.length === 0) {
            valid = false;
            $scope.contactError.email = true;
          }

          if ($scope.contact.message.length === 0) {
            valid = false;
            $scope.contactError.message = true;
          }

          if ($scope.contact.gdpr !== true) {
            valid = false;
            $scope.contact.gdpr = true;
          }

          if (vcRecaptchaService.getResponse() === '') {
            alert('Please resolve the captcha and submit!');
          } else {
            var data = {
              name: $scope.contact.name,
              email: $scope.contact.email,
              message: $scope.contact.message,
              recaptchaResponse: vcRecaptchaService.getResponse()
            };

            if (valid) {
              $http.post(Settings.backendHost + '/contact.php', data).then(function (response) {
                alert('Message sent. Thank you.');
              }, function (error) {
                console.log('error', error);
              });
            }
          }
        };
      };

      ContactController.$inject = ['$rootScope', '$scope', '$http', '$state', '$stateParams', 'Settings', 'ngMeta', 'vcRecaptchaService'];

      _export('default', ContactController);
    }
  };
});
$__System.register('23', ['3', '24', '22'], function (_export, _context) {
  "use strict";

  var angular, ContactController, contactModule;
  return {
    setters: [function (_) {
      angular = _.default;
    }, function (_2) {}, function (_3) {
      ContactController = _3.default;
    }],
    execute: function () {
      contactModule = angular.module('app.contact', ['ngCookies', 'vcRecaptcha']).controller('ContactController', ContactController);

      _export('default', contactModule);
    }
  };
});
$__System.register('25', [], function (_export, _context) {
  "use strict";

  var AboutController;
  return {
    setters: [],
    execute: function () {
      AboutController = function AboutController($rootScope, $scope, $http, $state, $stateParams, Settings, ngMeta, vcRecaptchaService) {
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$http = $http;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.Settings = Settings;
        this.ngMeta = ngMeta;
        this.vcRecaptchaService = vcRecaptchaService;

        /**
         * Initialize variables.
         */

        $scope.contactSuccess = false;

        $scope.contact = false;
        $scope.contact = {
          name: '',
          company: '',
          email: '',
          message: ''
        };
        $scope.contactError = {
          name: '',
          company: '',
          email: '',
          message: '',
          gdpr: ''
        };

        /**
         * Contact.
         */
        $scope.doContact = function () {
          // Reset form validity
          var valid = true;

          // Reset errors
          $scope.contactError = {
            name: '',
            company: '',
            email: '',
            message: '',
            gdpr: ''
          };

          // Validate fields
          if ($scope.contact.name.length === 0) {
            valid = false;
            $scope.contactError.name = true;
          }

          if ($scope.contact.company.length === 0) {
            valid = false;
            $scope.contactError.company = true;
          }

          if ($scope.contact.email.length === 0) {
            valid = false;
            $scope.contactError.email = true;
          }

          if ($scope.contact.message.length === 0) {
            valid = false;
            $scope.contactError.message = true;
          }

          if ($scope.contact.gdpr !== true) {
            valid = false;
            $scope.contact.gdpr = true;
          }

          if (vcRecaptchaService.getResponse() === '') {
            alert('Please resolve the captcha and submit!');
          } else {
            var data = {
              name: $scope.contact.name,
              company: $scope.contact.company,
              email: $scope.contact.email,
              message: $scope.contact.message,
              recaptchaResponse: vcRecaptchaService.getResponse()
            };

            if (valid) {
              $http.post(Settings.backendHost + '/contact_about.php', data, {
                headers: { 'Content-Type': 'application/json' }
              }).then(function (response) {
                alert('Message sent. Thank you.');
              }, function (error) {
                console.log('error', error);
              });
            }
          }
        };
      };

      AboutController.$inject = ['$rootScope', '$scope', '$http', '$state', '$stateParams', 'Settings', 'ngMeta', 'vcRecaptchaService'];

      _export('default', AboutController);
    }
  };
});
$__System.register('26', ['3', '24', '25'], function (_export, _context) {
  "use strict";

  var angular, AboutController, aboutModule;
  return {
    setters: [function (_) {
      angular = _.default;
    }, function (_2) {}, function (_3) {
      AboutController = _3.default;
    }],
    execute: function () {
      aboutModule = angular.module('app.about', ['ngCookies', 'vcRecaptcha']).controller('AboutController', AboutController);

      _export('default', aboutModule);
    }
  };
});
$__System.register('27', [], function (_export, _context) {
  "use strict";

  var ServicesController;
  return {
    setters: [],
    execute: function () {
      ServicesController = function ServicesController($rootScope, $scope, $http, $state, $stateParams, Settings, ngMeta, vcRecaptchaService) {
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$http = $http;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.Settings = Settings;
        this.ngMeta = ngMeta;
        this.vcRecaptchaService = vcRecaptchaService;

        /**
         * Initialize variables.
         */

        $scope.contactSuccess = false;

        $scope.contact = false;
        $scope.contact = {
          name: '',
          company: '',
          email: '',
          message: '',
          gdpr: ''
        };
        $scope.contactError = {
          name: '',
          company: '',
          email: '',
          message: '',
          gdpr: ''
        };
        /**
         * Flags for carousels.
         */

        /**
         * Subscribe.
         */
        $scope.doContact = function () {
          // Reset form validity
          var valid = true;

          // Reset errors
          $scope.contactError = {
            name: '',
            company: '',
            email: '',
            message: '',
            gdpr: ''
          };

          // Validate fields
          if ($scope.contact.name.length === 0) {
            valid = false;
            $scope.contactError.name = true;
          }

          if ($scope.contact.company.length === 0) {
            valid = false;
            $scope.contactError.company = true;
          }

          if ($scope.contact.email.length === 0) {
            valid = false;
            $scope.contactError.email = true;
          }

          if ($scope.contact.message.length === 0) {
            valid = false;
            $scope.contactError.message = true;
          }

          if ($scope.contact.gdpr !== true) {
            valid = false;
            $scope.contact.gdpr = true;
          }
          if (vcRecaptchaService.getResponse() === '') {
            alert('Please resolve the captcha and submit!');
          } else {
            var data = {
              name: $scope.contact.name,
              company: $scope.contact.company,
              email: $scope.contact.email,
              message: $scope.contact.message,
              recaptchaResponse: vcRecaptchaService.getResponse()
            };

            if (valid) {
              $http.post(Settings.backendHost + '/contact_services.php', data, {
                headers: { 'Content-Type': 'application/json' }
              }).then(function (response) {
                alert('Message sent. Thank you.');
              }, function (error) {
                console.log('error', error);
              });
            }
          }
        };
      };

      ServicesController.$inject = ['$rootScope', '$scope', '$http', '$state', '$stateParams', 'Settings', 'ngMeta', 'vcRecaptchaService'];

      _export('default', ServicesController);
    }
  };
});
$__System.register('28', ['3', '24', '27'], function (_export, _context) {
  "use strict";

  var angular, ServicesController, servicesModule;
  return {
    setters: [function (_) {
      angular = _.default;
    }, function (_2) {}, function (_3) {
      ServicesController = _3.default;
    }],
    execute: function () {
      servicesModule = angular.module('app.services', ['ngCookies', 'vcRecaptcha']).controller('ServicesController', ServicesController);

      _export('default', servicesModule);
    }
  };
});
$__System.registerDynamic("29", [], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  (function(ng) {
    'use strict';
    ng.module('vcRecaptcha', []);
  }(angular));
  (function(ng) {
    'use strict';
    function throwNoKeyException() {
      throw new Error('You need to set the "key" attribute to your public reCaptcha key. If you don\'t have a key, please get one from https://www.google.com/recaptcha/admin/create');
    }
    var app = ng.module('vcRecaptcha');
    app.provider('vcRecaptchaService', function() {
      var provider = this;
      var config = {};
      provider.onLoadFunctionName = 'vcRecaptchaApiLoaded';
      provider.setDefaults = function(defaults) {
        ng.copy(defaults, config);
      };
      provider.setSiteKey = function(siteKey) {
        config.key = siteKey;
      };
      provider.setTheme = function(theme) {
        config.theme = theme;
      };
      provider.setStoken = function(stoken) {
        config.stoken = stoken;
      };
      provider.setSize = function(size) {
        config.size = size;
      };
      provider.setType = function(type) {
        config.type = type;
      };
      provider.setLang = function(lang) {
        config.lang = lang;
      };
      provider.setBadge = function(badge) {
        config.badge = badge;
      };
      provider.setOnLoadFunctionName = function(onLoadFunctionName) {
        provider.onLoadFunctionName = onLoadFunctionName;
      };
      provider.$get = ['$rootScope', '$window', '$q', '$document', '$interval', function($rootScope, $window, $q, $document, $interval) {
        var deferred = $q.defer(),
            promise = deferred.promise,
            instances = {},
            recaptcha;
        $window.vcRecaptchaApiLoadedCallback = $window.vcRecaptchaApiLoadedCallback || [];
        var callback = function() {
          recaptcha = $window.grecaptcha;
          deferred.resolve(recaptcha);
        };
        $window.vcRecaptchaApiLoadedCallback.push(callback);
        $window[provider.onLoadFunctionName] = function() {
          $window.vcRecaptchaApiLoadedCallback.forEach(function(callback) {
            callback();
          });
        };
        function getRecaptcha() {
          if (!!recaptcha) {
            return $q.when(recaptcha);
          }
          return promise;
        }
        function validateRecaptchaInstance() {
          if (!recaptcha) {
            throw new Error('reCaptcha has not been loaded yet.');
          }
        }
        function isRenderFunctionAvailable() {
          return ng.isFunction(($window.grecaptcha || {}).render);
        }
        if (isRenderFunctionAvailable()) {
          callback();
        } else if ($window.document.querySelector('script[src^="https://www.google.com/recaptcha/api.js"]')) {
          var intervalWait = $interval(function() {
            if (isRenderFunctionAvailable()) {
              $interval.cancel(intervalWait);
              callback();
            }
          }, 25);
        } else {
          var script = $window.document.createElement('script');
          script.async = true;
          script.defer = true;
          script.src = 'https://www.google.com/recaptcha/api.js?onload=' + provider.onLoadFunctionName + '&render=explicit';
          $document.find('body')[0].appendChild(script);
        }
        return {
          create: function(elm, conf) {
            conf.sitekey = conf.key || config.key;
            conf.theme = conf.theme || config.theme;
            conf.stoken = conf.stoken || config.stoken;
            conf.size = conf.size || config.size;
            conf.type = conf.type || config.type;
            conf.hl = conf.lang || config.lang;
            conf.badge = conf.badge || config.badge;
            if (!conf.sitekey) {
              throwNoKeyException();
            }
            return getRecaptcha().then(function(recaptcha) {
              var widgetId = recaptcha.render(elm, conf);
              instances[widgetId] = elm;
              return widgetId;
            });
          },
          reload: function(widgetId) {
            validateRecaptchaInstance();
            recaptcha.reset(widgetId);
            $rootScope.$broadcast('reCaptchaReset', widgetId);
          },
          execute: function(widgetId) {
            validateRecaptchaInstance();
            recaptcha.execute(widgetId);
          },
          useLang: function(widgetId, lang) {
            var instance = instances[widgetId];
            if (instance) {
              var iframe = instance.querySelector('iframe');
              if (lang) {
                if (iframe && iframe.src) {
                  var s = iframe.src;
                  if (/[?&]hl=/.test(s)) {
                    s = s.replace(/([?&]hl=)\w+/, '$1' + lang);
                  } else {
                    s += ((s.indexOf('?') === -1) ? '?' : '&') + 'hl=' + lang;
                  }
                  iframe.src = s;
                }
              } else {
                if (iframe && iframe.src && /[?&]hl=\w+/.test(iframe.src)) {
                  return iframe.src.replace(/.+[?&]hl=(\w+)([^\w].+)?/, '$1');
                } else {
                  return null;
                }
              }
            } else {
              throw new Error('reCaptcha Widget ID not exists', widgetId);
            }
          },
          getResponse: function(widgetId) {
            validateRecaptchaInstance();
            return recaptcha.getResponse(widgetId);
          },
          getInstance: function(widgetId) {
            return instances[widgetId];
          },
          destroy: function(widgetId) {
            delete instances[widgetId];
          }
        };
      }];
    });
  }(angular));
  (function(ng) {
    'use strict';
    var app = ng.module('vcRecaptcha');
    app.directive('vcRecaptcha', ['$document', '$timeout', 'vcRecaptchaService', function($document, $timeout, vcRecaptcha) {
      return {
        restrict: 'A',
        require: "?^^form",
        scope: {
          response: '=?ngModel',
          key: '=?',
          stoken: '=?',
          theme: '=?',
          size: '=?',
          type: '=?',
          lang: '=?',
          badge: '=?',
          tabindex: '=?',
          required: '=?',
          onCreate: '&',
          onSuccess: '&',
          onExpire: '&'
        },
        link: function(scope, elm, attrs, ctrl) {
          scope.widgetId = null;
          if (ctrl && ng.isDefined(attrs.required)) {
            scope.$watch('required', validate);
          }
          var removeCreationListener = scope.$watch('key', function(key) {
            var callback = function(gRecaptchaResponse) {
              $timeout(function() {
                scope.response = gRecaptchaResponse;
                validate();
                scope.onSuccess({
                  response: gRecaptchaResponse,
                  widgetId: scope.widgetId
                });
              });
            };
            vcRecaptcha.create(elm[0], {
              callback: callback,
              key: key,
              stoken: scope.stoken || attrs.stoken || null,
              theme: scope.theme || attrs.theme || null,
              type: scope.type || attrs.type || null,
              lang: scope.lang || attrs.lang || null,
              tabindex: scope.tabindex || attrs.tabindex || null,
              size: scope.size || attrs.size || null,
              badge: scope.badge || attrs.badge || null,
              'expired-callback': expired
            }).then(function(widgetId) {
              validate();
              scope.widgetId = widgetId;
              scope.onCreate({widgetId: widgetId});
              scope.$on('$destroy', destroy);
              scope.$on('reCaptchaReset', function(event, resetWidgetId) {
                if (ng.isUndefined(resetWidgetId) || widgetId === resetWidgetId) {
                  scope.response = "";
                  validate();
                }
              });
            });
            removeCreationListener();
          });
          function destroy() {
            if (ctrl) {
              ctrl.$setValidity('recaptcha', null);
            }
            cleanup();
          }
          function expired() {
            $timeout(function() {
              scope.response = "";
              validate();
              scope.onExpire({widgetId: scope.widgetId});
            });
          }
          function validate() {
            if (ctrl) {
              ctrl.$setValidity('recaptcha', scope.required === false ? null : Boolean(scope.response));
            }
          }
          function cleanup() {
            vcRecaptcha.destroy(scope.widgetId);
            ng.element($document[0].querySelectorAll('.pls-container')).parent().remove();
          }
        }
      };
    }]);
  }(angular));
  return module.exports;
});

$__System.registerDynamic("24", ["29"], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  $__require('29');
  module.exports = 'vcRecaptcha';
  return module.exports;
});

$__System.register('2a', [], function (_export, _context) {
  "use strict";

  var ArtistController;
  return {
    setters: [],
    execute: function () {
      ArtistController = function ArtistController($rootScope, $scope, $http, $state, $stateParams, Settings, ngMeta, vcRecaptchaService) {
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$http = $http;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.Settings = Settings;
        this.ngMeta = ngMeta;
        this.vcRecaptchaService = vcRecaptchaService;

        /**
         * Initialize variables.
         */

        $scope.contactSuccess = false;
        $scope.contact = false;
        $scope.contact = {
          name: '',
          email: '',
          artist_name: '',
          country: '',
          description: '',
          link: ''
        };
        $scope.contactError = {
          name: '',
          email: '',
          artist_name: '',
          country: '',
          description: '',
          link: '',
          gdpr: ''
        };

        /**
         * Contact.
         */
        $scope.doContact = function () {
          // Reset form validity
          var valid = true;

          // Reset errors
          $scope.contactError = {
            name: '',
            email: '',
            artist_name: '',
            country: '',
            description: '',
            link: '',
            gdpr: ''
          };

          // Validate fields
          if ($scope.contact.name.length === 0) {
            valid = false;
            $scope.contactError.name = true;
          }
          if ($scope.contact.email.length === 0) {
            valid = false;
            $scope.contactError.email = true;
          }
          if ($scope.contact.artist_name.length === 0) {
            valid = false;
            $scope.contactError.artist_name = true;
          }
          if ($scope.contact.country.length === 0) {
            valid = false;
            $scope.contactError.country = true;
          }

          if ($scope.contact.description.length === 0) {
            valid = false;
            $scope.contactError.description = true;
          }
          if ($scope.contact.link.length === 0) {
            valid = false;
            $scope.contactError.link = true;
          }

          if ($scope.contact.gdpr !== true) {
            valid = false;
            $scope.contactError.gdpr = true;
          }

          if (vcRecaptchaService.getResponse() === '') {
            // if string is empty
            alert('Please resolve the captcha and submit!');
          } else {
            var data = {
              name: $scope.contact.name,
              email: $scope.contact.email,
              artistName: $scope.contact.artist_name,
              country: $scope.contact.country,
              description: $scope.contact.description,
              link: $scope.contact.link,
              recaptchaResponse: vcRecaptchaService.getResponse() // send g-captcah-reponse to  server
            };

            if (valid) {
              $http.post(Settings.backendHost + '/contact_artists.php', data, {
                headers: { 'Content-Type': 'application/json' }
              }).then(function (response) {
                alert('Message sent. Thank you.');
              }, function (error) {
                console.log('error', error);
              });
            }
          }
        };
      };

      ArtistController.$inject = ['$rootScope', '$scope', '$http', '$state', '$stateParams', 'Settings', 'ngMeta', 'vcRecaptchaService'];

      _export('default', ArtistController);
    }
  };
});
$__System.register('2b', ['3', '24', '2a'], function (_export, _context) {
  "use strict";

  var angular, ArtistController, artistModule;
  return {
    setters: [function (_) {
      angular = _.default;
    }, function (_2) {}, function (_a) {
      ArtistController = _a.default;
    }],
    execute: function () {
      artistModule = angular.module('app.artist', ['ngCookies', 'vcRecaptcha']).controller('ArtistController', ArtistController);

      _export('default', artistModule);
    }
  };
});
$__System.register('2c', [], function (_export, _context) {
  "use strict";

  var PlayerController;
  return {
    setters: [],
    execute: function () {
      PlayerController = function PlayerController($rootScope, $scope, $http, $state, $stateParams, Settings, ngAudio) {
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$http = $http;
        this.Settings = Settings;
        this.ngAudio = ngAudio;

        // Fix for audio progress control
        $scope.audioProgressControl = {
          get value() {
            if ($rootScope.player) {
              return parseFloat($rootScope.player.progress);
            }

            return 0;
          },
          set value(value) {
            // bugfix. this will prevent your player to get in a audio loop
            if (Math.abs(value - parseFloat($rootScope.player.progress)) < 0.001) {
              return;
            }

            $rootScope.player.progress = value;
          }
        };

        // All loaded tracks
        $rootScope.tracks = [];

        // Embedded player flag
        $rootScope.embed = false;
        $rootScope.embedEntity = null;

        // Current track index
        $rootScope.index = 0;

        // Current track ended; jumping to next
        $rootScope.jumpTrack = false;

        // Current player section source
        $rootScope.playerSection = 'homepage';

        // Player and playing flag
        $rootScope.playing = false;
        $rootScope.player = null;

        // Previous track as object
        $scope.previousTrack = function () {
          return $rootScope.tracks[$rootScope.index - 1];
        };

        // Current track as object
        $scope.currentTrack = function () {
          return $rootScope.tracks[$rootScope.index];
        };

        // Next track as object
        $scope.nextTrack = function () {
          return $rootScope.tracks[$rootScope.index + 1];
        };

        // Check if track has country
        $scope.trackHasCountry = function (track) {
          if (!track || typeof track === 'undefined' || !track.countries) {
            return false;
          }

          return track.countries.length > 0;
        };

        // Link track to country
        $scope.linkTrackToCountry = function (track) {
          if (!track.countries.length) {
            return;
          }

          $state.go('musicmap.country', { alpha2: track.countries[0].alpha2 });
        };

        /**
         * Go to next track.
         */
        $scope.next = function () {
          // Nothing to play
          if (typeof $rootScope.tracks[$rootScope.index + 1] === 'undefined') {
            return;
          }

          $rootScope.index++;
          $rootScope.jumpTrack = false;
          $scope.updateTrack();
        };

        /**
         * Go to previous track.
         */
        $scope.previous = function () {
          // Nothing to play
          if (typeof $rootScope.tracks[$rootScope.index - 1] === 'undefined') {
            return;
          }

          $rootScope.index--;
          $scope.updateTrack();
        };

        /**
         * Update previous/next track and resume if it was playing.
         */
        $scope.updateTrack = function () {
          $rootScope.player.pause();
          $rootScope.player = ngAudio.load($scope.currentTrack().file);

          if ($rootScope.playing === true) {
            $rootScope.player.play();

            $rootScope.player.complete(function () {
              if ($rootScope.jumpTrack === false) {
                $scope.next();
                $rootScope.jumpTrack = true;
              }
            });
          }
        };

        /**
         * Play.
         */
        $scope.play = function () {
          $rootScope.playing = true;
          $rootScope.player.play();
        };

        /**
         * Pause.
         */
        $scope.pause = function () {
          $rootScope.playing = false;
          $rootScope.player.pause();
        };

        /**
         * Start playing the playlist when a track is clicked.
         */
        $rootScope.playlistLoaded = false;
        $rootScope.startPlaylist = function (playlist, index, section) {
          // First track played, load list in to player
          $rootScope.tracks = playlist;
          $rootScope.playlistLoaded = true;

          // Set track cursor
          $rootScope.index = index;

          // Mark as playing for auto start
          $rootScope.playing = true;

          // Set player source section
          $rootScope.playerSection = section;

          $scope.updateTrack();
        };

        /**
         * Render class for play/pause of a track from current playlist.
         */
        $rootScope.trackPlayingClass = function (index) {
          if ($rootScope.playlistLoaded && $rootScope.index === index && $rootScope.playing) {
            return 'fa-pause';
          }

          return 'fa-play';
        };
      };

      PlayerController.prototype = {
        /**
         * Initialize.
         */
        init: function init() {
          // Get homepage playlist
          this.getPlaylist(false);
        },

        /**
         * Get playlist.
         */
        getPlaylist: function getPlaylist(resetHome) {
          if (typeof resetHome === 'undefined') {
            resetHome = false;
          }

          var that = this;

          var stateName = that.$state.current.name;
          var args = '';
          var siteUrl = that.$state.href('musicmap.homepage', {}, { absolute: true });

          // Stop any playing song on homepage reset
          if (resetHome) {
            that.$scope.pause();

            that.$rootScope.index = 0;
            that.$rootScope.playerSection = 'homepage';
          }

          // Country
          if (stateName === 'embed.country' && that.$stateParams.alpha2) {
            args = 'country_alpha2=' + that.$stateParams.alpha2;

            this.$http({
              url: this.Settings.backendHost + '/countries.php?alpha2=' + that.$stateParams.alpha2,
              method: 'GET'
            }).then(function (response) {
              var country = response.data[0];
              var embedUrl = that.$state.href('musicmap.country', { alpha2: country.alpha2 }, { absolute: true });

              that.$rootScope.embedEntity = { name: country.name, url: embedUrl, site: siteUrl };
              that.$rootScope.embed = true;
            }, function (error) {
              console.log('error', error);
            });
          }

          // Continent
          if (stateName === 'embed.continent' && that.$stateParams.name) {
            /**
             * Continents mapping.
             */
            var continents = [];
            continents.europe = { code: 'EU', name: 'Europe' };
            continents.africa = { code: 'AF', name: 'Africa' };
            continents.antarctica = { code: 'AN', name: 'Antarctica' };
            continents.asia = { code: 'AS', name: 'Asia' };
            continents.oceania = { code: 'OC', name: 'Oceania' };
            continents['north-america'] = { code: 'NA', name: 'North America' };
            continents['south-america'] = { code: 'SA', name: 'South America' };

            args = 'continent=' + continents[that.$stateParams.name].code;

            var embedUrl = that.$state.href('musicmap.continent', { name: that.$stateParams.name }, { absolute: true });
            var continentName = continents[that.$stateParams.name].name;

            that.$rootScope.embedEntity = { name: continentName, url: embedUrl, site: siteUrl };
            that.$rootScope.embed = true;
          }

          that.$http({
            url: this.Settings.backendHost + '/playlist.php' + (args ? '?' + args : ''),
            method: 'GET'
          }).then(function (response) {
            that.$rootScope.tracks = response.data.tracks;
            that.$rootScope.player = that.ngAudio.load(that.$scope.currentTrack().file);

            that.$rootScope.player.complete(function () {
              if (that.$rootScope.jumpTrack === false) {
                that.$scope.next();
                that.$rootScope.jumpTrack = true;
              }
            });

            if (resetHome) {
              that.$scope.play();
            }
          }, function (error) {
            console.log('error', error);
          });
        }
      };

      PlayerController.$inject = ['$rootScope', '$scope', '$http', '$state', '$stateParams', 'Settings', 'ngAudio'];

      _export('default', PlayerController);
    }
  };
});
$__System.register('2d', ['3', '2c'], function (_export, _context) {
  "use strict";

  var angular, PlayerController, playerModule;
  return {
    setters: [function (_) {
      angular = _.default;
    }, function (_c) {
      PlayerController = _c.default;
    }],
    execute: function () {
      playerModule = angular.module('app.player', ['ngCookies']).controller('PlayerController', PlayerController).constant('ngAudioUidLookup', function () {
        var uidLookup = {};
        return uidLookup;
      }()).value('ngAudioUidGenerator', function () {
        var domUid = '';
        for (var i = 0; i < 8; i++) {
          domUid = domUid + Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
        }
        return domUid; //unique id persisting through module life
      }).directive('ngAudio', ['$compile', '$q', 'ngAudio', function ($compile, $q, ngAudio) {
        return {
          restrict: 'AEC',
          scope: {
            volume: '=',
            start: '=',
            currentTime: '=',
            loop: '=',
            clickPlay: '=',
            disablePreload: '='
            //ngAudio:'='
          },
          controller: ['$scope', '$attrs', '$element', '$timeout', function ($scope, $attrs, $element, $timeout) {

            /* Loads the sound from destination */
            var audio;

            function initSound() {
              audio = ngAudio.load($attrs.ngAudio, $scope);
              /* Add audio to local scope for modification with nested inputs */
              $scope.$audio = audio;

              /* Remove watching features for improved performance */
              audio.unbind();
            }

            if (!$scope.disablePreload) {
              initSound();
            }

            $element.on('click', function () {
              if ($scope.clickPlay === false) {
                return;
              }

              if ($scope.disablePreload) {
                initSound();
              }

              /* iOS workaround: Call the play method directly in listener function */
              audio.audio.play();

              /* Set volume to $scope volume if it exists, or default to audio's current value */
              audio.volume = $scope.volume || audio.volume;
              audio.loop = $scope.loop;
              audio.currentTime = $scope.start || 0;

              /* Fixes a bug with Firefox (???) */
              $timeout(function () {
                audio.play();
              }, 5);
            });

            $element.on('$destroy', function () {
              audio.destroy();
            });
          }]
        };
      }]).directive('ngAudioHover', ['$compile', '$q', 'ngAudio', function ($compile, $q, ngAudio) {
        return {
          restrict: 'AEC',
          controller: ['$scope', '$attrs', '$element', '$timeout', function ($scope, $attrs, $element, $timeout) {

            var audio = ngAudio.load($attrs.ngAudioHover, $scope);

            $element.on('mouseover rollover hover', function () {

              /* iOS workaround: Call the play method directly in listener function */
              audio.audio.play();

              audio.volume = $attrs.volumeHover || audio.volume;
              audio.loop = $attrs.loop;
              audio.currentTime = $attrs.startHover || 0;
            });

            $element.on('$destroy', function () {
              audio.destroy();
            });
          }]
        };
      }]).service('localAudioFindingService', ['$q', function ($q) {

        this.find = function (id) {
          var deferred = $q.defer();
          var $sound = document.getElementById(id);
          if ($sound) {
            deferred.resolve($sound);
          } else {
            deferred.reject(id);
          }

          return deferred.promise;
        };
      }]).service('remoteAudioFindingService', ['$q', 'ngAudioUidLookup', 'ngAudioUidGenerator', function ($q, ngAudioUidLookup, ngAudioUidGenerator) {
        this.find = function (url) {
          var deferred = $q.defer();
          var uId;
          uId = ngAudioUidLookup[url];
          if (uId == null) {
            uId = ngAudioUidGenerator();
            ngAudioUidLookup[url] = uId;
          }
          var $sound = document.getElementById(uId);
          if (!$sound) {
            var audioTag = document.createElement('audio');
            audioTag.style.display = 'none';
            audioTag.id = uId;
            audioTag.src = url;
            document.body.appendChild(audioTag);
            $sound = document.getElementById(uId);
            $sound.load();
          } else {
            $sound.pause();
            $sound.src = url;
            $sound.load();
          }

          if ($sound) {
            deferred.resolve($sound);
          } else {
            deferred.reject(id);
          }

          return deferred.promise;
        };
      }]).service('cleverAudioFindingService', ['$q', 'localAudioFindingService', 'remoteAudioFindingService', function ($q, localAudioFindingService, remoteAudioFindingService) {
        this.find = function (id) {
          var deferred = $q.defer();

          id = id.replace('|', '/');

          localAudioFindingService.find(id).then(deferred.resolve, function () {
            return remoteAudioFindingService.find(id);
          }).then(deferred.resolve, deferred.reject);

          return deferred.promise;
        };
      }]).value('ngAudioGlobals', {
        muting: false,
        performance: 25,
        unlock: true,
        volume: 1
      }).factory('NgAudioObject', ['cleverAudioFindingService', '$rootScope', '$interval', '$timeout', 'ngAudioGlobals', function (cleverAudioFindingService, $rootScope, $interval, $timeout, ngAudioGlobals) {
        return function (id, scope) {

          function twiddle() {
            try {
              audio.play();
              audio.pause();
            } catch (e) {}
            window.removeEventListener("click", twiddle);
          }

          var $audioWatch,
              $intervalWatch,
              $willPlay = false,
              $willPause = false,
              $willRestart = false,
              $willChangePlaybackRate = false,
              $newPlaybackRate = false,
              $volumeToSet,
              $looping,
              $isMuting = false,
              $observeProperties = true,
              $destroyed = false,
              $scope = scope || $rootScope,
              audio,
              audioObject = this;

          this.id = id;
          this.safeId = id.replace('/', '|');
          this.loop = 0;

          this.unbind = function () {
            $observeProperties = false;
          };

          this.play = function () {
            $willPlay = true;
            return this;
          };

          var completeListeners = [];
          this.complete = function (callback) {
            completeListeners.push(callback);
          };

          var toFinishListeners = [];
          this.toFinish = function (secs, callback) {
            toFinishListeners.push({ 'secs': secs, 'callback': callback });
          };

          this.pause = function () {
            $willPause = true;
          };

          this.restart = function () {
            $willRestart = true;
          };

          this.stop = function () {
            this.restart();
          };

          this.setVolume = function (volume) {
            $volumeToSet = volume;
          };

          this.setPlaybackRate = function (rate) {
            $newPlaybackRate = rate;
            $willChangePlaybackRate = true;
          };

          this.setMuting = function (muting) {
            $isMuting = muting;
          };

          this.setProgress = function (progress) {
            if (audio && audio.duration && isFinite(progress)) {
              audio.currentTime = audio.duration * progress;
            }
          };

          this.setPercentage = function (percentage) {
            if (audio && audio.duration && isFinite(percentage)) {
              audio.currentTime = audio.duration * (percentage / 100);
            }
          };

          this.setCurrentTime = function (currentTime) {
            if (audio && audio.duration) {
              audio.currentTime = currentTime;
            }
          };

          this.destroy = $destroy;

          $scope.$on('$destroy', function () {
            $destroy();
          });

          function $destroy() {
            if (!$destroyed) {
              if (interval) {
                $interval.cancel(interval);
              }
              if ($intervalWatch) {
                $intervalWatch();
              }
              if ($audioWatch) {
                $audioWatch();
              }
              $destroyed = true;
            }
          }

          this.destroyed = function () {
            return $destroyed;
          };

          function $setWatch() {
            if ($destroyed) {
              return;
            }
            $audioWatch = $scope.$watch(function () {
              return {
                volume: audioObject.volume,
                currentTime: audioObject.currentTime,
                progress: audioObject.progress,
                percentage: audioObject.percentage,
                muting: audioObject.muting,
                loop: audioObject.loop,
                playbackRate: audioObject.playbackRate,
                globalVolume: ngAudioGlobals.volume
              };
            }, function (newValue, oldValue) {
              //console.log("ngaudio watch callback for: " + audioObject.id);
              if (newValue.currentTime !== oldValue.currentTime) {
                audioObject.setCurrentTime(newValue.currentTime);
              }

              if (newValue.progress !== oldValue.progress) {
                audioObject.setProgress(newValue.progress);
              }
              if (newValue.percentage !== oldValue.percentage) {
                audioObject.setPercentage(newValue.percentage);
              }
              if (newValue.volume !== oldValue.volume) {
                audioObject.setVolume(newValue.volume);
              }

              if (newValue.playbackRate !== oldValue.playbackRate) {
                audioObject.setPlaybackRate(newValue.playbackRate);
              }

              if (newValue.globalVolume !== oldValue.globalVolume) {
                if (newValue.globalVolume === 0) {
                  audioObject.setMuting(true);
                } else {
                  audioObject.setMuting(false);
                  audioObject.setVolume(newValue.globalVolume);
                }
              }

              $looping = newValue.loop;

              if (newValue.muting !== oldValue.muting) {
                audioObject.setMuting(newValue.muting);
              }
            }, true);
          }

          function audioLoadError() {
            audioObject.error = true;
          }

          cleverAudioFindingService.find(id).then(function (nativeAudio) {
            audio = nativeAudio;
            if (ngAudioGlobals.unlock) {

              window.addEventListener("click", twiddle);

              audio.addEventListener('playing', function () {
                window.removeEventListener("click", twiddle);
              });
            }

            audio.addEventListener('error', audioLoadError);

            audio.addEventListener('canplay', function () {
              audioObject.canPlay = true;
            });
          }, audioLoadError);

          var interval = $interval(checkWatchers, ngAudioGlobals.performance);
          $intervalWatch = $scope.$watch(function () {
            return ngAudioGlobals.performance;
          }, function () {
            $interval.cancel(interval);
            interval = $interval(checkWatchers, ngAudioGlobals.performance);
          });

          function checkWatchers() {
            if ($audioWatch) {
              $audioWatch();
            }
            if (audio) {

              if ($isMuting || ngAudioGlobals.muting) {
                audio.volume = 0;
              } else {
                audio.volume = audioObject.volume !== undefined ? audioObject.volume : 1;
              }

              if ($willPlay) {
                audio.play();
                $willPlay = false;
              }

              if ($willRestart) {
                audio.pause();
                audio.currentTime = 0;
                $willRestart = false;
              }

              if ($willPause) {
                audio.pause();
                $willPause = false;
              }

              if ($willChangePlaybackRate) {
                audio.playbackRate = $newPlaybackRate;
                $willChangePlaybackRate = false;
              }

              if ($volumeToSet) {
                audio.volume = $volumeToSet;
                $volumeToSet = undefined;
              }

              if ($observeProperties) {
                audioObject.currentTime = audio.currentTime;
                audioObject.duration = audio.duration;
                audioObject.remaining = audio.duration - audio.currentTime;
                audioObject.progress = 0; //We set initial value to 0
                audioObject.percentage = 0; // We set initial value to 0
                audioObject.paused = audio.paused;
                audioObject.src = audio.src;

                //After we check if progress is bigger than 0, and we set
                var tempProgress = (audio.currentTime / audio.duration).toPrecision();
                if (tempProgress > 0) {
                  audioObject.progress = parseFloat(tempProgress);
                  audioObject.percentage = parseInt(audio.currentTime * 100 / audio.duration);
                }

                if (audioObject.currentTime >= audioObject.duration) {
                  completeListeners.forEach(function (listener) {
                    listener(audioObject);
                  });
                }

                toFinishListeners.forEach(function (listener) {
                  if (audioObject.duration - audioObject.currentTime <= listener.secs) {
                    listener.callback(audioObject);
                    toFinishListeners.shift();
                  }
                });

                if ($looping && audioObject.currentTime >= audioObject.duration) {
                  if ($looping !== true) {
                    $looping--;
                    audioObject.loop--;
                    // if (!$looping) return;
                  }
                  audioObject.setCurrentTime(0);
                  audioObject.play();
                }
              }

              if (!$isMuting && !ngAudioGlobals.muting) {
                audioObject.volume = audio.volume;
              }

              audioObject.audio = audio;
            }

            $setWatch();
          }
        };
      }]).service('ngAudio', ['NgAudioObject', 'ngAudioGlobals', '$cookies', '$location', function (NgAudioObject, ngAudioGlobals, $cookies, $location) {
        this.play = function (id, scope) {
          var audio = new NgAudioObject(id, scope);
          audio.play();
          return audio;
        };

        this.load = function (id, scope) {
          var url = new URL(id);
          var hash = url.search.replace('?hash=', '');
          var rand = Math.floor(Math.random() * 999999999999 + 1);

          // Cookie helpers
          var now = new Date();
          var exp = new Date(now.getTime() + 1000 * 60); // 60 seconds

          var domain = $location.host().split('.').splice(1).join('.');

          // Set user data
          $cookies.put('player', hash + rand, {
            'path': '/',
            'expires': exp,
            'domain': domain
          });

          // Append random salt
          id += '&rand=' + rand;

          return new NgAudioObject(id, scope);
        };

        this.mute = function () {
          ngAudioGlobals.muting = true;
        };

        this.unmute = function () {
          ngAudioGlobals.muting = false;
        };

        this.toggleMute = function () {
          ngAudioGlobals.muting = !ngAudioGlobals.muting;
        };

        this.setUnlock = function (unlock) {
          ngAudioGlobals.unlock = unlock;
        };

        this.setGlobalVolume = function (globalVolume) {
          ngAudioGlobals.volume = globalVolume;
        };
      }]).filter("trackTime", function () {
        /* Conveniently takes a number and returns the track time */

        return function (input) {

          var totalSec = Math.floor(input | 0);

          var output = "";
          var hours = 0;
          var minutes = 0;
          var seconds = 0;

          if (totalSec > 3599) {
            hours = Math.floor(totalSec / 3600);
            minutes = Math.floor((totalSec - hours * 3600) / 60);
            seconds = totalSec - (minutes * 60 + hours * 3600);

            if (hours.toString().length === 1) {
              hours = '0' + Math.floor(totalSec / 3600).toString();
            }

            if (minutes.toString().length === 1) {
              minutes = '0' + Math.floor((totalSec - hours * 3600) / 60).toString();
            }

            if (seconds.toString().length === 1) {
              seconds = '0' + (totalSec - (minutes * 60 + hours * 3600)).toString();
            }

            output = hours + ':' + minutes + ':' + seconds;
          } else if (totalSec > 59) {
            minutes = Math.floor(totalSec / 60);
            seconds = totalSec - minutes * 60;

            if (minutes.toString().length === 1) {
              minutes = '0' + Math.floor(totalSec / 60).toString();
            }

            if (seconds.toString().length === 1) {
              seconds = '0' + (totalSec - minutes * 60).toString();
            }

            output = minutes + ':' + seconds;
          } else {
            seconds = totalSec;

            if (seconds.toString().length === 1) {
              seconds = '0' + totalSec.toString();
            }

            output = '00:' + seconds;
          }

          if (typeof Number.isNaN === "function" && Number.isNaN(output)) {
            debugger;
          }

          return output;
        };
      });

      _export('default', playerModule);
    }
  };
});
$__System.registerDynamic("3", [], false, function($__require, $__exports, $__module) {
  var _retrieveGlobal = $__System.get("@@global-helpers").prepareGlobal($__module.id, "angular", null);
  (function() {
    (function(window) {
      'use strict';
      var minErrConfig = {objectMaxDepth: 5};
      function errorHandlingConfig(config) {
        if (isObject(config)) {
          if (isDefined(config.objectMaxDepth)) {
            minErrConfig.objectMaxDepth = isValidObjectMaxDepth(config.objectMaxDepth) ? config.objectMaxDepth : NaN;
          }
        } else {
          return minErrConfig;
        }
      }
      function isValidObjectMaxDepth(maxDepth) {
        return isNumber(maxDepth) && maxDepth > 0;
      }
      function minErr(module, ErrorConstructor) {
        ErrorConstructor = ErrorConstructor || Error;
        return function() {
          var code = arguments[0],
              template = arguments[1],
              message = '[' + (module ? module + ':' : '') + code + '] ',
              templateArgs = sliceArgs(arguments, 2).map(function(arg) {
                return toDebugString(arg, minErrConfig.objectMaxDepth);
              }),
              paramPrefix,
              i;
          message += template.replace(/\{\d+\}/g, function(match) {
            var index = +match.slice(1, -1);
            if (index < templateArgs.length) {
              return templateArgs[index];
            }
            return match;
          });
          message += '\nhttp://errors.angularjs.org/1.6.9/' + (module ? module + '/' : '') + code;
          for (i = 0, paramPrefix = '?'; i < templateArgs.length; i++, paramPrefix = '&') {
            message += paramPrefix + 'p' + i + '=' + encodeURIComponent(templateArgs[i]);
          }
          return new ErrorConstructor(message);
        };
      }
      var REGEX_STRING_REGEXP = /^\/(.+)\/([a-z]*)$/;
      var VALIDITY_STATE_PROPERTY = 'validity';
      var hasOwnProperty = Object.prototype.hasOwnProperty;
      var lowercase = function(string) {
        return isString(string) ? string.toLowerCase() : string;
      };
      var uppercase = function(string) {
        return isString(string) ? string.toUpperCase() : string;
      };
      var manualLowercase = function(s) {
        return isString(s) ? s.replace(/[A-Z]/g, function(ch) {
          return String.fromCharCode(ch.charCodeAt(0) | 32);
        }) : s;
      };
      var manualUppercase = function(s) {
        return isString(s) ? s.replace(/[a-z]/g, function(ch) {
          return String.fromCharCode(ch.charCodeAt(0) & ~32);
        }) : s;
      };
      if ('i' !== 'I'.toLowerCase()) {
        lowercase = manualLowercase;
        uppercase = manualUppercase;
      }
      var msie,
          jqLite,
          jQuery,
          slice = [].slice,
          splice = [].splice,
          push = [].push,
          toString = Object.prototype.toString,
          getPrototypeOf = Object.getPrototypeOf,
          ngMinErr = minErr('ng'),
          angular = window.angular || (window.angular = {}),
          angularModule,
          uid = 0;
      msie = window.document.documentMode;
      function isArrayLike(obj) {
        if (obj == null || isWindow(obj))
          return false;
        if (isArray(obj) || isString(obj) || (jqLite && obj instanceof jqLite))
          return true;
        var length = 'length' in Object(obj) && obj.length;
        return isNumber(length) && (length >= 0 && ((length - 1) in obj || obj instanceof Array) || typeof obj.item === 'function');
      }
      function forEach(obj, iterator, context) {
        var key,
            length;
        if (obj) {
          if (isFunction(obj)) {
            for (key in obj) {
              if (key !== 'prototype' && key !== 'length' && key !== 'name' && obj.hasOwnProperty(key)) {
                iterator.call(context, obj[key], key, obj);
              }
            }
          } else if (isArray(obj) || isArrayLike(obj)) {
            var isPrimitive = typeof obj !== 'object';
            for (key = 0, length = obj.length; key < length; key++) {
              if (isPrimitive || key in obj) {
                iterator.call(context, obj[key], key, obj);
              }
            }
          } else if (obj.forEach && obj.forEach !== forEach) {
            obj.forEach(iterator, context, obj);
          } else if (isBlankObject(obj)) {
            for (key in obj) {
              iterator.call(context, obj[key], key, obj);
            }
          } else if (typeof obj.hasOwnProperty === 'function') {
            for (key in obj) {
              if (obj.hasOwnProperty(key)) {
                iterator.call(context, obj[key], key, obj);
              }
            }
          } else {
            for (key in obj) {
              if (hasOwnProperty.call(obj, key)) {
                iterator.call(context, obj[key], key, obj);
              }
            }
          }
        }
        return obj;
      }
      function forEachSorted(obj, iterator, context) {
        var keys = Object.keys(obj).sort();
        for (var i = 0; i < keys.length; i++) {
          iterator.call(context, obj[keys[i]], keys[i]);
        }
        return keys;
      }
      function reverseParams(iteratorFn) {
        return function(value, key) {
          iteratorFn(key, value);
        };
      }
      function nextUid() {
        return ++uid;
      }
      function setHashKey(obj, h) {
        if (h) {
          obj.$$hashKey = h;
        } else {
          delete obj.$$hashKey;
        }
      }
      function baseExtend(dst, objs, deep) {
        var h = dst.$$hashKey;
        for (var i = 0,
            ii = objs.length; i < ii; ++i) {
          var obj = objs[i];
          if (!isObject(obj) && !isFunction(obj))
            continue;
          var keys = Object.keys(obj);
          for (var j = 0,
              jj = keys.length; j < jj; j++) {
            var key = keys[j];
            var src = obj[key];
            if (deep && isObject(src)) {
              if (isDate(src)) {
                dst[key] = new Date(src.valueOf());
              } else if (isRegExp(src)) {
                dst[key] = new RegExp(src);
              } else if (src.nodeName) {
                dst[key] = src.cloneNode(true);
              } else if (isElement(src)) {
                dst[key] = src.clone();
              } else {
                if (!isObject(dst[key]))
                  dst[key] = isArray(src) ? [] : {};
                baseExtend(dst[key], [src], true);
              }
            } else {
              dst[key] = src;
            }
          }
        }
        setHashKey(dst, h);
        return dst;
      }
      function extend(dst) {
        return baseExtend(dst, slice.call(arguments, 1), false);
      }
      function merge(dst) {
        return baseExtend(dst, slice.call(arguments, 1), true);
      }
      function toInt(str) {
        return parseInt(str, 10);
      }
      var isNumberNaN = Number.isNaN || function isNumberNaN(num) {
        return num !== num;
      };
      function inherit(parent, extra) {
        return extend(Object.create(parent), extra);
      }
      function noop() {}
      noop.$inject = [];
      function identity($) {
        return $;
      }
      identity.$inject = [];
      function valueFn(value) {
        return function valueRef() {
          return value;
        };
      }
      function hasCustomToString(obj) {
        return isFunction(obj.toString) && obj.toString !== toString;
      }
      function isUndefined(value) {
        return typeof value === 'undefined';
      }
      function isDefined(value) {
        return typeof value !== 'undefined';
      }
      function isObject(value) {
        return value !== null && typeof value === 'object';
      }
      function isBlankObject(value) {
        return value !== null && typeof value === 'object' && !getPrototypeOf(value);
      }
      function isString(value) {
        return typeof value === 'string';
      }
      function isNumber(value) {
        return typeof value === 'number';
      }
      function isDate(value) {
        return toString.call(value) === '[object Date]';
      }
      var isArray = Array.isArray;
      function isError(value) {
        var tag = toString.call(value);
        switch (tag) {
          case '[object Error]':
            return true;
          case '[object Exception]':
            return true;
          case '[object DOMException]':
            return true;
          default:
            return value instanceof Error;
        }
      }
      function isFunction(value) {
        return typeof value === 'function';
      }
      function isRegExp(value) {
        return toString.call(value) === '[object RegExp]';
      }
      function isWindow(obj) {
        return obj && obj.window === obj;
      }
      function isScope(obj) {
        return obj && obj.$evalAsync && obj.$watch;
      }
      function isFile(obj) {
        return toString.call(obj) === '[object File]';
      }
      function isFormData(obj) {
        return toString.call(obj) === '[object FormData]';
      }
      function isBlob(obj) {
        return toString.call(obj) === '[object Blob]';
      }
      function isBoolean(value) {
        return typeof value === 'boolean';
      }
      function isPromiseLike(obj) {
        return obj && isFunction(obj.then);
      }
      var TYPED_ARRAY_REGEXP = /^\[object (?:Uint8|Uint8Clamped|Uint16|Uint32|Int8|Int16|Int32|Float32|Float64)Array]$/;
      function isTypedArray(value) {
        return value && isNumber(value.length) && TYPED_ARRAY_REGEXP.test(toString.call(value));
      }
      function isArrayBuffer(obj) {
        return toString.call(obj) === '[object ArrayBuffer]';
      }
      var trim = function(value) {
        return isString(value) ? value.trim() : value;
      };
      var escapeForRegexp = function(s) {
        return s.replace(/([-()[\]{}+?*.$^|,:#<!\\])/g, '\\$1').replace(/\x08/g, '\\x08');
      };
      function isElement(node) {
        return !!(node && (node.nodeName || (node.prop && node.attr && node.find)));
      }
      function makeMap(str) {
        var obj = {},
            items = str.split(','),
            i;
        for (i = 0; i < items.length; i++) {
          obj[items[i]] = true;
        }
        return obj;
      }
      function nodeName_(element) {
        return lowercase(element.nodeName || (element[0] && element[0].nodeName));
      }
      function includes(array, obj) {
        return Array.prototype.indexOf.call(array, obj) !== -1;
      }
      function arrayRemove(array, value) {
        var index = array.indexOf(value);
        if (index >= 0) {
          array.splice(index, 1);
        }
        return index;
      }
      function copy(source, destination, maxDepth) {
        var stackSource = [];
        var stackDest = [];
        maxDepth = isValidObjectMaxDepth(maxDepth) ? maxDepth : NaN;
        if (destination) {
          if (isTypedArray(destination) || isArrayBuffer(destination)) {
            throw ngMinErr('cpta', 'Can\'t copy! TypedArray destination cannot be mutated.');
          }
          if (source === destination) {
            throw ngMinErr('cpi', 'Can\'t copy! Source and destination are identical.');
          }
          if (isArray(destination)) {
            destination.length = 0;
          } else {
            forEach(destination, function(value, key) {
              if (key !== '$$hashKey') {
                delete destination[key];
              }
            });
          }
          stackSource.push(source);
          stackDest.push(destination);
          return copyRecurse(source, destination, maxDepth);
        }
        return copyElement(source, maxDepth);
        function copyRecurse(source, destination, maxDepth) {
          maxDepth--;
          if (maxDepth < 0) {
            return '...';
          }
          var h = destination.$$hashKey;
          var key;
          if (isArray(source)) {
            for (var i = 0,
                ii = source.length; i < ii; i++) {
              destination.push(copyElement(source[i], maxDepth));
            }
          } else if (isBlankObject(source)) {
            for (key in source) {
              destination[key] = copyElement(source[key], maxDepth);
            }
          } else if (source && typeof source.hasOwnProperty === 'function') {
            for (key in source) {
              if (source.hasOwnProperty(key)) {
                destination[key] = copyElement(source[key], maxDepth);
              }
            }
          } else {
            for (key in source) {
              if (hasOwnProperty.call(source, key)) {
                destination[key] = copyElement(source[key], maxDepth);
              }
            }
          }
          setHashKey(destination, h);
          return destination;
        }
        function copyElement(source, maxDepth) {
          if (!isObject(source)) {
            return source;
          }
          var index = stackSource.indexOf(source);
          if (index !== -1) {
            return stackDest[index];
          }
          if (isWindow(source) || isScope(source)) {
            throw ngMinErr('cpws', 'Can\'t copy! Making copies of Window or Scope instances is not supported.');
          }
          var needsRecurse = false;
          var destination = copyType(source);
          if (destination === undefined) {
            destination = isArray(source) ? [] : Object.create(getPrototypeOf(source));
            needsRecurse = true;
          }
          stackSource.push(source);
          stackDest.push(destination);
          return needsRecurse ? copyRecurse(source, destination, maxDepth) : destination;
        }
        function copyType(source) {
          switch (toString.call(source)) {
            case '[object Int8Array]':
            case '[object Int16Array]':
            case '[object Int32Array]':
            case '[object Float32Array]':
            case '[object Float64Array]':
            case '[object Uint8Array]':
            case '[object Uint8ClampedArray]':
            case '[object Uint16Array]':
            case '[object Uint32Array]':
              return new source.constructor(copyElement(source.buffer), source.byteOffset, source.length);
            case '[object ArrayBuffer]':
              if (!source.slice) {
                var copied = new ArrayBuffer(source.byteLength);
                new Uint8Array(copied).set(new Uint8Array(source));
                return copied;
              }
              return source.slice(0);
            case '[object Boolean]':
            case '[object Number]':
            case '[object String]':
            case '[object Date]':
              return new source.constructor(source.valueOf());
            case '[object RegExp]':
              var re = new RegExp(source.source, source.toString().match(/[^/]*$/)[0]);
              re.lastIndex = source.lastIndex;
              return re;
            case '[object Blob]':
              return new source.constructor([source], {type: source.type});
          }
          if (isFunction(source.cloneNode)) {
            return source.cloneNode(true);
          }
        }
      }
      function simpleCompare(a, b) {
        return a === b || (a !== a && b !== b);
      }
      function equals(o1, o2) {
        if (o1 === o2)
          return true;
        if (o1 === null || o2 === null)
          return false;
        if (o1 !== o1 && o2 !== o2)
          return true;
        var t1 = typeof o1,
            t2 = typeof o2,
            length,
            key,
            keySet;
        if (t1 === t2 && t1 === 'object') {
          if (isArray(o1)) {
            if (!isArray(o2))
              return false;
            if ((length = o1.length) === o2.length) {
              for (key = 0; key < length; key++) {
                if (!equals(o1[key], o2[key]))
                  return false;
              }
              return true;
            }
          } else if (isDate(o1)) {
            if (!isDate(o2))
              return false;
            return simpleCompare(o1.getTime(), o2.getTime());
          } else if (isRegExp(o1)) {
            if (!isRegExp(o2))
              return false;
            return o1.toString() === o2.toString();
          } else {
            if (isScope(o1) || isScope(o2) || isWindow(o1) || isWindow(o2) || isArray(o2) || isDate(o2) || isRegExp(o2))
              return false;
            keySet = createMap();
            for (key in o1) {
              if (key.charAt(0) === '$' || isFunction(o1[key]))
                continue;
              if (!equals(o1[key], o2[key]))
                return false;
              keySet[key] = true;
            }
            for (key in o2) {
              if (!(key in keySet) && key.charAt(0) !== '$' && isDefined(o2[key]) && !isFunction(o2[key]))
                return false;
            }
            return true;
          }
        }
        return false;
      }
      var csp = function() {
        if (!isDefined(csp.rules)) {
          var ngCspElement = (window.document.querySelector('[ng-csp]') || window.document.querySelector('[data-ng-csp]'));
          if (ngCspElement) {
            var ngCspAttribute = ngCspElement.getAttribute('ng-csp') || ngCspElement.getAttribute('data-ng-csp');
            csp.rules = {
              noUnsafeEval: !ngCspAttribute || (ngCspAttribute.indexOf('no-unsafe-eval') !== -1),
              noInlineStyle: !ngCspAttribute || (ngCspAttribute.indexOf('no-inline-style') !== -1)
            };
          } else {
            csp.rules = {
              noUnsafeEval: noUnsafeEval(),
              noInlineStyle: false
            };
          }
        }
        return csp.rules;
        function noUnsafeEval() {
          try {
            new Function('');
            return false;
          } catch (e) {
            return true;
          }
        }
      };
      var jq = function() {
        if (isDefined(jq.name_))
          return jq.name_;
        var el;
        var i,
            ii = ngAttrPrefixes.length,
            prefix,
            name;
        for (i = 0; i < ii; ++i) {
          prefix = ngAttrPrefixes[i];
          el = window.document.querySelector('[' + prefix.replace(':', '\\:') + 'jq]');
          if (el) {
            name = el.getAttribute(prefix + 'jq');
            break;
          }
        }
        return (jq.name_ = name);
      };
      function concat(array1, array2, index) {
        return array1.concat(slice.call(array2, index));
      }
      function sliceArgs(args, startIndex) {
        return slice.call(args, startIndex || 0);
      }
      function bind(self, fn) {
        var curryArgs = arguments.length > 2 ? sliceArgs(arguments, 2) : [];
        if (isFunction(fn) && !(fn instanceof RegExp)) {
          return curryArgs.length ? function() {
            return arguments.length ? fn.apply(self, concat(curryArgs, arguments, 0)) : fn.apply(self, curryArgs);
          } : function() {
            return arguments.length ? fn.apply(self, arguments) : fn.call(self);
          };
        } else {
          return fn;
        }
      }
      function toJsonReplacer(key, value) {
        var val = value;
        if (typeof key === 'string' && key.charAt(0) === '$' && key.charAt(1) === '$') {
          val = undefined;
        } else if (isWindow(value)) {
          val = '$WINDOW';
        } else if (value && window.document === value) {
          val = '$DOCUMENT';
        } else if (isScope(value)) {
          val = '$SCOPE';
        }
        return val;
      }
      function toJson(obj, pretty) {
        if (isUndefined(obj))
          return undefined;
        if (!isNumber(pretty)) {
          pretty = pretty ? 2 : null;
        }
        return JSON.stringify(obj, toJsonReplacer, pretty);
      }
      function fromJson(json) {
        return isString(json) ? JSON.parse(json) : json;
      }
      var ALL_COLONS = /:/g;
      function timezoneToOffset(timezone, fallback) {
        timezone = timezone.replace(ALL_COLONS, '');
        var requestedTimezoneOffset = Date.parse('Jan 01, 1970 00:00:00 ' + timezone) / 60000;
        return isNumberNaN(requestedTimezoneOffset) ? fallback : requestedTimezoneOffset;
      }
      function addDateMinutes(date, minutes) {
        date = new Date(date.getTime());
        date.setMinutes(date.getMinutes() + minutes);
        return date;
      }
      function convertTimezoneToLocal(date, timezone, reverse) {
        reverse = reverse ? -1 : 1;
        var dateTimezoneOffset = date.getTimezoneOffset();
        var timezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
        return addDateMinutes(date, reverse * (timezoneOffset - dateTimezoneOffset));
      }
      function startingTag(element) {
        element = jqLite(element).clone().empty();
        var elemHtml = jqLite('<div>').append(element).html();
        try {
          return element[0].nodeType === NODE_TYPE_TEXT ? lowercase(elemHtml) : elemHtml.match(/^(<[^>]+>)/)[1].replace(/^<([\w-]+)/, function(match, nodeName) {
            return '<' + lowercase(nodeName);
          });
        } catch (e) {
          return lowercase(elemHtml);
        }
      }
      function tryDecodeURIComponent(value) {
        try {
          return decodeURIComponent(value);
        } catch (e) {}
      }
      function parseKeyValue(keyValue) {
        var obj = {};
        forEach((keyValue || '').split('&'), function(keyValue) {
          var splitPoint,
              key,
              val;
          if (keyValue) {
            key = keyValue = keyValue.replace(/\+/g, '%20');
            splitPoint = keyValue.indexOf('=');
            if (splitPoint !== -1) {
              key = keyValue.substring(0, splitPoint);
              val = keyValue.substring(splitPoint + 1);
            }
            key = tryDecodeURIComponent(key);
            if (isDefined(key)) {
              val = isDefined(val) ? tryDecodeURIComponent(val) : true;
              if (!hasOwnProperty.call(obj, key)) {
                obj[key] = val;
              } else if (isArray(obj[key])) {
                obj[key].push(val);
              } else {
                obj[key] = [obj[key], val];
              }
            }
          }
        });
        return obj;
      }
      function toKeyValue(obj) {
        var parts = [];
        forEach(obj, function(value, key) {
          if (isArray(value)) {
            forEach(value, function(arrayValue) {
              parts.push(encodeUriQuery(key, true) + (arrayValue === true ? '' : '=' + encodeUriQuery(arrayValue, true)));
            });
          } else {
            parts.push(encodeUriQuery(key, true) + (value === true ? '' : '=' + encodeUriQuery(value, true)));
          }
        });
        return parts.length ? parts.join('&') : '';
      }
      function encodeUriSegment(val) {
        return encodeUriQuery(val, true).replace(/%26/gi, '&').replace(/%3D/gi, '=').replace(/%2B/gi, '+');
      }
      function encodeUriQuery(val, pctEncodeSpaces) {
        return encodeURIComponent(val).replace(/%40/gi, '@').replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%3B/gi, ';').replace(/%20/g, (pctEncodeSpaces ? '%20' : '+'));
      }
      var ngAttrPrefixes = ['ng-', 'data-ng-', 'ng:', 'x-ng-'];
      function getNgAttribute(element, ngAttr) {
        var attr,
            i,
            ii = ngAttrPrefixes.length;
        for (i = 0; i < ii; ++i) {
          attr = ngAttrPrefixes[i] + ngAttr;
          if (isString(attr = element.getAttribute(attr))) {
            return attr;
          }
        }
        return null;
      }
      function allowAutoBootstrap(document) {
        var script = document.currentScript;
        if (!script) {
          return true;
        }
        if (!(script instanceof window.HTMLScriptElement || script instanceof window.SVGScriptElement)) {
          return false;
        }
        var attributes = script.attributes;
        var srcs = [attributes.getNamedItem('src'), attributes.getNamedItem('href'), attributes.getNamedItem('xlink:href')];
        return srcs.every(function(src) {
          if (!src) {
            return true;
          }
          if (!src.value) {
            return false;
          }
          var link = document.createElement('a');
          link.href = src.value;
          if (document.location.origin === link.origin) {
            return true;
          }
          switch (link.protocol) {
            case 'http:':
            case 'https:':
            case 'ftp:':
            case 'blob:':
            case 'file:':
            case 'data:':
              return true;
            default:
              return false;
          }
        });
      }
      var isAutoBootstrapAllowed = allowAutoBootstrap(window.document);
      function angularInit(element, bootstrap) {
        var appElement,
            module,
            config = {};
        forEach(ngAttrPrefixes, function(prefix) {
          var name = prefix + 'app';
          if (!appElement && element.hasAttribute && element.hasAttribute(name)) {
            appElement = element;
            module = element.getAttribute(name);
          }
        });
        forEach(ngAttrPrefixes, function(prefix) {
          var name = prefix + 'app';
          var candidate;
          if (!appElement && (candidate = element.querySelector('[' + name.replace(':', '\\:') + ']'))) {
            appElement = candidate;
            module = candidate.getAttribute(name);
          }
        });
        if (appElement) {
          if (!isAutoBootstrapAllowed) {
            window.console.error('AngularJS: disabling automatic bootstrap. <script> protocol indicates ' + 'an extension, document.location.href does not match.');
            return;
          }
          config.strictDi = getNgAttribute(appElement, 'strict-di') !== null;
          bootstrap(appElement, module ? [module] : [], config);
        }
      }
      function bootstrap(element, modules, config) {
        if (!isObject(config))
          config = {};
        var defaultConfig = {strictDi: false};
        config = extend(defaultConfig, config);
        var doBootstrap = function() {
          element = jqLite(element);
          if (element.injector()) {
            var tag = (element[0] === window.document) ? 'document' : startingTag(element);
            throw ngMinErr('btstrpd', 'App already bootstrapped with this element \'{0}\'', tag.replace(/</, '&lt;').replace(/>/, '&gt;'));
          }
          modules = modules || [];
          modules.unshift(['$provide', function($provide) {
            $provide.value('$rootElement', element);
          }]);
          if (config.debugInfoEnabled) {
            modules.push(['$compileProvider', function($compileProvider) {
              $compileProvider.debugInfoEnabled(true);
            }]);
          }
          modules.unshift('ng');
          var injector = createInjector(modules, config.strictDi);
          injector.invoke(['$rootScope', '$rootElement', '$compile', '$injector', function bootstrapApply(scope, element, compile, injector) {
            scope.$apply(function() {
              element.data('$injector', injector);
              compile(element)(scope);
            });
          }]);
          return injector;
        };
        var NG_ENABLE_DEBUG_INFO = /^NG_ENABLE_DEBUG_INFO!/;
        var NG_DEFER_BOOTSTRAP = /^NG_DEFER_BOOTSTRAP!/;
        if (window && NG_ENABLE_DEBUG_INFO.test(window.name)) {
          config.debugInfoEnabled = true;
          window.name = window.name.replace(NG_ENABLE_DEBUG_INFO, '');
        }
        if (window && !NG_DEFER_BOOTSTRAP.test(window.name)) {
          return doBootstrap();
        }
        window.name = window.name.replace(NG_DEFER_BOOTSTRAP, '');
        angular.resumeBootstrap = function(extraModules) {
          forEach(extraModules, function(module) {
            modules.push(module);
          });
          return doBootstrap();
        };
        if (isFunction(angular.resumeDeferredBootstrap)) {
          angular.resumeDeferredBootstrap();
        }
      }
      function reloadWithDebugInfo() {
        window.name = 'NG_ENABLE_DEBUG_INFO!' + window.name;
        window.location.reload();
      }
      function getTestability(rootElement) {
        var injector = angular.element(rootElement).injector();
        if (!injector) {
          throw ngMinErr('test', 'no injector found for element argument to getTestability');
        }
        return injector.get('$$testability');
      }
      var SNAKE_CASE_REGEXP = /[A-Z]/g;
      function snake_case(name, separator) {
        separator = separator || '_';
        return name.replace(SNAKE_CASE_REGEXP, function(letter, pos) {
          return (pos ? separator : '') + letter.toLowerCase();
        });
      }
      var bindJQueryFired = false;
      function bindJQuery() {
        var originalCleanData;
        if (bindJQueryFired) {
          return;
        }
        var jqName = jq();
        jQuery = isUndefined(jqName) ? window.jQuery : !jqName ? undefined : window[jqName];
        if (jQuery && jQuery.fn.on) {
          jqLite = jQuery;
          extend(jQuery.fn, {
            scope: JQLitePrototype.scope,
            isolateScope: JQLitePrototype.isolateScope,
            controller: (JQLitePrototype).controller,
            injector: JQLitePrototype.injector,
            inheritedData: JQLitePrototype.inheritedData
          });
          originalCleanData = jQuery.cleanData;
          jQuery.cleanData = function(elems) {
            var events;
            for (var i = 0,
                elem; (elem = elems[i]) != null; i++) {
              events = jQuery._data(elem, 'events');
              if (events && events.$destroy) {
                jQuery(elem).triggerHandler('$destroy');
              }
            }
            originalCleanData(elems);
          };
        } else {
          jqLite = JQLite;
        }
        angular.element = jqLite;
        bindJQueryFired = true;
      }
      function assertArg(arg, name, reason) {
        if (!arg) {
          throw ngMinErr('areq', 'Argument \'{0}\' is {1}', (name || '?'), (reason || 'required'));
        }
        return arg;
      }
      function assertArgFn(arg, name, acceptArrayAnnotation) {
        if (acceptArrayAnnotation && isArray(arg)) {
          arg = arg[arg.length - 1];
        }
        assertArg(isFunction(arg), name, 'not a function, got ' + (arg && typeof arg === 'object' ? arg.constructor.name || 'Object' : typeof arg));
        return arg;
      }
      function assertNotHasOwnProperty(name, context) {
        if (name === 'hasOwnProperty') {
          throw ngMinErr('badname', 'hasOwnProperty is not a valid {0} name', context);
        }
      }
      function getter(obj, path, bindFnToScope) {
        if (!path)
          return obj;
        var keys = path.split('.');
        var key;
        var lastInstance = obj;
        var len = keys.length;
        for (var i = 0; i < len; i++) {
          key = keys[i];
          if (obj) {
            obj = (lastInstance = obj)[key];
          }
        }
        if (!bindFnToScope && isFunction(obj)) {
          return bind(lastInstance, obj);
        }
        return obj;
      }
      function getBlockNodes(nodes) {
        var node = nodes[0];
        var endNode = nodes[nodes.length - 1];
        var blockNodes;
        for (var i = 1; node !== endNode && (node = node.nextSibling); i++) {
          if (blockNodes || nodes[i] !== node) {
            if (!blockNodes) {
              blockNodes = jqLite(slice.call(nodes, 0, i));
            }
            blockNodes.push(node);
          }
        }
        return blockNodes || nodes;
      }
      function createMap() {
        return Object.create(null);
      }
      function stringify(value) {
        if (value == null) {
          return '';
        }
        switch (typeof value) {
          case 'string':
            break;
          case 'number':
            value = '' + value;
            break;
          default:
            if (hasCustomToString(value) && !isArray(value) && !isDate(value)) {
              value = value.toString();
            } else {
              value = toJson(value);
            }
        }
        return value;
      }
      var NODE_TYPE_ELEMENT = 1;
      var NODE_TYPE_ATTRIBUTE = 2;
      var NODE_TYPE_TEXT = 3;
      var NODE_TYPE_COMMENT = 8;
      var NODE_TYPE_DOCUMENT = 9;
      var NODE_TYPE_DOCUMENT_FRAGMENT = 11;
      function setupModuleLoader(window) {
        var $injectorMinErr = minErr('$injector');
        var ngMinErr = minErr('ng');
        function ensure(obj, name, factory) {
          return obj[name] || (obj[name] = factory());
        }
        var angular = ensure(window, 'angular', Object);
        angular.$$minErr = angular.$$minErr || minErr;
        return ensure(angular, 'module', function() {
          var modules = {};
          return function module(name, requires, configFn) {
            var info = {};
            var assertNotHasOwnProperty = function(name, context) {
              if (name === 'hasOwnProperty') {
                throw ngMinErr('badname', 'hasOwnProperty is not a valid {0} name', context);
              }
            };
            assertNotHasOwnProperty(name, 'module');
            if (requires && modules.hasOwnProperty(name)) {
              modules[name] = null;
            }
            return ensure(modules, name, function() {
              if (!requires) {
                throw $injectorMinErr('nomod', 'Module \'{0}\' is not available! You either misspelled ' + 'the module name or forgot to load it. If registering a module ensure that you ' + 'specify the dependencies as the second argument.', name);
              }
              var invokeQueue = [];
              var configBlocks = [];
              var runBlocks = [];
              var config = invokeLater('$injector', 'invoke', 'push', configBlocks);
              var moduleInstance = {
                _invokeQueue: invokeQueue,
                _configBlocks: configBlocks,
                _runBlocks: runBlocks,
                info: function(value) {
                  if (isDefined(value)) {
                    if (!isObject(value))
                      throw ngMinErr('aobj', 'Argument \'{0}\' must be an object', 'value');
                    info = value;
                    return this;
                  }
                  return info;
                },
                requires: requires,
                name: name,
                provider: invokeLaterAndSetModuleName('$provide', 'provider'),
                factory: invokeLaterAndSetModuleName('$provide', 'factory'),
                service: invokeLaterAndSetModuleName('$provide', 'service'),
                value: invokeLater('$provide', 'value'),
                constant: invokeLater('$provide', 'constant', 'unshift'),
                decorator: invokeLaterAndSetModuleName('$provide', 'decorator', configBlocks),
                animation: invokeLaterAndSetModuleName('$animateProvider', 'register'),
                filter: invokeLaterAndSetModuleName('$filterProvider', 'register'),
                controller: invokeLaterAndSetModuleName('$controllerProvider', 'register'),
                directive: invokeLaterAndSetModuleName('$compileProvider', 'directive'),
                component: invokeLaterAndSetModuleName('$compileProvider', 'component'),
                config: config,
                run: function(block) {
                  runBlocks.push(block);
                  return this;
                }
              };
              if (configFn) {
                config(configFn);
              }
              return moduleInstance;
              function invokeLater(provider, method, insertMethod, queue) {
                if (!queue)
                  queue = invokeQueue;
                return function() {
                  queue[insertMethod || 'push']([provider, method, arguments]);
                  return moduleInstance;
                };
              }
              function invokeLaterAndSetModuleName(provider, method, queue) {
                if (!queue)
                  queue = invokeQueue;
                return function(recipeName, factoryFunction) {
                  if (factoryFunction && isFunction(factoryFunction))
                    factoryFunction.$$moduleName = name;
                  queue.push([provider, method, arguments]);
                  return moduleInstance;
                };
              }
            });
          };
        });
      }
      function shallowCopy(src, dst) {
        if (isArray(src)) {
          dst = dst || [];
          for (var i = 0,
              ii = src.length; i < ii; i++) {
            dst[i] = src[i];
          }
        } else if (isObject(src)) {
          dst = dst || {};
          for (var key in src) {
            if (!(key.charAt(0) === '$' && key.charAt(1) === '$')) {
              dst[key] = src[key];
            }
          }
        }
        return dst || src;
      }
      function serializeObject(obj, maxDepth) {
        var seen = [];
        if (isValidObjectMaxDepth(maxDepth)) {
          obj = angular.copy(obj, null, maxDepth);
        }
        return JSON.stringify(obj, function(key, val) {
          val = toJsonReplacer(key, val);
          if (isObject(val)) {
            if (seen.indexOf(val) >= 0)
              return '...';
            seen.push(val);
          }
          return val;
        });
      }
      function toDebugString(obj, maxDepth) {
        if (typeof obj === 'function') {
          return obj.toString().replace(/ \{[\s\S]*$/, '');
        } else if (isUndefined(obj)) {
          return 'undefined';
        } else if (typeof obj !== 'string') {
          return serializeObject(obj, maxDepth);
        }
        return obj;
      }
      var version = {
        full: '1.6.9',
        major: 1,
        minor: 6,
        dot: 9,
        codeName: 'fiery-basilisk'
      };
      function publishExternalAPI(angular) {
        extend(angular, {
          'errorHandlingConfig': errorHandlingConfig,
          'bootstrap': bootstrap,
          'copy': copy,
          'extend': extend,
          'merge': merge,
          'equals': equals,
          'element': jqLite,
          'forEach': forEach,
          'injector': createInjector,
          'noop': noop,
          'bind': bind,
          'toJson': toJson,
          'fromJson': fromJson,
          'identity': identity,
          'isUndefined': isUndefined,
          'isDefined': isDefined,
          'isString': isString,
          'isFunction': isFunction,
          'isObject': isObject,
          'isNumber': isNumber,
          'isElement': isElement,
          'isArray': isArray,
          'version': version,
          'isDate': isDate,
          'lowercase': lowercase,
          'uppercase': uppercase,
          'callbacks': {$$counter: 0},
          'getTestability': getTestability,
          'reloadWithDebugInfo': reloadWithDebugInfo,
          '$$minErr': minErr,
          '$$csp': csp,
          '$$encodeUriSegment': encodeUriSegment,
          '$$encodeUriQuery': encodeUriQuery,
          '$$stringify': stringify
        });
        angularModule = setupModuleLoader(window);
        angularModule('ng', ['ngLocale'], ['$provide', function ngModule($provide) {
          $provide.provider({$$sanitizeUri: $$SanitizeUriProvider});
          $provide.provider('$compile', $CompileProvider).directive({
            a: htmlAnchorDirective,
            input: inputDirective,
            textarea: inputDirective,
            form: formDirective,
            script: scriptDirective,
            select: selectDirective,
            option: optionDirective,
            ngBind: ngBindDirective,
            ngBindHtml: ngBindHtmlDirective,
            ngBindTemplate: ngBindTemplateDirective,
            ngClass: ngClassDirective,
            ngClassEven: ngClassEvenDirective,
            ngClassOdd: ngClassOddDirective,
            ngCloak: ngCloakDirective,
            ngController: ngControllerDirective,
            ngForm: ngFormDirective,
            ngHide: ngHideDirective,
            ngIf: ngIfDirective,
            ngInclude: ngIncludeDirective,
            ngInit: ngInitDirective,
            ngNonBindable: ngNonBindableDirective,
            ngPluralize: ngPluralizeDirective,
            ngRepeat: ngRepeatDirective,
            ngShow: ngShowDirective,
            ngStyle: ngStyleDirective,
            ngSwitch: ngSwitchDirective,
            ngSwitchWhen: ngSwitchWhenDirective,
            ngSwitchDefault: ngSwitchDefaultDirective,
            ngOptions: ngOptionsDirective,
            ngTransclude: ngTranscludeDirective,
            ngModel: ngModelDirective,
            ngList: ngListDirective,
            ngChange: ngChangeDirective,
            pattern: patternDirective,
            ngPattern: patternDirective,
            required: requiredDirective,
            ngRequired: requiredDirective,
            minlength: minlengthDirective,
            ngMinlength: minlengthDirective,
            maxlength: maxlengthDirective,
            ngMaxlength: maxlengthDirective,
            ngValue: ngValueDirective,
            ngModelOptions: ngModelOptionsDirective
          }).directive({ngInclude: ngIncludeFillContentDirective}).directive(ngAttributeAliasDirectives).directive(ngEventDirectives);
          $provide.provider({
            $anchorScroll: $AnchorScrollProvider,
            $animate: $AnimateProvider,
            $animateCss: $CoreAnimateCssProvider,
            $$animateJs: $$CoreAnimateJsProvider,
            $$animateQueue: $$CoreAnimateQueueProvider,
            $$AnimateRunner: $$AnimateRunnerFactoryProvider,
            $$animateAsyncRun: $$AnimateAsyncRunFactoryProvider,
            $browser: $BrowserProvider,
            $cacheFactory: $CacheFactoryProvider,
            $controller: $ControllerProvider,
            $document: $DocumentProvider,
            $$isDocumentHidden: $$IsDocumentHiddenProvider,
            $exceptionHandler: $ExceptionHandlerProvider,
            $filter: $FilterProvider,
            $$forceReflow: $$ForceReflowProvider,
            $interpolate: $InterpolateProvider,
            $interval: $IntervalProvider,
            $http: $HttpProvider,
            $httpParamSerializer: $HttpParamSerializerProvider,
            $httpParamSerializerJQLike: $HttpParamSerializerJQLikeProvider,
            $httpBackend: $HttpBackendProvider,
            $xhrFactory: $xhrFactoryProvider,
            $jsonpCallbacks: $jsonpCallbacksProvider,
            $location: $LocationProvider,
            $log: $LogProvider,
            $parse: $ParseProvider,
            $rootScope: $RootScopeProvider,
            $q: $QProvider,
            $$q: $$QProvider,
            $sce: $SceProvider,
            $sceDelegate: $SceDelegateProvider,
            $sniffer: $SnifferProvider,
            $templateCache: $TemplateCacheProvider,
            $templateRequest: $TemplateRequestProvider,
            $$testability: $$TestabilityProvider,
            $timeout: $TimeoutProvider,
            $window: $WindowProvider,
            $$rAF: $$RAFProvider,
            $$jqLite: $$jqLiteProvider,
            $$Map: $$MapProvider,
            $$cookieReader: $$CookieReaderProvider
          });
        }]).info({angularVersion: '1.6.9'});
      }
      JQLite.expando = 'ng339';
      var jqCache = JQLite.cache = {},
          jqId = 1;
      JQLite._data = function(node) {
        return this.cache[node[this.expando]] || {};
      };
      function jqNextId() {
        return ++jqId;
      }
      var DASH_LOWERCASE_REGEXP = /-([a-z])/g;
      var MS_HACK_REGEXP = /^-ms-/;
      var MOUSE_EVENT_MAP = {
        mouseleave: 'mouseout',
        mouseenter: 'mouseover'
      };
      var jqLiteMinErr = minErr('jqLite');
      function cssKebabToCamel(name) {
        return kebabToCamel(name.replace(MS_HACK_REGEXP, 'ms-'));
      }
      function fnCamelCaseReplace(all, letter) {
        return letter.toUpperCase();
      }
      function kebabToCamel(name) {
        return name.replace(DASH_LOWERCASE_REGEXP, fnCamelCaseReplace);
      }
      var SINGLE_TAG_REGEXP = /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/;
      var HTML_REGEXP = /<|&#?\w+;/;
      var TAG_NAME_REGEXP = /<([\w:-]+)/;
      var XHTML_TAG_REGEXP = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi;
      var wrapMap = {
        'option': [1, '<select multiple="multiple">', '</select>'],
        'thead': [1, '<table>', '</table>'],
        'col': [2, '<table><colgroup>', '</colgroup></table>'],
        'tr': [2, '<table><tbody>', '</tbody></table>'],
        'td': [3, '<table><tbody><tr>', '</tr></tbody></table>'],
        '_default': [0, '', '']
      };
      wrapMap.optgroup = wrapMap.option;
      wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
      wrapMap.th = wrapMap.td;
      function jqLiteIsTextNode(html) {
        return !HTML_REGEXP.test(html);
      }
      function jqLiteAcceptsData(node) {
        var nodeType = node.nodeType;
        return nodeType === NODE_TYPE_ELEMENT || !nodeType || nodeType === NODE_TYPE_DOCUMENT;
      }
      function jqLiteHasData(node) {
        for (var key in jqCache[node.ng339]) {
          return true;
        }
        return false;
      }
      function jqLiteBuildFragment(html, context) {
        var tmp,
            tag,
            wrap,
            fragment = context.createDocumentFragment(),
            nodes = [],
            i;
        if (jqLiteIsTextNode(html)) {
          nodes.push(context.createTextNode(html));
        } else {
          tmp = fragment.appendChild(context.createElement('div'));
          tag = (TAG_NAME_REGEXP.exec(html) || ['', ''])[1].toLowerCase();
          wrap = wrapMap[tag] || wrapMap._default;
          tmp.innerHTML = wrap[1] + html.replace(XHTML_TAG_REGEXP, '<$1></$2>') + wrap[2];
          i = wrap[0];
          while (i--) {
            tmp = tmp.lastChild;
          }
          nodes = concat(nodes, tmp.childNodes);
          tmp = fragment.firstChild;
          tmp.textContent = '';
        }
        fragment.textContent = '';
        fragment.innerHTML = '';
        forEach(nodes, function(node) {
          fragment.appendChild(node);
        });
        return fragment;
      }
      function jqLiteParseHTML(html, context) {
        context = context || window.document;
        var parsed;
        if ((parsed = SINGLE_TAG_REGEXP.exec(html))) {
          return [context.createElement(parsed[1])];
        }
        if ((parsed = jqLiteBuildFragment(html, context))) {
          return parsed.childNodes;
        }
        return [];
      }
      function jqLiteWrapNode(node, wrapper) {
        var parent = node.parentNode;
        if (parent) {
          parent.replaceChild(wrapper, node);
        }
        wrapper.appendChild(node);
      }
      var jqLiteContains = window.Node.prototype.contains || function(arg) {
        return !!(this.compareDocumentPosition(arg) & 16);
      };
      function JQLite(element) {
        if (element instanceof JQLite) {
          return element;
        }
        var argIsString;
        if (isString(element)) {
          element = trim(element);
          argIsString = true;
        }
        if (!(this instanceof JQLite)) {
          if (argIsString && element.charAt(0) !== '<') {
            throw jqLiteMinErr('nosel', 'Looking up elements via selectors is not supported by jqLite! See: http://docs.angularjs.org/api/angular.element');
          }
          return new JQLite(element);
        }
        if (argIsString) {
          jqLiteAddNodes(this, jqLiteParseHTML(element));
        } else if (isFunction(element)) {
          jqLiteReady(element);
        } else {
          jqLiteAddNodes(this, element);
        }
      }
      function jqLiteClone(element) {
        return element.cloneNode(true);
      }
      function jqLiteDealoc(element, onlyDescendants) {
        if (!onlyDescendants && jqLiteAcceptsData(element))
          jqLite.cleanData([element]);
        if (element.querySelectorAll) {
          jqLite.cleanData(element.querySelectorAll('*'));
        }
      }
      function jqLiteOff(element, type, fn, unsupported) {
        if (isDefined(unsupported))
          throw jqLiteMinErr('offargs', 'jqLite#off() does not support the `selector` argument');
        var expandoStore = jqLiteExpandoStore(element);
        var events = expandoStore && expandoStore.events;
        var handle = expandoStore && expandoStore.handle;
        if (!handle)
          return;
        if (!type) {
          for (type in events) {
            if (type !== '$destroy') {
              element.removeEventListener(type, handle);
            }
            delete events[type];
          }
        } else {
          var removeHandler = function(type) {
            var listenerFns = events[type];
            if (isDefined(fn)) {
              arrayRemove(listenerFns || [], fn);
            }
            if (!(isDefined(fn) && listenerFns && listenerFns.length > 0)) {
              element.removeEventListener(type, handle);
              delete events[type];
            }
          };
          forEach(type.split(' '), function(type) {
            removeHandler(type);
            if (MOUSE_EVENT_MAP[type]) {
              removeHandler(MOUSE_EVENT_MAP[type]);
            }
          });
        }
      }
      function jqLiteRemoveData(element, name) {
        var expandoId = element.ng339;
        var expandoStore = expandoId && jqCache[expandoId];
        if (expandoStore) {
          if (name) {
            delete expandoStore.data[name];
            return;
          }
          if (expandoStore.handle) {
            if (expandoStore.events.$destroy) {
              expandoStore.handle({}, '$destroy');
            }
            jqLiteOff(element);
          }
          delete jqCache[expandoId];
          element.ng339 = undefined;
        }
      }
      function jqLiteExpandoStore(element, createIfNecessary) {
        var expandoId = element.ng339,
            expandoStore = expandoId && jqCache[expandoId];
        if (createIfNecessary && !expandoStore) {
          element.ng339 = expandoId = jqNextId();
          expandoStore = jqCache[expandoId] = {
            events: {},
            data: {},
            handle: undefined
          };
        }
        return expandoStore;
      }
      function jqLiteData(element, key, value) {
        if (jqLiteAcceptsData(element)) {
          var prop;
          var isSimpleSetter = isDefined(value);
          var isSimpleGetter = !isSimpleSetter && key && !isObject(key);
          var massGetter = !key;
          var expandoStore = jqLiteExpandoStore(element, !isSimpleGetter);
          var data = expandoStore && expandoStore.data;
          if (isSimpleSetter) {
            data[kebabToCamel(key)] = value;
          } else {
            if (massGetter) {
              return data;
            } else {
              if (isSimpleGetter) {
                return data && data[kebabToCamel(key)];
              } else {
                for (prop in key) {
                  data[kebabToCamel(prop)] = key[prop];
                }
              }
            }
          }
        }
      }
      function jqLiteHasClass(element, selector) {
        if (!element.getAttribute)
          return false;
        return ((' ' + (element.getAttribute('class') || '') + ' ').replace(/[\n\t]/g, ' ').indexOf(' ' + selector + ' ') > -1);
      }
      function jqLiteRemoveClass(element, cssClasses) {
        if (cssClasses && element.setAttribute) {
          var existingClasses = (' ' + (element.getAttribute('class') || '') + ' ').replace(/[\n\t]/g, ' ');
          var newClasses = existingClasses;
          forEach(cssClasses.split(' '), function(cssClass) {
            cssClass = trim(cssClass);
            newClasses = newClasses.replace(' ' + cssClass + ' ', ' ');
          });
          if (newClasses !== existingClasses) {
            element.setAttribute('class', trim(newClasses));
          }
        }
      }
      function jqLiteAddClass(element, cssClasses) {
        if (cssClasses && element.setAttribute) {
          var existingClasses = (' ' + (element.getAttribute('class') || '') + ' ').replace(/[\n\t]/g, ' ');
          var newClasses = existingClasses;
          forEach(cssClasses.split(' '), function(cssClass) {
            cssClass = trim(cssClass);
            if (newClasses.indexOf(' ' + cssClass + ' ') === -1) {
              newClasses += cssClass + ' ';
            }
          });
          if (newClasses !== existingClasses) {
            element.setAttribute('class', trim(newClasses));
          }
        }
      }
      function jqLiteAddNodes(root, elements) {
        if (elements) {
          if (elements.nodeType) {
            root[root.length++] = elements;
          } else {
            var length = elements.length;
            if (typeof length === 'number' && elements.window !== elements) {
              if (length) {
                for (var i = 0; i < length; i++) {
                  root[root.length++] = elements[i];
                }
              }
            } else {
              root[root.length++] = elements;
            }
          }
        }
      }
      function jqLiteController(element, name) {
        return jqLiteInheritedData(element, '$' + (name || 'ngController') + 'Controller');
      }
      function jqLiteInheritedData(element, name, value) {
        if (element.nodeType === NODE_TYPE_DOCUMENT) {
          element = element.documentElement;
        }
        var names = isArray(name) ? name : [name];
        while (element) {
          for (var i = 0,
              ii = names.length; i < ii; i++) {
            if (isDefined(value = jqLite.data(element, names[i])))
              return value;
          }
          element = element.parentNode || (element.nodeType === NODE_TYPE_DOCUMENT_FRAGMENT && element.host);
        }
      }
      function jqLiteEmpty(element) {
        jqLiteDealoc(element, true);
        while (element.firstChild) {
          element.removeChild(element.firstChild);
        }
      }
      function jqLiteRemove(element, keepData) {
        if (!keepData)
          jqLiteDealoc(element);
        var parent = element.parentNode;
        if (parent)
          parent.removeChild(element);
      }
      function jqLiteDocumentLoaded(action, win) {
        win = win || window;
        if (win.document.readyState === 'complete') {
          win.setTimeout(action);
        } else {
          jqLite(win).on('load', action);
        }
      }
      function jqLiteReady(fn) {
        function trigger() {
          window.document.removeEventListener('DOMContentLoaded', trigger);
          window.removeEventListener('load', trigger);
          fn();
        }
        if (window.document.readyState === 'complete') {
          window.setTimeout(fn);
        } else {
          window.document.addEventListener('DOMContentLoaded', trigger);
          window.addEventListener('load', trigger);
        }
      }
      var JQLitePrototype = JQLite.prototype = {
        ready: jqLiteReady,
        toString: function() {
          var value = [];
          forEach(this, function(e) {
            value.push('' + e);
          });
          return '[' + value.join(', ') + ']';
        },
        eq: function(index) {
          return (index >= 0) ? jqLite(this[index]) : jqLite(this[this.length + index]);
        },
        length: 0,
        push: push,
        sort: [].sort,
        splice: [].splice
      };
      var BOOLEAN_ATTR = {};
      forEach('multiple,selected,checked,disabled,readOnly,required,open'.split(','), function(value) {
        BOOLEAN_ATTR[lowercase(value)] = value;
      });
      var BOOLEAN_ELEMENTS = {};
      forEach('input,select,option,textarea,button,form,details'.split(','), function(value) {
        BOOLEAN_ELEMENTS[value] = true;
      });
      var ALIASED_ATTR = {
        'ngMinlength': 'minlength',
        'ngMaxlength': 'maxlength',
        'ngMin': 'min',
        'ngMax': 'max',
        'ngPattern': 'pattern',
        'ngStep': 'step'
      };
      function getBooleanAttrName(element, name) {
        var booleanAttr = BOOLEAN_ATTR[name.toLowerCase()];
        return booleanAttr && BOOLEAN_ELEMENTS[nodeName_(element)] && booleanAttr;
      }
      function getAliasedAttrName(name) {
        return ALIASED_ATTR[name];
      }
      forEach({
        data: jqLiteData,
        removeData: jqLiteRemoveData,
        hasData: jqLiteHasData,
        cleanData: function jqLiteCleanData(nodes) {
          for (var i = 0,
              ii = nodes.length; i < ii; i++) {
            jqLiteRemoveData(nodes[i]);
          }
        }
      }, function(fn, name) {
        JQLite[name] = fn;
      });
      forEach({
        data: jqLiteData,
        inheritedData: jqLiteInheritedData,
        scope: function(element) {
          return jqLite.data(element, '$scope') || jqLiteInheritedData(element.parentNode || element, ['$isolateScope', '$scope']);
        },
        isolateScope: function(element) {
          return jqLite.data(element, '$isolateScope') || jqLite.data(element, '$isolateScopeNoTemplate');
        },
        controller: jqLiteController,
        injector: function(element) {
          return jqLiteInheritedData(element, '$injector');
        },
        removeAttr: function(element, name) {
          element.removeAttribute(name);
        },
        hasClass: jqLiteHasClass,
        css: function(element, name, value) {
          name = cssKebabToCamel(name);
          if (isDefined(value)) {
            element.style[name] = value;
          } else {
            return element.style[name];
          }
        },
        attr: function(element, name, value) {
          var ret;
          var nodeType = element.nodeType;
          if (nodeType === NODE_TYPE_TEXT || nodeType === NODE_TYPE_ATTRIBUTE || nodeType === NODE_TYPE_COMMENT || !element.getAttribute) {
            return;
          }
          var lowercasedName = lowercase(name);
          var isBooleanAttr = BOOLEAN_ATTR[lowercasedName];
          if (isDefined(value)) {
            if (value === null || (value === false && isBooleanAttr)) {
              element.removeAttribute(name);
            } else {
              element.setAttribute(name, isBooleanAttr ? lowercasedName : value);
            }
          } else {
            ret = element.getAttribute(name);
            if (isBooleanAttr && ret !== null) {
              ret = lowercasedName;
            }
            return ret === null ? undefined : ret;
          }
        },
        prop: function(element, name, value) {
          if (isDefined(value)) {
            element[name] = value;
          } else {
            return element[name];
          }
        },
        text: (function() {
          getText.$dv = '';
          return getText;
          function getText(element, value) {
            if (isUndefined(value)) {
              var nodeType = element.nodeType;
              return (nodeType === NODE_TYPE_ELEMENT || nodeType === NODE_TYPE_TEXT) ? element.textContent : '';
            }
            element.textContent = value;
          }
        })(),
        val: function(element, value) {
          if (isUndefined(value)) {
            if (element.multiple && nodeName_(element) === 'select') {
              var result = [];
              forEach(element.options, function(option) {
                if (option.selected) {
                  result.push(option.value || option.text);
                }
              });
              return result;
            }
            return element.value;
          }
          element.value = value;
        },
        html: function(element, value) {
          if (isUndefined(value)) {
            return element.innerHTML;
          }
          jqLiteDealoc(element, true);
          element.innerHTML = value;
        },
        empty: jqLiteEmpty
      }, function(fn, name) {
        JQLite.prototype[name] = function(arg1, arg2) {
          var i,
              key;
          var nodeCount = this.length;
          if (fn !== jqLiteEmpty && (isUndefined((fn.length === 2 && (fn !== jqLiteHasClass && fn !== jqLiteController)) ? arg1 : arg2))) {
            if (isObject(arg1)) {
              for (i = 0; i < nodeCount; i++) {
                if (fn === jqLiteData) {
                  fn(this[i], arg1);
                } else {
                  for (key in arg1) {
                    fn(this[i], key, arg1[key]);
                  }
                }
              }
              return this;
            } else {
              var value = fn.$dv;
              var jj = (isUndefined(value)) ? Math.min(nodeCount, 1) : nodeCount;
              for (var j = 0; j < jj; j++) {
                var nodeValue = fn(this[j], arg1, arg2);
                value = value ? value + nodeValue : nodeValue;
              }
              return value;
            }
          } else {
            for (i = 0; i < nodeCount; i++) {
              fn(this[i], arg1, arg2);
            }
            return this;
          }
        };
      });
      function createEventHandler(element, events) {
        var eventHandler = function(event, type) {
          event.isDefaultPrevented = function() {
            return event.defaultPrevented;
          };
          var eventFns = events[type || event.type];
          var eventFnsLength = eventFns ? eventFns.length : 0;
          if (!eventFnsLength)
            return;
          if (isUndefined(event.immediatePropagationStopped)) {
            var originalStopImmediatePropagation = event.stopImmediatePropagation;
            event.stopImmediatePropagation = function() {
              event.immediatePropagationStopped = true;
              if (event.stopPropagation) {
                event.stopPropagation();
              }
              if (originalStopImmediatePropagation) {
                originalStopImmediatePropagation.call(event);
              }
            };
          }
          event.isImmediatePropagationStopped = function() {
            return event.immediatePropagationStopped === true;
          };
          var handlerWrapper = eventFns.specialHandlerWrapper || defaultHandlerWrapper;
          if ((eventFnsLength > 1)) {
            eventFns = shallowCopy(eventFns);
          }
          for (var i = 0; i < eventFnsLength; i++) {
            if (!event.isImmediatePropagationStopped()) {
              handlerWrapper(element, event, eventFns[i]);
            }
          }
        };
        eventHandler.elem = element;
        return eventHandler;
      }
      function defaultHandlerWrapper(element, event, handler) {
        handler.call(element, event);
      }
      function specialMouseHandlerWrapper(target, event, handler) {
        var related = event.relatedTarget;
        if (!related || (related !== target && !jqLiteContains.call(target, related))) {
          handler.call(target, event);
        }
      }
      forEach({
        removeData: jqLiteRemoveData,
        on: function jqLiteOn(element, type, fn, unsupported) {
          if (isDefined(unsupported))
            throw jqLiteMinErr('onargs', 'jqLite#on() does not support the `selector` or `eventData` parameters');
          if (!jqLiteAcceptsData(element)) {
            return;
          }
          var expandoStore = jqLiteExpandoStore(element, true);
          var events = expandoStore.events;
          var handle = expandoStore.handle;
          if (!handle) {
            handle = expandoStore.handle = createEventHandler(element, events);
          }
          var types = type.indexOf(' ') >= 0 ? type.split(' ') : [type];
          var i = types.length;
          var addHandler = function(type, specialHandlerWrapper, noEventListener) {
            var eventFns = events[type];
            if (!eventFns) {
              eventFns = events[type] = [];
              eventFns.specialHandlerWrapper = specialHandlerWrapper;
              if (type !== '$destroy' && !noEventListener) {
                element.addEventListener(type, handle);
              }
            }
            eventFns.push(fn);
          };
          while (i--) {
            type = types[i];
            if (MOUSE_EVENT_MAP[type]) {
              addHandler(MOUSE_EVENT_MAP[type], specialMouseHandlerWrapper);
              addHandler(type, undefined, true);
            } else {
              addHandler(type);
            }
          }
        },
        off: jqLiteOff,
        one: function(element, type, fn) {
          element = jqLite(element);
          element.on(type, function onFn() {
            element.off(type, fn);
            element.off(type, onFn);
          });
          element.on(type, fn);
        },
        replaceWith: function(element, replaceNode) {
          var index,
              parent = element.parentNode;
          jqLiteDealoc(element);
          forEach(new JQLite(replaceNode), function(node) {
            if (index) {
              parent.insertBefore(node, index.nextSibling);
            } else {
              parent.replaceChild(node, element);
            }
            index = node;
          });
        },
        children: function(element) {
          var children = [];
          forEach(element.childNodes, function(element) {
            if (element.nodeType === NODE_TYPE_ELEMENT) {
              children.push(element);
            }
          });
          return children;
        },
        contents: function(element) {
          return element.contentDocument || element.childNodes || [];
        },
        append: function(element, node) {
          var nodeType = element.nodeType;
          if (nodeType !== NODE_TYPE_ELEMENT && nodeType !== NODE_TYPE_DOCUMENT_FRAGMENT)
            return;
          node = new JQLite(node);
          for (var i = 0,
              ii = node.length; i < ii; i++) {
            var child = node[i];
            element.appendChild(child);
          }
        },
        prepend: function(element, node) {
          if (element.nodeType === NODE_TYPE_ELEMENT) {
            var index = element.firstChild;
            forEach(new JQLite(node), function(child) {
              element.insertBefore(child, index);
            });
          }
        },
        wrap: function(element, wrapNode) {
          jqLiteWrapNode(element, jqLite(wrapNode).eq(0).clone()[0]);
        },
        remove: jqLiteRemove,
        detach: function(element) {
          jqLiteRemove(element, true);
        },
        after: function(element, newElement) {
          var index = element,
              parent = element.parentNode;
          if (parent) {
            newElement = new JQLite(newElement);
            for (var i = 0,
                ii = newElement.length; i < ii; i++) {
              var node = newElement[i];
              parent.insertBefore(node, index.nextSibling);
              index = node;
            }
          }
        },
        addClass: jqLiteAddClass,
        removeClass: jqLiteRemoveClass,
        toggleClass: function(element, selector, condition) {
          if (selector) {
            forEach(selector.split(' '), function(className) {
              var classCondition = condition;
              if (isUndefined(classCondition)) {
                classCondition = !jqLiteHasClass(element, className);
              }
              (classCondition ? jqLiteAddClass : jqLiteRemoveClass)(element, className);
            });
          }
        },
        parent: function(element) {
          var parent = element.parentNode;
          return parent && parent.nodeType !== NODE_TYPE_DOCUMENT_FRAGMENT ? parent : null;
        },
        next: function(element) {
          return element.nextElementSibling;
        },
        find: function(element, selector) {
          if (element.getElementsByTagName) {
            return element.getElementsByTagName(selector);
          } else {
            return [];
          }
        },
        clone: jqLiteClone,
        triggerHandler: function(element, event, extraParameters) {
          var dummyEvent,
              eventFnsCopy,
              handlerArgs;
          var eventName = event.type || event;
          var expandoStore = jqLiteExpandoStore(element);
          var events = expandoStore && expandoStore.events;
          var eventFns = events && events[eventName];
          if (eventFns) {
            dummyEvent = {
              preventDefault: function() {
                this.defaultPrevented = true;
              },
              isDefaultPrevented: function() {
                return this.defaultPrevented === true;
              },
              stopImmediatePropagation: function() {
                this.immediatePropagationStopped = true;
              },
              isImmediatePropagationStopped: function() {
                return this.immediatePropagationStopped === true;
              },
              stopPropagation: noop,
              type: eventName,
              target: element
            };
            if (event.type) {
              dummyEvent = extend(dummyEvent, event);
            }
            eventFnsCopy = shallowCopy(eventFns);
            handlerArgs = extraParameters ? [dummyEvent].concat(extraParameters) : [dummyEvent];
            forEach(eventFnsCopy, function(fn) {
              if (!dummyEvent.isImmediatePropagationStopped()) {
                fn.apply(element, handlerArgs);
              }
            });
          }
        }
      }, function(fn, name) {
        JQLite.prototype[name] = function(arg1, arg2, arg3) {
          var value;
          for (var i = 0,
              ii = this.length; i < ii; i++) {
            if (isUndefined(value)) {
              value = fn(this[i], arg1, arg2, arg3);
              if (isDefined(value)) {
                value = jqLite(value);
              }
            } else {
              jqLiteAddNodes(value, fn(this[i], arg1, arg2, arg3));
            }
          }
          return isDefined(value) ? value : this;
        };
      });
      JQLite.prototype.bind = JQLite.prototype.on;
      JQLite.prototype.unbind = JQLite.prototype.off;
      function $$jqLiteProvider() {
        this.$get = function $$jqLite() {
          return extend(JQLite, {
            hasClass: function(node, classes) {
              if (node.attr)
                node = node[0];
              return jqLiteHasClass(node, classes);
            },
            addClass: function(node, classes) {
              if (node.attr)
                node = node[0];
              return jqLiteAddClass(node, classes);
            },
            removeClass: function(node, classes) {
              if (node.attr)
                node = node[0];
              return jqLiteRemoveClass(node, classes);
            }
          });
        };
      }
      function hashKey(obj, nextUidFn) {
        var key = obj && obj.$$hashKey;
        if (key) {
          if (typeof key === 'function') {
            key = obj.$$hashKey();
          }
          return key;
        }
        var objType = typeof obj;
        if (objType === 'function' || (objType === 'object' && obj !== null)) {
          key = obj.$$hashKey = objType + ':' + (nextUidFn || nextUid)();
        } else {
          key = objType + ':' + obj;
        }
        return key;
      }
      var nanKey = Object.create(null);
      function NgMapShim() {
        this._keys = [];
        this._values = [];
        this._lastKey = NaN;
        this._lastIndex = -1;
      }
      NgMapShim.prototype = {
        _idx: function(key) {
          if (key === this._lastKey) {
            return this._lastIndex;
          }
          this._lastKey = key;
          this._lastIndex = this._keys.indexOf(key);
          return this._lastIndex;
        },
        _transformKey: function(key) {
          return isNumberNaN(key) ? nanKey : key;
        },
        get: function(key) {
          key = this._transformKey(key);
          var idx = this._idx(key);
          if (idx !== -1) {
            return this._values[idx];
          }
        },
        set: function(key, value) {
          key = this._transformKey(key);
          var idx = this._idx(key);
          if (idx === -1) {
            idx = this._lastIndex = this._keys.length;
          }
          this._keys[idx] = key;
          this._values[idx] = value;
        },
        delete: function(key) {
          key = this._transformKey(key);
          var idx = this._idx(key);
          if (idx === -1) {
            return false;
          }
          this._keys.splice(idx, 1);
          this._values.splice(idx, 1);
          this._lastKey = NaN;
          this._lastIndex = -1;
          return true;
        }
      };
      var NgMap = NgMapShim;
      var $$MapProvider = [function() {
        this.$get = [function() {
          return NgMap;
        }];
      }];
      var ARROW_ARG = /^([^(]+?)=>/;
      var FN_ARGS = /^[^(]*\(\s*([^)]*)\)/m;
      var FN_ARG_SPLIT = /,/;
      var FN_ARG = /^\s*(_?)(\S+?)\1\s*$/;
      var STRIP_COMMENTS = /((\/\/.*$)|(\/\*[\s\S]*?\*\/))/mg;
      var $injectorMinErr = minErr('$injector');
      function stringifyFn(fn) {
        return Function.prototype.toString.call(fn);
      }
      function extractArgs(fn) {
        var fnText = stringifyFn(fn).replace(STRIP_COMMENTS, ''),
            args = fnText.match(ARROW_ARG) || fnText.match(FN_ARGS);
        return args;
      }
      function anonFn(fn) {
        var args = extractArgs(fn);
        if (args) {
          return 'function(' + (args[1] || '').replace(/[\s\r\n]+/, ' ') + ')';
        }
        return 'fn';
      }
      function annotate(fn, strictDi, name) {
        var $inject,
            argDecl,
            last;
        if (typeof fn === 'function') {
          if (!($inject = fn.$inject)) {
            $inject = [];
            if (fn.length) {
              if (strictDi) {
                if (!isString(name) || !name) {
                  name = fn.name || anonFn(fn);
                }
                throw $injectorMinErr('strictdi', '{0} is not using explicit annotation and cannot be invoked in strict mode', name);
              }
              argDecl = extractArgs(fn);
              forEach(argDecl[1].split(FN_ARG_SPLIT), function(arg) {
                arg.replace(FN_ARG, function(all, underscore, name) {
                  $inject.push(name);
                });
              });
            }
            fn.$inject = $inject;
          }
        } else if (isArray(fn)) {
          last = fn.length - 1;
          assertArgFn(fn[last], 'fn');
          $inject = fn.slice(0, last);
        } else {
          assertArgFn(fn, 'fn', true);
        }
        return $inject;
      }
      function createInjector(modulesToLoad, strictDi) {
        strictDi = (strictDi === true);
        var INSTANTIATING = {},
            providerSuffix = 'Provider',
            path = [],
            loadedModules = new NgMap(),
            providerCache = {$provide: {
                provider: supportObject(provider),
                factory: supportObject(factory),
                service: supportObject(service),
                value: supportObject(value),
                constant: supportObject(constant),
                decorator: decorator
              }},
            providerInjector = (providerCache.$injector = createInternalInjector(providerCache, function(serviceName, caller) {
              if (angular.isString(caller)) {
                path.push(caller);
              }
              throw $injectorMinErr('unpr', 'Unknown provider: {0}', path.join(' <- '));
            })),
            instanceCache = {},
            protoInstanceInjector = createInternalInjector(instanceCache, function(serviceName, caller) {
              var provider = providerInjector.get(serviceName + providerSuffix, caller);
              return instanceInjector.invoke(provider.$get, provider, undefined, serviceName);
            }),
            instanceInjector = protoInstanceInjector;
        providerCache['$injector' + providerSuffix] = {$get: valueFn(protoInstanceInjector)};
        instanceInjector.modules = providerInjector.modules = createMap();
        var runBlocks = loadModules(modulesToLoad);
        instanceInjector = protoInstanceInjector.get('$injector');
        instanceInjector.strictDi = strictDi;
        forEach(runBlocks, function(fn) {
          if (fn)
            instanceInjector.invoke(fn);
        });
        instanceInjector.loadNewModules = function(mods) {
          forEach(loadModules(mods), function(fn) {
            if (fn)
              instanceInjector.invoke(fn);
          });
        };
        return instanceInjector;
        function supportObject(delegate) {
          return function(key, value) {
            if (isObject(key)) {
              forEach(key, reverseParams(delegate));
            } else {
              return delegate(key, value);
            }
          };
        }
        function provider(name, provider_) {
          assertNotHasOwnProperty(name, 'service');
          if (isFunction(provider_) || isArray(provider_)) {
            provider_ = providerInjector.instantiate(provider_);
          }
          if (!provider_.$get) {
            throw $injectorMinErr('pget', 'Provider \'{0}\' must define $get factory method.', name);
          }
          return (providerCache[name + providerSuffix] = provider_);
        }
        function enforceReturnValue(name, factory) {
          return function enforcedReturnValue() {
            var result = instanceInjector.invoke(factory, this);
            if (isUndefined(result)) {
              throw $injectorMinErr('undef', 'Provider \'{0}\' must return a value from $get factory method.', name);
            }
            return result;
          };
        }
        function factory(name, factoryFn, enforce) {
          return provider(name, {$get: enforce !== false ? enforceReturnValue(name, factoryFn) : factoryFn});
        }
        function service(name, constructor) {
          return factory(name, ['$injector', function($injector) {
            return $injector.instantiate(constructor);
          }]);
        }
        function value(name, val) {
          return factory(name, valueFn(val), false);
        }
        function constant(name, value) {
          assertNotHasOwnProperty(name, 'constant');
          providerCache[name] = value;
          instanceCache[name] = value;
        }
        function decorator(serviceName, decorFn) {
          var origProvider = providerInjector.get(serviceName + providerSuffix),
              orig$get = origProvider.$get;
          origProvider.$get = function() {
            var origInstance = instanceInjector.invoke(orig$get, origProvider);
            return instanceInjector.invoke(decorFn, null, {$delegate: origInstance});
          };
        }
        function loadModules(modulesToLoad) {
          assertArg(isUndefined(modulesToLoad) || isArray(modulesToLoad), 'modulesToLoad', 'not an array');
          var runBlocks = [],
              moduleFn;
          forEach(modulesToLoad, function(module) {
            if (loadedModules.get(module))
              return;
            loadedModules.set(module, true);
            function runInvokeQueue(queue) {
              var i,
                  ii;
              for (i = 0, ii = queue.length; i < ii; i++) {
                var invokeArgs = queue[i],
                    provider = providerInjector.get(invokeArgs[0]);
                provider[invokeArgs[1]].apply(provider, invokeArgs[2]);
              }
            }
            try {
              if (isString(module)) {
                moduleFn = angularModule(module);
                instanceInjector.modules[module] = moduleFn;
                runBlocks = runBlocks.concat(loadModules(moduleFn.requires)).concat(moduleFn._runBlocks);
                runInvokeQueue(moduleFn._invokeQueue);
                runInvokeQueue(moduleFn._configBlocks);
              } else if (isFunction(module)) {
                runBlocks.push(providerInjector.invoke(module));
              } else if (isArray(module)) {
                runBlocks.push(providerInjector.invoke(module));
              } else {
                assertArgFn(module, 'module');
              }
            } catch (e) {
              if (isArray(module)) {
                module = module[module.length - 1];
              }
              if (e.message && e.stack && e.stack.indexOf(e.message) === -1) {
                e = e.message + '\n' + e.stack;
              }
              throw $injectorMinErr('modulerr', 'Failed to instantiate module {0} due to:\n{1}', module, e.stack || e.message || e);
            }
          });
          return runBlocks;
        }
        function createInternalInjector(cache, factory) {
          function getService(serviceName, caller) {
            if (cache.hasOwnProperty(serviceName)) {
              if (cache[serviceName] === INSTANTIATING) {
                throw $injectorMinErr('cdep', 'Circular dependency found: {0}', serviceName + ' <- ' + path.join(' <- '));
              }
              return cache[serviceName];
            } else {
              try {
                path.unshift(serviceName);
                cache[serviceName] = INSTANTIATING;
                cache[serviceName] = factory(serviceName, caller);
                return cache[serviceName];
              } catch (err) {
                if (cache[serviceName] === INSTANTIATING) {
                  delete cache[serviceName];
                }
                throw err;
              } finally {
                path.shift();
              }
            }
          }
          function injectionArgs(fn, locals, serviceName) {
            var args = [],
                $inject = createInjector.$$annotate(fn, strictDi, serviceName);
            for (var i = 0,
                length = $inject.length; i < length; i++) {
              var key = $inject[i];
              if (typeof key !== 'string') {
                throw $injectorMinErr('itkn', 'Incorrect injection token! Expected service name as string, got {0}', key);
              }
              args.push(locals && locals.hasOwnProperty(key) ? locals[key] : getService(key, serviceName));
            }
            return args;
          }
          function isClass(func) {
            if (msie || typeof func !== 'function') {
              return false;
            }
            var result = func.$$ngIsClass;
            if (!isBoolean(result)) {
              result = func.$$ngIsClass = /^(?:class\b|constructor\()/.test(stringifyFn(func));
            }
            return result;
          }
          function invoke(fn, self, locals, serviceName) {
            if (typeof locals === 'string') {
              serviceName = locals;
              locals = null;
            }
            var args = injectionArgs(fn, locals, serviceName);
            if (isArray(fn)) {
              fn = fn[fn.length - 1];
            }
            if (!isClass(fn)) {
              return fn.apply(self, args);
            } else {
              args.unshift(null);
              return new (Function.prototype.bind.apply(fn, args))();
            }
          }
          function instantiate(Type, locals, serviceName) {
            var ctor = (isArray(Type) ? Type[Type.length - 1] : Type);
            var args = injectionArgs(Type, locals, serviceName);
            args.unshift(null);
            return new (Function.prototype.bind.apply(ctor, args))();
          }
          return {
            invoke: invoke,
            instantiate: instantiate,
            get: getService,
            annotate: createInjector.$$annotate,
            has: function(name) {
              return providerCache.hasOwnProperty(name + providerSuffix) || cache.hasOwnProperty(name);
            }
          };
        }
      }
      createInjector.$$annotate = annotate;
      function $AnchorScrollProvider() {
        var autoScrollingEnabled = true;
        this.disableAutoScrolling = function() {
          autoScrollingEnabled = false;
        };
        this.$get = ['$window', '$location', '$rootScope', function($window, $location, $rootScope) {
          var document = $window.document;
          function getFirstAnchor(list) {
            var result = null;
            Array.prototype.some.call(list, function(element) {
              if (nodeName_(element) === 'a') {
                result = element;
                return true;
              }
            });
            return result;
          }
          function getYOffset() {
            var offset = scroll.yOffset;
            if (isFunction(offset)) {
              offset = offset();
            } else if (isElement(offset)) {
              var elem = offset[0];
              var style = $window.getComputedStyle(elem);
              if (style.position !== 'fixed') {
                offset = 0;
              } else {
                offset = elem.getBoundingClientRect().bottom;
              }
            } else if (!isNumber(offset)) {
              offset = 0;
            }
            return offset;
          }
          function scrollTo(elem) {
            if (elem) {
              elem.scrollIntoView();
              var offset = getYOffset();
              if (offset) {
                var elemTop = elem.getBoundingClientRect().top;
                $window.scrollBy(0, elemTop - offset);
              }
            } else {
              $window.scrollTo(0, 0);
            }
          }
          function scroll(hash) {
            hash = isString(hash) ? hash : isNumber(hash) ? hash.toString() : $location.hash();
            var elm;
            if (!hash)
              scrollTo(null);
            else if ((elm = document.getElementById(hash)))
              scrollTo(elm);
            else if ((elm = getFirstAnchor(document.getElementsByName(hash))))
              scrollTo(elm);
            else if (hash === 'top')
              scrollTo(null);
          }
          if (autoScrollingEnabled) {
            $rootScope.$watch(function autoScrollWatch() {
              return $location.hash();
            }, function autoScrollWatchAction(newVal, oldVal) {
              if (newVal === oldVal && newVal === '')
                return;
              jqLiteDocumentLoaded(function() {
                $rootScope.$evalAsync(scroll);
              });
            });
          }
          return scroll;
        }];
      }
      var $animateMinErr = minErr('$animate');
      var ELEMENT_NODE = 1;
      var NG_ANIMATE_CLASSNAME = 'ng-animate';
      function mergeClasses(a, b) {
        if (!a && !b)
          return '';
        if (!a)
          return b;
        if (!b)
          return a;
        if (isArray(a))
          a = a.join(' ');
        if (isArray(b))
          b = b.join(' ');
        return a + ' ' + b;
      }
      function extractElementNode(element) {
        for (var i = 0; i < element.length; i++) {
          var elm = element[i];
          if (elm.nodeType === ELEMENT_NODE) {
            return elm;
          }
        }
      }
      function splitClasses(classes) {
        if (isString(classes)) {
          classes = classes.split(' ');
        }
        var obj = createMap();
        forEach(classes, function(klass) {
          if (klass.length) {
            obj[klass] = true;
          }
        });
        return obj;
      }
      function prepareAnimateOptions(options) {
        return isObject(options) ? options : {};
      }
      var $$CoreAnimateJsProvider = function() {
        this.$get = noop;
      };
      var $$CoreAnimateQueueProvider = function() {
        var postDigestQueue = new NgMap();
        var postDigestElements = [];
        this.$get = ['$$AnimateRunner', '$rootScope', function($$AnimateRunner, $rootScope) {
          return {
            enabled: noop,
            on: noop,
            off: noop,
            pin: noop,
            push: function(element, event, options, domOperation) {
              if (domOperation) {
                domOperation();
              }
              options = options || {};
              if (options.from) {
                element.css(options.from);
              }
              if (options.to) {
                element.css(options.to);
              }
              if (options.addClass || options.removeClass) {
                addRemoveClassesPostDigest(element, options.addClass, options.removeClass);
              }
              var runner = new $$AnimateRunner();
              runner.complete();
              return runner;
            }
          };
          function updateData(data, classes, value) {
            var changed = false;
            if (classes) {
              classes = isString(classes) ? classes.split(' ') : isArray(classes) ? classes : [];
              forEach(classes, function(className) {
                if (className) {
                  changed = true;
                  data[className] = value;
                }
              });
            }
            return changed;
          }
          function handleCSSClassChanges() {
            forEach(postDigestElements, function(element) {
              var data = postDigestQueue.get(element);
              if (data) {
                var existing = splitClasses(element.attr('class'));
                var toAdd = '';
                var toRemove = '';
                forEach(data, function(status, className) {
                  var hasClass = !!existing[className];
                  if (status !== hasClass) {
                    if (status) {
                      toAdd += (toAdd.length ? ' ' : '') + className;
                    } else {
                      toRemove += (toRemove.length ? ' ' : '') + className;
                    }
                  }
                });
                forEach(element, function(elm) {
                  if (toAdd) {
                    jqLiteAddClass(elm, toAdd);
                  }
                  if (toRemove) {
                    jqLiteRemoveClass(elm, toRemove);
                  }
                });
                postDigestQueue.delete(element);
              }
            });
            postDigestElements.length = 0;
          }
          function addRemoveClassesPostDigest(element, add, remove) {
            var data = postDigestQueue.get(element) || {};
            var classesAdded = updateData(data, add, true);
            var classesRemoved = updateData(data, remove, false);
            if (classesAdded || classesRemoved) {
              postDigestQueue.set(element, data);
              postDigestElements.push(element);
              if (postDigestElements.length === 1) {
                $rootScope.$$postDigest(handleCSSClassChanges);
              }
            }
          }
        }];
      };
      var $AnimateProvider = ['$provide', function($provide) {
        var provider = this;
        var classNameFilter = null;
        var customFilter = null;
        this.$$registeredAnimations = Object.create(null);
        this.register = function(name, factory) {
          if (name && name.charAt(0) !== '.') {
            throw $animateMinErr('notcsel', 'Expecting class selector starting with \'.\' got \'{0}\'.', name);
          }
          var key = name + '-animation';
          provider.$$registeredAnimations[name.substr(1)] = key;
          $provide.factory(key, factory);
        };
        this.customFilter = function(filterFn) {
          if (arguments.length === 1) {
            customFilter = isFunction(filterFn) ? filterFn : null;
          }
          return customFilter;
        };
        this.classNameFilter = function(expression) {
          if (arguments.length === 1) {
            classNameFilter = (expression instanceof RegExp) ? expression : null;
            if (classNameFilter) {
              var reservedRegex = new RegExp('[(\\s|\\/)]' + NG_ANIMATE_CLASSNAME + '[(\\s|\\/)]');
              if (reservedRegex.test(classNameFilter.toString())) {
                classNameFilter = null;
                throw $animateMinErr('nongcls', '$animateProvider.classNameFilter(regex) prohibits accepting a regex value which matches/contains the "{0}" CSS class.', NG_ANIMATE_CLASSNAME);
              }
            }
          }
          return classNameFilter;
        };
        this.$get = ['$$animateQueue', function($$animateQueue) {
          function domInsert(element, parentElement, afterElement) {
            if (afterElement) {
              var afterNode = extractElementNode(afterElement);
              if (afterNode && !afterNode.parentNode && !afterNode.previousElementSibling) {
                afterElement = null;
              }
            }
            if (afterElement) {
              afterElement.after(element);
            } else {
              parentElement.prepend(element);
            }
          }
          return {
            on: $$animateQueue.on,
            off: $$animateQueue.off,
            pin: $$animateQueue.pin,
            enabled: $$animateQueue.enabled,
            cancel: function(runner) {
              if (runner.end) {
                runner.end();
              }
            },
            enter: function(element, parent, after, options) {
              parent = parent && jqLite(parent);
              after = after && jqLite(after);
              parent = parent || after.parent();
              domInsert(element, parent, after);
              return $$animateQueue.push(element, 'enter', prepareAnimateOptions(options));
            },
            move: function(element, parent, after, options) {
              parent = parent && jqLite(parent);
              after = after && jqLite(after);
              parent = parent || after.parent();
              domInsert(element, parent, after);
              return $$animateQueue.push(element, 'move', prepareAnimateOptions(options));
            },
            leave: function(element, options) {
              return $$animateQueue.push(element, 'leave', prepareAnimateOptions(options), function() {
                element.remove();
              });
            },
            addClass: function(element, className, options) {
              options = prepareAnimateOptions(options);
              options.addClass = mergeClasses(options.addclass, className);
              return $$animateQueue.push(element, 'addClass', options);
            },
            removeClass: function(element, className, options) {
              options = prepareAnimateOptions(options);
              options.removeClass = mergeClasses(options.removeClass, className);
              return $$animateQueue.push(element, 'removeClass', options);
            },
            setClass: function(element, add, remove, options) {
              options = prepareAnimateOptions(options);
              options.addClass = mergeClasses(options.addClass, add);
              options.removeClass = mergeClasses(options.removeClass, remove);
              return $$animateQueue.push(element, 'setClass', options);
            },
            animate: function(element, from, to, className, options) {
              options = prepareAnimateOptions(options);
              options.from = options.from ? extend(options.from, from) : from;
              options.to = options.to ? extend(options.to, to) : to;
              className = className || 'ng-inline-animate';
              options.tempClasses = mergeClasses(options.tempClasses, className);
              return $$animateQueue.push(element, 'animate', options);
            }
          };
        }];
      }];
      var $$AnimateAsyncRunFactoryProvider = function() {
        this.$get = ['$$rAF', function($$rAF) {
          var waitQueue = [];
          function waitForTick(fn) {
            waitQueue.push(fn);
            if (waitQueue.length > 1)
              return;
            $$rAF(function() {
              for (var i = 0; i < waitQueue.length; i++) {
                waitQueue[i]();
              }
              waitQueue = [];
            });
          }
          return function() {
            var passed = false;
            waitForTick(function() {
              passed = true;
            });
            return function(callback) {
              if (passed) {
                callback();
              } else {
                waitForTick(callback);
              }
            };
          };
        }];
      };
      var $$AnimateRunnerFactoryProvider = function() {
        this.$get = ['$q', '$sniffer', '$$animateAsyncRun', '$$isDocumentHidden', '$timeout', function($q, $sniffer, $$animateAsyncRun, $$isDocumentHidden, $timeout) {
          var INITIAL_STATE = 0;
          var DONE_PENDING_STATE = 1;
          var DONE_COMPLETE_STATE = 2;
          AnimateRunner.chain = function(chain, callback) {
            var index = 0;
            next();
            function next() {
              if (index === chain.length) {
                callback(true);
                return;
              }
              chain[index](function(response) {
                if (response === false) {
                  callback(false);
                  return;
                }
                index++;
                next();
              });
            }
          };
          AnimateRunner.all = function(runners, callback) {
            var count = 0;
            var status = true;
            forEach(runners, function(runner) {
              runner.done(onProgress);
            });
            function onProgress(response) {
              status = status && response;
              if (++count === runners.length) {
                callback(status);
              }
            }
          };
          function AnimateRunner(host) {
            this.setHost(host);
            var rafTick = $$animateAsyncRun();
            var timeoutTick = function(fn) {
              $timeout(fn, 0, false);
            };
            this._doneCallbacks = [];
            this._tick = function(fn) {
              if ($$isDocumentHidden()) {
                timeoutTick(fn);
              } else {
                rafTick(fn);
              }
            };
            this._state = 0;
          }
          AnimateRunner.prototype = {
            setHost: function(host) {
              this.host = host || {};
            },
            done: function(fn) {
              if (this._state === DONE_COMPLETE_STATE) {
                fn();
              } else {
                this._doneCallbacks.push(fn);
              }
            },
            progress: noop,
            getPromise: function() {
              if (!this.promise) {
                var self = this;
                this.promise = $q(function(resolve, reject) {
                  self.done(function(status) {
                    if (status === false) {
                      reject();
                    } else {
                      resolve();
                    }
                  });
                });
              }
              return this.promise;
            },
            then: function(resolveHandler, rejectHandler) {
              return this.getPromise().then(resolveHandler, rejectHandler);
            },
            'catch': function(handler) {
              return this.getPromise()['catch'](handler);
            },
            'finally': function(handler) {
              return this.getPromise()['finally'](handler);
            },
            pause: function() {
              if (this.host.pause) {
                this.host.pause();
              }
            },
            resume: function() {
              if (this.host.resume) {
                this.host.resume();
              }
            },
            end: function() {
              if (this.host.end) {
                this.host.end();
              }
              this._resolve(true);
            },
            cancel: function() {
              if (this.host.cancel) {
                this.host.cancel();
              }
              this._resolve(false);
            },
            complete: function(response) {
              var self = this;
              if (self._state === INITIAL_STATE) {
                self._state = DONE_PENDING_STATE;
                self._tick(function() {
                  self._resolve(response);
                });
              }
            },
            _resolve: function(response) {
              if (this._state !== DONE_COMPLETE_STATE) {
                forEach(this._doneCallbacks, function(fn) {
                  fn(response);
                });
                this._doneCallbacks.length = 0;
                this._state = DONE_COMPLETE_STATE;
              }
            }
          };
          return AnimateRunner;
        }];
      };
      var $CoreAnimateCssProvider = function() {
        this.$get = ['$$rAF', '$q', '$$AnimateRunner', function($$rAF, $q, $$AnimateRunner) {
          return function(element, initialOptions) {
            var options = initialOptions || {};
            if (!options.$$prepared) {
              options = copy(options);
            }
            if (options.cleanupStyles) {
              options.from = options.to = null;
            }
            if (options.from) {
              element.css(options.from);
              options.from = null;
            }
            var closed,
                runner = new $$AnimateRunner();
            return {
              start: run,
              end: run
            };
            function run() {
              $$rAF(function() {
                applyAnimationContents();
                if (!closed) {
                  runner.complete();
                }
                closed = true;
              });
              return runner;
            }
            function applyAnimationContents() {
              if (options.addClass) {
                element.addClass(options.addClass);
                options.addClass = null;
              }
              if (options.removeClass) {
                element.removeClass(options.removeClass);
                options.removeClass = null;
              }
              if (options.to) {
                element.css(options.to);
                options.to = null;
              }
            }
          };
        }];
      };
      function Browser(window, document, $log, $sniffer) {
        var self = this,
            location = window.location,
            history = window.history,
            setTimeout = window.setTimeout,
            clearTimeout = window.clearTimeout,
            pendingDeferIds = {};
        self.isMock = false;
        var outstandingRequestCount = 0;
        var outstandingRequestCallbacks = [];
        self.$$completeOutstandingRequest = completeOutstandingRequest;
        self.$$incOutstandingRequestCount = function() {
          outstandingRequestCount++;
        };
        function completeOutstandingRequest(fn) {
          try {
            fn.apply(null, sliceArgs(arguments, 1));
          } finally {
            outstandingRequestCount--;
            if (outstandingRequestCount === 0) {
              while (outstandingRequestCallbacks.length) {
                try {
                  outstandingRequestCallbacks.pop()();
                } catch (e) {
                  $log.error(e);
                }
              }
            }
          }
        }
        function getHash(url) {
          var index = url.indexOf('#');
          return index === -1 ? '' : url.substr(index);
        }
        self.notifyWhenNoOutstandingRequests = function(callback) {
          if (outstandingRequestCount === 0) {
            callback();
          } else {
            outstandingRequestCallbacks.push(callback);
          }
        };
        var cachedState,
            lastHistoryState,
            lastBrowserUrl = location.href,
            baseElement = document.find('base'),
            pendingLocation = null,
            getCurrentState = !$sniffer.history ? noop : function getCurrentState() {
              try {
                return history.state;
              } catch (e) {}
            };
        cacheState();
        self.url = function(url, replace, state) {
          if (isUndefined(state)) {
            state = null;
          }
          if (location !== window.location)
            location = window.location;
          if (history !== window.history)
            history = window.history;
          if (url) {
            var sameState = lastHistoryState === state;
            if (lastBrowserUrl === url && (!$sniffer.history || sameState)) {
              return self;
            }
            var sameBase = lastBrowserUrl && stripHash(lastBrowserUrl) === stripHash(url);
            lastBrowserUrl = url;
            lastHistoryState = state;
            if ($sniffer.history && (!sameBase || !sameState)) {
              history[replace ? 'replaceState' : 'pushState'](state, '', url);
              cacheState();
            } else {
              if (!sameBase) {
                pendingLocation = url;
              }
              if (replace) {
                location.replace(url);
              } else if (!sameBase) {
                location.href = url;
              } else {
                location.hash = getHash(url);
              }
              if (location.href !== url) {
                pendingLocation = url;
              }
            }
            if (pendingLocation) {
              pendingLocation = url;
            }
            return self;
          } else {
            return pendingLocation || location.href.replace(/%27/g, '\'');
          }
        };
        self.state = function() {
          return cachedState;
        };
        var urlChangeListeners = [],
            urlChangeInit = false;
        function cacheStateAndFireUrlChange() {
          pendingLocation = null;
          fireStateOrUrlChange();
        }
        var lastCachedState = null;
        function cacheState() {
          cachedState = getCurrentState();
          cachedState = isUndefined(cachedState) ? null : cachedState;
          if (equals(cachedState, lastCachedState)) {
            cachedState = lastCachedState;
          }
          lastCachedState = cachedState;
          lastHistoryState = cachedState;
        }
        function fireStateOrUrlChange() {
          var prevLastHistoryState = lastHistoryState;
          cacheState();
          if (lastBrowserUrl === self.url() && prevLastHistoryState === cachedState) {
            return;
          }
          lastBrowserUrl = self.url();
          lastHistoryState = cachedState;
          forEach(urlChangeListeners, function(listener) {
            listener(self.url(), cachedState);
          });
        }
        self.onUrlChange = function(callback) {
          if (!urlChangeInit) {
            if ($sniffer.history)
              jqLite(window).on('popstate', cacheStateAndFireUrlChange);
            jqLite(window).on('hashchange', cacheStateAndFireUrlChange);
            urlChangeInit = true;
          }
          urlChangeListeners.push(callback);
          return callback;
        };
        self.$$applicationDestroyed = function() {
          jqLite(window).off('hashchange popstate', cacheStateAndFireUrlChange);
        };
        self.$$checkUrlChange = fireStateOrUrlChange;
        self.baseHref = function() {
          var href = baseElement.attr('href');
          return href ? href.replace(/^(https?:)?\/\/[^/]*/, '') : '';
        };
        self.defer = function(fn, delay) {
          var timeoutId;
          outstandingRequestCount++;
          timeoutId = setTimeout(function() {
            delete pendingDeferIds[timeoutId];
            completeOutstandingRequest(fn);
          }, delay || 0);
          pendingDeferIds[timeoutId] = true;
          return timeoutId;
        };
        self.defer.cancel = function(deferId) {
          if (pendingDeferIds[deferId]) {
            delete pendingDeferIds[deferId];
            clearTimeout(deferId);
            completeOutstandingRequest(noop);
            return true;
          }
          return false;
        };
      }
      function $BrowserProvider() {
        this.$get = ['$window', '$log', '$sniffer', '$document', function($window, $log, $sniffer, $document) {
          return new Browser($window, $document, $log, $sniffer);
        }];
      }
      function $CacheFactoryProvider() {
        this.$get = function() {
          var caches = {};
          function cacheFactory(cacheId, options) {
            if (cacheId in caches) {
              throw minErr('$cacheFactory')('iid', 'CacheId \'{0}\' is already taken!', cacheId);
            }
            var size = 0,
                stats = extend({}, options, {id: cacheId}),
                data = createMap(),
                capacity = (options && options.capacity) || Number.MAX_VALUE,
                lruHash = createMap(),
                freshEnd = null,
                staleEnd = null;
            return (caches[cacheId] = {
              put: function(key, value) {
                if (isUndefined(value))
                  return;
                if (capacity < Number.MAX_VALUE) {
                  var lruEntry = lruHash[key] || (lruHash[key] = {key: key});
                  refresh(lruEntry);
                }
                if (!(key in data))
                  size++;
                data[key] = value;
                if (size > capacity) {
                  this.remove(staleEnd.key);
                }
                return value;
              },
              get: function(key) {
                if (capacity < Number.MAX_VALUE) {
                  var lruEntry = lruHash[key];
                  if (!lruEntry)
                    return;
                  refresh(lruEntry);
                }
                return data[key];
              },
              remove: function(key) {
                if (capacity < Number.MAX_VALUE) {
                  var lruEntry = lruHash[key];
                  if (!lruEntry)
                    return;
                  if (lruEntry === freshEnd)
                    freshEnd = lruEntry.p;
                  if (lruEntry === staleEnd)
                    staleEnd = lruEntry.n;
                  link(lruEntry.n, lruEntry.p);
                  delete lruHash[key];
                }
                if (!(key in data))
                  return;
                delete data[key];
                size--;
              },
              removeAll: function() {
                data = createMap();
                size = 0;
                lruHash = createMap();
                freshEnd = staleEnd = null;
              },
              destroy: function() {
                data = null;
                stats = null;
                lruHash = null;
                delete caches[cacheId];
              },
              info: function() {
                return extend({}, stats, {size: size});
              }
            });
            function refresh(entry) {
              if (entry !== freshEnd) {
                if (!staleEnd) {
                  staleEnd = entry;
                } else if (staleEnd === entry) {
                  staleEnd = entry.n;
                }
                link(entry.n, entry.p);
                link(entry, freshEnd);
                freshEnd = entry;
                freshEnd.n = null;
              }
            }
            function link(nextEntry, prevEntry) {
              if (nextEntry !== prevEntry) {
                if (nextEntry)
                  nextEntry.p = prevEntry;
                if (prevEntry)
                  prevEntry.n = nextEntry;
              }
            }
          }
          cacheFactory.info = function() {
            var info = {};
            forEach(caches, function(cache, cacheId) {
              info[cacheId] = cache.info();
            });
            return info;
          };
          cacheFactory.get = function(cacheId) {
            return caches[cacheId];
          };
          return cacheFactory;
        };
      }
      function $TemplateCacheProvider() {
        this.$get = ['$cacheFactory', function($cacheFactory) {
          return $cacheFactory('templates');
        }];
      }
      var $compileMinErr = minErr('$compile');
      function UNINITIALIZED_VALUE() {}
      var _UNINITIALIZED_VALUE = new UNINITIALIZED_VALUE();
      $CompileProvider.$inject = ['$provide', '$$sanitizeUriProvider'];
      function $CompileProvider($provide, $$sanitizeUriProvider) {
        var hasDirectives = {},
            Suffix = 'Directive',
            COMMENT_DIRECTIVE_REGEXP = /^\s*directive:\s*([\w-]+)\s+(.*)$/,
            CLASS_DIRECTIVE_REGEXP = /(([\w-]+)(?::([^;]+))?;?)/,
            ALL_OR_NOTHING_ATTRS = makeMap('ngSrc,ngSrcset,src,srcset'),
            REQUIRE_PREFIX_REGEXP = /^(?:(\^\^?)?(\?)?(\^\^?)?)?/;
        var EVENT_HANDLER_ATTR_REGEXP = /^(on[a-z]+|formaction)$/;
        var bindingCache = createMap();
        function parseIsolateBindings(scope, directiveName, isController) {
          var LOCAL_REGEXP = /^\s*([@&<]|=(\*?))(\??)\s*([\w$]*)\s*$/;
          var bindings = createMap();
          forEach(scope, function(definition, scopeName) {
            if (definition in bindingCache) {
              bindings[scopeName] = bindingCache[definition];
              return;
            }
            var match = definition.match(LOCAL_REGEXP);
            if (!match) {
              throw $compileMinErr('iscp', 'Invalid {3} for directive \'{0}\'.' + ' Definition: {... {1}: \'{2}\' ...}', directiveName, scopeName, definition, (isController ? 'controller bindings definition' : 'isolate scope definition'));
            }
            bindings[scopeName] = {
              mode: match[1][0],
              collection: match[2] === '*',
              optional: match[3] === '?',
              attrName: match[4] || scopeName
            };
            if (match[4]) {
              bindingCache[definition] = bindings[scopeName];
            }
          });
          return bindings;
        }
        function parseDirectiveBindings(directive, directiveName) {
          var bindings = {
            isolateScope: null,
            bindToController: null
          };
          if (isObject(directive.scope)) {
            if (directive.bindToController === true) {
              bindings.bindToController = parseIsolateBindings(directive.scope, directiveName, true);
              bindings.isolateScope = {};
            } else {
              bindings.isolateScope = parseIsolateBindings(directive.scope, directiveName, false);
            }
          }
          if (isObject(directive.bindToController)) {
            bindings.bindToController = parseIsolateBindings(directive.bindToController, directiveName, true);
          }
          if (bindings.bindToController && !directive.controller) {
            throw $compileMinErr('noctrl', 'Cannot bind to controller without directive \'{0}\'s controller.', directiveName);
          }
          return bindings;
        }
        function assertValidDirectiveName(name) {
          var letter = name.charAt(0);
          if (!letter || letter !== lowercase(letter)) {
            throw $compileMinErr('baddir', 'Directive/Component name \'{0}\' is invalid. The first character must be a lowercase letter', name);
          }
          if (name !== name.trim()) {
            throw $compileMinErr('baddir', 'Directive/Component name \'{0}\' is invalid. The name should not contain leading or trailing whitespaces', name);
          }
        }
        function getDirectiveRequire(directive) {
          var require = directive.require || (directive.controller && directive.name);
          if (!isArray(require) && isObject(require)) {
            forEach(require, function(value, key) {
              var match = value.match(REQUIRE_PREFIX_REGEXP);
              var name = value.substring(match[0].length);
              if (!name)
                require[key] = match[0] + key;
            });
          }
          return require;
        }
        function getDirectiveRestrict(restrict, name) {
          if (restrict && !(isString(restrict) && /[EACM]/.test(restrict))) {
            throw $compileMinErr('badrestrict', 'Restrict property \'{0}\' of directive \'{1}\' is invalid', restrict, name);
          }
          return restrict || 'EA';
        }
        this.directive = function registerDirective(name, directiveFactory) {
          assertArg(name, 'name');
          assertNotHasOwnProperty(name, 'directive');
          if (isString(name)) {
            assertValidDirectiveName(name);
            assertArg(directiveFactory, 'directiveFactory');
            if (!hasDirectives.hasOwnProperty(name)) {
              hasDirectives[name] = [];
              $provide.factory(name + Suffix, ['$injector', '$exceptionHandler', function($injector, $exceptionHandler) {
                var directives = [];
                forEach(hasDirectives[name], function(directiveFactory, index) {
                  try {
                    var directive = $injector.invoke(directiveFactory);
                    if (isFunction(directive)) {
                      directive = {compile: valueFn(directive)};
                    } else if (!directive.compile && directive.link) {
                      directive.compile = valueFn(directive.link);
                    }
                    directive.priority = directive.priority || 0;
                    directive.index = index;
                    directive.name = directive.name || name;
                    directive.require = getDirectiveRequire(directive);
                    directive.restrict = getDirectiveRestrict(directive.restrict, name);
                    directive.$$moduleName = directiveFactory.$$moduleName;
                    directives.push(directive);
                  } catch (e) {
                    $exceptionHandler(e);
                  }
                });
                return directives;
              }]);
            }
            hasDirectives[name].push(directiveFactory);
          } else {
            forEach(name, reverseParams(registerDirective));
          }
          return this;
        };
        this.component = function registerComponent(name, options) {
          if (!isString(name)) {
            forEach(name, reverseParams(bind(this, registerComponent)));
            return this;
          }
          var controller = options.controller || function() {};
          function factory($injector) {
            function makeInjectable(fn) {
              if (isFunction(fn) || isArray(fn)) {
                return function(tElement, tAttrs) {
                  return $injector.invoke(fn, this, {
                    $element: tElement,
                    $attrs: tAttrs
                  });
                };
              } else {
                return fn;
              }
            }
            var template = (!options.template && !options.templateUrl ? '' : options.template);
            var ddo = {
              controller: controller,
              controllerAs: identifierForController(options.controller) || options.controllerAs || '$ctrl',
              template: makeInjectable(template),
              templateUrl: makeInjectable(options.templateUrl),
              transclude: options.transclude,
              scope: {},
              bindToController: options.bindings || {},
              restrict: 'E',
              require: options.require
            };
            forEach(options, function(val, key) {
              if (key.charAt(0) === '$')
                ddo[key] = val;
            });
            return ddo;
          }
          forEach(options, function(val, key) {
            if (key.charAt(0) === '$') {
              factory[key] = val;
              if (isFunction(controller))
                controller[key] = val;
            }
          });
          factory.$inject = ['$injector'];
          return this.directive(name, factory);
        };
        this.aHrefSanitizationWhitelist = function(regexp) {
          if (isDefined(regexp)) {
            $$sanitizeUriProvider.aHrefSanitizationWhitelist(regexp);
            return this;
          } else {
            return $$sanitizeUriProvider.aHrefSanitizationWhitelist();
          }
        };
        this.imgSrcSanitizationWhitelist = function(regexp) {
          if (isDefined(regexp)) {
            $$sanitizeUriProvider.imgSrcSanitizationWhitelist(regexp);
            return this;
          } else {
            return $$sanitizeUriProvider.imgSrcSanitizationWhitelist();
          }
        };
        var debugInfoEnabled = true;
        this.debugInfoEnabled = function(enabled) {
          if (isDefined(enabled)) {
            debugInfoEnabled = enabled;
            return this;
          }
          return debugInfoEnabled;
        };
        var preAssignBindingsEnabled = false;
        this.preAssignBindingsEnabled = function(enabled) {
          if (isDefined(enabled)) {
            preAssignBindingsEnabled = enabled;
            return this;
          }
          return preAssignBindingsEnabled;
        };
        var strictComponentBindingsEnabled = false;
        this.strictComponentBindingsEnabled = function(enabled) {
          if (isDefined(enabled)) {
            strictComponentBindingsEnabled = enabled;
            return this;
          }
          return strictComponentBindingsEnabled;
        };
        var TTL = 10;
        this.onChangesTtl = function(value) {
          if (arguments.length) {
            TTL = value;
            return this;
          }
          return TTL;
        };
        var commentDirectivesEnabledConfig = true;
        this.commentDirectivesEnabled = function(value) {
          if (arguments.length) {
            commentDirectivesEnabledConfig = value;
            return this;
          }
          return commentDirectivesEnabledConfig;
        };
        var cssClassDirectivesEnabledConfig = true;
        this.cssClassDirectivesEnabled = function(value) {
          if (arguments.length) {
            cssClassDirectivesEnabledConfig = value;
            return this;
          }
          return cssClassDirectivesEnabledConfig;
        };
        this.$get = ['$injector', '$interpolate', '$exceptionHandler', '$templateRequest', '$parse', '$controller', '$rootScope', '$sce', '$animate', '$$sanitizeUri', function($injector, $interpolate, $exceptionHandler, $templateRequest, $parse, $controller, $rootScope, $sce, $animate, $$sanitizeUri) {
          var SIMPLE_ATTR_NAME = /^\w/;
          var specialAttrHolder = window.document.createElement('div');
          var commentDirectivesEnabled = commentDirectivesEnabledConfig;
          var cssClassDirectivesEnabled = cssClassDirectivesEnabledConfig;
          var onChangesTtl = TTL;
          var onChangesQueue;
          function flushOnChangesQueue() {
            try {
              if (!(--onChangesTtl)) {
                onChangesQueue = undefined;
                throw $compileMinErr('infchng', '{0} $onChanges() iterations reached. Aborting!\n', TTL);
              }
              $rootScope.$apply(function() {
                var errors = [];
                for (var i = 0,
                    ii = onChangesQueue.length; i < ii; ++i) {
                  try {
                    onChangesQueue[i]();
                  } catch (e) {
                    errors.push(e);
                  }
                }
                onChangesQueue = undefined;
                if (errors.length) {
                  throw errors;
                }
              });
            } finally {
              onChangesTtl++;
            }
          }
          function Attributes(element, attributesToCopy) {
            if (attributesToCopy) {
              var keys = Object.keys(attributesToCopy);
              var i,
                  l,
                  key;
              for (i = 0, l = keys.length; i < l; i++) {
                key = keys[i];
                this[key] = attributesToCopy[key];
              }
            } else {
              this.$attr = {};
            }
            this.$$element = element;
          }
          Attributes.prototype = {
            $normalize: directiveNormalize,
            $addClass: function(classVal) {
              if (classVal && classVal.length > 0) {
                $animate.addClass(this.$$element, classVal);
              }
            },
            $removeClass: function(classVal) {
              if (classVal && classVal.length > 0) {
                $animate.removeClass(this.$$element, classVal);
              }
            },
            $updateClass: function(newClasses, oldClasses) {
              var toAdd = tokenDifference(newClasses, oldClasses);
              if (toAdd && toAdd.length) {
                $animate.addClass(this.$$element, toAdd);
              }
              var toRemove = tokenDifference(oldClasses, newClasses);
              if (toRemove && toRemove.length) {
                $animate.removeClass(this.$$element, toRemove);
              }
            },
            $set: function(key, value, writeAttr, attrName) {
              var node = this.$$element[0],
                  booleanKey = getBooleanAttrName(node, key),
                  aliasedKey = getAliasedAttrName(key),
                  observer = key,
                  nodeName;
              if (booleanKey) {
                this.$$element.prop(key, value);
                attrName = booleanKey;
              } else if (aliasedKey) {
                this[aliasedKey] = value;
                observer = aliasedKey;
              }
              this[key] = value;
              if (attrName) {
                this.$attr[key] = attrName;
              } else {
                attrName = this.$attr[key];
                if (!attrName) {
                  this.$attr[key] = attrName = snake_case(key, '-');
                }
              }
              nodeName = nodeName_(this.$$element);
              if ((nodeName === 'a' && (key === 'href' || key === 'xlinkHref')) || (nodeName === 'img' && key === 'src')) {
                this[key] = value = $$sanitizeUri(value, key === 'src');
              } else if (nodeName === 'img' && key === 'srcset' && isDefined(value)) {
                var result = '';
                var trimmedSrcset = trim(value);
                var srcPattern = /(\s+\d+x\s*,|\s+\d+w\s*,|\s+,|,\s+)/;
                var pattern = /\s/.test(trimmedSrcset) ? srcPattern : /(,)/;
                var rawUris = trimmedSrcset.split(pattern);
                var nbrUrisWith2parts = Math.floor(rawUris.length / 2);
                for (var i = 0; i < nbrUrisWith2parts; i++) {
                  var innerIdx = i * 2;
                  result += $$sanitizeUri(trim(rawUris[innerIdx]), true);
                  result += (' ' + trim(rawUris[innerIdx + 1]));
                }
                var lastTuple = trim(rawUris[i * 2]).split(/\s/);
                result += $$sanitizeUri(trim(lastTuple[0]), true);
                if (lastTuple.length === 2) {
                  result += (' ' + trim(lastTuple[1]));
                }
                this[key] = value = result;
              }
              if (writeAttr !== false) {
                if (value === null || isUndefined(value)) {
                  this.$$element.removeAttr(attrName);
                } else {
                  if (SIMPLE_ATTR_NAME.test(attrName)) {
                    this.$$element.attr(attrName, value);
                  } else {
                    setSpecialAttr(this.$$element[0], attrName, value);
                  }
                }
              }
              var $$observers = this.$$observers;
              if ($$observers) {
                forEach($$observers[observer], function(fn) {
                  try {
                    fn(value);
                  } catch (e) {
                    $exceptionHandler(e);
                  }
                });
              }
            },
            $observe: function(key, fn) {
              var attrs = this,
                  $$observers = (attrs.$$observers || (attrs.$$observers = createMap())),
                  listeners = ($$observers[key] || ($$observers[key] = []));
              listeners.push(fn);
              $rootScope.$evalAsync(function() {
                if (!listeners.$$inter && attrs.hasOwnProperty(key) && !isUndefined(attrs[key])) {
                  fn(attrs[key]);
                }
              });
              return function() {
                arrayRemove(listeners, fn);
              };
            }
          };
          function setSpecialAttr(element, attrName, value) {
            specialAttrHolder.innerHTML = '<span ' + attrName + '>';
            var attributes = specialAttrHolder.firstChild.attributes;
            var attribute = attributes[0];
            attributes.removeNamedItem(attribute.name);
            attribute.value = value;
            element.attributes.setNamedItem(attribute);
          }
          function safeAddClass($element, className) {
            try {
              $element.addClass(className);
            } catch (e) {}
          }
          var startSymbol = $interpolate.startSymbol(),
              endSymbol = $interpolate.endSymbol(),
              denormalizeTemplate = (startSymbol === '{{' && endSymbol === '}}') ? identity : function denormalizeTemplate(template) {
                return template.replace(/\{\{/g, startSymbol).replace(/}}/g, endSymbol);
              },
              NG_ATTR_BINDING = /^ngAttr[A-Z]/;
          var MULTI_ELEMENT_DIR_RE = /^(.+)Start$/;
          compile.$$addBindingInfo = debugInfoEnabled ? function $$addBindingInfo($element, binding) {
            var bindings = $element.data('$binding') || [];
            if (isArray(binding)) {
              bindings = bindings.concat(binding);
            } else {
              bindings.push(binding);
            }
            $element.data('$binding', bindings);
          } : noop;
          compile.$$addBindingClass = debugInfoEnabled ? function $$addBindingClass($element) {
            safeAddClass($element, 'ng-binding');
          } : noop;
          compile.$$addScopeInfo = debugInfoEnabled ? function $$addScopeInfo($element, scope, isolated, noTemplate) {
            var dataName = isolated ? (noTemplate ? '$isolateScopeNoTemplate' : '$isolateScope') : '$scope';
            $element.data(dataName, scope);
          } : noop;
          compile.$$addScopeClass = debugInfoEnabled ? function $$addScopeClass($element, isolated) {
            safeAddClass($element, isolated ? 'ng-isolate-scope' : 'ng-scope');
          } : noop;
          compile.$$createComment = function(directiveName, comment) {
            var content = '';
            if (debugInfoEnabled) {
              content = ' ' + (directiveName || '') + ': ';
              if (comment)
                content += comment + ' ';
            }
            return window.document.createComment(content);
          };
          return compile;
          function compile($compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext) {
            if (!($compileNodes instanceof jqLite)) {
              $compileNodes = jqLite($compileNodes);
            }
            var compositeLinkFn = compileNodes($compileNodes, transcludeFn, $compileNodes, maxPriority, ignoreDirective, previousCompileContext);
            compile.$$addScopeClass($compileNodes);
            var namespace = null;
            return function publicLinkFn(scope, cloneConnectFn, options) {
              if (!$compileNodes) {
                throw $compileMinErr('multilink', 'This element has already been linked.');
              }
              assertArg(scope, 'scope');
              if (previousCompileContext && previousCompileContext.needsNewScope) {
                scope = scope.$parent.$new();
              }
              options = options || {};
              var parentBoundTranscludeFn = options.parentBoundTranscludeFn,
                  transcludeControllers = options.transcludeControllers,
                  futureParentElement = options.futureParentElement;
              if (parentBoundTranscludeFn && parentBoundTranscludeFn.$$boundTransclude) {
                parentBoundTranscludeFn = parentBoundTranscludeFn.$$boundTransclude;
              }
              if (!namespace) {
                namespace = detectNamespaceForChildElements(futureParentElement);
              }
              var $linkNode;
              if (namespace !== 'html') {
                $linkNode = jqLite(wrapTemplate(namespace, jqLite('<div>').append($compileNodes).html()));
              } else if (cloneConnectFn) {
                $linkNode = JQLitePrototype.clone.call($compileNodes);
              } else {
                $linkNode = $compileNodes;
              }
              if (transcludeControllers) {
                for (var controllerName in transcludeControllers) {
                  $linkNode.data('$' + controllerName + 'Controller', transcludeControllers[controllerName].instance);
                }
              }
              compile.$$addScopeInfo($linkNode, scope);
              if (cloneConnectFn)
                cloneConnectFn($linkNode, scope);
              if (compositeLinkFn)
                compositeLinkFn(scope, $linkNode, $linkNode, parentBoundTranscludeFn);
              if (!cloneConnectFn) {
                $compileNodes = compositeLinkFn = null;
              }
              return $linkNode;
            };
          }
          function detectNamespaceForChildElements(parentElement) {
            var node = parentElement && parentElement[0];
            if (!node) {
              return 'html';
            } else {
              return nodeName_(node) !== 'foreignobject' && toString.call(node).match(/SVG/) ? 'svg' : 'html';
            }
          }
          function compileNodes(nodeList, transcludeFn, $rootElement, maxPriority, ignoreDirective, previousCompileContext) {
            var linkFns = [],
                notLiveList = isArray(nodeList) || (nodeList instanceof jqLite),
                attrs,
                directives,
                nodeLinkFn,
                childNodes,
                childLinkFn,
                linkFnFound,
                nodeLinkFnFound;
            for (var i = 0; i < nodeList.length; i++) {
              attrs = new Attributes();
              if (msie === 11) {
                mergeConsecutiveTextNodes(nodeList, i, notLiveList);
              }
              directives = collectDirectives(nodeList[i], [], attrs, i === 0 ? maxPriority : undefined, ignoreDirective);
              nodeLinkFn = (directives.length) ? applyDirectivesToNode(directives, nodeList[i], attrs, transcludeFn, $rootElement, null, [], [], previousCompileContext) : null;
              if (nodeLinkFn && nodeLinkFn.scope) {
                compile.$$addScopeClass(attrs.$$element);
              }
              childLinkFn = (nodeLinkFn && nodeLinkFn.terminal || !(childNodes = nodeList[i].childNodes) || !childNodes.length) ? null : compileNodes(childNodes, nodeLinkFn ? ((nodeLinkFn.transcludeOnThisElement || !nodeLinkFn.templateOnThisElement) && nodeLinkFn.transclude) : transcludeFn);
              if (nodeLinkFn || childLinkFn) {
                linkFns.push(i, nodeLinkFn, childLinkFn);
                linkFnFound = true;
                nodeLinkFnFound = nodeLinkFnFound || nodeLinkFn;
              }
              previousCompileContext = null;
            }
            return linkFnFound ? compositeLinkFn : null;
            function compositeLinkFn(scope, nodeList, $rootElement, parentBoundTranscludeFn) {
              var nodeLinkFn,
                  childLinkFn,
                  node,
                  childScope,
                  i,
                  ii,
                  idx,
                  childBoundTranscludeFn;
              var stableNodeList;
              if (nodeLinkFnFound) {
                var nodeListLength = nodeList.length;
                stableNodeList = new Array(nodeListLength);
                for (i = 0; i < linkFns.length; i += 3) {
                  idx = linkFns[i];
                  stableNodeList[idx] = nodeList[idx];
                }
              } else {
                stableNodeList = nodeList;
              }
              for (i = 0, ii = linkFns.length; i < ii; ) {
                node = stableNodeList[linkFns[i++]];
                nodeLinkFn = linkFns[i++];
                childLinkFn = linkFns[i++];
                if (nodeLinkFn) {
                  if (nodeLinkFn.scope) {
                    childScope = scope.$new();
                    compile.$$addScopeInfo(jqLite(node), childScope);
                  } else {
                    childScope = scope;
                  }
                  if (nodeLinkFn.transcludeOnThisElement) {
                    childBoundTranscludeFn = createBoundTranscludeFn(scope, nodeLinkFn.transclude, parentBoundTranscludeFn);
                  } else if (!nodeLinkFn.templateOnThisElement && parentBoundTranscludeFn) {
                    childBoundTranscludeFn = parentBoundTranscludeFn;
                  } else if (!parentBoundTranscludeFn && transcludeFn) {
                    childBoundTranscludeFn = createBoundTranscludeFn(scope, transcludeFn);
                  } else {
                    childBoundTranscludeFn = null;
                  }
                  nodeLinkFn(childLinkFn, childScope, node, $rootElement, childBoundTranscludeFn);
                } else if (childLinkFn) {
                  childLinkFn(scope, node.childNodes, undefined, parentBoundTranscludeFn);
                }
              }
            }
          }
          function mergeConsecutiveTextNodes(nodeList, idx, notLiveList) {
            var node = nodeList[idx];
            var parent = node.parentNode;
            var sibling;
            if (node.nodeType !== NODE_TYPE_TEXT) {
              return;
            }
            while (true) {
              sibling = parent ? node.nextSibling : nodeList[idx + 1];
              if (!sibling || sibling.nodeType !== NODE_TYPE_TEXT) {
                break;
              }
              node.nodeValue = node.nodeValue + sibling.nodeValue;
              if (sibling.parentNode) {
                sibling.parentNode.removeChild(sibling);
              }
              if (notLiveList && sibling === nodeList[idx + 1]) {
                nodeList.splice(idx + 1, 1);
              }
            }
          }
          function createBoundTranscludeFn(scope, transcludeFn, previousBoundTranscludeFn) {
            function boundTranscludeFn(transcludedScope, cloneFn, controllers, futureParentElement, containingScope) {
              if (!transcludedScope) {
                transcludedScope = scope.$new(false, containingScope);
                transcludedScope.$$transcluded = true;
              }
              return transcludeFn(transcludedScope, cloneFn, {
                parentBoundTranscludeFn: previousBoundTranscludeFn,
                transcludeControllers: controllers,
                futureParentElement: futureParentElement
              });
            }
            var boundSlots = boundTranscludeFn.$$slots = createMap();
            for (var slotName in transcludeFn.$$slots) {
              if (transcludeFn.$$slots[slotName]) {
                boundSlots[slotName] = createBoundTranscludeFn(scope, transcludeFn.$$slots[slotName], previousBoundTranscludeFn);
              } else {
                boundSlots[slotName] = null;
              }
            }
            return boundTranscludeFn;
          }
          function collectDirectives(node, directives, attrs, maxPriority, ignoreDirective) {
            var nodeType = node.nodeType,
                attrsMap = attrs.$attr,
                match,
                nodeName,
                className;
            switch (nodeType) {
              case NODE_TYPE_ELEMENT:
                nodeName = nodeName_(node);
                addDirective(directives, directiveNormalize(nodeName), 'E', maxPriority, ignoreDirective);
                for (var attr,
                    name,
                    nName,
                    ngAttrName,
                    value,
                    isNgAttr,
                    nAttrs = node.attributes,
                    j = 0,
                    jj = nAttrs && nAttrs.length; j < jj; j++) {
                  var attrStartName = false;
                  var attrEndName = false;
                  attr = nAttrs[j];
                  name = attr.name;
                  value = attr.value;
                  ngAttrName = directiveNormalize(name);
                  isNgAttr = NG_ATTR_BINDING.test(ngAttrName);
                  if (isNgAttr) {
                    name = name.replace(PREFIX_REGEXP, '').substr(8).replace(/_(.)/g, function(match, letter) {
                      return letter.toUpperCase();
                    });
                  }
                  var multiElementMatch = ngAttrName.match(MULTI_ELEMENT_DIR_RE);
                  if (multiElementMatch && directiveIsMultiElement(multiElementMatch[1])) {
                    attrStartName = name;
                    attrEndName = name.substr(0, name.length - 5) + 'end';
                    name = name.substr(0, name.length - 6);
                  }
                  nName = directiveNormalize(name.toLowerCase());
                  attrsMap[nName] = name;
                  if (isNgAttr || !attrs.hasOwnProperty(nName)) {
                    attrs[nName] = value;
                    if (getBooleanAttrName(node, nName)) {
                      attrs[nName] = true;
                    }
                  }
                  addAttrInterpolateDirective(node, directives, value, nName, isNgAttr);
                  addDirective(directives, nName, 'A', maxPriority, ignoreDirective, attrStartName, attrEndName);
                }
                if (nodeName === 'input' && node.getAttribute('type') === 'hidden') {
                  node.setAttribute('autocomplete', 'off');
                }
                if (!cssClassDirectivesEnabled)
                  break;
                className = node.className;
                if (isObject(className)) {
                  className = className.animVal;
                }
                if (isString(className) && className !== '') {
                  while ((match = CLASS_DIRECTIVE_REGEXP.exec(className))) {
                    nName = directiveNormalize(match[2]);
                    if (addDirective(directives, nName, 'C', maxPriority, ignoreDirective)) {
                      attrs[nName] = trim(match[3]);
                    }
                    className = className.substr(match.index + match[0].length);
                  }
                }
                break;
              case NODE_TYPE_TEXT:
                addTextInterpolateDirective(directives, node.nodeValue);
                break;
              case NODE_TYPE_COMMENT:
                if (!commentDirectivesEnabled)
                  break;
                collectCommentDirectives(node, directives, attrs, maxPriority, ignoreDirective);
                break;
            }
            directives.sort(byPriority);
            return directives;
          }
          function collectCommentDirectives(node, directives, attrs, maxPriority, ignoreDirective) {
            try {
              var match = COMMENT_DIRECTIVE_REGEXP.exec(node.nodeValue);
              if (match) {
                var nName = directiveNormalize(match[1]);
                if (addDirective(directives, nName, 'M', maxPriority, ignoreDirective)) {
                  attrs[nName] = trim(match[2]);
                }
              }
            } catch (e) {}
          }
          function groupScan(node, attrStart, attrEnd) {
            var nodes = [];
            var depth = 0;
            if (attrStart && node.hasAttribute && node.hasAttribute(attrStart)) {
              do {
                if (!node) {
                  throw $compileMinErr('uterdir', 'Unterminated attribute, found \'{0}\' but no matching \'{1}\' found.', attrStart, attrEnd);
                }
                if (node.nodeType === NODE_TYPE_ELEMENT) {
                  if (node.hasAttribute(attrStart))
                    depth++;
                  if (node.hasAttribute(attrEnd))
                    depth--;
                }
                nodes.push(node);
                node = node.nextSibling;
              } while (depth > 0);
            } else {
              nodes.push(node);
            }
            return jqLite(nodes);
          }
          function groupElementsLinkFnWrapper(linkFn, attrStart, attrEnd) {
            return function groupedElementsLink(scope, element, attrs, controllers, transcludeFn) {
              element = groupScan(element[0], attrStart, attrEnd);
              return linkFn(scope, element, attrs, controllers, transcludeFn);
            };
          }
          function compilationGenerator(eager, $compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext) {
            var compiled;
            if (eager) {
              return compile($compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext);
            }
            return function lazyCompilation() {
              if (!compiled) {
                compiled = compile($compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext);
                $compileNodes = transcludeFn = previousCompileContext = null;
              }
              return compiled.apply(this, arguments);
            };
          }
          function applyDirectivesToNode(directives, compileNode, templateAttrs, transcludeFn, jqCollection, originalReplaceDirective, preLinkFns, postLinkFns, previousCompileContext) {
            previousCompileContext = previousCompileContext || {};
            var terminalPriority = -Number.MAX_VALUE,
                newScopeDirective = previousCompileContext.newScopeDirective,
                controllerDirectives = previousCompileContext.controllerDirectives,
                newIsolateScopeDirective = previousCompileContext.newIsolateScopeDirective,
                templateDirective = previousCompileContext.templateDirective,
                nonTlbTranscludeDirective = previousCompileContext.nonTlbTranscludeDirective,
                hasTranscludeDirective = false,
                hasTemplate = false,
                hasElementTranscludeDirective = previousCompileContext.hasElementTranscludeDirective,
                $compileNode = templateAttrs.$$element = jqLite(compileNode),
                directive,
                directiveName,
                $template,
                replaceDirective = originalReplaceDirective,
                childTranscludeFn = transcludeFn,
                linkFn,
                didScanForMultipleTransclusion = false,
                mightHaveMultipleTransclusionError = false,
                directiveValue;
            for (var i = 0,
                ii = directives.length; i < ii; i++) {
              directive = directives[i];
              var attrStart = directive.$$start;
              var attrEnd = directive.$$end;
              if (attrStart) {
                $compileNode = groupScan(compileNode, attrStart, attrEnd);
              }
              $template = undefined;
              if (terminalPriority > directive.priority) {
                break;
              }
              directiveValue = directive.scope;
              if (directiveValue) {
                if (!directive.templateUrl) {
                  if (isObject(directiveValue)) {
                    assertNoDuplicate('new/isolated scope', newIsolateScopeDirective || newScopeDirective, directive, $compileNode);
                    newIsolateScopeDirective = directive;
                  } else {
                    assertNoDuplicate('new/isolated scope', newIsolateScopeDirective, directive, $compileNode);
                  }
                }
                newScopeDirective = newScopeDirective || directive;
              }
              directiveName = directive.name;
              if (!didScanForMultipleTransclusion && ((directive.replace && (directive.templateUrl || directive.template)) || (directive.transclude && !directive.$$tlb))) {
                var candidateDirective;
                for (var scanningIndex = i + 1; (candidateDirective = directives[scanningIndex++]); ) {
                  if ((candidateDirective.transclude && !candidateDirective.$$tlb) || (candidateDirective.replace && (candidateDirective.templateUrl || candidateDirective.template))) {
                    mightHaveMultipleTransclusionError = true;
                    break;
                  }
                }
                didScanForMultipleTransclusion = true;
              }
              if (!directive.templateUrl && directive.controller) {
                controllerDirectives = controllerDirectives || createMap();
                assertNoDuplicate('\'' + directiveName + '\' controller', controllerDirectives[directiveName], directive, $compileNode);
                controllerDirectives[directiveName] = directive;
              }
              directiveValue = directive.transclude;
              if (directiveValue) {
                hasTranscludeDirective = true;
                if (!directive.$$tlb) {
                  assertNoDuplicate('transclusion', nonTlbTranscludeDirective, directive, $compileNode);
                  nonTlbTranscludeDirective = directive;
                }
                if (directiveValue === 'element') {
                  hasElementTranscludeDirective = true;
                  terminalPriority = directive.priority;
                  $template = $compileNode;
                  $compileNode = templateAttrs.$$element = jqLite(compile.$$createComment(directiveName, templateAttrs[directiveName]));
                  compileNode = $compileNode[0];
                  replaceWith(jqCollection, sliceArgs($template), compileNode);
                  $template[0].$$parentNode = $template[0].parentNode;
                  childTranscludeFn = compilationGenerator(mightHaveMultipleTransclusionError, $template, transcludeFn, terminalPriority, replaceDirective && replaceDirective.name, {nonTlbTranscludeDirective: nonTlbTranscludeDirective});
                } else {
                  var slots = createMap();
                  if (!isObject(directiveValue)) {
                    $template = jqLite(jqLiteClone(compileNode)).contents();
                  } else {
                    $template = [];
                    var slotMap = createMap();
                    var filledSlots = createMap();
                    forEach(directiveValue, function(elementSelector, slotName) {
                      var optional = (elementSelector.charAt(0) === '?');
                      elementSelector = optional ? elementSelector.substring(1) : elementSelector;
                      slotMap[elementSelector] = slotName;
                      slots[slotName] = null;
                      filledSlots[slotName] = optional;
                    });
                    forEach($compileNode.contents(), function(node) {
                      var slotName = slotMap[directiveNormalize(nodeName_(node))];
                      if (slotName) {
                        filledSlots[slotName] = true;
                        slots[slotName] = slots[slotName] || [];
                        slots[slotName].push(node);
                      } else {
                        $template.push(node);
                      }
                    });
                    forEach(filledSlots, function(filled, slotName) {
                      if (!filled) {
                        throw $compileMinErr('reqslot', 'Required transclusion slot `{0}` was not filled.', slotName);
                      }
                    });
                    for (var slotName in slots) {
                      if (slots[slotName]) {
                        slots[slotName] = compilationGenerator(mightHaveMultipleTransclusionError, slots[slotName], transcludeFn);
                      }
                    }
                  }
                  $compileNode.empty();
                  childTranscludeFn = compilationGenerator(mightHaveMultipleTransclusionError, $template, transcludeFn, undefined, undefined, {needsNewScope: directive.$$isolateScope || directive.$$newScope});
                  childTranscludeFn.$$slots = slots;
                }
              }
              if (directive.template) {
                hasTemplate = true;
                assertNoDuplicate('template', templateDirective, directive, $compileNode);
                templateDirective = directive;
                directiveValue = (isFunction(directive.template)) ? directive.template($compileNode, templateAttrs) : directive.template;
                directiveValue = denormalizeTemplate(directiveValue);
                if (directive.replace) {
                  replaceDirective = directive;
                  if (jqLiteIsTextNode(directiveValue)) {
                    $template = [];
                  } else {
                    $template = removeComments(wrapTemplate(directive.templateNamespace, trim(directiveValue)));
                  }
                  compileNode = $template[0];
                  if ($template.length !== 1 || compileNode.nodeType !== NODE_TYPE_ELEMENT) {
                    throw $compileMinErr('tplrt', 'Template for directive \'{0}\' must have exactly one root element. {1}', directiveName, '');
                  }
                  replaceWith(jqCollection, $compileNode, compileNode);
                  var newTemplateAttrs = {$attr: {}};
                  var templateDirectives = collectDirectives(compileNode, [], newTemplateAttrs);
                  var unprocessedDirectives = directives.splice(i + 1, directives.length - (i + 1));
                  if (newIsolateScopeDirective || newScopeDirective) {
                    markDirectiveScope(templateDirectives, newIsolateScopeDirective, newScopeDirective);
                  }
                  directives = directives.concat(templateDirectives).concat(unprocessedDirectives);
                  mergeTemplateAttributes(templateAttrs, newTemplateAttrs);
                  ii = directives.length;
                } else {
                  $compileNode.html(directiveValue);
                }
              }
              if (directive.templateUrl) {
                hasTemplate = true;
                assertNoDuplicate('template', templateDirective, directive, $compileNode);
                templateDirective = directive;
                if (directive.replace) {
                  replaceDirective = directive;
                }
                nodeLinkFn = compileTemplateUrl(directives.splice(i, directives.length - i), $compileNode, templateAttrs, jqCollection, hasTranscludeDirective && childTranscludeFn, preLinkFns, postLinkFns, {
                  controllerDirectives: controllerDirectives,
                  newScopeDirective: (newScopeDirective !== directive) && newScopeDirective,
                  newIsolateScopeDirective: newIsolateScopeDirective,
                  templateDirective: templateDirective,
                  nonTlbTranscludeDirective: nonTlbTranscludeDirective
                });
                ii = directives.length;
              } else if (directive.compile) {
                try {
                  linkFn = directive.compile($compileNode, templateAttrs, childTranscludeFn);
                  var context = directive.$$originalDirective || directive;
                  if (isFunction(linkFn)) {
                    addLinkFns(null, bind(context, linkFn), attrStart, attrEnd);
                  } else if (linkFn) {
                    addLinkFns(bind(context, linkFn.pre), bind(context, linkFn.post), attrStart, attrEnd);
                  }
                } catch (e) {
                  $exceptionHandler(e, startingTag($compileNode));
                }
              }
              if (directive.terminal) {
                nodeLinkFn.terminal = true;
                terminalPriority = Math.max(terminalPriority, directive.priority);
              }
            }
            nodeLinkFn.scope = newScopeDirective && newScopeDirective.scope === true;
            nodeLinkFn.transcludeOnThisElement = hasTranscludeDirective;
            nodeLinkFn.templateOnThisElement = hasTemplate;
            nodeLinkFn.transclude = childTranscludeFn;
            previousCompileContext.hasElementTranscludeDirective = hasElementTranscludeDirective;
            return nodeLinkFn;
            function addLinkFns(pre, post, attrStart, attrEnd) {
              if (pre) {
                if (attrStart)
                  pre = groupElementsLinkFnWrapper(pre, attrStart, attrEnd);
                pre.require = directive.require;
                pre.directiveName = directiveName;
                if (newIsolateScopeDirective === directive || directive.$$isolateScope) {
                  pre = cloneAndAnnotateFn(pre, {isolateScope: true});
                }
                preLinkFns.push(pre);
              }
              if (post) {
                if (attrStart)
                  post = groupElementsLinkFnWrapper(post, attrStart, attrEnd);
                post.require = directive.require;
                post.directiveName = directiveName;
                if (newIsolateScopeDirective === directive || directive.$$isolateScope) {
                  post = cloneAndAnnotateFn(post, {isolateScope: true});
                }
                postLinkFns.push(post);
              }
            }
            function nodeLinkFn(childLinkFn, scope, linkNode, $rootElement, boundTranscludeFn) {
              var i,
                  ii,
                  linkFn,
                  isolateScope,
                  controllerScope,
                  elementControllers,
                  transcludeFn,
                  $element,
                  attrs,
                  scopeBindingInfo;
              if (compileNode === linkNode) {
                attrs = templateAttrs;
                $element = templateAttrs.$$element;
              } else {
                $element = jqLite(linkNode);
                attrs = new Attributes($element, templateAttrs);
              }
              controllerScope = scope;
              if (newIsolateScopeDirective) {
                isolateScope = scope.$new(true);
              } else if (newScopeDirective) {
                controllerScope = scope.$parent;
              }
              if (boundTranscludeFn) {
                transcludeFn = controllersBoundTransclude;
                transcludeFn.$$boundTransclude = boundTranscludeFn;
                transcludeFn.isSlotFilled = function(slotName) {
                  return !!boundTranscludeFn.$$slots[slotName];
                };
              }
              if (controllerDirectives) {
                elementControllers = setupControllers($element, attrs, transcludeFn, controllerDirectives, isolateScope, scope, newIsolateScopeDirective);
              }
              if (newIsolateScopeDirective) {
                compile.$$addScopeInfo($element, isolateScope, true, !(templateDirective && (templateDirective === newIsolateScopeDirective || templateDirective === newIsolateScopeDirective.$$originalDirective)));
                compile.$$addScopeClass($element, true);
                isolateScope.$$isolateBindings = newIsolateScopeDirective.$$isolateBindings;
                scopeBindingInfo = initializeDirectiveBindings(scope, attrs, isolateScope, isolateScope.$$isolateBindings, newIsolateScopeDirective);
                if (scopeBindingInfo.removeWatches) {
                  isolateScope.$on('$destroy', scopeBindingInfo.removeWatches);
                }
              }
              for (var name in elementControllers) {
                var controllerDirective = controllerDirectives[name];
                var controller = elementControllers[name];
                var bindings = controllerDirective.$$bindings.bindToController;
                if (preAssignBindingsEnabled) {
                  if (bindings) {
                    controller.bindingInfo = initializeDirectiveBindings(controllerScope, attrs, controller.instance, bindings, controllerDirective);
                  } else {
                    controller.bindingInfo = {};
                  }
                  var controllerResult = controller();
                  if (controllerResult !== controller.instance) {
                    controller.instance = controllerResult;
                    $element.data('$' + controllerDirective.name + 'Controller', controllerResult);
                    if (controller.bindingInfo.removeWatches) {
                      controller.bindingInfo.removeWatches();
                    }
                    controller.bindingInfo = initializeDirectiveBindings(controllerScope, attrs, controller.instance, bindings, controllerDirective);
                  }
                } else {
                  controller.instance = controller();
                  $element.data('$' + controllerDirective.name + 'Controller', controller.instance);
                  controller.bindingInfo = initializeDirectiveBindings(controllerScope, attrs, controller.instance, bindings, controllerDirective);
                }
              }
              forEach(controllerDirectives, function(controllerDirective, name) {
                var require = controllerDirective.require;
                if (controllerDirective.bindToController && !isArray(require) && isObject(require)) {
                  extend(elementControllers[name].instance, getControllers(name, require, $element, elementControllers));
                }
              });
              forEach(elementControllers, function(controller) {
                var controllerInstance = controller.instance;
                if (isFunction(controllerInstance.$onChanges)) {
                  try {
                    controllerInstance.$onChanges(controller.bindingInfo.initialChanges);
                  } catch (e) {
                    $exceptionHandler(e);
                  }
                }
                if (isFunction(controllerInstance.$onInit)) {
                  try {
                    controllerInstance.$onInit();
                  } catch (e) {
                    $exceptionHandler(e);
                  }
                }
                if (isFunction(controllerInstance.$doCheck)) {
                  controllerScope.$watch(function() {
                    controllerInstance.$doCheck();
                  });
                  controllerInstance.$doCheck();
                }
                if (isFunction(controllerInstance.$onDestroy)) {
                  controllerScope.$on('$destroy', function callOnDestroyHook() {
                    controllerInstance.$onDestroy();
                  });
                }
              });
              for (i = 0, ii = preLinkFns.length; i < ii; i++) {
                linkFn = preLinkFns[i];
                invokeLinkFn(linkFn, linkFn.isolateScope ? isolateScope : scope, $element, attrs, linkFn.require && getControllers(linkFn.directiveName, linkFn.require, $element, elementControllers), transcludeFn);
              }
              var scopeToChild = scope;
              if (newIsolateScopeDirective && (newIsolateScopeDirective.template || newIsolateScopeDirective.templateUrl === null)) {
                scopeToChild = isolateScope;
              }
              if (childLinkFn) {
                childLinkFn(scopeToChild, linkNode.childNodes, undefined, boundTranscludeFn);
              }
              for (i = postLinkFns.length - 1; i >= 0; i--) {
                linkFn = postLinkFns[i];
                invokeLinkFn(linkFn, linkFn.isolateScope ? isolateScope : scope, $element, attrs, linkFn.require && getControllers(linkFn.directiveName, linkFn.require, $element, elementControllers), transcludeFn);
              }
              forEach(elementControllers, function(controller) {
                var controllerInstance = controller.instance;
                if (isFunction(controllerInstance.$postLink)) {
                  controllerInstance.$postLink();
                }
              });
              function controllersBoundTransclude(scope, cloneAttachFn, futureParentElement, slotName) {
                var transcludeControllers;
                if (!isScope(scope)) {
                  slotName = futureParentElement;
                  futureParentElement = cloneAttachFn;
                  cloneAttachFn = scope;
                  scope = undefined;
                }
                if (hasElementTranscludeDirective) {
                  transcludeControllers = elementControllers;
                }
                if (!futureParentElement) {
                  futureParentElement = hasElementTranscludeDirective ? $element.parent() : $element;
                }
                if (slotName) {
                  var slotTranscludeFn = boundTranscludeFn.$$slots[slotName];
                  if (slotTranscludeFn) {
                    return slotTranscludeFn(scope, cloneAttachFn, transcludeControllers, futureParentElement, scopeToChild);
                  } else if (isUndefined(slotTranscludeFn)) {
                    throw $compileMinErr('noslot', 'No parent directive that requires a transclusion with slot name "{0}". ' + 'Element: {1}', slotName, startingTag($element));
                  }
                } else {
                  return boundTranscludeFn(scope, cloneAttachFn, transcludeControllers, futureParentElement, scopeToChild);
                }
              }
            }
          }
          function getControllers(directiveName, require, $element, elementControllers) {
            var value;
            if (isString(require)) {
              var match = require.match(REQUIRE_PREFIX_REGEXP);
              var name = require.substring(match[0].length);
              var inheritType = match[1] || match[3];
              var optional = match[2] === '?';
              if (inheritType === '^^') {
                $element = $element.parent();
              } else {
                value = elementControllers && elementControllers[name];
                value = value && value.instance;
              }
              if (!value) {
                var dataName = '$' + name + 'Controller';
                value = inheritType ? $element.inheritedData(dataName) : $element.data(dataName);
              }
              if (!value && !optional) {
                throw $compileMinErr('ctreq', 'Controller \'{0}\', required by directive \'{1}\', can\'t be found!', name, directiveName);
              }
            } else if (isArray(require)) {
              value = [];
              for (var i = 0,
                  ii = require.length; i < ii; i++) {
                value[i] = getControllers(directiveName, require[i], $element, elementControllers);
              }
            } else if (isObject(require)) {
              value = {};
              forEach(require, function(controller, property) {
                value[property] = getControllers(directiveName, controller, $element, elementControllers);
              });
            }
            return value || null;
          }
          function setupControllers($element, attrs, transcludeFn, controllerDirectives, isolateScope, scope, newIsolateScopeDirective) {
            var elementControllers = createMap();
            for (var controllerKey in controllerDirectives) {
              var directive = controllerDirectives[controllerKey];
              var locals = {
                $scope: directive === newIsolateScopeDirective || directive.$$isolateScope ? isolateScope : scope,
                $element: $element,
                $attrs: attrs,
                $transclude: transcludeFn
              };
              var controller = directive.controller;
              if (controller === '@') {
                controller = attrs[directive.name];
              }
              var controllerInstance = $controller(controller, locals, true, directive.controllerAs);
              elementControllers[directive.name] = controllerInstance;
              $element.data('$' + directive.name + 'Controller', controllerInstance.instance);
            }
            return elementControllers;
          }
          function markDirectiveScope(directives, isolateScope, newScope) {
            for (var j = 0,
                jj = directives.length; j < jj; j++) {
              directives[j] = inherit(directives[j], {
                $$isolateScope: isolateScope,
                $$newScope: newScope
              });
            }
          }
          function addDirective(tDirectives, name, location, maxPriority, ignoreDirective, startAttrName, endAttrName) {
            if (name === ignoreDirective)
              return null;
            var match = null;
            if (hasDirectives.hasOwnProperty(name)) {
              for (var directive,
                  directives = $injector.get(name + Suffix),
                  i = 0,
                  ii = directives.length; i < ii; i++) {
                directive = directives[i];
                if ((isUndefined(maxPriority) || maxPriority > directive.priority) && directive.restrict.indexOf(location) !== -1) {
                  if (startAttrName) {
                    directive = inherit(directive, {
                      $$start: startAttrName,
                      $$end: endAttrName
                    });
                  }
                  if (!directive.$$bindings) {
                    var bindings = directive.$$bindings = parseDirectiveBindings(directive, directive.name);
                    if (isObject(bindings.isolateScope)) {
                      directive.$$isolateBindings = bindings.isolateScope;
                    }
                  }
                  tDirectives.push(directive);
                  match = directive;
                }
              }
            }
            return match;
          }
          function directiveIsMultiElement(name) {
            if (hasDirectives.hasOwnProperty(name)) {
              for (var directive,
                  directives = $injector.get(name + Suffix),
                  i = 0,
                  ii = directives.length; i < ii; i++) {
                directive = directives[i];
                if (directive.multiElement) {
                  return true;
                }
              }
            }
            return false;
          }
          function mergeTemplateAttributes(dst, src) {
            var srcAttr = src.$attr,
                dstAttr = dst.$attr;
            forEach(dst, function(value, key) {
              if (key.charAt(0) !== '$') {
                if (src[key] && src[key] !== value) {
                  if (value.length) {
                    value += (key === 'style' ? ';' : ' ') + src[key];
                  } else {
                    value = src[key];
                  }
                }
                dst.$set(key, value, true, srcAttr[key]);
              }
            });
            forEach(src, function(value, key) {
              if (!dst.hasOwnProperty(key) && key.charAt(0) !== '$') {
                dst[key] = value;
                if (key !== 'class' && key !== 'style') {
                  dstAttr[key] = srcAttr[key];
                }
              }
            });
          }
          function compileTemplateUrl(directives, $compileNode, tAttrs, $rootElement, childTranscludeFn, preLinkFns, postLinkFns, previousCompileContext) {
            var linkQueue = [],
                afterTemplateNodeLinkFn,
                afterTemplateChildLinkFn,
                beforeTemplateCompileNode = $compileNode[0],
                origAsyncDirective = directives.shift(),
                derivedSyncDirective = inherit(origAsyncDirective, {
                  templateUrl: null,
                  transclude: null,
                  replace: null,
                  $$originalDirective: origAsyncDirective
                }),
                templateUrl = (isFunction(origAsyncDirective.templateUrl)) ? origAsyncDirective.templateUrl($compileNode, tAttrs) : origAsyncDirective.templateUrl,
                templateNamespace = origAsyncDirective.templateNamespace;
            $compileNode.empty();
            $templateRequest(templateUrl).then(function(content) {
              var compileNode,
                  tempTemplateAttrs,
                  $template,
                  childBoundTranscludeFn;
              content = denormalizeTemplate(content);
              if (origAsyncDirective.replace) {
                if (jqLiteIsTextNode(content)) {
                  $template = [];
                } else {
                  $template = removeComments(wrapTemplate(templateNamespace, trim(content)));
                }
                compileNode = $template[0];
                if ($template.length !== 1 || compileNode.nodeType !== NODE_TYPE_ELEMENT) {
                  throw $compileMinErr('tplrt', 'Template for directive \'{0}\' must have exactly one root element. {1}', origAsyncDirective.name, templateUrl);
                }
                tempTemplateAttrs = {$attr: {}};
                replaceWith($rootElement, $compileNode, compileNode);
                var templateDirectives = collectDirectives(compileNode, [], tempTemplateAttrs);
                if (isObject(origAsyncDirective.scope)) {
                  markDirectiveScope(templateDirectives, true);
                }
                directives = templateDirectives.concat(directives);
                mergeTemplateAttributes(tAttrs, tempTemplateAttrs);
              } else {
                compileNode = beforeTemplateCompileNode;
                $compileNode.html(content);
              }
              directives.unshift(derivedSyncDirective);
              afterTemplateNodeLinkFn = applyDirectivesToNode(directives, compileNode, tAttrs, childTranscludeFn, $compileNode, origAsyncDirective, preLinkFns, postLinkFns, previousCompileContext);
              forEach($rootElement, function(node, i) {
                if (node === compileNode) {
                  $rootElement[i] = $compileNode[0];
                }
              });
              afterTemplateChildLinkFn = compileNodes($compileNode[0].childNodes, childTranscludeFn);
              while (linkQueue.length) {
                var scope = linkQueue.shift(),
                    beforeTemplateLinkNode = linkQueue.shift(),
                    linkRootElement = linkQueue.shift(),
                    boundTranscludeFn = linkQueue.shift(),
                    linkNode = $compileNode[0];
                if (scope.$$destroyed)
                  continue;
                if (beforeTemplateLinkNode !== beforeTemplateCompileNode) {
                  var oldClasses = beforeTemplateLinkNode.className;
                  if (!(previousCompileContext.hasElementTranscludeDirective && origAsyncDirective.replace)) {
                    linkNode = jqLiteClone(compileNode);
                  }
                  replaceWith(linkRootElement, jqLite(beforeTemplateLinkNode), linkNode);
                  safeAddClass(jqLite(linkNode), oldClasses);
                }
                if (afterTemplateNodeLinkFn.transcludeOnThisElement) {
                  childBoundTranscludeFn = createBoundTranscludeFn(scope, afterTemplateNodeLinkFn.transclude, boundTranscludeFn);
                } else {
                  childBoundTranscludeFn = boundTranscludeFn;
                }
                afterTemplateNodeLinkFn(afterTemplateChildLinkFn, scope, linkNode, $rootElement, childBoundTranscludeFn);
              }
              linkQueue = null;
            }).catch(function(error) {
              if (isError(error)) {
                $exceptionHandler(error);
              }
            });
            return function delayedNodeLinkFn(ignoreChildLinkFn, scope, node, rootElement, boundTranscludeFn) {
              var childBoundTranscludeFn = boundTranscludeFn;
              if (scope.$$destroyed)
                return;
              if (linkQueue) {
                linkQueue.push(scope, node, rootElement, childBoundTranscludeFn);
              } else {
                if (afterTemplateNodeLinkFn.transcludeOnThisElement) {
                  childBoundTranscludeFn = createBoundTranscludeFn(scope, afterTemplateNodeLinkFn.transclude, boundTranscludeFn);
                }
                afterTemplateNodeLinkFn(afterTemplateChildLinkFn, scope, node, rootElement, childBoundTranscludeFn);
              }
            };
          }
          function byPriority(a, b) {
            var diff = b.priority - a.priority;
            if (diff !== 0)
              return diff;
            if (a.name !== b.name)
              return (a.name < b.name) ? -1 : 1;
            return a.index - b.index;
          }
          function assertNoDuplicate(what, previousDirective, directive, element) {
            function wrapModuleNameIfDefined(moduleName) {
              return moduleName ? (' (module: ' + moduleName + ')') : '';
            }
            if (previousDirective) {
              throw $compileMinErr('multidir', 'Multiple directives [{0}{1}, {2}{3}] asking for {4} on: {5}', previousDirective.name, wrapModuleNameIfDefined(previousDirective.$$moduleName), directive.name, wrapModuleNameIfDefined(directive.$$moduleName), what, startingTag(element));
            }
          }
          function addTextInterpolateDirective(directives, text) {
            var interpolateFn = $interpolate(text, true);
            if (interpolateFn) {
              directives.push({
                priority: 0,
                compile: function textInterpolateCompileFn(templateNode) {
                  var templateNodeParent = templateNode.parent(),
                      hasCompileParent = !!templateNodeParent.length;
                  if (hasCompileParent)
                    compile.$$addBindingClass(templateNodeParent);
                  return function textInterpolateLinkFn(scope, node) {
                    var parent = node.parent();
                    if (!hasCompileParent)
                      compile.$$addBindingClass(parent);
                    compile.$$addBindingInfo(parent, interpolateFn.expressions);
                    scope.$watch(interpolateFn, function interpolateFnWatchAction(value) {
                      node[0].nodeValue = value;
                    });
                  };
                }
              });
            }
          }
          function wrapTemplate(type, template) {
            type = lowercase(type || 'html');
            switch (type) {
              case 'svg':
              case 'math':
                var wrapper = window.document.createElement('div');
                wrapper.innerHTML = '<' + type + '>' + template + '</' + type + '>';
                return wrapper.childNodes[0].childNodes;
              default:
                return template;
            }
          }
          function getTrustedContext(node, attrNormalizedName) {
            if (attrNormalizedName === 'srcdoc') {
              return $sce.HTML;
            }
            var tag = nodeName_(node);
            if (attrNormalizedName === 'src' || attrNormalizedName === 'ngSrc') {
              if (['img', 'video', 'audio', 'source', 'track'].indexOf(tag) === -1) {
                return $sce.RESOURCE_URL;
              }
            } else if (attrNormalizedName === 'xlinkHref' || (tag === 'form' && attrNormalizedName === 'action') || (tag === 'link' && attrNormalizedName === 'href')) {
              return $sce.RESOURCE_URL;
            }
          }
          function addAttrInterpolateDirective(node, directives, value, name, isNgAttr) {
            var trustedContext = getTrustedContext(node, name);
            var mustHaveExpression = !isNgAttr;
            var allOrNothing = ALL_OR_NOTHING_ATTRS[name] || isNgAttr;
            var interpolateFn = $interpolate(value, mustHaveExpression, trustedContext, allOrNothing);
            if (!interpolateFn)
              return;
            if (name === 'multiple' && nodeName_(node) === 'select') {
              throw $compileMinErr('selmulti', 'Binding to the \'multiple\' attribute is not supported. Element: {0}', startingTag(node));
            }
            if (EVENT_HANDLER_ATTR_REGEXP.test(name)) {
              throw $compileMinErr('nodomevents', 'Interpolations for HTML DOM event attributes are disallowed.  Please use the ' + 'ng- versions (such as ng-click instead of onclick) instead.');
            }
            directives.push({
              priority: 100,
              compile: function() {
                return {pre: function attrInterpolatePreLinkFn(scope, element, attr) {
                    var $$observers = (attr.$$observers || (attr.$$observers = createMap()));
                    var newValue = attr[name];
                    if (newValue !== value) {
                      interpolateFn = newValue && $interpolate(newValue, true, trustedContext, allOrNothing);
                      value = newValue;
                    }
                    if (!interpolateFn)
                      return;
                    attr[name] = interpolateFn(scope);
                    ($$observers[name] || ($$observers[name] = [])).$$inter = true;
                    (attr.$$observers && attr.$$observers[name].$$scope || scope).$watch(interpolateFn, function interpolateFnWatchAction(newValue, oldValue) {
                      if (name === 'class' && newValue !== oldValue) {
                        attr.$updateClass(newValue, oldValue);
                      } else {
                        attr.$set(name, newValue);
                      }
                    });
                  }};
              }
            });
          }
          function replaceWith($rootElement, elementsToRemove, newNode) {
            var firstElementToRemove = elementsToRemove[0],
                removeCount = elementsToRemove.length,
                parent = firstElementToRemove.parentNode,
                i,
                ii;
            if ($rootElement) {
              for (i = 0, ii = $rootElement.length; i < ii; i++) {
                if ($rootElement[i] === firstElementToRemove) {
                  $rootElement[i++] = newNode;
                  for (var j = i,
                      j2 = j + removeCount - 1,
                      jj = $rootElement.length; j < jj; j++, j2++) {
                    if (j2 < jj) {
                      $rootElement[j] = $rootElement[j2];
                    } else {
                      delete $rootElement[j];
                    }
                  }
                  $rootElement.length -= removeCount - 1;
                  if ($rootElement.context === firstElementToRemove) {
                    $rootElement.context = newNode;
                  }
                  break;
                }
              }
            }
            if (parent) {
              parent.replaceChild(newNode, firstElementToRemove);
            }
            var fragment = window.document.createDocumentFragment();
            for (i = 0; i < removeCount; i++) {
              fragment.appendChild(elementsToRemove[i]);
            }
            if (jqLite.hasData(firstElementToRemove)) {
              jqLite.data(newNode, jqLite.data(firstElementToRemove));
              jqLite(firstElementToRemove).off('$destroy');
            }
            jqLite.cleanData(fragment.querySelectorAll('*'));
            for (i = 1; i < removeCount; i++) {
              delete elementsToRemove[i];
            }
            elementsToRemove[0] = newNode;
            elementsToRemove.length = 1;
          }
          function cloneAndAnnotateFn(fn, annotation) {
            return extend(function() {
              return fn.apply(null, arguments);
            }, fn, annotation);
          }
          function invokeLinkFn(linkFn, scope, $element, attrs, controllers, transcludeFn) {
            try {
              linkFn(scope, $element, attrs, controllers, transcludeFn);
            } catch (e) {
              $exceptionHandler(e, startingTag($element));
            }
          }
          function strictBindingsCheck(attrName, directiveName) {
            if (strictComponentBindingsEnabled) {
              throw $compileMinErr('missingattr', 'Attribute \'{0}\' of \'{1}\' is non-optional and must be set!', attrName, directiveName);
            }
          }
          function initializeDirectiveBindings(scope, attrs, destination, bindings, directive) {
            var removeWatchCollection = [];
            var initialChanges = {};
            var changes;
            forEach(bindings, function initializeBinding(definition, scopeName) {
              var attrName = definition.attrName,
                  optional = definition.optional,
                  mode = definition.mode,
                  lastValue,
                  parentGet,
                  parentSet,
                  compare,
                  removeWatch;
              switch (mode) {
                case '@':
                  if (!optional && !hasOwnProperty.call(attrs, attrName)) {
                    strictBindingsCheck(attrName, directive.name);
                    destination[scopeName] = attrs[attrName] = undefined;
                  }
                  removeWatch = attrs.$observe(attrName, function(value) {
                    if (isString(value) || isBoolean(value)) {
                      var oldValue = destination[scopeName];
                      recordChanges(scopeName, value, oldValue);
                      destination[scopeName] = value;
                    }
                  });
                  attrs.$$observers[attrName].$$scope = scope;
                  lastValue = attrs[attrName];
                  if (isString(lastValue)) {
                    destination[scopeName] = $interpolate(lastValue)(scope);
                  } else if (isBoolean(lastValue)) {
                    destination[scopeName] = lastValue;
                  }
                  initialChanges[scopeName] = new SimpleChange(_UNINITIALIZED_VALUE, destination[scopeName]);
                  removeWatchCollection.push(removeWatch);
                  break;
                case '=':
                  if (!hasOwnProperty.call(attrs, attrName)) {
                    if (optional)
                      break;
                    strictBindingsCheck(attrName, directive.name);
                    attrs[attrName] = undefined;
                  }
                  if (optional && !attrs[attrName])
                    break;
                  parentGet = $parse(attrs[attrName]);
                  if (parentGet.literal) {
                    compare = equals;
                  } else {
                    compare = simpleCompare;
                  }
                  parentSet = parentGet.assign || function() {
                    lastValue = destination[scopeName] = parentGet(scope);
                    throw $compileMinErr('nonassign', 'Expression \'{0}\' in attribute \'{1}\' used with directive \'{2}\' is non-assignable!', attrs[attrName], attrName, directive.name);
                  };
                  lastValue = destination[scopeName] = parentGet(scope);
                  var parentValueWatch = function parentValueWatch(parentValue) {
                    if (!compare(parentValue, destination[scopeName])) {
                      if (!compare(parentValue, lastValue)) {
                        destination[scopeName] = parentValue;
                      } else {
                        parentSet(scope, parentValue = destination[scopeName]);
                      }
                    }
                    lastValue = parentValue;
                    return lastValue;
                  };
                  parentValueWatch.$stateful = true;
                  if (definition.collection) {
                    removeWatch = scope.$watchCollection(attrs[attrName], parentValueWatch);
                  } else {
                    removeWatch = scope.$watch($parse(attrs[attrName], parentValueWatch), null, parentGet.literal);
                  }
                  removeWatchCollection.push(removeWatch);
                  break;
                case '<':
                  if (!hasOwnProperty.call(attrs, attrName)) {
                    if (optional)
                      break;
                    strictBindingsCheck(attrName, directive.name);
                    attrs[attrName] = undefined;
                  }
                  if (optional && !attrs[attrName])
                    break;
                  parentGet = $parse(attrs[attrName]);
                  var deepWatch = parentGet.literal;
                  var initialValue = destination[scopeName] = parentGet(scope);
                  initialChanges[scopeName] = new SimpleChange(_UNINITIALIZED_VALUE, destination[scopeName]);
                  removeWatch = scope.$watch(parentGet, function parentValueWatchAction(newValue, oldValue) {
                    if (oldValue === newValue) {
                      if (oldValue === initialValue || (deepWatch && equals(oldValue, initialValue))) {
                        return;
                      }
                      oldValue = initialValue;
                    }
                    recordChanges(scopeName, newValue, oldValue);
                    destination[scopeName] = newValue;
                  }, deepWatch);
                  removeWatchCollection.push(removeWatch);
                  break;
                case '&':
                  if (!optional && !hasOwnProperty.call(attrs, attrName)) {
                    strictBindingsCheck(attrName, directive.name);
                  }
                  parentGet = attrs.hasOwnProperty(attrName) ? $parse(attrs[attrName]) : noop;
                  if (parentGet === noop && optional)
                    break;
                  destination[scopeName] = function(locals) {
                    return parentGet(scope, locals);
                  };
                  break;
              }
            });
            function recordChanges(key, currentValue, previousValue) {
              if (isFunction(destination.$onChanges) && !simpleCompare(currentValue, previousValue)) {
                if (!onChangesQueue) {
                  scope.$$postDigest(flushOnChangesQueue);
                  onChangesQueue = [];
                }
                if (!changes) {
                  changes = {};
                  onChangesQueue.push(triggerOnChangesHook);
                }
                if (changes[key]) {
                  previousValue = changes[key].previousValue;
                }
                changes[key] = new SimpleChange(previousValue, currentValue);
              }
            }
            function triggerOnChangesHook() {
              destination.$onChanges(changes);
              changes = undefined;
            }
            return {
              initialChanges: initialChanges,
              removeWatches: removeWatchCollection.length && function removeWatches() {
                for (var i = 0,
                    ii = removeWatchCollection.length; i < ii; ++i) {
                  removeWatchCollection[i]();
                }
              }
            };
          }
        }];
      }
      function SimpleChange(previous, current) {
        this.previousValue = previous;
        this.currentValue = current;
      }
      SimpleChange.prototype.isFirstChange = function() {
        return this.previousValue === _UNINITIALIZED_VALUE;
      };
      var PREFIX_REGEXP = /^((?:x|data)[:\-_])/i;
      var SPECIAL_CHARS_REGEXP = /[:\-_]+(.)/g;
      function directiveNormalize(name) {
        return name.replace(PREFIX_REGEXP, '').replace(SPECIAL_CHARS_REGEXP, function(_, letter, offset) {
          return offset ? letter.toUpperCase() : letter;
        });
      }
      function nodesetLinkingFn(scope, nodeList, rootElement, boundTranscludeFn) {}
      function directiveLinkingFn(nodesetLinkingFn, scope, node, rootElement, boundTranscludeFn) {}
      function tokenDifference(str1, str2) {
        var values = '',
            tokens1 = str1.split(/\s+/),
            tokens2 = str2.split(/\s+/);
        outer: for (var i = 0; i < tokens1.length; i++) {
          var token = tokens1[i];
          for (var j = 0; j < tokens2.length; j++) {
            if (token === tokens2[j])
              continue outer;
          }
          values += (values.length > 0 ? ' ' : '') + token;
        }
        return values;
      }
      function removeComments(jqNodes) {
        jqNodes = jqLite(jqNodes);
        var i = jqNodes.length;
        if (i <= 1) {
          return jqNodes;
        }
        while (i--) {
          var node = jqNodes[i];
          if (node.nodeType === NODE_TYPE_COMMENT || (node.nodeType === NODE_TYPE_TEXT && node.nodeValue.trim() === '')) {
            splice.call(jqNodes, i, 1);
          }
        }
        return jqNodes;
      }
      var $controllerMinErr = minErr('$controller');
      var CNTRL_REG = /^(\S+)(\s+as\s+([\w$]+))?$/;
      function identifierForController(controller, ident) {
        if (ident && isString(ident))
          return ident;
        if (isString(controller)) {
          var match = CNTRL_REG.exec(controller);
          if (match)
            return match[3];
        }
      }
      function $ControllerProvider() {
        var controllers = {},
            globals = false;
        this.has = function(name) {
          return controllers.hasOwnProperty(name);
        };
        this.register = function(name, constructor) {
          assertNotHasOwnProperty(name, 'controller');
          if (isObject(name)) {
            extend(controllers, name);
          } else {
            controllers[name] = constructor;
          }
        };
        this.allowGlobals = function() {
          globals = true;
        };
        this.$get = ['$injector', '$window', function($injector, $window) {
          return function $controller(expression, locals, later, ident) {
            var instance,
                match,
                constructor,
                identifier;
            later = later === true;
            if (ident && isString(ident)) {
              identifier = ident;
            }
            if (isString(expression)) {
              match = expression.match(CNTRL_REG);
              if (!match) {
                throw $controllerMinErr('ctrlfmt', 'Badly formed controller string \'{0}\'. ' + 'Must match `__name__ as __id__` or `__name__`.', expression);
              }
              constructor = match[1];
              identifier = identifier || match[3];
              expression = controllers.hasOwnProperty(constructor) ? controllers[constructor] : getter(locals.$scope, constructor, true) || (globals ? getter($window, constructor, true) : undefined);
              if (!expression) {
                throw $controllerMinErr('ctrlreg', 'The controller with the name \'{0}\' is not registered.', constructor);
              }
              assertArgFn(expression, constructor, true);
            }
            if (later) {
              var controllerPrototype = (isArray(expression) ? expression[expression.length - 1] : expression).prototype;
              instance = Object.create(controllerPrototype || null);
              if (identifier) {
                addIdentifier(locals, identifier, instance, constructor || expression.name);
              }
              return extend(function $controllerInit() {
                var result = $injector.invoke(expression, instance, locals, constructor);
                if (result !== instance && (isObject(result) || isFunction(result))) {
                  instance = result;
                  if (identifier) {
                    addIdentifier(locals, identifier, instance, constructor || expression.name);
                  }
                }
                return instance;
              }, {
                instance: instance,
                identifier: identifier
              });
            }
            instance = $injector.instantiate(expression, locals, constructor);
            if (identifier) {
              addIdentifier(locals, identifier, instance, constructor || expression.name);
            }
            return instance;
          };
          function addIdentifier(locals, identifier, instance, name) {
            if (!(locals && isObject(locals.$scope))) {
              throw minErr('$controller')('noscp', 'Cannot export controller \'{0}\' as \'{1}\'! No $scope object provided via `locals`.', name, identifier);
            }
            locals.$scope[identifier] = instance;
          }
        }];
      }
      function $DocumentProvider() {
        this.$get = ['$window', function(window) {
          return jqLite(window.document);
        }];
      }
      function $$IsDocumentHiddenProvider() {
        this.$get = ['$document', '$rootScope', function($document, $rootScope) {
          var doc = $document[0];
          var hidden = doc && doc.hidden;
          $document.on('visibilitychange', changeListener);
          $rootScope.$on('$destroy', function() {
            $document.off('visibilitychange', changeListener);
          });
          function changeListener() {
            hidden = doc.hidden;
          }
          return function() {
            return hidden;
          };
        }];
      }
      function $ExceptionHandlerProvider() {
        this.$get = ['$log', function($log) {
          return function(exception, cause) {
            $log.error.apply($log, arguments);
          };
        }];
      }
      var $$ForceReflowProvider = function() {
        this.$get = ['$document', function($document) {
          return function(domNode) {
            if (domNode) {
              if (!domNode.nodeType && domNode instanceof jqLite) {
                domNode = domNode[0];
              }
            } else {
              domNode = $document[0].body;
            }
            return domNode.offsetWidth + 1;
          };
        }];
      };
      var APPLICATION_JSON = 'application/json';
      var CONTENT_TYPE_APPLICATION_JSON = {'Content-Type': APPLICATION_JSON + ';charset=utf-8'};
      var JSON_START = /^\[|^\{(?!\{)/;
      var JSON_ENDS = {
        '[': /]$/,
        '{': /}$/
      };
      var JSON_PROTECTION_PREFIX = /^\)]\}',?\n/;
      var $httpMinErr = minErr('$http');
      function serializeValue(v) {
        if (isObject(v)) {
          return isDate(v) ? v.toISOString() : toJson(v);
        }
        return v;
      }
      function $HttpParamSerializerProvider() {
        this.$get = function() {
          return function ngParamSerializer(params) {
            if (!params)
              return '';
            var parts = [];
            forEachSorted(params, function(value, key) {
              if (value === null || isUndefined(value) || isFunction(value))
                return;
              if (isArray(value)) {
                forEach(value, function(v) {
                  parts.push(encodeUriQuery(key) + '=' + encodeUriQuery(serializeValue(v)));
                });
              } else {
                parts.push(encodeUriQuery(key) + '=' + encodeUriQuery(serializeValue(value)));
              }
            });
            return parts.join('&');
          };
        };
      }
      function $HttpParamSerializerJQLikeProvider() {
        this.$get = function() {
          return function jQueryLikeParamSerializer(params) {
            if (!params)
              return '';
            var parts = [];
            serialize(params, '', true);
            return parts.join('&');
            function serialize(toSerialize, prefix, topLevel) {
              if (toSerialize === null || isUndefined(toSerialize))
                return;
              if (isArray(toSerialize)) {
                forEach(toSerialize, function(value, index) {
                  serialize(value, prefix + '[' + (isObject(value) ? index : '') + ']');
                });
              } else if (isObject(toSerialize) && !isDate(toSerialize)) {
                forEachSorted(toSerialize, function(value, key) {
                  serialize(value, prefix + (topLevel ? '' : '[') + key + (topLevel ? '' : ']'));
                });
              } else {
                parts.push(encodeUriQuery(prefix) + '=' + encodeUriQuery(serializeValue(toSerialize)));
              }
            }
          };
        };
      }
      function defaultHttpResponseTransform(data, headers) {
        if (isString(data)) {
          var tempData = data.replace(JSON_PROTECTION_PREFIX, '').trim();
          if (tempData) {
            var contentType = headers('Content-Type');
            var hasJsonContentType = contentType && (contentType.indexOf(APPLICATION_JSON) === 0);
            if (hasJsonContentType || isJsonLike(tempData)) {
              try {
                data = fromJson(tempData);
              } catch (e) {
                if (!hasJsonContentType) {
                  return data;
                }
                throw $httpMinErr('baddata', 'Data must be a valid JSON object. Received: "{0}". ' + 'Parse error: "{1}"', data, e);
              }
            }
          }
        }
        return data;
      }
      function isJsonLike(str) {
        var jsonStart = str.match(JSON_START);
        return jsonStart && JSON_ENDS[jsonStart[0]].test(str);
      }
      function parseHeaders(headers) {
        var parsed = createMap(),
            i;
        function fillInParsed(key, val) {
          if (key) {
            parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
          }
        }
        if (isString(headers)) {
          forEach(headers.split('\n'), function(line) {
            i = line.indexOf(':');
            fillInParsed(lowercase(trim(line.substr(0, i))), trim(line.substr(i + 1)));
          });
        } else if (isObject(headers)) {
          forEach(headers, function(headerVal, headerKey) {
            fillInParsed(lowercase(headerKey), trim(headerVal));
          });
        }
        return parsed;
      }
      function headersGetter(headers) {
        var headersObj;
        return function(name) {
          if (!headersObj)
            headersObj = parseHeaders(headers);
          if (name) {
            var value = headersObj[lowercase(name)];
            if (value === undefined) {
              value = null;
            }
            return value;
          }
          return headersObj;
        };
      }
      function transformData(data, headers, status, fns) {
        if (isFunction(fns)) {
          return fns(data, headers, status);
        }
        forEach(fns, function(fn) {
          data = fn(data, headers, status);
        });
        return data;
      }
      function isSuccess(status) {
        return 200 <= status && status < 300;
      }
      function $HttpProvider() {
        var defaults = this.defaults = {
          transformResponse: [defaultHttpResponseTransform],
          transformRequest: [function(d) {
            return isObject(d) && !isFile(d) && !isBlob(d) && !isFormData(d) ? toJson(d) : d;
          }],
          headers: {
            common: {'Accept': 'application/json, text/plain, */*'},
            post: shallowCopy(CONTENT_TYPE_APPLICATION_JSON),
            put: shallowCopy(CONTENT_TYPE_APPLICATION_JSON),
            patch: shallowCopy(CONTENT_TYPE_APPLICATION_JSON)
          },
          xsrfCookieName: 'XSRF-TOKEN',
          xsrfHeaderName: 'X-XSRF-TOKEN',
          paramSerializer: '$httpParamSerializer',
          jsonpCallbackParam: 'callback'
        };
        var useApplyAsync = false;
        this.useApplyAsync = function(value) {
          if (isDefined(value)) {
            useApplyAsync = !!value;
            return this;
          }
          return useApplyAsync;
        };
        var interceptorFactories = this.interceptors = [];
        this.$get = ['$browser', '$httpBackend', '$$cookieReader', '$cacheFactory', '$rootScope', '$q', '$injector', '$sce', function($browser, $httpBackend, $$cookieReader, $cacheFactory, $rootScope, $q, $injector, $sce) {
          var defaultCache = $cacheFactory('$http');
          defaults.paramSerializer = isString(defaults.paramSerializer) ? $injector.get(defaults.paramSerializer) : defaults.paramSerializer;
          var reversedInterceptors = [];
          forEach(interceptorFactories, function(interceptorFactory) {
            reversedInterceptors.unshift(isString(interceptorFactory) ? $injector.get(interceptorFactory) : $injector.invoke(interceptorFactory));
          });
          function $http(requestConfig) {
            if (!isObject(requestConfig)) {
              throw minErr('$http')('badreq', 'Http request configuration must be an object.  Received: {0}', requestConfig);
            }
            if (!isString($sce.valueOf(requestConfig.url))) {
              throw minErr('$http')('badreq', 'Http request configuration url must be a string or a $sce trusted object.  Received: {0}', requestConfig.url);
            }
            var config = extend({
              method: 'get',
              transformRequest: defaults.transformRequest,
              transformResponse: defaults.transformResponse,
              paramSerializer: defaults.paramSerializer,
              jsonpCallbackParam: defaults.jsonpCallbackParam
            }, requestConfig);
            config.headers = mergeHeaders(requestConfig);
            config.method = uppercase(config.method);
            config.paramSerializer = isString(config.paramSerializer) ? $injector.get(config.paramSerializer) : config.paramSerializer;
            $browser.$$incOutstandingRequestCount();
            var requestInterceptors = [];
            var responseInterceptors = [];
            var promise = $q.resolve(config);
            forEach(reversedInterceptors, function(interceptor) {
              if (interceptor.request || interceptor.requestError) {
                requestInterceptors.unshift(interceptor.request, interceptor.requestError);
              }
              if (interceptor.response || interceptor.responseError) {
                responseInterceptors.push(interceptor.response, interceptor.responseError);
              }
            });
            promise = chainInterceptors(promise, requestInterceptors);
            promise = promise.then(serverRequest);
            promise = chainInterceptors(promise, responseInterceptors);
            promise = promise.finally(completeOutstandingRequest);
            return promise;
            function chainInterceptors(promise, interceptors) {
              for (var i = 0,
                  ii = interceptors.length; i < ii; ) {
                var thenFn = interceptors[i++];
                var rejectFn = interceptors[i++];
                promise = promise.then(thenFn, rejectFn);
              }
              interceptors.length = 0;
              return promise;
            }
            function completeOutstandingRequest() {
              $browser.$$completeOutstandingRequest(noop);
            }
            function executeHeaderFns(headers, config) {
              var headerContent,
                  processedHeaders = {};
              forEach(headers, function(headerFn, header) {
                if (isFunction(headerFn)) {
                  headerContent = headerFn(config);
                  if (headerContent != null) {
                    processedHeaders[header] = headerContent;
                  }
                } else {
                  processedHeaders[header] = headerFn;
                }
              });
              return processedHeaders;
            }
            function mergeHeaders(config) {
              var defHeaders = defaults.headers,
                  reqHeaders = extend({}, config.headers),
                  defHeaderName,
                  lowercaseDefHeaderName,
                  reqHeaderName;
              defHeaders = extend({}, defHeaders.common, defHeaders[lowercase(config.method)]);
              defaultHeadersIteration: for (defHeaderName in defHeaders) {
                lowercaseDefHeaderName = lowercase(defHeaderName);
                for (reqHeaderName in reqHeaders) {
                  if (lowercase(reqHeaderName) === lowercaseDefHeaderName) {
                    continue defaultHeadersIteration;
                  }
                }
                reqHeaders[defHeaderName] = defHeaders[defHeaderName];
              }
              return executeHeaderFns(reqHeaders, shallowCopy(config));
            }
            function serverRequest(config) {
              var headers = config.headers;
              var reqData = transformData(config.data, headersGetter(headers), undefined, config.transformRequest);
              if (isUndefined(reqData)) {
                forEach(headers, function(value, header) {
                  if (lowercase(header) === 'content-type') {
                    delete headers[header];
                  }
                });
              }
              if (isUndefined(config.withCredentials) && !isUndefined(defaults.withCredentials)) {
                config.withCredentials = defaults.withCredentials;
              }
              return sendReq(config, reqData).then(transformResponse, transformResponse);
            }
            function transformResponse(response) {
              var resp = extend({}, response);
              resp.data = transformData(response.data, response.headers, response.status, config.transformResponse);
              return (isSuccess(response.status)) ? resp : $q.reject(resp);
            }
          }
          $http.pendingRequests = [];
          createShortMethods('get', 'delete', 'head', 'jsonp');
          createShortMethodsWithData('post', 'put', 'patch');
          $http.defaults = defaults;
          return $http;
          function createShortMethods(names) {
            forEach(arguments, function(name) {
              $http[name] = function(url, config) {
                return $http(extend({}, config || {}, {
                  method: name,
                  url: url
                }));
              };
            });
          }
          function createShortMethodsWithData(name) {
            forEach(arguments, function(name) {
              $http[name] = function(url, data, config) {
                return $http(extend({}, config || {}, {
                  method: name,
                  url: url,
                  data: data
                }));
              };
            });
          }
          function sendReq(config, reqData) {
            var deferred = $q.defer(),
                promise = deferred.promise,
                cache,
                cachedResp,
                reqHeaders = config.headers,
                isJsonp = lowercase(config.method) === 'jsonp',
                url = config.url;
            if (isJsonp) {
              url = $sce.getTrustedResourceUrl(url);
            } else if (!isString(url)) {
              url = $sce.valueOf(url);
            }
            url = buildUrl(url, config.paramSerializer(config.params));
            if (isJsonp) {
              url = sanitizeJsonpCallbackParam(url, config.jsonpCallbackParam);
            }
            $http.pendingRequests.push(config);
            promise.then(removePendingReq, removePendingReq);
            if ((config.cache || defaults.cache) && config.cache !== false && (config.method === 'GET' || config.method === 'JSONP')) {
              cache = isObject(config.cache) ? config.cache : isObject((defaults).cache) ? (defaults).cache : defaultCache;
            }
            if (cache) {
              cachedResp = cache.get(url);
              if (isDefined(cachedResp)) {
                if (isPromiseLike(cachedResp)) {
                  cachedResp.then(resolvePromiseWithResult, resolvePromiseWithResult);
                } else {
                  if (isArray(cachedResp)) {
                    resolvePromise(cachedResp[1], cachedResp[0], shallowCopy(cachedResp[2]), cachedResp[3], cachedResp[4]);
                  } else {
                    resolvePromise(cachedResp, 200, {}, 'OK', 'complete');
                  }
                }
              } else {
                cache.put(url, promise);
              }
            }
            if (isUndefined(cachedResp)) {
              var xsrfValue = urlIsSameOrigin(config.url) ? $$cookieReader()[config.xsrfCookieName || defaults.xsrfCookieName] : undefined;
              if (xsrfValue) {
                reqHeaders[(config.xsrfHeaderName || defaults.xsrfHeaderName)] = xsrfValue;
              }
              $httpBackend(config.method, url, reqData, done, reqHeaders, config.timeout, config.withCredentials, config.responseType, createApplyHandlers(config.eventHandlers), createApplyHandlers(config.uploadEventHandlers));
            }
            return promise;
            function createApplyHandlers(eventHandlers) {
              if (eventHandlers) {
                var applyHandlers = {};
                forEach(eventHandlers, function(eventHandler, key) {
                  applyHandlers[key] = function(event) {
                    if (useApplyAsync) {
                      $rootScope.$applyAsync(callEventHandler);
                    } else if ($rootScope.$$phase) {
                      callEventHandler();
                    } else {
                      $rootScope.$apply(callEventHandler);
                    }
                    function callEventHandler() {
                      eventHandler(event);
                    }
                  };
                });
                return applyHandlers;
              }
            }
            function done(status, response, headersString, statusText, xhrStatus) {
              if (cache) {
                if (isSuccess(status)) {
                  cache.put(url, [status, response, parseHeaders(headersString), statusText, xhrStatus]);
                } else {
                  cache.remove(url);
                }
              }
              function resolveHttpPromise() {
                resolvePromise(response, status, headersString, statusText, xhrStatus);
              }
              if (useApplyAsync) {
                $rootScope.$applyAsync(resolveHttpPromise);
              } else {
                resolveHttpPromise();
                if (!$rootScope.$$phase)
                  $rootScope.$apply();
              }
            }
            function resolvePromise(response, status, headers, statusText, xhrStatus) {
              status = status >= -1 ? status : 0;
              (isSuccess(status) ? deferred.resolve : deferred.reject)({
                data: response,
                status: status,
                headers: headersGetter(headers),
                config: config,
                statusText: statusText,
                xhrStatus: xhrStatus
              });
            }
            function resolvePromiseWithResult(result) {
              resolvePromise(result.data, result.status, shallowCopy(result.headers()), result.statusText, result.xhrStatus);
            }
            function removePendingReq() {
              var idx = $http.pendingRequests.indexOf(config);
              if (idx !== -1)
                $http.pendingRequests.splice(idx, 1);
            }
          }
          function buildUrl(url, serializedParams) {
            if (serializedParams.length > 0) {
              url += ((url.indexOf('?') === -1) ? '?' : '&') + serializedParams;
            }
            return url;
          }
          function sanitizeJsonpCallbackParam(url, cbKey) {
            var parts = url.split('?');
            if (parts.length > 2) {
              throw $httpMinErr('badjsonp', 'Illegal use more than one "?", in url, "{1}"', url);
            }
            var params = parseKeyValue(parts[1]);
            forEach(params, function(value, key) {
              if (value === 'JSON_CALLBACK') {
                throw $httpMinErr('badjsonp', 'Illegal use of JSON_CALLBACK in url, "{0}"', url);
              }
              if (key === cbKey) {
                throw $httpMinErr('badjsonp', 'Illegal use of callback param, "{0}", in url, "{1}"', cbKey, url);
              }
            });
            url += ((url.indexOf('?') === -1) ? '?' : '&') + cbKey + '=JSON_CALLBACK';
            return url;
          }
        }];
      }
      function $xhrFactoryProvider() {
        this.$get = function() {
          return function createXhr() {
            return new window.XMLHttpRequest();
          };
        };
      }
      function $HttpBackendProvider() {
        this.$get = ['$browser', '$jsonpCallbacks', '$document', '$xhrFactory', function($browser, $jsonpCallbacks, $document, $xhrFactory) {
          return createHttpBackend($browser, $xhrFactory, $browser.defer, $jsonpCallbacks, $document[0]);
        }];
      }
      function createHttpBackend($browser, createXhr, $browserDefer, callbacks, rawDocument) {
        return function(method, url, post, callback, headers, timeout, withCredentials, responseType, eventHandlers, uploadEventHandlers) {
          url = url || $browser.url();
          if (lowercase(method) === 'jsonp') {
            var callbackPath = callbacks.createCallback(url);
            var jsonpDone = jsonpReq(url, callbackPath, function(status, text) {
              var response = (status === 200) && callbacks.getResponse(callbackPath);
              completeRequest(callback, status, response, '', text, 'complete');
              callbacks.removeCallback(callbackPath);
            });
          } else {
            var xhr = createXhr(method, url);
            xhr.open(method, url, true);
            forEach(headers, function(value, key) {
              if (isDefined(value)) {
                xhr.setRequestHeader(key, value);
              }
            });
            xhr.onload = function requestLoaded() {
              var statusText = xhr.statusText || '';
              var response = ('response' in xhr) ? xhr.response : xhr.responseText;
              var status = xhr.status === 1223 ? 204 : xhr.status;
              if (status === 0) {
                status = response ? 200 : urlResolve(url).protocol === 'file' ? 404 : 0;
              }
              completeRequest(callback, status, response, xhr.getAllResponseHeaders(), statusText, 'complete');
            };
            var requestError = function() {
              completeRequest(callback, -1, null, null, '', 'error');
            };
            var requestAborted = function() {
              completeRequest(callback, -1, null, null, '', 'abort');
            };
            var requestTimeout = function() {
              completeRequest(callback, -1, null, null, '', 'timeout');
            };
            xhr.onerror = requestError;
            xhr.onabort = requestAborted;
            xhr.ontimeout = requestTimeout;
            forEach(eventHandlers, function(value, key) {
              xhr.addEventListener(key, value);
            });
            forEach(uploadEventHandlers, function(value, key) {
              xhr.upload.addEventListener(key, value);
            });
            if (withCredentials) {
              xhr.withCredentials = true;
            }
            if (responseType) {
              try {
                xhr.responseType = responseType;
              } catch (e) {
                if (responseType !== 'json') {
                  throw e;
                }
              }
            }
            xhr.send(isUndefined(post) ? null : post);
          }
          if (timeout > 0) {
            var timeoutId = $browserDefer(timeoutRequest, timeout);
          } else if (isPromiseLike(timeout)) {
            timeout.then(timeoutRequest);
          }
          function timeoutRequest() {
            if (jsonpDone) {
              jsonpDone();
            }
            if (xhr) {
              xhr.abort();
            }
          }
          function completeRequest(callback, status, response, headersString, statusText, xhrStatus) {
            if (isDefined(timeoutId)) {
              $browserDefer.cancel(timeoutId);
            }
            jsonpDone = xhr = null;
            callback(status, response, headersString, statusText, xhrStatus);
          }
        };
        function jsonpReq(url, callbackPath, done) {
          url = url.replace('JSON_CALLBACK', callbackPath);
          var script = rawDocument.createElement('script'),
              callback = null;
          script.type = 'text/javascript';
          script.src = url;
          script.async = true;
          callback = function(event) {
            script.removeEventListener('load', callback);
            script.removeEventListener('error', callback);
            rawDocument.body.removeChild(script);
            script = null;
            var status = -1;
            var text = 'unknown';
            if (event) {
              if (event.type === 'load' && !callbacks.wasCalled(callbackPath)) {
                event = {type: 'error'};
              }
              text = event.type;
              status = event.type === 'error' ? 404 : 200;
            }
            if (done) {
              done(status, text);
            }
          };
          script.addEventListener('load', callback);
          script.addEventListener('error', callback);
          rawDocument.body.appendChild(script);
          return callback;
        }
      }
      var $interpolateMinErr = angular.$interpolateMinErr = minErr('$interpolate');
      $interpolateMinErr.throwNoconcat = function(text) {
        throw $interpolateMinErr('noconcat', 'Error while interpolating: {0}\nStrict Contextual Escaping disallows ' + 'interpolations that concatenate multiple expressions when a trusted value is ' + 'required.  See http://docs.angularjs.org/api/ng.$sce', text);
      };
      $interpolateMinErr.interr = function(text, err) {
        return $interpolateMinErr('interr', 'Can\'t interpolate: {0}\n{1}', text, err.toString());
      };
      function $InterpolateProvider() {
        var startSymbol = '{{';
        var endSymbol = '}}';
        this.startSymbol = function(value) {
          if (value) {
            startSymbol = value;
            return this;
          } else {
            return startSymbol;
          }
        };
        this.endSymbol = function(value) {
          if (value) {
            endSymbol = value;
            return this;
          } else {
            return endSymbol;
          }
        };
        this.$get = ['$parse', '$exceptionHandler', '$sce', function($parse, $exceptionHandler, $sce) {
          var startSymbolLength = startSymbol.length,
              endSymbolLength = endSymbol.length,
              escapedStartRegexp = new RegExp(startSymbol.replace(/./g, escape), 'g'),
              escapedEndRegexp = new RegExp(endSymbol.replace(/./g, escape), 'g');
          function escape(ch) {
            return '\\\\\\' + ch;
          }
          function unescapeText(text) {
            return text.replace(escapedStartRegexp, startSymbol).replace(escapedEndRegexp, endSymbol);
          }
          function constantWatchDelegate(scope, listener, objectEquality, constantInterp) {
            var unwatch = scope.$watch(function constantInterpolateWatch(scope) {
              unwatch();
              return constantInterp(scope);
            }, listener, objectEquality);
            return unwatch;
          }
          function $interpolate(text, mustHaveExpression, trustedContext, allOrNothing) {
            if (!text.length || text.indexOf(startSymbol) === -1) {
              var constantInterp;
              if (!mustHaveExpression) {
                var unescapedText = unescapeText(text);
                constantInterp = valueFn(unescapedText);
                constantInterp.exp = text;
                constantInterp.expressions = [];
                constantInterp.$$watchDelegate = constantWatchDelegate;
              }
              return constantInterp;
            }
            allOrNothing = !!allOrNothing;
            var startIndex,
                endIndex,
                index = 0,
                expressions = [],
                parseFns = [],
                textLength = text.length,
                exp,
                concat = [],
                expressionPositions = [];
            while (index < textLength) {
              if (((startIndex = text.indexOf(startSymbol, index)) !== -1) && ((endIndex = text.indexOf(endSymbol, startIndex + startSymbolLength)) !== -1)) {
                if (index !== startIndex) {
                  concat.push(unescapeText(text.substring(index, startIndex)));
                }
                exp = text.substring(startIndex + startSymbolLength, endIndex);
                expressions.push(exp);
                parseFns.push($parse(exp, parseStringifyInterceptor));
                index = endIndex + endSymbolLength;
                expressionPositions.push(concat.length);
                concat.push('');
              } else {
                if (index !== textLength) {
                  concat.push(unescapeText(text.substring(index)));
                }
                break;
              }
            }
            if (trustedContext && concat.length > 1) {
              $interpolateMinErr.throwNoconcat(text);
            }
            if (!mustHaveExpression || expressions.length) {
              var compute = function(values) {
                for (var i = 0,
                    ii = expressions.length; i < ii; i++) {
                  if (allOrNothing && isUndefined(values[i]))
                    return;
                  concat[expressionPositions[i]] = values[i];
                }
                return concat.join('');
              };
              var getValue = function(value) {
                return trustedContext ? $sce.getTrusted(trustedContext, value) : $sce.valueOf(value);
              };
              return extend(function interpolationFn(context) {
                var i = 0;
                var ii = expressions.length;
                var values = new Array(ii);
                try {
                  for (; i < ii; i++) {
                    values[i] = parseFns[i](context);
                  }
                  return compute(values);
                } catch (err) {
                  $exceptionHandler($interpolateMinErr.interr(text, err));
                }
              }, {
                exp: text,
                expressions: expressions,
                $$watchDelegate: function(scope, listener) {
                  var lastValue;
                  return scope.$watchGroup(parseFns, function interpolateFnWatcher(values, oldValues) {
                    var currValue = compute(values);
                    listener.call(this, currValue, values !== oldValues ? lastValue : currValue, scope);
                    lastValue = currValue;
                  });
                }
              });
            }
            function parseStringifyInterceptor(value) {
              try {
                value = getValue(value);
                return allOrNothing && !isDefined(value) ? value : stringify(value);
              } catch (err) {
                $exceptionHandler($interpolateMinErr.interr(text, err));
              }
            }
          }
          $interpolate.startSymbol = function() {
            return startSymbol;
          };
          $interpolate.endSymbol = function() {
            return endSymbol;
          };
          return $interpolate;
        }];
      }
      function $IntervalProvider() {
        this.$get = ['$rootScope', '$window', '$q', '$$q', '$browser', function($rootScope, $window, $q, $$q, $browser) {
          var intervals = {};
          function interval(fn, delay, count, invokeApply) {
            var hasParams = arguments.length > 4,
                args = hasParams ? sliceArgs(arguments, 4) : [],
                setInterval = $window.setInterval,
                clearInterval = $window.clearInterval,
                iteration = 0,
                skipApply = (isDefined(invokeApply) && !invokeApply),
                deferred = (skipApply ? $$q : $q).defer(),
                promise = deferred.promise;
            count = isDefined(count) ? count : 0;
            promise.$$intervalId = setInterval(function tick() {
              if (skipApply) {
                $browser.defer(callback);
              } else {
                $rootScope.$evalAsync(callback);
              }
              deferred.notify(iteration++);
              if (count > 0 && iteration >= count) {
                deferred.resolve(iteration);
                clearInterval(promise.$$intervalId);
                delete intervals[promise.$$intervalId];
              }
              if (!skipApply)
                $rootScope.$apply();
            }, delay);
            intervals[promise.$$intervalId] = deferred;
            return promise;
            function callback() {
              if (!hasParams) {
                fn(iteration);
              } else {
                fn.apply(null, args);
              }
            }
          }
          interval.cancel = function(promise) {
            if (promise && promise.$$intervalId in intervals) {
              markQExceptionHandled(intervals[promise.$$intervalId].promise);
              intervals[promise.$$intervalId].reject('canceled');
              $window.clearInterval(promise.$$intervalId);
              delete intervals[promise.$$intervalId];
              return true;
            }
            return false;
          };
          return interval;
        }];
      }
      var $jsonpCallbacksProvider = function() {
        this.$get = function() {
          var callbacks = angular.callbacks;
          var callbackMap = {};
          function createCallback(callbackId) {
            var callback = function(data) {
              callback.data = data;
              callback.called = true;
            };
            callback.id = callbackId;
            return callback;
          }
          return {
            createCallback: function(url) {
              var callbackId = '_' + (callbacks.$$counter++).toString(36);
              var callbackPath = 'angular.callbacks.' + callbackId;
              var callback = createCallback(callbackId);
              callbackMap[callbackPath] = callbacks[callbackId] = callback;
              return callbackPath;
            },
            wasCalled: function(callbackPath) {
              return callbackMap[callbackPath].called;
            },
            getResponse: function(callbackPath) {
              return callbackMap[callbackPath].data;
            },
            removeCallback: function(callbackPath) {
              var callback = callbackMap[callbackPath];
              delete callbacks[callback.id];
              delete callbackMap[callbackPath];
            }
          };
        };
      };
      var PATH_MATCH = /^([^?#]*)(\?([^#]*))?(#(.*))?$/,
          DEFAULT_PORTS = {
            'http': 80,
            'https': 443,
            'ftp': 21
          };
      var $locationMinErr = minErr('$location');
      function encodePath(path) {
        var segments = path.split('/'),
            i = segments.length;
        while (i--) {
          segments[i] = encodeUriSegment(segments[i].replace(/%2F/g, '/'));
        }
        return segments.join('/');
      }
      function decodePath(path, html5Mode) {
        var segments = path.split('/'),
            i = segments.length;
        while (i--) {
          segments[i] = decodeURIComponent(segments[i]);
          if (html5Mode) {
            segments[i] = segments[i].replace(/\//g, '%2F');
          }
        }
        return segments.join('/');
      }
      function parseAbsoluteUrl(absoluteUrl, locationObj) {
        var parsedUrl = urlResolve(absoluteUrl);
        locationObj.$$protocol = parsedUrl.protocol;
        locationObj.$$host = parsedUrl.hostname;
        locationObj.$$port = toInt(parsedUrl.port) || DEFAULT_PORTS[parsedUrl.protocol] || null;
      }
      var DOUBLE_SLASH_REGEX = /^\s*[\\/]{2,}/;
      function parseAppUrl(url, locationObj, html5Mode) {
        if (DOUBLE_SLASH_REGEX.test(url)) {
          throw $locationMinErr('badpath', 'Invalid url "{0}".', url);
        }
        var prefixed = (url.charAt(0) !== '/');
        if (prefixed) {
          url = '/' + url;
        }
        var match = urlResolve(url);
        var path = prefixed && match.pathname.charAt(0) === '/' ? match.pathname.substring(1) : match.pathname;
        locationObj.$$path = decodePath(path, html5Mode);
        locationObj.$$search = parseKeyValue(match.search);
        locationObj.$$hash = decodeURIComponent(match.hash);
        if (locationObj.$$path && locationObj.$$path.charAt(0) !== '/') {
          locationObj.$$path = '/' + locationObj.$$path;
        }
      }
      function startsWith(str, search) {
        return str.slice(0, search.length) === search;
      }
      function stripBaseUrl(base, url) {
        if (startsWith(url, base)) {
          return url.substr(base.length);
        }
      }
      function stripHash(url) {
        var index = url.indexOf('#');
        return index === -1 ? url : url.substr(0, index);
      }
      function trimEmptyHash(url) {
        return url.replace(/(#.+)|#$/, '$1');
      }
      function stripFile(url) {
        return url.substr(0, stripHash(url).lastIndexOf('/') + 1);
      }
      function serverBase(url) {
        return url.substring(0, url.indexOf('/', url.indexOf('//') + 2));
      }
      function LocationHtml5Url(appBase, appBaseNoFile, basePrefix) {
        this.$$html5 = true;
        basePrefix = basePrefix || '';
        parseAbsoluteUrl(appBase, this);
        this.$$parse = function(url) {
          var pathUrl = stripBaseUrl(appBaseNoFile, url);
          if (!isString(pathUrl)) {
            throw $locationMinErr('ipthprfx', 'Invalid url "{0}", missing path prefix "{1}".', url, appBaseNoFile);
          }
          parseAppUrl(pathUrl, this, true);
          if (!this.$$path) {
            this.$$path = '/';
          }
          this.$$compose();
        };
        this.$$compose = function() {
          var search = toKeyValue(this.$$search),
              hash = this.$$hash ? '#' + encodeUriSegment(this.$$hash) : '';
          this.$$url = encodePath(this.$$path) + (search ? '?' + search : '') + hash;
          this.$$absUrl = appBaseNoFile + this.$$url.substr(1);
          this.$$urlUpdatedByLocation = true;
        };
        this.$$parseLinkUrl = function(url, relHref) {
          if (relHref && relHref[0] === '#') {
            this.hash(relHref.slice(1));
            return true;
          }
          var appUrl,
              prevAppUrl;
          var rewrittenUrl;
          if (isDefined(appUrl = stripBaseUrl(appBase, url))) {
            prevAppUrl = appUrl;
            if (basePrefix && isDefined(appUrl = stripBaseUrl(basePrefix, appUrl))) {
              rewrittenUrl = appBaseNoFile + (stripBaseUrl('/', appUrl) || appUrl);
            } else {
              rewrittenUrl = appBase + prevAppUrl;
            }
          } else if (isDefined(appUrl = stripBaseUrl(appBaseNoFile, url))) {
            rewrittenUrl = appBaseNoFile + appUrl;
          } else if (appBaseNoFile === url + '/') {
            rewrittenUrl = appBaseNoFile;
          }
          if (rewrittenUrl) {
            this.$$parse(rewrittenUrl);
          }
          return !!rewrittenUrl;
        };
      }
      function LocationHashbangUrl(appBase, appBaseNoFile, hashPrefix) {
        parseAbsoluteUrl(appBase, this);
        this.$$parse = function(url) {
          var withoutBaseUrl = stripBaseUrl(appBase, url) || stripBaseUrl(appBaseNoFile, url);
          var withoutHashUrl;
          if (!isUndefined(withoutBaseUrl) && withoutBaseUrl.charAt(0) === '#') {
            withoutHashUrl = stripBaseUrl(hashPrefix, withoutBaseUrl);
            if (isUndefined(withoutHashUrl)) {
              withoutHashUrl = withoutBaseUrl;
            }
          } else {
            if (this.$$html5) {
              withoutHashUrl = withoutBaseUrl;
            } else {
              withoutHashUrl = '';
              if (isUndefined(withoutBaseUrl)) {
                appBase = url;
                (this).replace();
              }
            }
          }
          parseAppUrl(withoutHashUrl, this, false);
          this.$$path = removeWindowsDriveName(this.$$path, withoutHashUrl, appBase);
          this.$$compose();
          function removeWindowsDriveName(path, url, base) {
            var windowsFilePathExp = /^\/[A-Z]:(\/.*)/;
            var firstPathSegmentMatch;
            if (startsWith(url, base)) {
              url = url.replace(base, '');
            }
            if (windowsFilePathExp.exec(url)) {
              return path;
            }
            firstPathSegmentMatch = windowsFilePathExp.exec(path);
            return firstPathSegmentMatch ? firstPathSegmentMatch[1] : path;
          }
        };
        this.$$compose = function() {
          var search = toKeyValue(this.$$search),
              hash = this.$$hash ? '#' + encodeUriSegment(this.$$hash) : '';
          this.$$url = encodePath(this.$$path) + (search ? '?' + search : '') + hash;
          this.$$absUrl = appBase + (this.$$url ? hashPrefix + this.$$url : '');
          this.$$urlUpdatedByLocation = true;
        };
        this.$$parseLinkUrl = function(url, relHref) {
          if (stripHash(appBase) === stripHash(url)) {
            this.$$parse(url);
            return true;
          }
          return false;
        };
      }
      function LocationHashbangInHtml5Url(appBase, appBaseNoFile, hashPrefix) {
        this.$$html5 = true;
        LocationHashbangUrl.apply(this, arguments);
        this.$$parseLinkUrl = function(url, relHref) {
          if (relHref && relHref[0] === '#') {
            this.hash(relHref.slice(1));
            return true;
          }
          var rewrittenUrl;
          var appUrl;
          if (appBase === stripHash(url)) {
            rewrittenUrl = url;
          } else if ((appUrl = stripBaseUrl(appBaseNoFile, url))) {
            rewrittenUrl = appBase + hashPrefix + appUrl;
          } else if (appBaseNoFile === url + '/') {
            rewrittenUrl = appBaseNoFile;
          }
          if (rewrittenUrl) {
            this.$$parse(rewrittenUrl);
          }
          return !!rewrittenUrl;
        };
        this.$$compose = function() {
          var search = toKeyValue(this.$$search),
              hash = this.$$hash ? '#' + encodeUriSegment(this.$$hash) : '';
          this.$$url = encodePath(this.$$path) + (search ? '?' + search : '') + hash;
          this.$$absUrl = appBase + hashPrefix + this.$$url;
          this.$$urlUpdatedByLocation = true;
        };
      }
      var locationPrototype = {
        $$absUrl: '',
        $$html5: false,
        $$replace: false,
        absUrl: locationGetter('$$absUrl'),
        url: function(url) {
          if (isUndefined(url)) {
            return this.$$url;
          }
          var match = PATH_MATCH.exec(url);
          if (match[1] || url === '')
            this.path(decodeURIComponent(match[1]));
          if (match[2] || match[1] || url === '')
            this.search(match[3] || '');
          this.hash(match[5] || '');
          return this;
        },
        protocol: locationGetter('$$protocol'),
        host: locationGetter('$$host'),
        port: locationGetter('$$port'),
        path: locationGetterSetter('$$path', function(path) {
          path = path !== null ? path.toString() : '';
          return path.charAt(0) === '/' ? path : '/' + path;
        }),
        search: function(search, paramValue) {
          switch (arguments.length) {
            case 0:
              return this.$$search;
            case 1:
              if (isString(search) || isNumber(search)) {
                search = search.toString();
                this.$$search = parseKeyValue(search);
              } else if (isObject(search)) {
                search = copy(search, {});
                forEach(search, function(value, key) {
                  if (value == null)
                    delete search[key];
                });
                this.$$search = search;
              } else {
                throw $locationMinErr('isrcharg', 'The first argument of the `$location#search()` call must be a string or an object.');
              }
              break;
            default:
              if (isUndefined(paramValue) || paramValue === null) {
                delete this.$$search[search];
              } else {
                this.$$search[search] = paramValue;
              }
          }
          this.$$compose();
          return this;
        },
        hash: locationGetterSetter('$$hash', function(hash) {
          return hash !== null ? hash.toString() : '';
        }),
        replace: function() {
          this.$$replace = true;
          return this;
        }
      };
      forEach([LocationHashbangInHtml5Url, LocationHashbangUrl, LocationHtml5Url], function(Location) {
        Location.prototype = Object.create(locationPrototype);
        Location.prototype.state = function(state) {
          if (!arguments.length) {
            return this.$$state;
          }
          if (Location !== LocationHtml5Url || !this.$$html5) {
            throw $locationMinErr('nostate', 'History API state support is available only ' + 'in HTML5 mode and only in browsers supporting HTML5 History API');
          }
          this.$$state = isUndefined(state) ? null : state;
          this.$$urlUpdatedByLocation = true;
          return this;
        };
      });
      function locationGetter(property) {
        return function() {
          return this[property];
        };
      }
      function locationGetterSetter(property, preprocess) {
        return function(value) {
          if (isUndefined(value)) {
            return this[property];
          }
          this[property] = preprocess(value);
          this.$$compose();
          return this;
        };
      }
      function $LocationProvider() {
        var hashPrefix = '!',
            html5Mode = {
              enabled: false,
              requireBase: true,
              rewriteLinks: true
            };
        this.hashPrefix = function(prefix) {
          if (isDefined(prefix)) {
            hashPrefix = prefix;
            return this;
          } else {
            return hashPrefix;
          }
        };
        this.html5Mode = function(mode) {
          if (isBoolean(mode)) {
            html5Mode.enabled = mode;
            return this;
          } else if (isObject(mode)) {
            if (isBoolean(mode.enabled)) {
              html5Mode.enabled = mode.enabled;
            }
            if (isBoolean(mode.requireBase)) {
              html5Mode.requireBase = mode.requireBase;
            }
            if (isBoolean(mode.rewriteLinks) || isString(mode.rewriteLinks)) {
              html5Mode.rewriteLinks = mode.rewriteLinks;
            }
            return this;
          } else {
            return html5Mode;
          }
        };
        this.$get = ['$rootScope', '$browser', '$sniffer', '$rootElement', '$window', function($rootScope, $browser, $sniffer, $rootElement, $window) {
          var $location,
              LocationMode,
              baseHref = $browser.baseHref(),
              initialUrl = $browser.url(),
              appBase;
          if (html5Mode.enabled) {
            if (!baseHref && html5Mode.requireBase) {
              throw $locationMinErr('nobase', '$location in HTML5 mode requires a <base> tag to be present!');
            }
            appBase = serverBase(initialUrl) + (baseHref || '/');
            LocationMode = $sniffer.history ? LocationHtml5Url : LocationHashbangInHtml5Url;
          } else {
            appBase = stripHash(initialUrl);
            LocationMode = LocationHashbangUrl;
          }
          var appBaseNoFile = stripFile(appBase);
          $location = new LocationMode(appBase, appBaseNoFile, '#' + hashPrefix);
          $location.$$parseLinkUrl(initialUrl, initialUrl);
          $location.$$state = $browser.state();
          var IGNORE_URI_REGEXP = /^\s*(javascript|mailto):/i;
          function setBrowserUrlWithFallback(url, replace, state) {
            var oldUrl = $location.url();
            var oldState = $location.$$state;
            try {
              $browser.url(url, replace, state);
              $location.$$state = $browser.state();
            } catch (e) {
              $location.url(oldUrl);
              $location.$$state = oldState;
              throw e;
            }
          }
          $rootElement.on('click', function(event) {
            var rewriteLinks = html5Mode.rewriteLinks;
            if (!rewriteLinks || event.ctrlKey || event.metaKey || event.shiftKey || event.which === 2 || event.button === 2)
              return;
            var elm = jqLite(event.target);
            while (nodeName_(elm[0]) !== 'a') {
              if (elm[0] === $rootElement[0] || !(elm = elm.parent())[0])
                return;
            }
            if (isString(rewriteLinks) && isUndefined(elm.attr(rewriteLinks)))
              return;
            var absHref = elm.prop('href');
            var relHref = elm.attr('href') || elm.attr('xlink:href');
            if (isObject(absHref) && absHref.toString() === '[object SVGAnimatedString]') {
              absHref = urlResolve(absHref.animVal).href;
            }
            if (IGNORE_URI_REGEXP.test(absHref))
              return;
            if (absHref && !elm.attr('target') && !event.isDefaultPrevented()) {
              if ($location.$$parseLinkUrl(absHref, relHref)) {
                event.preventDefault();
                if ($location.absUrl() !== $browser.url()) {
                  $rootScope.$apply();
                  $window.angular['ff-684208-preventDefault'] = true;
                }
              }
            }
          });
          if (trimEmptyHash($location.absUrl()) !== trimEmptyHash(initialUrl)) {
            $browser.url($location.absUrl(), true);
          }
          var initializing = true;
          $browser.onUrlChange(function(newUrl, newState) {
            if (!startsWith(newUrl, appBaseNoFile)) {
              $window.location.href = newUrl;
              return;
            }
            $rootScope.$evalAsync(function() {
              var oldUrl = $location.absUrl();
              var oldState = $location.$$state;
              var defaultPrevented;
              newUrl = trimEmptyHash(newUrl);
              $location.$$parse(newUrl);
              $location.$$state = newState;
              defaultPrevented = $rootScope.$broadcast('$locationChangeStart', newUrl, oldUrl, newState, oldState).defaultPrevented;
              if ($location.absUrl() !== newUrl)
                return;
              if (defaultPrevented) {
                $location.$$parse(oldUrl);
                $location.$$state = oldState;
                setBrowserUrlWithFallback(oldUrl, false, oldState);
              } else {
                initializing = false;
                afterLocationChange(oldUrl, oldState);
              }
            });
            if (!$rootScope.$$phase)
              $rootScope.$digest();
          });
          $rootScope.$watch(function $locationWatch() {
            if (initializing || $location.$$urlUpdatedByLocation) {
              $location.$$urlUpdatedByLocation = false;
              var oldUrl = trimEmptyHash($browser.url());
              var newUrl = trimEmptyHash($location.absUrl());
              var oldState = $browser.state();
              var currentReplace = $location.$$replace;
              var urlOrStateChanged = oldUrl !== newUrl || ($location.$$html5 && $sniffer.history && oldState !== $location.$$state);
              if (initializing || urlOrStateChanged) {
                initializing = false;
                $rootScope.$evalAsync(function() {
                  var newUrl = $location.absUrl();
                  var defaultPrevented = $rootScope.$broadcast('$locationChangeStart', newUrl, oldUrl, $location.$$state, oldState).defaultPrevented;
                  if ($location.absUrl() !== newUrl)
                    return;
                  if (defaultPrevented) {
                    $location.$$parse(oldUrl);
                    $location.$$state = oldState;
                  } else {
                    if (urlOrStateChanged) {
                      setBrowserUrlWithFallback(newUrl, currentReplace, oldState === $location.$$state ? null : $location.$$state);
                    }
                    afterLocationChange(oldUrl, oldState);
                  }
                });
              }
            }
            $location.$$replace = false;
          });
          return $location;
          function afterLocationChange(oldUrl, oldState) {
            $rootScope.$broadcast('$locationChangeSuccess', $location.absUrl(), oldUrl, $location.$$state, oldState);
          }
        }];
      }
      function $LogProvider() {
        var debug = true,
            self = this;
        this.debugEnabled = function(flag) {
          if (isDefined(flag)) {
            debug = flag;
            return this;
          } else {
            return debug;
          }
        };
        this.$get = ['$window', function($window) {
          var formatStackTrace = msie || /\bEdge\//.test($window.navigator && $window.navigator.userAgent);
          return {
            log: consoleLog('log'),
            info: consoleLog('info'),
            warn: consoleLog('warn'),
            error: consoleLog('error'),
            debug: (function() {
              var fn = consoleLog('debug');
              return function() {
                if (debug) {
                  fn.apply(self, arguments);
                }
              };
            })()
          };
          function formatError(arg) {
            if (isError(arg)) {
              if (arg.stack && formatStackTrace) {
                arg = (arg.message && arg.stack.indexOf(arg.message) === -1) ? 'Error: ' + arg.message + '\n' + arg.stack : arg.stack;
              } else if (arg.sourceURL) {
                arg = arg.message + '\n' + arg.sourceURL + ':' + arg.line;
              }
            }
            return arg;
          }
          function consoleLog(type) {
            var console = $window.console || {},
                logFn = console[type] || console.log || noop;
            return function() {
              var args = [];
              forEach(arguments, function(arg) {
                args.push(formatError(arg));
              });
              return Function.prototype.apply.call(logFn, console, args);
            };
          }
        }];
      }
      var $parseMinErr = minErr('$parse');
      var objectValueOf = {}.constructor.prototype.valueOf;
      function getStringValue(name) {
        return name + '';
      }
      var OPERATORS = createMap();
      forEach('+ - * / % === !== == != < > <= >= && || ! = |'.split(' '), function(operator) {
        OPERATORS[operator] = true;
      });
      var ESCAPE = {
        'n': '\n',
        'f': '\f',
        'r': '\r',
        't': '\t',
        'v': '\v',
        '\'': '\'',
        '"': '"'
      };
      var Lexer = function Lexer(options) {
        this.options = options;
      };
      Lexer.prototype = {
        constructor: Lexer,
        lex: function(text) {
          this.text = text;
          this.index = 0;
          this.tokens = [];
          while (this.index < this.text.length) {
            var ch = this.text.charAt(this.index);
            if (ch === '"' || ch === '\'') {
              this.readString(ch);
            } else if (this.isNumber(ch) || ch === '.' && this.isNumber(this.peek())) {
              this.readNumber();
            } else if (this.isIdentifierStart(this.peekMultichar())) {
              this.readIdent();
            } else if (this.is(ch, '(){}[].,;:?')) {
              this.tokens.push({
                index: this.index,
                text: ch
              });
              this.index++;
            } else if (this.isWhitespace(ch)) {
              this.index++;
            } else {
              var ch2 = ch + this.peek();
              var ch3 = ch2 + this.peek(2);
              var op1 = OPERATORS[ch];
              var op2 = OPERATORS[ch2];
              var op3 = OPERATORS[ch3];
              if (op1 || op2 || op3) {
                var token = op3 ? ch3 : (op2 ? ch2 : ch);
                this.tokens.push({
                  index: this.index,
                  text: token,
                  operator: true
                });
                this.index += token.length;
              } else {
                this.throwError('Unexpected next character ', this.index, this.index + 1);
              }
            }
          }
          return this.tokens;
        },
        is: function(ch, chars) {
          return chars.indexOf(ch) !== -1;
        },
        peek: function(i) {
          var num = i || 1;
          return (this.index + num < this.text.length) ? this.text.charAt(this.index + num) : false;
        },
        isNumber: function(ch) {
          return ('0' <= ch && ch <= '9') && typeof ch === 'string';
        },
        isWhitespace: function(ch) {
          return (ch === ' ' || ch === '\r' || ch === '\t' || ch === '\n' || ch === '\v' || ch === '\u00A0');
        },
        isIdentifierStart: function(ch) {
          return this.options.isIdentifierStart ? this.options.isIdentifierStart(ch, this.codePointAt(ch)) : this.isValidIdentifierStart(ch);
        },
        isValidIdentifierStart: function(ch) {
          return ('a' <= ch && ch <= 'z' || 'A' <= ch && ch <= 'Z' || '_' === ch || ch === '$');
        },
        isIdentifierContinue: function(ch) {
          return this.options.isIdentifierContinue ? this.options.isIdentifierContinue(ch, this.codePointAt(ch)) : this.isValidIdentifierContinue(ch);
        },
        isValidIdentifierContinue: function(ch, cp) {
          return this.isValidIdentifierStart(ch, cp) || this.isNumber(ch);
        },
        codePointAt: function(ch) {
          if (ch.length === 1)
            return ch.charCodeAt(0);
          return (ch.charCodeAt(0) << 10) + ch.charCodeAt(1) - 0x35FDC00;
        },
        peekMultichar: function() {
          var ch = this.text.charAt(this.index);
          var peek = this.peek();
          if (!peek) {
            return ch;
          }
          var cp1 = ch.charCodeAt(0);
          var cp2 = peek.charCodeAt(0);
          if (cp1 >= 0xD800 && cp1 <= 0xDBFF && cp2 >= 0xDC00 && cp2 <= 0xDFFF) {
            return ch + peek;
          }
          return ch;
        },
        isExpOperator: function(ch) {
          return (ch === '-' || ch === '+' || this.isNumber(ch));
        },
        throwError: function(error, start, end) {
          end = end || this.index;
          var colStr = (isDefined(start) ? 's ' + start + '-' + this.index + ' [' + this.text.substring(start, end) + ']' : ' ' + end);
          throw $parseMinErr('lexerr', 'Lexer Error: {0} at column{1} in expression [{2}].', error, colStr, this.text);
        },
        readNumber: function() {
          var number = '';
          var start = this.index;
          while (this.index < this.text.length) {
            var ch = lowercase(this.text.charAt(this.index));
            if (ch === '.' || this.isNumber(ch)) {
              number += ch;
            } else {
              var peekCh = this.peek();
              if (ch === 'e' && this.isExpOperator(peekCh)) {
                number += ch;
              } else if (this.isExpOperator(ch) && peekCh && this.isNumber(peekCh) && number.charAt(number.length - 1) === 'e') {
                number += ch;
              } else if (this.isExpOperator(ch) && (!peekCh || !this.isNumber(peekCh)) && number.charAt(number.length - 1) === 'e') {
                this.throwError('Invalid exponent');
              } else {
                break;
              }
            }
            this.index++;
          }
          this.tokens.push({
            index: start,
            text: number,
            constant: true,
            value: Number(number)
          });
        },
        readIdent: function() {
          var start = this.index;
          this.index += this.peekMultichar().length;
          while (this.index < this.text.length) {
            var ch = this.peekMultichar();
            if (!this.isIdentifierContinue(ch)) {
              break;
            }
            this.index += ch.length;
          }
          this.tokens.push({
            index: start,
            text: this.text.slice(start, this.index),
            identifier: true
          });
        },
        readString: function(quote) {
          var start = this.index;
          this.index++;
          var string = '';
          var rawString = quote;
          var escape = false;
          while (this.index < this.text.length) {
            var ch = this.text.charAt(this.index);
            rawString += ch;
            if (escape) {
              if (ch === 'u') {
                var hex = this.text.substring(this.index + 1, this.index + 5);
                if (!hex.match(/[\da-f]{4}/i)) {
                  this.throwError('Invalid unicode escape [\\u' + hex + ']');
                }
                this.index += 4;
                string += String.fromCharCode(parseInt(hex, 16));
              } else {
                var rep = ESCAPE[ch];
                string = string + (rep || ch);
              }
              escape = false;
            } else if (ch === '\\') {
              escape = true;
            } else if (ch === quote) {
              this.index++;
              this.tokens.push({
                index: start,
                text: rawString,
                constant: true,
                value: string
              });
              return;
            } else {
              string += ch;
            }
            this.index++;
          }
          this.throwError('Unterminated quote', start);
        }
      };
      var AST = function AST(lexer, options) {
        this.lexer = lexer;
        this.options = options;
      };
      AST.Program = 'Program';
      AST.ExpressionStatement = 'ExpressionStatement';
      AST.AssignmentExpression = 'AssignmentExpression';
      AST.ConditionalExpression = 'ConditionalExpression';
      AST.LogicalExpression = 'LogicalExpression';
      AST.BinaryExpression = 'BinaryExpression';
      AST.UnaryExpression = 'UnaryExpression';
      AST.CallExpression = 'CallExpression';
      AST.MemberExpression = 'MemberExpression';
      AST.Identifier = 'Identifier';
      AST.Literal = 'Literal';
      AST.ArrayExpression = 'ArrayExpression';
      AST.Property = 'Property';
      AST.ObjectExpression = 'ObjectExpression';
      AST.ThisExpression = 'ThisExpression';
      AST.LocalsExpression = 'LocalsExpression';
      AST.NGValueParameter = 'NGValueParameter';
      AST.prototype = {
        ast: function(text) {
          this.text = text;
          this.tokens = this.lexer.lex(text);
          var value = this.program();
          if (this.tokens.length !== 0) {
            this.throwError('is an unexpected token', this.tokens[0]);
          }
          return value;
        },
        program: function() {
          var body = [];
          while (true) {
            if (this.tokens.length > 0 && !this.peek('}', ')', ';', ']'))
              body.push(this.expressionStatement());
            if (!this.expect(';')) {
              return {
                type: AST.Program,
                body: body
              };
            }
          }
        },
        expressionStatement: function() {
          return {
            type: AST.ExpressionStatement,
            expression: this.filterChain()
          };
        },
        filterChain: function() {
          var left = this.expression();
          while (this.expect('|')) {
            left = this.filter(left);
          }
          return left;
        },
        expression: function() {
          return this.assignment();
        },
        assignment: function() {
          var result = this.ternary();
          if (this.expect('=')) {
            if (!isAssignable(result)) {
              throw $parseMinErr('lval', 'Trying to assign a value to a non l-value');
            }
            result = {
              type: AST.AssignmentExpression,
              left: result,
              right: this.assignment(),
              operator: '='
            };
          }
          return result;
        },
        ternary: function() {
          var test = this.logicalOR();
          var alternate;
          var consequent;
          if (this.expect('?')) {
            alternate = this.expression();
            if (this.consume(':')) {
              consequent = this.expression();
              return {
                type: AST.ConditionalExpression,
                test: test,
                alternate: alternate,
                consequent: consequent
              };
            }
          }
          return test;
        },
        logicalOR: function() {
          var left = this.logicalAND();
          while (this.expect('||')) {
            left = {
              type: AST.LogicalExpression,
              operator: '||',
              left: left,
              right: this.logicalAND()
            };
          }
          return left;
        },
        logicalAND: function() {
          var left = this.equality();
          while (this.expect('&&')) {
            left = {
              type: AST.LogicalExpression,
              operator: '&&',
              left: left,
              right: this.equality()
            };
          }
          return left;
        },
        equality: function() {
          var left = this.relational();
          var token;
          while ((token = this.expect('==', '!=', '===', '!=='))) {
            left = {
              type: AST.BinaryExpression,
              operator: token.text,
              left: left,
              right: this.relational()
            };
          }
          return left;
        },
        relational: function() {
          var left = this.additive();
          var token;
          while ((token = this.expect('<', '>', '<=', '>='))) {
            left = {
              type: AST.BinaryExpression,
              operator: token.text,
              left: left,
              right: this.additive()
            };
          }
          return left;
        },
        additive: function() {
          var left = this.multiplicative();
          var token;
          while ((token = this.expect('+', '-'))) {
            left = {
              type: AST.BinaryExpression,
              operator: token.text,
              left: left,
              right: this.multiplicative()
            };
          }
          return left;
        },
        multiplicative: function() {
          var left = this.unary();
          var token;
          while ((token = this.expect('*', '/', '%'))) {
            left = {
              type: AST.BinaryExpression,
              operator: token.text,
              left: left,
              right: this.unary()
            };
          }
          return left;
        },
        unary: function() {
          var token;
          if ((token = this.expect('+', '-', '!'))) {
            return {
              type: AST.UnaryExpression,
              operator: token.text,
              prefix: true,
              argument: this.unary()
            };
          } else {
            return this.primary();
          }
        },
        primary: function() {
          var primary;
          if (this.expect('(')) {
            primary = this.filterChain();
            this.consume(')');
          } else if (this.expect('[')) {
            primary = this.arrayDeclaration();
          } else if (this.expect('{')) {
            primary = this.object();
          } else if (this.selfReferential.hasOwnProperty(this.peek().text)) {
            primary = copy(this.selfReferential[this.consume().text]);
          } else if (this.options.literals.hasOwnProperty(this.peek().text)) {
            primary = {
              type: AST.Literal,
              value: this.options.literals[this.consume().text]
            };
          } else if (this.peek().identifier) {
            primary = this.identifier();
          } else if (this.peek().constant) {
            primary = this.constant();
          } else {
            this.throwError('not a primary expression', this.peek());
          }
          var next;
          while ((next = this.expect('(', '[', '.'))) {
            if (next.text === '(') {
              primary = {
                type: AST.CallExpression,
                callee: primary,
                arguments: this.parseArguments()
              };
              this.consume(')');
            } else if (next.text === '[') {
              primary = {
                type: AST.MemberExpression,
                object: primary,
                property: this.expression(),
                computed: true
              };
              this.consume(']');
            } else if (next.text === '.') {
              primary = {
                type: AST.MemberExpression,
                object: primary,
                property: this.identifier(),
                computed: false
              };
            } else {
              this.throwError('IMPOSSIBLE');
            }
          }
          return primary;
        },
        filter: function(baseExpression) {
          var args = [baseExpression];
          var result = {
            type: AST.CallExpression,
            callee: this.identifier(),
            arguments: args,
            filter: true
          };
          while (this.expect(':')) {
            args.push(this.expression());
          }
          return result;
        },
        parseArguments: function() {
          var args = [];
          if (this.peekToken().text !== ')') {
            do {
              args.push(this.filterChain());
            } while (this.expect(','));
          }
          return args;
        },
        identifier: function() {
          var token = this.consume();
          if (!token.identifier) {
            this.throwError('is not a valid identifier', token);
          }
          return {
            type: AST.Identifier,
            name: token.text
          };
        },
        constant: function() {
          return {
            type: AST.Literal,
            value: this.consume().value
          };
        },
        arrayDeclaration: function() {
          var elements = [];
          if (this.peekToken().text !== ']') {
            do {
              if (this.peek(']')) {
                break;
              }
              elements.push(this.expression());
            } while (this.expect(','));
          }
          this.consume(']');
          return {
            type: AST.ArrayExpression,
            elements: elements
          };
        },
        object: function() {
          var properties = [],
              property;
          if (this.peekToken().text !== '}') {
            do {
              if (this.peek('}')) {
                break;
              }
              property = {
                type: AST.Property,
                kind: 'init'
              };
              if (this.peek().constant) {
                property.key = this.constant();
                property.computed = false;
                this.consume(':');
                property.value = this.expression();
              } else if (this.peek().identifier) {
                property.key = this.identifier();
                property.computed = false;
                if (this.peek(':')) {
                  this.consume(':');
                  property.value = this.expression();
                } else {
                  property.value = property.key;
                }
              } else if (this.peek('[')) {
                this.consume('[');
                property.key = this.expression();
                this.consume(']');
                property.computed = true;
                this.consume(':');
                property.value = this.expression();
              } else {
                this.throwError('invalid key', this.peek());
              }
              properties.push(property);
            } while (this.expect(','));
          }
          this.consume('}');
          return {
            type: AST.ObjectExpression,
            properties: properties
          };
        },
        throwError: function(msg, token) {
          throw $parseMinErr('syntax', 'Syntax Error: Token \'{0}\' {1} at column {2} of the expression [{3}] starting at [{4}].', token.text, msg, (token.index + 1), this.text, this.text.substring(token.index));
        },
        consume: function(e1) {
          if (this.tokens.length === 0) {
            throw $parseMinErr('ueoe', 'Unexpected end of expression: {0}', this.text);
          }
          var token = this.expect(e1);
          if (!token) {
            this.throwError('is unexpected, expecting [' + e1 + ']', this.peek());
          }
          return token;
        },
        peekToken: function() {
          if (this.tokens.length === 0) {
            throw $parseMinErr('ueoe', 'Unexpected end of expression: {0}', this.text);
          }
          return this.tokens[0];
        },
        peek: function(e1, e2, e3, e4) {
          return this.peekAhead(0, e1, e2, e3, e4);
        },
        peekAhead: function(i, e1, e2, e3, e4) {
          if (this.tokens.length > i) {
            var token = this.tokens[i];
            var t = token.text;
            if (t === e1 || t === e2 || t === e3 || t === e4 || (!e1 && !e2 && !e3 && !e4)) {
              return token;
            }
          }
          return false;
        },
        expect: function(e1, e2, e3, e4) {
          var token = this.peek(e1, e2, e3, e4);
          if (token) {
            this.tokens.shift();
            return token;
          }
          return false;
        },
        selfReferential: {
          'this': {type: AST.ThisExpression},
          '$locals': {type: AST.LocalsExpression}
        }
      };
      function ifDefined(v, d) {
        return typeof v !== 'undefined' ? v : d;
      }
      function plusFn(l, r) {
        if (typeof l === 'undefined')
          return r;
        if (typeof r === 'undefined')
          return l;
        return l + r;
      }
      function isStateless($filter, filterName) {
        var fn = $filter(filterName);
        return !fn.$stateful;
      }
      var PURITY_ABSOLUTE = 1;
      var PURITY_RELATIVE = 2;
      function isPure(node, parentIsPure) {
        switch (node.type) {
          case AST.MemberExpression:
            if (node.computed) {
              return false;
            }
            break;
          case AST.UnaryExpression:
            return PURITY_ABSOLUTE;
          case AST.BinaryExpression:
            return node.operator !== '+' ? PURITY_ABSOLUTE : false;
          case AST.CallExpression:
            return false;
        }
        return (undefined === parentIsPure) ? PURITY_RELATIVE : parentIsPure;
      }
      function findConstantAndWatchExpressions(ast, $filter, parentIsPure) {
        var allConstants;
        var argsToWatch;
        var isStatelessFilter;
        var astIsPure = ast.isPure = isPure(ast, parentIsPure);
        switch (ast.type) {
          case AST.Program:
            allConstants = true;
            forEach(ast.body, function(expr) {
              findConstantAndWatchExpressions(expr.expression, $filter, astIsPure);
              allConstants = allConstants && expr.expression.constant;
            });
            ast.constant = allConstants;
            break;
          case AST.Literal:
            ast.constant = true;
            ast.toWatch = [];
            break;
          case AST.UnaryExpression:
            findConstantAndWatchExpressions(ast.argument, $filter, astIsPure);
            ast.constant = ast.argument.constant;
            ast.toWatch = ast.argument.toWatch;
            break;
          case AST.BinaryExpression:
            findConstantAndWatchExpressions(ast.left, $filter, astIsPure);
            findConstantAndWatchExpressions(ast.right, $filter, astIsPure);
            ast.constant = ast.left.constant && ast.right.constant;
            ast.toWatch = ast.left.toWatch.concat(ast.right.toWatch);
            break;
          case AST.LogicalExpression:
            findConstantAndWatchExpressions(ast.left, $filter, astIsPure);
            findConstantAndWatchExpressions(ast.right, $filter, astIsPure);
            ast.constant = ast.left.constant && ast.right.constant;
            ast.toWatch = ast.constant ? [] : [ast];
            break;
          case AST.ConditionalExpression:
            findConstantAndWatchExpressions(ast.test, $filter, astIsPure);
            findConstantAndWatchExpressions(ast.alternate, $filter, astIsPure);
            findConstantAndWatchExpressions(ast.consequent, $filter, astIsPure);
            ast.constant = ast.test.constant && ast.alternate.constant && ast.consequent.constant;
            ast.toWatch = ast.constant ? [] : [ast];
            break;
          case AST.Identifier:
            ast.constant = false;
            ast.toWatch = [ast];
            break;
          case AST.MemberExpression:
            findConstantAndWatchExpressions(ast.object, $filter, astIsPure);
            if (ast.computed) {
              findConstantAndWatchExpressions(ast.property, $filter, astIsPure);
            }
            ast.constant = ast.object.constant && (!ast.computed || ast.property.constant);
            ast.toWatch = ast.constant ? [] : [ast];
            break;
          case AST.CallExpression:
            isStatelessFilter = ast.filter ? isStateless($filter, ast.callee.name) : false;
            allConstants = isStatelessFilter;
            argsToWatch = [];
            forEach(ast.arguments, function(expr) {
              findConstantAndWatchExpressions(expr, $filter, astIsPure);
              allConstants = allConstants && expr.constant;
              argsToWatch.push.apply(argsToWatch, expr.toWatch);
            });
            ast.constant = allConstants;
            ast.toWatch = isStatelessFilter ? argsToWatch : [ast];
            break;
          case AST.AssignmentExpression:
            findConstantAndWatchExpressions(ast.left, $filter, astIsPure);
            findConstantAndWatchExpressions(ast.right, $filter, astIsPure);
            ast.constant = ast.left.constant && ast.right.constant;
            ast.toWatch = [ast];
            break;
          case AST.ArrayExpression:
            allConstants = true;
            argsToWatch = [];
            forEach(ast.elements, function(expr) {
              findConstantAndWatchExpressions(expr, $filter, astIsPure);
              allConstants = allConstants && expr.constant;
              argsToWatch.push.apply(argsToWatch, expr.toWatch);
            });
            ast.constant = allConstants;
            ast.toWatch = argsToWatch;
            break;
          case AST.ObjectExpression:
            allConstants = true;
            argsToWatch = [];
            forEach(ast.properties, function(property) {
              findConstantAndWatchExpressions(property.value, $filter, astIsPure);
              allConstants = allConstants && property.value.constant;
              argsToWatch.push.apply(argsToWatch, property.value.toWatch);
              if (property.computed) {
                findConstantAndWatchExpressions(property.key, $filter, false);
                allConstants = allConstants && property.key.constant;
                argsToWatch.push.apply(argsToWatch, property.key.toWatch);
              }
            });
            ast.constant = allConstants;
            ast.toWatch = argsToWatch;
            break;
          case AST.ThisExpression:
            ast.constant = false;
            ast.toWatch = [];
            break;
          case AST.LocalsExpression:
            ast.constant = false;
            ast.toWatch = [];
            break;
        }
      }
      function getInputs(body) {
        if (body.length !== 1)
          return;
        var lastExpression = body[0].expression;
        var candidate = lastExpression.toWatch;
        if (candidate.length !== 1)
          return candidate;
        return candidate[0] !== lastExpression ? candidate : undefined;
      }
      function isAssignable(ast) {
        return ast.type === AST.Identifier || ast.type === AST.MemberExpression;
      }
      function assignableAST(ast) {
        if (ast.body.length === 1 && isAssignable(ast.body[0].expression)) {
          return {
            type: AST.AssignmentExpression,
            left: ast.body[0].expression,
            right: {type: AST.NGValueParameter},
            operator: '='
          };
        }
      }
      function isLiteral(ast) {
        return ast.body.length === 0 || ast.body.length === 1 && (ast.body[0].expression.type === AST.Literal || ast.body[0].expression.type === AST.ArrayExpression || ast.body[0].expression.type === AST.ObjectExpression);
      }
      function isConstant(ast) {
        return ast.constant;
      }
      function ASTCompiler($filter) {
        this.$filter = $filter;
      }
      ASTCompiler.prototype = {
        compile: function(ast) {
          var self = this;
          this.state = {
            nextId: 0,
            filters: {},
            fn: {
              vars: [],
              body: [],
              own: {}
            },
            assign: {
              vars: [],
              body: [],
              own: {}
            },
            inputs: []
          };
          findConstantAndWatchExpressions(ast, self.$filter);
          var extra = '';
          var assignable;
          this.stage = 'assign';
          if ((assignable = assignableAST(ast))) {
            this.state.computing = 'assign';
            var result = this.nextId();
            this.recurse(assignable, result);
            this.return_(result);
            extra = 'fn.assign=' + this.generateFunction('assign', 's,v,l');
          }
          var toWatch = getInputs(ast.body);
          self.stage = 'inputs';
          forEach(toWatch, function(watch, key) {
            var fnKey = 'fn' + key;
            self.state[fnKey] = {
              vars: [],
              body: [],
              own: {}
            };
            self.state.computing = fnKey;
            var intoId = self.nextId();
            self.recurse(watch, intoId);
            self.return_(intoId);
            self.state.inputs.push({
              name: fnKey,
              isPure: watch.isPure
            });
            watch.watchId = key;
          });
          this.state.computing = 'fn';
          this.stage = 'main';
          this.recurse(ast);
          var fnString = '"' + this.USE + ' ' + this.STRICT + '";\n' + this.filterPrefix() + 'var fn=' + this.generateFunction('fn', 's,l,a,i') + extra + this.watchFns() + 'return fn;';
          var fn = (new Function('$filter', 'getStringValue', 'ifDefined', 'plus', fnString))(this.$filter, getStringValue, ifDefined, plusFn);
          this.state = this.stage = undefined;
          return fn;
        },
        USE: 'use',
        STRICT: 'strict',
        watchFns: function() {
          var result = [];
          var inputs = this.state.inputs;
          var self = this;
          forEach(inputs, function(input) {
            result.push('var ' + input.name + '=' + self.generateFunction(input.name, 's'));
            if (input.isPure) {
              result.push(input.name, '.isPure=' + JSON.stringify(input.isPure) + ';');
            }
          });
          if (inputs.length) {
            result.push('fn.inputs=[' + inputs.map(function(i) {
              return i.name;
            }).join(',') + '];');
          }
          return result.join('');
        },
        generateFunction: function(name, params) {
          return 'function(' + params + '){' + this.varsPrefix(name) + this.body(name) + '};';
        },
        filterPrefix: function() {
          var parts = [];
          var self = this;
          forEach(this.state.filters, function(id, filter) {
            parts.push(id + '=$filter(' + self.escape(filter) + ')');
          });
          if (parts.length)
            return 'var ' + parts.join(',') + ';';
          return '';
        },
        varsPrefix: function(section) {
          return this.state[section].vars.length ? 'var ' + this.state[section].vars.join(',') + ';' : '';
        },
        body: function(section) {
          return this.state[section].body.join('');
        },
        recurse: function(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck) {
          var left,
              right,
              self = this,
              args,
              expression,
              computed;
          recursionFn = recursionFn || noop;
          if (!skipWatchIdCheck && isDefined(ast.watchId)) {
            intoId = intoId || this.nextId();
            this.if_('i', this.lazyAssign(intoId, this.computedMember('i', ast.watchId)), this.lazyRecurse(ast, intoId, nameId, recursionFn, create, true));
            return;
          }
          switch (ast.type) {
            case AST.Program:
              forEach(ast.body, function(expression, pos) {
                self.recurse(expression.expression, undefined, undefined, function(expr) {
                  right = expr;
                });
                if (pos !== ast.body.length - 1) {
                  self.current().body.push(right, ';');
                } else {
                  self.return_(right);
                }
              });
              break;
            case AST.Literal:
              expression = this.escape(ast.value);
              this.assign(intoId, expression);
              recursionFn(intoId || expression);
              break;
            case AST.UnaryExpression:
              this.recurse(ast.argument, undefined, undefined, function(expr) {
                right = expr;
              });
              expression = ast.operator + '(' + this.ifDefined(right, 0) + ')';
              this.assign(intoId, expression);
              recursionFn(expression);
              break;
            case AST.BinaryExpression:
              this.recurse(ast.left, undefined, undefined, function(expr) {
                left = expr;
              });
              this.recurse(ast.right, undefined, undefined, function(expr) {
                right = expr;
              });
              if (ast.operator === '+') {
                expression = this.plus(left, right);
              } else if (ast.operator === '-') {
                expression = this.ifDefined(left, 0) + ast.operator + this.ifDefined(right, 0);
              } else {
                expression = '(' + left + ')' + ast.operator + '(' + right + ')';
              }
              this.assign(intoId, expression);
              recursionFn(expression);
              break;
            case AST.LogicalExpression:
              intoId = intoId || this.nextId();
              self.recurse(ast.left, intoId);
              self.if_(ast.operator === '&&' ? intoId : self.not(intoId), self.lazyRecurse(ast.right, intoId));
              recursionFn(intoId);
              break;
            case AST.ConditionalExpression:
              intoId = intoId || this.nextId();
              self.recurse(ast.test, intoId);
              self.if_(intoId, self.lazyRecurse(ast.alternate, intoId), self.lazyRecurse(ast.consequent, intoId));
              recursionFn(intoId);
              break;
            case AST.Identifier:
              intoId = intoId || this.nextId();
              if (nameId) {
                nameId.context = self.stage === 'inputs' ? 's' : this.assign(this.nextId(), this.getHasOwnProperty('l', ast.name) + '?l:s');
                nameId.computed = false;
                nameId.name = ast.name;
              }
              self.if_(self.stage === 'inputs' || self.not(self.getHasOwnProperty('l', ast.name)), function() {
                self.if_(self.stage === 'inputs' || 's', function() {
                  if (create && create !== 1) {
                    self.if_(self.isNull(self.nonComputedMember('s', ast.name)), self.lazyAssign(self.nonComputedMember('s', ast.name), '{}'));
                  }
                  self.assign(intoId, self.nonComputedMember('s', ast.name));
                });
              }, intoId && self.lazyAssign(intoId, self.nonComputedMember('l', ast.name)));
              recursionFn(intoId);
              break;
            case AST.MemberExpression:
              left = nameId && (nameId.context = this.nextId()) || this.nextId();
              intoId = intoId || this.nextId();
              self.recurse(ast.object, left, undefined, function() {
                self.if_(self.notNull(left), function() {
                  if (ast.computed) {
                    right = self.nextId();
                    self.recurse(ast.property, right);
                    self.getStringValue(right);
                    if (create && create !== 1) {
                      self.if_(self.not(self.computedMember(left, right)), self.lazyAssign(self.computedMember(left, right), '{}'));
                    }
                    expression = self.computedMember(left, right);
                    self.assign(intoId, expression);
                    if (nameId) {
                      nameId.computed = true;
                      nameId.name = right;
                    }
                  } else {
                    if (create && create !== 1) {
                      self.if_(self.isNull(self.nonComputedMember(left, ast.property.name)), self.lazyAssign(self.nonComputedMember(left, ast.property.name), '{}'));
                    }
                    expression = self.nonComputedMember(left, ast.property.name);
                    self.assign(intoId, expression);
                    if (nameId) {
                      nameId.computed = false;
                      nameId.name = ast.property.name;
                    }
                  }
                }, function() {
                  self.assign(intoId, 'undefined');
                });
                recursionFn(intoId);
              }, !!create);
              break;
            case AST.CallExpression:
              intoId = intoId || this.nextId();
              if (ast.filter) {
                right = self.filter(ast.callee.name);
                args = [];
                forEach(ast.arguments, function(expr) {
                  var argument = self.nextId();
                  self.recurse(expr, argument);
                  args.push(argument);
                });
                expression = right + '(' + args.join(',') + ')';
                self.assign(intoId, expression);
                recursionFn(intoId);
              } else {
                right = self.nextId();
                left = {};
                args = [];
                self.recurse(ast.callee, right, left, function() {
                  self.if_(self.notNull(right), function() {
                    forEach(ast.arguments, function(expr) {
                      self.recurse(expr, ast.constant ? undefined : self.nextId(), undefined, function(argument) {
                        args.push(argument);
                      });
                    });
                    if (left.name) {
                      expression = self.member(left.context, left.name, left.computed) + '(' + args.join(',') + ')';
                    } else {
                      expression = right + '(' + args.join(',') + ')';
                    }
                    self.assign(intoId, expression);
                  }, function() {
                    self.assign(intoId, 'undefined');
                  });
                  recursionFn(intoId);
                });
              }
              break;
            case AST.AssignmentExpression:
              right = this.nextId();
              left = {};
              this.recurse(ast.left, undefined, left, function() {
                self.if_(self.notNull(left.context), function() {
                  self.recurse(ast.right, right);
                  expression = self.member(left.context, left.name, left.computed) + ast.operator + right;
                  self.assign(intoId, expression);
                  recursionFn(intoId || expression);
                });
              }, 1);
              break;
            case AST.ArrayExpression:
              args = [];
              forEach(ast.elements, function(expr) {
                self.recurse(expr, ast.constant ? undefined : self.nextId(), undefined, function(argument) {
                  args.push(argument);
                });
              });
              expression = '[' + args.join(',') + ']';
              this.assign(intoId, expression);
              recursionFn(intoId || expression);
              break;
            case AST.ObjectExpression:
              args = [];
              computed = false;
              forEach(ast.properties, function(property) {
                if (property.computed) {
                  computed = true;
                }
              });
              if (computed) {
                intoId = intoId || this.nextId();
                this.assign(intoId, '{}');
                forEach(ast.properties, function(property) {
                  if (property.computed) {
                    left = self.nextId();
                    self.recurse(property.key, left);
                  } else {
                    left = property.key.type === AST.Identifier ? property.key.name : ('' + property.key.value);
                  }
                  right = self.nextId();
                  self.recurse(property.value, right);
                  self.assign(self.member(intoId, left, property.computed), right);
                });
              } else {
                forEach(ast.properties, function(property) {
                  self.recurse(property.value, ast.constant ? undefined : self.nextId(), undefined, function(expr) {
                    args.push(self.escape(property.key.type === AST.Identifier ? property.key.name : ('' + property.key.value)) + ':' + expr);
                  });
                });
                expression = '{' + args.join(',') + '}';
                this.assign(intoId, expression);
              }
              recursionFn(intoId || expression);
              break;
            case AST.ThisExpression:
              this.assign(intoId, 's');
              recursionFn(intoId || 's');
              break;
            case AST.LocalsExpression:
              this.assign(intoId, 'l');
              recursionFn(intoId || 'l');
              break;
            case AST.NGValueParameter:
              this.assign(intoId, 'v');
              recursionFn(intoId || 'v');
              break;
          }
        },
        getHasOwnProperty: function(element, property) {
          var key = element + '.' + property;
          var own = this.current().own;
          if (!own.hasOwnProperty(key)) {
            own[key] = this.nextId(false, element + '&&(' + this.escape(property) + ' in ' + element + ')');
          }
          return own[key];
        },
        assign: function(id, value) {
          if (!id)
            return;
          this.current().body.push(id, '=', value, ';');
          return id;
        },
        filter: function(filterName) {
          if (!this.state.filters.hasOwnProperty(filterName)) {
            this.state.filters[filterName] = this.nextId(true);
          }
          return this.state.filters[filterName];
        },
        ifDefined: function(id, defaultValue) {
          return 'ifDefined(' + id + ',' + this.escape(defaultValue) + ')';
        },
        plus: function(left, right) {
          return 'plus(' + left + ',' + right + ')';
        },
        return_: function(id) {
          this.current().body.push('return ', id, ';');
        },
        if_: function(test, alternate, consequent) {
          if (test === true) {
            alternate();
          } else {
            var body = this.current().body;
            body.push('if(', test, '){');
            alternate();
            body.push('}');
            if (consequent) {
              body.push('else{');
              consequent();
              body.push('}');
            }
          }
        },
        not: function(expression) {
          return '!(' + expression + ')';
        },
        isNull: function(expression) {
          return expression + '==null';
        },
        notNull: function(expression) {
          return expression + '!=null';
        },
        nonComputedMember: function(left, right) {
          var SAFE_IDENTIFIER = /^[$_a-zA-Z][$_a-zA-Z0-9]*$/;
          var UNSAFE_CHARACTERS = /[^$_a-zA-Z0-9]/g;
          if (SAFE_IDENTIFIER.test(right)) {
            return left + '.' + right;
          } else {
            return left + '["' + right.replace(UNSAFE_CHARACTERS, this.stringEscapeFn) + '"]';
          }
        },
        computedMember: function(left, right) {
          return left + '[' + right + ']';
        },
        member: function(left, right, computed) {
          if (computed)
            return this.computedMember(left, right);
          return this.nonComputedMember(left, right);
        },
        getStringValue: function(item) {
          this.assign(item, 'getStringValue(' + item + ')');
        },
        lazyRecurse: function(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck) {
          var self = this;
          return function() {
            self.recurse(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck);
          };
        },
        lazyAssign: function(id, value) {
          var self = this;
          return function() {
            self.assign(id, value);
          };
        },
        stringEscapeRegex: /[^ a-zA-Z0-9]/g,
        stringEscapeFn: function(c) {
          return '\\u' + ('0000' + c.charCodeAt(0).toString(16)).slice(-4);
        },
        escape: function(value) {
          if (isString(value))
            return '\'' + value.replace(this.stringEscapeRegex, this.stringEscapeFn) + '\'';
          if (isNumber(value))
            return value.toString();
          if (value === true)
            return 'true';
          if (value === false)
            return 'false';
          if (value === null)
            return 'null';
          if (typeof value === 'undefined')
            return 'undefined';
          throw $parseMinErr('esc', 'IMPOSSIBLE');
        },
        nextId: function(skip, init) {
          var id = 'v' + (this.state.nextId++);
          if (!skip) {
            this.current().vars.push(id + (init ? '=' + init : ''));
          }
          return id;
        },
        current: function() {
          return this.state[this.state.computing];
        }
      };
      function ASTInterpreter($filter) {
        this.$filter = $filter;
      }
      ASTInterpreter.prototype = {
        compile: function(ast) {
          var self = this;
          findConstantAndWatchExpressions(ast, self.$filter);
          var assignable;
          var assign;
          if ((assignable = assignableAST(ast))) {
            assign = this.recurse(assignable);
          }
          var toWatch = getInputs(ast.body);
          var inputs;
          if (toWatch) {
            inputs = [];
            forEach(toWatch, function(watch, key) {
              var input = self.recurse(watch);
              input.isPure = watch.isPure;
              watch.input = input;
              inputs.push(input);
              watch.watchId = key;
            });
          }
          var expressions = [];
          forEach(ast.body, function(expression) {
            expressions.push(self.recurse(expression.expression));
          });
          var fn = ast.body.length === 0 ? noop : ast.body.length === 1 ? expressions[0] : function(scope, locals) {
            var lastValue;
            forEach(expressions, function(exp) {
              lastValue = exp(scope, locals);
            });
            return lastValue;
          };
          if (assign) {
            fn.assign = function(scope, value, locals) {
              return assign(scope, locals, value);
            };
          }
          if (inputs) {
            fn.inputs = inputs;
          }
          return fn;
        },
        recurse: function(ast, context, create) {
          var left,
              right,
              self = this,
              args;
          if (ast.input) {
            return this.inputs(ast.input, ast.watchId);
          }
          switch (ast.type) {
            case AST.Literal:
              return this.value(ast.value, context);
            case AST.UnaryExpression:
              right = this.recurse(ast.argument);
              return this['unary' + ast.operator](right, context);
            case AST.BinaryExpression:
              left = this.recurse(ast.left);
              right = this.recurse(ast.right);
              return this['binary' + ast.operator](left, right, context);
            case AST.LogicalExpression:
              left = this.recurse(ast.left);
              right = this.recurse(ast.right);
              return this['binary' + ast.operator](left, right, context);
            case AST.ConditionalExpression:
              return this['ternary?:'](this.recurse(ast.test), this.recurse(ast.alternate), this.recurse(ast.consequent), context);
            case AST.Identifier:
              return self.identifier(ast.name, context, create);
            case AST.MemberExpression:
              left = this.recurse(ast.object, false, !!create);
              if (!ast.computed) {
                right = ast.property.name;
              }
              if (ast.computed)
                right = this.recurse(ast.property);
              return ast.computed ? this.computedMember(left, right, context, create) : this.nonComputedMember(left, right, context, create);
            case AST.CallExpression:
              args = [];
              forEach(ast.arguments, function(expr) {
                args.push(self.recurse(expr));
              });
              if (ast.filter)
                right = this.$filter(ast.callee.name);
              if (!ast.filter)
                right = this.recurse(ast.callee, true);
              return ast.filter ? function(scope, locals, assign, inputs) {
                var values = [];
                for (var i = 0; i < args.length; ++i) {
                  values.push(args[i](scope, locals, assign, inputs));
                }
                var value = right.apply(undefined, values, inputs);
                return context ? {
                  context: undefined,
                  name: undefined,
                  value: value
                } : value;
              } : function(scope, locals, assign, inputs) {
                var rhs = right(scope, locals, assign, inputs);
                var value;
                if (rhs.value != null) {
                  var values = [];
                  for (var i = 0; i < args.length; ++i) {
                    values.push(args[i](scope, locals, assign, inputs));
                  }
                  value = rhs.value.apply(rhs.context, values);
                }
                return context ? {value: value} : value;
              };
            case AST.AssignmentExpression:
              left = this.recurse(ast.left, true, 1);
              right = this.recurse(ast.right);
              return function(scope, locals, assign, inputs) {
                var lhs = left(scope, locals, assign, inputs);
                var rhs = right(scope, locals, assign, inputs);
                lhs.context[lhs.name] = rhs;
                return context ? {value: rhs} : rhs;
              };
            case AST.ArrayExpression:
              args = [];
              forEach(ast.elements, function(expr) {
                args.push(self.recurse(expr));
              });
              return function(scope, locals, assign, inputs) {
                var value = [];
                for (var i = 0; i < args.length; ++i) {
                  value.push(args[i](scope, locals, assign, inputs));
                }
                return context ? {value: value} : value;
              };
            case AST.ObjectExpression:
              args = [];
              forEach(ast.properties, function(property) {
                if (property.computed) {
                  args.push({
                    key: self.recurse(property.key),
                    computed: true,
                    value: self.recurse(property.value)
                  });
                } else {
                  args.push({
                    key: property.key.type === AST.Identifier ? property.key.name : ('' + property.key.value),
                    computed: false,
                    value: self.recurse(property.value)
                  });
                }
              });
              return function(scope, locals, assign, inputs) {
                var value = {};
                for (var i = 0; i < args.length; ++i) {
                  if (args[i].computed) {
                    value[args[i].key(scope, locals, assign, inputs)] = args[i].value(scope, locals, assign, inputs);
                  } else {
                    value[args[i].key] = args[i].value(scope, locals, assign, inputs);
                  }
                }
                return context ? {value: value} : value;
              };
            case AST.ThisExpression:
              return function(scope) {
                return context ? {value: scope} : scope;
              };
            case AST.LocalsExpression:
              return function(scope, locals) {
                return context ? {value: locals} : locals;
              };
            case AST.NGValueParameter:
              return function(scope, locals, assign) {
                return context ? {value: assign} : assign;
              };
          }
        },
        'unary+': function(argument, context) {
          return function(scope, locals, assign, inputs) {
            var arg = argument(scope, locals, assign, inputs);
            if (isDefined(arg)) {
              arg = +arg;
            } else {
              arg = 0;
            }
            return context ? {value: arg} : arg;
          };
        },
        'unary-': function(argument, context) {
          return function(scope, locals, assign, inputs) {
            var arg = argument(scope, locals, assign, inputs);
            if (isDefined(arg)) {
              arg = -arg;
            } else {
              arg = -0;
            }
            return context ? {value: arg} : arg;
          };
        },
        'unary!': function(argument, context) {
          return function(scope, locals, assign, inputs) {
            var arg = !argument(scope, locals, assign, inputs);
            return context ? {value: arg} : arg;
          };
        },
        'binary+': function(left, right, context) {
          return function(scope, locals, assign, inputs) {
            var lhs = left(scope, locals, assign, inputs);
            var rhs = right(scope, locals, assign, inputs);
            var arg = plusFn(lhs, rhs);
            return context ? {value: arg} : arg;
          };
        },
        'binary-': function(left, right, context) {
          return function(scope, locals, assign, inputs) {
            var lhs = left(scope, locals, assign, inputs);
            var rhs = right(scope, locals, assign, inputs);
            var arg = (isDefined(lhs) ? lhs : 0) - (isDefined(rhs) ? rhs : 0);
            return context ? {value: arg} : arg;
          };
        },
        'binary*': function(left, right, context) {
          return function(scope, locals, assign, inputs) {
            var arg = left(scope, locals, assign, inputs) * right(scope, locals, assign, inputs);
            return context ? {value: arg} : arg;
          };
        },
        'binary/': function(left, right, context) {
          return function(scope, locals, assign, inputs) {
            var arg = left(scope, locals, assign, inputs) / right(scope, locals, assign, inputs);
            return context ? {value: arg} : arg;
          };
        },
        'binary%': function(left, right, context) {
          return function(scope, locals, assign, inputs) {
            var arg = left(scope, locals, assign, inputs) % right(scope, locals, assign, inputs);
            return context ? {value: arg} : arg;
          };
        },
        'binary===': function(left, right, context) {
          return function(scope, locals, assign, inputs) {
            var arg = left(scope, locals, assign, inputs) === right(scope, locals, assign, inputs);
            return context ? {value: arg} : arg;
          };
        },
        'binary!==': function(left, right, context) {
          return function(scope, locals, assign, inputs) {
            var arg = left(scope, locals, assign, inputs) !== right(scope, locals, assign, inputs);
            return context ? {value: arg} : arg;
          };
        },
        'binary==': function(left, right, context) {
          return function(scope, locals, assign, inputs) {
            var arg = left(scope, locals, assign, inputs) == right(scope, locals, assign, inputs);
            return context ? {value: arg} : arg;
          };
        },
        'binary!=': function(left, right, context) {
          return function(scope, locals, assign, inputs) {
            var arg = left(scope, locals, assign, inputs) != right(scope, locals, assign, inputs);
            return context ? {value: arg} : arg;
          };
        },
        'binary<': function(left, right, context) {
          return function(scope, locals, assign, inputs) {
            var arg = left(scope, locals, assign, inputs) < right(scope, locals, assign, inputs);
            return context ? {value: arg} : arg;
          };
        },
        'binary>': function(left, right, context) {
          return function(scope, locals, assign, inputs) {
            var arg = left(scope, locals, assign, inputs) > right(scope, locals, assign, inputs);
            return context ? {value: arg} : arg;
          };
        },
        'binary<=': function(left, right, context) {
          return function(scope, locals, assign, inputs) {
            var arg = left(scope, locals, assign, inputs) <= right(scope, locals, assign, inputs);
            return context ? {value: arg} : arg;
          };
        },
        'binary>=': function(left, right, context) {
          return function(scope, locals, assign, inputs) {
            var arg = left(scope, locals, assign, inputs) >= right(scope, locals, assign, inputs);
            return context ? {value: arg} : arg;
          };
        },
        'binary&&': function(left, right, context) {
          return function(scope, locals, assign, inputs) {
            var arg = left(scope, locals, assign, inputs) && right(scope, locals, assign, inputs);
            return context ? {value: arg} : arg;
          };
        },
        'binary||': function(left, right, context) {
          return function(scope, locals, assign, inputs) {
            var arg = left(scope, locals, assign, inputs) || right(scope, locals, assign, inputs);
            return context ? {value: arg} : arg;
          };
        },
        'ternary?:': function(test, alternate, consequent, context) {
          return function(scope, locals, assign, inputs) {
            var arg = test(scope, locals, assign, inputs) ? alternate(scope, locals, assign, inputs) : consequent(scope, locals, assign, inputs);
            return context ? {value: arg} : arg;
          };
        },
        value: function(value, context) {
          return function() {
            return context ? {
              context: undefined,
              name: undefined,
              value: value
            } : value;
          };
        },
        identifier: function(name, context, create) {
          return function(scope, locals, assign, inputs) {
            var base = locals && (name in locals) ? locals : scope;
            if (create && create !== 1 && base && base[name] == null) {
              base[name] = {};
            }
            var value = base ? base[name] : undefined;
            if (context) {
              return {
                context: base,
                name: name,
                value: value
              };
            } else {
              return value;
            }
          };
        },
        computedMember: function(left, right, context, create) {
          return function(scope, locals, assign, inputs) {
            var lhs = left(scope, locals, assign, inputs);
            var rhs;
            var value;
            if (lhs != null) {
              rhs = right(scope, locals, assign, inputs);
              rhs = getStringValue(rhs);
              if (create && create !== 1) {
                if (lhs && !(lhs[rhs])) {
                  lhs[rhs] = {};
                }
              }
              value = lhs[rhs];
            }
            if (context) {
              return {
                context: lhs,
                name: rhs,
                value: value
              };
            } else {
              return value;
            }
          };
        },
        nonComputedMember: function(left, right, context, create) {
          return function(scope, locals, assign, inputs) {
            var lhs = left(scope, locals, assign, inputs);
            if (create && create !== 1) {
              if (lhs && lhs[right] == null) {
                lhs[right] = {};
              }
            }
            var value = lhs != null ? lhs[right] : undefined;
            if (context) {
              return {
                context: lhs,
                name: right,
                value: value
              };
            } else {
              return value;
            }
          };
        },
        inputs: function(input, watchId) {
          return function(scope, value, locals, inputs) {
            if (inputs)
              return inputs[watchId];
            return input(scope, value, locals);
          };
        }
      };
      function Parser(lexer, $filter, options) {
        this.ast = new AST(lexer, options);
        this.astCompiler = options.csp ? new ASTInterpreter($filter) : new ASTCompiler($filter);
      }
      Parser.prototype = {
        constructor: Parser,
        parse: function(text) {
          var ast = this.getAst(text);
          var fn = this.astCompiler.compile(ast.ast);
          fn.literal = isLiteral(ast.ast);
          fn.constant = isConstant(ast.ast);
          fn.oneTime = ast.oneTime;
          return fn;
        },
        getAst: function(exp) {
          var oneTime = false;
          exp = exp.trim();
          if (exp.charAt(0) === ':' && exp.charAt(1) === ':') {
            oneTime = true;
            exp = exp.substring(2);
          }
          return {
            ast: this.ast.ast(exp),
            oneTime: oneTime
          };
        }
      };
      function getValueOf(value) {
        return isFunction(value.valueOf) ? value.valueOf() : objectValueOf.call(value);
      }
      function $ParseProvider() {
        var cache = createMap();
        var literals = {
          'true': true,
          'false': false,
          'null': null,
          'undefined': undefined
        };
        var identStart,
            identContinue;
        this.addLiteral = function(literalName, literalValue) {
          literals[literalName] = literalValue;
        };
        this.setIdentifierFns = function(identifierStart, identifierContinue) {
          identStart = identifierStart;
          identContinue = identifierContinue;
          return this;
        };
        this.$get = ['$filter', function($filter) {
          var noUnsafeEval = csp().noUnsafeEval;
          var $parseOptions = {
            csp: noUnsafeEval,
            literals: copy(literals),
            isIdentifierStart: isFunction(identStart) && identStart,
            isIdentifierContinue: isFunction(identContinue) && identContinue
          };
          $parse.$$getAst = $$getAst;
          return $parse;
          function $parse(exp, interceptorFn) {
            var parsedExpression,
                cacheKey;
            switch (typeof exp) {
              case 'string':
                exp = exp.trim();
                cacheKey = exp;
                parsedExpression = cache[cacheKey];
                if (!parsedExpression) {
                  var lexer = new Lexer($parseOptions);
                  var parser = new Parser(lexer, $filter, $parseOptions);
                  parsedExpression = parser.parse(exp);
                  if (parsedExpression.constant) {
                    parsedExpression.$$watchDelegate = constantWatchDelegate;
                  } else if (parsedExpression.oneTime) {
                    parsedExpression.$$watchDelegate = parsedExpression.literal ? oneTimeLiteralWatchDelegate : oneTimeWatchDelegate;
                  } else if (parsedExpression.inputs) {
                    parsedExpression.$$watchDelegate = inputsWatchDelegate;
                  }
                  cache[cacheKey] = parsedExpression;
                }
                return addInterceptor(parsedExpression, interceptorFn);
              case 'function':
                return addInterceptor(exp, interceptorFn);
              default:
                return addInterceptor(noop, interceptorFn);
            }
          }
          function $$getAst(exp) {
            var lexer = new Lexer($parseOptions);
            var parser = new Parser(lexer, $filter, $parseOptions);
            return parser.getAst(exp).ast;
          }
          function expressionInputDirtyCheck(newValue, oldValueOfValue, compareObjectIdentity) {
            if (newValue == null || oldValueOfValue == null) {
              return newValue === oldValueOfValue;
            }
            if (typeof newValue === 'object') {
              newValue = getValueOf(newValue);
              if (typeof newValue === 'object' && !compareObjectIdentity) {
                return false;
              }
            }
            return newValue === oldValueOfValue || (newValue !== newValue && oldValueOfValue !== oldValueOfValue);
          }
          function inputsWatchDelegate(scope, listener, objectEquality, parsedExpression, prettyPrintExpression) {
            var inputExpressions = parsedExpression.inputs;
            var lastResult;
            if (inputExpressions.length === 1) {
              var oldInputValueOf = expressionInputDirtyCheck;
              inputExpressions = inputExpressions[0];
              return scope.$watch(function expressionInputWatch(scope) {
                var newInputValue = inputExpressions(scope);
                if (!expressionInputDirtyCheck(newInputValue, oldInputValueOf, inputExpressions.isPure)) {
                  lastResult = parsedExpression(scope, undefined, undefined, [newInputValue]);
                  oldInputValueOf = newInputValue && getValueOf(newInputValue);
                }
                return lastResult;
              }, listener, objectEquality, prettyPrintExpression);
            }
            var oldInputValueOfValues = [];
            var oldInputValues = [];
            for (var i = 0,
                ii = inputExpressions.length; i < ii; i++) {
              oldInputValueOfValues[i] = expressionInputDirtyCheck;
              oldInputValues[i] = null;
            }
            return scope.$watch(function expressionInputsWatch(scope) {
              var changed = false;
              for (var i = 0,
                  ii = inputExpressions.length; i < ii; i++) {
                var newInputValue = inputExpressions[i](scope);
                if (changed || (changed = !expressionInputDirtyCheck(newInputValue, oldInputValueOfValues[i], inputExpressions[i].isPure))) {
                  oldInputValues[i] = newInputValue;
                  oldInputValueOfValues[i] = newInputValue && getValueOf(newInputValue);
                }
              }
              if (changed) {
                lastResult = parsedExpression(scope, undefined, undefined, oldInputValues);
              }
              return lastResult;
            }, listener, objectEquality, prettyPrintExpression);
          }
          function oneTimeWatchDelegate(scope, listener, objectEquality, parsedExpression, prettyPrintExpression) {
            var unwatch,
                lastValue;
            if (parsedExpression.inputs) {
              unwatch = inputsWatchDelegate(scope, oneTimeListener, objectEquality, parsedExpression, prettyPrintExpression);
            } else {
              unwatch = scope.$watch(oneTimeWatch, oneTimeListener, objectEquality);
            }
            return unwatch;
            function oneTimeWatch(scope) {
              return parsedExpression(scope);
            }
            function oneTimeListener(value, old, scope) {
              lastValue = value;
              if (isFunction(listener)) {
                listener(value, old, scope);
              }
              if (isDefined(value)) {
                scope.$$postDigest(function() {
                  if (isDefined(lastValue)) {
                    unwatch();
                  }
                });
              }
            }
          }
          function oneTimeLiteralWatchDelegate(scope, listener, objectEquality, parsedExpression) {
            var unwatch,
                lastValue;
            unwatch = scope.$watch(function oneTimeWatch(scope) {
              return parsedExpression(scope);
            }, function oneTimeListener(value, old, scope) {
              lastValue = value;
              if (isFunction(listener)) {
                listener(value, old, scope);
              }
              if (isAllDefined(value)) {
                scope.$$postDigest(function() {
                  if (isAllDefined(lastValue))
                    unwatch();
                });
              }
            }, objectEquality);
            return unwatch;
            function isAllDefined(value) {
              var allDefined = true;
              forEach(value, function(val) {
                if (!isDefined(val))
                  allDefined = false;
              });
              return allDefined;
            }
          }
          function constantWatchDelegate(scope, listener, objectEquality, parsedExpression) {
            var unwatch = scope.$watch(function constantWatch(scope) {
              unwatch();
              return parsedExpression(scope);
            }, listener, objectEquality);
            return unwatch;
          }
          function addInterceptor(parsedExpression, interceptorFn) {
            if (!interceptorFn)
              return parsedExpression;
            var watchDelegate = parsedExpression.$$watchDelegate;
            var useInputs = false;
            var regularWatch = watchDelegate !== oneTimeLiteralWatchDelegate && watchDelegate !== oneTimeWatchDelegate;
            var fn = regularWatch ? function regularInterceptedExpression(scope, locals, assign, inputs) {
              var value = useInputs && inputs ? inputs[0] : parsedExpression(scope, locals, assign, inputs);
              return interceptorFn(value, scope, locals);
            } : function oneTimeInterceptedExpression(scope, locals, assign, inputs) {
              var value = parsedExpression(scope, locals, assign, inputs);
              var result = interceptorFn(value, scope, locals);
              return isDefined(value) ? result : value;
            };
            useInputs = !parsedExpression.inputs;
            if (watchDelegate && watchDelegate !== inputsWatchDelegate) {
              fn.$$watchDelegate = watchDelegate;
              fn.inputs = parsedExpression.inputs;
            } else if (!interceptorFn.$stateful) {
              fn.$$watchDelegate = inputsWatchDelegate;
              fn.inputs = parsedExpression.inputs ? parsedExpression.inputs : [parsedExpression];
            }
            if (fn.inputs) {
              fn.inputs = fn.inputs.map(function(e) {
                if (e.isPure === PURITY_RELATIVE) {
                  return function depurifier(s) {
                    return e(s);
                  };
                }
                return e;
              });
            }
            return fn;
          }
        }];
      }
      function $QProvider() {
        var errorOnUnhandledRejections = true;
        this.$get = ['$rootScope', '$exceptionHandler', function($rootScope, $exceptionHandler) {
          return qFactory(function(callback) {
            $rootScope.$evalAsync(callback);
          }, $exceptionHandler, errorOnUnhandledRejections);
        }];
        this.errorOnUnhandledRejections = function(value) {
          if (isDefined(value)) {
            errorOnUnhandledRejections = value;
            return this;
          } else {
            return errorOnUnhandledRejections;
          }
        };
      }
      function $$QProvider() {
        var errorOnUnhandledRejections = true;
        this.$get = ['$browser', '$exceptionHandler', function($browser, $exceptionHandler) {
          return qFactory(function(callback) {
            $browser.defer(callback);
          }, $exceptionHandler, errorOnUnhandledRejections);
        }];
        this.errorOnUnhandledRejections = function(value) {
          if (isDefined(value)) {
            errorOnUnhandledRejections = value;
            return this;
          } else {
            return errorOnUnhandledRejections;
          }
        };
      }
      function qFactory(nextTick, exceptionHandler, errorOnUnhandledRejections) {
        var $qMinErr = minErr('$q', TypeError);
        var queueSize = 0;
        var checkQueue = [];
        function defer() {
          return new Deferred();
        }
        function Deferred() {
          var promise = this.promise = new Promise();
          this.resolve = function(val) {
            resolvePromise(promise, val);
          };
          this.reject = function(reason) {
            rejectPromise(promise, reason);
          };
          this.notify = function(progress) {
            notifyPromise(promise, progress);
          };
        }
        function Promise() {
          this.$$state = {status: 0};
        }
        extend(Promise.prototype, {
          then: function(onFulfilled, onRejected, progressBack) {
            if (isUndefined(onFulfilled) && isUndefined(onRejected) && isUndefined(progressBack)) {
              return this;
            }
            var result = new Promise();
            this.$$state.pending = this.$$state.pending || [];
            this.$$state.pending.push([result, onFulfilled, onRejected, progressBack]);
            if (this.$$state.status > 0)
              scheduleProcessQueue(this.$$state);
            return result;
          },
          'catch': function(callback) {
            return this.then(null, callback);
          },
          'finally': function(callback, progressBack) {
            return this.then(function(value) {
              return handleCallback(value, resolve, callback);
            }, function(error) {
              return handleCallback(error, reject, callback);
            }, progressBack);
          }
        });
        function processQueue(state) {
          var fn,
              promise,
              pending;
          pending = state.pending;
          state.processScheduled = false;
          state.pending = undefined;
          try {
            for (var i = 0,
                ii = pending.length; i < ii; ++i) {
              markQStateExceptionHandled(state);
              promise = pending[i][0];
              fn = pending[i][state.status];
              try {
                if (isFunction(fn)) {
                  resolvePromise(promise, fn(state.value));
                } else if (state.status === 1) {
                  resolvePromise(promise, state.value);
                } else {
                  rejectPromise(promise, state.value);
                }
              } catch (e) {
                rejectPromise(promise, e);
                if (e && e.$$passToExceptionHandler === true) {
                  exceptionHandler(e);
                }
              }
            }
          } finally {
            --queueSize;
            if (errorOnUnhandledRejections && queueSize === 0) {
              nextTick(processChecks);
            }
          }
        }
        function processChecks() {
          while (!queueSize && checkQueue.length) {
            var toCheck = checkQueue.shift();
            if (!isStateExceptionHandled(toCheck)) {
              markQStateExceptionHandled(toCheck);
              var errorMessage = 'Possibly unhandled rejection: ' + toDebugString(toCheck.value);
              if (isError(toCheck.value)) {
                exceptionHandler(toCheck.value, errorMessage);
              } else {
                exceptionHandler(errorMessage);
              }
            }
          }
        }
        function scheduleProcessQueue(state) {
          if (errorOnUnhandledRejections && !state.pending && state.status === 2 && !isStateExceptionHandled(state)) {
            if (queueSize === 0 && checkQueue.length === 0) {
              nextTick(processChecks);
            }
            checkQueue.push(state);
          }
          if (state.processScheduled || !state.pending)
            return;
          state.processScheduled = true;
          ++queueSize;
          nextTick(function() {
            processQueue(state);
          });
        }
        function resolvePromise(promise, val) {
          if (promise.$$state.status)
            return;
          if (val === promise) {
            $$reject(promise, $qMinErr('qcycle', 'Expected promise to be resolved with value other than itself \'{0}\'', val));
          } else {
            $$resolve(promise, val);
          }
        }
        function $$resolve(promise, val) {
          var then;
          var done = false;
          try {
            if (isObject(val) || isFunction(val))
              then = val.then;
            if (isFunction(then)) {
              promise.$$state.status = -1;
              then.call(val, doResolve, doReject, doNotify);
            } else {
              promise.$$state.value = val;
              promise.$$state.status = 1;
              scheduleProcessQueue(promise.$$state);
            }
          } catch (e) {
            doReject(e);
          }
          function doResolve(val) {
            if (done)
              return;
            done = true;
            $$resolve(promise, val);
          }
          function doReject(val) {
            if (done)
              return;
            done = true;
            $$reject(promise, val);
          }
          function doNotify(progress) {
            notifyPromise(promise, progress);
          }
        }
        function rejectPromise(promise, reason) {
          if (promise.$$state.status)
            return;
          $$reject(promise, reason);
        }
        function $$reject(promise, reason) {
          promise.$$state.value = reason;
          promise.$$state.status = 2;
          scheduleProcessQueue(promise.$$state);
        }
        function notifyPromise(promise, progress) {
          var callbacks = promise.$$state.pending;
          if ((promise.$$state.status <= 0) && callbacks && callbacks.length) {
            nextTick(function() {
              var callback,
                  result;
              for (var i = 0,
                  ii = callbacks.length; i < ii; i++) {
                result = callbacks[i][0];
                callback = callbacks[i][3];
                try {
                  notifyPromise(result, isFunction(callback) ? callback(progress) : progress);
                } catch (e) {
                  exceptionHandler(e);
                }
              }
            });
          }
        }
        function reject(reason) {
          var result = new Promise();
          rejectPromise(result, reason);
          return result;
        }
        function handleCallback(value, resolver, callback) {
          var callbackOutput = null;
          try {
            if (isFunction(callback))
              callbackOutput = callback();
          } catch (e) {
            return reject(e);
          }
          if (isPromiseLike(callbackOutput)) {
            return callbackOutput.then(function() {
              return resolver(value);
            }, reject);
          } else {
            return resolver(value);
          }
        }
        function when(value, callback, errback, progressBack) {
          var result = new Promise();
          resolvePromise(result, value);
          return result.then(callback, errback, progressBack);
        }
        var resolve = when;
        function all(promises) {
          var result = new Promise(),
              counter = 0,
              results = isArray(promises) ? [] : {};
          forEach(promises, function(promise, key) {
            counter++;
            when(promise).then(function(value) {
              results[key] = value;
              if (!(--counter))
                resolvePromise(result, results);
            }, function(reason) {
              rejectPromise(result, reason);
            });
          });
          if (counter === 0) {
            resolvePromise(result, results);
          }
          return result;
        }
        function race(promises) {
          var deferred = defer();
          forEach(promises, function(promise) {
            when(promise).then(deferred.resolve, deferred.reject);
          });
          return deferred.promise;
        }
        function $Q(resolver) {
          if (!isFunction(resolver)) {
            throw $qMinErr('norslvr', 'Expected resolverFn, got \'{0}\'', resolver);
          }
          var promise = new Promise();
          function resolveFn(value) {
            resolvePromise(promise, value);
          }
          function rejectFn(reason) {
            rejectPromise(promise, reason);
          }
          resolver(resolveFn, rejectFn);
          return promise;
        }
        $Q.prototype = Promise.prototype;
        $Q.defer = defer;
        $Q.reject = reject;
        $Q.when = when;
        $Q.resolve = resolve;
        $Q.all = all;
        $Q.race = race;
        return $Q;
      }
      function isStateExceptionHandled(state) {
        return !!state.pur;
      }
      function markQStateExceptionHandled(state) {
        state.pur = true;
      }
      function markQExceptionHandled(q) {
        markQStateExceptionHandled(q.$$state);
      }
      function $$RAFProvider() {
        this.$get = ['$window', '$timeout', function($window, $timeout) {
          var requestAnimationFrame = $window.requestAnimationFrame || $window.webkitRequestAnimationFrame;
          var cancelAnimationFrame = $window.cancelAnimationFrame || $window.webkitCancelAnimationFrame || $window.webkitCancelRequestAnimationFrame;
          var rafSupported = !!requestAnimationFrame;
          var raf = rafSupported ? function(fn) {
            var id = requestAnimationFrame(fn);
            return function() {
              cancelAnimationFrame(id);
            };
          } : function(fn) {
            var timer = $timeout(fn, 16.66, false);
            return function() {
              $timeout.cancel(timer);
            };
          };
          raf.supported = rafSupported;
          return raf;
        }];
      }
      function $RootScopeProvider() {
        var TTL = 10;
        var $rootScopeMinErr = minErr('$rootScope');
        var lastDirtyWatch = null;
        var applyAsyncId = null;
        this.digestTtl = function(value) {
          if (arguments.length) {
            TTL = value;
          }
          return TTL;
        };
        function createChildScopeClass(parent) {
          function ChildScope() {
            this.$$watchers = this.$$nextSibling = this.$$childHead = this.$$childTail = null;
            this.$$listeners = {};
            this.$$listenerCount = {};
            this.$$watchersCount = 0;
            this.$id = nextUid();
            this.$$ChildScope = null;
          }
          ChildScope.prototype = parent;
          return ChildScope;
        }
        this.$get = ['$exceptionHandler', '$parse', '$browser', function($exceptionHandler, $parse, $browser) {
          function destroyChildScope($event) {
            $event.currentScope.$$destroyed = true;
          }
          function cleanUpScope($scope) {
            if (msie === 9) {
              if ($scope.$$childHead) {
                cleanUpScope($scope.$$childHead);
              }
              if ($scope.$$nextSibling) {
                cleanUpScope($scope.$$nextSibling);
              }
            }
            $scope.$parent = $scope.$$nextSibling = $scope.$$prevSibling = $scope.$$childHead = $scope.$$childTail = $scope.$root = $scope.$$watchers = null;
          }
          function Scope() {
            this.$id = nextUid();
            this.$$phase = this.$parent = this.$$watchers = this.$$nextSibling = this.$$prevSibling = this.$$childHead = this.$$childTail = null;
            this.$root = this;
            this.$$destroyed = false;
            this.$$listeners = {};
            this.$$listenerCount = {};
            this.$$watchersCount = 0;
            this.$$isolateBindings = null;
          }
          Scope.prototype = {
            constructor: Scope,
            $new: function(isolate, parent) {
              var child;
              parent = parent || this;
              if (isolate) {
                child = new Scope();
                child.$root = this.$root;
              } else {
                if (!this.$$ChildScope) {
                  this.$$ChildScope = createChildScopeClass(this);
                }
                child = new this.$$ChildScope();
              }
              child.$parent = parent;
              child.$$prevSibling = parent.$$childTail;
              if (parent.$$childHead) {
                parent.$$childTail.$$nextSibling = child;
                parent.$$childTail = child;
              } else {
                parent.$$childHead = parent.$$childTail = child;
              }
              if (isolate || parent !== this)
                child.$on('$destroy', destroyChildScope);
              return child;
            },
            $watch: function(watchExp, listener, objectEquality, prettyPrintExpression) {
              var get = $parse(watchExp);
              var fn = isFunction(listener) ? listener : noop;
              if (get.$$watchDelegate) {
                return get.$$watchDelegate(this, fn, objectEquality, get, watchExp);
              }
              var scope = this,
                  array = scope.$$watchers,
                  watcher = {
                    fn: fn,
                    last: initWatchVal,
                    get: get,
                    exp: prettyPrintExpression || watchExp,
                    eq: !!objectEquality
                  };
              lastDirtyWatch = null;
              if (!array) {
                array = scope.$$watchers = [];
                array.$$digestWatchIndex = -1;
              }
              array.unshift(watcher);
              array.$$digestWatchIndex++;
              incrementWatchersCount(this, 1);
              return function deregisterWatch() {
                var index = arrayRemove(array, watcher);
                if (index >= 0) {
                  incrementWatchersCount(scope, -1);
                  if (index < array.$$digestWatchIndex) {
                    array.$$digestWatchIndex--;
                  }
                }
                lastDirtyWatch = null;
              };
            },
            $watchGroup: function(watchExpressions, listener) {
              var oldValues = new Array(watchExpressions.length);
              var newValues = new Array(watchExpressions.length);
              var deregisterFns = [];
              var self = this;
              var changeReactionScheduled = false;
              var firstRun = true;
              if (!watchExpressions.length) {
                var shouldCall = true;
                self.$evalAsync(function() {
                  if (shouldCall)
                    listener(newValues, newValues, self);
                });
                return function deregisterWatchGroup() {
                  shouldCall = false;
                };
              }
              if (watchExpressions.length === 1) {
                return this.$watch(watchExpressions[0], function watchGroupAction(value, oldValue, scope) {
                  newValues[0] = value;
                  oldValues[0] = oldValue;
                  listener(newValues, (value === oldValue) ? newValues : oldValues, scope);
                });
              }
              forEach(watchExpressions, function(expr, i) {
                var unwatchFn = self.$watch(expr, function watchGroupSubAction(value, oldValue) {
                  newValues[i] = value;
                  oldValues[i] = oldValue;
                  if (!changeReactionScheduled) {
                    changeReactionScheduled = true;
                    self.$evalAsync(watchGroupAction);
                  }
                });
                deregisterFns.push(unwatchFn);
              });
              function watchGroupAction() {
                changeReactionScheduled = false;
                if (firstRun) {
                  firstRun = false;
                  listener(newValues, newValues, self);
                } else {
                  listener(newValues, oldValues, self);
                }
              }
              return function deregisterWatchGroup() {
                while (deregisterFns.length) {
                  deregisterFns.shift()();
                }
              };
            },
            $watchCollection: function(obj, listener) {
              $watchCollectionInterceptor.$stateful = true;
              var self = this;
              var newValue;
              var oldValue;
              var veryOldValue;
              var trackVeryOldValue = (listener.length > 1);
              var changeDetected = 0;
              var changeDetector = $parse(obj, $watchCollectionInterceptor);
              var internalArray = [];
              var internalObject = {};
              var initRun = true;
              var oldLength = 0;
              function $watchCollectionInterceptor(_value) {
                newValue = _value;
                var newLength,
                    key,
                    bothNaN,
                    newItem,
                    oldItem;
                if (isUndefined(newValue))
                  return;
                if (!isObject(newValue)) {
                  if (oldValue !== newValue) {
                    oldValue = newValue;
                    changeDetected++;
                  }
                } else if (isArrayLike(newValue)) {
                  if (oldValue !== internalArray) {
                    oldValue = internalArray;
                    oldLength = oldValue.length = 0;
                    changeDetected++;
                  }
                  newLength = newValue.length;
                  if (oldLength !== newLength) {
                    changeDetected++;
                    oldValue.length = oldLength = newLength;
                  }
                  for (var i = 0; i < newLength; i++) {
                    oldItem = oldValue[i];
                    newItem = newValue[i];
                    bothNaN = (oldItem !== oldItem) && (newItem !== newItem);
                    if (!bothNaN && (oldItem !== newItem)) {
                      changeDetected++;
                      oldValue[i] = newItem;
                    }
                  }
                } else {
                  if (oldValue !== internalObject) {
                    oldValue = internalObject = {};
                    oldLength = 0;
                    changeDetected++;
                  }
                  newLength = 0;
                  for (key in newValue) {
                    if (hasOwnProperty.call(newValue, key)) {
                      newLength++;
                      newItem = newValue[key];
                      oldItem = oldValue[key];
                      if (key in oldValue) {
                        bothNaN = (oldItem !== oldItem) && (newItem !== newItem);
                        if (!bothNaN && (oldItem !== newItem)) {
                          changeDetected++;
                          oldValue[key] = newItem;
                        }
                      } else {
                        oldLength++;
                        oldValue[key] = newItem;
                        changeDetected++;
                      }
                    }
                  }
                  if (oldLength > newLength) {
                    changeDetected++;
                    for (key in oldValue) {
                      if (!hasOwnProperty.call(newValue, key)) {
                        oldLength--;
                        delete oldValue[key];
                      }
                    }
                  }
                }
                return changeDetected;
              }
              function $watchCollectionAction() {
                if (initRun) {
                  initRun = false;
                  listener(newValue, newValue, self);
                } else {
                  listener(newValue, veryOldValue, self);
                }
                if (trackVeryOldValue) {
                  if (!isObject(newValue)) {
                    veryOldValue = newValue;
                  } else if (isArrayLike(newValue)) {
                    veryOldValue = new Array(newValue.length);
                    for (var i = 0; i < newValue.length; i++) {
                      veryOldValue[i] = newValue[i];
                    }
                  } else {
                    veryOldValue = {};
                    for (var key in newValue) {
                      if (hasOwnProperty.call(newValue, key)) {
                        veryOldValue[key] = newValue[key];
                      }
                    }
                  }
                }
              }
              return this.$watch(changeDetector, $watchCollectionAction);
            },
            $digest: function() {
              var watch,
                  value,
                  last,
                  fn,
                  get,
                  watchers,
                  dirty,
                  ttl = TTL,
                  next,
                  current,
                  target = this,
                  watchLog = [],
                  logIdx,
                  asyncTask;
              beginPhase('$digest');
              $browser.$$checkUrlChange();
              if (this === $rootScope && applyAsyncId !== null) {
                $browser.defer.cancel(applyAsyncId);
                flushApplyAsync();
              }
              lastDirtyWatch = null;
              do {
                dirty = false;
                current = target;
                for (var asyncQueuePosition = 0; asyncQueuePosition < asyncQueue.length; asyncQueuePosition++) {
                  try {
                    asyncTask = asyncQueue[asyncQueuePosition];
                    fn = asyncTask.fn;
                    fn(asyncTask.scope, asyncTask.locals);
                  } catch (e) {
                    $exceptionHandler(e);
                  }
                  lastDirtyWatch = null;
                }
                asyncQueue.length = 0;
                traverseScopesLoop: do {
                  if ((watchers = current.$$watchers)) {
                    watchers.$$digestWatchIndex = watchers.length;
                    while (watchers.$$digestWatchIndex--) {
                      try {
                        watch = watchers[watchers.$$digestWatchIndex];
                        if (watch) {
                          get = watch.get;
                          if ((value = get(current)) !== (last = watch.last) && !(watch.eq ? equals(value, last) : (isNumberNaN(value) && isNumberNaN(last)))) {
                            dirty = true;
                            lastDirtyWatch = watch;
                            watch.last = watch.eq ? copy(value, null) : value;
                            fn = watch.fn;
                            fn(value, ((last === initWatchVal) ? value : last), current);
                            if (ttl < 5) {
                              logIdx = 4 - ttl;
                              if (!watchLog[logIdx])
                                watchLog[logIdx] = [];
                              watchLog[logIdx].push({
                                msg: isFunction(watch.exp) ? 'fn: ' + (watch.exp.name || watch.exp.toString()) : watch.exp,
                                newVal: value,
                                oldVal: last
                              });
                            }
                          } else if (watch === lastDirtyWatch) {
                            dirty = false;
                            break traverseScopesLoop;
                          }
                        }
                      } catch (e) {
                        $exceptionHandler(e);
                      }
                    }
                  }
                  if (!(next = ((current.$$watchersCount && current.$$childHead) || (current !== target && current.$$nextSibling)))) {
                    while (current !== target && !(next = current.$$nextSibling)) {
                      current = current.$parent;
                    }
                  }
                } while ((current = next));
                if ((dirty || asyncQueue.length) && !(ttl--)) {
                  clearPhase();
                  throw $rootScopeMinErr('infdig', '{0} $digest() iterations reached. Aborting!\n' + 'Watchers fired in the last 5 iterations: {1}', TTL, watchLog);
                }
              } while (dirty || asyncQueue.length);
              clearPhase();
              while (postDigestQueuePosition < postDigestQueue.length) {
                try {
                  postDigestQueue[postDigestQueuePosition++]();
                } catch (e) {
                  $exceptionHandler(e);
                }
              }
              postDigestQueue.length = postDigestQueuePosition = 0;
              $browser.$$checkUrlChange();
            },
            $destroy: function() {
              if (this.$$destroyed)
                return;
              var parent = this.$parent;
              this.$broadcast('$destroy');
              this.$$destroyed = true;
              if (this === $rootScope) {
                $browser.$$applicationDestroyed();
              }
              incrementWatchersCount(this, -this.$$watchersCount);
              for (var eventName in this.$$listenerCount) {
                decrementListenerCount(this, this.$$listenerCount[eventName], eventName);
              }
              if (parent && parent.$$childHead === this)
                parent.$$childHead = this.$$nextSibling;
              if (parent && parent.$$childTail === this)
                parent.$$childTail = this.$$prevSibling;
              if (this.$$prevSibling)
                this.$$prevSibling.$$nextSibling = this.$$nextSibling;
              if (this.$$nextSibling)
                this.$$nextSibling.$$prevSibling = this.$$prevSibling;
              this.$destroy = this.$digest = this.$apply = this.$evalAsync = this.$applyAsync = noop;
              this.$on = this.$watch = this.$watchGroup = function() {
                return noop;
              };
              this.$$listeners = {};
              this.$$nextSibling = null;
              cleanUpScope(this);
            },
            $eval: function(expr, locals) {
              return $parse(expr)(this, locals);
            },
            $evalAsync: function(expr, locals) {
              if (!$rootScope.$$phase && !asyncQueue.length) {
                $browser.defer(function() {
                  if (asyncQueue.length) {
                    $rootScope.$digest();
                  }
                });
              }
              asyncQueue.push({
                scope: this,
                fn: $parse(expr),
                locals: locals
              });
            },
            $$postDigest: function(fn) {
              postDigestQueue.push(fn);
            },
            $apply: function(expr) {
              try {
                beginPhase('$apply');
                try {
                  return this.$eval(expr);
                } finally {
                  clearPhase();
                }
              } catch (e) {
                $exceptionHandler(e);
              } finally {
                try {
                  $rootScope.$digest();
                } catch (e) {
                  $exceptionHandler(e);
                  throw e;
                }
              }
            },
            $applyAsync: function(expr) {
              var scope = this;
              if (expr) {
                applyAsyncQueue.push($applyAsyncExpression);
              }
              expr = $parse(expr);
              scheduleApplyAsync();
              function $applyAsyncExpression() {
                scope.$eval(expr);
              }
            },
            $on: function(name, listener) {
              var namedListeners = this.$$listeners[name];
              if (!namedListeners) {
                this.$$listeners[name] = namedListeners = [];
              }
              namedListeners.push(listener);
              var current = this;
              do {
                if (!current.$$listenerCount[name]) {
                  current.$$listenerCount[name] = 0;
                }
                current.$$listenerCount[name]++;
              } while ((current = current.$parent));
              var self = this;
              return function() {
                var indexOfListener = namedListeners.indexOf(listener);
                if (indexOfListener !== -1) {
                  delete namedListeners[indexOfListener];
                  decrementListenerCount(self, 1, name);
                }
              };
            },
            $emit: function(name, args) {
              var empty = [],
                  namedListeners,
                  scope = this,
                  stopPropagation = false,
                  event = {
                    name: name,
                    targetScope: scope,
                    stopPropagation: function() {
                      stopPropagation = true;
                    },
                    preventDefault: function() {
                      event.defaultPrevented = true;
                    },
                    defaultPrevented: false
                  },
                  listenerArgs = concat([event], arguments, 1),
                  i,
                  length;
              do {
                namedListeners = scope.$$listeners[name] || empty;
                event.currentScope = scope;
                for (i = 0, length = namedListeners.length; i < length; i++) {
                  if (!namedListeners[i]) {
                    namedListeners.splice(i, 1);
                    i--;
                    length--;
                    continue;
                  }
                  try {
                    namedListeners[i].apply(null, listenerArgs);
                  } catch (e) {
                    $exceptionHandler(e);
                  }
                }
                if (stopPropagation) {
                  break;
                }
                scope = scope.$parent;
              } while (scope);
              event.currentScope = null;
              return event;
            },
            $broadcast: function(name, args) {
              var target = this,
                  current = target,
                  next = target,
                  event = {
                    name: name,
                    targetScope: target,
                    preventDefault: function() {
                      event.defaultPrevented = true;
                    },
                    defaultPrevented: false
                  };
              if (!target.$$listenerCount[name])
                return event;
              var listenerArgs = concat([event], arguments, 1),
                  listeners,
                  i,
                  length;
              while ((current = next)) {
                event.currentScope = current;
                listeners = current.$$listeners[name] || [];
                for (i = 0, length = listeners.length; i < length; i++) {
                  if (!listeners[i]) {
                    listeners.splice(i, 1);
                    i--;
                    length--;
                    continue;
                  }
                  try {
                    listeners[i].apply(null, listenerArgs);
                  } catch (e) {
                    $exceptionHandler(e);
                  }
                }
                if (!(next = ((current.$$listenerCount[name] && current.$$childHead) || (current !== target && current.$$nextSibling)))) {
                  while (current !== target && !(next = current.$$nextSibling)) {
                    current = current.$parent;
                  }
                }
              }
              event.currentScope = null;
              return event;
            }
          };
          var $rootScope = new Scope();
          var asyncQueue = $rootScope.$$asyncQueue = [];
          var postDigestQueue = $rootScope.$$postDigestQueue = [];
          var applyAsyncQueue = $rootScope.$$applyAsyncQueue = [];
          var postDigestQueuePosition = 0;
          return $rootScope;
          function beginPhase(phase) {
            if ($rootScope.$$phase) {
              throw $rootScopeMinErr('inprog', '{0} already in progress', $rootScope.$$phase);
            }
            $rootScope.$$phase = phase;
          }
          function clearPhase() {
            $rootScope.$$phase = null;
          }
          function incrementWatchersCount(current, count) {
            do {
              current.$$watchersCount += count;
            } while ((current = current.$parent));
          }
          function decrementListenerCount(current, count, name) {
            do {
              current.$$listenerCount[name] -= count;
              if (current.$$listenerCount[name] === 0) {
                delete current.$$listenerCount[name];
              }
            } while ((current = current.$parent));
          }
          function initWatchVal() {}
          function flushApplyAsync() {
            while (applyAsyncQueue.length) {
              try {
                applyAsyncQueue.shift()();
              } catch (e) {
                $exceptionHandler(e);
              }
            }
            applyAsyncId = null;
          }
          function scheduleApplyAsync() {
            if (applyAsyncId === null) {
              applyAsyncId = $browser.defer(function() {
                $rootScope.$apply(flushApplyAsync);
              });
            }
          }
        }];
      }
      function $$SanitizeUriProvider() {
        var aHrefSanitizationWhitelist = /^\s*(https?|s?ftp|mailto|tel|file):/,
            imgSrcSanitizationWhitelist = /^\s*((https?|ftp|file|blob):|data:image\/)/;
        this.aHrefSanitizationWhitelist = function(regexp) {
          if (isDefined(regexp)) {
            aHrefSanitizationWhitelist = regexp;
            return this;
          }
          return aHrefSanitizationWhitelist;
        };
        this.imgSrcSanitizationWhitelist = function(regexp) {
          if (isDefined(regexp)) {
            imgSrcSanitizationWhitelist = regexp;
            return this;
          }
          return imgSrcSanitizationWhitelist;
        };
        this.$get = function() {
          return function sanitizeUri(uri, isImage) {
            var regex = isImage ? imgSrcSanitizationWhitelist : aHrefSanitizationWhitelist;
            var normalizedVal;
            normalizedVal = urlResolve(uri && uri.trim()).href;
            if (normalizedVal !== '' && !normalizedVal.match(regex)) {
              return 'unsafe:' + normalizedVal;
            }
            return uri;
          };
        };
      }
      var $sceMinErr = minErr('$sce');
      var SCE_CONTEXTS = {
        HTML: 'html',
        CSS: 'css',
        URL: 'url',
        RESOURCE_URL: 'resourceUrl',
        JS: 'js'
      };
      var UNDERSCORE_LOWERCASE_REGEXP = /_([a-z])/g;
      function snakeToCamel(name) {
        return name.replace(UNDERSCORE_LOWERCASE_REGEXP, fnCamelCaseReplace);
      }
      function adjustMatcher(matcher) {
        if (matcher === 'self') {
          return matcher;
        } else if (isString(matcher)) {
          if (matcher.indexOf('***') > -1) {
            throw $sceMinErr('iwcard', 'Illegal sequence *** in string matcher.  String: {0}', matcher);
          }
          matcher = escapeForRegexp(matcher).replace(/\\\*\\\*/g, '.*').replace(/\\\*/g, '[^:/.?&;]*');
          return new RegExp('^' + matcher + '$');
        } else if (isRegExp(matcher)) {
          return new RegExp('^' + matcher.source + '$');
        } else {
          throw $sceMinErr('imatcher', 'Matchers may only be "self", string patterns or RegExp objects');
        }
      }
      function adjustMatchers(matchers) {
        var adjustedMatchers = [];
        if (isDefined(matchers)) {
          forEach(matchers, function(matcher) {
            adjustedMatchers.push(adjustMatcher(matcher));
          });
        }
        return adjustedMatchers;
      }
      function $SceDelegateProvider() {
        this.SCE_CONTEXTS = SCE_CONTEXTS;
        var resourceUrlWhitelist = ['self'],
            resourceUrlBlacklist = [];
        this.resourceUrlWhitelist = function(value) {
          if (arguments.length) {
            resourceUrlWhitelist = adjustMatchers(value);
          }
          return resourceUrlWhitelist;
        };
        this.resourceUrlBlacklist = function(value) {
          if (arguments.length) {
            resourceUrlBlacklist = adjustMatchers(value);
          }
          return resourceUrlBlacklist;
        };
        this.$get = ['$injector', function($injector) {
          var htmlSanitizer = function htmlSanitizer(html) {
            throw $sceMinErr('unsafe', 'Attempting to use an unsafe value in a safe context.');
          };
          if ($injector.has('$sanitize')) {
            htmlSanitizer = $injector.get('$sanitize');
          }
          function matchUrl(matcher, parsedUrl) {
            if (matcher === 'self') {
              return urlIsSameOrigin(parsedUrl);
            } else {
              return !!matcher.exec(parsedUrl.href);
            }
          }
          function isResourceUrlAllowedByPolicy(url) {
            var parsedUrl = urlResolve(url.toString());
            var i,
                n,
                allowed = false;
            for (i = 0, n = resourceUrlWhitelist.length; i < n; i++) {
              if (matchUrl(resourceUrlWhitelist[i], parsedUrl)) {
                allowed = true;
                break;
              }
            }
            if (allowed) {
              for (i = 0, n = resourceUrlBlacklist.length; i < n; i++) {
                if (matchUrl(resourceUrlBlacklist[i], parsedUrl)) {
                  allowed = false;
                  break;
                }
              }
            }
            return allowed;
          }
          function generateHolderType(Base) {
            var holderType = function TrustedValueHolderType(trustedValue) {
              this.$$unwrapTrustedValue = function() {
                return trustedValue;
              };
            };
            if (Base) {
              holderType.prototype = new Base();
            }
            holderType.prototype.valueOf = function sceValueOf() {
              return this.$$unwrapTrustedValue();
            };
            holderType.prototype.toString = function sceToString() {
              return this.$$unwrapTrustedValue().toString();
            };
            return holderType;
          }
          var trustedValueHolderBase = generateHolderType(),
              byType = {};
          byType[SCE_CONTEXTS.HTML] = generateHolderType(trustedValueHolderBase);
          byType[SCE_CONTEXTS.CSS] = generateHolderType(trustedValueHolderBase);
          byType[SCE_CONTEXTS.URL] = generateHolderType(trustedValueHolderBase);
          byType[SCE_CONTEXTS.JS] = generateHolderType(trustedValueHolderBase);
          byType[SCE_CONTEXTS.RESOURCE_URL] = generateHolderType(byType[SCE_CONTEXTS.URL]);
          function trustAs(type, trustedValue) {
            var Constructor = (byType.hasOwnProperty(type) ? byType[type] : null);
            if (!Constructor) {
              throw $sceMinErr('icontext', 'Attempted to trust a value in invalid context. Context: {0}; Value: {1}', type, trustedValue);
            }
            if (trustedValue === null || isUndefined(trustedValue) || trustedValue === '') {
              return trustedValue;
            }
            if (typeof trustedValue !== 'string') {
              throw $sceMinErr('itype', 'Attempted to trust a non-string value in a content requiring a string: Context: {0}', type);
            }
            return new Constructor(trustedValue);
          }
          function valueOf(maybeTrusted) {
            if (maybeTrusted instanceof trustedValueHolderBase) {
              return maybeTrusted.$$unwrapTrustedValue();
            } else {
              return maybeTrusted;
            }
          }
          function getTrusted(type, maybeTrusted) {
            if (maybeTrusted === null || isUndefined(maybeTrusted) || maybeTrusted === '') {
              return maybeTrusted;
            }
            var constructor = (byType.hasOwnProperty(type) ? byType[type] : null);
            if (constructor && maybeTrusted instanceof constructor) {
              return maybeTrusted.$$unwrapTrustedValue();
            }
            if (type === SCE_CONTEXTS.RESOURCE_URL) {
              if (isResourceUrlAllowedByPolicy(maybeTrusted)) {
                return maybeTrusted;
              } else {
                throw $sceMinErr('insecurl', 'Blocked loading resource from url not allowed by $sceDelegate policy.  URL: {0}', maybeTrusted.toString());
              }
            } else if (type === SCE_CONTEXTS.HTML) {
              return htmlSanitizer(maybeTrusted);
            }
            throw $sceMinErr('unsafe', 'Attempting to use an unsafe value in a safe context.');
          }
          return {
            trustAs: trustAs,
            getTrusted: getTrusted,
            valueOf: valueOf
          };
        }];
      }
      function $SceProvider() {
        var enabled = true;
        this.enabled = function(value) {
          if (arguments.length) {
            enabled = !!value;
          }
          return enabled;
        };
        this.$get = ['$parse', '$sceDelegate', function($parse, $sceDelegate) {
          if (enabled && msie < 8) {
            throw $sceMinErr('iequirks', 'Strict Contextual Escaping does not support Internet Explorer version < 11 in quirks ' + 'mode.  You can fix this by adding the text <!doctype html> to the top of your HTML ' + 'document.  See http://docs.angularjs.org/api/ng.$sce for more information.');
          }
          var sce = shallowCopy(SCE_CONTEXTS);
          sce.isEnabled = function() {
            return enabled;
          };
          sce.trustAs = $sceDelegate.trustAs;
          sce.getTrusted = $sceDelegate.getTrusted;
          sce.valueOf = $sceDelegate.valueOf;
          if (!enabled) {
            sce.trustAs = sce.getTrusted = function(type, value) {
              return value;
            };
            sce.valueOf = identity;
          }
          sce.parseAs = function sceParseAs(type, expr) {
            var parsed = $parse(expr);
            if (parsed.literal && parsed.constant) {
              return parsed;
            } else {
              return $parse(expr, function(value) {
                return sce.getTrusted(type, value);
              });
            }
          };
          var parse = sce.parseAs,
              getTrusted = sce.getTrusted,
              trustAs = sce.trustAs;
          forEach(SCE_CONTEXTS, function(enumValue, name) {
            var lName = lowercase(name);
            sce[snakeToCamel('parse_as_' + lName)] = function(expr) {
              return parse(enumValue, expr);
            };
            sce[snakeToCamel('get_trusted_' + lName)] = function(value) {
              return getTrusted(enumValue, value);
            };
            sce[snakeToCamel('trust_as_' + lName)] = function(value) {
              return trustAs(enumValue, value);
            };
          });
          return sce;
        }];
      }
      function $SnifferProvider() {
        this.$get = ['$window', '$document', function($window, $document) {
          var eventSupport = {},
              isNw = $window.nw && $window.nw.process,
              isChromePackagedApp = !isNw && $window.chrome && ($window.chrome.app && $window.chrome.app.runtime || !$window.chrome.app && $window.chrome.runtime && $window.chrome.runtime.id),
              hasHistoryPushState = !isChromePackagedApp && $window.history && $window.history.pushState,
              android = toInt((/android (\d+)/.exec(lowercase(($window.navigator || {}).userAgent)) || [])[1]),
              boxee = /Boxee/i.test(($window.navigator || {}).userAgent),
              document = $document[0] || {},
              bodyStyle = document.body && document.body.style,
              transitions = false,
              animations = false;
          if (bodyStyle) {
            transitions = !!('transition' in bodyStyle || 'webkitTransition' in bodyStyle);
            animations = !!('animation' in bodyStyle || 'webkitAnimation' in bodyStyle);
          }
          return {
            history: !!(hasHistoryPushState && !(android < 4) && !boxee),
            hasEvent: function(event) {
              if (event === 'input' && msie)
                return false;
              if (isUndefined(eventSupport[event])) {
                var divElm = document.createElement('div');
                eventSupport[event] = 'on' + event in divElm;
              }
              return eventSupport[event];
            },
            csp: csp(),
            transitions: transitions,
            animations: animations,
            android: android
          };
        }];
      }
      var $templateRequestMinErr = minErr('$compile');
      function $TemplateRequestProvider() {
        var httpOptions;
        this.httpOptions = function(val) {
          if (val) {
            httpOptions = val;
            return this;
          }
          return httpOptions;
        };
        this.$get = ['$exceptionHandler', '$templateCache', '$http', '$q', '$sce', function($exceptionHandler, $templateCache, $http, $q, $sce) {
          function handleRequestFn(tpl, ignoreRequestError) {
            handleRequestFn.totalPendingRequests++;
            if (!isString(tpl) || isUndefined($templateCache.get(tpl))) {
              tpl = $sce.getTrustedResourceUrl(tpl);
            }
            var transformResponse = $http.defaults && $http.defaults.transformResponse;
            if (isArray(transformResponse)) {
              transformResponse = transformResponse.filter(function(transformer) {
                return transformer !== defaultHttpResponseTransform;
              });
            } else if (transformResponse === defaultHttpResponseTransform) {
              transformResponse = null;
            }
            return $http.get(tpl, extend({
              cache: $templateCache,
              transformResponse: transformResponse
            }, httpOptions)).finally(function() {
              handleRequestFn.totalPendingRequests--;
            }).then(function(response) {
              $templateCache.put(tpl, response.data);
              return response.data;
            }, handleError);
            function handleError(resp) {
              if (!ignoreRequestError) {
                resp = $templateRequestMinErr('tpload', 'Failed to load template: {0} (HTTP status: {1} {2})', tpl, resp.status, resp.statusText);
                $exceptionHandler(resp);
              }
              return $q.reject(resp);
            }
          }
          handleRequestFn.totalPendingRequests = 0;
          return handleRequestFn;
        }];
      }
      function $$TestabilityProvider() {
        this.$get = ['$rootScope', '$browser', '$location', function($rootScope, $browser, $location) {
          var testability = {};
          testability.findBindings = function(element, expression, opt_exactMatch) {
            var bindings = element.getElementsByClassName('ng-binding');
            var matches = [];
            forEach(bindings, function(binding) {
              var dataBinding = angular.element(binding).data('$binding');
              if (dataBinding) {
                forEach(dataBinding, function(bindingName) {
                  if (opt_exactMatch) {
                    var matcher = new RegExp('(^|\\s)' + escapeForRegexp(expression) + '(\\s|\\||$)');
                    if (matcher.test(bindingName)) {
                      matches.push(binding);
                    }
                  } else {
                    if (bindingName.indexOf(expression) !== -1) {
                      matches.push(binding);
                    }
                  }
                });
              }
            });
            return matches;
          };
          testability.findModels = function(element, expression, opt_exactMatch) {
            var prefixes = ['ng-', 'data-ng-', 'ng\\:'];
            for (var p = 0; p < prefixes.length; ++p) {
              var attributeEquals = opt_exactMatch ? '=' : '*=';
              var selector = '[' + prefixes[p] + 'model' + attributeEquals + '"' + expression + '"]';
              var elements = element.querySelectorAll(selector);
              if (elements.length) {
                return elements;
              }
            }
          };
          testability.getLocation = function() {
            return $location.url();
          };
          testability.setLocation = function(url) {
            if (url !== $location.url()) {
              $location.url(url);
              $rootScope.$digest();
            }
          };
          testability.whenStable = function(callback) {
            $browser.notifyWhenNoOutstandingRequests(callback);
          };
          return testability;
        }];
      }
      function $TimeoutProvider() {
        this.$get = ['$rootScope', '$browser', '$q', '$$q', '$exceptionHandler', function($rootScope, $browser, $q, $$q, $exceptionHandler) {
          var deferreds = {};
          function timeout(fn, delay, invokeApply) {
            if (!isFunction(fn)) {
              invokeApply = delay;
              delay = fn;
              fn = noop;
            }
            var args = sliceArgs(arguments, 3),
                skipApply = (isDefined(invokeApply) && !invokeApply),
                deferred = (skipApply ? $$q : $q).defer(),
                promise = deferred.promise,
                timeoutId;
            timeoutId = $browser.defer(function() {
              try {
                deferred.resolve(fn.apply(null, args));
              } catch (e) {
                deferred.reject(e);
                $exceptionHandler(e);
              } finally {
                delete deferreds[promise.$$timeoutId];
              }
              if (!skipApply)
                $rootScope.$apply();
            }, delay);
            promise.$$timeoutId = timeoutId;
            deferreds[timeoutId] = deferred;
            return promise;
          }
          timeout.cancel = function(promise) {
            if (promise && promise.$$timeoutId in deferreds) {
              markQExceptionHandled(deferreds[promise.$$timeoutId].promise);
              deferreds[promise.$$timeoutId].reject('canceled');
              delete deferreds[promise.$$timeoutId];
              return $browser.defer.cancel(promise.$$timeoutId);
            }
            return false;
          };
          return timeout;
        }];
      }
      var urlParsingNode = window.document.createElement('a');
      var originUrl = urlResolve(window.location.href);
      function urlResolve(url) {
        var href = url;
        if (msie) {
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute('href', href);
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ? urlParsingNode.pathname : '/' + urlParsingNode.pathname
        };
      }
      function urlIsSameOrigin(requestUrl) {
        var parsed = (isString(requestUrl)) ? urlResolve(requestUrl) : requestUrl;
        return (parsed.protocol === originUrl.protocol && parsed.host === originUrl.host);
      }
      function $WindowProvider() {
        this.$get = valueFn(window);
      }
      function $$CookieReader($document) {
        var rawDocument = $document[0] || {};
        var lastCookies = {};
        var lastCookieString = '';
        function safeGetCookie(rawDocument) {
          try {
            return rawDocument.cookie || '';
          } catch (e) {
            return '';
          }
        }
        function safeDecodeURIComponent(str) {
          try {
            return decodeURIComponent(str);
          } catch (e) {
            return str;
          }
        }
        return function() {
          var cookieArray,
              cookie,
              i,
              index,
              name;
          var currentCookieString = safeGetCookie(rawDocument);
          if (currentCookieString !== lastCookieString) {
            lastCookieString = currentCookieString;
            cookieArray = lastCookieString.split('; ');
            lastCookies = {};
            for (i = 0; i < cookieArray.length; i++) {
              cookie = cookieArray[i];
              index = cookie.indexOf('=');
              if (index > 0) {
                name = safeDecodeURIComponent(cookie.substring(0, index));
                if (isUndefined(lastCookies[name])) {
                  lastCookies[name] = safeDecodeURIComponent(cookie.substring(index + 1));
                }
              }
            }
          }
          return lastCookies;
        };
      }
      $$CookieReader.$inject = ['$document'];
      function $$CookieReaderProvider() {
        this.$get = $$CookieReader;
      }
      $FilterProvider.$inject = ['$provide'];
      function $FilterProvider($provide) {
        var suffix = 'Filter';
        function register(name, factory) {
          if (isObject(name)) {
            var filters = {};
            forEach(name, function(filter, key) {
              filters[key] = register(key, filter);
            });
            return filters;
          } else {
            return $provide.factory(name + suffix, factory);
          }
        }
        this.register = register;
        this.$get = ['$injector', function($injector) {
          return function(name) {
            return $injector.get(name + suffix);
          };
        }];
        register('currency', currencyFilter);
        register('date', dateFilter);
        register('filter', filterFilter);
        register('json', jsonFilter);
        register('limitTo', limitToFilter);
        register('lowercase', lowercaseFilter);
        register('number', numberFilter);
        register('orderBy', orderByFilter);
        register('uppercase', uppercaseFilter);
      }
      function filterFilter() {
        return function(array, expression, comparator, anyPropertyKey) {
          if (!isArrayLike(array)) {
            if (array == null) {
              return array;
            } else {
              throw minErr('filter')('notarray', 'Expected array but received: {0}', array);
            }
          }
          anyPropertyKey = anyPropertyKey || '$';
          var expressionType = getTypeForFilter(expression);
          var predicateFn;
          var matchAgainstAnyProp;
          switch (expressionType) {
            case 'function':
              predicateFn = expression;
              break;
            case 'boolean':
            case 'null':
            case 'number':
            case 'string':
              matchAgainstAnyProp = true;
            case 'object':
              predicateFn = createPredicateFn(expression, comparator, anyPropertyKey, matchAgainstAnyProp);
              break;
            default:
              return array;
          }
          return Array.prototype.filter.call(array, predicateFn);
        };
      }
      function createPredicateFn(expression, comparator, anyPropertyKey, matchAgainstAnyProp) {
        var shouldMatchPrimitives = isObject(expression) && (anyPropertyKey in expression);
        var predicateFn;
        if (comparator === true) {
          comparator = equals;
        } else if (!isFunction(comparator)) {
          comparator = function(actual, expected) {
            if (isUndefined(actual)) {
              return false;
            }
            if ((actual === null) || (expected === null)) {
              return actual === expected;
            }
            if (isObject(expected) || (isObject(actual) && !hasCustomToString(actual))) {
              return false;
            }
            actual = lowercase('' + actual);
            expected = lowercase('' + expected);
            return actual.indexOf(expected) !== -1;
          };
        }
        predicateFn = function(item) {
          if (shouldMatchPrimitives && !isObject(item)) {
            return deepCompare(item, expression[anyPropertyKey], comparator, anyPropertyKey, false);
          }
          return deepCompare(item, expression, comparator, anyPropertyKey, matchAgainstAnyProp);
        };
        return predicateFn;
      }
      function deepCompare(actual, expected, comparator, anyPropertyKey, matchAgainstAnyProp, dontMatchWholeObject) {
        var actualType = getTypeForFilter(actual);
        var expectedType = getTypeForFilter(expected);
        if ((expectedType === 'string') && (expected.charAt(0) === '!')) {
          return !deepCompare(actual, expected.substring(1), comparator, anyPropertyKey, matchAgainstAnyProp);
        } else if (isArray(actual)) {
          return actual.some(function(item) {
            return deepCompare(item, expected, comparator, anyPropertyKey, matchAgainstAnyProp);
          });
        }
        switch (actualType) {
          case 'object':
            var key;
            if (matchAgainstAnyProp) {
              for (key in actual) {
                if (key.charAt && (key.charAt(0) !== '$') && deepCompare(actual[key], expected, comparator, anyPropertyKey, true)) {
                  return true;
                }
              }
              return dontMatchWholeObject ? false : deepCompare(actual, expected, comparator, anyPropertyKey, false);
            } else if (expectedType === 'object') {
              for (key in expected) {
                var expectedVal = expected[key];
                if (isFunction(expectedVal) || isUndefined(expectedVal)) {
                  continue;
                }
                var matchAnyProperty = key === anyPropertyKey;
                var actualVal = matchAnyProperty ? actual : actual[key];
                if (!deepCompare(actualVal, expectedVal, comparator, anyPropertyKey, matchAnyProperty, matchAnyProperty)) {
                  return false;
                }
              }
              return true;
            } else {
              return comparator(actual, expected);
            }
          case 'function':
            return false;
          default:
            return comparator(actual, expected);
        }
      }
      function getTypeForFilter(val) {
        return (val === null) ? 'null' : typeof val;
      }
      var MAX_DIGITS = 22;
      var DECIMAL_SEP = '.';
      var ZERO_CHAR = '0';
      currencyFilter.$inject = ['$locale'];
      function currencyFilter($locale) {
        var formats = $locale.NUMBER_FORMATS;
        return function(amount, currencySymbol, fractionSize) {
          if (isUndefined(currencySymbol)) {
            currencySymbol = formats.CURRENCY_SYM;
          }
          if (isUndefined(fractionSize)) {
            fractionSize = formats.PATTERNS[1].maxFrac;
          }
          var currencySymbolRe = !currencySymbol ? /\s*\u00A4\s*/g : /\u00A4/g;
          return (amount == null) ? amount : formatNumber(amount, formats.PATTERNS[1], formats.GROUP_SEP, formats.DECIMAL_SEP, fractionSize).replace(currencySymbolRe, currencySymbol);
        };
      }
      numberFilter.$inject = ['$locale'];
      function numberFilter($locale) {
        var formats = $locale.NUMBER_FORMATS;
        return function(number, fractionSize) {
          return (number == null) ? number : formatNumber(number, formats.PATTERNS[0], formats.GROUP_SEP, formats.DECIMAL_SEP, fractionSize);
        };
      }
      function parse(numStr) {
        var exponent = 0,
            digits,
            numberOfIntegerDigits;
        var i,
            j,
            zeros;
        if ((numberOfIntegerDigits = numStr.indexOf(DECIMAL_SEP)) > -1) {
          numStr = numStr.replace(DECIMAL_SEP, '');
        }
        if ((i = numStr.search(/e/i)) > 0) {
          if (numberOfIntegerDigits < 0)
            numberOfIntegerDigits = i;
          numberOfIntegerDigits += +numStr.slice(i + 1);
          numStr = numStr.substring(0, i);
        } else if (numberOfIntegerDigits < 0) {
          numberOfIntegerDigits = numStr.length;
        }
        for (i = 0; numStr.charAt(i) === ZERO_CHAR; i++) {}
        if (i === (zeros = numStr.length)) {
          digits = [0];
          numberOfIntegerDigits = 1;
        } else {
          zeros--;
          while (numStr.charAt(zeros) === ZERO_CHAR)
            zeros--;
          numberOfIntegerDigits -= i;
          digits = [];
          for (j = 0; i <= zeros; i++, j++) {
            digits[j] = +numStr.charAt(i);
          }
        }
        if (numberOfIntegerDigits > MAX_DIGITS) {
          digits = digits.splice(0, MAX_DIGITS - 1);
          exponent = numberOfIntegerDigits - 1;
          numberOfIntegerDigits = 1;
        }
        return {
          d: digits,
          e: exponent,
          i: numberOfIntegerDigits
        };
      }
      function roundNumber(parsedNumber, fractionSize, minFrac, maxFrac) {
        var digits = parsedNumber.d;
        var fractionLen = digits.length - parsedNumber.i;
        fractionSize = (isUndefined(fractionSize)) ? Math.min(Math.max(minFrac, fractionLen), maxFrac) : +fractionSize;
        var roundAt = fractionSize + parsedNumber.i;
        var digit = digits[roundAt];
        if (roundAt > 0) {
          digits.splice(Math.max(parsedNumber.i, roundAt));
          for (var j = roundAt; j < digits.length; j++) {
            digits[j] = 0;
          }
        } else {
          fractionLen = Math.max(0, fractionLen);
          parsedNumber.i = 1;
          digits.length = Math.max(1, roundAt = fractionSize + 1);
          digits[0] = 0;
          for (var i = 1; i < roundAt; i++)
            digits[i] = 0;
        }
        if (digit >= 5) {
          if (roundAt - 1 < 0) {
            for (var k = 0; k > roundAt; k--) {
              digits.unshift(0);
              parsedNumber.i++;
            }
            digits.unshift(1);
            parsedNumber.i++;
          } else {
            digits[roundAt - 1]++;
          }
        }
        for (; fractionLen < Math.max(0, fractionSize); fractionLen++)
          digits.push(0);
        var carry = digits.reduceRight(function(carry, d, i, digits) {
          d = d + carry;
          digits[i] = d % 10;
          return Math.floor(d / 10);
        }, 0);
        if (carry) {
          digits.unshift(carry);
          parsedNumber.i++;
        }
      }
      function formatNumber(number, pattern, groupSep, decimalSep, fractionSize) {
        if (!(isString(number) || isNumber(number)) || isNaN(number))
          return '';
        var isInfinity = !isFinite(number);
        var isZero = false;
        var numStr = Math.abs(number) + '',
            formattedText = '',
            parsedNumber;
        if (isInfinity) {
          formattedText = '\u221e';
        } else {
          parsedNumber = parse(numStr);
          roundNumber(parsedNumber, fractionSize, pattern.minFrac, pattern.maxFrac);
          var digits = parsedNumber.d;
          var integerLen = parsedNumber.i;
          var exponent = parsedNumber.e;
          var decimals = [];
          isZero = digits.reduce(function(isZero, d) {
            return isZero && !d;
          }, true);
          while (integerLen < 0) {
            digits.unshift(0);
            integerLen++;
          }
          if (integerLen > 0) {
            decimals = digits.splice(integerLen, digits.length);
          } else {
            decimals = digits;
            digits = [0];
          }
          var groups = [];
          if (digits.length >= pattern.lgSize) {
            groups.unshift(digits.splice(-pattern.lgSize, digits.length).join(''));
          }
          while (digits.length > pattern.gSize) {
            groups.unshift(digits.splice(-pattern.gSize, digits.length).join(''));
          }
          if (digits.length) {
            groups.unshift(digits.join(''));
          }
          formattedText = groups.join(groupSep);
          if (decimals.length) {
            formattedText += decimalSep + decimals.join('');
          }
          if (exponent) {
            formattedText += 'e+' + exponent;
          }
        }
        if (number < 0 && !isZero) {
          return pattern.negPre + formattedText + pattern.negSuf;
        } else {
          return pattern.posPre + formattedText + pattern.posSuf;
        }
      }
      function padNumber(num, digits, trim, negWrap) {
        var neg = '';
        if (num < 0 || (negWrap && num <= 0)) {
          if (negWrap) {
            num = -num + 1;
          } else {
            num = -num;
            neg = '-';
          }
        }
        num = '' + num;
        while (num.length < digits)
          num = ZERO_CHAR + num;
        if (trim) {
          num = num.substr(num.length - digits);
        }
        return neg + num;
      }
      function dateGetter(name, size, offset, trim, negWrap) {
        offset = offset || 0;
        return function(date) {
          var value = date['get' + name]();
          if (offset > 0 || value > -offset) {
            value += offset;
          }
          if (value === 0 && offset === -12)
            value = 12;
          return padNumber(value, size, trim, negWrap);
        };
      }
      function dateStrGetter(name, shortForm, standAlone) {
        return function(date, formats) {
          var value = date['get' + name]();
          var propPrefix = (standAlone ? 'STANDALONE' : '') + (shortForm ? 'SHORT' : '');
          var get = uppercase(propPrefix + name);
          return formats[get][value];
        };
      }
      function timeZoneGetter(date, formats, offset) {
        var zone = -1 * offset;
        var paddedZone = (zone >= 0) ? '+' : '';
        paddedZone += padNumber(Math[zone > 0 ? 'floor' : 'ceil'](zone / 60), 2) + padNumber(Math.abs(zone % 60), 2);
        return paddedZone;
      }
      function getFirstThursdayOfYear(year) {
        var dayOfWeekOnFirst = (new Date(year, 0, 1)).getDay();
        return new Date(year, 0, ((dayOfWeekOnFirst <= 4) ? 5 : 12) - dayOfWeekOnFirst);
      }
      function getThursdayThisWeek(datetime) {
        return new Date(datetime.getFullYear(), datetime.getMonth(), datetime.getDate() + (4 - datetime.getDay()));
      }
      function weekGetter(size) {
        return function(date) {
          var firstThurs = getFirstThursdayOfYear(date.getFullYear()),
              thisThurs = getThursdayThisWeek(date);
          var diff = +thisThurs - +firstThurs,
              result = 1 + Math.round(diff / 6.048e8);
          return padNumber(result, size);
        };
      }
      function ampmGetter(date, formats) {
        return date.getHours() < 12 ? formats.AMPMS[0] : formats.AMPMS[1];
      }
      function eraGetter(date, formats) {
        return date.getFullYear() <= 0 ? formats.ERAS[0] : formats.ERAS[1];
      }
      function longEraGetter(date, formats) {
        return date.getFullYear() <= 0 ? formats.ERANAMES[0] : formats.ERANAMES[1];
      }
      var DATE_FORMATS = {
        yyyy: dateGetter('FullYear', 4, 0, false, true),
        yy: dateGetter('FullYear', 2, 0, true, true),
        y: dateGetter('FullYear', 1, 0, false, true),
        MMMM: dateStrGetter('Month'),
        MMM: dateStrGetter('Month', true),
        MM: dateGetter('Month', 2, 1),
        M: dateGetter('Month', 1, 1),
        LLLL: dateStrGetter('Month', false, true),
        dd: dateGetter('Date', 2),
        d: dateGetter('Date', 1),
        HH: dateGetter('Hours', 2),
        H: dateGetter('Hours', 1),
        hh: dateGetter('Hours', 2, -12),
        h: dateGetter('Hours', 1, -12),
        mm: dateGetter('Minutes', 2),
        m: dateGetter('Minutes', 1),
        ss: dateGetter('Seconds', 2),
        s: dateGetter('Seconds', 1),
        sss: dateGetter('Milliseconds', 3),
        EEEE: dateStrGetter('Day'),
        EEE: dateStrGetter('Day', true),
        a: ampmGetter,
        Z: timeZoneGetter,
        ww: weekGetter(2),
        w: weekGetter(1),
        G: eraGetter,
        GG: eraGetter,
        GGG: eraGetter,
        GGGG: longEraGetter
      };
      var DATE_FORMATS_SPLIT = /((?:[^yMLdHhmsaZEwG']+)|(?:'(?:[^']|'')*')|(?:E+|y+|M+|L+|d+|H+|h+|m+|s+|a|Z|G+|w+))([\s\S]*)/,
          NUMBER_STRING = /^-?\d+$/;
      dateFilter.$inject = ['$locale'];
      function dateFilter($locale) {
        var R_ISO8601_STR = /^(\d{4})-?(\d\d)-?(\d\d)(?:T(\d\d)(?::?(\d\d)(?::?(\d\d)(?:\.(\d+))?)?)?(Z|([+-])(\d\d):?(\d\d))?)?$/;
        function jsonStringToDate(string) {
          var match;
          if ((match = string.match(R_ISO8601_STR))) {
            var date = new Date(0),
                tzHour = 0,
                tzMin = 0,
                dateSetter = match[8] ? date.setUTCFullYear : date.setFullYear,
                timeSetter = match[8] ? date.setUTCHours : date.setHours;
            if (match[9]) {
              tzHour = toInt(match[9] + match[10]);
              tzMin = toInt(match[9] + match[11]);
            }
            dateSetter.call(date, toInt(match[1]), toInt(match[2]) - 1, toInt(match[3]));
            var h = toInt(match[4] || 0) - tzHour;
            var m = toInt(match[5] || 0) - tzMin;
            var s = toInt(match[6] || 0);
            var ms = Math.round(parseFloat('0.' + (match[7] || 0)) * 1000);
            timeSetter.call(date, h, m, s, ms);
            return date;
          }
          return string;
        }
        return function(date, format, timezone) {
          var text = '',
              parts = [],
              fn,
              match;
          format = format || 'mediumDate';
          format = $locale.DATETIME_FORMATS[format] || format;
          if (isString(date)) {
            date = NUMBER_STRING.test(date) ? toInt(date) : jsonStringToDate(date);
          }
          if (isNumber(date)) {
            date = new Date(date);
          }
          if (!isDate(date) || !isFinite(date.getTime())) {
            return date;
          }
          while (format) {
            match = DATE_FORMATS_SPLIT.exec(format);
            if (match) {
              parts = concat(parts, match, 1);
              format = parts.pop();
            } else {
              parts.push(format);
              format = null;
            }
          }
          var dateTimezoneOffset = date.getTimezoneOffset();
          if (timezone) {
            dateTimezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
            date = convertTimezoneToLocal(date, timezone, true);
          }
          forEach(parts, function(value) {
            fn = DATE_FORMATS[value];
            text += fn ? fn(date, $locale.DATETIME_FORMATS, dateTimezoneOffset) : value === '\'\'' ? '\'' : value.replace(/(^'|'$)/g, '').replace(/''/g, '\'');
          });
          return text;
        };
      }
      function jsonFilter() {
        return function(object, spacing) {
          if (isUndefined(spacing)) {
            spacing = 2;
          }
          return toJson(object, spacing);
        };
      }
      var lowercaseFilter = valueFn(lowercase);
      var uppercaseFilter = valueFn(uppercase);
      function limitToFilter() {
        return function(input, limit, begin) {
          if (Math.abs(Number(limit)) === Infinity) {
            limit = Number(limit);
          } else {
            limit = toInt(limit);
          }
          if (isNumberNaN(limit))
            return input;
          if (isNumber(input))
            input = input.toString();
          if (!isArrayLike(input))
            return input;
          begin = (!begin || isNaN(begin)) ? 0 : toInt(begin);
          begin = (begin < 0) ? Math.max(0, input.length + begin) : begin;
          if (limit >= 0) {
            return sliceFn(input, begin, begin + limit);
          } else {
            if (begin === 0) {
              return sliceFn(input, limit, input.length);
            } else {
              return sliceFn(input, Math.max(0, begin + limit), begin);
            }
          }
        };
      }
      function sliceFn(input, begin, end) {
        if (isString(input))
          return input.slice(begin, end);
        return slice.call(input, begin, end);
      }
      orderByFilter.$inject = ['$parse'];
      function orderByFilter($parse) {
        return function(array, sortPredicate, reverseOrder, compareFn) {
          if (array == null)
            return array;
          if (!isArrayLike(array)) {
            throw minErr('orderBy')('notarray', 'Expected array but received: {0}', array);
          }
          if (!isArray(sortPredicate)) {
            sortPredicate = [sortPredicate];
          }
          if (sortPredicate.length === 0) {
            sortPredicate = ['+'];
          }
          var predicates = processPredicates(sortPredicate);
          var descending = reverseOrder ? -1 : 1;
          var compare = isFunction(compareFn) ? compareFn : defaultCompare;
          var compareValues = Array.prototype.map.call(array, getComparisonObject);
          compareValues.sort(doComparison);
          array = compareValues.map(function(item) {
            return item.value;
          });
          return array;
          function getComparisonObject(value, index) {
            return {
              value: value,
              tieBreaker: {
                value: index,
                type: 'number',
                index: index
              },
              predicateValues: predicates.map(function(predicate) {
                return getPredicateValue(predicate.get(value), index);
              })
            };
          }
          function doComparison(v1, v2) {
            for (var i = 0,
                ii = predicates.length; i < ii; i++) {
              var result = compare(v1.predicateValues[i], v2.predicateValues[i]);
              if (result) {
                return result * predicates[i].descending * descending;
              }
            }
            return (compare(v1.tieBreaker, v2.tieBreaker) || defaultCompare(v1.tieBreaker, v2.tieBreaker)) * descending;
          }
        };
        function processPredicates(sortPredicates) {
          return sortPredicates.map(function(predicate) {
            var descending = 1,
                get = identity;
            if (isFunction(predicate)) {
              get = predicate;
            } else if (isString(predicate)) {
              if ((predicate.charAt(0) === '+' || predicate.charAt(0) === '-')) {
                descending = predicate.charAt(0) === '-' ? -1 : 1;
                predicate = predicate.substring(1);
              }
              if (predicate !== '') {
                get = $parse(predicate);
                if (get.constant) {
                  var key = get();
                  get = function(value) {
                    return value[key];
                  };
                }
              }
            }
            return {
              get: get,
              descending: descending
            };
          });
        }
        function isPrimitive(value) {
          switch (typeof value) {
            case 'number':
            case 'boolean':
            case 'string':
              return true;
            default:
              return false;
          }
        }
        function objectValue(value) {
          if (isFunction(value.valueOf)) {
            value = value.valueOf();
            if (isPrimitive(value))
              return value;
          }
          if (hasCustomToString(value)) {
            value = value.toString();
            if (isPrimitive(value))
              return value;
          }
          return value;
        }
        function getPredicateValue(value, index) {
          var type = typeof value;
          if (value === null) {
            type = 'string';
            value = 'null';
          } else if (type === 'object') {
            value = objectValue(value);
          }
          return {
            value: value,
            type: type,
            index: index
          };
        }
        function defaultCompare(v1, v2) {
          var result = 0;
          var type1 = v1.type;
          var type2 = v2.type;
          if (type1 === type2) {
            var value1 = v1.value;
            var value2 = v2.value;
            if (type1 === 'string') {
              value1 = value1.toLowerCase();
              value2 = value2.toLowerCase();
            } else if (type1 === 'object') {
              if (isObject(value1))
                value1 = v1.index;
              if (isObject(value2))
                value2 = v2.index;
            }
            if (value1 !== value2) {
              result = value1 < value2 ? -1 : 1;
            }
          } else {
            result = type1 < type2 ? -1 : 1;
          }
          return result;
        }
      }
      function ngDirective(directive) {
        if (isFunction(directive)) {
          directive = {link: directive};
        }
        directive.restrict = directive.restrict || 'AC';
        return valueFn(directive);
      }
      var htmlAnchorDirective = valueFn({
        restrict: 'E',
        compile: function(element, attr) {
          if (!attr.href && !attr.xlinkHref) {
            return function(scope, element) {
              if (element[0].nodeName.toLowerCase() !== 'a')
                return;
              var href = toString.call(element.prop('href')) === '[object SVGAnimatedString]' ? 'xlink:href' : 'href';
              element.on('click', function(event) {
                if (!element.attr(href)) {
                  event.preventDefault();
                }
              });
            };
          }
        }
      });
      var ngAttributeAliasDirectives = {};
      forEach(BOOLEAN_ATTR, function(propName, attrName) {
        if (propName === 'multiple')
          return;
        function defaultLinkFn(scope, element, attr) {
          scope.$watch(attr[normalized], function ngBooleanAttrWatchAction(value) {
            attr.$set(attrName, !!value);
          });
        }
        var normalized = directiveNormalize('ng-' + attrName);
        var linkFn = defaultLinkFn;
        if (propName === 'checked') {
          linkFn = function(scope, element, attr) {
            if (attr.ngModel !== attr[normalized]) {
              defaultLinkFn(scope, element, attr);
            }
          };
        }
        ngAttributeAliasDirectives[normalized] = function() {
          return {
            restrict: 'A',
            priority: 100,
            link: linkFn
          };
        };
      });
      forEach(ALIASED_ATTR, function(htmlAttr, ngAttr) {
        ngAttributeAliasDirectives[ngAttr] = function() {
          return {
            priority: 100,
            link: function(scope, element, attr) {
              if (ngAttr === 'ngPattern' && attr.ngPattern.charAt(0) === '/') {
                var match = attr.ngPattern.match(REGEX_STRING_REGEXP);
                if (match) {
                  attr.$set('ngPattern', new RegExp(match[1], match[2]));
                  return;
                }
              }
              scope.$watch(attr[ngAttr], function ngAttrAliasWatchAction(value) {
                attr.$set(ngAttr, value);
              });
            }
          };
        };
      });
      forEach(['src', 'srcset', 'href'], function(attrName) {
        var normalized = directiveNormalize('ng-' + attrName);
        ngAttributeAliasDirectives[normalized] = function() {
          return {
            priority: 99,
            link: function(scope, element, attr) {
              var propName = attrName,
                  name = attrName;
              if (attrName === 'href' && toString.call(element.prop('href')) === '[object SVGAnimatedString]') {
                name = 'xlinkHref';
                attr.$attr[name] = 'xlink:href';
                propName = null;
              }
              attr.$observe(normalized, function(value) {
                if (!value) {
                  if (attrName === 'href') {
                    attr.$set(name, null);
                  }
                  return;
                }
                attr.$set(name, value);
                if (msie && propName)
                  element.prop(propName, attr[name]);
              });
            }
          };
        };
      });
      var nullFormCtrl = {
        $addControl: noop,
        $$renameControl: nullFormRenameControl,
        $removeControl: noop,
        $setValidity: noop,
        $setDirty: noop,
        $setPristine: noop,
        $setSubmitted: noop
      },
          PENDING_CLASS = 'ng-pending',
          SUBMITTED_CLASS = 'ng-submitted';
      function nullFormRenameControl(control, name) {
        control.$name = name;
      }
      FormController.$inject = ['$element', '$attrs', '$scope', '$animate', '$interpolate'];
      function FormController($element, $attrs, $scope, $animate, $interpolate) {
        this.$$controls = [];
        this.$error = {};
        this.$$success = {};
        this.$pending = undefined;
        this.$name = $interpolate($attrs.name || $attrs.ngForm || '')($scope);
        this.$dirty = false;
        this.$pristine = true;
        this.$valid = true;
        this.$invalid = false;
        this.$submitted = false;
        this.$$parentForm = nullFormCtrl;
        this.$$element = $element;
        this.$$animate = $animate;
        setupValidity(this);
      }
      FormController.prototype = {
        $rollbackViewValue: function() {
          forEach(this.$$controls, function(control) {
            control.$rollbackViewValue();
          });
        },
        $commitViewValue: function() {
          forEach(this.$$controls, function(control) {
            control.$commitViewValue();
          });
        },
        $addControl: function(control) {
          assertNotHasOwnProperty(control.$name, 'input');
          this.$$controls.push(control);
          if (control.$name) {
            this[control.$name] = control;
          }
          control.$$parentForm = this;
        },
        $$renameControl: function(control, newName) {
          var oldName = control.$name;
          if (this[oldName] === control) {
            delete this[oldName];
          }
          this[newName] = control;
          control.$name = newName;
        },
        $removeControl: function(control) {
          if (control.$name && this[control.$name] === control) {
            delete this[control.$name];
          }
          forEach(this.$pending, function(value, name) {
            this.$setValidity(name, null, control);
          }, this);
          forEach(this.$error, function(value, name) {
            this.$setValidity(name, null, control);
          }, this);
          forEach(this.$$success, function(value, name) {
            this.$setValidity(name, null, control);
          }, this);
          arrayRemove(this.$$controls, control);
          control.$$parentForm = nullFormCtrl;
        },
        $setDirty: function() {
          this.$$animate.removeClass(this.$$element, PRISTINE_CLASS);
          this.$$animate.addClass(this.$$element, DIRTY_CLASS);
          this.$dirty = true;
          this.$pristine = false;
          this.$$parentForm.$setDirty();
        },
        $setPristine: function() {
          this.$$animate.setClass(this.$$element, PRISTINE_CLASS, DIRTY_CLASS + ' ' + SUBMITTED_CLASS);
          this.$dirty = false;
          this.$pristine = true;
          this.$submitted = false;
          forEach(this.$$controls, function(control) {
            control.$setPristine();
          });
        },
        $setUntouched: function() {
          forEach(this.$$controls, function(control) {
            control.$setUntouched();
          });
        },
        $setSubmitted: function() {
          this.$$animate.addClass(this.$$element, SUBMITTED_CLASS);
          this.$submitted = true;
          this.$$parentForm.$setSubmitted();
        }
      };
      addSetValidityMethod({
        clazz: FormController,
        set: function(object, property, controller) {
          var list = object[property];
          if (!list) {
            object[property] = [controller];
          } else {
            var index = list.indexOf(controller);
            if (index === -1) {
              list.push(controller);
            }
          }
        },
        unset: function(object, property, controller) {
          var list = object[property];
          if (!list) {
            return;
          }
          arrayRemove(list, controller);
          if (list.length === 0) {
            delete object[property];
          }
        }
      });
      var formDirectiveFactory = function(isNgForm) {
        return ['$timeout', '$parse', function($timeout, $parse) {
          var formDirective = {
            name: 'form',
            restrict: isNgForm ? 'EAC' : 'E',
            require: ['form', '^^?form'],
            controller: FormController,
            compile: function ngFormCompile(formElement, attr) {
              formElement.addClass(PRISTINE_CLASS).addClass(VALID_CLASS);
              var nameAttr = attr.name ? 'name' : (isNgForm && attr.ngForm ? 'ngForm' : false);
              return {pre: function ngFormPreLink(scope, formElement, attr, ctrls) {
                  var controller = ctrls[0];
                  if (!('action' in attr)) {
                    var handleFormSubmission = function(event) {
                      scope.$apply(function() {
                        controller.$commitViewValue();
                        controller.$setSubmitted();
                      });
                      event.preventDefault();
                    };
                    formElement[0].addEventListener('submit', handleFormSubmission);
                    formElement.on('$destroy', function() {
                      $timeout(function() {
                        formElement[0].removeEventListener('submit', handleFormSubmission);
                      }, 0, false);
                    });
                  }
                  var parentFormCtrl = ctrls[1] || controller.$$parentForm;
                  parentFormCtrl.$addControl(controller);
                  var setter = nameAttr ? getSetter(controller.$name) : noop;
                  if (nameAttr) {
                    setter(scope, controller);
                    attr.$observe(nameAttr, function(newValue) {
                      if (controller.$name === newValue)
                        return;
                      setter(scope, undefined);
                      controller.$$parentForm.$$renameControl(controller, newValue);
                      setter = getSetter(controller.$name);
                      setter(scope, controller);
                    });
                  }
                  formElement.on('$destroy', function() {
                    controller.$$parentForm.$removeControl(controller);
                    setter(scope, undefined);
                    extend(controller, nullFormCtrl);
                  });
                }};
            }
          };
          return formDirective;
          function getSetter(expression) {
            if (expression === '') {
              return $parse('this[""]').assign;
            }
            return $parse(expression).assign || noop;
          }
        }];
      };
      var formDirective = formDirectiveFactory();
      var ngFormDirective = formDirectiveFactory(true);
      function setupValidity(instance) {
        instance.$$classCache = {};
        instance.$$classCache[INVALID_CLASS] = !(instance.$$classCache[VALID_CLASS] = instance.$$element.hasClass(VALID_CLASS));
      }
      function addSetValidityMethod(context) {
        var clazz = context.clazz,
            set = context.set,
            unset = context.unset;
        clazz.prototype.$setValidity = function(validationErrorKey, state, controller) {
          if (isUndefined(state)) {
            createAndSet(this, '$pending', validationErrorKey, controller);
          } else {
            unsetAndCleanup(this, '$pending', validationErrorKey, controller);
          }
          if (!isBoolean(state)) {
            unset(this.$error, validationErrorKey, controller);
            unset(this.$$success, validationErrorKey, controller);
          } else {
            if (state) {
              unset(this.$error, validationErrorKey, controller);
              set(this.$$success, validationErrorKey, controller);
            } else {
              set(this.$error, validationErrorKey, controller);
              unset(this.$$success, validationErrorKey, controller);
            }
          }
          if (this.$pending) {
            cachedToggleClass(this, PENDING_CLASS, true);
            this.$valid = this.$invalid = undefined;
            toggleValidationCss(this, '', null);
          } else {
            cachedToggleClass(this, PENDING_CLASS, false);
            this.$valid = isObjectEmpty(this.$error);
            this.$invalid = !this.$valid;
            toggleValidationCss(this, '', this.$valid);
          }
          var combinedState;
          if (this.$pending && this.$pending[validationErrorKey]) {
            combinedState = undefined;
          } else if (this.$error[validationErrorKey]) {
            combinedState = false;
          } else if (this.$$success[validationErrorKey]) {
            combinedState = true;
          } else {
            combinedState = null;
          }
          toggleValidationCss(this, validationErrorKey, combinedState);
          this.$$parentForm.$setValidity(validationErrorKey, combinedState, this);
        };
        function createAndSet(ctrl, name, value, controller) {
          if (!ctrl[name]) {
            ctrl[name] = {};
          }
          set(ctrl[name], value, controller);
        }
        function unsetAndCleanup(ctrl, name, value, controller) {
          if (ctrl[name]) {
            unset(ctrl[name], value, controller);
          }
          if (isObjectEmpty(ctrl[name])) {
            ctrl[name] = undefined;
          }
        }
        function cachedToggleClass(ctrl, className, switchValue) {
          if (switchValue && !ctrl.$$classCache[className]) {
            ctrl.$$animate.addClass(ctrl.$$element, className);
            ctrl.$$classCache[className] = true;
          } else if (!switchValue && ctrl.$$classCache[className]) {
            ctrl.$$animate.removeClass(ctrl.$$element, className);
            ctrl.$$classCache[className] = false;
          }
        }
        function toggleValidationCss(ctrl, validationErrorKey, isValid) {
          validationErrorKey = validationErrorKey ? '-' + snake_case(validationErrorKey, '-') : '';
          cachedToggleClass(ctrl, VALID_CLASS + validationErrorKey, isValid === true);
          cachedToggleClass(ctrl, INVALID_CLASS + validationErrorKey, isValid === false);
        }
      }
      function isObjectEmpty(obj) {
        if (obj) {
          for (var prop in obj) {
            if (obj.hasOwnProperty(prop)) {
              return false;
            }
          }
        }
        return true;
      }
      var ISO_DATE_REGEXP = /^\d{4,}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+(?:[+-][0-2]\d:[0-5]\d|Z)$/;
      var URL_REGEXP = /^[a-z][a-z\d.+-]*:\/*(?:[^:@]+(?::[^@]+)?@)?(?:[^\s:/?#]+|\[[a-f\d:]+])(?::\d+)?(?:\/[^?#]*)?(?:\?[^#]*)?(?:#.*)?$/i;
      var EMAIL_REGEXP = /^(?=.{1,254}$)(?=.{1,64}@)[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+(\.[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+)*@[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?(\.[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?)*$/;
      var NUMBER_REGEXP = /^\s*(-|\+)?(\d+|(\d*(\.\d*)))([eE][+-]?\d+)?\s*$/;
      var DATE_REGEXP = /^(\d{4,})-(\d{2})-(\d{2})$/;
      var DATETIMELOCAL_REGEXP = /^(\d{4,})-(\d\d)-(\d\d)T(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/;
      var WEEK_REGEXP = /^(\d{4,})-W(\d\d)$/;
      var MONTH_REGEXP = /^(\d{4,})-(\d\d)$/;
      var TIME_REGEXP = /^(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/;
      var PARTIAL_VALIDATION_EVENTS = 'keydown wheel mousedown';
      var PARTIAL_VALIDATION_TYPES = createMap();
      forEach('date,datetime-local,month,time,week'.split(','), function(type) {
        PARTIAL_VALIDATION_TYPES[type] = true;
      });
      var inputType = {
        'text': textInputType,
        'date': createDateInputType('date', DATE_REGEXP, createDateParser(DATE_REGEXP, ['yyyy', 'MM', 'dd']), 'yyyy-MM-dd'),
        'datetime-local': createDateInputType('datetimelocal', DATETIMELOCAL_REGEXP, createDateParser(DATETIMELOCAL_REGEXP, ['yyyy', 'MM', 'dd', 'HH', 'mm', 'ss', 'sss']), 'yyyy-MM-ddTHH:mm:ss.sss'),
        'time': createDateInputType('time', TIME_REGEXP, createDateParser(TIME_REGEXP, ['HH', 'mm', 'ss', 'sss']), 'HH:mm:ss.sss'),
        'week': createDateInputType('week', WEEK_REGEXP, weekParser, 'yyyy-Www'),
        'month': createDateInputType('month', MONTH_REGEXP, createDateParser(MONTH_REGEXP, ['yyyy', 'MM']), 'yyyy-MM'),
        'number': numberInputType,
        'url': urlInputType,
        'email': emailInputType,
        'radio': radioInputType,
        'range': rangeInputType,
        'checkbox': checkboxInputType,
        'hidden': noop,
        'button': noop,
        'submit': noop,
        'reset': noop,
        'file': noop
      };
      function stringBasedInputType(ctrl) {
        ctrl.$formatters.push(function(value) {
          return ctrl.$isEmpty(value) ? value : value.toString();
        });
      }
      function textInputType(scope, element, attr, ctrl, $sniffer, $browser) {
        baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
        stringBasedInputType(ctrl);
      }
      function baseInputType(scope, element, attr, ctrl, $sniffer, $browser) {
        var type = lowercase(element[0].type);
        if (!$sniffer.android) {
          var composing = false;
          element.on('compositionstart', function() {
            composing = true;
          });
          element.on('compositionend', function() {
            composing = false;
            listener();
          });
        }
        var timeout;
        var listener = function(ev) {
          if (timeout) {
            $browser.defer.cancel(timeout);
            timeout = null;
          }
          if (composing)
            return;
          var value = element.val(),
              event = ev && ev.type;
          if (type !== 'password' && (!attr.ngTrim || attr.ngTrim !== 'false')) {
            value = trim(value);
          }
          if (ctrl.$viewValue !== value || (value === '' && ctrl.$$hasNativeValidators)) {
            ctrl.$setViewValue(value, event);
          }
        };
        if ($sniffer.hasEvent('input')) {
          element.on('input', listener);
        } else {
          var deferListener = function(ev, input, origValue) {
            if (!timeout) {
              timeout = $browser.defer(function() {
                timeout = null;
                if (!input || input.value !== origValue) {
                  listener(ev);
                }
              });
            }
          };
          element.on('keydown', function(event) {
            var key = event.keyCode;
            if (key === 91 || (15 < key && key < 19) || (37 <= key && key <= 40))
              return;
            deferListener(event, this, this.value);
          });
          if ($sniffer.hasEvent('paste')) {
            element.on('paste cut drop', deferListener);
          }
        }
        element.on('change', listener);
        if (PARTIAL_VALIDATION_TYPES[type] && ctrl.$$hasNativeValidators && type === attr.type) {
          element.on(PARTIAL_VALIDATION_EVENTS, function(ev) {
            if (!timeout) {
              var validity = this[VALIDITY_STATE_PROPERTY];
              var origBadInput = validity.badInput;
              var origTypeMismatch = validity.typeMismatch;
              timeout = $browser.defer(function() {
                timeout = null;
                if (validity.badInput !== origBadInput || validity.typeMismatch !== origTypeMismatch) {
                  listener(ev);
                }
              });
            }
          });
        }
        ctrl.$render = function() {
          var value = ctrl.$isEmpty(ctrl.$viewValue) ? '' : ctrl.$viewValue;
          if (element.val() !== value) {
            element.val(value);
          }
        };
      }
      function weekParser(isoWeek, existingDate) {
        if (isDate(isoWeek)) {
          return isoWeek;
        }
        if (isString(isoWeek)) {
          WEEK_REGEXP.lastIndex = 0;
          var parts = WEEK_REGEXP.exec(isoWeek);
          if (parts) {
            var year = +parts[1],
                week = +parts[2],
                hours = 0,
                minutes = 0,
                seconds = 0,
                milliseconds = 0,
                firstThurs = getFirstThursdayOfYear(year),
                addDays = (week - 1) * 7;
            if (existingDate) {
              hours = existingDate.getHours();
              minutes = existingDate.getMinutes();
              seconds = existingDate.getSeconds();
              milliseconds = existingDate.getMilliseconds();
            }
            return new Date(year, 0, firstThurs.getDate() + addDays, hours, minutes, seconds, milliseconds);
          }
        }
        return NaN;
      }
      function createDateParser(regexp, mapping) {
        return function(iso, date) {
          var parts,
              map;
          if (isDate(iso)) {
            return iso;
          }
          if (isString(iso)) {
            if (iso.charAt(0) === '"' && iso.charAt(iso.length - 1) === '"') {
              iso = iso.substring(1, iso.length - 1);
            }
            if (ISO_DATE_REGEXP.test(iso)) {
              return new Date(iso);
            }
            regexp.lastIndex = 0;
            parts = regexp.exec(iso);
            if (parts) {
              parts.shift();
              if (date) {
                map = {
                  yyyy: date.getFullYear(),
                  MM: date.getMonth() + 1,
                  dd: date.getDate(),
                  HH: date.getHours(),
                  mm: date.getMinutes(),
                  ss: date.getSeconds(),
                  sss: date.getMilliseconds() / 1000
                };
              } else {
                map = {
                  yyyy: 1970,
                  MM: 1,
                  dd: 1,
                  HH: 0,
                  mm: 0,
                  ss: 0,
                  sss: 0
                };
              }
              forEach(parts, function(part, index) {
                if (index < mapping.length) {
                  map[mapping[index]] = +part;
                }
              });
              return new Date(map.yyyy, map.MM - 1, map.dd, map.HH, map.mm, map.ss || 0, map.sss * 1000 || 0);
            }
          }
          return NaN;
        };
      }
      function createDateInputType(type, regexp, parseDate, format) {
        return function dynamicDateInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter) {
          badInputChecker(scope, element, attr, ctrl);
          baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
          var timezone = ctrl && ctrl.$options.getOption('timezone');
          var previousDate;
          ctrl.$$parserName = type;
          ctrl.$parsers.push(function(value) {
            if (ctrl.$isEmpty(value))
              return null;
            if (regexp.test(value)) {
              var parsedDate = parseDate(value, previousDate);
              if (timezone) {
                parsedDate = convertTimezoneToLocal(parsedDate, timezone);
              }
              return parsedDate;
            }
            return undefined;
          });
          ctrl.$formatters.push(function(value) {
            if (value && !isDate(value)) {
              throw ngModelMinErr('datefmt', 'Expected `{0}` to be a date', value);
            }
            if (isValidDate(value)) {
              previousDate = value;
              if (previousDate && timezone) {
                previousDate = convertTimezoneToLocal(previousDate, timezone, true);
              }
              return $filter('date')(value, format, timezone);
            } else {
              previousDate = null;
              return '';
            }
          });
          if (isDefined(attr.min) || attr.ngMin) {
            var minVal;
            ctrl.$validators.min = function(value) {
              return !isValidDate(value) || isUndefined(minVal) || parseDate(value) >= minVal;
            };
            attr.$observe('min', function(val) {
              minVal = parseObservedDateValue(val);
              ctrl.$validate();
            });
          }
          if (isDefined(attr.max) || attr.ngMax) {
            var maxVal;
            ctrl.$validators.max = function(value) {
              return !isValidDate(value) || isUndefined(maxVal) || parseDate(value) <= maxVal;
            };
            attr.$observe('max', function(val) {
              maxVal = parseObservedDateValue(val);
              ctrl.$validate();
            });
          }
          function isValidDate(value) {
            return value && !(value.getTime && value.getTime() !== value.getTime());
          }
          function parseObservedDateValue(val) {
            return isDefined(val) && !isDate(val) ? parseDate(val) || undefined : val;
          }
        };
      }
      function badInputChecker(scope, element, attr, ctrl) {
        var node = element[0];
        var nativeValidation = ctrl.$$hasNativeValidators = isObject(node.validity);
        if (nativeValidation) {
          ctrl.$parsers.push(function(value) {
            var validity = element.prop(VALIDITY_STATE_PROPERTY) || {};
            return validity.badInput || validity.typeMismatch ? undefined : value;
          });
        }
      }
      function numberFormatterParser(ctrl) {
        ctrl.$$parserName = 'number';
        ctrl.$parsers.push(function(value) {
          if (ctrl.$isEmpty(value))
            return null;
          if (NUMBER_REGEXP.test(value))
            return parseFloat(value);
          return undefined;
        });
        ctrl.$formatters.push(function(value) {
          if (!ctrl.$isEmpty(value)) {
            if (!isNumber(value)) {
              throw ngModelMinErr('numfmt', 'Expected `{0}` to be a number', value);
            }
            value = value.toString();
          }
          return value;
        });
      }
      function parseNumberAttrVal(val) {
        if (isDefined(val) && !isNumber(val)) {
          val = parseFloat(val);
        }
        return !isNumberNaN(val) ? val : undefined;
      }
      function isNumberInteger(num) {
        return (num | 0) === num;
      }
      function countDecimals(num) {
        var numString = num.toString();
        var decimalSymbolIndex = numString.indexOf('.');
        if (decimalSymbolIndex === -1) {
          if (-1 < num && num < 1) {
            var match = /e-(\d+)$/.exec(numString);
            if (match) {
              return Number(match[1]);
            }
          }
          return 0;
        }
        return numString.length - decimalSymbolIndex - 1;
      }
      function isValidForStep(viewValue, stepBase, step) {
        var value = Number(viewValue);
        var isNonIntegerValue = !isNumberInteger(value);
        var isNonIntegerStepBase = !isNumberInteger(stepBase);
        var isNonIntegerStep = !isNumberInteger(step);
        if (isNonIntegerValue || isNonIntegerStepBase || isNonIntegerStep) {
          var valueDecimals = isNonIntegerValue ? countDecimals(value) : 0;
          var stepBaseDecimals = isNonIntegerStepBase ? countDecimals(stepBase) : 0;
          var stepDecimals = isNonIntegerStep ? countDecimals(step) : 0;
          var decimalCount = Math.max(valueDecimals, stepBaseDecimals, stepDecimals);
          var multiplier = Math.pow(10, decimalCount);
          value = value * multiplier;
          stepBase = stepBase * multiplier;
          step = step * multiplier;
          if (isNonIntegerValue)
            value = Math.round(value);
          if (isNonIntegerStepBase)
            stepBase = Math.round(stepBase);
          if (isNonIntegerStep)
            step = Math.round(step);
        }
        return (value - stepBase) % step === 0;
      }
      function numberInputType(scope, element, attr, ctrl, $sniffer, $browser) {
        badInputChecker(scope, element, attr, ctrl);
        numberFormatterParser(ctrl);
        baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
        var minVal;
        var maxVal;
        if (isDefined(attr.min) || attr.ngMin) {
          ctrl.$validators.min = function(value) {
            return ctrl.$isEmpty(value) || isUndefined(minVal) || value >= minVal;
          };
          attr.$observe('min', function(val) {
            minVal = parseNumberAttrVal(val);
            ctrl.$validate();
          });
        }
        if (isDefined(attr.max) || attr.ngMax) {
          ctrl.$validators.max = function(value) {
            return ctrl.$isEmpty(value) || isUndefined(maxVal) || value <= maxVal;
          };
          attr.$observe('max', function(val) {
            maxVal = parseNumberAttrVal(val);
            ctrl.$validate();
          });
        }
        if (isDefined(attr.step) || attr.ngStep) {
          var stepVal;
          ctrl.$validators.step = function(modelValue, viewValue) {
            return ctrl.$isEmpty(viewValue) || isUndefined(stepVal) || isValidForStep(viewValue, minVal || 0, stepVal);
          };
          attr.$observe('step', function(val) {
            stepVal = parseNumberAttrVal(val);
            ctrl.$validate();
          });
        }
      }
      function rangeInputType(scope, element, attr, ctrl, $sniffer, $browser) {
        badInputChecker(scope, element, attr, ctrl);
        numberFormatterParser(ctrl);
        baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
        var supportsRange = ctrl.$$hasNativeValidators && element[0].type === 'range',
            minVal = supportsRange ? 0 : undefined,
            maxVal = supportsRange ? 100 : undefined,
            stepVal = supportsRange ? 1 : undefined,
            validity = element[0].validity,
            hasMinAttr = isDefined(attr.min),
            hasMaxAttr = isDefined(attr.max),
            hasStepAttr = isDefined(attr.step);
        var originalRender = ctrl.$render;
        ctrl.$render = supportsRange && isDefined(validity.rangeUnderflow) && isDefined(validity.rangeOverflow) ? function rangeRender() {
          originalRender();
          ctrl.$setViewValue(element.val());
        } : originalRender;
        if (hasMinAttr) {
          ctrl.$validators.min = supportsRange ? function noopMinValidator() {
            return true;
          } : function minValidator(modelValue, viewValue) {
            return ctrl.$isEmpty(viewValue) || isUndefined(minVal) || viewValue >= minVal;
          };
          setInitialValueAndObserver('min', minChange);
        }
        if (hasMaxAttr) {
          ctrl.$validators.max = supportsRange ? function noopMaxValidator() {
            return true;
          } : function maxValidator(modelValue, viewValue) {
            return ctrl.$isEmpty(viewValue) || isUndefined(maxVal) || viewValue <= maxVal;
          };
          setInitialValueAndObserver('max', maxChange);
        }
        if (hasStepAttr) {
          ctrl.$validators.step = supportsRange ? function nativeStepValidator() {
            return !validity.stepMismatch;
          } : function stepValidator(modelValue, viewValue) {
            return ctrl.$isEmpty(viewValue) || isUndefined(stepVal) || isValidForStep(viewValue, minVal || 0, stepVal);
          };
          setInitialValueAndObserver('step', stepChange);
        }
        function setInitialValueAndObserver(htmlAttrName, changeFn) {
          element.attr(htmlAttrName, attr[htmlAttrName]);
          attr.$observe(htmlAttrName, changeFn);
        }
        function minChange(val) {
          minVal = parseNumberAttrVal(val);
          if (isNumberNaN(ctrl.$modelValue)) {
            return;
          }
          if (supportsRange) {
            var elVal = element.val();
            if (minVal > elVal) {
              elVal = minVal;
              element.val(elVal);
            }
            ctrl.$setViewValue(elVal);
          } else {
            ctrl.$validate();
          }
        }
        function maxChange(val) {
          maxVal = parseNumberAttrVal(val);
          if (isNumberNaN(ctrl.$modelValue)) {
            return;
          }
          if (supportsRange) {
            var elVal = element.val();
            if (maxVal < elVal) {
              element.val(maxVal);
              elVal = maxVal < minVal ? minVal : maxVal;
            }
            ctrl.$setViewValue(elVal);
          } else {
            ctrl.$validate();
          }
        }
        function stepChange(val) {
          stepVal = parseNumberAttrVal(val);
          if (isNumberNaN(ctrl.$modelValue)) {
            return;
          }
          if (supportsRange && ctrl.$viewValue !== element.val()) {
            ctrl.$setViewValue(element.val());
          } else {
            ctrl.$validate();
          }
        }
      }
      function urlInputType(scope, element, attr, ctrl, $sniffer, $browser) {
        baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
        stringBasedInputType(ctrl);
        ctrl.$$parserName = 'url';
        ctrl.$validators.url = function(modelValue, viewValue) {
          var value = modelValue || viewValue;
          return ctrl.$isEmpty(value) || URL_REGEXP.test(value);
        };
      }
      function emailInputType(scope, element, attr, ctrl, $sniffer, $browser) {
        baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
        stringBasedInputType(ctrl);
        ctrl.$$parserName = 'email';
        ctrl.$validators.email = function(modelValue, viewValue) {
          var value = modelValue || viewValue;
          return ctrl.$isEmpty(value) || EMAIL_REGEXP.test(value);
        };
      }
      function radioInputType(scope, element, attr, ctrl) {
        var doTrim = !attr.ngTrim || trim(attr.ngTrim) !== 'false';
        if (isUndefined(attr.name)) {
          element.attr('name', nextUid());
        }
        var listener = function(ev) {
          var value;
          if (element[0].checked) {
            value = attr.value;
            if (doTrim) {
              value = trim(value);
            }
            ctrl.$setViewValue(value, ev && ev.type);
          }
        };
        element.on('click', listener);
        ctrl.$render = function() {
          var value = attr.value;
          if (doTrim) {
            value = trim(value);
          }
          element[0].checked = (value === ctrl.$viewValue);
        };
        attr.$observe('value', ctrl.$render);
      }
      function parseConstantExpr($parse, context, name, expression, fallback) {
        var parseFn;
        if (isDefined(expression)) {
          parseFn = $parse(expression);
          if (!parseFn.constant) {
            throw ngModelMinErr('constexpr', 'Expected constant expression for `{0}`, but saw ' + '`{1}`.', name, expression);
          }
          return parseFn(context);
        }
        return fallback;
      }
      function checkboxInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter, $parse) {
        var trueValue = parseConstantExpr($parse, scope, 'ngTrueValue', attr.ngTrueValue, true);
        var falseValue = parseConstantExpr($parse, scope, 'ngFalseValue', attr.ngFalseValue, false);
        var listener = function(ev) {
          ctrl.$setViewValue(element[0].checked, ev && ev.type);
        };
        element.on('click', listener);
        ctrl.$render = function() {
          element[0].checked = ctrl.$viewValue;
        };
        ctrl.$isEmpty = function(value) {
          return value === false;
        };
        ctrl.$formatters.push(function(value) {
          return equals(value, trueValue);
        });
        ctrl.$parsers.push(function(value) {
          return value ? trueValue : falseValue;
        });
      }
      var inputDirective = ['$browser', '$sniffer', '$filter', '$parse', function($browser, $sniffer, $filter, $parse) {
        return {
          restrict: 'E',
          require: ['?ngModel'],
          link: {pre: function(scope, element, attr, ctrls) {
              if (ctrls[0]) {
                (inputType[lowercase(attr.type)] || inputType.text)(scope, element, attr, ctrls[0], $sniffer, $browser, $filter, $parse);
              }
            }}
        };
      }];
      var CONSTANT_VALUE_REGEXP = /^(true|false|\d+)$/;
      var ngValueDirective = function() {
        function updateElementValue(element, attr, value) {
          var propValue = isDefined(value) ? value : (msie === 9) ? '' : null;
          element.prop('value', propValue);
          attr.$set('value', value);
        }
        return {
          restrict: 'A',
          priority: 100,
          compile: function(tpl, tplAttr) {
            if (CONSTANT_VALUE_REGEXP.test(tplAttr.ngValue)) {
              return function ngValueConstantLink(scope, elm, attr) {
                var value = scope.$eval(attr.ngValue);
                updateElementValue(elm, attr, value);
              };
            } else {
              return function ngValueLink(scope, elm, attr) {
                scope.$watch(attr.ngValue, function valueWatchAction(value) {
                  updateElementValue(elm, attr, value);
                });
              };
            }
          }
        };
      };
      var ngBindDirective = ['$compile', function($compile) {
        return {
          restrict: 'AC',
          compile: function ngBindCompile(templateElement) {
            $compile.$$addBindingClass(templateElement);
            return function ngBindLink(scope, element, attr) {
              $compile.$$addBindingInfo(element, attr.ngBind);
              element = element[0];
              scope.$watch(attr.ngBind, function ngBindWatchAction(value) {
                element.textContent = stringify(value);
              });
            };
          }
        };
      }];
      var ngBindTemplateDirective = ['$interpolate', '$compile', function($interpolate, $compile) {
        return {compile: function ngBindTemplateCompile(templateElement) {
            $compile.$$addBindingClass(templateElement);
            return function ngBindTemplateLink(scope, element, attr) {
              var interpolateFn = $interpolate(element.attr(attr.$attr.ngBindTemplate));
              $compile.$$addBindingInfo(element, interpolateFn.expressions);
              element = element[0];
              attr.$observe('ngBindTemplate', function(value) {
                element.textContent = isUndefined(value) ? '' : value;
              });
            };
          }};
      }];
      var ngBindHtmlDirective = ['$sce', '$parse', '$compile', function($sce, $parse, $compile) {
        return {
          restrict: 'A',
          compile: function ngBindHtmlCompile(tElement, tAttrs) {
            var ngBindHtmlGetter = $parse(tAttrs.ngBindHtml);
            var ngBindHtmlWatch = $parse(tAttrs.ngBindHtml, function sceValueOf(val) {
              return $sce.valueOf(val);
            });
            $compile.$$addBindingClass(tElement);
            return function ngBindHtmlLink(scope, element, attr) {
              $compile.$$addBindingInfo(element, attr.ngBindHtml);
              scope.$watch(ngBindHtmlWatch, function ngBindHtmlWatchAction() {
                var value = ngBindHtmlGetter(scope);
                element.html($sce.getTrustedHtml(value) || '');
              });
            };
          }
        };
      }];
      var ngChangeDirective = valueFn({
        restrict: 'A',
        require: 'ngModel',
        link: function(scope, element, attr, ctrl) {
          ctrl.$viewChangeListeners.push(function() {
            scope.$eval(attr.ngChange);
          });
        }
      });
      function classDirective(name, selector) {
        name = 'ngClass' + name;
        var indexWatchExpression;
        return ['$parse', function($parse) {
          return {
            restrict: 'AC',
            link: function(scope, element, attr) {
              var expression = attr[name].trim();
              var isOneTime = (expression.charAt(0) === ':') && (expression.charAt(1) === ':');
              var watchInterceptor = isOneTime ? toFlatValue : toClassString;
              var watchExpression = $parse(expression, watchInterceptor);
              var watchAction = isOneTime ? ngClassOneTimeWatchAction : ngClassWatchAction;
              var classCounts = element.data('$classCounts');
              var oldModulo = true;
              var oldClassString;
              if (!classCounts) {
                classCounts = createMap();
                element.data('$classCounts', classCounts);
              }
              if (name !== 'ngClass') {
                if (!indexWatchExpression) {
                  indexWatchExpression = $parse('$index', function moduloTwo($index) {
                    return $index & 1;
                  });
                }
                scope.$watch(indexWatchExpression, ngClassIndexWatchAction);
              }
              scope.$watch(watchExpression, watchAction, isOneTime);
              function addClasses(classString) {
                classString = digestClassCounts(split(classString), 1);
                attr.$addClass(classString);
              }
              function removeClasses(classString) {
                classString = digestClassCounts(split(classString), -1);
                attr.$removeClass(classString);
              }
              function updateClasses(oldClassString, newClassString) {
                var oldClassArray = split(oldClassString);
                var newClassArray = split(newClassString);
                var toRemoveArray = arrayDifference(oldClassArray, newClassArray);
                var toAddArray = arrayDifference(newClassArray, oldClassArray);
                var toRemoveString = digestClassCounts(toRemoveArray, -1);
                var toAddString = digestClassCounts(toAddArray, 1);
                attr.$addClass(toAddString);
                attr.$removeClass(toRemoveString);
              }
              function digestClassCounts(classArray, count) {
                var classesToUpdate = [];
                forEach(classArray, function(className) {
                  if (count > 0 || classCounts[className]) {
                    classCounts[className] = (classCounts[className] || 0) + count;
                    if (classCounts[className] === +(count > 0)) {
                      classesToUpdate.push(className);
                    }
                  }
                });
                return classesToUpdate.join(' ');
              }
              function ngClassIndexWatchAction(newModulo) {
                if (newModulo === selector) {
                  addClasses(oldClassString);
                } else {
                  removeClasses(oldClassString);
                }
                oldModulo = newModulo;
              }
              function ngClassOneTimeWatchAction(newClassValue) {
                var newClassString = toClassString(newClassValue);
                if (newClassString !== oldClassString) {
                  ngClassWatchAction(newClassString);
                }
              }
              function ngClassWatchAction(newClassString) {
                if (oldModulo === selector) {
                  updateClasses(oldClassString, newClassString);
                }
                oldClassString = newClassString;
              }
            }
          };
        }];
        function arrayDifference(tokens1, tokens2) {
          if (!tokens1 || !tokens1.length)
            return [];
          if (!tokens2 || !tokens2.length)
            return tokens1;
          var values = [];
          outer: for (var i = 0; i < tokens1.length; i++) {
            var token = tokens1[i];
            for (var j = 0; j < tokens2.length; j++) {
              if (token === tokens2[j])
                continue outer;
            }
            values.push(token);
          }
          return values;
        }
        function split(classString) {
          return classString && classString.split(' ');
        }
        function toClassString(classValue) {
          var classString = classValue;
          if (isArray(classValue)) {
            classString = classValue.map(toClassString).join(' ');
          } else if (isObject(classValue)) {
            classString = Object.keys(classValue).filter(function(key) {
              return classValue[key];
            }).join(' ');
          }
          return classString;
        }
        function toFlatValue(classValue) {
          var flatValue = classValue;
          if (isArray(classValue)) {
            flatValue = classValue.map(toFlatValue);
          } else if (isObject(classValue)) {
            var hasUndefined = false;
            flatValue = Object.keys(classValue).filter(function(key) {
              var value = classValue[key];
              if (!hasUndefined && isUndefined(value)) {
                hasUndefined = true;
              }
              return value;
            });
            if (hasUndefined) {
              flatValue.push(undefined);
            }
          }
          return flatValue;
        }
      }
      var ngClassDirective = classDirective('', true);
      var ngClassOddDirective = classDirective('Odd', 0);
      var ngClassEvenDirective = classDirective('Even', 1);
      var ngCloakDirective = ngDirective({compile: function(element, attr) {
          attr.$set('ngCloak', undefined);
          element.removeClass('ng-cloak');
        }});
      var ngControllerDirective = [function() {
        return {
          restrict: 'A',
          scope: true,
          controller: '@',
          priority: 500
        };
      }];
      var ngEventDirectives = {};
      var forceAsyncEvents = {
        'blur': true,
        'focus': true
      };
      forEach('click dblclick mousedown mouseup mouseover mouseout mousemove mouseenter mouseleave keydown keyup keypress submit focus blur copy cut paste'.split(' '), function(eventName) {
        var directiveName = directiveNormalize('ng-' + eventName);
        ngEventDirectives[directiveName] = ['$parse', '$rootScope', function($parse, $rootScope) {
          return {
            restrict: 'A',
            compile: function($element, attr) {
              var fn = $parse(attr[directiveName]);
              return function ngEventHandler(scope, element) {
                element.on(eventName, function(event) {
                  var callback = function() {
                    fn(scope, {$event: event});
                  };
                  if (forceAsyncEvents[eventName] && $rootScope.$$phase) {
                    scope.$evalAsync(callback);
                  } else {
                    scope.$apply(callback);
                  }
                });
              };
            }
          };
        }];
      });
      var ngIfDirective = ['$animate', '$compile', function($animate, $compile) {
        return {
          multiElement: true,
          transclude: 'element',
          priority: 600,
          terminal: true,
          restrict: 'A',
          $$tlb: true,
          link: function($scope, $element, $attr, ctrl, $transclude) {
            var block,
                childScope,
                previousElements;
            $scope.$watch($attr.ngIf, function ngIfWatchAction(value) {
              if (value) {
                if (!childScope) {
                  $transclude(function(clone, newScope) {
                    childScope = newScope;
                    clone[clone.length++] = $compile.$$createComment('end ngIf', $attr.ngIf);
                    block = {clone: clone};
                    $animate.enter(clone, $element.parent(), $element);
                  });
                }
              } else {
                if (previousElements) {
                  previousElements.remove();
                  previousElements = null;
                }
                if (childScope) {
                  childScope.$destroy();
                  childScope = null;
                }
                if (block) {
                  previousElements = getBlockNodes(block.clone);
                  $animate.leave(previousElements).done(function(response) {
                    if (response !== false)
                      previousElements = null;
                  });
                  block = null;
                }
              }
            });
          }
        };
      }];
      var ngIncludeDirective = ['$templateRequest', '$anchorScroll', '$animate', function($templateRequest, $anchorScroll, $animate) {
        return {
          restrict: 'ECA',
          priority: 400,
          terminal: true,
          transclude: 'element',
          controller: angular.noop,
          compile: function(element, attr) {
            var srcExp = attr.ngInclude || attr.src,
                onloadExp = attr.onload || '',
                autoScrollExp = attr.autoscroll;
            return function(scope, $element, $attr, ctrl, $transclude) {
              var changeCounter = 0,
                  currentScope,
                  previousElement,
                  currentElement;
              var cleanupLastIncludeContent = function() {
                if (previousElement) {
                  previousElement.remove();
                  previousElement = null;
                }
                if (currentScope) {
                  currentScope.$destroy();
                  currentScope = null;
                }
                if (currentElement) {
                  $animate.leave(currentElement).done(function(response) {
                    if (response !== false)
                      previousElement = null;
                  });
                  previousElement = currentElement;
                  currentElement = null;
                }
              };
              scope.$watch(srcExp, function ngIncludeWatchAction(src) {
                var afterAnimation = function(response) {
                  if (response !== false && isDefined(autoScrollExp) && (!autoScrollExp || scope.$eval(autoScrollExp))) {
                    $anchorScroll();
                  }
                };
                var thisChangeId = ++changeCounter;
                if (src) {
                  $templateRequest(src, true).then(function(response) {
                    if (scope.$$destroyed)
                      return;
                    if (thisChangeId !== changeCounter)
                      return;
                    var newScope = scope.$new();
                    ctrl.template = response;
                    var clone = $transclude(newScope, function(clone) {
                      cleanupLastIncludeContent();
                      $animate.enter(clone, null, $element).done(afterAnimation);
                    });
                    currentScope = newScope;
                    currentElement = clone;
                    currentScope.$emit('$includeContentLoaded', src);
                    scope.$eval(onloadExp);
                  }, function() {
                    if (scope.$$destroyed)
                      return;
                    if (thisChangeId === changeCounter) {
                      cleanupLastIncludeContent();
                      scope.$emit('$includeContentError', src);
                    }
                  });
                  scope.$emit('$includeContentRequested', src);
                } else {
                  cleanupLastIncludeContent();
                  ctrl.template = null;
                }
              });
            };
          }
        };
      }];
      var ngIncludeFillContentDirective = ['$compile', function($compile) {
        return {
          restrict: 'ECA',
          priority: -400,
          require: 'ngInclude',
          link: function(scope, $element, $attr, ctrl) {
            if (toString.call($element[0]).match(/SVG/)) {
              $element.empty();
              $compile(jqLiteBuildFragment(ctrl.template, window.document).childNodes)(scope, function namespaceAdaptedClone(clone) {
                $element.append(clone);
              }, {futureParentElement: $element});
              return;
            }
            $element.html(ctrl.template);
            $compile($element.contents())(scope);
          }
        };
      }];
      var ngInitDirective = ngDirective({
        priority: 450,
        compile: function() {
          return {pre: function(scope, element, attrs) {
              scope.$eval(attrs.ngInit);
            }};
        }
      });
      var ngListDirective = function() {
        return {
          restrict: 'A',
          priority: 100,
          require: 'ngModel',
          link: function(scope, element, attr, ctrl) {
            var ngList = attr.ngList || ', ';
            var trimValues = attr.ngTrim !== 'false';
            var separator = trimValues ? trim(ngList) : ngList;
            var parse = function(viewValue) {
              if (isUndefined(viewValue))
                return;
              var list = [];
              if (viewValue) {
                forEach(viewValue.split(separator), function(value) {
                  if (value)
                    list.push(trimValues ? trim(value) : value);
                });
              }
              return list;
            };
            ctrl.$parsers.push(parse);
            ctrl.$formatters.push(function(value) {
              if (isArray(value)) {
                return value.join(ngList);
              }
              return undefined;
            });
            ctrl.$isEmpty = function(value) {
              return !value || !value.length;
            };
          }
        };
      };
      var VALID_CLASS = 'ng-valid',
          INVALID_CLASS = 'ng-invalid',
          PRISTINE_CLASS = 'ng-pristine',
          DIRTY_CLASS = 'ng-dirty',
          UNTOUCHED_CLASS = 'ng-untouched',
          TOUCHED_CLASS = 'ng-touched',
          EMPTY_CLASS = 'ng-empty',
          NOT_EMPTY_CLASS = 'ng-not-empty';
      var ngModelMinErr = minErr('ngModel');
      NgModelController.$inject = ['$scope', '$exceptionHandler', '$attrs', '$element', '$parse', '$animate', '$timeout', '$q', '$interpolate'];
      function NgModelController($scope, $exceptionHandler, $attr, $element, $parse, $animate, $timeout, $q, $interpolate) {
        this.$viewValue = Number.NaN;
        this.$modelValue = Number.NaN;
        this.$$rawModelValue = undefined;
        this.$validators = {};
        this.$asyncValidators = {};
        this.$parsers = [];
        this.$formatters = [];
        this.$viewChangeListeners = [];
        this.$untouched = true;
        this.$touched = false;
        this.$pristine = true;
        this.$dirty = false;
        this.$valid = true;
        this.$invalid = false;
        this.$error = {};
        this.$$success = {};
        this.$pending = undefined;
        this.$name = $interpolate($attr.name || '', false)($scope);
        this.$$parentForm = nullFormCtrl;
        this.$options = defaultModelOptions;
        this.$$updateEvents = '';
        this.$$updateEventHandler = this.$$updateEventHandler.bind(this);
        this.$$parsedNgModel = $parse($attr.ngModel);
        this.$$parsedNgModelAssign = this.$$parsedNgModel.assign;
        this.$$ngModelGet = this.$$parsedNgModel;
        this.$$ngModelSet = this.$$parsedNgModelAssign;
        this.$$pendingDebounce = null;
        this.$$parserValid = undefined;
        this.$$currentValidationRunId = 0;
        Object.defineProperty(this, '$$scope', {value: $scope});
        this.$$attr = $attr;
        this.$$element = $element;
        this.$$animate = $animate;
        this.$$timeout = $timeout;
        this.$$parse = $parse;
        this.$$q = $q;
        this.$$exceptionHandler = $exceptionHandler;
        setupValidity(this);
        setupModelWatcher(this);
      }
      NgModelController.prototype = {
        $$initGetterSetters: function() {
          if (this.$options.getOption('getterSetter')) {
            var invokeModelGetter = this.$$parse(this.$$attr.ngModel + '()'),
                invokeModelSetter = this.$$parse(this.$$attr.ngModel + '($$$p)');
            this.$$ngModelGet = function($scope) {
              var modelValue = this.$$parsedNgModel($scope);
              if (isFunction(modelValue)) {
                modelValue = invokeModelGetter($scope);
              }
              return modelValue;
            };
            this.$$ngModelSet = function($scope, newValue) {
              if (isFunction(this.$$parsedNgModel($scope))) {
                invokeModelSetter($scope, {$$$p: newValue});
              } else {
                this.$$parsedNgModelAssign($scope, newValue);
              }
            };
          } else if (!this.$$parsedNgModel.assign) {
            throw ngModelMinErr('nonassign', 'Expression \'{0}\' is non-assignable. Element: {1}', this.$$attr.ngModel, startingTag(this.$$element));
          }
        },
        $render: noop,
        $isEmpty: function(value) {
          return isUndefined(value) || value === '' || value === null || value !== value;
        },
        $$updateEmptyClasses: function(value) {
          if (this.$isEmpty(value)) {
            this.$$animate.removeClass(this.$$element, NOT_EMPTY_CLASS);
            this.$$animate.addClass(this.$$element, EMPTY_CLASS);
          } else {
            this.$$animate.removeClass(this.$$element, EMPTY_CLASS);
            this.$$animate.addClass(this.$$element, NOT_EMPTY_CLASS);
          }
        },
        $setPristine: function() {
          this.$dirty = false;
          this.$pristine = true;
          this.$$animate.removeClass(this.$$element, DIRTY_CLASS);
          this.$$animate.addClass(this.$$element, PRISTINE_CLASS);
        },
        $setDirty: function() {
          this.$dirty = true;
          this.$pristine = false;
          this.$$animate.removeClass(this.$$element, PRISTINE_CLASS);
          this.$$animate.addClass(this.$$element, DIRTY_CLASS);
          this.$$parentForm.$setDirty();
        },
        $setUntouched: function() {
          this.$touched = false;
          this.$untouched = true;
          this.$$animate.setClass(this.$$element, UNTOUCHED_CLASS, TOUCHED_CLASS);
        },
        $setTouched: function() {
          this.$touched = true;
          this.$untouched = false;
          this.$$animate.setClass(this.$$element, TOUCHED_CLASS, UNTOUCHED_CLASS);
        },
        $rollbackViewValue: function() {
          this.$$timeout.cancel(this.$$pendingDebounce);
          this.$viewValue = this.$$lastCommittedViewValue;
          this.$render();
        },
        $validate: function() {
          if (isNumberNaN(this.$modelValue)) {
            return;
          }
          var viewValue = this.$$lastCommittedViewValue;
          var modelValue = this.$$rawModelValue;
          var prevValid = this.$valid;
          var prevModelValue = this.$modelValue;
          var allowInvalid = this.$options.getOption('allowInvalid');
          var that = this;
          this.$$runValidators(modelValue, viewValue, function(allValid) {
            if (!allowInvalid && prevValid !== allValid) {
              that.$modelValue = allValid ? modelValue : undefined;
              if (that.$modelValue !== prevModelValue) {
                that.$$writeModelToScope();
              }
            }
          });
        },
        $$runValidators: function(modelValue, viewValue, doneCallback) {
          this.$$currentValidationRunId++;
          var localValidationRunId = this.$$currentValidationRunId;
          var that = this;
          if (!processParseErrors()) {
            validationDone(false);
            return;
          }
          if (!processSyncValidators()) {
            validationDone(false);
            return;
          }
          processAsyncValidators();
          function processParseErrors() {
            var errorKey = that.$$parserName || 'parse';
            if (isUndefined(that.$$parserValid)) {
              setValidity(errorKey, null);
            } else {
              if (!that.$$parserValid) {
                forEach(that.$validators, function(v, name) {
                  setValidity(name, null);
                });
                forEach(that.$asyncValidators, function(v, name) {
                  setValidity(name, null);
                });
              }
              setValidity(errorKey, that.$$parserValid);
              return that.$$parserValid;
            }
            return true;
          }
          function processSyncValidators() {
            var syncValidatorsValid = true;
            forEach(that.$validators, function(validator, name) {
              var result = Boolean(validator(modelValue, viewValue));
              syncValidatorsValid = syncValidatorsValid && result;
              setValidity(name, result);
            });
            if (!syncValidatorsValid) {
              forEach(that.$asyncValidators, function(v, name) {
                setValidity(name, null);
              });
              return false;
            }
            return true;
          }
          function processAsyncValidators() {
            var validatorPromises = [];
            var allValid = true;
            forEach(that.$asyncValidators, function(validator, name) {
              var promise = validator(modelValue, viewValue);
              if (!isPromiseLike(promise)) {
                throw ngModelMinErr('nopromise', 'Expected asynchronous validator to return a promise but got \'{0}\' instead.', promise);
              }
              setValidity(name, undefined);
              validatorPromises.push(promise.then(function() {
                setValidity(name, true);
              }, function() {
                allValid = false;
                setValidity(name, false);
              }));
            });
            if (!validatorPromises.length) {
              validationDone(true);
            } else {
              that.$$q.all(validatorPromises).then(function() {
                validationDone(allValid);
              }, noop);
            }
          }
          function setValidity(name, isValid) {
            if (localValidationRunId === that.$$currentValidationRunId) {
              that.$setValidity(name, isValid);
            }
          }
          function validationDone(allValid) {
            if (localValidationRunId === that.$$currentValidationRunId) {
              doneCallback(allValid);
            }
          }
        },
        $commitViewValue: function() {
          var viewValue = this.$viewValue;
          this.$$timeout.cancel(this.$$pendingDebounce);
          if (this.$$lastCommittedViewValue === viewValue && (viewValue !== '' || !this.$$hasNativeValidators)) {
            return;
          }
          this.$$updateEmptyClasses(viewValue);
          this.$$lastCommittedViewValue = viewValue;
          if (this.$pristine) {
            this.$setDirty();
          }
          this.$$parseAndValidate();
        },
        $$parseAndValidate: function() {
          var viewValue = this.$$lastCommittedViewValue;
          var modelValue = viewValue;
          var that = this;
          this.$$parserValid = isUndefined(modelValue) ? undefined : true;
          if (this.$$parserValid) {
            for (var i = 0; i < this.$parsers.length; i++) {
              modelValue = this.$parsers[i](modelValue);
              if (isUndefined(modelValue)) {
                this.$$parserValid = false;
                break;
              }
            }
          }
          if (isNumberNaN(this.$modelValue)) {
            this.$modelValue = this.$$ngModelGet(this.$$scope);
          }
          var prevModelValue = this.$modelValue;
          var allowInvalid = this.$options.getOption('allowInvalid');
          this.$$rawModelValue = modelValue;
          if (allowInvalid) {
            this.$modelValue = modelValue;
            writeToModelIfNeeded();
          }
          this.$$runValidators(modelValue, this.$$lastCommittedViewValue, function(allValid) {
            if (!allowInvalid) {
              that.$modelValue = allValid ? modelValue : undefined;
              writeToModelIfNeeded();
            }
          });
          function writeToModelIfNeeded() {
            if (that.$modelValue !== prevModelValue) {
              that.$$writeModelToScope();
            }
          }
        },
        $$writeModelToScope: function() {
          this.$$ngModelSet(this.$$scope, this.$modelValue);
          forEach(this.$viewChangeListeners, function(listener) {
            try {
              listener();
            } catch (e) {
              this.$$exceptionHandler(e);
            }
          }, this);
        },
        $setViewValue: function(value, trigger) {
          this.$viewValue = value;
          if (this.$options.getOption('updateOnDefault')) {
            this.$$debounceViewValueCommit(trigger);
          }
        },
        $$debounceViewValueCommit: function(trigger) {
          var debounceDelay = this.$options.getOption('debounce');
          if (isNumber(debounceDelay[trigger])) {
            debounceDelay = debounceDelay[trigger];
          } else if (isNumber(debounceDelay['default'])) {
            debounceDelay = debounceDelay['default'];
          }
          this.$$timeout.cancel(this.$$pendingDebounce);
          var that = this;
          if (debounceDelay > 0) {
            this.$$pendingDebounce = this.$$timeout(function() {
              that.$commitViewValue();
            }, debounceDelay);
          } else if (this.$$scope.$root.$$phase) {
            this.$commitViewValue();
          } else {
            this.$$scope.$apply(function() {
              that.$commitViewValue();
            });
          }
        },
        $overrideModelOptions: function(options) {
          this.$options = this.$options.createChild(options);
          this.$$setUpdateOnEvents();
        },
        $processModelValue: function() {
          var viewValue = this.$$format();
          if (this.$viewValue !== viewValue) {
            this.$$updateEmptyClasses(viewValue);
            this.$viewValue = this.$$lastCommittedViewValue = viewValue;
            this.$render();
            this.$$runValidators(this.$modelValue, this.$viewValue, noop);
          }
        },
        $$format: function() {
          var formatters = this.$formatters,
              idx = formatters.length;
          var viewValue = this.$modelValue;
          while (idx--) {
            viewValue = formatters[idx](viewValue);
          }
          return viewValue;
        },
        $$setModelValue: function(modelValue) {
          this.$modelValue = this.$$rawModelValue = modelValue;
          this.$$parserValid = undefined;
          this.$processModelValue();
        },
        $$setUpdateOnEvents: function() {
          if (this.$$updateEvents) {
            this.$$element.off(this.$$updateEvents, this.$$updateEventHandler);
          }
          this.$$updateEvents = this.$options.getOption('updateOn');
          if (this.$$updateEvents) {
            this.$$element.on(this.$$updateEvents, this.$$updateEventHandler);
          }
        },
        $$updateEventHandler: function(ev) {
          this.$$debounceViewValueCommit(ev && ev.type);
        }
      };
      function setupModelWatcher(ctrl) {
        ctrl.$$scope.$watch(function ngModelWatch(scope) {
          var modelValue = ctrl.$$ngModelGet(scope);
          if (modelValue !== ctrl.$modelValue && (ctrl.$modelValue === ctrl.$modelValue || modelValue === modelValue)) {
            ctrl.$$setModelValue(modelValue);
          }
          return modelValue;
        });
      }
      addSetValidityMethod({
        clazz: NgModelController,
        set: function(object, property) {
          object[property] = true;
        },
        unset: function(object, property) {
          delete object[property];
        }
      });
      var ngModelDirective = ['$rootScope', function($rootScope) {
        return {
          restrict: 'A',
          require: ['ngModel', '^?form', '^?ngModelOptions'],
          controller: NgModelController,
          priority: 1,
          compile: function ngModelCompile(element) {
            element.addClass(PRISTINE_CLASS).addClass(UNTOUCHED_CLASS).addClass(VALID_CLASS);
            return {
              pre: function ngModelPreLink(scope, element, attr, ctrls) {
                var modelCtrl = ctrls[0],
                    formCtrl = ctrls[1] || modelCtrl.$$parentForm,
                    optionsCtrl = ctrls[2];
                if (optionsCtrl) {
                  modelCtrl.$options = optionsCtrl.$options;
                }
                modelCtrl.$$initGetterSetters();
                formCtrl.$addControl(modelCtrl);
                attr.$observe('name', function(newValue) {
                  if (modelCtrl.$name !== newValue) {
                    modelCtrl.$$parentForm.$$renameControl(modelCtrl, newValue);
                  }
                });
                scope.$on('$destroy', function() {
                  modelCtrl.$$parentForm.$removeControl(modelCtrl);
                });
              },
              post: function ngModelPostLink(scope, element, attr, ctrls) {
                var modelCtrl = ctrls[0];
                modelCtrl.$$setUpdateOnEvents();
                function setTouched() {
                  modelCtrl.$setTouched();
                }
                element.on('blur', function() {
                  if (modelCtrl.$touched)
                    return;
                  if ($rootScope.$$phase) {
                    scope.$evalAsync(setTouched);
                  } else {
                    scope.$apply(setTouched);
                  }
                });
              }
            };
          }
        };
      }];
      var defaultModelOptions;
      var DEFAULT_REGEXP = /(\s+|^)default(\s+|$)/;
      function ModelOptions(options) {
        this.$$options = options;
      }
      ModelOptions.prototype = {
        getOption: function(name) {
          return this.$$options[name];
        },
        createChild: function(options) {
          var inheritAll = false;
          options = extend({}, options);
          forEach(options, function(option, key) {
            if (option === '$inherit') {
              if (key === '*') {
                inheritAll = true;
              } else {
                options[key] = this.$$options[key];
                if (key === 'updateOn') {
                  options.updateOnDefault = this.$$options.updateOnDefault;
                }
              }
            } else {
              if (key === 'updateOn') {
                options.updateOnDefault = false;
                options[key] = trim(option.replace(DEFAULT_REGEXP, function() {
                  options.updateOnDefault = true;
                  return ' ';
                }));
              }
            }
          }, this);
          if (inheritAll) {
            delete options['*'];
            defaults(options, this.$$options);
          }
          defaults(options, defaultModelOptions.$$options);
          return new ModelOptions(options);
        }
      };
      defaultModelOptions = new ModelOptions({
        updateOn: '',
        updateOnDefault: true,
        debounce: 0,
        getterSetter: false,
        allowInvalid: false,
        timezone: null
      });
      var ngModelOptionsDirective = function() {
        NgModelOptionsController.$inject = ['$attrs', '$scope'];
        function NgModelOptionsController($attrs, $scope) {
          this.$$attrs = $attrs;
          this.$$scope = $scope;
        }
        NgModelOptionsController.prototype = {$onInit: function() {
            var parentOptions = this.parentCtrl ? this.parentCtrl.$options : defaultModelOptions;
            var modelOptionsDefinition = this.$$scope.$eval(this.$$attrs.ngModelOptions);
            this.$options = parentOptions.createChild(modelOptionsDefinition);
          }};
        return {
          restrict: 'A',
          priority: 10,
          require: {parentCtrl: '?^^ngModelOptions'},
          bindToController: true,
          controller: NgModelOptionsController
        };
      };
      function defaults(dst, src) {
        forEach(src, function(value, key) {
          if (!isDefined(dst[key])) {
            dst[key] = value;
          }
        });
      }
      var ngNonBindableDirective = ngDirective({
        terminal: true,
        priority: 1000
      });
      var ngOptionsMinErr = minErr('ngOptions');
      var NG_OPTIONS_REGEXP = /^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+group\s+by\s+([\s\S]+?))?(?:\s+disable\s+when\s+([\s\S]+?))?\s+for\s+(?:([$\w][$\w]*)|(?:\(\s*([$\w][$\w]*)\s*,\s*([$\w][$\w]*)\s*\)))\s+in\s+([\s\S]+?)(?:\s+track\s+by\s+([\s\S]+?))?$/;
      var ngOptionsDirective = ['$compile', '$document', '$parse', function($compile, $document, $parse) {
        function parseOptionsExpression(optionsExp, selectElement, scope) {
          var match = optionsExp.match(NG_OPTIONS_REGEXP);
          if (!(match)) {
            throw ngOptionsMinErr('iexp', 'Expected expression in form of ' + '\'_select_ (as _label_)? for (_key_,)?_value_ in _collection_\'' + ' but got \'{0}\'. Element: {1}', optionsExp, startingTag(selectElement));
          }
          var valueName = match[5] || match[7];
          var keyName = match[6];
          var selectAs = / as /.test(match[0]) && match[1];
          var trackBy = match[9];
          var valueFn = $parse(match[2] ? match[1] : valueName);
          var selectAsFn = selectAs && $parse(selectAs);
          var viewValueFn = selectAsFn || valueFn;
          var trackByFn = trackBy && $parse(trackBy);
          var getTrackByValueFn = trackBy ? function(value, locals) {
            return trackByFn(scope, locals);
          } : function getHashOfValue(value) {
            return hashKey(value);
          };
          var getTrackByValue = function(value, key) {
            return getTrackByValueFn(value, getLocals(value, key));
          };
          var displayFn = $parse(match[2] || match[1]);
          var groupByFn = $parse(match[3] || '');
          var disableWhenFn = $parse(match[4] || '');
          var valuesFn = $parse(match[8]);
          var locals = {};
          var getLocals = keyName ? function(value, key) {
            locals[keyName] = key;
            locals[valueName] = value;
            return locals;
          } : function(value) {
            locals[valueName] = value;
            return locals;
          };
          function Option(selectValue, viewValue, label, group, disabled) {
            this.selectValue = selectValue;
            this.viewValue = viewValue;
            this.label = label;
            this.group = group;
            this.disabled = disabled;
          }
          function getOptionValuesKeys(optionValues) {
            var optionValuesKeys;
            if (!keyName && isArrayLike(optionValues)) {
              optionValuesKeys = optionValues;
            } else {
              optionValuesKeys = [];
              for (var itemKey in optionValues) {
                if (optionValues.hasOwnProperty(itemKey) && itemKey.charAt(0) !== '$') {
                  optionValuesKeys.push(itemKey);
                }
              }
            }
            return optionValuesKeys;
          }
          return {
            trackBy: trackBy,
            getTrackByValue: getTrackByValue,
            getWatchables: $parse(valuesFn, function(optionValues) {
              var watchedArray = [];
              optionValues = optionValues || [];
              var optionValuesKeys = getOptionValuesKeys(optionValues);
              var optionValuesLength = optionValuesKeys.length;
              for (var index = 0; index < optionValuesLength; index++) {
                var key = (optionValues === optionValuesKeys) ? index : optionValuesKeys[index];
                var value = optionValues[key];
                var locals = getLocals(value, key);
                var selectValue = getTrackByValueFn(value, locals);
                watchedArray.push(selectValue);
                if (match[2] || match[1]) {
                  var label = displayFn(scope, locals);
                  watchedArray.push(label);
                }
                if (match[4]) {
                  var disableWhen = disableWhenFn(scope, locals);
                  watchedArray.push(disableWhen);
                }
              }
              return watchedArray;
            }),
            getOptions: function() {
              var optionItems = [];
              var selectValueMap = {};
              var optionValues = valuesFn(scope) || [];
              var optionValuesKeys = getOptionValuesKeys(optionValues);
              var optionValuesLength = optionValuesKeys.length;
              for (var index = 0; index < optionValuesLength; index++) {
                var key = (optionValues === optionValuesKeys) ? index : optionValuesKeys[index];
                var value = optionValues[key];
                var locals = getLocals(value, key);
                var viewValue = viewValueFn(scope, locals);
                var selectValue = getTrackByValueFn(viewValue, locals);
                var label = displayFn(scope, locals);
                var group = groupByFn(scope, locals);
                var disabled = disableWhenFn(scope, locals);
                var optionItem = new Option(selectValue, viewValue, label, group, disabled);
                optionItems.push(optionItem);
                selectValueMap[selectValue] = optionItem;
              }
              return {
                items: optionItems,
                selectValueMap: selectValueMap,
                getOptionFromViewValue: function(value) {
                  return selectValueMap[getTrackByValue(value)];
                },
                getViewValueFromOption: function(option) {
                  return trackBy ? copy(option.viewValue) : option.viewValue;
                }
              };
            }
          };
        }
        var optionTemplate = window.document.createElement('option'),
            optGroupTemplate = window.document.createElement('optgroup');
        function ngOptionsPostLink(scope, selectElement, attr, ctrls) {
          var selectCtrl = ctrls[0];
          var ngModelCtrl = ctrls[1];
          var multiple = attr.multiple;
          for (var i = 0,
              children = selectElement.children(),
              ii = children.length; i < ii; i++) {
            if (children[i].value === '') {
              selectCtrl.hasEmptyOption = true;
              selectCtrl.emptyOption = children.eq(i);
              break;
            }
          }
          selectElement.empty();
          var providedEmptyOption = !!selectCtrl.emptyOption;
          var unknownOption = jqLite(optionTemplate.cloneNode(false));
          unknownOption.val('?');
          var options;
          var ngOptions = parseOptionsExpression(attr.ngOptions, selectElement, scope);
          var listFragment = $document[0].createDocumentFragment();
          selectCtrl.generateUnknownOptionValue = function(val) {
            return '?';
          };
          if (!multiple) {
            selectCtrl.writeValue = function writeNgOptionsValue(value) {
              if (!options)
                return;
              var selectedOption = selectElement[0].options[selectElement[0].selectedIndex];
              var option = options.getOptionFromViewValue(value);
              if (selectedOption)
                selectedOption.removeAttribute('selected');
              if (option) {
                if (selectElement[0].value !== option.selectValue) {
                  selectCtrl.removeUnknownOption();
                  selectElement[0].value = option.selectValue;
                  option.element.selected = true;
                }
                option.element.setAttribute('selected', 'selected');
              } else {
                selectCtrl.selectUnknownOrEmptyOption(value);
              }
            };
            selectCtrl.readValue = function readNgOptionsValue() {
              var selectedOption = options.selectValueMap[selectElement.val()];
              if (selectedOption && !selectedOption.disabled) {
                selectCtrl.unselectEmptyOption();
                selectCtrl.removeUnknownOption();
                return options.getViewValueFromOption(selectedOption);
              }
              return null;
            };
            if (ngOptions.trackBy) {
              scope.$watch(function() {
                return ngOptions.getTrackByValue(ngModelCtrl.$viewValue);
              }, function() {
                ngModelCtrl.$render();
              });
            }
          } else {
            selectCtrl.writeValue = function writeNgOptionsMultiple(values) {
              if (!options)
                return;
              var selectedOptions = values && values.map(getAndUpdateSelectedOption) || [];
              options.items.forEach(function(option) {
                if (option.element.selected && !includes(selectedOptions, option)) {
                  option.element.selected = false;
                }
              });
            };
            selectCtrl.readValue = function readNgOptionsMultiple() {
              var selectedValues = selectElement.val() || [],
                  selections = [];
              forEach(selectedValues, function(value) {
                var option = options.selectValueMap[value];
                if (option && !option.disabled)
                  selections.push(options.getViewValueFromOption(option));
              });
              return selections;
            };
            if (ngOptions.trackBy) {
              scope.$watchCollection(function() {
                if (isArray(ngModelCtrl.$viewValue)) {
                  return ngModelCtrl.$viewValue.map(function(value) {
                    return ngOptions.getTrackByValue(value);
                  });
                }
              }, function() {
                ngModelCtrl.$render();
              });
            }
          }
          if (providedEmptyOption) {
            $compile(selectCtrl.emptyOption)(scope);
            selectElement.prepend(selectCtrl.emptyOption);
            if (selectCtrl.emptyOption[0].nodeType === NODE_TYPE_COMMENT) {
              selectCtrl.hasEmptyOption = false;
              selectCtrl.registerOption = function(optionScope, optionEl) {
                if (optionEl.val() === '') {
                  selectCtrl.hasEmptyOption = true;
                  selectCtrl.emptyOption = optionEl;
                  selectCtrl.emptyOption.removeClass('ng-scope');
                  ngModelCtrl.$render();
                  optionEl.on('$destroy', function() {
                    var needsRerender = selectCtrl.$isEmptyOptionSelected();
                    selectCtrl.hasEmptyOption = false;
                    selectCtrl.emptyOption = undefined;
                    if (needsRerender)
                      ngModelCtrl.$render();
                  });
                }
              };
            } else {
              selectCtrl.emptyOption.removeClass('ng-scope');
            }
          }
          scope.$watchCollection(ngOptions.getWatchables, updateOptions);
          function addOptionElement(option, parent) {
            var optionElement = optionTemplate.cloneNode(false);
            parent.appendChild(optionElement);
            updateOptionElement(option, optionElement);
          }
          function getAndUpdateSelectedOption(viewValue) {
            var option = options.getOptionFromViewValue(viewValue);
            var element = option && option.element;
            if (element && !element.selected)
              element.selected = true;
            return option;
          }
          function updateOptionElement(option, element) {
            option.element = element;
            element.disabled = option.disabled;
            if (option.label !== element.label) {
              element.label = option.label;
              element.textContent = option.label;
            }
            element.value = option.selectValue;
          }
          function updateOptions() {
            var previousValue = options && selectCtrl.readValue();
            if (options) {
              for (var i = options.items.length - 1; i >= 0; i--) {
                var option = options.items[i];
                if (isDefined(option.group)) {
                  jqLiteRemove(option.element.parentNode);
                } else {
                  jqLiteRemove(option.element);
                }
              }
            }
            options = ngOptions.getOptions();
            var groupElementMap = {};
            options.items.forEach(function addOption(option) {
              var groupElement;
              if (isDefined(option.group)) {
                groupElement = groupElementMap[option.group];
                if (!groupElement) {
                  groupElement = optGroupTemplate.cloneNode(false);
                  listFragment.appendChild(groupElement);
                  groupElement.label = option.group === null ? 'null' : option.group;
                  groupElementMap[option.group] = groupElement;
                }
                addOptionElement(option, groupElement);
              } else {
                addOptionElement(option, listFragment);
              }
            });
            selectElement[0].appendChild(listFragment);
            ngModelCtrl.$render();
            if (!ngModelCtrl.$isEmpty(previousValue)) {
              var nextValue = selectCtrl.readValue();
              var isNotPrimitive = ngOptions.trackBy || multiple;
              if (isNotPrimitive ? !equals(previousValue, nextValue) : previousValue !== nextValue) {
                ngModelCtrl.$setViewValue(nextValue);
                ngModelCtrl.$render();
              }
            }
          }
        }
        return {
          restrict: 'A',
          terminal: true,
          require: ['select', 'ngModel'],
          link: {
            pre: function ngOptionsPreLink(scope, selectElement, attr, ctrls) {
              ctrls[0].registerOption = noop;
            },
            post: ngOptionsPostLink
          }
        };
      }];
      var ngPluralizeDirective = ['$locale', '$interpolate', '$log', function($locale, $interpolate, $log) {
        var BRACE = /{}/g,
            IS_WHEN = /^when(Minus)?(.+)$/;
        return {link: function(scope, element, attr) {
            var numberExp = attr.count,
                whenExp = attr.$attr.when && element.attr(attr.$attr.when),
                offset = attr.offset || 0,
                whens = scope.$eval(whenExp) || {},
                whensExpFns = {},
                startSymbol = $interpolate.startSymbol(),
                endSymbol = $interpolate.endSymbol(),
                braceReplacement = startSymbol + numberExp + '-' + offset + endSymbol,
                watchRemover = angular.noop,
                lastCount;
            forEach(attr, function(expression, attributeName) {
              var tmpMatch = IS_WHEN.exec(attributeName);
              if (tmpMatch) {
                var whenKey = (tmpMatch[1] ? '-' : '') + lowercase(tmpMatch[2]);
                whens[whenKey] = element.attr(attr.$attr[attributeName]);
              }
            });
            forEach(whens, function(expression, key) {
              whensExpFns[key] = $interpolate(expression.replace(BRACE, braceReplacement));
            });
            scope.$watch(numberExp, function ngPluralizeWatchAction(newVal) {
              var count = parseFloat(newVal);
              var countIsNaN = isNumberNaN(count);
              if (!countIsNaN && !(count in whens)) {
                count = $locale.pluralCat(count - offset);
              }
              if ((count !== lastCount) && !(countIsNaN && isNumberNaN(lastCount))) {
                watchRemover();
                var whenExpFn = whensExpFns[count];
                if (isUndefined(whenExpFn)) {
                  if (newVal != null) {
                    $log.debug('ngPluralize: no rule defined for \'' + count + '\' in ' + whenExp);
                  }
                  watchRemover = noop;
                  updateElementText();
                } else {
                  watchRemover = scope.$watch(whenExpFn, updateElementText);
                }
                lastCount = count;
              }
            });
            function updateElementText(newText) {
              element.text(newText || '');
            }
          }};
      }];
      var ngRepeatDirective = ['$parse', '$animate', '$compile', function($parse, $animate, $compile) {
        var NG_REMOVED = '$$NG_REMOVED';
        var ngRepeatMinErr = minErr('ngRepeat');
        var updateScope = function(scope, index, valueIdentifier, value, keyIdentifier, key, arrayLength) {
          scope[valueIdentifier] = value;
          if (keyIdentifier)
            scope[keyIdentifier] = key;
          scope.$index = index;
          scope.$first = (index === 0);
          scope.$last = (index === (arrayLength - 1));
          scope.$middle = !(scope.$first || scope.$last);
          scope.$odd = !(scope.$even = (index & 1) === 0);
        };
        var getBlockStart = function(block) {
          return block.clone[0];
        };
        var getBlockEnd = function(block) {
          return block.clone[block.clone.length - 1];
        };
        return {
          restrict: 'A',
          multiElement: true,
          transclude: 'element',
          priority: 1000,
          terminal: true,
          $$tlb: true,
          compile: function ngRepeatCompile($element, $attr) {
            var expression = $attr.ngRepeat;
            var ngRepeatEndComment = $compile.$$createComment('end ngRepeat', expression);
            var match = expression.match(/^\s*([\s\S]+?)\s+in\s+([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+track\s+by\s+([\s\S]+?))?\s*$/);
            if (!match) {
              throw ngRepeatMinErr('iexp', 'Expected expression in form of \'_item_ in _collection_[ track by _id_]\' but got \'{0}\'.', expression);
            }
            var lhs = match[1];
            var rhs = match[2];
            var aliasAs = match[3];
            var trackByExp = match[4];
            match = lhs.match(/^(?:(\s*[$\w]+)|\(\s*([$\w]+)\s*,\s*([$\w]+)\s*\))$/);
            if (!match) {
              throw ngRepeatMinErr('iidexp', '\'_item_\' in \'_item_ in _collection_\' should be an identifier or \'(_key_, _value_)\' expression, but got \'{0}\'.', lhs);
            }
            var valueIdentifier = match[3] || match[1];
            var keyIdentifier = match[2];
            if (aliasAs && (!/^[$a-zA-Z_][$a-zA-Z0-9_]*$/.test(aliasAs) || /^(null|undefined|this|\$index|\$first|\$middle|\$last|\$even|\$odd|\$parent|\$root|\$id)$/.test(aliasAs))) {
              throw ngRepeatMinErr('badident', 'alias \'{0}\' is invalid --- must be a valid JS identifier which is not a reserved name.', aliasAs);
            }
            var trackByExpGetter,
                trackByIdExpFn,
                trackByIdArrayFn,
                trackByIdObjFn;
            var hashFnLocals = {$id: hashKey};
            if (trackByExp) {
              trackByExpGetter = $parse(trackByExp);
            } else {
              trackByIdArrayFn = function(key, value) {
                return hashKey(value);
              };
              trackByIdObjFn = function(key) {
                return key;
              };
            }
            return function ngRepeatLink($scope, $element, $attr, ctrl, $transclude) {
              if (trackByExpGetter) {
                trackByIdExpFn = function(key, value, index) {
                  if (keyIdentifier)
                    hashFnLocals[keyIdentifier] = key;
                  hashFnLocals[valueIdentifier] = value;
                  hashFnLocals.$index = index;
                  return trackByExpGetter($scope, hashFnLocals);
                };
              }
              var lastBlockMap = createMap();
              $scope.$watchCollection(rhs, function ngRepeatAction(collection) {
                var index,
                    length,
                    previousNode = $element[0],
                    nextNode,
                    nextBlockMap = createMap(),
                    collectionLength,
                    key,
                    value,
                    trackById,
                    trackByIdFn,
                    collectionKeys,
                    block,
                    nextBlockOrder,
                    elementsToRemove;
                if (aliasAs) {
                  $scope[aliasAs] = collection;
                }
                if (isArrayLike(collection)) {
                  collectionKeys = collection;
                  trackByIdFn = trackByIdExpFn || trackByIdArrayFn;
                } else {
                  trackByIdFn = trackByIdExpFn || trackByIdObjFn;
                  collectionKeys = [];
                  for (var itemKey in collection) {
                    if (hasOwnProperty.call(collection, itemKey) && itemKey.charAt(0) !== '$') {
                      collectionKeys.push(itemKey);
                    }
                  }
                }
                collectionLength = collectionKeys.length;
                nextBlockOrder = new Array(collectionLength);
                for (index = 0; index < collectionLength; index++) {
                  key = (collection === collectionKeys) ? index : collectionKeys[index];
                  value = collection[key];
                  trackById = trackByIdFn(key, value, index);
                  if (lastBlockMap[trackById]) {
                    block = lastBlockMap[trackById];
                    delete lastBlockMap[trackById];
                    nextBlockMap[trackById] = block;
                    nextBlockOrder[index] = block;
                  } else if (nextBlockMap[trackById]) {
                    forEach(nextBlockOrder, function(block) {
                      if (block && block.scope)
                        lastBlockMap[block.id] = block;
                    });
                    throw ngRepeatMinErr('dupes', 'Duplicates in a repeater are not allowed. Use \'track by\' expression to specify unique keys. Repeater: {0}, Duplicate key: {1}, Duplicate value: {2}', expression, trackById, value);
                  } else {
                    nextBlockOrder[index] = {
                      id: trackById,
                      scope: undefined,
                      clone: undefined
                    };
                    nextBlockMap[trackById] = true;
                  }
                }
                for (var blockKey in lastBlockMap) {
                  block = lastBlockMap[blockKey];
                  elementsToRemove = getBlockNodes(block.clone);
                  $animate.leave(elementsToRemove);
                  if (elementsToRemove[0].parentNode) {
                    for (index = 0, length = elementsToRemove.length; index < length; index++) {
                      elementsToRemove[index][NG_REMOVED] = true;
                    }
                  }
                  block.scope.$destroy();
                }
                for (index = 0; index < collectionLength; index++) {
                  key = (collection === collectionKeys) ? index : collectionKeys[index];
                  value = collection[key];
                  block = nextBlockOrder[index];
                  if (block.scope) {
                    nextNode = previousNode;
                    do {
                      nextNode = nextNode.nextSibling;
                    } while (nextNode && nextNode[NG_REMOVED]);
                    if (getBlockStart(block) !== nextNode) {
                      $animate.move(getBlockNodes(block.clone), null, previousNode);
                    }
                    previousNode = getBlockEnd(block);
                    updateScope(block.scope, index, valueIdentifier, value, keyIdentifier, key, collectionLength);
                  } else {
                    $transclude(function ngRepeatTransclude(clone, scope) {
                      block.scope = scope;
                      var endNode = ngRepeatEndComment.cloneNode(false);
                      clone[clone.length++] = endNode;
                      $animate.enter(clone, null, previousNode);
                      previousNode = endNode;
                      block.clone = clone;
                      nextBlockMap[block.id] = block;
                      updateScope(block.scope, index, valueIdentifier, value, keyIdentifier, key, collectionLength);
                    });
                  }
                }
                lastBlockMap = nextBlockMap;
              });
            };
          }
        };
      }];
      var NG_HIDE_CLASS = 'ng-hide';
      var NG_HIDE_IN_PROGRESS_CLASS = 'ng-hide-animate';
      var ngShowDirective = ['$animate', function($animate) {
        return {
          restrict: 'A',
          multiElement: true,
          link: function(scope, element, attr) {
            scope.$watch(attr.ngShow, function ngShowWatchAction(value) {
              $animate[value ? 'removeClass' : 'addClass'](element, NG_HIDE_CLASS, {tempClasses: NG_HIDE_IN_PROGRESS_CLASS});
            });
          }
        };
      }];
      var ngHideDirective = ['$animate', function($animate) {
        return {
          restrict: 'A',
          multiElement: true,
          link: function(scope, element, attr) {
            scope.$watch(attr.ngHide, function ngHideWatchAction(value) {
              $animate[value ? 'addClass' : 'removeClass'](element, NG_HIDE_CLASS, {tempClasses: NG_HIDE_IN_PROGRESS_CLASS});
            });
          }
        };
      }];
      var ngStyleDirective = ngDirective(function(scope, element, attr) {
        scope.$watch(attr.ngStyle, function ngStyleWatchAction(newStyles, oldStyles) {
          if (oldStyles && (newStyles !== oldStyles)) {
            forEach(oldStyles, function(val, style) {
              element.css(style, '');
            });
          }
          if (newStyles)
            element.css(newStyles);
        }, true);
      });
      var ngSwitchDirective = ['$animate', '$compile', function($animate, $compile) {
        return {
          require: 'ngSwitch',
          controller: ['$scope', function NgSwitchController() {
            this.cases = {};
          }],
          link: function(scope, element, attr, ngSwitchController) {
            var watchExpr = attr.ngSwitch || attr.on,
                selectedTranscludes = [],
                selectedElements = [],
                previousLeaveAnimations = [],
                selectedScopes = [];
            var spliceFactory = function(array, index) {
              return function(response) {
                if (response !== false)
                  array.splice(index, 1);
              };
            };
            scope.$watch(watchExpr, function ngSwitchWatchAction(value) {
              var i,
                  ii;
              while (previousLeaveAnimations.length) {
                $animate.cancel(previousLeaveAnimations.pop());
              }
              for (i = 0, ii = selectedScopes.length; i < ii; ++i) {
                var selected = getBlockNodes(selectedElements[i].clone);
                selectedScopes[i].$destroy();
                var runner = previousLeaveAnimations[i] = $animate.leave(selected);
                runner.done(spliceFactory(previousLeaveAnimations, i));
              }
              selectedElements.length = 0;
              selectedScopes.length = 0;
              if ((selectedTranscludes = ngSwitchController.cases['!' + value] || ngSwitchController.cases['?'])) {
                forEach(selectedTranscludes, function(selectedTransclude) {
                  selectedTransclude.transclude(function(caseElement, selectedScope) {
                    selectedScopes.push(selectedScope);
                    var anchor = selectedTransclude.element;
                    caseElement[caseElement.length++] = $compile.$$createComment('end ngSwitchWhen');
                    var block = {clone: caseElement};
                    selectedElements.push(block);
                    $animate.enter(caseElement, anchor.parent(), anchor);
                  });
                });
              }
            });
          }
        };
      }];
      var ngSwitchWhenDirective = ngDirective({
        transclude: 'element',
        priority: 1200,
        require: '^ngSwitch',
        multiElement: true,
        link: function(scope, element, attrs, ctrl, $transclude) {
          var cases = attrs.ngSwitchWhen.split(attrs.ngSwitchWhenSeparator).sort().filter(function(element, index, array) {
            return array[index - 1] !== element;
          });
          forEach(cases, function(whenCase) {
            ctrl.cases['!' + whenCase] = (ctrl.cases['!' + whenCase] || []);
            ctrl.cases['!' + whenCase].push({
              transclude: $transclude,
              element: element
            });
          });
        }
      });
      var ngSwitchDefaultDirective = ngDirective({
        transclude: 'element',
        priority: 1200,
        require: '^ngSwitch',
        multiElement: true,
        link: function(scope, element, attr, ctrl, $transclude) {
          ctrl.cases['?'] = (ctrl.cases['?'] || []);
          ctrl.cases['?'].push({
            transclude: $transclude,
            element: element
          });
        }
      });
      var ngTranscludeMinErr = minErr('ngTransclude');
      var ngTranscludeDirective = ['$compile', function($compile) {
        return {
          restrict: 'EAC',
          compile: function ngTranscludeCompile(tElement) {
            var fallbackLinkFn = $compile(tElement.contents());
            tElement.empty();
            return function ngTranscludePostLink($scope, $element, $attrs, controller, $transclude) {
              if (!$transclude) {
                throw ngTranscludeMinErr('orphan', 'Illegal use of ngTransclude directive in the template! ' + 'No parent directive that requires a transclusion found. ' + 'Element: {0}', startingTag($element));
              }
              if ($attrs.ngTransclude === $attrs.$attr.ngTransclude) {
                $attrs.ngTransclude = '';
              }
              var slotName = $attrs.ngTransclude || $attrs.ngTranscludeSlot;
              $transclude(ngTranscludeCloneAttachFn, null, slotName);
              if (slotName && !$transclude.isSlotFilled(slotName)) {
                useFallbackContent();
              }
              function ngTranscludeCloneAttachFn(clone, transcludedScope) {
                if (clone.length && notWhitespace(clone)) {
                  $element.append(clone);
                } else {
                  useFallbackContent();
                  transcludedScope.$destroy();
                }
              }
              function useFallbackContent() {
                fallbackLinkFn($scope, function(clone) {
                  $element.append(clone);
                });
              }
              function notWhitespace(nodes) {
                for (var i = 0,
                    ii = nodes.length; i < ii; i++) {
                  var node = nodes[i];
                  if (node.nodeType !== NODE_TYPE_TEXT || node.nodeValue.trim()) {
                    return true;
                  }
                }
              }
            };
          }
        };
      }];
      var scriptDirective = ['$templateCache', function($templateCache) {
        return {
          restrict: 'E',
          terminal: true,
          compile: function(element, attr) {
            if (attr.type === 'text/ng-template') {
              var templateUrl = attr.id,
                  text = element[0].text;
              $templateCache.put(templateUrl, text);
            }
          }
        };
      }];
      var noopNgModelController = {
        $setViewValue: noop,
        $render: noop
      };
      function setOptionSelectedStatus(optionEl, value) {
        optionEl.prop('selected', value);
        optionEl.attr('selected', value);
      }
      var SelectController = ['$element', '$scope', function($element, $scope) {
        var self = this,
            optionsMap = new NgMap();
        self.selectValueMap = {};
        self.ngModelCtrl = noopNgModelController;
        self.multiple = false;
        self.unknownOption = jqLite(window.document.createElement('option'));
        self.hasEmptyOption = false;
        self.emptyOption = undefined;
        self.renderUnknownOption = function(val) {
          var unknownVal = self.generateUnknownOptionValue(val);
          self.unknownOption.val(unknownVal);
          $element.prepend(self.unknownOption);
          setOptionSelectedStatus(self.unknownOption, true);
          $element.val(unknownVal);
        };
        self.updateUnknownOption = function(val) {
          var unknownVal = self.generateUnknownOptionValue(val);
          self.unknownOption.val(unknownVal);
          setOptionSelectedStatus(self.unknownOption, true);
          $element.val(unknownVal);
        };
        self.generateUnknownOptionValue = function(val) {
          return '? ' + hashKey(val) + ' ?';
        };
        self.removeUnknownOption = function() {
          if (self.unknownOption.parent())
            self.unknownOption.remove();
        };
        self.selectEmptyOption = function() {
          if (self.emptyOption) {
            $element.val('');
            setOptionSelectedStatus(self.emptyOption, true);
          }
        };
        self.unselectEmptyOption = function() {
          if (self.hasEmptyOption) {
            setOptionSelectedStatus(self.emptyOption, false);
          }
        };
        $scope.$on('$destroy', function() {
          self.renderUnknownOption = noop;
        });
        self.readValue = function readSingleValue() {
          var val = $element.val();
          var realVal = val in self.selectValueMap ? self.selectValueMap[val] : val;
          if (self.hasOption(realVal)) {
            return realVal;
          }
          return null;
        };
        self.writeValue = function writeSingleValue(value) {
          var currentlySelectedOption = $element[0].options[$element[0].selectedIndex];
          if (currentlySelectedOption)
            setOptionSelectedStatus(jqLite(currentlySelectedOption), false);
          if (self.hasOption(value)) {
            self.removeUnknownOption();
            var hashedVal = hashKey(value);
            $element.val(hashedVal in self.selectValueMap ? hashedVal : value);
            var selectedOption = $element[0].options[$element[0].selectedIndex];
            setOptionSelectedStatus(jqLite(selectedOption), true);
          } else {
            self.selectUnknownOrEmptyOption(value);
          }
        };
        self.addOption = function(value, element) {
          if (element[0].nodeType === NODE_TYPE_COMMENT)
            return;
          assertNotHasOwnProperty(value, '"option value"');
          if (value === '') {
            self.hasEmptyOption = true;
            self.emptyOption = element;
          }
          var count = optionsMap.get(value) || 0;
          optionsMap.set(value, count + 1);
          scheduleRender();
        };
        self.removeOption = function(value) {
          var count = optionsMap.get(value);
          if (count) {
            if (count === 1) {
              optionsMap.delete(value);
              if (value === '') {
                self.hasEmptyOption = false;
                self.emptyOption = undefined;
              }
            } else {
              optionsMap.set(value, count - 1);
            }
          }
        };
        self.hasOption = function(value) {
          return !!optionsMap.get(value);
        };
        self.$hasEmptyOption = function() {
          return self.hasEmptyOption;
        };
        self.$isUnknownOptionSelected = function() {
          return $element[0].options[0] === self.unknownOption[0];
        };
        self.$isEmptyOptionSelected = function() {
          return self.hasEmptyOption && $element[0].options[$element[0].selectedIndex] === self.emptyOption[0];
        };
        self.selectUnknownOrEmptyOption = function(value) {
          if (value == null && self.emptyOption) {
            self.removeUnknownOption();
            self.selectEmptyOption();
          } else if (self.unknownOption.parent().length) {
            self.updateUnknownOption(value);
          } else {
            self.renderUnknownOption(value);
          }
        };
        var renderScheduled = false;
        function scheduleRender() {
          if (renderScheduled)
            return;
          renderScheduled = true;
          $scope.$$postDigest(function() {
            renderScheduled = false;
            self.ngModelCtrl.$render();
          });
        }
        var updateScheduled = false;
        function scheduleViewValueUpdate(renderAfter) {
          if (updateScheduled)
            return;
          updateScheduled = true;
          $scope.$$postDigest(function() {
            if ($scope.$$destroyed)
              return;
            updateScheduled = false;
            self.ngModelCtrl.$setViewValue(self.readValue());
            if (renderAfter)
              self.ngModelCtrl.$render();
          });
        }
        self.registerOption = function(optionScope, optionElement, optionAttrs, interpolateValueFn, interpolateTextFn) {
          if (optionAttrs.$attr.ngValue) {
            var oldVal,
                hashedVal = NaN;
            optionAttrs.$observe('value', function valueAttributeObserveAction(newVal) {
              var removal;
              var previouslySelected = optionElement.prop('selected');
              if (isDefined(hashedVal)) {
                self.removeOption(oldVal);
                delete self.selectValueMap[hashedVal];
                removal = true;
              }
              hashedVal = hashKey(newVal);
              oldVal = newVal;
              self.selectValueMap[hashedVal] = newVal;
              self.addOption(newVal, optionElement);
              optionElement.attr('value', hashedVal);
              if (removal && previouslySelected) {
                scheduleViewValueUpdate();
              }
            });
          } else if (interpolateValueFn) {
            optionAttrs.$observe('value', function valueAttributeObserveAction(newVal) {
              self.readValue();
              var removal;
              var previouslySelected = optionElement.prop('selected');
              if (isDefined(oldVal)) {
                self.removeOption(oldVal);
                removal = true;
              }
              oldVal = newVal;
              self.addOption(newVal, optionElement);
              if (removal && previouslySelected) {
                scheduleViewValueUpdate();
              }
            });
          } else if (interpolateTextFn) {
            optionScope.$watch(interpolateTextFn, function interpolateWatchAction(newVal, oldVal) {
              optionAttrs.$set('value', newVal);
              var previouslySelected = optionElement.prop('selected');
              if (oldVal !== newVal) {
                self.removeOption(oldVal);
              }
              self.addOption(newVal, optionElement);
              if (oldVal && previouslySelected) {
                scheduleViewValueUpdate();
              }
            });
          } else {
            self.addOption(optionAttrs.value, optionElement);
          }
          optionAttrs.$observe('disabled', function(newVal) {
            if (newVal === 'true' || newVal && optionElement.prop('selected')) {
              if (self.multiple) {
                scheduleViewValueUpdate(true);
              } else {
                self.ngModelCtrl.$setViewValue(null);
                self.ngModelCtrl.$render();
              }
            }
          });
          optionElement.on('$destroy', function() {
            var currentValue = self.readValue();
            var removeValue = optionAttrs.value;
            self.removeOption(removeValue);
            scheduleRender();
            if (self.multiple && currentValue && currentValue.indexOf(removeValue) !== -1 || currentValue === removeValue) {
              scheduleViewValueUpdate(true);
            }
          });
        };
      }];
      var selectDirective = function() {
        return {
          restrict: 'E',
          require: ['select', '?ngModel'],
          controller: SelectController,
          priority: 1,
          link: {
            pre: selectPreLink,
            post: selectPostLink
          }
        };
        function selectPreLink(scope, element, attr, ctrls) {
          var selectCtrl = ctrls[0];
          var ngModelCtrl = ctrls[1];
          if (!ngModelCtrl) {
            selectCtrl.registerOption = noop;
            return;
          }
          selectCtrl.ngModelCtrl = ngModelCtrl;
          element.on('change', function() {
            selectCtrl.removeUnknownOption();
            scope.$apply(function() {
              ngModelCtrl.$setViewValue(selectCtrl.readValue());
            });
          });
          if (attr.multiple) {
            selectCtrl.multiple = true;
            selectCtrl.readValue = function readMultipleValue() {
              var array = [];
              forEach(element.find('option'), function(option) {
                if (option.selected && !option.disabled) {
                  var val = option.value;
                  array.push(val in selectCtrl.selectValueMap ? selectCtrl.selectValueMap[val] : val);
                }
              });
              return array;
            };
            selectCtrl.writeValue = function writeMultipleValue(value) {
              forEach(element.find('option'), function(option) {
                var shouldBeSelected = !!value && (includes(value, option.value) || includes(value, selectCtrl.selectValueMap[option.value]));
                var currentlySelected = option.selected;
                if (shouldBeSelected !== currentlySelected) {
                  setOptionSelectedStatus(jqLite(option), shouldBeSelected);
                }
              });
            };
            var lastView,
                lastViewRef = NaN;
            scope.$watch(function selectMultipleWatch() {
              if (lastViewRef === ngModelCtrl.$viewValue && !equals(lastView, ngModelCtrl.$viewValue)) {
                lastView = shallowCopy(ngModelCtrl.$viewValue);
                ngModelCtrl.$render();
              }
              lastViewRef = ngModelCtrl.$viewValue;
            });
            ngModelCtrl.$isEmpty = function(value) {
              return !value || value.length === 0;
            };
          }
        }
        function selectPostLink(scope, element, attrs, ctrls) {
          var ngModelCtrl = ctrls[1];
          if (!ngModelCtrl)
            return;
          var selectCtrl = ctrls[0];
          ngModelCtrl.$render = function() {
            selectCtrl.writeValue(ngModelCtrl.$viewValue);
          };
        }
      };
      var optionDirective = ['$interpolate', function($interpolate) {
        return {
          restrict: 'E',
          priority: 100,
          compile: function(element, attr) {
            var interpolateValueFn,
                interpolateTextFn;
            if (isDefined(attr.ngValue)) {} else if (isDefined(attr.value)) {
              interpolateValueFn = $interpolate(attr.value, true);
            } else {
              interpolateTextFn = $interpolate(element.text(), true);
              if (!interpolateTextFn) {
                attr.$set('value', element.text());
              }
            }
            return function(scope, element, attr) {
              var selectCtrlName = '$selectController',
                  parent = element.parent(),
                  selectCtrl = parent.data(selectCtrlName) || parent.parent().data(selectCtrlName);
              if (selectCtrl) {
                selectCtrl.registerOption(scope, element, attr, interpolateValueFn, interpolateTextFn);
              }
            };
          }
        };
      }];
      var requiredDirective = function() {
        return {
          restrict: 'A',
          require: '?ngModel',
          link: function(scope, elm, attr, ctrl) {
            if (!ctrl)
              return;
            attr.required = true;
            ctrl.$validators.required = function(modelValue, viewValue) {
              return !attr.required || !ctrl.$isEmpty(viewValue);
            };
            attr.$observe('required', function() {
              ctrl.$validate();
            });
          }
        };
      };
      var patternDirective = function() {
        return {
          restrict: 'A',
          require: '?ngModel',
          link: function(scope, elm, attr, ctrl) {
            if (!ctrl)
              return;
            var regexp,
                patternExp = attr.ngPattern || attr.pattern;
            attr.$observe('pattern', function(regex) {
              if (isString(regex) && regex.length > 0) {
                regex = new RegExp('^' + regex + '$');
              }
              if (regex && !regex.test) {
                throw minErr('ngPattern')('noregexp', 'Expected {0} to be a RegExp but was {1}. Element: {2}', patternExp, regex, startingTag(elm));
              }
              regexp = regex || undefined;
              ctrl.$validate();
            });
            ctrl.$validators.pattern = function(modelValue, viewValue) {
              return ctrl.$isEmpty(viewValue) || isUndefined(regexp) || regexp.test(viewValue);
            };
          }
        };
      };
      var maxlengthDirective = function() {
        return {
          restrict: 'A',
          require: '?ngModel',
          link: function(scope, elm, attr, ctrl) {
            if (!ctrl)
              return;
            var maxlength = -1;
            attr.$observe('maxlength', function(value) {
              var intVal = toInt(value);
              maxlength = isNumberNaN(intVal) ? -1 : intVal;
              ctrl.$validate();
            });
            ctrl.$validators.maxlength = function(modelValue, viewValue) {
              return (maxlength < 0) || ctrl.$isEmpty(viewValue) || (viewValue.length <= maxlength);
            };
          }
        };
      };
      var minlengthDirective = function() {
        return {
          restrict: 'A',
          require: '?ngModel',
          link: function(scope, elm, attr, ctrl) {
            if (!ctrl)
              return;
            var minlength = 0;
            attr.$observe('minlength', function(value) {
              minlength = toInt(value) || 0;
              ctrl.$validate();
            });
            ctrl.$validators.minlength = function(modelValue, viewValue) {
              return ctrl.$isEmpty(viewValue) || viewValue.length >= minlength;
            };
          }
        };
      };
      if (window.angular.bootstrap) {
        if (window.console) {
          console.log('WARNING: Tried to load AngularJS more than once.');
        }
        return;
      }
      bindJQuery();
      publishExternalAPI(angular);
      angular.module("ngLocale", [], ["$provide", function($provide) {
        var PLURAL_CATEGORY = {
          ZERO: "zero",
          ONE: "one",
          TWO: "two",
          FEW: "few",
          MANY: "many",
          OTHER: "other"
        };
        function getDecimals(n) {
          n = n + '';
          var i = n.indexOf('.');
          return (i == -1) ? 0 : n.length - i - 1;
        }
        function getVF(n, opt_precision) {
          var v = opt_precision;
          if (undefined === v) {
            v = Math.min(getDecimals(n), 3);
          }
          var base = Math.pow(10, v);
          var f = ((n * base) | 0) % base;
          return {
            v: v,
            f: f
          };
        }
        $provide.value("$locale", {
          "DATETIME_FORMATS": {
            "AMPMS": ["AM", "PM"],
            "DAY": ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
            "ERANAMES": ["Before Christ", "Anno Domini"],
            "ERAS": ["BC", "AD"],
            "FIRSTDAYOFWEEK": 6,
            "MONTH": ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
            "SHORTDAY": ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
            "SHORTMONTH": ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
            "STANDALONEMONTH": ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
            "WEEKENDRANGE": [5, 6],
            "fullDate": "EEEE, MMMM d, y",
            "longDate": "MMMM d, y",
            "medium": "MMM d, y h:mm:ss a",
            "mediumDate": "MMM d, y",
            "mediumTime": "h:mm:ss a",
            "short": "M/d/yy h:mm a",
            "shortDate": "M/d/yy",
            "shortTime": "h:mm a"
          },
          "NUMBER_FORMATS": {
            "CURRENCY_SYM": "$",
            "DECIMAL_SEP": ".",
            "GROUP_SEP": ",",
            "PATTERNS": [{
              "gSize": 3,
              "lgSize": 3,
              "maxFrac": 3,
              "minFrac": 0,
              "minInt": 1,
              "negPre": "-",
              "negSuf": "",
              "posPre": "",
              "posSuf": ""
            }, {
              "gSize": 3,
              "lgSize": 3,
              "maxFrac": 2,
              "minFrac": 2,
              "minInt": 1,
              "negPre": "-\u00a4",
              "negSuf": "",
              "posPre": "\u00a4",
              "posSuf": ""
            }]
          },
          "id": "en-us",
          "localeID": "en_US",
          "pluralCat": function(n, opt_precision) {
            var i = n | 0;
            var vf = getVF(n, opt_precision);
            if (i == 1 && vf.v == 0) {
              return PLURAL_CATEGORY.ONE;
            }
            return PLURAL_CATEGORY.OTHER;
          }
        });
      }]);
      jqLite(function() {
        angularInit(window.document, bootstrap);
      });
    })(window);
    !window.angular.$$csp().noInlineStyle && window.angular.element(document.head).prepend('<style type="text/css">@charset "UTF-8";[ng\\:cloak],[ng-cloak],[data-ng-cloak],[x-ng-cloak],.ng-cloak,.x-ng-cloak,.ng-hide:not(.ng-hide-animate){display:none !important;}ng\\:form{display:block;}.ng-animate-shim{visibility:hidden;}.ng-anchor{position:absolute;}</style>');
  })();
  return _retrieveGlobal();
});

$__System.register("2e", [], function (_export, _context) {
	"use strict";

	var PageController;
	return {
		setters: [],
		execute: function () {
			PageController = function PageController($rootScope, $scope) {
				this.$scope = $scope;
				this.$rootScope = $rootScope;

				$scope.submitForm = function (isValid) {
					this.formInput = {
						name: $("input[name='name']").val(),
						email: $("input[name='email']").val(),
						message: $("textarea[name='message']").val()
					};
					if (isValid) {
						console.log('Message sent successfully');
						console.log(this.formInput);
					} else {
						console.log('Failed to send message');
					}
				};
			};

			PageController.prototype = {
				/**
     * Initialize.
     */
				init: function init() {
					var that = this;

					that.$rootScope.page = true;
				}

			};

			PageController.$inject = ['$rootScope', '$scope'];

			_export("default", PageController);
		}
	};
});
$__System.register('2f', ['3', '2e'], function (_export, _context) {
  "use strict";

  var angular, PageController, pageModule;
  return {
    setters: [function (_) {
      angular = _.default;
    }, function (_e) {
      PageController = _e.default;
    }],
    execute: function () {
      pageModule = angular.module('app.page', ['ngCookies']).controller('PageController', PageController);

      _export('default', pageModule);
    }
  };
});
$__System.register('1', ['3', '4', '5', '6', '7', '8', '15', '17', '19', '1b', '1d', '1f', '21', '23', '26', '28', '2b', '2d', '2f'], function (_export, _context) {
  "use strict";

  var angular, coreModule, routesModule, homepageModule, categoryModule, continentModule, countryModule, articleModule, contactModule, aboutModule, servicesModule, artistModule, playerModule, pageModule, app;
  return {
    setters: [function (_) {
      angular = _.default;
    }, function (_2) {}, function (_3) {}, function (_4) {}, function (_5) {}, function (_6) {}, function (_7) {
      coreModule = _7.default;
    }, function (_8) {
      routesModule = _8.default;
    }, function (_9) {
      homepageModule = _9.default;
    }, function (_b) {
      categoryModule = _b.default;
    }, function (_d) {
      continentModule = _d.default;
    }, function (_f) {
      countryModule = _f.default;
    }, function (_10) {
      articleModule = _10.default;
    }, function (_11) {
      contactModule = _11.default;
    }, function (_12) {
      aboutModule = _12.default;
    }, function (_13) {
      servicesModule = _13.default;
    }, function (_b2) {
      artistModule = _b2.default;
    }, function (_d2) {
      playerModule = _d2.default;
    }, function (_f2) {
      pageModule = _f2.default;
    }],
    execute: function () {
      app = angular.module('app', [coreModule.name, routesModule.name, homepageModule.name, categoryModule.name, continentModule.name, countryModule.name, articleModule.name, contactModule.name, servicesModule.name, aboutModule.name, artistModule.name, playerModule.name, pageModule.name]);
    }
  };
});
})
(function(factory) {
  if (typeof define == 'function' && define.amd)
    define([], factory);
  else if (typeof module == 'object' && module.exports && typeof require == 'function')
    module.exports = factory();
  else
    factory();
});